function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire45ff"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire45ff"] = parcelRequire;
}
parcelRequire.register("8j8zV", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $60c6c09291648837$export$ffb0004e005737fa; }, function (v) { return $60c6c09291648837$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $60c6c09291648837$export$34b9dba7ce09269b; }, function (v) { return $60c6c09291648837$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $60c6c09291648837$export$25062201e9e25d76; }, function (v) { return $60c6c09291648837$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $60c6c09291648837$export$ffb0004e005737fa;
var $60c6c09291648837$export$34b9dba7ce09269b;
var $60c6c09291648837$export$25062201e9e25d76;
"use strict";

var $aivMx = parcelRequire("aivMx");
var $60c6c09291648837$var$k = Symbol.for("react.element"), $60c6c09291648837$var$l = Symbol.for("react.fragment"), $60c6c09291648837$var$m = Object.prototype.hasOwnProperty, $60c6c09291648837$var$n = $aivMx.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $60c6c09291648837$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $60c6c09291648837$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$60c6c09291648837$var$m.call(a, b) && !$60c6c09291648837$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $60c6c09291648837$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $60c6c09291648837$var$n.current
    };
}
$60c6c09291648837$export$ffb0004e005737fa = $60c6c09291648837$var$l;
$60c6c09291648837$export$34b9dba7ce09269b = $60c6c09291648837$var$q;
$60c6c09291648837$export$25062201e9e25d76 = $60c6c09291648837$var$q;

});
parcelRequire.register("aivMx", function(module, exports) {
"use strict";

module.exports = (parcelRequire("jZOM6"));

});
parcelRequire.register("jZOM6", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $e8eb19a844d02677$export$dca3b0875bd9a954; }, function (v) { return $e8eb19a844d02677$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $e8eb19a844d02677$export$16fa2f45be04daa8; }, function (v) { return $e8eb19a844d02677$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $e8eb19a844d02677$export$ffb0004e005737fa; }, function (v) { return $e8eb19a844d02677$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $e8eb19a844d02677$export$e2c29f18771995cb; }, function (v) { return $e8eb19a844d02677$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $e8eb19a844d02677$export$221d75b3f55bb0bd; }, function (v) { return $e8eb19a844d02677$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $e8eb19a844d02677$export$5f8d39834fd61797; }, function (v) { return $e8eb19a844d02677$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $e8eb19a844d02677$export$74bf444e3cd11ea5; }, function (v) { return $e8eb19a844d02677$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $e8eb19a844d02677$export$ae55be85d98224ed; }, function (v) { return $e8eb19a844d02677$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $e8eb19a844d02677$export$e530037191fcd5d7; }, function (v) { return $e8eb19a844d02677$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $e8eb19a844d02677$export$fd42f52fd3ae1109; }, function (v) { return $e8eb19a844d02677$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $e8eb19a844d02677$export$c8a8987d4410bf2d; }, function (v) { return $e8eb19a844d02677$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $e8eb19a844d02677$export$d38cd72104c1f0e9; }, function (v) { return $e8eb19a844d02677$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $e8eb19a844d02677$export$7d1e3a5e95ceca43; }, function (v) { return $e8eb19a844d02677$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $e8eb19a844d02677$export$257a8862b851cb5b; }, function (v) { return $e8eb19a844d02677$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $e8eb19a844d02677$export$a8257692ac88316c; }, function (v) { return $e8eb19a844d02677$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $e8eb19a844d02677$export$488013bae63b21da; }, function (v) { return $e8eb19a844d02677$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $e8eb19a844d02677$export$7c73462e0d25e514; }, function (v) { return $e8eb19a844d02677$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $e8eb19a844d02677$export$7568632d0d33d16d; }, function (v) { return $e8eb19a844d02677$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $e8eb19a844d02677$export$88948ce120ea2619; }, function (v) { return $e8eb19a844d02677$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $e8eb19a844d02677$export$35808ee640e87ca7; }, function (v) { return $e8eb19a844d02677$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $e8eb19a844d02677$export$fae74005e78b1a27; }, function (v) { return $e8eb19a844d02677$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $e8eb19a844d02677$export$dc8fbce3eb94dc1e; }, function (v) { return $e8eb19a844d02677$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $e8eb19a844d02677$export$6a7bc4e911dc01cf; }, function (v) { return $e8eb19a844d02677$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $e8eb19a844d02677$export$6d9c69b0de29b591; }, function (v) { return $e8eb19a844d02677$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $e8eb19a844d02677$export$f680877a34711e37; }, function (v) { return $e8eb19a844d02677$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $e8eb19a844d02677$export$d5a552a76deda3c2; }, function (v) { return $e8eb19a844d02677$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $e8eb19a844d02677$export$aaabe4eda9ed9969; }, function (v) { return $e8eb19a844d02677$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $e8eb19a844d02677$export$e5c5a5f917a5871c; }, function (v) { return $e8eb19a844d02677$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $e8eb19a844d02677$export$1538c33de8887b59; }, function (v) { return $e8eb19a844d02677$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $e8eb19a844d02677$export$13e3392192263954; }, function (v) { return $e8eb19a844d02677$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $e8eb19a844d02677$export$b8f5890fc79d6aca; }, function (v) { return $e8eb19a844d02677$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $e8eb19a844d02677$export$60241385465d0a34; }, function (v) { return $e8eb19a844d02677$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $e8eb19a844d02677$export$306c0aa65ff9ec16; }, function (v) { return $e8eb19a844d02677$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $e8eb19a844d02677$export$7b286972b8d8ccbf; }, function (v) { return $e8eb19a844d02677$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $e8eb19a844d02677$export$83d89fbfd8236492; }, function (v) { return $e8eb19a844d02677$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e8eb19a844d02677$export$dca3b0875bd9a954;
var $e8eb19a844d02677$export$16fa2f45be04daa8;
var $e8eb19a844d02677$export$ffb0004e005737fa;
var $e8eb19a844d02677$export$e2c29f18771995cb;
var $e8eb19a844d02677$export$221d75b3f55bb0bd;
var $e8eb19a844d02677$export$5f8d39834fd61797;
var $e8eb19a844d02677$export$74bf444e3cd11ea5;
var $e8eb19a844d02677$export$ae55be85d98224ed;
var $e8eb19a844d02677$export$e530037191fcd5d7;
var $e8eb19a844d02677$export$fd42f52fd3ae1109;
var $e8eb19a844d02677$export$c8a8987d4410bf2d;
var $e8eb19a844d02677$export$d38cd72104c1f0e9;
var $e8eb19a844d02677$export$7d1e3a5e95ceca43;
var $e8eb19a844d02677$export$257a8862b851cb5b;
var $e8eb19a844d02677$export$a8257692ac88316c;
var $e8eb19a844d02677$export$488013bae63b21da;
var $e8eb19a844d02677$export$7c73462e0d25e514;
var $e8eb19a844d02677$export$7568632d0d33d16d;
var $e8eb19a844d02677$export$88948ce120ea2619;
var $e8eb19a844d02677$export$35808ee640e87ca7;
var $e8eb19a844d02677$export$fae74005e78b1a27;
var $e8eb19a844d02677$export$dc8fbce3eb94dc1e;
var $e8eb19a844d02677$export$6a7bc4e911dc01cf;
var $e8eb19a844d02677$export$6d9c69b0de29b591;
var $e8eb19a844d02677$export$f680877a34711e37;
var $e8eb19a844d02677$export$d5a552a76deda3c2;
var $e8eb19a844d02677$export$aaabe4eda9ed9969;
var $e8eb19a844d02677$export$e5c5a5f917a5871c;
var $e8eb19a844d02677$export$1538c33de8887b59;
var $e8eb19a844d02677$export$13e3392192263954;
var $e8eb19a844d02677$export$b8f5890fc79d6aca;
var $e8eb19a844d02677$export$60241385465d0a34;
var $e8eb19a844d02677$export$306c0aa65ff9ec16;
var $e8eb19a844d02677$export$7b286972b8d8ccbf;
var $e8eb19a844d02677$export$83d89fbfd8236492;
"use strict";
var $e8eb19a844d02677$var$l = Symbol.for("react.element"), $e8eb19a844d02677$var$n = Symbol.for("react.portal"), $e8eb19a844d02677$var$p = Symbol.for("react.fragment"), $e8eb19a844d02677$var$q = Symbol.for("react.strict_mode"), $e8eb19a844d02677$var$r = Symbol.for("react.profiler"), $e8eb19a844d02677$var$t = Symbol.for("react.provider"), $e8eb19a844d02677$var$u = Symbol.for("react.context"), $e8eb19a844d02677$var$v = Symbol.for("react.forward_ref"), $e8eb19a844d02677$var$w = Symbol.for("react.suspense"), $e8eb19a844d02677$var$x = Symbol.for("react.memo"), $e8eb19a844d02677$var$y = Symbol.for("react.lazy"), $e8eb19a844d02677$var$z = Symbol.iterator;
function $e8eb19a844d02677$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $e8eb19a844d02677$var$z && a[$e8eb19a844d02677$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $e8eb19a844d02677$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $e8eb19a844d02677$var$C = Object.assign, $e8eb19a844d02677$var$D = {};
function $e8eb19a844d02677$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $e8eb19a844d02677$var$D;
    this.updater = e || $e8eb19a844d02677$var$B;
}
$e8eb19a844d02677$var$E.prototype.isReactComponent = {};
$e8eb19a844d02677$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$e8eb19a844d02677$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $e8eb19a844d02677$var$F() {}
$e8eb19a844d02677$var$F.prototype = $e8eb19a844d02677$var$E.prototype;
function $e8eb19a844d02677$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $e8eb19a844d02677$var$D;
    this.updater = e || $e8eb19a844d02677$var$B;
}
var $e8eb19a844d02677$var$H = $e8eb19a844d02677$var$G.prototype = new $e8eb19a844d02677$var$F;
$e8eb19a844d02677$var$H.constructor = $e8eb19a844d02677$var$G;
$e8eb19a844d02677$var$C($e8eb19a844d02677$var$H, $e8eb19a844d02677$var$E.prototype);
$e8eb19a844d02677$var$H.isPureReactComponent = !0;
var $e8eb19a844d02677$var$I = Array.isArray, $e8eb19a844d02677$var$J = Object.prototype.hasOwnProperty, $e8eb19a844d02677$var$K = {
    current: null
}, $e8eb19a844d02677$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $e8eb19a844d02677$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$e8eb19a844d02677$var$J.call(b, d) && !$e8eb19a844d02677$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $e8eb19a844d02677$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $e8eb19a844d02677$var$K.current
    };
}
function $e8eb19a844d02677$var$N(a, b) {
    return {
        $$typeof: $e8eb19a844d02677$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $e8eb19a844d02677$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $e8eb19a844d02677$var$l;
}
function $e8eb19a844d02677$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $e8eb19a844d02677$var$P = /\/+/g;
function $e8eb19a844d02677$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $e8eb19a844d02677$var$escape("" + a.key) : b.toString(36);
}
function $e8eb19a844d02677$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $e8eb19a844d02677$var$l:
                case $e8eb19a844d02677$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $e8eb19a844d02677$var$Q(h, 0) : d, $e8eb19a844d02677$var$I(c) ? (e = "", null != a && (e = a.replace($e8eb19a844d02677$var$P, "$&/") + "/"), $e8eb19a844d02677$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($e8eb19a844d02677$var$O(c) && (c = $e8eb19a844d02677$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($e8eb19a844d02677$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($e8eb19a844d02677$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $e8eb19a844d02677$var$Q(k, g);
        h += $e8eb19a844d02677$var$R(k, b, e, f, c);
    }
    else if (f = $e8eb19a844d02677$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $e8eb19a844d02677$var$Q(k, g++), h += $e8eb19a844d02677$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $e8eb19a844d02677$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $e8eb19a844d02677$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $e8eb19a844d02677$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $e8eb19a844d02677$var$U = {
    current: null
}, $e8eb19a844d02677$var$V = {
    transition: null
}, $e8eb19a844d02677$var$W = {
    ReactCurrentDispatcher: $e8eb19a844d02677$var$U,
    ReactCurrentBatchConfig: $e8eb19a844d02677$var$V,
    ReactCurrentOwner: $e8eb19a844d02677$var$K
};
$e8eb19a844d02677$export$dca3b0875bd9a954 = {
    map: $e8eb19a844d02677$var$S,
    forEach: function(a, b, e) {
        $e8eb19a844d02677$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $e8eb19a844d02677$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $e8eb19a844d02677$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$e8eb19a844d02677$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$e8eb19a844d02677$export$16fa2f45be04daa8 = $e8eb19a844d02677$var$E;
$e8eb19a844d02677$export$ffb0004e005737fa = $e8eb19a844d02677$var$p;
$e8eb19a844d02677$export$e2c29f18771995cb = $e8eb19a844d02677$var$r;
$e8eb19a844d02677$export$221d75b3f55bb0bd = $e8eb19a844d02677$var$G;
$e8eb19a844d02677$export$5f8d39834fd61797 = $e8eb19a844d02677$var$q;
$e8eb19a844d02677$export$74bf444e3cd11ea5 = $e8eb19a844d02677$var$w;
$e8eb19a844d02677$export$ae55be85d98224ed = $e8eb19a844d02677$var$W;
$e8eb19a844d02677$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $e8eb19a844d02677$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $e8eb19a844d02677$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$e8eb19a844d02677$var$J.call(b, f) && !$e8eb19a844d02677$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $e8eb19a844d02677$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$e8eb19a844d02677$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $e8eb19a844d02677$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $e8eb19a844d02677$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$e8eb19a844d02677$export$c8a8987d4410bf2d = $e8eb19a844d02677$var$M;
$e8eb19a844d02677$export$d38cd72104c1f0e9 = function(a) {
    var b = $e8eb19a844d02677$var$M.bind(null, a);
    b.type = a;
    return b;
};
$e8eb19a844d02677$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$e8eb19a844d02677$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $e8eb19a844d02677$var$v,
        render: a
    };
};
$e8eb19a844d02677$export$a8257692ac88316c = $e8eb19a844d02677$var$O;
$e8eb19a844d02677$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $e8eb19a844d02677$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $e8eb19a844d02677$var$T
    };
};
$e8eb19a844d02677$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $e8eb19a844d02677$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$e8eb19a844d02677$export$7568632d0d33d16d = function(a) {
    var b = $e8eb19a844d02677$var$V.transition;
    $e8eb19a844d02677$var$V.transition = {};
    try {
        a();
    } finally{
        $e8eb19a844d02677$var$V.transition = b;
    }
};
$e8eb19a844d02677$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$e8eb19a844d02677$export$35808ee640e87ca7 = function(a, b) {
    return $e8eb19a844d02677$var$U.current.useCallback(a, b);
};
$e8eb19a844d02677$export$fae74005e78b1a27 = function(a) {
    return $e8eb19a844d02677$var$U.current.useContext(a);
};
$e8eb19a844d02677$export$dc8fbce3eb94dc1e = function() {};
$e8eb19a844d02677$export$6a7bc4e911dc01cf = function(a) {
    return $e8eb19a844d02677$var$U.current.useDeferredValue(a);
};
$e8eb19a844d02677$export$6d9c69b0de29b591 = function(a, b) {
    return $e8eb19a844d02677$var$U.current.useEffect(a, b);
};
$e8eb19a844d02677$export$f680877a34711e37 = function() {
    return $e8eb19a844d02677$var$U.current.useId();
};
$e8eb19a844d02677$export$d5a552a76deda3c2 = function(a, b, e) {
    return $e8eb19a844d02677$var$U.current.useImperativeHandle(a, b, e);
};
$e8eb19a844d02677$export$aaabe4eda9ed9969 = function(a, b) {
    return $e8eb19a844d02677$var$U.current.useInsertionEffect(a, b);
};
$e8eb19a844d02677$export$e5c5a5f917a5871c = function(a, b) {
    return $e8eb19a844d02677$var$U.current.useLayoutEffect(a, b);
};
$e8eb19a844d02677$export$1538c33de8887b59 = function(a, b) {
    return $e8eb19a844d02677$var$U.current.useMemo(a, b);
};
$e8eb19a844d02677$export$13e3392192263954 = function(a, b, e) {
    return $e8eb19a844d02677$var$U.current.useReducer(a, b, e);
};
$e8eb19a844d02677$export$b8f5890fc79d6aca = function(a) {
    return $e8eb19a844d02677$var$U.current.useRef(a);
};
$e8eb19a844d02677$export$60241385465d0a34 = function(a) {
    return $e8eb19a844d02677$var$U.current.useState(a);
};
$e8eb19a844d02677$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $e8eb19a844d02677$var$U.current.useSyncExternalStore(a, b, e);
};
$e8eb19a844d02677$export$7b286972b8d8ccbf = function() {
    return $e8eb19a844d02677$var$U.current.useTransition();
};
$e8eb19a844d02677$export$83d89fbfd8236492 = "18.2.0";

});



parcelRequire.register("gaHwe", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $bc5f567978faddca$export$ae55be85d98224ed; }, function (v) { return $bc5f567978faddca$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $bc5f567978faddca$export$d39a5bbd09211389; }, function (v) { return $bc5f567978faddca$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $bc5f567978faddca$export$882461b6382ed46c; }, function (v) { return $bc5f567978faddca$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $bc5f567978faddca$export$466bfc07425424d5; }, function (v) { return $bc5f567978faddca$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $bc5f567978faddca$export$cd75ccfd720a3cd4; }, function (v) { return $bc5f567978faddca$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $bc5f567978faddca$export$fa8d919ba61d84db; }, function (v) { return $bc5f567978faddca$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $bc5f567978faddca$export$757ceba2d55c277e; }, function (v) { return $bc5f567978faddca$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $bc5f567978faddca$export$b3890eb0ae9dca99; }, function (v) { return $bc5f567978faddca$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $bc5f567978faddca$export$502457920280e6be; }, function (v) { return $bc5f567978faddca$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $bc5f567978faddca$export$c78a37762a8d58e1; }, function (v) { return $bc5f567978faddca$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $bc5f567978faddca$export$dc54d992c10e8a18; }, function (v) { return $bc5f567978faddca$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $bc5f567978faddca$export$83d89fbfd8236492; }, function (v) { return $bc5f567978faddca$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $bc5f567978faddca$export$ae55be85d98224ed;
var $bc5f567978faddca$export$d39a5bbd09211389;
var $bc5f567978faddca$export$882461b6382ed46c;
var $bc5f567978faddca$export$466bfc07425424d5;
var $bc5f567978faddca$export$cd75ccfd720a3cd4;
var $bc5f567978faddca$export$fa8d919ba61d84db;
var $bc5f567978faddca$export$757ceba2d55c277e;
var $bc5f567978faddca$export$b3890eb0ae9dca99;
var $bc5f567978faddca$export$502457920280e6be;
var $bc5f567978faddca$export$c78a37762a8d58e1;
var $bc5f567978faddca$export$dc54d992c10e8a18;
var $bc5f567978faddca$export$83d89fbfd8236492;
"use strict";

var $aivMx = parcelRequire("aivMx");

var $fxLu7 = parcelRequire("fxLu7");
function $bc5f567978faddca$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $bc5f567978faddca$var$da = new Set, $bc5f567978faddca$var$ea = {};
function $bc5f567978faddca$var$fa(a, b) {
    $bc5f567978faddca$var$ha(a, b);
    $bc5f567978faddca$var$ha(a + "Capture", b);
}
function $bc5f567978faddca$var$ha(a, b) {
    $bc5f567978faddca$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$bc5f567978faddca$var$da.add(b[a]);
}
var $bc5f567978faddca$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $bc5f567978faddca$var$ja = Object.prototype.hasOwnProperty, $bc5f567978faddca$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $bc5f567978faddca$var$la = {}, $bc5f567978faddca$var$ma = {};
function $bc5f567978faddca$var$oa(a) {
    if ($bc5f567978faddca$var$ja.call($bc5f567978faddca$var$ma, a)) return !0;
    if ($bc5f567978faddca$var$ja.call($bc5f567978faddca$var$la, a)) return !1;
    if ($bc5f567978faddca$var$ka.test(a)) return $bc5f567978faddca$var$ma[a] = !0;
    $bc5f567978faddca$var$la[a] = !0;
    return !1;
}
function $bc5f567978faddca$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $bc5f567978faddca$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $bc5f567978faddca$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $bc5f567978faddca$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $bc5f567978faddca$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $bc5f567978faddca$var$z[a] = new $bc5f567978faddca$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $bc5f567978faddca$var$z[b] = new $bc5f567978faddca$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $bc5f567978faddca$var$z[a] = new $bc5f567978faddca$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $bc5f567978faddca$var$z[a] = new $bc5f567978faddca$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $bc5f567978faddca$var$z[a] = new $bc5f567978faddca$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $bc5f567978faddca$var$z[a] = new $bc5f567978faddca$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $bc5f567978faddca$var$z[a] = new $bc5f567978faddca$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $bc5f567978faddca$var$z[a] = new $bc5f567978faddca$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $bc5f567978faddca$var$z[a] = new $bc5f567978faddca$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $bc5f567978faddca$var$ra = /[\-:]([a-z])/g;
function $bc5f567978faddca$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($bc5f567978faddca$var$ra, $bc5f567978faddca$var$sa);
    $bc5f567978faddca$var$z[b] = new $bc5f567978faddca$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($bc5f567978faddca$var$ra, $bc5f567978faddca$var$sa);
    $bc5f567978faddca$var$z[b] = new $bc5f567978faddca$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($bc5f567978faddca$var$ra, $bc5f567978faddca$var$sa);
    $bc5f567978faddca$var$z[b] = new $bc5f567978faddca$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $bc5f567978faddca$var$z[a] = new $bc5f567978faddca$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$bc5f567978faddca$var$z.xlinkHref = new $bc5f567978faddca$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $bc5f567978faddca$var$z[a] = new $bc5f567978faddca$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $bc5f567978faddca$var$ta(a, b, c, d) {
    var e = $bc5f567978faddca$var$z.hasOwnProperty(b) ? $bc5f567978faddca$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $bc5f567978faddca$var$qa(b, c, e, d) && (c = null), d || null === e ? $bc5f567978faddca$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $bc5f567978faddca$var$ua = $aivMx.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $bc5f567978faddca$var$va = Symbol.for("react.element"), $bc5f567978faddca$var$wa = Symbol.for("react.portal"), $bc5f567978faddca$var$ya = Symbol.for("react.fragment"), $bc5f567978faddca$var$za = Symbol.for("react.strict_mode"), $bc5f567978faddca$var$Aa = Symbol.for("react.profiler"), $bc5f567978faddca$var$Ba = Symbol.for("react.provider"), $bc5f567978faddca$var$Ca = Symbol.for("react.context"), $bc5f567978faddca$var$Da = Symbol.for("react.forward_ref"), $bc5f567978faddca$var$Ea = Symbol.for("react.suspense"), $bc5f567978faddca$var$Fa = Symbol.for("react.suspense_list"), $bc5f567978faddca$var$Ga = Symbol.for("react.memo"), $bc5f567978faddca$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $bc5f567978faddca$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $bc5f567978faddca$var$Ja = Symbol.iterator;
function $bc5f567978faddca$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $bc5f567978faddca$var$Ja && a[$bc5f567978faddca$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $bc5f567978faddca$var$A = Object.assign, $bc5f567978faddca$var$La;
function $bc5f567978faddca$var$Ma(a) {
    if (void 0 === $bc5f567978faddca$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $bc5f567978faddca$var$La = b && b[1] || "";
    }
    return "\n" + $bc5f567978faddca$var$La + a;
}
var $bc5f567978faddca$var$Na = !1;
function $bc5f567978faddca$var$Oa(a, b) {
    if (!a || $bc5f567978faddca$var$Na) return "";
    $bc5f567978faddca$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $bc5f567978faddca$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $bc5f567978faddca$var$Ma(a) : "";
}
function $bc5f567978faddca$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $bc5f567978faddca$var$Ma(a.type);
        case 16:
            return $bc5f567978faddca$var$Ma("Lazy");
        case 13:
            return $bc5f567978faddca$var$Ma("Suspense");
        case 19:
            return $bc5f567978faddca$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $bc5f567978faddca$var$Oa(a.type, !1), a;
        case 11:
            return a = $bc5f567978faddca$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $bc5f567978faddca$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $bc5f567978faddca$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $bc5f567978faddca$var$ya:
            return "Fragment";
        case $bc5f567978faddca$var$wa:
            return "Portal";
        case $bc5f567978faddca$var$Aa:
            return "Profiler";
        case $bc5f567978faddca$var$za:
            return "StrictMode";
        case $bc5f567978faddca$var$Ea:
            return "Suspense";
        case $bc5f567978faddca$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $bc5f567978faddca$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $bc5f567978faddca$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $bc5f567978faddca$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $bc5f567978faddca$var$Ga:
            return b = a.displayName || null, null !== b ? b : $bc5f567978faddca$var$Qa(a.type) || "Memo";
        case $bc5f567978faddca$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $bc5f567978faddca$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $bc5f567978faddca$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $bc5f567978faddca$var$Qa(b);
        case 8:
            return b === $bc5f567978faddca$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $bc5f567978faddca$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $bc5f567978faddca$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $bc5f567978faddca$var$Ua(a) {
    var b = $bc5f567978faddca$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $bc5f567978faddca$var$Va(a) {
    a._valueTracker || (a._valueTracker = $bc5f567978faddca$var$Ua(a));
}
function $bc5f567978faddca$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $bc5f567978faddca$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $bc5f567978faddca$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $bc5f567978faddca$var$Ya(a, b) {
    var c = b.checked;
    return $bc5f567978faddca$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $bc5f567978faddca$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $bc5f567978faddca$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $bc5f567978faddca$var$ab(a, b) {
    b = b.checked;
    null != b && $bc5f567978faddca$var$ta(a, "checked", b, !1);
}
function $bc5f567978faddca$var$bb(a, b) {
    $bc5f567978faddca$var$ab(a, b);
    var c = $bc5f567978faddca$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $bc5f567978faddca$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $bc5f567978faddca$var$cb(a, b.type, $bc5f567978faddca$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $bc5f567978faddca$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $bc5f567978faddca$var$cb(a, b, c) {
    if ("number" !== b || $bc5f567978faddca$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $bc5f567978faddca$var$eb = Array.isArray;
function $bc5f567978faddca$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $bc5f567978faddca$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $bc5f567978faddca$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($bc5f567978faddca$var$p(91));
    return $bc5f567978faddca$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $bc5f567978faddca$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($bc5f567978faddca$var$p(92));
            if ($bc5f567978faddca$var$eb(c)) {
                if (1 < c.length) throw Error($bc5f567978faddca$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $bc5f567978faddca$var$Sa(c)
    };
}
function $bc5f567978faddca$var$ib(a, b) {
    var c = $bc5f567978faddca$var$Sa(b.value), d = $bc5f567978faddca$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $bc5f567978faddca$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $bc5f567978faddca$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $bc5f567978faddca$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $bc5f567978faddca$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $bc5f567978faddca$var$mb, $bc5f567978faddca$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $bc5f567978faddca$var$mb = $bc5f567978faddca$var$mb || document.createElement("div");
        $bc5f567978faddca$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $bc5f567978faddca$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $bc5f567978faddca$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $bc5f567978faddca$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $bc5f567978faddca$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($bc5f567978faddca$var$pb).forEach(function(a) {
    $bc5f567978faddca$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $bc5f567978faddca$var$pb[b] = $bc5f567978faddca$var$pb[a];
    });
});
function $bc5f567978faddca$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $bc5f567978faddca$var$pb.hasOwnProperty(a) && $bc5f567978faddca$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $bc5f567978faddca$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $bc5f567978faddca$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $bc5f567978faddca$var$tb = $bc5f567978faddca$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $bc5f567978faddca$var$ub(a, b) {
    if (b) {
        if ($bc5f567978faddca$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($bc5f567978faddca$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($bc5f567978faddca$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($bc5f567978faddca$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($bc5f567978faddca$var$p(62));
    }
}
function $bc5f567978faddca$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $bc5f567978faddca$var$wb = null;
function $bc5f567978faddca$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $bc5f567978faddca$var$yb = null, $bc5f567978faddca$var$zb = null, $bc5f567978faddca$var$Ab = null;
function $bc5f567978faddca$var$Bb(a) {
    if (a = $bc5f567978faddca$var$Cb(a)) {
        if ("function" !== typeof $bc5f567978faddca$var$yb) throw Error($bc5f567978faddca$var$p(280));
        var b = a.stateNode;
        b && (b = $bc5f567978faddca$var$Db(b), $bc5f567978faddca$var$yb(a.stateNode, a.type, b));
    }
}
function $bc5f567978faddca$var$Eb(a) {
    $bc5f567978faddca$var$zb ? $bc5f567978faddca$var$Ab ? $bc5f567978faddca$var$Ab.push(a) : $bc5f567978faddca$var$Ab = [
        a
    ] : $bc5f567978faddca$var$zb = a;
}
function $bc5f567978faddca$var$Fb() {
    if ($bc5f567978faddca$var$zb) {
        var a = $bc5f567978faddca$var$zb, b = $bc5f567978faddca$var$Ab;
        $bc5f567978faddca$var$Ab = $bc5f567978faddca$var$zb = null;
        $bc5f567978faddca$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$bc5f567978faddca$var$Bb(b[a]);
    }
}
function $bc5f567978faddca$var$Gb(a, b) {
    return a(b);
}
function $bc5f567978faddca$var$Hb() {}
var $bc5f567978faddca$var$Ib = !1;
function $bc5f567978faddca$var$Jb(a, b, c) {
    if ($bc5f567978faddca$var$Ib) return a(b, c);
    $bc5f567978faddca$var$Ib = !0;
    try {
        return $bc5f567978faddca$var$Gb(a, b, c);
    } finally{
        if ($bc5f567978faddca$var$Ib = !1, null !== $bc5f567978faddca$var$zb || null !== $bc5f567978faddca$var$Ab) $bc5f567978faddca$var$Hb(), $bc5f567978faddca$var$Fb();
    }
}
function $bc5f567978faddca$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $bc5f567978faddca$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($bc5f567978faddca$var$p(231, b, typeof c));
    return c;
}
var $bc5f567978faddca$var$Lb = !1;
if ($bc5f567978faddca$var$ia) try {
    var $bc5f567978faddca$var$Mb = {};
    Object.defineProperty($bc5f567978faddca$var$Mb, "passive", {
        get: function() {
            $bc5f567978faddca$var$Lb = !0;
        }
    });
    window.addEventListener("test", $bc5f567978faddca$var$Mb, $bc5f567978faddca$var$Mb);
    window.removeEventListener("test", $bc5f567978faddca$var$Mb, $bc5f567978faddca$var$Mb);
} catch (a) {
    $bc5f567978faddca$var$Lb = !1;
}
function $bc5f567978faddca$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $bc5f567978faddca$var$Ob = !1, $bc5f567978faddca$var$Pb = null, $bc5f567978faddca$var$Qb = !1, $bc5f567978faddca$var$Rb = null, $bc5f567978faddca$var$Sb = {
    onError: function(a) {
        $bc5f567978faddca$var$Ob = !0;
        $bc5f567978faddca$var$Pb = a;
    }
};
function $bc5f567978faddca$var$Tb(a, b, c, d, e, f, g, h, k) {
    $bc5f567978faddca$var$Ob = !1;
    $bc5f567978faddca$var$Pb = null;
    $bc5f567978faddca$var$Nb.apply($bc5f567978faddca$var$Sb, arguments);
}
function $bc5f567978faddca$var$Ub(a, b, c, d, e, f, g, h, k) {
    $bc5f567978faddca$var$Tb.apply(this, arguments);
    if ($bc5f567978faddca$var$Ob) {
        if ($bc5f567978faddca$var$Ob) {
            var l = $bc5f567978faddca$var$Pb;
            $bc5f567978faddca$var$Ob = !1;
            $bc5f567978faddca$var$Pb = null;
        } else throw Error($bc5f567978faddca$var$p(198));
        $bc5f567978faddca$var$Qb || ($bc5f567978faddca$var$Qb = !0, $bc5f567978faddca$var$Rb = l);
    }
}
function $bc5f567978faddca$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $bc5f567978faddca$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $bc5f567978faddca$var$Xb(a) {
    if ($bc5f567978faddca$var$Vb(a) !== a) throw Error($bc5f567978faddca$var$p(188));
}
function $bc5f567978faddca$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $bc5f567978faddca$var$Vb(a);
        if (null === b) throw Error($bc5f567978faddca$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $bc5f567978faddca$var$Xb(e), a;
                if (f === d) return $bc5f567978faddca$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($bc5f567978faddca$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($bc5f567978faddca$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($bc5f567978faddca$var$p(190));
    }
    if (3 !== c.tag) throw Error($bc5f567978faddca$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $bc5f567978faddca$var$Zb(a) {
    a = $bc5f567978faddca$var$Yb(a);
    return null !== a ? $bc5f567978faddca$var$$b(a) : null;
}
function $bc5f567978faddca$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $bc5f567978faddca$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $bc5f567978faddca$var$ac = $fxLu7.unstable_scheduleCallback, $bc5f567978faddca$var$bc = $fxLu7.unstable_cancelCallback, $bc5f567978faddca$var$cc = $fxLu7.unstable_shouldYield, $bc5f567978faddca$var$dc = $fxLu7.unstable_requestPaint, $bc5f567978faddca$var$B = $fxLu7.unstable_now, $bc5f567978faddca$var$ec = $fxLu7.unstable_getCurrentPriorityLevel, $bc5f567978faddca$var$fc = $fxLu7.unstable_ImmediatePriority, $bc5f567978faddca$var$gc = $fxLu7.unstable_UserBlockingPriority, $bc5f567978faddca$var$hc = $fxLu7.unstable_NormalPriority, $bc5f567978faddca$var$ic = $fxLu7.unstable_LowPriority, $bc5f567978faddca$var$jc = $fxLu7.unstable_IdlePriority, $bc5f567978faddca$var$kc = null, $bc5f567978faddca$var$lc = null;
function $bc5f567978faddca$var$mc(a) {
    if ($bc5f567978faddca$var$lc && "function" === typeof $bc5f567978faddca$var$lc.onCommitFiberRoot) try {
        $bc5f567978faddca$var$lc.onCommitFiberRoot($bc5f567978faddca$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $bc5f567978faddca$var$oc = Math.clz32 ? Math.clz32 : $bc5f567978faddca$var$nc, $bc5f567978faddca$var$pc = Math.log, $bc5f567978faddca$var$qc = Math.LN2;
function $bc5f567978faddca$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($bc5f567978faddca$var$pc(a) / $bc5f567978faddca$var$qc | 0) | 0;
}
var $bc5f567978faddca$var$rc = 64, $bc5f567978faddca$var$sc = 4194304;
function $bc5f567978faddca$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $bc5f567978faddca$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $bc5f567978faddca$var$tc(h) : (f &= g, 0 !== f && (d = $bc5f567978faddca$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $bc5f567978faddca$var$tc(g) : 0 !== f && (d = $bc5f567978faddca$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $bc5f567978faddca$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $bc5f567978faddca$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $bc5f567978faddca$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $bc5f567978faddca$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $bc5f567978faddca$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $bc5f567978faddca$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $bc5f567978faddca$var$yc() {
    var a = $bc5f567978faddca$var$rc;
    $bc5f567978faddca$var$rc <<= 1;
    0 === ($bc5f567978faddca$var$rc & 4194240) && ($bc5f567978faddca$var$rc = 64);
    return a;
}
function $bc5f567978faddca$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $bc5f567978faddca$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $bc5f567978faddca$var$oc(b);
    a[b] = c;
}
function $bc5f567978faddca$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $bc5f567978faddca$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $bc5f567978faddca$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $bc5f567978faddca$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $bc5f567978faddca$var$C = 0;
function $bc5f567978faddca$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $bc5f567978faddca$var$Ec, $bc5f567978faddca$var$Fc, $bc5f567978faddca$var$Gc, $bc5f567978faddca$var$Hc, $bc5f567978faddca$var$Ic, $bc5f567978faddca$var$Jc = !1, $bc5f567978faddca$var$Kc = [], $bc5f567978faddca$var$Lc = null, $bc5f567978faddca$var$Mc = null, $bc5f567978faddca$var$Nc = null, $bc5f567978faddca$var$Oc = new Map, $bc5f567978faddca$var$Pc = new Map, $bc5f567978faddca$var$Qc = [], $bc5f567978faddca$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $bc5f567978faddca$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $bc5f567978faddca$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $bc5f567978faddca$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $bc5f567978faddca$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $bc5f567978faddca$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $bc5f567978faddca$var$Pc.delete(b.pointerId);
    }
}
function $bc5f567978faddca$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $bc5f567978faddca$var$Cb(b), null !== b && $bc5f567978faddca$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $bc5f567978faddca$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $bc5f567978faddca$var$Lc = $bc5f567978faddca$var$Tc($bc5f567978faddca$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $bc5f567978faddca$var$Mc = $bc5f567978faddca$var$Tc($bc5f567978faddca$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $bc5f567978faddca$var$Nc = $bc5f567978faddca$var$Tc($bc5f567978faddca$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $bc5f567978faddca$var$Oc.set(f, $bc5f567978faddca$var$Tc($bc5f567978faddca$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $bc5f567978faddca$var$Pc.set(f, $bc5f567978faddca$var$Tc($bc5f567978faddca$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $bc5f567978faddca$var$Vc(a) {
    var b = $bc5f567978faddca$var$Wc(a.target);
    if (null !== b) {
        var c = $bc5f567978faddca$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $bc5f567978faddca$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $bc5f567978faddca$var$Ic(a.priority, function() {
                        $bc5f567978faddca$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $bc5f567978faddca$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $bc5f567978faddca$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $bc5f567978faddca$var$wb = d;
            c.target.dispatchEvent(d);
            $bc5f567978faddca$var$wb = null;
        } else return b = $bc5f567978faddca$var$Cb(c), null !== b && $bc5f567978faddca$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $bc5f567978faddca$var$Zc(a, b, c) {
    $bc5f567978faddca$var$Xc(a) && c.delete(b);
}
function $bc5f567978faddca$var$$c() {
    $bc5f567978faddca$var$Jc = !1;
    null !== $bc5f567978faddca$var$Lc && $bc5f567978faddca$var$Xc($bc5f567978faddca$var$Lc) && ($bc5f567978faddca$var$Lc = null);
    null !== $bc5f567978faddca$var$Mc && $bc5f567978faddca$var$Xc($bc5f567978faddca$var$Mc) && ($bc5f567978faddca$var$Mc = null);
    null !== $bc5f567978faddca$var$Nc && $bc5f567978faddca$var$Xc($bc5f567978faddca$var$Nc) && ($bc5f567978faddca$var$Nc = null);
    $bc5f567978faddca$var$Oc.forEach($bc5f567978faddca$var$Zc);
    $bc5f567978faddca$var$Pc.forEach($bc5f567978faddca$var$Zc);
}
function $bc5f567978faddca$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $bc5f567978faddca$var$Jc || ($bc5f567978faddca$var$Jc = !0, $fxLu7.unstable_scheduleCallback($fxLu7.unstable_NormalPriority, $bc5f567978faddca$var$$c)));
}
function $bc5f567978faddca$var$bd(a) {
    function b(b) {
        return $bc5f567978faddca$var$ad(b, a);
    }
    if (0 < $bc5f567978faddca$var$Kc.length) {
        $bc5f567978faddca$var$ad($bc5f567978faddca$var$Kc[0], a);
        for(var c = 1; c < $bc5f567978faddca$var$Kc.length; c++){
            var d = $bc5f567978faddca$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $bc5f567978faddca$var$Lc && $bc5f567978faddca$var$ad($bc5f567978faddca$var$Lc, a);
    null !== $bc5f567978faddca$var$Mc && $bc5f567978faddca$var$ad($bc5f567978faddca$var$Mc, a);
    null !== $bc5f567978faddca$var$Nc && $bc5f567978faddca$var$ad($bc5f567978faddca$var$Nc, a);
    $bc5f567978faddca$var$Oc.forEach(b);
    $bc5f567978faddca$var$Pc.forEach(b);
    for(c = 0; c < $bc5f567978faddca$var$Qc.length; c++)d = $bc5f567978faddca$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $bc5f567978faddca$var$Qc.length && (c = $bc5f567978faddca$var$Qc[0], null === c.blockedOn);)$bc5f567978faddca$var$Vc(c), null === c.blockedOn && $bc5f567978faddca$var$Qc.shift();
}
var $bc5f567978faddca$var$cd = $bc5f567978faddca$var$ua.ReactCurrentBatchConfig, $bc5f567978faddca$var$dd = !0;
function $bc5f567978faddca$var$ed(a, b, c, d) {
    var e = $bc5f567978faddca$var$C, f = $bc5f567978faddca$var$cd.transition;
    $bc5f567978faddca$var$cd.transition = null;
    try {
        $bc5f567978faddca$var$C = 1, $bc5f567978faddca$var$fd(a, b, c, d);
    } finally{
        $bc5f567978faddca$var$C = e, $bc5f567978faddca$var$cd.transition = f;
    }
}
function $bc5f567978faddca$var$gd(a, b, c, d) {
    var e = $bc5f567978faddca$var$C, f = $bc5f567978faddca$var$cd.transition;
    $bc5f567978faddca$var$cd.transition = null;
    try {
        $bc5f567978faddca$var$C = 4, $bc5f567978faddca$var$fd(a, b, c, d);
    } finally{
        $bc5f567978faddca$var$C = e, $bc5f567978faddca$var$cd.transition = f;
    }
}
function $bc5f567978faddca$var$fd(a, b, c, d) {
    if ($bc5f567978faddca$var$dd) {
        var e = $bc5f567978faddca$var$Yc(a, b, c, d);
        if (null === e) $bc5f567978faddca$var$hd(a, b, d, $bc5f567978faddca$var$id, c), $bc5f567978faddca$var$Sc(a, d);
        else if ($bc5f567978faddca$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($bc5f567978faddca$var$Sc(a, d), b & 4 && -1 < $bc5f567978faddca$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $bc5f567978faddca$var$Cb(e);
                null !== f && $bc5f567978faddca$var$Ec(f);
                f = $bc5f567978faddca$var$Yc(a, b, c, d);
                null === f && $bc5f567978faddca$var$hd(a, b, d, $bc5f567978faddca$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $bc5f567978faddca$var$hd(a, b, d, null, c);
    }
}
var $bc5f567978faddca$var$id = null;
function $bc5f567978faddca$var$Yc(a, b, c, d) {
    $bc5f567978faddca$var$id = null;
    a = $bc5f567978faddca$var$xb(d);
    a = $bc5f567978faddca$var$Wc(a);
    if (null !== a) {
        if (b = $bc5f567978faddca$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $bc5f567978faddca$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $bc5f567978faddca$var$id = a;
    return null;
}
function $bc5f567978faddca$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($bc5f567978faddca$var$ec()){
                case $bc5f567978faddca$var$fc:
                    return 1;
                case $bc5f567978faddca$var$gc:
                    return 4;
                case $bc5f567978faddca$var$hc:
                case $bc5f567978faddca$var$ic:
                    return 16;
                case $bc5f567978faddca$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $bc5f567978faddca$var$kd = null, $bc5f567978faddca$var$ld = null, $bc5f567978faddca$var$md = null;
function $bc5f567978faddca$var$nd() {
    if ($bc5f567978faddca$var$md) return $bc5f567978faddca$var$md;
    var a, b = $bc5f567978faddca$var$ld, c = b.length, d, e = "value" in $bc5f567978faddca$var$kd ? $bc5f567978faddca$var$kd.value : $bc5f567978faddca$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $bc5f567978faddca$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $bc5f567978faddca$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $bc5f567978faddca$var$pd() {
    return !0;
}
function $bc5f567978faddca$var$qd() {
    return !1;
}
function $bc5f567978faddca$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $bc5f567978faddca$var$pd : $bc5f567978faddca$var$qd;
        this.isPropagationStopped = $bc5f567978faddca$var$qd;
        return this;
    }
    $bc5f567978faddca$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $bc5f567978faddca$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $bc5f567978faddca$var$pd);
        },
        persist: function() {},
        isPersistent: $bc5f567978faddca$var$pd
    });
    return b;
}
var $bc5f567978faddca$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $bc5f567978faddca$var$td = $bc5f567978faddca$var$rd($bc5f567978faddca$var$sd), $bc5f567978faddca$var$ud = $bc5f567978faddca$var$A({}, $bc5f567978faddca$var$sd, {
    view: 0,
    detail: 0
}), $bc5f567978faddca$var$vd = $bc5f567978faddca$var$rd($bc5f567978faddca$var$ud), $bc5f567978faddca$var$wd, $bc5f567978faddca$var$xd, $bc5f567978faddca$var$yd, $bc5f567978faddca$var$Ad = $bc5f567978faddca$var$A({}, $bc5f567978faddca$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $bc5f567978faddca$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $bc5f567978faddca$var$yd && ($bc5f567978faddca$var$yd && "mousemove" === a.type ? ($bc5f567978faddca$var$wd = a.screenX - $bc5f567978faddca$var$yd.screenX, $bc5f567978faddca$var$xd = a.screenY - $bc5f567978faddca$var$yd.screenY) : $bc5f567978faddca$var$xd = $bc5f567978faddca$var$wd = 0, $bc5f567978faddca$var$yd = a);
        return $bc5f567978faddca$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $bc5f567978faddca$var$xd;
    }
}), $bc5f567978faddca$var$Bd = $bc5f567978faddca$var$rd($bc5f567978faddca$var$Ad), $bc5f567978faddca$var$Cd = $bc5f567978faddca$var$A({}, $bc5f567978faddca$var$Ad, {
    dataTransfer: 0
}), $bc5f567978faddca$var$Dd = $bc5f567978faddca$var$rd($bc5f567978faddca$var$Cd), $bc5f567978faddca$var$Ed = $bc5f567978faddca$var$A({}, $bc5f567978faddca$var$ud, {
    relatedTarget: 0
}), $bc5f567978faddca$var$Fd = $bc5f567978faddca$var$rd($bc5f567978faddca$var$Ed), $bc5f567978faddca$var$Gd = $bc5f567978faddca$var$A({}, $bc5f567978faddca$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $bc5f567978faddca$var$Hd = $bc5f567978faddca$var$rd($bc5f567978faddca$var$Gd), $bc5f567978faddca$var$Id = $bc5f567978faddca$var$A({}, $bc5f567978faddca$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $bc5f567978faddca$var$Jd = $bc5f567978faddca$var$rd($bc5f567978faddca$var$Id), $bc5f567978faddca$var$Kd = $bc5f567978faddca$var$A({}, $bc5f567978faddca$var$sd, {
    data: 0
}), $bc5f567978faddca$var$Ld = $bc5f567978faddca$var$rd($bc5f567978faddca$var$Kd), $bc5f567978faddca$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $bc5f567978faddca$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $bc5f567978faddca$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $bc5f567978faddca$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $bc5f567978faddca$var$Od[a]) ? !!b[a] : !1;
}
function $bc5f567978faddca$var$zd() {
    return $bc5f567978faddca$var$Pd;
}
var $bc5f567978faddca$var$Qd = $bc5f567978faddca$var$A({}, $bc5f567978faddca$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $bc5f567978faddca$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $bc5f567978faddca$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $bc5f567978faddca$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $bc5f567978faddca$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $bc5f567978faddca$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $bc5f567978faddca$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $bc5f567978faddca$var$Rd = $bc5f567978faddca$var$rd($bc5f567978faddca$var$Qd), $bc5f567978faddca$var$Sd = $bc5f567978faddca$var$A({}, $bc5f567978faddca$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $bc5f567978faddca$var$Td = $bc5f567978faddca$var$rd($bc5f567978faddca$var$Sd), $bc5f567978faddca$var$Ud = $bc5f567978faddca$var$A({}, $bc5f567978faddca$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $bc5f567978faddca$var$zd
}), $bc5f567978faddca$var$Vd = $bc5f567978faddca$var$rd($bc5f567978faddca$var$Ud), $bc5f567978faddca$var$Wd = $bc5f567978faddca$var$A({}, $bc5f567978faddca$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $bc5f567978faddca$var$Xd = $bc5f567978faddca$var$rd($bc5f567978faddca$var$Wd), $bc5f567978faddca$var$Yd = $bc5f567978faddca$var$A({}, $bc5f567978faddca$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $bc5f567978faddca$var$Zd = $bc5f567978faddca$var$rd($bc5f567978faddca$var$Yd), $bc5f567978faddca$var$$d = [
    9,
    13,
    27,
    32
], $bc5f567978faddca$var$ae = $bc5f567978faddca$var$ia && "CompositionEvent" in window, $bc5f567978faddca$var$be = null;
$bc5f567978faddca$var$ia && "documentMode" in document && ($bc5f567978faddca$var$be = document.documentMode);
var $bc5f567978faddca$var$ce = $bc5f567978faddca$var$ia && "TextEvent" in window && !$bc5f567978faddca$var$be, $bc5f567978faddca$var$de = $bc5f567978faddca$var$ia && (!$bc5f567978faddca$var$ae || $bc5f567978faddca$var$be && 8 < $bc5f567978faddca$var$be && 11 >= $bc5f567978faddca$var$be), $bc5f567978faddca$var$ee = String.fromCharCode(32), $bc5f567978faddca$var$fe = !1;
function $bc5f567978faddca$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $bc5f567978faddca$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $bc5f567978faddca$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $bc5f567978faddca$var$ie = !1;
function $bc5f567978faddca$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $bc5f567978faddca$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $bc5f567978faddca$var$fe = !0;
            return $bc5f567978faddca$var$ee;
        case "textInput":
            return a = b.data, a === $bc5f567978faddca$var$ee && $bc5f567978faddca$var$fe ? null : a;
        default:
            return null;
    }
}
function $bc5f567978faddca$var$ke(a, b) {
    if ($bc5f567978faddca$var$ie) return "compositionend" === a || !$bc5f567978faddca$var$ae && $bc5f567978faddca$var$ge(a, b) ? (a = $bc5f567978faddca$var$nd(), $bc5f567978faddca$var$md = $bc5f567978faddca$var$ld = $bc5f567978faddca$var$kd = null, $bc5f567978faddca$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $bc5f567978faddca$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $bc5f567978faddca$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $bc5f567978faddca$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$bc5f567978faddca$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $bc5f567978faddca$var$ne(a, b, c, d) {
    $bc5f567978faddca$var$Eb(d);
    b = $bc5f567978faddca$var$oe(b, "onChange");
    0 < b.length && (c = new $bc5f567978faddca$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $bc5f567978faddca$var$pe = null, $bc5f567978faddca$var$qe = null;
function $bc5f567978faddca$var$re(a) {
    $bc5f567978faddca$var$se(a, 0);
}
function $bc5f567978faddca$var$te(a) {
    var b = $bc5f567978faddca$var$ue(a);
    if ($bc5f567978faddca$var$Wa(b)) return a;
}
function $bc5f567978faddca$var$ve(a, b) {
    if ("change" === a) return b;
}
var $bc5f567978faddca$var$we = !1;
if ($bc5f567978faddca$var$ia) {
    var $bc5f567978faddca$var$xe;
    if ($bc5f567978faddca$var$ia) {
        var $bc5f567978faddca$var$ye = "oninput" in document;
        if (!$bc5f567978faddca$var$ye) {
            var $bc5f567978faddca$var$ze = document.createElement("div");
            $bc5f567978faddca$var$ze.setAttribute("oninput", "return;");
            $bc5f567978faddca$var$ye = "function" === typeof $bc5f567978faddca$var$ze.oninput;
        }
        $bc5f567978faddca$var$xe = $bc5f567978faddca$var$ye;
    } else $bc5f567978faddca$var$xe = !1;
    $bc5f567978faddca$var$we = $bc5f567978faddca$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $bc5f567978faddca$var$Ae() {
    $bc5f567978faddca$var$pe && ($bc5f567978faddca$var$pe.detachEvent("onpropertychange", $bc5f567978faddca$var$Be), $bc5f567978faddca$var$qe = $bc5f567978faddca$var$pe = null);
}
function $bc5f567978faddca$var$Be(a) {
    if ("value" === a.propertyName && $bc5f567978faddca$var$te($bc5f567978faddca$var$qe)) {
        var b = [];
        $bc5f567978faddca$var$ne(b, $bc5f567978faddca$var$qe, a, $bc5f567978faddca$var$xb(a));
        $bc5f567978faddca$var$Jb($bc5f567978faddca$var$re, b);
    }
}
function $bc5f567978faddca$var$Ce(a, b, c) {
    "focusin" === a ? ($bc5f567978faddca$var$Ae(), $bc5f567978faddca$var$pe = b, $bc5f567978faddca$var$qe = c, $bc5f567978faddca$var$pe.attachEvent("onpropertychange", $bc5f567978faddca$var$Be)) : "focusout" === a && $bc5f567978faddca$var$Ae();
}
function $bc5f567978faddca$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $bc5f567978faddca$var$te($bc5f567978faddca$var$qe);
}
function $bc5f567978faddca$var$Ee(a, b) {
    if ("click" === a) return $bc5f567978faddca$var$te(b);
}
function $bc5f567978faddca$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $bc5f567978faddca$var$te(b);
}
function $bc5f567978faddca$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $bc5f567978faddca$var$He = "function" === typeof Object.is ? Object.is : $bc5f567978faddca$var$Ge;
function $bc5f567978faddca$var$Ie(a, b) {
    if ($bc5f567978faddca$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$bc5f567978faddca$var$ja.call(b, e) || !$bc5f567978faddca$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $bc5f567978faddca$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $bc5f567978faddca$var$Ke(a, b) {
    var c = $bc5f567978faddca$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $bc5f567978faddca$var$Je(c);
    }
}
function $bc5f567978faddca$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $bc5f567978faddca$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $bc5f567978faddca$var$Me() {
    for(var a = window, b = $bc5f567978faddca$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $bc5f567978faddca$var$Xa(a.document);
    }
    return b;
}
function $bc5f567978faddca$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $bc5f567978faddca$var$Oe(a) {
    var b = $bc5f567978faddca$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $bc5f567978faddca$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $bc5f567978faddca$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $bc5f567978faddca$var$Ke(c, f);
                var g = $bc5f567978faddca$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $bc5f567978faddca$var$Pe = $bc5f567978faddca$var$ia && "documentMode" in document && 11 >= document.documentMode, $bc5f567978faddca$var$Qe = null, $bc5f567978faddca$var$Re = null, $bc5f567978faddca$var$Se = null, $bc5f567978faddca$var$Te = !1;
function $bc5f567978faddca$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $bc5f567978faddca$var$Te || null == $bc5f567978faddca$var$Qe || $bc5f567978faddca$var$Qe !== $bc5f567978faddca$var$Xa(d) || (d = $bc5f567978faddca$var$Qe, "selectionStart" in d && $bc5f567978faddca$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $bc5f567978faddca$var$Se && $bc5f567978faddca$var$Ie($bc5f567978faddca$var$Se, d) || ($bc5f567978faddca$var$Se = d, d = $bc5f567978faddca$var$oe($bc5f567978faddca$var$Re, "onSelect"), 0 < d.length && (b = new $bc5f567978faddca$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $bc5f567978faddca$var$Qe)));
}
function $bc5f567978faddca$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $bc5f567978faddca$var$We = {
    animationend: $bc5f567978faddca$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $bc5f567978faddca$var$Ve("Animation", "AnimationIteration"),
    animationstart: $bc5f567978faddca$var$Ve("Animation", "AnimationStart"),
    transitionend: $bc5f567978faddca$var$Ve("Transition", "TransitionEnd")
}, $bc5f567978faddca$var$Xe = {}, $bc5f567978faddca$var$Ye = {};
$bc5f567978faddca$var$ia && ($bc5f567978faddca$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $bc5f567978faddca$var$We.animationend.animation, delete $bc5f567978faddca$var$We.animationiteration.animation, delete $bc5f567978faddca$var$We.animationstart.animation), "TransitionEvent" in window || delete $bc5f567978faddca$var$We.transitionend.transition);
function $bc5f567978faddca$var$Ze(a) {
    if ($bc5f567978faddca$var$Xe[a]) return $bc5f567978faddca$var$Xe[a];
    if (!$bc5f567978faddca$var$We[a]) return a;
    var b = $bc5f567978faddca$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $bc5f567978faddca$var$Ye) return $bc5f567978faddca$var$Xe[a] = b[c];
    return a;
}
var $bc5f567978faddca$var$$e = $bc5f567978faddca$var$Ze("animationend"), $bc5f567978faddca$var$af = $bc5f567978faddca$var$Ze("animationiteration"), $bc5f567978faddca$var$bf = $bc5f567978faddca$var$Ze("animationstart"), $bc5f567978faddca$var$cf = $bc5f567978faddca$var$Ze("transitionend"), $bc5f567978faddca$var$df = new Map, $bc5f567978faddca$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $bc5f567978faddca$var$ff(a, b) {
    $bc5f567978faddca$var$df.set(a, b);
    $bc5f567978faddca$var$fa(b, [
        a
    ]);
}
for(var $bc5f567978faddca$var$gf = 0; $bc5f567978faddca$var$gf < $bc5f567978faddca$var$ef.length; $bc5f567978faddca$var$gf++){
    var $bc5f567978faddca$var$hf = $bc5f567978faddca$var$ef[$bc5f567978faddca$var$gf], $bc5f567978faddca$var$jf = $bc5f567978faddca$var$hf.toLowerCase(), $bc5f567978faddca$var$kf = $bc5f567978faddca$var$hf[0].toUpperCase() + $bc5f567978faddca$var$hf.slice(1);
    $bc5f567978faddca$var$ff($bc5f567978faddca$var$jf, "on" + $bc5f567978faddca$var$kf);
}
$bc5f567978faddca$var$ff($bc5f567978faddca$var$$e, "onAnimationEnd");
$bc5f567978faddca$var$ff($bc5f567978faddca$var$af, "onAnimationIteration");
$bc5f567978faddca$var$ff($bc5f567978faddca$var$bf, "onAnimationStart");
$bc5f567978faddca$var$ff("dblclick", "onDoubleClick");
$bc5f567978faddca$var$ff("focusin", "onFocus");
$bc5f567978faddca$var$ff("focusout", "onBlur");
$bc5f567978faddca$var$ff($bc5f567978faddca$var$cf, "onTransitionEnd");
$bc5f567978faddca$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$bc5f567978faddca$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$bc5f567978faddca$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$bc5f567978faddca$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$bc5f567978faddca$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$bc5f567978faddca$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$bc5f567978faddca$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$bc5f567978faddca$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$bc5f567978faddca$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$bc5f567978faddca$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $bc5f567978faddca$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $bc5f567978faddca$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($bc5f567978faddca$var$lf));
function $bc5f567978faddca$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $bc5f567978faddca$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $bc5f567978faddca$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $bc5f567978faddca$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $bc5f567978faddca$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($bc5f567978faddca$var$Qb) throw a = $bc5f567978faddca$var$Rb, $bc5f567978faddca$var$Qb = !1, $bc5f567978faddca$var$Rb = null, a;
}
function $bc5f567978faddca$var$D(a, b) {
    var c = b[$bc5f567978faddca$var$of];
    void 0 === c && (c = b[$bc5f567978faddca$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($bc5f567978faddca$var$pf(b, a, 2, !1), c.add(d));
}
function $bc5f567978faddca$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $bc5f567978faddca$var$pf(c, a, d, b);
}
var $bc5f567978faddca$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $bc5f567978faddca$var$sf(a) {
    if (!a[$bc5f567978faddca$var$rf]) {
        a[$bc5f567978faddca$var$rf] = !0;
        $bc5f567978faddca$var$da.forEach(function(b) {
            "selectionchange" !== b && ($bc5f567978faddca$var$mf.has(b) || $bc5f567978faddca$var$qf(b, !1, a), $bc5f567978faddca$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$bc5f567978faddca$var$rf] || (b[$bc5f567978faddca$var$rf] = !0, $bc5f567978faddca$var$qf("selectionchange", !1, b));
    }
}
function $bc5f567978faddca$var$pf(a, b, c, d) {
    switch($bc5f567978faddca$var$jd(b)){
        case 1:
            var e = $bc5f567978faddca$var$ed;
            break;
        case 4:
            e = $bc5f567978faddca$var$gd;
            break;
        default:
            e = $bc5f567978faddca$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$bc5f567978faddca$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $bc5f567978faddca$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $bc5f567978faddca$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $bc5f567978faddca$var$Jb(function() {
        var d = f, e = $bc5f567978faddca$var$xb(c), g = [];
        a: {
            var h = $bc5f567978faddca$var$df.get(a);
            if (void 0 !== h) {
                var k = $bc5f567978faddca$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $bc5f567978faddca$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $bc5f567978faddca$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $bc5f567978faddca$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $bc5f567978faddca$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $bc5f567978faddca$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $bc5f567978faddca$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $bc5f567978faddca$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $bc5f567978faddca$var$Vd;
                        break;
                    case $bc5f567978faddca$var$$e:
                    case $bc5f567978faddca$var$af:
                    case $bc5f567978faddca$var$bf:
                        k = $bc5f567978faddca$var$Hd;
                        break;
                    case $bc5f567978faddca$var$cf:
                        k = $bc5f567978faddca$var$Xd;
                        break;
                    case "scroll":
                        k = $bc5f567978faddca$var$vd;
                        break;
                    case "wheel":
                        k = $bc5f567978faddca$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $bc5f567978faddca$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $bc5f567978faddca$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $bc5f567978faddca$var$Kb(w, x), null != F && t.push($bc5f567978faddca$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $bc5f567978faddca$var$wb && (n = c.relatedTarget || c.fromElement) && ($bc5f567978faddca$var$Wc(n) || n[$bc5f567978faddca$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $bc5f567978faddca$var$Wc(n) : null, null !== n && (J = $bc5f567978faddca$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $bc5f567978faddca$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $bc5f567978faddca$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $bc5f567978faddca$var$ue(k);
                        u = null == n ? h : $bc5f567978faddca$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $bc5f567978faddca$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $bc5f567978faddca$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $bc5f567978faddca$var$vf(F))u++;
                            for(; 0 < w - u;)t = $bc5f567978faddca$var$vf(t), w--;
                            for(; 0 < u - w;)x = $bc5f567978faddca$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $bc5f567978faddca$var$vf(t);
                                x = $bc5f567978faddca$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $bc5f567978faddca$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $bc5f567978faddca$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $bc5f567978faddca$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $bc5f567978faddca$var$ve;
                else if ($bc5f567978faddca$var$me(h)) {
                    if ($bc5f567978faddca$var$we) na = $bc5f567978faddca$var$Fe;
                    else {
                        na = $bc5f567978faddca$var$De;
                        var xa = $bc5f567978faddca$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $bc5f567978faddca$var$Ee);
                if (na && (na = na(a, d))) {
                    $bc5f567978faddca$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $bc5f567978faddca$var$cb(h, "number", h.value);
            }
            xa = d ? $bc5f567978faddca$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($bc5f567978faddca$var$me(xa) || "true" === xa.contentEditable) $bc5f567978faddca$var$Qe = xa, $bc5f567978faddca$var$Re = d, $bc5f567978faddca$var$Se = null;
                    break;
                case "focusout":
                    $bc5f567978faddca$var$Se = $bc5f567978faddca$var$Re = $bc5f567978faddca$var$Qe = null;
                    break;
                case "mousedown":
                    $bc5f567978faddca$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $bc5f567978faddca$var$Te = !1;
                    $bc5f567978faddca$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($bc5f567978faddca$var$Pe) break;
                case "keydown":
                case "keyup":
                    $bc5f567978faddca$var$Ue(g, c, e);
            }
            var $a;
            if ($bc5f567978faddca$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $bc5f567978faddca$var$ie ? $bc5f567978faddca$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($bc5f567978faddca$var$de && "ko" !== c.locale && ($bc5f567978faddca$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $bc5f567978faddca$var$ie && ($a = $bc5f567978faddca$var$nd()) : ($bc5f567978faddca$var$kd = e, $bc5f567978faddca$var$ld = "value" in $bc5f567978faddca$var$kd ? $bc5f567978faddca$var$kd.value : $bc5f567978faddca$var$kd.textContent, $bc5f567978faddca$var$ie = !0)), xa = $bc5f567978faddca$var$oe(d, ba), 0 < xa.length && (ba = new $bc5f567978faddca$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $bc5f567978faddca$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $bc5f567978faddca$var$ce ? $bc5f567978faddca$var$je(a, c) : $bc5f567978faddca$var$ke(a, c)) d = $bc5f567978faddca$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $bc5f567978faddca$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $bc5f567978faddca$var$se(g, b);
    });
}
function $bc5f567978faddca$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $bc5f567978faddca$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $bc5f567978faddca$var$Kb(a, c), null != f && d.unshift($bc5f567978faddca$var$tf(a, f, e)), f = $bc5f567978faddca$var$Kb(a, b), null != f && d.push($bc5f567978faddca$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $bc5f567978faddca$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $bc5f567978faddca$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $bc5f567978faddca$var$Kb(c, f), null != k && g.unshift($bc5f567978faddca$var$tf(c, k, h))) : e || (k = $bc5f567978faddca$var$Kb(c, f), null != k && g.push($bc5f567978faddca$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $bc5f567978faddca$var$xf = /\r\n?/g, $bc5f567978faddca$var$yf = /\u0000|\uFFFD/g;
function $bc5f567978faddca$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($bc5f567978faddca$var$xf, "\n").replace($bc5f567978faddca$var$yf, "");
}
function $bc5f567978faddca$var$Af(a, b, c) {
    b = $bc5f567978faddca$var$zf(b);
    if ($bc5f567978faddca$var$zf(a) !== b && c) throw Error($bc5f567978faddca$var$p(425));
}
function $bc5f567978faddca$var$Bf() {}
var $bc5f567978faddca$var$Cf = null, $bc5f567978faddca$var$Df = null;
function $bc5f567978faddca$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $bc5f567978faddca$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $bc5f567978faddca$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $bc5f567978faddca$var$Hf = "function" === typeof Promise ? Promise : void 0, $bc5f567978faddca$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $bc5f567978faddca$var$Hf ? function(a) {
    return $bc5f567978faddca$var$Hf.resolve(null).then(a).catch($bc5f567978faddca$var$If);
} : $bc5f567978faddca$var$Ff;
function $bc5f567978faddca$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $bc5f567978faddca$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $bc5f567978faddca$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $bc5f567978faddca$var$bd(b);
}
function $bc5f567978faddca$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $bc5f567978faddca$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $bc5f567978faddca$var$Nf = Math.random().toString(36).slice(2), $bc5f567978faddca$var$Of = "__reactFiber$" + $bc5f567978faddca$var$Nf, $bc5f567978faddca$var$Pf = "__reactProps$" + $bc5f567978faddca$var$Nf, $bc5f567978faddca$var$uf = "__reactContainer$" + $bc5f567978faddca$var$Nf, $bc5f567978faddca$var$of = "__reactEvents$" + $bc5f567978faddca$var$Nf, $bc5f567978faddca$var$Qf = "__reactListeners$" + $bc5f567978faddca$var$Nf, $bc5f567978faddca$var$Rf = "__reactHandles$" + $bc5f567978faddca$var$Nf;
function $bc5f567978faddca$var$Wc(a) {
    var b = a[$bc5f567978faddca$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$bc5f567978faddca$var$uf] || c[$bc5f567978faddca$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $bc5f567978faddca$var$Mf(a); null !== a;){
                if (c = a[$bc5f567978faddca$var$Of]) return c;
                a = $bc5f567978faddca$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $bc5f567978faddca$var$Cb(a) {
    a = a[$bc5f567978faddca$var$Of] || a[$bc5f567978faddca$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $bc5f567978faddca$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($bc5f567978faddca$var$p(33));
}
function $bc5f567978faddca$var$Db(a) {
    return a[$bc5f567978faddca$var$Pf] || null;
}
var $bc5f567978faddca$var$Sf = [], $bc5f567978faddca$var$Tf = -1;
function $bc5f567978faddca$var$Uf(a) {
    return {
        current: a
    };
}
function $bc5f567978faddca$var$E(a) {
    0 > $bc5f567978faddca$var$Tf || (a.current = $bc5f567978faddca$var$Sf[$bc5f567978faddca$var$Tf], $bc5f567978faddca$var$Sf[$bc5f567978faddca$var$Tf] = null, $bc5f567978faddca$var$Tf--);
}
function $bc5f567978faddca$var$G(a, b) {
    $bc5f567978faddca$var$Tf++;
    $bc5f567978faddca$var$Sf[$bc5f567978faddca$var$Tf] = a.current;
    a.current = b;
}
var $bc5f567978faddca$var$Vf = {}, $bc5f567978faddca$var$H = $bc5f567978faddca$var$Uf($bc5f567978faddca$var$Vf), $bc5f567978faddca$var$Wf = $bc5f567978faddca$var$Uf(!1), $bc5f567978faddca$var$Xf = $bc5f567978faddca$var$Vf;
function $bc5f567978faddca$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $bc5f567978faddca$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $bc5f567978faddca$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $bc5f567978faddca$var$$f() {
    $bc5f567978faddca$var$E($bc5f567978faddca$var$Wf);
    $bc5f567978faddca$var$E($bc5f567978faddca$var$H);
}
function $bc5f567978faddca$var$ag(a, b, c) {
    if ($bc5f567978faddca$var$H.current !== $bc5f567978faddca$var$Vf) throw Error($bc5f567978faddca$var$p(168));
    $bc5f567978faddca$var$G($bc5f567978faddca$var$H, b);
    $bc5f567978faddca$var$G($bc5f567978faddca$var$Wf, c);
}
function $bc5f567978faddca$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($bc5f567978faddca$var$p(108, $bc5f567978faddca$var$Ra(a) || "Unknown", e));
    return $bc5f567978faddca$var$A({}, c, d);
}
function $bc5f567978faddca$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $bc5f567978faddca$var$Vf;
    $bc5f567978faddca$var$Xf = $bc5f567978faddca$var$H.current;
    $bc5f567978faddca$var$G($bc5f567978faddca$var$H, a);
    $bc5f567978faddca$var$G($bc5f567978faddca$var$Wf, $bc5f567978faddca$var$Wf.current);
    return !0;
}
function $bc5f567978faddca$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($bc5f567978faddca$var$p(169));
    c ? (a = $bc5f567978faddca$var$bg(a, b, $bc5f567978faddca$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $bc5f567978faddca$var$E($bc5f567978faddca$var$Wf), $bc5f567978faddca$var$E($bc5f567978faddca$var$H), $bc5f567978faddca$var$G($bc5f567978faddca$var$H, a)) : $bc5f567978faddca$var$E($bc5f567978faddca$var$Wf);
    $bc5f567978faddca$var$G($bc5f567978faddca$var$Wf, c);
}
var $bc5f567978faddca$var$eg = null, $bc5f567978faddca$var$fg = !1, $bc5f567978faddca$var$gg = !1;
function $bc5f567978faddca$var$hg(a) {
    null === $bc5f567978faddca$var$eg ? $bc5f567978faddca$var$eg = [
        a
    ] : $bc5f567978faddca$var$eg.push(a);
}
function $bc5f567978faddca$var$ig(a) {
    $bc5f567978faddca$var$fg = !0;
    $bc5f567978faddca$var$hg(a);
}
function $bc5f567978faddca$var$jg() {
    if (!$bc5f567978faddca$var$gg && null !== $bc5f567978faddca$var$eg) {
        $bc5f567978faddca$var$gg = !0;
        var a = 0, b = $bc5f567978faddca$var$C;
        try {
            var c = $bc5f567978faddca$var$eg;
            for($bc5f567978faddca$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $bc5f567978faddca$var$eg = null;
            $bc5f567978faddca$var$fg = !1;
        } catch (e) {
            throw null !== $bc5f567978faddca$var$eg && ($bc5f567978faddca$var$eg = $bc5f567978faddca$var$eg.slice(a + 1)), $bc5f567978faddca$var$ac($bc5f567978faddca$var$fc, $bc5f567978faddca$var$jg), e;
        } finally{
            $bc5f567978faddca$var$C = b, $bc5f567978faddca$var$gg = !1;
        }
    }
    return null;
}
var $bc5f567978faddca$var$kg = [], $bc5f567978faddca$var$lg = 0, $bc5f567978faddca$var$mg = null, $bc5f567978faddca$var$ng = 0, $bc5f567978faddca$var$og = [], $bc5f567978faddca$var$pg = 0, $bc5f567978faddca$var$qg = null, $bc5f567978faddca$var$rg = 1, $bc5f567978faddca$var$sg = "";
function $bc5f567978faddca$var$tg(a, b) {
    $bc5f567978faddca$var$kg[$bc5f567978faddca$var$lg++] = $bc5f567978faddca$var$ng;
    $bc5f567978faddca$var$kg[$bc5f567978faddca$var$lg++] = $bc5f567978faddca$var$mg;
    $bc5f567978faddca$var$mg = a;
    $bc5f567978faddca$var$ng = b;
}
function $bc5f567978faddca$var$ug(a, b, c) {
    $bc5f567978faddca$var$og[$bc5f567978faddca$var$pg++] = $bc5f567978faddca$var$rg;
    $bc5f567978faddca$var$og[$bc5f567978faddca$var$pg++] = $bc5f567978faddca$var$sg;
    $bc5f567978faddca$var$og[$bc5f567978faddca$var$pg++] = $bc5f567978faddca$var$qg;
    $bc5f567978faddca$var$qg = a;
    var d = $bc5f567978faddca$var$rg;
    a = $bc5f567978faddca$var$sg;
    var e = 32 - $bc5f567978faddca$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $bc5f567978faddca$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $bc5f567978faddca$var$rg = 1 << 32 - $bc5f567978faddca$var$oc(b) + e | c << e | d;
        $bc5f567978faddca$var$sg = f + a;
    } else $bc5f567978faddca$var$rg = 1 << f | c << e | d, $bc5f567978faddca$var$sg = a;
}
function $bc5f567978faddca$var$vg(a) {
    null !== a.return && ($bc5f567978faddca$var$tg(a, 1), $bc5f567978faddca$var$ug(a, 1, 0));
}
function $bc5f567978faddca$var$wg(a) {
    for(; a === $bc5f567978faddca$var$mg;)$bc5f567978faddca$var$mg = $bc5f567978faddca$var$kg[--$bc5f567978faddca$var$lg], $bc5f567978faddca$var$kg[$bc5f567978faddca$var$lg] = null, $bc5f567978faddca$var$ng = $bc5f567978faddca$var$kg[--$bc5f567978faddca$var$lg], $bc5f567978faddca$var$kg[$bc5f567978faddca$var$lg] = null;
    for(; a === $bc5f567978faddca$var$qg;)$bc5f567978faddca$var$qg = $bc5f567978faddca$var$og[--$bc5f567978faddca$var$pg], $bc5f567978faddca$var$og[$bc5f567978faddca$var$pg] = null, $bc5f567978faddca$var$sg = $bc5f567978faddca$var$og[--$bc5f567978faddca$var$pg], $bc5f567978faddca$var$og[$bc5f567978faddca$var$pg] = null, $bc5f567978faddca$var$rg = $bc5f567978faddca$var$og[--$bc5f567978faddca$var$pg], $bc5f567978faddca$var$og[$bc5f567978faddca$var$pg] = null;
}
var $bc5f567978faddca$var$xg = null, $bc5f567978faddca$var$yg = null, $bc5f567978faddca$var$I = !1, $bc5f567978faddca$var$zg = null;
function $bc5f567978faddca$var$Ag(a, b) {
    var c = $bc5f567978faddca$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $bc5f567978faddca$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $bc5f567978faddca$var$xg = a, $bc5f567978faddca$var$yg = $bc5f567978faddca$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $bc5f567978faddca$var$xg = a, $bc5f567978faddca$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $bc5f567978faddca$var$qg ? {
                id: $bc5f567978faddca$var$rg,
                overflow: $bc5f567978faddca$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $bc5f567978faddca$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $bc5f567978faddca$var$xg = a, $bc5f567978faddca$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $bc5f567978faddca$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $bc5f567978faddca$var$Eg(a) {
    if ($bc5f567978faddca$var$I) {
        var b = $bc5f567978faddca$var$yg;
        if (b) {
            var c = b;
            if (!$bc5f567978faddca$var$Cg(a, b)) {
                if ($bc5f567978faddca$var$Dg(a)) throw Error($bc5f567978faddca$var$p(418));
                b = $bc5f567978faddca$var$Lf(c.nextSibling);
                var d = $bc5f567978faddca$var$xg;
                b && $bc5f567978faddca$var$Cg(a, b) ? $bc5f567978faddca$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $bc5f567978faddca$var$I = !1, $bc5f567978faddca$var$xg = a);
            }
        } else {
            if ($bc5f567978faddca$var$Dg(a)) throw Error($bc5f567978faddca$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $bc5f567978faddca$var$I = !1;
            $bc5f567978faddca$var$xg = a;
        }
    }
}
function $bc5f567978faddca$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $bc5f567978faddca$var$xg = a;
}
function $bc5f567978faddca$var$Gg(a) {
    if (a !== $bc5f567978faddca$var$xg) return !1;
    if (!$bc5f567978faddca$var$I) return $bc5f567978faddca$var$Fg(a), $bc5f567978faddca$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$bc5f567978faddca$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $bc5f567978faddca$var$yg)) {
        if ($bc5f567978faddca$var$Dg(a)) throw $bc5f567978faddca$var$Hg(), Error($bc5f567978faddca$var$p(418));
        for(; b;)$bc5f567978faddca$var$Ag(a, b), b = $bc5f567978faddca$var$Lf(b.nextSibling);
    }
    $bc5f567978faddca$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($bc5f567978faddca$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $bc5f567978faddca$var$yg = $bc5f567978faddca$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $bc5f567978faddca$var$yg = null;
        }
    } else $bc5f567978faddca$var$yg = $bc5f567978faddca$var$xg ? $bc5f567978faddca$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $bc5f567978faddca$var$Hg() {
    for(var a = $bc5f567978faddca$var$yg; a;)a = $bc5f567978faddca$var$Lf(a.nextSibling);
}
function $bc5f567978faddca$var$Ig() {
    $bc5f567978faddca$var$yg = $bc5f567978faddca$var$xg = null;
    $bc5f567978faddca$var$I = !1;
}
function $bc5f567978faddca$var$Jg(a) {
    null === $bc5f567978faddca$var$zg ? $bc5f567978faddca$var$zg = [
        a
    ] : $bc5f567978faddca$var$zg.push(a);
}
var $bc5f567978faddca$var$Kg = $bc5f567978faddca$var$ua.ReactCurrentBatchConfig;
function $bc5f567978faddca$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $bc5f567978faddca$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $bc5f567978faddca$var$Mg = $bc5f567978faddca$var$Uf(null), $bc5f567978faddca$var$Ng = null, $bc5f567978faddca$var$Og = null, $bc5f567978faddca$var$Pg = null;
function $bc5f567978faddca$var$Qg() {
    $bc5f567978faddca$var$Pg = $bc5f567978faddca$var$Og = $bc5f567978faddca$var$Ng = null;
}
function $bc5f567978faddca$var$Rg(a) {
    var b = $bc5f567978faddca$var$Mg.current;
    $bc5f567978faddca$var$E($bc5f567978faddca$var$Mg);
    a._currentValue = b;
}
function $bc5f567978faddca$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $bc5f567978faddca$var$Tg(a, b) {
    $bc5f567978faddca$var$Ng = a;
    $bc5f567978faddca$var$Pg = $bc5f567978faddca$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($bc5f567978faddca$var$Ug = !0), a.firstContext = null);
}
function $bc5f567978faddca$var$Vg(a) {
    var b = a._currentValue;
    if ($bc5f567978faddca$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $bc5f567978faddca$var$Og) {
            if (null === $bc5f567978faddca$var$Ng) throw Error($bc5f567978faddca$var$p(308));
            $bc5f567978faddca$var$Og = a;
            $bc5f567978faddca$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $bc5f567978faddca$var$Og = $bc5f567978faddca$var$Og.next = a;
    }
    return b;
}
var $bc5f567978faddca$var$Wg = null;
function $bc5f567978faddca$var$Xg(a) {
    null === $bc5f567978faddca$var$Wg ? $bc5f567978faddca$var$Wg = [
        a
    ] : $bc5f567978faddca$var$Wg.push(a);
}
function $bc5f567978faddca$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $bc5f567978faddca$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $bc5f567978faddca$var$Zg(a, d);
}
function $bc5f567978faddca$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $bc5f567978faddca$var$$g = !1;
function $bc5f567978faddca$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $bc5f567978faddca$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $bc5f567978faddca$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $bc5f567978faddca$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($bc5f567978faddca$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $bc5f567978faddca$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $bc5f567978faddca$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $bc5f567978faddca$var$Zg(a, c);
}
function $bc5f567978faddca$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $bc5f567978faddca$var$Cc(a, c);
    }
}
function $bc5f567978faddca$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $bc5f567978faddca$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $bc5f567978faddca$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $bc5f567978faddca$var$A({}, q, r);
                            break a;
                        case 2:
                            $bc5f567978faddca$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $bc5f567978faddca$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $bc5f567978faddca$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($bc5f567978faddca$var$p(191, e));
            e.call(d);
        }
    }
}
var $bc5f567978faddca$var$jh = (new $aivMx.Component).refs;
function $bc5f567978faddca$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $bc5f567978faddca$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $bc5f567978faddca$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $bc5f567978faddca$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $bc5f567978faddca$var$L(), e = $bc5f567978faddca$var$lh(a), f = $bc5f567978faddca$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $bc5f567978faddca$var$dh(a, f, e);
        null !== b && ($bc5f567978faddca$var$mh(b, a, e, d), $bc5f567978faddca$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $bc5f567978faddca$var$L(), e = $bc5f567978faddca$var$lh(a), f = $bc5f567978faddca$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $bc5f567978faddca$var$dh(a, f, e);
        null !== b && ($bc5f567978faddca$var$mh(b, a, e, d), $bc5f567978faddca$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $bc5f567978faddca$var$L(), d = $bc5f567978faddca$var$lh(a), e = $bc5f567978faddca$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $bc5f567978faddca$var$dh(a, e, d);
        null !== b && ($bc5f567978faddca$var$mh(b, a, d, c), $bc5f567978faddca$var$eh(b, a, d));
    }
};
function $bc5f567978faddca$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$bc5f567978faddca$var$Ie(c, d) || !$bc5f567978faddca$var$Ie(e, f) : !0;
}
function $bc5f567978faddca$var$ph(a, b, c) {
    var d = !1, e = $bc5f567978faddca$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $bc5f567978faddca$var$Vg(f) : (e = $bc5f567978faddca$var$Zf(b) ? $bc5f567978faddca$var$Xf : $bc5f567978faddca$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $bc5f567978faddca$var$Yf(a, e) : $bc5f567978faddca$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $bc5f567978faddca$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $bc5f567978faddca$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $bc5f567978faddca$var$nh.enqueueReplaceState(b, b.state, null);
}
function $bc5f567978faddca$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $bc5f567978faddca$var$jh;
    $bc5f567978faddca$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $bc5f567978faddca$var$Vg(f) : (f = $bc5f567978faddca$var$Zf(b) ? $bc5f567978faddca$var$Xf : $bc5f567978faddca$var$H.current, e.context = $bc5f567978faddca$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($bc5f567978faddca$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $bc5f567978faddca$var$nh.enqueueReplaceState(e, e.state, null), $bc5f567978faddca$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $bc5f567978faddca$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($bc5f567978faddca$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($bc5f567978faddca$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $bc5f567978faddca$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($bc5f567978faddca$var$p(284));
        if (!c._owner) throw Error($bc5f567978faddca$var$p(290, a));
    }
    return a;
}
function $bc5f567978faddca$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($bc5f567978faddca$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $bc5f567978faddca$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $bc5f567978faddca$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $bc5f567978faddca$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $bc5f567978faddca$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $bc5f567978faddca$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $bc5f567978faddca$var$Ha && $bc5f567978faddca$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $bc5f567978faddca$var$sh(a, b, c), d.return = a, d;
        d = $bc5f567978faddca$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $bc5f567978faddca$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $bc5f567978faddca$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $bc5f567978faddca$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $bc5f567978faddca$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $bc5f567978faddca$var$va:
                    return c = $bc5f567978faddca$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $bc5f567978faddca$var$sh(a, null, b), c.return = a, c;
                case $bc5f567978faddca$var$wa:
                    return b = $bc5f567978faddca$var$zh(b, a.mode, c), b.return = a, b;
                case $bc5f567978faddca$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($bc5f567978faddca$var$eb(b) || $bc5f567978faddca$var$Ka(b)) return b = $bc5f567978faddca$var$Ah(b, a.mode, c, null), b.return = a, b;
            $bc5f567978faddca$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $bc5f567978faddca$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $bc5f567978faddca$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $bc5f567978faddca$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($bc5f567978faddca$var$eb(c) || $bc5f567978faddca$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $bc5f567978faddca$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $bc5f567978faddca$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $bc5f567978faddca$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $bc5f567978faddca$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($bc5f567978faddca$var$eb(d) || $bc5f567978faddca$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $bc5f567978faddca$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $bc5f567978faddca$var$I && $bc5f567978faddca$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $bc5f567978faddca$var$I && $bc5f567978faddca$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $bc5f567978faddca$var$I && $bc5f567978faddca$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $bc5f567978faddca$var$Ka(h);
        if ("function" !== typeof l) throw Error($bc5f567978faddca$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($bc5f567978faddca$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $bc5f567978faddca$var$I && $bc5f567978faddca$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $bc5f567978faddca$var$I && $bc5f567978faddca$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $bc5f567978faddca$var$I && $bc5f567978faddca$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $bc5f567978faddca$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $bc5f567978faddca$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $bc5f567978faddca$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $bc5f567978faddca$var$Ha && $bc5f567978faddca$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $bc5f567978faddca$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $bc5f567978faddca$var$ya ? (d = $bc5f567978faddca$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $bc5f567978faddca$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $bc5f567978faddca$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $bc5f567978faddca$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $bc5f567978faddca$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $bc5f567978faddca$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($bc5f567978faddca$var$eb(f)) return n(a, d, f, h);
            if ($bc5f567978faddca$var$Ka(f)) return t(a, d, f, h);
            $bc5f567978faddca$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $bc5f567978faddca$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $bc5f567978faddca$var$Bh = $bc5f567978faddca$var$vh(!0), $bc5f567978faddca$var$Ch = $bc5f567978faddca$var$vh(!1), $bc5f567978faddca$var$Dh = {}, $bc5f567978faddca$var$Eh = $bc5f567978faddca$var$Uf($bc5f567978faddca$var$Dh), $bc5f567978faddca$var$Fh = $bc5f567978faddca$var$Uf($bc5f567978faddca$var$Dh), $bc5f567978faddca$var$Gh = $bc5f567978faddca$var$Uf($bc5f567978faddca$var$Dh);
function $bc5f567978faddca$var$Hh(a) {
    if (a === $bc5f567978faddca$var$Dh) throw Error($bc5f567978faddca$var$p(174));
    return a;
}
function $bc5f567978faddca$var$Ih(a, b) {
    $bc5f567978faddca$var$G($bc5f567978faddca$var$Gh, b);
    $bc5f567978faddca$var$G($bc5f567978faddca$var$Fh, a);
    $bc5f567978faddca$var$G($bc5f567978faddca$var$Eh, $bc5f567978faddca$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $bc5f567978faddca$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $bc5f567978faddca$var$lb(b, a);
    }
    $bc5f567978faddca$var$E($bc5f567978faddca$var$Eh);
    $bc5f567978faddca$var$G($bc5f567978faddca$var$Eh, b);
}
function $bc5f567978faddca$var$Jh() {
    $bc5f567978faddca$var$E($bc5f567978faddca$var$Eh);
    $bc5f567978faddca$var$E($bc5f567978faddca$var$Fh);
    $bc5f567978faddca$var$E($bc5f567978faddca$var$Gh);
}
function $bc5f567978faddca$var$Kh(a) {
    $bc5f567978faddca$var$Hh($bc5f567978faddca$var$Gh.current);
    var b = $bc5f567978faddca$var$Hh($bc5f567978faddca$var$Eh.current);
    var c = $bc5f567978faddca$var$lb(b, a.type);
    b !== c && ($bc5f567978faddca$var$G($bc5f567978faddca$var$Fh, a), $bc5f567978faddca$var$G($bc5f567978faddca$var$Eh, c));
}
function $bc5f567978faddca$var$Lh(a) {
    $bc5f567978faddca$var$Fh.current === a && ($bc5f567978faddca$var$E($bc5f567978faddca$var$Eh), $bc5f567978faddca$var$E($bc5f567978faddca$var$Fh));
}
var $bc5f567978faddca$var$M = $bc5f567978faddca$var$Uf(0);
function $bc5f567978faddca$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $bc5f567978faddca$var$Nh = [];
function $bc5f567978faddca$var$Oh() {
    for(var a = 0; a < $bc5f567978faddca$var$Nh.length; a++)$bc5f567978faddca$var$Nh[a]._workInProgressVersionPrimary = null;
    $bc5f567978faddca$var$Nh.length = 0;
}
var $bc5f567978faddca$var$Ph = $bc5f567978faddca$var$ua.ReactCurrentDispatcher, $bc5f567978faddca$var$Qh = $bc5f567978faddca$var$ua.ReactCurrentBatchConfig, $bc5f567978faddca$var$Rh = 0, $bc5f567978faddca$var$N = null, $bc5f567978faddca$var$O = null, $bc5f567978faddca$var$P = null, $bc5f567978faddca$var$Sh = !1, $bc5f567978faddca$var$Th = !1, $bc5f567978faddca$var$Uh = 0, $bc5f567978faddca$var$Vh = 0;
function $bc5f567978faddca$var$Q() {
    throw Error($bc5f567978faddca$var$p(321));
}
function $bc5f567978faddca$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$bc5f567978faddca$var$He(a[c], b[c])) return !1;
    return !0;
}
function $bc5f567978faddca$var$Xh(a, b, c, d, e, f) {
    $bc5f567978faddca$var$Rh = f;
    $bc5f567978faddca$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $bc5f567978faddca$var$Ph.current = null === a || null === a.memoizedState ? $bc5f567978faddca$var$Yh : $bc5f567978faddca$var$Zh;
    a = c(d, e);
    if ($bc5f567978faddca$var$Th) {
        f = 0;
        do {
            $bc5f567978faddca$var$Th = !1;
            $bc5f567978faddca$var$Uh = 0;
            if (25 <= f) throw Error($bc5f567978faddca$var$p(301));
            f += 1;
            $bc5f567978faddca$var$P = $bc5f567978faddca$var$O = null;
            b.updateQueue = null;
            $bc5f567978faddca$var$Ph.current = $bc5f567978faddca$var$$h;
            a = c(d, e);
        }while ($bc5f567978faddca$var$Th);
    }
    $bc5f567978faddca$var$Ph.current = $bc5f567978faddca$var$ai;
    b = null !== $bc5f567978faddca$var$O && null !== $bc5f567978faddca$var$O.next;
    $bc5f567978faddca$var$Rh = 0;
    $bc5f567978faddca$var$P = $bc5f567978faddca$var$O = $bc5f567978faddca$var$N = null;
    $bc5f567978faddca$var$Sh = !1;
    if (b) throw Error($bc5f567978faddca$var$p(300));
    return a;
}
function $bc5f567978faddca$var$bi() {
    var a = 0 !== $bc5f567978faddca$var$Uh;
    $bc5f567978faddca$var$Uh = 0;
    return a;
}
function $bc5f567978faddca$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $bc5f567978faddca$var$P ? $bc5f567978faddca$var$N.memoizedState = $bc5f567978faddca$var$P = a : $bc5f567978faddca$var$P = $bc5f567978faddca$var$P.next = a;
    return $bc5f567978faddca$var$P;
}
function $bc5f567978faddca$var$di() {
    if (null === $bc5f567978faddca$var$O) {
        var a = $bc5f567978faddca$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $bc5f567978faddca$var$O.next;
    var b = null === $bc5f567978faddca$var$P ? $bc5f567978faddca$var$N.memoizedState : $bc5f567978faddca$var$P.next;
    if (null !== b) $bc5f567978faddca$var$P = b, $bc5f567978faddca$var$O = a;
    else {
        if (null === a) throw Error($bc5f567978faddca$var$p(310));
        $bc5f567978faddca$var$O = a;
        a = {
            memoizedState: $bc5f567978faddca$var$O.memoizedState,
            baseState: $bc5f567978faddca$var$O.baseState,
            baseQueue: $bc5f567978faddca$var$O.baseQueue,
            queue: $bc5f567978faddca$var$O.queue,
            next: null
        };
        null === $bc5f567978faddca$var$P ? $bc5f567978faddca$var$N.memoizedState = $bc5f567978faddca$var$P = a : $bc5f567978faddca$var$P = $bc5f567978faddca$var$P.next = a;
    }
    return $bc5f567978faddca$var$P;
}
function $bc5f567978faddca$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $bc5f567978faddca$var$fi(a) {
    var b = $bc5f567978faddca$var$di(), c = b.queue;
    if (null === c) throw Error($bc5f567978faddca$var$p(311));
    c.lastRenderedReducer = a;
    var d = $bc5f567978faddca$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($bc5f567978faddca$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $bc5f567978faddca$var$N.lanes |= m;
                $bc5f567978faddca$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $bc5f567978faddca$var$He(d, b.memoizedState) || ($bc5f567978faddca$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $bc5f567978faddca$var$N.lanes |= f, $bc5f567978faddca$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $bc5f567978faddca$var$gi(a) {
    var b = $bc5f567978faddca$var$di(), c = b.queue;
    if (null === c) throw Error($bc5f567978faddca$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $bc5f567978faddca$var$He(f, b.memoizedState) || ($bc5f567978faddca$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $bc5f567978faddca$var$hi() {}
function $bc5f567978faddca$var$ii(a, b) {
    var c = $bc5f567978faddca$var$N, d = $bc5f567978faddca$var$di(), e = b(), f = !$bc5f567978faddca$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $bc5f567978faddca$var$Ug = !0);
    d = d.queue;
    $bc5f567978faddca$var$ji($bc5f567978faddca$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $bc5f567978faddca$var$P && $bc5f567978faddca$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $bc5f567978faddca$var$li(9, $bc5f567978faddca$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $bc5f567978faddca$var$R) throw Error($bc5f567978faddca$var$p(349));
        0 !== ($bc5f567978faddca$var$Rh & 30) || $bc5f567978faddca$var$ni(c, b, e);
    }
    return e;
}
function $bc5f567978faddca$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $bc5f567978faddca$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $bc5f567978faddca$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $bc5f567978faddca$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $bc5f567978faddca$var$oi(b) && $bc5f567978faddca$var$pi(a);
}
function $bc5f567978faddca$var$ki(a, b, c) {
    return c(function() {
        $bc5f567978faddca$var$oi(b) && $bc5f567978faddca$var$pi(a);
    });
}
function $bc5f567978faddca$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$bc5f567978faddca$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $bc5f567978faddca$var$pi(a) {
    var b = $bc5f567978faddca$var$Zg(a, 1);
    null !== b && $bc5f567978faddca$var$mh(b, a, 1, -1);
}
function $bc5f567978faddca$var$qi(a) {
    var b = $bc5f567978faddca$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $bc5f567978faddca$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $bc5f567978faddca$var$ri.bind(null, $bc5f567978faddca$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $bc5f567978faddca$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $bc5f567978faddca$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $bc5f567978faddca$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $bc5f567978faddca$var$si() {
    return $bc5f567978faddca$var$di().memoizedState;
}
function $bc5f567978faddca$var$ti(a, b, c, d) {
    var e = $bc5f567978faddca$var$ci();
    $bc5f567978faddca$var$N.flags |= a;
    e.memoizedState = $bc5f567978faddca$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $bc5f567978faddca$var$ui(a, b, c, d) {
    var e = $bc5f567978faddca$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $bc5f567978faddca$var$O) {
        var g = $bc5f567978faddca$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $bc5f567978faddca$var$Wh(d, g.deps)) {
            e.memoizedState = $bc5f567978faddca$var$li(b, c, f, d);
            return;
        }
    }
    $bc5f567978faddca$var$N.flags |= a;
    e.memoizedState = $bc5f567978faddca$var$li(1 | b, c, f, d);
}
function $bc5f567978faddca$var$vi(a, b) {
    return $bc5f567978faddca$var$ti(8390656, 8, a, b);
}
function $bc5f567978faddca$var$ji(a, b) {
    return $bc5f567978faddca$var$ui(2048, 8, a, b);
}
function $bc5f567978faddca$var$wi(a, b) {
    return $bc5f567978faddca$var$ui(4, 2, a, b);
}
function $bc5f567978faddca$var$xi(a, b) {
    return $bc5f567978faddca$var$ui(4, 4, a, b);
}
function $bc5f567978faddca$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $bc5f567978faddca$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $bc5f567978faddca$var$ui(4, 4, $bc5f567978faddca$var$yi.bind(null, b, a), c);
}
function $bc5f567978faddca$var$Ai() {}
function $bc5f567978faddca$var$Bi(a, b) {
    var c = $bc5f567978faddca$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $bc5f567978faddca$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $bc5f567978faddca$var$Ci(a, b) {
    var c = $bc5f567978faddca$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $bc5f567978faddca$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $bc5f567978faddca$var$Di(a, b, c) {
    if (0 === ($bc5f567978faddca$var$Rh & 21)) return a.baseState && (a.baseState = !1, $bc5f567978faddca$var$Ug = !0), a.memoizedState = c;
    $bc5f567978faddca$var$He(c, b) || (c = $bc5f567978faddca$var$yc(), $bc5f567978faddca$var$N.lanes |= c, $bc5f567978faddca$var$hh |= c, a.baseState = !0);
    return b;
}
function $bc5f567978faddca$var$Ei(a, b) {
    var c = $bc5f567978faddca$var$C;
    $bc5f567978faddca$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $bc5f567978faddca$var$Qh.transition;
    $bc5f567978faddca$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $bc5f567978faddca$var$C = c, $bc5f567978faddca$var$Qh.transition = d;
    }
}
function $bc5f567978faddca$var$Fi() {
    return $bc5f567978faddca$var$di().memoizedState;
}
function $bc5f567978faddca$var$Gi(a, b, c) {
    var d = $bc5f567978faddca$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($bc5f567978faddca$var$Hi(a)) $bc5f567978faddca$var$Ii(b, c);
    else if (c = $bc5f567978faddca$var$Yg(a, b, c, d), null !== c) {
        var e = $bc5f567978faddca$var$L();
        $bc5f567978faddca$var$mh(c, a, d, e);
        $bc5f567978faddca$var$Ji(c, b, d);
    }
}
function $bc5f567978faddca$var$ri(a, b, c) {
    var d = $bc5f567978faddca$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($bc5f567978faddca$var$Hi(a)) $bc5f567978faddca$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($bc5f567978faddca$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $bc5f567978faddca$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $bc5f567978faddca$var$Yg(a, b, e, d);
        null !== c && (e = $bc5f567978faddca$var$L(), $bc5f567978faddca$var$mh(c, a, d, e), $bc5f567978faddca$var$Ji(c, b, d));
    }
}
function $bc5f567978faddca$var$Hi(a) {
    var b = a.alternate;
    return a === $bc5f567978faddca$var$N || null !== b && b === $bc5f567978faddca$var$N;
}
function $bc5f567978faddca$var$Ii(a, b) {
    $bc5f567978faddca$var$Th = $bc5f567978faddca$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $bc5f567978faddca$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $bc5f567978faddca$var$Cc(a, c);
    }
}
var $bc5f567978faddca$var$ai = {
    readContext: $bc5f567978faddca$var$Vg,
    useCallback: $bc5f567978faddca$var$Q,
    useContext: $bc5f567978faddca$var$Q,
    useEffect: $bc5f567978faddca$var$Q,
    useImperativeHandle: $bc5f567978faddca$var$Q,
    useInsertionEffect: $bc5f567978faddca$var$Q,
    useLayoutEffect: $bc5f567978faddca$var$Q,
    useMemo: $bc5f567978faddca$var$Q,
    useReducer: $bc5f567978faddca$var$Q,
    useRef: $bc5f567978faddca$var$Q,
    useState: $bc5f567978faddca$var$Q,
    useDebugValue: $bc5f567978faddca$var$Q,
    useDeferredValue: $bc5f567978faddca$var$Q,
    useTransition: $bc5f567978faddca$var$Q,
    useMutableSource: $bc5f567978faddca$var$Q,
    useSyncExternalStore: $bc5f567978faddca$var$Q,
    useId: $bc5f567978faddca$var$Q,
    unstable_isNewReconciler: !1
}, $bc5f567978faddca$var$Yh = {
    readContext: $bc5f567978faddca$var$Vg,
    useCallback: function(a, b) {
        $bc5f567978faddca$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $bc5f567978faddca$var$Vg,
    useEffect: $bc5f567978faddca$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $bc5f567978faddca$var$ti(4194308, 4, $bc5f567978faddca$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $bc5f567978faddca$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $bc5f567978faddca$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $bc5f567978faddca$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $bc5f567978faddca$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $bc5f567978faddca$var$Gi.bind(null, $bc5f567978faddca$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $bc5f567978faddca$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $bc5f567978faddca$var$qi,
    useDebugValue: $bc5f567978faddca$var$Ai,
    useDeferredValue: function(a) {
        return $bc5f567978faddca$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $bc5f567978faddca$var$qi(!1), b = a[0];
        a = $bc5f567978faddca$var$Ei.bind(null, a[1]);
        $bc5f567978faddca$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $bc5f567978faddca$var$N, e = $bc5f567978faddca$var$ci();
        if ($bc5f567978faddca$var$I) {
            if (void 0 === c) throw Error($bc5f567978faddca$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $bc5f567978faddca$var$R) throw Error($bc5f567978faddca$var$p(349));
            0 !== ($bc5f567978faddca$var$Rh & 30) || $bc5f567978faddca$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $bc5f567978faddca$var$vi($bc5f567978faddca$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $bc5f567978faddca$var$li(9, $bc5f567978faddca$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $bc5f567978faddca$var$ci(), b = $bc5f567978faddca$var$R.identifierPrefix;
        if ($bc5f567978faddca$var$I) {
            var c = $bc5f567978faddca$var$sg;
            var d = $bc5f567978faddca$var$rg;
            c = (d & ~(1 << 32 - $bc5f567978faddca$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $bc5f567978faddca$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $bc5f567978faddca$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $bc5f567978faddca$var$Zh = {
    readContext: $bc5f567978faddca$var$Vg,
    useCallback: $bc5f567978faddca$var$Bi,
    useContext: $bc5f567978faddca$var$Vg,
    useEffect: $bc5f567978faddca$var$ji,
    useImperativeHandle: $bc5f567978faddca$var$zi,
    useInsertionEffect: $bc5f567978faddca$var$wi,
    useLayoutEffect: $bc5f567978faddca$var$xi,
    useMemo: $bc5f567978faddca$var$Ci,
    useReducer: $bc5f567978faddca$var$fi,
    useRef: $bc5f567978faddca$var$si,
    useState: function() {
        return $bc5f567978faddca$var$fi($bc5f567978faddca$var$ei);
    },
    useDebugValue: $bc5f567978faddca$var$Ai,
    useDeferredValue: function(a) {
        var b = $bc5f567978faddca$var$di();
        return $bc5f567978faddca$var$Di(b, $bc5f567978faddca$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $bc5f567978faddca$var$fi($bc5f567978faddca$var$ei)[0], b = $bc5f567978faddca$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $bc5f567978faddca$var$hi,
    useSyncExternalStore: $bc5f567978faddca$var$ii,
    useId: $bc5f567978faddca$var$Fi,
    unstable_isNewReconciler: !1
}, $bc5f567978faddca$var$$h = {
    readContext: $bc5f567978faddca$var$Vg,
    useCallback: $bc5f567978faddca$var$Bi,
    useContext: $bc5f567978faddca$var$Vg,
    useEffect: $bc5f567978faddca$var$ji,
    useImperativeHandle: $bc5f567978faddca$var$zi,
    useInsertionEffect: $bc5f567978faddca$var$wi,
    useLayoutEffect: $bc5f567978faddca$var$xi,
    useMemo: $bc5f567978faddca$var$Ci,
    useReducer: $bc5f567978faddca$var$gi,
    useRef: $bc5f567978faddca$var$si,
    useState: function() {
        return $bc5f567978faddca$var$gi($bc5f567978faddca$var$ei);
    },
    useDebugValue: $bc5f567978faddca$var$Ai,
    useDeferredValue: function(a) {
        var b = $bc5f567978faddca$var$di();
        return null === $bc5f567978faddca$var$O ? b.memoizedState = a : $bc5f567978faddca$var$Di(b, $bc5f567978faddca$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $bc5f567978faddca$var$gi($bc5f567978faddca$var$ei)[0], b = $bc5f567978faddca$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $bc5f567978faddca$var$hi,
    useSyncExternalStore: $bc5f567978faddca$var$ii,
    useId: $bc5f567978faddca$var$Fi,
    unstable_isNewReconciler: !1
};
function $bc5f567978faddca$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $bc5f567978faddca$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $bc5f567978faddca$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $bc5f567978faddca$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $bc5f567978faddca$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $bc5f567978faddca$var$Oi(a, b, c) {
    c = $bc5f567978faddca$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $bc5f567978faddca$var$Pi || ($bc5f567978faddca$var$Pi = !0, $bc5f567978faddca$var$Qi = d);
        $bc5f567978faddca$var$Mi(a, b);
    };
    return c;
}
function $bc5f567978faddca$var$Ri(a, b, c) {
    c = $bc5f567978faddca$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $bc5f567978faddca$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $bc5f567978faddca$var$Mi(a, b);
        "function" !== typeof d && (null === $bc5f567978faddca$var$Si ? $bc5f567978faddca$var$Si = new Set([
            this
        ]) : $bc5f567978faddca$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $bc5f567978faddca$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $bc5f567978faddca$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $bc5f567978faddca$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $bc5f567978faddca$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $bc5f567978faddca$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $bc5f567978faddca$var$ch(-1, 1), b.tag = 2, $bc5f567978faddca$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $bc5f567978faddca$var$Xi = $bc5f567978faddca$var$ua.ReactCurrentOwner, $bc5f567978faddca$var$Ug = !1;
function $bc5f567978faddca$var$Yi(a, b, c, d) {
    b.child = null === a ? $bc5f567978faddca$var$Ch(b, null, c, d) : $bc5f567978faddca$var$Bh(b, a.child, c, d);
}
function $bc5f567978faddca$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $bc5f567978faddca$var$Tg(b, e);
    d = $bc5f567978faddca$var$Xh(a, b, c, d, f, e);
    c = $bc5f567978faddca$var$bi();
    if (null !== a && !$bc5f567978faddca$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $bc5f567978faddca$var$$i(a, b, e);
    $bc5f567978faddca$var$I && c && $bc5f567978faddca$var$vg(b);
    b.flags |= 1;
    $bc5f567978faddca$var$Yi(a, b, d, e);
    return b.child;
}
function $bc5f567978faddca$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$bc5f567978faddca$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $bc5f567978faddca$var$cj(a, b, f, d, e);
        a = $bc5f567978faddca$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $bc5f567978faddca$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $bc5f567978faddca$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $bc5f567978faddca$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $bc5f567978faddca$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($bc5f567978faddca$var$Ie(f, d) && a.ref === b.ref) {
            if ($bc5f567978faddca$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($bc5f567978faddca$var$Ug = !0);
            else return b.lanes = a.lanes, $bc5f567978faddca$var$$i(a, b, e);
        }
    }
    return $bc5f567978faddca$var$dj(a, b, c, d, e);
}
function $bc5f567978faddca$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $bc5f567978faddca$var$G($bc5f567978faddca$var$fj, $bc5f567978faddca$var$gj), $bc5f567978faddca$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $bc5f567978faddca$var$G($bc5f567978faddca$var$fj, $bc5f567978faddca$var$gj), $bc5f567978faddca$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $bc5f567978faddca$var$G($bc5f567978faddca$var$fj, $bc5f567978faddca$var$gj);
            $bc5f567978faddca$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $bc5f567978faddca$var$G($bc5f567978faddca$var$fj, $bc5f567978faddca$var$gj), $bc5f567978faddca$var$gj |= d;
    $bc5f567978faddca$var$Yi(a, b, e, c);
    return b.child;
}
function $bc5f567978faddca$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $bc5f567978faddca$var$dj(a, b, c, d, e) {
    var f = $bc5f567978faddca$var$Zf(c) ? $bc5f567978faddca$var$Xf : $bc5f567978faddca$var$H.current;
    f = $bc5f567978faddca$var$Yf(b, f);
    $bc5f567978faddca$var$Tg(b, e);
    c = $bc5f567978faddca$var$Xh(a, b, c, d, f, e);
    d = $bc5f567978faddca$var$bi();
    if (null !== a && !$bc5f567978faddca$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $bc5f567978faddca$var$$i(a, b, e);
    $bc5f567978faddca$var$I && d && $bc5f567978faddca$var$vg(b);
    b.flags |= 1;
    $bc5f567978faddca$var$Yi(a, b, c, e);
    return b.child;
}
function $bc5f567978faddca$var$ij(a, b, c, d, e) {
    if ($bc5f567978faddca$var$Zf(c)) {
        var f = !0;
        $bc5f567978faddca$var$cg(b);
    } else f = !1;
    $bc5f567978faddca$var$Tg(b, e);
    if (null === b.stateNode) $bc5f567978faddca$var$jj(a, b), $bc5f567978faddca$var$ph(b, c, d), $bc5f567978faddca$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $bc5f567978faddca$var$Vg(l) : (l = $bc5f567978faddca$var$Zf(c) ? $bc5f567978faddca$var$Xf : $bc5f567978faddca$var$H.current, l = $bc5f567978faddca$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $bc5f567978faddca$var$qh(b, g, d, l);
        $bc5f567978faddca$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $bc5f567978faddca$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $bc5f567978faddca$var$Wf.current || $bc5f567978faddca$var$$g ? ("function" === typeof m && ($bc5f567978faddca$var$kh(b, c, m, d), k = b.memoizedState), (h = $bc5f567978faddca$var$$g || $bc5f567978faddca$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $bc5f567978faddca$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $bc5f567978faddca$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $bc5f567978faddca$var$Vg(k) : (k = $bc5f567978faddca$var$Zf(c) ? $bc5f567978faddca$var$Xf : $bc5f567978faddca$var$H.current, k = $bc5f567978faddca$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $bc5f567978faddca$var$qh(b, g, d, k);
        $bc5f567978faddca$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $bc5f567978faddca$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $bc5f567978faddca$var$Wf.current || $bc5f567978faddca$var$$g ? ("function" === typeof y && ($bc5f567978faddca$var$kh(b, c, y, d), n = b.memoizedState), (l = $bc5f567978faddca$var$$g || $bc5f567978faddca$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $bc5f567978faddca$var$kj(a, b, c, d, f, e);
}
function $bc5f567978faddca$var$kj(a, b, c, d, e, f) {
    $bc5f567978faddca$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $bc5f567978faddca$var$dg(b, c, !1), $bc5f567978faddca$var$$i(a, b, f);
    d = b.stateNode;
    $bc5f567978faddca$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $bc5f567978faddca$var$Bh(b, a.child, null, f), b.child = $bc5f567978faddca$var$Bh(b, null, h, f)) : $bc5f567978faddca$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $bc5f567978faddca$var$dg(b, c, !0);
    return b.child;
}
function $bc5f567978faddca$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $bc5f567978faddca$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $bc5f567978faddca$var$ag(a, b.context, !1);
    $bc5f567978faddca$var$Ih(a, b.containerInfo);
}
function $bc5f567978faddca$var$mj(a, b, c, d, e) {
    $bc5f567978faddca$var$Ig();
    $bc5f567978faddca$var$Jg(e);
    b.flags |= 256;
    $bc5f567978faddca$var$Yi(a, b, c, d);
    return b.child;
}
var $bc5f567978faddca$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $bc5f567978faddca$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $bc5f567978faddca$var$pj(a, b, c) {
    var d = b.pendingProps, e = $bc5f567978faddca$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $bc5f567978faddca$var$G($bc5f567978faddca$var$M, e & 1);
    if (null === a) {
        $bc5f567978faddca$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $bc5f567978faddca$var$qj(g, d, 0, null), a = $bc5f567978faddca$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $bc5f567978faddca$var$oj(c), b.memoizedState = $bc5f567978faddca$var$nj, a) : $bc5f567978faddca$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $bc5f567978faddca$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $bc5f567978faddca$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $bc5f567978faddca$var$wh(h, f) : (f = $bc5f567978faddca$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $bc5f567978faddca$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $bc5f567978faddca$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $bc5f567978faddca$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $bc5f567978faddca$var$rj(a, b) {
    b = $bc5f567978faddca$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $bc5f567978faddca$var$tj(a, b, c, d) {
    null !== d && $bc5f567978faddca$var$Jg(d);
    $bc5f567978faddca$var$Bh(b, a.child, null, c);
    a = $bc5f567978faddca$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $bc5f567978faddca$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $bc5f567978faddca$var$Li(Error($bc5f567978faddca$var$p(422))), $bc5f567978faddca$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $bc5f567978faddca$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $bc5f567978faddca$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $bc5f567978faddca$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $bc5f567978faddca$var$oj(g);
        b.memoizedState = $bc5f567978faddca$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $bc5f567978faddca$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($bc5f567978faddca$var$p(419));
        d = $bc5f567978faddca$var$Li(f, d, void 0);
        return $bc5f567978faddca$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($bc5f567978faddca$var$Ug || h) {
        d = $bc5f567978faddca$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $bc5f567978faddca$var$Zg(a, e), $bc5f567978faddca$var$mh(d, a, e, -1));
        }
        $bc5f567978faddca$var$uj();
        d = $bc5f567978faddca$var$Li(Error($bc5f567978faddca$var$p(421)));
        return $bc5f567978faddca$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $bc5f567978faddca$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $bc5f567978faddca$var$yg = $bc5f567978faddca$var$Lf(e.nextSibling);
    $bc5f567978faddca$var$xg = b;
    $bc5f567978faddca$var$I = !0;
    $bc5f567978faddca$var$zg = null;
    null !== a && ($bc5f567978faddca$var$og[$bc5f567978faddca$var$pg++] = $bc5f567978faddca$var$rg, $bc5f567978faddca$var$og[$bc5f567978faddca$var$pg++] = $bc5f567978faddca$var$sg, $bc5f567978faddca$var$og[$bc5f567978faddca$var$pg++] = $bc5f567978faddca$var$qg, $bc5f567978faddca$var$rg = a.id, $bc5f567978faddca$var$sg = a.overflow, $bc5f567978faddca$var$qg = b);
    b = $bc5f567978faddca$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $bc5f567978faddca$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $bc5f567978faddca$var$Sg(a.return, b, c);
}
function $bc5f567978faddca$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $bc5f567978faddca$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $bc5f567978faddca$var$Yi(a, b, d.children, c);
    d = $bc5f567978faddca$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $bc5f567978faddca$var$wj(a, c, b);
            else if (19 === a.tag) $bc5f567978faddca$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $bc5f567978faddca$var$G($bc5f567978faddca$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $bc5f567978faddca$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $bc5f567978faddca$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $bc5f567978faddca$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $bc5f567978faddca$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $bc5f567978faddca$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $bc5f567978faddca$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $bc5f567978faddca$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $bc5f567978faddca$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($bc5f567978faddca$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $bc5f567978faddca$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $bc5f567978faddca$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $bc5f567978faddca$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $bc5f567978faddca$var$lj(b);
            $bc5f567978faddca$var$Ig();
            break;
        case 5:
            $bc5f567978faddca$var$Kh(b);
            break;
        case 1:
            $bc5f567978faddca$var$Zf(b.type) && $bc5f567978faddca$var$cg(b);
            break;
        case 4:
            $bc5f567978faddca$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $bc5f567978faddca$var$G($bc5f567978faddca$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $bc5f567978faddca$var$G($bc5f567978faddca$var$M, $bc5f567978faddca$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $bc5f567978faddca$var$pj(a, b, c);
                $bc5f567978faddca$var$G($bc5f567978faddca$var$M, $bc5f567978faddca$var$M.current & 1);
                a = $bc5f567978faddca$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $bc5f567978faddca$var$G($bc5f567978faddca$var$M, $bc5f567978faddca$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $bc5f567978faddca$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $bc5f567978faddca$var$G($bc5f567978faddca$var$M, $bc5f567978faddca$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $bc5f567978faddca$var$ej(a, b, c);
    }
    return $bc5f567978faddca$var$$i(a, b, c);
}
var $bc5f567978faddca$var$Aj, $bc5f567978faddca$var$Bj, $bc5f567978faddca$var$Cj, $bc5f567978faddca$var$Dj;
$bc5f567978faddca$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$bc5f567978faddca$var$Bj = function() {};
$bc5f567978faddca$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $bc5f567978faddca$var$Hh($bc5f567978faddca$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $bc5f567978faddca$var$Ya(a, e);
                d = $bc5f567978faddca$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $bc5f567978faddca$var$A({}, e, {
                    value: void 0
                });
                d = $bc5f567978faddca$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $bc5f567978faddca$var$gb(a, e);
                d = $bc5f567978faddca$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $bc5f567978faddca$var$Bf);
        }
        $bc5f567978faddca$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($bc5f567978faddca$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($bc5f567978faddca$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $bc5f567978faddca$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$bc5f567978faddca$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $bc5f567978faddca$var$Ej(a, b) {
    if (!$bc5f567978faddca$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $bc5f567978faddca$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $bc5f567978faddca$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $bc5f567978faddca$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $bc5f567978faddca$var$S(b), null;
        case 1:
            return $bc5f567978faddca$var$Zf(b.type) && $bc5f567978faddca$var$$f(), $bc5f567978faddca$var$S(b), null;
        case 3:
            d = b.stateNode;
            $bc5f567978faddca$var$Jh();
            $bc5f567978faddca$var$E($bc5f567978faddca$var$Wf);
            $bc5f567978faddca$var$E($bc5f567978faddca$var$H);
            $bc5f567978faddca$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $bc5f567978faddca$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $bc5f567978faddca$var$zg && ($bc5f567978faddca$var$Gj($bc5f567978faddca$var$zg), $bc5f567978faddca$var$zg = null));
            $bc5f567978faddca$var$Bj(a, b);
            $bc5f567978faddca$var$S(b);
            return null;
        case 5:
            $bc5f567978faddca$var$Lh(b);
            var e = $bc5f567978faddca$var$Hh($bc5f567978faddca$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $bc5f567978faddca$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($bc5f567978faddca$var$p(166));
                    $bc5f567978faddca$var$S(b);
                    return null;
                }
                a = $bc5f567978faddca$var$Hh($bc5f567978faddca$var$Eh.current);
                if ($bc5f567978faddca$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$bc5f567978faddca$var$Of] = b;
                    d[$bc5f567978faddca$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $bc5f567978faddca$var$D("cancel", d);
                            $bc5f567978faddca$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $bc5f567978faddca$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $bc5f567978faddca$var$lf.length; e++)$bc5f567978faddca$var$D($bc5f567978faddca$var$lf[e], d);
                            break;
                        case "source":
                            $bc5f567978faddca$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $bc5f567978faddca$var$D("error", d);
                            $bc5f567978faddca$var$D("load", d);
                            break;
                        case "details":
                            $bc5f567978faddca$var$D("toggle", d);
                            break;
                        case "input":
                            $bc5f567978faddca$var$Za(d, f);
                            $bc5f567978faddca$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $bc5f567978faddca$var$D("invalid", d);
                            break;
                        case "textarea":
                            $bc5f567978faddca$var$hb(d, f), $bc5f567978faddca$var$D("invalid", d);
                    }
                    $bc5f567978faddca$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $bc5f567978faddca$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $bc5f567978faddca$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $bc5f567978faddca$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $bc5f567978faddca$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $bc5f567978faddca$var$Va(d);
                            $bc5f567978faddca$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $bc5f567978faddca$var$Va(d);
                            $bc5f567978faddca$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $bc5f567978faddca$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $bc5f567978faddca$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$bc5f567978faddca$var$Of] = b;
                    a[$bc5f567978faddca$var$Pf] = d;
                    $bc5f567978faddca$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $bc5f567978faddca$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $bc5f567978faddca$var$D("cancel", a);
                                $bc5f567978faddca$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $bc5f567978faddca$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $bc5f567978faddca$var$lf.length; e++)$bc5f567978faddca$var$D($bc5f567978faddca$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $bc5f567978faddca$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $bc5f567978faddca$var$D("error", a);
                                $bc5f567978faddca$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $bc5f567978faddca$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $bc5f567978faddca$var$Za(a, d);
                                e = $bc5f567978faddca$var$Ya(a, d);
                                $bc5f567978faddca$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $bc5f567978faddca$var$A({}, d, {
                                    value: void 0
                                });
                                $bc5f567978faddca$var$D("invalid", a);
                                break;
                            case "textarea":
                                $bc5f567978faddca$var$hb(a, d);
                                e = $bc5f567978faddca$var$gb(a, d);
                                $bc5f567978faddca$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $bc5f567978faddca$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $bc5f567978faddca$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $bc5f567978faddca$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $bc5f567978faddca$var$ob(a, k) : "number" === typeof k && $bc5f567978faddca$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($bc5f567978faddca$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $bc5f567978faddca$var$D("scroll", a) : null != k && $bc5f567978faddca$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $bc5f567978faddca$var$Va(a);
                                $bc5f567978faddca$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $bc5f567978faddca$var$Va(a);
                                $bc5f567978faddca$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $bc5f567978faddca$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $bc5f567978faddca$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $bc5f567978faddca$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $bc5f567978faddca$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $bc5f567978faddca$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $bc5f567978faddca$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($bc5f567978faddca$var$p(166));
                c = $bc5f567978faddca$var$Hh($bc5f567978faddca$var$Gh.current);
                $bc5f567978faddca$var$Hh($bc5f567978faddca$var$Eh.current);
                if ($bc5f567978faddca$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$bc5f567978faddca$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $bc5f567978faddca$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $bc5f567978faddca$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $bc5f567978faddca$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$bc5f567978faddca$var$Of] = b, b.stateNode = d;
            }
            $bc5f567978faddca$var$S(b);
            return null;
        case 13:
            $bc5f567978faddca$var$E($bc5f567978faddca$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($bc5f567978faddca$var$I && null !== $bc5f567978faddca$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $bc5f567978faddca$var$Hg(), $bc5f567978faddca$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $bc5f567978faddca$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($bc5f567978faddca$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($bc5f567978faddca$var$p(317));
                        f[$bc5f567978faddca$var$Of] = b;
                    } else $bc5f567978faddca$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $bc5f567978faddca$var$S(b);
                    f = !1;
                } else null !== $bc5f567978faddca$var$zg && ($bc5f567978faddca$var$Gj($bc5f567978faddca$var$zg), $bc5f567978faddca$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($bc5f567978faddca$var$M.current & 1) ? 0 === $bc5f567978faddca$var$T && ($bc5f567978faddca$var$T = 3) : $bc5f567978faddca$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $bc5f567978faddca$var$S(b);
            return null;
        case 4:
            return $bc5f567978faddca$var$Jh(), $bc5f567978faddca$var$Bj(a, b), null === a && $bc5f567978faddca$var$sf(b.stateNode.containerInfo), $bc5f567978faddca$var$S(b), null;
        case 10:
            return $bc5f567978faddca$var$Rg(b.type._context), $bc5f567978faddca$var$S(b), null;
        case 17:
            return $bc5f567978faddca$var$Zf(b.type) && $bc5f567978faddca$var$$f(), $bc5f567978faddca$var$S(b), null;
        case 19:
            $bc5f567978faddca$var$E($bc5f567978faddca$var$M);
            f = b.memoizedState;
            if (null === f) return $bc5f567978faddca$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $bc5f567978faddca$var$Ej(f, !1);
                else {
                    if (0 !== $bc5f567978faddca$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $bc5f567978faddca$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $bc5f567978faddca$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $bc5f567978faddca$var$G($bc5f567978faddca$var$M, $bc5f567978faddca$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $bc5f567978faddca$var$B() > $bc5f567978faddca$var$Hj && (b.flags |= 128, d = !0, $bc5f567978faddca$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $bc5f567978faddca$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $bc5f567978faddca$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$bc5f567978faddca$var$I) return $bc5f567978faddca$var$S(b), null;
                    } else 2 * $bc5f567978faddca$var$B() - f.renderingStartTime > $bc5f567978faddca$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $bc5f567978faddca$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $bc5f567978faddca$var$B(), b.sibling = null, c = $bc5f567978faddca$var$M.current, $bc5f567978faddca$var$G($bc5f567978faddca$var$M, d ? c & 1 | 2 : c & 1), b;
            $bc5f567978faddca$var$S(b);
            return null;
        case 22:
        case 23:
            return $bc5f567978faddca$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($bc5f567978faddca$var$gj & 1073741824) && ($bc5f567978faddca$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $bc5f567978faddca$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($bc5f567978faddca$var$p(156, b.tag));
}
function $bc5f567978faddca$var$Jj(a, b) {
    $bc5f567978faddca$var$wg(b);
    switch(b.tag){
        case 1:
            return $bc5f567978faddca$var$Zf(b.type) && $bc5f567978faddca$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $bc5f567978faddca$var$Jh(), $bc5f567978faddca$var$E($bc5f567978faddca$var$Wf), $bc5f567978faddca$var$E($bc5f567978faddca$var$H), $bc5f567978faddca$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $bc5f567978faddca$var$Lh(b), null;
        case 13:
            $bc5f567978faddca$var$E($bc5f567978faddca$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($bc5f567978faddca$var$p(340));
                $bc5f567978faddca$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $bc5f567978faddca$var$E($bc5f567978faddca$var$M), null;
        case 4:
            return $bc5f567978faddca$var$Jh(), null;
        case 10:
            return $bc5f567978faddca$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $bc5f567978faddca$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $bc5f567978faddca$var$Kj = !1, $bc5f567978faddca$var$U = !1, $bc5f567978faddca$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $bc5f567978faddca$var$V = null;
function $bc5f567978faddca$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $bc5f567978faddca$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $bc5f567978faddca$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $bc5f567978faddca$var$W(a, b, d);
    }
}
var $bc5f567978faddca$var$Oj = !1;
function $bc5f567978faddca$var$Pj(a, b) {
    $bc5f567978faddca$var$Cf = $bc5f567978faddca$var$dd;
    a = $bc5f567978faddca$var$Me();
    if ($bc5f567978faddca$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $bc5f567978faddca$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $bc5f567978faddca$var$dd = !1;
    for($bc5f567978faddca$var$V = b; null !== $bc5f567978faddca$var$V;)if (b = $bc5f567978faddca$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $bc5f567978faddca$var$V = a;
    else for(; null !== $bc5f567978faddca$var$V;){
        b = $bc5f567978faddca$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $bc5f567978faddca$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($bc5f567978faddca$var$p(163));
            }
        } catch (F) {
            $bc5f567978faddca$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $bc5f567978faddca$var$V = a;
            break;
        }
        $bc5f567978faddca$var$V = b.return;
    }
    n = $bc5f567978faddca$var$Oj;
    $bc5f567978faddca$var$Oj = !1;
    return n;
}
function $bc5f567978faddca$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $bc5f567978faddca$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $bc5f567978faddca$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $bc5f567978faddca$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $bc5f567978faddca$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $bc5f567978faddca$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$bc5f567978faddca$var$Of], delete b[$bc5f567978faddca$var$Pf], delete b[$bc5f567978faddca$var$of], delete b[$bc5f567978faddca$var$Qf], delete b[$bc5f567978faddca$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $bc5f567978faddca$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $bc5f567978faddca$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $bc5f567978faddca$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $bc5f567978faddca$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $bc5f567978faddca$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($bc5f567978faddca$var$Wj(a, b, c), a = a.sibling; null !== a;)$bc5f567978faddca$var$Wj(a, b, c), a = a.sibling;
}
function $bc5f567978faddca$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($bc5f567978faddca$var$Xj(a, b, c), a = a.sibling; null !== a;)$bc5f567978faddca$var$Xj(a, b, c), a = a.sibling;
}
var $bc5f567978faddca$var$X = null, $bc5f567978faddca$var$Yj = !1;
function $bc5f567978faddca$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$bc5f567978faddca$var$ak(a, b, c), c = c.sibling;
}
function $bc5f567978faddca$var$ak(a, b, c) {
    if ($bc5f567978faddca$var$lc && "function" === typeof $bc5f567978faddca$var$lc.onCommitFiberUnmount) try {
        $bc5f567978faddca$var$lc.onCommitFiberUnmount($bc5f567978faddca$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $bc5f567978faddca$var$U || $bc5f567978faddca$var$Mj(c, b);
        case 6:
            var d = $bc5f567978faddca$var$X, e = $bc5f567978faddca$var$Yj;
            $bc5f567978faddca$var$X = null;
            $bc5f567978faddca$var$Zj(a, b, c);
            $bc5f567978faddca$var$X = d;
            $bc5f567978faddca$var$Yj = e;
            null !== $bc5f567978faddca$var$X && ($bc5f567978faddca$var$Yj ? (a = $bc5f567978faddca$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $bc5f567978faddca$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $bc5f567978faddca$var$X && ($bc5f567978faddca$var$Yj ? (a = $bc5f567978faddca$var$X, c = c.stateNode, 8 === a.nodeType ? $bc5f567978faddca$var$Kf(a.parentNode, c) : 1 === a.nodeType && $bc5f567978faddca$var$Kf(a, c), $bc5f567978faddca$var$bd(a)) : $bc5f567978faddca$var$Kf($bc5f567978faddca$var$X, c.stateNode));
            break;
        case 4:
            d = $bc5f567978faddca$var$X;
            e = $bc5f567978faddca$var$Yj;
            $bc5f567978faddca$var$X = c.stateNode.containerInfo;
            $bc5f567978faddca$var$Yj = !0;
            $bc5f567978faddca$var$Zj(a, b, c);
            $bc5f567978faddca$var$X = d;
            $bc5f567978faddca$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$bc5f567978faddca$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $bc5f567978faddca$var$Nj(c, b, g) : 0 !== (f & 4) && $bc5f567978faddca$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $bc5f567978faddca$var$Zj(a, b, c);
            break;
        case 1:
            if (!$bc5f567978faddca$var$U && ($bc5f567978faddca$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $bc5f567978faddca$var$W(c, b, h);
            }
            $bc5f567978faddca$var$Zj(a, b, c);
            break;
        case 21:
            $bc5f567978faddca$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($bc5f567978faddca$var$U = (d = $bc5f567978faddca$var$U) || null !== c.memoizedState, $bc5f567978faddca$var$Zj(a, b, c), $bc5f567978faddca$var$U = d) : $bc5f567978faddca$var$Zj(a, b, c);
            break;
        default:
            $bc5f567978faddca$var$Zj(a, b, c);
    }
}
function $bc5f567978faddca$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $bc5f567978faddca$var$Lj);
        b.forEach(function(b) {
            var d = $bc5f567978faddca$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $bc5f567978faddca$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $bc5f567978faddca$var$X = h.stateNode;
                        $bc5f567978faddca$var$Yj = !1;
                        break a;
                    case 3:
                        $bc5f567978faddca$var$X = h.stateNode.containerInfo;
                        $bc5f567978faddca$var$Yj = !0;
                        break a;
                    case 4:
                        $bc5f567978faddca$var$X = h.stateNode.containerInfo;
                        $bc5f567978faddca$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $bc5f567978faddca$var$X) throw Error($bc5f567978faddca$var$p(160));
            $bc5f567978faddca$var$ak(f, g, e);
            $bc5f567978faddca$var$X = null;
            $bc5f567978faddca$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $bc5f567978faddca$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$bc5f567978faddca$var$ek(b, a), b = b.sibling;
}
function $bc5f567978faddca$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $bc5f567978faddca$var$dk(b, a);
            $bc5f567978faddca$var$fk(a);
            if (d & 4) {
                try {
                    $bc5f567978faddca$var$Qj(3, a, a.return), $bc5f567978faddca$var$Rj(3, a);
                } catch (t) {
                    $bc5f567978faddca$var$W(a, a.return, t);
                }
                try {
                    $bc5f567978faddca$var$Qj(5, a, a.return);
                } catch (t) {
                    $bc5f567978faddca$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $bc5f567978faddca$var$dk(b, a);
            $bc5f567978faddca$var$fk(a);
            d & 512 && null !== c && $bc5f567978faddca$var$Mj(c, c.return);
            break;
        case 5:
            $bc5f567978faddca$var$dk(b, a);
            $bc5f567978faddca$var$fk(a);
            d & 512 && null !== c && $bc5f567978faddca$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $bc5f567978faddca$var$ob(e, "");
                } catch (t) {
                    $bc5f567978faddca$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $bc5f567978faddca$var$ab(e, f);
                    $bc5f567978faddca$var$vb(h, g);
                    var l = $bc5f567978faddca$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $bc5f567978faddca$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $bc5f567978faddca$var$nb(e, q) : "children" === m ? $bc5f567978faddca$var$ob(e, q) : $bc5f567978faddca$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $bc5f567978faddca$var$bb(e, f);
                            break;
                        case "textarea":
                            $bc5f567978faddca$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $bc5f567978faddca$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $bc5f567978faddca$var$fb(e, !!f.multiple, f.defaultValue, !0) : $bc5f567978faddca$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$bc5f567978faddca$var$Pf] = f;
                } catch (t) {
                    $bc5f567978faddca$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $bc5f567978faddca$var$dk(b, a);
            $bc5f567978faddca$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($bc5f567978faddca$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $bc5f567978faddca$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $bc5f567978faddca$var$dk(b, a);
            $bc5f567978faddca$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $bc5f567978faddca$var$bd(b.containerInfo);
            } catch (t) {
                $bc5f567978faddca$var$W(a, a.return, t);
            }
            break;
        case 4:
            $bc5f567978faddca$var$dk(b, a);
            $bc5f567978faddca$var$fk(a);
            break;
        case 13:
            $bc5f567978faddca$var$dk(b, a);
            $bc5f567978faddca$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($bc5f567978faddca$var$gk = $bc5f567978faddca$var$B()));
            d & 4 && $bc5f567978faddca$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($bc5f567978faddca$var$U = (l = $bc5f567978faddca$var$U) || m, $bc5f567978faddca$var$dk(b, a), $bc5f567978faddca$var$U = l) : $bc5f567978faddca$var$dk(b, a);
            $bc5f567978faddca$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($bc5f567978faddca$var$V = a, m = a.child; null !== m;){
                    for(q = $bc5f567978faddca$var$V = m; null !== $bc5f567978faddca$var$V;){
                        r = $bc5f567978faddca$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $bc5f567978faddca$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $bc5f567978faddca$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $bc5f567978faddca$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $bc5f567978faddca$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $bc5f567978faddca$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $bc5f567978faddca$var$V = y) : $bc5f567978faddca$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $bc5f567978faddca$var$rb("display", g));
                            } catch (t) {
                                $bc5f567978faddca$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $bc5f567978faddca$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $bc5f567978faddca$var$dk(b, a);
            $bc5f567978faddca$var$fk(a);
            d & 4 && $bc5f567978faddca$var$bk(a);
            break;
        case 21:
            break;
        default:
            $bc5f567978faddca$var$dk(b, a), $bc5f567978faddca$var$fk(a);
    }
}
function $bc5f567978faddca$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($bc5f567978faddca$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($bc5f567978faddca$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($bc5f567978faddca$var$ob(e, ""), d.flags &= -33);
                    var f = $bc5f567978faddca$var$Vj(a);
                    $bc5f567978faddca$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $bc5f567978faddca$var$Vj(a);
                    $bc5f567978faddca$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($bc5f567978faddca$var$p(161));
            }
        } catch (k) {
            $bc5f567978faddca$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $bc5f567978faddca$var$ik(a, b, c) {
    $bc5f567978faddca$var$V = a;
    $bc5f567978faddca$var$jk(a, b, c);
}
function $bc5f567978faddca$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $bc5f567978faddca$var$V;){
        var e = $bc5f567978faddca$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $bc5f567978faddca$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $bc5f567978faddca$var$U;
                h = $bc5f567978faddca$var$Kj;
                var l = $bc5f567978faddca$var$U;
                $bc5f567978faddca$var$Kj = g;
                if (($bc5f567978faddca$var$U = k) && !l) for($bc5f567978faddca$var$V = e; null !== $bc5f567978faddca$var$V;)g = $bc5f567978faddca$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $bc5f567978faddca$var$kk(e) : null !== k ? (k.return = g, $bc5f567978faddca$var$V = k) : $bc5f567978faddca$var$kk(e);
                for(; null !== f;)$bc5f567978faddca$var$V = f, $bc5f567978faddca$var$jk(f, b, c), f = f.sibling;
                $bc5f567978faddca$var$V = e;
                $bc5f567978faddca$var$Kj = h;
                $bc5f567978faddca$var$U = l;
            }
            $bc5f567978faddca$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $bc5f567978faddca$var$V = f) : $bc5f567978faddca$var$lk(a, b, c);
    }
}
function $bc5f567978faddca$var$lk(a) {
    for(; null !== $bc5f567978faddca$var$V;){
        var b = $bc5f567978faddca$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $bc5f567978faddca$var$U || $bc5f567978faddca$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$bc5f567978faddca$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $bc5f567978faddca$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $bc5f567978faddca$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $bc5f567978faddca$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $bc5f567978faddca$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($bc5f567978faddca$var$p(163));
                }
                $bc5f567978faddca$var$U || b.flags & 512 && $bc5f567978faddca$var$Sj(b);
            } catch (r) {
                $bc5f567978faddca$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $bc5f567978faddca$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $bc5f567978faddca$var$V = c;
            break;
        }
        $bc5f567978faddca$var$V = b.return;
    }
}
function $bc5f567978faddca$var$hk(a) {
    for(; null !== $bc5f567978faddca$var$V;){
        var b = $bc5f567978faddca$var$V;
        if (b === a) {
            $bc5f567978faddca$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $bc5f567978faddca$var$V = c;
            break;
        }
        $bc5f567978faddca$var$V = b.return;
    }
}
function $bc5f567978faddca$var$kk(a) {
    for(; null !== $bc5f567978faddca$var$V;){
        var b = $bc5f567978faddca$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $bc5f567978faddca$var$Rj(4, b);
                    } catch (k) {
                        $bc5f567978faddca$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $bc5f567978faddca$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $bc5f567978faddca$var$Sj(b);
                    } catch (k) {
                        $bc5f567978faddca$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $bc5f567978faddca$var$Sj(b);
                    } catch (k) {
                        $bc5f567978faddca$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $bc5f567978faddca$var$W(b, b.return, k);
        }
        if (b === a) {
            $bc5f567978faddca$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $bc5f567978faddca$var$V = h;
            break;
        }
        $bc5f567978faddca$var$V = b.return;
    }
}
var $bc5f567978faddca$var$mk = Math.ceil, $bc5f567978faddca$var$nk = $bc5f567978faddca$var$ua.ReactCurrentDispatcher, $bc5f567978faddca$var$ok = $bc5f567978faddca$var$ua.ReactCurrentOwner, $bc5f567978faddca$var$pk = $bc5f567978faddca$var$ua.ReactCurrentBatchConfig, $bc5f567978faddca$var$K = 0, $bc5f567978faddca$var$R = null, $bc5f567978faddca$var$Y = null, $bc5f567978faddca$var$Z = 0, $bc5f567978faddca$var$gj = 0, $bc5f567978faddca$var$fj = $bc5f567978faddca$var$Uf(0), $bc5f567978faddca$var$T = 0, $bc5f567978faddca$var$qk = null, $bc5f567978faddca$var$hh = 0, $bc5f567978faddca$var$rk = 0, $bc5f567978faddca$var$sk = 0, $bc5f567978faddca$var$tk = null, $bc5f567978faddca$var$uk = null, $bc5f567978faddca$var$gk = 0, $bc5f567978faddca$var$Hj = Infinity, $bc5f567978faddca$var$vk = null, $bc5f567978faddca$var$Pi = !1, $bc5f567978faddca$var$Qi = null, $bc5f567978faddca$var$Si = null, $bc5f567978faddca$var$wk = !1, $bc5f567978faddca$var$xk = null, $bc5f567978faddca$var$yk = 0, $bc5f567978faddca$var$zk = 0, $bc5f567978faddca$var$Ak = null, $bc5f567978faddca$var$Bk = -1, $bc5f567978faddca$var$Ck = 0;
function $bc5f567978faddca$var$L() {
    return 0 !== ($bc5f567978faddca$var$K & 6) ? $bc5f567978faddca$var$B() : -1 !== $bc5f567978faddca$var$Bk ? $bc5f567978faddca$var$Bk : $bc5f567978faddca$var$Bk = $bc5f567978faddca$var$B();
}
function $bc5f567978faddca$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($bc5f567978faddca$var$K & 2) && 0 !== $bc5f567978faddca$var$Z) return $bc5f567978faddca$var$Z & -$bc5f567978faddca$var$Z;
    if (null !== $bc5f567978faddca$var$Kg.transition) return 0 === $bc5f567978faddca$var$Ck && ($bc5f567978faddca$var$Ck = $bc5f567978faddca$var$yc()), $bc5f567978faddca$var$Ck;
    a = $bc5f567978faddca$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $bc5f567978faddca$var$jd(a.type);
    return a;
}
function $bc5f567978faddca$var$mh(a, b, c, d) {
    if (50 < $bc5f567978faddca$var$zk) throw $bc5f567978faddca$var$zk = 0, $bc5f567978faddca$var$Ak = null, Error($bc5f567978faddca$var$p(185));
    $bc5f567978faddca$var$Ac(a, c, d);
    if (0 === ($bc5f567978faddca$var$K & 2) || a !== $bc5f567978faddca$var$R) a === $bc5f567978faddca$var$R && (0 === ($bc5f567978faddca$var$K & 2) && ($bc5f567978faddca$var$rk |= c), 4 === $bc5f567978faddca$var$T && $bc5f567978faddca$var$Dk(a, $bc5f567978faddca$var$Z)), $bc5f567978faddca$var$Ek(a, d), 1 === c && 0 === $bc5f567978faddca$var$K && 0 === (b.mode & 1) && ($bc5f567978faddca$var$Hj = $bc5f567978faddca$var$B() + 500, $bc5f567978faddca$var$fg && $bc5f567978faddca$var$jg());
}
function $bc5f567978faddca$var$Ek(a, b) {
    var c = a.callbackNode;
    $bc5f567978faddca$var$wc(a, b);
    var d = $bc5f567978faddca$var$uc(a, a === $bc5f567978faddca$var$R ? $bc5f567978faddca$var$Z : 0);
    if (0 === d) null !== c && $bc5f567978faddca$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $bc5f567978faddca$var$bc(c);
        if (1 === b) 0 === a.tag ? $bc5f567978faddca$var$ig($bc5f567978faddca$var$Fk.bind(null, a)) : $bc5f567978faddca$var$hg($bc5f567978faddca$var$Fk.bind(null, a)), $bc5f567978faddca$var$Jf(function() {
            0 === ($bc5f567978faddca$var$K & 6) && $bc5f567978faddca$var$jg();
        }), c = null;
        else {
            switch($bc5f567978faddca$var$Dc(d)){
                case 1:
                    c = $bc5f567978faddca$var$fc;
                    break;
                case 4:
                    c = $bc5f567978faddca$var$gc;
                    break;
                case 16:
                    c = $bc5f567978faddca$var$hc;
                    break;
                case 536870912:
                    c = $bc5f567978faddca$var$jc;
                    break;
                default:
                    c = $bc5f567978faddca$var$hc;
            }
            c = $bc5f567978faddca$var$Gk(c, $bc5f567978faddca$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $bc5f567978faddca$var$Hk(a, b) {
    $bc5f567978faddca$var$Bk = -1;
    $bc5f567978faddca$var$Ck = 0;
    if (0 !== ($bc5f567978faddca$var$K & 6)) throw Error($bc5f567978faddca$var$p(327));
    var c = a.callbackNode;
    if ($bc5f567978faddca$var$Ik() && a.callbackNode !== c) return null;
    var d = $bc5f567978faddca$var$uc(a, a === $bc5f567978faddca$var$R ? $bc5f567978faddca$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $bc5f567978faddca$var$Jk(a, d);
    else {
        b = d;
        var e = $bc5f567978faddca$var$K;
        $bc5f567978faddca$var$K |= 2;
        var f = $bc5f567978faddca$var$Kk();
        if ($bc5f567978faddca$var$R !== a || $bc5f567978faddca$var$Z !== b) $bc5f567978faddca$var$vk = null, $bc5f567978faddca$var$Hj = $bc5f567978faddca$var$B() + 500, $bc5f567978faddca$var$Lk(a, b);
        for(;;)try {
            $bc5f567978faddca$var$Mk();
            break;
        } catch (h) {
            $bc5f567978faddca$var$Nk(a, h);
        }
        $bc5f567978faddca$var$Qg();
        $bc5f567978faddca$var$nk.current = f;
        $bc5f567978faddca$var$K = e;
        null !== $bc5f567978faddca$var$Y ? b = 0 : ($bc5f567978faddca$var$R = null, $bc5f567978faddca$var$Z = 0, b = $bc5f567978faddca$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $bc5f567978faddca$var$xc(a), 0 !== e && (d = e, b = $bc5f567978faddca$var$Ok(a, e)));
        if (1 === b) throw c = $bc5f567978faddca$var$qk, $bc5f567978faddca$var$Lk(a, 0), $bc5f567978faddca$var$Dk(a, d), $bc5f567978faddca$var$Ek(a, $bc5f567978faddca$var$B()), c;
        if (6 === b) $bc5f567978faddca$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$bc5f567978faddca$var$Pk(e) && (b = $bc5f567978faddca$var$Jk(a, d), 2 === b && (f = $bc5f567978faddca$var$xc(a), 0 !== f && (d = f, b = $bc5f567978faddca$var$Ok(a, f))), 1 === b)) throw c = $bc5f567978faddca$var$qk, $bc5f567978faddca$var$Lk(a, 0), $bc5f567978faddca$var$Dk(a, d), $bc5f567978faddca$var$Ek(a, $bc5f567978faddca$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($bc5f567978faddca$var$p(345));
                case 2:
                    $bc5f567978faddca$var$Qk(a, $bc5f567978faddca$var$uk, $bc5f567978faddca$var$vk);
                    break;
                case 3:
                    $bc5f567978faddca$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $bc5f567978faddca$var$gk + 500 - $bc5f567978faddca$var$B(), 10 < b)) {
                        if (0 !== $bc5f567978faddca$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $bc5f567978faddca$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $bc5f567978faddca$var$Ff($bc5f567978faddca$var$Qk.bind(null, a, $bc5f567978faddca$var$uk, $bc5f567978faddca$var$vk), b);
                        break;
                    }
                    $bc5f567978faddca$var$Qk(a, $bc5f567978faddca$var$uk, $bc5f567978faddca$var$vk);
                    break;
                case 4:
                    $bc5f567978faddca$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $bc5f567978faddca$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $bc5f567978faddca$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $bc5f567978faddca$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $bc5f567978faddca$var$Ff($bc5f567978faddca$var$Qk.bind(null, a, $bc5f567978faddca$var$uk, $bc5f567978faddca$var$vk), d);
                        break;
                    }
                    $bc5f567978faddca$var$Qk(a, $bc5f567978faddca$var$uk, $bc5f567978faddca$var$vk);
                    break;
                case 5:
                    $bc5f567978faddca$var$Qk(a, $bc5f567978faddca$var$uk, $bc5f567978faddca$var$vk);
                    break;
                default:
                    throw Error($bc5f567978faddca$var$p(329));
            }
        }
    }
    $bc5f567978faddca$var$Ek(a, $bc5f567978faddca$var$B());
    return a.callbackNode === c ? $bc5f567978faddca$var$Hk.bind(null, a) : null;
}
function $bc5f567978faddca$var$Ok(a, b) {
    var c = $bc5f567978faddca$var$tk;
    a.current.memoizedState.isDehydrated && ($bc5f567978faddca$var$Lk(a, b).flags |= 256);
    a = $bc5f567978faddca$var$Jk(a, b);
    2 !== a && (b = $bc5f567978faddca$var$uk, $bc5f567978faddca$var$uk = c, null !== b && $bc5f567978faddca$var$Gj(b));
    return a;
}
function $bc5f567978faddca$var$Gj(a) {
    null === $bc5f567978faddca$var$uk ? $bc5f567978faddca$var$uk = a : $bc5f567978faddca$var$uk.push.apply($bc5f567978faddca$var$uk, a);
}
function $bc5f567978faddca$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$bc5f567978faddca$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $bc5f567978faddca$var$Dk(a, b) {
    b &= ~$bc5f567978faddca$var$sk;
    b &= ~$bc5f567978faddca$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $bc5f567978faddca$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $bc5f567978faddca$var$Fk(a) {
    if (0 !== ($bc5f567978faddca$var$K & 6)) throw Error($bc5f567978faddca$var$p(327));
    $bc5f567978faddca$var$Ik();
    var b = $bc5f567978faddca$var$uc(a, 0);
    if (0 === (b & 1)) return $bc5f567978faddca$var$Ek(a, $bc5f567978faddca$var$B()), null;
    var c = $bc5f567978faddca$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $bc5f567978faddca$var$xc(a);
        0 !== d && (b = d, c = $bc5f567978faddca$var$Ok(a, d));
    }
    if (1 === c) throw c = $bc5f567978faddca$var$qk, $bc5f567978faddca$var$Lk(a, 0), $bc5f567978faddca$var$Dk(a, b), $bc5f567978faddca$var$Ek(a, $bc5f567978faddca$var$B()), c;
    if (6 === c) throw Error($bc5f567978faddca$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $bc5f567978faddca$var$Qk(a, $bc5f567978faddca$var$uk, $bc5f567978faddca$var$vk);
    $bc5f567978faddca$var$Ek(a, $bc5f567978faddca$var$B());
    return null;
}
function $bc5f567978faddca$var$Rk(a, b) {
    var c = $bc5f567978faddca$var$K;
    $bc5f567978faddca$var$K |= 1;
    try {
        return a(b);
    } finally{
        $bc5f567978faddca$var$K = c, 0 === $bc5f567978faddca$var$K && ($bc5f567978faddca$var$Hj = $bc5f567978faddca$var$B() + 500, $bc5f567978faddca$var$fg && $bc5f567978faddca$var$jg());
    }
}
function $bc5f567978faddca$var$Sk(a) {
    null !== $bc5f567978faddca$var$xk && 0 === $bc5f567978faddca$var$xk.tag && 0 === ($bc5f567978faddca$var$K & 6) && $bc5f567978faddca$var$Ik();
    var b = $bc5f567978faddca$var$K;
    $bc5f567978faddca$var$K |= 1;
    var c = $bc5f567978faddca$var$pk.transition, d = $bc5f567978faddca$var$C;
    try {
        if ($bc5f567978faddca$var$pk.transition = null, $bc5f567978faddca$var$C = 1, a) return a();
    } finally{
        $bc5f567978faddca$var$C = d, $bc5f567978faddca$var$pk.transition = c, $bc5f567978faddca$var$K = b, 0 === ($bc5f567978faddca$var$K & 6) && $bc5f567978faddca$var$jg();
    }
}
function $bc5f567978faddca$var$Ij() {
    $bc5f567978faddca$var$gj = $bc5f567978faddca$var$fj.current;
    $bc5f567978faddca$var$E($bc5f567978faddca$var$fj);
}
function $bc5f567978faddca$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $bc5f567978faddca$var$Gf(c));
    if (null !== $bc5f567978faddca$var$Y) for(c = $bc5f567978faddca$var$Y.return; null !== c;){
        var d = c;
        $bc5f567978faddca$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $bc5f567978faddca$var$$f();
                break;
            case 3:
                $bc5f567978faddca$var$Jh();
                $bc5f567978faddca$var$E($bc5f567978faddca$var$Wf);
                $bc5f567978faddca$var$E($bc5f567978faddca$var$H);
                $bc5f567978faddca$var$Oh();
                break;
            case 5:
                $bc5f567978faddca$var$Lh(d);
                break;
            case 4:
                $bc5f567978faddca$var$Jh();
                break;
            case 13:
                $bc5f567978faddca$var$E($bc5f567978faddca$var$M);
                break;
            case 19:
                $bc5f567978faddca$var$E($bc5f567978faddca$var$M);
                break;
            case 10:
                $bc5f567978faddca$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $bc5f567978faddca$var$Ij();
        }
        c = c.return;
    }
    $bc5f567978faddca$var$R = a;
    $bc5f567978faddca$var$Y = a = $bc5f567978faddca$var$wh(a.current, null);
    $bc5f567978faddca$var$Z = $bc5f567978faddca$var$gj = b;
    $bc5f567978faddca$var$T = 0;
    $bc5f567978faddca$var$qk = null;
    $bc5f567978faddca$var$sk = $bc5f567978faddca$var$rk = $bc5f567978faddca$var$hh = 0;
    $bc5f567978faddca$var$uk = $bc5f567978faddca$var$tk = null;
    if (null !== $bc5f567978faddca$var$Wg) {
        for(b = 0; b < $bc5f567978faddca$var$Wg.length; b++)if (c = $bc5f567978faddca$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $bc5f567978faddca$var$Wg = null;
    }
    return a;
}
function $bc5f567978faddca$var$Nk(a, b) {
    do {
        var c = $bc5f567978faddca$var$Y;
        try {
            $bc5f567978faddca$var$Qg();
            $bc5f567978faddca$var$Ph.current = $bc5f567978faddca$var$ai;
            if ($bc5f567978faddca$var$Sh) {
                for(var d = $bc5f567978faddca$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $bc5f567978faddca$var$Sh = !1;
            }
            $bc5f567978faddca$var$Rh = 0;
            $bc5f567978faddca$var$P = $bc5f567978faddca$var$O = $bc5f567978faddca$var$N = null;
            $bc5f567978faddca$var$Th = !1;
            $bc5f567978faddca$var$Uh = 0;
            $bc5f567978faddca$var$ok.current = null;
            if (null === c || null === c.return) {
                $bc5f567978faddca$var$T = 1;
                $bc5f567978faddca$var$qk = b;
                $bc5f567978faddca$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $bc5f567978faddca$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $bc5f567978faddca$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $bc5f567978faddca$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $bc5f567978faddca$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $bc5f567978faddca$var$Ti(f, l, b);
                            $bc5f567978faddca$var$uj();
                            break a;
                        }
                        k = Error($bc5f567978faddca$var$p(426));
                    }
                } else if ($bc5f567978faddca$var$I && h.mode & 1) {
                    var J = $bc5f567978faddca$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $bc5f567978faddca$var$Wi(J, g, h, f, b);
                        $bc5f567978faddca$var$Jg($bc5f567978faddca$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $bc5f567978faddca$var$Ki(k, h);
                4 !== $bc5f567978faddca$var$T && ($bc5f567978faddca$var$T = 2);
                null === $bc5f567978faddca$var$tk ? $bc5f567978faddca$var$tk = [
                    f
                ] : $bc5f567978faddca$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $bc5f567978faddca$var$Oi(f, k, b);
                            $bc5f567978faddca$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $bc5f567978faddca$var$Si || !$bc5f567978faddca$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $bc5f567978faddca$var$Ri(f, h, b);
                                $bc5f567978faddca$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $bc5f567978faddca$var$Tk(c);
        } catch (na) {
            b = na;
            $bc5f567978faddca$var$Y === c && null !== c && ($bc5f567978faddca$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $bc5f567978faddca$var$Kk() {
    var a = $bc5f567978faddca$var$nk.current;
    $bc5f567978faddca$var$nk.current = $bc5f567978faddca$var$ai;
    return null === a ? $bc5f567978faddca$var$ai : a;
}
function $bc5f567978faddca$var$uj() {
    if (0 === $bc5f567978faddca$var$T || 3 === $bc5f567978faddca$var$T || 2 === $bc5f567978faddca$var$T) $bc5f567978faddca$var$T = 4;
    null === $bc5f567978faddca$var$R || 0 === ($bc5f567978faddca$var$hh & 268435455) && 0 === ($bc5f567978faddca$var$rk & 268435455) || $bc5f567978faddca$var$Dk($bc5f567978faddca$var$R, $bc5f567978faddca$var$Z);
}
function $bc5f567978faddca$var$Jk(a, b) {
    var c = $bc5f567978faddca$var$K;
    $bc5f567978faddca$var$K |= 2;
    var d = $bc5f567978faddca$var$Kk();
    if ($bc5f567978faddca$var$R !== a || $bc5f567978faddca$var$Z !== b) $bc5f567978faddca$var$vk = null, $bc5f567978faddca$var$Lk(a, b);
    for(;;)try {
        $bc5f567978faddca$var$Uk();
        break;
    } catch (e) {
        $bc5f567978faddca$var$Nk(a, e);
    }
    $bc5f567978faddca$var$Qg();
    $bc5f567978faddca$var$K = c;
    $bc5f567978faddca$var$nk.current = d;
    if (null !== $bc5f567978faddca$var$Y) throw Error($bc5f567978faddca$var$p(261));
    $bc5f567978faddca$var$R = null;
    $bc5f567978faddca$var$Z = 0;
    return $bc5f567978faddca$var$T;
}
function $bc5f567978faddca$var$Uk() {
    for(; null !== $bc5f567978faddca$var$Y;)$bc5f567978faddca$var$Vk($bc5f567978faddca$var$Y);
}
function $bc5f567978faddca$var$Mk() {
    for(; null !== $bc5f567978faddca$var$Y && !$bc5f567978faddca$var$cc();)$bc5f567978faddca$var$Vk($bc5f567978faddca$var$Y);
}
function $bc5f567978faddca$var$Vk(a) {
    var b = $bc5f567978faddca$var$Wk(a.alternate, a, $bc5f567978faddca$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $bc5f567978faddca$var$Tk(a) : $bc5f567978faddca$var$Y = b;
    $bc5f567978faddca$var$ok.current = null;
}
function $bc5f567978faddca$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $bc5f567978faddca$var$Fj(c, b, $bc5f567978faddca$var$gj), null !== c) {
                $bc5f567978faddca$var$Y = c;
                return;
            }
        } else {
            c = $bc5f567978faddca$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $bc5f567978faddca$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $bc5f567978faddca$var$T = 6;
                $bc5f567978faddca$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $bc5f567978faddca$var$Y = b;
            return;
        }
        $bc5f567978faddca$var$Y = b = a;
    }while (null !== b);
    0 === $bc5f567978faddca$var$T && ($bc5f567978faddca$var$T = 5);
}
function $bc5f567978faddca$var$Qk(a, b, c) {
    var d = $bc5f567978faddca$var$C, e = $bc5f567978faddca$var$pk.transition;
    try {
        $bc5f567978faddca$var$pk.transition = null, $bc5f567978faddca$var$C = 1, $bc5f567978faddca$var$Xk(a, b, c, d);
    } finally{
        $bc5f567978faddca$var$pk.transition = e, $bc5f567978faddca$var$C = d;
    }
    return null;
}
function $bc5f567978faddca$var$Xk(a, b, c, d) {
    do $bc5f567978faddca$var$Ik();
    while (null !== $bc5f567978faddca$var$xk);
    if (0 !== ($bc5f567978faddca$var$K & 6)) throw Error($bc5f567978faddca$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($bc5f567978faddca$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $bc5f567978faddca$var$Bc(a, f);
    a === $bc5f567978faddca$var$R && ($bc5f567978faddca$var$Y = $bc5f567978faddca$var$R = null, $bc5f567978faddca$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $bc5f567978faddca$var$wk || ($bc5f567978faddca$var$wk = !0, $bc5f567978faddca$var$Gk($bc5f567978faddca$var$hc, function() {
        $bc5f567978faddca$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $bc5f567978faddca$var$pk.transition;
        $bc5f567978faddca$var$pk.transition = null;
        var g = $bc5f567978faddca$var$C;
        $bc5f567978faddca$var$C = 1;
        var h = $bc5f567978faddca$var$K;
        $bc5f567978faddca$var$K |= 4;
        $bc5f567978faddca$var$ok.current = null;
        $bc5f567978faddca$var$Pj(a, c);
        $bc5f567978faddca$var$ek(c, a);
        $bc5f567978faddca$var$Oe($bc5f567978faddca$var$Df);
        $bc5f567978faddca$var$dd = !!$bc5f567978faddca$var$Cf;
        $bc5f567978faddca$var$Df = $bc5f567978faddca$var$Cf = null;
        a.current = c;
        $bc5f567978faddca$var$ik(c, a, e);
        $bc5f567978faddca$var$dc();
        $bc5f567978faddca$var$K = h;
        $bc5f567978faddca$var$C = g;
        $bc5f567978faddca$var$pk.transition = f;
    } else a.current = c;
    $bc5f567978faddca$var$wk && ($bc5f567978faddca$var$wk = !1, $bc5f567978faddca$var$xk = a, $bc5f567978faddca$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($bc5f567978faddca$var$Si = null);
    $bc5f567978faddca$var$mc(c.stateNode, d);
    $bc5f567978faddca$var$Ek(a, $bc5f567978faddca$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($bc5f567978faddca$var$Pi) throw $bc5f567978faddca$var$Pi = !1, a = $bc5f567978faddca$var$Qi, $bc5f567978faddca$var$Qi = null, a;
    0 !== ($bc5f567978faddca$var$yk & 1) && 0 !== a.tag && $bc5f567978faddca$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $bc5f567978faddca$var$Ak ? $bc5f567978faddca$var$zk++ : ($bc5f567978faddca$var$zk = 0, $bc5f567978faddca$var$Ak = a) : $bc5f567978faddca$var$zk = 0;
    $bc5f567978faddca$var$jg();
    return null;
}
function $bc5f567978faddca$var$Ik() {
    if (null !== $bc5f567978faddca$var$xk) {
        var a = $bc5f567978faddca$var$Dc($bc5f567978faddca$var$yk), b = $bc5f567978faddca$var$pk.transition, c = $bc5f567978faddca$var$C;
        try {
            $bc5f567978faddca$var$pk.transition = null;
            $bc5f567978faddca$var$C = 16 > a ? 16 : a;
            if (null === $bc5f567978faddca$var$xk) var d = !1;
            else {
                a = $bc5f567978faddca$var$xk;
                $bc5f567978faddca$var$xk = null;
                $bc5f567978faddca$var$yk = 0;
                if (0 !== ($bc5f567978faddca$var$K & 6)) throw Error($bc5f567978faddca$var$p(331));
                var e = $bc5f567978faddca$var$K;
                $bc5f567978faddca$var$K |= 4;
                for($bc5f567978faddca$var$V = a.current; null !== $bc5f567978faddca$var$V;){
                    var f = $bc5f567978faddca$var$V, g = f.child;
                    if (0 !== ($bc5f567978faddca$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($bc5f567978faddca$var$V = l; null !== $bc5f567978faddca$var$V;){
                                    var m = $bc5f567978faddca$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $bc5f567978faddca$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $bc5f567978faddca$var$V = q;
                                    else for(; null !== $bc5f567978faddca$var$V;){
                                        m = $bc5f567978faddca$var$V;
                                        var r = m.sibling, y = m.return;
                                        $bc5f567978faddca$var$Tj(m);
                                        if (m === l) {
                                            $bc5f567978faddca$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $bc5f567978faddca$var$V = r;
                                            break;
                                        }
                                        $bc5f567978faddca$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $bc5f567978faddca$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $bc5f567978faddca$var$V = g;
                    else b: for(; null !== $bc5f567978faddca$var$V;){
                        f = $bc5f567978faddca$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $bc5f567978faddca$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $bc5f567978faddca$var$V = x;
                            break b;
                        }
                        $bc5f567978faddca$var$V = f.return;
                    }
                }
                var w = a.current;
                for($bc5f567978faddca$var$V = w; null !== $bc5f567978faddca$var$V;){
                    g = $bc5f567978faddca$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $bc5f567978faddca$var$V = u;
                    else b: for(g = w; null !== $bc5f567978faddca$var$V;){
                        h = $bc5f567978faddca$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $bc5f567978faddca$var$Rj(9, h);
                            }
                        } catch (na) {
                            $bc5f567978faddca$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $bc5f567978faddca$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $bc5f567978faddca$var$V = F;
                            break b;
                        }
                        $bc5f567978faddca$var$V = h.return;
                    }
                }
                $bc5f567978faddca$var$K = e;
                $bc5f567978faddca$var$jg();
                if ($bc5f567978faddca$var$lc && "function" === typeof $bc5f567978faddca$var$lc.onPostCommitFiberRoot) try {
                    $bc5f567978faddca$var$lc.onPostCommitFiberRoot($bc5f567978faddca$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $bc5f567978faddca$var$C = c, $bc5f567978faddca$var$pk.transition = b;
        }
    }
    return !1;
}
function $bc5f567978faddca$var$Yk(a, b, c) {
    b = $bc5f567978faddca$var$Ki(c, b);
    b = $bc5f567978faddca$var$Oi(a, b, 1);
    a = $bc5f567978faddca$var$dh(a, b, 1);
    b = $bc5f567978faddca$var$L();
    null !== a && ($bc5f567978faddca$var$Ac(a, 1, b), $bc5f567978faddca$var$Ek(a, b));
}
function $bc5f567978faddca$var$W(a, b, c) {
    if (3 === a.tag) $bc5f567978faddca$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $bc5f567978faddca$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $bc5f567978faddca$var$Si || !$bc5f567978faddca$var$Si.has(d))) {
                a = $bc5f567978faddca$var$Ki(c, a);
                a = $bc5f567978faddca$var$Ri(b, a, 1);
                b = $bc5f567978faddca$var$dh(b, a, 1);
                a = $bc5f567978faddca$var$L();
                null !== b && ($bc5f567978faddca$var$Ac(b, 1, a), $bc5f567978faddca$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $bc5f567978faddca$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $bc5f567978faddca$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $bc5f567978faddca$var$R === a && ($bc5f567978faddca$var$Z & c) === c && (4 === $bc5f567978faddca$var$T || 3 === $bc5f567978faddca$var$T && ($bc5f567978faddca$var$Z & 130023424) === $bc5f567978faddca$var$Z && 500 > $bc5f567978faddca$var$B() - $bc5f567978faddca$var$gk ? $bc5f567978faddca$var$Lk(a, 0) : $bc5f567978faddca$var$sk |= c);
    $bc5f567978faddca$var$Ek(a, b);
}
function $bc5f567978faddca$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $bc5f567978faddca$var$sc, $bc5f567978faddca$var$sc <<= 1, 0 === ($bc5f567978faddca$var$sc & 130023424) && ($bc5f567978faddca$var$sc = 4194304)));
    var c = $bc5f567978faddca$var$L();
    a = $bc5f567978faddca$var$Zg(a, b);
    null !== a && ($bc5f567978faddca$var$Ac(a, b, c), $bc5f567978faddca$var$Ek(a, c));
}
function $bc5f567978faddca$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $bc5f567978faddca$var$Zk(a, c);
}
function $bc5f567978faddca$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($bc5f567978faddca$var$p(314));
    }
    null !== d && d.delete(b);
    $bc5f567978faddca$var$Zk(a, c);
}
var $bc5f567978faddca$var$Wk;
$bc5f567978faddca$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $bc5f567978faddca$var$Wf.current) $bc5f567978faddca$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $bc5f567978faddca$var$Ug = !1, $bc5f567978faddca$var$zj(a, b, c);
            $bc5f567978faddca$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $bc5f567978faddca$var$Ug = !1, $bc5f567978faddca$var$I && 0 !== (b.flags & 1048576) && $bc5f567978faddca$var$ug(b, $bc5f567978faddca$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $bc5f567978faddca$var$jj(a, b);
            a = b.pendingProps;
            var e = $bc5f567978faddca$var$Yf(b, $bc5f567978faddca$var$H.current);
            $bc5f567978faddca$var$Tg(b, c);
            e = $bc5f567978faddca$var$Xh(null, b, d, a, e, c);
            var f = $bc5f567978faddca$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $bc5f567978faddca$var$Zf(d) ? (f = !0, $bc5f567978faddca$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $bc5f567978faddca$var$ah(b), e.updater = $bc5f567978faddca$var$nh, b.stateNode = e, e._reactInternals = b, $bc5f567978faddca$var$rh(b, d, a, c), b = $bc5f567978faddca$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $bc5f567978faddca$var$I && f && $bc5f567978faddca$var$vg(b), $bc5f567978faddca$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $bc5f567978faddca$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $bc5f567978faddca$var$$k(d);
                a = $bc5f567978faddca$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $bc5f567978faddca$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $bc5f567978faddca$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $bc5f567978faddca$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $bc5f567978faddca$var$aj(null, b, d, $bc5f567978faddca$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($bc5f567978faddca$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $bc5f567978faddca$var$Lg(d, e), $bc5f567978faddca$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $bc5f567978faddca$var$Lg(d, e), $bc5f567978faddca$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $bc5f567978faddca$var$lj(b);
                if (null === a) throw Error($bc5f567978faddca$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $bc5f567978faddca$var$bh(a, b);
                $bc5f567978faddca$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $bc5f567978faddca$var$Ki(Error($bc5f567978faddca$var$p(423)), b);
                        b = $bc5f567978faddca$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $bc5f567978faddca$var$Ki(Error($bc5f567978faddca$var$p(424)), b);
                        b = $bc5f567978faddca$var$mj(a, b, d, c, e);
                        break a;
                    } else for($bc5f567978faddca$var$yg = $bc5f567978faddca$var$Lf(b.stateNode.containerInfo.firstChild), $bc5f567978faddca$var$xg = b, $bc5f567978faddca$var$I = !0, $bc5f567978faddca$var$zg = null, c = $bc5f567978faddca$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $bc5f567978faddca$var$Ig();
                    if (d === e) {
                        b = $bc5f567978faddca$var$$i(a, b, c);
                        break a;
                    }
                    $bc5f567978faddca$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $bc5f567978faddca$var$Kh(b), null === a && $bc5f567978faddca$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $bc5f567978faddca$var$Ef(d, e) ? g = null : null !== f && $bc5f567978faddca$var$Ef(d, f) && (b.flags |= 32), $bc5f567978faddca$var$hj(a, b), $bc5f567978faddca$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $bc5f567978faddca$var$Eg(b), null;
        case 13:
            return $bc5f567978faddca$var$pj(a, b, c);
        case 4:
            return $bc5f567978faddca$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $bc5f567978faddca$var$Bh(b, null, d, c) : $bc5f567978faddca$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $bc5f567978faddca$var$Lg(d, e), $bc5f567978faddca$var$Zi(a, b, d, e, c);
        case 7:
            return $bc5f567978faddca$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $bc5f567978faddca$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $bc5f567978faddca$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $bc5f567978faddca$var$G($bc5f567978faddca$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($bc5f567978faddca$var$He(f.value, g)) {
                        if (f.children === e.children && !$bc5f567978faddca$var$Wf.current) {
                            b = $bc5f567978faddca$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $bc5f567978faddca$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $bc5f567978faddca$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($bc5f567978faddca$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $bc5f567978faddca$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $bc5f567978faddca$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $bc5f567978faddca$var$Tg(b, c), e = $bc5f567978faddca$var$Vg(e), d = d(e), b.flags |= 1, $bc5f567978faddca$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $bc5f567978faddca$var$Lg(d, b.pendingProps), e = $bc5f567978faddca$var$Lg(d.type, e), $bc5f567978faddca$var$aj(a, b, d, e, c);
        case 15:
            return $bc5f567978faddca$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $bc5f567978faddca$var$Lg(d, e), $bc5f567978faddca$var$jj(a, b), b.tag = 1, $bc5f567978faddca$var$Zf(d) ? (a = !0, $bc5f567978faddca$var$cg(b)) : a = !1, $bc5f567978faddca$var$Tg(b, c), $bc5f567978faddca$var$ph(b, d, e), $bc5f567978faddca$var$rh(b, d, e, c), $bc5f567978faddca$var$kj(null, b, d, !0, a, c);
        case 19:
            return $bc5f567978faddca$var$yj(a, b, c);
        case 22:
            return $bc5f567978faddca$var$ej(a, b, c);
    }
    throw Error($bc5f567978faddca$var$p(156, b.tag));
};
function $bc5f567978faddca$var$Gk(a, b) {
    return $bc5f567978faddca$var$ac(a, b);
}
function $bc5f567978faddca$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $bc5f567978faddca$var$Bg(a, b, c, d) {
    return new $bc5f567978faddca$var$al(a, b, c, d);
}
function $bc5f567978faddca$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $bc5f567978faddca$var$$k(a) {
    if ("function" === typeof a) return $bc5f567978faddca$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $bc5f567978faddca$var$Da) return 11;
        if (a === $bc5f567978faddca$var$Ga) return 14;
    }
    return 2;
}
function $bc5f567978faddca$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $bc5f567978faddca$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $bc5f567978faddca$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $bc5f567978faddca$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $bc5f567978faddca$var$ya:
            return $bc5f567978faddca$var$Ah(c.children, e, f, b);
        case $bc5f567978faddca$var$za:
            g = 8;
            e |= 8;
            break;
        case $bc5f567978faddca$var$Aa:
            return a = $bc5f567978faddca$var$Bg(12, c, b, e | 2), a.elementType = $bc5f567978faddca$var$Aa, a.lanes = f, a;
        case $bc5f567978faddca$var$Ea:
            return a = $bc5f567978faddca$var$Bg(13, c, b, e), a.elementType = $bc5f567978faddca$var$Ea, a.lanes = f, a;
        case $bc5f567978faddca$var$Fa:
            return a = $bc5f567978faddca$var$Bg(19, c, b, e), a.elementType = $bc5f567978faddca$var$Fa, a.lanes = f, a;
        case $bc5f567978faddca$var$Ia:
            return $bc5f567978faddca$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $bc5f567978faddca$var$Ba:
                    g = 10;
                    break a;
                case $bc5f567978faddca$var$Ca:
                    g = 9;
                    break a;
                case $bc5f567978faddca$var$Da:
                    g = 11;
                    break a;
                case $bc5f567978faddca$var$Ga:
                    g = 14;
                    break a;
                case $bc5f567978faddca$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($bc5f567978faddca$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $bc5f567978faddca$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $bc5f567978faddca$var$Ah(a, b, c, d) {
    a = $bc5f567978faddca$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $bc5f567978faddca$var$qj(a, b, c, d) {
    a = $bc5f567978faddca$var$Bg(22, a, d, b);
    a.elementType = $bc5f567978faddca$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $bc5f567978faddca$var$xh(a, b, c) {
    a = $bc5f567978faddca$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $bc5f567978faddca$var$zh(a, b, c) {
    b = $bc5f567978faddca$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $bc5f567978faddca$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $bc5f567978faddca$var$zc(0);
    this.expirationTimes = $bc5f567978faddca$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $bc5f567978faddca$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $bc5f567978faddca$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $bc5f567978faddca$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $bc5f567978faddca$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $bc5f567978faddca$var$ah(f);
    return a;
}
function $bc5f567978faddca$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $bc5f567978faddca$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $bc5f567978faddca$var$el(a) {
    if (!a) return $bc5f567978faddca$var$Vf;
    a = a._reactInternals;
    a: {
        if ($bc5f567978faddca$var$Vb(a) !== a || 1 !== a.tag) throw Error($bc5f567978faddca$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($bc5f567978faddca$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($bc5f567978faddca$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($bc5f567978faddca$var$Zf(c)) return $bc5f567978faddca$var$bg(a, c, b);
    }
    return b;
}
function $bc5f567978faddca$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $bc5f567978faddca$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $bc5f567978faddca$var$el(null);
    c = a.current;
    d = $bc5f567978faddca$var$L();
    e = $bc5f567978faddca$var$lh(c);
    f = $bc5f567978faddca$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $bc5f567978faddca$var$dh(c, f, e);
    a.current.lanes = e;
    $bc5f567978faddca$var$Ac(a, e, d);
    $bc5f567978faddca$var$Ek(a, d);
    return a;
}
function $bc5f567978faddca$var$gl(a, b, c, d) {
    var e = b.current, f = $bc5f567978faddca$var$L(), g = $bc5f567978faddca$var$lh(e);
    c = $bc5f567978faddca$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $bc5f567978faddca$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $bc5f567978faddca$var$dh(e, b, g);
    null !== a && ($bc5f567978faddca$var$mh(a, e, g, f), $bc5f567978faddca$var$eh(a, e, g));
    return g;
}
function $bc5f567978faddca$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $bc5f567978faddca$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $bc5f567978faddca$var$jl(a, b) {
    $bc5f567978faddca$var$il(a, b);
    (a = a.alternate) && $bc5f567978faddca$var$il(a, b);
}
function $bc5f567978faddca$var$kl() {
    return null;
}
var $bc5f567978faddca$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $bc5f567978faddca$var$ml(a) {
    this._internalRoot = a;
}
$bc5f567978faddca$var$nl.prototype.render = $bc5f567978faddca$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($bc5f567978faddca$var$p(409));
    $bc5f567978faddca$var$gl(a, b, null, null);
};
$bc5f567978faddca$var$nl.prototype.unmount = $bc5f567978faddca$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $bc5f567978faddca$var$Sk(function() {
            $bc5f567978faddca$var$gl(null, a, null, null);
        });
        b[$bc5f567978faddca$var$uf] = null;
    }
};
function $bc5f567978faddca$var$nl(a) {
    this._internalRoot = a;
}
$bc5f567978faddca$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $bc5f567978faddca$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $bc5f567978faddca$var$Qc.length && 0 !== b && b < $bc5f567978faddca$var$Qc[c].priority; c++);
        $bc5f567978faddca$var$Qc.splice(c, 0, a);
        0 === c && $bc5f567978faddca$var$Vc(a);
    }
};
function $bc5f567978faddca$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $bc5f567978faddca$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $bc5f567978faddca$var$ql() {}
function $bc5f567978faddca$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $bc5f567978faddca$var$hl(g);
                f.call(a);
            };
        }
        var g = $bc5f567978faddca$var$fl(b, d, a, 0, null, !1, !1, "", $bc5f567978faddca$var$ql);
        a._reactRootContainer = g;
        a[$bc5f567978faddca$var$uf] = g.current;
        $bc5f567978faddca$var$sf(8 === a.nodeType ? a.parentNode : a);
        $bc5f567978faddca$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $bc5f567978faddca$var$hl(k);
            h.call(a);
        };
    }
    var k = $bc5f567978faddca$var$cl(a, 0, !1, null, null, !1, !1, "", $bc5f567978faddca$var$ql);
    a._reactRootContainer = k;
    a[$bc5f567978faddca$var$uf] = k.current;
    $bc5f567978faddca$var$sf(8 === a.nodeType ? a.parentNode : a);
    $bc5f567978faddca$var$Sk(function() {
        $bc5f567978faddca$var$gl(b, k, c, d);
    });
    return k;
}
function $bc5f567978faddca$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $bc5f567978faddca$var$hl(g);
                h.call(a);
            };
        }
        $bc5f567978faddca$var$gl(b, g, a, e);
    } else g = $bc5f567978faddca$var$rl(c, b, a, e, d);
    return $bc5f567978faddca$var$hl(g);
}
$bc5f567978faddca$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $bc5f567978faddca$var$tc(b.pendingLanes);
                0 !== c && ($bc5f567978faddca$var$Cc(b, c | 1), $bc5f567978faddca$var$Ek(b, $bc5f567978faddca$var$B()), 0 === ($bc5f567978faddca$var$K & 6) && ($bc5f567978faddca$var$Hj = $bc5f567978faddca$var$B() + 500, $bc5f567978faddca$var$jg()));
            }
            break;
        case 13:
            $bc5f567978faddca$var$Sk(function() {
                var b = $bc5f567978faddca$var$Zg(a, 1);
                if (null !== b) {
                    var c = $bc5f567978faddca$var$L();
                    $bc5f567978faddca$var$mh(b, a, 1, c);
                }
            }), $bc5f567978faddca$var$jl(a, 1);
    }
};
$bc5f567978faddca$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $bc5f567978faddca$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $bc5f567978faddca$var$L();
            $bc5f567978faddca$var$mh(b, a, 134217728, c);
        }
        $bc5f567978faddca$var$jl(a, 134217728);
    }
};
$bc5f567978faddca$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $bc5f567978faddca$var$lh(a), c = $bc5f567978faddca$var$Zg(a, b);
        if (null !== c) {
            var d = $bc5f567978faddca$var$L();
            $bc5f567978faddca$var$mh(c, a, b, d);
        }
        $bc5f567978faddca$var$jl(a, b);
    }
};
$bc5f567978faddca$var$Hc = function() {
    return $bc5f567978faddca$var$C;
};
$bc5f567978faddca$var$Ic = function(a, b) {
    var c = $bc5f567978faddca$var$C;
    try {
        return $bc5f567978faddca$var$C = a, b();
    } finally{
        $bc5f567978faddca$var$C = c;
    }
};
$bc5f567978faddca$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $bc5f567978faddca$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $bc5f567978faddca$var$Db(d);
                        if (!e) throw Error($bc5f567978faddca$var$p(90));
                        $bc5f567978faddca$var$Wa(d);
                        $bc5f567978faddca$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $bc5f567978faddca$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $bc5f567978faddca$var$fb(a, !!c.multiple, b, !1);
    }
};
$bc5f567978faddca$var$Gb = $bc5f567978faddca$var$Rk;
$bc5f567978faddca$var$Hb = $bc5f567978faddca$var$Sk;
var $bc5f567978faddca$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $bc5f567978faddca$var$Cb,
        $bc5f567978faddca$var$ue,
        $bc5f567978faddca$var$Db,
        $bc5f567978faddca$var$Eb,
        $bc5f567978faddca$var$Fb,
        $bc5f567978faddca$var$Rk
    ]
}, $bc5f567978faddca$var$ul = {
    findFiberByHostInstance: $bc5f567978faddca$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $bc5f567978faddca$var$vl = {
    bundleType: $bc5f567978faddca$var$ul.bundleType,
    version: $bc5f567978faddca$var$ul.version,
    rendererPackageName: $bc5f567978faddca$var$ul.rendererPackageName,
    rendererConfig: $bc5f567978faddca$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $bc5f567978faddca$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $bc5f567978faddca$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $bc5f567978faddca$var$ul.findFiberByHostInstance || $bc5f567978faddca$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $bc5f567978faddca$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$bc5f567978faddca$var$wl.isDisabled && $bc5f567978faddca$var$wl.supportsFiber) try {
        $bc5f567978faddca$var$kc = $bc5f567978faddca$var$wl.inject($bc5f567978faddca$var$vl), $bc5f567978faddca$var$lc = $bc5f567978faddca$var$wl;
    } catch (a) {}
}
$bc5f567978faddca$export$ae55be85d98224ed = $bc5f567978faddca$var$tl;
$bc5f567978faddca$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$bc5f567978faddca$var$ol(b)) throw Error($bc5f567978faddca$var$p(200));
    return $bc5f567978faddca$var$dl(a, b, null, c);
};
$bc5f567978faddca$export$882461b6382ed46c = function(a, b) {
    if (!$bc5f567978faddca$var$ol(a)) throw Error($bc5f567978faddca$var$p(299));
    var c = !1, d = "", e = $bc5f567978faddca$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $bc5f567978faddca$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$bc5f567978faddca$var$uf] = b.current;
    $bc5f567978faddca$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $bc5f567978faddca$var$ml(b);
};
$bc5f567978faddca$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($bc5f567978faddca$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($bc5f567978faddca$var$p(268, a));
    }
    a = $bc5f567978faddca$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$bc5f567978faddca$export$cd75ccfd720a3cd4 = function(a) {
    return $bc5f567978faddca$var$Sk(a);
};
$bc5f567978faddca$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$bc5f567978faddca$var$pl(b)) throw Error($bc5f567978faddca$var$p(200));
    return $bc5f567978faddca$var$sl(null, a, b, !0, c);
};
$bc5f567978faddca$export$757ceba2d55c277e = function(a, b, c) {
    if (!$bc5f567978faddca$var$ol(a)) throw Error($bc5f567978faddca$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $bc5f567978faddca$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $bc5f567978faddca$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$bc5f567978faddca$var$uf] = b.current;
    $bc5f567978faddca$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $bc5f567978faddca$var$nl(b);
};
$bc5f567978faddca$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$bc5f567978faddca$var$pl(b)) throw Error($bc5f567978faddca$var$p(200));
    return $bc5f567978faddca$var$sl(null, a, b, !1, c);
};
$bc5f567978faddca$export$502457920280e6be = function(a) {
    if (!$bc5f567978faddca$var$pl(a)) throw Error($bc5f567978faddca$var$p(40));
    return a._reactRootContainer ? ($bc5f567978faddca$var$Sk(function() {
        $bc5f567978faddca$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$bc5f567978faddca$var$uf] = null;
        });
    }), !0) : !1;
};
$bc5f567978faddca$export$c78a37762a8d58e1 = $bc5f567978faddca$var$Rk;
$bc5f567978faddca$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$bc5f567978faddca$var$pl(c)) throw Error($bc5f567978faddca$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($bc5f567978faddca$var$p(38));
    return $bc5f567978faddca$var$sl(a, b, c, !1, d);
};
$bc5f567978faddca$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRequire.register("fxLu7", function(module, exports) {
"use strict";

module.exports = (parcelRequire("k5KFB"));

});
parcelRequire.register("k5KFB", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $ea0879f9e82260fb$export$c4744153514ff05d; }, function (v) { return $ea0879f9e82260fb$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $ea0879f9e82260fb$export$3e506c1ccc9cc1a7; }, function (v) { return $ea0879f9e82260fb$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $ea0879f9e82260fb$export$e26fe2ed2fa76875; }, function (v) { return $ea0879f9e82260fb$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $ea0879f9e82260fb$export$502329bbf4b505b1; }, function (v) { return $ea0879f9e82260fb$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $ea0879f9e82260fb$export$6e3807111c4874c4; }, function (v) { return $ea0879f9e82260fb$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $ea0879f9e82260fb$export$c27134553091fb3a; }, function (v) { return $ea0879f9e82260fb$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $ea0879f9e82260fb$export$33ee1acdc04fd2a2; }, function (v) { return $ea0879f9e82260fb$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $ea0879f9e82260fb$export$b00a404bbd5edef2; }, function (v) { return $ea0879f9e82260fb$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $ea0879f9e82260fb$export$8352ce38b91d0c62; }, function (v) { return $ea0879f9e82260fb$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $ea0879f9e82260fb$export$d66a1c1c77bd778b; }, function (v) { return $ea0879f9e82260fb$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $ea0879f9e82260fb$export$d3dfb8e4810cb555; }, function (v) { return $ea0879f9e82260fb$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $ea0879f9e82260fb$export$839f9183b0465a69; }, function (v) { return $ea0879f9e82260fb$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $ea0879f9e82260fb$export$72fdf0e06517287b; }, function (v) { return $ea0879f9e82260fb$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $ea0879f9e82260fb$export$4b844e58a3e414b4; }, function (v) { return $ea0879f9e82260fb$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $ea0879f9e82260fb$export$816d2913ae6b83b1; }, function (v) { return $ea0879f9e82260fb$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $ea0879f9e82260fb$export$61bcfe829111a1d0; }, function (v) { return $ea0879f9e82260fb$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $ea0879f9e82260fb$export$7ee8c9beb337bc3f; }, function (v) { return $ea0879f9e82260fb$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $ea0879f9e82260fb$export$b5836b71941fa3ed; }, function (v) { return $ea0879f9e82260fb$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $ea0879f9e82260fb$export$cf845f2c119da08a; }, function (v) { return $ea0879f9e82260fb$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $ea0879f9e82260fb$export$c4744153514ff05d;
var $ea0879f9e82260fb$export$3e506c1ccc9cc1a7;
var $ea0879f9e82260fb$export$e26fe2ed2fa76875;
var $ea0879f9e82260fb$export$502329bbf4b505b1;
var $ea0879f9e82260fb$export$6e3807111c4874c4;
var $ea0879f9e82260fb$export$c27134553091fb3a;
var $ea0879f9e82260fb$export$33ee1acdc04fd2a2;
var $ea0879f9e82260fb$export$b00a404bbd5edef2;
var $ea0879f9e82260fb$export$8352ce38b91d0c62;
var $ea0879f9e82260fb$export$d66a1c1c77bd778b;
var $ea0879f9e82260fb$export$d3dfb8e4810cb555;
var $ea0879f9e82260fb$export$839f9183b0465a69;
var $ea0879f9e82260fb$export$72fdf0e06517287b;
var $ea0879f9e82260fb$export$4b844e58a3e414b4;
var $ea0879f9e82260fb$export$816d2913ae6b83b1;
var $ea0879f9e82260fb$export$61bcfe829111a1d0;
var $ea0879f9e82260fb$export$7ee8c9beb337bc3f;
var $ea0879f9e82260fb$export$b5836b71941fa3ed;
var $ea0879f9e82260fb$export$cf845f2c119da08a;
"use strict";
function $ea0879f9e82260fb$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $ea0879f9e82260fb$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $ea0879f9e82260fb$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $ea0879f9e82260fb$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $ea0879f9e82260fb$var$g(C, c)) n < e && 0 > $ea0879f9e82260fb$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $ea0879f9e82260fb$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $ea0879f9e82260fb$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $ea0879f9e82260fb$var$l = performance;
    $ea0879f9e82260fb$export$c4744153514ff05d = function() {
        return $ea0879f9e82260fb$var$l.now();
    };
} else {
    var $ea0879f9e82260fb$var$p = Date, $ea0879f9e82260fb$var$q = $ea0879f9e82260fb$var$p.now();
    $ea0879f9e82260fb$export$c4744153514ff05d = function() {
        return $ea0879f9e82260fb$var$p.now() - $ea0879f9e82260fb$var$q;
    };
}
var $ea0879f9e82260fb$var$r = [], $ea0879f9e82260fb$var$t = [], $ea0879f9e82260fb$var$u = 1, $ea0879f9e82260fb$var$v = null, $ea0879f9e82260fb$var$y = 3, $ea0879f9e82260fb$var$z = !1, $ea0879f9e82260fb$var$A = !1, $ea0879f9e82260fb$var$B = !1, $ea0879f9e82260fb$var$D = "function" === typeof setTimeout ? setTimeout : null, $ea0879f9e82260fb$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $ea0879f9e82260fb$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $ea0879f9e82260fb$var$G(a) {
    for(var b = $ea0879f9e82260fb$var$h($ea0879f9e82260fb$var$t); null !== b;){
        if (null === b.callback) $ea0879f9e82260fb$var$k($ea0879f9e82260fb$var$t);
        else if (b.startTime <= a) $ea0879f9e82260fb$var$k($ea0879f9e82260fb$var$t), b.sortIndex = b.expirationTime, $ea0879f9e82260fb$var$f($ea0879f9e82260fb$var$r, b);
        else break;
        b = $ea0879f9e82260fb$var$h($ea0879f9e82260fb$var$t);
    }
}
function $ea0879f9e82260fb$var$H(a) {
    $ea0879f9e82260fb$var$B = !1;
    $ea0879f9e82260fb$var$G(a);
    if (!$ea0879f9e82260fb$var$A) {
        if (null !== $ea0879f9e82260fb$var$h($ea0879f9e82260fb$var$r)) $ea0879f9e82260fb$var$A = !0, $ea0879f9e82260fb$var$I($ea0879f9e82260fb$var$J);
        else {
            var b = $ea0879f9e82260fb$var$h($ea0879f9e82260fb$var$t);
            null !== b && $ea0879f9e82260fb$var$K($ea0879f9e82260fb$var$H, b.startTime - a);
        }
    }
}
function $ea0879f9e82260fb$var$J(a, b) {
    $ea0879f9e82260fb$var$A = !1;
    $ea0879f9e82260fb$var$B && ($ea0879f9e82260fb$var$B = !1, $ea0879f9e82260fb$var$E($ea0879f9e82260fb$var$L), $ea0879f9e82260fb$var$L = -1);
    $ea0879f9e82260fb$var$z = !0;
    var c = $ea0879f9e82260fb$var$y;
    try {
        $ea0879f9e82260fb$var$G(b);
        for($ea0879f9e82260fb$var$v = $ea0879f9e82260fb$var$h($ea0879f9e82260fb$var$r); null !== $ea0879f9e82260fb$var$v && (!($ea0879f9e82260fb$var$v.expirationTime > b) || a && !$ea0879f9e82260fb$var$M());){
            var d = $ea0879f9e82260fb$var$v.callback;
            if ("function" === typeof d) {
                $ea0879f9e82260fb$var$v.callback = null;
                $ea0879f9e82260fb$var$y = $ea0879f9e82260fb$var$v.priorityLevel;
                var e = d($ea0879f9e82260fb$var$v.expirationTime <= b);
                b = $ea0879f9e82260fb$export$c4744153514ff05d();
                "function" === typeof e ? $ea0879f9e82260fb$var$v.callback = e : $ea0879f9e82260fb$var$v === $ea0879f9e82260fb$var$h($ea0879f9e82260fb$var$r) && $ea0879f9e82260fb$var$k($ea0879f9e82260fb$var$r);
                $ea0879f9e82260fb$var$G(b);
            } else $ea0879f9e82260fb$var$k($ea0879f9e82260fb$var$r);
            $ea0879f9e82260fb$var$v = $ea0879f9e82260fb$var$h($ea0879f9e82260fb$var$r);
        }
        if (null !== $ea0879f9e82260fb$var$v) var w = !0;
        else {
            var m = $ea0879f9e82260fb$var$h($ea0879f9e82260fb$var$t);
            null !== m && $ea0879f9e82260fb$var$K($ea0879f9e82260fb$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $ea0879f9e82260fb$var$v = null, $ea0879f9e82260fb$var$y = c, $ea0879f9e82260fb$var$z = !1;
    }
}
var $ea0879f9e82260fb$var$N = !1, $ea0879f9e82260fb$var$O = null, $ea0879f9e82260fb$var$L = -1, $ea0879f9e82260fb$var$P = 5, $ea0879f9e82260fb$var$Q = -1;
function $ea0879f9e82260fb$var$M() {
    return $ea0879f9e82260fb$export$c4744153514ff05d() - $ea0879f9e82260fb$var$Q < $ea0879f9e82260fb$var$P ? !1 : !0;
}
function $ea0879f9e82260fb$var$R() {
    if (null !== $ea0879f9e82260fb$var$O) {
        var a = $ea0879f9e82260fb$export$c4744153514ff05d();
        $ea0879f9e82260fb$var$Q = a;
        var b = !0;
        try {
            b = $ea0879f9e82260fb$var$O(!0, a);
        } finally{
            b ? $ea0879f9e82260fb$var$S() : ($ea0879f9e82260fb$var$N = !1, $ea0879f9e82260fb$var$O = null);
        }
    } else $ea0879f9e82260fb$var$N = !1;
}
var $ea0879f9e82260fb$var$S;
if ("function" === typeof $ea0879f9e82260fb$var$F) $ea0879f9e82260fb$var$S = function() {
    $ea0879f9e82260fb$var$F($ea0879f9e82260fb$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $ea0879f9e82260fb$var$T = new MessageChannel, $ea0879f9e82260fb$var$U = $ea0879f9e82260fb$var$T.port2;
    $ea0879f9e82260fb$var$T.port1.onmessage = $ea0879f9e82260fb$var$R;
    $ea0879f9e82260fb$var$S = function() {
        $ea0879f9e82260fb$var$U.postMessage(null);
    };
} else $ea0879f9e82260fb$var$S = function() {
    $ea0879f9e82260fb$var$D($ea0879f9e82260fb$var$R, 0);
};
function $ea0879f9e82260fb$var$I(a) {
    $ea0879f9e82260fb$var$O = a;
    $ea0879f9e82260fb$var$N || ($ea0879f9e82260fb$var$N = !0, $ea0879f9e82260fb$var$S());
}
function $ea0879f9e82260fb$var$K(a, b) {
    $ea0879f9e82260fb$var$L = $ea0879f9e82260fb$var$D(function() {
        a($ea0879f9e82260fb$export$c4744153514ff05d());
    }, b);
}
$ea0879f9e82260fb$export$3e506c1ccc9cc1a7 = 5;
$ea0879f9e82260fb$export$e26fe2ed2fa76875 = 1;
$ea0879f9e82260fb$export$502329bbf4b505b1 = 4;
$ea0879f9e82260fb$export$6e3807111c4874c4 = 3;
$ea0879f9e82260fb$export$c27134553091fb3a = null;
$ea0879f9e82260fb$export$33ee1acdc04fd2a2 = 2;
$ea0879f9e82260fb$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$ea0879f9e82260fb$export$8352ce38b91d0c62 = function() {
    $ea0879f9e82260fb$var$A || $ea0879f9e82260fb$var$z || ($ea0879f9e82260fb$var$A = !0, $ea0879f9e82260fb$var$I($ea0879f9e82260fb$var$J));
};
$ea0879f9e82260fb$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $ea0879f9e82260fb$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$ea0879f9e82260fb$export$d3dfb8e4810cb555 = function() {
    return $ea0879f9e82260fb$var$y;
};
$ea0879f9e82260fb$export$839f9183b0465a69 = function() {
    return $ea0879f9e82260fb$var$h($ea0879f9e82260fb$var$r);
};
$ea0879f9e82260fb$export$72fdf0e06517287b = function(a) {
    switch($ea0879f9e82260fb$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $ea0879f9e82260fb$var$y;
    }
    var c = $ea0879f9e82260fb$var$y;
    $ea0879f9e82260fb$var$y = b;
    try {
        return a();
    } finally{
        $ea0879f9e82260fb$var$y = c;
    }
};
$ea0879f9e82260fb$export$4b844e58a3e414b4 = function() {};
$ea0879f9e82260fb$export$816d2913ae6b83b1 = function() {};
$ea0879f9e82260fb$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $ea0879f9e82260fb$var$y;
    $ea0879f9e82260fb$var$y = a;
    try {
        return b();
    } finally{
        $ea0879f9e82260fb$var$y = c;
    }
};
$ea0879f9e82260fb$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $ea0879f9e82260fb$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $ea0879f9e82260fb$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $ea0879f9e82260fb$var$f($ea0879f9e82260fb$var$t, a), null === $ea0879f9e82260fb$var$h($ea0879f9e82260fb$var$r) && a === $ea0879f9e82260fb$var$h($ea0879f9e82260fb$var$t) && ($ea0879f9e82260fb$var$B ? ($ea0879f9e82260fb$var$E($ea0879f9e82260fb$var$L), $ea0879f9e82260fb$var$L = -1) : $ea0879f9e82260fb$var$B = !0, $ea0879f9e82260fb$var$K($ea0879f9e82260fb$var$H, c - d))) : (a.sortIndex = e, $ea0879f9e82260fb$var$f($ea0879f9e82260fb$var$r, a), $ea0879f9e82260fb$var$A || $ea0879f9e82260fb$var$z || ($ea0879f9e82260fb$var$A = !0, $ea0879f9e82260fb$var$I($ea0879f9e82260fb$var$J)));
    return a;
};
$ea0879f9e82260fb$export$b5836b71941fa3ed = $ea0879f9e82260fb$var$M;
$ea0879f9e82260fb$export$cf845f2c119da08a = function(a) {
    var b = $ea0879f9e82260fb$var$y;
    return function() {
        var c = $ea0879f9e82260fb$var$y;
        $ea0879f9e82260fb$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $ea0879f9e82260fb$var$y = c;
        }
    };
};

});



parcelRequire.register("lJpQh", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $vtwyg = parcelRequire("vtwyg");
function $fd21d8a7aca9ca69$var$emptyFunction() {}
function $fd21d8a7aca9ca69$var$emptyFunctionWithReset() {}
$fd21d8a7aca9ca69$var$emptyFunctionWithReset.resetWarningCache = $fd21d8a7aca9ca69$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $vtwyg) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $fd21d8a7aca9ca69$var$emptyFunctionWithReset,
        resetWarningCache: $fd21d8a7aca9ca69$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRequire.register("vtwyg", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $05e9cc38adc5be63$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $05e9cc38adc5be63$var$ReactPropTypesSecret;

});


parcelRequire.register("caLJN", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $8dcb72e37864127e$export$306c0aa65ff9ec16; }, function (v) { return $8dcb72e37864127e$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8dcb72e37864127e$export$306c0aa65ff9ec16;
"use strict";

var $aivMx = parcelRequire("aivMx");
function $8dcb72e37864127e$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $8dcb72e37864127e$var$k = "function" === typeof Object.is ? Object.is : $8dcb72e37864127e$var$h, $8dcb72e37864127e$var$l = $aivMx.useState, $8dcb72e37864127e$var$m = $aivMx.useEffect, $8dcb72e37864127e$var$n = $aivMx.useLayoutEffect, $8dcb72e37864127e$var$p = $aivMx.useDebugValue;
function $8dcb72e37864127e$var$q(a, b) {
    var d = b(), f = $8dcb72e37864127e$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $8dcb72e37864127e$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $8dcb72e37864127e$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $8dcb72e37864127e$var$m(function() {
        $8dcb72e37864127e$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $8dcb72e37864127e$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $8dcb72e37864127e$var$p(d);
    return d;
}
function $8dcb72e37864127e$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$8dcb72e37864127e$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $8dcb72e37864127e$var$t(a, b) {
    return b();
}
var $8dcb72e37864127e$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $8dcb72e37864127e$var$t : $8dcb72e37864127e$var$q;
$8dcb72e37864127e$export$306c0aa65ff9ec16 = void 0 !== $aivMx.useSyncExternalStore ? $aivMx.useSyncExternalStore : $8dcb72e37864127e$var$u;

});

parcelRequire.register("jh9FG", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $e0871b59c164ca32$export$bf730a2d8bf68b42; }, function (v) { return $e0871b59c164ca32$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e0871b59c164ca32$export$bf730a2d8bf68b42;
"use strict";

var $aivMx = parcelRequire("aivMx");

var $5MEMe = parcelRequire("5MEMe");
function $e0871b59c164ca32$var$p(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $e0871b59c164ca32$var$q = "function" === typeof Object.is ? Object.is : $e0871b59c164ca32$var$p, $e0871b59c164ca32$var$r = $5MEMe.useSyncExternalStore, $e0871b59c164ca32$var$t = $aivMx.useRef, $e0871b59c164ca32$var$u = $aivMx.useEffect, $e0871b59c164ca32$var$v = $aivMx.useMemo, $e0871b59c164ca32$var$w = $aivMx.useDebugValue;
$e0871b59c164ca32$export$bf730a2d8bf68b42 = function(a, b, e, l, g) {
    var c = $e0871b59c164ca32$var$t(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $e0871b59c164ca32$var$v(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== g && f.hasValue) {
                    var b = f.value;
                    if (g(b, a)) return k = b;
                }
                return k = a;
            }
            b = k;
            if ($e0871b59c164ca32$var$q(d, a)) return b;
            var e = l(a);
            if (void 0 !== g && g(b, e)) return b;
            d = a;
            return k = e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        g
    ]);
    var d = $e0871b59c164ca32$var$r(a, c[0], c[1]);
    $e0871b59c164ca32$var$u(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $e0871b59c164ca32$var$w(d);
    return d;
};

});
parcelRequire.register("5MEMe", function(module, exports) {
"use strict";

module.exports = (parcelRequire("caLJN"));

});


parcelRequire.register("A9JWB", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $06caeb137d83ef6a$export$2b8d127b894957b9; }, function (v) { return $06caeb137d83ef6a$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $06caeb137d83ef6a$export$cea3a54a6425200c; }, function (v) { return $06caeb137d83ef6a$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $06caeb137d83ef6a$export$a7c73072b1a182ae; }, function (v) { return $06caeb137d83ef6a$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $06caeb137d83ef6a$export$9f27bc3417b4524d; }, function (v) { return $06caeb137d83ef6a$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $06caeb137d83ef6a$export$db77ccec0bb4ccac; }, function (v) { return $06caeb137d83ef6a$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $06caeb137d83ef6a$export$8392c0c9d3dcbd35; }, function (v) { return $06caeb137d83ef6a$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $06caeb137d83ef6a$export$ffb0004e005737fa; }, function (v) { return $06caeb137d83ef6a$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $06caeb137d83ef6a$export$b624eff549462981; }, function (v) { return $06caeb137d83ef6a$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $06caeb137d83ef6a$export$7897aa7841a5380c; }, function (v) { return $06caeb137d83ef6a$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $06caeb137d83ef6a$export$602eac185826482c; }, function (v) { return $06caeb137d83ef6a$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $06caeb137d83ef6a$export$e2c29f18771995cb; }, function (v) { return $06caeb137d83ef6a$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $06caeb137d83ef6a$export$5f8d39834fd61797; }, function (v) { return $06caeb137d83ef6a$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $06caeb137d83ef6a$export$74bf444e3cd11ea5; }, function (v) { return $06caeb137d83ef6a$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $06caeb137d83ef6a$export$92387174baf9b227; }, function (v) { return $06caeb137d83ef6a$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $06caeb137d83ef6a$export$ec112efeb987d9c6; }, function (v) { return $06caeb137d83ef6a$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $06caeb137d83ef6a$export$b706b080d889d2c9; }, function (v) { return $06caeb137d83ef6a$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $06caeb137d83ef6a$export$5be5a87408f70ddc; }, function (v) { return $06caeb137d83ef6a$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $06caeb137d83ef6a$export$45a5e7f76e0caa8d; }, function (v) { return $06caeb137d83ef6a$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $06caeb137d83ef6a$export$455c2e768291efa6; }, function (v) { return $06caeb137d83ef6a$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $06caeb137d83ef6a$export$9522e17588c12572; }, function (v) { return $06caeb137d83ef6a$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $06caeb137d83ef6a$export$2110ac352bb060b9; }, function (v) { return $06caeb137d83ef6a$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $06caeb137d83ef6a$export$56885ab8b9c456ab; }, function (v) { return $06caeb137d83ef6a$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $06caeb137d83ef6a$export$d927fcb6adf8f9de; }, function (v) { return $06caeb137d83ef6a$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $06caeb137d83ef6a$export$b82d16f27459e05a; }, function (v) { return $06caeb137d83ef6a$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $06caeb137d83ef6a$export$522c17b4f5e123e8; }, function (v) { return $06caeb137d83ef6a$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $06caeb137d83ef6a$export$1aabd8a0274ecfd6; }, function (v) { return $06caeb137d83ef6a$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $06caeb137d83ef6a$export$9b621391a187a31a; }, function (v) { return $06caeb137d83ef6a$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $06caeb137d83ef6a$export$f5bbd400c2f4426f; }, function (v) { return $06caeb137d83ef6a$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $06caeb137d83ef6a$export$2b8d127b894957b9;
var $06caeb137d83ef6a$export$cea3a54a6425200c;
var $06caeb137d83ef6a$export$a7c73072b1a182ae;
var $06caeb137d83ef6a$export$9f27bc3417b4524d;
var $06caeb137d83ef6a$export$db77ccec0bb4ccac;
var $06caeb137d83ef6a$export$8392c0c9d3dcbd35;
var $06caeb137d83ef6a$export$ffb0004e005737fa;
var $06caeb137d83ef6a$export$b624eff549462981;
var $06caeb137d83ef6a$export$7897aa7841a5380c;
var $06caeb137d83ef6a$export$602eac185826482c;
var $06caeb137d83ef6a$export$e2c29f18771995cb;
var $06caeb137d83ef6a$export$5f8d39834fd61797;
var $06caeb137d83ef6a$export$74bf444e3cd11ea5;
var $06caeb137d83ef6a$export$92387174baf9b227;
var $06caeb137d83ef6a$export$ec112efeb987d9c6;
var $06caeb137d83ef6a$export$b706b080d889d2c9;
var $06caeb137d83ef6a$export$5be5a87408f70ddc;
var $06caeb137d83ef6a$export$45a5e7f76e0caa8d;
var $06caeb137d83ef6a$export$455c2e768291efa6;
var $06caeb137d83ef6a$export$9522e17588c12572;
var $06caeb137d83ef6a$export$2110ac352bb060b9;
var $06caeb137d83ef6a$export$56885ab8b9c456ab;
var $06caeb137d83ef6a$export$d927fcb6adf8f9de;
var $06caeb137d83ef6a$export$b82d16f27459e05a;
var $06caeb137d83ef6a$export$522c17b4f5e123e8;
var $06caeb137d83ef6a$export$1aabd8a0274ecfd6;
var $06caeb137d83ef6a$export$9b621391a187a31a;
var $06caeb137d83ef6a$export$f5bbd400c2f4426f;
"use strict";
var $06caeb137d83ef6a$var$b = "function" === typeof Symbol && Symbol.for, $06caeb137d83ef6a$var$c = $06caeb137d83ef6a$var$b ? Symbol.for("react.element") : 60103, $06caeb137d83ef6a$var$d = $06caeb137d83ef6a$var$b ? Symbol.for("react.portal") : 60106, $06caeb137d83ef6a$var$e = $06caeb137d83ef6a$var$b ? Symbol.for("react.fragment") : 60107, $06caeb137d83ef6a$var$f = $06caeb137d83ef6a$var$b ? Symbol.for("react.strict_mode") : 60108, $06caeb137d83ef6a$var$g = $06caeb137d83ef6a$var$b ? Symbol.for("react.profiler") : 60114, $06caeb137d83ef6a$var$h = $06caeb137d83ef6a$var$b ? Symbol.for("react.provider") : 60109, $06caeb137d83ef6a$var$k = $06caeb137d83ef6a$var$b ? Symbol.for("react.context") : 60110, $06caeb137d83ef6a$var$l = $06caeb137d83ef6a$var$b ? Symbol.for("react.async_mode") : 60111, $06caeb137d83ef6a$var$m = $06caeb137d83ef6a$var$b ? Symbol.for("react.concurrent_mode") : 60111, $06caeb137d83ef6a$var$n = $06caeb137d83ef6a$var$b ? Symbol.for("react.forward_ref") : 60112, $06caeb137d83ef6a$var$p = $06caeb137d83ef6a$var$b ? Symbol.for("react.suspense") : 60113, $06caeb137d83ef6a$var$q = $06caeb137d83ef6a$var$b ? Symbol.for("react.suspense_list") : 60120, $06caeb137d83ef6a$var$r = $06caeb137d83ef6a$var$b ? Symbol.for("react.memo") : 60115, $06caeb137d83ef6a$var$t = $06caeb137d83ef6a$var$b ? Symbol.for("react.lazy") : 60116, $06caeb137d83ef6a$var$v = $06caeb137d83ef6a$var$b ? Symbol.for("react.block") : 60121, $06caeb137d83ef6a$var$w = $06caeb137d83ef6a$var$b ? Symbol.for("react.fundamental") : 60117, $06caeb137d83ef6a$var$x = $06caeb137d83ef6a$var$b ? Symbol.for("react.responder") : 60118, $06caeb137d83ef6a$var$y = $06caeb137d83ef6a$var$b ? Symbol.for("react.scope") : 60119;
function $06caeb137d83ef6a$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $06caeb137d83ef6a$var$c:
                switch(a = a.type, a){
                    case $06caeb137d83ef6a$var$l:
                    case $06caeb137d83ef6a$var$m:
                    case $06caeb137d83ef6a$var$e:
                    case $06caeb137d83ef6a$var$g:
                    case $06caeb137d83ef6a$var$f:
                    case $06caeb137d83ef6a$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $06caeb137d83ef6a$var$k:
                            case $06caeb137d83ef6a$var$n:
                            case $06caeb137d83ef6a$var$t:
                            case $06caeb137d83ef6a$var$r:
                            case $06caeb137d83ef6a$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $06caeb137d83ef6a$var$d:
                return u;
        }
    }
}
function $06caeb137d83ef6a$var$A(a) {
    return $06caeb137d83ef6a$var$z(a) === $06caeb137d83ef6a$var$m;
}
$06caeb137d83ef6a$export$2b8d127b894957b9 = $06caeb137d83ef6a$var$l;
$06caeb137d83ef6a$export$cea3a54a6425200c = $06caeb137d83ef6a$var$m;
$06caeb137d83ef6a$export$a7c73072b1a182ae = $06caeb137d83ef6a$var$k;
$06caeb137d83ef6a$export$9f27bc3417b4524d = $06caeb137d83ef6a$var$h;
$06caeb137d83ef6a$export$db77ccec0bb4ccac = $06caeb137d83ef6a$var$c;
$06caeb137d83ef6a$export$8392c0c9d3dcbd35 = $06caeb137d83ef6a$var$n;
$06caeb137d83ef6a$export$ffb0004e005737fa = $06caeb137d83ef6a$var$e;
$06caeb137d83ef6a$export$b624eff549462981 = $06caeb137d83ef6a$var$t;
$06caeb137d83ef6a$export$7897aa7841a5380c = $06caeb137d83ef6a$var$r;
$06caeb137d83ef6a$export$602eac185826482c = $06caeb137d83ef6a$var$d;
$06caeb137d83ef6a$export$e2c29f18771995cb = $06caeb137d83ef6a$var$g;
$06caeb137d83ef6a$export$5f8d39834fd61797 = $06caeb137d83ef6a$var$f;
$06caeb137d83ef6a$export$74bf444e3cd11ea5 = $06caeb137d83ef6a$var$p;
$06caeb137d83ef6a$export$92387174baf9b227 = function(a) {
    return $06caeb137d83ef6a$var$A(a) || $06caeb137d83ef6a$var$z(a) === $06caeb137d83ef6a$var$l;
};
$06caeb137d83ef6a$export$ec112efeb987d9c6 = $06caeb137d83ef6a$var$A;
$06caeb137d83ef6a$export$b706b080d889d2c9 = function(a) {
    return $06caeb137d83ef6a$var$z(a) === $06caeb137d83ef6a$var$k;
};
$06caeb137d83ef6a$export$5be5a87408f70ddc = function(a) {
    return $06caeb137d83ef6a$var$z(a) === $06caeb137d83ef6a$var$h;
};
$06caeb137d83ef6a$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $06caeb137d83ef6a$var$c;
};
$06caeb137d83ef6a$export$455c2e768291efa6 = function(a) {
    return $06caeb137d83ef6a$var$z(a) === $06caeb137d83ef6a$var$n;
};
$06caeb137d83ef6a$export$9522e17588c12572 = function(a) {
    return $06caeb137d83ef6a$var$z(a) === $06caeb137d83ef6a$var$e;
};
$06caeb137d83ef6a$export$2110ac352bb060b9 = function(a) {
    return $06caeb137d83ef6a$var$z(a) === $06caeb137d83ef6a$var$t;
};
$06caeb137d83ef6a$export$56885ab8b9c456ab = function(a) {
    return $06caeb137d83ef6a$var$z(a) === $06caeb137d83ef6a$var$r;
};
$06caeb137d83ef6a$export$d927fcb6adf8f9de = function(a) {
    return $06caeb137d83ef6a$var$z(a) === $06caeb137d83ef6a$var$d;
};
$06caeb137d83ef6a$export$b82d16f27459e05a = function(a) {
    return $06caeb137d83ef6a$var$z(a) === $06caeb137d83ef6a$var$g;
};
$06caeb137d83ef6a$export$522c17b4f5e123e8 = function(a) {
    return $06caeb137d83ef6a$var$z(a) === $06caeb137d83ef6a$var$f;
};
$06caeb137d83ef6a$export$1aabd8a0274ecfd6 = function(a) {
    return $06caeb137d83ef6a$var$z(a) === $06caeb137d83ef6a$var$p;
};
$06caeb137d83ef6a$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $06caeb137d83ef6a$var$e || a === $06caeb137d83ef6a$var$m || a === $06caeb137d83ef6a$var$g || a === $06caeb137d83ef6a$var$f || a === $06caeb137d83ef6a$var$p || a === $06caeb137d83ef6a$var$q || "object" === typeof a && null !== a && (a.$$typeof === $06caeb137d83ef6a$var$t || a.$$typeof === $06caeb137d83ef6a$var$r || a.$$typeof === $06caeb137d83ef6a$var$h || a.$$typeof === $06caeb137d83ef6a$var$k || a.$$typeof === $06caeb137d83ef6a$var$n || a.$$typeof === $06caeb137d83ef6a$var$w || a.$$typeof === $06caeb137d83ef6a$var$x || a.$$typeof === $06caeb137d83ef6a$var$y || a.$$typeof === $06caeb137d83ef6a$var$v);
};
$06caeb137d83ef6a$export$f5bbd400c2f4426f = $06caeb137d83ef6a$var$z;

});

parcelRequire.register("hSPEQ", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $d04f8cf7e9864647$export$a7c73072b1a182ae; }, function (v) { return $d04f8cf7e9864647$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $d04f8cf7e9864647$export$9f27bc3417b4524d; }, function (v) { return $d04f8cf7e9864647$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $d04f8cf7e9864647$export$db77ccec0bb4ccac; }, function (v) { return $d04f8cf7e9864647$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $d04f8cf7e9864647$export$8392c0c9d3dcbd35; }, function (v) { return $d04f8cf7e9864647$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $d04f8cf7e9864647$export$ffb0004e005737fa; }, function (v) { return $d04f8cf7e9864647$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $d04f8cf7e9864647$export$b624eff549462981; }, function (v) { return $d04f8cf7e9864647$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $d04f8cf7e9864647$export$7897aa7841a5380c; }, function (v) { return $d04f8cf7e9864647$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $d04f8cf7e9864647$export$602eac185826482c; }, function (v) { return $d04f8cf7e9864647$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $d04f8cf7e9864647$export$e2c29f18771995cb; }, function (v) { return $d04f8cf7e9864647$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $d04f8cf7e9864647$export$5f8d39834fd61797; }, function (v) { return $d04f8cf7e9864647$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $d04f8cf7e9864647$export$74bf444e3cd11ea5; }, function (v) { return $d04f8cf7e9864647$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $d04f8cf7e9864647$export$998bcd577473dd93; }, function (v) { return $d04f8cf7e9864647$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $d04f8cf7e9864647$export$92387174baf9b227; }, function (v) { return $d04f8cf7e9864647$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $d04f8cf7e9864647$export$ec112efeb987d9c6; }, function (v) { return $d04f8cf7e9864647$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $d04f8cf7e9864647$export$b706b080d889d2c9; }, function (v) { return $d04f8cf7e9864647$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $d04f8cf7e9864647$export$5be5a87408f70ddc; }, function (v) { return $d04f8cf7e9864647$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $d04f8cf7e9864647$export$45a5e7f76e0caa8d; }, function (v) { return $d04f8cf7e9864647$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $d04f8cf7e9864647$export$455c2e768291efa6; }, function (v) { return $d04f8cf7e9864647$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $d04f8cf7e9864647$export$9522e17588c12572; }, function (v) { return $d04f8cf7e9864647$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $d04f8cf7e9864647$export$2110ac352bb060b9; }, function (v) { return $d04f8cf7e9864647$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $d04f8cf7e9864647$export$56885ab8b9c456ab; }, function (v) { return $d04f8cf7e9864647$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $d04f8cf7e9864647$export$d927fcb6adf8f9de; }, function (v) { return $d04f8cf7e9864647$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $d04f8cf7e9864647$export$b82d16f27459e05a; }, function (v) { return $d04f8cf7e9864647$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $d04f8cf7e9864647$export$522c17b4f5e123e8; }, function (v) { return $d04f8cf7e9864647$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $d04f8cf7e9864647$export$1aabd8a0274ecfd6; }, function (v) { return $d04f8cf7e9864647$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $d04f8cf7e9864647$export$3d6c20d97e46b957; }, function (v) { return $d04f8cf7e9864647$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $d04f8cf7e9864647$export$9b621391a187a31a; }, function (v) { return $d04f8cf7e9864647$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $d04f8cf7e9864647$export$f5bbd400c2f4426f; }, function (v) { return $d04f8cf7e9864647$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d04f8cf7e9864647$export$a7c73072b1a182ae;
var $d04f8cf7e9864647$export$9f27bc3417b4524d;
var $d04f8cf7e9864647$export$db77ccec0bb4ccac;
var $d04f8cf7e9864647$export$8392c0c9d3dcbd35;
var $d04f8cf7e9864647$export$ffb0004e005737fa;
var $d04f8cf7e9864647$export$b624eff549462981;
var $d04f8cf7e9864647$export$7897aa7841a5380c;
var $d04f8cf7e9864647$export$602eac185826482c;
var $d04f8cf7e9864647$export$e2c29f18771995cb;
var $d04f8cf7e9864647$export$5f8d39834fd61797;
var $d04f8cf7e9864647$export$74bf444e3cd11ea5;
var $d04f8cf7e9864647$export$998bcd577473dd93;
var $d04f8cf7e9864647$export$92387174baf9b227;
var $d04f8cf7e9864647$export$ec112efeb987d9c6;
var $d04f8cf7e9864647$export$b706b080d889d2c9;
var $d04f8cf7e9864647$export$5be5a87408f70ddc;
var $d04f8cf7e9864647$export$45a5e7f76e0caa8d;
var $d04f8cf7e9864647$export$455c2e768291efa6;
var $d04f8cf7e9864647$export$9522e17588c12572;
var $d04f8cf7e9864647$export$2110ac352bb060b9;
var $d04f8cf7e9864647$export$56885ab8b9c456ab;
var $d04f8cf7e9864647$export$d927fcb6adf8f9de;
var $d04f8cf7e9864647$export$b82d16f27459e05a;
var $d04f8cf7e9864647$export$522c17b4f5e123e8;
var $d04f8cf7e9864647$export$1aabd8a0274ecfd6;
var $d04f8cf7e9864647$export$3d6c20d97e46b957;
var $d04f8cf7e9864647$export$9b621391a187a31a;
var $d04f8cf7e9864647$export$f5bbd400c2f4426f;
"use strict";
var $d04f8cf7e9864647$var$b = Symbol.for("react.element"), $d04f8cf7e9864647$var$c = Symbol.for("react.portal"), $d04f8cf7e9864647$var$d = Symbol.for("react.fragment"), $d04f8cf7e9864647$var$e = Symbol.for("react.strict_mode"), $d04f8cf7e9864647$var$f = Symbol.for("react.profiler"), $d04f8cf7e9864647$var$g = Symbol.for("react.provider"), $d04f8cf7e9864647$var$h = Symbol.for("react.context"), $d04f8cf7e9864647$var$k = Symbol.for("react.server_context"), $d04f8cf7e9864647$var$l = Symbol.for("react.forward_ref"), $d04f8cf7e9864647$var$m = Symbol.for("react.suspense"), $d04f8cf7e9864647$var$n = Symbol.for("react.suspense_list"), $d04f8cf7e9864647$var$p = Symbol.for("react.memo"), $d04f8cf7e9864647$var$q = Symbol.for("react.lazy"), $d04f8cf7e9864647$var$t = Symbol.for("react.offscreen"), $d04f8cf7e9864647$var$u;
$d04f8cf7e9864647$var$u = Symbol.for("react.module.reference");
function $d04f8cf7e9864647$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $d04f8cf7e9864647$var$b:
                switch(a = a.type, a){
                    case $d04f8cf7e9864647$var$d:
                    case $d04f8cf7e9864647$var$f:
                    case $d04f8cf7e9864647$var$e:
                    case $d04f8cf7e9864647$var$m:
                    case $d04f8cf7e9864647$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $d04f8cf7e9864647$var$k:
                            case $d04f8cf7e9864647$var$h:
                            case $d04f8cf7e9864647$var$l:
                            case $d04f8cf7e9864647$var$q:
                            case $d04f8cf7e9864647$var$p:
                            case $d04f8cf7e9864647$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $d04f8cf7e9864647$var$c:
                return r;
        }
    }
}
$d04f8cf7e9864647$export$a7c73072b1a182ae = $d04f8cf7e9864647$var$h;
$d04f8cf7e9864647$export$9f27bc3417b4524d = $d04f8cf7e9864647$var$g;
$d04f8cf7e9864647$export$db77ccec0bb4ccac = $d04f8cf7e9864647$var$b;
$d04f8cf7e9864647$export$8392c0c9d3dcbd35 = $d04f8cf7e9864647$var$l;
$d04f8cf7e9864647$export$ffb0004e005737fa = $d04f8cf7e9864647$var$d;
$d04f8cf7e9864647$export$b624eff549462981 = $d04f8cf7e9864647$var$q;
$d04f8cf7e9864647$export$7897aa7841a5380c = $d04f8cf7e9864647$var$p;
$d04f8cf7e9864647$export$602eac185826482c = $d04f8cf7e9864647$var$c;
$d04f8cf7e9864647$export$e2c29f18771995cb = $d04f8cf7e9864647$var$f;
$d04f8cf7e9864647$export$5f8d39834fd61797 = $d04f8cf7e9864647$var$e;
$d04f8cf7e9864647$export$74bf444e3cd11ea5 = $d04f8cf7e9864647$var$m;
$d04f8cf7e9864647$export$998bcd577473dd93 = $d04f8cf7e9864647$var$n;
$d04f8cf7e9864647$export$92387174baf9b227 = function() {
    return !1;
};
$d04f8cf7e9864647$export$ec112efeb987d9c6 = function() {
    return !1;
};
$d04f8cf7e9864647$export$b706b080d889d2c9 = function(a) {
    return $d04f8cf7e9864647$var$v(a) === $d04f8cf7e9864647$var$h;
};
$d04f8cf7e9864647$export$5be5a87408f70ddc = function(a) {
    return $d04f8cf7e9864647$var$v(a) === $d04f8cf7e9864647$var$g;
};
$d04f8cf7e9864647$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $d04f8cf7e9864647$var$b;
};
$d04f8cf7e9864647$export$455c2e768291efa6 = function(a) {
    return $d04f8cf7e9864647$var$v(a) === $d04f8cf7e9864647$var$l;
};
$d04f8cf7e9864647$export$9522e17588c12572 = function(a) {
    return $d04f8cf7e9864647$var$v(a) === $d04f8cf7e9864647$var$d;
};
$d04f8cf7e9864647$export$2110ac352bb060b9 = function(a) {
    return $d04f8cf7e9864647$var$v(a) === $d04f8cf7e9864647$var$q;
};
$d04f8cf7e9864647$export$56885ab8b9c456ab = function(a) {
    return $d04f8cf7e9864647$var$v(a) === $d04f8cf7e9864647$var$p;
};
$d04f8cf7e9864647$export$d927fcb6adf8f9de = function(a) {
    return $d04f8cf7e9864647$var$v(a) === $d04f8cf7e9864647$var$c;
};
$d04f8cf7e9864647$export$b82d16f27459e05a = function(a) {
    return $d04f8cf7e9864647$var$v(a) === $d04f8cf7e9864647$var$f;
};
$d04f8cf7e9864647$export$522c17b4f5e123e8 = function(a) {
    return $d04f8cf7e9864647$var$v(a) === $d04f8cf7e9864647$var$e;
};
$d04f8cf7e9864647$export$1aabd8a0274ecfd6 = function(a) {
    return $d04f8cf7e9864647$var$v(a) === $d04f8cf7e9864647$var$m;
};
$d04f8cf7e9864647$export$3d6c20d97e46b957 = function(a) {
    return $d04f8cf7e9864647$var$v(a) === $d04f8cf7e9864647$var$n;
};
$d04f8cf7e9864647$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $d04f8cf7e9864647$var$d || a === $d04f8cf7e9864647$var$f || a === $d04f8cf7e9864647$var$e || a === $d04f8cf7e9864647$var$m || a === $d04f8cf7e9864647$var$n || a === $d04f8cf7e9864647$var$t || "object" === typeof a && null !== a && (a.$$typeof === $d04f8cf7e9864647$var$q || a.$$typeof === $d04f8cf7e9864647$var$p || a.$$typeof === $d04f8cf7e9864647$var$g || a.$$typeof === $d04f8cf7e9864647$var$h || a.$$typeof === $d04f8cf7e9864647$var$l || a.$$typeof === $d04f8cf7e9864647$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$d04f8cf7e9864647$export$f5bbd400c2f4426f = $d04f8cf7e9864647$var$v;

});

parcelRequire.register("j2CB6", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used to compose bitmasks for comparison styles. */ var UNORDERED_COMPARE_FLAG = 1, PARTIAL_COMPARE_FLAG = 2;
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", objectTag = "[object Object]", promiseTag = "[object Promise]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        return freeProcess && freeProcess.binding("util");
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array ? array.length : 0;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != "function") try {
        result = !!(value + "");
    } catch (e) {}
    return result;
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root["__core-js_shared__"];
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var objectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/** Built-in value references. */ var Symbol = root.Symbol, Uint8Array = root.Uint8Array, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, "DataView"), Map = getNative(root, "Map"), Promise = getNative(root, "Promise"), Set = getNative(root, "Set"), WeakMap = getNative(root, "WeakMap"), nativeCreate = getNative(Object, "create");
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) data.push([
        key,
        value
    ]);
    else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.__data__ = {
        "hash": new Hash,
        "map": new (Map || ListCache),
        "string": new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    return getMapData(this, key)["delete"](key);
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    getMapData(this, key).set(key, value);
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values ? values.length : 0;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    this.__data__ = new ListCache(entries);
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    return this.__data__["delete"](key);
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var cache = this.__data__;
    if (cache instanceof ListCache) {
        var pairs = cache.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            return this;
        }
        cache = this.__data__ = new MapCache(pairs);
    }
    cache.set(key, value);
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    // Safari 9 makes `arguments.length` enumerable in strict mode.
    var result = isArray(value) || isArguments(value) ? baseTimes(value.length, String) : [];
    var length = result.length, skipIndexes = !!length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (key == "length" || isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    return objectToString.call(value);
}
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {boolean} [bitmask] The bitmask of comparison flags.
 *  The bitmask may be composed of the following flags:
 *     1 - Unordered comparison
 *     2 - Partial comparison
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, customizer, bitmask, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObject(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
}
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = arrayTag, othTag = arrayTag;
    if (!objIsArr) {
        objTag = getTag(object);
        objTag = objTag == argsTag ? objectTag : objTag;
    }
    if (!othIsArr) {
        othTag = getTag(other);
        othTag = othTag == argsTag ? objectTag : othTag;
    }
    var objIsObj = objTag == objectTag && !isHostObject(object), othIsObj = othTag == objectTag && !isHostObject(other), isSameTag = objTag == othTag;
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, equalFunc, customizer, bitmask, stack) : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
    }
    if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
    var isPartial = bitmask & PARTIAL_COMPARE_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Assume cyclic values are equal.
    var stacked = stack.get(array);
    if (stacked && stack.get(other)) return stacked == other;
    var index = -1, result = true, seen = bitmask & UNORDERED_COMPARE_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!seen.has(othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) return seen.add(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= UNORDERED_COMPARE_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
            stack["delete"](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
    var isPartial = bitmask & PARTIAL_COMPARE_FLAG, objProps = keys(object), objLength = objProps.length, othProps = keys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Assume cyclic values are equal.
    var stacked = stack.get(object);
    if (stacked && stack.get(other)) return stacked == other;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = objectToString.call(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : undefined;
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == "number" || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ function isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return isArrayLikeObject(value) && hasOwnProperty.call(value, "callee") && (!propertyIsEnumerable.call(value, "callee") || objectToString.call(value) == argsTag);
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
/**
 * This method is like `_.isEqual` except that it accepts `customizer` which
 * is invoked to compare values. If `customizer` returns `undefined`, comparisons
 * are handled by the method instead. The `customizer` is invoked with up to
 * six arguments: (objValue, othValue [, index|key, object, other, stack]).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * function isGreeting(value) {
 *   return /^h(?:i|ello)$/.test(value);
 * }
 *
 * function customizer(objValue, othValue) {
 *   if (isGreeting(objValue) && isGreeting(othValue)) {
 *     return true;
 *   }
 * }
 *
 * var array = ['hello', 'goodbye'];
 * var other = ['hi', 'goodbye'];
 *
 * _.isEqualWith(array, other, customizer);
 * // => true
 */ function isEqualWith(value, other, customizer) {
    customizer = typeof customizer == "function" ? customizer : undefined;
    var result = customizer ? customizer(value, other) : undefined;
    return result === undefined ? baseIsEqual(value, other, customizer) : !!result;
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = isObject(value) ? objectToString.call(value) : "";
    return tag == funcTag || tag == genTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
module.exports = isEqualWith;

});

parcelRequire.register("94WEq", function(module, exports) {
/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root["__core-js_shared__"];
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object);
/** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, Symbol = root.Symbol, Uint8Array = root.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object.getPrototypeOf, Object), objectCreate = Object.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
var defineProperty = function() {
    try {
        var func = getNative(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeMax = Math.max, nativeNow = Date.now;
/* Built-in method references that are verified to be native. */ var Map = getNative(root, "Map"), nativeCreate = getNative(Object, "create");
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!isObject(proto)) return {};
        if (objectCreate) return objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new Hash,
        "map": new (Map || ListCache),
        "string": new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignMergeValue(object, key, value) {
    if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
}
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function baseAssignValue(object, key, value) {
    if (key == "__proto__" && defineProperty) defineProperty(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var baseFor = createBaseFor();
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeysIn(object) {
    if (!isObject(object)) return nativeKeysIn(object);
    var isProto = isPrototype(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            assignMergeValue(object, key, newValue);
        }
    }, keysIn);
}
/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if (isArray(objValue)) newValue = objValue;
            else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = cloneBuffer(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = cloneTypedArray(srcValue, true);
            } else newValue = [];
        } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
            newValue = objValue;
            if (isArguments(objValue)) newValue = toPlainObject(objValue);
            else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack["delete"](srcValue);
    }
    assignMergeValue(object, key, newValue);
}
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function baseRest(func, start) {
    return setToString(overRest(func, start, identity), func + "");
}
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var baseSetToString = !defineProperty ? identity : function(func, string) {
    return defineProperty(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": constant(string),
        "writable": true
    });
};
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array(result).set(new Uint8Array(arrayBuffer));
    return result;
}
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) baseAssignValue(object, key, newValue);
        else assignValue(object, key, newValue);
    }
    return object;
}
/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function createAssigner(assigner) {
    return baseRest(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneObject(object) {
    return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
}
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function isIterateeCall(value, index, object) {
    if (!isObject(object)) return false;
    var type = typeof index;
    if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
    return false;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function overRest(func, start, transform) {
    start = nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
    };
}
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function safeGet(object, key) {
    if (key === "constructor" && typeof object[key] === "function") return;
    if (key == "__proto__") return;
    return object[key];
}
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var setToString = shortOut(baseSetToString);
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == "object";
}
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function isPlainObject(value) {
    if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
    var proto = getPrototype(value);
    if (proto === null) return true;
    var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function toPlainObject(value) {
    return copyObject(value, keysIn(value));
}
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function keysIn(object) {
    return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}
/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var merge = createAssigner(function(object, source, srcIndex) {
    baseMerge(object, source, srcIndex);
});
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function constant(value) {
    return function() {
        return value;
    };
}
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function identity(value) {
    return value;
}
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = merge;

});

parcelRequire.register("4vp6j", function(module, exports) {
/////////////////////////////////////////////////////////////////////////////////
/* UAParser.js v1.0.37
   Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
   MIT License */ /*
   Detect Browser, Engine, OS, CPU, and Device type/model from User-Agent data.
   Supports browser & node.js environment. 
   Demo   : https://faisalman.github.io/ua-parser-js
   Source : https://github.com/faisalman/ua-parser-js */ /////////////////////////////////////////////////////////////////////////////////
(function(window1, undefined) {
    "use strict";
    //////////////
    // Constants
    /////////////
    var LIBVERSION = "1.0.37", EMPTY = "", UNKNOWN = "?", FUNC_TYPE = "function", UNDEF_TYPE = "undefined", OBJ_TYPE = "object", STR_TYPE = "string", MAJOR = "major", MODEL = "model", NAME = "name", TYPE = "type", VENDOR = "vendor", VERSION = "version", ARCHITECTURE = "architecture", CONSOLE = "console", MOBILE = "mobile", TABLET = "tablet", SMARTTV = "smarttv", WEARABLE = "wearable", EMBEDDED = "embedded", UA_MAX_LENGTH = 500;
    var AMAZON = "Amazon", APPLE = "Apple", ASUS = "ASUS", BLACKBERRY = "BlackBerry", BROWSER = "Browser", CHROME = "Chrome", EDGE = "Edge", FIREFOX = "Firefox", GOOGLE = "Google", HUAWEI = "Huawei", LG = "LG", MICROSOFT = "Microsoft", MOTOROLA = "Motorola", OPERA = "Opera", SAMSUNG = "Samsung", SHARP = "Sharp", SONY = "Sony", XIAOMI = "Xiaomi", ZEBRA = "Zebra", FACEBOOK = "Facebook", CHROMIUM_OS = "Chromium OS", MAC_OS = "Mac OS";
    ///////////
    // Helper
    //////////
    var extend = function(regexes, extensions) {
        var mergedRegexes = {};
        for(var i in regexes)if (extensions[i] && extensions[i].length % 2 === 0) mergedRegexes[i] = extensions[i].concat(regexes[i]);
        else mergedRegexes[i] = regexes[i];
        return mergedRegexes;
    }, enumerize = function(arr) {
        var enums = {};
        for(var i = 0; i < arr.length; i++)enums[arr[i].toUpperCase()] = arr[i];
        return enums;
    }, has = function(str1, str2) {
        return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
    }, lowerize = function(str) {
        return str.toLowerCase();
    }, majorize = function(version) {
        return typeof version === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split(".")[0] : undefined;
    }, trim = function(str, len) {
        if (typeof str === STR_TYPE) {
            str = str.replace(/^\s\s*/, EMPTY);
            return typeof len === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
        }
    };
    ///////////////
    // Map helper
    //////////////
    var rgxMapper = function(ua, arrays) {
        var i = 0, j, k, p, q, matches, match;
        // loop through all regexes maps
        while(i < arrays.length && !matches){
            var regex = arrays[i], props = arrays[i + 1]; // odd sequence (1,3,5,..)
            j = k = 0;
            // try matching uastring with regexes
            while(j < regex.length && !matches){
                if (!regex[j]) break;
                matches = regex[j++].exec(ua);
                if (!!matches) for(p = 0; p < props.length; p++){
                    match = matches[++k];
                    q = props[p];
                    // check if given property is actually array
                    if (typeof q === OBJ_TYPE && q.length > 0) {
                        if (q.length === 2) {
                            if (typeof q[1] == FUNC_TYPE) // assign modified match
                            this[q[0]] = q[1].call(this, match);
                            else // assign given value, ignore regex match
                            this[q[0]] = q[1];
                        } else if (q.length === 3) {
                            // check whether function or regex
                            if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) // call function (usually string mapper)
                            this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                            else // sanitize match using given regex
                            this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                        } else if (q.length === 4) this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                    } else this[q] = match ? match : undefined;
                }
            }
            i += 2;
        }
    }, strMapper = function(str, map) {
        for(var i in map){
            // check if current value is array
            if (typeof map[i] === OBJ_TYPE && map[i].length > 0) for(var j = 0; j < map[i].length; j++){
                if (has(map[i][j], str)) return i === UNKNOWN ? undefined : i;
            }
            else if (has(map[i], str)) return i === UNKNOWN ? undefined : i;
        }
        return str;
    };
    ///////////////
    // String map
    //////////////
    // Safari < 3.0
    var oldSafariMap = {
        "1.0": "/8",
        "1.2": "/1",
        "1.3": "/3",
        "2.0": "/412",
        "2.0.2": "/416",
        "2.0.3": "/417",
        "2.0.4": "/419",
        "?": "/"
    }, windowsVersionMap = {
        "ME": "4.90",
        "NT 3.11": "NT3.51",
        "NT 4.0": "NT4.0",
        "2000": "NT 5.0",
        "XP": [
            "NT 5.1",
            "NT 5.2"
        ],
        "Vista": "NT 6.0",
        "7": "NT 6.1",
        "8": "NT 6.2",
        "8.1": "NT 6.3",
        "10": [
            "NT 6.4",
            "NT 10.0"
        ],
        "RT": "ARM"
    };
    //////////////
    // Regex map
    /////////////
    var regexes = {
        browser: [
            [
                /\b(?:crmo|crios)\/([\w\.]+)/i // Chrome for Android/iOS
            ],
            [
                VERSION,
                [
                    NAME,
                    "Chrome"
                ]
            ],
            [
                /edg(?:e|ios|a)?\/([\w\.]+)/i // Microsoft Edge
            ],
            [
                VERSION,
                [
                    NAME,
                    "Edge"
                ]
            ],
            [
                // Presto based
                /(opera mini)\/([-\w\.]+)/i,
                /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
                /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i // Opera
            ],
            [
                NAME,
                VERSION
            ],
            [
                /opios[\/ ]+([\w\.]+)/i // Opera mini on iphone >= 8.0
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Mini"
                ]
            ],
            [
                /\bopr\/([\w\.]+)/i // Opera Webkit
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA
                ]
            ],
            [
                // Mixed
                /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i // Baidu
            ],
            [
                VERSION,
                [
                    NAME,
                    "Baidu"
                ]
            ],
            [
                /(kindle)\/([\w\.]+)/i,
                /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,
                // Trident based
                /(avant|iemobile|slim)\s?(?:browser)?[\/ ]?([\w\.]*)/i,
                /(?:ms|\()(ie) ([\w\.]+)/i,
                // Webkit/KHTML based                                               // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
                /(flock|rockmelt|midori|epiphany|silk|skyfire|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i,
                // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ, aka ShouQ
                /(heytap|ovi)browser\/([\d\.]+)/i,
                /(weibo)__([\d\.]+)/i // Weibo
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i // UCBrowser
            ],
            [
                VERSION,
                [
                    NAME,
                    "UC" + BROWSER
                ]
            ],
            [
                /microm.+\bqbcore\/([\w\.]+)/i,
                /\bqbcore\/([\w\.]+).+microm/i,
                /micromessenger\/([\w\.]+)/i // WeChat
            ],
            [
                VERSION,
                [
                    NAME,
                    "WeChat"
                ]
            ],
            [
                /konqueror\/([\w\.]+)/i // Konqueror
            ],
            [
                VERSION,
                [
                    NAME,
                    "Konqueror"
                ]
            ],
            [
                /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i // IE11
            ],
            [
                VERSION,
                [
                    NAME,
                    "IE"
                ]
            ],
            [
                /ya(?:search)?browser\/([\w\.]+)/i // Yandex
            ],
            [
                VERSION,
                [
                    NAME,
                    "Yandex"
                ]
            ],
            [
                /slbrowser\/([\w\.]+)/i // Smart Lenovo Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    "Smart Lenovo " + BROWSER
                ]
            ],
            [
                /(avast|avg)\/([\w\.]+)/i // Avast/AVG Secure Browser
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1 Secure " + BROWSER
                ],
                VERSION
            ],
            [
                /\bfocus\/([\w\.]+)/i // Firefox Focus
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " Focus"
                ]
            ],
            [
                /\bopt\/([\w\.]+)/i // Opera Touch
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Touch"
                ]
            ],
            [
                /coc_coc\w+\/([\w\.]+)/i // Coc Coc Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    "Coc Coc"
                ]
            ],
            [
                /dolfin\/([\w\.]+)/i // Dolphin
            ],
            [
                VERSION,
                [
                    NAME,
                    "Dolphin"
                ]
            ],
            [
                /coast\/([\w\.]+)/i // Opera Coast
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Coast"
                ]
            ],
            [
                /miuibrowser\/([\w\.]+)/i // MIUI Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    "MIUI " + BROWSER
                ]
            ],
            [
                /fxios\/([-\w\.]+)/i // Firefox for iOS
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX
                ]
            ],
            [
                /\bqihu|(qi?ho?o?|360)browser/i // 360
            ],
            [
                [
                    NAME,
                    "360 " + BROWSER
                ]
            ],
            [
                /(oculus|sailfish|huawei|vivo)browser\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1 " + BROWSER
                ],
                VERSION
            ],
            [
                /samsungbrowser\/([\w\.]+)/i // Samsung Internet
            ],
            [
                VERSION,
                [
                    NAME,
                    SAMSUNG + " Internet"
                ]
            ],
            [
                /(comodo_dragon)\/([\w\.]+)/i // Comodo Dragon
            ],
            [
                [
                    NAME,
                    /_/g,
                    " "
                ],
                VERSION
            ],
            [
                /metasr[\/ ]?([\d\.]+)/i // Sogou Explorer
            ],
            [
                VERSION,
                [
                    NAME,
                    "Sogou Explorer"
                ]
            ],
            [
                /(sogou)mo\w+\/([\d\.]+)/i // Sogou Mobile
            ],
            [
                [
                    NAME,
                    "Sogou Mobile"
                ],
                VERSION
            ],
            [
                /(electron)\/([\w\.]+) safari/i,
                /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
                /m?(qqbrowser|2345Explorer)[\/ ]?([\w\.]+)/i // QQBrowser/2345 Browser
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(lbbrowser)/i,
                /\[(linkedin)app\]/i // LinkedIn App for iOS & Android
            ],
            [
                NAME
            ],
            [
                // WebView
                /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i // Facebook App for iOS & Android
            ],
            [
                [
                    NAME,
                    FACEBOOK
                ],
                VERSION
            ],
            [
                /(Klarna)\/([\w\.]+)/i,
                /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
                /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
                /safari (line)\/([\w\.]+)/i,
                /\b(line)\/([\w\.]+)\/iab/i,
                /(alipay)client\/([\w\.]+)/i,
                /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i // Chromium/Instagram/Snapchat
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\bgsa\/([\w\.]+) .*safari\//i // Google Search Appliance on iOS
            ],
            [
                VERSION,
                [
                    NAME,
                    "GSA"
                ]
            ],
            [
                /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i // TikTok
            ],
            [
                VERSION,
                [
                    NAME,
                    "TikTok"
                ]
            ],
            [
                /headlesschrome(?:\/([\w\.]+)| )/i // Chrome Headless
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + " Headless"
                ]
            ],
            [
                / wv\).+(chrome)\/([\w\.]+)/i // Chrome WebView
            ],
            [
                [
                    NAME,
                    CHROME + " WebView"
                ],
                VERSION
            ],
            [
                /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i // Android Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    "Android " + BROWSER
                ]
            ],
            [
                /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i // Chrome/OmniWeb/Arora/Tizen/Nokia
            ],
            [
                NAME,
                VERSION
            ],
            [
                /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i // Mobile Safari
            ],
            [
                VERSION,
                [
                    NAME,
                    "Mobile Safari"
                ]
            ],
            [
                /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i // Safari & Safari Mobile
            ],
            [
                VERSION,
                NAME
            ],
            [
                /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i // Safari < 3.0
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    oldSafariMap
                ]
            ],
            [
                /(webkit|khtml)\/([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                // Gecko based
                /(navigator|netscape\d?)\/([-\w\.]+)/i // Netscape
            ],
            [
                [
                    NAME,
                    "Netscape"
                ],
                VERSION
            ],
            [
                /mobile vr; rv:([\w\.]+)\).+firefox/i // Firefox Reality
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " Reality"
                ]
            ],
            [
                /ekiohf.+(flow)\/([\w\.]+)/i,
                /(swiftfox)/i,
                /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
                // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror/Klar
                /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
                // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
                /(firefox)\/([\w\.]+)/i,
                /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
                // Other
                /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
                // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir/Obigo/Mosaic/Go/ICE/UP.Browser
                /(links) \(([\w\.]+)/i,
                /panasonic;(viera)/i // Panasonic Viera
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(cobalt)\/([\w\.]+)/i // Cobalt
            ],
            [
                NAME,
                [
                    VERSION,
                    /master.|lts./,
                    ""
                ]
            ]
        ],
        cpu: [
            [
                /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i // AMD64 (x64)
            ],
            [
                [
                    ARCHITECTURE,
                    "amd64"
                ]
            ],
            [
                /(ia32(?=;))/i // IA32 (quicktime)
            ],
            [
                [
                    ARCHITECTURE,
                    lowerize
                ]
            ],
            [
                /((?:i[346]|x)86)[;\)]/i // IA32 (x86)
            ],
            [
                [
                    ARCHITECTURE,
                    "ia32"
                ]
            ],
            [
                /\b(aarch64|arm(v?8e?l?|_?64))\b/i // ARM64
            ],
            [
                [
                    ARCHITECTURE,
                    "arm64"
                ]
            ],
            [
                /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i // ARMHF
            ],
            [
                [
                    ARCHITECTURE,
                    "armhf"
                ]
            ],
            [
                // PocketPC mistakenly identified as PowerPC
                /windows (ce|mobile); ppc;/i
            ],
            [
                [
                    ARCHITECTURE,
                    "arm"
                ]
            ],
            [
                /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i // PowerPC
            ],
            [
                [
                    ARCHITECTURE,
                    /ower/,
                    EMPTY,
                    lowerize
                ]
            ],
            [
                /(sun4\w)[;\)]/i // SPARC
            ],
            [
                [
                    ARCHITECTURE,
                    "sparc"
                ]
            ],
            [
                /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
            ],
            [
                [
                    ARCHITECTURE,
                    lowerize
                ]
            ]
        ],
        device: [
            [
                //////////////////////////
                // MOBILES & TABLETS
                /////////////////////////
                // Samsung
                /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
                /samsung[- ]([-\w]+)/i,
                /sec-(sgh\w+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Apple
                /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i // iPod/iPhone
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\((ipad);[-\w\),; ]+apple/i,
                /applecoremedia\/[\w\.]+ \((ipad)/i,
                /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(macintosh);/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ]
            ],
            [
                // Sharp
                /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Huawei
                /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(?:huawei|honor)([-\w ]+)[;\)]/i,
                /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Xiaomi
                /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,
                /\b; (\w+) build\/hm\1/i,
                /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
                /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
                /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,
                /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i // Xiaomi Mi
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /oid[^\)]+; (2\d{4}(283|rpbf)[cgl])( bui|\))/i,
                /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i // Mi Pad tablets
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // OPPO
                /; (\w+) bui.+ oppo/i,
                /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "OPPO"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Vivo
                /vivo (\w+)(?: bui|\))/i,
                /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Vivo"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Realme
                /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Realme"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Motorola
                /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
                /\bmot(?:orola)?[- ](\w*)/i,
                /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(mz60\d|xoom[2 ]{0,2}) build\//i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // LG
                /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
                /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
                /\blg-?([\d\w]+) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Lenovo
                /(ideatab[-\w ]+)/i,
                /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Lenovo"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // Nokia
                /(?:maemo|nokia).*(n900|lumia \d+)/i,
                /nokia[-_ ]?([-\w\.]*)/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    "Nokia"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Google
                /(pixel c)\b/i // Google Pixel C
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i // Google Pixel
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Sony
                /droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /sony tablet [ps]/i,
                /\b(?:sony)?sgp\w+(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    "Xperia Tablet"
                ],
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // OnePlus
                / (kb2005|in20[12]5|be20[12][59])\b/i,
                /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "OnePlus"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Amazon
                /(alexa)webm/i,
                /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i,
                /(kf[a-z]+)( bui|\)).+silk\//i // Kindle Fire HD
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i // Fire Phone
            ],
            [
                [
                    MODEL,
                    /(.+)/g,
                    "Fire Phone $1"
                ],
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // BlackBerry
                /(playbook);[-\w\),; ]+(rim)/i // BlackBerry PlayBook
            ],
            [
                MODEL,
                VENDOR,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:bb[a-f]|st[hv])100-\d)/i,
                /\(bb10; (\w+)/i // BlackBerry 10
            ],
            [
                MODEL,
                [
                    VENDOR,
                    BLACKBERRY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Asus
                /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // HTC
                /(nexus 9)/i // HTC Nexus 9
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "HTC"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
                // ZTE
                /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
                /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
            ],
            [
                VENDOR,
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Acer
                /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Acer"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // Meizu
                /droid.+; (m[1-5] note) bui/i,
                /\bmz-([-\w]{2,})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Meizu"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Ulefone
                /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Ulefone"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // MIXED
                /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron|infinix|tecno)[-_ ]?([-\w]*)/i,
                // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
                /(hp) ([\w ]+\w)/i,
                /(asus)-?(\w+)/i,
                /(microsoft); (lumia[\w ]+)/i,
                /(lenovo)[-_ ]?([-\w]+)/i,
                /(jolla)/i,
                /(oppo) ?([\w ]+) bui/i // OPPO
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kobo)\s(ereader|touch)/i,
                /(archos) (gamepad2?)/i,
                /(hp).+(touchpad(?!.+tablet)|tablet)/i,
                /(kindle)\/([\w\.]+)/i,
                /(nook)[\w ]+build\/(\w+)/i,
                /(dell) (strea[kpr\d ]*[\dko])/i,
                /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
                /(trinity)[- ]*(t\d{3}) bui/i,
                /(gigaset)[- ]+(q\w{1,9}) bui/i,
                /(vodafone) ([\w ]+)(?:\)| bui)/i // Vodafone
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(surface duo)/i // Surface Duo
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid [\d\.]+; (fp\du?)(?: b|\))/i // Fairphone
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Fairphone"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(u304aa)/i // AT&T
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "AT&T"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\bsie-(\w*)/i // Siemens
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Siemens"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(rct\w+) b/i // RCA Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "RCA"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(venue[\d ]{2,7}) b/i // Dell Venue Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Dell"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(q(?:mv|ta)\w+) b/i // Verizon Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Verizon"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i // Barnes & Noble Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Barnes & Noble"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(tm\d{3}\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "NuVision"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(k88) b/i // ZTE K Series Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "ZTE"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(nx\d{3}j) b/i // ZTE Nubia
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "ZTE"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(gen\d{3}) b.+49h/i // Swiss GEN Mobile
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Swiss"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(zur\d{3}) b/i // Swiss ZUR Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Swiss"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((zeki)?tb.*\b) b/i // Zeki Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Zeki"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b([yr]\d{2}) b/i,
                /\b(dragon[- ]+touch |dt)(\w{5}) b/i // Dragon Touch Tablet
            ],
            [
                [
                    VENDOR,
                    "Dragon Touch"
                ],
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(ns-?\w{0,9}) b/i // Insignia Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Insignia"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((nxa|next)-?\w{0,9}) b/i // NextBook Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "NextBook"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i // Voice Xtreme Phones
            ],
            [
                [
                    VENDOR,
                    "Voice"
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(lvtel\-)?(v1[12]) b/i // LvTel Phones
            ],
            [
                [
                    VENDOR,
                    "LvTel"
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(ph-1) /i // Essential PH-1
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Essential"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(v(100md|700na|7011|917g).*\b) b/i // Envizen Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Envizen"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(trio[-\w\. ]+) b/i // MachSpeed Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "MachSpeed"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\btu_(1491) b/i // Rotor Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Rotor"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(shield[\w ]+) b/i // Nvidia Shield Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Nvidia"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(sprint) (\w+)/i // Sprint Phones
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kin\.[onetw]{3})/i // Microsoft Kin
            ],
            [
                [
                    MODEL,
                    /\./g,
                    " "
                ],
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i // Zebra
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                ///////////////////
                // SMARTTVS
                ///////////////////
                /smart-tv.+(samsung)/i // Samsung
            ],
            [
                VENDOR,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /hbbtv.+maple;(\d+)/i
            ],
            [
                [
                    MODEL,
                    /^/,
                    "SmartTV"
                ],
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i // LG SmartTV
            ],
            [
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(apple) ?tv/i // Apple TV
            ],
            [
                VENDOR,
                [
                    MODEL,
                    APPLE + " TV"
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /crkey/i // Google Chromecast
            ],
            [
                [
                    MODEL,
                    CHROME + "cast"
                ],
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /droid.+aft(\w+)( bui|\))/i // Fire TV
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\(dtv[\);].+(aquos)/i,
                /(aquos-tv[\w ]+)\)/i // Sharp
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(bravia[\w ]+)( bui|\))/i // Sony
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(mitv-\w{5}) bui/i // Xiaomi
            ],
            [
                MODEL,
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /Hbbtv.*(technisat) (.*);/i // TechniSAT
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
                /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i // HbbTV devices
            ],
            [
                [
                    VENDOR,
                    trim
                ],
                [
                    MODEL,
                    trim
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i // SmartTV from Unidentified Vendors
            ],
            [
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                ///////////////////
                // CONSOLES
                ///////////////////
                /(ouya)/i,
                /(nintendo) ([wids3utch]+)/i // Nintendo
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /droid.+; (shield) bui/i // Nvidia
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Nvidia"
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /(playstation [345portablevi]+)/i // Playstation
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /\b(xbox(?: one)?(?!; xbox))[\); ]/i // Microsoft Xbox
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                ///////////////////
                // WEARABLES
                ///////////////////
                /((pebble))app/i // Pebble
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i // Apple Watch
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (glass) \d/i // Google Glass
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (wt63?0{2,3})\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(quest( 2| pro)?)/i // Oculus Quest
            ],
            [
                MODEL,
                [
                    VENDOR,
                    FACEBOOK
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                ///////////////////
                // EMBEDDED
                ///////////////////
                /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i // Tesla
            ],
            [
                VENDOR,
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /(aeobc)\b/i // Echo Dot
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                ////////////////////
                // MIXED (GENERIC)
                ///////////////////
                /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i // Android Phones from Unidentified Vendors
            ],
            [
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i // Android Tablets from Unidentified Vendors
            ],
            [
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i // Unidentifiable Tablet
            ],
            [
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i // Unidentifiable Mobile
            ],
            [
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(android[-\w\. ]{0,9});.+buil/i // Generic Android Device
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Generic"
                ]
            ]
        ],
        engine: [
            [
                /windows.+ edge\/([\w\.]+)/i // EdgeHTML
            ],
            [
                VERSION,
                [
                    NAME,
                    EDGE + "HTML"
                ]
            ],
            [
                /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i // Blink
            ],
            [
                VERSION,
                [
                    NAME,
                    "Blink"
                ]
            ],
            [
                /(presto)\/([\w\.]+)/i,
                /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,
                /ekioh(flow)\/([\w\.]+)/i,
                /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
                /(icab)[\/ ]([23]\.[\d\.]+)/i,
                /\b(libweb)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /rv\:([\w\.]{1,9})\b.+(gecko)/i // Gecko
            ],
            [
                VERSION,
                NAME
            ]
        ],
        os: [
            [
                // Windows
                /microsoft (windows) (vista|xp)/i // Windows (iTunes)
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i // Windows Phone
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ]
            ],
            [
                /windows nt 6\.2; (arm)/i,
                /windows[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i,
                /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
            ],
            [
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ],
                [
                    NAME,
                    "Windows"
                ]
            ],
            [
                // iOS/macOS
                /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,
                /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
                /cfnetwork\/.+darwin/i
            ],
            [
                [
                    VERSION,
                    /_/g,
                    "."
                ],
                [
                    NAME,
                    "iOS"
                ]
            ],
            [
                /(mac os x) ?([\w\. ]*)/i,
                /(macintosh|mac_powerpc\b)(?!.+haiku)/i // Mac OS
            ],
            [
                [
                    NAME,
                    MAC_OS
                ],
                [
                    VERSION,
                    /_/g,
                    "."
                ]
            ],
            [
                // Mobile OSes
                /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i // Android-x86/HarmonyOS
            ],
            [
                VERSION,
                NAME
            ],
            [
                /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
                /(blackberry)\w*\/([\w\.]*)/i,
                /(tizen|kaios)[\/ ]([\w\.]+)/i,
                /\((series40);/i // Series 40
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\(bb(10);/i // BlackBerry 10
            ],
            [
                VERSION,
                [
                    NAME,
                    BLACKBERRY
                ]
            ],
            [
                /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i // Symbian
            ],
            [
                VERSION,
                [
                    NAME,
                    "Symbian"
                ]
            ],
            [
                /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i // Firefox OS
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " OS"
                ]
            ],
            [
                /web0s;.+rt(tv)/i,
                /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i // WebOS
            ],
            [
                VERSION,
                [
                    NAME,
                    "webOS"
                ]
            ],
            [
                /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i // watchOS
            ],
            [
                VERSION,
                [
                    NAME,
                    "watchOS"
                ]
            ],
            [
                // Google Chromecast
                /crkey\/([\d\.]+)/i // Google Chromecast
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + "cast"
                ]
            ],
            [
                /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i // Chromium OS
            ],
            [
                [
                    NAME,
                    CHROMIUM_OS
                ],
                VERSION
            ],
            [
                // Smart TVs
                /panasonic;(viera)/i,
                /(netrange)mmh/i,
                /(nettv)\/(\d+\.[\w\.]+)/i,
                // Console
                /(nintendo|playstation) ([wids345portablevuch]+)/i,
                /(xbox); +xbox ([^\);]+)/i,
                // Other
                /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
                /(mint)[\/\(\) ]?(\w*)/i,
                /(mageia|vectorlinux)[; ]/i,
                /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
                // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
                /(hurd|linux) ?([\w\.]*)/i,
                /(gnu) ?([\w\.]*)/i,
                /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
                /(haiku) (\w+)/i // Haiku
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(sunos) ?([\w\.\d]*)/i // Solaris
            ],
            [
                [
                    NAME,
                    "Solaris"
                ],
                VERSION
            ],
            [
                /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
                /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
                /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
                /(unix) ?([\w\.]*)/i // UNIX
            ],
            [
                NAME,
                VERSION
            ]
        ]
    };
    /////////////////
    // Constructor
    ////////////////
    var UAParser = function(ua, extensions) {
        if (typeof ua === OBJ_TYPE) {
            extensions = ua;
            ua = undefined;
        }
        if (!(this instanceof UAParser)) return new UAParser(ua, extensions).getResult();
        var _navigator = typeof window1 !== UNDEF_TYPE && window1.navigator ? window1.navigator : undefined;
        var _ua = ua || (_navigator && _navigator.userAgent ? _navigator.userAgent : EMPTY);
        var _uach = _navigator && _navigator.userAgentData ? _navigator.userAgentData : undefined;
        var _rgxmap = extensions ? extend(regexes, extensions) : regexes;
        var _isSelfNav = _navigator && _navigator.userAgent == _ua;
        this.getBrowser = function() {
            var _browser = {};
            _browser[NAME] = undefined;
            _browser[VERSION] = undefined;
            rgxMapper.call(_browser, _ua, _rgxmap.browser);
            _browser[MAJOR] = majorize(_browser[VERSION]);
            // Brave-specific detection
            if (_isSelfNav && _navigator && _navigator.brave && typeof _navigator.brave.isBrave == FUNC_TYPE) _browser[NAME] = "Brave";
            return _browser;
        };
        this.getCPU = function() {
            var _cpu = {};
            _cpu[ARCHITECTURE] = undefined;
            rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
            return _cpu;
        };
        this.getDevice = function() {
            var _device = {};
            _device[VENDOR] = undefined;
            _device[MODEL] = undefined;
            _device[TYPE] = undefined;
            rgxMapper.call(_device, _ua, _rgxmap.device);
            if (_isSelfNav && !_device[TYPE] && _uach && _uach.mobile) _device[TYPE] = MOBILE;
            // iPadOS-specific detection: identified as Mac, but has some iOS-only properties
            if (_isSelfNav && _device[MODEL] == "Macintosh" && _navigator && typeof _navigator.standalone !== UNDEF_TYPE && _navigator.maxTouchPoints && _navigator.maxTouchPoints > 2) {
                _device[MODEL] = "iPad";
                _device[TYPE] = TABLET;
            }
            return _device;
        };
        this.getEngine = function() {
            var _engine = {};
            _engine[NAME] = undefined;
            _engine[VERSION] = undefined;
            rgxMapper.call(_engine, _ua, _rgxmap.engine);
            return _engine;
        };
        this.getOS = function() {
            var _os = {};
            _os[NAME] = undefined;
            _os[VERSION] = undefined;
            rgxMapper.call(_os, _ua, _rgxmap.os);
            if (_isSelfNav && !_os[NAME] && _uach && _uach.platform != "Unknown") _os[NAME] = _uach.platform.replace(/chrome os/i, CHROMIUM_OS).replace(/macos/i, MAC_OS); // backward compatibility
            return _os;
        };
        this.getResult = function() {
            return {
                ua: this.getUA(),
                browser: this.getBrowser(),
                engine: this.getEngine(),
                os: this.getOS(),
                device: this.getDevice(),
                cpu: this.getCPU()
            };
        };
        this.getUA = function() {
            return _ua;
        };
        this.setUA = function(ua) {
            _ua = typeof ua === STR_TYPE && ua.length > UA_MAX_LENGTH ? trim(ua, UA_MAX_LENGTH) : ua;
            return this;
        };
        this.setUA(_ua);
        return this;
    };
    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER = enumerize([
        NAME,
        VERSION,
        MAJOR
    ]);
    UAParser.CPU = enumerize([
        ARCHITECTURE
    ]);
    UAParser.DEVICE = enumerize([
        MODEL,
        VENDOR,
        TYPE,
        CONSOLE,
        MOBILE,
        SMARTTV,
        TABLET,
        WEARABLE,
        EMBEDDED
    ]);
    UAParser.ENGINE = UAParser.OS = enumerize([
        NAME,
        VERSION
    ]);
    ///////////
    // Export
    //////////
    // check js environment
    if (typeof exports !== UNDEF_TYPE) {
        // nodejs env
        if ("object" !== UNDEF_TYPE && module.exports) exports = module.exports = UAParser;
        exports.UAParser = UAParser;
    } else {
        // requirejs env (optional)
        if (typeof define === FUNC_TYPE && define.amd) define(function() {
            return UAParser;
        });
        else if (typeof window1 !== UNDEF_TYPE) // browser env
        window1.UAParser = UAParser;
    }
    // jQuery/Zepto specific (optional)
    // Note:
    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
    //   and we should catch that.
    var $ = typeof window1 !== UNDEF_TYPE && (window1.jQuery || window1.Zepto);
    if ($ && !$.ua) {
        var parser = new UAParser();
        $.ua = parser.getResult();
        $.ua.get = function() {
            return parser.getUA();
        };
        $.ua.set = function(ua) {
            parser.setUA(ua);
            var result = parser.getResult();
            for(var prop in result)$.ua[prop] = result[prop];
        };
    }
})(typeof window === "object" ? window : this);

});

parcelRequire.register("g1KQj", function(module, exports) {
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    "use strict";
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === "[object Array]";
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === "[object Object]";
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === "number" || Object.prototype.toString.call(input) === "[object Number]";
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === "[object Date]";
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, "toString")) a.toString = b.toString;
        if (hasOwnProp(b, "valueOf")) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        var flags = null, parsedParts = false, isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            });
            isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
        else return isNowValid;
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== "undefined" && console.warn) console.warn("Deprecation warning: " + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = "";
                    if (typeof arguments[i] === "object") {
                        arg += "\n[" + i + "] ";
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ": " + arguments[0][key] + ", ";
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + "\nArguments: " + Array.prototype.slice.call(args).join("") + "\n" + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== "undefined" && input instanceof Function || Object.prototype.toString.call(input) === "[object Function]";
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this["_" + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: "[Today at] LT",
        nextDay: "[Tomorrow at] LT",
        nextWeek: "dddd [at] LT",
        lastDay: "[Yesterday at] LT",
        lastWeek: "[Last] dddd [at] LT",
        sameElse: "L"
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar["sameElse"];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = "" + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? "+" : "" : "-") + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === "string") func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, "");
        return input.replace(/\\/g, "");
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = "", i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === "MMMM" || tok === "MM" || tok === "DD" || tok === "dddd") return tok.slice(1);
            return tok;
        }).join("");
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = "Invalid date";
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = "%d", defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace("%d", number);
    }
    var defaultRelativeTime = {
        future: "in %s",
        past: "%s ago",
        s: "a few seconds",
        ss: "%d seconds",
        m: "a minute",
        mm: "%d minutes",
        h: "an hour",
        hh: "%d hours",
        d: "a day",
        dd: "%d days",
        w: "a week",
        ww: "%d weeks",
        M: "a month",
        MM: "%d months",
        y: "a year",
        yy: "%d years"
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? "future" : "past"];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {
        D: "date",
        dates: "date",
        date: "date",
        d: "day",
        days: "day",
        day: "day",
        e: "weekday",
        weekdays: "weekday",
        weekday: "weekday",
        E: "isoWeekday",
        isoweekdays: "isoWeekday",
        isoweekday: "isoWeekday",
        DDD: "dayOfYear",
        dayofyears: "dayOfYear",
        dayofyear: "dayOfYear",
        h: "hour",
        hours: "hour",
        hour: "hour",
        ms: "millisecond",
        milliseconds: "millisecond",
        millisecond: "millisecond",
        m: "minute",
        minutes: "minute",
        minute: "minute",
        M: "month",
        months: "month",
        month: "month",
        Q: "quarter",
        quarters: "quarter",
        quarter: "quarter",
        s: "second",
        seconds: "second",
        second: "second",
        gg: "weekYear",
        weekyears: "weekYear",
        weekyear: "weekYear",
        GG: "isoWeekYear",
        isoweekyears: "isoWeekYear",
        isoweekyear: "isoWeekYear",
        w: "week",
        weeks: "week",
        week: "week",
        W: "isoWeek",
        isoweeks: "isoWeek",
        isoweek: "isoWeek",
        y: "year",
        years: "year",
        year: "year"
    };
    function normalizeUnits(units) {
        return typeof units === "string" ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1
    };
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace("\\", "").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === "string") token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    // FORMATTING
    addFormatToken("Y", 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : "+" + y;
    });
    addFormatToken(0, [
        "YY",
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        "YYYY",
        4
    ], 0, "year");
    addFormatToken(0, [
        "YYYYY",
        5
    ], 0, "year");
    addFormatToken(0, [
        "YYYYYY",
        6,
        true
    ], 0, "year");
    // PARSING
    addRegexToken("Y", matchSigned);
    addRegexToken("YY", match1to2, match2);
    addRegexToken("YYYY", match1to4, match4);
    addRegexToken("YYYYY", match1to6, match6);
    addRegexToken("YYYYYY", match1to6, match6);
    addParseToken([
        "YYYYY",
        "YYYYYY"
    ], YEAR);
    addParseToken("YYYY", function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken("YY", function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken("Y", function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet("FullYear", true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        if (!mom.isValid()) return NaN;
        var d = mom._d, isUTC = mom._isUTC;
        switch(unit){
            case "Milliseconds":
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case "Seconds":
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case "Minutes":
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case "Hours":
                return isUTC ? d.getUTCHours() : d.getHours();
            case "Date":
                return isUTC ? d.getUTCDate() : d.getDate();
            case "Day":
                return isUTC ? d.getUTCDay() : d.getDay();
            case "Month":
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case "FullYear":
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }
    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;
        if (!mom.isValid() || isNaN(value)) return;
        d = mom._d;
        isUTC = mom._isUTC;
        switch(unit){
            case "Milliseconds":
                return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
            case "Seconds":
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case "Minutes":
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case "Hours":
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case "Date":
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case "FullYear":
                break; // See below ...
            default:
                return; // Just in case
        }
        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date);
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === "object") {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken("M", [
        "MM",
        2
    ], "Mo", function() {
        return this.month() + 1;
    });
    addFormatToken("MMM", 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken("MMMM", 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // PARSING
    addRegexToken("M", match1to2, match1to2NoLeadingZero);
    addRegexToken("MM", match1to2, match2);
    addRegexToken("MMM", function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken("MMMM", function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        "M",
        "MM"
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        "MMM",
        "MMMM"
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), defaultLocaleMonthsShort = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months["standalone"];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? "format" : "standalone"][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort["standalone"];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? "format" : "standalone"][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, "").toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "MMM") {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === "MMM") {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp("^" + this.months(mom, "").replace(".", "") + "$", "i");
                this._shortMonthsParse[i] = new RegExp("^" + this.monthsShort(mom, "").replace(".", "") + "$", "i");
            }
            if (!strict && !this._monthsParse[i]) {
                regex = "^" + this.months(mom, "") + "|^" + this.monthsShort(mom, "");
                this._monthsParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "MMMM" && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === "MMM" && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === "string") {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        var month = value, date = mom.date();
        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, "Month");
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, "_monthsShortRegex")) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, "_monthsRegex")) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortP = regexEscape(this.monthsShort(mom, ""));
            longP = regexEscape(this.months(mom, ""));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._monthsRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._monthsShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken("w", [
        "ww",
        2
    ], "wo", "week");
    addFormatToken("W", [
        "WW",
        2
    ], "Wo", "isoWeek");
    // PARSING
    addRegexToken("w", match1to2, match1to2NoLeadingZero);
    addRegexToken("ww", match1to2, match2);
    addRegexToken("W", match1to2, match1to2NoLeadingZero);
    addRegexToken("WW", match1to2, match2);
    addWeekParseToken([
        "w",
        "ww",
        "W",
        "WW"
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    // FORMATTING
    addFormatToken("d", 0, "do", "day");
    addFormatToken("dd", 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken("ddd", 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken("dddd", 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken("e", 0, 0, "weekday");
    addFormatToken("E", 0, 0, "isoWeekday");
    // PARSING
    addRegexToken("d", match1to2);
    addRegexToken("e", match1to2);
    addRegexToken("E", match1to2);
    addRegexToken("dd", function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken("ddd", function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken("dddd", function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        "dd",
        "ddd",
        "dddd"
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        "d",
        "e",
        "E"
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== "string") return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === "number") return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === "string") return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), defaultLocaleWeekdaysShort = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), defaultLocaleWeekdaysMin = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? "format" : "standalone"];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, "").toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, "").toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp("^" + this.weekdays(mom, "").replace(".", "\\.?") + "$", "i");
                this._shortWeekdaysParse[i] = new RegExp("^" + this.weekdaysShort(mom, "").replace(".", "\\.?") + "$", "i");
                this._minWeekdaysParse[i] = new RegExp("^" + this.weekdaysMin(mom, "").replace(".", "\\.?") + "$", "i");
            }
            if (!this._weekdaysParse[i]) {
                regex = "^" + this.weekdays(mom, "") + "|^" + this.weekdaysShort(mom, "") + "|^" + this.weekdaysMin(mom, "");
                this._weekdaysParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "dddd" && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "ddd" && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "dd" && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = get(this, "Day");
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, "d");
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, "d");
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysRegex")) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysShortRegex")) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysMinRegex")) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ""));
            shortp = regexEscape(this.weekdaysShort(mom, ""));
            longp = regexEscape(this.weekdays(mom, ""));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._weekdaysShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
        this._weekdaysMinStrictRegex = new RegExp("^(" + minPieces.join("|") + ")", "i");
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken("H", [
        "HH",
        2
    ], 0, "hour");
    addFormatToken("h", [
        "hh",
        2
    ], 0, hFormat);
    addFormatToken("k", [
        "kk",
        2
    ], 0, kFormat);
    addFormatToken("hmm", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken("hmmss", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken("Hmm", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken("Hmmss", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem("a", true);
    meridiem("A", false);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken("a", matchMeridiem);
    addRegexToken("A", matchMeridiem);
    addRegexToken("H", match1to2, match1to2HasZero);
    addRegexToken("h", match1to2, match1to2NoLeadingZero);
    addRegexToken("k", match1to2, match1to2NoLeadingZero);
    addRegexToken("HH", match1to2, match2);
    addRegexToken("hh", match1to2, match2);
    addRegexToken("kk", match1to2, match2);
    addRegexToken("hmm", match3to4);
    addRegexToken("hmmss", match5to6);
    addRegexToken("Hmm", match3to4);
    addRegexToken("Hmmss", match5to6);
    addParseToken([
        "H",
        "HH"
    ], HOUR);
    addParseToken([
        "k",
        "kk"
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        "a",
        "A"
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        "h",
        "hh"
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("Hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken("Hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + "").toLowerCase().charAt(0) === "p";
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet("Hours", true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? "pm" : "PM";
        else return isLower ? "am" : "AM";
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace("_", "-") : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split("-");
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split("-") : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join("-"));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match("^[^/\\\\]*$"));
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire("./locale/" + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== "undefined" && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn("Locale " + key + " not found. Did you forget to load it?");
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple("defineLocaleOverride", "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            "YYYYYY-MM-DD",
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            "YYYY-MM-DD",
            /\d{4}-\d\d-\d\d/
        ],
        [
            "GGGG-[W]WW-E",
            /\d{4}-W\d\d-\d/
        ],
        [
            "GGGG-[W]WW",
            /\d{4}-W\d\d/,
            false
        ],
        [
            "YYYY-DDD",
            /\d{4}-\d{3}/
        ],
        [
            "YYYY-MM",
            /\d{4}-\d\d/,
            false
        ],
        [
            "YYYYYYMMDD",
            /[+-]\d{10}/
        ],
        [
            "YYYYMMDD",
            /\d{8}/
        ],
        [
            "GGGG[W]WWE",
            /\d{4}W\d{3}/
        ],
        [
            "GGGG[W]WW",
            /\d{4}W\d{2}/,
            false
        ],
        [
            "YYYYDDD",
            /\d{7}/
        ],
        [
            "YYYYMM",
            /\d{6}/,
            false
        ],
        [
            "YYYY",
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            "HH:mm:ss.SSSS",
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            "HH:mm:ss,SSSS",
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            "HH:mm:ss",
            /\d\d:\d\d:\d\d/
        ],
        [
            "HH:mm",
            /\d\d:\d\d/
        ],
        [
            "HHmmss.SSSS",
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            "HHmmss,SSSS",
            /\d\d\d\d\d\d,\d+/
        ],
        [
            "HHmmss",
            /\d\d\d\d\d\d/
        ],
        [
            "HHmm",
            /\d\d\d\d/
        ],
        [
            "HH",
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || " ") + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = "Z";
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || "") + (tzFormat || "");
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? " UTC" : ""));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== "undefined" && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = "" + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, "d");
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === "") return createInvalid({
            nullInput: true
        });
        if (typeof input === "string") config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === "string") configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isBefore", args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isAfter", args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        "year",
        "quarter",
        "month",
        "week",
        "day",
        "hour",
        "minute",
        "second",
        "millisecond"
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = "+";
            if (offset < 0) {
                offset = -offset;
                sign = "-";
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset("Z", ":");
    offset("ZZ", "");
    // PARSING
    addRegexToken("Z", matchShortOffset);
    addRegexToken("ZZ", matchShortOffset);
    addParseToken([
        "Z",
        "ZZ"
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || "").match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + "").match(chunkOffset) || [
            "-",
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === "+" ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === "string") {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, "m");
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, "m"), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== "string") input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), "m");
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === "string") {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === "object" && ("from" in duration || "to" in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, "_locale")) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, "_isValid")) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(",", "."));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, "M").isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, "M");
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, "moment()." + name + "(period, number) is deprecated. Please use moment()." + name + "(number, period). " + "See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.");
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, "Month") + months * isAdding);
        if (days) set$1(mom, "Date", get(mom, "Date") + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, "add"), subtract = createAdder(-1, "subtract");
    function isString(input) {
        return typeof input === "string" || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "years",
            "year",
            "y",
            "months",
            "month",
            "M",
            "days",
            "day",
            "d",
            "dates",
            "date",
            "D",
            "hours",
            "hour",
            "h",
            "minutes",
            "minute",
            "m",
            "seconds",
            "second",
            "s",
            "milliseconds",
            "millisecond",
            "ms"
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "sameDay",
            "nextDay",
            "lastDay",
            "nextWeek",
            "lastWeek",
            "sameElse"
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, "days", true);
        return diff < -6 ? "sameElse" : diff < -1 ? "lastWeek" : diff < 0 ? "lastDay" : diff < 1 ? "sameDay" : diff < 2 ? "nextDay" : diff < 7 ? "nextWeek" : "sameElse";
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf("day"), format = hooks.calendarFormat(this, sod) || "sameElse", output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || "()";
        return (inclusivity[0] === "(" ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ")" ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case "year":
                output = monthDiff(this, that) / 12;
                break;
            case "month":
                output = monthDiff(this, that);
                break;
            case "quarter":
                output = monthDiff(this, that) / 3;
                break;
            case "second":
                output = (this - that) / 1e3;
                break; // 1000
            case "minute":
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case "hour":
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case "day":
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case "week":
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, "months"), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
    hooks.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
    function toString() {
        return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ");
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace("Z", formatMoment(m, "Z"));
        }
        return formatMoment(m, utc ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ");
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return "moment.invalid(/* " + this._i + " */)";
        var func = "moment", zone = "", prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone";
            zone = "Z";
        }
        prefix = "[" + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY";
        datetime = "-MM-DD[T]HH:mm:ss.SSS";
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.", function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year(), 0, 1);
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case "month":
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case "hour":
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case "minute":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case "second":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case "month":
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case "hour":
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case "minute":
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case "second":
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken("N", 0, 0, "eraAbbr");
    addFormatToken("NN", 0, 0, "eraAbbr");
    addFormatToken("NNN", 0, 0, "eraAbbr");
    addFormatToken("NNNN", 0, 0, "eraName");
    addFormatToken("NNNNN", 0, 0, "eraNarrow");
    addFormatToken("y", [
        "y",
        1
    ], "yo", "eraYear");
    addFormatToken("y", [
        "yy",
        2
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyy",
        3
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyyy",
        4
    ], 0, "eraYear");
    addRegexToken("N", matchEraAbbr);
    addRegexToken("NN", matchEraAbbr);
    addRegexToken("NNN", matchEraAbbr);
    addRegexToken("NNNN", matchEraName);
    addRegexToken("NNNNN", matchEraNarrow);
    addParseToken([
        "N",
        "NN",
        "NNN",
        "NNNN",
        "NNNNN"
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken("y", matchUnsigned);
    addRegexToken("yy", matchUnsigned);
    addRegexToken("yyy", matchUnsigned);
    addRegexToken("yyyy", matchUnsigned);
    addRegexToken("yo", matchEraYearOrdinal);
    addParseToken([
        "y",
        "yy",
        "yyy",
        "yyyy"
    ], YEAR);
    addParseToken([
        "yo"
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale("en")._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case "string":
                    // truncate time
                    date = hooks(eras[i].since).startOf("day");
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case "undefined":
                    eras[i].until = Infinity;
                    break;
                case "string":
                    // truncate time
                    date = hooks(eras[i].until).startOf("day").valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case "N":
                case "NN":
                case "NNN":
                    if (abbr === eraName) return eras[i];
                    break;
                case "NNNN":
                    if (name === eraName) return eras[i];
                    break;
                case "NNNNN":
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return "";
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return "";
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return "";
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNameRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, "_erasAbbrRegex")) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNarrowRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);
            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }
        this._erasRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._erasNameRegex = new RegExp("^(" + namePieces.join("|") + ")", "i");
        this._erasAbbrRegex = new RegExp("^(" + abbrPieces.join("|") + ")", "i");
        this._erasNarrowRegex = new RegExp("^(" + narrowPieces.join("|") + ")", "i");
    }
    // FORMATTING
    addFormatToken(0, [
        "gg",
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        "GG",
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken("gggg", "weekYear");
    addWeekYearFormatToken("ggggg", "weekYear");
    addWeekYearFormatToken("GGGG", "isoWeekYear");
    addWeekYearFormatToken("GGGGG", "isoWeekYear");
    // ALIASES
    // PARSING
    addRegexToken("G", matchSigned);
    addRegexToken("g", matchSigned);
    addRegexToken("GG", match1to2, match2);
    addRegexToken("gg", match1to2, match2);
    addRegexToken("GGGG", match1to4, match4);
    addRegexToken("gggg", match1to4, match4);
    addRegexToken("GGGGG", match1to6, match6);
    addRegexToken("ggggg", match1to6, match6);
    addWeekParseToken([
        "gggg",
        "ggggg",
        "GGGG",
        "GGGGG"
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        "gg",
        "GG"
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken("Q", 0, "Qo", "quarter");
    // PARSING
    addRegexToken("Q", match1);
    addParseToken("Q", function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken("D", [
        "DD",
        2
    ], "Do", "date");
    // PARSING
    addRegexToken("D", match1to2, match1to2NoLeadingZero);
    addRegexToken("DD", match1to2, match2);
    addRegexToken("Do", function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        "D",
        "DD"
    ], DATE);
    addParseToken("Do", function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet("Date", true);
    // FORMATTING
    addFormatToken("DDD", [
        "DDDD",
        3
    ], "DDDo", "dayOfYear");
    // PARSING
    addRegexToken("DDD", match1to3);
    addRegexToken("DDDD", match3);
    addParseToken([
        "DDD",
        "DDDD"
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf("day") - this.clone().startOf("year")) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, "d");
    }
    // FORMATTING
    addFormatToken("m", [
        "mm",
        2
    ], 0, "minute");
    // PARSING
    addRegexToken("m", match1to2, match1to2HasZero);
    addRegexToken("mm", match1to2, match2);
    addParseToken([
        "m",
        "mm"
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet("Minutes", false);
    // FORMATTING
    addFormatToken("s", [
        "ss",
        2
    ], 0, "second");
    // PARSING
    addRegexToken("s", match1to2, match1to2HasZero);
    addRegexToken("ss", match1to2, match2);
    addParseToken([
        "s",
        "ss"
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet("Seconds", false);
    // FORMATTING
    addFormatToken("S", 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        "SS",
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        "SSS",
        3
    ], 0, "millisecond");
    addFormatToken(0, [
        "SSSS",
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        "SSSSS",
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        "SSSSSS",
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        "SSSSSSS",
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        "SSSSSSSS",
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        "SSSSSSSSS",
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // PARSING
    addRegexToken("S", match1to3, match1);
    addRegexToken("SS", match1to3, match2);
    addRegexToken("SSS", match1to3, match3);
    var token, getSetMillisecond;
    for(token = "SSSS"; token.length <= 9; token += "S")addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(("0." + input) * 1000);
    }
    for(token = "S"; token.length <= 9; token += "S")addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet("Milliseconds", false);
    // FORMATTING
    addFormatToken("z", 0, 0, "zoneAbbr");
    addFormatToken("zz", 0, 0, "zoneName");
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? "UTC" : "";
    }
    function getZoneName() {
        return this._isUTC ? "Coordinated Universal Time" : "";
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== "undefined" && Symbol.for != null) proto[Symbol.for("nodejs.util.inspect.custom")] = function() {
        return "Moment<" + this.format() + ">";
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate("dates accessor is deprecated. Use date instead.", getSetDayOfMonth);
    proto.months = deprecate("months accessor is deprecated. Use month instead", getSetMonth);
    proto.years = deprecate("years accessor is deprecated. Use year instead", getSetYear);
    proto.zone = deprecate("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/", getSetZone);
    proto.isDSTShifted = deprecate("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information", isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || "";
        if (index != null) return get$1(format, index, field, "month");
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, "month");
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === "boolean") {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, "day");
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, "day");
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, "months");
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, "monthsShort");
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdays");
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysShort");
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysMin");
    }
    getSetGlobalLocale("en", {
        eras: [
            {
                since: "0001-01-01",
                until: Infinity,
                offset: 1,
                name: "Anno Domini",
                narrow: "AD",
                abbr: "AD"
            },
            {
                since: "0000-12-31",
                until: -Infinity,
                offset: 1,
                name: "Before Christ",
                narrow: "BC",
                abbr: "BC"
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate("moment.lang is deprecated. Use moment.locale instead.", getSetGlobalLocale);
    hooks.langData = deprecate("moment.langData is deprecated. Use moment.localeData instead.", getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === "month" || units === "quarter" || units === "year") {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case "month":
                    return months;
                case "quarter":
                    return months / 3;
                case "year":
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case "week":
                    return days / 7 + milliseconds / 6048e5;
                case "day":
                    return days + milliseconds / 864e5;
                case "hour":
                    return days * 24 + milliseconds / 36e5;
                case "minute":
                    return days * 1440 + milliseconds / 6e4;
                case "second":
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case "millisecond":
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error("Unknown unit " + units);
            }
        }
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs("ms"), asSeconds = makeAs("s"), asMinutes = makeAs("m"), asHours = makeAs("h"), asDays = makeAs("d"), asWeeks = makeAs("w"), asMonths = makeAs("M"), asQuarters = makeAs("Q"), asYears = makeAs("y"), valueOf$1 = asMilliseconds;
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + "s"]() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter("milliseconds"), seconds = makeGetter("seconds"), minutes = makeGetter("minutes"), hours = makeGetter("hours"), days = makeGetter("days"), months = makeGetter("months"), years = makeGetter("years");
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as("s")), minutes = round(duration.as("m")), hours = round(duration.as("h")), days = round(duration.as("d")), months = round(duration.as("M")), weeks = round(duration.as("w")), years = round(duration.as("y")), a = seconds <= thresholds.ss && [
            "s",
            seconds
        ] || seconds < thresholds.s && [
            "ss",
            seconds
        ] || minutes <= 1 && [
            "m"
        ] || minutes < thresholds.m && [
            "mm",
            minutes
        ] || hours <= 1 && [
            "h"
        ] || hours < thresholds.h && [
            "hh",
            hours
        ] || days <= 1 && [
            "d"
        ] || days < thresholds.d && [
            "dd",
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            "w"
        ] || weeks < thresholds.w && [
            "ww",
            weeks
        ];
        a = a || months <= 1 && [
            "M"
        ] || months < thresholds.M && [
            "MM",
            months
        ] || years <= 1 && [
            "y"
        ] || [
            "yy",
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === "function") {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === "s") thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === "object") {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === "boolean") withSuffix = argWithSuffix;
        if (typeof argThresholds === "object") {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return "P0D";
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, "") : "";
        totalSign = total < 0 ? "-" : "";
        ymSign = sign(this._months) !== sign(total) ? "-" : "";
        daysSign = sign(this._days) !== sign(total) ? "-" : "";
        hmsSign = sign(this._milliseconds) !== sign(total) ? "-" : "";
        return totalSign + "P" + (years ? ymSign + years + "Y" : "") + (months ? ymSign + months + "M" : "") + (days ? daysSign + days + "D" : "") + (hours || minutes || seconds ? "T" : "") + (hours ? hmsSign + hours + "H" : "") + (minutes ? hmsSign + minutes + "M" : "") + (seconds ? hmsSign + s + "S" : "");
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)", toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken("X", 0, 0, "unix");
    addFormatToken("x", 0, 0, "valueOf");
    // PARSING
    addRegexToken("x", matchSigned);
    addRegexToken("X", matchTimestamp);
    addParseToken("X", function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken("x", function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = "2.30.1";
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
        DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
        DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
        DATE: "YYYY-MM-DD",
        TIME: "HH:mm",
        TIME_SECONDS: "HH:mm:ss",
        TIME_MS: "HH:mm:ss.SSS",
        WEEK: "GGGG-[W]WW",
        MONTH: "YYYY-MM"
    };
    return hooks;
});

});

parcelRequire.register("i4YVD", function(module, exports) {
/*!
 * jQuery JavaScript Library v3.7.1
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-08-28T13:37Z
 */ (function(global, factory) {
    "use strict";
    if (typeof module.exports === "object") // For CommonJS and CommonJS-like environments where a proper `window`
    // is present, execute the factory and get jQuery.
    // For environments that do not have a `window` with a `document`
    // (such as Node.js), expose a factory as module.exports.
    // This accentuates the need for the creation of a real `window`.
    // e.g. var jQuery = require("jquery")(window);
    // See ticket trac-14549 for more info.
    module.exports = global.document ? factory(global, true) : function(w) {
        if (!w.document) throw new Error("jQuery requires a window with a document");
        return factory(w);
    };
    else factory(global);
// Pass this if window is not defined yet
})(typeof window !== "undefined" ? window : module.exports, function(window1, noGlobal) {
    // Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
    // throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
    // arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
    // enough that all such attempts are guarded in a try block.
    "use strict";
    var arr = [];
    var getProto = Object.getPrototypeOf;
    var slice = arr.slice;
    var flat = arr.flat ? function(array) {
        return arr.flat.call(array);
    } : function(array) {
        return arr.concat.apply([], array);
    };
    var push = arr.push;
    var indexOf = arr.indexOf;
    var class2type = {};
    var toString = class2type.toString;
    var hasOwn = class2type.hasOwnProperty;
    var fnToString = hasOwn.toString;
    var ObjectFunctionString = fnToString.call(Object);
    var support = {};
    var isFunction = function isFunction(obj) {
        // Support: Chrome <=57, Firefox <=52
        // In some browsers, typeof returns "function" for HTML <object> elements
        // (i.e., `typeof document.createElement( "object" ) === "function"`).
        // We don't want to classify *any* DOM node as a function.
        // Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
        // Plus for old WebKit, typeof returns "function" for HTML collections
        // (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
        return typeof obj === "function" && typeof obj.nodeType !== "number" && typeof obj.item !== "function";
    };
    var isWindow = function isWindow(obj) {
        return obj != null && obj === obj.window;
    };
    var document = window1.document;
    var preservedScriptAttributes = {
        type: true,
        src: true,
        nonce: true,
        noModule: true
    };
    function DOMEval(code, node, doc) {
        doc = doc || document;
        var i, val, script = doc.createElement("script");
        script.text = code;
        if (node) for(i in preservedScriptAttributes){
            // Support: Firefox 64+, Edge 18+
            // Some browsers don't support the "nonce" property on scripts.
            // On the other hand, just using `getAttribute` is not enough as
            // the `nonce` attribute is reset to an empty string whenever it
            // becomes browsing-context connected.
            // See https://github.com/whatwg/html/issues/2369
            // See https://html.spec.whatwg.org/#nonce-attributes
            // The `node.getAttribute` check was added for the sake of
            // `jQuery.globalEval` so that it can fake a nonce-containing node
            // via an object.
            val = node[i] || node.getAttribute && node.getAttribute(i);
            if (val) script.setAttribute(i, val);
        }
        doc.head.appendChild(script).parentNode.removeChild(script);
    }
    function toType(obj) {
        if (obj == null) return obj + "";
        // Support: Android <=2.3 only (functionish RegExp)
        return typeof obj === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : typeof obj;
    }
    /* global Symbol */ // Defining this global in .eslintrc.json would create a danger of using the global
    // unguarded in another place, it seems safer to define global only for this module
    var version = "3.7.1", rhtmlSuffix = /HTML$/i, // Define a local copy of jQuery
    jQuery = function(selector, context) {
        // The jQuery object is actually just the init constructor 'enhanced'
        // Need init if jQuery is called (just allow error to be thrown if not included)
        return new jQuery.fn.init(selector, context);
    };
    jQuery.fn = jQuery.prototype = {
        // The current version of jQuery being used
        jquery: version,
        constructor: jQuery,
        // The default length of a jQuery object is 0
        length: 0,
        toArray: function() {
            return slice.call(this);
        },
        // Get the Nth element in the matched element set OR
        // Get the whole matched element set as a clean array
        get: function(num) {
            // Return all the elements in a clean array
            if (num == null) return slice.call(this);
            // Return just the one element from the set
            return num < 0 ? this[num + this.length] : this[num];
        },
        // Take an array of elements and push it onto the stack
        // (returning the new matched element set)
        pushStack: function(elems) {
            // Build a new jQuery matched element set
            var ret = jQuery.merge(this.constructor(), elems);
            // Add the old object onto the stack (as a reference)
            ret.prevObject = this;
            // Return the newly-formed element set
            return ret;
        },
        // Execute a callback for every element in the matched set.
        each: function(callback) {
            return jQuery.each(this, callback);
        },
        map: function(callback) {
            return this.pushStack(jQuery.map(this, function(elem, i) {
                return callback.call(elem, i, elem);
            }));
        },
        slice: function() {
            return this.pushStack(slice.apply(this, arguments));
        },
        first: function() {
            return this.eq(0);
        },
        last: function() {
            return this.eq(-1);
        },
        even: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return (i + 1) % 2;
            }));
        },
        odd: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return i % 2;
            }));
        },
        eq: function(i) {
            var len = this.length, j = +i + (i < 0 ? len : 0);
            return this.pushStack(j >= 0 && j < len ? [
                this[j]
            ] : []);
        },
        end: function() {
            return this.prevObject || this.constructor();
        },
        // For internal use only.
        // Behaves like an Array's method, not like a jQuery method.
        push: push,
        sort: arr.sort,
        splice: arr.splice
    };
    jQuery.extend = jQuery.fn.extend = function() {
        var options, name, src, copy, copyIsArray, clone, target = arguments[0] || {}, i = 1, length = arguments.length, deep = false;
        // Handle a deep copy situation
        if (typeof target === "boolean") {
            deep = target;
            // Skip the boolean and the target
            target = arguments[i] || {};
            i++;
        }
        // Handle case when target is a string or something (possible in deep copy)
        if (typeof target !== "object" && !isFunction(target)) target = {};
        // Extend jQuery itself if only one argument is passed
        if (i === length) {
            target = this;
            i--;
        }
        for(; i < length; i++){
            // Only deal with non-null/undefined values
            if ((options = arguments[i]) != null) // Extend the base object
            for(name in options){
                copy = options[name];
                // Prevent Object.prototype pollution
                // Prevent never-ending loop
                if (name === "__proto__" || target === copy) continue;
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
                    src = target[name];
                    // Ensure proper type for the source value
                    if (copyIsArray && !Array.isArray(src)) clone = [];
                    else if (!copyIsArray && !jQuery.isPlainObject(src)) clone = {};
                    else clone = src;
                    copyIsArray = false;
                    // Never move original objects, clone them
                    target[name] = jQuery.extend(deep, clone, copy);
                // Don't bring in undefined values
                } else if (copy !== undefined) target[name] = copy;
            }
        }
        // Return the modified object
        return target;
    };
    jQuery.extend({
        // Unique for each copy of jQuery on the page
        expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
        // Assume jQuery is ready without the ready module
        isReady: true,
        error: function(msg) {
            throw new Error(msg);
        },
        noop: function() {},
        isPlainObject: function(obj) {
            var proto, Ctor;
            // Detect obvious negatives
            // Use toString instead of jQuery.type to catch host objects
            if (!obj || toString.call(obj) !== "[object Object]") return false;
            proto = getProto(obj);
            // Objects with no prototype (e.g., `Object.create( null )`) are plain
            if (!proto) return true;
            // Objects with prototype are plain iff they were constructed by a global Object function
            Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
            return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
        },
        isEmptyObject: function(obj) {
            var name;
            for(name in obj)return false;
            return true;
        },
        // Evaluates a script in a provided context; falls back to the global one
        // if not specified.
        globalEval: function(code, options, doc) {
            DOMEval(code, {
                nonce: options && options.nonce
            }, doc);
        },
        each: function(obj, callback) {
            var length, i = 0;
            if (isArrayLike(obj)) {
                length = obj.length;
                for(; i < length; i++){
                    if (callback.call(obj[i], i, obj[i]) === false) break;
                }
            } else for(i in obj){
                if (callback.call(obj[i], i, obj[i]) === false) break;
            }
            return obj;
        },
        // Retrieve the text value of an array of DOM nodes
        text: function(elem) {
            var node, ret = "", i = 0, nodeType = elem.nodeType;
            if (!nodeType) // If no nodeType, this is expected to be an array
            while(node = elem[i++])// Do not traverse comment nodes
            ret += jQuery.text(node);
            if (nodeType === 1 || nodeType === 11) return elem.textContent;
            if (nodeType === 9) return elem.documentElement.textContent;
            if (nodeType === 3 || nodeType === 4) return elem.nodeValue;
            // Do not include comment or processing instruction nodes
            return ret;
        },
        // results is for internal usage only
        makeArray: function(arr, results) {
            var ret = results || [];
            if (arr != null) {
                if (isArrayLike(Object(arr))) jQuery.merge(ret, typeof arr === "string" ? [
                    arr
                ] : arr);
                else push.call(ret, arr);
            }
            return ret;
        },
        inArray: function(elem, arr, i) {
            return arr == null ? -1 : indexOf.call(arr, elem, i);
        },
        isXMLDoc: function(elem) {
            var namespace = elem && elem.namespaceURI, docElem = elem && (elem.ownerDocument || elem).documentElement;
            // Assume HTML when documentElement doesn't yet exist, such as inside
            // document fragments.
            return !rhtmlSuffix.test(namespace || docElem && docElem.nodeName || "HTML");
        },
        // Support: Android <=4.0 only, PhantomJS 1 only
        // push.apply(_, arraylike) throws on ancient WebKit
        merge: function(first, second) {
            var len = +second.length, j = 0, i = first.length;
            for(; j < len; j++)first[i++] = second[j];
            first.length = i;
            return first;
        },
        grep: function(elems, callback, invert) {
            var callbackInverse, matches = [], i = 0, length = elems.length, callbackExpect = !invert;
            // Go through the array, only saving the items
            // that pass the validator function
            for(; i < length; i++){
                callbackInverse = !callback(elems[i], i);
                if (callbackInverse !== callbackExpect) matches.push(elems[i]);
            }
            return matches;
        },
        // arg is for internal usage only
        map: function(elems, callback, arg) {
            var length, value, i = 0, ret = [];
            // Go through the array, translating each of the items to their new values
            if (isArrayLike(elems)) {
                length = elems.length;
                for(; i < length; i++){
                    value = callback(elems[i], i, arg);
                    if (value != null) ret.push(value);
                }
            // Go through every key on the object,
            } else for(i in elems){
                value = callback(elems[i], i, arg);
                if (value != null) ret.push(value);
            }
            // Flatten any nested arrays
            return flat(ret);
        },
        // A global GUID counter for objects
        guid: 1,
        // jQuery.support is not used in Core but other projects attach their
        // properties to it so it needs to exist.
        support: support
    });
    if (typeof Symbol === "function") jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
    // Populate the class2type map
    jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(_i, name) {
        class2type["[object " + name + "]"] = name.toLowerCase();
    });
    function isArrayLike(obj) {
        // Support: real iOS 8.2 only (not reproducible in simulator)
        // `in` check used to prevent JIT error (gh-2145)
        // hasOwn isn't used here due to false negatives
        // regarding Nodelist length in IE
        var length = !!obj && "length" in obj && obj.length, type = toType(obj);
        if (isFunction(obj) || isWindow(obj)) return false;
        return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
    }
    function nodeName(elem, name) {
        return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
    }
    var pop = arr.pop;
    var sort = arr.sort;
    var splice = arr.splice;
    var whitespace = "[\\x20\\t\\r\\n\\f]";
    var rtrimCSS = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g");
    // Note: an element does not contain itself
    jQuery.contains = function(a, b) {
        var bup = b && b.parentNode;
        return a === bup || !!(bup && bup.nodeType === 1 && // Support: IE 9 - 11+
        // IE doesn't have `contains` on SVG.
        (a.contains ? a.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
    };
    // CSS string/identifier serialization
    // https://drafts.csswg.org/cssom/#common-serializing-idioms
    var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
    function fcssescape(ch, asCodePoint) {
        if (asCodePoint) {
            // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
            if (ch === "\x00") return "�";
            // Control characters and (dependent upon position) numbers get escaped as code points
            return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
        }
        // Other potentially-special ASCII characters get backslash-escaped
        return "\\" + ch;
    }
    jQuery.escapeSelector = function(sel) {
        return (sel + "").replace(rcssescape, fcssescape);
    };
    var preferredDoc = document, pushNative = push;
    (function() {
        var i, Expr, outermostContext, sortInput, hasDuplicate, push = pushNative, // Local document vars
        document, documentElement, documentIsHTML, rbuggyQSA, matches, // Instance-specific data
        expando = jQuery.expando, dirruns = 0, done = 0, classCache = createCache(), tokenCache = createCache(), compilerCache = createCache(), nonnativeSelectorCache = createCache(), sortOrder = function(a, b) {
            if (a === b) hasDuplicate = true;
            return 0;
        }, booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", // Regular expressions
        // https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
        identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\x00-\\x7f])+", // Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
        attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace + // Operator (capture 2)
        "*([*^$|!~]?=)" + whitespace + // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
        "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]", pseudos = ":(" + identifier + ")(?:\\((" + // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
        // 1. quoted (capture 3; capture 4 or capture 5)
        "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" + // 2. simple (capture 6)
        "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" + // 3. anything else (capture 2)
        ".*" + ")\\)|)", // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
        rwhitespace = new RegExp(whitespace + "+", "g"), rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"), rleadingCombinator = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"), rdescend = new RegExp(whitespace + "|>"), rpseudo = new RegExp(pseudos), ridentifier = new RegExp("^" + identifier + "$"), matchExpr = {
            ID: new RegExp("^#(" + identifier + ")"),
            CLASS: new RegExp("^\\.(" + identifier + ")"),
            TAG: new RegExp("^(" + identifier + "|[*])"),
            ATTR: new RegExp("^" + attributes),
            PSEUDO: new RegExp("^" + pseudos),
            CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
            bool: new RegExp("^(?:" + booleans + ")$", "i"),
            // For use in libraries implementing .is()
            // We use this for POS matching in `select`
            needsContext: new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
        }, rinputs = /^(?:input|select|textarea|button)$/i, rheader = /^h\d$/i, // Easily-parseable/retrievable ID or TAG or CLASS selectors
        rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, rsibling = /[+~]/, // CSS escapes
        // https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
        runescape = new RegExp("\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g"), funescape = function(escape, nonHex) {
            var high = "0x" + escape.slice(1) - 0x10000;
            if (nonHex) // Strip the backslash prefix from a non-hex escape sequence
            return nonHex;
            // Replace a hexadecimal escape sequence with the encoded Unicode code point
            // Support: IE <=11+
            // For values outside the Basic Multilingual Plane (BMP), manually construct a
            // surrogate pair
            return high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
        }, // Used for iframes; see `setDocument`.
        // Support: IE 9 - 11+, Edge 12 - 18+
        // Removing the function wrapper causes a "Permission Denied"
        // error in IE/Edge.
        unloadHandler = function() {
            setDocument();
        }, inDisabledFieldset = addCombinator(function(elem) {
            return elem.disabled === true && nodeName(elem, "fieldset");
        }, {
            dir: "parentNode",
            next: "legend"
        });
        // Support: IE <=9 only
        // Accessing document.activeElement can throw unexpectedly
        // https://bugs.jquery.com/ticket/13393
        function safeActiveElement() {
            try {
                return document.activeElement;
            } catch (err) {}
        }
        // Optimize for push.apply( _, NodeList )
        try {
            push.apply(arr = slice.call(preferredDoc.childNodes), preferredDoc.childNodes);
            // Support: Android <=4.0
            // Detect silently failing push.apply
            // eslint-disable-next-line no-unused-expressions
            arr[preferredDoc.childNodes.length].nodeType;
        } catch (e) {
            push = {
                apply: function(target, els) {
                    pushNative.apply(target, slice.call(els));
                },
                call: function(target) {
                    pushNative.apply(target, slice.call(arguments, 1));
                }
            };
        }
        function find(selector, context, results, seed) {
            var m, i, elem, nid, match, groups, newSelector, newContext = context && context.ownerDocument, // nodeType defaults to 9, since context defaults to document
            nodeType = context ? context.nodeType : 9;
            results = results || [];
            // Return early from calls with invalid selector or context
            if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) return results;
            // Try to shortcut find operations (as opposed to filters) in HTML documents
            if (!seed) {
                setDocument(context);
                context = context || document;
                if (documentIsHTML) {
                    // If the selector is sufficiently simple, try using a "get*By*" DOM method
                    // (excepting DocumentFragment context, where the methods don't exist)
                    if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {
                        // ID selector
                        if (m = match[1]) {
                            // Document context
                            if (nodeType === 9) {
                                if (elem = context.getElementById(m)) // Support: IE 9 only
                                // getElementById can match elements by name instead of ID
                                {
                                    if (elem.id === m) {
                                        push.call(results, elem);
                                        return results;
                                    }
                                } else return results;
                            // Element context
                            } else // Support: IE 9 only
                            // getElementById can match elements by name instead of ID
                            if (newContext && (elem = newContext.getElementById(m)) && find.contains(context, elem) && elem.id === m) {
                                push.call(results, elem);
                                return results;
                            }
                        // Type selector
                        } else if (match[2]) {
                            push.apply(results, context.getElementsByTagName(selector));
                            return results;
                        // Class selector
                        } else if ((m = match[3]) && context.getElementsByClassName) {
                            push.apply(results, context.getElementsByClassName(m));
                            return results;
                        }
                    }
                    // Take advantage of querySelectorAll
                    if (!nonnativeSelectorCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
                        newSelector = selector;
                        newContext = context;
                        // qSA considers elements outside a scoping root when evaluating child or
                        // descendant combinators, which is not what we want.
                        // In such cases, we work around the behavior by prefixing every selector in the
                        // list with an ID selector referencing the scope context.
                        // The technique has to be used as well when a leading combinator is used
                        // as such selectors are not recognized by querySelectorAll.
                        // Thanks to Andrew Dupont for this technique.
                        if (nodeType === 1 && (rdescend.test(selector) || rleadingCombinator.test(selector))) {
                            // Expand context for sibling selectors
                            newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
                            // We can use :scope instead of the ID hack if the browser
                            // supports it & if we're not changing the context.
                            // Support: IE 11+, Edge 17 - 18+
                            // IE/Edge sometimes throw a "Permission denied" error when
                            // strict-comparing two documents; shallow comparisons work.
                            // eslint-disable-next-line eqeqeq
                            if (newContext != context || !support.scope) {
                                // Capture the context ID, setting it first if necessary
                                if (nid = context.getAttribute("id")) nid = jQuery.escapeSelector(nid);
                                else context.setAttribute("id", nid = expando);
                            }
                            // Prefix every selector in the list
                            groups = tokenize(selector);
                            i = groups.length;
                            while(i--)groups[i] = (nid ? "#" + nid : ":scope") + " " + toSelector(groups[i]);
                            newSelector = groups.join(",");
                        }
                        try {
                            push.apply(results, newContext.querySelectorAll(newSelector));
                            return results;
                        } catch (qsaError) {
                            nonnativeSelectorCache(selector, true);
                        } finally{
                            if (nid === expando) context.removeAttribute("id");
                        }
                    }
                }
            }
            // All others
            return select(selector.replace(rtrimCSS, "$1"), context, results, seed);
        }
        /**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */ function createCache() {
            var keys = [];
            function cache(key, value) {
                // Use (key + " ") to avoid collision with native prototype properties
                // (see https://github.com/jquery/sizzle/issues/157)
                if (keys.push(key + " ") > Expr.cacheLength) // Only keep the most recent entries
                delete cache[keys.shift()];
                return cache[key + " "] = value;
            }
            return cache;
        }
        /**
 * Mark a function for special use by jQuery selector module
 * @param {Function} fn The function to mark
 */ function markFunction(fn) {
            fn[expando] = true;
            return fn;
        }
        /**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */ function assert(fn) {
            var el = document.createElement("fieldset");
            try {
                return !!fn(el);
            } catch (e) {
                return false;
            } finally{
                // Remove from its parent by default
                if (el.parentNode) el.parentNode.removeChild(el);
                // release memory in IE
                el = null;
            }
        }
        /**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */ function createInputPseudo(type) {
            return function(elem) {
                return nodeName(elem, "input") && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */ function createButtonPseudo(type) {
            return function(elem) {
                return (nodeName(elem, "input") || nodeName(elem, "button")) && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */ function createDisabledPseudo(disabled) {
            // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
            return function(elem) {
                // Only certain elements can match :enabled or :disabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
                if ("form" in elem) {
                    // Check for inherited disabledness on relevant non-disabled elements:
                    // * listed form-associated elements in a disabled fieldset
                    //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
                    // * option elements in a disabled optgroup
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
                    // All such elements have a "form" property.
                    if (elem.parentNode && elem.disabled === false) {
                        // Option elements defer to a parent optgroup if present
                        if ("label" in elem) {
                            if ("label" in elem.parentNode) return elem.parentNode.disabled === disabled;
                            else return elem.disabled === disabled;
                        }
                        // Support: IE 6 - 11+
                        // Use the isDisabled shortcut property to check for disabled fieldset ancestors
                        return elem.isDisabled === disabled || // Where there is no isDisabled, check manually
                        elem.isDisabled !== !disabled && inDisabledFieldset(elem) === disabled;
                    }
                    return elem.disabled === disabled;
                // Try to winnow out elements that can't be disabled before trusting the disabled property.
                // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
                // even exist on them, let alone have a boolean value.
                } else if ("label" in elem) return elem.disabled === disabled;
                // Remaining elements are neither :enabled nor :disabled
                return false;
            };
        }
        /**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */ function createPositionalPseudo(fn) {
            return markFunction(function(argument) {
                argument = +argument;
                return markFunction(function(seed, matches) {
                    var j, matchIndexes = fn([], seed.length, argument), i = matchIndexes.length;
                    // Match elements found at the specified indexes
                    while(i--)if (seed[j = matchIndexes[i]]) seed[j] = !(matches[j] = seed[j]);
                });
            });
        }
        /**
 * Checks a node for validity as a jQuery selector context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */ function testContext(context) {
            return context && typeof context.getElementsByTagName !== "undefined" && context;
        }
        /**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [node] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */ function setDocument(node) {
            var subWindow, doc = node ? node.ownerDocument || node : preferredDoc;
            // Return early if doc is invalid or already selected
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (doc == document || doc.nodeType !== 9 || !doc.documentElement) return document;
            // Update global variables
            document = doc;
            documentElement = document.documentElement;
            documentIsHTML = !jQuery.isXMLDoc(document);
            // Support: iOS 7 only, IE 9 - 11+
            // Older browsers didn't support unprefixed `matches`.
            matches = documentElement.matches || documentElement.webkitMatchesSelector || documentElement.msMatchesSelector;
            // Support: IE 9 - 11+, Edge 12 - 18+
            // Accessing iframe documents after unload throws "permission denied" errors
            // (see trac-13936).
            // Limit the fix to IE & Edge Legacy; despite Edge 15+ implementing `matches`,
            // all IE 9+ and Edge Legacy versions implement `msMatchesSelector` as well.
            if (documentElement.msMatchesSelector && // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            preferredDoc != document && (subWindow = document.defaultView) && subWindow.top !== subWindow) // Support: IE 9 - 11+, Edge 12 - 18+
            subWindow.addEventListener("unload", unloadHandler);
            // Support: IE <10
            // Check if getElementById returns elements by name
            // The broken getElementById methods don't pick up programmatically-set names,
            // so use a roundabout getElementsByName test
            support.getById = assert(function(el) {
                documentElement.appendChild(el).id = jQuery.expando;
                return !document.getElementsByName || !document.getElementsByName(jQuery.expando).length;
            });
            // Support: IE 9 only
            // Check to see if it's possible to do matchesSelector
            // on a disconnected node.
            support.disconnectedMatch = assert(function(el) {
                return matches.call(el, "*");
            });
            // Support: IE 9 - 11+, Edge 12 - 18+
            // IE/Edge don't support the :scope pseudo-class.
            support.scope = assert(function() {
                return document.querySelectorAll(":scope");
            });
            // Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
            // Make sure the `:has()` argument is parsed unforgivingly.
            // We include `*` in the test to detect buggy implementations that are
            // _selectively_ forgiving (specifically when the list includes at least
            // one valid selector).
            // Note that we treat complete lack of support for `:has()` as if it were
            // spec-compliant support, which is fine because use of `:has()` in such
            // environments will fail in the qSA path and fall back to jQuery traversal
            // anyway.
            support.cssHas = assert(function() {
                try {
                    document.querySelector(":has(*,:jqfake)");
                    return false;
                } catch (e) {
                    return true;
                }
            });
            // ID filter and find
            if (support.getById) {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        return elem.getAttribute("id") === attrId;
                    };
                };
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var elem = context.getElementById(id);
                        return elem ? [
                            elem
                        ] : [];
                    }
                };
            } else {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
                        return node && node.value === attrId;
                    };
                };
                // Support: IE 6 - 7 only
                // getElementById is not reliable as a find shortcut
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var node, i, elems, elem = context.getElementById(id);
                        if (elem) {
                            // Verify the id attribute
                            node = elem.getAttributeNode("id");
                            if (node && node.value === id) return [
                                elem
                            ];
                            // Fall back on getElementsByName
                            elems = context.getElementsByName(id);
                            i = 0;
                            while(elem = elems[i++]){
                                node = elem.getAttributeNode("id");
                                if (node && node.value === id) return [
                                    elem
                                ];
                            }
                        }
                        return [];
                    }
                };
            }
            // Tag
            Expr.find.TAG = function(tag, context) {
                if (typeof context.getElementsByTagName !== "undefined") return context.getElementsByTagName(tag);
                else return context.querySelectorAll(tag);
            };
            // Class
            Expr.find.CLASS = function(className, context) {
                if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) return context.getElementsByClassName(className);
            };
            /* QSA/matchesSelector
	---------------------------------------------------------------------- */ // QSA and matchesSelector support
            rbuggyQSA = [];
            // Build QSA regex
            // Regex strategy adopted from Diego Perini
            assert(function(el) {
                var input;
                documentElement.appendChild(el).innerHTML = "<a id='" + expando + "' href='' disabled='disabled'></a>" + "<select id='" + expando + "-\r\\' disabled='disabled'>" + "<option selected=''></option></select>";
                // Support: iOS <=7 - 8 only
                // Boolean attributes and "value" are not treated correctly in some XML documents
                if (!el.querySelectorAll("[selected]").length) rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
                // Support: iOS <=7 - 8 only
                if (!el.querySelectorAll("[id~=" + expando + "-]").length) rbuggyQSA.push("~=");
                // Support: iOS 8 only
                // https://bugs.webkit.org/show_bug.cgi?id=136851
                // In-page `selector#id sibling-combinator selector` fails
                if (!el.querySelectorAll("a#" + expando + "+*").length) rbuggyQSA.push(".#.+[+~]");
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                if (!el.querySelectorAll(":checked").length) rbuggyQSA.push(":checked");
                // Support: Windows 8 Native Apps
                // The type and name attributes are restricted during .innerHTML assignment
                input = document.createElement("input");
                input.setAttribute("type", "hidden");
                el.appendChild(input).setAttribute("name", "D");
                // Support: IE 9 - 11+
                // IE's :disabled selector does not pick up the children of disabled fieldsets
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                documentElement.appendChild(el).disabled = true;
                if (el.querySelectorAll(":disabled").length !== 2) rbuggyQSA.push(":enabled", ":disabled");
                // Support: IE 11+, Edge 15 - 18+
                // IE 11/Edge don't find elements on a `[name='']` query in some cases.
                // Adding a temporary attribute to the document before the selection works
                // around the issue.
                // Interestingly, IE 10 & older don't seem to have the issue.
                input = document.createElement("input");
                input.setAttribute("name", "");
                el.appendChild(input);
                if (!el.querySelectorAll("[name='']").length) rbuggyQSA.push("\\[" + whitespace + "*name" + whitespace + "*=" + whitespace + "*(?:''|\"\")");
            });
            if (!support.cssHas) // Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
            // Our regular `try-catch` mechanism fails to detect natively-unsupported
            // pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
            // in browsers that parse the `:has()` argument as a forgiving selector list.
            // https://drafts.csswg.org/selectors/#relational now requires the argument
            // to be parsed unforgivingly, but browsers have not yet fully adjusted.
            rbuggyQSA.push(":has");
            rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
            /* Sorting
	---------------------------------------------------------------------- */ // Document order sorting
            sortOrder = function(a, b) {
                // Flag for duplicate removal
                if (a === b) {
                    hasDuplicate = true;
                    return 0;
                }
                // Sort on method existence if only one input has compareDocumentPosition
                var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
                if (compare) return compare;
                // Calculate position if both inputs belong to the same document
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                compare = (a.ownerDocument || a) == (b.ownerDocument || b) ? a.compareDocumentPosition(b) : // Otherwise we know they are disconnected
                1;
                // Disconnected nodes
                if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {
                    // Choose the first element that is related to our preferred document
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (a === document || a.ownerDocument == preferredDoc && find.contains(preferredDoc, a)) return -1;
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (b === document || b.ownerDocument == preferredDoc && find.contains(preferredDoc, b)) return 1;
                    // Maintain original order
                    return sortInput ? indexOf.call(sortInput, a) - indexOf.call(sortInput, b) : 0;
                }
                return compare & 4 ? -1 : 1;
            };
            return document;
        }
        find.matches = function(expr, elements) {
            return find(expr, null, null, elements);
        };
        find.matchesSelector = function(elem, expr) {
            setDocument(elem);
            if (documentIsHTML && !nonnativeSelectorCache[expr + " "] && (!rbuggyQSA || !rbuggyQSA.test(expr))) try {
                var ret = matches.call(elem, expr);
                // IE 9's matchesSelector returns false on disconnected nodes
                if (ret || support.disconnectedMatch || // As well, disconnected nodes are said to be in a document
                // fragment in IE 9
                elem.document && elem.document.nodeType !== 11) return ret;
            } catch (e) {
                nonnativeSelectorCache(expr, true);
            }
            return find(expr, document, null, [
                elem
            ]).length > 0;
        };
        find.contains = function(context, elem) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((context.ownerDocument || context) != document) setDocument(context);
            return jQuery.contains(context, elem);
        };
        find.attr = function(elem, name) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((elem.ownerDocument || elem) != document) setDocument(elem);
            var fn = Expr.attrHandle[name.toLowerCase()], // Don't get fooled by Object.prototype properties (see trac-13807)
            val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;
            if (val !== undefined) return val;
            return elem.getAttribute(name);
        };
        find.error = function(msg) {
            throw new Error("Syntax error, unrecognized expression: " + msg);
        };
        /**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */ jQuery.uniqueSort = function(results) {
            var elem, duplicates = [], j = 0, i = 0;
            // Unless we *know* we can detect duplicates, assume their presence
            //
            // Support: Android <=4.0+
            // Testing for detecting duplicates is unpredictable so instead assume we can't
            // depend on duplicate detection in all browsers without a stable sort.
            hasDuplicate = !support.sortStable;
            sortInput = !support.sortStable && slice.call(results, 0);
            sort.call(results, sortOrder);
            if (hasDuplicate) {
                while(elem = results[i++])if (elem === results[i]) j = duplicates.push(i);
                while(j--)splice.call(results, duplicates[j], 1);
            }
            // Clear input after sorting to release objects
            // See https://github.com/jquery/sizzle/pull/225
            sortInput = null;
            return results;
        };
        jQuery.fn.uniqueSort = function() {
            return this.pushStack(jQuery.uniqueSort(slice.apply(this)));
        };
        Expr = jQuery.expr = {
            // Can be adjusted by the user
            cacheLength: 50,
            createPseudo: markFunction,
            match: matchExpr,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: true
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: true
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                ATTR: function(match) {
                    match[1] = match[1].replace(runescape, funescape);
                    // Move the given value to match[3] whether quoted or unquoted
                    match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);
                    if (match[2] === "~=") match[3] = " " + match[3] + " ";
                    return match.slice(0, 4);
                },
                CHILD: function(match) {
                    /* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/ match[1] = match[1].toLowerCase();
                    if (match[1].slice(0, 3) === "nth") {
                        // nth-* requires argument
                        if (!match[3]) find.error(match[0]);
                        // numeric x and y parameters for Expr.filter.CHILD
                        // remember that false/true cast respectively to 0/1
                        match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
                        match[5] = +(match[7] + match[8] || match[3] === "odd");
                    // other types prohibit arguments
                    } else if (match[3]) find.error(match[0]);
                    return match;
                },
                PSEUDO: function(match) {
                    var excess, unquoted = !match[6] && match[2];
                    if (matchExpr.CHILD.test(match[0])) return null;
                    // Accept quoted arguments as-is
                    if (match[3]) match[2] = match[4] || match[5] || "";
                    else if (unquoted && rpseudo.test(unquoted) && // Get excess from tokenize (recursively)
                    (excess = tokenize(unquoted, true)) && // advance to the next closing parenthesis
                    (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
                        // excess is a negative index
                        match[0] = match[0].slice(0, excess);
                        match[2] = unquoted.slice(0, excess);
                    }
                    // Return only captures needed by the pseudo filter method (type and argument)
                    return match.slice(0, 3);
                }
            },
            filter: {
                TAG: function(nodeNameSelector) {
                    var expectedNodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
                    return nodeNameSelector === "*" ? function() {
                        return true;
                    } : function(elem) {
                        return nodeName(elem, expectedNodeName);
                    };
                },
                CLASS: function(className) {
                    var pattern = classCache[className + " "];
                    return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)"), classCache(className, function(elem) {
                        return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
                    }));
                },
                ATTR: function(name, operator, check) {
                    return function(elem) {
                        var result = find.attr(elem, name);
                        if (result == null) return operator === "!=";
                        if (!operator) return true;
                        result += "";
                        if (operator === "=") return result === check;
                        if (operator === "!=") return result !== check;
                        if (operator === "^=") return check && result.indexOf(check) === 0;
                        if (operator === "*=") return check && result.indexOf(check) > -1;
                        if (operator === "$=") return check && result.slice(-check.length) === check;
                        if (operator === "~=") return (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1;
                        if (operator === "|=") return result === check || result.slice(0, check.length + 1) === check + "-";
                        return false;
                    };
                },
                CHILD: function(type, what, _argument, first, last) {
                    var simple = type.slice(0, 3) !== "nth", forward = type.slice(-4) !== "last", ofType = what === "of-type";
                    return first === 1 && last === 0 ? // Shortcut for :nth-*(n)
                    function(elem) {
                        return !!elem.parentNode;
                    } : function(elem, _context, xml) {
                        var cache, outerCache, node, nodeIndex, start, dir = simple !== forward ? "nextSibling" : "previousSibling", parent = elem.parentNode, name = ofType && elem.nodeName.toLowerCase(), useCache = !xml && !ofType, diff = false;
                        if (parent) {
                            // :(first|last|only)-(child|of-type)
                            if (simple) {
                                while(dir){
                                    node = elem;
                                    while(node = node[dir]){
                                        if (ofType ? nodeName(node, name) : node.nodeType === 1) return false;
                                    }
                                    // Reverse direction for :only-* (if we haven't yet done so)
                                    start = dir = type === "only" && !start && "nextSibling";
                                }
                                return true;
                            }
                            start = [
                                forward ? parent.firstChild : parent.lastChild
                            ];
                            // non-xml :nth-child(...) stores cache data on `parent`
                            if (forward && useCache) {
                                // Seek `elem` from a previously-cached index
                                outerCache = parent[expando] || (parent[expando] = {});
                                cache = outerCache[type] || [];
                                nodeIndex = cache[0] === dirruns && cache[1];
                                diff = nodeIndex && cache[2];
                                node = nodeIndex && parent.childNodes[nodeIndex];
                                while(node = ++nodeIndex && node && node[dir] || // Fallback to seeking `elem` from the start
                                (diff = nodeIndex = 0) || start.pop())// When found, cache indexes on `parent` and break
                                if (node.nodeType === 1 && ++diff && node === elem) {
                                    outerCache[type] = [
                                        dirruns,
                                        nodeIndex,
                                        diff
                                    ];
                                    break;
                                }
                            } else {
                                // Use previously-cached element index if available
                                if (useCache) {
                                    outerCache = elem[expando] || (elem[expando] = {});
                                    cache = outerCache[type] || [];
                                    nodeIndex = cache[0] === dirruns && cache[1];
                                    diff = nodeIndex;
                                }
                                // xml :nth-child(...)
                                // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                                if (diff === false) {
                                    // Use the same loop as above to seek `elem` from the start
                                    while(node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop())if ((ofType ? nodeName(node, name) : node.nodeType === 1) && ++diff) {
                                        // Cache the index of each encountered element
                                        if (useCache) {
                                            outerCache = node[expando] || (node[expando] = {});
                                            outerCache[type] = [
                                                dirruns,
                                                diff
                                            ];
                                        }
                                        if (node === elem) break;
                                    }
                                }
                            }
                            // Incorporate the offset, then check against cycle size
                            diff -= last;
                            return diff === first || diff % first === 0 && diff / first >= 0;
                        }
                    };
                },
                PSEUDO: function(pseudo, argument) {
                    // pseudo-class names are case-insensitive
                    // https://www.w3.org/TR/selectors/#pseudo-classes
                    // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
                    // Remember that setFilters inherits from pseudos
                    var args, fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || find.error("unsupported pseudo: " + pseudo);
                    // The user may use createPseudo to indicate that
                    // arguments are needed to create the filter function
                    // just as jQuery does
                    if (fn[expando]) return fn(argument);
                    // But maintain support for old signatures
                    if (fn.length > 1) {
                        args = [
                            pseudo,
                            pseudo,
                            "",
                            argument
                        ];
                        return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function(seed, matches) {
                            var idx, matched = fn(seed, argument), i = matched.length;
                            while(i--){
                                idx = indexOf.call(seed, matched[i]);
                                seed[idx] = !(matches[idx] = matched[i]);
                            }
                        }) : function(elem) {
                            return fn(elem, 0, args);
                        };
                    }
                    return fn;
                }
            },
            pseudos: {
                // Potentially complex pseudos
                not: markFunction(function(selector) {
                    // Trim the selector passed to compile
                    // to avoid treating leading and trailing
                    // spaces as combinators
                    var input = [], results = [], matcher = compile(selector.replace(rtrimCSS, "$1"));
                    return matcher[expando] ? markFunction(function(seed, matches, _context, xml) {
                        var elem, unmatched = matcher(seed, null, xml, []), i = seed.length;
                        // Match elements unmatched by `matcher`
                        while(i--)if (elem = unmatched[i]) seed[i] = !(matches[i] = elem);
                    }) : function(elem, _context, xml) {
                        input[0] = elem;
                        matcher(input, null, xml, results);
                        // Don't keep the element
                        // (see https://github.com/jquery/sizzle/issues/299)
                        input[0] = null;
                        return !results.pop();
                    };
                }),
                has: markFunction(function(selector) {
                    return function(elem) {
                        return find(selector, elem).length > 0;
                    };
                }),
                contains: markFunction(function(text) {
                    text = text.replace(runescape, funescape);
                    return function(elem) {
                        return (elem.textContent || jQuery.text(elem)).indexOf(text) > -1;
                    };
                }),
                // "Whether an element is represented by a :lang() selector
                // is based solely on the element's language value
                // being equal to the identifier C,
                // or beginning with the identifier C immediately followed by "-".
                // The matching of C against the element's language value is performed case-insensitively.
                // The identifier C does not have to be a valid language name."
                // https://www.w3.org/TR/selectors/#lang-pseudo
                lang: markFunction(function(lang) {
                    // lang value must be a valid identifier
                    if (!ridentifier.test(lang || "")) find.error("unsupported lang: " + lang);
                    lang = lang.replace(runescape, funescape).toLowerCase();
                    return function(elem) {
                        var elemLang;
                        do if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
                            elemLang = elemLang.toLowerCase();
                            return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
                        }
                        while ((elem = elem.parentNode) && elem.nodeType === 1);
                        return false;
                    };
                }),
                // Miscellaneous
                target: function(elem) {
                    var hash = window1.location && window1.location.hash;
                    return hash && hash.slice(1) === elem.id;
                },
                root: function(elem) {
                    return elem === documentElement;
                },
                focus: function(elem) {
                    return elem === safeActiveElement() && document.hasFocus() && !!(elem.type || elem.href || ~elem.tabIndex);
                },
                // Boolean properties
                enabled: createDisabledPseudo(false),
                disabled: createDisabledPseudo(true),
                checked: function(elem) {
                    // In CSS3, :checked should return both checked and selected elements
                    // https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                    return nodeName(elem, "input") && !!elem.checked || nodeName(elem, "option") && !!elem.selected;
                },
                selected: function(elem) {
                    // Support: IE <=11+
                    // Accessing the selectedIndex property
                    // forces the browser to treat the default option as
                    // selected when in an optgroup.
                    if (elem.parentNode) // eslint-disable-next-line no-unused-expressions
                    elem.parentNode.selectedIndex;
                    return elem.selected === true;
                },
                // Contents
                empty: function(elem) {
                    // https://www.w3.org/TR/selectors/#empty-pseudo
                    // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
                    //   but not by others (comment: 8; processing instruction: 7; etc.)
                    // nodeType < 6 works because attributes (2) do not appear as children
                    for(elem = elem.firstChild; elem; elem = elem.nextSibling){
                        if (elem.nodeType < 6) return false;
                    }
                    return true;
                },
                parent: function(elem) {
                    return !Expr.pseudos.empty(elem);
                },
                // Element/input types
                header: function(elem) {
                    return rheader.test(elem.nodeName);
                },
                input: function(elem) {
                    return rinputs.test(elem.nodeName);
                },
                button: function(elem) {
                    return nodeName(elem, "input") && elem.type === "button" || nodeName(elem, "button");
                },
                text: function(elem) {
                    var attr;
                    return nodeName(elem, "input") && elem.type === "text" && // Support: IE <10 only
                    // New HTML5 attribute values (e.g., "search") appear
                    // with elem.type === "text"
                    ((attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
                },
                // Position-in-collection
                first: createPositionalPseudo(function() {
                    return [
                        0
                    ];
                }),
                last: createPositionalPseudo(function(_matchIndexes, length) {
                    return [
                        length - 1
                    ];
                }),
                eq: createPositionalPseudo(function(_matchIndexes, length, argument) {
                    return [
                        argument < 0 ? argument + length : argument
                    ];
                }),
                even: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 0;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                odd: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 1;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                lt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i;
                    if (argument < 0) i = argument + length;
                    else if (argument > length) i = length;
                    else i = argument;
                    for(; --i >= 0;)matchIndexes.push(i);
                    return matchIndexes;
                }),
                gt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i = argument < 0 ? argument + length : argument;
                    for(; ++i < length;)matchIndexes.push(i);
                    return matchIndexes;
                })
            }
        };
        Expr.pseudos.nth = Expr.pseudos.eq;
        // Add button/input type pseudos
        for(i in {
            radio: true,
            checkbox: true,
            file: true,
            password: true,
            image: true
        })Expr.pseudos[i] = createInputPseudo(i);
        for(i in {
            submit: true,
            reset: true
        })Expr.pseudos[i] = createButtonPseudo(i);
        // Easy API for creating new setFilters
        function setFilters() {}
        setFilters.prototype = Expr.filters = Expr.pseudos;
        Expr.setFilters = new setFilters();
        function tokenize(selector, parseOnly) {
            var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + " "];
            if (cached) return parseOnly ? 0 : cached.slice(0);
            soFar = selector;
            groups = [];
            preFilters = Expr.preFilter;
            while(soFar){
                // Comma and first run
                if (!matched || (match = rcomma.exec(soFar))) {
                    if (match) // Don't consume trailing commas as valid
                    soFar = soFar.slice(match[0].length) || soFar;
                    groups.push(tokens = []);
                }
                matched = false;
                // Combinators
                if (match = rleadingCombinator.exec(soFar)) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        // Cast descendant combinators to space
                        type: match[0].replace(rtrimCSS, " ")
                    });
                    soFar = soFar.slice(matched.length);
                }
                // Filters
                for(type in Expr.filter)if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        type: type,
                        matches: match
                    });
                    soFar = soFar.slice(matched.length);
                }
                if (!matched) break;
            }
            // Return the length of the invalid excess
            // if we're just parsing
            // Otherwise, throw an error or return tokens
            if (parseOnly) return soFar.length;
            return soFar ? find.error(selector) : // Cache the tokens
            tokenCache(selector, groups).slice(0);
        }
        function toSelector(tokens) {
            var i = 0, len = tokens.length, selector = "";
            for(; i < len; i++)selector += tokens[i].value;
            return selector;
        }
        function addCombinator(matcher, combinator, base) {
            var dir = combinator.dir, skip = combinator.next, key = skip || dir, checkNonElements = base && key === "parentNode", doneName = done++;
            return combinator.first ? // Check against closest ancestor/preceding element
            function(elem, context, xml) {
                while(elem = elem[dir]){
                    if (elem.nodeType === 1 || checkNonElements) return matcher(elem, context, xml);
                }
                return false;
            } : // Check against all ancestor/preceding elements
            function(elem, context, xml) {
                var oldCache, outerCache, newCache = [
                    dirruns,
                    doneName
                ];
                // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
                if (xml) {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        if (matcher(elem, context, xml)) return true;
                    }
                } else {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        outerCache = elem[expando] || (elem[expando] = {});
                        if (skip && nodeName(elem, skip)) elem = elem[dir] || elem;
                        else if ((oldCache = outerCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) // Assign to newCache so results back-propagate to previous elements
                        return newCache[2] = oldCache[2];
                        else {
                            // Reuse newcache so results back-propagate to previous elements
                            outerCache[key] = newCache;
                            // A match means we're done; a fail means we have to keep checking
                            if (newCache[2] = matcher(elem, context, xml)) return true;
                        }
                    }
                }
                return false;
            };
        }
        function elementMatcher(matchers) {
            return matchers.length > 1 ? function(elem, context, xml) {
                var i = matchers.length;
                while(i--){
                    if (!matchers[i](elem, context, xml)) return false;
                }
                return true;
            } : matchers[0];
        }
        function multipleContexts(selector, contexts, results) {
            var i = 0, len = contexts.length;
            for(; i < len; i++)find(selector, contexts[i], results);
            return results;
        }
        function condense(unmatched, map, filter, context, xml) {
            var elem, newUnmatched = [], i = 0, len = unmatched.length, mapped = map != null;
            for(; i < len; i++){
                if (elem = unmatched[i]) {
                    if (!filter || filter(elem, context, xml)) {
                        newUnmatched.push(elem);
                        if (mapped) map.push(i);
                    }
                }
            }
            return newUnmatched;
        }
        function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
            if (postFilter && !postFilter[expando]) postFilter = setMatcher(postFilter);
            if (postFinder && !postFinder[expando]) postFinder = setMatcher(postFinder, postSelector);
            return markFunction(function(seed, results, context, xml) {
                var temp, i, elem, matcherOut, preMap = [], postMap = [], preexisting = results.length, // Get initial elements from seed or context
                elems = seed || multipleContexts(selector || "*", context.nodeType ? [
                    context
                ] : context, []), // Prefilter to get matcher input, preserving a map for seed-results synchronization
                matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems;
                if (matcher) {
                    // If we have a postFinder, or filtered seed, or non-seed postFilter
                    // or preexisting results,
                    matcherOut = postFinder || (seed ? preFilter : preexisting || postFilter) ? // ...intermediate processing is necessary
                    [] : // ...otherwise use results directly
                    results;
                    // Find primary matches
                    matcher(matcherIn, matcherOut, context, xml);
                } else matcherOut = matcherIn;
                // Apply postFilter
                if (postFilter) {
                    temp = condense(matcherOut, postMap);
                    postFilter(temp, [], context, xml);
                    // Un-match failing elements by moving them back to matcherIn
                    i = temp.length;
                    while(i--)if (elem = temp[i]) matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
                }
                if (seed) {
                    if (postFinder || preFilter) {
                        if (postFinder) {
                            // Get the final matcherOut by condensing this intermediate into postFinder contexts
                            temp = [];
                            i = matcherOut.length;
                            while(i--)if (elem = matcherOut[i]) // Restore matcherIn since elem is not yet a final match
                            temp.push(matcherIn[i] = elem);
                            postFinder(null, matcherOut = [], temp, xml);
                        }
                        // Move matched elements from seed to results to keep them synchronized
                        i = matcherOut.length;
                        while(i--)if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf.call(seed, elem) : preMap[i]) > -1) seed[temp] = !(results[temp] = elem);
                    }
                } else {
                    matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
                    if (postFinder) postFinder(null, results, matcherOut, xml);
                    else push.apply(results, matcherOut);
                }
            });
        }
        function matcherFromTokens(tokens) {
            var checkContext, matcher, j, len = tokens.length, leadingRelative = Expr.relative[tokens[0].type], implicitRelative = leadingRelative || Expr.relative[" "], i = leadingRelative ? 1 : 0, // The foundational matcher ensures that elements are reachable from top-level context(s)
            matchContext = addCombinator(function(elem) {
                return elem === checkContext;
            }, implicitRelative, true), matchAnyContext = addCombinator(function(elem) {
                return indexOf.call(checkContext, elem) > -1;
            }, implicitRelative, true), matchers = [
                function(elem, context, xml) {
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    var ret = !leadingRelative && (xml || context != outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
                    // Avoid hanging onto element
                    // (see https://github.com/jquery/sizzle/issues/299)
                    checkContext = null;
                    return ret;
                }
            ];
            for(; i < len; i++)if (matcher = Expr.relative[tokens[i].type]) matchers = [
                addCombinator(elementMatcher(matchers), matcher)
            ];
            else {
                matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);
                // Return special upon seeing a positional matcher
                if (matcher[expando]) {
                    // Find the next relative operator (if any) for proper handling
                    j = ++i;
                    for(; j < len; j++){
                        if (Expr.relative[tokens[j].type]) break;
                    }
                    return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(// If the preceding token was a descendant combinator, insert an implicit any-element `*`
                    tokens.slice(0, i - 1).concat({
                        value: tokens[i - 2].type === " " ? "*" : ""
                    })).replace(rtrimCSS, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
                }
                matchers.push(matcher);
            }
            return elementMatcher(matchers);
        }
        function matcherFromGroupMatchers(elementMatchers, setMatchers) {
            var bySet = setMatchers.length > 0, byElement = elementMatchers.length > 0, superMatcher = function(seed, context, xml, results, outermost) {
                var elem, j, matcher, matchedCount = 0, i = "0", unmatched = seed && [], setMatched = [], contextBackup = outermostContext, // We must always have either seed elements or outermost context
                elems = seed || byElement && Expr.find.TAG("*", outermost), // Use integer dirruns iff this is the outermost matcher
                dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1, len = elems.length;
                if (outermost) // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                outermostContext = context == document || context || outermost;
                // Add elements passing elementMatchers directly to results
                // Support: iOS <=7 - 9 only
                // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
                // elements by id. (see trac-14142)
                for(; i !== len && (elem = elems[i]) != null; i++){
                    if (byElement && elem) {
                        j = 0;
                        // Support: IE 11+, Edge 17 - 18+
                        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                        // two documents; shallow comparisons work.
                        // eslint-disable-next-line eqeqeq
                        if (!context && elem.ownerDocument != document) {
                            setDocument(elem);
                            xml = !documentIsHTML;
                        }
                        while(matcher = elementMatchers[j++])if (matcher(elem, context || document, xml)) {
                            push.call(results, elem);
                            break;
                        }
                        if (outermost) dirruns = dirrunsUnique;
                    }
                    // Track unmatched elements for set filters
                    if (bySet) {
                        // They will have gone through all possible matchers
                        if (elem = !matcher && elem) matchedCount--;
                        // Lengthen the array for every element, matched or not
                        if (seed) unmatched.push(elem);
                    }
                }
                // `i` is now the count of elements visited above, and adding it to `matchedCount`
                // makes the latter nonnegative.
                matchedCount += i;
                // Apply set filters to unmatched elements
                // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
                // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
                // no element matchers and no seed.
                // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
                // case, which will result in a "00" `matchedCount` that differs from `i` but is also
                // numerically zero.
                if (bySet && i !== matchedCount) {
                    j = 0;
                    while(matcher = setMatchers[j++])matcher(unmatched, setMatched, context, xml);
                    if (seed) {
                        // Reintegrate element matches to eliminate the need for sorting
                        if (matchedCount > 0) {
                            while(i--)if (!(unmatched[i] || setMatched[i])) setMatched[i] = pop.call(results);
                        }
                        // Discard index placeholder values to get only actual matches
                        setMatched = condense(setMatched);
                    }
                    // Add matches to results
                    push.apply(results, setMatched);
                    // Seedless set matches succeeding multiple successful matchers stipulate sorting
                    if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) jQuery.uniqueSort(results);
                }
                // Override manipulation of globals by nested matchers
                if (outermost) {
                    dirruns = dirrunsUnique;
                    outermostContext = contextBackup;
                }
                return unmatched;
            };
            return bySet ? markFunction(superMatcher) : superMatcher;
        }
        function compile(selector, match /* Internal Use Only */ ) {
            var i, setMatchers = [], elementMatchers = [], cached = compilerCache[selector + " "];
            if (!cached) {
                // Generate a function of recursive functions that can be used to check each element
                if (!match) match = tokenize(selector);
                i = match.length;
                while(i--){
                    cached = matcherFromTokens(match[i]);
                    if (cached[expando]) setMatchers.push(cached);
                    else elementMatchers.push(cached);
                }
                // Cache the compiled function
                cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
                // Save selector and tokenization
                cached.selector = selector;
            }
            return cached;
        }
        /**
 * A low-level selection function that works with jQuery's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with jQuery selector compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */ function select(selector, context, results, seed) {
            var i, tokens, token, type, find, compiled = typeof selector === "function" && selector, match = !seed && tokenize(selector = compiled.selector || selector);
            results = results || [];
            // Try to minimize operations if there is only one selector in the list and no seed
            // (the latter of which guarantees us context)
            if (match.length === 1) {
                // Reduce context if the leading compound selector is an ID
                tokens = match[0] = match[0].slice(0);
                if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
                    context = (Expr.find.ID(token.matches[0].replace(runescape, funescape), context) || [])[0];
                    if (!context) return results;
                    else if (compiled) context = context.parentNode;
                    selector = selector.slice(tokens.shift().value.length);
                }
                // Fetch a seed set for right-to-left matching
                i = matchExpr.needsContext.test(selector) ? 0 : tokens.length;
                while(i--){
                    token = tokens[i];
                    // Abort if we hit a combinator
                    if (Expr.relative[type = token.type]) break;
                    if (find = Expr.find[type]) // Search, expanding context for leading sibling combinators
                    {
                        if (seed = find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
                            // If seed is empty or no tokens remain, we can return early
                            tokens.splice(i, 1);
                            selector = seed.length && toSelector(tokens);
                            if (!selector) {
                                push.apply(results, seed);
                                return results;
                            }
                            break;
                        }
                    }
                }
            }
            // Compile and execute a filtering function if one is not provided
            // Provide `match` to avoid retokenization if we modified the selector above
            (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
            return results;
        }
        // One-time assignments
        // Support: Android <=4.0 - 4.1+
        // Sort stability
        support.sortStable = expando.split("").sort(sortOrder).join("") === expando;
        // Initialize against the default document
        setDocument();
        // Support: Android <=4.0 - 4.1+
        // Detached nodes confoundingly follow *each other*
        support.sortDetached = assert(function(el) {
            // Should return 1, but returns 4 (following)
            return el.compareDocumentPosition(document.createElement("fieldset")) & 1;
        });
        jQuery.find = find;
        // Deprecated
        jQuery.expr[":"] = jQuery.expr.pseudos;
        jQuery.unique = jQuery.uniqueSort;
        // These have always been private, but they used to be documented as part of
        // Sizzle so let's maintain them for now for backwards compatibility purposes.
        find.compile = compile;
        find.select = select;
        find.setDocument = setDocument;
        find.tokenize = tokenize;
        find.escape = jQuery.escapeSelector;
        find.getText = jQuery.text;
        find.isXML = jQuery.isXMLDoc;
        find.selectors = jQuery.expr;
        find.support = jQuery.support;
        find.uniqueSort = jQuery.uniqueSort;
    /* eslint-enable */ })();
    var dir = function(elem, dir, until) {
        var matched = [], truncate = until !== undefined;
        while((elem = elem[dir]) && elem.nodeType !== 9)if (elem.nodeType === 1) {
            if (truncate && jQuery(elem).is(until)) break;
            matched.push(elem);
        }
        return matched;
    };
    var siblings = function(n, elem) {
        var matched = [];
        for(; n; n = n.nextSibling)if (n.nodeType === 1 && n !== elem) matched.push(n);
        return matched;
    };
    var rneedsContext = jQuery.expr.match.needsContext;
    var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    // Implement the identical functionality for filter and not
    function winnow(elements, qualifier, not) {
        if (isFunction(qualifier)) return jQuery.grep(elements, function(elem, i) {
            return !!qualifier.call(elem, i, elem) !== not;
        });
        // Single element
        if (qualifier.nodeType) return jQuery.grep(elements, function(elem) {
            return elem === qualifier !== not;
        });
        // Arraylike of elements (jQuery, arguments, Array)
        if (typeof qualifier !== "string") return jQuery.grep(elements, function(elem) {
            return indexOf.call(qualifier, elem) > -1 !== not;
        });
        // Filtered directly for both simple and complex selectors
        return jQuery.filter(qualifier, elements, not);
    }
    jQuery.filter = function(expr, elems, not) {
        var elem = elems[0];
        if (not) expr = ":not(" + expr + ")";
        if (elems.length === 1 && elem.nodeType === 1) return jQuery.find.matchesSelector(elem, expr) ? [
            elem
        ] : [];
        return jQuery.find.matches(expr, jQuery.grep(elems, function(elem) {
            return elem.nodeType === 1;
        }));
    };
    jQuery.fn.extend({
        find: function(selector) {
            var i, ret, len = this.length, self = this;
            if (typeof selector !== "string") return this.pushStack(jQuery(selector).filter(function() {
                for(i = 0; i < len; i++){
                    if (jQuery.contains(self[i], this)) return true;
                }
            }));
            ret = this.pushStack([]);
            for(i = 0; i < len; i++)jQuery.find(selector, self[i], ret);
            return len > 1 ? jQuery.uniqueSort(ret) : ret;
        },
        filter: function(selector) {
            return this.pushStack(winnow(this, selector || [], false));
        },
        not: function(selector) {
            return this.pushStack(winnow(this, selector || [], true));
        },
        is: function(selector) {
            return !!winnow(this, // If this is a positional/relative selector, check membership in the returned set
            // so $("p:first").is("p:last") won't return true for a doc with two "p".
            typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
        }
    });
    // Initialize a jQuery object
    // A central reference to the root jQuery(document)
    var rootjQuery, // A simple way to check for HTML strings
    // Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
    // Strict HTML recognition (trac-11290: must start with <)
    // Shortcut simple #id case for speed
    rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, init = jQuery.fn.init = function(selector, context, root) {
        var match, elem;
        // HANDLE: $(""), $(null), $(undefined), $(false)
        if (!selector) return this;
        // Method init() accepts an alternate rootjQuery
        // so migrate can support jQuery.sub (gh-2101)
        root = root || rootjQuery;
        // Handle HTML strings
        if (typeof selector === "string") {
            if (selector[0] === "<" && selector[selector.length - 1] === ">" && selector.length >= 3) // Assume that strings that start and end with <> are HTML and skip the regex check
            match = [
                null,
                selector,
                null
            ];
            else match = rquickExpr.exec(selector);
            // Match html or make sure no context is specified for #id
            if (match && (match[1] || !context)) {
                // HANDLE: $(html) -> $(array)
                if (match[1]) {
                    context = context instanceof jQuery ? context[0] : context;
                    // Option to run scripts is true for back-compat
                    // Intentionally let the error be thrown if parseHTML is not present
                    jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document, true));
                    // HANDLE: $(html, props)
                    if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
                        for(match in context)// Properties of context are called as methods if possible
                        if (isFunction(this[match])) this[match](context[match]);
                        else this.attr(match, context[match]);
                    }
                    return this;
                // HANDLE: $(#id)
                } else {
                    elem = document.getElementById(match[2]);
                    if (elem) {
                        // Inject the element directly into the jQuery object
                        this[0] = elem;
                        this.length = 1;
                    }
                    return this;
                }
            } else if (!context || context.jquery) return (context || root).find(selector);
            else return this.constructor(context).find(selector);
        // HANDLE: $(DOMElement)
        } else if (selector.nodeType) {
            this[0] = selector;
            this.length = 1;
            return this;
        // HANDLE: $(function)
        // Shortcut for document ready
        } else if (isFunction(selector)) return root.ready !== undefined ? root.ready(selector) : // Execute immediately if ready is not present
        selector(jQuery);
        return jQuery.makeArray(selector, this);
    };
    // Give the init function the jQuery prototype for later instantiation
    init.prototype = jQuery.fn;
    // Initialize central reference
    rootjQuery = jQuery(document);
    var rparentsprev = /^(?:parents|prev(?:Until|All))/, // Methods guaranteed to produce a unique set when starting from a unique set
    guaranteedUnique = {
        children: true,
        contents: true,
        next: true,
        prev: true
    };
    jQuery.fn.extend({
        has: function(target) {
            var targets = jQuery(target, this), l = targets.length;
            return this.filter(function() {
                var i = 0;
                for(; i < l; i++){
                    if (jQuery.contains(this, targets[i])) return true;
                }
            });
        },
        closest: function(selectors, context) {
            var cur, i = 0, l = this.length, matched = [], targets = typeof selectors !== "string" && jQuery(selectors);
            // Positional selectors never match, since there's no _selection_ context
            if (!rneedsContext.test(selectors)) for(; i < l; i++){
                for(cur = this[i]; cur && cur !== context; cur = cur.parentNode)// Always skip document fragments
                if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 : // Don't pass non-elements to jQuery#find
                cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {
                    matched.push(cur);
                    break;
                }
            }
            return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
        },
        // Determine the position of an element within the set
        index: function(elem) {
            // No argument, return index in parent
            if (!elem) return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            // Index in selector
            if (typeof elem === "string") return indexOf.call(jQuery(elem), this[0]);
            // Locate the position of the desired element
            return indexOf.call(this, // If it receives a jQuery object, the first element is used
            elem.jquery ? elem[0] : elem);
        },
        add: function(selector, context) {
            return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
        },
        addBack: function(selector) {
            return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
        }
    });
    function sibling(cur, dir) {
        while((cur = cur[dir]) && cur.nodeType !== 1);
        return cur;
    }
    jQuery.each({
        parent: function(elem) {
            var parent = elem.parentNode;
            return parent && parent.nodeType !== 11 ? parent : null;
        },
        parents: function(elem) {
            return dir(elem, "parentNode");
        },
        parentsUntil: function(elem, _i, until) {
            return dir(elem, "parentNode", until);
        },
        next: function(elem) {
            return sibling(elem, "nextSibling");
        },
        prev: function(elem) {
            return sibling(elem, "previousSibling");
        },
        nextAll: function(elem) {
            return dir(elem, "nextSibling");
        },
        prevAll: function(elem) {
            return dir(elem, "previousSibling");
        },
        nextUntil: function(elem, _i, until) {
            return dir(elem, "nextSibling", until);
        },
        prevUntil: function(elem, _i, until) {
            return dir(elem, "previousSibling", until);
        },
        siblings: function(elem) {
            return siblings((elem.parentNode || {}).firstChild, elem);
        },
        children: function(elem) {
            return siblings(elem.firstChild);
        },
        contents: function(elem) {
            if (elem.contentDocument != null && // Support: IE 11+
            // <object> elements with no `data` attribute has an object
            // `contentDocument` with a `null` prototype.
            getProto(elem.contentDocument)) return elem.contentDocument;
            // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
            // Treat the template element as a regular one in browsers that
            // don't support it.
            if (nodeName(elem, "template")) elem = elem.content || elem;
            return jQuery.merge([], elem.childNodes);
        }
    }, function(name, fn) {
        jQuery.fn[name] = function(until, selector) {
            var matched = jQuery.map(this, fn, until);
            if (name.slice(-5) !== "Until") selector = until;
            if (selector && typeof selector === "string") matched = jQuery.filter(selector, matched);
            if (this.length > 1) {
                // Remove duplicates
                if (!guaranteedUnique[name]) jQuery.uniqueSort(matched);
                // Reverse order for parents* and prev-derivatives
                if (rparentsprev.test(name)) matched.reverse();
            }
            return this.pushStack(matched);
        };
    });
    var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;
    // Convert String-formatted options into Object-formatted ones
    function createOptions(options) {
        var object = {};
        jQuery.each(options.match(rnothtmlwhite) || [], function(_, flag) {
            object[flag] = true;
        });
        return object;
    }
    /*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */ jQuery.Callbacks = function(options) {
        // Convert options from String-formatted to Object-formatted if needed
        // (we check in cache first)
        options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);
        var firing, // Last fire value for non-forgettable lists
        memory, // Flag to know if list was already fired
        fired, // Flag to prevent firing
        locked, // Actual callback list
        list = [], // Queue of execution data for repeatable lists
        queue = [], // Index of currently firing callback (modified by add/remove as needed)
        firingIndex = -1, // Fire callbacks
        fire = function() {
            // Enforce single-firing
            locked = locked || options.once;
            // Execute callbacks for all pending executions,
            // respecting firingIndex overrides and runtime changes
            fired = firing = true;
            for(; queue.length; firingIndex = -1){
                memory = queue.shift();
                while(++firingIndex < list.length)// Run callback and check for early termination
                if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
                    // Jump to end and forget the data so .add doesn't re-fire
                    firingIndex = list.length;
                    memory = false;
                }
            }
            // Forget the data if we're done with it
            if (!options.memory) memory = false;
            firing = false;
            // Clean up if we're done firing for good
            if (locked) {
                // Keep an empty list if we have data for future add calls
                if (memory) list = [];
                else list = "";
            }
        }, // Actual Callbacks object
        self = {
            // Add a callback or a collection of callbacks to the list
            add: function() {
                if (list) {
                    // If we have memory from a past run, we should fire after adding
                    if (memory && !firing) {
                        firingIndex = list.length - 1;
                        queue.push(memory);
                    }
                    (function add(args) {
                        jQuery.each(args, function(_, arg) {
                            if (isFunction(arg)) {
                                if (!options.unique || !self.has(arg)) list.push(arg);
                            } else if (arg && arg.length && toType(arg) !== "string") // Inspect recursively
                            add(arg);
                        });
                    })(arguments);
                    if (memory && !firing) fire();
                }
                return this;
            },
            // Remove a callback from the list
            remove: function() {
                jQuery.each(arguments, function(_, arg) {
                    var index;
                    while((index = jQuery.inArray(arg, list, index)) > -1){
                        list.splice(index, 1);
                        // Handle firing indexes
                        if (index <= firingIndex) firingIndex--;
                    }
                });
                return this;
            },
            // Check if a given callback is in the list.
            // If no argument is given, return whether or not list has callbacks attached.
            has: function(fn) {
                return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
            },
            // Remove all callbacks from the list
            empty: function() {
                if (list) list = [];
                return this;
            },
            // Disable .fire and .add
            // Abort any current/pending executions
            // Clear all callbacks and values
            disable: function() {
                locked = queue = [];
                list = memory = "";
                return this;
            },
            disabled: function() {
                return !list;
            },
            // Disable .fire
            // Also disable .add unless we have memory (since it would have no effect)
            // Abort any pending executions
            lock: function() {
                locked = queue = [];
                if (!memory && !firing) list = memory = "";
                return this;
            },
            locked: function() {
                return !!locked;
            },
            // Call all callbacks with the given context and arguments
            fireWith: function(context, args) {
                if (!locked) {
                    args = args || [];
                    args = [
                        context,
                        args.slice ? args.slice() : args
                    ];
                    queue.push(args);
                    if (!firing) fire();
                }
                return this;
            },
            // Call all the callbacks with the given arguments
            fire: function() {
                self.fireWith(this, arguments);
                return this;
            },
            // To know if the callbacks have already been called at least once
            fired: function() {
                return !!fired;
            }
        };
        return self;
    };
    function Identity(v) {
        return v;
    }
    function Thrower(ex) {
        throw ex;
    }
    function adoptValue(value, resolve, reject, noValue) {
        var method;
        try {
            // Check for promise aspect first to privilege synchronous behavior
            if (value && isFunction(method = value.promise)) method.call(value).done(resolve).fail(reject);
            else if (value && isFunction(method = value.then)) method.call(value, resolve, reject);
            else // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
            // * false: [ value ].slice( 0 ) => resolve( value )
            // * true: [ value ].slice( 1 ) => resolve()
            resolve.apply(undefined, [
                value
            ].slice(noValue));
        // For Promises/A+, convert exceptions into rejections
        // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
        // Deferred#then to conditionally suppress rejection.
        } catch (value) {
            // Support: Android 4.0 only
            // Strict mode functions invoked without .call/.apply get global-object context
            reject.apply(undefined, [
                value
            ]);
        }
    }
    jQuery.extend({
        Deferred: function(func) {
            var tuples = [
                // action, add listener, callbacks,
                // ... .then handlers, argument index, [final state]
                [
                    "notify",
                    "progress",
                    jQuery.Callbacks("memory"),
                    jQuery.Callbacks("memory"),
                    2
                ],
                [
                    "resolve",
                    "done",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    0,
                    "resolved"
                ],
                [
                    "reject",
                    "fail",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    1,
                    "rejected"
                ]
            ], state = "pending", promise = {
                state: function() {
                    return state;
                },
                always: function() {
                    deferred.done(arguments).fail(arguments);
                    return this;
                },
                "catch": function(fn) {
                    return promise.then(null, fn);
                },
                // Keep pipe for back-compat
                pipe: function() {
                    var fns = arguments;
                    return jQuery.Deferred(function(newDefer) {
                        jQuery.each(tuples, function(_i, tuple) {
                            // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                            var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];
                            // deferred.progress(function() { bind to newDefer or newDefer.notify })
                            // deferred.done(function() { bind to newDefer or newDefer.resolve })
                            // deferred.fail(function() { bind to newDefer or newDefer.reject })
                            deferred[tuple[1]](function() {
                                var returned = fn && fn.apply(this, arguments);
                                if (returned && isFunction(returned.promise)) returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
                                else newDefer[tuple[0] + "With"](this, fn ? [
                                    returned
                                ] : arguments);
                            });
                        });
                        fns = null;
                    }).promise();
                },
                then: function(onFulfilled, onRejected, onProgress) {
                    var maxDepth = 0;
                    function resolve(depth, deferred, handler, special) {
                        return function() {
                            var that = this, args = arguments, mightThrow = function() {
                                var returned, then;
                                // Support: Promises/A+ section 2.3.3.3.3
                                // https://promisesaplus.com/#point-59
                                // Ignore double-resolution attempts
                                if (depth < maxDepth) return;
                                returned = handler.apply(that, args);
                                // Support: Promises/A+ section 2.3.1
                                // https://promisesaplus.com/#point-48
                                if (returned === deferred.promise()) throw new TypeError("Thenable self-resolution");
                                // Support: Promises/A+ sections 2.3.3.1, 3.5
                                // https://promisesaplus.com/#point-54
                                // https://promisesaplus.com/#point-75
                                // Retrieve `then` only once
                                then = returned && // Support: Promises/A+ section 2.3.4
                                // https://promisesaplus.com/#point-64
                                // Only check objects and functions for thenability
                                (typeof returned === "object" || typeof returned === "function") && returned.then;
                                // Handle a returned thenable
                                if (isFunction(then)) {
                                    // Special processors (notify) just wait for resolution
                                    if (special) then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special));
                                    else {
                                        // ...and disregard older resolution values
                                        maxDepth++;
                                        then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith));
                                    }
                                } else {
                                    // Only substitute handlers pass on context
                                    // and multiple values (non-spec behavior)
                                    if (handler !== Identity) {
                                        that = undefined;
                                        args = [
                                            returned
                                        ];
                                    }
                                    // Process the value(s)
                                    // Default process is resolve
                                    (special || deferred.resolveWith)(that, args);
                                }
                            }, // Only normal processors (resolve) catch and reject exceptions
                            process = special ? mightThrow : function() {
                                try {
                                    mightThrow();
                                } catch (e) {
                                    if (jQuery.Deferred.exceptionHook) jQuery.Deferred.exceptionHook(e, process.error);
                                    // Support: Promises/A+ section 2.3.3.3.4.1
                                    // https://promisesaplus.com/#point-61
                                    // Ignore post-resolution exceptions
                                    if (depth + 1 >= maxDepth) {
                                        // Only substitute handlers pass on context
                                        // and multiple values (non-spec behavior)
                                        if (handler !== Thrower) {
                                            that = undefined;
                                            args = [
                                                e
                                            ];
                                        }
                                        deferred.rejectWith(that, args);
                                    }
                                }
                            };
                            // Support: Promises/A+ section 2.3.3.3.1
                            // https://promisesaplus.com/#point-57
                            // Re-resolve promises immediately to dodge false rejection from
                            // subsequent errors
                            if (depth) process();
                            else {
                                // Call an optional hook to record the error, in case of exception
                                // since it's otherwise lost when execution goes async
                                if (jQuery.Deferred.getErrorHook) process.error = jQuery.Deferred.getErrorHook();
                                else if (jQuery.Deferred.getStackHook) process.error = jQuery.Deferred.getStackHook();
                                window1.setTimeout(process);
                            }
                        };
                    }
                    return jQuery.Deferred(function(newDefer) {
                        // progress_handlers.add( ... )
                        tuples[0][3].add(resolve(0, newDefer, isFunction(onProgress) ? onProgress : Identity, newDefer.notifyWith));
                        // fulfilled_handlers.add( ... )
                        tuples[1][3].add(resolve(0, newDefer, isFunction(onFulfilled) ? onFulfilled : Identity));
                        // rejected_handlers.add( ... )
                        tuples[2][3].add(resolve(0, newDefer, isFunction(onRejected) ? onRejected : Thrower));
                    }).promise();
                },
                // Get a promise for this deferred
                // If obj is provided, the promise aspect is added to the object
                promise: function(obj) {
                    return obj != null ? jQuery.extend(obj, promise) : promise;
                }
            }, deferred = {};
            // Add list-specific methods
            jQuery.each(tuples, function(i, tuple) {
                var list = tuple[2], stateString = tuple[5];
                // promise.progress = list.add
                // promise.done = list.add
                // promise.fail = list.add
                promise[tuple[1]] = list.add;
                // Handle state
                if (stateString) list.add(function() {
                    // state = "resolved" (i.e., fulfilled)
                    // state = "rejected"
                    state = stateString;
                }, // rejected_callbacks.disable
                // fulfilled_callbacks.disable
                tuples[3 - i][2].disable, // rejected_handlers.disable
                // fulfilled_handlers.disable
                tuples[3 - i][3].disable, // progress_callbacks.lock
                tuples[0][2].lock, // progress_handlers.lock
                tuples[0][3].lock);
                // progress_handlers.fire
                // fulfilled_handlers.fire
                // rejected_handlers.fire
                list.add(tuple[3].fire);
                // deferred.notify = function() { deferred.notifyWith(...) }
                // deferred.resolve = function() { deferred.resolveWith(...) }
                // deferred.reject = function() { deferred.rejectWith(...) }
                deferred[tuple[0]] = function() {
                    deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
                    return this;
                };
                // deferred.notifyWith = list.fireWith
                // deferred.resolveWith = list.fireWith
                // deferred.rejectWith = list.fireWith
                deferred[tuple[0] + "With"] = list.fireWith;
            });
            // Make the deferred a promise
            promise.promise(deferred);
            // Call given func if any
            if (func) func.call(deferred, deferred);
            // All done!
            return deferred;
        },
        // Deferred helper
        when: function(singleValue) {
            var // count of uncompleted subordinates
            remaining = arguments.length, // count of unprocessed arguments
            i = remaining, // subordinate fulfillment data
            resolveContexts = Array(i), resolveValues = slice.call(arguments), // the primary Deferred
            primary = jQuery.Deferred(), // subordinate callback factory
            updateFunc = function(i) {
                return function(value) {
                    resolveContexts[i] = this;
                    resolveValues[i] = arguments.length > 1 ? slice.call(arguments) : value;
                    if (!--remaining) primary.resolveWith(resolveContexts, resolveValues);
                };
            };
            // Single- and empty arguments are adopted like Promise.resolve
            if (remaining <= 1) {
                adoptValue(singleValue, primary.done(updateFunc(i)).resolve, primary.reject, !remaining);
                // Use .then() to unwrap secondary thenables (cf. gh-3000)
                if (primary.state() === "pending" || isFunction(resolveValues[i] && resolveValues[i].then)) return primary.then();
            }
            // Multiple arguments are aggregated like Promise.all array elements
            while(i--)adoptValue(resolveValues[i], updateFunc(i), primary.reject);
            return primary.promise();
        }
    });
    // These usually indicate a programmer mistake during development,
    // warn about them ASAP rather than swallowing them by default.
    var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    // If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
    // captured before the async barrier to get the original error cause
    // which may otherwise be hidden.
    jQuery.Deferred.exceptionHook = function(error, asyncError) {
        // Support: IE 8 - 9 only
        // Console exists when dev tools are open, which can happen at any time
        if (window1.console && window1.console.warn && error && rerrorNames.test(error.name)) window1.console.warn("jQuery.Deferred exception: " + error.message, error.stack, asyncError);
    };
    jQuery.readyException = function(error) {
        window1.setTimeout(function() {
            throw error;
        });
    };
    // The deferred used on DOM ready
    var readyList = jQuery.Deferred();
    jQuery.fn.ready = function(fn) {
        readyList.then(fn)// Wrap jQuery.readyException in a function so that the lookup
        // happens at the time of error handling instead of callback
        // registration.
        .catch(function(error) {
            jQuery.readyException(error);
        });
        return this;
    };
    jQuery.extend({
        // Is the DOM ready to be used? Set to true once it occurs.
        isReady: false,
        // A counter to track how many items to wait for before
        // the ready event fires. See trac-6781
        readyWait: 1,
        // Handle when the DOM is ready
        ready: function(wait) {
            // Abort if there are pending holds or we're already ready
            if (wait === true ? --jQuery.readyWait : jQuery.isReady) return;
            // Remember that the DOM is ready
            jQuery.isReady = true;
            // If a normal DOM Ready event fired, decrement, and wait if need be
            if (wait !== true && --jQuery.readyWait > 0) return;
            // If there are functions bound, to execute
            readyList.resolveWith(document, [
                jQuery
            ]);
        }
    });
    jQuery.ready.then = readyList.then;
    // The ready event handler and self cleanup method
    function completed() {
        document.removeEventListener("DOMContentLoaded", completed);
        window1.removeEventListener("load", completed);
        jQuery.ready();
    }
    // Catch cases where $(document).ready() is called
    // after the browser event has already occurred.
    // Support: IE <=9 - 10 only
    // Older IE sometimes signals "interactive" too soon
    if (document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll) // Handle it asynchronously to allow scripts the opportunity to delay ready
    window1.setTimeout(jQuery.ready);
    else {
        // Use the handy event callback
        document.addEventListener("DOMContentLoaded", completed);
        // A fallback to window.onload, that will always work
        window1.addEventListener("load", completed);
    }
    // Multifunctional method to get and set values of a collection
    // The value/s can optionally be executed if it's a function
    var access = function(elems, fn, key, value, chainable, emptyGet, raw) {
        var i = 0, len = elems.length, bulk = key == null;
        // Sets many values
        if (toType(key) === "object") {
            chainable = true;
            for(i in key)access(elems, fn, i, key[i], true, emptyGet, raw);
        // Sets one value
        } else if (value !== undefined) {
            chainable = true;
            if (!isFunction(value)) raw = true;
            if (bulk) {
                // Bulk operations run against the entire set
                if (raw) {
                    fn.call(elems, value);
                    fn = null;
                // ...except when executing function values
                } else {
                    bulk = fn;
                    fn = function(elem, _key, value) {
                        return bulk.call(jQuery(elem), value);
                    };
                }
            }
            if (fn) for(; i < len; i++)fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
        }
        if (chainable) return elems;
        // Gets
        if (bulk) return fn.call(elems);
        return len ? fn(elems[0], key) : emptyGet;
    };
    // Matches dashed string for camelizing
    var rmsPrefix = /^-ms-/, rdashAlpha = /-([a-z])/g;
    // Used by camelCase as callback to replace()
    function fcamelCase(_all, letter) {
        return letter.toUpperCase();
    }
    // Convert dashed to camelCase; used by the css and data modules
    // Support: IE <=9 - 11, Edge 12 - 15
    // Microsoft forgot to hump their vendor prefix (trac-9572)
    function camelCase(string) {
        return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
    }
    var acceptData = function(owner) {
        // Accepts only:
        //  - Node
        //    - Node.ELEMENT_NODE
        //    - Node.DOCUMENT_NODE
        //  - Object
        //    - Any
        return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
    };
    function Data() {
        this.expando = jQuery.expando + Data.uid++;
    }
    Data.uid = 1;
    Data.prototype = {
        cache: function(owner) {
            // Check if the owner object already has a cache
            var value = owner[this.expando];
            // If not, create one
            if (!value) {
                value = {};
                // We can accept data for non-element nodes in modern browsers,
                // but we should not, see trac-8335.
                // Always return an empty object.
                if (acceptData(owner)) {
                    // If it is a node unlikely to be stringify-ed or looped over
                    // use plain assignment
                    if (owner.nodeType) owner[this.expando] = value;
                    else Object.defineProperty(owner, this.expando, {
                        value: value,
                        configurable: true
                    });
                }
            }
            return value;
        },
        set: function(owner, data, value) {
            var prop, cache = this.cache(owner);
            // Handle: [ owner, key, value ] args
            // Always use camelCase key (gh-2257)
            if (typeof data === "string") cache[camelCase(data)] = value;
            else // Copy the properties one-by-one to the cache object
            for(prop in data)cache[camelCase(prop)] = data[prop];
            return cache;
        },
        get: function(owner, key) {
            return key === undefined ? this.cache(owner) : // Always use camelCase key (gh-2257)
            owner[this.expando] && owner[this.expando][camelCase(key)];
        },
        access: function(owner, key, value) {
            // In cases where either:
            //
            //   1. No key was specified
            //   2. A string key was specified, but no value provided
            //
            // Take the "read" path and allow the get method to determine
            // which value to return, respectively either:
            //
            //   1. The entire cache object
            //   2. The data stored at the key
            //
            if (key === undefined || key && typeof key === "string" && value === undefined) return this.get(owner, key);
            // When the key is not a string, or both a key and value
            // are specified, set or extend (existing objects) with either:
            //
            //   1. An object of properties
            //   2. A key and value
            //
            this.set(owner, key, value);
            // Since the "set" path can have two possible entry points
            // return the expected data based on which path was taken[*]
            return value !== undefined ? value : key;
        },
        remove: function(owner, key) {
            var i, cache = owner[this.expando];
            if (cache === undefined) return;
            if (key !== undefined) {
                // Support array or space separated string of keys
                if (Array.isArray(key)) // If key is an array of keys...
                // We always set camelCase keys, so remove that.
                key = key.map(camelCase);
                else {
                    key = camelCase(key);
                    // If a key with the spaces exists, use it.
                    // Otherwise, create an array by matching non-whitespace
                    key = key in cache ? [
                        key
                    ] : key.match(rnothtmlwhite) || [];
                }
                i = key.length;
                while(i--)delete cache[key[i]];
            }
            // Remove the expando if there's no more data
            if (key === undefined || jQuery.isEmptyObject(cache)) {
                // Support: Chrome <=35 - 45
                // Webkit & Blink performance suffers when deleting properties
                // from DOM nodes, so set to undefined instead
                // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
                if (owner.nodeType) owner[this.expando] = undefined;
                else delete owner[this.expando];
            }
        },
        hasData: function(owner) {
            var cache = owner[this.expando];
            return cache !== undefined && !jQuery.isEmptyObject(cache);
        }
    };
    var dataPriv = new Data();
    var dataUser = new Data();
    //	Implementation Summary
    //
    //	1. Enforce API surface and semantic compatibility with 1.9.x branch
    //	2. Improve the module's maintainability by reducing the storage
    //		paths to a single mechanism.
    //	3. Use the same single mechanism to support "private" and "user" data.
    //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
    //	5. Avoid exposing implementation details on user objects (eg. expando properties)
    //	6. Provide a clear path for implementation upgrade to WeakMap in 2014
    var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, rmultiDash = /[A-Z]/g;
    function getData(data) {
        if (data === "true") return true;
        if (data === "false") return false;
        if (data === "null") return null;
        // Only convert to a number if it doesn't change the string
        if (data === +data + "") return +data;
        if (rbrace.test(data)) return JSON.parse(data);
        return data;
    }
    function dataAttr(elem, key, data) {
        var name;
        // If nothing was found internally, try to fetch any
        // data from the HTML5 data-* attribute
        if (data === undefined && elem.nodeType === 1) {
            name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
            data = elem.getAttribute(name);
            if (typeof data === "string") {
                try {
                    data = getData(data);
                } catch (e) {}
                // Make sure we set the data so it isn't changed later
                dataUser.set(elem, key, data);
            } else data = undefined;
        }
        return data;
    }
    jQuery.extend({
        hasData: function(elem) {
            return dataUser.hasData(elem) || dataPriv.hasData(elem);
        },
        data: function(elem, name, data) {
            return dataUser.access(elem, name, data);
        },
        removeData: function(elem, name) {
            dataUser.remove(elem, name);
        },
        // TODO: Now that all calls to _data and _removeData have been replaced
        // with direct calls to dataPriv methods, these can be deprecated.
        _data: function(elem, name, data) {
            return dataPriv.access(elem, name, data);
        },
        _removeData: function(elem, name) {
            dataPriv.remove(elem, name);
        }
    });
    jQuery.fn.extend({
        data: function(key, value) {
            var i, name, data, elem = this[0], attrs = elem && elem.attributes;
            // Gets all values
            if (key === undefined) {
                if (this.length) {
                    data = dataUser.get(elem);
                    if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
                        i = attrs.length;
                        while(i--)// Support: IE 11 only
                        // The attrs elements can be null (trac-14894)
                        if (attrs[i]) {
                            name = attrs[i].name;
                            if (name.indexOf("data-") === 0) {
                                name = camelCase(name.slice(5));
                                dataAttr(elem, name, data[name]);
                            }
                        }
                        dataPriv.set(elem, "hasDataAttrs", true);
                    }
                }
                return data;
            }
            // Sets multiple values
            if (typeof key === "object") return this.each(function() {
                dataUser.set(this, key);
            });
            return access(this, function(value) {
                var data;
                // The calling jQuery object (element matches) is not empty
                // (and therefore has an element appears at this[ 0 ]) and the
                // `value` parameter was not undefined. An empty jQuery object
                // will result in `undefined` for elem = this[ 0 ] which will
                // throw an exception if an attempt to read a data cache is made.
                if (elem && value === undefined) {
                    // Attempt to get data from the cache
                    // The key will always be camelCased in Data
                    data = dataUser.get(elem, key);
                    if (data !== undefined) return data;
                    // Attempt to "discover" the data in
                    // HTML5 custom data-* attrs
                    data = dataAttr(elem, key);
                    if (data !== undefined) return data;
                    // We tried really hard, but the data doesn't exist.
                    return;
                }
                // Set the data...
                this.each(function() {
                    // We always store the camelCased key
                    dataUser.set(this, key, value);
                });
            }, null, value, arguments.length > 1, null, true);
        },
        removeData: function(key) {
            return this.each(function() {
                dataUser.remove(this, key);
            });
        }
    });
    jQuery.extend({
        queue: function(elem, type, data) {
            var queue;
            if (elem) {
                type = (type || "fx") + "queue";
                queue = dataPriv.get(elem, type);
                // Speed up dequeue by getting out quickly if this is just a lookup
                if (data) {
                    if (!queue || Array.isArray(data)) queue = dataPriv.access(elem, type, jQuery.makeArray(data));
                    else queue.push(data);
                }
                return queue || [];
            }
        },
        dequeue: function(elem, type) {
            type = type || "fx";
            var queue = jQuery.queue(elem, type), startLength = queue.length, fn = queue.shift(), hooks = jQuery._queueHooks(elem, type), next = function() {
                jQuery.dequeue(elem, type);
            };
            // If the fx queue is dequeued, always remove the progress sentinel
            if (fn === "inprogress") {
                fn = queue.shift();
                startLength--;
            }
            if (fn) {
                // Add a progress sentinel to prevent the fx queue from being
                // automatically dequeued
                if (type === "fx") queue.unshift("inprogress");
                // Clear up the last queue stop function
                delete hooks.stop;
                fn.call(elem, next, hooks);
            }
            if (!startLength && hooks) hooks.empty.fire();
        },
        // Not public - generate a queueHooks object, or return the current one
        _queueHooks: function(elem, type) {
            var key = type + "queueHooks";
            return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
                empty: jQuery.Callbacks("once memory").add(function() {
                    dataPriv.remove(elem, [
                        type + "queue",
                        key
                    ]);
                })
            });
        }
    });
    jQuery.fn.extend({
        queue: function(type, data) {
            var setter = 2;
            if (typeof type !== "string") {
                data = type;
                type = "fx";
                setter--;
            }
            if (arguments.length < setter) return jQuery.queue(this[0], type);
            return data === undefined ? this : this.each(function() {
                var queue = jQuery.queue(this, type, data);
                // Ensure a hooks for this queue
                jQuery._queueHooks(this, type);
                if (type === "fx" && queue[0] !== "inprogress") jQuery.dequeue(this, type);
            });
        },
        dequeue: function(type) {
            return this.each(function() {
                jQuery.dequeue(this, type);
            });
        },
        clearQueue: function(type) {
            return this.queue(type || "fx", []);
        },
        // Get a promise resolved when queues of a certain type
        // are emptied (fx is the type by default)
        promise: function(type, obj) {
            var tmp, count = 1, defer = jQuery.Deferred(), elements = this, i = this.length, resolve = function() {
                if (!--count) defer.resolveWith(elements, [
                    elements
                ]);
            };
            if (typeof type !== "string") {
                obj = type;
                type = undefined;
            }
            type = type || "fx";
            while(i--){
                tmp = dataPriv.get(elements[i], type + "queueHooks");
                if (tmp && tmp.empty) {
                    count++;
                    tmp.empty.add(resolve);
                }
            }
            resolve();
            return defer.promise(obj);
        }
    });
    var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
    var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
    var cssExpand = [
        "Top",
        "Right",
        "Bottom",
        "Left"
    ];
    var documentElement = document.documentElement;
    var isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem);
    }, composed = {
        composed: true
    };
    // Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
    // Check attachment across shadow DOM boundaries when possible (gh-3504)
    // Support: iOS 10.0-10.2 only
    // Early iOS 10 versions support `attachShadow` but not `getRootNode`,
    // leading to errors. We need to check for `getRootNode`.
    if (documentElement.getRootNode) isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem) || elem.getRootNode(composed) === elem.ownerDocument;
    };
    var isHiddenWithinTree = function(elem, el) {
        // isHiddenWithinTree might be called from jQuery#filter function;
        // in that case, element will be second argument
        elem = el || elem;
        // Inline style trumps all
        return elem.style.display === "none" || elem.style.display === "" && // Otherwise, check computed style
        // Support: Firefox <=43 - 45
        // Disconnected elements can have computed display: none, so first confirm that elem is
        // in the document.
        isAttached(elem) && jQuery.css(elem, "display") === "none";
    };
    function adjustCSS(elem, prop, valueParts, tween) {
        var adjusted, scale, maxIterations = 20, currentValue = tween ? function() {
            return tween.cur();
        } : function() {
            return jQuery.css(elem, prop, "");
        }, initial = currentValue(), unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"), // Starting value computation is required for potential unit mismatches
        initialInUnit = elem.nodeType && (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));
        if (initialInUnit && initialInUnit[3] !== unit) {
            // Support: Firefox <=54
            // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
            initial = initial / 2;
            // Trust units reported by jQuery.css
            unit = unit || initialInUnit[3];
            // Iteratively approximate from a nonzero starting point
            initialInUnit = +initial || 1;
            while(maxIterations--){
                // Evaluate and update our best guess (doubling guesses that zero out).
                // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
                jQuery.style(elem, prop, initialInUnit + unit);
                if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) maxIterations = 0;
                initialInUnit = initialInUnit / scale;
            }
            initialInUnit = initialInUnit * 2;
            jQuery.style(elem, prop, initialInUnit + unit);
            // Make sure we update the tween properties later on
            valueParts = valueParts || [];
        }
        if (valueParts) {
            initialInUnit = +initialInUnit || +initial || 0;
            // Apply relative offset (+=/-=) if specified
            adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
            if (tween) {
                tween.unit = unit;
                tween.start = initialInUnit;
                tween.end = adjusted;
            }
        }
        return adjusted;
    }
    var defaultDisplayMap = {};
    function getDefaultDisplay(elem) {
        var temp, doc = elem.ownerDocument, nodeName = elem.nodeName, display = defaultDisplayMap[nodeName];
        if (display) return display;
        temp = doc.body.appendChild(doc.createElement(nodeName));
        display = jQuery.css(temp, "display");
        temp.parentNode.removeChild(temp);
        if (display === "none") display = "block";
        defaultDisplayMap[nodeName] = display;
        return display;
    }
    function showHide(elements, show) {
        var display, elem, values = [], index = 0, length = elements.length;
        // Determine new display value for elements that need to change
        for(; index < length; index++){
            elem = elements[index];
            if (!elem.style) continue;
            display = elem.style.display;
            if (show) {
                // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
                // check is required in this first loop unless we have a nonempty display value (either
                // inline or about-to-be-restored)
                if (display === "none") {
                    values[index] = dataPriv.get(elem, "display") || null;
                    if (!values[index]) elem.style.display = "";
                }
                if (elem.style.display === "" && isHiddenWithinTree(elem)) values[index] = getDefaultDisplay(elem);
            } else if (display !== "none") {
                values[index] = "none";
                // Remember what we're overwriting
                dataPriv.set(elem, "display", display);
            }
        }
        // Set the display of the elements in a second loop to avoid constant reflow
        for(index = 0; index < length; index++)if (values[index] != null) elements[index].style.display = values[index];
        return elements;
    }
    jQuery.fn.extend({
        show: function() {
            return showHide(this, true);
        },
        hide: function() {
            return showHide(this);
        },
        toggle: function(state) {
            if (typeof state === "boolean") return state ? this.show() : this.hide();
            return this.each(function() {
                if (isHiddenWithinTree(this)) jQuery(this).show();
                else jQuery(this).hide();
            });
        }
    });
    var rcheckableType = /^(?:checkbox|radio)$/i;
    var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
    var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;
    (function() {
        var fragment = document.createDocumentFragment(), div = fragment.appendChild(document.createElement("div")), input = document.createElement("input");
        // Support: Android 4.0 - 4.3 only
        // Check state lost if the name is set (trac-11217)
        // Support: Windows Web Apps (WWA)
        // `name` and `type` must use .setAttribute for WWA (trac-14901)
        input.setAttribute("type", "radio");
        input.setAttribute("checked", "checked");
        input.setAttribute("name", "t");
        div.appendChild(input);
        // Support: Android <=4.1 only
        // Older WebKit doesn't clone checked state correctly in fragments
        support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;
        // Support: IE <=11 only
        // Make sure textarea (and checkbox) defaultValue is properly cloned
        div.innerHTML = "<textarea>x</textarea>";
        support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;
        // Support: IE <=9 only
        // IE <=9 replaces <option> tags with their contents when inserted outside of
        // the select element.
        div.innerHTML = "<option></option>";
        support.option = !!div.lastChild;
    })();
    // We have to close these tags to support XHTML (trac-13200)
    var wrapMap = {
        // XHTML parsers do not magically insert elements in the
        // same way that tag soup parsers do. So we cannot shorten
        // this by omitting <tbody> or other required elements.
        thead: [
            1,
            "<table>",
            "</table>"
        ],
        col: [
            2,
            "<table><colgroup>",
            "</colgroup></table>"
        ],
        tr: [
            2,
            "<table><tbody>",
            "</tbody></table>"
        ],
        td: [
            3,
            "<table><tbody><tr>",
            "</tr></tbody></table>"
        ],
        _default: [
            0,
            "",
            ""
        ]
    };
    wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
    wrapMap.th = wrapMap.td;
    // Support: IE <=9 only
    if (!support.option) wrapMap.optgroup = wrapMap.option = [
        1,
        "<select multiple='multiple'>",
        "</select>"
    ];
    function getAll(context, tag) {
        // Support: IE <=9 - 11 only
        // Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
        var ret;
        if (typeof context.getElementsByTagName !== "undefined") ret = context.getElementsByTagName(tag || "*");
        else if (typeof context.querySelectorAll !== "undefined") ret = context.querySelectorAll(tag || "*");
        else ret = [];
        if (tag === undefined || tag && nodeName(context, tag)) return jQuery.merge([
            context
        ], ret);
        return ret;
    }
    // Mark scripts as having already been evaluated
    function setGlobalEval(elems, refElements) {
        var i = 0, l = elems.length;
        for(; i < l; i++)dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
    }
    var rhtml = /<|&#?\w+;/;
    function buildFragment(elems, context, scripts, selection, ignored) {
        var elem, tmp, tag, wrap, attached, j, fragment = context.createDocumentFragment(), nodes = [], i = 0, l = elems.length;
        for(; i < l; i++){
            elem = elems[i];
            if (elem || elem === 0) {
                // Add nodes directly
                if (toType(elem) === "object") // Support: Android <=4.0 only, PhantomJS 1 only
                // push.apply(_, arraylike) throws on ancient WebKit
                jQuery.merge(nodes, elem.nodeType ? [
                    elem
                ] : elem);
                else if (!rhtml.test(elem)) nodes.push(context.createTextNode(elem));
                else {
                    tmp = tmp || fragment.appendChild(context.createElement("div"));
                    // Deserialize a standard representation
                    tag = (rtagName.exec(elem) || [
                        "",
                        ""
                    ])[1].toLowerCase();
                    wrap = wrapMap[tag] || wrapMap._default;
                    tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];
                    // Descend through wrappers to the right content
                    j = wrap[0];
                    while(j--)tmp = tmp.lastChild;
                    // Support: Android <=4.0 only, PhantomJS 1 only
                    // push.apply(_, arraylike) throws on ancient WebKit
                    jQuery.merge(nodes, tmp.childNodes);
                    // Remember the top-level container
                    tmp = fragment.firstChild;
                    // Ensure the created nodes are orphaned (trac-12392)
                    tmp.textContent = "";
                }
            }
        }
        // Remove wrapper from fragment
        fragment.textContent = "";
        i = 0;
        while(elem = nodes[i++]){
            // Skip elements already in the context collection (trac-4087)
            if (selection && jQuery.inArray(elem, selection) > -1) {
                if (ignored) ignored.push(elem);
                continue;
            }
            attached = isAttached(elem);
            // Append to fragment
            tmp = getAll(fragment.appendChild(elem), "script");
            // Preserve script evaluation history
            if (attached) setGlobalEval(tmp);
            // Capture executables
            if (scripts) {
                j = 0;
                while(elem = tmp[j++])if (rscriptType.test(elem.type || "")) scripts.push(elem);
            }
        }
        return fragment;
    }
    var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
    function returnTrue() {
        return true;
    }
    function returnFalse() {
        return false;
    }
    function on(elem, types, selector, data, fn, one) {
        var origFn, type;
        // Types can be a map of types/handlers
        if (typeof types === "object") {
            // ( types-Object, selector, data )
            if (typeof selector !== "string") {
                // ( types-Object, data )
                data = data || selector;
                selector = undefined;
            }
            for(type in types)on(elem, type, selector, data, types[type], one);
            return elem;
        }
        if (data == null && fn == null) {
            // ( types, fn )
            fn = selector;
            data = selector = undefined;
        } else if (fn == null) {
            if (typeof selector === "string") {
                // ( types, selector, fn )
                fn = data;
                data = undefined;
            } else {
                // ( types, data, fn )
                fn = data;
                data = selector;
                selector = undefined;
            }
        }
        if (fn === false) fn = returnFalse;
        else if (!fn) return elem;
        if (one === 1) {
            origFn = fn;
            fn = function(event) {
                // Can use an empty set, since event contains the info
                jQuery().off(event);
                return origFn.apply(this, arguments);
            };
            // Use same guid so caller can remove using origFn
            fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
        }
        return elem.each(function() {
            jQuery.event.add(this, types, fn, data, selector);
        });
    }
    /*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */ jQuery.event = {
        global: {},
        add: function(elem, types, handler, data, selector) {
            var handleObjIn, eventHandle, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.get(elem);
            // Only attach events to objects that accept data
            if (!acceptData(elem)) return;
            // Caller can pass in an object of custom data in lieu of the handler
            if (handler.handler) {
                handleObjIn = handler;
                handler = handleObjIn.handler;
                selector = handleObjIn.selector;
            }
            // Ensure that invalid selectors throw exceptions at attach time
            // Evaluate against documentElement in case elem is a non-element node (e.g., document)
            if (selector) jQuery.find.matchesSelector(documentElement, selector);
            // Make sure that the handler has a unique ID, used to find/remove it later
            if (!handler.guid) handler.guid = jQuery.guid++;
            // Init the element's event structure and main handler, if this is the first
            if (!(events = elemData.events)) events = elemData.events = Object.create(null);
            if (!(eventHandle = elemData.handle)) eventHandle = elemData.handle = function(e) {
                // Discard the second event of a jQuery.event.trigger() and
                // when an event is called after a page has unloaded
                return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined;
            };
            // Handle multiple events separated by a space
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // There *must* be a type, no attaching namespace-only handlers
                if (!type) continue;
                // If event changes its type, use the special event handlers for the changed type
                special = jQuery.event.special[type] || {};
                // If selector defined, determine special event api type, otherwise given type
                type = (selector ? special.delegateType : special.bindType) || type;
                // Update special based on newly reset type
                special = jQuery.event.special[type] || {};
                // handleObj is passed to all event handlers
                handleObj = jQuery.extend({
                    type: type,
                    origType: origType,
                    data: data,
                    handler: handler,
                    guid: handler.guid,
                    selector: selector,
                    needsContext: selector && jQuery.expr.match.needsContext.test(selector),
                    namespace: namespaces.join(".")
                }, handleObjIn);
                // Init the event handler queue if we're the first
                if (!(handlers = events[type])) {
                    handlers = events[type] = [];
                    handlers.delegateCount = 0;
                    // Only use addEventListener if the special events handler returns false
                    if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
                        if (elem.addEventListener) elem.addEventListener(type, eventHandle);
                    }
                }
                if (special.add) {
                    special.add.call(elem, handleObj);
                    if (!handleObj.handler.guid) handleObj.handler.guid = handler.guid;
                }
                // Add to the element's handler list, delegates in front
                if (selector) handlers.splice(handlers.delegateCount++, 0, handleObj);
                else handlers.push(handleObj);
                // Keep track of which events have ever been used, for event optimization
                jQuery.event.global[type] = true;
            }
        },
        // Detach an event or set of events from an element
        remove: function(elem, types, handler, selector, mappedTypes) {
            var j, origCount, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
            if (!elemData || !(events = elemData.events)) return;
            // Once for each type.namespace in types; type may be omitted
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // Unbind all events (on this namespace, if provided) for the element
                if (!type) {
                    for(type in events)jQuery.event.remove(elem, type + types[t], handler, selector, true);
                    continue;
                }
                special = jQuery.event.special[type] || {};
                type = (selector ? special.delegateType : special.bindType) || type;
                handlers = events[type] || [];
                tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");
                // Remove matching events
                origCount = j = handlers.length;
                while(j--){
                    handleObj = handlers[j];
                    if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
                        handlers.splice(j, 1);
                        if (handleObj.selector) handlers.delegateCount--;
                        if (special.remove) special.remove.call(elem, handleObj);
                    }
                }
                // Remove generic event handler if we removed something and no more handlers exist
                // (avoids potential for endless recursion during removal of special event handlers)
                if (origCount && !handlers.length) {
                    if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) jQuery.removeEvent(elem, type, elemData.handle);
                    delete events[type];
                }
            }
            // Remove data and the expando if it's no longer used
            if (jQuery.isEmptyObject(events)) dataPriv.remove(elem, "handle events");
        },
        dispatch: function(nativeEvent) {
            var i, j, ret, matched, handleObj, handlerQueue, args = new Array(arguments.length), // Make a writable jQuery.Event from the native event object
            event = jQuery.event.fix(nativeEvent), handlers = (dataPriv.get(this, "events") || Object.create(null))[event.type] || [], special = jQuery.event.special[event.type] || {};
            // Use the fix-ed jQuery.Event rather than the (read-only) native event
            args[0] = event;
            for(i = 1; i < arguments.length; i++)args[i] = arguments[i];
            event.delegateTarget = this;
            // Call the preDispatch hook for the mapped type, and let it bail if desired
            if (special.preDispatch && special.preDispatch.call(this, event) === false) return;
            // Determine handlers
            handlerQueue = jQuery.event.handlers.call(this, event, handlers);
            // Run delegates first; they may want to stop propagation beneath us
            i = 0;
            while((matched = handlerQueue[i++]) && !event.isPropagationStopped()){
                event.currentTarget = matched.elem;
                j = 0;
                while((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped())// If the event is namespaced, then each handler is only invoked if it is
                // specially universal or its namespaces are a superset of the event's.
                if (!event.rnamespace || handleObj.namespace === false || event.rnamespace.test(handleObj.namespace)) {
                    event.handleObj = handleObj;
                    event.data = handleObj.data;
                    ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
                    if (ret !== undefined) {
                        if ((event.result = ret) === false) {
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    }
                }
            }
            // Call the postDispatch hook for the mapped type
            if (special.postDispatch) special.postDispatch.call(this, event);
            return event.result;
        },
        handlers: function(event, handlers) {
            var i, handleObj, sel, matchedHandlers, matchedSelectors, handlerQueue = [], delegateCount = handlers.delegateCount, cur = event.target;
            // Find delegate handlers
            if (delegateCount && // Support: IE <=9
            // Black-hole SVG <use> instance trees (trac-13180)
            cur.nodeType && // Support: Firefox <=42
            // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
            // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
            // Support: IE 11 only
            // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
            !(event.type === "click" && event.button >= 1)) {
                for(; cur !== this; cur = cur.parentNode || this)// Don't check non-elements (trac-13208)
                // Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
                if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
                    matchedHandlers = [];
                    matchedSelectors = {};
                    for(i = 0; i < delegateCount; i++){
                        handleObj = handlers[i];
                        // Don't conflict with Object.prototype properties (trac-13203)
                        sel = handleObj.selector + " ";
                        if (matchedSelectors[sel] === undefined) matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [
                            cur
                        ]).length;
                        if (matchedSelectors[sel]) matchedHandlers.push(handleObj);
                    }
                    if (matchedHandlers.length) handlerQueue.push({
                        elem: cur,
                        handlers: matchedHandlers
                    });
                }
            }
            // Add the remaining (directly-bound) handlers
            cur = this;
            if (delegateCount < handlers.length) handlerQueue.push({
                elem: cur,
                handlers: handlers.slice(delegateCount)
            });
            return handlerQueue;
        },
        addProp: function(name, hook) {
            Object.defineProperty(jQuery.Event.prototype, name, {
                enumerable: true,
                configurable: true,
                get: isFunction(hook) ? function() {
                    if (this.originalEvent) return hook(this.originalEvent);
                } : function() {
                    if (this.originalEvent) return this.originalEvent[name];
                },
                set: function(value) {
                    Object.defineProperty(this, name, {
                        enumerable: true,
                        configurable: true,
                        writable: true,
                        value: value
                    });
                }
            });
        },
        fix: function(originalEvent) {
            return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
        },
        special: {
            load: {
                // Prevent triggered image.load events from bubbling to window.load
                noBubble: true
            },
            click: {
                // Utilize native event to ensure correct state for checkable inputs
                setup: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Claim the first handler
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) // dataPriv.set( el, "click", ... )
                    leverageNative(el, "click", true);
                    // Return false to allow normal processing in the caller
                    return false;
                },
                trigger: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Force setup before triggering a click
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) leverageNative(el, "click");
                    // Return non-false to allow normal event-path propagation
                    return true;
                },
                // For cross-browser consistency, suppress native .click() on links
                // Also prevent it if we're currently inside a leveraged native-event stack
                _default: function(event) {
                    var target = event.target;
                    return rcheckableType.test(target.type) && target.click && nodeName(target, "input") && dataPriv.get(target, "click") || nodeName(target, "a");
                }
            },
            beforeunload: {
                postDispatch: function(event) {
                    // Support: Firefox 20+
                    // Firefox doesn't alert if the returnValue field is not set.
                    if (event.result !== undefined && event.originalEvent) event.originalEvent.returnValue = event.result;
                }
            }
        }
    };
    // Ensure the presence of an event listener that handles manually-triggered
    // synthetic events by interrupting progress until reinvoked in response to
    // *native* events that it fires directly, ensuring that state changes have
    // already occurred before other listeners are invoked.
    function leverageNative(el, type, isSetup) {
        // Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
        if (!isSetup) {
            if (dataPriv.get(el, type) === undefined) jQuery.event.add(el, type, returnTrue);
            return;
        }
        // Register the controller as a special universal handler for all event namespaces
        dataPriv.set(el, type, false);
        jQuery.event.add(el, type, {
            namespace: false,
            handler: function(event) {
                var result, saved = dataPriv.get(this, type);
                if (event.isTrigger & 1 && this[type]) {
                    // Interrupt processing of the outer synthetic .trigger()ed event
                    if (!saved) {
                        // Store arguments for use when handling the inner native event
                        // There will always be at least one argument (an event object), so this array
                        // will not be confused with a leftover capture object.
                        saved = slice.call(arguments);
                        dataPriv.set(this, type, saved);
                        // Trigger the native event and capture its result
                        this[type]();
                        result = dataPriv.get(this, type);
                        dataPriv.set(this, type, false);
                        if (saved !== result) {
                            // Cancel the outer synthetic event
                            event.stopImmediatePropagation();
                            event.preventDefault();
                            return result;
                        }
                    // If this is an inner synthetic event for an event with a bubbling surrogate
                    // (focus or blur), assume that the surrogate already propagated from triggering
                    // the native event and prevent that from happening again here.
                    // This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
                    // bubbling surrogate propagates *after* the non-bubbling base), but that seems
                    // less bad than duplication.
                    } else if ((jQuery.event.special[type] || {}).delegateType) event.stopPropagation();
                // If this is a native event triggered above, everything is now in order
                // Fire an inner synthetic event with the original arguments
                } else if (saved) {
                    // ...and capture the result
                    dataPriv.set(this, type, jQuery.event.trigger(saved[0], saved.slice(1), this));
                    // Abort handling of the native event by all jQuery handlers while allowing
                    // native handlers on the same element to run. On target, this is achieved
                    // by stopping immediate propagation just on the jQuery event. However,
                    // the native event is re-wrapped by a jQuery one on each level of the
                    // propagation so the only way to stop it for jQuery is to stop it for
                    // everyone via native `stopPropagation()`. This is not a problem for
                    // focus/blur which don't bubble, but it does also stop click on checkboxes
                    // and radios. We accept this limitation.
                    event.stopPropagation();
                    event.isImmediatePropagationStopped = returnTrue;
                }
            }
        });
    }
    jQuery.removeEvent = function(elem, type, handle) {
        // This "if" is needed for plain objects
        if (elem.removeEventListener) elem.removeEventListener(type, handle);
    };
    jQuery.Event = function(src, props) {
        // Allow instantiation without the 'new' keyword
        if (!(this instanceof jQuery.Event)) return new jQuery.Event(src, props);
        // Event object
        if (src && src.type) {
            this.originalEvent = src;
            this.type = src.type;
            // Events bubbling up the document may have been marked as prevented
            // by a handler lower down the tree; reflect the correct value.
            this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === undefined && // Support: Android <=2.3 only
            src.returnValue === false ? returnTrue : returnFalse;
            // Create target properties
            // Support: Safari <=6 - 7 only
            // Target should not be a text node (trac-504, trac-13143)
            this.target = src.target && src.target.nodeType === 3 ? src.target.parentNode : src.target;
            this.currentTarget = src.currentTarget;
            this.relatedTarget = src.relatedTarget;
        // Event type
        } else this.type = src;
        // Put explicitly provided properties onto the event object
        if (props) jQuery.extend(this, props);
        // Create a timestamp if incoming event doesn't have one
        this.timeStamp = src && src.timeStamp || Date.now();
        // Mark it as fixed
        this[jQuery.expando] = true;
    };
    // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
    // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
    jQuery.Event.prototype = {
        constructor: jQuery.Event,
        isDefaultPrevented: returnFalse,
        isPropagationStopped: returnFalse,
        isImmediatePropagationStopped: returnFalse,
        isSimulated: false,
        preventDefault: function() {
            var e = this.originalEvent;
            this.isDefaultPrevented = returnTrue;
            if (e && !this.isSimulated) e.preventDefault();
        },
        stopPropagation: function() {
            var e = this.originalEvent;
            this.isPropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopPropagation();
        },
        stopImmediatePropagation: function() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopImmediatePropagation();
            this.stopPropagation();
        }
    };
    // Includes all common event props including KeyEvent and MouseEvent specific props
    jQuery.each({
        altKey: true,
        bubbles: true,
        cancelable: true,
        changedTouches: true,
        ctrlKey: true,
        detail: true,
        eventPhase: true,
        metaKey: true,
        pageX: true,
        pageY: true,
        shiftKey: true,
        view: true,
        "char": true,
        code: true,
        charCode: true,
        key: true,
        keyCode: true,
        button: true,
        buttons: true,
        clientX: true,
        clientY: true,
        offsetX: true,
        offsetY: true,
        pointerId: true,
        pointerType: true,
        screenX: true,
        screenY: true,
        targetTouches: true,
        toElement: true,
        touches: true,
        which: true
    }, jQuery.event.addProp);
    jQuery.each({
        focus: "focusin",
        blur: "focusout"
    }, function(type, delegateType) {
        function focusMappedHandler(nativeEvent) {
            if (document.documentMode) {
                // Support: IE 11+
                // Attach a single focusin/focusout handler on the document while someone wants
                // focus/blur. This is because the former are synchronous in IE while the latter
                // are async. In other browsers, all those handlers are invoked synchronously.
                // `handle` from private data would already wrap the event, but we need
                // to change the `type` here.
                var handle = dataPriv.get(this, "handle"), event = jQuery.event.fix(nativeEvent);
                event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
                event.isSimulated = true;
                // First, handle focusin/focusout
                handle(nativeEvent);
                // ...then, handle focus/blur
                //
                // focus/blur don't bubble while focusin/focusout do; simulate the former by only
                // invoking the handler at the lower level.
                if (event.target === event.currentTarget) // The setup part calls `leverageNative`, which, in turn, calls
                // `jQuery.event.add`, so event handle will already have been set
                // by this point.
                handle(event);
            } else // For non-IE browsers, attach a single capturing handler on the document
            // while someone wants focusin/focusout.
            jQuery.event.simulate(delegateType, nativeEvent.target, jQuery.event.fix(nativeEvent));
        }
        jQuery.event.special[type] = {
            // Utilize native event if possible so blur/focus sequence is correct
            setup: function() {
                var attaches;
                // Claim the first handler
                // dataPriv.set( this, "focus", ... )
                // dataPriv.set( this, "blur", ... )
                leverageNative(this, type, true);
                if (document.documentMode) {
                    // Support: IE 9 - 11+
                    // We use the same native handler for focusin & focus (and focusout & blur)
                    // so we need to coordinate setup & teardown parts between those events.
                    // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                    attaches = dataPriv.get(this, delegateType);
                    if (!attaches) this.addEventListener(delegateType, focusMappedHandler);
                    dataPriv.set(this, delegateType, (attaches || 0) + 1);
                } else // Return false to allow normal processing in the caller
                return false;
            },
            trigger: function() {
                // Force setup before trigger
                leverageNative(this, type);
                // Return non-false to allow normal event-path propagation
                return true;
            },
            teardown: function() {
                var attaches;
                if (document.documentMode) {
                    attaches = dataPriv.get(this, delegateType) - 1;
                    if (!attaches) {
                        this.removeEventListener(delegateType, focusMappedHandler);
                        dataPriv.remove(this, delegateType);
                    } else dataPriv.set(this, delegateType, attaches);
                } else // Return false to indicate standard teardown should be applied
                return false;
            },
            // Suppress native focus or blur if we're currently inside
            // a leveraged native-event stack
            _default: function(event) {
                return dataPriv.get(event.target, type);
            },
            delegateType: delegateType
        };
        // Support: Firefox <=44
        // Firefox doesn't have focus(in | out) events
        // Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
        //
        // Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
        // focus(in | out) events fire after focus & blur events,
        // which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
        // Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
        //
        // Support: IE 9 - 11+
        // To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
        // attach a single handler for both events in IE.
        jQuery.event.special[delegateType] = {
            setup: function() {
                // Handle: regular nodes (via `this.ownerDocument`), window
                // (via `this.document`) & document (via `this`).
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType);
                // Support: IE 9 - 11+
                // We use the same native handler for focusin & focus (and focusout & blur)
                // so we need to coordinate setup & teardown parts between those events.
                // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                if (!attaches) {
                    if (document.documentMode) this.addEventListener(delegateType, focusMappedHandler);
                    else doc.addEventListener(type, focusMappedHandler, true);
                }
                dataPriv.set(dataHolder, delegateType, (attaches || 0) + 1);
            },
            teardown: function() {
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType) - 1;
                if (!attaches) {
                    if (document.documentMode) this.removeEventListener(delegateType, focusMappedHandler);
                    else doc.removeEventListener(type, focusMappedHandler, true);
                    dataPriv.remove(dataHolder, delegateType);
                } else dataPriv.set(dataHolder, delegateType, attaches);
            }
        };
    });
    // Create mouseenter/leave events using mouseover/out and event-time checks
    // so that event delegation works in jQuery.
    // Do the same for pointerenter/pointerleave and pointerover/pointerout
    //
    // Support: Safari 7 only
    // Safari sends mouseenter too often; see:
    // https://bugs.chromium.org/p/chromium/issues/detail?id=470258
    // for the description of the bug (it existed in older Chrome versions as well).
    jQuery.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(orig, fix) {
        jQuery.event.special[orig] = {
            delegateType: fix,
            bindType: fix,
            handle: function(event) {
                var ret, target = this, related = event.relatedTarget, handleObj = event.handleObj;
                // For mouseenter/leave call the handler if related is outside the target.
                // NB: No relatedTarget if the mouse left/entered the browser window
                if (!related || related !== target && !jQuery.contains(target, related)) {
                    event.type = handleObj.origType;
                    ret = handleObj.handler.apply(this, arguments);
                    event.type = fix;
                }
                return ret;
            }
        };
    });
    jQuery.fn.extend({
        on: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn);
        },
        one: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn, 1);
        },
        off: function(types, selector, fn) {
            var handleObj, type;
            if (types && types.preventDefault && types.handleObj) {
                // ( event )  dispatched jQuery.Event
                handleObj = types.handleObj;
                jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
                return this;
            }
            if (typeof types === "object") {
                // ( types-object [, selector] )
                for(type in types)this.off(type, selector, types[type]);
                return this;
            }
            if (selector === false || typeof selector === "function") {
                // ( types [, fn] )
                fn = selector;
                selector = undefined;
            }
            if (fn === false) fn = returnFalse;
            return this.each(function() {
                jQuery.event.remove(this, types, fn, selector);
            });
        }
    });
    var // Support: IE <=10 - 11, Edge 12 - 13 only
    // In IE/Edge using regex groups here causes severe slowdowns.
    // See https://connect.microsoft.com/IE/feedback/details/1736512/
    rnoInnerhtml = /<script|<style|<link/i, // checked="checked" or checked
    rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i, rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
    // Prefer a tbody over its parent table for containing new rows
    function manipulationTarget(elem, content) {
        if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) return jQuery(elem).children("tbody")[0] || elem;
        return elem;
    }
    // Replace/restore the type attribute of script elements for safe DOM manipulation
    function disableScript(elem) {
        elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
        return elem;
    }
    function restoreScript(elem) {
        if ((elem.type || "").slice(0, 5) === "true/") elem.type = elem.type.slice(5);
        else elem.removeAttribute("type");
        return elem;
    }
    function cloneCopyEvent(src, dest) {
        var i, l, type, pdataOld, udataOld, udataCur, events;
        if (dest.nodeType !== 1) return;
        // 1. Copy private data: events, handlers, etc.
        if (dataPriv.hasData(src)) {
            pdataOld = dataPriv.get(src);
            events = pdataOld.events;
            if (events) {
                dataPriv.remove(dest, "handle events");
                for(type in events)for(i = 0, l = events[type].length; i < l; i++)jQuery.event.add(dest, type, events[type][i]);
            }
        }
        // 2. Copy user data
        if (dataUser.hasData(src)) {
            udataOld = dataUser.access(src);
            udataCur = jQuery.extend({}, udataOld);
            dataUser.set(dest, udataCur);
        }
    }
    // Fix IE bugs, see support tests
    function fixInput(src, dest) {
        var nodeName = dest.nodeName.toLowerCase();
        // Fails to persist the checked state of a cloned checkbox or radio button.
        if (nodeName === "input" && rcheckableType.test(src.type)) dest.checked = src.checked;
        else if (nodeName === "input" || nodeName === "textarea") dest.defaultValue = src.defaultValue;
    }
    function domManip(collection, args, callback, ignored) {
        // Flatten any nested arrays
        args = flat(args);
        var fragment, first, scripts, hasScripts, node, doc, i = 0, l = collection.length, iNoClone = l - 1, value = args[0], valueIsFunction = isFunction(value);
        // We can't cloneNode fragments that contain checked, in WebKit
        if (valueIsFunction || l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) return collection.each(function(index) {
            var self = collection.eq(index);
            if (valueIsFunction) args[0] = value.call(this, index, self.html());
            domManip(self, args, callback, ignored);
        });
        if (l) {
            fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
            first = fragment.firstChild;
            if (fragment.childNodes.length === 1) fragment = first;
            // Require either new content or an interest in ignored elements to invoke the callback
            if (first || ignored) {
                scripts = jQuery.map(getAll(fragment, "script"), disableScript);
                hasScripts = scripts.length;
                // Use the original fragment for the last item
                // instead of the first because it can end up
                // being emptied incorrectly in certain situations (trac-8070).
                for(; i < l; i++){
                    node = fragment;
                    if (i !== iNoClone) {
                        node = jQuery.clone(node, true, true);
                        // Keep references to cloned scripts for later restoration
                        if (hasScripts) // Support: Android <=4.0 only, PhantomJS 1 only
                        // push.apply(_, arraylike) throws on ancient WebKit
                        jQuery.merge(scripts, getAll(node, "script"));
                    }
                    callback.call(collection[i], node, i);
                }
                if (hasScripts) {
                    doc = scripts[scripts.length - 1].ownerDocument;
                    // Re-enable scripts
                    jQuery.map(scripts, restoreScript);
                    // Evaluate executable scripts on first document insertion
                    for(i = 0; i < hasScripts; i++){
                        node = scripts[i];
                        if (rscriptType.test(node.type || "") && !dataPriv.access(node, "globalEval") && jQuery.contains(doc, node)) {
                            if (node.src && (node.type || "").toLowerCase() !== "module") // Optional AJAX dependency, but won't run scripts if not present
                            {
                                if (jQuery._evalUrl && !node.noModule) jQuery._evalUrl(node.src, {
                                    nonce: node.nonce || node.getAttribute("nonce")
                                }, doc);
                            } else // Unwrap a CDATA section containing script contents. This shouldn't be
                            // needed as in XML documents they're already not visible when
                            // inspecting element contents and in HTML documents they have no
                            // meaning but we're preserving that logic for backwards compatibility.
                            // This will be removed completely in 4.0. See gh-4904.
                            DOMEval(node.textContent.replace(rcleanScript, ""), node, doc);
                        }
                    }
                }
            }
        }
        return collection;
    }
    function remove(elem, selector, keepData) {
        var node, nodes = selector ? jQuery.filter(selector, elem) : elem, i = 0;
        for(; (node = nodes[i]) != null; i++){
            if (!keepData && node.nodeType === 1) jQuery.cleanData(getAll(node));
            if (node.parentNode) {
                if (keepData && isAttached(node)) setGlobalEval(getAll(node, "script"));
                node.parentNode.removeChild(node);
            }
        }
        return elem;
    }
    jQuery.extend({
        htmlPrefilter: function(html) {
            return html;
        },
        clone: function(elem, dataAndEvents, deepDataAndEvents) {
            var i, l, srcElements, destElements, clone = elem.cloneNode(true), inPage = isAttached(elem);
            // Fix IE cloning issues
            if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
                // We eschew jQuery#find here for performance reasons:
                // https://jsperf.com/getall-vs-sizzle/2
                destElements = getAll(clone);
                srcElements = getAll(elem);
                for(i = 0, l = srcElements.length; i < l; i++)fixInput(srcElements[i], destElements[i]);
            }
            // Copy the events from the original to the clone
            if (dataAndEvents) {
                if (deepDataAndEvents) {
                    srcElements = srcElements || getAll(elem);
                    destElements = destElements || getAll(clone);
                    for(i = 0, l = srcElements.length; i < l; i++)cloneCopyEvent(srcElements[i], destElements[i]);
                } else cloneCopyEvent(elem, clone);
            }
            // Preserve script evaluation history
            destElements = getAll(clone, "script");
            if (destElements.length > 0) setGlobalEval(destElements, !inPage && getAll(elem, "script"));
            // Return the cloned set
            return clone;
        },
        cleanData: function(elems) {
            var data, elem, type, special = jQuery.event.special, i = 0;
            for(; (elem = elems[i]) !== undefined; i++)if (acceptData(elem)) {
                if (data = elem[dataPriv.expando]) {
                    if (data.events) {
                        for(type in data.events)if (special[type]) jQuery.event.remove(elem, type);
                        else jQuery.removeEvent(elem, type, data.handle);
                    }
                    // Support: Chrome <=35 - 45+
                    // Assign undefined instead of using delete, see Data#remove
                    elem[dataPriv.expando] = undefined;
                }
                if (elem[dataUser.expando]) // Support: Chrome <=35 - 45+
                // Assign undefined instead of using delete, see Data#remove
                elem[dataUser.expando] = undefined;
            }
        }
    });
    jQuery.fn.extend({
        detach: function(selector) {
            return remove(this, selector, true);
        },
        remove: function(selector) {
            return remove(this, selector);
        },
        text: function(value) {
            return access(this, function(value) {
                return value === undefined ? jQuery.text(this) : this.empty().each(function() {
                    if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) this.textContent = value;
                });
            }, null, value, arguments.length);
        },
        append: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.appendChild(elem);
                }
            });
        },
        prepend: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.insertBefore(elem, target.firstChild);
                }
            });
        },
        before: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this);
            });
        },
        after: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this.nextSibling);
            });
        },
        empty: function() {
            var elem, i = 0;
            for(; (elem = this[i]) != null; i++)if (elem.nodeType === 1) {
                // Prevent memory leaks
                jQuery.cleanData(getAll(elem, false));
                // Remove any remaining nodes
                elem.textContent = "";
            }
            return this;
        },
        clone: function(dataAndEvents, deepDataAndEvents) {
            dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
            deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
            return this.map(function() {
                return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
            });
        },
        html: function(value) {
            return access(this, function(value) {
                var elem = this[0] || {}, i = 0, l = this.length;
                if (value === undefined && elem.nodeType === 1) return elem.innerHTML;
                // See if we can take a shortcut and just use innerHTML
                if (typeof value === "string" && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || [
                    "",
                    ""
                ])[1].toLowerCase()]) {
                    value = jQuery.htmlPrefilter(value);
                    try {
                        for(; i < l; i++){
                            elem = this[i] || {};
                            // Remove element nodes and prevent memory leaks
                            if (elem.nodeType === 1) {
                                jQuery.cleanData(getAll(elem, false));
                                elem.innerHTML = value;
                            }
                        }
                        elem = 0;
                    // If using innerHTML throws an exception, use the fallback method
                    } catch (e) {}
                }
                if (elem) this.empty().append(value);
            }, null, value, arguments.length);
        },
        replaceWith: function() {
            var ignored = [];
            // Make the changes, replacing each non-ignored context element with the new content
            return domManip(this, arguments, function(elem) {
                var parent = this.parentNode;
                if (jQuery.inArray(this, ignored) < 0) {
                    jQuery.cleanData(getAll(this));
                    if (parent) parent.replaceChild(elem, this);
                }
            // Force callback invocation
            }, ignored);
        }
    });
    jQuery.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(name, original) {
        jQuery.fn[name] = function(selector) {
            var elems, ret = [], insert = jQuery(selector), last = insert.length - 1, i = 0;
            for(; i <= last; i++){
                elems = i === last ? this : this.clone(true);
                jQuery(insert[i])[original](elems);
                // Support: Android <=4.0 only, PhantomJS 1 only
                // .get() because push.apply(_, arraylike) throws on ancient WebKit
                push.apply(ret, elems.get());
            }
            return this.pushStack(ret);
        };
    });
    var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
    var rcustomProp = /^--/;
    var getStyles = function(elem) {
        // Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
        // IE throws on elements created in popups
        // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
        var view = elem.ownerDocument.defaultView;
        if (!view || !view.opener) view = window1;
        return view.getComputedStyle(elem);
    };
    var swap = function(elem, options, callback) {
        var ret, name, old = {};
        // Remember the old values, and insert the new ones
        for(name in options){
            old[name] = elem.style[name];
            elem.style[name] = options[name];
        }
        ret = callback.call(elem);
        // Revert the old values
        for(name in options)elem.style[name] = old[name];
        return ret;
    };
    var rboxStyle = new RegExp(cssExpand.join("|"), "i");
    (function() {
        // Executing both pixelPosition & boxSizingReliable tests require only one layout
        // so they're executed at the same time to save the second computation.
        function computeStyleTests() {
            // This is a singleton, we need to execute it only once
            if (!div) return;
            container.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0";
            div.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%";
            documentElement.appendChild(container).appendChild(div);
            var divStyle = window1.getComputedStyle(div);
            pixelPositionVal = divStyle.top !== "1%";
            // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
            reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;
            // Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
            // Some styles come back with percentage values, even though they shouldn't
            div.style.right = "60%";
            pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;
            // Support: IE 9 - 11 only
            // Detect misreporting of content dimensions for box-sizing:border-box elements
            boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;
            // Support: IE 9 only
            // Detect overflow:scroll screwiness (gh-3699)
            // Support: Chrome <=64
            // Don't get tricked when zoom affects offsetWidth (gh-4029)
            div.style.position = "absolute";
            scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12;
            documentElement.removeChild(container);
            // Nullify the div so it wouldn't be stored in the memory and
            // it will also be a sign that checks already performed
            div = null;
        }
        function roundPixelMeasures(measure) {
            return Math.round(parseFloat(measure));
        }
        var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal, reliableTrDimensionsVal, reliableMarginLeftVal, container = document.createElement("div"), div = document.createElement("div");
        // Finish early in limited (non-browser) environments
        if (!div.style) return;
        // Support: IE <=9 - 11 only
        // Style of cloned element affects source element cloned (trac-8908)
        div.style.backgroundClip = "content-box";
        div.cloneNode(true).style.backgroundClip = "";
        support.clearCloneStyle = div.style.backgroundClip === "content-box";
        jQuery.extend(support, {
            boxSizingReliable: function() {
                computeStyleTests();
                return boxSizingReliableVal;
            },
            pixelBoxStyles: function() {
                computeStyleTests();
                return pixelBoxStylesVal;
            },
            pixelPosition: function() {
                computeStyleTests();
                return pixelPositionVal;
            },
            reliableMarginLeft: function() {
                computeStyleTests();
                return reliableMarginLeftVal;
            },
            scrollboxSize: function() {
                computeStyleTests();
                return scrollboxSizeVal;
            },
            // Support: IE 9 - 11+, Edge 15 - 18+
            // IE/Edge misreport `getComputedStyle` of table rows with width/height
            // set in CSS while `offset*` properties report correct values.
            // Behavior in IE 9 is more subtle than in newer versions & it passes
            // some versions of this test; make sure not to make it pass there!
            //
            // Support: Firefox 70+
            // Only Firefox includes border widths
            // in computed dimensions. (gh-4529)
            reliableTrDimensions: function() {
                var table, tr, trChild, trStyle;
                if (reliableTrDimensionsVal == null) {
                    table = document.createElement("table");
                    tr = document.createElement("tr");
                    trChild = document.createElement("div");
                    table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
                    tr.style.cssText = "box-sizing:content-box;border:1px solid";
                    // Support: Chrome 86+
                    // Height set through cssText does not get applied.
                    // Computed height then comes back as 0.
                    tr.style.height = "1px";
                    trChild.style.height = "9px";
                    // Support: Android 8 Chrome 86+
                    // In our bodyBackground.html iframe,
                    // display for all div elements is set to "inline",
                    // which causes a problem only in Android 8 Chrome 86.
                    // Ensuring the div is `display: block`
                    // gets around this issue.
                    trChild.style.display = "block";
                    documentElement.appendChild(table).appendChild(tr).appendChild(trChild);
                    trStyle = window1.getComputedStyle(tr);
                    reliableTrDimensionsVal = parseInt(trStyle.height, 10) + parseInt(trStyle.borderTopWidth, 10) + parseInt(trStyle.borderBottomWidth, 10) === tr.offsetHeight;
                    documentElement.removeChild(table);
                }
                return reliableTrDimensionsVal;
            }
        });
    })();
    function curCSS(elem, name, computed) {
        var width, minWidth, maxWidth, ret, isCustomProp = rcustomProp.test(name), // Support: Firefox 51+
        // Retrieving style before computed somehow
        // fixes an issue with getting wrong values
        // on detached elements
        style = elem.style;
        computed = computed || getStyles(elem);
        // getPropertyValue is needed for:
        //   .css('filter') (IE 9 only, trac-12537)
        //   .css('--customProperty) (gh-3144)
        if (computed) {
            // Support: IE <=9 - 11+
            // IE only supports `"float"` in `getPropertyValue`; in computed styles
            // it's only available as `"cssFloat"`. We no longer modify properties
            // sent to `.css()` apart from camelCasing, so we need to check both.
            // Normally, this would create difference in behavior: if
            // `getPropertyValue` returns an empty string, the value returned
            // by `.css()` would be `undefined`. This is usually the case for
            // disconnected elements. However, in IE even disconnected elements
            // with no styles return `"none"` for `getPropertyValue( "float" )`
            ret = computed.getPropertyValue(name) || computed[name];
            if (isCustomProp && ret) // Support: Firefox 105+, Chrome <=105+
            // Spec requires trimming whitespace for custom properties (gh-4926).
            // Firefox only trims leading whitespace. Chrome just collapses
            // both leading & trailing whitespace to a single space.
            //
            // Fall back to `undefined` if empty string returned.
            // This collapses a missing definition with property defined
            // and set to an empty string but there's no standard API
            // allowing us to differentiate them without a performance penalty
            // and returning `undefined` aligns with older jQuery.
            //
            // rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
            // as whitespace while CSS does not, but this is not a problem
            // because CSS preprocessing replaces them with U+000A LINE FEED
            // (which *is* CSS whitespace)
            // https://www.w3.org/TR/css-syntax-3/#input-preprocessing
            ret = ret.replace(rtrimCSS, "$1") || undefined;
            if (ret === "" && !isAttached(elem)) ret = jQuery.style(elem, name);
            // A tribute to the "awesome hack by Dean Edwards"
            // Android Browser returns percentage for some values,
            // but width seems to be reliably pixels.
            // This is against the CSSOM draft spec:
            // https://drafts.csswg.org/cssom/#resolved-values
            if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {
                // Remember the original values
                width = style.width;
                minWidth = style.minWidth;
                maxWidth = style.maxWidth;
                // Put in the new values to get a computed value out
                style.minWidth = style.maxWidth = style.width = ret;
                ret = computed.width;
                // Revert the changed values
                style.width = width;
                style.minWidth = minWidth;
                style.maxWidth = maxWidth;
            }
        }
        return ret !== undefined ? // Support: IE <=9 - 11 only
        // IE returns zIndex value as an integer.
        ret + "" : ret;
    }
    function addGetHookIf(conditionFn, hookFn) {
        // Define the hook, we'll check on the first run if it's really needed.
        return {
            get: function() {
                if (conditionFn()) {
                    // Hook not needed (or it's not possible to use it due
                    // to missing dependency), remove it.
                    delete this.get;
                    return;
                }
                // Hook needed; redefine it so that the support test is not executed again.
                return (this.get = hookFn).apply(this, arguments);
            }
        };
    }
    var cssPrefixes = [
        "Webkit",
        "Moz",
        "ms"
    ], emptyStyle = document.createElement("div").style, vendorProps = {};
    // Return a vendor-prefixed property or undefined
    function vendorPropName(name) {
        // Check for vendor prefixed names
        var capName = name[0].toUpperCase() + name.slice(1), i = cssPrefixes.length;
        while(i--){
            name = cssPrefixes[i] + capName;
            if (name in emptyStyle) return name;
        }
    }
    // Return a potentially-mapped jQuery.cssProps or vendor prefixed property
    function finalPropName(name) {
        var final = jQuery.cssProps[name] || vendorProps[name];
        if (final) return final;
        if (name in emptyStyle) return name;
        return vendorProps[name] = vendorPropName(name) || name;
    }
    var // Swappable if display is none or starts with table
    // except "table", "table-cell", or "table-caption"
    // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
    rdisplayswap = /^(none|table(?!-c[ea]).+)/, cssShow = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }, cssNormalTransform = {
        letterSpacing: "0",
        fontWeight: "400"
    };
    function setPositiveNumber(_elem, value, subtract) {
        // Any relative (+/-) values have already been
        // normalized at this point
        var matches = rcssNum.exec(value);
        return matches ? // Guard against undefined "subtract", e.g., when used as in cssHooks
        Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value;
    }
    function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
        var i = dimension === "width" ? 1 : 0, extra = 0, delta = 0, marginDelta = 0;
        // Adjustment may not be necessary
        if (box === (isBorderBox ? "border" : "content")) return 0;
        for(; i < 4; i += 2){
            // Both box models exclude margin
            // Count margin delta separately to only add it after scroll gutter adjustment.
            // This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
            if (box === "margin") marginDelta += jQuery.css(elem, box + cssExpand[i], true, styles);
            // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
            if (!isBorderBox) {
                // Add padding
                delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "border" or "margin", add border
                if (box !== "padding") delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
                else extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            // If we get here with a border-box (content + padding + border), we're seeking "content" or
            // "padding" or "margin"
            } else {
                // For "content", subtract padding
                if (box === "content") delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "content" or "padding", subtract border
                if (box !== "margin") delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            }
        }
        // Account for positive content-box scroll gutter when requested by providing computedVal
        if (!isBorderBox && computedVal >= 0) // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
        // Assuming integer scroll gutter, subtract the rest and round down
        delta += Math.max(0, Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5)) || 0;
        return delta + marginDelta;
    }
    function getWidthOrHeight(elem, dimension, extra) {
        // Start with computed style
        var styles = getStyles(elem), // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
        // Fake content-box until we know it's needed to know the true value.
        boxSizingNeeded = !support.boxSizingReliable() || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", valueIsBorderBox = isBorderBox, val = curCSS(elem, dimension, styles), offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1);
        // Support: Firefox <=54
        // Return a confounding non-pixel value or feign ignorance, as appropriate.
        if (rnumnonpx.test(val)) {
            if (!extra) return val;
            val = "auto";
        }
        // Support: IE 9 - 11 only
        // Use offsetWidth/offsetHeight for when box sizing is unreliable.
        // In those cases, the computed value can be trusted to be border-box.
        if ((!support.boxSizingReliable() && isBorderBox || // Support: IE 10 - 11+, Edge 15 - 18+
        // IE/Edge misreport `getComputedStyle` of table rows with width/height
        // set in CSS while `offset*` properties report correct values.
        // Interestingly, in some cases IE 9 doesn't suffer from this issue.
        !support.reliableTrDimensions() && nodeName(elem, "tr") || // Fall back to offsetWidth/offsetHeight when value is "auto"
        // This happens for inline elements with no explicit setting (gh-3571)
        val === "auto" || // Support: Android <=4.1 - 4.3 only
        // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
        !parseFloat(val) && jQuery.css(elem, "display", false, styles) === "inline") && // Make sure the element is visible & connected
        elem.getClientRects().length) {
            isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";
            // Where available, offsetWidth/offsetHeight approximate border box dimensions.
            // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
            // retrieved value as a content box dimension.
            valueIsBorderBox = offsetProp in elem;
            if (valueIsBorderBox) val = elem[offsetProp];
        }
        // Normalize "" and auto
        val = parseFloat(val) || 0;
        // Adjust for the element's box model
        return val + boxModelAdjustment(elem, dimension, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles, // Provide the current computed size to request scroll gutter calculation (gh-3589)
        val) + "px";
    }
    jQuery.extend({
        // Add in style property hooks for overriding the default
        // behavior of getting and setting a style property
        cssHooks: {
            opacity: {
                get: function(elem, computed) {
                    if (computed) {
                        // We should always get a number back from opacity
                        var ret = curCSS(elem, "opacity");
                        return ret === "" ? "1" : ret;
                    }
                }
            }
        },
        // Don't automatically add "px" to these possibly-unitless properties
        cssNumber: {
            animationIterationCount: true,
            aspectRatio: true,
            borderImageSlice: true,
            columnCount: true,
            flexGrow: true,
            flexShrink: true,
            fontWeight: true,
            gridArea: true,
            gridColumn: true,
            gridColumnEnd: true,
            gridColumnStart: true,
            gridRow: true,
            gridRowEnd: true,
            gridRowStart: true,
            lineHeight: true,
            opacity: true,
            order: true,
            orphans: true,
            scale: true,
            widows: true,
            zIndex: true,
            zoom: true,
            // SVG-related
            fillOpacity: true,
            floodOpacity: true,
            stopOpacity: true,
            strokeMiterlimit: true,
            strokeOpacity: true
        },
        // Add in properties whose names you wish to fix before
        // setting or getting the value
        cssProps: {},
        // Get and set the style property on a DOM Node
        style: function(elem, name, value, extra) {
            // Don't set styles on text and comment nodes
            if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) return;
            // Make sure that we're working with the right name
            var ret, type, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name), style = elem.style;
            // Make sure that we're working with the right name. We don't
            // want to query the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Gets hook for the prefixed version, then unprefixed version
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // Check if we're setting a value
            if (value !== undefined) {
                type = typeof value;
                // Convert "+=" or "-=" to relative numbers (trac-7345)
                if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
                    value = adjustCSS(elem, name, ret);
                    // Fixes bug trac-9237
                    type = "number";
                }
                // Make sure that null and NaN values aren't set (trac-7116)
                if (value == null || value !== value) return;
                // If a number was passed in, add the unit (except for certain CSS properties)
                // The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
                // "px" to a few hardcoded values.
                if (type === "number" && !isCustomProp) value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
                // background-* props affect original clone's values
                if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) style[name] = "inherit";
                // If a hook was provided, use that value, otherwise just set the specified value
                if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {
                    if (isCustomProp) style.setProperty(name, value);
                    else style[name] = value;
                }
            } else {
                // If a hook was provided get the non-computed value from there
                if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) return ret;
                // Otherwise just get the value from the style object
                return style[name];
            }
        },
        css: function(elem, name, extra, styles) {
            var val, num, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name);
            // Make sure that we're working with the right name. We don't
            // want to modify the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Try prefixed name followed by the unprefixed name
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // If a hook was provided get the computed value from there
            if (hooks && "get" in hooks) val = hooks.get(elem, true, extra);
            // Otherwise, if a way to get the computed value exists, use that
            if (val === undefined) val = curCSS(elem, name, styles);
            // Convert "normal" to computed value
            if (val === "normal" && name in cssNormalTransform) val = cssNormalTransform[name];
            // Make numeric if forced or a qualifier was provided and val looks numeric
            if (extra === "" || extra) {
                num = parseFloat(val);
                return extra === true || isFinite(num) ? num || 0 : val;
            }
            return val;
        }
    });
    jQuery.each([
        "height",
        "width"
    ], function(_i, dimension) {
        jQuery.cssHooks[dimension] = {
            get: function(elem, computed, extra) {
                if (computed) // Certain elements can have dimension info if we invisibly show them
                // but it must have a current display style that would benefit
                return rdisplayswap.test(jQuery.css(elem, "display")) && // Support: Safari 8+
                // Table columns in Safari have non-zero offsetWidth & zero
                // getBoundingClientRect().width unless display is changed.
                // Support: IE <=11 only
                // Running getBoundingClientRect on a disconnected node
                // in IE throws an error.
                (!elem.getClientRects().length || !elem.getBoundingClientRect().width) ? swap(elem, cssShow, function() {
                    return getWidthOrHeight(elem, dimension, extra);
                }) : getWidthOrHeight(elem, dimension, extra);
            },
            set: function(elem, value, extra) {
                var matches, styles = getStyles(elem), // Only read styles.position if the test has a chance to fail
                // to avoid forcing a reflow.
                scrollboxSizeBuggy = !support.scrollboxSize() && styles.position === "absolute", // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
                boxSizingNeeded = scrollboxSizeBuggy || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", subtract = extra ? boxModelAdjustment(elem, dimension, extra, isBorderBox, styles) : 0;
                // Account for unreliable border-box dimensions by comparing offset* to computed and
                // faking a content-box to get border and padding (gh-3699)
                if (isBorderBox && scrollboxSizeBuggy) subtract -= Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - parseFloat(styles[dimension]) - boxModelAdjustment(elem, dimension, "border", false, styles) - 0.5);
                // Convert to pixels if value adjustment is needed
                if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {
                    elem.style[dimension] = value;
                    value = jQuery.css(elem, dimension);
                }
                return setPositiveNumber(elem, value, subtract);
            }
        };
    });
    jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft, function(elem, computed) {
        if (computed) return (parseFloat(curCSS(elem, "marginLeft")) || elem.getBoundingClientRect().left - swap(elem, {
            marginLeft: 0
        }, function() {
            return elem.getBoundingClientRect().left;
        })) + "px";
    });
    // These hooks are used by animate to expand properties
    jQuery.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(prefix, suffix) {
        jQuery.cssHooks[prefix + suffix] = {
            expand: function(value) {
                var i = 0, expanded = {}, // Assumes a single number if not a string
                parts = typeof value === "string" ? value.split(" ") : [
                    value
                ];
                for(; i < 4; i++)expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
                return expanded;
            }
        };
        if (prefix !== "margin") jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
    });
    jQuery.fn.extend({
        css: function(name, value) {
            return access(this, function(elem, name, value) {
                var styles, len, map = {}, i = 0;
                if (Array.isArray(name)) {
                    styles = getStyles(elem);
                    len = name.length;
                    for(; i < len; i++)map[name[i]] = jQuery.css(elem, name[i], false, styles);
                    return map;
                }
                return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
            }, name, value, arguments.length > 1);
        }
    });
    function Tween(elem, options, prop, end, easing) {
        return new Tween.prototype.init(elem, options, prop, end, easing);
    }
    jQuery.Tween = Tween;
    Tween.prototype = {
        constructor: Tween,
        init: function(elem, options, prop, end, easing, unit) {
            this.elem = elem;
            this.prop = prop;
            this.easing = easing || jQuery.easing._default;
            this.options = options;
            this.start = this.now = this.cur();
            this.end = end;
            this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
        },
        cur: function() {
            var hooks = Tween.propHooks[this.prop];
            return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
        },
        run: function(percent) {
            var eased, hooks = Tween.propHooks[this.prop];
            if (this.options.duration) this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
            else this.pos = eased = percent;
            this.now = (this.end - this.start) * eased + this.start;
            if (this.options.step) this.options.step.call(this.elem, this.now, this);
            if (hooks && hooks.set) hooks.set(this);
            else Tween.propHooks._default.set(this);
            return this;
        }
    };
    Tween.prototype.init.prototype = Tween.prototype;
    Tween.propHooks = {
        _default: {
            get: function(tween) {
                var result;
                // Use a property on the element directly when it is not a DOM element,
                // or when there is no matching style property that exists.
                if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) return tween.elem[tween.prop];
                // Passing an empty string as a 3rd parameter to .css will automatically
                // attempt a parseFloat and fallback to a string if the parse fails.
                // Simple values such as "10px" are parsed to Float;
                // complex values such as "rotate(1rad)" are returned as-is.
                result = jQuery.css(tween.elem, tween.prop, "");
                // Empty strings, null, undefined and "auto" are converted to 0.
                return !result || result === "auto" ? 0 : result;
            },
            set: function(tween) {
                // Use step hook for back compat.
                // Use cssHook if its there.
                // Use .style if available and use plain properties where available.
                if (jQuery.fx.step[tween.prop]) jQuery.fx.step[tween.prop](tween);
                else if (tween.elem.nodeType === 1 && (jQuery.cssHooks[tween.prop] || tween.elem.style[finalPropName(tween.prop)] != null)) jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
                else tween.elem[tween.prop] = tween.now;
            }
        }
    };
    // Support: IE <=9 only
    // Panic based approach to setting things on disconnected nodes
    Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
        set: function(tween) {
            if (tween.elem.nodeType && tween.elem.parentNode) tween.elem[tween.prop] = tween.now;
        }
    };
    jQuery.easing = {
        linear: function(p) {
            return p;
        },
        swing: function(p) {
            return 0.5 - Math.cos(p * Math.PI) / 2;
        },
        _default: "swing"
    };
    jQuery.fx = Tween.prototype.init;
    // Back compat <1.8 extension point
    jQuery.fx.step = {};
    var fxNow, inProgress, rfxtypes = /^(?:toggle|show|hide)$/, rrun = /queueHooks$/;
    function schedule() {
        if (inProgress) {
            if (document.hidden === false && window1.requestAnimationFrame) window1.requestAnimationFrame(schedule);
            else window1.setTimeout(schedule, jQuery.fx.interval);
            jQuery.fx.tick();
        }
    }
    // Animations created synchronously will run synchronously
    function createFxNow() {
        window1.setTimeout(function() {
            fxNow = undefined;
        });
        return fxNow = Date.now();
    }
    // Generate parameters to create a standard animation
    function genFx(type, includeWidth) {
        var which, i = 0, attrs = {
            height: type
        };
        // If we include width, step value is 1 to do all cssExpand values,
        // otherwise step value is 2 to skip over Left and Right
        includeWidth = includeWidth ? 1 : 0;
        for(; i < 4; i += 2 - includeWidth){
            which = cssExpand[i];
            attrs["margin" + which] = attrs["padding" + which] = type;
        }
        if (includeWidth) attrs.opacity = attrs.width = type;
        return attrs;
    }
    function createTween(value, prop, animation) {
        var tween, collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]), index = 0, length = collection.length;
        for(; index < length; index++){
            if (tween = collection[index].call(animation, prop, value)) // We're done with this property
            return tween;
        }
    }
    function defaultPrefilter(elem, props, opts) {
        var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display, isBox = "width" in props || "height" in props, anim = this, orig = {}, style = elem.style, hidden = elem.nodeType && isHiddenWithinTree(elem), dataShow = dataPriv.get(elem, "fxshow");
        // Queue-skipping animations hijack the fx hooks
        if (!opts.queue) {
            hooks = jQuery._queueHooks(elem, "fx");
            if (hooks.unqueued == null) {
                hooks.unqueued = 0;
                oldfire = hooks.empty.fire;
                hooks.empty.fire = function() {
                    if (!hooks.unqueued) oldfire();
                };
            }
            hooks.unqueued++;
            anim.always(function() {
                // Ensure the complete handler is called before this completes
                anim.always(function() {
                    hooks.unqueued--;
                    if (!jQuery.queue(elem, "fx").length) hooks.empty.fire();
                });
            });
        }
        // Detect show/hide animations
        for(prop in props){
            value = props[prop];
            if (rfxtypes.test(value)) {
                delete props[prop];
                toggle = toggle || value === "toggle";
                if (value === (hidden ? "hide" : "show")) {
                    // Pretend to be hidden if this is a "show" and
                    // there is still data from a stopped show/hide
                    if (value === "show" && dataShow && dataShow[prop] !== undefined) hidden = true;
                    else continue;
                }
                orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
            }
        }
        // Bail out if this is a no-op like .hide().hide()
        propTween = !jQuery.isEmptyObject(props);
        if (!propTween && jQuery.isEmptyObject(orig)) return;
        // Restrict "overflow" and "display" styles during box animations
        if (isBox && elem.nodeType === 1) {
            // Support: IE <=9 - 11, Edge 12 - 15
            // Record all 3 overflow attributes because IE does not infer the shorthand
            // from identically-valued overflowX and overflowY and Edge just mirrors
            // the overflowX value there.
            opts.overflow = [
                style.overflow,
                style.overflowX,
                style.overflowY
            ];
            // Identify a display type, preferring old show/hide data over the CSS cascade
            restoreDisplay = dataShow && dataShow.display;
            if (restoreDisplay == null) restoreDisplay = dataPriv.get(elem, "display");
            display = jQuery.css(elem, "display");
            if (display === "none") {
                if (restoreDisplay) display = restoreDisplay;
                else {
                    // Get nonempty value(s) by temporarily forcing visibility
                    showHide([
                        elem
                    ], true);
                    restoreDisplay = elem.style.display || restoreDisplay;
                    display = jQuery.css(elem, "display");
                    showHide([
                        elem
                    ]);
                }
            }
            // Animate inline elements as inline-block
            if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
                if (jQuery.css(elem, "float") === "none") {
                    // Restore the original display value at the end of pure show/hide animations
                    if (!propTween) {
                        anim.done(function() {
                            style.display = restoreDisplay;
                        });
                        if (restoreDisplay == null) {
                            display = style.display;
                            restoreDisplay = display === "none" ? "" : display;
                        }
                    }
                    style.display = "inline-block";
                }
            }
        }
        if (opts.overflow) {
            style.overflow = "hidden";
            anim.always(function() {
                style.overflow = opts.overflow[0];
                style.overflowX = opts.overflow[1];
                style.overflowY = opts.overflow[2];
            });
        }
        // Implement show/hide animations
        propTween = false;
        for(prop in orig){
            // General show/hide setup for this element animation
            if (!propTween) {
                if (dataShow) {
                    if ("hidden" in dataShow) hidden = dataShow.hidden;
                } else dataShow = dataPriv.access(elem, "fxshow", {
                    display: restoreDisplay
                });
                // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
                if (toggle) dataShow.hidden = !hidden;
                // Show elements before animating them
                if (hidden) showHide([
                    elem
                ], true);
                /* eslint-disable no-loop-func */ anim.done(function() {
                    /* eslint-enable no-loop-func */ // The final step of a "hide" animation is actually hiding the element
                    if (!hidden) showHide([
                        elem
                    ]);
                    dataPriv.remove(elem, "fxshow");
                    for(prop in orig)jQuery.style(elem, prop, orig[prop]);
                });
            }
            // Per-property setup
            propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
            if (!(prop in dataShow)) {
                dataShow[prop] = propTween.start;
                if (hidden) {
                    propTween.end = propTween.start;
                    propTween.start = 0;
                }
            }
        }
    }
    function propFilter(props, specialEasing) {
        var index, name, easing, value, hooks;
        // camelCase, specialEasing and expand cssHook pass
        for(index in props){
            name = camelCase(index);
            easing = specialEasing[name];
            value = props[index];
            if (Array.isArray(value)) {
                easing = value[1];
                value = props[index] = value[0];
            }
            if (index !== name) {
                props[name] = value;
                delete props[index];
            }
            hooks = jQuery.cssHooks[name];
            if (hooks && "expand" in hooks) {
                value = hooks.expand(value);
                delete props[name];
                // Not quite $.extend, this won't overwrite existing keys.
                // Reusing 'index' because we have the correct "name"
                for(index in value)if (!(index in props)) {
                    props[index] = value[index];
                    specialEasing[index] = easing;
                }
            } else specialEasing[name] = easing;
        }
    }
    function Animation(elem, properties, options) {
        var result, stopped, index = 0, length = Animation.prefilters.length, deferred = jQuery.Deferred().always(function() {
            // Don't match elem in the :animated selector
            delete tick.elem;
        }), tick = function() {
            if (stopped) return false;
            var currentTime = fxNow || createFxNow(), remaining = Math.max(0, animation.startTime + animation.duration - currentTime), // Support: Android 2.3 only
            // Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
            temp = remaining / animation.duration || 0, percent = 1 - temp, index = 0, length = animation.tweens.length;
            for(; index < length; index++)animation.tweens[index].run(percent);
            deferred.notifyWith(elem, [
                animation,
                percent,
                remaining
            ]);
            // If there's more to do, yield
            if (percent < 1 && length) return remaining;
            // If this was an empty animation, synthesize a final progress notification
            if (!length) deferred.notifyWith(elem, [
                animation,
                1,
                0
            ]);
            // Resolve the animation and report its conclusion
            deferred.resolveWith(elem, [
                animation
            ]);
            return false;
        }, animation = deferred.promise({
            elem: elem,
            props: jQuery.extend({}, properties),
            opts: jQuery.extend(true, {
                specialEasing: {},
                easing: jQuery.easing._default
            }, options),
            originalProperties: properties,
            originalOptions: options,
            startTime: fxNow || createFxNow(),
            duration: options.duration,
            tweens: [],
            createTween: function(prop, end) {
                var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
                animation.tweens.push(tween);
                return tween;
            },
            stop: function(gotoEnd) {
                var index = 0, // If we are going to the end, we want to run all the tweens
                // otherwise we skip this part
                length = gotoEnd ? animation.tweens.length : 0;
                if (stopped) return this;
                stopped = true;
                for(; index < length; index++)animation.tweens[index].run(1);
                // Resolve when we played the last frame; otherwise, reject
                if (gotoEnd) {
                    deferred.notifyWith(elem, [
                        animation,
                        1,
                        0
                    ]);
                    deferred.resolveWith(elem, [
                        animation,
                        gotoEnd
                    ]);
                } else deferred.rejectWith(elem, [
                    animation,
                    gotoEnd
                ]);
                return this;
            }
        }), props = animation.props;
        propFilter(props, animation.opts.specialEasing);
        for(; index < length; index++){
            result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
            if (result) {
                if (isFunction(result.stop)) jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
                return result;
            }
        }
        jQuery.map(props, createTween, animation);
        if (isFunction(animation.opts.start)) animation.opts.start.call(elem, animation);
        // Attach callbacks from options
        animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
        jQuery.fx.timer(jQuery.extend(tick, {
            elem: elem,
            anim: animation,
            queue: animation.opts.queue
        }));
        return animation;
    }
    jQuery.Animation = jQuery.extend(Animation, {
        tweeners: {
            "*": [
                function(prop, value) {
                    var tween = this.createTween(prop, value);
                    adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
                    return tween;
                }
            ]
        },
        tweener: function(props, callback) {
            if (isFunction(props)) {
                callback = props;
                props = [
                    "*"
                ];
            } else props = props.match(rnothtmlwhite);
            var prop, index = 0, length = props.length;
            for(; index < length; index++){
                prop = props[index];
                Animation.tweeners[prop] = Animation.tweeners[prop] || [];
                Animation.tweeners[prop].unshift(callback);
            }
        },
        prefilters: [
            defaultPrefilter
        ],
        prefilter: function(callback, prepend) {
            if (prepend) Animation.prefilters.unshift(callback);
            else Animation.prefilters.push(callback);
        }
    });
    jQuery.speed = function(speed, easing, fn) {
        var opt = speed && typeof speed === "object" ? jQuery.extend({}, speed) : {
            complete: fn || !fn && easing || isFunction(speed) && speed,
            duration: speed,
            easing: fn && easing || easing && !isFunction(easing) && easing
        };
        // Go to the end state if fx are off
        if (jQuery.fx.off) opt.duration = 0;
        else if (typeof opt.duration !== "number") {
            if (opt.duration in jQuery.fx.speeds) opt.duration = jQuery.fx.speeds[opt.duration];
            else opt.duration = jQuery.fx.speeds._default;
        }
        // Normalize opt.queue - true/undefined/null -> "fx"
        if (opt.queue == null || opt.queue === true) opt.queue = "fx";
        // Queueing
        opt.old = opt.complete;
        opt.complete = function() {
            if (isFunction(opt.old)) opt.old.call(this);
            if (opt.queue) jQuery.dequeue(this, opt.queue);
        };
        return opt;
    };
    jQuery.fn.extend({
        fadeTo: function(speed, to, easing, callback) {
            // Show any hidden elements after setting opacity to 0
            return this.filter(isHiddenWithinTree).css("opacity", 0).show()// Animate to the value specified
            .end().animate({
                opacity: to
            }, speed, easing, callback);
        },
        animate: function(prop, speed, easing, callback) {
            var empty = jQuery.isEmptyObject(prop), optall = jQuery.speed(speed, easing, callback), doAnimation = function() {
                // Operate on a copy of prop so per-property easing won't be lost
                var anim = Animation(this, jQuery.extend({}, prop), optall);
                // Empty animations, or finishing resolves immediately
                if (empty || dataPriv.get(this, "finish")) anim.stop(true);
            };
            doAnimation.finish = doAnimation;
            return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
        },
        stop: function(type, clearQueue, gotoEnd) {
            var stopQueue = function(hooks) {
                var stop = hooks.stop;
                delete hooks.stop;
                stop(gotoEnd);
            };
            if (typeof type !== "string") {
                gotoEnd = clearQueue;
                clearQueue = type;
                type = undefined;
            }
            if (clearQueue) this.queue(type || "fx", []);
            return this.each(function() {
                var dequeue = true, index = type != null && type + "queueHooks", timers = jQuery.timers, data = dataPriv.get(this);
                if (index) {
                    if (data[index] && data[index].stop) stopQueue(data[index]);
                } else {
                    for(index in data)if (data[index] && data[index].stop && rrun.test(index)) stopQueue(data[index]);
                }
                for(index = timers.length; index--;)if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
                    timers[index].anim.stop(gotoEnd);
                    dequeue = false;
                    timers.splice(index, 1);
                }
                // Start the next in the queue if the last step wasn't forced.
                // Timers currently will call their complete callbacks, which
                // will dequeue but only if they were gotoEnd.
                if (dequeue || !gotoEnd) jQuery.dequeue(this, type);
            });
        },
        finish: function(type) {
            if (type !== false) type = type || "fx";
            return this.each(function() {
                var index, data = dataPriv.get(this), queue = data[type + "queue"], hooks = data[type + "queueHooks"], timers = jQuery.timers, length = queue ? queue.length : 0;
                // Enable finishing flag on private data
                data.finish = true;
                // Empty the queue first
                jQuery.queue(this, type, []);
                if (hooks && hooks.stop) hooks.stop.call(this, true);
                // Look for any active animations, and finish them
                for(index = timers.length; index--;)if (timers[index].elem === this && timers[index].queue === type) {
                    timers[index].anim.stop(true);
                    timers.splice(index, 1);
                }
                // Look for any animations in the old queue and finish them
                for(index = 0; index < length; index++)if (queue[index] && queue[index].finish) queue[index].finish.call(this);
                // Turn off finishing flag
                delete data.finish;
            });
        }
    });
    jQuery.each([
        "toggle",
        "show",
        "hide"
    ], function(_i, name) {
        var cssFn = jQuery.fn[name];
        jQuery.fn[name] = function(speed, easing, callback) {
            return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
        };
    });
    // Generate shortcuts for custom animations
    jQuery.each({
        slideDown: genFx("show"),
        slideUp: genFx("hide"),
        slideToggle: genFx("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(name, props) {
        jQuery.fn[name] = function(speed, easing, callback) {
            return this.animate(props, speed, easing, callback);
        };
    });
    jQuery.timers = [];
    jQuery.fx.tick = function() {
        var timer, i = 0, timers = jQuery.timers;
        fxNow = Date.now();
        for(; i < timers.length; i++){
            timer = timers[i];
            // Run the timer and safely remove it when done (allowing for external removal)
            if (!timer() && timers[i] === timer) timers.splice(i--, 1);
        }
        if (!timers.length) jQuery.fx.stop();
        fxNow = undefined;
    };
    jQuery.fx.timer = function(timer) {
        jQuery.timers.push(timer);
        jQuery.fx.start();
    };
    jQuery.fx.interval = 13;
    jQuery.fx.start = function() {
        if (inProgress) return;
        inProgress = true;
        schedule();
    };
    jQuery.fx.stop = function() {
        inProgress = null;
    };
    jQuery.fx.speeds = {
        slow: 600,
        fast: 200,
        // Default speed
        _default: 400
    };
    // Based off of the plugin by Clint Helfers, with permission.
    jQuery.fn.delay = function(time, type) {
        time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
        type = type || "fx";
        return this.queue(type, function(next, hooks) {
            var timeout = window1.setTimeout(next, time);
            hooks.stop = function() {
                window1.clearTimeout(timeout);
            };
        });
    };
    (function() {
        var input = document.createElement("input"), select = document.createElement("select"), opt = select.appendChild(document.createElement("option"));
        input.type = "checkbox";
        // Support: Android <=4.3 only
        // Default value for a checkbox should be "on"
        support.checkOn = input.value !== "";
        // Support: IE <=11 only
        // Must access selectedIndex to make default options select
        support.optSelected = opt.selected;
        // Support: IE <=11 only
        // An input loses its value after becoming a radio
        input = document.createElement("input");
        input.value = "t";
        input.type = "radio";
        support.radioValue = input.value === "t";
    })();
    var boolHook, attrHandle = jQuery.expr.attrHandle;
    jQuery.fn.extend({
        attr: function(name, value) {
            return access(this, jQuery.attr, name, value, arguments.length > 1);
        },
        removeAttr: function(name) {
            return this.each(function() {
                jQuery.removeAttr(this, name);
            });
        }
    });
    jQuery.extend({
        attr: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set attributes on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            // Fallback to prop when attributes are not supported
            if (typeof elem.getAttribute === "undefined") return jQuery.prop(elem, name, value);
            // Attribute hooks are determined by the lowercase version
            // Grab necessary hook if one is defined
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) hooks = jQuery.attrHooks[name.toLowerCase()] || (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
            if (value !== undefined) {
                if (value === null) {
                    jQuery.removeAttr(elem, name);
                    return;
                }
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                elem.setAttribute(name, value + "");
                return value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            ret = jQuery.find.attr(elem, name);
            // Non-existent attributes return null, we normalize to undefined
            return ret == null ? undefined : ret;
        },
        attrHooks: {
            type: {
                set: function(elem, value) {
                    if (!support.radioValue && value === "radio" && nodeName(elem, "input")) {
                        var val = elem.value;
                        elem.setAttribute("type", value);
                        if (val) elem.value = val;
                        return value;
                    }
                }
            }
        },
        removeAttr: function(elem, value) {
            var name, i = 0, // Attribute names can contain non-HTML whitespace characters
            // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
            attrNames = value && value.match(rnothtmlwhite);
            if (attrNames && elem.nodeType === 1) while(name = attrNames[i++])elem.removeAttribute(name);
        }
    });
    // Hooks for boolean attributes
    boolHook = {
        set: function(elem, value, name) {
            if (value === false) // Remove boolean attributes when set to false
            jQuery.removeAttr(elem, name);
            else elem.setAttribute(name, name);
            return name;
        }
    };
    jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function(_i, name) {
        var getter = attrHandle[name] || jQuery.find.attr;
        attrHandle[name] = function(elem, name, isXML) {
            var ret, handle, lowercaseName = name.toLowerCase();
            if (!isXML) {
                // Avoid an infinite loop by temporarily removing this function from the getter
                handle = attrHandle[lowercaseName];
                attrHandle[lowercaseName] = ret;
                ret = getter(elem, name, isXML) != null ? lowercaseName : null;
                attrHandle[lowercaseName] = handle;
            }
            return ret;
        };
    });
    var rfocusable = /^(?:input|select|textarea|button)$/i, rclickable = /^(?:a|area)$/i;
    jQuery.fn.extend({
        prop: function(name, value) {
            return access(this, jQuery.prop, name, value, arguments.length > 1);
        },
        removeProp: function(name) {
            return this.each(function() {
                delete this[jQuery.propFix[name] || name];
            });
        }
    });
    jQuery.extend({
        prop: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set properties on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
                // Fix name and attach hooks
                name = jQuery.propFix[name] || name;
                hooks = jQuery.propHooks[name];
            }
            if (value !== undefined) {
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                return elem[name] = value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            return elem[name];
        },
        propHooks: {
            tabIndex: {
                get: function(elem) {
                    // Support: IE <=9 - 11 only
                    // elem.tabIndex doesn't always return the
                    // correct value when it hasn't been explicitly set
                    // Use proper attribute retrieval (trac-12072)
                    var tabindex = jQuery.find.attr(elem, "tabindex");
                    if (tabindex) return parseInt(tabindex, 10);
                    if (rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href) return 0;
                    return -1;
                }
            }
        },
        propFix: {
            "for": "htmlFor",
            "class": "className"
        }
    });
    // Support: IE <=11 only
    // Accessing the selectedIndex property
    // forces the browser to respect setting selected
    // on the option
    // The getter ensures a default option is selected
    // when in an optgroup
    // eslint rule "no-unused-expressions" is disabled for this code
    // since it considers such accessions noop
    if (!support.optSelected) jQuery.propHooks.selected = {
        get: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent && parent.parentNode) parent.parentNode.selectedIndex;
            return null;
        },
        set: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent) {
                parent.selectedIndex;
                if (parent.parentNode) parent.parentNode.selectedIndex;
            }
        }
    };
    jQuery.each([
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable"
    ], function() {
        jQuery.propFix[this.toLowerCase()] = this;
    });
    // Strip and collapse whitespace according to HTML spec
    // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
    function stripAndCollapse(value) {
        var tokens = value.match(rnothtmlwhite) || [];
        return tokens.join(" ");
    }
    function getClass(elem) {
        return elem.getAttribute && elem.getAttribute("class") || "";
    }
    function classesToArray(value) {
        if (Array.isArray(value)) return value;
        if (typeof value === "string") return value.match(rnothtmlwhite) || [];
        return [];
    }
    jQuery.fn.extend({
        addClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).addClass(value.call(this, j, getClass(this)));
            });
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        if (cur.indexOf(" " + className + " ") < 0) cur += className + " ";
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        removeClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).removeClass(value.call(this, j, getClass(this)));
            });
            if (!arguments.length) return this.attr("class", "");
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                // This expression is here for better compressibility (see addClass)
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Remove *all* instances
                        while(cur.indexOf(" " + className + " ") > -1)cur = cur.replace(" " + className + " ", " ");
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        toggleClass: function(value, stateVal) {
            var classNames, className, i, self, type = typeof value, isValidValue = type === "string" || Array.isArray(value);
            if (isFunction(value)) return this.each(function(i) {
                jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
            });
            if (typeof stateVal === "boolean" && isValidValue) return stateVal ? this.addClass(value) : this.removeClass(value);
            classNames = classesToArray(value);
            return this.each(function() {
                if (isValidValue) {
                    // Toggle individual class names
                    self = jQuery(this);
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Check each className given, space separated list
                        if (self.hasClass(className)) self.removeClass(className);
                        else self.addClass(className);
                    }
                // Toggle whole class name
                } else if (value === undefined || type === "boolean") {
                    className = getClass(this);
                    if (className) // Store className if set
                    dataPriv.set(this, "__className__", className);
                    // If the element has a class name or if we're passed `false`,
                    // then remove the whole classname (if there was one, the above saved it).
                    // Otherwise bring back whatever was previously saved (if anything),
                    // falling back to the empty string if nothing was stored.
                    if (this.setAttribute) this.setAttribute("class", className || value === false ? "" : dataPriv.get(this, "__className__") || "");
                }
            });
        },
        hasClass: function(selector) {
            var className, elem, i = 0;
            className = " " + selector + " ";
            while(elem = this[i++]){
                if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) return true;
            }
            return false;
        }
    });
    var rreturn = /\r/g;
    jQuery.fn.extend({
        val: function(value) {
            var hooks, ret, valueIsFunction, elem = this[0];
            if (!arguments.length) {
                if (elem) {
                    hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];
                    if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) return ret;
                    ret = elem.value;
                    // Handle most common string cases
                    if (typeof ret === "string") return ret.replace(rreturn, "");
                    // Handle cases where value is null/undef or number
                    return ret == null ? "" : ret;
                }
                return;
            }
            valueIsFunction = isFunction(value);
            return this.each(function(i) {
                var val;
                if (this.nodeType !== 1) return;
                if (valueIsFunction) val = value.call(this, i, jQuery(this).val());
                else val = value;
                // Treat null/undefined as ""; convert numbers to string
                if (val == null) val = "";
                else if (typeof val === "number") val += "";
                else if (Array.isArray(val)) val = jQuery.map(val, function(value) {
                    return value == null ? "" : value + "";
                });
                hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];
                // If set returns undefined, fall back to normal setting
                if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) this.value = val;
            });
        }
    });
    jQuery.extend({
        valHooks: {
            option: {
                get: function(elem) {
                    var val = jQuery.find.attr(elem, "value");
                    return val != null ? val : // Support: IE <=10 - 11 only
                    // option.text throws exceptions (trac-14686, trac-14858)
                    // Strip and collapse whitespace
                    // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
                    stripAndCollapse(jQuery.text(elem));
                }
            },
            select: {
                get: function(elem) {
                    var value, option, i, options = elem.options, index = elem.selectedIndex, one = elem.type === "select-one", values = one ? null : [], max = one ? index + 1 : options.length;
                    if (index < 0) i = max;
                    else i = one ? index : 0;
                    // Loop through all the selected options
                    for(; i < max; i++){
                        option = options[i];
                        // Support: IE <=9 only
                        // IE8-9 doesn't update selected after form reset (trac-2551)
                        if ((option.selected || i === index) && // Don't return options that are disabled or in a disabled optgroup
                        !option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {
                            // Get the specific value for the option
                            value = jQuery(option).val();
                            // We don't need an array for one selects
                            if (one) return value;
                            // Multi-Selects return an array
                            values.push(value);
                        }
                    }
                    return values;
                },
                set: function(elem, value) {
                    var optionSet, option, options = elem.options, values = jQuery.makeArray(value), i = options.length;
                    while(i--){
                        option = options[i];
                        /* eslint-disable no-cond-assign */ if (option.selected = jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) optionSet = true;
                    /* eslint-enable no-cond-assign */ }
                    // Force browsers to behave consistently when non-matching value is set
                    if (!optionSet) elem.selectedIndex = -1;
                    return values;
                }
            }
        }
    });
    // Radios and checkboxes getter/setter
    jQuery.each([
        "radio",
        "checkbox"
    ], function() {
        jQuery.valHooks[this] = {
            set: function(elem, value) {
                if (Array.isArray(value)) return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
            }
        };
        if (!support.checkOn) jQuery.valHooks[this].get = function(elem) {
            return elem.getAttribute("value") === null ? "on" : elem.value;
        };
    });
    // Return jQuery for attributes-only inclusion
    var location = window1.location;
    var nonce = {
        guid: Date.now()
    };
    var rquery = /\?/;
    // Cross-browser xml parsing
    jQuery.parseXML = function(data) {
        var xml, parserErrorElem;
        if (!data || typeof data !== "string") return null;
        // Support: IE 9 - 11 only
        // IE throws on parseFromString with invalid input.
        try {
            xml = new window1.DOMParser().parseFromString(data, "text/xml");
        } catch (e) {}
        parserErrorElem = xml && xml.getElementsByTagName("parsererror")[0];
        if (!xml || parserErrorElem) jQuery.error("Invalid XML: " + (parserErrorElem ? jQuery.map(parserErrorElem.childNodes, function(el) {
            return el.textContent;
        }).join("\n") : data));
        return xml;
    };
    var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/, stopPropagationCallback = function(e) {
        e.stopPropagation();
    };
    jQuery.extend(jQuery.event, {
        trigger: function(event, data, elem, onlyHandlers) {
            var i, cur, tmp, bubbleType, ontype, handle, special, lastElement, eventPath = [
                elem || document
            ], type = hasOwn.call(event, "type") ? event.type : event, namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
            cur = lastElement = tmp = elem = elem || document;
            // Don't do events on text and comment nodes
            if (elem.nodeType === 3 || elem.nodeType === 8) return;
            // focus/blur morphs to focusin/out; ensure we're not firing them right now
            if (rfocusMorph.test(type + jQuery.event.triggered)) return;
            if (type.indexOf(".") > -1) {
                // Namespaced trigger; create a regexp to match event type in handle()
                namespaces = type.split(".");
                type = namespaces.shift();
                namespaces.sort();
            }
            ontype = type.indexOf(":") < 0 && "on" + type;
            // Caller can pass in a jQuery.Event object, Object, or just an event type string
            event = event[jQuery.expando] ? event : new jQuery.Event(type, typeof event === "object" && event);
            // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
            event.isTrigger = onlyHandlers ? 2 : 3;
            event.namespace = namespaces.join(".");
            event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
            // Clean up the event in case it is being reused
            event.result = undefined;
            if (!event.target) event.target = elem;
            // Clone any incoming data and prepend the event, creating the handler arg list
            data = data == null ? [
                event
            ] : jQuery.makeArray(data, [
                event
            ]);
            // Allow special events to draw outside the lines
            special = jQuery.event.special[type] || {};
            if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) return;
            // Determine event propagation path in advance, per W3C events spec (trac-9951)
            // Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
            if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
                bubbleType = special.delegateType || type;
                if (!rfocusMorph.test(bubbleType + type)) cur = cur.parentNode;
                for(; cur; cur = cur.parentNode){
                    eventPath.push(cur);
                    tmp = cur;
                }
                // Only add window if we got to document (e.g., not plain obj or detached DOM)
                if (tmp === (elem.ownerDocument || document)) eventPath.push(tmp.defaultView || tmp.parentWindow || window1);
            }
            // Fire handlers on the event path
            i = 0;
            while((cur = eventPath[i++]) && !event.isPropagationStopped()){
                lastElement = cur;
                event.type = i > 1 ? bubbleType : special.bindType || type;
                // jQuery handler
                handle = (dataPriv.get(cur, "events") || Object.create(null))[event.type] && dataPriv.get(cur, "handle");
                if (handle) handle.apply(cur, data);
                // Native handler
                handle = ontype && cur[ontype];
                if (handle && handle.apply && acceptData(cur)) {
                    event.result = handle.apply(cur, data);
                    if (event.result === false) event.preventDefault();
                }
            }
            event.type = type;
            // If nobody prevented the default action, do it now
            if (!onlyHandlers && !event.isDefaultPrevented()) {
                if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) // Call a native DOM method on the target with the same name as the event.
                // Don't do default actions on window, that's where global variables be (trac-6170)
                {
                    if (ontype && isFunction(elem[type]) && !isWindow(elem)) {
                        // Don't re-trigger an onFOO event when we call its FOO() method
                        tmp = elem[ontype];
                        if (tmp) elem[ontype] = null;
                        // Prevent re-triggering of the same event, since we already bubbled it above
                        jQuery.event.triggered = type;
                        if (event.isPropagationStopped()) lastElement.addEventListener(type, stopPropagationCallback);
                        elem[type]();
                        if (event.isPropagationStopped()) lastElement.removeEventListener(type, stopPropagationCallback);
                        jQuery.event.triggered = undefined;
                        if (tmp) elem[ontype] = tmp;
                    }
                }
            }
            return event.result;
        },
        // Piggyback on a donor event to simulate a different one
        // Used only for `focus(in | out)` events
        simulate: function(type, elem, event) {
            var e = jQuery.extend(new jQuery.Event(), event, {
                type: type,
                isSimulated: true
            });
            jQuery.event.trigger(e, null, elem);
        }
    });
    jQuery.fn.extend({
        trigger: function(type, data) {
            return this.each(function() {
                jQuery.event.trigger(type, data, this);
            });
        },
        triggerHandler: function(type, data) {
            var elem = this[0];
            if (elem) return jQuery.event.trigger(type, data, elem, true);
        }
    });
    var rbracket = /\[\]$/, rCRLF = /\r?\n/g, rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i, rsubmittable = /^(?:input|select|textarea|keygen)/i;
    function buildParams(prefix, obj, traditional, add) {
        var name;
        if (Array.isArray(obj)) // Serialize array item.
        jQuery.each(obj, function(i, v) {
            if (traditional || rbracket.test(prefix)) // Treat each array item as a scalar.
            add(prefix, v);
            else // Item is non-scalar (array or object), encode its numeric index.
            buildParams(prefix + "[" + (typeof v === "object" && v != null ? i : "") + "]", v, traditional, add);
        });
        else if (!traditional && toType(obj) === "object") // Serialize object item.
        for(name in obj)buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
        else // Serialize scalar item.
        add(prefix, obj);
    }
    // Serialize an array of form elements or a set of
    // key/values into a query string
    jQuery.param = function(a, traditional) {
        var prefix, s = [], add = function(key, valueOrFunction) {
            // If value is a function, invoke it and use its return value
            var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction;
            s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
        };
        if (a == null) return "";
        // If an array was passed in, assume that it is an array of form elements.
        if (Array.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) // Serialize the form elements
        jQuery.each(a, function() {
            add(this.name, this.value);
        });
        else // If traditional, encode the "old" way (the way 1.3.2 or older
        // did it), otherwise encode params recursively.
        for(prefix in a)buildParams(prefix, a[prefix], traditional, add);
        // Return the resulting serialization
        return s.join("&");
    };
    jQuery.fn.extend({
        serialize: function() {
            return jQuery.param(this.serializeArray());
        },
        serializeArray: function() {
            return this.map(function() {
                // Can add propHook for "elements" to filter or add form elements
                var elements = jQuery.prop(this, "elements");
                return elements ? jQuery.makeArray(elements) : this;
            }).filter(function() {
                var type = this.type;
                // Use .is( ":disabled" ) so that fieldset[disabled] works
                return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
            }).map(function(_i, elem) {
                var val = jQuery(this).val();
                if (val == null) return null;
                if (Array.isArray(val)) return jQuery.map(val, function(val) {
                    return {
                        name: elem.name,
                        value: val.replace(rCRLF, "\r\n")
                    };
                });
                return {
                    name: elem.name,
                    value: val.replace(rCRLF, "\r\n")
                };
            }).get();
        }
    });
    var r20 = /%20/g, rhash = /#.*$/, rantiCache = /([?&])_=[^&]*/, rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg, // trac-7653, trac-8125, trac-8152: local protocol detection
    rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, rnoContent = /^(?:GET|HEAD)$/, rprotocol = /^\/\//, /* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */ prefilters = {}, /* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */ transports = {}, // Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
    allTypes = "*/".concat("*"), // Anchor tag for parsing the document origin
    originAnchor = document.createElement("a");
    originAnchor.href = location.href;
    // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
    function addToPrefiltersOrTransports(structure) {
        // dataTypeExpression is optional and defaults to "*"
        return function(dataTypeExpression, func) {
            if (typeof dataTypeExpression !== "string") {
                func = dataTypeExpression;
                dataTypeExpression = "*";
            }
            var dataType, i = 0, dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];
            if (isFunction(func)) {
                // For each dataType in the dataTypeExpression
                while(dataType = dataTypes[i++])// Prepend if requested
                if (dataType[0] === "+") {
                    dataType = dataType.slice(1) || "*";
                    (structure[dataType] = structure[dataType] || []).unshift(func);
                // Otherwise append
                } else (structure[dataType] = structure[dataType] || []).push(func);
            }
        };
    }
    // Base inspection function for prefilters and transports
    function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
        var inspected = {}, seekingTransport = structure === transports;
        function inspect(dataType) {
            var selected;
            inspected[dataType] = true;
            jQuery.each(structure[dataType] || [], function(_, prefilterOrFactory) {
                var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
                if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
                    options.dataTypes.unshift(dataTypeOrTransport);
                    inspect(dataTypeOrTransport);
                    return false;
                } else if (seekingTransport) return !(selected = dataTypeOrTransport);
            });
            return selected;
        }
        return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
    }
    // A special extend for ajax options
    // that takes "flat" options (not to be deep extended)
    // Fixes trac-9887
    function ajaxExtend(target, src) {
        var key, deep, flatOptions = jQuery.ajaxSettings.flatOptions || {};
        for(key in src)if (src[key] !== undefined) (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
        if (deep) jQuery.extend(true, target, deep);
        return target;
    }
    /* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */ function ajaxHandleResponses(s, jqXHR, responses) {
        var ct, type, finalDataType, firstDataType, contents = s.contents, dataTypes = s.dataTypes;
        // Remove auto dataType and get content-type in the process
        while(dataTypes[0] === "*"){
            dataTypes.shift();
            if (ct === undefined) ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
        }
        // Check if we're dealing with a known content-type
        if (ct) {
            for(type in contents)if (contents[type] && contents[type].test(ct)) {
                dataTypes.unshift(type);
                break;
            }
        }
        // Check to see if we have a response for the expected dataType
        if (dataTypes[0] in responses) finalDataType = dataTypes[0];
        else {
            // Try convertible dataTypes
            for(type in responses){
                if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
                    finalDataType = type;
                    break;
                }
                if (!firstDataType) firstDataType = type;
            }
            // Or just use first one
            finalDataType = finalDataType || firstDataType;
        }
        // If we found a dataType
        // We add the dataType to the list if needed
        // and return the corresponding response
        if (finalDataType) {
            if (finalDataType !== dataTypes[0]) dataTypes.unshift(finalDataType);
            return responses[finalDataType];
        }
    }
    /* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */ function ajaxConvert(s, response, jqXHR, isSuccess) {
        var conv2, current, conv, tmp, prev, converters = {}, // Work with a copy of dataTypes in case we need to modify it for conversion
        dataTypes = s.dataTypes.slice();
        // Create converters map with lowercased keys
        if (dataTypes[1]) for(conv in s.converters)converters[conv.toLowerCase()] = s.converters[conv];
        current = dataTypes.shift();
        // Convert to each sequential dataType
        while(current){
            if (s.responseFields[current]) jqXHR[s.responseFields[current]] = response;
            // Apply the dataFilter if provided
            if (!prev && isSuccess && s.dataFilter) response = s.dataFilter(response, s.dataType);
            prev = current;
            current = dataTypes.shift();
            if (current) {
                // There's only work to do if current dataType is non-auto
                if (current === "*") current = prev;
                else if (prev !== "*" && prev !== current) {
                    // Seek a direct converter
                    conv = converters[prev + " " + current] || converters["* " + current];
                    // If none found, seek a pair
                    if (!conv) for(conv2 in converters){
                        // If conv2 outputs current
                        tmp = conv2.split(" ");
                        if (tmp[1] === current) {
                            // If prev can be converted to accepted input
                            conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
                            if (conv) {
                                // Condense equivalence converters
                                if (conv === true) conv = converters[conv2];
                                else if (converters[conv2] !== true) {
                                    current = tmp[0];
                                    dataTypes.unshift(tmp[1]);
                                }
                                break;
                            }
                        }
                    }
                    // Apply converter (if not an equivalence)
                    if (conv !== true) {
                        // Unless errors are allowed to bubble, catch and return them
                        if (conv && s.throws) response = conv(response);
                        else try {
                            response = conv(response);
                        } catch (e) {
                            return {
                                state: "parsererror",
                                error: conv ? e : "No conversion from " + prev + " to " + current
                            };
                        }
                    }
                }
            }
        }
        return {
            state: "success",
            data: response
        };
    }
    jQuery.extend({
        // Counter for holding the number of active queries
        active: 0,
        // Last-Modified header cache for next request
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: location.href,
            type: "GET",
            isLocal: rlocalProtocol.test(location.protocol),
            global: true,
            processData: true,
            async: true,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            /*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/ accepts: {
                "*": allTypes,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            // Data converters
            // Keys separate source (or catchall "*") and destination types with a single space
            converters: {
                // Convert anything to text
                "* text": String,
                // Text to html (true = no transformation)
                "text html": true,
                // Evaluate text as a json expression
                "text json": JSON.parse,
                // Parse text as xml
                "text xml": jQuery.parseXML
            },
            // For options that shouldn't be deep extended:
            // you can add your own custom options here if
            // and when you create one that shouldn't be
            // deep extended (see ajaxExtend)
            flatOptions: {
                url: true,
                context: true
            }
        },
        // Creates a full fledged settings object into target
        // with both ajaxSettings and settings fields.
        // If target is omitted, writes into ajaxSettings.
        ajaxSetup: function(target, settings) {
            return settings ? // Building a settings object
            ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) : // Extending ajaxSettings
            ajaxExtend(jQuery.ajaxSettings, target);
        },
        ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
        ajaxTransport: addToPrefiltersOrTransports(transports),
        // Main method
        ajax: function(url, options) {
            // If url is an object, simulate pre-1.5 signature
            if (typeof url === "object") {
                options = url;
                url = undefined;
            }
            // Force options to be an object
            options = options || {};
            var transport, // URL without anti-cache param
            cacheURL, // Response headers
            responseHeadersString, responseHeaders, // timeout handle
            timeoutTimer, // Url cleanup var
            urlAnchor, // Request state (becomes false upon send and true upon completion)
            completed, // To know if global events are to be dispatched
            fireGlobals, // Loop variable
            i, // uncached part of the url
            uncached, // Create the final options object
            s = jQuery.ajaxSetup({}, options), // Callbacks context
            callbackContext = s.context || s, // Context for global events is callbackContext if it is a DOM node or jQuery collection
            globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event, // Deferreds
            deferred = jQuery.Deferred(), completeDeferred = jQuery.Callbacks("once memory"), // Status-dependent callbacks
            statusCode = s.statusCode || {}, // Headers (they are sent all at once)
            requestHeaders = {}, requestHeadersNames = {}, // Default abort message
            strAbort = "canceled", // Fake xhr
            jqXHR = {
                readyState: 0,
                // Builds headers hashtable if needed
                getResponseHeader: function(key) {
                    var match;
                    if (completed) {
                        if (!responseHeaders) {
                            responseHeaders = {};
                            while(match = rheaders.exec(responseHeadersString))responseHeaders[match[1].toLowerCase() + " "] = (responseHeaders[match[1].toLowerCase() + " "] || []).concat(match[2]);
                        }
                        match = responseHeaders[key.toLowerCase() + " "];
                    }
                    return match == null ? null : match.join(", ");
                },
                // Raw string
                getAllResponseHeaders: function() {
                    return completed ? responseHeadersString : null;
                },
                // Caches the header
                setRequestHeader: function(name, value) {
                    if (completed == null) {
                        name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
                        requestHeaders[name] = value;
                    }
                    return this;
                },
                // Overrides response content-type header
                overrideMimeType: function(type) {
                    if (completed == null) s.mimeType = type;
                    return this;
                },
                // Status-dependent callbacks
                statusCode: function(map) {
                    var code;
                    if (map) {
                        if (completed) // Execute the appropriate callbacks
                        jqXHR.always(map[jqXHR.status]);
                        else // Lazy-add the new callbacks in a way that preserves old ones
                        for(code in map)statusCode[code] = [
                            statusCode[code],
                            map[code]
                        ];
                    }
                    return this;
                },
                // Cancel the request
                abort: function(statusText) {
                    var finalText = statusText || strAbort;
                    if (transport) transport.abort(finalText);
                    done(0, finalText);
                    return this;
                }
            };
            // Attach deferreds
            deferred.promise(jqXHR);
            // Add protocol if not provided (prefilters might expect it)
            // Handle falsy url in the settings object (trac-10093: consistency with old signature)
            // We also use the url parameter if available
            s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//");
            // Alias method option to type as per ticket trac-12004
            s.type = options.method || options.type || s.method || s.type;
            // Extract dataTypes list
            s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [
                ""
            ];
            // A cross-domain request is in order when the origin doesn't match the current origin.
            if (s.crossDomain == null) {
                urlAnchor = document.createElement("a");
                // Support: IE <=8 - 11, Edge 12 - 15
                // IE throws exception on accessing the href property if url is malformed,
                // e.g. http://example.com:80x/
                try {
                    urlAnchor.href = s.url;
                    // Support: IE <=8 - 11 only
                    // Anchor's host property isn't correctly set when s.url is relative
                    urlAnchor.href = urlAnchor.href;
                    s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
                } catch (e) {
                    // If there is an error parsing the URL, assume it is crossDomain,
                    // it can be rejected by the transport if it is invalid
                    s.crossDomain = true;
                }
            }
            // Convert data if not already a string
            if (s.data && s.processData && typeof s.data !== "string") s.data = jQuery.param(s.data, s.traditional);
            // Apply prefilters
            inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);
            // If request was aborted inside a prefilter, stop there
            if (completed) return jqXHR;
            // We can fire global events as of now if asked to
            // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
            fireGlobals = jQuery.event && s.global;
            // Watch for a new set of requests
            if (fireGlobals && jQuery.active++ === 0) jQuery.event.trigger("ajaxStart");
            // Uppercase the type
            s.type = s.type.toUpperCase();
            // Determine if request has content
            s.hasContent = !rnoContent.test(s.type);
            // Save the URL in case we're toying with the If-Modified-Since
            // and/or If-None-Match header later on
            // Remove hash to simplify url manipulation
            cacheURL = s.url.replace(rhash, "");
            // More options handling for requests with no content
            if (!s.hasContent) {
                // Remember the hash so we can put it back
                uncached = s.url.slice(cacheURL.length);
                // If data is available and should be processed, append data to url
                if (s.data && (s.processData || typeof s.data === "string")) {
                    cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;
                    // trac-9682: remove data so that it's not used in an eventual retry
                    delete s.data;
                }
                // Add or update anti-cache param if needed
                if (s.cache === false) {
                    cacheURL = cacheURL.replace(rantiCache, "$1");
                    uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce.guid++ + uncached;
                }
                // Put hash and anti-cache on the URL that will be requested (gh-1732)
                s.url = cacheURL + uncached;
            // Change '%20' to '+' if this is encoded form body content (gh-2658)
            } else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) s.data = s.data.replace(r20, "+");
            // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
            if (s.ifModified) {
                if (jQuery.lastModified[cacheURL]) jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
                if (jQuery.etag[cacheURL]) jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
            }
            // Set the correct header, if data is being sent
            if (s.data && s.hasContent && s.contentType !== false || options.contentType) jqXHR.setRequestHeader("Content-Type", s.contentType);
            // Set the Accepts header for the server, depending on the dataType
            jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);
            // Check for headers option
            for(i in s.headers)jqXHR.setRequestHeader(i, s.headers[i]);
            // Allow custom headers/mimetypes and early abort
            if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || completed)) // Abort if not done already and return
            return jqXHR.abort();
            // Aborting is no longer a cancellation
            strAbort = "abort";
            // Install callbacks on deferreds
            completeDeferred.add(s.complete);
            jqXHR.done(s.success);
            jqXHR.fail(s.error);
            // Get transport
            transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);
            // If no transport, we auto-abort
            if (!transport) done(-1, "No Transport");
            else {
                jqXHR.readyState = 1;
                // Send global event
                if (fireGlobals) globalEventContext.trigger("ajaxSend", [
                    jqXHR,
                    s
                ]);
                // If request was aborted inside ajaxSend, stop there
                if (completed) return jqXHR;
                // Timeout
                if (s.async && s.timeout > 0) timeoutTimer = window1.setTimeout(function() {
                    jqXHR.abort("timeout");
                }, s.timeout);
                try {
                    completed = false;
                    transport.send(requestHeaders, done);
                } catch (e) {
                    // Rethrow post-completion exceptions
                    if (completed) throw e;
                    // Propagate others as results
                    done(-1, e);
                }
            }
            // Callback for when everything is done
            function done(status, nativeStatusText, responses, headers) {
                var isSuccess, success, error, response, modified, statusText = nativeStatusText;
                // Ignore repeat invocations
                if (completed) return;
                completed = true;
                // Clear timeout if it exists
                if (timeoutTimer) window1.clearTimeout(timeoutTimer);
                // Dereference transport for early garbage collection
                // (no matter how long the jqXHR object will be used)
                transport = undefined;
                // Cache response headers
                responseHeadersString = headers || "";
                // Set readyState
                jqXHR.readyState = status > 0 ? 4 : 0;
                // Determine if successful
                isSuccess = status >= 200 && status < 300 || status === 304;
                // Get response data
                if (responses) response = ajaxHandleResponses(s, jqXHR, responses);
                // Use a noop converter for missing script but not if jsonp
                if (!isSuccess && jQuery.inArray("script", s.dataTypes) > -1 && jQuery.inArray("json", s.dataTypes) < 0) s.converters["text script"] = function() {};
                // Convert no matter what (that way responseXXX fields are always set)
                response = ajaxConvert(s, response, jqXHR, isSuccess);
                // If successful, handle type chaining
                if (isSuccess) {
                    // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                    if (s.ifModified) {
                        modified = jqXHR.getResponseHeader("Last-Modified");
                        if (modified) jQuery.lastModified[cacheURL] = modified;
                        modified = jqXHR.getResponseHeader("etag");
                        if (modified) jQuery.etag[cacheURL] = modified;
                    }
                    // if no content
                    if (status === 204 || s.type === "HEAD") statusText = "nocontent";
                    else if (status === 304) statusText = "notmodified";
                    else {
                        statusText = response.state;
                        success = response.data;
                        error = response.error;
                        isSuccess = !error;
                    }
                } else {
                    // Extract error from statusText and normalize for non-aborts
                    error = statusText;
                    if (status || !statusText) {
                        statusText = "error";
                        if (status < 0) status = 0;
                    }
                }
                // Set data for the fake xhr object
                jqXHR.status = status;
                jqXHR.statusText = (nativeStatusText || statusText) + "";
                // Success/Error
                if (isSuccess) deferred.resolveWith(callbackContext, [
                    success,
                    statusText,
                    jqXHR
                ]);
                else deferred.rejectWith(callbackContext, [
                    jqXHR,
                    statusText,
                    error
                ]);
                // Status-dependent callbacks
                jqXHR.statusCode(statusCode);
                statusCode = undefined;
                if (fireGlobals) globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [
                    jqXHR,
                    s,
                    isSuccess ? success : error
                ]);
                // Complete
                completeDeferred.fireWith(callbackContext, [
                    jqXHR,
                    statusText
                ]);
                if (fireGlobals) {
                    globalEventContext.trigger("ajaxComplete", [
                        jqXHR,
                        s
                    ]);
                    // Handle the global AJAX counter
                    if (!--jQuery.active) jQuery.event.trigger("ajaxStop");
                }
            }
            return jqXHR;
        },
        getJSON: function(url, data, callback) {
            return jQuery.get(url, data, callback, "json");
        },
        getScript: function(url, callback) {
            return jQuery.get(url, undefined, callback, "script");
        }
    });
    jQuery.each([
        "get",
        "post"
    ], function(_i, method) {
        jQuery[method] = function(url, data, callback, type) {
            // Shift arguments if data argument was omitted
            if (isFunction(data)) {
                type = type || callback;
                callback = data;
                data = undefined;
            }
            // The url can be an options object (which then must have .url)
            return jQuery.ajax(jQuery.extend({
                url: url,
                type: method,
                dataType: type,
                data: data,
                success: callback
            }, jQuery.isPlainObject(url) && url));
        };
    });
    jQuery.ajaxPrefilter(function(s) {
        var i;
        for(i in s.headers)if (i.toLowerCase() === "content-type") s.contentType = s.headers[i] || "";
    });
    jQuery._evalUrl = function(url, options, doc) {
        return jQuery.ajax({
            url: url,
            // Make this explicit, since user can override this through ajaxSetup (trac-11264)
            type: "GET",
            dataType: "script",
            cache: true,
            async: false,
            global: false,
            // Only evaluate the response if it is successful (gh-4126)
            // dataFilter is not invoked for failure responses, so using it instead
            // of the default converter is kludgy but it works.
            converters: {
                "text script": function() {}
            },
            dataFilter: function(response) {
                jQuery.globalEval(response, options, doc);
            }
        });
    };
    jQuery.fn.extend({
        wrapAll: function(html) {
            var wrap;
            if (this[0]) {
                if (isFunction(html)) html = html.call(this[0]);
                // The elements to wrap the target around
                wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);
                if (this[0].parentNode) wrap.insertBefore(this[0]);
                wrap.map(function() {
                    var elem = this;
                    while(elem.firstElementChild)elem = elem.firstElementChild;
                    return elem;
                }).append(this);
            }
            return this;
        },
        wrapInner: function(html) {
            if (isFunction(html)) return this.each(function(i) {
                jQuery(this).wrapInner(html.call(this, i));
            });
            return this.each(function() {
                var self = jQuery(this), contents = self.contents();
                if (contents.length) contents.wrapAll(html);
                else self.append(html);
            });
        },
        wrap: function(html) {
            var htmlIsFunction = isFunction(html);
            return this.each(function(i) {
                jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
            });
        },
        unwrap: function(selector) {
            this.parent(selector).not("body").each(function() {
                jQuery(this).replaceWith(this.childNodes);
            });
            return this;
        }
    });
    jQuery.expr.pseudos.hidden = function(elem) {
        return !jQuery.expr.pseudos.visible(elem);
    };
    jQuery.expr.pseudos.visible = function(elem) {
        return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
    };
    jQuery.ajaxSettings.xhr = function() {
        try {
            return new window1.XMLHttpRequest();
        } catch (e) {}
    };
    var xhrSuccessStatus = {
        // File protocol always yields status code 0, assume 200
        0: 200,
        // Support: IE <=9 only
        // trac-1450: sometimes IE returns 1223 when it should be 204
        1223: 204
    }, xhrSupported = jQuery.ajaxSettings.xhr();
    support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
    support.ajax = xhrSupported = !!xhrSupported;
    jQuery.ajaxTransport(function(options) {
        var callback, errorCallback;
        // Cross domain only allowed if supported through XMLHttpRequest
        if (support.cors || xhrSupported && !options.crossDomain) return {
            send: function(headers, complete) {
                var i, xhr = options.xhr();
                xhr.open(options.type, options.url, options.async, options.username, options.password);
                // Apply custom fields if provided
                if (options.xhrFields) for(i in options.xhrFields)xhr[i] = options.xhrFields[i];
                // Override mime type if needed
                if (options.mimeType && xhr.overrideMimeType) xhr.overrideMimeType(options.mimeType);
                // X-Requested-With header
                // For cross-domain requests, seeing as conditions for a preflight are
                // akin to a jigsaw puzzle, we simply never set it to be sure.
                // (it can always be set on a per-request basis or even using ajaxSetup)
                // For same-domain requests, won't change header if already provided.
                if (!options.crossDomain && !headers["X-Requested-With"]) headers["X-Requested-With"] = "XMLHttpRequest";
                // Set headers
                for(i in headers)xhr.setRequestHeader(i, headers[i]);
                // Callback
                callback = function(type) {
                    return function() {
                        if (callback) {
                            callback = errorCallback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = xhr.onreadystatechange = null;
                            if (type === "abort") xhr.abort();
                            else if (type === "error") {
                                // Support: IE <=9 only
                                // On a manual native abort, IE9 throws
                                // errors on any property access that is not readyState
                                if (typeof xhr.status !== "number") complete(0, "error");
                                else complete(// File: protocol always yields status 0; see trac-8605, trac-14207
                                xhr.status, xhr.statusText);
                            } else complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText, // Support: IE <=9 only
                            // IE9 has no XHR2 but throws on binary (trac-11426)
                            // For XHR2 non-text, let the caller handle it (gh-2498)
                            (xhr.responseType || "text") !== "text" || typeof xhr.responseText !== "string" ? {
                                binary: xhr.response
                            } : {
                                text: xhr.responseText
                            }, xhr.getAllResponseHeaders());
                        }
                    };
                };
                // Listen to events
                xhr.onload = callback();
                errorCallback = xhr.onerror = xhr.ontimeout = callback("error");
                // Support: IE 9 only
                // Use onreadystatechange to replace onabort
                // to handle uncaught aborts
                if (xhr.onabort !== undefined) xhr.onabort = errorCallback;
                else xhr.onreadystatechange = function() {
                    // Check readyState before timeout as it changes
                    if (xhr.readyState === 4) // Allow onerror to be called first,
                    // but that will not handle a native abort
                    // Also, save errorCallback to a variable
                    // as xhr.onerror cannot be accessed
                    window1.setTimeout(function() {
                        if (callback) errorCallback();
                    });
                };
                // Create the abort callback
                callback = callback("abort");
                try {
                    // Do send the request (this may raise an exception)
                    xhr.send(options.hasContent && options.data || null);
                } catch (e) {
                    // trac-14683: Only rethrow if this hasn't been notified as an error yet
                    if (callback) throw e;
                }
            },
            abort: function() {
                if (callback) callback();
            }
        };
    });
    // Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
    jQuery.ajaxPrefilter(function(s) {
        if (s.crossDomain) s.contents.script = false;
    });
    // Install script dataType
    jQuery.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(text) {
                jQuery.globalEval(text);
                return text;
            }
        }
    });
    // Handle cache's special case and crossDomain
    jQuery.ajaxPrefilter("script", function(s) {
        if (s.cache === undefined) s.cache = false;
        if (s.crossDomain) s.type = "GET";
    });
    // Bind script tag hack transport
    jQuery.ajaxTransport("script", function(s) {
        // This transport only deals with cross domain or forced-by-attrs requests
        if (s.crossDomain || s.scriptAttrs) {
            var script, callback;
            return {
                send: function(_, complete) {
                    script = jQuery("<script>").attr(s.scriptAttrs || {}).prop({
                        charset: s.scriptCharset,
                        src: s.url
                    }).on("load error", callback = function(evt) {
                        script.remove();
                        callback = null;
                        if (evt) complete(evt.type === "error" ? 404 : 200, evt.type);
                    });
                    // Use native DOM manipulation to avoid our domManip AJAX trickery
                    document.head.appendChild(script[0]);
                },
                abort: function() {
                    if (callback) callback();
                }
            };
        }
    });
    var oldCallbacks = [], rjsonp = /(=)\?(?=&|$)|\?\?/;
    // Default jsonp settings
    jQuery.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce.guid++;
            this[callback] = true;
            return callback;
        }
    });
    // Detect, normalize options and install callbacks for jsonp requests
    jQuery.ajaxPrefilter("json jsonp", function(s, originalSettings, jqXHR) {
        var callbackName, overwritten, responseContainer, jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");
        // Handle iff the expected data type is "jsonp" or we have a parameter to set
        if (jsonProp || s.dataTypes[0] === "jsonp") {
            // Get callback name, remembering preexisting value associated with it
            callbackName = s.jsonpCallback = isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;
            // Insert callback into url or form data
            if (jsonProp) s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
            else if (s.jsonp !== false) s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
            // Use data converter to retrieve json after script execution
            s.converters["script json"] = function() {
                if (!responseContainer) jQuery.error(callbackName + " was not called");
                return responseContainer[0];
            };
            // Force json dataType
            s.dataTypes[0] = "json";
            // Install callback
            overwritten = window1[callbackName];
            window1[callbackName] = function() {
                responseContainer = arguments;
            };
            // Clean-up function (fires after converters)
            jqXHR.always(function() {
                // If previous value didn't exist - remove it
                if (overwritten === undefined) jQuery(window1).removeProp(callbackName);
                else window1[callbackName] = overwritten;
                // Save back as free
                if (s[callbackName]) {
                    // Make sure that re-using the options doesn't screw things around
                    s.jsonpCallback = originalSettings.jsonpCallback;
                    // Save the callback name for future use
                    oldCallbacks.push(callbackName);
                }
                // Call if it was a function and we have a response
                if (responseContainer && isFunction(overwritten)) overwritten(responseContainer[0]);
                responseContainer = overwritten = undefined;
            });
            // Delegate to script
            return "script";
        }
    });
    // Support: Safari 8 only
    // In Safari 8 documents created via document.implementation.createHTMLDocument
    // collapse sibling forms: the second one becomes a child of the first one.
    // Because of that, this security measure has to be disabled in Safari 8.
    // https://bugs.webkit.org/show_bug.cgi?id=137337
    support.createHTMLDocument = function() {
        var body = document.implementation.createHTMLDocument("").body;
        body.innerHTML = "<form></form><form></form>";
        return body.childNodes.length === 2;
    }();
    // Argument "data" should be string of html
    // context (optional): If specified, the fragment will be created in this context,
    // defaults to document
    // keepScripts (optional): If true, will include scripts passed in the html string
    jQuery.parseHTML = function(data, context, keepScripts) {
        if (typeof data !== "string") return [];
        if (typeof context === "boolean") {
            keepScripts = context;
            context = false;
        }
        var base, parsed, scripts;
        if (!context) {
            // Stop scripts or inline event handlers from being executed immediately
            // by using document.implementation
            if (support.createHTMLDocument) {
                context = document.implementation.createHTMLDocument("");
                // Set the base href for the created document
                // so any parsed elements with URLs
                // are based on the document's URL (gh-2965)
                base = context.createElement("base");
                base.href = document.location.href;
                context.head.appendChild(base);
            } else context = document;
        }
        parsed = rsingleTag.exec(data);
        scripts = !keepScripts && [];
        // Single tag
        if (parsed) return [
            context.createElement(parsed[1])
        ];
        parsed = buildFragment([
            data
        ], context, scripts);
        if (scripts && scripts.length) jQuery(scripts).remove();
        return jQuery.merge([], parsed.childNodes);
    };
    /**
 * Load a url into a page
 */ jQuery.fn.load = function(url, params, callback) {
        var selector, type, response, self = this, off = url.indexOf(" ");
        if (off > -1) {
            selector = stripAndCollapse(url.slice(off));
            url = url.slice(0, off);
        }
        // If it's a function
        if (isFunction(params)) {
            // We assume that it's the callback
            callback = params;
            params = undefined;
        // Otherwise, build a param string
        } else if (params && typeof params === "object") type = "POST";
        // If we have elements to modify, make the request
        if (self.length > 0) jQuery.ajax({
            url: url,
            // If "type" variable is undefined, then "GET" method will be used.
            // Make value of this field explicit since
            // user can override it through ajaxSetup method
            type: type || "GET",
            dataType: "html",
            data: params
        }).done(function(responseText) {
            // Save response for use in complete callback
            response = arguments;
            self.html(selector ? // If a selector was specified, locate the right elements in a dummy div
            // Exclude scripts to avoid IE 'Permission Denied' errors
            jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) : // Otherwise use the full result
            responseText);
        // If the request succeeds, this function gets "data", "status", "jqXHR"
        // but they are ignored because response was set above.
        // If it fails, this function gets "jqXHR", "status", "error"
        }).always(callback && function(jqXHR, status) {
            self.each(function() {
                callback.apply(this, response || [
                    jqXHR.responseText,
                    status,
                    jqXHR
                ]);
            });
        });
        return this;
    };
    jQuery.expr.pseudos.animated = function(elem) {
        return jQuery.grep(jQuery.timers, function(fn) {
            return elem === fn.elem;
        }).length;
    };
    jQuery.offset = {
        setOffset: function(elem, options, i) {
            var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition, position = jQuery.css(elem, "position"), curElem = jQuery(elem), props = {};
            // Set position first, in-case top/left are set even on static elem
            if (position === "static") elem.style.position = "relative";
            curOffset = curElem.offset();
            curCSSTop = jQuery.css(elem, "top");
            curCSSLeft = jQuery.css(elem, "left");
            calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;
            // Need to be able to calculate position if either
            // top or left is auto and position is either absolute or fixed
            if (calculatePosition) {
                curPosition = curElem.position();
                curTop = curPosition.top;
                curLeft = curPosition.left;
            } else {
                curTop = parseFloat(curCSSTop) || 0;
                curLeft = parseFloat(curCSSLeft) || 0;
            }
            if (isFunction(options)) // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
            options = options.call(elem, i, jQuery.extend({}, curOffset));
            if (options.top != null) props.top = options.top - curOffset.top + curTop;
            if (options.left != null) props.left = options.left - curOffset.left + curLeft;
            if ("using" in options) options.using.call(elem, props);
            else curElem.css(props);
        }
    };
    jQuery.fn.extend({
        // offset() relates an element's border box to the document origin
        offset: function(options) {
            // Preserve chaining for setter
            if (arguments.length) return options === undefined ? this : this.each(function(i) {
                jQuery.offset.setOffset(this, options, i);
            });
            var rect, win, elem = this[0];
            if (!elem) return;
            // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
            // Support: IE <=11 only
            // Running getBoundingClientRect on a
            // disconnected node in IE throws an error
            if (!elem.getClientRects().length) return {
                top: 0,
                left: 0
            };
            // Get document-relative position by adding viewport scroll to viewport-relative gBCR
            rect = elem.getBoundingClientRect();
            win = elem.ownerDocument.defaultView;
            return {
                top: rect.top + win.pageYOffset,
                left: rect.left + win.pageXOffset
            };
        },
        // position() relates an element's margin box to its offset parent's padding box
        // This corresponds to the behavior of CSS absolute positioning
        position: function() {
            if (!this[0]) return;
            var offsetParent, offset, doc, elem = this[0], parentOffset = {
                top: 0,
                left: 0
            };
            // position:fixed elements are offset from the viewport, which itself always has zero offset
            if (jQuery.css(elem, "position") === "fixed") // Assume position:fixed implies availability of getBoundingClientRect
            offset = elem.getBoundingClientRect();
            else {
                offset = this.offset();
                // Account for the *real* offset parent, which can be the document or its root element
                // when a statically positioned element is identified
                doc = elem.ownerDocument;
                offsetParent = elem.offsetParent || doc.documentElement;
                while(offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.parentNode;
                if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {
                    // Incorporate borders into its offset, since they are outside its content origin
                    parentOffset = jQuery(offsetParent).offset();
                    parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
                    parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
                }
            }
            // Subtract parent offsets and element margins
            return {
                top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
                left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
            };
        },
        // This method will return documentElement in the following cases:
        // 1) For the element inside the iframe without offsetParent, this method will return
        //    documentElement of the parent window
        // 2) For the hidden or detached element
        // 3) For body or html element, i.e. in case of the html node - it will return itself
        //
        // but those exceptions were never presented as a real life use-cases
        // and might be considered as more preferable results.
        //
        // This logic, however, is not guaranteed and can change at any point in the future
        offsetParent: function() {
            return this.map(function() {
                var offsetParent = this.offsetParent;
                while(offsetParent && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.offsetParent;
                return offsetParent || documentElement;
            });
        }
    });
    // Create scrollLeft and scrollTop methods
    jQuery.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(method, prop) {
        var top = "pageYOffset" === prop;
        jQuery.fn[method] = function(val) {
            return access(this, function(elem, method, val) {
                // Coalesce documents and windows
                var win;
                if (isWindow(elem)) win = elem;
                else if (elem.nodeType === 9) win = elem.defaultView;
                if (val === undefined) return win ? win[prop] : elem[method];
                if (win) win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
                else elem[method] = val;
            }, method, val, arguments.length);
        };
    });
    // Support: Safari <=7 - 9.1, Chrome <=37 - 49
    // Add the top/left cssHooks using jQuery.fn.position
    // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
    // Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
    // getComputedStyle returns percent when specified for top/left/bottom/right;
    // rather than make the css module depend on the offset module, just check for it here
    jQuery.each([
        "top",
        "left"
    ], function(_i, prop) {
        jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function(elem, computed) {
            if (computed) {
                computed = curCSS(elem, prop);
                // If curCSS returns percentage, fallback to offset
                return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
            }
        });
    });
    // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
    jQuery.each({
        Height: "height",
        Width: "width"
    }, function(name, type) {
        jQuery.each({
            padding: "inner" + name,
            content: type,
            "": "outer" + name
        }, function(defaultExtra, funcName) {
            // Margin is only for outerHeight, outerWidth
            jQuery.fn[funcName] = function(margin, value) {
                var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"), extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
                return access(this, function(elem, type, value) {
                    var doc;
                    if (isWindow(elem)) // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
                    return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
                    // Get document width or height
                    if (elem.nodeType === 9) {
                        doc = elem.documentElement;
                        // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
                        // whichever is greatest
                        return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
                    }
                    return value === undefined ? // Get width or height on the element, requesting but not forcing parseFloat
                    jQuery.css(elem, type, extra) : // Set width or height on the element
                    jQuery.style(elem, type, value, extra);
                }, type, chainable ? margin : undefined, chainable);
            };
        });
    });
    jQuery.each([
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend"
    ], function(_i, type) {
        jQuery.fn[type] = function(fn) {
            return this.on(type, fn);
        };
    });
    jQuery.fn.extend({
        bind: function(types, data, fn) {
            return this.on(types, null, data, fn);
        },
        unbind: function(types, fn) {
            return this.off(types, null, fn);
        },
        delegate: function(selector, types, data, fn) {
            return this.on(types, selector, data, fn);
        },
        undelegate: function(selector, types, fn) {
            // ( namespace ) or ( selector, types [, fn] )
            return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
        },
        hover: function(fnOver, fnOut) {
            return this.on("mouseenter", fnOver).on("mouseleave", fnOut || fnOver);
        }
    });
    jQuery.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(_i, name) {
        // Handle event binding
        jQuery.fn[name] = function(data, fn) {
            return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
        };
    });
    // Support: Android <=4.0 only
    // Make sure we trim BOM and NBSP
    // Require that the "whitespace run" starts from a non-whitespace
    // to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
    var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
    // Bind a function to a context, optionally partially applying any
    // arguments.
    // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
    // However, it is not slated for removal any time soon
    jQuery.proxy = function(fn, context) {
        var tmp, args, proxy;
        if (typeof context === "string") {
            tmp = fn[context];
            context = fn;
            fn = tmp;
        }
        // Quick check to determine if target is callable, in the spec
        // this throws a TypeError, but we will just return undefined.
        if (!isFunction(fn)) return undefined;
        // Simulated bind
        args = slice.call(arguments, 2);
        proxy = function() {
            return fn.apply(context || this, args.concat(slice.call(arguments)));
        };
        // Set the guid of unique handler to the same of original handler, so it can be removed
        proxy.guid = fn.guid = fn.guid || jQuery.guid++;
        return proxy;
    };
    jQuery.holdReady = function(hold) {
        if (hold) jQuery.readyWait++;
        else jQuery.ready(true);
    };
    jQuery.isArray = Array.isArray;
    jQuery.parseJSON = JSON.parse;
    jQuery.nodeName = nodeName;
    jQuery.isFunction = isFunction;
    jQuery.isWindow = isWindow;
    jQuery.camelCase = camelCase;
    jQuery.type = toType;
    jQuery.now = Date.now;
    jQuery.isNumeric = function(obj) {
        // As of jQuery 3.0, isNumeric is limited to
        // strings and numbers (primitives or objects)
        // that can be coerced to finite numbers (gh-2662)
        var type = jQuery.type(obj);
        return (type === "number" || type === "string") && // parseFloat NaNs numeric-cast false positives ("")
        // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
        // subtraction forces infinities to NaN
        !isNaN(obj - parseFloat(obj));
    };
    jQuery.trim = function(text) {
        return text == null ? "" : (text + "").replace(rtrim, "$1");
    };
    // Register as a named AMD module, since jQuery can be concatenated with other
    // files that may use define, but not via a proper concatenation script that
    // understands anonymous AMD modules. A named AMD is safest and most robust
    // way to register. Lowercase jquery is used because AMD module names are
    // derived from file names, and jQuery is normally delivered in a lowercase
    // file name. Do this after creating the global so that if an AMD module wants
    // to call noConflict to hide this version of jQuery, it will work.
    // Note that for maximum portability, libraries that are not jQuery should
    // declare themselves as anonymous modules, and avoid setting a global if an
    // AMD loader is present. jQuery is a special case. For more information, see
    // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
    if (typeof define === "function" && define.amd) define("jquery", [], function() {
        return jQuery;
    });
    var // Map over jQuery in case of overwrite
    _jQuery = window1.jQuery, // Map over the $ in case of overwrite
    _$ = window1.$;
    jQuery.noConflict = function(deep) {
        if (window1.$ === jQuery) window1.$ = _$;
        if (deep && window1.jQuery === jQuery) window1.jQuery = _jQuery;
        return jQuery;
    };
    // Expose jQuery and $ identifiers, even in AMD
    // (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
    // and CommonJS for browser emulators (trac-13566)
    if (typeof noGlobal === "undefined") window1.jQuery = window1.$ = jQuery;
    return jQuery;
});

});

parcelRequire.register("anY5p", function(module, exports) {

$parcel$export(module.exports, "renderToNodeStream", function () { return $78faa942f71965c2$export$307591e98609eddd; }, function (v) { return $78faa942f71965c2$export$307591e98609eddd = v; });
$parcel$export(module.exports, "renderToStaticMarkup", function () { return $78faa942f71965c2$export$eb3a06aef9e6ee51; }, function (v) { return $78faa942f71965c2$export$eb3a06aef9e6ee51 = v; });
$parcel$export(module.exports, "renderToStaticNodeStream", function () { return $78faa942f71965c2$export$b23711c915539651; }, function (v) { return $78faa942f71965c2$export$b23711c915539651 = v; });
$parcel$export(module.exports, "renderToString", function () { return $78faa942f71965c2$export$80e7718417253a51; }, function (v) { return $78faa942f71965c2$export$80e7718417253a51 = v; });
$parcel$export(module.exports, "version", function () { return $78faa942f71965c2$export$83d89fbfd8236492; }, function (v) { return $78faa942f71965c2$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom-server-legacy.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $78faa942f71965c2$export$307591e98609eddd;
var $78faa942f71965c2$export$eb3a06aef9e6ee51;
var $78faa942f71965c2$export$b23711c915539651;
var $78faa942f71965c2$export$80e7718417253a51;
var $78faa942f71965c2$export$83d89fbfd8236492;
"use strict";

var $aivMx = parcelRequire("aivMx");
function $78faa942f71965c2$var$l(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $78faa942f71965c2$var$p = Object.prototype.hasOwnProperty, $78faa942f71965c2$var$fa = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $78faa942f71965c2$var$ha = {}, $78faa942f71965c2$var$ia = {};
function $78faa942f71965c2$var$ja(a) {
    if ($78faa942f71965c2$var$p.call($78faa942f71965c2$var$ia, a)) return !0;
    if ($78faa942f71965c2$var$p.call($78faa942f71965c2$var$ha, a)) return !1;
    if ($78faa942f71965c2$var$fa.test(a)) return $78faa942f71965c2$var$ia[a] = !0;
    $78faa942f71965c2$var$ha[a] = !0;
    return !1;
}
function $78faa942f71965c2$var$r(a, b, c, d, f, e, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = f;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = e;
    this.removeEmptyString = g;
}
var $78faa942f71965c2$var$t = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $78faa942f71965c2$var$t[a] = new $78faa942f71965c2$var$r(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $78faa942f71965c2$var$t[b] = new $78faa942f71965c2$var$r(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $78faa942f71965c2$var$t[a] = new $78faa942f71965c2$var$r(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $78faa942f71965c2$var$t[a] = new $78faa942f71965c2$var$r(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $78faa942f71965c2$var$t[a] = new $78faa942f71965c2$var$r(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $78faa942f71965c2$var$t[a] = new $78faa942f71965c2$var$r(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $78faa942f71965c2$var$t[a] = new $78faa942f71965c2$var$r(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $78faa942f71965c2$var$t[a] = new $78faa942f71965c2$var$r(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $78faa942f71965c2$var$t[a] = new $78faa942f71965c2$var$r(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $78faa942f71965c2$var$ka = /[\-:]([a-z])/g;
function $78faa942f71965c2$var$la(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($78faa942f71965c2$var$ka, $78faa942f71965c2$var$la);
    $78faa942f71965c2$var$t[b] = new $78faa942f71965c2$var$r(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($78faa942f71965c2$var$ka, $78faa942f71965c2$var$la);
    $78faa942f71965c2$var$t[b] = new $78faa942f71965c2$var$r(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($78faa942f71965c2$var$ka, $78faa942f71965c2$var$la);
    $78faa942f71965c2$var$t[b] = new $78faa942f71965c2$var$r(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $78faa942f71965c2$var$t[a] = new $78faa942f71965c2$var$r(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$78faa942f71965c2$var$t.xlinkHref = new $78faa942f71965c2$var$r("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $78faa942f71965c2$var$t[a] = new $78faa942f71965c2$var$r(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
var $78faa942f71965c2$var$u = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $78faa942f71965c2$var$ma = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($78faa942f71965c2$var$u).forEach(function(a) {
    $78faa942f71965c2$var$ma.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $78faa942f71965c2$var$u[b] = $78faa942f71965c2$var$u[a];
    });
});
var $78faa942f71965c2$var$na = /["'&<>]/;
function $78faa942f71965c2$var$v(a) {
    if ("boolean" === typeof a || "number" === typeof a) return "" + a;
    a = "" + a;
    var b = $78faa942f71965c2$var$na.exec(a);
    if (b) {
        var c = "", d, f = 0;
        for(d = b.index; d < a.length; d++){
            switch(a.charCodeAt(d)){
                case 34:
                    b = "&quot;";
                    break;
                case 38:
                    b = "&amp;";
                    break;
                case 39:
                    b = "&#x27;";
                    break;
                case 60:
                    b = "&lt;";
                    break;
                case 62:
                    b = "&gt;";
                    break;
                default:
                    continue;
            }
            f !== d && (c += a.substring(f, d));
            f = d + 1;
            c += b;
        }
        a = f !== d ? c + a.substring(f, d) : c;
    }
    return a;
}
var $78faa942f71965c2$var$oa = /([A-Z])/g, $78faa942f71965c2$var$pa = /^ms-/, $78faa942f71965c2$var$qa = Array.isArray;
function $78faa942f71965c2$var$w(a, b) {
    return {
        insertionMode: a,
        selectedValue: b
    };
}
function $78faa942f71965c2$var$ra(a, b, c) {
    switch(b){
        case "select":
            return $78faa942f71965c2$var$w(1, null != c.value ? c.value : c.defaultValue);
        case "svg":
            return $78faa942f71965c2$var$w(2, null);
        case "math":
            return $78faa942f71965c2$var$w(3, null);
        case "foreignObject":
            return $78faa942f71965c2$var$w(1, null);
        case "table":
            return $78faa942f71965c2$var$w(4, null);
        case "thead":
        case "tbody":
        case "tfoot":
            return $78faa942f71965c2$var$w(5, null);
        case "colgroup":
            return $78faa942f71965c2$var$w(7, null);
        case "tr":
            return $78faa942f71965c2$var$w(6, null);
    }
    return 4 <= a.insertionMode || 0 === a.insertionMode ? $78faa942f71965c2$var$w(1, null) : a;
}
var $78faa942f71965c2$var$sa = new Map;
function $78faa942f71965c2$var$ta(a, b, c) {
    if ("object" !== typeof c) throw Error($78faa942f71965c2$var$l(62));
    b = !0;
    for(var d in c)if ($78faa942f71965c2$var$p.call(c, d)) {
        var f = c[d];
        if (null != f && "boolean" !== typeof f && "" !== f) {
            if (0 === d.indexOf("--")) {
                var e = $78faa942f71965c2$var$v(d);
                f = $78faa942f71965c2$var$v(("" + f).trim());
            } else {
                e = d;
                var g = $78faa942f71965c2$var$sa.get(e);
                void 0 !== g ? e = g : (g = $78faa942f71965c2$var$v(e.replace($78faa942f71965c2$var$oa, "-$1").toLowerCase().replace($78faa942f71965c2$var$pa, "-ms-")), $78faa942f71965c2$var$sa.set(e, g), e = g);
                f = "number" === typeof f ? 0 === f || $78faa942f71965c2$var$p.call($78faa942f71965c2$var$u, d) ? "" + f : f + "px" : $78faa942f71965c2$var$v(("" + f).trim());
            }
            b ? (b = !1, a.push(' style="', e, ":", f)) : a.push(";", e, ":", f);
        }
    }
    b || a.push('"');
}
function $78faa942f71965c2$var$x(a, b, c, d) {
    switch(c){
        case "style":
            $78faa942f71965c2$var$ta(a, b, d);
            return;
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
            return;
    }
    if (!(2 < c.length) || "o" !== c[0] && "O" !== c[0] || "n" !== c[1] && "N" !== c[1]) {
        if (b = $78faa942f71965c2$var$t.hasOwnProperty(c) ? $78faa942f71965c2$var$t[c] : null, null !== b) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (!b.acceptsBooleans) return;
            }
            c = b.attributeName;
            switch(b.type){
                case 3:
                    d && a.push(" ", c, '=""');
                    break;
                case 4:
                    !0 === d ? a.push(" ", c, '=""') : !1 !== d && a.push(" ", c, '="', $78faa942f71965c2$var$v(d), '"');
                    break;
                case 5:
                    isNaN(d) || a.push(" ", c, '="', $78faa942f71965c2$var$v(d), '"');
                    break;
                case 6:
                    !isNaN(d) && 1 <= d && a.push(" ", c, '="', $78faa942f71965c2$var$v(d), '"');
                    break;
                default:
                    b.sanitizeURL && (d = "" + d), a.push(" ", c, '="', $78faa942f71965c2$var$v(d), '"');
            }
        } else if ($78faa942f71965c2$var$ja(c)) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (b = c.toLowerCase().slice(0, 5), "data-" !== b && "aria-" !== b) return;
            }
            a.push(" ", c, '="', $78faa942f71965c2$var$v(d), '"');
        }
    }
}
function $78faa942f71965c2$var$y(a, b, c) {
    if (null != b) {
        if (null != c) throw Error($78faa942f71965c2$var$l(60));
        if ("object" !== typeof b || !("__html" in b)) throw Error($78faa942f71965c2$var$l(61));
        b = b.__html;
        null !== b && void 0 !== b && a.push("" + b);
    }
}
function $78faa942f71965c2$var$ua(a) {
    var b = "";
    $aivMx.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function $78faa942f71965c2$var$va(a, b, c, d) {
    a.push($78faa942f71965c2$var$A(c));
    var f = c = null, e;
    for(e in b)if ($78faa942f71965c2$var$p.call(b, e)) {
        var g = b[e];
        if (null != g) switch(e){
            case "children":
                c = g;
                break;
            case "dangerouslySetInnerHTML":
                f = g;
                break;
            default:
                $78faa942f71965c2$var$x(a, d, e, g);
        }
    }
    a.push(">");
    $78faa942f71965c2$var$y(a, f, c);
    return "string" === typeof c ? (a.push($78faa942f71965c2$var$v(c)), null) : c;
}
var $78faa942f71965c2$var$wa = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, $78faa942f71965c2$var$xa = new Map;
function $78faa942f71965c2$var$A(a) {
    var b = $78faa942f71965c2$var$xa.get(a);
    if (void 0 === b) {
        if (!$78faa942f71965c2$var$wa.test(a)) throw Error($78faa942f71965c2$var$l(65, a));
        b = "<" + a;
        $78faa942f71965c2$var$xa.set(a, b);
    }
    return b;
}
function $78faa942f71965c2$var$ya(a, b, c, d, f) {
    switch(b){
        case "select":
            a.push($78faa942f71965c2$var$A("select"));
            var e = null, g = null;
            for(n in c)if ($78faa942f71965c2$var$p.call(c, n)) {
                var h = c[n];
                if (null != h) switch(n){
                    case "children":
                        e = h;
                        break;
                    case "dangerouslySetInnerHTML":
                        g = h;
                        break;
                    case "defaultValue":
                    case "value":
                        break;
                    default:
                        $78faa942f71965c2$var$x(a, d, n, h);
                }
            }
            a.push(">");
            $78faa942f71965c2$var$y(a, g, e);
            return e;
        case "option":
            g = f.selectedValue;
            a.push($78faa942f71965c2$var$A("option"));
            var k = h = null, m = null;
            var n = null;
            for(e in c)if ($78faa942f71965c2$var$p.call(c, e)) {
                var q = c[e];
                if (null != q) switch(e){
                    case "children":
                        h = q;
                        break;
                    case "selected":
                        m = q;
                        break;
                    case "dangerouslySetInnerHTML":
                        n = q;
                        break;
                    case "value":
                        k = q;
                    default:
                        $78faa942f71965c2$var$x(a, d, e, q);
                }
            }
            if (null != g) {
                if (c = null !== k ? "" + k : $78faa942f71965c2$var$ua(h), $78faa942f71965c2$var$qa(g)) {
                    for(d = 0; d < g.length; d++)if ("" + g[d] === c) {
                        a.push(' selected=""');
                        break;
                    }
                } else "" + g === c && a.push(' selected=""');
            } else m && a.push(' selected=""');
            a.push(">");
            $78faa942f71965c2$var$y(a, n, h);
            return h;
        case "textarea":
            a.push($78faa942f71965c2$var$A("textarea"));
            n = g = e = null;
            for(h in c)if ($78faa942f71965c2$var$p.call(c, h) && (k = c[h], null != k)) switch(h){
                case "children":
                    n = k;
                    break;
                case "value":
                    e = k;
                    break;
                case "defaultValue":
                    g = k;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error($78faa942f71965c2$var$l(91));
                default:
                    $78faa942f71965c2$var$x(a, d, h, k);
            }
            null === e && null !== g && (e = g);
            a.push(">");
            if (null != n) {
                if (null != e) throw Error($78faa942f71965c2$var$l(92));
                if ($78faa942f71965c2$var$qa(n) && 1 < n.length) throw Error($78faa942f71965c2$var$l(93));
                e = "" + n;
            }
            "string" === typeof e && "\n" === e[0] && a.push("\n");
            null !== e && a.push($78faa942f71965c2$var$v("" + e));
            return null;
        case "input":
            a.push($78faa942f71965c2$var$A("input"));
            k = n = h = e = null;
            for(g in c)if ($78faa942f71965c2$var$p.call(c, g) && (m = c[g], null != m)) switch(g){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($78faa942f71965c2$var$l(399, "input"));
                case "defaultChecked":
                    k = m;
                    break;
                case "defaultValue":
                    h = m;
                    break;
                case "checked":
                    n = m;
                    break;
                case "value":
                    e = m;
                    break;
                default:
                    $78faa942f71965c2$var$x(a, d, g, m);
            }
            null !== n ? $78faa942f71965c2$var$x(a, d, "checked", n) : null !== k && $78faa942f71965c2$var$x(a, d, "checked", k);
            null !== e ? $78faa942f71965c2$var$x(a, d, "value", e) : null !== h && $78faa942f71965c2$var$x(a, d, "value", h);
            a.push("/>");
            return null;
        case "menuitem":
            a.push($78faa942f71965c2$var$A("menuitem"));
            for(var C in c)if ($78faa942f71965c2$var$p.call(c, C) && (e = c[C], null != e)) switch(C){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($78faa942f71965c2$var$l(400));
                default:
                    $78faa942f71965c2$var$x(a, d, C, e);
            }
            a.push(">");
            return null;
        case "title":
            a.push($78faa942f71965c2$var$A("title"));
            e = null;
            for(q in c)if ($78faa942f71965c2$var$p.call(c, q) && (g = c[q], null != g)) switch(q){
                case "children":
                    e = g;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error($78faa942f71965c2$var$l(434));
                default:
                    $78faa942f71965c2$var$x(a, d, q, g);
            }
            a.push(">");
            return e;
        case "listing":
        case "pre":
            a.push($78faa942f71965c2$var$A(b));
            g = e = null;
            for(k in c)if ($78faa942f71965c2$var$p.call(c, k) && (h = c[k], null != h)) switch(k){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                default:
                    $78faa942f71965c2$var$x(a, d, k, h);
            }
            a.push(">");
            if (null != g) {
                if (null != e) throw Error($78faa942f71965c2$var$l(60));
                if ("object" !== typeof g || !("__html" in g)) throw Error($78faa942f71965c2$var$l(61));
                c = g.__html;
                null !== c && void 0 !== c && ("string" === typeof c && 0 < c.length && "\n" === c[0] ? a.push("\n", c) : a.push("" + c));
            }
            "string" === typeof e && "\n" === e[0] && a.push("\n");
            return e;
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
            a.push($78faa942f71965c2$var$A(b));
            for(var D in c)if ($78faa942f71965c2$var$p.call(c, D) && (e = c[D], null != e)) switch(D){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($78faa942f71965c2$var$l(399, b));
                default:
                    $78faa942f71965c2$var$x(a, d, D, e);
            }
            a.push("/>");
            return null;
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return $78faa942f71965c2$var$va(a, c, b, d);
        case "html":
            return 0 === f.insertionMode && a.push("<!DOCTYPE html>"), $78faa942f71965c2$var$va(a, c, b, d);
        default:
            if (-1 === b.indexOf("-") && "string" !== typeof c.is) return $78faa942f71965c2$var$va(a, c, b, d);
            a.push($78faa942f71965c2$var$A(b));
            g = e = null;
            for(m in c)if ($78faa942f71965c2$var$p.call(c, m) && (h = c[m], null != h)) switch(m){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                case "style":
                    $78faa942f71965c2$var$ta(a, d, h);
                    break;
                case "suppressContentEditableWarning":
                case "suppressHydrationWarning":
                    break;
                default:
                    $78faa942f71965c2$var$ja(m) && "function" !== typeof h && "symbol" !== typeof h && a.push(" ", m, '="', $78faa942f71965c2$var$v(h), '"');
            }
            a.push(">");
            $78faa942f71965c2$var$y(a, g, e);
            return e;
    }
}
function $78faa942f71965c2$var$za(a, b, c) {
    a.push('<!--$?--><template id="');
    if (null === c) throw Error($78faa942f71965c2$var$l(395));
    a.push(c);
    return a.push('"></template>');
}
function $78faa942f71965c2$var$Aa(a, b, c, d) {
    switch(c.insertionMode){
        case 0:
        case 1:
            return a.push('<div hidden id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 2:
            return a.push('<svg aria-hidden="true" style="display:none" id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 3:
            return a.push('<math aria-hidden="true" style="display:none" id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 4:
            return a.push('<table hidden id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 5:
            return a.push('<table hidden><tbody id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 6:
            return a.push('<table hidden><tr id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 7:
            return a.push('<table hidden><colgroup id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        default:
            throw Error($78faa942f71965c2$var$l(397));
    }
}
function $78faa942f71965c2$var$Ba(a, b) {
    switch(b.insertionMode){
        case 0:
        case 1:
            return a.push("</div>");
        case 2:
            return a.push("</svg>");
        case 3:
            return a.push("</math>");
        case 4:
            return a.push("</table>");
        case 5:
            return a.push("</tbody></table>");
        case 6:
            return a.push("</tr></table>");
        case 7:
            return a.push("</colgroup></table>");
        default:
            throw Error($78faa942f71965c2$var$l(397));
    }
}
var $78faa942f71965c2$var$Ca = /[<\u2028\u2029]/g;
function $78faa942f71965c2$var$Da(a) {
    return JSON.stringify(a).replace($78faa942f71965c2$var$Ca, function(a) {
        switch(a){
            case "<":
                return "\\u003c";
            case "\u2028":
                return "\\u2028";
            case "\u2029":
                return "\\u2029";
            default:
                throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
        }
    });
}
function $78faa942f71965c2$var$Ea(a, b) {
    b = void 0 === b ? "" : b;
    return {
        bootstrapChunks: [],
        startInlineScript: "<script>",
        placeholderPrefix: b + "P:",
        segmentPrefix: b + "S:",
        boundaryPrefix: b + "B:",
        idPrefix: b,
        nextSuspenseID: 0,
        sentCompleteSegmentFunction: !1,
        sentCompleteBoundaryFunction: !1,
        sentClientRenderFunction: !1,
        generateStaticMarkup: a
    };
}
function $78faa942f71965c2$var$Fa(a, b, c, d) {
    if (c.generateStaticMarkup) return a.push($78faa942f71965c2$var$v(b)), !1;
    "" === b ? a = d : (d && a.push("<!-- -->"), a.push($78faa942f71965c2$var$v(b)), a = !0);
    return a;
}
var $78faa942f71965c2$var$B = Object.assign, $78faa942f71965c2$var$Ga = Symbol.for("react.element"), $78faa942f71965c2$var$Ha = Symbol.for("react.portal"), $78faa942f71965c2$var$Ia = Symbol.for("react.fragment"), $78faa942f71965c2$var$Ja = Symbol.for("react.strict_mode"), $78faa942f71965c2$var$Ka = Symbol.for("react.profiler"), $78faa942f71965c2$var$La = Symbol.for("react.provider"), $78faa942f71965c2$var$Ma = Symbol.for("react.context"), $78faa942f71965c2$var$Na = Symbol.for("react.forward_ref"), $78faa942f71965c2$var$Oa = Symbol.for("react.suspense"), $78faa942f71965c2$var$Pa = Symbol.for("react.suspense_list"), $78faa942f71965c2$var$Qa = Symbol.for("react.memo"), $78faa942f71965c2$var$Ra = Symbol.for("react.lazy"), $78faa942f71965c2$var$Sa = Symbol.for("react.scope"), $78faa942f71965c2$var$Ta = Symbol.for("react.debug_trace_mode"), $78faa942f71965c2$var$Ua = Symbol.for("react.legacy_hidden"), $78faa942f71965c2$var$Va = Symbol.for("react.default_value"), $78faa942f71965c2$var$Wa = Symbol.iterator;
function $78faa942f71965c2$var$Xa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $78faa942f71965c2$var$Ia:
            return "Fragment";
        case $78faa942f71965c2$var$Ha:
            return "Portal";
        case $78faa942f71965c2$var$Ka:
            return "Profiler";
        case $78faa942f71965c2$var$Ja:
            return "StrictMode";
        case $78faa942f71965c2$var$Oa:
            return "Suspense";
        case $78faa942f71965c2$var$Pa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $78faa942f71965c2$var$Ma:
            return (a.displayName || "Context") + ".Consumer";
        case $78faa942f71965c2$var$La:
            return (a._context.displayName || "Context") + ".Provider";
        case $78faa942f71965c2$var$Na:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $78faa942f71965c2$var$Qa:
            return b = a.displayName || null, null !== b ? b : $78faa942f71965c2$var$Xa(a.type) || "Memo";
        case $78faa942f71965c2$var$Ra:
            b = a._payload;
            a = a._init;
            try {
                return $78faa942f71965c2$var$Xa(a(b));
            } catch (c) {}
    }
    return null;
}
var $78faa942f71965c2$var$Ya = {};
function $78faa942f71965c2$var$Za(a, b) {
    a = a.contextTypes;
    if (!a) return $78faa942f71965c2$var$Ya;
    var c = {}, d;
    for(d in a)c[d] = b[d];
    return c;
}
var $78faa942f71965c2$var$E = null;
function $78faa942f71965c2$var$F(a, b) {
    if (a !== b) {
        a.context._currentValue2 = a.parentValue;
        a = a.parent;
        var c = b.parent;
        if (null === a) {
            if (null !== c) throw Error($78faa942f71965c2$var$l(401));
        } else {
            if (null === c) throw Error($78faa942f71965c2$var$l(401));
            $78faa942f71965c2$var$F(a, c);
        }
        b.context._currentValue2 = b.value;
    }
}
function $78faa942f71965c2$var$$a(a) {
    a.context._currentValue2 = a.parentValue;
    a = a.parent;
    null !== a && $78faa942f71965c2$var$$a(a);
}
function $78faa942f71965c2$var$ab(a) {
    var b = a.parent;
    null !== b && $78faa942f71965c2$var$ab(b);
    a.context._currentValue2 = a.value;
}
function $78faa942f71965c2$var$bb(a, b) {
    a.context._currentValue2 = a.parentValue;
    a = a.parent;
    if (null === a) throw Error($78faa942f71965c2$var$l(402));
    a.depth === b.depth ? $78faa942f71965c2$var$F(a, b) : $78faa942f71965c2$var$bb(a, b);
}
function $78faa942f71965c2$var$cb(a, b) {
    var c = b.parent;
    if (null === c) throw Error($78faa942f71965c2$var$l(402));
    a.depth === c.depth ? $78faa942f71965c2$var$F(a, c) : $78faa942f71965c2$var$cb(a, c);
    b.context._currentValue2 = b.value;
}
function $78faa942f71965c2$var$G(a) {
    var b = $78faa942f71965c2$var$E;
    b !== a && (null === b ? $78faa942f71965c2$var$ab(a) : null === a ? $78faa942f71965c2$var$$a(b) : b.depth === a.depth ? $78faa942f71965c2$var$F(b, a) : b.depth > a.depth ? $78faa942f71965c2$var$bb(b, a) : $78faa942f71965c2$var$cb(b, a), $78faa942f71965c2$var$E = a);
}
var $78faa942f71965c2$var$db = {
    isMounted: function() {
        return !1;
    },
    enqueueSetState: function(a, b) {
        a = a._reactInternals;
        null !== a.queue && a.queue.push(b);
    },
    enqueueReplaceState: function(a, b) {
        a = a._reactInternals;
        a.replace = !0;
        a.queue = [
            b
        ];
    },
    enqueueForceUpdate: function() {}
};
function $78faa942f71965c2$var$eb(a, b, c, d) {
    var f = void 0 !== a.state ? a.state : null;
    a.updater = $78faa942f71965c2$var$db;
    a.props = c;
    a.state = f;
    var e = {
        queue: [],
        replace: !1
    };
    a._reactInternals = e;
    var g = b.contextType;
    a.context = "object" === typeof g && null !== g ? g._currentValue2 : d;
    g = b.getDerivedStateFromProps;
    "function" === typeof g && (g = g(c, f), f = null === g || void 0 === g ? f : $78faa942f71965c2$var$B({}, f, g), a.state = f);
    if ("function" !== typeof b.getDerivedStateFromProps && "function" !== typeof a.getSnapshotBeforeUpdate && ("function" === typeof a.UNSAFE_componentWillMount || "function" === typeof a.componentWillMount)) {
        if (b = a.state, "function" === typeof a.componentWillMount && a.componentWillMount(), "function" === typeof a.UNSAFE_componentWillMount && a.UNSAFE_componentWillMount(), b !== a.state && $78faa942f71965c2$var$db.enqueueReplaceState(a, a.state, null), null !== e.queue && 0 < e.queue.length) {
            if (b = e.queue, g = e.replace, e.queue = null, e.replace = !1, g && 1 === b.length) a.state = b[0];
            else {
                e = g ? b[0] : a.state;
                f = !0;
                for(g = g ? 1 : 0; g < b.length; g++){
                    var h = b[g];
                    h = "function" === typeof h ? h.call(a, e, c, d) : h;
                    null != h && (f ? (f = !1, e = $78faa942f71965c2$var$B({}, e, h)) : $78faa942f71965c2$var$B(e, h));
                }
                a.state = e;
            }
        } else e.queue = null;
    }
}
var $78faa942f71965c2$var$fb = {
    id: 1,
    overflow: ""
};
function $78faa942f71965c2$var$gb(a, b, c) {
    var d = a.id;
    a = a.overflow;
    var f = 32 - $78faa942f71965c2$var$H(d) - 1;
    d &= ~(1 << f);
    c += 1;
    var e = 32 - $78faa942f71965c2$var$H(b) + f;
    if (30 < e) {
        var g = f - f % 5;
        e = (d & (1 << g) - 1).toString(32);
        d >>= g;
        f -= g;
        return {
            id: 1 << 32 - $78faa942f71965c2$var$H(b) + f | c << f | d,
            overflow: e + a
        };
    }
    return {
        id: 1 << e | c << f | d,
        overflow: a
    };
}
var $78faa942f71965c2$var$H = Math.clz32 ? Math.clz32 : $78faa942f71965c2$var$hb, $78faa942f71965c2$var$ib = Math.log, $78faa942f71965c2$var$jb = Math.LN2;
function $78faa942f71965c2$var$hb(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($78faa942f71965c2$var$ib(a) / $78faa942f71965c2$var$jb | 0) | 0;
}
function $78faa942f71965c2$var$kb(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $78faa942f71965c2$var$lb = "function" === typeof Object.is ? Object.is : $78faa942f71965c2$var$kb, $78faa942f71965c2$var$I = null, $78faa942f71965c2$var$ob = null, $78faa942f71965c2$var$J = null, $78faa942f71965c2$var$K = null, $78faa942f71965c2$var$L = !1, $78faa942f71965c2$var$M = !1, $78faa942f71965c2$var$N = 0, $78faa942f71965c2$var$O = null, $78faa942f71965c2$var$P = 0;
function $78faa942f71965c2$var$Q() {
    if (null === $78faa942f71965c2$var$I) throw Error($78faa942f71965c2$var$l(321));
    return $78faa942f71965c2$var$I;
}
function $78faa942f71965c2$var$pb() {
    if (0 < $78faa942f71965c2$var$P) throw Error($78faa942f71965c2$var$l(312));
    return {
        memoizedState: null,
        queue: null,
        next: null
    };
}
function $78faa942f71965c2$var$qb() {
    null === $78faa942f71965c2$var$K ? null === $78faa942f71965c2$var$J ? ($78faa942f71965c2$var$L = !1, $78faa942f71965c2$var$J = $78faa942f71965c2$var$K = $78faa942f71965c2$var$pb()) : ($78faa942f71965c2$var$L = !0, $78faa942f71965c2$var$K = $78faa942f71965c2$var$J) : null === $78faa942f71965c2$var$K.next ? ($78faa942f71965c2$var$L = !1, $78faa942f71965c2$var$K = $78faa942f71965c2$var$K.next = $78faa942f71965c2$var$pb()) : ($78faa942f71965c2$var$L = !0, $78faa942f71965c2$var$K = $78faa942f71965c2$var$K.next);
    return $78faa942f71965c2$var$K;
}
function $78faa942f71965c2$var$rb() {
    $78faa942f71965c2$var$ob = $78faa942f71965c2$var$I = null;
    $78faa942f71965c2$var$M = !1;
    $78faa942f71965c2$var$J = null;
    $78faa942f71965c2$var$P = 0;
    $78faa942f71965c2$var$K = $78faa942f71965c2$var$O = null;
}
function $78faa942f71965c2$var$sb(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $78faa942f71965c2$var$tb(a, b, c) {
    $78faa942f71965c2$var$I = $78faa942f71965c2$var$Q();
    $78faa942f71965c2$var$K = $78faa942f71965c2$var$qb();
    if ($78faa942f71965c2$var$L) {
        var d = $78faa942f71965c2$var$K.queue;
        b = d.dispatch;
        if (null !== $78faa942f71965c2$var$O && (c = $78faa942f71965c2$var$O.get(d), void 0 !== c)) {
            $78faa942f71965c2$var$O.delete(d);
            d = $78faa942f71965c2$var$K.memoizedState;
            do d = a(d, c.action), c = c.next;
            while (null !== c);
            $78faa942f71965c2$var$K.memoizedState = d;
            return [
                d,
                b
            ];
        }
        return [
            $78faa942f71965c2$var$K.memoizedState,
            b
        ];
    }
    a = a === $78faa942f71965c2$var$sb ? "function" === typeof b ? b() : b : void 0 !== c ? c(b) : b;
    $78faa942f71965c2$var$K.memoizedState = a;
    a = $78faa942f71965c2$var$K.queue = {
        last: null,
        dispatch: null
    };
    a = a.dispatch = $78faa942f71965c2$var$ub.bind(null, $78faa942f71965c2$var$I, a);
    return [
        $78faa942f71965c2$var$K.memoizedState,
        a
    ];
}
function $78faa942f71965c2$var$vb(a, b) {
    $78faa942f71965c2$var$I = $78faa942f71965c2$var$Q();
    $78faa942f71965c2$var$K = $78faa942f71965c2$var$qb();
    b = void 0 === b ? null : b;
    if (null !== $78faa942f71965c2$var$K) {
        var c = $78faa942f71965c2$var$K.memoizedState;
        if (null !== c && null !== b) {
            var d = c[1];
            a: if (null === d) d = !1;
            else {
                for(var f = 0; f < d.length && f < b.length; f++)if (!$78faa942f71965c2$var$lb(b[f], d[f])) {
                    d = !1;
                    break a;
                }
                d = !0;
            }
            if (d) return c[0];
        }
    }
    a = a();
    $78faa942f71965c2$var$K.memoizedState = [
        a,
        b
    ];
    return a;
}
function $78faa942f71965c2$var$ub(a, b, c) {
    if (25 <= $78faa942f71965c2$var$P) throw Error($78faa942f71965c2$var$l(301));
    if (a === $78faa942f71965c2$var$I) {
        if ($78faa942f71965c2$var$M = !0, a = {
            action: c,
            next: null
        }, null === $78faa942f71965c2$var$O && ($78faa942f71965c2$var$O = new Map), c = $78faa942f71965c2$var$O.get(b), void 0 === c) $78faa942f71965c2$var$O.set(b, a);
        else {
            for(b = c; null !== b.next;)b = b.next;
            b.next = a;
        }
    }
}
function $78faa942f71965c2$var$wb() {
    throw Error($78faa942f71965c2$var$l(394));
}
function $78faa942f71965c2$var$R() {}
var $78faa942f71965c2$var$xb = {
    readContext: function(a) {
        return a._currentValue2;
    },
    useContext: function(a) {
        $78faa942f71965c2$var$Q();
        return a._currentValue2;
    },
    useMemo: $78faa942f71965c2$var$vb,
    useReducer: $78faa942f71965c2$var$tb,
    useRef: function(a) {
        $78faa942f71965c2$var$I = $78faa942f71965c2$var$Q();
        $78faa942f71965c2$var$K = $78faa942f71965c2$var$qb();
        var b = $78faa942f71965c2$var$K.memoizedState;
        return null === b ? (a = {
            current: a
        }, $78faa942f71965c2$var$K.memoizedState = a) : b;
    },
    useState: function(a) {
        return $78faa942f71965c2$var$tb($78faa942f71965c2$var$sb, a);
    },
    useInsertionEffect: $78faa942f71965c2$var$R,
    useLayoutEffect: function() {},
    useCallback: function(a, b) {
        return $78faa942f71965c2$var$vb(function() {
            return a;
        }, b);
    },
    useImperativeHandle: $78faa942f71965c2$var$R,
    useEffect: $78faa942f71965c2$var$R,
    useDebugValue: $78faa942f71965c2$var$R,
    useDeferredValue: function(a) {
        $78faa942f71965c2$var$Q();
        return a;
    },
    useTransition: function() {
        $78faa942f71965c2$var$Q();
        return [
            !1,
            $78faa942f71965c2$var$wb
        ];
    },
    useId: function() {
        var a = $78faa942f71965c2$var$ob.treeContext;
        var b = a.overflow;
        a = a.id;
        a = (a & ~(1 << 32 - $78faa942f71965c2$var$H(a) - 1)).toString(32) + b;
        var c = $78faa942f71965c2$var$S;
        if (null === c) throw Error($78faa942f71965c2$var$l(404));
        b = $78faa942f71965c2$var$N++;
        a = ":" + c.idPrefix + "R" + a;
        0 < b && (a += "H" + b.toString(32));
        return a + ":";
    },
    useMutableSource: function(a, b) {
        $78faa942f71965c2$var$Q();
        return b(a._source);
    },
    useSyncExternalStore: function(a, b, c) {
        if (void 0 === c) throw Error($78faa942f71965c2$var$l(407));
        return c();
    }
}, $78faa942f71965c2$var$S = null, $78faa942f71965c2$var$yb = $aivMx.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;
function $78faa942f71965c2$var$zb(a) {
    console.error(a);
    return null;
}
function $78faa942f71965c2$var$T() {}
function $78faa942f71965c2$var$Ab(a, b, c, d, f, e, g, h, k) {
    var m = [], n = new Set;
    b = {
        destination: null,
        responseState: b,
        progressiveChunkSize: void 0 === d ? 12800 : d,
        status: 0,
        fatalError: null,
        nextSegmentId: 0,
        allPendingTasks: 0,
        pendingRootTasks: 0,
        completedRootSegment: null,
        abortableTasks: n,
        pingedTasks: m,
        clientRenderedBoundaries: [],
        completedBoundaries: [],
        partialBoundaries: [],
        onError: void 0 === f ? $78faa942f71965c2$var$zb : f,
        onAllReady: void 0 === e ? $78faa942f71965c2$var$T : e,
        onShellReady: void 0 === g ? $78faa942f71965c2$var$T : g,
        onShellError: void 0 === h ? $78faa942f71965c2$var$T : h,
        onFatalError: void 0 === k ? $78faa942f71965c2$var$T : k
    };
    c = $78faa942f71965c2$var$U(b, 0, null, c, !1, !1);
    c.parentFlushed = !0;
    a = $78faa942f71965c2$var$Bb(b, a, null, c, n, $78faa942f71965c2$var$Ya, null, $78faa942f71965c2$var$fb);
    m.push(a);
    return b;
}
function $78faa942f71965c2$var$Bb(a, b, c, d, f, e, g, h) {
    a.allPendingTasks++;
    null === c ? a.pendingRootTasks++ : c.pendingTasks++;
    var k = {
        node: b,
        ping: function() {
            var b = a.pingedTasks;
            b.push(k);
            1 === b.length && $78faa942f71965c2$var$Cb(a);
        },
        blockedBoundary: c,
        blockedSegment: d,
        abortSet: f,
        legacyContext: e,
        context: g,
        treeContext: h
    };
    f.add(k);
    return k;
}
function $78faa942f71965c2$var$U(a, b, c, d, f, e) {
    return {
        status: 0,
        id: -1,
        index: b,
        parentFlushed: !1,
        chunks: [],
        children: [],
        formatContext: d,
        boundary: c,
        lastPushedText: f,
        textEmbedded: e
    };
}
function $78faa942f71965c2$var$V(a, b) {
    a = a.onError(b);
    if (null != a && "string" !== typeof a) throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof a + '" instead');
    return a;
}
function $78faa942f71965c2$var$W(a, b) {
    var c = a.onShellError;
    c(b);
    c = a.onFatalError;
    c(b);
    null !== a.destination ? (a.status = 2, a.destination.destroy(b)) : (a.status = 1, a.fatalError = b);
}
function $78faa942f71965c2$var$Db(a, b, c, d, f) {
    $78faa942f71965c2$var$I = {};
    $78faa942f71965c2$var$ob = b;
    $78faa942f71965c2$var$N = 0;
    for(a = c(d, f); $78faa942f71965c2$var$M;)$78faa942f71965c2$var$M = !1, $78faa942f71965c2$var$N = 0, $78faa942f71965c2$var$P += 1, $78faa942f71965c2$var$K = null, a = c(d, f);
    $78faa942f71965c2$var$rb();
    return a;
}
function $78faa942f71965c2$var$Eb(a, b, c, d) {
    var f = c.render(), e = d.childContextTypes;
    if (null !== e && void 0 !== e) {
        var g = b.legacyContext;
        if ("function" !== typeof c.getChildContext) d = g;
        else {
            c = c.getChildContext();
            for(var h in c)if (!(h in e)) throw Error($78faa942f71965c2$var$l(108, $78faa942f71965c2$var$Xa(d) || "Unknown", h));
            d = $78faa942f71965c2$var$B({}, g, c);
        }
        b.legacyContext = d;
        $78faa942f71965c2$var$X(a, b, f);
        b.legacyContext = g;
    } else $78faa942f71965c2$var$X(a, b, f);
}
function $78faa942f71965c2$var$Fb(a, b) {
    if (a && a.defaultProps) {
        b = $78faa942f71965c2$var$B({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $78faa942f71965c2$var$Gb(a, b, c, d, f) {
    if ("function" === typeof c) {
        if (c.prototype && c.prototype.isReactComponent) {
            f = $78faa942f71965c2$var$Za(c, b.legacyContext);
            var e = c.contextType;
            e = new c(d, "object" === typeof e && null !== e ? e._currentValue2 : f);
            $78faa942f71965c2$var$eb(e, c, d, f);
            $78faa942f71965c2$var$Eb(a, b, e, c);
        } else {
            e = $78faa942f71965c2$var$Za(c, b.legacyContext);
            f = $78faa942f71965c2$var$Db(a, b, c, d, e);
            var g = 0 !== $78faa942f71965c2$var$N;
            if ("object" === typeof f && null !== f && "function" === typeof f.render && void 0 === f.$$typeof) $78faa942f71965c2$var$eb(f, c, d, e), $78faa942f71965c2$var$Eb(a, b, f, c);
            else if (g) {
                d = b.treeContext;
                b.treeContext = $78faa942f71965c2$var$gb(d, 1, 0);
                try {
                    $78faa942f71965c2$var$X(a, b, f);
                } finally{
                    b.treeContext = d;
                }
            } else $78faa942f71965c2$var$X(a, b, f);
        }
    } else if ("string" === typeof c) {
        f = b.blockedSegment;
        e = $78faa942f71965c2$var$ya(f.chunks, c, d, a.responseState, f.formatContext);
        f.lastPushedText = !1;
        g = f.formatContext;
        f.formatContext = $78faa942f71965c2$var$ra(g, c, d);
        $78faa942f71965c2$var$Hb(a, b, e);
        f.formatContext = g;
        switch(c){
            case "area":
            case "base":
            case "br":
            case "col":
            case "embed":
            case "hr":
            case "img":
            case "input":
            case "keygen":
            case "link":
            case "meta":
            case "param":
            case "source":
            case "track":
            case "wbr":
                break;
            default:
                f.chunks.push("</", c, ">");
        }
        f.lastPushedText = !1;
    } else {
        switch(c){
            case $78faa942f71965c2$var$Ua:
            case $78faa942f71965c2$var$Ta:
            case $78faa942f71965c2$var$Ja:
            case $78faa942f71965c2$var$Ka:
            case $78faa942f71965c2$var$Ia:
                $78faa942f71965c2$var$X(a, b, d.children);
                return;
            case $78faa942f71965c2$var$Pa:
                $78faa942f71965c2$var$X(a, b, d.children);
                return;
            case $78faa942f71965c2$var$Sa:
                throw Error($78faa942f71965c2$var$l(343));
            case $78faa942f71965c2$var$Oa:
                a: {
                    c = b.blockedBoundary;
                    f = b.blockedSegment;
                    e = d.fallback;
                    d = d.children;
                    g = new Set;
                    var h = {
                        id: null,
                        rootSegmentID: -1,
                        parentFlushed: !1,
                        pendingTasks: 0,
                        forceClientRender: !1,
                        completedSegments: [],
                        byteSize: 0,
                        fallbackAbortableTasks: g,
                        errorDigest: null
                    }, k = $78faa942f71965c2$var$U(a, f.chunks.length, h, f.formatContext, !1, !1);
                    f.children.push(k);
                    f.lastPushedText = !1;
                    var m = $78faa942f71965c2$var$U(a, 0, null, f.formatContext, !1, !1);
                    m.parentFlushed = !0;
                    b.blockedBoundary = h;
                    b.blockedSegment = m;
                    try {
                        if ($78faa942f71965c2$var$Hb(a, b, d), a.responseState.generateStaticMarkup || m.lastPushedText && m.textEmbedded && m.chunks.push("<!-- -->"), m.status = 1, $78faa942f71965c2$var$Y(h, m), 0 === h.pendingTasks) break a;
                    } catch (n) {
                        m.status = 4, h.forceClientRender = !0, h.errorDigest = $78faa942f71965c2$var$V(a, n);
                    } finally{
                        b.blockedBoundary = c, b.blockedSegment = f;
                    }
                    b = $78faa942f71965c2$var$Bb(a, e, c, k, g, b.legacyContext, b.context, b.treeContext);
                    a.pingedTasks.push(b);
                }
                return;
        }
        if ("object" === typeof c && null !== c) switch(c.$$typeof){
            case $78faa942f71965c2$var$Na:
                d = $78faa942f71965c2$var$Db(a, b, c.render, d, f);
                if (0 !== $78faa942f71965c2$var$N) {
                    c = b.treeContext;
                    b.treeContext = $78faa942f71965c2$var$gb(c, 1, 0);
                    try {
                        $78faa942f71965c2$var$X(a, b, d);
                    } finally{
                        b.treeContext = c;
                    }
                } else $78faa942f71965c2$var$X(a, b, d);
                return;
            case $78faa942f71965c2$var$Qa:
                c = c.type;
                d = $78faa942f71965c2$var$Fb(c, d);
                $78faa942f71965c2$var$Gb(a, b, c, d, f);
                return;
            case $78faa942f71965c2$var$La:
                f = d.children;
                c = c._context;
                d = d.value;
                e = c._currentValue2;
                c._currentValue2 = d;
                g = $78faa942f71965c2$var$E;
                $78faa942f71965c2$var$E = d = {
                    parent: g,
                    depth: null === g ? 0 : g.depth + 1,
                    context: c,
                    parentValue: e,
                    value: d
                };
                b.context = d;
                $78faa942f71965c2$var$X(a, b, f);
                a = $78faa942f71965c2$var$E;
                if (null === a) throw Error($78faa942f71965c2$var$l(403));
                d = a.parentValue;
                a.context._currentValue2 = d === $78faa942f71965c2$var$Va ? a.context._defaultValue : d;
                a = $78faa942f71965c2$var$E = a.parent;
                b.context = a;
                return;
            case $78faa942f71965c2$var$Ma:
                d = d.children;
                d = d(c._currentValue2);
                $78faa942f71965c2$var$X(a, b, d);
                return;
            case $78faa942f71965c2$var$Ra:
                f = c._init;
                c = f(c._payload);
                d = $78faa942f71965c2$var$Fb(c, d);
                $78faa942f71965c2$var$Gb(a, b, c, d, void 0);
                return;
        }
        throw Error($78faa942f71965c2$var$l(130, null == c ? c : typeof c, ""));
    }
}
function $78faa942f71965c2$var$X(a, b, c) {
    b.node = c;
    if ("object" === typeof c && null !== c) {
        switch(c.$$typeof){
            case $78faa942f71965c2$var$Ga:
                $78faa942f71965c2$var$Gb(a, b, c.type, c.props, c.ref);
                return;
            case $78faa942f71965c2$var$Ha:
                throw Error($78faa942f71965c2$var$l(257));
            case $78faa942f71965c2$var$Ra:
                var d = c._init;
                c = d(c._payload);
                $78faa942f71965c2$var$X(a, b, c);
                return;
        }
        if ($78faa942f71965c2$var$qa(c)) {
            $78faa942f71965c2$var$Ib(a, b, c);
            return;
        }
        null === c || "object" !== typeof c ? d = null : (d = $78faa942f71965c2$var$Wa && c[$78faa942f71965c2$var$Wa] || c["@@iterator"], d = "function" === typeof d ? d : null);
        if (d && (d = d.call(c))) {
            c = d.next();
            if (!c.done) {
                var f = [];
                do f.push(c.value), c = d.next();
                while (!c.done);
                $78faa942f71965c2$var$Ib(a, b, f);
            }
            return;
        }
        a = Object.prototype.toString.call(c);
        throw Error($78faa942f71965c2$var$l(31, "[object Object]" === a ? "object with keys {" + Object.keys(c).join(", ") + "}" : a));
    }
    "string" === typeof c ? (d = b.blockedSegment, d.lastPushedText = $78faa942f71965c2$var$Fa(b.blockedSegment.chunks, c, a.responseState, d.lastPushedText)) : "number" === typeof c && (d = b.blockedSegment, d.lastPushedText = $78faa942f71965c2$var$Fa(b.blockedSegment.chunks, "" + c, a.responseState, d.lastPushedText));
}
function $78faa942f71965c2$var$Ib(a, b, c) {
    for(var d = c.length, f = 0; f < d; f++){
        var e = b.treeContext;
        b.treeContext = $78faa942f71965c2$var$gb(e, d, f);
        try {
            $78faa942f71965c2$var$Hb(a, b, c[f]);
        } finally{
            b.treeContext = e;
        }
    }
}
function $78faa942f71965c2$var$Hb(a, b, c) {
    var d = b.blockedSegment.formatContext, f = b.legacyContext, e = b.context;
    try {
        return $78faa942f71965c2$var$X(a, b, c);
    } catch (k) {
        if ($78faa942f71965c2$var$rb(), "object" === typeof k && null !== k && "function" === typeof k.then) {
            c = k;
            var g = b.blockedSegment, h = $78faa942f71965c2$var$U(a, g.chunks.length, null, g.formatContext, g.lastPushedText, !0);
            g.children.push(h);
            g.lastPushedText = !1;
            a = $78faa942f71965c2$var$Bb(a, b.node, b.blockedBoundary, h, b.abortSet, b.legacyContext, b.context, b.treeContext).ping;
            c.then(a, a);
            b.blockedSegment.formatContext = d;
            b.legacyContext = f;
            b.context = e;
            $78faa942f71965c2$var$G(e);
        } else throw b.blockedSegment.formatContext = d, b.legacyContext = f, b.context = e, $78faa942f71965c2$var$G(e), k;
    }
}
function $78faa942f71965c2$var$Jb(a) {
    var b = a.blockedBoundary;
    a = a.blockedSegment;
    a.status = 3;
    $78faa942f71965c2$var$Kb(this, b, a);
}
function $78faa942f71965c2$var$Lb(a, b, c) {
    var d = a.blockedBoundary;
    a.blockedSegment.status = 3;
    null === d ? (b.allPendingTasks--, 2 !== b.status && (b.status = 2, null !== b.destination && b.destination.push(null))) : (d.pendingTasks--, d.forceClientRender || (d.forceClientRender = !0, a = void 0 === c ? Error($78faa942f71965c2$var$l(432)) : c, d.errorDigest = b.onError(a), d.parentFlushed && b.clientRenderedBoundaries.push(d)), d.fallbackAbortableTasks.forEach(function(a) {
        return $78faa942f71965c2$var$Lb(a, b, c);
    }), d.fallbackAbortableTasks.clear(), b.allPendingTasks--, 0 === b.allPendingTasks && (d = b.onAllReady, d()));
}
function $78faa942f71965c2$var$Y(a, b) {
    if (0 === b.chunks.length && 1 === b.children.length && null === b.children[0].boundary) {
        var c = b.children[0];
        c.id = b.id;
        c.parentFlushed = !0;
        1 === c.status && $78faa942f71965c2$var$Y(a, c);
    } else a.completedSegments.push(b);
}
function $78faa942f71965c2$var$Kb(a, b, c) {
    if (null === b) {
        if (c.parentFlushed) {
            if (null !== a.completedRootSegment) throw Error($78faa942f71965c2$var$l(389));
            a.completedRootSegment = c;
        }
        a.pendingRootTasks--;
        0 === a.pendingRootTasks && (a.onShellError = $78faa942f71965c2$var$T, b = a.onShellReady, b());
    } else b.pendingTasks--, b.forceClientRender || (0 === b.pendingTasks ? (c.parentFlushed && 1 === c.status && $78faa942f71965c2$var$Y(b, c), b.parentFlushed && a.completedBoundaries.push(b), b.fallbackAbortableTasks.forEach($78faa942f71965c2$var$Jb, a), b.fallbackAbortableTasks.clear()) : c.parentFlushed && 1 === c.status && ($78faa942f71965c2$var$Y(b, c), 1 === b.completedSegments.length && b.parentFlushed && a.partialBoundaries.push(b)));
    a.allPendingTasks--;
    0 === a.allPendingTasks && (a = a.onAllReady, a());
}
function $78faa942f71965c2$var$Cb(a) {
    if (2 !== a.status) {
        var b = $78faa942f71965c2$var$E, c = $78faa942f71965c2$var$yb.current;
        $78faa942f71965c2$var$yb.current = $78faa942f71965c2$var$xb;
        var d = $78faa942f71965c2$var$S;
        $78faa942f71965c2$var$S = a.responseState;
        try {
            var f = a.pingedTasks, e;
            for(e = 0; e < f.length; e++){
                var g = f[e];
                var h = a, k = g.blockedSegment;
                if (0 === k.status) {
                    $78faa942f71965c2$var$G(g.context);
                    try {
                        $78faa942f71965c2$var$X(h, g, g.node), h.responseState.generateStaticMarkup || k.lastPushedText && k.textEmbedded && k.chunks.push("<!-- -->"), g.abortSet.delete(g), k.status = 1, $78faa942f71965c2$var$Kb(h, g.blockedBoundary, k);
                    } catch (z) {
                        if ($78faa942f71965c2$var$rb(), "object" === typeof z && null !== z && "function" === typeof z.then) {
                            var m = g.ping;
                            z.then(m, m);
                        } else {
                            g.abortSet.delete(g);
                            k.status = 4;
                            var n = g.blockedBoundary, q = z, C = $78faa942f71965c2$var$V(h, q);
                            null === n ? $78faa942f71965c2$var$W(h, q) : (n.pendingTasks--, n.forceClientRender || (n.forceClientRender = !0, n.errorDigest = C, n.parentFlushed && h.clientRenderedBoundaries.push(n)));
                            h.allPendingTasks--;
                            if (0 === h.allPendingTasks) {
                                var D = h.onAllReady;
                                D();
                            }
                        }
                    } finally{}
                }
            }
            f.splice(0, e);
            null !== a.destination && $78faa942f71965c2$var$Mb(a, a.destination);
        } catch (z) {
            $78faa942f71965c2$var$V(a, z), $78faa942f71965c2$var$W(a, z);
        } finally{
            $78faa942f71965c2$var$S = d, $78faa942f71965c2$var$yb.current = c, c === $78faa942f71965c2$var$xb && $78faa942f71965c2$var$G(b);
        }
    }
}
function $78faa942f71965c2$var$Z(a, b, c) {
    c.parentFlushed = !0;
    switch(c.status){
        case 0:
            var d = c.id = a.nextSegmentId++;
            c.lastPushedText = !1;
            c.textEmbedded = !1;
            a = a.responseState;
            b.push('<template id="');
            b.push(a.placeholderPrefix);
            a = d.toString(16);
            b.push(a);
            return b.push('"></template>');
        case 1:
            c.status = 2;
            var f = !0;
            d = c.chunks;
            var e = 0;
            c = c.children;
            for(var g = 0; g < c.length; g++){
                for(f = c[g]; e < f.index; e++)b.push(d[e]);
                f = $78faa942f71965c2$var$Nb(a, b, f);
            }
            for(; e < d.length - 1; e++)b.push(d[e]);
            e < d.length && (f = b.push(d[e]));
            return f;
        default:
            throw Error($78faa942f71965c2$var$l(390));
    }
}
function $78faa942f71965c2$var$Nb(a, b, c) {
    var d = c.boundary;
    if (null === d) return $78faa942f71965c2$var$Z(a, b, c);
    d.parentFlushed = !0;
    if (d.forceClientRender) return a.responseState.generateStaticMarkup || (d = d.errorDigest, b.push("<!--$!-->"), b.push("<template"), d && (b.push(' data-dgst="'), d = $78faa942f71965c2$var$v(d), b.push(d), b.push('"')), b.push("></template>")), $78faa942f71965c2$var$Z(a, b, c), a = a.responseState.generateStaticMarkup ? !0 : b.push("<!--/$-->"), a;
    if (0 < d.pendingTasks) {
        d.rootSegmentID = a.nextSegmentId++;
        0 < d.completedSegments.length && a.partialBoundaries.push(d);
        var f = a.responseState;
        var e = f.nextSuspenseID++;
        f = f.boundaryPrefix + e.toString(16);
        d = d.id = f;
        $78faa942f71965c2$var$za(b, a.responseState, d);
        $78faa942f71965c2$var$Z(a, b, c);
        return b.push("<!--/$-->");
    }
    if (d.byteSize > a.progressiveChunkSize) return d.rootSegmentID = a.nextSegmentId++, a.completedBoundaries.push(d), $78faa942f71965c2$var$za(b, a.responseState, d.id), $78faa942f71965c2$var$Z(a, b, c), b.push("<!--/$-->");
    a.responseState.generateStaticMarkup || b.push("<!--$-->");
    c = d.completedSegments;
    if (1 !== c.length) throw Error($78faa942f71965c2$var$l(391));
    $78faa942f71965c2$var$Nb(a, b, c[0]);
    a = a.responseState.generateStaticMarkup ? !0 : b.push("<!--/$-->");
    return a;
}
function $78faa942f71965c2$var$Ob(a, b, c) {
    $78faa942f71965c2$var$Aa(b, a.responseState, c.formatContext, c.id);
    $78faa942f71965c2$var$Nb(a, b, c);
    return $78faa942f71965c2$var$Ba(b, c.formatContext);
}
function $78faa942f71965c2$var$Pb(a, b, c) {
    for(var d = c.completedSegments, f = 0; f < d.length; f++)$78faa942f71965c2$var$Qb(a, b, c, d[f]);
    d.length = 0;
    a = a.responseState;
    d = c.id;
    c = c.rootSegmentID;
    b.push(a.startInlineScript);
    a.sentCompleteBoundaryFunction ? b.push('$RC("') : (a.sentCompleteBoundaryFunction = !0, b.push('function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}};$RC("'));
    if (null === d) throw Error($78faa942f71965c2$var$l(395));
    c = c.toString(16);
    b.push(d);
    b.push('","');
    b.push(a.segmentPrefix);
    b.push(c);
    return b.push('")</script>');
}
function $78faa942f71965c2$var$Qb(a, b, c, d) {
    if (2 === d.status) return !0;
    var f = d.id;
    if (-1 === f) {
        if (-1 === (d.id = c.rootSegmentID)) throw Error($78faa942f71965c2$var$l(392));
        return $78faa942f71965c2$var$Ob(a, b, d);
    }
    $78faa942f71965c2$var$Ob(a, b, d);
    a = a.responseState;
    b.push(a.startInlineScript);
    a.sentCompleteSegmentFunction ? b.push('$RS("') : (a.sentCompleteSegmentFunction = !0, b.push('function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("'));
    b.push(a.segmentPrefix);
    f = f.toString(16);
    b.push(f);
    b.push('","');
    b.push(a.placeholderPrefix);
    b.push(f);
    return b.push('")</script>');
}
function $78faa942f71965c2$var$Mb(a, b) {
    try {
        var c = a.completedRootSegment;
        if (null !== c && 0 === a.pendingRootTasks) {
            $78faa942f71965c2$var$Nb(a, b, c);
            a.completedRootSegment = null;
            var d = a.responseState.bootstrapChunks;
            for(c = 0; c < d.length - 1; c++)b.push(d[c]);
            c < d.length && b.push(d[c]);
        }
        var f = a.clientRenderedBoundaries, e;
        for(e = 0; e < f.length; e++){
            var g = f[e];
            d = b;
            var h = a.responseState, k = g.id, m = g.errorDigest, n = g.errorMessage, q = g.errorComponentStack;
            d.push(h.startInlineScript);
            h.sentClientRenderFunction ? d.push('$RX("') : (h.sentClientRenderFunction = !0, d.push('function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())};$RX("'));
            if (null === k) throw Error($78faa942f71965c2$var$l(395));
            d.push(k);
            d.push('"');
            if (m || n || q) {
                d.push(",");
                var C = $78faa942f71965c2$var$Da(m || "");
                d.push(C);
            }
            if (n || q) {
                d.push(",");
                var D = $78faa942f71965c2$var$Da(n || "");
                d.push(D);
            }
            if (q) {
                d.push(",");
                var z = $78faa942f71965c2$var$Da(q);
                d.push(z);
            }
            if (!d.push(")</script>")) {
                a.destination = null;
                e++;
                f.splice(0, e);
                return;
            }
        }
        f.splice(0, e);
        var ba = a.completedBoundaries;
        for(e = 0; e < ba.length; e++)if (!$78faa942f71965c2$var$Pb(a, b, ba[e])) {
            a.destination = null;
            e++;
            ba.splice(0, e);
            return;
        }
        ba.splice(0, e);
        var ca = a.partialBoundaries;
        for(e = 0; e < ca.length; e++){
            var mb = ca[e];
            a: {
                f = a;
                g = b;
                var da = mb.completedSegments;
                for(h = 0; h < da.length; h++)if (!$78faa942f71965c2$var$Qb(f, g, mb, da[h])) {
                    h++;
                    da.splice(0, h);
                    var nb = !1;
                    break a;
                }
                da.splice(0, h);
                nb = !0;
            }
            if (!nb) {
                a.destination = null;
                e++;
                ca.splice(0, e);
                return;
            }
        }
        ca.splice(0, e);
        var ea = a.completedBoundaries;
        for(e = 0; e < ea.length; e++)if (!$78faa942f71965c2$var$Pb(a, b, ea[e])) {
            a.destination = null;
            e++;
            ea.splice(0, e);
            return;
        }
        ea.splice(0, e);
    } finally{
        0 === a.allPendingTasks && 0 === a.pingedTasks.length && 0 === a.clientRenderedBoundaries.length && 0 === a.completedBoundaries.length && b.push(null);
    }
}
function $78faa942f71965c2$var$Rb(a, b) {
    try {
        var c = a.abortableTasks;
        c.forEach(function(c) {
            return $78faa942f71965c2$var$Lb(c, a, b);
        });
        c.clear();
        null !== a.destination && $78faa942f71965c2$var$Mb(a, a.destination);
    } catch (d) {
        $78faa942f71965c2$var$V(a, d), $78faa942f71965c2$var$W(a, d);
    }
}
function $78faa942f71965c2$var$Sb() {}
function $78faa942f71965c2$var$Tb(a, b, c, d) {
    var f = !1, e = null, g = "", h = {
        push: function(a) {
            null !== a && (g += a);
            return !0;
        },
        destroy: function(a) {
            f = !0;
            e = a;
        }
    }, k = !1;
    a = $78faa942f71965c2$var$Ab(a, $78faa942f71965c2$var$Ea(c, b ? b.identifierPrefix : void 0), {
        insertionMode: 1,
        selectedValue: null
    }, Infinity, $78faa942f71965c2$var$Sb, void 0, function() {
        k = !0;
    }, void 0, void 0);
    $78faa942f71965c2$var$Cb(a);
    $78faa942f71965c2$var$Rb(a, d);
    if (1 === a.status) a.status = 2, h.destroy(a.fatalError);
    else if (2 !== a.status && null === a.destination) {
        a.destination = h;
        try {
            $78faa942f71965c2$var$Mb(a, h);
        } catch (m) {
            $78faa942f71965c2$var$V(a, m), $78faa942f71965c2$var$W(a, m);
        }
    }
    if (f) throw e;
    if (!k) throw Error($78faa942f71965c2$var$l(426));
    return g;
}
$78faa942f71965c2$export$307591e98609eddd = function() {
    throw Error($78faa942f71965c2$var$l(207));
};
$78faa942f71965c2$export$eb3a06aef9e6ee51 = function(a, b) {
    return $78faa942f71965c2$var$Tb(a, b, !0, 'The server used "renderToStaticMarkup" which does not support Suspense. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
};
$78faa942f71965c2$export$b23711c915539651 = function() {
    throw Error($78faa942f71965c2$var$l(208));
};
$78faa942f71965c2$export$80e7718417253a51 = function(a, b) {
    return $78faa942f71965c2$var$Tb(a, b, !1, 'The server used "renderToString" which does not support Suspense. If you intended for this Suspense boundary to render the fallback content on the server consider throwing an Error somewhere within the Suspense boundary. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
};
$78faa942f71965c2$export$83d89fbfd8236492 = "18.2.0";

});

parcelRequire.register("3c06z", function(module, exports) {

$parcel$export(module.exports, "renderToReadableStream", function () { return $253292e9913a6593$export$7020a3240b287705; }, function (v) { return $253292e9913a6593$export$7020a3240b287705 = v; });
$parcel$export(module.exports, "version", function () { return $253292e9913a6593$export$83d89fbfd8236492; }, function (v) { return $253292e9913a6593$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom-server.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $253292e9913a6593$export$7020a3240b287705;
var $253292e9913a6593$export$83d89fbfd8236492;
"use strict";

var $aivMx = parcelRequire("aivMx");
function $253292e9913a6593$var$k(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $253292e9913a6593$var$l = null, $253292e9913a6593$var$n = 0;
function $253292e9913a6593$var$p(a, b) {
    if (0 !== b.length) {
        if (512 < b.length) 0 < $253292e9913a6593$var$n && (a.enqueue(new Uint8Array($253292e9913a6593$var$l.buffer, 0, $253292e9913a6593$var$n)), $253292e9913a6593$var$l = new Uint8Array(512), $253292e9913a6593$var$n = 0), a.enqueue(b);
        else {
            var c = $253292e9913a6593$var$l.length - $253292e9913a6593$var$n;
            c < b.length && (0 === c ? a.enqueue($253292e9913a6593$var$l) : ($253292e9913a6593$var$l.set(b.subarray(0, c), $253292e9913a6593$var$n), a.enqueue($253292e9913a6593$var$l), b = b.subarray(c)), $253292e9913a6593$var$l = new Uint8Array(512), $253292e9913a6593$var$n = 0);
            $253292e9913a6593$var$l.set(b, $253292e9913a6593$var$n);
            $253292e9913a6593$var$n += b.length;
        }
    }
}
function $253292e9913a6593$var$t(a, b) {
    $253292e9913a6593$var$p(a, b);
    return !0;
}
function $253292e9913a6593$var$ba(a) {
    $253292e9913a6593$var$l && 0 < $253292e9913a6593$var$n && (a.enqueue(new Uint8Array($253292e9913a6593$var$l.buffer, 0, $253292e9913a6593$var$n)), $253292e9913a6593$var$l = null, $253292e9913a6593$var$n = 0);
}
var $253292e9913a6593$var$ca = new TextEncoder;
function $253292e9913a6593$var$u(a) {
    return $253292e9913a6593$var$ca.encode(a);
}
function $253292e9913a6593$var$w(a) {
    return $253292e9913a6593$var$ca.encode(a);
}
function $253292e9913a6593$var$da(a, b) {
    "function" === typeof a.error ? a.error(b) : a.close();
}
var $253292e9913a6593$var$x = Object.prototype.hasOwnProperty, $253292e9913a6593$var$ea = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $253292e9913a6593$var$fa = {}, $253292e9913a6593$var$ha = {};
function $253292e9913a6593$var$ia(a) {
    if ($253292e9913a6593$var$x.call($253292e9913a6593$var$ha, a)) return !0;
    if ($253292e9913a6593$var$x.call($253292e9913a6593$var$fa, a)) return !1;
    if ($253292e9913a6593$var$ea.test(a)) return $253292e9913a6593$var$ha[a] = !0;
    $253292e9913a6593$var$fa[a] = !0;
    return !1;
}
function $253292e9913a6593$var$y(a, b, c, d, f, e, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = f;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = e;
    this.removeEmptyString = g;
}
var $253292e9913a6593$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $253292e9913a6593$var$z[a] = new $253292e9913a6593$var$y(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $253292e9913a6593$var$z[b] = new $253292e9913a6593$var$y(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $253292e9913a6593$var$z[a] = new $253292e9913a6593$var$y(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $253292e9913a6593$var$z[a] = new $253292e9913a6593$var$y(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $253292e9913a6593$var$z[a] = new $253292e9913a6593$var$y(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $253292e9913a6593$var$z[a] = new $253292e9913a6593$var$y(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $253292e9913a6593$var$z[a] = new $253292e9913a6593$var$y(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $253292e9913a6593$var$z[a] = new $253292e9913a6593$var$y(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $253292e9913a6593$var$z[a] = new $253292e9913a6593$var$y(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $253292e9913a6593$var$ja = /[\-:]([a-z])/g;
function $253292e9913a6593$var$ka(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($253292e9913a6593$var$ja, $253292e9913a6593$var$ka);
    $253292e9913a6593$var$z[b] = new $253292e9913a6593$var$y(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($253292e9913a6593$var$ja, $253292e9913a6593$var$ka);
    $253292e9913a6593$var$z[b] = new $253292e9913a6593$var$y(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($253292e9913a6593$var$ja, $253292e9913a6593$var$ka);
    $253292e9913a6593$var$z[b] = new $253292e9913a6593$var$y(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $253292e9913a6593$var$z[a] = new $253292e9913a6593$var$y(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$253292e9913a6593$var$z.xlinkHref = new $253292e9913a6593$var$y("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $253292e9913a6593$var$z[a] = new $253292e9913a6593$var$y(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
var $253292e9913a6593$var$B = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $253292e9913a6593$var$la = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($253292e9913a6593$var$B).forEach(function(a) {
    $253292e9913a6593$var$la.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $253292e9913a6593$var$B[b] = $253292e9913a6593$var$B[a];
    });
});
var $253292e9913a6593$var$oa = /["'&<>]/;
function $253292e9913a6593$var$C(a) {
    if ("boolean" === typeof a || "number" === typeof a) return "" + a;
    a = "" + a;
    var b = $253292e9913a6593$var$oa.exec(a);
    if (b) {
        var c = "", d, f = 0;
        for(d = b.index; d < a.length; d++){
            switch(a.charCodeAt(d)){
                case 34:
                    b = "&quot;";
                    break;
                case 38:
                    b = "&amp;";
                    break;
                case 39:
                    b = "&#x27;";
                    break;
                case 60:
                    b = "&lt;";
                    break;
                case 62:
                    b = "&gt;";
                    break;
                default:
                    continue;
            }
            f !== d && (c += a.substring(f, d));
            f = d + 1;
            c += b;
        }
        a = f !== d ? c + a.substring(f, d) : c;
    }
    return a;
}
var $253292e9913a6593$var$pa = /([A-Z])/g, $253292e9913a6593$var$qa = /^ms-/, $253292e9913a6593$var$ra = Array.isArray, $253292e9913a6593$var$sa = $253292e9913a6593$var$w("<script>"), $253292e9913a6593$var$ta = $253292e9913a6593$var$w("</script>"), $253292e9913a6593$var$ua = $253292e9913a6593$var$w('<script src="'), $253292e9913a6593$var$va = $253292e9913a6593$var$w('<script type="module" src="'), $253292e9913a6593$var$wa = $253292e9913a6593$var$w('" async=""></script>'), $253292e9913a6593$var$xa = /(<\/|<)(s)(cript)/gi;
function $253292e9913a6593$var$ya(a, b, c, d) {
    return "" + b + ("s" === c ? "\\u0073" : "\\u0053") + d;
}
function $253292e9913a6593$var$za(a, b, c, d, f) {
    a = void 0 === a ? "" : a;
    b = void 0 === b ? $253292e9913a6593$var$sa : $253292e9913a6593$var$w('<script nonce="' + $253292e9913a6593$var$C(b) + '">');
    var e = [];
    void 0 !== c && e.push(b, $253292e9913a6593$var$u(("" + c).replace($253292e9913a6593$var$xa, $253292e9913a6593$var$ya)), $253292e9913a6593$var$ta);
    if (void 0 !== d) for(c = 0; c < d.length; c++)e.push($253292e9913a6593$var$ua, $253292e9913a6593$var$u($253292e9913a6593$var$C(d[c])), $253292e9913a6593$var$wa);
    if (void 0 !== f) for(d = 0; d < f.length; d++)e.push($253292e9913a6593$var$va, $253292e9913a6593$var$u($253292e9913a6593$var$C(f[d])), $253292e9913a6593$var$wa);
    return {
        bootstrapChunks: e,
        startInlineScript: b,
        placeholderPrefix: $253292e9913a6593$var$w(a + "P:"),
        segmentPrefix: $253292e9913a6593$var$w(a + "S:"),
        boundaryPrefix: a + "B:",
        idPrefix: a,
        nextSuspenseID: 0,
        sentCompleteSegmentFunction: !1,
        sentCompleteBoundaryFunction: !1,
        sentClientRenderFunction: !1
    };
}
function $253292e9913a6593$var$D(a, b) {
    return {
        insertionMode: a,
        selectedValue: b
    };
}
function $253292e9913a6593$var$Aa(a) {
    return $253292e9913a6593$var$D("http://www.w3.org/2000/svg" === a ? 2 : "http://www.w3.org/1998/Math/MathML" === a ? 3 : 0, null);
}
function $253292e9913a6593$var$Ba(a, b, c) {
    switch(b){
        case "select":
            return $253292e9913a6593$var$D(1, null != c.value ? c.value : c.defaultValue);
        case "svg":
            return $253292e9913a6593$var$D(2, null);
        case "math":
            return $253292e9913a6593$var$D(3, null);
        case "foreignObject":
            return $253292e9913a6593$var$D(1, null);
        case "table":
            return $253292e9913a6593$var$D(4, null);
        case "thead":
        case "tbody":
        case "tfoot":
            return $253292e9913a6593$var$D(5, null);
        case "colgroup":
            return $253292e9913a6593$var$D(7, null);
        case "tr":
            return $253292e9913a6593$var$D(6, null);
    }
    return 4 <= a.insertionMode || 0 === a.insertionMode ? $253292e9913a6593$var$D(1, null) : a;
}
var $253292e9913a6593$var$Ca = $253292e9913a6593$var$w("<!-- -->");
function $253292e9913a6593$var$Da(a, b, c, d) {
    if ("" === b) return d;
    d && a.push($253292e9913a6593$var$Ca);
    a.push($253292e9913a6593$var$u($253292e9913a6593$var$C(b)));
    return !0;
}
var $253292e9913a6593$var$Ea = new Map, $253292e9913a6593$var$Fa = $253292e9913a6593$var$w(' style="'), $253292e9913a6593$var$Ga = $253292e9913a6593$var$w(":"), $253292e9913a6593$var$Ha = $253292e9913a6593$var$w(";");
function $253292e9913a6593$var$Ia(a, b, c) {
    if ("object" !== typeof c) throw Error($253292e9913a6593$var$k(62));
    b = !0;
    for(var d in c)if ($253292e9913a6593$var$x.call(c, d)) {
        var f = c[d];
        if (null != f && "boolean" !== typeof f && "" !== f) {
            if (0 === d.indexOf("--")) {
                var e = $253292e9913a6593$var$u($253292e9913a6593$var$C(d));
                f = $253292e9913a6593$var$u($253292e9913a6593$var$C(("" + f).trim()));
            } else {
                e = d;
                var g = $253292e9913a6593$var$Ea.get(e);
                void 0 !== g ? e = g : (g = $253292e9913a6593$var$w($253292e9913a6593$var$C(e.replace($253292e9913a6593$var$pa, "-$1").toLowerCase().replace($253292e9913a6593$var$qa, "-ms-"))), $253292e9913a6593$var$Ea.set(e, g), e = g);
                f = "number" === typeof f ? 0 === f || $253292e9913a6593$var$x.call($253292e9913a6593$var$B, d) ? $253292e9913a6593$var$u("" + f) : $253292e9913a6593$var$u(f + "px") : $253292e9913a6593$var$u($253292e9913a6593$var$C(("" + f).trim()));
            }
            b ? (b = !1, a.push($253292e9913a6593$var$Fa, e, $253292e9913a6593$var$Ga, f)) : a.push($253292e9913a6593$var$Ha, e, $253292e9913a6593$var$Ga, f);
        }
    }
    b || a.push($253292e9913a6593$var$E);
}
var $253292e9913a6593$var$H = $253292e9913a6593$var$w(" "), $253292e9913a6593$var$I = $253292e9913a6593$var$w('="'), $253292e9913a6593$var$E = $253292e9913a6593$var$w('"'), $253292e9913a6593$var$Ja = $253292e9913a6593$var$w('=""');
function $253292e9913a6593$var$J(a, b, c, d) {
    switch(c){
        case "style":
            $253292e9913a6593$var$Ia(a, b, d);
            return;
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
            return;
    }
    if (!(2 < c.length) || "o" !== c[0] && "O" !== c[0] || "n" !== c[1] && "N" !== c[1]) {
        if (b = $253292e9913a6593$var$z.hasOwnProperty(c) ? $253292e9913a6593$var$z[c] : null, null !== b) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (!b.acceptsBooleans) return;
            }
            c = $253292e9913a6593$var$u(b.attributeName);
            switch(b.type){
                case 3:
                    d && a.push($253292e9913a6593$var$H, c, $253292e9913a6593$var$Ja);
                    break;
                case 4:
                    !0 === d ? a.push($253292e9913a6593$var$H, c, $253292e9913a6593$var$Ja) : !1 !== d && a.push($253292e9913a6593$var$H, c, $253292e9913a6593$var$I, $253292e9913a6593$var$u($253292e9913a6593$var$C(d)), $253292e9913a6593$var$E);
                    break;
                case 5:
                    isNaN(d) || a.push($253292e9913a6593$var$H, c, $253292e9913a6593$var$I, $253292e9913a6593$var$u($253292e9913a6593$var$C(d)), $253292e9913a6593$var$E);
                    break;
                case 6:
                    !isNaN(d) && 1 <= d && a.push($253292e9913a6593$var$H, c, $253292e9913a6593$var$I, $253292e9913a6593$var$u($253292e9913a6593$var$C(d)), $253292e9913a6593$var$E);
                    break;
                default:
                    b.sanitizeURL && (d = "" + d), a.push($253292e9913a6593$var$H, c, $253292e9913a6593$var$I, $253292e9913a6593$var$u($253292e9913a6593$var$C(d)), $253292e9913a6593$var$E);
            }
        } else if ($253292e9913a6593$var$ia(c)) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (b = c.toLowerCase().slice(0, 5), "data-" !== b && "aria-" !== b) return;
            }
            a.push($253292e9913a6593$var$H, $253292e9913a6593$var$u(c), $253292e9913a6593$var$I, $253292e9913a6593$var$u($253292e9913a6593$var$C(d)), $253292e9913a6593$var$E);
        }
    }
}
var $253292e9913a6593$var$K = $253292e9913a6593$var$w(">"), $253292e9913a6593$var$Ka = $253292e9913a6593$var$w("/>");
function $253292e9913a6593$var$L(a, b, c) {
    if (null != b) {
        if (null != c) throw Error($253292e9913a6593$var$k(60));
        if ("object" !== typeof b || !("__html" in b)) throw Error($253292e9913a6593$var$k(61));
        b = b.__html;
        null !== b && void 0 !== b && a.push($253292e9913a6593$var$u("" + b));
    }
}
function $253292e9913a6593$var$La(a) {
    var b = "";
    $aivMx.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
var $253292e9913a6593$var$Ma = $253292e9913a6593$var$w(' selected=""');
function $253292e9913a6593$var$Na(a, b, c, d) {
    a.push($253292e9913a6593$var$M(c));
    var f = c = null, e;
    for(e in b)if ($253292e9913a6593$var$x.call(b, e)) {
        var g = b[e];
        if (null != g) switch(e){
            case "children":
                c = g;
                break;
            case "dangerouslySetInnerHTML":
                f = g;
                break;
            default:
                $253292e9913a6593$var$J(a, d, e, g);
        }
    }
    a.push($253292e9913a6593$var$K);
    $253292e9913a6593$var$L(a, f, c);
    return "string" === typeof c ? (a.push($253292e9913a6593$var$u($253292e9913a6593$var$C(c))), null) : c;
}
var $253292e9913a6593$var$Oa = $253292e9913a6593$var$w("\n"), $253292e9913a6593$var$Pa = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, $253292e9913a6593$var$Qa = new Map;
function $253292e9913a6593$var$M(a) {
    var b = $253292e9913a6593$var$Qa.get(a);
    if (void 0 === b) {
        if (!$253292e9913a6593$var$Pa.test(a)) throw Error($253292e9913a6593$var$k(65, a));
        b = $253292e9913a6593$var$w("<" + a);
        $253292e9913a6593$var$Qa.set(a, b);
    }
    return b;
}
var $253292e9913a6593$var$Ra = $253292e9913a6593$var$w("<!DOCTYPE html>");
function $253292e9913a6593$var$Sa(a, b, c, d, f) {
    switch(b){
        case "select":
            a.push($253292e9913a6593$var$M("select"));
            var e = null, g = null;
            for(r in c)if ($253292e9913a6593$var$x.call(c, r)) {
                var h = c[r];
                if (null != h) switch(r){
                    case "children":
                        e = h;
                        break;
                    case "dangerouslySetInnerHTML":
                        g = h;
                        break;
                    case "defaultValue":
                    case "value":
                        break;
                    default:
                        $253292e9913a6593$var$J(a, d, r, h);
                }
            }
            a.push($253292e9913a6593$var$K);
            $253292e9913a6593$var$L(a, g, e);
            return e;
        case "option":
            g = f.selectedValue;
            a.push($253292e9913a6593$var$M("option"));
            var m = h = null, q = null;
            var r = null;
            for(e in c)if ($253292e9913a6593$var$x.call(c, e)) {
                var v = c[e];
                if (null != v) switch(e){
                    case "children":
                        h = v;
                        break;
                    case "selected":
                        q = v;
                        break;
                    case "dangerouslySetInnerHTML":
                        r = v;
                        break;
                    case "value":
                        m = v;
                    default:
                        $253292e9913a6593$var$J(a, d, e, v);
                }
            }
            if (null != g) {
                if (c = null !== m ? "" + m : $253292e9913a6593$var$La(h), $253292e9913a6593$var$ra(g)) {
                    for(d = 0; d < g.length; d++)if ("" + g[d] === c) {
                        a.push($253292e9913a6593$var$Ma);
                        break;
                    }
                } else "" + g === c && a.push($253292e9913a6593$var$Ma);
            } else q && a.push($253292e9913a6593$var$Ma);
            a.push($253292e9913a6593$var$K);
            $253292e9913a6593$var$L(a, r, h);
            return h;
        case "textarea":
            a.push($253292e9913a6593$var$M("textarea"));
            r = g = e = null;
            for(h in c)if ($253292e9913a6593$var$x.call(c, h) && (m = c[h], null != m)) switch(h){
                case "children":
                    r = m;
                    break;
                case "value":
                    e = m;
                    break;
                case "defaultValue":
                    g = m;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error($253292e9913a6593$var$k(91));
                default:
                    $253292e9913a6593$var$J(a, d, h, m);
            }
            null === e && null !== g && (e = g);
            a.push($253292e9913a6593$var$K);
            if (null != r) {
                if (null != e) throw Error($253292e9913a6593$var$k(92));
                if ($253292e9913a6593$var$ra(r) && 1 < r.length) throw Error($253292e9913a6593$var$k(93));
                e = "" + r;
            }
            "string" === typeof e && "\n" === e[0] && a.push($253292e9913a6593$var$Oa);
            null !== e && a.push($253292e9913a6593$var$u($253292e9913a6593$var$C("" + e)));
            return null;
        case "input":
            a.push($253292e9913a6593$var$M("input"));
            m = r = h = e = null;
            for(g in c)if ($253292e9913a6593$var$x.call(c, g) && (q = c[g], null != q)) switch(g){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($253292e9913a6593$var$k(399, "input"));
                case "defaultChecked":
                    m = q;
                    break;
                case "defaultValue":
                    h = q;
                    break;
                case "checked":
                    r = q;
                    break;
                case "value":
                    e = q;
                    break;
                default:
                    $253292e9913a6593$var$J(a, d, g, q);
            }
            null !== r ? $253292e9913a6593$var$J(a, d, "checked", r) : null !== m && $253292e9913a6593$var$J(a, d, "checked", m);
            null !== e ? $253292e9913a6593$var$J(a, d, "value", e) : null !== h && $253292e9913a6593$var$J(a, d, "value", h);
            a.push($253292e9913a6593$var$Ka);
            return null;
        case "menuitem":
            a.push($253292e9913a6593$var$M("menuitem"));
            for(var A in c)if ($253292e9913a6593$var$x.call(c, A) && (e = c[A], null != e)) switch(A){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($253292e9913a6593$var$k(400));
                default:
                    $253292e9913a6593$var$J(a, d, A, e);
            }
            a.push($253292e9913a6593$var$K);
            return null;
        case "title":
            a.push($253292e9913a6593$var$M("title"));
            e = null;
            for(v in c)if ($253292e9913a6593$var$x.call(c, v) && (g = c[v], null != g)) switch(v){
                case "children":
                    e = g;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error($253292e9913a6593$var$k(434));
                default:
                    $253292e9913a6593$var$J(a, d, v, g);
            }
            a.push($253292e9913a6593$var$K);
            return e;
        case "listing":
        case "pre":
            a.push($253292e9913a6593$var$M(b));
            g = e = null;
            for(m in c)if ($253292e9913a6593$var$x.call(c, m) && (h = c[m], null != h)) switch(m){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                default:
                    $253292e9913a6593$var$J(a, d, m, h);
            }
            a.push($253292e9913a6593$var$K);
            if (null != g) {
                if (null != e) throw Error($253292e9913a6593$var$k(60));
                if ("object" !== typeof g || !("__html" in g)) throw Error($253292e9913a6593$var$k(61));
                c = g.__html;
                null !== c && void 0 !== c && ("string" === typeof c && 0 < c.length && "\n" === c[0] ? a.push($253292e9913a6593$var$Oa, $253292e9913a6593$var$u(c)) : a.push($253292e9913a6593$var$u("" + c)));
            }
            "string" === typeof e && "\n" === e[0] && a.push($253292e9913a6593$var$Oa);
            return e;
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
            a.push($253292e9913a6593$var$M(b));
            for(var F in c)if ($253292e9913a6593$var$x.call(c, F) && (e = c[F], null != e)) switch(F){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($253292e9913a6593$var$k(399, b));
                default:
                    $253292e9913a6593$var$J(a, d, F, e);
            }
            a.push($253292e9913a6593$var$Ka);
            return null;
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return $253292e9913a6593$var$Na(a, c, b, d);
        case "html":
            return 0 === f.insertionMode && a.push($253292e9913a6593$var$Ra), $253292e9913a6593$var$Na(a, c, b, d);
        default:
            if (-1 === b.indexOf("-") && "string" !== typeof c.is) return $253292e9913a6593$var$Na(a, c, b, d);
            a.push($253292e9913a6593$var$M(b));
            g = e = null;
            for(q in c)if ($253292e9913a6593$var$x.call(c, q) && (h = c[q], null != h)) switch(q){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                case "style":
                    $253292e9913a6593$var$Ia(a, d, h);
                    break;
                case "suppressContentEditableWarning":
                case "suppressHydrationWarning":
                    break;
                default:
                    $253292e9913a6593$var$ia(q) && "function" !== typeof h && "symbol" !== typeof h && a.push($253292e9913a6593$var$H, $253292e9913a6593$var$u(q), $253292e9913a6593$var$I, $253292e9913a6593$var$u($253292e9913a6593$var$C(h)), $253292e9913a6593$var$E);
            }
            a.push($253292e9913a6593$var$K);
            $253292e9913a6593$var$L(a, g, e);
            return e;
    }
}
var $253292e9913a6593$var$Ta = $253292e9913a6593$var$w("</"), $253292e9913a6593$var$Ua = $253292e9913a6593$var$w(">"), $253292e9913a6593$var$Va = $253292e9913a6593$var$w('<template id="'), $253292e9913a6593$var$Wa = $253292e9913a6593$var$w('"></template>'), $253292e9913a6593$var$Xa = $253292e9913a6593$var$w("<!--$-->"), $253292e9913a6593$var$Ya = $253292e9913a6593$var$w('<!--$?--><template id="'), $253292e9913a6593$var$Za = $253292e9913a6593$var$w('"></template>'), $253292e9913a6593$var$$a = $253292e9913a6593$var$w("<!--$!-->"), $253292e9913a6593$var$ab = $253292e9913a6593$var$w("<!--/$-->"), $253292e9913a6593$var$bb = $253292e9913a6593$var$w("<template"), $253292e9913a6593$var$cb = $253292e9913a6593$var$w('"'), $253292e9913a6593$var$db = $253292e9913a6593$var$w(' data-dgst="');
$253292e9913a6593$var$w(' data-msg="');
$253292e9913a6593$var$w(' data-stck="');
var $253292e9913a6593$var$eb = $253292e9913a6593$var$w("></template>");
function $253292e9913a6593$var$fb(a, b, c) {
    $253292e9913a6593$var$p(a, $253292e9913a6593$var$Ya);
    if (null === c) throw Error($253292e9913a6593$var$k(395));
    $253292e9913a6593$var$p(a, c);
    return $253292e9913a6593$var$t(a, $253292e9913a6593$var$Za);
}
var $253292e9913a6593$var$gb = $253292e9913a6593$var$w('<div hidden id="'), $253292e9913a6593$var$hb = $253292e9913a6593$var$w('">'), $253292e9913a6593$var$ib = $253292e9913a6593$var$w("</div>"), $253292e9913a6593$var$jb = $253292e9913a6593$var$w('<svg aria-hidden="true" style="display:none" id="'), $253292e9913a6593$var$kb = $253292e9913a6593$var$w('">'), $253292e9913a6593$var$lb = $253292e9913a6593$var$w("</svg>"), $253292e9913a6593$var$mb = $253292e9913a6593$var$w('<math aria-hidden="true" style="display:none" id="'), $253292e9913a6593$var$nb = $253292e9913a6593$var$w('">'), $253292e9913a6593$var$ob = $253292e9913a6593$var$w("</math>"), $253292e9913a6593$var$pb = $253292e9913a6593$var$w('<table hidden id="'), $253292e9913a6593$var$qb = $253292e9913a6593$var$w('">'), $253292e9913a6593$var$rb = $253292e9913a6593$var$w("</table>"), $253292e9913a6593$var$sb = $253292e9913a6593$var$w('<table hidden><tbody id="'), $253292e9913a6593$var$tb = $253292e9913a6593$var$w('">'), $253292e9913a6593$var$ub = $253292e9913a6593$var$w("</tbody></table>"), $253292e9913a6593$var$vb = $253292e9913a6593$var$w('<table hidden><tr id="'), $253292e9913a6593$var$wb = $253292e9913a6593$var$w('">'), $253292e9913a6593$var$xb = $253292e9913a6593$var$w("</tr></table>"), $253292e9913a6593$var$yb = $253292e9913a6593$var$w('<table hidden><colgroup id="'), $253292e9913a6593$var$zb = $253292e9913a6593$var$w('">'), $253292e9913a6593$var$Ab = $253292e9913a6593$var$w("</colgroup></table>");
function $253292e9913a6593$var$Bb(a, b, c, d) {
    switch(c.insertionMode){
        case 0:
        case 1:
            return $253292e9913a6593$var$p(a, $253292e9913a6593$var$gb), $253292e9913a6593$var$p(a, b.segmentPrefix), $253292e9913a6593$var$p(a, $253292e9913a6593$var$u(d.toString(16))), $253292e9913a6593$var$t(a, $253292e9913a6593$var$hb);
        case 2:
            return $253292e9913a6593$var$p(a, $253292e9913a6593$var$jb), $253292e9913a6593$var$p(a, b.segmentPrefix), $253292e9913a6593$var$p(a, $253292e9913a6593$var$u(d.toString(16))), $253292e9913a6593$var$t(a, $253292e9913a6593$var$kb);
        case 3:
            return $253292e9913a6593$var$p(a, $253292e9913a6593$var$mb), $253292e9913a6593$var$p(a, b.segmentPrefix), $253292e9913a6593$var$p(a, $253292e9913a6593$var$u(d.toString(16))), $253292e9913a6593$var$t(a, $253292e9913a6593$var$nb);
        case 4:
            return $253292e9913a6593$var$p(a, $253292e9913a6593$var$pb), $253292e9913a6593$var$p(a, b.segmentPrefix), $253292e9913a6593$var$p(a, $253292e9913a6593$var$u(d.toString(16))), $253292e9913a6593$var$t(a, $253292e9913a6593$var$qb);
        case 5:
            return $253292e9913a6593$var$p(a, $253292e9913a6593$var$sb), $253292e9913a6593$var$p(a, b.segmentPrefix), $253292e9913a6593$var$p(a, $253292e9913a6593$var$u(d.toString(16))), $253292e9913a6593$var$t(a, $253292e9913a6593$var$tb);
        case 6:
            return $253292e9913a6593$var$p(a, $253292e9913a6593$var$vb), $253292e9913a6593$var$p(a, b.segmentPrefix), $253292e9913a6593$var$p(a, $253292e9913a6593$var$u(d.toString(16))), $253292e9913a6593$var$t(a, $253292e9913a6593$var$wb);
        case 7:
            return $253292e9913a6593$var$p(a, $253292e9913a6593$var$yb), $253292e9913a6593$var$p(a, b.segmentPrefix), $253292e9913a6593$var$p(a, $253292e9913a6593$var$u(d.toString(16))), $253292e9913a6593$var$t(a, $253292e9913a6593$var$zb);
        default:
            throw Error($253292e9913a6593$var$k(397));
    }
}
function $253292e9913a6593$var$Cb(a, b) {
    switch(b.insertionMode){
        case 0:
        case 1:
            return $253292e9913a6593$var$t(a, $253292e9913a6593$var$ib);
        case 2:
            return $253292e9913a6593$var$t(a, $253292e9913a6593$var$lb);
        case 3:
            return $253292e9913a6593$var$t(a, $253292e9913a6593$var$ob);
        case 4:
            return $253292e9913a6593$var$t(a, $253292e9913a6593$var$rb);
        case 5:
            return $253292e9913a6593$var$t(a, $253292e9913a6593$var$ub);
        case 6:
            return $253292e9913a6593$var$t(a, $253292e9913a6593$var$xb);
        case 7:
            return $253292e9913a6593$var$t(a, $253292e9913a6593$var$Ab);
        default:
            throw Error($253292e9913a6593$var$k(397));
    }
}
var $253292e9913a6593$var$Db = $253292e9913a6593$var$w('function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("'), $253292e9913a6593$var$Eb = $253292e9913a6593$var$w('$RS("'), $253292e9913a6593$var$Gb = $253292e9913a6593$var$w('","'), $253292e9913a6593$var$Hb = $253292e9913a6593$var$w('")</script>'), $253292e9913a6593$var$Ib = $253292e9913a6593$var$w('function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}};$RC("'), $253292e9913a6593$var$Jb = $253292e9913a6593$var$w('$RC("'), $253292e9913a6593$var$Kb = $253292e9913a6593$var$w('","'), $253292e9913a6593$var$Lb = $253292e9913a6593$var$w('")</script>'), $253292e9913a6593$var$Mb = $253292e9913a6593$var$w('function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())};$RX("'), $253292e9913a6593$var$Nb = $253292e9913a6593$var$w('$RX("'), $253292e9913a6593$var$Ob = $253292e9913a6593$var$w('"'), $253292e9913a6593$var$Pb = $253292e9913a6593$var$w(")</script>"), $253292e9913a6593$var$Qb = $253292e9913a6593$var$w(","), $253292e9913a6593$var$Rb = /[<\u2028\u2029]/g;
function $253292e9913a6593$var$Sb(a) {
    return JSON.stringify(a).replace($253292e9913a6593$var$Rb, function(a) {
        switch(a){
            case "<":
                return "\\u003c";
            case "\u2028":
                return "\\u2028";
            case "\u2029":
                return "\\u2029";
            default:
                throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
        }
    });
}
var $253292e9913a6593$var$N = Object.assign, $253292e9913a6593$var$Tb = Symbol.for("react.element"), $253292e9913a6593$var$Ub = Symbol.for("react.portal"), $253292e9913a6593$var$Vb = Symbol.for("react.fragment"), $253292e9913a6593$var$Wb = Symbol.for("react.strict_mode"), $253292e9913a6593$var$Xb = Symbol.for("react.profiler"), $253292e9913a6593$var$Yb = Symbol.for("react.provider"), $253292e9913a6593$var$Zb = Symbol.for("react.context"), $253292e9913a6593$var$$b = Symbol.for("react.forward_ref"), $253292e9913a6593$var$ac = Symbol.for("react.suspense"), $253292e9913a6593$var$bc = Symbol.for("react.suspense_list"), $253292e9913a6593$var$cc = Symbol.for("react.memo"), $253292e9913a6593$var$dc = Symbol.for("react.lazy"), $253292e9913a6593$var$ec = Symbol.for("react.scope"), $253292e9913a6593$var$fc = Symbol.for("react.debug_trace_mode"), $253292e9913a6593$var$gc = Symbol.for("react.legacy_hidden"), $253292e9913a6593$var$hc = Symbol.for("react.default_value"), $253292e9913a6593$var$ic = Symbol.iterator;
function $253292e9913a6593$var$jc(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $253292e9913a6593$var$Vb:
            return "Fragment";
        case $253292e9913a6593$var$Ub:
            return "Portal";
        case $253292e9913a6593$var$Xb:
            return "Profiler";
        case $253292e9913a6593$var$Wb:
            return "StrictMode";
        case $253292e9913a6593$var$ac:
            return "Suspense";
        case $253292e9913a6593$var$bc:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $253292e9913a6593$var$Zb:
            return (a.displayName || "Context") + ".Consumer";
        case $253292e9913a6593$var$Yb:
            return (a._context.displayName || "Context") + ".Provider";
        case $253292e9913a6593$var$$b:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $253292e9913a6593$var$cc:
            return b = a.displayName || null, null !== b ? b : $253292e9913a6593$var$jc(a.type) || "Memo";
        case $253292e9913a6593$var$dc:
            b = a._payload;
            a = a._init;
            try {
                return $253292e9913a6593$var$jc(a(b));
            } catch (c) {}
    }
    return null;
}
var $253292e9913a6593$var$kc = {};
function $253292e9913a6593$var$lc(a, b) {
    a = a.contextTypes;
    if (!a) return $253292e9913a6593$var$kc;
    var c = {}, d;
    for(d in a)c[d] = b[d];
    return c;
}
var $253292e9913a6593$var$O = null;
function $253292e9913a6593$var$P(a, b) {
    if (a !== b) {
        a.context._currentValue = a.parentValue;
        a = a.parent;
        var c = b.parent;
        if (null === a) {
            if (null !== c) throw Error($253292e9913a6593$var$k(401));
        } else {
            if (null === c) throw Error($253292e9913a6593$var$k(401));
            $253292e9913a6593$var$P(a, c);
        }
        b.context._currentValue = b.value;
    }
}
function $253292e9913a6593$var$mc(a) {
    a.context._currentValue = a.parentValue;
    a = a.parent;
    null !== a && $253292e9913a6593$var$mc(a);
}
function $253292e9913a6593$var$nc(a) {
    var b = a.parent;
    null !== b && $253292e9913a6593$var$nc(b);
    a.context._currentValue = a.value;
}
function $253292e9913a6593$var$oc(a, b) {
    a.context._currentValue = a.parentValue;
    a = a.parent;
    if (null === a) throw Error($253292e9913a6593$var$k(402));
    a.depth === b.depth ? $253292e9913a6593$var$P(a, b) : $253292e9913a6593$var$oc(a, b);
}
function $253292e9913a6593$var$pc(a, b) {
    var c = b.parent;
    if (null === c) throw Error($253292e9913a6593$var$k(402));
    a.depth === c.depth ? $253292e9913a6593$var$P(a, c) : $253292e9913a6593$var$pc(a, c);
    b.context._currentValue = b.value;
}
function $253292e9913a6593$var$Q(a) {
    var b = $253292e9913a6593$var$O;
    b !== a && (null === b ? $253292e9913a6593$var$nc(a) : null === a ? $253292e9913a6593$var$mc(b) : b.depth === a.depth ? $253292e9913a6593$var$P(b, a) : b.depth > a.depth ? $253292e9913a6593$var$oc(b, a) : $253292e9913a6593$var$pc(b, a), $253292e9913a6593$var$O = a);
}
var $253292e9913a6593$var$qc = {
    isMounted: function() {
        return !1;
    },
    enqueueSetState: function(a, b) {
        a = a._reactInternals;
        null !== a.queue && a.queue.push(b);
    },
    enqueueReplaceState: function(a, b) {
        a = a._reactInternals;
        a.replace = !0;
        a.queue = [
            b
        ];
    },
    enqueueForceUpdate: function() {}
};
function $253292e9913a6593$var$rc(a, b, c, d) {
    var f = void 0 !== a.state ? a.state : null;
    a.updater = $253292e9913a6593$var$qc;
    a.props = c;
    a.state = f;
    var e = {
        queue: [],
        replace: !1
    };
    a._reactInternals = e;
    var g = b.contextType;
    a.context = "object" === typeof g && null !== g ? g._currentValue : d;
    g = b.getDerivedStateFromProps;
    "function" === typeof g && (g = g(c, f), f = null === g || void 0 === g ? f : $253292e9913a6593$var$N({}, f, g), a.state = f);
    if ("function" !== typeof b.getDerivedStateFromProps && "function" !== typeof a.getSnapshotBeforeUpdate && ("function" === typeof a.UNSAFE_componentWillMount || "function" === typeof a.componentWillMount)) {
        if (b = a.state, "function" === typeof a.componentWillMount && a.componentWillMount(), "function" === typeof a.UNSAFE_componentWillMount && a.UNSAFE_componentWillMount(), b !== a.state && $253292e9913a6593$var$qc.enqueueReplaceState(a, a.state, null), null !== e.queue && 0 < e.queue.length) {
            if (b = e.queue, g = e.replace, e.queue = null, e.replace = !1, g && 1 === b.length) a.state = b[0];
            else {
                e = g ? b[0] : a.state;
                f = !0;
                for(g = g ? 1 : 0; g < b.length; g++){
                    var h = b[g];
                    h = "function" === typeof h ? h.call(a, e, c, d) : h;
                    null != h && (f ? (f = !1, e = $253292e9913a6593$var$N({}, e, h)) : $253292e9913a6593$var$N(e, h));
                }
                a.state = e;
            }
        } else e.queue = null;
    }
}
var $253292e9913a6593$var$sc = {
    id: 1,
    overflow: ""
};
function $253292e9913a6593$var$tc(a, b, c) {
    var d = a.id;
    a = a.overflow;
    var f = 32 - $253292e9913a6593$var$uc(d) - 1;
    d &= ~(1 << f);
    c += 1;
    var e = 32 - $253292e9913a6593$var$uc(b) + f;
    if (30 < e) {
        var g = f - f % 5;
        e = (d & (1 << g) - 1).toString(32);
        d >>= g;
        f -= g;
        return {
            id: 1 << 32 - $253292e9913a6593$var$uc(b) + f | c << f | d,
            overflow: e + a
        };
    }
    return {
        id: 1 << e | c << f | d,
        overflow: a
    };
}
var $253292e9913a6593$var$uc = Math.clz32 ? Math.clz32 : $253292e9913a6593$var$vc, $253292e9913a6593$var$wc = Math.log, $253292e9913a6593$var$xc = Math.LN2;
function $253292e9913a6593$var$vc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($253292e9913a6593$var$wc(a) / $253292e9913a6593$var$xc | 0) | 0;
}
function $253292e9913a6593$var$yc(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $253292e9913a6593$var$zc = "function" === typeof Object.is ? Object.is : $253292e9913a6593$var$yc, $253292e9913a6593$var$R = null, $253292e9913a6593$var$Ac = null, $253292e9913a6593$var$Bc = null, $253292e9913a6593$var$S = null, $253292e9913a6593$var$T = !1, $253292e9913a6593$var$Cc = !1, $253292e9913a6593$var$U = 0, $253292e9913a6593$var$V = null, $253292e9913a6593$var$Dc = 0;
function $253292e9913a6593$var$W() {
    if (null === $253292e9913a6593$var$R) throw Error($253292e9913a6593$var$k(321));
    return $253292e9913a6593$var$R;
}
function $253292e9913a6593$var$Ec() {
    if (0 < $253292e9913a6593$var$Dc) throw Error($253292e9913a6593$var$k(312));
    return {
        memoizedState: null,
        queue: null,
        next: null
    };
}
function $253292e9913a6593$var$Fc() {
    null === $253292e9913a6593$var$S ? null === $253292e9913a6593$var$Bc ? ($253292e9913a6593$var$T = !1, $253292e9913a6593$var$Bc = $253292e9913a6593$var$S = $253292e9913a6593$var$Ec()) : ($253292e9913a6593$var$T = !0, $253292e9913a6593$var$S = $253292e9913a6593$var$Bc) : null === $253292e9913a6593$var$S.next ? ($253292e9913a6593$var$T = !1, $253292e9913a6593$var$S = $253292e9913a6593$var$S.next = $253292e9913a6593$var$Ec()) : ($253292e9913a6593$var$T = !0, $253292e9913a6593$var$S = $253292e9913a6593$var$S.next);
    return $253292e9913a6593$var$S;
}
function $253292e9913a6593$var$Gc() {
    $253292e9913a6593$var$Ac = $253292e9913a6593$var$R = null;
    $253292e9913a6593$var$Cc = !1;
    $253292e9913a6593$var$Bc = null;
    $253292e9913a6593$var$Dc = 0;
    $253292e9913a6593$var$S = $253292e9913a6593$var$V = null;
}
function $253292e9913a6593$var$Hc(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $253292e9913a6593$var$Ic(a, b, c) {
    $253292e9913a6593$var$R = $253292e9913a6593$var$W();
    $253292e9913a6593$var$S = $253292e9913a6593$var$Fc();
    if ($253292e9913a6593$var$T) {
        var d = $253292e9913a6593$var$S.queue;
        b = d.dispatch;
        if (null !== $253292e9913a6593$var$V && (c = $253292e9913a6593$var$V.get(d), void 0 !== c)) {
            $253292e9913a6593$var$V.delete(d);
            d = $253292e9913a6593$var$S.memoizedState;
            do d = a(d, c.action), c = c.next;
            while (null !== c);
            $253292e9913a6593$var$S.memoizedState = d;
            return [
                d,
                b
            ];
        }
        return [
            $253292e9913a6593$var$S.memoizedState,
            b
        ];
    }
    a = a === $253292e9913a6593$var$Hc ? "function" === typeof b ? b() : b : void 0 !== c ? c(b) : b;
    $253292e9913a6593$var$S.memoizedState = a;
    a = $253292e9913a6593$var$S.queue = {
        last: null,
        dispatch: null
    };
    a = a.dispatch = $253292e9913a6593$var$Jc.bind(null, $253292e9913a6593$var$R, a);
    return [
        $253292e9913a6593$var$S.memoizedState,
        a
    ];
}
function $253292e9913a6593$var$Kc(a, b) {
    $253292e9913a6593$var$R = $253292e9913a6593$var$W();
    $253292e9913a6593$var$S = $253292e9913a6593$var$Fc();
    b = void 0 === b ? null : b;
    if (null !== $253292e9913a6593$var$S) {
        var c = $253292e9913a6593$var$S.memoizedState;
        if (null !== c && null !== b) {
            var d = c[1];
            a: if (null === d) d = !1;
            else {
                for(var f = 0; f < d.length && f < b.length; f++)if (!$253292e9913a6593$var$zc(b[f], d[f])) {
                    d = !1;
                    break a;
                }
                d = !0;
            }
            if (d) return c[0];
        }
    }
    a = a();
    $253292e9913a6593$var$S.memoizedState = [
        a,
        b
    ];
    return a;
}
function $253292e9913a6593$var$Jc(a, b, c) {
    if (25 <= $253292e9913a6593$var$Dc) throw Error($253292e9913a6593$var$k(301));
    if (a === $253292e9913a6593$var$R) {
        if ($253292e9913a6593$var$Cc = !0, a = {
            action: c,
            next: null
        }, null === $253292e9913a6593$var$V && ($253292e9913a6593$var$V = new Map), c = $253292e9913a6593$var$V.get(b), void 0 === c) $253292e9913a6593$var$V.set(b, a);
        else {
            for(b = c; null !== b.next;)b = b.next;
            b.next = a;
        }
    }
}
function $253292e9913a6593$var$Lc() {
    throw Error($253292e9913a6593$var$k(394));
}
function $253292e9913a6593$var$Mc() {}
var $253292e9913a6593$var$Oc = {
    readContext: function(a) {
        return a._currentValue;
    },
    useContext: function(a) {
        $253292e9913a6593$var$W();
        return a._currentValue;
    },
    useMemo: $253292e9913a6593$var$Kc,
    useReducer: $253292e9913a6593$var$Ic,
    useRef: function(a) {
        $253292e9913a6593$var$R = $253292e9913a6593$var$W();
        $253292e9913a6593$var$S = $253292e9913a6593$var$Fc();
        var b = $253292e9913a6593$var$S.memoizedState;
        return null === b ? (a = {
            current: a
        }, $253292e9913a6593$var$S.memoizedState = a) : b;
    },
    useState: function(a) {
        return $253292e9913a6593$var$Ic($253292e9913a6593$var$Hc, a);
    },
    useInsertionEffect: $253292e9913a6593$var$Mc,
    useLayoutEffect: function() {},
    useCallback: function(a, b) {
        return $253292e9913a6593$var$Kc(function() {
            return a;
        }, b);
    },
    useImperativeHandle: $253292e9913a6593$var$Mc,
    useEffect: $253292e9913a6593$var$Mc,
    useDebugValue: $253292e9913a6593$var$Mc,
    useDeferredValue: function(a) {
        $253292e9913a6593$var$W();
        return a;
    },
    useTransition: function() {
        $253292e9913a6593$var$W();
        return [
            !1,
            $253292e9913a6593$var$Lc
        ];
    },
    useId: function() {
        var a = $253292e9913a6593$var$Ac.treeContext;
        var b = a.overflow;
        a = a.id;
        a = (a & ~(1 << 32 - $253292e9913a6593$var$uc(a) - 1)).toString(32) + b;
        var c = $253292e9913a6593$var$Nc;
        if (null === c) throw Error($253292e9913a6593$var$k(404));
        b = $253292e9913a6593$var$U++;
        a = ":" + c.idPrefix + "R" + a;
        0 < b && (a += "H" + b.toString(32));
        return a + ":";
    },
    useMutableSource: function(a, b) {
        $253292e9913a6593$var$W();
        return b(a._source);
    },
    useSyncExternalStore: function(a, b, c) {
        if (void 0 === c) throw Error($253292e9913a6593$var$k(407));
        return c();
    }
}, $253292e9913a6593$var$Nc = null, $253292e9913a6593$var$Pc = $aivMx.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;
function $253292e9913a6593$var$Qc(a) {
    console.error(a);
    return null;
}
function $253292e9913a6593$var$X() {}
function $253292e9913a6593$var$Rc(a, b, c, d, f, e, g, h, m) {
    var q = [], r = new Set;
    b = {
        destination: null,
        responseState: b,
        progressiveChunkSize: void 0 === d ? 12800 : d,
        status: 0,
        fatalError: null,
        nextSegmentId: 0,
        allPendingTasks: 0,
        pendingRootTasks: 0,
        completedRootSegment: null,
        abortableTasks: r,
        pingedTasks: q,
        clientRenderedBoundaries: [],
        completedBoundaries: [],
        partialBoundaries: [],
        onError: void 0 === f ? $253292e9913a6593$var$Qc : f,
        onAllReady: void 0 === e ? $253292e9913a6593$var$X : e,
        onShellReady: void 0 === g ? $253292e9913a6593$var$X : g,
        onShellError: void 0 === h ? $253292e9913a6593$var$X : h,
        onFatalError: void 0 === m ? $253292e9913a6593$var$X : m
    };
    c = $253292e9913a6593$var$Sc(b, 0, null, c, !1, !1);
    c.parentFlushed = !0;
    a = $253292e9913a6593$var$Tc(b, a, null, c, r, $253292e9913a6593$var$kc, null, $253292e9913a6593$var$sc);
    q.push(a);
    return b;
}
function $253292e9913a6593$var$Tc(a, b, c, d, f, e, g, h) {
    a.allPendingTasks++;
    null === c ? a.pendingRootTasks++ : c.pendingTasks++;
    var m = {
        node: b,
        ping: function() {
            var b = a.pingedTasks;
            b.push(m);
            1 === b.length && $253292e9913a6593$var$Uc(a);
        },
        blockedBoundary: c,
        blockedSegment: d,
        abortSet: f,
        legacyContext: e,
        context: g,
        treeContext: h
    };
    f.add(m);
    return m;
}
function $253292e9913a6593$var$Sc(a, b, c, d, f, e) {
    return {
        status: 0,
        id: -1,
        index: b,
        parentFlushed: !1,
        chunks: [],
        children: [],
        formatContext: d,
        boundary: c,
        lastPushedText: f,
        textEmbedded: e
    };
}
function $253292e9913a6593$var$Y(a, b) {
    a = a.onError(b);
    if (null != a && "string" !== typeof a) throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof a + '" instead');
    return a;
}
function $253292e9913a6593$var$Vc(a, b) {
    var c = a.onShellError;
    c(b);
    c = a.onFatalError;
    c(b);
    null !== a.destination ? (a.status = 2, $253292e9913a6593$var$da(a.destination, b)) : (a.status = 1, a.fatalError = b);
}
function $253292e9913a6593$var$Wc(a, b, c, d, f) {
    $253292e9913a6593$var$R = {};
    $253292e9913a6593$var$Ac = b;
    $253292e9913a6593$var$U = 0;
    for(a = c(d, f); $253292e9913a6593$var$Cc;)$253292e9913a6593$var$Cc = !1, $253292e9913a6593$var$U = 0, $253292e9913a6593$var$Dc += 1, $253292e9913a6593$var$S = null, a = c(d, f);
    $253292e9913a6593$var$Gc();
    return a;
}
function $253292e9913a6593$var$Xc(a, b, c, d) {
    var f = c.render(), e = d.childContextTypes;
    if (null !== e && void 0 !== e) {
        var g = b.legacyContext;
        if ("function" !== typeof c.getChildContext) d = g;
        else {
            c = c.getChildContext();
            for(var h in c)if (!(h in e)) throw Error($253292e9913a6593$var$k(108, $253292e9913a6593$var$jc(d) || "Unknown", h));
            d = $253292e9913a6593$var$N({}, g, c);
        }
        b.legacyContext = d;
        $253292e9913a6593$var$Z(a, b, f);
        b.legacyContext = g;
    } else $253292e9913a6593$var$Z(a, b, f);
}
function $253292e9913a6593$var$Yc(a, b) {
    if (a && a.defaultProps) {
        b = $253292e9913a6593$var$N({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $253292e9913a6593$var$Zc(a, b, c, d, f) {
    if ("function" === typeof c) {
        if (c.prototype && c.prototype.isReactComponent) {
            f = $253292e9913a6593$var$lc(c, b.legacyContext);
            var e = c.contextType;
            e = new c(d, "object" === typeof e && null !== e ? e._currentValue : f);
            $253292e9913a6593$var$rc(e, c, d, f);
            $253292e9913a6593$var$Xc(a, b, e, c);
        } else {
            e = $253292e9913a6593$var$lc(c, b.legacyContext);
            f = $253292e9913a6593$var$Wc(a, b, c, d, e);
            var g = 0 !== $253292e9913a6593$var$U;
            if ("object" === typeof f && null !== f && "function" === typeof f.render && void 0 === f.$$typeof) $253292e9913a6593$var$rc(f, c, d, e), $253292e9913a6593$var$Xc(a, b, f, c);
            else if (g) {
                d = b.treeContext;
                b.treeContext = $253292e9913a6593$var$tc(d, 1, 0);
                try {
                    $253292e9913a6593$var$Z(a, b, f);
                } finally{
                    b.treeContext = d;
                }
            } else $253292e9913a6593$var$Z(a, b, f);
        }
    } else if ("string" === typeof c) {
        f = b.blockedSegment;
        e = $253292e9913a6593$var$Sa(f.chunks, c, d, a.responseState, f.formatContext);
        f.lastPushedText = !1;
        g = f.formatContext;
        f.formatContext = $253292e9913a6593$var$Ba(g, c, d);
        $253292e9913a6593$var$$c(a, b, e);
        f.formatContext = g;
        switch(c){
            case "area":
            case "base":
            case "br":
            case "col":
            case "embed":
            case "hr":
            case "img":
            case "input":
            case "keygen":
            case "link":
            case "meta":
            case "param":
            case "source":
            case "track":
            case "wbr":
                break;
            default:
                f.chunks.push($253292e9913a6593$var$Ta, $253292e9913a6593$var$u(c), $253292e9913a6593$var$Ua);
        }
        f.lastPushedText = !1;
    } else {
        switch(c){
            case $253292e9913a6593$var$gc:
            case $253292e9913a6593$var$fc:
            case $253292e9913a6593$var$Wb:
            case $253292e9913a6593$var$Xb:
            case $253292e9913a6593$var$Vb:
                $253292e9913a6593$var$Z(a, b, d.children);
                return;
            case $253292e9913a6593$var$bc:
                $253292e9913a6593$var$Z(a, b, d.children);
                return;
            case $253292e9913a6593$var$ec:
                throw Error($253292e9913a6593$var$k(343));
            case $253292e9913a6593$var$ac:
                a: {
                    c = b.blockedBoundary;
                    f = b.blockedSegment;
                    e = d.fallback;
                    d = d.children;
                    g = new Set;
                    var h = {
                        id: null,
                        rootSegmentID: -1,
                        parentFlushed: !1,
                        pendingTasks: 0,
                        forceClientRender: !1,
                        completedSegments: [],
                        byteSize: 0,
                        fallbackAbortableTasks: g,
                        errorDigest: null
                    }, m = $253292e9913a6593$var$Sc(a, f.chunks.length, h, f.formatContext, !1, !1);
                    f.children.push(m);
                    f.lastPushedText = !1;
                    var q = $253292e9913a6593$var$Sc(a, 0, null, f.formatContext, !1, !1);
                    q.parentFlushed = !0;
                    b.blockedBoundary = h;
                    b.blockedSegment = q;
                    try {
                        if ($253292e9913a6593$var$$c(a, b, d), q.lastPushedText && q.textEmbedded && q.chunks.push($253292e9913a6593$var$Ca), q.status = 1, $253292e9913a6593$var$ad(h, q), 0 === h.pendingTasks) break a;
                    } catch (r) {
                        q.status = 4, h.forceClientRender = !0, h.errorDigest = $253292e9913a6593$var$Y(a, r);
                    } finally{
                        b.blockedBoundary = c, b.blockedSegment = f;
                    }
                    b = $253292e9913a6593$var$Tc(a, e, c, m, g, b.legacyContext, b.context, b.treeContext);
                    a.pingedTasks.push(b);
                }
                return;
        }
        if ("object" === typeof c && null !== c) switch(c.$$typeof){
            case $253292e9913a6593$var$$b:
                d = $253292e9913a6593$var$Wc(a, b, c.render, d, f);
                if (0 !== $253292e9913a6593$var$U) {
                    c = b.treeContext;
                    b.treeContext = $253292e9913a6593$var$tc(c, 1, 0);
                    try {
                        $253292e9913a6593$var$Z(a, b, d);
                    } finally{
                        b.treeContext = c;
                    }
                } else $253292e9913a6593$var$Z(a, b, d);
                return;
            case $253292e9913a6593$var$cc:
                c = c.type;
                d = $253292e9913a6593$var$Yc(c, d);
                $253292e9913a6593$var$Zc(a, b, c, d, f);
                return;
            case $253292e9913a6593$var$Yb:
                f = d.children;
                c = c._context;
                d = d.value;
                e = c._currentValue;
                c._currentValue = d;
                g = $253292e9913a6593$var$O;
                $253292e9913a6593$var$O = d = {
                    parent: g,
                    depth: null === g ? 0 : g.depth + 1,
                    context: c,
                    parentValue: e,
                    value: d
                };
                b.context = d;
                $253292e9913a6593$var$Z(a, b, f);
                a = $253292e9913a6593$var$O;
                if (null === a) throw Error($253292e9913a6593$var$k(403));
                d = a.parentValue;
                a.context._currentValue = d === $253292e9913a6593$var$hc ? a.context._defaultValue : d;
                a = $253292e9913a6593$var$O = a.parent;
                b.context = a;
                return;
            case $253292e9913a6593$var$Zb:
                d = d.children;
                d = d(c._currentValue);
                $253292e9913a6593$var$Z(a, b, d);
                return;
            case $253292e9913a6593$var$dc:
                f = c._init;
                c = f(c._payload);
                d = $253292e9913a6593$var$Yc(c, d);
                $253292e9913a6593$var$Zc(a, b, c, d, void 0);
                return;
        }
        throw Error($253292e9913a6593$var$k(130, null == c ? c : typeof c, ""));
    }
}
function $253292e9913a6593$var$Z(a, b, c) {
    b.node = c;
    if ("object" === typeof c && null !== c) {
        switch(c.$$typeof){
            case $253292e9913a6593$var$Tb:
                $253292e9913a6593$var$Zc(a, b, c.type, c.props, c.ref);
                return;
            case $253292e9913a6593$var$Ub:
                throw Error($253292e9913a6593$var$k(257));
            case $253292e9913a6593$var$dc:
                var d = c._init;
                c = d(c._payload);
                $253292e9913a6593$var$Z(a, b, c);
                return;
        }
        if ($253292e9913a6593$var$ra(c)) {
            $253292e9913a6593$var$bd(a, b, c);
            return;
        }
        null === c || "object" !== typeof c ? d = null : (d = $253292e9913a6593$var$ic && c[$253292e9913a6593$var$ic] || c["@@iterator"], d = "function" === typeof d ? d : null);
        if (d && (d = d.call(c))) {
            c = d.next();
            if (!c.done) {
                var f = [];
                do f.push(c.value), c = d.next();
                while (!c.done);
                $253292e9913a6593$var$bd(a, b, f);
            }
            return;
        }
        a = Object.prototype.toString.call(c);
        throw Error($253292e9913a6593$var$k(31, "[object Object]" === a ? "object with keys {" + Object.keys(c).join(", ") + "}" : a));
    }
    "string" === typeof c ? (d = b.blockedSegment, d.lastPushedText = $253292e9913a6593$var$Da(b.blockedSegment.chunks, c, a.responseState, d.lastPushedText)) : "number" === typeof c && (d = b.blockedSegment, d.lastPushedText = $253292e9913a6593$var$Da(b.blockedSegment.chunks, "" + c, a.responseState, d.lastPushedText));
}
function $253292e9913a6593$var$bd(a, b, c) {
    for(var d = c.length, f = 0; f < d; f++){
        var e = b.treeContext;
        b.treeContext = $253292e9913a6593$var$tc(e, d, f);
        try {
            $253292e9913a6593$var$$c(a, b, c[f]);
        } finally{
            b.treeContext = e;
        }
    }
}
function $253292e9913a6593$var$$c(a, b, c) {
    var d = b.blockedSegment.formatContext, f = b.legacyContext, e = b.context;
    try {
        return $253292e9913a6593$var$Z(a, b, c);
    } catch (m) {
        if ($253292e9913a6593$var$Gc(), "object" === typeof m && null !== m && "function" === typeof m.then) {
            c = m;
            var g = b.blockedSegment, h = $253292e9913a6593$var$Sc(a, g.chunks.length, null, g.formatContext, g.lastPushedText, !0);
            g.children.push(h);
            g.lastPushedText = !1;
            a = $253292e9913a6593$var$Tc(a, b.node, b.blockedBoundary, h, b.abortSet, b.legacyContext, b.context, b.treeContext).ping;
            c.then(a, a);
            b.blockedSegment.formatContext = d;
            b.legacyContext = f;
            b.context = e;
            $253292e9913a6593$var$Q(e);
        } else throw b.blockedSegment.formatContext = d, b.legacyContext = f, b.context = e, $253292e9913a6593$var$Q(e), m;
    }
}
function $253292e9913a6593$var$cd(a) {
    var b = a.blockedBoundary;
    a = a.blockedSegment;
    a.status = 3;
    $253292e9913a6593$var$dd(this, b, a);
}
function $253292e9913a6593$var$ed(a, b, c) {
    var d = a.blockedBoundary;
    a.blockedSegment.status = 3;
    null === d ? (b.allPendingTasks--, 2 !== b.status && (b.status = 2, null !== b.destination && b.destination.close())) : (d.pendingTasks--, d.forceClientRender || (d.forceClientRender = !0, a = void 0 === c ? Error($253292e9913a6593$var$k(432)) : c, d.errorDigest = b.onError(a), d.parentFlushed && b.clientRenderedBoundaries.push(d)), d.fallbackAbortableTasks.forEach(function(a) {
        return $253292e9913a6593$var$ed(a, b, c);
    }), d.fallbackAbortableTasks.clear(), b.allPendingTasks--, 0 === b.allPendingTasks && (d = b.onAllReady, d()));
}
function $253292e9913a6593$var$ad(a, b) {
    if (0 === b.chunks.length && 1 === b.children.length && null === b.children[0].boundary) {
        var c = b.children[0];
        c.id = b.id;
        c.parentFlushed = !0;
        1 === c.status && $253292e9913a6593$var$ad(a, c);
    } else a.completedSegments.push(b);
}
function $253292e9913a6593$var$dd(a, b, c) {
    if (null === b) {
        if (c.parentFlushed) {
            if (null !== a.completedRootSegment) throw Error($253292e9913a6593$var$k(389));
            a.completedRootSegment = c;
        }
        a.pendingRootTasks--;
        0 === a.pendingRootTasks && (a.onShellError = $253292e9913a6593$var$X, b = a.onShellReady, b());
    } else b.pendingTasks--, b.forceClientRender || (0 === b.pendingTasks ? (c.parentFlushed && 1 === c.status && $253292e9913a6593$var$ad(b, c), b.parentFlushed && a.completedBoundaries.push(b), b.fallbackAbortableTasks.forEach($253292e9913a6593$var$cd, a), b.fallbackAbortableTasks.clear()) : c.parentFlushed && 1 === c.status && ($253292e9913a6593$var$ad(b, c), 1 === b.completedSegments.length && b.parentFlushed && a.partialBoundaries.push(b)));
    a.allPendingTasks--;
    0 === a.allPendingTasks && (a = a.onAllReady, a());
}
function $253292e9913a6593$var$Uc(a) {
    if (2 !== a.status) {
        var b = $253292e9913a6593$var$O, c = $253292e9913a6593$var$Pc.current;
        $253292e9913a6593$var$Pc.current = $253292e9913a6593$var$Oc;
        var d = $253292e9913a6593$var$Nc;
        $253292e9913a6593$var$Nc = a.responseState;
        try {
            var f = a.pingedTasks, e;
            for(e = 0; e < f.length; e++){
                var g = f[e];
                var h = a, m = g.blockedSegment;
                if (0 === m.status) {
                    $253292e9913a6593$var$Q(g.context);
                    try {
                        $253292e9913a6593$var$Z(h, g, g.node), m.lastPushedText && m.textEmbedded && m.chunks.push($253292e9913a6593$var$Ca), g.abortSet.delete(g), m.status = 1, $253292e9913a6593$var$dd(h, g.blockedBoundary, m);
                    } catch (G) {
                        if ($253292e9913a6593$var$Gc(), "object" === typeof G && null !== G && "function" === typeof G.then) {
                            var q = g.ping;
                            G.then(q, q);
                        } else {
                            g.abortSet.delete(g);
                            m.status = 4;
                            var r = g.blockedBoundary, v = G, A = $253292e9913a6593$var$Y(h, v);
                            null === r ? $253292e9913a6593$var$Vc(h, v) : (r.pendingTasks--, r.forceClientRender || (r.forceClientRender = !0, r.errorDigest = A, r.parentFlushed && h.clientRenderedBoundaries.push(r)));
                            h.allPendingTasks--;
                            if (0 === h.allPendingTasks) {
                                var F = h.onAllReady;
                                F();
                            }
                        }
                    } finally{}
                }
            }
            f.splice(0, e);
            null !== a.destination && $253292e9913a6593$var$fd(a, a.destination);
        } catch (G) {
            $253292e9913a6593$var$Y(a, G), $253292e9913a6593$var$Vc(a, G);
        } finally{
            $253292e9913a6593$var$Nc = d, $253292e9913a6593$var$Pc.current = c, c === $253292e9913a6593$var$Oc && $253292e9913a6593$var$Q(b);
        }
    }
}
function $253292e9913a6593$var$gd(a, b, c) {
    c.parentFlushed = !0;
    switch(c.status){
        case 0:
            var d = c.id = a.nextSegmentId++;
            c.lastPushedText = !1;
            c.textEmbedded = !1;
            a = a.responseState;
            $253292e9913a6593$var$p(b, $253292e9913a6593$var$Va);
            $253292e9913a6593$var$p(b, a.placeholderPrefix);
            a = $253292e9913a6593$var$u(d.toString(16));
            $253292e9913a6593$var$p(b, a);
            return $253292e9913a6593$var$t(b, $253292e9913a6593$var$Wa);
        case 1:
            c.status = 2;
            var f = !0;
            d = c.chunks;
            var e = 0;
            c = c.children;
            for(var g = 0; g < c.length; g++){
                for(f = c[g]; e < f.index; e++)$253292e9913a6593$var$p(b, d[e]);
                f = $253292e9913a6593$var$hd(a, b, f);
            }
            for(; e < d.length - 1; e++)$253292e9913a6593$var$p(b, d[e]);
            e < d.length && (f = $253292e9913a6593$var$t(b, d[e]));
            return f;
        default:
            throw Error($253292e9913a6593$var$k(390));
    }
}
function $253292e9913a6593$var$hd(a, b, c) {
    var d = c.boundary;
    if (null === d) return $253292e9913a6593$var$gd(a, b, c);
    d.parentFlushed = !0;
    if (d.forceClientRender) d = d.errorDigest, $253292e9913a6593$var$t(b, $253292e9913a6593$var$$a), $253292e9913a6593$var$p(b, $253292e9913a6593$var$bb), d && ($253292e9913a6593$var$p(b, $253292e9913a6593$var$db), $253292e9913a6593$var$p(b, $253292e9913a6593$var$u($253292e9913a6593$var$C(d))), $253292e9913a6593$var$p(b, $253292e9913a6593$var$cb)), $253292e9913a6593$var$t(b, $253292e9913a6593$var$eb), $253292e9913a6593$var$gd(a, b, c);
    else if (0 < d.pendingTasks) {
        d.rootSegmentID = a.nextSegmentId++;
        0 < d.completedSegments.length && a.partialBoundaries.push(d);
        var f = a.responseState;
        var e = f.nextSuspenseID++;
        f = $253292e9913a6593$var$w(f.boundaryPrefix + e.toString(16));
        d = d.id = f;
        $253292e9913a6593$var$fb(b, a.responseState, d);
        $253292e9913a6593$var$gd(a, b, c);
    } else if (d.byteSize > a.progressiveChunkSize) d.rootSegmentID = a.nextSegmentId++, a.completedBoundaries.push(d), $253292e9913a6593$var$fb(b, a.responseState, d.id), $253292e9913a6593$var$gd(a, b, c);
    else {
        $253292e9913a6593$var$t(b, $253292e9913a6593$var$Xa);
        c = d.completedSegments;
        if (1 !== c.length) throw Error($253292e9913a6593$var$k(391));
        $253292e9913a6593$var$hd(a, b, c[0]);
    }
    return $253292e9913a6593$var$t(b, $253292e9913a6593$var$ab);
}
function $253292e9913a6593$var$id(a, b, c) {
    $253292e9913a6593$var$Bb(b, a.responseState, c.formatContext, c.id);
    $253292e9913a6593$var$hd(a, b, c);
    return $253292e9913a6593$var$Cb(b, c.formatContext);
}
function $253292e9913a6593$var$jd(a, b, c) {
    for(var d = c.completedSegments, f = 0; f < d.length; f++)$253292e9913a6593$var$kd(a, b, c, d[f]);
    d.length = 0;
    a = a.responseState;
    d = c.id;
    c = c.rootSegmentID;
    $253292e9913a6593$var$p(b, a.startInlineScript);
    a.sentCompleteBoundaryFunction ? $253292e9913a6593$var$p(b, $253292e9913a6593$var$Jb) : (a.sentCompleteBoundaryFunction = !0, $253292e9913a6593$var$p(b, $253292e9913a6593$var$Ib));
    if (null === d) throw Error($253292e9913a6593$var$k(395));
    c = $253292e9913a6593$var$u(c.toString(16));
    $253292e9913a6593$var$p(b, d);
    $253292e9913a6593$var$p(b, $253292e9913a6593$var$Kb);
    $253292e9913a6593$var$p(b, a.segmentPrefix);
    $253292e9913a6593$var$p(b, c);
    return $253292e9913a6593$var$t(b, $253292e9913a6593$var$Lb);
}
function $253292e9913a6593$var$kd(a, b, c, d) {
    if (2 === d.status) return !0;
    var f = d.id;
    if (-1 === f) {
        if (-1 === (d.id = c.rootSegmentID)) throw Error($253292e9913a6593$var$k(392));
        return $253292e9913a6593$var$id(a, b, d);
    }
    $253292e9913a6593$var$id(a, b, d);
    a = a.responseState;
    $253292e9913a6593$var$p(b, a.startInlineScript);
    a.sentCompleteSegmentFunction ? $253292e9913a6593$var$p(b, $253292e9913a6593$var$Eb) : (a.sentCompleteSegmentFunction = !0, $253292e9913a6593$var$p(b, $253292e9913a6593$var$Db));
    $253292e9913a6593$var$p(b, a.segmentPrefix);
    f = $253292e9913a6593$var$u(f.toString(16));
    $253292e9913a6593$var$p(b, f);
    $253292e9913a6593$var$p(b, $253292e9913a6593$var$Gb);
    $253292e9913a6593$var$p(b, a.placeholderPrefix);
    $253292e9913a6593$var$p(b, f);
    return $253292e9913a6593$var$t(b, $253292e9913a6593$var$Hb);
}
function $253292e9913a6593$var$fd(a, b) {
    $253292e9913a6593$var$l = new Uint8Array(512);
    $253292e9913a6593$var$n = 0;
    try {
        var c = a.completedRootSegment;
        if (null !== c && 0 === a.pendingRootTasks) {
            $253292e9913a6593$var$hd(a, b, c);
            a.completedRootSegment = null;
            var d = a.responseState.bootstrapChunks;
            for(c = 0; c < d.length - 1; c++)$253292e9913a6593$var$p(b, d[c]);
            c < d.length && $253292e9913a6593$var$t(b, d[c]);
        }
        var f = a.clientRenderedBoundaries, e;
        for(e = 0; e < f.length; e++){
            var g = f[e];
            d = b;
            var h = a.responseState, m = g.id, q = g.errorDigest, r = g.errorMessage, v = g.errorComponentStack;
            $253292e9913a6593$var$p(d, h.startInlineScript);
            h.sentClientRenderFunction ? $253292e9913a6593$var$p(d, $253292e9913a6593$var$Nb) : (h.sentClientRenderFunction = !0, $253292e9913a6593$var$p(d, $253292e9913a6593$var$Mb));
            if (null === m) throw Error($253292e9913a6593$var$k(395));
            $253292e9913a6593$var$p(d, m);
            $253292e9913a6593$var$p(d, $253292e9913a6593$var$Ob);
            if (q || r || v) $253292e9913a6593$var$p(d, $253292e9913a6593$var$Qb), $253292e9913a6593$var$p(d, $253292e9913a6593$var$u($253292e9913a6593$var$Sb(q || "")));
            if (r || v) $253292e9913a6593$var$p(d, $253292e9913a6593$var$Qb), $253292e9913a6593$var$p(d, $253292e9913a6593$var$u($253292e9913a6593$var$Sb(r || "")));
            v && ($253292e9913a6593$var$p(d, $253292e9913a6593$var$Qb), $253292e9913a6593$var$p(d, $253292e9913a6593$var$u($253292e9913a6593$var$Sb(v))));
            if (!$253292e9913a6593$var$t(d, $253292e9913a6593$var$Pb)) {
                a.destination = null;
                e++;
                f.splice(0, e);
                return;
            }
        }
        f.splice(0, e);
        var A = a.completedBoundaries;
        for(e = 0; e < A.length; e++)if (!$253292e9913a6593$var$jd(a, b, A[e])) {
            a.destination = null;
            e++;
            A.splice(0, e);
            return;
        }
        A.splice(0, e);
        $253292e9913a6593$var$ba(b);
        $253292e9913a6593$var$l = new Uint8Array(512);
        $253292e9913a6593$var$n = 0;
        var F = a.partialBoundaries;
        for(e = 0; e < F.length; e++){
            var G = F[e];
            a: {
                f = a;
                g = b;
                var ma = G.completedSegments;
                for(h = 0; h < ma.length; h++)if (!$253292e9913a6593$var$kd(f, g, G, ma[h])) {
                    h++;
                    ma.splice(0, h);
                    var Fb = !1;
                    break a;
                }
                ma.splice(0, h);
                Fb = !0;
            }
            if (!Fb) {
                a.destination = null;
                e++;
                F.splice(0, e);
                return;
            }
        }
        F.splice(0, e);
        var na = a.completedBoundaries;
        for(e = 0; e < na.length; e++)if (!$253292e9913a6593$var$jd(a, b, na[e])) {
            a.destination = null;
            e++;
            na.splice(0, e);
            return;
        }
        na.splice(0, e);
    } finally{
        $253292e9913a6593$var$ba(b), 0 === a.allPendingTasks && 0 === a.pingedTasks.length && 0 === a.clientRenderedBoundaries.length && 0 === a.completedBoundaries.length && b.close();
    }
}
function $253292e9913a6593$var$ld(a, b) {
    try {
        var c = a.abortableTasks;
        c.forEach(function(c) {
            return $253292e9913a6593$var$ed(c, a, b);
        });
        c.clear();
        null !== a.destination && $253292e9913a6593$var$fd(a, a.destination);
    } catch (d) {
        $253292e9913a6593$var$Y(a, d), $253292e9913a6593$var$Vc(a, d);
    }
}
$253292e9913a6593$export$7020a3240b287705 = function(a, b) {
    return new Promise(function(c, d) {
        var f, e, g = new Promise(function(a, b) {
            e = a;
            f = b;
        }), h = $253292e9913a6593$var$Rc(a, $253292e9913a6593$var$za(b ? b.identifierPrefix : void 0, b ? b.nonce : void 0, b ? b.bootstrapScriptContent : void 0, b ? b.bootstrapScripts : void 0, b ? b.bootstrapModules : void 0), $253292e9913a6593$var$Aa(b ? b.namespaceURI : void 0), b ? b.progressiveChunkSize : void 0, b ? b.onError : void 0, e, function() {
            var a = new ReadableStream({
                type: "bytes",
                pull: function(a) {
                    if (1 === h.status) h.status = 2, $253292e9913a6593$var$da(a, h.fatalError);
                    else if (2 !== h.status && null === h.destination) {
                        h.destination = a;
                        try {
                            $253292e9913a6593$var$fd(h, a);
                        } catch (A) {
                            $253292e9913a6593$var$Y(h, A), $253292e9913a6593$var$Vc(h, A);
                        }
                    }
                },
                cancel: function() {
                    $253292e9913a6593$var$ld(h);
                }
            }, {
                highWaterMark: 0
            });
            a.allReady = g;
            c(a);
        }, function(a) {
            g.catch(function() {});
            d(a);
        }, f);
        if (b && b.signal) {
            var m = b.signal, q = function() {
                $253292e9913a6593$var$ld(h, m.reason);
                m.removeEventListener("abort", q);
            };
            m.addEventListener("abort", q);
        }
        $253292e9913a6593$var$Uc(h);
    });
};
$253292e9913a6593$export$83d89fbfd8236492 = "18.2.0";

});

parcelRequire.register("hWFK5", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $ed73f0f7fed221b0$export$2e2bcd8739ae039; });

var $dUvTh = parcelRequire("dUvTh");
var $ed73f0f7fed221b0$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($dUvTh))).default || (0, (/*@__PURE__*/$parcel$interopDefault($dUvTh)));

});
parcelRequire.register("dUvTh", function(module, exports) {
"use strict";
var $a2093e264106255c$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a2093e264106255c$var$HTMLDOMParser;

var $a2093e264106255c$var$domparser_1 = $a2093e264106255c$var$__importDefault((parcelRequire("66hct")));

var $53fKz = parcelRequire("53fKz");
var $a2093e264106255c$var$DIRECTIVE_REGEX = /<(![a-zA-Z\s]+)>/; // e.g., <!doctype html>
/**
 * Parses HTML string to DOM nodes in browser.
 *
 * @param html - HTML markup.
 * @returns - DOM elements.
 */ function $a2093e264106255c$var$HTMLDOMParser(html) {
    if (typeof html !== "string") throw new TypeError("First argument must be a string");
    if (!html) return [];
    // match directive
    var match = html.match($a2093e264106255c$var$DIRECTIVE_REGEX);
    var directive = match ? match[1] : undefined;
    return (0, $53fKz.formatDOM)((0, $a2093e264106255c$var$domparser_1.default)(html), null, directive);
}

});
parcelRequire.register("66hct", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4710a53297fe91da$var$domparser;

var $53fKz = parcelRequire("53fKz");
// constants
var $4710a53297fe91da$var$HTML = "html";
var $4710a53297fe91da$var$HEAD = "head";
var $4710a53297fe91da$var$BODY = "body";
var $4710a53297fe91da$var$FIRST_TAG_REGEX = /<([a-zA-Z]+[0-9]?)/; // e.g., <h1>
// match-all-characters in case of newlines (DOTALL)
var $4710a53297fe91da$var$HEAD_TAG_REGEX = /<head[^]*>/i;
var $4710a53297fe91da$var$BODY_TAG_REGEX = /<body[^]*>/i;
// falls back to `parseFromString` if `createHTMLDocument` cannot be used
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var $4710a53297fe91da$var$parseFromDocument = function(html, tagName) {
    /* istanbul ignore next */ throw new Error("This browser does not support `document.implementation.createHTMLDocument`");
};
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var $4710a53297fe91da$var$parseFromString = function(html, tagName) {
    /* istanbul ignore next */ throw new Error("This browser does not support `DOMParser.prototype.parseFromString`");
};
var $4710a53297fe91da$var$DOMParser = typeof window === "object" && window.DOMParser;
/**
 * DOMParser (performance: slow).
 *
 * @see https://developer.mozilla.org/docs/Web/API/DOMParser#Parsing_an_SVG_or_HTML_document
 */ if (typeof $4710a53297fe91da$var$DOMParser === "function") {
    var $4710a53297fe91da$var$domParser_1 = new $4710a53297fe91da$var$DOMParser();
    var $4710a53297fe91da$var$mimeType_1 = "text/html";
    /**
     * Creates an HTML document using `DOMParser.parseFromString`.
     *
     * @param html - The HTML string.
     * @param tagName - The element to render the HTML (with 'body' as fallback).
     * @returns - Document.
     */ $4710a53297fe91da$var$parseFromString = function(html, tagName) {
        if (tagName) /* istanbul ignore next */ html = "<".concat(tagName, ">").concat(html, "</").concat(tagName, ">");
        return $4710a53297fe91da$var$domParser_1.parseFromString(html, $4710a53297fe91da$var$mimeType_1);
    };
    $4710a53297fe91da$var$parseFromDocument = $4710a53297fe91da$var$parseFromString;
}
/**
 * DOMImplementation (performance: fair).
 *
 * @see https://developer.mozilla.org/docs/Web/API/DOMImplementation/createHTMLDocument
 */ if (typeof document === "object" && document.implementation) {
    var $4710a53297fe91da$var$htmlDocument_1 = document.implementation.createHTMLDocument();
    /**
     * Use HTML document created by `document.implementation.createHTMLDocument`.
     *
     * @param html - The HTML string.
     * @param tagName - The element to render the HTML (with 'body' as fallback).
     * @returns - Document
     */ $4710a53297fe91da$var$parseFromDocument = function(html, tagName) {
        if (tagName) {
            var element = $4710a53297fe91da$var$htmlDocument_1.documentElement.querySelector(tagName);
            if (element) element.innerHTML = html;
            return $4710a53297fe91da$var$htmlDocument_1;
        }
        $4710a53297fe91da$var$htmlDocument_1.documentElement.innerHTML = html;
        return $4710a53297fe91da$var$htmlDocument_1;
    };
}
/**
 * Template (performance: fast).
 *
 * @see https://developer.mozilla.org/docs/Web/HTML/Element/template
 */ var $4710a53297fe91da$var$template = typeof document === "object" && document.createElement("template");
var $4710a53297fe91da$var$parseFromTemplate;
if ($4710a53297fe91da$var$template && $4710a53297fe91da$var$template.content) /**
     * Uses a template element (content fragment) to parse HTML.
     *
     * @param html - HTML string.
     * @returns - Nodes.
     */ $4710a53297fe91da$var$parseFromTemplate = function(html) {
    $4710a53297fe91da$var$template.innerHTML = html;
    return $4710a53297fe91da$var$template.content.childNodes;
};
/**
 * Parses HTML string to DOM nodes.
 *
 * @param html - HTML markup.
 * @returns - DOM nodes.
 */ function $4710a53297fe91da$var$domparser(html) {
    var _a, _b;
    // Escape special characters before parsing
    html = (0, $53fKz.escapeSpecialCharacters)(html);
    var match = html.match($4710a53297fe91da$var$FIRST_TAG_REGEX);
    var firstTagName = match && match[1] ? match[1].toLowerCase() : "";
    switch(firstTagName){
        case $4710a53297fe91da$var$HTML:
            var doc = $4710a53297fe91da$var$parseFromString(html);
            // the created document may come with filler head/body elements,
            // so make sure to remove them if they don't actually exist
            if (!$4710a53297fe91da$var$HEAD_TAG_REGEX.test(html)) {
                var element = doc.querySelector($4710a53297fe91da$var$HEAD);
                (_a = element === null || element === void 0 ? void 0 : element.parentNode) === null || _a === void 0 || _a.removeChild(element);
            }
            if (!$4710a53297fe91da$var$BODY_TAG_REGEX.test(html)) {
                var element = doc.querySelector($4710a53297fe91da$var$BODY);
                (_b = element === null || element === void 0 ? void 0 : element.parentNode) === null || _b === void 0 || _b.removeChild(element);
            }
            return doc.querySelectorAll($4710a53297fe91da$var$HTML);
        case $4710a53297fe91da$var$HEAD:
        case $4710a53297fe91da$var$BODY:
            var elements = $4710a53297fe91da$var$parseFromDocument(html).querySelectorAll(firstTagName);
            // if there's a sibling element, then return both elements
            if ($4710a53297fe91da$var$BODY_TAG_REGEX.test(html) && $4710a53297fe91da$var$HEAD_TAG_REGEX.test(html)) return elements[0].parentNode.childNodes;
            return elements;
        // low-level tag or text
        default:
            if ($4710a53297fe91da$var$parseFromTemplate) return $4710a53297fe91da$var$parseFromTemplate(html);
            var element = $4710a53297fe91da$var$parseFromDocument(html, $4710a53297fe91da$var$BODY).querySelector($4710a53297fe91da$var$BODY);
            return element.childNodes;
    }
}

});
parcelRequire.register("53fKz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.formatAttributes = $3ad973354ea9f5cd$var$formatAttributes;
module.exports.escapeSpecialCharacters = $3ad973354ea9f5cd$var$escapeSpecialCharacters;
module.exports.revertEscapedCharacters = $3ad973354ea9f5cd$var$revertEscapedCharacters;
module.exports.formatDOM = $3ad973354ea9f5cd$var$formatDOM;
parcelRequire("1yd5Y");
var $afy9O = parcelRequire("afy9O");

var $gj4vP = parcelRequire("gj4vP");
/**
 * Gets case-sensitive tag name.
 *
 * @param tagName - Tag name in lowercase.
 * @returns - Case-sensitive tag name.
 */ function $3ad973354ea9f5cd$var$getCaseSensitiveTagName(tagName) {
    return $gj4vP.CASE_SENSITIVE_TAG_NAMES_MAP[tagName];
}
/**
 * Formats DOM attributes to a hash map.
 *
 * @param attributes - List of attributes.
 * @returns - Map of attribute name to value.
 */ function $3ad973354ea9f5cd$var$formatAttributes(attributes) {
    var map = {};
    var index = 0;
    var attributesLength = attributes.length;
    // `NamedNodeMap` is array-like
    for(; index < attributesLength; index++){
        var attribute = attributes[index];
        map[attribute.name] = attribute.value;
    }
    return map;
}
/**
 * Corrects the tag name if it is case-sensitive (SVG).
 * Otherwise, returns the lowercase tag name (HTML).
 *
 * @param tagName - Lowercase tag name.
 * @returns - Formatted tag name.
 */ function $3ad973354ea9f5cd$var$formatTagName(tagName) {
    tagName = tagName.toLowerCase();
    var caseSensitiveTagName = $3ad973354ea9f5cd$var$getCaseSensitiveTagName(tagName);
    if (caseSensitiveTagName) return caseSensitiveTagName;
    return tagName;
}
/**
 * Escapes special characters before parsing.
 *
 * @param html - The HTML string.
 * @returns - HTML string with escaped special characters.
 */ function $3ad973354ea9f5cd$var$escapeSpecialCharacters(html) {
    return html.replace($gj4vP.CARRIAGE_RETURN_REGEX, $gj4vP.CARRIAGE_RETURN_PLACEHOLDER);
}
/**
 * Reverts escaped special characters back to actual characters.
 *
 * @param text - The text with escaped characters.
 * @returns - Text with escaped characters reverted.
 */ function $3ad973354ea9f5cd$var$revertEscapedCharacters(text) {
    return text.replace($gj4vP.CARRIAGE_RETURN_PLACEHOLDER_REGEX, $gj4vP.CARRIAGE_RETURN);
}
/**
 * Transforms DOM nodes to `domhandler` nodes.
 *
 * @param nodes - DOM nodes.
 * @param parent - Parent node.
 * @param directive - Directive.
 * @returns - Nodes.
 */ function $3ad973354ea9f5cd$var$formatDOM(nodes, parent, directive) {
    if (parent === void 0) parent = null;
    var domNodes = [];
    var current;
    var index = 0;
    var nodesLength = nodes.length;
    for(; index < nodesLength; index++){
        var node = nodes[index];
        // set the node data given the type
        switch(node.nodeType){
            case 1:
                var tagName = $3ad973354ea9f5cd$var$formatTagName(node.nodeName);
                // script, style, or tag
                current = new $afy9O.Element(tagName, $3ad973354ea9f5cd$var$formatAttributes(node.attributes));
                current.children = $3ad973354ea9f5cd$var$formatDOM(// template children are on content
                tagName === "template" ? node.content.childNodes : node.childNodes, current);
                break;
            case 3:
                current = new $afy9O.Text($3ad973354ea9f5cd$var$revertEscapedCharacters(node.nodeValue));
                break;
            case 8:
                current = new $afy9O.Comment(node.nodeValue);
                break;
            default:
                continue;
        }
        // set previous node next
        var prev = domNodes[index - 1] || null;
        if (prev) prev.next = current;
        // set properties for current node
        current.parent = parent;
        current.prev = prev;
        current.next = null;
        domNodes.push(current);
    }
    if (directive) {
        current = new $afy9O.ProcessingInstruction(directive.substring(0, directive.indexOf(" ")).toLowerCase(), directive);
        current.next = domNodes[0] || null;
        current.parent = parent;
        domNodes.unshift(current);
        if (domNodes[1]) domNodes[1].prev = domNodes[0];
    }
    return domNodes;
}

});
parcelRequire.register("1yd5Y", function(module, exports) {
$parcel$export(module.exports, "CDATA", function () { return (parcelRequire("afy9O")).CDATA; });
$parcel$export(module.exports, "Comment", function () { return (parcelRequire("afy9O")).Comment; });
$parcel$export(module.exports, "Document", function () { return (parcelRequire("afy9O")).Document; });
$parcel$export(module.exports, "Element", function () { return (parcelRequire("afy9O")).Element; });
$parcel$export(module.exports, "ProcessingInstruction", function () { return (parcelRequire("afy9O")).ProcessingInstruction; });
$parcel$export(module.exports, "Text", function () { return (parcelRequire("afy9O")).Text; });

var $iI7GW = parcelRequire("iI7GW");

var $afy9O = parcelRequire("afy9O");
// Default options
const $12131fe7bb802835$var$defaultOpts = {
    withStartIndices: false,
    withEndIndices: false,
    xmlMode: false
};
class $12131fe7bb802835$export$ff8ccbac9225de62 {
    /**
     * @param callback Called once parsing has completed.
     * @param options Settings for the handler.
     * @param elementCB Callback whenever a tag is closed.
     */ constructor(callback, options, elementCB){
        /** The elements of the DOM */ this.dom = [];
        /** The root element for the DOM */ this.root = new (0, $afy9O.Document)(this.dom);
        /** Indicated whether parsing has been completed. */ this.done = false;
        /** Stack of open tags. */ this.tagStack = [
            this.root
        ];
        /** A data node that is still being written to. */ this.lastNode = null;
        /** Reference to the parser instance. Used for location information. */ this.parser = null;
        // Make it possible to skip arguments, for backwards-compatibility
        if (typeof options === "function") {
            elementCB = options;
            options = $12131fe7bb802835$var$defaultOpts;
        }
        if (typeof callback === "object") {
            options = callback;
            callback = undefined;
        }
        this.callback = callback !== null && callback !== void 0 ? callback : null;
        this.options = options !== null && options !== void 0 ? options : $12131fe7bb802835$var$defaultOpts;
        this.elementCB = elementCB !== null && elementCB !== void 0 ? elementCB : null;
    }
    onparserinit(parser) {
        this.parser = parser;
    }
    // Resets the handler back to starting state
    onreset() {
        this.dom = [];
        this.root = new (0, $afy9O.Document)(this.dom);
        this.done = false;
        this.tagStack = [
            this.root
        ];
        this.lastNode = null;
        this.parser = null;
    }
    // Signals the handler that parsing is done
    onend() {
        if (this.done) return;
        this.done = true;
        this.parser = null;
        this.handleCallback(null);
    }
    onerror(error) {
        this.handleCallback(error);
    }
    onclosetag() {
        this.lastNode = null;
        const elem = this.tagStack.pop();
        if (this.options.withEndIndices) elem.endIndex = this.parser.endIndex;
        if (this.elementCB) this.elementCB(elem);
    }
    onopentag(name, attribs) {
        const type = this.options.xmlMode ? (0, $iI7GW.ElementType).Tag : undefined;
        const element = new (0, $afy9O.Element)(name, attribs, undefined, type);
        this.addNode(element);
        this.tagStack.push(element);
    }
    ontext(data) {
        const { lastNode: lastNode } = this;
        if (lastNode && lastNode.type === (0, $iI7GW.ElementType).Text) {
            lastNode.data += data;
            if (this.options.withEndIndices) lastNode.endIndex = this.parser.endIndex;
        } else {
            const node = new (0, $afy9O.Text)(data);
            this.addNode(node);
            this.lastNode = node;
        }
    }
    oncomment(data) {
        if (this.lastNode && this.lastNode.type === (0, $iI7GW.ElementType).Comment) {
            this.lastNode.data += data;
            return;
        }
        const node = new (0, $afy9O.Comment)(data);
        this.addNode(node);
        this.lastNode = node;
    }
    oncommentend() {
        this.lastNode = null;
    }
    oncdatastart() {
        const text = new (0, $afy9O.Text)("");
        const node = new (0, $afy9O.CDATA)([
            text
        ]);
        this.addNode(node);
        text.parent = node;
        this.lastNode = text;
    }
    oncdataend() {
        this.lastNode = null;
    }
    onprocessinginstruction(name, data) {
        const node = new (0, $afy9O.ProcessingInstruction)(name, data);
        this.addNode(node);
    }
    handleCallback(error) {
        if (typeof this.callback === "function") this.callback(error, this.dom);
        else if (error) throw error;
    }
    addNode(node) {
        const parent = this.tagStack[this.tagStack.length - 1];
        const previousSibling = parent.children[parent.children.length - 1];
        if (this.options.withStartIndices) node.startIndex = this.parser.startIndex;
        if (this.options.withEndIndices) node.endIndex = this.parser.endIndex;
        parent.children.push(node);
        if (previousSibling) {
            node.prev = previousSibling;
            previousSibling.next = node;
        }
        node.parent = parent;
        this.lastNode = null;
    }
}
var $12131fe7bb802835$export$2e2bcd8739ae039 = $12131fe7bb802835$export$ff8ccbac9225de62;

});
parcelRequire.register("iI7GW", function(module, exports) {

$parcel$export(module.exports, "ElementType", function () { return $d9f24d6f5a955024$export$b992dc138d950e31; });
$parcel$export(module.exports, "isTag", function () { return $d9f24d6f5a955024$export$3bf645f08efe3292; });
/** Types of elements found in htmlparser2's DOM */ var $d9f24d6f5a955024$export$b992dc138d950e31;
(function(ElementType) {
    /** Type for the root element of a document */ ElementType["Root"] = "root";
    /** Type for Text */ ElementType["Text"] = "text";
    /** Type for <? ... ?> */ ElementType["Directive"] = "directive";
    /** Type for <!-- ... --> */ ElementType["Comment"] = "comment";
    /** Type for <script> tags */ ElementType["Script"] = "script";
    /** Type for <style> tags */ ElementType["Style"] = "style";
    /** Type for Any tag */ ElementType["Tag"] = "tag";
    /** Type for <![CDATA[ ... ]]> */ ElementType["CDATA"] = "cdata";
    /** Type for <!doctype ...> */ ElementType["Doctype"] = "doctype";
})($d9f24d6f5a955024$export$b992dc138d950e31 || ($d9f24d6f5a955024$export$b992dc138d950e31 = {}));
function $d9f24d6f5a955024$export$3bf645f08efe3292(elem) {
    return elem.type === $d9f24d6f5a955024$export$b992dc138d950e31.Tag || elem.type === $d9f24d6f5a955024$export$b992dc138d950e31.Script || elem.type === $d9f24d6f5a955024$export$b992dc138d950e31.Style;
}
const $d9f24d6f5a955024$export$be92b6f5f03c0fe9 = $d9f24d6f5a955024$export$b992dc138d950e31.Root;
const $d9f24d6f5a955024$export$5f1af8db9871e1d6 = $d9f24d6f5a955024$export$b992dc138d950e31.Text;
const $d9f24d6f5a955024$export$befdefbdce210f91 = $d9f24d6f5a955024$export$b992dc138d950e31.Directive;
const $d9f24d6f5a955024$export$4d299b491347818a = $d9f24d6f5a955024$export$b992dc138d950e31.Comment;
const $d9f24d6f5a955024$export$2f8b47a141e57afc = $d9f24d6f5a955024$export$b992dc138d950e31.Script;
const $d9f24d6f5a955024$export$d9e45bc13d335801 = $d9f24d6f5a955024$export$b992dc138d950e31.Style;
const $d9f24d6f5a955024$export$3288d34c523a1192 = $d9f24d6f5a955024$export$b992dc138d950e31.Tag;
const $d9f24d6f5a955024$export$1f8b8f7e5c763232 = $d9f24d6f5a955024$export$b992dc138d950e31.CDATA;
const $d9f24d6f5a955024$export$31b44af36ff2c60f = $d9f24d6f5a955024$export$b992dc138d950e31.Doctype;

});

parcelRequire.register("afy9O", function(module, exports) {

$parcel$export(module.exports, "Text", function () { return $7765cd0a80144f7d$export$5f1af8db9871e1d6; });
$parcel$export(module.exports, "Comment", function () { return $7765cd0a80144f7d$export$4d299b491347818a; });
$parcel$export(module.exports, "ProcessingInstruction", function () { return $7765cd0a80144f7d$export$9269dce19ee35e96; });
$parcel$export(module.exports, "CDATA", function () { return $7765cd0a80144f7d$export$1f8b8f7e5c763232; });
$parcel$export(module.exports, "Document", function () { return $7765cd0a80144f7d$export$b34a105447964f9f; });
$parcel$export(module.exports, "Element", function () { return $7765cd0a80144f7d$export$db77ccec0bb4ccac; });

var $iI7GW = parcelRequire("iI7GW");
class $7765cd0a80144f7d$export$85c928794f8d04d4 {
    constructor(){
        /** Parent of the node */ this.parent = null;
        /** Previous sibling */ this.prev = null;
        /** Next sibling */ this.next = null;
        /** The start index of the node. Requires `withStartIndices` on the handler to be `true. */ this.startIndex = null;
        /** The end index of the node. Requires `withEndIndices` on the handler to be `true. */ this.endIndex = null;
    }
    // Read-write aliases for properties
    /**
     * Same as {@link parent}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get parentNode() {
        return this.parent;
    }
    set parentNode(parent) {
        this.parent = parent;
    }
    /**
     * Same as {@link prev}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get previousSibling() {
        return this.prev;
    }
    set previousSibling(prev) {
        this.prev = prev;
    }
    /**
     * Same as {@link next}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get nextSibling() {
        return this.next;
    }
    set nextSibling(next) {
        this.next = next;
    }
    /**
     * Clone this node, and optionally its children.
     *
     * @param recursive Clone child nodes as well.
     * @returns A clone of the node.
     */ cloneNode(recursive = false) {
        return $7765cd0a80144f7d$export$ae8e35ea29ddac22(this, recursive);
    }
}
class $7765cd0a80144f7d$export$c3569d91cd44d357 extends $7765cd0a80144f7d$export$85c928794f8d04d4 {
    /**
     * @param data The content of the data node
     */ constructor(data){
        super();
        this.data = data;
    }
    /**
     * Same as {@link data}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get nodeValue() {
        return this.data;
    }
    set nodeValue(data) {
        this.data = data;
    }
}
class $7765cd0a80144f7d$export$5f1af8db9871e1d6 extends $7765cd0a80144f7d$export$c3569d91cd44d357 {
    constructor(){
        super(...arguments);
        this.type = (0, $iI7GW.ElementType).Text;
    }
    get nodeType() {
        return 3;
    }
}
class $7765cd0a80144f7d$export$4d299b491347818a extends $7765cd0a80144f7d$export$c3569d91cd44d357 {
    constructor(){
        super(...arguments);
        this.type = (0, $iI7GW.ElementType).Comment;
    }
    get nodeType() {
        return 8;
    }
}
class $7765cd0a80144f7d$export$9269dce19ee35e96 extends $7765cd0a80144f7d$export$c3569d91cd44d357 {
    constructor(name, data){
        super(data);
        this.name = name;
        this.type = (0, $iI7GW.ElementType).Directive;
    }
    get nodeType() {
        return 1;
    }
}
class $7765cd0a80144f7d$export$62be934f90997196 extends $7765cd0a80144f7d$export$85c928794f8d04d4 {
    /**
     * @param children Children of the node. Only certain node types can have children.
     */ constructor(children){
        super();
        this.children = children;
    }
    // Aliases
    /** First child of the node. */ get firstChild() {
        var _a;
        return (_a = this.children[0]) !== null && _a !== void 0 ? _a : null;
    }
    /** Last child of the node. */ get lastChild() {
        return this.children.length > 0 ? this.children[this.children.length - 1] : null;
    }
    /**
     * Same as {@link children}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get childNodes() {
        return this.children;
    }
    set childNodes(children) {
        this.children = children;
    }
}
class $7765cd0a80144f7d$export$1f8b8f7e5c763232 extends $7765cd0a80144f7d$export$62be934f90997196 {
    constructor(){
        super(...arguments);
        this.type = (0, $iI7GW.ElementType).CDATA;
    }
    get nodeType() {
        return 4;
    }
}
class $7765cd0a80144f7d$export$b34a105447964f9f extends $7765cd0a80144f7d$export$62be934f90997196 {
    constructor(){
        super(...arguments);
        this.type = (0, $iI7GW.ElementType).Root;
    }
    get nodeType() {
        return 9;
    }
}
class $7765cd0a80144f7d$export$db77ccec0bb4ccac extends $7765cd0a80144f7d$export$62be934f90997196 {
    /**
     * @param name Name of the tag, eg. `div`, `span`.
     * @param attribs Object mapping attribute names to attribute values.
     * @param children Children of the node.
     */ constructor(name, attribs, children = [], type = name === "script" ? (0, $iI7GW.ElementType).Script : name === "style" ? (0, $iI7GW.ElementType).Style : (0, $iI7GW.ElementType).Tag){
        super(children);
        this.name = name;
        this.attribs = attribs;
        this.type = type;
    }
    get nodeType() {
        return 1;
    }
    // DOM Level 1 aliases
    /**
     * Same as {@link name}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get tagName() {
        return this.name;
    }
    set tagName(name) {
        this.name = name;
    }
    get attributes() {
        return Object.keys(this.attribs).map((name)=>{
            var _a, _b;
            return {
                name: name,
                value: this.attribs[name],
                namespace: (_a = this["x-attribsNamespace"]) === null || _a === void 0 ? void 0 : _a[name],
                prefix: (_b = this["x-attribsPrefix"]) === null || _b === void 0 ? void 0 : _b[name]
            };
        });
    }
}
function $7765cd0a80144f7d$export$3bf645f08efe3292(node) {
    return (0, $iI7GW.isTag)(node);
}
function $7765cd0a80144f7d$export$c2d65aed98d39b56(node) {
    return node.type === (0, $iI7GW.ElementType).CDATA;
}
function $7765cd0a80144f7d$export$1879817ac5c922b7(node) {
    return node.type === (0, $iI7GW.ElementType).Text;
}
function $7765cd0a80144f7d$export$3ab01370f5e64ac8(node) {
    return node.type === (0, $iI7GW.ElementType).Comment;
}
function $7765cd0a80144f7d$export$4b5d79f26e0e3ad5(node) {
    return node.type === (0, $iI7GW.ElementType).Directive;
}
function $7765cd0a80144f7d$export$62858bae88b53fd0(node) {
    return node.type === (0, $iI7GW.ElementType).Root;
}
function $7765cd0a80144f7d$export$bd5ff50f0e53d41c(node) {
    return Object.prototype.hasOwnProperty.call(node, "children");
}
function $7765cd0a80144f7d$export$ae8e35ea29ddac22(node, recursive = false) {
    let result;
    if ($7765cd0a80144f7d$export$1879817ac5c922b7(node)) result = new $7765cd0a80144f7d$export$5f1af8db9871e1d6(node.data);
    else if ($7765cd0a80144f7d$export$3ab01370f5e64ac8(node)) result = new $7765cd0a80144f7d$export$4d299b491347818a(node.data);
    else if ($7765cd0a80144f7d$export$3bf645f08efe3292(node)) {
        const children = recursive ? $7765cd0a80144f7d$var$cloneChildren(node.children) : [];
        const clone = new $7765cd0a80144f7d$export$db77ccec0bb4ccac(node.name, {
            ...node.attribs
        }, children);
        children.forEach((child)=>child.parent = clone);
        if (node.namespace != null) clone.namespace = node.namespace;
        if (node["x-attribsNamespace"]) clone["x-attribsNamespace"] = {
            ...node["x-attribsNamespace"]
        };
        if (node["x-attribsPrefix"]) clone["x-attribsPrefix"] = {
            ...node["x-attribsPrefix"]
        };
        result = clone;
    } else if ($7765cd0a80144f7d$export$c2d65aed98d39b56(node)) {
        const children = recursive ? $7765cd0a80144f7d$var$cloneChildren(node.children) : [];
        const clone = new $7765cd0a80144f7d$export$1f8b8f7e5c763232(children);
        children.forEach((child)=>child.parent = clone);
        result = clone;
    } else if ($7765cd0a80144f7d$export$62858bae88b53fd0(node)) {
        const children = recursive ? $7765cd0a80144f7d$var$cloneChildren(node.children) : [];
        const clone = new $7765cd0a80144f7d$export$b34a105447964f9f(children);
        children.forEach((child)=>child.parent = clone);
        if (node["x-mode"]) clone["x-mode"] = node["x-mode"];
        result = clone;
    } else if ($7765cd0a80144f7d$export$4b5d79f26e0e3ad5(node)) {
        const instruction = new $7765cd0a80144f7d$export$9269dce19ee35e96(node.name, node.data);
        if (node["x-name"] != null) {
            instruction["x-name"] = node["x-name"];
            instruction["x-publicId"] = node["x-publicId"];
            instruction["x-systemId"] = node["x-systemId"];
        }
        result = instruction;
    } else throw new Error(`Not implemented yet: ${node.type}`);
    result.startIndex = node.startIndex;
    result.endIndex = node.endIndex;
    if (node.sourceCodeLocation != null) result.sourceCodeLocation = node.sourceCodeLocation;
    return result;
}
function $7765cd0a80144f7d$var$cloneChildren(childs) {
    const children = childs.map((child)=>$7765cd0a80144f7d$export$ae8e35ea29ddac22(child, true));
    for(let i = 1; i < children.length; i++){
        children[i].prev = children[i - 1];
        children[i - 1].next = children[i];
    }
    return children;
}

});


parcelRequire.register("gj4vP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CARRIAGE_RETURN_PLACEHOLDER_REGEX = module.exports.CARRIAGE_RETURN_PLACEHOLDER = module.exports.CARRIAGE_RETURN_REGEX = module.exports.CARRIAGE_RETURN = module.exports.CASE_SENSITIVE_TAG_NAMES_MAP = module.exports.CASE_SENSITIVE_TAG_NAMES = void 0;
/**
 * SVG elements are case-sensitive.
 *
 * @see https://developer.mozilla.org/docs/Web/SVG/Element#svg_elements_a_to_z
 */ module.exports.CASE_SENSITIVE_TAG_NAMES = [
    "animateMotion",
    "animateTransform",
    "clipPath",
    "feBlend",
    "feColorMatrix",
    "feComponentTransfer",
    "feComposite",
    "feConvolveMatrix",
    "feDiffuseLighting",
    "feDisplacementMap",
    "feDropShadow",
    "feFlood",
    "feFuncA",
    "feFuncB",
    "feFuncG",
    "feFuncR",
    "feGaussianBlur",
    "feImage",
    "feMerge",
    "feMergeNode",
    "feMorphology",
    "feOffset",
    "fePointLight",
    "feSpecularLighting",
    "feSpotLight",
    "feTile",
    "feTurbulence",
    "foreignObject",
    "linearGradient",
    "radialGradient",
    "textPath"
];
module.exports.CASE_SENSITIVE_TAG_NAMES_MAP = module.exports.CASE_SENSITIVE_TAG_NAMES.reduce(function(accumulator, tagName) {
    accumulator[tagName.toLowerCase()] = tagName;
    return accumulator;
}, {});
module.exports.CARRIAGE_RETURN = "\r";
module.exports.CARRIAGE_RETURN_REGEX = new RegExp(module.exports.CARRIAGE_RETURN, "g");
module.exports.CARRIAGE_RETURN_PLACEHOLDER = "__HTML_DOM_PARSER_CARRIAGE_RETURN_PLACEHOLDER_".concat(Date.now(), "__");
module.exports.CARRIAGE_RETURN_PLACEHOLDER_REGEX = new RegExp(module.exports.CARRIAGE_RETURN_PLACEHOLDER, "g");

});





parcelRequire.register("2FPJE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1f278aa3a2158253$var$attributesToProps;

var $llNBE = parcelRequire("llNBE");

var $aWr2r = parcelRequire("aWr2r");
// https://react.dev/learn/sharing-state-between-components#controlled-and-uncontrolled-components
// https://developer.mozilla.org/docs/Web/HTML/Attributes
var $1f278aa3a2158253$var$UNCONTROLLED_COMPONENT_ATTRIBUTES = [
    "checked",
    "value"
];
var $1f278aa3a2158253$var$UNCONTROLLED_COMPONENT_NAMES = [
    "input",
    "select",
    "textarea"
];
var $1f278aa3a2158253$var$valueOnlyInputs = {
    reset: true,
    submit: true
};
/**
 * Converts HTML/SVG DOM attributes to React props.
 *
 * @param attributes - HTML/SVG DOM attributes.
 * @param nodeName - DOM node name.
 * @returns - React props.
 */ function $1f278aa3a2158253$var$attributesToProps(attributes, nodeName) {
    if (attributes === void 0) attributes = {};
    var props = {};
    var isInputValueOnly = Boolean(attributes.type && $1f278aa3a2158253$var$valueOnlyInputs[attributes.type]);
    for(var attributeName in attributes){
        var attributeValue = attributes[attributeName];
        // ARIA (aria-*) or custom data (data-*) attribute
        if ((0, $llNBE.isCustomAttribute)(attributeName)) {
            props[attributeName] = attributeValue;
            continue;
        }
        // convert HTML/SVG attribute to React prop
        var attributeNameLowerCased = attributeName.toLowerCase();
        var propName = $1f278aa3a2158253$var$getPropName(attributeNameLowerCased);
        if (propName) {
            var propertyInfo = (0, $llNBE.getPropertyInfo)(propName);
            // convert attribute to uncontrolled component prop (e.g., `value` to `defaultValue`)
            if ($1f278aa3a2158253$var$UNCONTROLLED_COMPONENT_ATTRIBUTES.includes(propName) && $1f278aa3a2158253$var$UNCONTROLLED_COMPONENT_NAMES.includes(nodeName) && !isInputValueOnly) propName = $1f278aa3a2158253$var$getPropName("default" + attributeNameLowerCased);
            props[propName] = attributeValue;
            switch(propertyInfo && propertyInfo.type){
                case $llNBE.BOOLEAN:
                    props[propName] = true;
                    break;
                case $llNBE.OVERLOADED_BOOLEAN:
                    if (attributeValue === "") props[propName] = true;
                    break;
            }
            continue;
        }
        // preserve custom attribute if React >=16
        if ($aWr2r.PRESERVE_CUSTOM_ATTRIBUTES) props[attributeName] = attributeValue;
    }
    // transform inline style to object
    (0, $aWr2r.setStyleProp)(attributes.style, props);
    return props;
}
/**
 * Gets prop name from lowercased attribute name.
 *
 * @param attributeName - Lowercased attribute name.
 * @returns - Prop name.
 */ function $1f278aa3a2158253$var$getPropName(attributeName) {
    return $llNBE.possibleStandardNames[attributeName];
}

});
parcelRequire.register("llNBE", function(module, exports) {

$parcel$export(module.exports, "BOOLEAN", function () { return $f8b209eae481e777$export$428cfe48a69a3b4f; }, function (v) { return $f8b209eae481e777$export$428cfe48a69a3b4f = v; });
$parcel$export(module.exports, "OVERLOADED_BOOLEAN", function () { return $f8b209eae481e777$export$91da4d9e9b612643; }, function (v) { return $f8b209eae481e777$export$91da4d9e9b612643 = v; });
$parcel$export(module.exports, "getPropertyInfo", function () { return $f8b209eae481e777$export$fd64a1f33de3651a; }, function (v) { return $f8b209eae481e777$export$fd64a1f33de3651a = v; });
$parcel$export(module.exports, "isCustomAttribute", function () { return $f8b209eae481e777$export$d89f61ed80c87270; }, function (v) { return $f8b209eae481e777$export$d89f61ed80c87270 = v; });
$parcel$export(module.exports, "possibleStandardNames", function () { return $f8b209eae481e777$export$bbecfff5ecf65cd8; }, function (v) { return $f8b209eae481e777$export$bbecfff5ecf65cd8 = v; });
var $f8b209eae481e777$export$428cfe48a69a3b4f;
var $f8b209eae481e777$export$d7e6493a7bfdb8c1;
var $f8b209eae481e777$export$4d318981b5a83836;
var $f8b209eae481e777$export$91da4d9e9b612643;
var $f8b209eae481e777$export$39307127151c9810;
var $f8b209eae481e777$export$75032a190741fbaf;
var $f8b209eae481e777$export$a0e01ba2ebef17f2;
var $f8b209eae481e777$export$fd64a1f33de3651a;
var $f8b209eae481e777$export$d89f61ed80c87270;
var $f8b209eae481e777$export$bbecfff5ecf65cd8;
"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ // A reserved attribute.
// It is handled by React separately and shouldn't be written to the DOM.
const $f8b209eae481e777$var$RESERVED = 0;
// A simple string attribute.
// Attributes that aren't in the filter are presumed to have this type.
const $f8b209eae481e777$var$STRING = 1;
// A string attribute that accepts booleans in React. In HTML, these are called
// "enumerated" attributes with "true" and "false" as possible values.
// When true, it should be set to a "true" string.
// When false, it should be set to a "false" string.
const $f8b209eae481e777$var$BOOLEANISH_STRING = 2;
// A real boolean attribute.
// When true, it should be present (set either to an empty string or its name).
// When false, it should be omitted.
const $f8b209eae481e777$var$BOOLEAN = 3;
// An attribute that can be used as a flag as well as with a value.
// When true, it should be present (set either to an empty string or its name).
// When false, it should be omitted.
// For any other value, should be present with that value.
const $f8b209eae481e777$var$OVERLOADED_BOOLEAN = 4;
// An attribute that must be numeric or parse as a numeric.
// When falsy, it should be removed.
const $f8b209eae481e777$var$NUMERIC = 5;
// An attribute that must be positive numeric or parse as a positive numeric.
// When falsy, it should be removed.
const $f8b209eae481e777$var$POSITIVE_NUMERIC = 6;
function $f8b209eae481e777$var$getPropertyInfo(name) {
    return $f8b209eae481e777$var$properties.hasOwnProperty(name) ? $f8b209eae481e777$var$properties[name] : null;
}
function $f8b209eae481e777$var$PropertyInfoRecord(name, type, mustUseProperty, attributeName, attributeNamespace, sanitizeURL, removeEmptyString) {
    this.acceptsBooleans = type === $f8b209eae481e777$var$BOOLEANISH_STRING || type === $f8b209eae481e777$var$BOOLEAN || type === $f8b209eae481e777$var$OVERLOADED_BOOLEAN;
    this.attributeName = attributeName;
    this.attributeNamespace = attributeNamespace;
    this.mustUseProperty = mustUseProperty;
    this.propertyName = name;
    this.type = type;
    this.sanitizeURL = sanitizeURL;
    this.removeEmptyString = removeEmptyString;
}
// When adding attributes to this list, be sure to also add them to
// the `possibleStandardNames` module to ensure casing and incorrect
// name warnings.
const $f8b209eae481e777$var$properties = {};
// These props are reserved by React. They shouldn't be written to the DOM.
const $f8b209eae481e777$var$reservedProps = [
    "children",
    "dangerouslySetInnerHTML",
    // TODO: This prevents the assignment of defaultValue to regular
    // elements (not just inputs). Now that ReactDOMInput assigns to the
    // defaultValue property -- do we need this?
    "defaultValue",
    "defaultChecked",
    "innerHTML",
    "suppressContentEditableWarning",
    "suppressHydrationWarning",
    "style"
];
$f8b209eae481e777$var$reservedProps.forEach((name)=>{
    $f8b209eae481e777$var$properties[name] = new $f8b209eae481e777$var$PropertyInfoRecord(name, $f8b209eae481e777$var$RESERVED, false, name, null, false, false);
});
// A few React string attributes have a different name.
// This is a mapping from React prop names to the attribute names.
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(([name, attributeName])=>{
    $f8b209eae481e777$var$properties[name] = new $f8b209eae481e777$var$PropertyInfoRecord(name, $f8b209eae481e777$var$STRING, false, attributeName, null, false, false);
});
// These are "enumerated" HTML attributes that accept "true" and "false".
// In React, we let users pass `true` and `false` even though technically
// these aren't boolean attributes (they are coerced to strings).
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach((name)=>{
    $f8b209eae481e777$var$properties[name] = new $f8b209eae481e777$var$PropertyInfoRecord(name, $f8b209eae481e777$var$BOOLEANISH_STRING, false, name.toLowerCase(), null, false, false);
});
// These are "enumerated" SVG attributes that accept "true" and "false".
// In React, we let users pass `true` and `false` even though technically
// these aren't boolean attributes (they are coerced to strings).
// Since these are SVG attributes, their attribute names are case-sensitive.
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach((name)=>{
    $f8b209eae481e777$var$properties[name] = new $f8b209eae481e777$var$PropertyInfoRecord(name, $f8b209eae481e777$var$BOOLEANISH_STRING, false, name, null, false, false);
});
// These are HTML boolean attributes.
[
    "allowFullScreen",
    "async",
    // Note: there is a special case that prevents it from being written to the DOM
    // on the client side because the browsers are inconsistent. Instead we call focus().
    "autoFocus",
    "autoPlay",
    "controls",
    "default",
    "defer",
    "disabled",
    "disablePictureInPicture",
    "disableRemotePlayback",
    "formNoValidate",
    "hidden",
    "loop",
    "noModule",
    "noValidate",
    "open",
    "playsInline",
    "readOnly",
    "required",
    "reversed",
    "scoped",
    "seamless",
    // Microdata
    "itemScope"
].forEach((name)=>{
    $f8b209eae481e777$var$properties[name] = new $f8b209eae481e777$var$PropertyInfoRecord(name, $f8b209eae481e777$var$BOOLEAN, false, name.toLowerCase(), null, false, false);
});
// These are the few React props that we set as DOM properties
// rather than attributes. These are all booleans.
[
    "checked",
    // Note: `option.selected` is not updated if `select.multiple` is
    // disabled with `removeAttribute`. We have special logic for handling this.
    "multiple",
    "muted",
    "selected"
].forEach((name)=>{
    $f8b209eae481e777$var$properties[name] = new $f8b209eae481e777$var$PropertyInfoRecord(name, $f8b209eae481e777$var$BOOLEAN, true, name, null, false, false);
});
// These are HTML attributes that are "overloaded booleans": they behave like
// booleans, but can also accept a string value.
[
    "capture",
    "download"
].forEach((name)=>{
    $f8b209eae481e777$var$properties[name] = new $f8b209eae481e777$var$PropertyInfoRecord(name, $f8b209eae481e777$var$OVERLOADED_BOOLEAN, false, name, null, false, false);
});
// These are HTML attributes that must be positive numbers.
[
    "cols",
    "rows",
    "size",
    "span"
].forEach((name)=>{
    $f8b209eae481e777$var$properties[name] = new $f8b209eae481e777$var$PropertyInfoRecord(name, $f8b209eae481e777$var$POSITIVE_NUMERIC, false, name, null, false, false);
});
// These are HTML attributes that must be numbers.
[
    "rowSpan",
    "start"
].forEach((name)=>{
    $f8b209eae481e777$var$properties[name] = new $f8b209eae481e777$var$PropertyInfoRecord(name, $f8b209eae481e777$var$NUMERIC, false, name.toLowerCase(), null, false, false);
});
const $f8b209eae481e777$var$CAMELIZE = /[\-\:]([a-z])/g;
const $f8b209eae481e777$var$capitalize = (token)=>token[1].toUpperCase();
// This is a list of all SVG attributes that need special casing, namespacing,
// or boolean value assignment. Regular attributes that just accept strings
// and have the same names are omitted, just like in the HTML attribute filter.
// Some of these attributes can be hard to find. This list was created by
// scraping the MDN documentation.
[
    "accent-height",
    "alignment-baseline",
    "arabic-form",
    "baseline-shift",
    "cap-height",
    "clip-path",
    "clip-rule",
    "color-interpolation",
    "color-interpolation-filters",
    "color-profile",
    "color-rendering",
    "dominant-baseline",
    "enable-background",
    "fill-opacity",
    "fill-rule",
    "flood-color",
    "flood-opacity",
    "font-family",
    "font-size",
    "font-size-adjust",
    "font-stretch",
    "font-style",
    "font-variant",
    "font-weight",
    "glyph-name",
    "glyph-orientation-horizontal",
    "glyph-orientation-vertical",
    "horiz-adv-x",
    "horiz-origin-x",
    "image-rendering",
    "letter-spacing",
    "lighting-color",
    "marker-end",
    "marker-mid",
    "marker-start",
    "overline-position",
    "overline-thickness",
    "paint-order",
    "panose-1",
    "pointer-events",
    "rendering-intent",
    "shape-rendering",
    "stop-color",
    "stop-opacity",
    "strikethrough-position",
    "strikethrough-thickness",
    "stroke-dasharray",
    "stroke-dashoffset",
    "stroke-linecap",
    "stroke-linejoin",
    "stroke-miterlimit",
    "stroke-opacity",
    "stroke-width",
    "text-anchor",
    "text-decoration",
    "text-rendering",
    "underline-position",
    "underline-thickness",
    "unicode-bidi",
    "unicode-range",
    "units-per-em",
    "v-alphabetic",
    "v-hanging",
    "v-ideographic",
    "v-mathematical",
    "vector-effect",
    "vert-adv-y",
    "vert-origin-x",
    "vert-origin-y",
    "word-spacing",
    "writing-mode",
    "xmlns:xlink",
    "x-height"
].forEach((attributeName)=>{
    const name = attributeName.replace($f8b209eae481e777$var$CAMELIZE, $f8b209eae481e777$var$capitalize);
    $f8b209eae481e777$var$properties[name] = new $f8b209eae481e777$var$PropertyInfoRecord(name, $f8b209eae481e777$var$STRING, false, attributeName, null, false, false);
});
// String SVG attributes with the xlink namespace.
[
    "xlink:actuate",
    "xlink:arcrole",
    "xlink:role",
    "xlink:show",
    "xlink:title",
    "xlink:type"
].forEach((attributeName)=>{
    const name = attributeName.replace($f8b209eae481e777$var$CAMELIZE, $f8b209eae481e777$var$capitalize);
    $f8b209eae481e777$var$properties[name] = new $f8b209eae481e777$var$PropertyInfoRecord(name, $f8b209eae481e777$var$STRING, false, attributeName, "http://www.w3.org/1999/xlink", false, false);
});
// String SVG attributes with the xml namespace.
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach((attributeName)=>{
    const name = attributeName.replace($f8b209eae481e777$var$CAMELIZE, $f8b209eae481e777$var$capitalize);
    $f8b209eae481e777$var$properties[name] = new $f8b209eae481e777$var$PropertyInfoRecord(name, $f8b209eae481e777$var$STRING, false, attributeName, "http://www.w3.org/XML/1998/namespace", false, false);
});
// These attribute exists both in HTML and SVG.
// The attribute name is case-sensitive in SVG so we can't just use
// the React name like we do for attributes that exist only in HTML.
[
    "tabIndex",
    "crossOrigin"
].forEach((attributeName)=>{
    $f8b209eae481e777$var$properties[attributeName] = new $f8b209eae481e777$var$PropertyInfoRecord(attributeName, $f8b209eae481e777$var$STRING, false, attributeName.toLowerCase(), null, false, false);
});
// These attributes accept URLs. These must not allow javascript: URLS.
// These will also need to accept Trusted Types object in the future.
const $f8b209eae481e777$var$xlinkHref = "xlinkHref";
$f8b209eae481e777$var$properties[$f8b209eae481e777$var$xlinkHref] = new $f8b209eae481e777$var$PropertyInfoRecord("xlinkHref", $f8b209eae481e777$var$STRING, false, "xlink:href", "http://www.w3.org/1999/xlink", true, false);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach((attributeName)=>{
    $f8b209eae481e777$var$properties[attributeName] = new $f8b209eae481e777$var$PropertyInfoRecord(attributeName, $f8b209eae481e777$var$STRING, false, attributeName.toLowerCase(), null, true, true);
});

var $iAGIO = parcelRequire("iAGIO");
var $f8b209eae481e777$require$CAMELCASE = $iAGIO.CAMELCASE;
var $f8b209eae481e777$require$SAME = $iAGIO.SAME;
var $f8b209eae481e777$require$possibleStandardNamesOptimized = $iAGIO.possibleStandardNames;
const $f8b209eae481e777$var$ATTRIBUTE_NAME_START_CHAR = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD";
const $f8b209eae481e777$var$ATTRIBUTE_NAME_CHAR = $f8b209eae481e777$var$ATTRIBUTE_NAME_START_CHAR + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040";
/**
 * Checks whether a property name is a custom attribute.
 *
 * @see https://github.com/facebook/react/blob/15-stable/src/renderers/dom/shared/HTMLDOMPropertyConfig.js#L23-L25
 *
 * @type {(attribute: string) => boolean}
 */ const $f8b209eae481e777$var$isCustomAttribute = RegExp.prototype.test.bind(// eslint-disable-next-line no-misleading-character-class
new RegExp("^(data|aria)-[" + $f8b209eae481e777$var$ATTRIBUTE_NAME_CHAR + "]*$"));
/**
 * @type {Record<string, string>}
 */ const $f8b209eae481e777$var$possibleStandardNames = Object.keys($f8b209eae481e777$require$possibleStandardNamesOptimized).reduce((accumulator, standardName)=>{
    const propName = $f8b209eae481e777$require$possibleStandardNamesOptimized[standardName];
    if (propName === $f8b209eae481e777$require$SAME) accumulator[standardName] = standardName;
    else if (propName === $f8b209eae481e777$require$CAMELCASE) accumulator[standardName.toLowerCase()] = standardName;
    else accumulator[standardName] = propName;
    return accumulator;
}, {});
$f8b209eae481e777$export$428cfe48a69a3b4f = $f8b209eae481e777$var$BOOLEAN;
$f8b209eae481e777$export$d7e6493a7bfdb8c1 = $f8b209eae481e777$var$BOOLEANISH_STRING;
$f8b209eae481e777$export$4d318981b5a83836 = $f8b209eae481e777$var$NUMERIC;
$f8b209eae481e777$export$91da4d9e9b612643 = $f8b209eae481e777$var$OVERLOADED_BOOLEAN;
$f8b209eae481e777$export$39307127151c9810 = $f8b209eae481e777$var$POSITIVE_NUMERIC;
$f8b209eae481e777$export$75032a190741fbaf = $f8b209eae481e777$var$RESERVED;
$f8b209eae481e777$export$a0e01ba2ebef17f2 = $f8b209eae481e777$var$STRING;
$f8b209eae481e777$export$fd64a1f33de3651a = $f8b209eae481e777$var$getPropertyInfo;
$f8b209eae481e777$export$d89f61ed80c87270 = $f8b209eae481e777$var$isCustomAttribute;
$f8b209eae481e777$export$bbecfff5ecf65cd8 = $f8b209eae481e777$var$possibleStandardNames;

});
parcelRequire.register("iAGIO", function(module, exports) {

$parcel$export(module.exports, "SAME", function () { return $d88cba6f79c10c09$export$7359a57b3ac1f378; }, function (v) { return $d88cba6f79c10c09$export$7359a57b3ac1f378 = v; });
$parcel$export(module.exports, "CAMELCASE", function () { return $d88cba6f79c10c09$export$5ab28d07cff57c11; }, function (v) { return $d88cba6f79c10c09$export$5ab28d07cff57c11 = v; });
$parcel$export(module.exports, "possibleStandardNames", function () { return $d88cba6f79c10c09$export$bbecfff5ecf65cd8; }, function (v) { return $d88cba6f79c10c09$export$bbecfff5ecf65cd8 = v; });
// An attribute in which the DOM/SVG standard name is the same as the React prop name (e.g., 'accept').
var $d88cba6f79c10c09$export$7359a57b3ac1f378;
var $d88cba6f79c10c09$export$5ab28d07cff57c11;
var $d88cba6f79c10c09$export$bbecfff5ecf65cd8;
var $d88cba6f79c10c09$var$SAME = 0;
$d88cba6f79c10c09$export$7359a57b3ac1f378 = $d88cba6f79c10c09$var$SAME;
// An attribute in which the React prop name is the camelcased version of the DOM/SVG standard name (e.g., 'acceptCharset').
var $d88cba6f79c10c09$var$CAMELCASE = 1;
$d88cba6f79c10c09$export$5ab28d07cff57c11 = $d88cba6f79c10c09$var$CAMELCASE;
$d88cba6f79c10c09$export$bbecfff5ecf65cd8 = {
    accept: 0,
    acceptCharset: 1,
    "accept-charset": "acceptCharset",
    accessKey: 1,
    action: 0,
    allowFullScreen: 1,
    alt: 0,
    as: 0,
    async: 0,
    autoCapitalize: 1,
    autoComplete: 1,
    autoCorrect: 1,
    autoFocus: 1,
    autoPlay: 1,
    autoSave: 1,
    capture: 0,
    cellPadding: 1,
    cellSpacing: 1,
    challenge: 0,
    charSet: 1,
    checked: 0,
    children: 0,
    cite: 0,
    class: "className",
    classID: 1,
    className: 1,
    cols: 0,
    colSpan: 1,
    content: 0,
    contentEditable: 1,
    contextMenu: 1,
    controls: 0,
    controlsList: 1,
    coords: 0,
    crossOrigin: 1,
    dangerouslySetInnerHTML: 1,
    data: 0,
    dateTime: 1,
    default: 0,
    defaultChecked: 1,
    defaultValue: 1,
    defer: 0,
    dir: 0,
    disabled: 0,
    disablePictureInPicture: 1,
    disableRemotePlayback: 1,
    download: 0,
    draggable: 0,
    encType: 1,
    enterKeyHint: 1,
    for: "htmlFor",
    form: 0,
    formMethod: 1,
    formAction: 1,
    formEncType: 1,
    formNoValidate: 1,
    formTarget: 1,
    frameBorder: 1,
    headers: 0,
    height: 0,
    hidden: 0,
    high: 0,
    href: 0,
    hrefLang: 1,
    htmlFor: 1,
    httpEquiv: 1,
    "http-equiv": "httpEquiv",
    icon: 0,
    id: 0,
    innerHTML: 1,
    inputMode: 1,
    integrity: 0,
    is: 0,
    itemID: 1,
    itemProp: 1,
    itemRef: 1,
    itemScope: 1,
    itemType: 1,
    keyParams: 1,
    keyType: 1,
    kind: 0,
    label: 0,
    lang: 0,
    list: 0,
    loop: 0,
    low: 0,
    manifest: 0,
    marginWidth: 1,
    marginHeight: 1,
    max: 0,
    maxLength: 1,
    media: 0,
    mediaGroup: 1,
    method: 0,
    min: 0,
    minLength: 1,
    multiple: 0,
    muted: 0,
    name: 0,
    noModule: 1,
    nonce: 0,
    noValidate: 1,
    open: 0,
    optimum: 0,
    pattern: 0,
    placeholder: 0,
    playsInline: 1,
    poster: 0,
    preload: 0,
    profile: 0,
    radioGroup: 1,
    readOnly: 1,
    referrerPolicy: 1,
    rel: 0,
    required: 0,
    reversed: 0,
    role: 0,
    rows: 0,
    rowSpan: 1,
    sandbox: 0,
    scope: 0,
    scoped: 0,
    scrolling: 0,
    seamless: 0,
    selected: 0,
    shape: 0,
    size: 0,
    sizes: 0,
    span: 0,
    spellCheck: 1,
    src: 0,
    srcDoc: 1,
    srcLang: 1,
    srcSet: 1,
    start: 0,
    step: 0,
    style: 0,
    summary: 0,
    tabIndex: 1,
    target: 0,
    title: 0,
    type: 0,
    useMap: 1,
    value: 0,
    width: 0,
    wmode: 0,
    wrap: 0,
    about: 0,
    accentHeight: 1,
    "accent-height": "accentHeight",
    accumulate: 0,
    additive: 0,
    alignmentBaseline: 1,
    "alignment-baseline": "alignmentBaseline",
    allowReorder: 1,
    alphabetic: 0,
    amplitude: 0,
    arabicForm: 1,
    "arabic-form": "arabicForm",
    ascent: 0,
    attributeName: 1,
    attributeType: 1,
    autoReverse: 1,
    azimuth: 0,
    baseFrequency: 1,
    baselineShift: 1,
    "baseline-shift": "baselineShift",
    baseProfile: 1,
    bbox: 0,
    begin: 0,
    bias: 0,
    by: 0,
    calcMode: 1,
    capHeight: 1,
    "cap-height": "capHeight",
    clip: 0,
    clipPath: 1,
    "clip-path": "clipPath",
    clipPathUnits: 1,
    clipRule: 1,
    "clip-rule": "clipRule",
    color: 0,
    colorInterpolation: 1,
    "color-interpolation": "colorInterpolation",
    colorInterpolationFilters: 1,
    "color-interpolation-filters": "colorInterpolationFilters",
    colorProfile: 1,
    "color-profile": "colorProfile",
    colorRendering: 1,
    "color-rendering": "colorRendering",
    contentScriptType: 1,
    contentStyleType: 1,
    cursor: 0,
    cx: 0,
    cy: 0,
    d: 0,
    datatype: 0,
    decelerate: 0,
    descent: 0,
    diffuseConstant: 1,
    direction: 0,
    display: 0,
    divisor: 0,
    dominantBaseline: 1,
    "dominant-baseline": "dominantBaseline",
    dur: 0,
    dx: 0,
    dy: 0,
    edgeMode: 1,
    elevation: 0,
    enableBackground: 1,
    "enable-background": "enableBackground",
    end: 0,
    exponent: 0,
    externalResourcesRequired: 1,
    fill: 0,
    fillOpacity: 1,
    "fill-opacity": "fillOpacity",
    fillRule: 1,
    "fill-rule": "fillRule",
    filter: 0,
    filterRes: 1,
    filterUnits: 1,
    floodOpacity: 1,
    "flood-opacity": "floodOpacity",
    floodColor: 1,
    "flood-color": "floodColor",
    focusable: 0,
    fontFamily: 1,
    "font-family": "fontFamily",
    fontSize: 1,
    "font-size": "fontSize",
    fontSizeAdjust: 1,
    "font-size-adjust": "fontSizeAdjust",
    fontStretch: 1,
    "font-stretch": "fontStretch",
    fontStyle: 1,
    "font-style": "fontStyle",
    fontVariant: 1,
    "font-variant": "fontVariant",
    fontWeight: 1,
    "font-weight": "fontWeight",
    format: 0,
    from: 0,
    fx: 0,
    fy: 0,
    g1: 0,
    g2: 0,
    glyphName: 1,
    "glyph-name": "glyphName",
    glyphOrientationHorizontal: 1,
    "glyph-orientation-horizontal": "glyphOrientationHorizontal",
    glyphOrientationVertical: 1,
    "glyph-orientation-vertical": "glyphOrientationVertical",
    glyphRef: 1,
    gradientTransform: 1,
    gradientUnits: 1,
    hanging: 0,
    horizAdvX: 1,
    "horiz-adv-x": "horizAdvX",
    horizOriginX: 1,
    "horiz-origin-x": "horizOriginX",
    ideographic: 0,
    imageRendering: 1,
    "image-rendering": "imageRendering",
    in2: 0,
    in: 0,
    inlist: 0,
    intercept: 0,
    k1: 0,
    k2: 0,
    k3: 0,
    k4: 0,
    k: 0,
    kernelMatrix: 1,
    kernelUnitLength: 1,
    kerning: 0,
    keyPoints: 1,
    keySplines: 1,
    keyTimes: 1,
    lengthAdjust: 1,
    letterSpacing: 1,
    "letter-spacing": "letterSpacing",
    lightingColor: 1,
    "lighting-color": "lightingColor",
    limitingConeAngle: 1,
    local: 0,
    markerEnd: 1,
    "marker-end": "markerEnd",
    markerHeight: 1,
    markerMid: 1,
    "marker-mid": "markerMid",
    markerStart: 1,
    "marker-start": "markerStart",
    markerUnits: 1,
    markerWidth: 1,
    mask: 0,
    maskContentUnits: 1,
    maskUnits: 1,
    mathematical: 0,
    mode: 0,
    numOctaves: 1,
    offset: 0,
    opacity: 0,
    operator: 0,
    order: 0,
    orient: 0,
    orientation: 0,
    origin: 0,
    overflow: 0,
    overlinePosition: 1,
    "overline-position": "overlinePosition",
    overlineThickness: 1,
    "overline-thickness": "overlineThickness",
    paintOrder: 1,
    "paint-order": "paintOrder",
    panose1: 0,
    "panose-1": "panose1",
    pathLength: 1,
    patternContentUnits: 1,
    patternTransform: 1,
    patternUnits: 1,
    pointerEvents: 1,
    "pointer-events": "pointerEvents",
    points: 0,
    pointsAtX: 1,
    pointsAtY: 1,
    pointsAtZ: 1,
    prefix: 0,
    preserveAlpha: 1,
    preserveAspectRatio: 1,
    primitiveUnits: 1,
    property: 0,
    r: 0,
    radius: 0,
    refX: 1,
    refY: 1,
    renderingIntent: 1,
    "rendering-intent": "renderingIntent",
    repeatCount: 1,
    repeatDur: 1,
    requiredExtensions: 1,
    requiredFeatures: 1,
    resource: 0,
    restart: 0,
    result: 0,
    results: 0,
    rotate: 0,
    rx: 0,
    ry: 0,
    scale: 0,
    security: 0,
    seed: 0,
    shapeRendering: 1,
    "shape-rendering": "shapeRendering",
    slope: 0,
    spacing: 0,
    specularConstant: 1,
    specularExponent: 1,
    speed: 0,
    spreadMethod: 1,
    startOffset: 1,
    stdDeviation: 1,
    stemh: 0,
    stemv: 0,
    stitchTiles: 1,
    stopColor: 1,
    "stop-color": "stopColor",
    stopOpacity: 1,
    "stop-opacity": "stopOpacity",
    strikethroughPosition: 1,
    "strikethrough-position": "strikethroughPosition",
    strikethroughThickness: 1,
    "strikethrough-thickness": "strikethroughThickness",
    string: 0,
    stroke: 0,
    strokeDasharray: 1,
    "stroke-dasharray": "strokeDasharray",
    strokeDashoffset: 1,
    "stroke-dashoffset": "strokeDashoffset",
    strokeLinecap: 1,
    "stroke-linecap": "strokeLinecap",
    strokeLinejoin: 1,
    "stroke-linejoin": "strokeLinejoin",
    strokeMiterlimit: 1,
    "stroke-miterlimit": "strokeMiterlimit",
    strokeWidth: 1,
    "stroke-width": "strokeWidth",
    strokeOpacity: 1,
    "stroke-opacity": "strokeOpacity",
    suppressContentEditableWarning: 1,
    suppressHydrationWarning: 1,
    surfaceScale: 1,
    systemLanguage: 1,
    tableValues: 1,
    targetX: 1,
    targetY: 1,
    textAnchor: 1,
    "text-anchor": "textAnchor",
    textDecoration: 1,
    "text-decoration": "textDecoration",
    textLength: 1,
    textRendering: 1,
    "text-rendering": "textRendering",
    to: 0,
    transform: 0,
    typeof: 0,
    u1: 0,
    u2: 0,
    underlinePosition: 1,
    "underline-position": "underlinePosition",
    underlineThickness: 1,
    "underline-thickness": "underlineThickness",
    unicode: 0,
    unicodeBidi: 1,
    "unicode-bidi": "unicodeBidi",
    unicodeRange: 1,
    "unicode-range": "unicodeRange",
    unitsPerEm: 1,
    "units-per-em": "unitsPerEm",
    unselectable: 0,
    vAlphabetic: 1,
    "v-alphabetic": "vAlphabetic",
    values: 0,
    vectorEffect: 1,
    "vector-effect": "vectorEffect",
    version: 0,
    vertAdvY: 1,
    "vert-adv-y": "vertAdvY",
    vertOriginX: 1,
    "vert-origin-x": "vertOriginX",
    vertOriginY: 1,
    "vert-origin-y": "vertOriginY",
    vHanging: 1,
    "v-hanging": "vHanging",
    vIdeographic: 1,
    "v-ideographic": "vIdeographic",
    viewBox: 1,
    viewTarget: 1,
    visibility: 0,
    vMathematical: 1,
    "v-mathematical": "vMathematical",
    vocab: 0,
    widths: 0,
    wordSpacing: 1,
    "word-spacing": "wordSpacing",
    writingMode: 1,
    "writing-mode": "writingMode",
    x1: 0,
    x2: 0,
    x: 0,
    xChannelSelector: 1,
    xHeight: 1,
    "x-height": "xHeight",
    xlinkActuate: 1,
    "xlink:actuate": "xlinkActuate",
    xlinkArcrole: 1,
    "xlink:arcrole": "xlinkArcrole",
    xlinkHref: 1,
    "xlink:href": "xlinkHref",
    xlinkRole: 1,
    "xlink:role": "xlinkRole",
    xlinkShow: 1,
    "xlink:show": "xlinkShow",
    xlinkTitle: 1,
    "xlink:title": "xlinkTitle",
    xlinkType: 1,
    "xlink:type": "xlinkType",
    xmlBase: 1,
    "xml:base": "xmlBase",
    xmlLang: 1,
    "xml:lang": "xmlLang",
    xmlns: 0,
    "xml:space": "xmlSpace",
    xmlnsXlink: 1,
    "xmlns:xlink": "xmlnsXlink",
    xmlSpace: 1,
    y1: 0,
    y2: 0,
    y: 0,
    yChannelSelector: 1,
    z: 0,
    zoomAndPan: 1
};

});


parcelRequire.register("aWr2r", function(module, exports) {
"use strict";
var $7f744b6f71a3719b$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.returnFirstArg = module.exports.canTextBeChildOfNode = module.exports.ELEMENTS_WITH_NO_TEXT_CHILDREN = module.exports.PRESERVE_CUSTOM_ATTRIBUTES = void 0;
module.exports.isCustomComponent = $7f744b6f71a3719b$var$isCustomComponent;
module.exports.setStyleProp = $7f744b6f71a3719b$var$setStyleProp;

var $aivMx = parcelRequire("aivMx");

var $7f744b6f71a3719b$var$style_to_js_1 = $7f744b6f71a3719b$var$__importDefault((parcelRequire("3IhUU")));
var $7f744b6f71a3719b$var$RESERVED_SVG_MATHML_ELEMENTS = new Set([
    "annotation-xml",
    "color-profile",
    "font-face",
    "font-face-src",
    "font-face-uri",
    "font-face-format",
    "font-face-name",
    "missing-glyph"
]);
/**
 * Check if a tag is a custom component.
 *
 * @see {@link https://github.com/facebook/react/blob/v16.6.3/packages/react-dom/src/shared/isCustomComponent.js}
 *
 * @param tagName - Tag name.
 * @param props - Props passed to the element.
 * @returns - Whether the tag is custom component.
 */ function $7f744b6f71a3719b$var$isCustomComponent(tagName, props) {
    if (!tagName.includes("-")) return Boolean(props && typeof props.is === "string");
    // These are reserved SVG and MathML elements.
    // We don't mind this whitelist too much because we expect it to never grow.
    // The alternative is to track the namespace in a few places which is convoluted.
    // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
    if ($7f744b6f71a3719b$var$RESERVED_SVG_MATHML_ELEMENTS.has(tagName)) return false;
    return true;
}
var $7f744b6f71a3719b$var$styleOptions = {
    reactCompat: true
};
/**
 * Sets style prop.
 *
 * @param style - Inline style.
 * @param props - Props object.
 */ function $7f744b6f71a3719b$var$setStyleProp(style, props) {
    if (typeof style !== "string") return;
    if (!style.trim()) {
        props.style = {};
        return;
    }
    try {
        props.style = (0, $7f744b6f71a3719b$var$style_to_js_1.default)(style, $7f744b6f71a3719b$var$styleOptions);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (error) {
        props.style = {};
    }
}
/**
 * @see https://reactjs.org/blog/2017/09/08/dom-attributes-in-react-16.html
 */ module.exports.PRESERVE_CUSTOM_ATTRIBUTES = Number($aivMx.version.split(".")[0]) >= 16;
/**
 * @see https://github.com/facebook/react/blob/cae635054e17a6f107a39d328649137b83f25972/packages/react-dom/src/client/validateDOMNesting.js#L213
 */ module.exports.ELEMENTS_WITH_NO_TEXT_CHILDREN = new Set([
    "tr",
    "tbody",
    "thead",
    "tfoot",
    "colgroup",
    "table",
    "head",
    "html",
    "frameset"
]);
/**
 * Checks if the given node can contain text nodes
 *
 * @param node - Element node.
 * @returns - Whether the node can contain text nodes.
 */ var $7f744b6f71a3719b$var$canTextBeChildOfNode = function(node) {
    return !module.exports.ELEMENTS_WITH_NO_TEXT_CHILDREN.has(node.name);
};
module.exports.canTextBeChildOfNode = $7f744b6f71a3719b$var$canTextBeChildOfNode;
/**
 * Returns the first argument as is.
 *
 * @param arg - The argument to be returned.
 * @returns - The input argument `arg`.
 */ var $7f744b6f71a3719b$var$returnFirstArg = function(arg) {
    return arg;
};
module.exports.returnFirstArg = $7f744b6f71a3719b$var$returnFirstArg;

});
parcelRequire.register("3IhUU", function(module, exports) {
"use strict";
var $2b4361174d308cc3$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};

var $2b4361174d308cc3$var$style_to_object_1 = $2b4361174d308cc3$var$__importDefault((parcelRequire("80JJC")));

var $czu3k = parcelRequire("czu3k");
/**
 * Parses CSS inline style to JavaScript object (camelCased).
 */ function $2b4361174d308cc3$var$StyleToJS(style, options) {
    var output = {};
    if (!style || typeof style !== "string") return output;
    (0, $2b4361174d308cc3$var$style_to_object_1.default)(style, function(property, value) {
        // skip CSS comment
        if (property && value) output[(0, $czu3k.camelCase)(property, options)] = value;
    });
    return output;
}
$2b4361174d308cc3$var$StyleToJS.default = $2b4361174d308cc3$var$StyleToJS;
module.exports = $2b4361174d308cc3$var$StyleToJS;

});
parcelRequire.register("80JJC", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $8cb7458ebf4b860a$export$2e2bcd8739ae039; });

var $4zhzM = parcelRequire("4zhzM");
var // ensure compatibility with rollup umd build
$8cb7458ebf4b860a$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($4zhzM))).default || (0, (/*@__PURE__*/$parcel$interopDefault($4zhzM)));

});
parcelRequire.register("4zhzM", function(module, exports) {
"use strict";
var $3538108879e5f9f4$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3538108879e5f9f4$var$StyleToObject;

var $3538108879e5f9f4$var$inline_style_parser_1 = $3538108879e5f9f4$var$__importDefault((parcelRequire("fvCHB")));
/**
 * Parses inline style to object.
 *
 * @param style - Inline style.
 * @param iterator - Iterator.
 * @returns - Style object or null.
 *
 * @example Parsing inline style to object:
 *
 * ```js
 * import parse from 'style-to-object';
 * parse('line-height: 42;'); // { 'line-height': '42' }
 * ```
 */ function $3538108879e5f9f4$var$StyleToObject(style, iterator) {
    var styleObject = null;
    if (!style || typeof style !== "string") return styleObject;
    var declarations = (0, $3538108879e5f9f4$var$inline_style_parser_1.default)(style);
    var hasIterator = typeof iterator === "function";
    declarations.forEach(function(declaration) {
        if (declaration.type !== "declaration") return;
        var property = declaration.property, value = declaration.value;
        if (hasIterator) iterator(property, value, declaration);
        else if (value) {
            styleObject = styleObject || {};
            styleObject[property] = value;
        }
    });
    return styleObject;
}

});
parcelRequire.register("fvCHB", function(module, exports) {
// http://www.w3.org/TR/CSS21/grammar.html
// https://github.com/visionmedia/css-parse/pull/49#issuecomment-30088027
var $b4a7c5baacd26c66$var$COMMENT_REGEX = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;
var $b4a7c5baacd26c66$var$NEWLINE_REGEX = /\n/g;
var $b4a7c5baacd26c66$var$WHITESPACE_REGEX = /^\s*/;
// declaration
var $b4a7c5baacd26c66$var$PROPERTY_REGEX = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/;
var $b4a7c5baacd26c66$var$COLON_REGEX = /^:\s*/;
var $b4a7c5baacd26c66$var$VALUE_REGEX = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/;
var $b4a7c5baacd26c66$var$SEMICOLON_REGEX = /^[;\s]*/;
// https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
var $b4a7c5baacd26c66$var$TRIM_REGEX = /^\s+|\s+$/g;
// strings
var $b4a7c5baacd26c66$var$NEWLINE = "\n";
var $b4a7c5baacd26c66$var$FORWARD_SLASH = "/";
var $b4a7c5baacd26c66$var$ASTERISK = "*";
var $b4a7c5baacd26c66$var$EMPTY_STRING = "";
// types
var $b4a7c5baacd26c66$var$TYPE_COMMENT = "comment";
var $b4a7c5baacd26c66$var$TYPE_DECLARATION = "declaration";
/**
 * @param {String} style
 * @param {Object} [options]
 * @return {Object[]}
 * @throws {TypeError}
 * @throws {Error}
 */ module.exports = function(style, options) {
    if (typeof style !== "string") throw new TypeError("First argument must be a string");
    if (!style) return [];
    options = options || {};
    /**
   * Positional.
   */ var lineno = 1;
    var column = 1;
    /**
   * Update lineno and column based on `str`.
   *
   * @param {String} str
   */ function updatePosition(str) {
        var lines = str.match($b4a7c5baacd26c66$var$NEWLINE_REGEX);
        if (lines) lineno += lines.length;
        var i = str.lastIndexOf($b4a7c5baacd26c66$var$NEWLINE);
        column = ~i ? str.length - i : column + str.length;
    }
    /**
   * Mark position and patch `node.position`.
   *
   * @return {Function}
   */ function position() {
        var start = {
            line: lineno,
            column: column
        };
        return function(node) {
            node.position = new Position(start);
            whitespace();
            return node;
        };
    }
    /**
   * Store position information for a node.
   *
   * @constructor
   * @property {Object} start
   * @property {Object} end
   * @property {undefined|String} source
   */ function Position(start) {
        this.start = start;
        this.end = {
            line: lineno,
            column: column
        };
        this.source = options.source;
    }
    /**
   * Non-enumerable source string.
   */ Position.prototype.content = style;
    var errorsList = [];
    /**
   * Error `msg`.
   *
   * @param {String} msg
   * @throws {Error}
   */ function error(msg) {
        var err = new Error(options.source + ":" + lineno + ":" + column + ": " + msg);
        err.reason = msg;
        err.filename = options.source;
        err.line = lineno;
        err.column = column;
        err.source = style;
        if (options.silent) errorsList.push(err);
        else throw err;
    }
    /**
   * Match `re` and return captures.
   *
   * @param {RegExp} re
   * @return {undefined|Array}
   */ function match(re) {
        var m = re.exec(style);
        if (!m) return;
        var str = m[0];
        updatePosition(str);
        style = style.slice(str.length);
        return m;
    }
    /**
   * Parse whitespace.
   */ function whitespace() {
        match($b4a7c5baacd26c66$var$WHITESPACE_REGEX);
    }
    /**
   * Parse comments.
   *
   * @param {Object[]} [rules]
   * @return {Object[]}
   */ function comments(rules) {
        var c;
        rules = rules || [];
        while(c = comment())if (c !== false) rules.push(c);
        return rules;
    }
    /**
   * Parse comment.
   *
   * @return {Object}
   * @throws {Error}
   */ function comment() {
        var pos = position();
        if ($b4a7c5baacd26c66$var$FORWARD_SLASH != style.charAt(0) || $b4a7c5baacd26c66$var$ASTERISK != style.charAt(1)) return;
        var i = 2;
        while($b4a7c5baacd26c66$var$EMPTY_STRING != style.charAt(i) && ($b4a7c5baacd26c66$var$ASTERISK != style.charAt(i) || $b4a7c5baacd26c66$var$FORWARD_SLASH != style.charAt(i + 1)))++i;
        i += 2;
        if ($b4a7c5baacd26c66$var$EMPTY_STRING === style.charAt(i - 1)) return error("End of comment missing");
        var str = style.slice(2, i - 2);
        column += 2;
        updatePosition(str);
        style = style.slice(i);
        column += 2;
        return pos({
            type: $b4a7c5baacd26c66$var$TYPE_COMMENT,
            comment: str
        });
    }
    /**
   * Parse declaration.
   *
   * @return {Object}
   * @throws {Error}
   */ function declaration() {
        var pos = position();
        // prop
        var prop = match($b4a7c5baacd26c66$var$PROPERTY_REGEX);
        if (!prop) return;
        comment();
        // :
        if (!match($b4a7c5baacd26c66$var$COLON_REGEX)) return error("property missing ':'");
        // val
        var val = match($b4a7c5baacd26c66$var$VALUE_REGEX);
        var ret = pos({
            type: $b4a7c5baacd26c66$var$TYPE_DECLARATION,
            property: $b4a7c5baacd26c66$var$trim(prop[0].replace($b4a7c5baacd26c66$var$COMMENT_REGEX, $b4a7c5baacd26c66$var$EMPTY_STRING)),
            value: val ? $b4a7c5baacd26c66$var$trim(val[0].replace($b4a7c5baacd26c66$var$COMMENT_REGEX, $b4a7c5baacd26c66$var$EMPTY_STRING)) : $b4a7c5baacd26c66$var$EMPTY_STRING
        });
        // ;
        match($b4a7c5baacd26c66$var$SEMICOLON_REGEX);
        return ret;
    }
    /**
   * Parse declarations.
   *
   * @return {Object[]}
   */ function declarations() {
        var decls = [];
        comments(decls);
        // declarations
        var decl;
        while(decl = declaration())if (decl !== false) {
            decls.push(decl);
            comments(decls);
        }
        return decls;
    }
    whitespace();
    return declarations();
};
/**
 * Trim `str`.
 *
 * @param {String} str
 * @return {String}
 */ function $b4a7c5baacd26c66$var$trim(str) {
    return str ? str.replace($b4a7c5baacd26c66$var$TRIM_REGEX, $b4a7c5baacd26c66$var$EMPTY_STRING) : $b4a7c5baacd26c66$var$EMPTY_STRING;
}

});



parcelRequire.register("czu3k", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.camelCase = void 0;
var $927010c467d64240$var$CUSTOM_PROPERTY_REGEX = /^--[a-zA-Z0-9_-]+$/;
var $927010c467d64240$var$HYPHEN_REGEX = /-([a-z])/g;
var $927010c467d64240$var$NO_HYPHEN_REGEX = /^[^-]+$/;
var $927010c467d64240$var$VENDOR_PREFIX_REGEX = /^-(webkit|moz|ms|o|khtml)-/;
var $927010c467d64240$var$MS_VENDOR_PREFIX_REGEX = /^-(ms)-/;
/**
 * Checks whether to skip camelCase.
 */ var $927010c467d64240$var$skipCamelCase = function(property) {
    return !property || $927010c467d64240$var$NO_HYPHEN_REGEX.test(property) || $927010c467d64240$var$CUSTOM_PROPERTY_REGEX.test(property);
};
/**
 * Replacer that capitalizes first character.
 */ var $927010c467d64240$var$capitalize = function(match, character) {
    return character.toUpperCase();
};
/**
 * Replacer that removes beginning hyphen of vendor prefix property.
 */ var $927010c467d64240$var$trimHyphen = function(match, prefix) {
    return "".concat(prefix, "-");
};
/**
 * CamelCases a CSS property.
 */ var $927010c467d64240$var$camelCase = function(property, options) {
    if (options === void 0) options = {};
    if ($927010c467d64240$var$skipCamelCase(property)) return property;
    property = property.toLowerCase();
    if (options.reactCompat) // `-ms` vendor prefix should not be capitalized
    property = property.replace($927010c467d64240$var$MS_VENDOR_PREFIX_REGEX, $927010c467d64240$var$trimHyphen);
    else // for non-React, remove first hyphen so vendor prefix is not capitalized
    property = property.replace($927010c467d64240$var$VENDOR_PREFIX_REGEX, $927010c467d64240$var$trimHyphen);
    return property.replace($927010c467d64240$var$HYPHEN_REGEX, $927010c467d64240$var$capitalize);
};
module.exports.camelCase = $927010c467d64240$var$camelCase;

});




parcelRequire.register("cakMo", function(module, exports) {
"use strict";
var $8db68999b7a3b326$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8db68999b7a3b326$var$domToReact;

var $aivMx = parcelRequire("aivMx");

var $8db68999b7a3b326$var$attributes_to_props_1 = $8db68999b7a3b326$var$__importDefault((parcelRequire("2FPJE")));

var $aWr2r = parcelRequire("aWr2r");
var $8db68999b7a3b326$var$React = {
    cloneElement: $aivMx.cloneElement,
    createElement: $aivMx.createElement,
    isValidElement: $aivMx.isValidElement
};
/**
 * Converts DOM nodes to JSX element(s).
 *
 * @param nodes - DOM nodes.
 * @param options - Options.
 * @returns - String or JSX element(s).
 */ function $8db68999b7a3b326$var$domToReact(nodes, options) {
    if (options === void 0) options = {};
    var reactElements = [];
    var hasReplace = typeof options.replace === "function";
    var transform = options.transform || $aWr2r.returnFirstArg;
    var _a = options.library || $8db68999b7a3b326$var$React, cloneElement = _a.cloneElement, createElement = _a.createElement, isValidElement = _a.isValidElement;
    var nodesLength = nodes.length;
    for(var index = 0; index < nodesLength; index++){
        var node = nodes[index];
        // replace with custom React element (if present)
        if (hasReplace) {
            var replaceElement = options.replace(node, index);
            if (isValidElement(replaceElement)) {
                // set "key" prop for sibling elements
                // https://react.dev/learn/rendering-lists#rules-of-keys
                if (nodesLength > 1) replaceElement = cloneElement(replaceElement, {
                    key: replaceElement.key || index
                });
                reactElements.push(transform(replaceElement, node, index));
                continue;
            }
        }
        if (node.type === "text") {
            var isWhitespace = !node.data.trim().length;
            // We have a whitespace node that can't be nested in its parent
            // so skip it
            if (isWhitespace && node.parent && !(0, $aWr2r.canTextBeChildOfNode)(node.parent)) continue;
            // Trim is enabled and we have a whitespace node
            // so skip it
            if (options.trim && isWhitespace) continue;
            // We have a text node that's not whitespace and it can be nested
            // in its parent so add it to the results
            reactElements.push(transform(node.data, node, index));
            continue;
        }
        var element = node;
        var props = {};
        if ($8db68999b7a3b326$var$skipAttributesToProps(element)) {
            (0, $aWr2r.setStyleProp)(element.attribs.style, element.attribs);
            props = element.attribs;
        } else if (element.attribs) props = (0, $8db68999b7a3b326$var$attributes_to_props_1.default)(element.attribs, element.name);
        var children = void 0;
        switch(node.type){
            case "script":
            case "style":
                // prevent text in <script> or <style> from being escaped
                // https://react.dev/reference/react-dom/components/common#dangerously-setting-the-inner-html
                if (node.children[0]) props.dangerouslySetInnerHTML = {
                    __html: node.children[0].data
                };
                break;
            case "tag":
                // setting textarea value in children is an antipattern in React
                // https://react.dev/reference/react-dom/components/textarea#caveats
                if (node.name === "textarea" && node.children[0]) props.defaultValue = node.children[0].data;
                else if (node.children && node.children.length) // continue recursion of creating React elements (if applicable)
                children = $8db68999b7a3b326$var$domToReact(node.children, options);
                break;
            // skip all other cases (e.g., comment)
            default:
                continue;
        }
        // set "key" prop for sibling elements
        // https://react.dev/learn/rendering-lists#rules-of-keys
        if (nodesLength > 1) props.key = index;
        reactElements.push(transform(createElement(node.name, props, children), node, index));
    }
    return reactElements.length === 1 ? reactElements[0] : reactElements;
}
/**
 * Determines whether DOM element attributes should be transformed to props.
 * Web Components should not have their attributes transformed except for `style`.
 *
 * @param node - Element node.
 * @returns - Whether the node attributes should be converted to props.
 */ function $8db68999b7a3b326$var$skipAttributesToProps(node) {
    return $aWr2r.PRESERVE_CUSTOM_ATTRIBUTES && node.type === "tag" && (0, $aWr2r.isCustomComponent)(node.name, node.attribs);
}

});

var $02de83db299f7983$exports = {};
"use strict";

$02de83db299f7983$exports = (parcelRequire("8j8zV"));


parcelRequire("aivMx");
var $86dae81a7d15f03f$export$882461b6382ed46c;
var $86dae81a7d15f03f$export$757ceba2d55c277e;
"use strict";
var $9f97ad3b314012cb$exports = {};
"use strict";
function $9f97ad3b314012cb$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($9f97ad3b314012cb$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$9f97ad3b314012cb$var$checkDCE();

$9f97ad3b314012cb$exports = (parcelRequire("gaHwe"));


var $86dae81a7d15f03f$var$i;
$86dae81a7d15f03f$export$882461b6382ed46c = $9f97ad3b314012cb$exports.createRoot;
$86dae81a7d15f03f$export$757ceba2d55c277e = $9f97ad3b314012cb$exports.hydrateRoot;


function $fa575a8859835fb5$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $fa575a8859835fb5$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $fa575a8859835fb5$export$2e2bcd8739ae039(o);
}



function $87d318f6d8110916$export$2e2bcd8739ae039(input, hint) {
    if ((0, $fa575a8859835fb5$export$2e2bcd8739ae039)(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((0, $fa575a8859835fb5$export$2e2bcd8739ae039)(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}


function $870a62074cbae60b$export$2e2bcd8739ae039(arg) {
    var key = (0, $87d318f6d8110916$export$2e2bcd8739ae039)(arg, "string");
    return (0, $fa575a8859835fb5$export$2e2bcd8739ae039)(key) === "symbol" ? key : String(key);
}


function $17254d86ba126058$export$2e2bcd8739ae039(obj, key, value) {
    key = (0, $870a62074cbae60b$export$2e2bcd8739ae039)(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $3400877ec9987019$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3400877ec9987019$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3400877ec9987019$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $17254d86ba126058$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3400877ec9987019$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}


/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $b4bc487a38c3f200$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + "use the non-minified dev environment for full errors. ";
}
// Inlined version of the `symbol-observable` polyfill
var $b4bc487a38c3f200$var$$$observable = function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $b4bc487a38c3f200$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split("").join(".");
};
var $b4bc487a38c3f200$export$4219e499db7ca678 = {
    INIT: "@@redux/INIT" + $b4bc487a38c3f200$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $b4bc487a38c3f200$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $b4bc487a38c3f200$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $b4bc487a38c3f200$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function $b4bc487a38c3f200$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    var type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($b4bc487a38c3f200$var$isDate(val)) return "date";
    if ($b4bc487a38c3f200$var$isError(val)) return "error";
    var constructorName = $b4bc487a38c3f200$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $b4bc487a38c3f200$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $b4bc487a38c3f200$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $b4bc487a38c3f200$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $b4bc487a38c3f200$var$kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function $b4bc487a38c3f200$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($b4bc487a38c3f200$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($b4bc487a38c3f200$var$formatProdErrorMessage(1));
        return enhancer($b4bc487a38c3f200$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    if (typeof reducer !== "function") throw new Error($b4bc487a38c3f200$var$formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error($b4bc487a38c3f200$var$formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($b4bc487a38c3f200$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($b4bc487a38c3f200$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($b4bc487a38c3f200$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$b4bc487a38c3f200$var$isPlainObject(action)) throw new Error($b4bc487a38c3f200$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($b4bc487a38c3f200$var$formatProdErrorMessage(8));
        if (isDispatching) throw new Error($b4bc487a38c3f200$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($b4bc487a38c3f200$var$formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $b4bc487a38c3f200$export$4219e499db7ca678.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($b4bc487a38c3f200$var$formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$b4bc487a38c3f200$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $b4bc487a38c3f200$export$4219e499db7ca678.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$b4bc487a38c3f200$var$$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var $b4bc487a38c3f200$export$8928921ea2d3b126 = $b4bc487a38c3f200$export$f51a9068ac82ea43;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $b4bc487a38c3f200$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function $b4bc487a38c3f200$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $b4bc487a38c3f200$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$b4bc487a38c3f200$var$isPlainObject(inputState)) return "The " + argumentName + ' has unexpected type of "' + $b4bc487a38c3f200$var$kindOf(inputState) + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $b4bc487a38c3f200$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? "keys" : "key") + " " + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
}
function $b4bc487a38c3f200$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: $b4bc487a38c3f200$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($b4bc487a38c3f200$var$formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: $b4bc487a38c3f200$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($b4bc487a38c3f200$var$formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function $b4bc487a38c3f200$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $b4bc487a38c3f200$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                var actionType = action && action.type;
                throw new Error($b4bc487a38c3f200$var$formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function $b4bc487a38c3f200$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function $b4bc487a38c3f200$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $b4bc487a38c3f200$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($b4bc487a38c3f200$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $b4bc487a38c3f200$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $b4bc487a38c3f200$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function $b4bc487a38c3f200$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error($b4bc487a38c3f200$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = $b4bc487a38c3f200$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
            return (0, $3400877ec9987019$export$2e2bcd8739ae039)((0, $3400877ec9987019$export$2e2bcd8739ae039)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}


var $05d10e651fe8cb91$var$createSymbol = function createSymbol(name) {
    return "@@redux-saga/" + name;
};
var $05d10e651fe8cb91$export$2b10f4b30fb65583 = /*#__PURE__*/ $05d10e651fe8cb91$var$createSymbol("CANCEL_PROMISE");
var $05d10e651fe8cb91$export$3281fbb3edc9dee3 = /*#__PURE__*/ $05d10e651fe8cb91$var$createSymbol("CHANNEL_END");
var $05d10e651fe8cb91$export$8f8422ac5947a789 = /*#__PURE__*/ $05d10e651fe8cb91$var$createSymbol("IO");
var $05d10e651fe8cb91$export$5a1a83be8f503735 = /*#__PURE__*/ $05d10e651fe8cb91$var$createSymbol("MATCH");
var $05d10e651fe8cb91$export$9074c4e62c4e51bb = /*#__PURE__*/ $05d10e651fe8cb91$var$createSymbol("MULTICAST");
var $05d10e651fe8cb91$export$7d963e45ecdffba1 = /*#__PURE__*/ $05d10e651fe8cb91$var$createSymbol("SAGA_ACTION");
var $05d10e651fe8cb91$export$3f4d38f8b89bfda7 = /*#__PURE__*/ $05d10e651fe8cb91$var$createSymbol("SELF_CANCELLATION");
var $05d10e651fe8cb91$export$9355e489ad16f98e = /*#__PURE__*/ $05d10e651fe8cb91$var$createSymbol("TASK");
var $05d10e651fe8cb91$export$a47f788ef0b36709 = /*#__PURE__*/ $05d10e651fe8cb91$var$createSymbol("TASK_CANCEL");
var $05d10e651fe8cb91$export$d966e43d90bf4c05 = /*#__PURE__*/ $05d10e651fe8cb91$var$createSymbol("TERMINATE");
var $05d10e651fe8cb91$export$bdae2c4f4f03305d = /*#__PURE__*/ $05d10e651fe8cb91$var$createSymbol("LOCATION");


function $6767be368738adce$export$2e2bcd8739ae039() {
    $6767be368738adce$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6767be368738adce$export$2e2bcd8739ae039.apply(this, arguments);
}


function $612ace97f19660e2$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var $8208d7224f148797$export$c7b6444af1f098df = function undef(v) {
    return v === null || v === undefined;
};
var $8208d7224f148797$export$1352885233577768 = function notUndef(v) {
    return v !== null && v !== undefined;
};
var $8208d7224f148797$export$86951950244e2001 = function func(f) {
    return typeof f === "function";
};
var $8208d7224f148797$export$98e628dec113755e = function number(n) {
    return typeof n === "number";
};
var $8208d7224f148797$export$22b082955e083ec3 = function string(s) {
    return typeof s === "string";
};
var $8208d7224f148797$export$2f23118c22fb2630 = Array.isArray;
var $8208d7224f148797$export$be5493f9613cbbe = function object(obj) {
    return obj && !$8208d7224f148797$export$2f23118c22fb2630(obj) && typeof obj === "object";
};
var $8208d7224f148797$export$c957ef27a0ebfd4 = function promise(p) {
    return p && $8208d7224f148797$export$86951950244e2001(p.then);
};
var $8208d7224f148797$export$6f58e2338da23f4d = function iterator(it) {
    return it && $8208d7224f148797$export$86951950244e2001(it.next) && $8208d7224f148797$export$86951950244e2001(it.throw);
};
var $8208d7224f148797$export$8e2ddbe84aff549 = function iterable(it) {
    return it && $8208d7224f148797$export$86951950244e2001(Symbol) ? $8208d7224f148797$export$86951950244e2001(it[Symbol.iterator]) : $8208d7224f148797$export$2f23118c22fb2630(it);
};
var $8208d7224f148797$export$94e939b87ca64fb4 = function task(t) {
    return t && t[0, $05d10e651fe8cb91$export$9355e489ad16f98e];
};
var $8208d7224f148797$export$2ce8c19c8dfba715 = function sagaAction(a) {
    return Boolean(a && a[0, $05d10e651fe8cb91$export$7d963e45ecdffba1]);
};
var $8208d7224f148797$export$5ab46cbf6120b33a = function observable(ob) {
    return ob && $8208d7224f148797$export$86951950244e2001(ob.subscribe);
};
var $8208d7224f148797$export$ab1029bcae9ddb4a = function buffer(buf) {
    return buf && $8208d7224f148797$export$86951950244e2001(buf.isEmpty) && $8208d7224f148797$export$86951950244e2001(buf.take) && $8208d7224f148797$export$86951950244e2001(buf.put);
};
var $8208d7224f148797$export$24f82734ea047e6f = function pattern(pat) {
    return pat && ($8208d7224f148797$export$22b082955e083ec3(pat) || $8208d7224f148797$export$8f701197936bc2a6(pat) || $8208d7224f148797$export$86951950244e2001(pat) || $8208d7224f148797$export$2f23118c22fb2630(pat) && pat.every(pattern));
};
var $8208d7224f148797$export$1f95fbd68d964d36 = function channel(ch) {
    return ch && $8208d7224f148797$export$86951950244e2001(ch.take) && $8208d7224f148797$export$86951950244e2001(ch.close);
};
var $8208d7224f148797$export$32b5e46230afa379 = function stringableFunc(f) {
    return $8208d7224f148797$export$86951950244e2001(f) && f.hasOwnProperty("toString");
};
var $8208d7224f148797$export$8f701197936bc2a6 = function symbol(sym) {
    return Boolean(sym) && typeof Symbol === "function" && sym.constructor === Symbol && sym !== Symbol.prototype;
};
var $8208d7224f148797$export$1364843af8d5a963 = function multicast(ch) {
    return $8208d7224f148797$export$1f95fbd68d964d36(ch) && ch[0, $05d10e651fe8cb91$export$9074c4e62c4e51bb];
};
var $8208d7224f148797$export$dc573d8a6576cdb3 = function effect(eff) {
    return eff && eff[0, $05d10e651fe8cb91$export$8f8422ac5947a789];
};






var $1c08c370c926c31e$var$MAX_SIGNED_INT = 2147483647;
function $1c08c370c926c31e$var$delayP(ms, val) {
    if (val === void 0) val = true;
    var timeoutId;
    var promise = new Promise(function(resolve) {
        timeoutId = setTimeout(resolve, Math.min($1c08c370c926c31e$var$MAX_SIGNED_INT, ms), val);
    });
    promise[0, $05d10e651fe8cb91$export$2b10f4b30fb65583] = function() {
        clearTimeout(timeoutId);
    };
    return promise;
}
var $1c08c370c926c31e$export$2e2bcd8739ae039 = $1c08c370c926c31e$var$delayP;


var $8f51be6e3f59daaa$var$konst = function konst(v) {
    return function() {
        return v;
    };
};
var $8f51be6e3f59daaa$export$342063e11d6c3cad = /*#__PURE__*/ $8f51be6e3f59daaa$var$konst(true);
var $8f51be6e3f59daaa$export$625550452a3fa3ec = function noop() {};
var $8f51be6e3f59daaa$export$a9c23c6ac3fc3eca = function identity(v) {
    return v;
};
var $8f51be6e3f59daaa$var$hasSymbol = typeof Symbol === "function";
var $8f51be6e3f59daaa$export$d141bba7fdc215a3 = $8f51be6e3f59daaa$var$hasSymbol && Symbol.asyncIterator ? Symbol.asyncIterator : "@@asyncIterator";
function $8f51be6e3f59daaa$export$db3b6bfb95261072(value, predicate, error) {
    if (!predicate(value)) throw new Error(error);
}
var $8f51be6e3f59daaa$export$ffb5f4729a158638 = function assignWithSymbols(target, source) {
    (0, $6767be368738adce$export$2e2bcd8739ae039)(target, source);
    if (Object.getOwnPropertySymbols) Object.getOwnPropertySymbols(source).forEach(function(s) {
        target[s] = source[s];
    });
};
var $8f51be6e3f59daaa$export$3b14a55fb2447963 = function flatMap(mapper, arr) {
    var _ref;
    return (_ref = []).concat.apply(_ref, arr.map(mapper));
};
function $8f51be6e3f59daaa$export$43caf9889c228507(array, item) {
    var index = array.indexOf(item);
    if (index >= 0) array.splice(index, 1);
}
function $8f51be6e3f59daaa$export$ae1af26003f05816(fn) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        fn();
    };
}
var $8f51be6e3f59daaa$var$kThrow = function kThrow(err) {
    throw err;
};
var $8f51be6e3f59daaa$var$kReturn = function kReturn(value) {
    return {
        value: value,
        done: true
    };
};
function $8f51be6e3f59daaa$export$9e5f44173e64f162(next, thro, name) {
    if (thro === void 0) thro = $8f51be6e3f59daaa$var$kThrow;
    if (name === void 0) name = "iterator";
    var iterator = {
        meta: {
            name: name
        },
        next: next,
        throw: thro,
        return: $8f51be6e3f59daaa$var$kReturn,
        isSagaIterator: true
    };
    if (typeof Symbol !== "undefined") iterator[Symbol.iterator] = function() {
        return iterator;
    };
    return iterator;
}
function $8f51be6e3f59daaa$export$ef35774e6d314e91(error, _ref2) {
    var sagaStack = _ref2.sagaStack;
    /*eslint-disable no-console*/ console.error(error);
    console.error(sagaStack);
}
var $8f51be6e3f59daaa$export$23f2a1d2818174ef = function internalErr(err) {
    return new Error("\n  redux-saga: Error checking hooks detected an inconsistent state. This is likely a bug\n  in redux-saga code and not yours. Thanks for reporting this in the project's github repo.\n  Error: " + err + "\n");
};
var $8f51be6e3f59daaa$export$efccba1c4a2ef57b = function createSetContextWarning(ctx, props) {
    return (ctx ? ctx + "." : "") + "setContext(props): argument " + props + " is not a plain object";
};
var $8f51be6e3f59daaa$var$FROZEN_ACTION_ERROR = "You can't put (a.k.a. dispatch from saga) frozen actions.\nWe have to define a special non-enumerable property on those actions for scheduling purposes.\nOtherwise you wouldn't be able to communicate properly between sagas & other subscribers (action ordering would become far less predictable).\nIf you are using redux and you care about this behaviour (frozen actions),\nthen you might want to switch to freezing actions in a middleware rather than in action creator.\nExample implementation:\n\nconst freezeActions = store => next => action => next(Object.freeze(action))\n"; // creates empty, but not-holey array
var $8f51be6e3f59daaa$export$953cecd6e717a553 = function createEmptyArray(n) {
    return Array.apply(null, new Array(n));
};
var $8f51be6e3f59daaa$export$96f57966bedc81b4 = function wrapSagaDispatch(dispatch) {
    return function(action) {
        return dispatch(Object.defineProperty(action, (0, $05d10e651fe8cb91$export$7d963e45ecdffba1), {
            value: true
        }));
    };
};
var $8f51be6e3f59daaa$export$df995fae86a55f06 = function shouldTerminate(res) {
    return res === (0, $05d10e651fe8cb91$export$d966e43d90bf4c05);
};
var $8f51be6e3f59daaa$export$4a5767248b18ef41 = function shouldCancel(res) {
    return res === (0, $05d10e651fe8cb91$export$a47f788ef0b36709);
};
var $8f51be6e3f59daaa$export$2408f22a0fab9ae5 = function shouldComplete(res) {
    return $8f51be6e3f59daaa$export$df995fae86a55f06(res) || $8f51be6e3f59daaa$export$4a5767248b18ef41(res);
};
function $8f51be6e3f59daaa$export$882b5998b3b9117c(shape, parentCallback) {
    var keys = Object.keys(shape);
    var totalCount = keys.length;
    var completedCount = 0;
    var completed;
    var results = (0, $8208d7224f148797$export$2f23118c22fb2630)(shape) ? $8f51be6e3f59daaa$export$953cecd6e717a553(totalCount) : {};
    var childCallbacks = {};
    function checkEnd() {
        if (completedCount === totalCount) {
            completed = true;
            parentCallback(results);
        }
    }
    keys.forEach(function(key) {
        var chCbAtKey = function chCbAtKey(res, isErr) {
            if (completed) return;
            if (isErr || $8f51be6e3f59daaa$export$2408f22a0fab9ae5(res)) {
                parentCallback.cancel();
                parentCallback(res, isErr);
            } else {
                results[key] = res;
                completedCount++;
                checkEnd();
            }
        };
        chCbAtKey.cancel = $8f51be6e3f59daaa$export$625550452a3fa3ec;
        childCallbacks[key] = chCbAtKey;
    });
    parentCallback.cancel = function() {
        if (!completed) {
            completed = true;
            keys.forEach(function(key) {
                return childCallbacks[key].cancel();
            });
        }
    };
    return childCallbacks;
}
function $8f51be6e3f59daaa$export$35e795649ee09318(fn) {
    return {
        name: fn.name || "anonymous",
        location: $8f51be6e3f59daaa$export$90a7f3efeed30595(fn)
    };
}
function $8f51be6e3f59daaa$export$90a7f3efeed30595(instrumented) {
    return instrumented[0, $05d10e651fe8cb91$export$bdae2c4f4f03305d];
}
var $8f51be6e3f59daaa$var$BUFFER_OVERFLOW = "Channel's Buffer overflow!";
var $8f51be6e3f59daaa$var$ON_OVERFLOW_THROW = 1;
var $8f51be6e3f59daaa$var$ON_OVERFLOW_DROP = 2;
var $8f51be6e3f59daaa$var$ON_OVERFLOW_SLIDE = 3;
var $8f51be6e3f59daaa$var$ON_OVERFLOW_EXPAND = 4;
var $8f51be6e3f59daaa$var$zeroBuffer = {
    isEmpty: $8f51be6e3f59daaa$export$342063e11d6c3cad,
    put: $8f51be6e3f59daaa$export$625550452a3fa3ec,
    take: $8f51be6e3f59daaa$export$625550452a3fa3ec
};
function $8f51be6e3f59daaa$var$ringBuffer(limit, overflowAction) {
    if (limit === void 0) limit = 10;
    var arr = new Array(limit);
    var length = 0;
    var pushIndex = 0;
    var popIndex = 0;
    var push = function push(it) {
        arr[pushIndex] = it;
        pushIndex = (pushIndex + 1) % limit;
        length++;
    };
    var take = function take() {
        if (length != 0) {
            var it = arr[popIndex];
            arr[popIndex] = null;
            length--;
            popIndex = (popIndex + 1) % limit;
            return it;
        }
    };
    var flush = function flush() {
        var items = [];
        while(length)items.push(take());
        return items;
    };
    return {
        isEmpty: function isEmpty() {
            return length == 0;
        },
        put: function put(it) {
            if (length < limit) push(it);
            else {
                var doubledLimit;
                switch(overflowAction){
                    case $8f51be6e3f59daaa$var$ON_OVERFLOW_THROW:
                        throw new Error($8f51be6e3f59daaa$var$BUFFER_OVERFLOW);
                    case $8f51be6e3f59daaa$var$ON_OVERFLOW_SLIDE:
                        arr[pushIndex] = it;
                        pushIndex = (pushIndex + 1) % limit;
                        popIndex = pushIndex;
                        break;
                    case $8f51be6e3f59daaa$var$ON_OVERFLOW_EXPAND:
                        doubledLimit = 2 * limit;
                        arr = flush();
                        length = arr.length;
                        pushIndex = arr.length;
                        popIndex = 0;
                        arr.length = doubledLimit;
                        limit = doubledLimit;
                        push(it);
                        break;
                    default:
                }
            }
        },
        take: take,
        flush: flush
    };
}
var $8f51be6e3f59daaa$export$7ccc53e8f1e7dfc5 = function none() {
    return $8f51be6e3f59daaa$var$zeroBuffer;
};
var $8f51be6e3f59daaa$var$fixed = function fixed(limit) {
    return $8f51be6e3f59daaa$var$ringBuffer(limit, $8f51be6e3f59daaa$var$ON_OVERFLOW_THROW);
};
var $8f51be6e3f59daaa$var$dropping = function dropping(limit) {
    return $8f51be6e3f59daaa$var$ringBuffer(limit, $8f51be6e3f59daaa$var$ON_OVERFLOW_DROP);
};
var $8f51be6e3f59daaa$export$3a6d5c9ae78a2c08 = function sliding(limit) {
    return $8f51be6e3f59daaa$var$ringBuffer(limit, $8f51be6e3f59daaa$var$ON_OVERFLOW_SLIDE);
};
var $8f51be6e3f59daaa$export$f1e1789686576879 = function expanding(initialSize) {
    return $8f51be6e3f59daaa$var$ringBuffer(initialSize, $8f51be6e3f59daaa$var$ON_OVERFLOW_EXPAND);
};
var $8f51be6e3f59daaa$export$7f8ddf7c7c20b3cd = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    none: $8f51be6e3f59daaa$export$7ccc53e8f1e7dfc5,
    fixed: $8f51be6e3f59daaa$var$fixed,
    dropping: $8f51be6e3f59daaa$var$dropping,
    sliding: $8f51be6e3f59daaa$export$3a6d5c9ae78a2c08,
    expanding: $8f51be6e3f59daaa$export$f1e1789686576879
});
var $8f51be6e3f59daaa$export$971d5caa766a69d7 = "TAKE";
var $8f51be6e3f59daaa$export$56c0d5a1e737357d = "PUT";
var $8f51be6e3f59daaa$export$ebd11618f299a286 = "ALL";
var $8f51be6e3f59daaa$export$db202ddc8be9136 = "RACE";
var $8f51be6e3f59daaa$export$e7094788287c5e9b = "CALL";
var $8f51be6e3f59daaa$export$407448d2b89b1813 = "CPS";
var $8f51be6e3f59daaa$export$d66501df72047452 = "FORK";
var $8f51be6e3f59daaa$export$b4171a6734a65d42 = "JOIN";
var $8f51be6e3f59daaa$export$8b22cf2602fb60ce = "CANCEL";
var $8f51be6e3f59daaa$export$25ce5a424b770e84 = "SELECT";
var $8f51be6e3f59daaa$export$4368d992c4eafac0 = "ACTION_CHANNEL";
var $8f51be6e3f59daaa$export$2d1720544b23b823 = "CANCELLED";
var $8f51be6e3f59daaa$export$39b482c5e57630a8 = "FLUSH";
var $8f51be6e3f59daaa$export$2329c99376c9d0a4 = "GET_CONTEXT";
var $8f51be6e3f59daaa$export$dda1d9f60106f0e9 = "SET_CONTEXT";
var $8f51be6e3f59daaa$export$71cec2538cb2c617 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    TAKE: $8f51be6e3f59daaa$export$971d5caa766a69d7,
    PUT: $8f51be6e3f59daaa$export$56c0d5a1e737357d,
    ALL: $8f51be6e3f59daaa$export$ebd11618f299a286,
    RACE: $8f51be6e3f59daaa$export$db202ddc8be9136,
    CALL: $8f51be6e3f59daaa$export$e7094788287c5e9b,
    CPS: $8f51be6e3f59daaa$export$407448d2b89b1813,
    FORK: $8f51be6e3f59daaa$export$d66501df72047452,
    JOIN: $8f51be6e3f59daaa$export$b4171a6734a65d42,
    CANCEL: $8f51be6e3f59daaa$export$8b22cf2602fb60ce,
    SELECT: $8f51be6e3f59daaa$export$25ce5a424b770e84,
    ACTION_CHANNEL: $8f51be6e3f59daaa$export$4368d992c4eafac0,
    CANCELLED: $8f51be6e3f59daaa$export$2d1720544b23b823,
    FLUSH: $8f51be6e3f59daaa$export$39b482c5e57630a8,
    GET_CONTEXT: $8f51be6e3f59daaa$export$2329c99376c9d0a4,
    SET_CONTEXT: $8f51be6e3f59daaa$export$dda1d9f60106f0e9
});
var $8f51be6e3f59daaa$var$TEST_HINT = "\n(HINT: if you are getting these errors in tests, consider using createMockTask from @redux-saga/testing-utils)";
var $8f51be6e3f59daaa$var$makeEffect = function makeEffect(type, payload) {
    var _ref;
    return _ref = {}, _ref[0, $05d10e651fe8cb91$export$8f8422ac5947a789] = true, _ref.combinator = false, _ref.type = type, _ref.payload = payload, _ref;
};
var $8f51be6e3f59daaa$var$isForkEffect = function isForkEffect(eff) {
    return (0, $8208d7224f148797$export$dc573d8a6576cdb3)(eff) && eff.type === $8f51be6e3f59daaa$export$d66501df72047452;
};
var $8f51be6e3f59daaa$export$9bb611d729802a56 = function detach(eff) {
    return $8f51be6e3f59daaa$var$makeEffect($8f51be6e3f59daaa$export$d66501df72047452, (0, $6767be368738adce$export$2e2bcd8739ae039)({}, eff.payload, {
        detached: true
    }));
};
function $8f51be6e3f59daaa$export$3466f893ebf79586(patternOrChannel, multicastPattern) {
    if (patternOrChannel === void 0) patternOrChannel = "*";
    if ((0, $8208d7224f148797$export$24f82734ea047e6f)(patternOrChannel)) {
        if ((0, $8208d7224f148797$export$1352885233577768)(multicastPattern)) /* eslint-disable no-console */ console.warn("take(pattern) takes one argument but two were provided. Consider passing an array for listening to several action types");
        return $8f51be6e3f59daaa$var$makeEffect($8f51be6e3f59daaa$export$971d5caa766a69d7, {
            pattern: patternOrChannel
        });
    }
    if ((0, $8208d7224f148797$export$1364843af8d5a963)(patternOrChannel) && (0, $8208d7224f148797$export$1352885233577768)(multicastPattern) && (0, $8208d7224f148797$export$24f82734ea047e6f)(multicastPattern)) return $8f51be6e3f59daaa$var$makeEffect($8f51be6e3f59daaa$export$971d5caa766a69d7, {
        channel: patternOrChannel,
        pattern: multicastPattern
    });
    if ((0, $8208d7224f148797$export$1f95fbd68d964d36)(patternOrChannel)) {
        if ((0, $8208d7224f148797$export$1352885233577768)(multicastPattern)) /* eslint-disable no-console */ console.warn("take(channel) takes one argument but two were provided. Second argument is ignored.");
        return $8f51be6e3f59daaa$var$makeEffect($8f51be6e3f59daaa$export$971d5caa766a69d7, {
            channel: patternOrChannel
        });
    }
}
var $8f51be6e3f59daaa$export$78acf4525d8a74c4 = function takeMaybe() {
    var eff = $8f51be6e3f59daaa$export$3466f893ebf79586.apply(void 0, arguments);
    eff.payload.maybe = true;
    return eff;
};
function $8f51be6e3f59daaa$export$8743009a87fcb00f(channel$1, action) {
    if ((0, $8208d7224f148797$export$c7b6444af1f098df)(action)) {
        action = channel$1; // `undefined` instead of `null` to make default parameter work
        channel$1 = undefined;
    }
    return $8f51be6e3f59daaa$var$makeEffect($8f51be6e3f59daaa$export$56c0d5a1e737357d, {
        channel: channel$1,
        action: action
    });
}
var $8f51be6e3f59daaa$export$dc98b0b04f4c7758 = function putResolve() {
    var eff = $8f51be6e3f59daaa$export$8743009a87fcb00f.apply(void 0, arguments);
    eff.payload.resolve = true;
    return eff;
};
function $8f51be6e3f59daaa$export$71511d61b312f219(effects) {
    var eff = $8f51be6e3f59daaa$var$makeEffect($8f51be6e3f59daaa$export$ebd11618f299a286, effects);
    eff.combinator = true;
    return eff;
}
function $8f51be6e3f59daaa$export$e7c866399fa523f5(effects) {
    var eff = $8f51be6e3f59daaa$var$makeEffect($8f51be6e3f59daaa$export$db202ddc8be9136, effects);
    eff.combinator = true;
    return eff;
} // this match getFnCallDescriptor logic
var $8f51be6e3f59daaa$var$validateFnDescriptor = function validateFnDescriptor(effectName, fnDescriptor) {
    $8f51be6e3f59daaa$export$db3b6bfb95261072(fnDescriptor, (0, $8208d7224f148797$export$1352885233577768), effectName + ": argument fn is undefined or null");
    if ((0, $8208d7224f148797$export$86951950244e2001)(fnDescriptor)) return;
    var context = null;
    var fn;
    if ((0, $8208d7224f148797$export$2f23118c22fb2630)(fnDescriptor)) {
        context = fnDescriptor[0];
        fn = fnDescriptor[1];
        $8f51be6e3f59daaa$export$db3b6bfb95261072(fn, (0, $8208d7224f148797$export$1352885233577768), effectName + ": argument of type [context, fn] has undefined or null `fn`");
    } else if ((0, $8208d7224f148797$export$be5493f9613cbbe)(fnDescriptor)) {
        context = fnDescriptor.context;
        fn = fnDescriptor.fn;
        $8f51be6e3f59daaa$export$db3b6bfb95261072(fn, (0, $8208d7224f148797$export$1352885233577768), effectName + ": argument of type {context, fn} has undefined or null `fn`");
    } else {
        $8f51be6e3f59daaa$export$db3b6bfb95261072(fnDescriptor, (0, $8208d7224f148797$export$86951950244e2001), effectName + ": argument fn is not function");
        return;
    }
    if (context && (0, $8208d7224f148797$export$22b082955e083ec3)(fn)) {
        $8f51be6e3f59daaa$export$db3b6bfb95261072(context[fn], (0, $8208d7224f148797$export$86951950244e2001), effectName + ': context arguments has no such method - "' + fn + '"');
        return;
    }
    $8f51be6e3f59daaa$export$db3b6bfb95261072(fn, (0, $8208d7224f148797$export$86951950244e2001), effectName + ": unpacked fn argument (from [context, fn] or {context, fn}) is not a function");
};
function $8f51be6e3f59daaa$var$getFnCallDescriptor(fnDescriptor, args) {
    var context = null;
    var fn;
    if ((0, $8208d7224f148797$export$86951950244e2001)(fnDescriptor)) fn = fnDescriptor;
    else {
        if ((0, $8208d7224f148797$export$2f23118c22fb2630)(fnDescriptor)) {
            context = fnDescriptor[0];
            fn = fnDescriptor[1];
        } else {
            context = fnDescriptor.context;
            fn = fnDescriptor.fn;
        }
        if (context && (0, $8208d7224f148797$export$22b082955e083ec3)(fn) && (0, $8208d7224f148797$export$86951950244e2001)(context[fn])) fn = context[fn];
    }
    return {
        context: context,
        fn: fn,
        args: args
    };
}
var $8f51be6e3f59daaa$var$isNotDelayEffect = function isNotDelayEffect(fn) {
    return fn !== $8f51be6e3f59daaa$export$c4ce752e73470fba;
};
function $8f51be6e3f59daaa$export$a07804094c3ecf2d(fnDescriptor) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    var arg0;
    return $8f51be6e3f59daaa$var$makeEffect($8f51be6e3f59daaa$export$e7094788287c5e9b, $8f51be6e3f59daaa$var$getFnCallDescriptor(fnDescriptor, args));
}
function $8f51be6e3f59daaa$export$3d8c2f653ac9d0b9(context, fn, args) {
    if (args === void 0) args = [];
    var fnDescriptor = [
        context,
        fn
    ];
    return $8f51be6e3f59daaa$var$makeEffect($8f51be6e3f59daaa$export$e7094788287c5e9b, $8f51be6e3f59daaa$var$getFnCallDescriptor([
        context,
        fn
    ], args));
}
function $8f51be6e3f59daaa$export$34aec0b863436764(fnDescriptor) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    return $8f51be6e3f59daaa$var$makeEffect($8f51be6e3f59daaa$export$407448d2b89b1813, $8f51be6e3f59daaa$var$getFnCallDescriptor(fnDescriptor, args));
}
function $8f51be6e3f59daaa$export$61196ced6d74a310(fnDescriptor) {
    for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
    return $8f51be6e3f59daaa$var$makeEffect($8f51be6e3f59daaa$export$d66501df72047452, $8f51be6e3f59daaa$var$getFnCallDescriptor(fnDescriptor, args));
}
function $8f51be6e3f59daaa$export$3c2fa207a37baaea(fnDescriptor) {
    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
    return $8f51be6e3f59daaa$export$9bb611d729802a56($8f51be6e3f59daaa$export$61196ced6d74a310.apply(void 0, [
        fnDescriptor
    ].concat(args)));
}
function $8f51be6e3f59daaa$export$ce26c07117d59d6a(taskOrTasks) {
    return $8f51be6e3f59daaa$var$makeEffect($8f51be6e3f59daaa$export$b4171a6734a65d42, taskOrTasks);
}
function $8f51be6e3f59daaa$export$3a1a48c8f6ef640e(taskOrTasks) {
    if (taskOrTasks === void 0) taskOrTasks = (0, $05d10e651fe8cb91$export$3f4d38f8b89bfda7);
    return $8f51be6e3f59daaa$var$makeEffect($8f51be6e3f59daaa$export$8b22cf2602fb60ce, taskOrTasks);
}
function $8f51be6e3f59daaa$export$6559d589eb85fbb6(selector) {
    if (selector === void 0) selector = $8f51be6e3f59daaa$export$a9c23c6ac3fc3eca;
    for(var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++)args[_key5 - 1] = arguments[_key5];
    return $8f51be6e3f59daaa$var$makeEffect($8f51be6e3f59daaa$export$25ce5a424b770e84, {
        selector: selector,
        args: args
    });
}
/**
  channel(pattern, [buffer])    => creates a proxy channel for store actions
**/ function $8f51be6e3f59daaa$export$3722cfe417b6ed86(pattern$1, buffer$1) {
    return $8f51be6e3f59daaa$var$makeEffect($8f51be6e3f59daaa$export$4368d992c4eafac0, {
        pattern: pattern$1,
        buffer: buffer$1
    });
}
function $8f51be6e3f59daaa$export$efca4cbe5dd06740() {
    return $8f51be6e3f59daaa$var$makeEffect($8f51be6e3f59daaa$export$2d1720544b23b823, {});
}
function $8f51be6e3f59daaa$export$a8550f7dbe79f93a(channel$1) {
    return $8f51be6e3f59daaa$var$makeEffect($8f51be6e3f59daaa$export$39b482c5e57630a8, channel$1);
}
function $8f51be6e3f59daaa$export$2e2af4578d910ddf(prop) {
    return $8f51be6e3f59daaa$var$makeEffect($8f51be6e3f59daaa$export$2329c99376c9d0a4, prop);
}
function $8f51be6e3f59daaa$export$a93c5207d687da10(props) {
    return $8f51be6e3f59daaa$var$makeEffect($8f51be6e3f59daaa$export$dda1d9f60106f0e9, props);
}
var $8f51be6e3f59daaa$export$c4ce752e73470fba = /*#__PURE__*/ $8f51be6e3f59daaa$export$a07804094c3ecf2d.bind(null, (0, $1c08c370c926c31e$export$2e2bcd8739ae039));



function $973b2c0da971f80e$var$deferred() {
    var def = {};
    def.promise = new Promise(function(resolve, reject) {
        def.resolve = resolve;
        def.reject = reject;
    });
    return def;
}
function $973b2c0da971f80e$export$368f32fb8739d33c(length) {
    var arr = [];
    for(var i = 0; i < length; i++)arr.push($973b2c0da971f80e$var$deferred());
    return arr;
}
var $973b2c0da971f80e$export$2e2bcd8739ae039 = $973b2c0da971f80e$var$deferred;



var $c2bb61c8a2f6b79d$var$queue = [];
/**
  Variable to hold a counting semaphore
  - Incrementing adds a lock and puts the scheduler in a `suspended` state (if it's not
    already suspended)
  - Decrementing releases a lock. Zero locks puts the scheduler in a `released` state. This
    triggers flushing the queued tasks.
**/ var $c2bb61c8a2f6b79d$var$semaphore = 0;
/**
  Executes a task 'atomically'. Tasks scheduled during this execution will be queued
  and flushed after this task has finished (assuming the scheduler endup in a released
  state).
**/ function $c2bb61c8a2f6b79d$var$exec(task) {
    try {
        $c2bb61c8a2f6b79d$var$suspend();
        task();
    } finally{
        $c2bb61c8a2f6b79d$var$release();
    }
}
/**
  Executes or queues a task depending on the state of the scheduler (`suspended` or `released`)
**/ function $c2bb61c8a2f6b79d$var$asap(task) {
    $c2bb61c8a2f6b79d$var$queue.push(task);
    if (!$c2bb61c8a2f6b79d$var$semaphore) {
        $c2bb61c8a2f6b79d$var$suspend();
        $c2bb61c8a2f6b79d$var$flush();
    }
}
/**
 * Puts the scheduler in a `suspended` state and executes a task immediately.
 */ function $c2bb61c8a2f6b79d$var$immediately(task) {
    try {
        $c2bb61c8a2f6b79d$var$suspend();
        return task();
    } finally{
        $c2bb61c8a2f6b79d$var$flush();
    }
}
/**
  Puts the scheduler in a `suspended` state. Scheduled tasks will be queued until the
  scheduler is released.
**/ function $c2bb61c8a2f6b79d$var$suspend() {
    $c2bb61c8a2f6b79d$var$semaphore++;
}
/**
  Puts the scheduler in a `released` state.
**/ function $c2bb61c8a2f6b79d$var$release() {
    $c2bb61c8a2f6b79d$var$semaphore--;
}
/**
  Releases the current lock. Executes all queued tasks if the scheduler is in the released state.
**/ function $c2bb61c8a2f6b79d$var$flush() {
    $c2bb61c8a2f6b79d$var$release();
    var task;
    while(!$c2bb61c8a2f6b79d$var$semaphore && (task = $c2bb61c8a2f6b79d$var$queue.shift()) !== undefined)$c2bb61c8a2f6b79d$var$exec(task);
}
var $c2bb61c8a2f6b79d$var$array = function array(patterns) {
    return function(input) {
        return patterns.some(function(p) {
            return $c2bb61c8a2f6b79d$var$matcher(p)(input);
        });
    };
};
var $c2bb61c8a2f6b79d$var$predicate = function predicate(_predicate) {
    return function(input) {
        return _predicate(input);
    };
};
var $c2bb61c8a2f6b79d$var$string = function string(pattern) {
    return function(input) {
        return input.type === String(pattern);
    };
};
var $c2bb61c8a2f6b79d$var$symbol = function symbol(pattern) {
    return function(input) {
        return input.type === pattern;
    };
};
var $c2bb61c8a2f6b79d$var$wildcard = function wildcard() {
    return 0, $8f51be6e3f59daaa$export$342063e11d6c3cad;
};
function $c2bb61c8a2f6b79d$var$matcher(pattern) {
    // prettier-ignore
    var matcherCreator = pattern === "*" ? $c2bb61c8a2f6b79d$var$wildcard : (0, $8208d7224f148797$export$22b082955e083ec3)(pattern) ? $c2bb61c8a2f6b79d$var$string : (0, $8208d7224f148797$export$2f23118c22fb2630)(pattern) ? $c2bb61c8a2f6b79d$var$array : (0, $8208d7224f148797$export$32b5e46230afa379)(pattern) ? $c2bb61c8a2f6b79d$var$string : (0, $8208d7224f148797$export$86951950244e2001)(pattern) ? $c2bb61c8a2f6b79d$var$predicate : (0, $8208d7224f148797$export$8f701197936bc2a6)(pattern) ? $c2bb61c8a2f6b79d$var$symbol : null;
    if (matcherCreator === null) throw new Error("invalid pattern: " + pattern);
    return matcherCreator(pattern);
}
var $c2bb61c8a2f6b79d$export$32239d68d9c6cb49 = {
    type: (0, $05d10e651fe8cb91$export$3281fbb3edc9dee3)
};
var $c2bb61c8a2f6b79d$export$42af6f45c6e0d09f = function isEnd(a) {
    return a && a.type === (0, $05d10e651fe8cb91$export$3281fbb3edc9dee3);
};
var $c2bb61c8a2f6b79d$var$CLOSED_CHANNEL_WITH_TAKERS = "Cannot have a closed channel with pending takers";
var $c2bb61c8a2f6b79d$var$INVALID_BUFFER = "invalid buffer passed to channel factory function";
var $c2bb61c8a2f6b79d$var$UNDEFINED_INPUT_ERROR = "Saga or channel was provided with an undefined action\nHints:\n  - check that your Action Creator returns a non-undefined value\n  - if the Saga was started using runSaga, check that your subscribe source provides the action to its listeners";
function $c2bb61c8a2f6b79d$export$1f95fbd68d964d36(buffer$1) {
    if (buffer$1 === void 0) buffer$1 = (0, $8f51be6e3f59daaa$export$f1e1789686576879)();
    var closed = false;
    var takers = [];
    function checkForbiddenStates() {
        if (closed && takers.length) throw (0, $8f51be6e3f59daaa$export$23f2a1d2818174ef)($c2bb61c8a2f6b79d$var$CLOSED_CHANNEL_WITH_TAKERS);
        if (takers.length && !buffer$1.isEmpty()) throw (0, $8f51be6e3f59daaa$export$23f2a1d2818174ef)("Cannot have pending takers with non empty buffer");
    }
    function put(input) {
        if (closed) return;
        if (takers.length === 0) return buffer$1.put(input);
        var cb = takers.shift();
        cb(input);
    }
    function take(cb) {
        if (closed && buffer$1.isEmpty()) cb($c2bb61c8a2f6b79d$export$32239d68d9c6cb49);
        else if (!buffer$1.isEmpty()) cb(buffer$1.take());
        else {
            takers.push(cb);
            cb.cancel = function() {
                (0, $8f51be6e3f59daaa$export$43caf9889c228507)(takers, cb);
            };
        }
    }
    function flush(cb) {
        if (closed && buffer$1.isEmpty()) {
            cb($c2bb61c8a2f6b79d$export$32239d68d9c6cb49);
            return;
        }
        cb(buffer$1.flush());
    }
    function close() {
        if (closed) return;
        closed = true;
        var arr = takers;
        takers = [];
        for(var i = 0, len = arr.length; i < len; i++){
            var taker = arr[i];
            taker($c2bb61c8a2f6b79d$export$32239d68d9c6cb49);
        }
    }
    return {
        take: take,
        put: put,
        flush: flush,
        close: close
    };
}
function $c2bb61c8a2f6b79d$export$dfc3101b3180c292(subscribe, buffer) {
    if (buffer === void 0) buffer = (0, $8f51be6e3f59daaa$export$7ccc53e8f1e7dfc5)();
    var closed = false;
    var unsubscribe;
    var chan = $c2bb61c8a2f6b79d$export$1f95fbd68d964d36(buffer);
    var close = function close() {
        if (closed) return;
        closed = true;
        if ((0, $8208d7224f148797$export$86951950244e2001)(unsubscribe)) unsubscribe();
        chan.close();
    };
    unsubscribe = subscribe(function(input) {
        if ($c2bb61c8a2f6b79d$export$42af6f45c6e0d09f(input)) {
            close();
            return;
        }
        chan.put(input);
    });
    unsubscribe = (0, $8f51be6e3f59daaa$export$ae1af26003f05816)(unsubscribe);
    if (closed) unsubscribe();
    return {
        take: chan.take,
        flush: chan.flush,
        close: close
    };
}
function $c2bb61c8a2f6b79d$export$438eddf2fd884f37() {
    var _ref;
    var closed = false;
    var currentTakers = [];
    var nextTakers = currentTakers;
    function checkForbiddenStates() {
        if (closed && nextTakers.length) throw (0, $8f51be6e3f59daaa$export$23f2a1d2818174ef)($c2bb61c8a2f6b79d$var$CLOSED_CHANNEL_WITH_TAKERS);
    }
    var ensureCanMutateNextTakers = function ensureCanMutateNextTakers() {
        if (nextTakers !== currentTakers) return;
        nextTakers = currentTakers.slice();
    };
    var close = function close() {
        closed = true;
        var takers = currentTakers = nextTakers;
        nextTakers = [];
        takers.forEach(function(taker) {
            taker($c2bb61c8a2f6b79d$export$32239d68d9c6cb49);
        });
    };
    return _ref = {}, _ref[0, $05d10e651fe8cb91$export$9074c4e62c4e51bb] = true, _ref.put = function put(input) {
        if (closed) return;
        if ($c2bb61c8a2f6b79d$export$42af6f45c6e0d09f(input)) {
            close();
            return;
        }
        var takers = currentTakers = nextTakers;
        for(var i = 0, len = takers.length; i < len; i++){
            var taker = takers[i];
            if (taker[0, $05d10e651fe8cb91$export$5a1a83be8f503735](input)) {
                taker.cancel();
                taker(input);
            }
        }
    }, _ref.take = function take(cb, matcher) {
        if (matcher === void 0) matcher = $c2bb61c8a2f6b79d$var$wildcard;
        if (closed) {
            cb($c2bb61c8a2f6b79d$export$32239d68d9c6cb49);
            return;
        }
        cb[0, $05d10e651fe8cb91$export$5a1a83be8f503735] = matcher;
        ensureCanMutateNextTakers();
        nextTakers.push(cb);
        cb.cancel = (0, $8f51be6e3f59daaa$export$ae1af26003f05816)(function() {
            ensureCanMutateNextTakers();
            (0, $8f51be6e3f59daaa$export$43caf9889c228507)(nextTakers, cb);
        });
    }, _ref.close = close, _ref;
}
function $c2bb61c8a2f6b79d$export$e987d166a3a4f3ec() {
    var chan = $c2bb61c8a2f6b79d$export$438eddf2fd884f37();
    var put = chan.put;
    chan.put = function(input) {
        if (input[0, $05d10e651fe8cb91$export$7d963e45ecdffba1]) {
            put(input);
            return;
        }
        $c2bb61c8a2f6b79d$var$asap(function() {
            put(input);
        });
    };
    return chan;
}
var $c2bb61c8a2f6b79d$var$RUNNING = 0;
var $c2bb61c8a2f6b79d$var$CANCELLED = 1;
var $c2bb61c8a2f6b79d$var$ABORTED = 2;
var $c2bb61c8a2f6b79d$var$DONE = 3;
function $c2bb61c8a2f6b79d$var$resolvePromise(promise, cb) {
    var cancelPromise = promise[0, $05d10e651fe8cb91$export$2b10f4b30fb65583];
    if ((0, $8208d7224f148797$export$86951950244e2001)(cancelPromise)) cb.cancel = cancelPromise;
    promise.then(cb, function(error) {
        cb(error, true);
    });
}
var $c2bb61c8a2f6b79d$var$current = 0;
var $c2bb61c8a2f6b79d$var$nextSagaId = function() {
    return ++$c2bb61c8a2f6b79d$var$current;
};
var $c2bb61c8a2f6b79d$var$_effectRunnerMap;
function $c2bb61c8a2f6b79d$var$getIteratorMetaInfo(iterator, fn) {
    if (iterator.isSagaIterator) return {
        name: iterator.meta.name
    };
    return (0, $8f51be6e3f59daaa$export$35e795649ee09318)(fn);
}
function $c2bb61c8a2f6b79d$var$createTaskIterator(_ref) {
    var context = _ref.context, fn = _ref.fn, args = _ref.args;
    // catch synchronous failures; see #152 and #441
    try {
        var result = fn.apply(context, args); // i.e. a generator function returns an iterator
        if ((0, $8208d7224f148797$export$6f58e2338da23f4d)(result)) return result;
        var resolved = false;
        var next = function next(arg) {
            if (!resolved) {
                resolved = true; // Only promises returned from fork will be interpreted. See #1573
                return {
                    value: result,
                    done: !(0, $8208d7224f148797$export$c957ef27a0ebfd4)(result)
                };
            } else return {
                value: arg,
                done: true
            };
        };
        return (0, $8f51be6e3f59daaa$export$9e5f44173e64f162)(next);
    } catch (err) {
        // do not bubble up synchronous failures for detached forks
        // instead create a failed task. See #152 and #441
        return (0, $8f51be6e3f59daaa$export$9e5f44173e64f162)(function() {
            throw err;
        });
    }
}
function $c2bb61c8a2f6b79d$var$runPutEffect(env, _ref2, cb) {
    var channel = _ref2.channel, action = _ref2.action, resolve = _ref2.resolve;
    /**
   Schedule the put in case another saga is holding a lock.
   The put will be executed atomically. ie nested puts will execute after
   this put has terminated.
   **/ $c2bb61c8a2f6b79d$var$asap(function() {
        var result;
        try {
            result = (channel ? channel.put : env.dispatch)(action);
        } catch (error) {
            cb(error, true);
            return;
        }
        if (resolve && (0, $8208d7224f148797$export$c957ef27a0ebfd4)(result)) $c2bb61c8a2f6b79d$var$resolvePromise(result, cb);
        else cb(result);
    }); // Put effects are non cancellables
}
function $c2bb61c8a2f6b79d$var$runTakeEffect(env, _ref3, cb) {
    var _ref3$channel = _ref3.channel, channel = _ref3$channel === void 0 ? env.channel : _ref3$channel, pattern = _ref3.pattern, maybe = _ref3.maybe;
    var takeCb = function takeCb(input) {
        if (input instanceof Error) {
            cb(input, true);
            return;
        }
        if ($c2bb61c8a2f6b79d$export$42af6f45c6e0d09f(input) && !maybe) {
            cb((0, $05d10e651fe8cb91$export$d966e43d90bf4c05));
            return;
        }
        cb(input);
    };
    try {
        channel.take(takeCb, (0, $8208d7224f148797$export$1352885233577768)(pattern) ? $c2bb61c8a2f6b79d$var$matcher(pattern) : null);
    } catch (err) {
        cb(err, true);
        return;
    }
    cb.cancel = takeCb.cancel;
}
function $c2bb61c8a2f6b79d$var$runCallEffect(env, _ref4, cb, _ref5) {
    var context = _ref4.context, fn = _ref4.fn, args = _ref4.args;
    var task = _ref5.task;
    // catch synchronous failures; see #152
    try {
        var result = fn.apply(context, args);
        if ((0, $8208d7224f148797$export$c957ef27a0ebfd4)(result)) {
            $c2bb61c8a2f6b79d$var$resolvePromise(result, cb);
            return;
        }
        if ((0, $8208d7224f148797$export$6f58e2338da23f4d)(result)) {
            // resolve iterator
            $c2bb61c8a2f6b79d$var$proc(env, result, task.context, $c2bb61c8a2f6b79d$var$current, (0, $8f51be6e3f59daaa$export$35e795649ee09318)(fn), /* isRoot */ false, cb);
            return;
        }
        cb(result);
    } catch (error) {
        cb(error, true);
    }
}
function $c2bb61c8a2f6b79d$var$runCPSEffect(env, _ref6, cb) {
    var context = _ref6.context, fn = _ref6.fn, args = _ref6.args;
    // CPS (ie node style functions) can define their own cancellation logic
    // by setting cancel field on the cb
    // catch synchronous failures; see #152
    try {
        var cpsCb = function cpsCb(err, res) {
            if ((0, $8208d7224f148797$export$c7b6444af1f098df)(err)) cb(res);
            else cb(err, true);
        };
        fn.apply(context, args.concat(cpsCb));
        if (cpsCb.cancel) cb.cancel = cpsCb.cancel;
    } catch (error) {
        cb(error, true);
    }
}
function $c2bb61c8a2f6b79d$var$runForkEffect(env, _ref7, cb, _ref8) {
    var context = _ref7.context, fn = _ref7.fn, args = _ref7.args, detached = _ref7.detached;
    var parent = _ref8.task;
    var taskIterator = $c2bb61c8a2f6b79d$var$createTaskIterator({
        context: context,
        fn: fn,
        args: args
    });
    var meta = $c2bb61c8a2f6b79d$var$getIteratorMetaInfo(taskIterator, fn);
    $c2bb61c8a2f6b79d$var$immediately(function() {
        var child = $c2bb61c8a2f6b79d$var$proc(env, taskIterator, parent.context, $c2bb61c8a2f6b79d$var$current, meta, detached, undefined);
        if (detached) cb(child);
        else {
            if (child.isRunning()) {
                parent.queue.addTask(child);
                cb(child);
            } else if (child.isAborted()) parent.queue.abort(child.error());
            else cb(child);
        }
    }); // Fork effects are non cancellables
}
function $c2bb61c8a2f6b79d$var$runJoinEffect(env, taskOrTasks, cb, _ref9) {
    var task = _ref9.task;
    var joinSingleTask = function joinSingleTask(taskToJoin, cb) {
        if (taskToJoin.isRunning()) {
            var joiner = {
                task: task,
                cb: cb
            };
            cb.cancel = function() {
                if (taskToJoin.isRunning()) (0, $8f51be6e3f59daaa$export$43caf9889c228507)(taskToJoin.joiners, joiner);
            };
            taskToJoin.joiners.push(joiner);
        } else if (taskToJoin.isAborted()) cb(taskToJoin.error(), true);
        else cb(taskToJoin.result());
    };
    if ((0, $8208d7224f148797$export$2f23118c22fb2630)(taskOrTasks)) {
        if (taskOrTasks.length === 0) {
            cb([]);
            return;
        }
        var childCallbacks = (0, $8f51be6e3f59daaa$export$882b5998b3b9117c)(taskOrTasks, cb);
        taskOrTasks.forEach(function(t, i) {
            joinSingleTask(t, childCallbacks[i]);
        });
    } else joinSingleTask(taskOrTasks, cb);
}
function $c2bb61c8a2f6b79d$var$cancelSingleTask(taskToCancel) {
    if (taskToCancel.isRunning()) taskToCancel.cancel();
}
function $c2bb61c8a2f6b79d$var$runCancelEffect(env, taskOrTasks, cb, _ref10) {
    var task = _ref10.task;
    if (taskOrTasks === (0, $05d10e651fe8cb91$export$3f4d38f8b89bfda7)) $c2bb61c8a2f6b79d$var$cancelSingleTask(task);
    else if ((0, $8208d7224f148797$export$2f23118c22fb2630)(taskOrTasks)) taskOrTasks.forEach($c2bb61c8a2f6b79d$var$cancelSingleTask);
    else $c2bb61c8a2f6b79d$var$cancelSingleTask(taskOrTasks);
    cb(); // cancel effects are non cancellables
}
function $c2bb61c8a2f6b79d$var$runAllEffect(env, effects, cb, _ref11) {
    var digestEffect = _ref11.digestEffect;
    var effectId = $c2bb61c8a2f6b79d$var$current;
    var keys = Object.keys(effects);
    if (keys.length === 0) {
        cb((0, $8208d7224f148797$export$2f23118c22fb2630)(effects) ? [] : {});
        return;
    }
    var childCallbacks = (0, $8f51be6e3f59daaa$export$882b5998b3b9117c)(effects, cb);
    keys.forEach(function(key) {
        digestEffect(effects[key], effectId, childCallbacks[key], key);
    });
}
function $c2bb61c8a2f6b79d$var$runRaceEffect(env, effects, cb, _ref12) {
    var digestEffect = _ref12.digestEffect;
    var effectId = $c2bb61c8a2f6b79d$var$current;
    var keys = Object.keys(effects);
    var response = (0, $8208d7224f148797$export$2f23118c22fb2630)(effects) ? (0, $8f51be6e3f59daaa$export$953cecd6e717a553)(keys.length) : {};
    var childCbs = {};
    var completed = false;
    keys.forEach(function(key) {
        var chCbAtKey = function chCbAtKey(res, isErr) {
            if (completed) return;
            if (isErr || (0, $8f51be6e3f59daaa$export$2408f22a0fab9ae5)(res)) {
                // Race Auto cancellation
                cb.cancel();
                cb(res, isErr);
            } else {
                cb.cancel();
                completed = true;
                response[key] = res;
                cb(response);
            }
        };
        chCbAtKey.cancel = (0, $8f51be6e3f59daaa$export$625550452a3fa3ec);
        childCbs[key] = chCbAtKey;
    });
    cb.cancel = function() {
        // prevents unnecessary cancellation
        if (!completed) {
            completed = true;
            keys.forEach(function(key) {
                return childCbs[key].cancel();
            });
        }
    };
    keys.forEach(function(key) {
        if (completed) return;
        digestEffect(effects[key], effectId, childCbs[key], key);
    });
}
function $c2bb61c8a2f6b79d$var$runSelectEffect(env, _ref13, cb) {
    var selector = _ref13.selector, args = _ref13.args;
    try {
        var state = selector.apply(void 0, [
            env.getState()
        ].concat(args));
        cb(state);
    } catch (error) {
        cb(error, true);
    }
}
function $c2bb61c8a2f6b79d$var$runChannelEffect(env, _ref14, cb) {
    var pattern = _ref14.pattern, buffer = _ref14.buffer;
    var chan = $c2bb61c8a2f6b79d$export$1f95fbd68d964d36(buffer);
    var match = $c2bb61c8a2f6b79d$var$matcher(pattern);
    var taker = function taker(action) {
        if (!$c2bb61c8a2f6b79d$export$42af6f45c6e0d09f(action)) env.channel.take(taker, match);
        chan.put(action);
    };
    var close = chan.close;
    chan.close = function() {
        taker.cancel();
        close();
    };
    env.channel.take(taker, match);
    cb(chan);
}
function $c2bb61c8a2f6b79d$var$runCancelledEffect(env, data, cb, _ref15) {
    var task = _ref15.task;
    cb(task.isCancelled());
}
function $c2bb61c8a2f6b79d$var$runFlushEffect(env, channel, cb) {
    channel.flush(cb);
}
function $c2bb61c8a2f6b79d$var$runGetContextEffect(env, prop, cb, _ref16) {
    var task = _ref16.task;
    cb(task.context[prop]);
}
function $c2bb61c8a2f6b79d$var$runSetContextEffect(env, props, cb, _ref17) {
    var task = _ref17.task;
    (0, $8f51be6e3f59daaa$export$ffb5f4729a158638)(task.context, props);
    cb();
}
var $c2bb61c8a2f6b79d$var$effectRunnerMap = ($c2bb61c8a2f6b79d$var$_effectRunnerMap = {}, $c2bb61c8a2f6b79d$var$_effectRunnerMap[0, $8f51be6e3f59daaa$export$971d5caa766a69d7] = $c2bb61c8a2f6b79d$var$runTakeEffect, $c2bb61c8a2f6b79d$var$_effectRunnerMap[0, $8f51be6e3f59daaa$export$56c0d5a1e737357d] = $c2bb61c8a2f6b79d$var$runPutEffect, $c2bb61c8a2f6b79d$var$_effectRunnerMap[0, $8f51be6e3f59daaa$export$ebd11618f299a286] = $c2bb61c8a2f6b79d$var$runAllEffect, $c2bb61c8a2f6b79d$var$_effectRunnerMap[0, $8f51be6e3f59daaa$export$db202ddc8be9136] = $c2bb61c8a2f6b79d$var$runRaceEffect, $c2bb61c8a2f6b79d$var$_effectRunnerMap[0, $8f51be6e3f59daaa$export$e7094788287c5e9b] = $c2bb61c8a2f6b79d$var$runCallEffect, $c2bb61c8a2f6b79d$var$_effectRunnerMap[0, $8f51be6e3f59daaa$export$407448d2b89b1813] = $c2bb61c8a2f6b79d$var$runCPSEffect, $c2bb61c8a2f6b79d$var$_effectRunnerMap[0, $8f51be6e3f59daaa$export$d66501df72047452] = $c2bb61c8a2f6b79d$var$runForkEffect, $c2bb61c8a2f6b79d$var$_effectRunnerMap[0, $8f51be6e3f59daaa$export$b4171a6734a65d42] = $c2bb61c8a2f6b79d$var$runJoinEffect, $c2bb61c8a2f6b79d$var$_effectRunnerMap[0, $8f51be6e3f59daaa$export$8b22cf2602fb60ce] = $c2bb61c8a2f6b79d$var$runCancelEffect, $c2bb61c8a2f6b79d$var$_effectRunnerMap[0, $8f51be6e3f59daaa$export$25ce5a424b770e84] = $c2bb61c8a2f6b79d$var$runSelectEffect, $c2bb61c8a2f6b79d$var$_effectRunnerMap[0, $8f51be6e3f59daaa$export$4368d992c4eafac0] = $c2bb61c8a2f6b79d$var$runChannelEffect, $c2bb61c8a2f6b79d$var$_effectRunnerMap[0, $8f51be6e3f59daaa$export$2d1720544b23b823] = $c2bb61c8a2f6b79d$var$runCancelledEffect, $c2bb61c8a2f6b79d$var$_effectRunnerMap[0, $8f51be6e3f59daaa$export$39b482c5e57630a8] = $c2bb61c8a2f6b79d$var$runFlushEffect, $c2bb61c8a2f6b79d$var$_effectRunnerMap[0, $8f51be6e3f59daaa$export$2329c99376c9d0a4] = $c2bb61c8a2f6b79d$var$runGetContextEffect, $c2bb61c8a2f6b79d$var$_effectRunnerMap[0, $8f51be6e3f59daaa$export$dda1d9f60106f0e9] = $c2bb61c8a2f6b79d$var$runSetContextEffect, $c2bb61c8a2f6b79d$var$_effectRunnerMap);
/**
 Used to track a parent task and its forks
 In the fork model, forked tasks are attached by default to their parent
 We model this using the concept of Parent task && main Task
 main task is the main flow of the current Generator, the parent tasks is the
 aggregation of the main tasks + all its forked tasks.
 Thus the whole model represents an execution tree with multiple branches (vs the
 linear execution tree in sequential (non parallel) programming)

 A parent tasks has the following semantics
 - It completes if all its forks either complete or all cancelled
 - If it's cancelled, all forks are cancelled as well
 - It aborts if any uncaught error bubbles up from forks
 - If it completes, the return value is the one returned by the main task
 **/ function $c2bb61c8a2f6b79d$var$forkQueue(mainTask, onAbort, cont) {
    var tasks = [];
    var result;
    var completed = false;
    addTask(mainTask);
    var getTasks = function getTasks() {
        return tasks;
    };
    function abort(err) {
        onAbort();
        cancelAll();
        cont(err, true);
    }
    function addTask(task) {
        tasks.push(task);
        task.cont = function(res, isErr) {
            if (completed) return;
            (0, $8f51be6e3f59daaa$export$43caf9889c228507)(tasks, task);
            task.cont = (0, $8f51be6e3f59daaa$export$625550452a3fa3ec);
            if (isErr) abort(res);
            else {
                if (task === mainTask) result = res;
                if (!tasks.length) {
                    completed = true;
                    cont(result);
                }
            }
        };
    }
    function cancelAll() {
        if (completed) return;
        completed = true;
        tasks.forEach(function(t) {
            t.cont = (0, $8f51be6e3f59daaa$export$625550452a3fa3ec);
            t.cancel();
        });
        tasks = [];
    }
    return {
        addTask: addTask,
        cancelAll: cancelAll,
        abort: abort,
        getTasks: getTasks
    };
}
// there can be only a single saga error created at any given moment
function $c2bb61c8a2f6b79d$var$formatLocation(fileName, lineNumber) {
    return fileName + "?" + lineNumber;
}
function $c2bb61c8a2f6b79d$var$effectLocationAsString(effect) {
    var location = (0, $8f51be6e3f59daaa$export$90a7f3efeed30595)(effect);
    if (location) {
        var code = location.code, fileName = location.fileName, lineNumber = location.lineNumber;
        var source = code + "  " + $c2bb61c8a2f6b79d$var$formatLocation(fileName, lineNumber);
        return source;
    }
    return "";
}
function $c2bb61c8a2f6b79d$var$sagaLocationAsString(sagaMeta) {
    var name = sagaMeta.name, location = sagaMeta.location;
    if (location) return name + "  " + $c2bb61c8a2f6b79d$var$formatLocation(location.fileName, location.lineNumber);
    return name;
}
function $c2bb61c8a2f6b79d$var$cancelledTasksAsString(sagaStack) {
    var cancelledTasks = (0, $8f51be6e3f59daaa$export$3b14a55fb2447963)(function(i) {
        return i.cancelledTasks;
    }, sagaStack);
    if (!cancelledTasks.length) return "";
    return [
        "Tasks cancelled due to error:"
    ].concat(cancelledTasks).join("\n");
}
var $c2bb61c8a2f6b79d$var$crashedEffect = null;
var $c2bb61c8a2f6b79d$var$sagaStack = [];
var $c2bb61c8a2f6b79d$var$addSagaFrame = function addSagaFrame(frame) {
    frame.crashedEffect = $c2bb61c8a2f6b79d$var$crashedEffect;
    $c2bb61c8a2f6b79d$var$sagaStack.push(frame);
};
var $c2bb61c8a2f6b79d$var$clear = function clear() {
    $c2bb61c8a2f6b79d$var$crashedEffect = null;
    $c2bb61c8a2f6b79d$var$sagaStack.length = 0;
}; // this sets crashed effect for the soon-to-be-reported saga frame
// this slightly streatches the singleton nature of this module into wrong direction
// as it's even less obvious what's the data flow here, but it is what it is for now
var $c2bb61c8a2f6b79d$var$setCrashedEffect = function setCrashedEffect(effect) {
    $c2bb61c8a2f6b79d$var$crashedEffect = effect;
};
/**
  @returns {string}

  @example
  The above error occurred in task errorInPutSaga {pathToFile}
  when executing effect put({type: 'REDUCER_ACTION_ERROR_IN_PUT'}) {pathToFile}
      created by fetchSaga {pathToFile}
      created by rootSaga {pathToFile}
*/ var $c2bb61c8a2f6b79d$var$toString = function toString() {
    var firstSaga = $c2bb61c8a2f6b79d$var$sagaStack[0], otherSagas = $c2bb61c8a2f6b79d$var$sagaStack.slice(1);
    var crashedEffectLocation = firstSaga.crashedEffect ? $c2bb61c8a2f6b79d$var$effectLocationAsString(firstSaga.crashedEffect) : null;
    var errorMessage = "The above error occurred in task " + $c2bb61c8a2f6b79d$var$sagaLocationAsString(firstSaga.meta) + (crashedEffectLocation ? " \n when executing effect " + crashedEffectLocation : "");
    return [
        errorMessage
    ].concat(otherSagas.map(function(s) {
        return "    created by " + $c2bb61c8a2f6b79d$var$sagaLocationAsString(s.meta);
    }), [
        $c2bb61c8a2f6b79d$var$cancelledTasksAsString($c2bb61c8a2f6b79d$var$sagaStack)
    ]).join("\n");
};
function $c2bb61c8a2f6b79d$var$newTask(env, mainTask, parentContext, parentEffectId, meta, isRoot, cont) {
    var _task;
    if (cont === void 0) cont = (0, $8f51be6e3f59daaa$export$625550452a3fa3ec);
    var status = $c2bb61c8a2f6b79d$var$RUNNING;
    var taskResult;
    var taskError;
    var deferredEnd = null;
    var cancelledDueToErrorTasks = [];
    var context = Object.create(parentContext);
    var queue = $c2bb61c8a2f6b79d$var$forkQueue(mainTask, function onAbort() {
        cancelledDueToErrorTasks.push.apply(cancelledDueToErrorTasks, queue.getTasks().map(function(t) {
            return t.meta.name;
        }));
    }, end);
    /**
   This may be called by a parent generator to trigger/propagate cancellation
   cancel all pending tasks (including the main task), then end the current task.
    Cancellation propagates down to the whole execution tree held by this Parent task
   It's also propagated to all joiners of this task and their execution tree/joiners
    Cancellation is noop for terminated/Cancelled tasks tasks
   **/ function cancel() {
        if (status === $c2bb61c8a2f6b79d$var$RUNNING) {
            // Setting status to CANCELLED does not necessarily mean that the task/iterators are stopped
            // effects in the iterator's finally block will still be executed
            status = $c2bb61c8a2f6b79d$var$CANCELLED;
            queue.cancelAll(); // Ending with a TASK_CANCEL will propagate the Cancellation to all joiners
            end((0, $05d10e651fe8cb91$export$a47f788ef0b36709), false);
        }
    }
    function end(result, isErr) {
        if (!isErr) {
            // The status here may be RUNNING or CANCELLED
            // If the status is CANCELLED, then we do not need to change it here
            if (result === (0, $05d10e651fe8cb91$export$a47f788ef0b36709)) status = $c2bb61c8a2f6b79d$var$CANCELLED;
            else if (status !== $c2bb61c8a2f6b79d$var$CANCELLED) status = $c2bb61c8a2f6b79d$var$DONE;
            taskResult = result;
            deferredEnd && deferredEnd.resolve(result);
        } else {
            status = $c2bb61c8a2f6b79d$var$ABORTED;
            $c2bb61c8a2f6b79d$var$addSagaFrame({
                meta: meta,
                cancelledTasks: cancelledDueToErrorTasks
            });
            if (task.isRoot) {
                var sagaStack = $c2bb61c8a2f6b79d$var$toString(); // we've dumped the saga stack to string and are passing it to user's code
                // we know that it won't be needed anymore and we need to clear it
                $c2bb61c8a2f6b79d$var$clear();
                env.onError(result, {
                    sagaStack: sagaStack
                });
            }
            taskError = result;
            deferredEnd && deferredEnd.reject(result);
        }
        task.cont(result, isErr);
        task.joiners.forEach(function(joiner) {
            joiner.cb(result, isErr);
        });
        task.joiners = null;
    }
    function setContext(props) {
        (0, $8f51be6e3f59daaa$export$ffb5f4729a158638)(context, props);
    }
    function toPromise() {
        if (deferredEnd) return deferredEnd.promise;
        deferredEnd = (0, $973b2c0da971f80e$export$2e2bcd8739ae039)();
        if (status === $c2bb61c8a2f6b79d$var$ABORTED) deferredEnd.reject(taskError);
        else if (status !== $c2bb61c8a2f6b79d$var$RUNNING) deferredEnd.resolve(taskResult);
        return deferredEnd.promise;
    }
    var task = (_task = {}, _task[0, $05d10e651fe8cb91$export$9355e489ad16f98e] = true, _task.id = parentEffectId, _task.meta = meta, _task.isRoot = isRoot, _task.context = context, _task.joiners = [], _task.queue = queue, _task.cancel = cancel, _task.cont = cont, _task.end = end, _task.setContext = setContext, _task.toPromise = toPromise, _task.isRunning = function isRunning() {
        return status === $c2bb61c8a2f6b79d$var$RUNNING;
    }, _task.isCancelled = function isCancelled() {
        return status === $c2bb61c8a2f6b79d$var$CANCELLED || status === $c2bb61c8a2f6b79d$var$RUNNING && mainTask.status === $c2bb61c8a2f6b79d$var$CANCELLED;
    }, _task.isAborted = function isAborted() {
        return status === $c2bb61c8a2f6b79d$var$ABORTED;
    }, _task.result = function result() {
        return taskResult;
    }, _task.error = function error() {
        return taskError;
    }, _task);
    return task;
}
function $c2bb61c8a2f6b79d$var$proc(env, iterator$1, parentContext, parentEffectId, meta, isRoot, cont) {
    var finalRunEffect = env.finalizeRunEffect(runEffect);
    /**
    Tracks the current effect cancellation
    Each time the generator progresses. calling runEffect will set a new value
    on it. It allows propagating cancellation to child effects
  **/ next.cancel = (0, $8f51be6e3f59daaa$export$625550452a3fa3ec);
    /** Creates a main task to track the main flow */ var mainTask = {
        meta: meta,
        cancel: cancelMain,
        status: $c2bb61c8a2f6b79d$var$RUNNING
    };
    /**
   Creates a new task descriptor for this generator.
   A task is the aggregation of it's mainTask and all it's forked tasks.
   **/ var task = $c2bb61c8a2f6b79d$var$newTask(env, mainTask, parentContext, parentEffectId, meta, isRoot, cont);
    var executingContext = {
        task: task,
        digestEffect: digestEffect
    };
    /**
    cancellation of the main task. We'll simply resume the Generator with a TASK_CANCEL
  **/ function cancelMain() {
        if (mainTask.status === $c2bb61c8a2f6b79d$var$RUNNING) {
            mainTask.status = $c2bb61c8a2f6b79d$var$CANCELLED;
            next((0, $05d10e651fe8cb91$export$a47f788ef0b36709));
        }
    }
    /**
    attaches cancellation logic to this task's continuation
    this will permit cancellation to propagate down the call chain
  **/ if (cont) cont.cancel = task.cancel;
     // kicks up the generator
    next(); // then return the task descriptor to the caller
    return task;
    /**
   * This is the generator driver
   * It's a recursive async/continuation function which calls itself
   * until the generator terminates or throws
   * @param {internal commands(TASK_CANCEL | TERMINATE) | any} arg - value, generator will be resumed with.
   * @param {boolean} isErr - the flag shows if effect finished with an error
   *
   * receives either (command | effect result, false) or (any thrown thing, true)
   */ function next(arg, isErr) {
        try {
            var result;
            if (isErr) {
                result = iterator$1.throw(arg); // user handled the error, we can clear bookkept values
                $c2bb61c8a2f6b79d$var$clear();
            } else if ((0, $8f51be6e3f59daaa$export$4a5767248b18ef41)(arg)) {
                /**
          getting TASK_CANCEL automatically cancels the main task
          We can get this value here
           - By cancelling the parent task manually
          - By joining a Cancelled task
        **/ mainTask.status = $c2bb61c8a2f6b79d$var$CANCELLED;
                /**
          Cancels the current effect; this will propagate the cancellation down to any called tasks
        **/ next.cancel();
                /**
          If this Generator has a `return` method then invokes it
          This will jump to the finally block
        **/ result = (0, $8208d7224f148797$export$86951950244e2001)(iterator$1.return) ? iterator$1.return((0, $05d10e651fe8cb91$export$a47f788ef0b36709)) : {
                    done: true,
                    value: (0, $05d10e651fe8cb91$export$a47f788ef0b36709)
                };
            } else if ((0, $8f51be6e3f59daaa$export$df995fae86a55f06)(arg)) // We get TERMINATE flag, i.e. by taking from a channel that ended using `take` (and not `takem` used to trap End of channels)
            result = (0, $8208d7224f148797$export$86951950244e2001)(iterator$1.return) ? iterator$1.return() : {
                done: true
            };
            else result = iterator$1.next(arg);
            if (!result.done) digestEffect(result.value, parentEffectId, next);
            else {
                /**
          This Generator has ended, terminate the main task and notify the fork queue
        **/ if (mainTask.status !== $c2bb61c8a2f6b79d$var$CANCELLED) mainTask.status = $c2bb61c8a2f6b79d$var$DONE;
                mainTask.cont(result.value);
            }
        } catch (error) {
            if (mainTask.status === $c2bb61c8a2f6b79d$var$CANCELLED) throw error;
            mainTask.status = $c2bb61c8a2f6b79d$var$ABORTED;
            mainTask.cont(error, true);
        }
    }
    function runEffect(effect, effectId, currCb) {
        /**
      each effect runner must attach its own logic of cancellation to the provided callback
      it allows this generator to propagate cancellation downward.
       ATTENTION! effect runners must setup the cancel logic by setting cb.cancel = [cancelMethod]
      And the setup must occur before calling the callback
       This is a sort of inversion of control: called async functions are responsible
      of completing the flow by calling the provided continuation; while caller functions
      are responsible for aborting the current flow by calling the attached cancel function
       Library users can attach their own cancellation logic to promises by defining a
      promise[CANCEL] method in their returned promises
      ATTENTION! calling cancel must have no effect on an already completed or cancelled effect
    **/ if ((0, $8208d7224f148797$export$c957ef27a0ebfd4)(effect)) $c2bb61c8a2f6b79d$var$resolvePromise(effect, currCb);
        else if ((0, $8208d7224f148797$export$6f58e2338da23f4d)(effect)) // resolve iterator
        $c2bb61c8a2f6b79d$var$proc(env, effect, task.context, effectId, meta, /* isRoot */ false, currCb);
        else if (effect && effect[0, $05d10e651fe8cb91$export$8f8422ac5947a789]) {
            var effectRunner = $c2bb61c8a2f6b79d$var$effectRunnerMap[effect.type];
            effectRunner(env, effect.payload, currCb, executingContext);
        } else // anything else returned as is
        currCb(effect);
    }
    function digestEffect(effect, parentEffectId, cb, label) {
        if (label === void 0) label = "";
        var effectId = $c2bb61c8a2f6b79d$var$nextSagaId();
        env.sagaMonitor && env.sagaMonitor.effectTriggered({
            effectId: effectId,
            parentEffectId: parentEffectId,
            label: label,
            effect: effect
        });
        /**
      completion callback and cancel callback are mutually exclusive
      We can't cancel an already completed effect
      And We can't complete an already cancelled effectId
    **/ var effectSettled; // Completion callback passed to the appropriate effect runner
        function currCb(res, isErr) {
            if (effectSettled) return;
            effectSettled = true;
            cb.cancel = (0, $8f51be6e3f59daaa$export$625550452a3fa3ec); // defensive measure
            if (env.sagaMonitor) {
                if (isErr) env.sagaMonitor.effectRejected(effectId, res);
                else env.sagaMonitor.effectResolved(effectId, res);
            }
            if (isErr) $c2bb61c8a2f6b79d$var$setCrashedEffect(effect);
            cb(res, isErr);
        } // tracks down the current cancel
        currCb.cancel = (0, $8f51be6e3f59daaa$export$625550452a3fa3ec); // setup cancellation logic on the parent cb
        cb.cancel = function() {
            // prevents cancelling an already completed effect
            if (effectSettled) return;
            effectSettled = true;
            currCb.cancel(); // propagates cancel downward
            currCb.cancel = (0, $8f51be6e3f59daaa$export$625550452a3fa3ec); // defensive measure
            env.sagaMonitor && env.sagaMonitor.effectCancelled(effectId);
        };
        finalRunEffect(effect, effectId, currCb);
    }
}
var $c2bb61c8a2f6b79d$var$RUN_SAGA_SIGNATURE = "runSaga(options, saga, ...args)";
var $c2bb61c8a2f6b79d$var$NON_GENERATOR_ERR = $c2bb61c8a2f6b79d$var$RUN_SAGA_SIGNATURE + ": saga argument must be a Generator function!";
function $c2bb61c8a2f6b79d$export$3d8d44bf0c43bb61(_ref, saga) {
    var _ref$channel = _ref.channel, channel = _ref$channel === void 0 ? $c2bb61c8a2f6b79d$export$e987d166a3a4f3ec() : _ref$channel, dispatch = _ref.dispatch, getState = _ref.getState, _ref$context = _ref.context, context = _ref$context === void 0 ? {} : _ref$context, sagaMonitor = _ref.sagaMonitor, effectMiddlewares = _ref.effectMiddlewares, _ref$onError = _ref.onError, onError = _ref$onError === void 0 ? (0, $8f51be6e3f59daaa$export$ef35774e6d314e91) : _ref$onError;
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    var iterator$1 = saga.apply(void 0, args);
    var effectId = $c2bb61c8a2f6b79d$var$nextSagaId();
    if (sagaMonitor) {
        // monitors are expected to have a certain interface, let's fill-in any missing ones
        sagaMonitor.rootSagaStarted = sagaMonitor.rootSagaStarted || (0, $8f51be6e3f59daaa$export$625550452a3fa3ec);
        sagaMonitor.effectTriggered = sagaMonitor.effectTriggered || (0, $8f51be6e3f59daaa$export$625550452a3fa3ec);
        sagaMonitor.effectResolved = sagaMonitor.effectResolved || (0, $8f51be6e3f59daaa$export$625550452a3fa3ec);
        sagaMonitor.effectRejected = sagaMonitor.effectRejected || (0, $8f51be6e3f59daaa$export$625550452a3fa3ec);
        sagaMonitor.effectCancelled = sagaMonitor.effectCancelled || (0, $8f51be6e3f59daaa$export$625550452a3fa3ec);
        sagaMonitor.actionDispatched = sagaMonitor.actionDispatched || (0, $8f51be6e3f59daaa$export$625550452a3fa3ec);
        sagaMonitor.rootSagaStarted({
            effectId: effectId,
            saga: saga,
            args: args
        });
    }
    var MIDDLEWARE_TYPE_ERROR;
    var finalizeRunEffect;
    if (effectMiddlewares) {
        var middleware = (0, $b4bc487a38c3f200$export$f672e0b6f7222cd7).apply(void 0, effectMiddlewares);
        finalizeRunEffect = function finalizeRunEffect(runEffect) {
            return function(effect, effectId, currCb) {
                var plainRunEffect = function plainRunEffect(eff) {
                    return runEffect(eff, effectId, currCb);
                };
                return middleware(plainRunEffect)(effect);
            };
        };
    } else finalizeRunEffect = (0, $8f51be6e3f59daaa$export$a9c23c6ac3fc3eca);
    var env = {
        channel: channel,
        dispatch: (0, $8f51be6e3f59daaa$export$96f57966bedc81b4)(dispatch),
        getState: getState,
        sagaMonitor: sagaMonitor,
        onError: onError,
        finalizeRunEffect: finalizeRunEffect
    };
    return $c2bb61c8a2f6b79d$var$immediately(function() {
        var task = $c2bb61c8a2f6b79d$var$proc(env, iterator$1, context, effectId, (0, $8f51be6e3f59daaa$export$35e795649ee09318)(saga), /* isRoot */ true, undefined);
        if (sagaMonitor) sagaMonitor.effectResolved(effectId, task);
        return task;
    });
}
function $c2bb61c8a2f6b79d$var$sagaMiddlewareFactory(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref$context = _ref.context, context = _ref$context === void 0 ? {} : _ref$context, _ref$channel = _ref.channel, channel = _ref$channel === void 0 ? $c2bb61c8a2f6b79d$export$e987d166a3a4f3ec() : _ref$channel, sagaMonitor = _ref.sagaMonitor, options = (0, $612ace97f19660e2$export$2e2bcd8739ae039)(_ref, [
        "context",
        "channel",
        "sagaMonitor"
    ]);
    var boundRunSaga;
    function sagaMiddleware(_ref2) {
        var getState = _ref2.getState, dispatch = _ref2.dispatch;
        boundRunSaga = $c2bb61c8a2f6b79d$export$3d8d44bf0c43bb61.bind(null, (0, $6767be368738adce$export$2e2bcd8739ae039)({}, options, {
            context: context,
            channel: channel,
            dispatch: dispatch,
            getState: getState,
            sagaMonitor: sagaMonitor
        }));
        return function(next) {
            return function(action) {
                if (sagaMonitor && sagaMonitor.actionDispatched) sagaMonitor.actionDispatched(action);
                var result = next(action); // hit reducers
                channel.put(action);
                return result;
            };
        };
    }
    sagaMiddleware.run = function() {
        return boundRunSaga.apply(void 0, arguments);
    };
    sagaMiddleware.setContext = function(props) {
        (0, $8f51be6e3f59daaa$export$ffb5f4729a158638)(context, props);
    };
    return sagaMiddleware;
}
var $c2bb61c8a2f6b79d$export$2e2bcd8739ae039 = $c2bb61c8a2f6b79d$var$sagaMiddlewareFactory;


var $e77394150e9d59e6$export$2e2bcd8739ae039 = (0, $c2bb61c8a2f6b79d$export$2e2bcd8739ae039);


/**
 * This action type will be dispatched when your history
 * receives a location change.
 */ var $a53ee0234d47ba63$export$be84bd1ba815d4c2 = "@@router/LOCATION_CHANGE";
var $a53ee0234d47ba63$export$924382de27029fe1 = function onLocationChanged(location, action) {
    var isFirstRendering = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    return {
        type: $a53ee0234d47ba63$export$be84bd1ba815d4c2,
        payload: {
            location: location,
            action: action,
            isFirstRendering: isFirstRendering
        }
    };
};
var $a53ee0234d47ba63$export$d035cdafa5d37a89 = "@@router/CALL_HISTORY_METHOD";
var $a53ee0234d47ba63$var$updateLocation = function updateLocation(method) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return {
            type: $a53ee0234d47ba63$export$d035cdafa5d37a89,
            payload: {
                method: method,
                args: args
            }
        };
    };
};
var $a53ee0234d47ba63$export$4cbf152802aa238 = $a53ee0234d47ba63$var$updateLocation("push");
var $a53ee0234d47ba63$export$77ad94ebf1c2b9ed = $a53ee0234d47ba63$var$updateLocation("replace");
var $a53ee0234d47ba63$export$93bb224d05b3906d = $a53ee0234d47ba63$var$updateLocation("go");
var $a53ee0234d47ba63$export$28fca2ccfd38b8f = $a53ee0234d47ba63$var$updateLocation("goBack");
var $a53ee0234d47ba63$export$994d0e87e52ba8e3 = $a53ee0234d47ba63$var$updateLocation("goForward");
var $a53ee0234d47ba63$export$95755023e698c378 = {
    push: $a53ee0234d47ba63$export$4cbf152802aa238,
    replace: $a53ee0234d47ba63$export$77ad94ebf1c2b9ed,
    go: $a53ee0234d47ba63$export$93bb224d05b3906d,
    goBack: $a53ee0234d47ba63$export$28fca2ccfd38b8f,
    goForward: $a53ee0234d47ba63$export$994d0e87e52ba8e3
};


function $bf36379e38a118fb$var$_toConsumableArray(arr) {
    return $bf36379e38a118fb$var$_arrayWithoutHoles(arr) || $bf36379e38a118fb$var$_iterableToArray(arr) || $bf36379e38a118fb$var$_unsupportedIterableToArray(arr) || $bf36379e38a118fb$var$_nonIterableSpread();
}
function $bf36379e38a118fb$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $bf36379e38a118fb$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $bf36379e38a118fb$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $bf36379e38a118fb$var$_arrayLikeToArray(o, minLen);
}
function $bf36379e38a118fb$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $bf36379e38a118fb$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $bf36379e38a118fb$var$_arrayLikeToArray(arr);
}
function $bf36379e38a118fb$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
/**
 * This middleware captures CALL_HISTORY_METHOD actions to redirect to the
 * provided history object. This will prevent these actions from reaching your
 * reducer or any middleware that comes after this one.
 */ var $bf36379e38a118fb$var$routerMiddleware = function routerMiddleware(history) {
    return function(store) {
        return function(next) {
            return function(action) {
                // eslint-disable-line no-unused-vars
                if (action.type !== (0, $a53ee0234d47ba63$export$d035cdafa5d37a89)) return next(action);
                var _action$payload = action.payload, method = _action$payload.method, args = _action$payload.args;
                history[method].apply(history, $bf36379e38a118fb$var$_toConsumableArray(args));
            };
        };
    };
};
var $bf36379e38a118fb$export$2e2bcd8739ae039 = $bf36379e38a118fb$var$routerMiddleware;


var $60658be5529a36bf$export$1e511d4a378977f5;
var $60658be5529a36bf$export$d32324a03b6bde1b;
var $60658be5529a36bf$export$321b1ffcca858b2b;
"use strict";

var $60658be5529a36bf$require$compose = $b4bc487a38c3f200$export$f672e0b6f7222cd7;
$60658be5529a36bf$export$1e511d4a378977f5 = true;
$60658be5529a36bf$export$d32324a03b6bde1b = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return undefined;
    if (typeof arguments[0] === "object") return $60658be5529a36bf$require$compose;
    return $60658be5529a36bf$require$compose.apply(null, arguments);
};
$60658be5529a36bf$export$321b1ffcca858b2b = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop) {
        return noop;
    };
};



function $4d71ee434250a1d3$var$isAbsolute(pathname) {
    return pathname.charAt(0) === "/";
}
// About 1.5x faster than the two-arg version of Array#splice()
function $4d71ee434250a1d3$var$spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
// This implementation is based heavily on node's url.parse
function $4d71ee434250a1d3$var$resolvePathname(to, from) {
    if (from === undefined) from = "";
    var toParts = to && to.split("/") || [];
    var fromParts = from && from.split("/") || [];
    var isToAbs = to && $4d71ee434250a1d3$var$isAbsolute(to);
    var isFromAbs = from && $4d71ee434250a1d3$var$isAbsolute(from);
    var mustEndAbs = isToAbs || isFromAbs;
    if (to && $4d71ee434250a1d3$var$isAbsolute(to)) // to is absolute
    fromParts = toParts;
    else if (toParts.length) {
        // to is relative, drop the filename
        fromParts.pop();
        fromParts = fromParts.concat(toParts);
    }
    if (!fromParts.length) return "/";
    var hasTrailingSlash;
    if (fromParts.length) {
        var last = fromParts[fromParts.length - 1];
        hasTrailingSlash = last === "." || last === ".." || last === "";
    } else hasTrailingSlash = false;
    var up = 0;
    for(var i = fromParts.length; i >= 0; i--){
        var part = fromParts[i];
        if (part === ".") $4d71ee434250a1d3$var$spliceOne(fromParts, i);
        else if (part === "..") {
            $4d71ee434250a1d3$var$spliceOne(fromParts, i);
            up++;
        } else if (up) {
            $4d71ee434250a1d3$var$spliceOne(fromParts, i);
            up--;
        }
    }
    if (!mustEndAbs) for(; up--; up)fromParts.unshift("..");
    if (mustEndAbs && fromParts[0] !== "" && (!fromParts[0] || !$4d71ee434250a1d3$var$isAbsolute(fromParts[0]))) fromParts.unshift("");
    var result = fromParts.join("/");
    if (hasTrailingSlash && result.substr(-1) !== "/") result += "/";
    return result;
}
var $4d71ee434250a1d3$export$2e2bcd8739ae039 = $4d71ee434250a1d3$var$resolvePathname;


function $02e2bfdd0166f2f6$var$valueOf(obj) {
    return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}
function $02e2bfdd0166f2f6$var$valueEqual(a, b) {
    // Test for strict equality first.
    if (a === b) return true;
    // Otherwise, if either of them == null they are not equal.
    if (a == null || b == null) return false;
    if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
        return $02e2bfdd0166f2f6$var$valueEqual(item, b[index]);
    });
    if (typeof a === "object" || typeof b === "object") {
        var aValue = $02e2bfdd0166f2f6$var$valueOf(a);
        var bValue = $02e2bfdd0166f2f6$var$valueOf(b);
        if (aValue !== a || bValue !== b) return $02e2bfdd0166f2f6$var$valueEqual(aValue, bValue);
        return Object.keys(Object.assign({}, a, b)).every(function(key) {
            return $02e2bfdd0166f2f6$var$valueEqual(a[key], b[key]);
        });
    }
    return false;
}
var $02e2bfdd0166f2f6$export$2e2bcd8739ae039 = $02e2bfdd0166f2f6$var$valueEqual;



var $d23b6a4945e6cbc3$var$isProduction = true;
var $d23b6a4945e6cbc3$var$prefix = "Invariant failed";
function $d23b6a4945e6cbc3$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($d23b6a4945e6cbc3$var$isProduction) throw new Error($d23b6a4945e6cbc3$var$prefix);
    var provided = typeof message === "function" ? message() : message;
    var value = provided ? "".concat($d23b6a4945e6cbc3$var$prefix, ": ").concat(provided) : $d23b6a4945e6cbc3$var$prefix;
    throw new Error(value);
}


function $0e3a6b1020765bd1$var$addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function $0e3a6b1020765bd1$var$stripLeadingSlash(path) {
    return path.charAt(0) === "/" ? path.substr(1) : path;
}
function $0e3a6b1020765bd1$var$hasBasename(path, prefix) {
    return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && "/?#".indexOf(path.charAt(prefix.length)) !== -1;
}
function $0e3a6b1020765bd1$var$stripBasename(path, prefix) {
    return $0e3a6b1020765bd1$var$hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function $0e3a6b1020765bd1$var$stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === "/" ? path.slice(0, -1) : path;
}
function $0e3a6b1020765bd1$export$8ccf933b0513f8d0(path) {
    var pathname = path || "/";
    var search = "";
    var hash = "";
    var hashIndex = pathname.indexOf("#");
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf("?");
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === "?" ? "" : search,
        hash: hash === "#" ? "" : hash
    };
}
function $0e3a6b1020765bd1$export$fe53371bee54353d(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || "/";
    if (search && search !== "?") path += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") path += hash.charAt(0) === "#" ? hash : "#" + hash;
    return path;
}
function $0e3a6b1020765bd1$export$90c043f1c57770b8(path, state, key, currentLocation) {
    var location;
    if (typeof path === "string") {
        // Two-arg form: push(path, state)
        location = $0e3a6b1020765bd1$export$8ccf933b0513f8d0(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = (0, $6767be368738adce$export$2e2bcd8739ae039)({}, path);
        if (location.pathname === undefined) location.pathname = "";
        if (location.search) {
            if (location.search.charAt(0) !== "?") location.search = "?" + location.search;
        } else location.search = "";
        if (location.hash) {
            if (location.hash.charAt(0) !== "#") location.hash = "#" + location.hash;
        } else location.hash = "";
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + "This is likely caused by an invalid percent-encoding.");
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== "/") location.pathname = (0, $4d71ee434250a1d3$export$2e2bcd8739ae039)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = "/";
    return location;
}
function $0e3a6b1020765bd1$export$c3e8bb440bd55b18(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, $02e2bfdd0166f2f6$export$2e2bcd8739ae039)(a.state, b.state);
}
function $0e3a6b1020765bd1$var$createTransitionManager() {
    var prompt = null;
    function setPrompt(nextPrompt) {
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    }
    function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === "function" ? prompt(location, action) : prompt;
            if (typeof result === "string") {
                if (typeof getUserConfirmation === "function") getUserConfirmation(result, callback);
                else callback(true);
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    }
    var listeners = [];
    function appendListener(fn) {
        var isActive = true;
        function listener() {
            if (isActive) fn.apply(void 0, arguments);
        }
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    }
    function notifyListeners() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(void 0, args);
        });
    }
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
}
var $0e3a6b1020765bd1$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function $0e3a6b1020765bd1$var$getConfirmation(message, callback) {
    callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ function $0e3a6b1020765bd1$var$supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf("Android 2.") !== -1 || ua.indexOf("Android 4.0") !== -1) && ua.indexOf("Mobile Safari") !== -1 && ua.indexOf("Chrome") === -1 && ua.indexOf("Windows Phone") === -1) return false;
    return window.history && "pushState" in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ function $0e3a6b1020765bd1$var$supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf("Trident") === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ function $0e3a6b1020765bd1$var$supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf("Firefox") === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ function $0e3a6b1020765bd1$var$isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf("CriOS") === -1;
}
var $0e3a6b1020765bd1$var$PopStateEvent = "popstate";
var $0e3a6b1020765bd1$var$HashChangeEvent = "hashchange";
function $0e3a6b1020765bd1$var$getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ function $0e3a6b1020765bd1$export$719fc203c4e16dee(props) {
    if (props === void 0) props = {};
    !$0e3a6b1020765bd1$var$canUseDOM && (0, $d23b6a4945e6cbc3$export$2e2bcd8739ae039)(false);
    var globalHistory = window.history;
    var canUseHistory = $0e3a6b1020765bd1$var$supportsHistory();
    var needsHashChangeListener = !$0e3a6b1020765bd1$var$supportsPopStateOnHashChange();
    var _props = props, _props$forceRefresh = _props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $0e3a6b1020765bd1$var$getConfirmation : _props$getUserConfirm, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var basename = props.basename ? $0e3a6b1020765bd1$var$stripTrailingSlash($0e3a6b1020765bd1$var$addLeadingSlash(props.basename)) : "";
    function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        if (basename) path = $0e3a6b1020765bd1$var$stripBasename(path, basename);
        return $0e3a6b1020765bd1$export$90c043f1c57770b8(path, state, key);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var transitionManager = $0e3a6b1020765bd1$var$createTransitionManager();
    function setState(nextState) {
        (0, $6767be368738adce$export$2e2bcd8739ae039)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if ($0e3a6b1020765bd1$var$isExtraneousPopstateEvent(event)) return;
        handlePop(getDOMLocation(event.state));
    }
    function handleHashChange() {
        handlePop(getDOMLocation($0e3a6b1020765bd1$var$getHistoryState()));
    }
    var forceNextPop = false;
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = "POP";
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    }
    var initialLocation = getDOMLocation($0e3a6b1020765bd1$var$getHistoryState());
    var allKeys = [
        initialLocation.key
    ]; // Public interface
    function createHref(location) {
        return basename + $0e3a6b1020765bd1$export$fe53371bee54353d(location);
    }
    function push(path, state) {
        var action = "PUSH";
        var location = $0e3a6b1020765bd1$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.href = href;
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = $0e3a6b1020765bd1$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.replace(href);
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) {
            window.addEventListener($0e3a6b1020765bd1$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.addEventListener($0e3a6b1020765bd1$var$HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            window.removeEventListener($0e3a6b1020765bd1$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.removeEventListener($0e3a6b1020765bd1$var$HashChangeEvent, handleHashChange);
        }
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: "POP",
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
var $0e3a6b1020765bd1$var$HashChangeEvent$1 = "hashchange";
var $0e3a6b1020765bd1$var$HashPathCoders = {
    hashbang: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === "!" ? path : "!/" + $0e3a6b1020765bd1$var$stripLeadingSlash(path);
        },
        decodePath: function decodePath(path) {
            return path.charAt(0) === "!" ? path.substr(1) : path;
        }
    },
    noslash: {
        encodePath: $0e3a6b1020765bd1$var$stripLeadingSlash,
        decodePath: $0e3a6b1020765bd1$var$addLeadingSlash
    },
    slash: {
        encodePath: $0e3a6b1020765bd1$var$addLeadingSlash,
        decodePath: $0e3a6b1020765bd1$var$addLeadingSlash
    }
};
function $0e3a6b1020765bd1$var$stripHash(url) {
    var hashIndex = url.indexOf("#");
    return hashIndex === -1 ? url : url.slice(0, hashIndex);
}
function $0e3a6b1020765bd1$var$getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf("#");
    return hashIndex === -1 ? "" : href.substring(hashIndex + 1);
}
function $0e3a6b1020765bd1$var$pushHashPath(path) {
    window.location.hash = path;
}
function $0e3a6b1020765bd1$var$replaceHashPath(path) {
    window.location.replace($0e3a6b1020765bd1$var$stripHash(window.location.href) + "#" + path);
}
function $0e3a6b1020765bd1$export$b71fdd3798280242(props) {
    if (props === void 0) props = {};
    !$0e3a6b1020765bd1$var$canUseDOM && (0, $d23b6a4945e6cbc3$export$2e2bcd8739ae039)(false);
    var globalHistory = window.history;
    var canGoWithoutReload = $0e3a6b1020765bd1$var$supportsGoWithoutReloadUsingHash();
    var _props = props, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $0e3a6b1020765bd1$var$getConfirmation : _props$getUserConfirm, _props$hashType = _props.hashType, hashType = _props$hashType === void 0 ? "slash" : _props$hashType;
    var basename = props.basename ? $0e3a6b1020765bd1$var$stripTrailingSlash($0e3a6b1020765bd1$var$addLeadingSlash(props.basename)) : "";
    var _HashPathCoders$hashT = $0e3a6b1020765bd1$var$HashPathCoders[hashType], encodePath = _HashPathCoders$hashT.encodePath, decodePath = _HashPathCoders$hashT.decodePath;
    function getDOMLocation() {
        var path = decodePath($0e3a6b1020765bd1$var$getHashPath());
        if (basename) path = $0e3a6b1020765bd1$var$stripBasename(path, basename);
        return $0e3a6b1020765bd1$export$90c043f1c57770b8(path);
    }
    var transitionManager = $0e3a6b1020765bd1$var$createTransitionManager();
    function setState(nextState) {
        (0, $6767be368738adce$export$2e2bcd8739ae039)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    var forceNextPop = false;
    var ignorePath = null;
    function locationsAreEqual$$1(a, b) {
        return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
    }
    function handleHashChange() {
        var path = $0e3a6b1020765bd1$var$getHashPath();
        var encodedPath = encodePath(path);
        if (path !== encodedPath) // Ensure we always have a properly-encoded hash.
        $0e3a6b1020765bd1$var$replaceHashPath(encodedPath);
        else {
            var location = getDOMLocation();
            var prevLocation = history.location;
            if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.
            if (ignorePath === $0e3a6b1020765bd1$export$fe53371bee54353d(location)) return; // Ignore this change; we already setState in push/replace.
            ignorePath = null;
            handlePop(location);
        }
    }
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = "POP";
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of paths we've seen in sessionStorage.
        // Instead, we just default to 0 for paths we don't know.
        var toIndex = allPaths.lastIndexOf($0e3a6b1020765bd1$export$fe53371bee54353d(toLocation));
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allPaths.lastIndexOf($0e3a6b1020765bd1$export$fe53371bee54353d(fromLocation));
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    } // Ensure the hash is encoded properly before doing anything else.
    var path = $0e3a6b1020765bd1$var$getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) $0e3a6b1020765bd1$var$replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [
        $0e3a6b1020765bd1$export$fe53371bee54353d(initialLocation)
    ]; // Public interface
    function createHref(location) {
        var baseTag = document.querySelector("base");
        var href = "";
        if (baseTag && baseTag.getAttribute("href")) href = $0e3a6b1020765bd1$var$stripHash(window.location.href);
        return href + "#" + encodePath(basename + $0e3a6b1020765bd1$export$fe53371bee54353d(location));
    }
    function push(path, state) {
        var action = "PUSH";
        var location = $0e3a6b1020765bd1$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $0e3a6b1020765bd1$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $0e3a6b1020765bd1$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a PUSH, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $0e3a6b1020765bd1$var$pushHashPath(encodedPath);
                var prevIndex = allPaths.lastIndexOf($0e3a6b1020765bd1$export$fe53371bee54353d(history.location));
                var nextPaths = allPaths.slice(0, prevIndex + 1);
                nextPaths.push(path);
                allPaths = nextPaths;
                setState({
                    action: action,
                    location: location
                });
            } else setState();
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = $0e3a6b1020765bd1$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $0e3a6b1020765bd1$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $0e3a6b1020765bd1$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a REPLACE, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $0e3a6b1020765bd1$var$replaceHashPath(encodedPath);
            }
            var prevIndex = allPaths.indexOf($0e3a6b1020765bd1$export$fe53371bee54353d(history.location));
            if (prevIndex !== -1) allPaths[prevIndex] = path;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) window.addEventListener($0e3a6b1020765bd1$var$HashChangeEvent$1, handleHashChange);
        else if (listenerCount === 0) window.removeEventListener($0e3a6b1020765bd1$var$HashChangeEvent$1, handleHashChange);
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: "POP",
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
function $0e3a6b1020765bd1$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */ function $0e3a6b1020765bd1$export$2b76ad033c6e6d08(props) {
    if (props === void 0) props = {};
    var _props = props, getUserConfirmation = _props.getUserConfirmation, _props$initialEntries = _props.initialEntries, initialEntries = _props$initialEntries === void 0 ? [
        "/"
    ] : _props$initialEntries, _props$initialIndex = _props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var transitionManager = $0e3a6b1020765bd1$var$createTransitionManager();
    function setState(nextState) {
        (0, $6767be368738adce$export$2e2bcd8739ae039)(history, nextState);
        history.length = history.entries.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var index = $0e3a6b1020765bd1$var$clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function(entry) {
        return typeof entry === "string" ? $0e3a6b1020765bd1$export$90c043f1c57770b8(entry, undefined, createKey()) : $0e3a6b1020765bd1$export$90c043f1c57770b8(entry, undefined, entry.key || createKey());
    }); // Public interface
    var createHref = $0e3a6b1020765bd1$export$fe53371bee54353d;
    function push(path, state) {
        var action = "PUSH";
        var location = $0e3a6b1020765bd1$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var prevIndex = history.index;
            var nextIndex = prevIndex + 1;
            var nextEntries = history.entries.slice(0);
            if (nextEntries.length > nextIndex) nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
            else nextEntries.push(location);
            setState({
                action: action,
                location: location,
                index: nextIndex,
                entries: nextEntries
            });
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = $0e3a6b1020765bd1$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            history.entries[history.index] = location;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        var nextIndex = $0e3a6b1020765bd1$var$clamp(history.index + n, 0, history.entries.length - 1);
        var action = "POP";
        var location = history.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (ok) setState({
                action: action,
                location: location,
                index: nextIndex
            });
            else // Mimic the behavior of DOM histories by
            // causing a render after a cancelled POP.
            setState();
        });
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    function canGo(n) {
        var nextIndex = history.index + n;
        return nextIndex >= 0 && nextIndex < history.entries.length;
    }
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        return transitionManager.setPrompt(prompt);
    }
    function listen(listener) {
        return transitionManager.appendListener(listener);
    }
    var history = {
        length: entries.length,
        action: "POP",
        location: entries[index],
        index: index,
        entries: entries,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        canGo: canGo,
        block: block,
        listen: listen
    };
    return history;
}








var $17b5b1be37557756$var$done = function done(value) {
    return {
        done: true,
        value: value
    };
};
var $17b5b1be37557756$var$qEnd = {};
function $17b5b1be37557756$var$safeName(patternOrChannel) {
    if ((0, $8208d7224f148797$export$1f95fbd68d964d36)(patternOrChannel)) return "channel";
    if ((0, $8208d7224f148797$export$32b5e46230afa379)(patternOrChannel)) return String(patternOrChannel);
    if ((0, $8208d7224f148797$export$86951950244e2001)(patternOrChannel)) return patternOrChannel.name;
    return String(patternOrChannel);
}
function $17b5b1be37557756$var$fsmIterator(fsm, startState, name) {
    var stateUpdater, errorState, effect, nextState = startState;
    function next(arg, error) {
        if (nextState === $17b5b1be37557756$var$qEnd) return $17b5b1be37557756$var$done(arg);
        if (error && !errorState) {
            nextState = $17b5b1be37557756$var$qEnd;
            throw error;
        } else {
            stateUpdater && stateUpdater(arg);
            var currentState = error ? fsm[errorState](error) : fsm[nextState]();
            nextState = currentState.nextState;
            effect = currentState.effect;
            stateUpdater = currentState.stateUpdater;
            errorState = currentState.errorState;
            return nextState === $17b5b1be37557756$var$qEnd ? $17b5b1be37557756$var$done(arg) : effect;
        }
    }
    return (0, $8f51be6e3f59daaa$export$9e5f44173e64f162)(next, function(error) {
        return next(null, error);
    }, name);
}
function $17b5b1be37557756$var$takeEvery(patternOrChannel, worker) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    var yTake = {
        done: false,
        value: (0, $8f51be6e3f59daaa$export$3466f893ebf79586)(patternOrChannel)
    };
    var yFork = function yFork(ac) {
        return {
            done: false,
            value: (0, $8f51be6e3f59daaa$export$61196ced6d74a310).apply(void 0, [
                worker
            ].concat(args, [
                ac
            ]))
        };
    };
    var action, setAction = function setAction(ac) {
        return action = ac;
    };
    return $17b5b1be37557756$var$fsmIterator({
        q1: function q1() {
            return {
                nextState: "q2",
                effect: yTake,
                stateUpdater: setAction
            };
        },
        q2: function q2() {
            return {
                nextState: "q1",
                effect: yFork(action)
            };
        }
    }, "q1", "takeEvery(" + $17b5b1be37557756$var$safeName(patternOrChannel) + ", " + worker.name + ")");
}
function $17b5b1be37557756$var$takeLatest(patternOrChannel, worker) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    var yTake = {
        done: false,
        value: (0, $8f51be6e3f59daaa$export$3466f893ebf79586)(patternOrChannel)
    };
    var yFork = function yFork(ac) {
        return {
            done: false,
            value: (0, $8f51be6e3f59daaa$export$61196ced6d74a310).apply(void 0, [
                worker
            ].concat(args, [
                ac
            ]))
        };
    };
    var yCancel = function yCancel(task) {
        return {
            done: false,
            value: (0, $8f51be6e3f59daaa$export$3a1a48c8f6ef640e)(task)
        };
    };
    var task, action;
    var setTask = function setTask(t) {
        return task = t;
    };
    var setAction = function setAction(ac) {
        return action = ac;
    };
    return $17b5b1be37557756$var$fsmIterator({
        q1: function q1() {
            return {
                nextState: "q2",
                effect: yTake,
                stateUpdater: setAction
            };
        },
        q2: function q2() {
            return task ? {
                nextState: "q3",
                effect: yCancel(task)
            } : {
                nextState: "q1",
                effect: yFork(action),
                stateUpdater: setTask
            };
        },
        q3: function q3() {
            return {
                nextState: "q1",
                effect: yFork(action),
                stateUpdater: setTask
            };
        }
    }, "q1", "takeLatest(" + $17b5b1be37557756$var$safeName(patternOrChannel) + ", " + worker.name + ")");
}
function $17b5b1be37557756$var$takeLeading(patternOrChannel, worker) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    var yTake = {
        done: false,
        value: (0, $8f51be6e3f59daaa$export$3466f893ebf79586)(patternOrChannel)
    };
    var yCall = function yCall(ac) {
        return {
            done: false,
            value: (0, $8f51be6e3f59daaa$export$a07804094c3ecf2d).apply(void 0, [
                worker
            ].concat(args, [
                ac
            ]))
        };
    };
    var action;
    var setAction = function setAction(ac) {
        return action = ac;
    };
    return $17b5b1be37557756$var$fsmIterator({
        q1: function q1() {
            return {
                nextState: "q2",
                effect: yTake,
                stateUpdater: setAction
            };
        },
        q2: function q2() {
            return {
                nextState: "q1",
                effect: yCall(action)
            };
        }
    }, "q1", "takeLeading(" + $17b5b1be37557756$var$safeName(patternOrChannel) + ", " + worker.name + ")");
}
function $17b5b1be37557756$var$throttle(delayLength, patternOrChannel, worker) {
    for(var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++)args[_key - 3] = arguments[_key];
    var action, channel$1;
    var yTake = function yTake() {
        return {
            done: false,
            value: (0, $8f51be6e3f59daaa$export$3466f893ebf79586)(channel$1)
        };
    };
    var yFork = function yFork(ac) {
        return {
            done: false,
            value: (0, $8f51be6e3f59daaa$export$61196ced6d74a310).apply(void 0, [
                worker
            ].concat(args, [
                ac
            ]))
        };
    };
    var yDelay = {
        done: false,
        value: (0, $8f51be6e3f59daaa$export$c4ce752e73470fba)(delayLength)
    };
    var setAction = function setAction(ac) {
        return action = ac;
    };
    var setChannel = function setChannel(ch) {
        return channel$1 = ch;
    };
    var needsChannel = !(0, $8208d7224f148797$export$1f95fbd68d964d36)(patternOrChannel);
    if (!needsChannel) setChannel(patternOrChannel);
    return $17b5b1be37557756$var$fsmIterator({
        q1: function q1() {
            var yActionChannel = {
                done: false,
                value: (0, $8f51be6e3f59daaa$export$3722cfe417b6ed86)(patternOrChannel, (0, $8f51be6e3f59daaa$export$3a6d5c9ae78a2c08)(1))
            };
            return {
                nextState: "q2",
                effect: yActionChannel,
                stateUpdater: setChannel
            };
        },
        q2: function q2() {
            return {
                nextState: "q3",
                effect: yTake(),
                stateUpdater: setAction
            };
        },
        q3: function q3() {
            return {
                nextState: "q4",
                effect: yFork(action)
            };
        },
        q4: function q4() {
            return {
                nextState: "q2",
                effect: yDelay
            };
        }
    }, needsChannel ? "q1" : "q2", "throttle(" + $17b5b1be37557756$var$safeName(patternOrChannel) + ", " + worker.name + ")");
}
function $17b5b1be37557756$var$retry(maxTries, delayLength, fn) {
    var counter = maxTries;
    for(var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++)args[_key - 3] = arguments[_key];
    var yCall = {
        done: false,
        value: (0, $8f51be6e3f59daaa$export$a07804094c3ecf2d).apply(void 0, [
            fn
        ].concat(args))
    };
    var yDelay = {
        done: false,
        value: (0, $8f51be6e3f59daaa$export$c4ce752e73470fba)(delayLength)
    };
    return $17b5b1be37557756$var$fsmIterator({
        q1: function q1() {
            return {
                nextState: "q2",
                effect: yCall,
                errorState: "q10"
            };
        },
        q2: function q2() {
            return {
                nextState: $17b5b1be37557756$var$qEnd
            };
        },
        q10: function q10(error) {
            counter -= 1;
            if (counter <= 0) throw error;
            return {
                nextState: "q1",
                effect: yDelay
            };
        }
    }, "q1", "retry(" + fn.name + ")");
}
function $17b5b1be37557756$var$debounceHelper(delayLength, patternOrChannel, worker) {
    for(var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++)args[_key - 3] = arguments[_key];
    var action, raceOutput;
    var yTake = {
        done: false,
        value: (0, $8f51be6e3f59daaa$export$3466f893ebf79586)(patternOrChannel)
    };
    var yRace = {
        done: false,
        value: (0, $8f51be6e3f59daaa$export$e7c866399fa523f5)({
            action: (0, $8f51be6e3f59daaa$export$3466f893ebf79586)(patternOrChannel),
            debounce: (0, $8f51be6e3f59daaa$export$c4ce752e73470fba)(delayLength)
        })
    };
    var yFork = function yFork(ac) {
        return {
            done: false,
            value: (0, $8f51be6e3f59daaa$export$61196ced6d74a310).apply(void 0, [
                worker
            ].concat(args, [
                ac
            ]))
        };
    };
    var yNoop = function yNoop(value) {
        return {
            done: false,
            value: value
        };
    };
    var setAction = function setAction(ac) {
        return action = ac;
    };
    var setRaceOutput = function setRaceOutput(ro) {
        return raceOutput = ro;
    };
    return $17b5b1be37557756$var$fsmIterator({
        q1: function q1() {
            return {
                nextState: "q2",
                effect: yTake,
                stateUpdater: setAction
            };
        },
        q2: function q2() {
            return {
                nextState: "q3",
                effect: yRace,
                stateUpdater: setRaceOutput
            };
        },
        q3: function q3() {
            return raceOutput.debounce ? {
                nextState: "q1",
                effect: yFork(action)
            } : {
                nextState: "q2",
                effect: yNoop(raceOutput.action),
                stateUpdater: setAction
            };
        }
    }, "q1", "debounce(" + $17b5b1be37557756$var$safeName(patternOrChannel) + ", " + worker.name + ")");
}
var $17b5b1be37557756$var$validateTakeEffect = function validateTakeEffect(fn, patternOrChannel, worker) {
    (0, $8f51be6e3f59daaa$export$db3b6bfb95261072)(patternOrChannel, (0, $8208d7224f148797$export$1352885233577768), fn.name + " requires a pattern or channel");
    (0, $8f51be6e3f59daaa$export$db3b6bfb95261072)(worker, (0, $8208d7224f148797$export$1352885233577768), fn.name + " requires a saga parameter");
};
function $17b5b1be37557756$export$4e24be1e1c9d5c69(patternOrChannel, worker) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    return (0, $8f51be6e3f59daaa$export$61196ced6d74a310).apply(void 0, [
        $17b5b1be37557756$var$takeEvery,
        patternOrChannel,
        worker
    ].concat(args));
}
function $17b5b1be37557756$export$ca010cea618a298a(patternOrChannel, worker) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++)args[_key2 - 2] = arguments[_key2];
    return (0, $8f51be6e3f59daaa$export$61196ced6d74a310).apply(void 0, [
        $17b5b1be37557756$var$takeLatest,
        patternOrChannel,
        worker
    ].concat(args));
}
function $17b5b1be37557756$export$ab18f80dcccecca4(patternOrChannel, worker) {
    for(var _len3 = arguments.length, args = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)args[_key3 - 2] = arguments[_key3];
    return (0, $8f51be6e3f59daaa$export$61196ced6d74a310).apply(void 0, [
        $17b5b1be37557756$var$takeLeading,
        patternOrChannel,
        worker
    ].concat(args));
}
function $17b5b1be37557756$export$de363e709c412c8a(ms, patternOrChannel, worker) {
    for(var _len4 = arguments.length, args = new Array(_len4 > 3 ? _len4 - 3 : 0), _key4 = 3; _key4 < _len4; _key4++)args[_key4 - 3] = arguments[_key4];
    return (0, $8f51be6e3f59daaa$export$61196ced6d74a310).apply(void 0, [
        $17b5b1be37557756$var$throttle,
        ms,
        patternOrChannel,
        worker
    ].concat(args));
}
function $17b5b1be37557756$export$9369b12211e1fce4(maxTries, delayLength, worker) {
    for(var _len5 = arguments.length, args = new Array(_len5 > 3 ? _len5 - 3 : 0), _key5 = 3; _key5 < _len5; _key5++)args[_key5 - 3] = arguments[_key5];
    return (0, $8f51be6e3f59daaa$export$a07804094c3ecf2d).apply(void 0, [
        $17b5b1be37557756$var$retry,
        maxTries,
        delayLength,
        worker
    ].concat(args));
}
function $17b5b1be37557756$export$61fc7d43ac8f84b0(delayLength, pattern, worker) {
    for(var _len6 = arguments.length, args = new Array(_len6 > 3 ? _len6 - 3 : 0), _key6 = 3; _key6 < _len6; _key6++)args[_key6 - 3] = arguments[_key6];
    return (0, $8f51be6e3f59daaa$export$61196ced6d74a310).apply(void 0, [
        $17b5b1be37557756$var$debounceHelper,
        delayLength,
        pattern,
        worker
    ].concat(args));
}





var $aivMx = parcelRequire("aivMx");
var $e58e8d2b21900e4d$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e58e8d2b21900e4d$var$ReactIs, $e58e8d2b21900e4d$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$e58e8d2b21900e4d$exports = (parcelRequire("lJpQh"))();


// The primary entry point assumes we're working with standard ReactDOM/RN, but
// older versions that do not include `useSyncExternalStore` (React 16.9 - 17.x).
// Because of that, the useSyncExternalStore compat shim is needed.

var $5MEMe = parcelRequire("5MEMe");
var $e5d28596ff67251c$exports = {};
"use strict";

$e5d28596ff67251c$exports = (parcelRequire("jh9FG"));





// Default to a dummy "batch" implementation that just runs the callback
function $4c61203c9cf36eaa$var$defaultNoopBatch(callback) {
    callback();
}
let $4c61203c9cf36eaa$var$batch = $4c61203c9cf36eaa$var$defaultNoopBatch; // Allow injecting another batching function later
const $4c61203c9cf36eaa$export$4b9874722d0da7bc = (newBatch)=>$4c61203c9cf36eaa$var$batch = newBatch; // Supply a getter just to skip dealing with ESM bindings
const $4c61203c9cf36eaa$export$fc47d4c0ba3bd2c6 = ()=>$4c61203c9cf36eaa$var$batch;



var $aivMx = parcelRequire("aivMx");

var $aivMx = parcelRequire("aivMx");

var $aivMx = parcelRequire("aivMx");
const $361aa446d88712bf$var$ContextKey = Symbol.for(`react-redux-context`);
const $361aa446d88712bf$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $361aa446d88712bf$var$getContext() {
    var _gT$ContextKey;
    if (!$aivMx.createContext) return {};
    const contextMap = (_gT$ContextKey = $361aa446d88712bf$var$gT[$361aa446d88712bf$var$ContextKey]) != null ? _gT$ContextKey : $361aa446d88712bf$var$gT[$361aa446d88712bf$var$ContextKey] = new Map();
    let realContext = contextMap.get($aivMx.createContext);
    if (!realContext) {
        realContext = $aivMx.createContext(null);
        contextMap.set($aivMx.createContext, realContext);
    }
    return realContext;
}
const $361aa446d88712bf$export$cc80c08dc91f1c00 = /*#__PURE__*/ $361aa446d88712bf$var$getContext();
var $361aa446d88712bf$export$2e2bcd8739ae039 = $361aa446d88712bf$export$cc80c08dc91f1c00;


function $4127e7c544b4c057$export$d4d6226d5fc61558(context = (0, $361aa446d88712bf$export$cc80c08dc91f1c00)) {
    return function useReduxContext() {
        const contextValue = (0, $aivMx.useContext)(context);
        return contextValue;
    };
}
const $4127e7c544b4c057$export$c1275ca9a6fd3ec5 = /*#__PURE__*/ $4127e7c544b4c057$export$d4d6226d5fc61558();



const $abfd7c056df8e569$export$20656a4825650bd0 = ()=>{
    throw new Error("uSES not initialized!");
};


let $f40d1f3d995cccef$var$useSyncExternalStoreWithSelector = (0, $abfd7c056df8e569$export$20656a4825650bd0);
const $f40d1f3d995cccef$export$e2e6e3f3f3b782e3 = (fn)=>{
    $f40d1f3d995cccef$var$useSyncExternalStoreWithSelector = fn;
};
const $f40d1f3d995cccef$var$refEquality = (a, b)=>a === b;
function $f40d1f3d995cccef$export$2b53f90d2bd1cbfb(context = (0, $361aa446d88712bf$export$cc80c08dc91f1c00)) {
    const useReduxContext = context === (0, $361aa446d88712bf$export$cc80c08dc91f1c00) ? (0, $4127e7c544b4c057$export$c1275ca9a6fd3ec5) : (0, $4127e7c544b4c057$export$d4d6226d5fc61558)(context);
    return function useSelector(selector, equalityFnOrOptions = {}) {
        const { equalityFn: equalityFn = $f40d1f3d995cccef$var$refEquality, stabilityCheck: stabilityCheck, noopCheck: noopCheck } = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const { store: store, subscription: subscription, getServerState: getServerState, stabilityCheck: globalStabilityCheck, noopCheck: globalNoopCheck } = useReduxContext();
        const firstRun = (0, $aivMx.useRef)(true);
        const wrappedSelector = (0, $aivMx.useCallback)({
            [selector.name] (state) {
                const selected = selector(state);
                return selected;
            }
        }[selector.name], [
            selector,
            globalStabilityCheck,
            stabilityCheck
        ]);
        const selectedState = $f40d1f3d995cccef$var$useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        (0, $aivMx.useDebugValue)(selectedState);
        return selectedState;
    };
}
const $f40d1f3d995cccef$export$2105062e25df4afe = /*#__PURE__*/ $f40d1f3d995cccef$export$2b53f90d2bd1cbfb();




var $a32b854b69af5a94$exports = {};
"use strict";
var $c96e60eb6cff7e49$exports = {};
"use strict";

$c96e60eb6cff7e49$exports = (parcelRequire("A9JWB"));


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $a32b854b69af5a94$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $a32b854b69af5a94$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $a32b854b69af5a94$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $a32b854b69af5a94$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $a32b854b69af5a94$var$TYPE_STATICS = {};
$a32b854b69af5a94$var$TYPE_STATICS[$c96e60eb6cff7e49$exports.ForwardRef] = $a32b854b69af5a94$var$FORWARD_REF_STATICS;
$a32b854b69af5a94$var$TYPE_STATICS[$c96e60eb6cff7e49$exports.Memo] = $a32b854b69af5a94$var$MEMO_STATICS;
function $a32b854b69af5a94$var$getStatics(component) {
    // React v16.11 and below
    if ($c96e60eb6cff7e49$exports.isMemo(component)) return $a32b854b69af5a94$var$MEMO_STATICS;
     // React v16.12 and above
    return $a32b854b69af5a94$var$TYPE_STATICS[component["$$typeof"]] || $a32b854b69af5a94$var$REACT_STATICS;
}
var $a32b854b69af5a94$var$defineProperty = Object.defineProperty;
var $a32b854b69af5a94$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $a32b854b69af5a94$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $a32b854b69af5a94$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $a32b854b69af5a94$var$getPrototypeOf = Object.getPrototypeOf;
var $a32b854b69af5a94$var$objectPrototype = Object.prototype;
function $a32b854b69af5a94$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($a32b854b69af5a94$var$objectPrototype) {
            var inheritedComponent = $a32b854b69af5a94$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $a32b854b69af5a94$var$objectPrototype) $a32b854b69af5a94$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $a32b854b69af5a94$var$getOwnPropertyNames(sourceComponent);
        if ($a32b854b69af5a94$var$getOwnPropertySymbols) keys = keys.concat($a32b854b69af5a94$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $a32b854b69af5a94$var$getStatics(targetComponent);
        var sourceStatics = $a32b854b69af5a94$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$a32b854b69af5a94$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $a32b854b69af5a94$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $a32b854b69af5a94$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$a32b854b69af5a94$exports = $a32b854b69af5a94$var$hoistNonReactStatics;



var $aivMx = parcelRequire("aivMx");
var $5280ebdf6a2fee14$exports = {};
"use strict";

$5280ebdf6a2fee14$exports = (parcelRequire("hSPEQ"));



/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $c8dcf2f11e553f3d$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }


function $2d55f4e5d3122779$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) (0, $c8dcf2f11e553f3d$export$2e2bcd8739ae039)(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $2d55f4e5d3122779$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps) {
    $2d55f4e5d3122779$var$verify(mapStateToProps, "mapStateToProps");
    $2d55f4e5d3122779$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $2d55f4e5d3122779$var$verify(mergeProps, "mergeProps");
}


const $d994fed38fdd2c9c$var$_excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function $d994fed38fdd2c9c$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $d994fed38fdd2c9c$export$2e2bcd8739ae039(dispatch, _ref) {
    let { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _ref, options = (0, $612ace97f19660e2$export$2e2bcd8739ae039)(_ref, $d994fed38fdd2c9c$var$_excluded);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $d994fed38fdd2c9c$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}


function $5ff7f2480956b8ce$export$2e2bcd8739ae039(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}


/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $e7102004ed25fa60$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    let proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}



function $2faf2ca8db4437d4$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $e7102004ed25fa60$export$2e2bcd8739ae039)(value)) (0, $c8dcf2f11e553f3d$export$2e2bcd8739ae039)(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}


function $70699fd7311458e3$export$710f7c60f68acd3e(//  It seems that the dispatch argument
//  could be a dispatch function in some cases (ex: whenMapDispatchToPropsIsMissing)
//  and a state object in some others (ex: whenMapStateToPropsIsMissing)
// eslint-disable-next-line no-unused-vars
getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $70699fd7311458e3$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $70699fd7311458e3$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, undefined);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $70699fd7311458e3$export$e561b938df936d57(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $70699fd7311458e3$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}


function $053a6eaee2a635f2$export$19ef7b929f7e2559(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}


function $fca739655e9c9f6b$export$b69a785ceac019a6(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? (0, $70699fd7311458e3$export$710f7c60f68acd3e)((dispatch)=>(0, $5ff7f2480956b8ce$export$2e2bcd8739ae039)(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? (0, $70699fd7311458e3$export$710f7c60f68acd3e)((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === "function" ? (0, $70699fd7311458e3$export$8d46c7f53c8c602f)(mapDispatchToProps, "mapDispatchToProps") : (0, $053a6eaee2a635f2$export$19ef7b929f7e2559)(mapDispatchToProps, "mapDispatchToProps");
}




function $07a90a3d2d029fc5$export$e00e93951827eda7(mapStateToProps) {
    return !mapStateToProps ? (0, $70699fd7311458e3$export$710f7c60f68acd3e)(()=>({})) : typeof mapStateToProps === "function" ? (0, $70699fd7311458e3$export$8d46c7f53c8c602f)(mapStateToProps, "mapStateToProps") : (0, $053a6eaee2a635f2$export$19ef7b929f7e2559)(mapStateToProps, "mapStateToProps");
}





function $4d90bd7c26246bf4$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    // @ts-ignore
    return (0, $6767be368738adce$export$2e2bcd8739ae039)({}, ownProps, stateProps, dispatchProps);
}
function $4d90bd7c26246bf4$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $4d90bd7c26246bf4$export$17457cf6fa742f84(mergeProps) {
    return !mergeProps ? ()=>$4d90bd7c26246bf4$export$691c327fc30bc857 : typeof mergeProps === "function" ? $4d90bd7c26246bf4$export$5b105939c84b5234(mergeProps) : (0, $053a6eaee2a635f2$export$19ef7b929f7e2559)(mergeProps, "mergeProps");
}



// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function $39e2d9229ed3e385$var$createListenerCollection() {
    const batch = (0, $4c61203c9cf36eaa$export$fc47d4c0ba3bd2c6)();
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            batch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            let listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            let listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
const $39e2d9229ed3e385$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $39e2d9229ed3e385$export$d567d2b9af322f8f(store, parentSub) {
    let unsubscribe;
    let listeners = $39e2d9229ed3e385$var$nullListeners;
    function addNestedSub(listener) {
        trySubscribe();
        return listeners.subscribe(listener);
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return Boolean(unsubscribe);
    }
    function trySubscribe() {
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $39e2d9229ed3e385$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        if (unsubscribe) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = $39e2d9229ed3e385$var$nullListeners;
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribe,
        tryUnsubscribe: tryUnsubscribe,
        getListeners: ()=>listeners
    };
    return subscription;
}



var $aivMx = parcelRequire("aivMx");
const $d6662a22e770eb21$export$71594e8a50f746f4 = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
const $d6662a22e770eb21$export$700979bc83e7db82 = $d6662a22e770eb21$export$71594e8a50f746f4 ? $aivMx.useLayoutEffect : $aivMx.useEffect;


function $b1dd956634aa1b08$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $b1dd956634aa1b08$export$2e2bcd8739ae039(objA, objB) {
    if ($b1dd956634aa1b08$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$b1dd956634aa1b08$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}





const $0e647a1d90b9cc81$var$_excluded = [
    "reactReduxForwardedRef"
];
let $0e647a1d90b9cc81$var$useSyncExternalStore = (0, $abfd7c056df8e569$export$20656a4825650bd0);
const $0e647a1d90b9cc81$export$36d45daa6a4925b8 = (fn)=>{
    $0e647a1d90b9cc81$var$useSyncExternalStore = fn;
}; // Define some constant arrays just to avoid re-creating these
const $0e647a1d90b9cc81$var$EMPTY_ARRAY = [
    null,
    0
];
const $0e647a1d90b9cc81$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
]; // Attempts to stringify whatever not-really-a-component value we were given
// for logging in an error message
const $0e647a1d90b9cc81$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
// This is "just" a `useLayoutEffect`, but with two modifications:
// - we need to fall back to `useEffect` in SSR to avoid annoying warnings
// - we extract this to a separate function to avoid closing over values
//   and causing memory leaks
function $0e647a1d90b9cc81$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, $d6662a22e770eb21$export$700979bc83e7db82)(()=>effectFunc(...effectArgs), dependencies);
} // Effect callback, extracted: assign the latest props values to refs for later usage
function $0e647a1d90b9cc81$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
} // Effect callback, extracted: subscribe to the Redux store or nearest connected ancestor,
// check for updates after dispatched actions, and trigger re-renders.
function $0e647a1d90b9cc81$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return ()=>{}; // Capture values for checking if and when this component unmounts
    let didUnsubscribe = false;
    let lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
         // TODO We're currently calling getState ourselves here, rather than letting `uSES` do it
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // TODO This is hacky and not how `uSES` is meant to be used
            // Trigger the React `useSyncExternalStore` subscriber
            additionalSubscribeListener();
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
} // Reducer initial state creation for our update reducer
const $0e647a1d90b9cc81$var$initStateUpdates = ()=>$0e647a1d90b9cc81$var$EMPTY_ARRAY;
function $0e647a1d90b9cc81$var$strictEqual(a, b) {
    return a === b;
}
/**
 * Infers the type of props that a connector will inject into a component.
 */ let $0e647a1d90b9cc81$var$hasWarnedAboutDeprecatedPureOption = false;
/**
 * Connects a React component to a Redux store.
 *
 * - Without arguments, just wraps the component, without changing the behavior / props
 *
 * - If 2 params are passed (3rd param, mergeProps, is skipped), default behavior
 * is to override ownProps (as stated in the docs), so what remains is everything that's
 * not a state or dispatch prop
 *
 * - When 3rd param is passed, we don't know if ownProps propagate and whether they
 * should be valid component props, because it depends on mergeProps implementation.
 * As such, it is the user's responsibility to extend ownProps interface from state or
 * dispatch props or both when applicable
 *
 * @param mapStateToProps A function that extracts values from state
 * @param mapDispatchToProps Setup for dispatching actions
 * @param mergeProps Optional callback to merge state and dispatch props together
 * @param options Options for configuring the connection
 *
 */ function $0e647a1d90b9cc81$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $0e647a1d90b9cc81$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = (0, $b1dd956634aa1b08$export$2e2bcd8739ae039), areStatePropsEqual: areStatePropsEqual = (0, $b1dd956634aa1b08$export$2e2bcd8739ae039), areMergedPropsEqual: areMergedPropsEqual = (0, $b1dd956634aa1b08$export$2e2bcd8739ae039), forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = (0, $361aa446d88712bf$export$cc80c08dc91f1c00) } = {}) {
    const Context = context;
    const initMapStateToProps = (0, $07a90a3d2d029fc5$export$e00e93951827eda7)(mapStateToProps);
    const initMapDispatchToProps = (0, $fca739655e9c9f6b$export$b69a785ceac019a6)(mapDispatchToProps);
    const initMergeProps = (0, $4d90bd7c26246bf4$export$17457cf6fa742f84)(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: // @ts-ignore
            initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $aivMx.useMemo(()=>{
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                const { reactReduxForwardedRef: reactReduxForwardedRef } = props, wrapperProps = (0, $612ace97f19660e2$export$2e2bcd8739ae039)(props, $0e647a1d90b9cc81$var$_excluded);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]);
            const ContextToUse = $aivMx.useMemo(()=>{
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && // @ts-ignore
                (0, $5280ebdf6a2fee14$exports.isContextConsumer)(/*#__PURE__*/ $aivMx.createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            const contextValue = $aivMx.useContext(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $aivMx.useMemo(()=>{
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return (0, $d994fed38fdd2c9c$export$2e2bcd8739ae039)(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $aivMx.useMemo(()=>{
                if (!shouldHandleStateChanges) return $0e647a1d90b9cc81$var$NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                const subscription = (0, $39e2d9229ed3e385$export$d567d2b9af322f8f)(store, didStoreComeFromProps ? undefined : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                const notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]); // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            const overriddenContextValue = $aivMx.useMemo(()=>{
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, $6767be368738adce$export$2e2bcd8739ae039)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // Set up refs to coordinate values between the subscription effect and the render logic
            const lastChildProps = $aivMx.useRef();
            const lastWrapperProps = $aivMx.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $aivMx.useRef();
            const renderIsScheduled = $aivMx.useRef(false);
            const isProcessingDispatch = $aivMx.useRef(false);
            const isMounted = $aivMx.useRef(false);
            const latestSubscriptionCallbackError = $aivMx.useRef();
            (0, $d6662a22e770eb21$export$700979bc83e7db82)(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $aivMx.useMemo(()=>{
                const selector = ()=>{
                    // Tricky logic here:
                    // - This render may have been triggered by a Redux store update that produced new child props
                    // - However, we may have gotten new wrapper props after that
                    // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                    // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                    // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                     // TODO We're reading the store directly in render() here. Bad idea?
                    // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                    // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                    // to determine what the child props should be.
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            const subscribeForReact = $aivMx.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $0e647a1d90b9cc81$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $0e647a1d90b9cc81$var$useIsomorphicLayoutEffectWithArgs($0e647a1d90b9cc81$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $0e647a1d90b9cc81$var$useSyncExternalStore(subscribeForReact, // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `\nThe error may be correlated with this previous error:\n${latestSubscriptionCallbackError.current.stack}\n\n`;
                throw err;
            }
            (0, $d6662a22e770eb21$export$700979bc83e7db82)(()=>{
                latestSubscriptionCallbackError.current = undefined;
                childPropsFromStoreUpdate.current = undefined;
                lastChildProps.current = actualChildProps;
            }); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            const renderedWrappedComponent = $aivMx.useMemo(()=>{
                return(/*#__PURE__*/ // @ts-ignore
                $aivMx.createElement(WrappedComponent, (0, $6767be368738adce$export$2e2bcd8739ae039)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            const renderedChild = $aivMx.useMemo(()=>{
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ $aivMx.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $aivMx.memo(ConnectFunction);
        // Add a hacky cast to get the right output type
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $aivMx.forwardRef(function forwardConnectRef(props, ref) {
                // @ts-ignore
                return /*#__PURE__*/ $aivMx.createElement(Connect, (0, $6767be368738adce$export$2e2bcd8739ae039)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($a32b854b69af5a94$exports)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($a32b854b69af5a94$exports)))(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $0e647a1d90b9cc81$export$2e2bcd8739ae039 = $0e647a1d90b9cc81$var$connect;



var $aivMx = parcelRequire("aivMx");



function $7a57c545a1f92740$var$Provider({ store: store, context: context, children: children, serverState: serverState, stabilityCheck: stabilityCheck = "once", noopCheck: noopCheck = "once" }) {
    const contextValue = $aivMx.useMemo(()=>{
        const subscription = (0, $39e2d9229ed3e385$export$d567d2b9af322f8f)(store);
        return {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : undefined,
            stabilityCheck: stabilityCheck,
            noopCheck: noopCheck
        };
    }, [
        store,
        serverState,
        stabilityCheck,
        noopCheck
    ]);
    const previousState = $aivMx.useMemo(()=>store.getState(), [
        store
    ]);
    (0, $d6662a22e770eb21$export$700979bc83e7db82)(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = undefined;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || (0, $361aa446d88712bf$export$cc80c08dc91f1c00); // @ts-ignore 'AnyAction' is assignable to the constraint of type 'A', but 'A' could be instantiated with a different subtype
    return /*#__PURE__*/ $aivMx.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $7a57c545a1f92740$export$2e2bcd8739ae039 = $7a57c545a1f92740$var$Provider;







function $864b0261b61c7c4a$export$671dba69185d0304(context = (0, $361aa446d88712bf$export$cc80c08dc91f1c00)) {
    const useReduxContext = context === (0, $361aa446d88712bf$export$cc80c08dc91f1c00) ? (0, $4127e7c544b4c057$export$c1275ca9a6fd3ec5) : (0, $4127e7c544b4c057$export$d4d6226d5fc61558)(context);
    return function useStore() {
        const { store: store } = useReduxContext(); // @ts-ignore
        return store;
    };
}
const $864b0261b61c7c4a$export$6ccbb43953eebf8 = /*#__PURE__*/ $864b0261b61c7c4a$export$671dba69185d0304();


function $d023060d48542f4c$export$bc9b55530897c558(context = (0, $361aa446d88712bf$export$cc80c08dc91f1c00)) {
    const useStore = context === (0, $361aa446d88712bf$export$cc80c08dc91f1c00) ? (0, $864b0261b61c7c4a$export$6ccbb43953eebf8) : (0, $864b0261b61c7c4a$export$671dba69185d0304)(context);
    return function useDispatch() {
        const store = useStore(); // @ts-ignore
        return store.dispatch;
    };
}
const $d023060d48542f4c$export$8ad76b76a4c905f8 = /*#__PURE__*/ $d023060d48542f4c$export$bc9b55530897c558();









(0, $f40d1f3d995cccef$export$e2e6e3f3f3b782e3)((0, $e5d28596ff67251c$exports.useSyncExternalStoreWithSelector));
(0, $0e647a1d90b9cc81$export$36d45daa6a4925b8)((0, $5MEMe.useSyncExternalStore)); // Enable batched updates in our subscriptions for use
// with standard React renderers (ReactDOM, React Native)
(0, $4c61203c9cf36eaa$export$4b9874722d0da7bc)((0, $9f97ad3b314012cb$exports.unstable_batchedUpdates));


function $cce73e5d1d37055b$export$2e2bcd8739ae039(o, p) {
    $cce73e5d1d37055b$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $cce73e5d1d37055b$export$2e2bcd8739ae039(o, p);
}


function $0d767dd10c1fa0a3$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $cce73e5d1d37055b$export$2e2bcd8739ae039)(subClass, superClass);
}



var $aivMx = parcelRequire("aivMx");




var $aivMx = parcelRequire("aivMx");



var $ba53b1b3ac1ca015$var$MAX_SIGNED_31_BIT_INT = 1073741823;
var $ba53b1b3ac1ca015$var$commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : {};
function $ba53b1b3ac1ca015$var$getUniqueId() {
    var key = "__global_unique_id__";
    return $ba53b1b3ac1ca015$var$commonjsGlobal[key] = ($ba53b1b3ac1ca015$var$commonjsGlobal[key] || 0) + 1;
}
function $ba53b1b3ac1ca015$var$objectIs(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $ba53b1b3ac1ca015$var$createEventEmitter(value) {
    var handlers = [];
    return {
        on: function on(handler) {
            handlers.push(handler);
        },
        off: function off(handler) {
            handlers = handlers.filter(function(h) {
                return h !== handler;
            });
        },
        get: function get() {
            return value;
        },
        set: function set(newValue, changedBits) {
            value = newValue;
            handlers.forEach(function(handler) {
                return handler(value, changedBits);
            });
        }
    };
}
function $ba53b1b3ac1ca015$var$onlyChild(children) {
    return Array.isArray(children) ? children[0] : children;
}
function $ba53b1b3ac1ca015$var$createReactContext(defaultValue, calculateChangedBits) {
    var _Provider$childContex, _Consumer$contextType;
    var contextProp = "__create-react-context-" + $ba53b1b3ac1ca015$var$getUniqueId() + "__";
    var Provider = /*#__PURE__*/ function(_Component) {
        (0, $0d767dd10c1fa0a3$export$2e2bcd8739ae039)(Provider, _Component);
        function Provider() {
            var _this;
            _this = _Component.apply(this, arguments) || this;
            _this.emitter = $ba53b1b3ac1ca015$var$createEventEmitter(_this.props.value);
            return _this;
        }
        var _proto = Provider.prototype;
        _proto.getChildContext = function getChildContext() {
            var _ref;
            return _ref = {}, _ref[contextProp] = this.emitter, _ref;
        };
        _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            if (this.props.value !== nextProps.value) {
                var oldValue = this.props.value;
                var newValue = nextProps.value;
                var changedBits;
                if ($ba53b1b3ac1ca015$var$objectIs(oldValue, newValue)) changedBits = 0;
                else {
                    changedBits = typeof calculateChangedBits === "function" ? calculateChangedBits(oldValue, newValue) : $ba53b1b3ac1ca015$var$MAX_SIGNED_31_BIT_INT;
                    changedBits |= 0;
                    if (changedBits !== 0) this.emitter.set(nextProps.value, changedBits);
                }
            }
        };
        _proto.render = function render() {
            return this.props.children;
        };
        return Provider;
    }((0, $aivMx.Component));
    Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).object.isRequired, _Provider$childContex);
    var Consumer = /*#__PURE__*/ function(_Component2) {
        (0, $0d767dd10c1fa0a3$export$2e2bcd8739ae039)(Consumer, _Component2);
        function Consumer() {
            var _this2;
            _this2 = _Component2.apply(this, arguments) || this;
            _this2.state = {
                value: _this2.getValue()
            };
            _this2.onUpdate = function(newValue, changedBits) {
                var observedBits = _this2.observedBits | 0;
                if ((observedBits & changedBits) !== 0) _this2.setState({
                    value: _this2.getValue()
                });
            };
            return _this2;
        }
        var _proto2 = Consumer.prototype;
        _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            var observedBits = nextProps.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $ba53b1b3ac1ca015$var$MAX_SIGNED_31_BIT_INT : observedBits;
        };
        _proto2.componentDidMount = function componentDidMount() {
            if (this.context[contextProp]) this.context[contextProp].on(this.onUpdate);
            var observedBits = this.props.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $ba53b1b3ac1ca015$var$MAX_SIGNED_31_BIT_INT : observedBits;
        };
        _proto2.componentWillUnmount = function componentWillUnmount() {
            if (this.context[contextProp]) this.context[contextProp].off(this.onUpdate);
        };
        _proto2.getValue = function getValue() {
            if (this.context[contextProp]) return this.context[contextProp].get();
            else return defaultValue;
        };
        _proto2.render = function render() {
            return $ba53b1b3ac1ca015$var$onlyChild(this.props.children)(this.state.value);
        };
        return Consumer;
    }((0, $aivMx.Component));
    Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).object, _Consumer$contextType);
    return {
        Provider: Provider,
        Consumer: Consumer
    };
}
var $ba53b1b3ac1ca015$var$index = (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).createContext || $ba53b1b3ac1ca015$var$createReactContext;
var $ba53b1b3ac1ca015$export$2e2bcd8739ae039 = $ba53b1b3ac1ca015$var$index;




var $f37523df22180869$exports = {};
var $0d63d13190381196$exports = {};
$0d63d13190381196$exports = Array.isArray || function(arr) {
    return Object.prototype.toString.call(arr) == "[object Array]";
};


/**
 * Expose `pathToRegexp`.
 */ $f37523df22180869$exports = $f37523df22180869$var$pathToRegexp;
$f37523df22180869$exports.parse = $f37523df22180869$var$parse;
$f37523df22180869$exports.compile = $f37523df22180869$var$compile;
$f37523df22180869$exports.tokensToFunction = $f37523df22180869$var$tokensToFunction;
$f37523df22180869$exports.tokensToRegExp = $f37523df22180869$var$tokensToRegExp;
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var $f37523df22180869$var$PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    "(\\\\.)",
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
    // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
    // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
    "([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))"
].join("|"), "g");
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function $f37523df22180869$var$parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = "";
    var defaultDelimiter = options && options.delimiter || "/";
    var res;
    while((res = $f37523df22180869$var$PATH_REGEXP.exec(str)) != null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            continue;
        }
        var next = str[index];
        var prefix = res[2];
        var name = res[3];
        var capture = res[4];
        var group = res[5];
        var modifier = res[6];
        var asterisk = res[7];
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = "";
        }
        var partial = prefix != null && next != null && next !== prefix;
        var repeat = modifier === "+" || modifier === "*";
        var optional = modifier === "?" || modifier === "*";
        var delimiter = res[2] || defaultDelimiter;
        var pattern = capture || group;
        tokens.push({
            name: name || key++,
            prefix: prefix || "",
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            asterisk: !!asterisk,
            pattern: pattern ? $f37523df22180869$var$escapeGroup(pattern) : asterisk ? ".*" : "[^" + $f37523df22180869$var$escapeString(delimiter) + "]+?"
        });
    }
    // Match any characters still remaining.
    if (index < str.length) path += str.substr(index);
    // If the path exists, push it onto the end.
    if (path) tokens.push(path);
    return tokens;
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function $f37523df22180869$var$compile(str, options) {
    return $f37523df22180869$var$tokensToFunction($f37523df22180869$var$parse(str, options), options);
}
/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */ function $f37523df22180869$var$encodeURIComponentPretty(str) {
    return encodeURI(str).replace(/[\/?#]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */ function $f37523df22180869$var$encodeAsterisk(str) {
    return encodeURI(str).replace(/[?#]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function $f37523df22180869$var$tokensToFunction(tokens, options) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === "object") matches[i] = new RegExp("^(?:" + tokens[i].pattern + ")$", $f37523df22180869$var$flags(options));
    return function(obj, opts) {
        var path = "";
        var data = obj || {};
        var options = opts || {};
        var encode = options.pretty ? $f37523df22180869$var$encodeURIComponentPretty : encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === "string") {
                path += token;
                continue;
            }
            var value = data[token.name];
            var segment;
            if (value == null) {
                if (token.optional) {
                    // Prepend partial segment prefixes.
                    if (token.partial) path += token.prefix;
                    continue;
                } else throw new TypeError('Expected "' + token.name + '" to be defined');
            }
            if ($0d63d13190381196$exports(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + "`");
                if (value.length === 0) {
                    if (token.optional) continue;
                    else throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j]);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + "`");
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            segment = token.asterisk ? $f37523df22180869$var$encodeAsterisk(value) : encode(value);
            if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
            path += token.prefix + segment;
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function $f37523df22180869$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, "\\$1");
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function $f37523df22180869$var$escapeGroup(group) {
    return group.replace(/([=!:$\/()])/g, "\\$1");
}
/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */ function $f37523df22180869$var$attachKeys(re, keys) {
    re.keys = keys;
    return re;
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function $f37523df22180869$var$flags(options) {
    return options && options.sensitive ? "" : "i";
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */ function $f37523df22180869$var$regexpToRegexp(path, keys) {
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
    });
    return $f37523df22180869$var$attachKeys(path, keys);
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $f37523df22180869$var$arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push($f37523df22180869$var$pathToRegexp(path[i], keys, options).source);
    var regexp = new RegExp("(?:" + parts.join("|") + ")", $f37523df22180869$var$flags(options));
    return $f37523df22180869$var$attachKeys(regexp, keys);
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $f37523df22180869$var$stringToRegexp(path, keys, options) {
    return $f37523df22180869$var$tokensToRegExp($f37523df22180869$var$parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */ function $f37523df22180869$var$tokensToRegExp(tokens, keys, options) {
    if (!$0d63d13190381196$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    var strict = options.strict;
    var end = options.end !== false;
    var route = "";
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === "string") route += $f37523df22180869$var$escapeString(token);
        else {
            var prefix = $f37523df22180869$var$escapeString(token.prefix);
            var capture = "(?:" + token.pattern + ")";
            keys.push(token);
            if (token.repeat) capture += "(?:" + prefix + capture + ")*";
            if (token.optional) {
                if (!token.partial) capture = "(?:" + prefix + "(" + capture + "))?";
                else capture = prefix + "(" + capture + ")?";
            } else capture = prefix + "(" + capture + ")";
            route += capture;
        }
    }
    var delimiter = $f37523df22180869$var$escapeString(options.delimiter || "/");
    var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
    // In non-strict mode we allow a slash at the end of match. If the path to
    // match already ends with a slash, we remove it for consistency. The slash
    // is valid at the end of a path match, not in the middle. This is important
    // in non-ending mode, where "/test/" shouldn't match "/test//route".
    if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + "(?:" + delimiter + "(?=$))?";
    if (end) route += "$";
    else // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? "" : "(?=" + delimiter + "|$)";
    return $f37523df22180869$var$attachKeys(new RegExp("^" + route, $f37523df22180869$var$flags(options)), keys);
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function $f37523df22180869$var$pathToRegexp(path, keys, options) {
    if (!$0d63d13190381196$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    if (path instanceof RegExp) return $f37523df22180869$var$regexpToRegexp(path, /** @type {!Array} */ keys);
    if ($0d63d13190381196$exports(path)) return $f37523df22180869$var$arrayToRegexp(/** @type {!Array} */ path, /** @type {!Array} */ keys, options);
    return $f37523df22180869$var$stringToRegexp(/** @type {string} */ path, /** @type {!Array} */ keys, options);
}





// TODO: Replace with React.createContext once we can assume React 16+
var $8e7337eeed3043b3$var$createNamedContext = function createNamedContext(name) {
    var context = (0, $ba53b1b3ac1ca015$export$2e2bcd8739ae039)();
    context.displayName = name;
    return context;
};
var $8e7337eeed3043b3$export$c213558b66925821 = /*#__PURE__*/ $8e7337eeed3043b3$var$createNamedContext("Router-History");
// TODO: Replace with React.createContext once we can assume React 16+
var $8e7337eeed3043b3$var$createNamedContext$1 = function createNamedContext(name) {
    var context = (0, $ba53b1b3ac1ca015$export$2e2bcd8739ae039)();
    context.displayName = name;
    return context;
};
var $8e7337eeed3043b3$export$63baa8ccbe60bb07 = /*#__PURE__*/ $8e7337eeed3043b3$var$createNamedContext$1("Router");
/**
 * The public API for putting history on context.
 */ var $8e7337eeed3043b3$export$55185c17a0fcbe46 = /*#__PURE__*/ function(_React$Component) {
    (0, $0d767dd10c1fa0a3$export$2e2bcd8739ae039)(Router, _React$Component);
    Router.computeRootMatch = function computeRootMatch(pathname) {
        return {
            path: "/",
            url: "/",
            params: {},
            isExact: pathname === "/"
        };
    };
    function Router(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.state = {
            location: props.history.location
        }; // This is a bit of a hack. We have to start listening for location
        // changes here in the constructor in case there are any <Redirect>s
        // on the initial render. If there are, they will replace/push when
        // they mount and since cDM fires in children before parents, we may
        // get a new location before the <Router> is mounted.
        _this._isMounted = false;
        _this._pendingLocation = null;
        if (!props.staticContext) _this.unlisten = props.history.listen(function(location) {
            if (_this._isMounted) _this.setState({
                location: location
            });
            else _this._pendingLocation = location;
        });
        return _this;
    }
    var _proto = Router.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this._isMounted = true;
        if (this._pendingLocation) this.setState({
            location: this._pendingLocation
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.unlisten) this.unlisten();
    };
    _proto.render = function render() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).createElement($8e7337eeed3043b3$export$63baa8ccbe60bb07.Provider, {
            value: {
                history: this.props.history,
                location: this.state.location,
                match: Router.computeRootMatch(this.state.location.pathname),
                staticContext: this.props.staticContext
            }
        }, (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).createElement($8e7337eeed3043b3$export$c213558b66925821.Provider, {
            children: this.props.children || null,
            value: this.props.history
        }));
    };
    return Router;
}((0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).Component);
/**
 * The public API for a <Router> that stores location in memory.
 */ var $8e7337eeed3043b3$export$ae46f04cfaffe093 = /*#__PURE__*/ function(_React$Component) {
    (0, $0d767dd10c1fa0a3$export$2e2bcd8739ae039)(MemoryRouter, _React$Component);
    function MemoryRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $0e3a6b1020765bd1$export$2b76ad033c6e6d08)(_this.props);
        return _this;
    }
    var _proto = MemoryRouter.prototype;
    _proto.render = function render() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).createElement($8e7337eeed3043b3$export$55185c17a0fcbe46, {
            history: this.history,
            children: this.props.children
        });
    };
    return MemoryRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).Component);
var $8e7337eeed3043b3$var$Lifecycle = /*#__PURE__*/ function(_React$Component) {
    (0, $0d767dd10c1fa0a3$export$2e2bcd8739ae039)(Lifecycle, _React$Component);
    function Lifecycle() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Lifecycle.prototype;
    _proto.componentDidMount = function componentDidMount() {
        if (this.props.onMount) this.props.onMount.call(this, this);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.props.onUnmount) this.props.onUnmount.call(this, this);
    };
    _proto.render = function render() {
        return null;
    };
    return Lifecycle;
}((0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).Component);
/**
 * The public API for prompting the user before navigating away from a screen.
 */ function $8e7337eeed3043b3$export$83716a4aa1642908(_ref) {
    var message = _ref.message, _ref$when = _ref.when, when = _ref$when === void 0 ? true : _ref$when;
    return (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).createElement($8e7337eeed3043b3$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $d23b6a4945e6cbc3$export$2e2bcd8739ae039)(false);
        if (!when || context.staticContext) return null;
        var method = context.history.block;
        return (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).createElement($8e7337eeed3043b3$var$Lifecycle, {
            onMount: function onMount(self) {
                self.release = method(message);
            },
            onUpdate: function onUpdate(self, prevProps) {
                if (prevProps.message !== message) {
                    self.release();
                    self.release = method(message);
                }
            },
            onUnmount: function onUnmount(self) {
                self.release();
            },
            message: message
        });
    });
}
var $8e7337eeed3043b3$var$messageType;
var $8e7337eeed3043b3$var$cache = {};
var $8e7337eeed3043b3$var$cacheLimit = 10000;
var $8e7337eeed3043b3$var$cacheCount = 0;
function $8e7337eeed3043b3$var$compilePath(path) {
    if ($8e7337eeed3043b3$var$cache[path]) return $8e7337eeed3043b3$var$cache[path];
    var generator = (0, (/*@__PURE__*/$parcel$interopDefault($f37523df22180869$exports))).compile(path);
    if ($8e7337eeed3043b3$var$cacheCount < $8e7337eeed3043b3$var$cacheLimit) {
        $8e7337eeed3043b3$var$cache[path] = generator;
        $8e7337eeed3043b3$var$cacheCount++;
    }
    return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */ function $8e7337eeed3043b3$export$82476f982757e71e(path, params) {
    if (path === void 0) path = "/";
    if (params === void 0) params = {};
    return path === "/" ? path : $8e7337eeed3043b3$var$compilePath(path)(params, {
        pretty: true
    });
}
/**
 * The public API for navigating programmatically with a component.
 */ function $8e7337eeed3043b3$export$2d8d895a0a0f636e(_ref) {
    var computedMatch = _ref.computedMatch, to = _ref.to, _ref$push = _ref.push, push = _ref$push === void 0 ? false : _ref$push;
    return (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).createElement($8e7337eeed3043b3$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $d23b6a4945e6cbc3$export$2e2bcd8739ae039)(false);
        var history = context.history, staticContext = context.staticContext;
        var method = push ? history.push : history.replace;
        var location = (0, $0e3a6b1020765bd1$export$90c043f1c57770b8)(computedMatch ? typeof to === "string" ? $8e7337eeed3043b3$export$82476f982757e71e(to, computedMatch.params) : (0, $6767be368738adce$export$2e2bcd8739ae039)({}, to, {
            pathname: $8e7337eeed3043b3$export$82476f982757e71e(to.pathname, computedMatch.params)
        }) : to); // When rendering in a static context,
        // set the new location immediately.
        if (staticContext) {
            method(location);
            return null;
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).createElement($8e7337eeed3043b3$var$Lifecycle, {
            onMount: function onMount() {
                method(location);
            },
            onUpdate: function onUpdate(self, prevProps) {
                var prevLocation = (0, $0e3a6b1020765bd1$export$90c043f1c57770b8)(prevProps.to);
                if (!(0, $0e3a6b1020765bd1$export$c3e8bb440bd55b18)(prevLocation, (0, $6767be368738adce$export$2e2bcd8739ae039)({}, location, {
                    key: prevLocation.key
                }))) method(location);
            },
            to: to
        });
    });
}
var $8e7337eeed3043b3$var$cache$1 = {};
var $8e7337eeed3043b3$var$cacheLimit$1 = 10000;
var $8e7337eeed3043b3$var$cacheCount$1 = 0;
function $8e7337eeed3043b3$var$compilePath$1(path, options) {
    var cacheKey = "" + options.end + options.strict + options.sensitive;
    var pathCache = $8e7337eeed3043b3$var$cache$1[cacheKey] || ($8e7337eeed3043b3$var$cache$1[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    var keys = [];
    var regexp = (0, (/*@__PURE__*/$parcel$interopDefault($f37523df22180869$exports)))(path, keys, options);
    var result = {
        regexp: regexp,
        keys: keys
    };
    if ($8e7337eeed3043b3$var$cacheCount$1 < $8e7337eeed3043b3$var$cacheLimit$1) {
        pathCache[path] = result;
        $8e7337eeed3043b3$var$cacheCount$1++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */ function $8e7337eeed3043b3$export$81336c211d5ff295(pathname, options) {
    if (options === void 0) options = {};
    if (typeof options === "string" || Array.isArray(options)) options = {
        path: options
    };
    var _options = options, path = _options.path, _options$exact = _options.exact, exact = _options$exact === void 0 ? false : _options$exact, _options$strict = _options.strict, strict = _options$strict === void 0 ? false : _options$strict, _options$sensitive = _options.sensitive, sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
    var paths = [].concat(path);
    return paths.reduce(function(matched, path) {
        if (!path && path !== "") return null;
        if (matched) return matched;
        var _compilePath = $8e7337eeed3043b3$var$compilePath$1(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        }), regexp = _compilePath.regexp, keys = _compilePath.keys;
        var match = regexp.exec(pathname);
        if (!match) return null;
        var url = match[0], values = match.slice(1);
        var isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === "/" && url === "" ? "/" : url,
            // the matched portion of the URL
            isExact: isExact,
            // whether or not we matched exactly
            params: keys.reduce(function(memo, key, index) {
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
function $8e7337eeed3043b3$var$isEmptyChildren(children) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).Children.count(children) === 0;
}
function $8e7337eeed3043b3$var$evalChildrenDev(children, props, path) {
    var value = children(props);
    return value || null;
}
/**
 * The public API for matching a single path and rendering.
 */ var $8e7337eeed3043b3$export$e7b0ac011bb776c6 = /*#__PURE__*/ function(_React$Component) {
    (0, $0d767dd10c1fa0a3$export$2e2bcd8739ae039)(Route, _React$Component);
    function Route() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Route.prototype;
    _proto.render = function render() {
        var _this = this;
        return (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).createElement($8e7337eeed3043b3$export$63baa8ccbe60bb07.Consumer, null, function(context$1) {
            !context$1 && (0, $d23b6a4945e6cbc3$export$2e2bcd8739ae039)(false);
            var location = _this.props.location || context$1.location;
            var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
             : _this.props.path ? $8e7337eeed3043b3$export$81336c211d5ff295(location.pathname, _this.props) : context$1.match;
            var props = (0, $6767be368738adce$export$2e2bcd8739ae039)({}, context$1, {
                location: location,
                match: match
            });
            var _this$props = _this.props, children = _this$props.children, component = _this$props.component, render = _this$props.render; // Preact uses an empty array as children by
            // default, so use null if that's the case.
            if (Array.isArray(children) && children.length === 0) children = null;
            return (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).createElement($8e7337eeed3043b3$export$63baa8ccbe60bb07.Provider, {
                value: props
            }, props.match ? children ? typeof children === "function" ? children(props) : children : component ? (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).createElement(component, props) : render ? render(props) : null : typeof children === "function" ? children(props) : null);
        });
    };
    return Route;
}((0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).Component);
function $8e7337eeed3043b3$var$addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function $8e7337eeed3043b3$var$addBasename(basename, location) {
    if (!basename) return location;
    return (0, $6767be368738adce$export$2e2bcd8739ae039)({}, location, {
        pathname: $8e7337eeed3043b3$var$addLeadingSlash(basename) + location.pathname
    });
}
function $8e7337eeed3043b3$var$stripBasename(basename, location) {
    if (!basename) return location;
    var base = $8e7337eeed3043b3$var$addLeadingSlash(basename);
    if (location.pathname.indexOf(base) !== 0) return location;
    return (0, $6767be368738adce$export$2e2bcd8739ae039)({}, location, {
        pathname: location.pathname.substr(base.length)
    });
}
function $8e7337eeed3043b3$var$createURL(location) {
    return typeof location === "string" ? location : (0, $0e3a6b1020765bd1$export$fe53371bee54353d)(location);
}
function $8e7337eeed3043b3$var$staticHandler(methodName) {
    return function() {
        (0, $d23b6a4945e6cbc3$export$2e2bcd8739ae039)(false);
    };
}
function $8e7337eeed3043b3$var$noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */ var $8e7337eeed3043b3$export$cac06da4d76d935b = /*#__PURE__*/ function(_React$Component) {
    (0, $0d767dd10c1fa0a3$export$2e2bcd8739ae039)(StaticRouter, _React$Component);
    function StaticRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.handlePush = function(location) {
            return _this.navigateTo(location, "PUSH");
        };
        _this.handleReplace = function(location) {
            return _this.navigateTo(location, "REPLACE");
        };
        _this.handleListen = function() {
            return $8e7337eeed3043b3$var$noop;
        };
        _this.handleBlock = function() {
            return $8e7337eeed3043b3$var$noop;
        };
        return _this;
    }
    var _proto = StaticRouter.prototype;
    _proto.navigateTo = function navigateTo(location, action) {
        var _this$props = this.props, _this$props$basename = _this$props.basename, basename = _this$props$basename === void 0 ? "" : _this$props$basename, _this$props$context = _this$props.context, context = _this$props$context === void 0 ? {} : _this$props$context;
        context.action = action;
        context.location = $8e7337eeed3043b3$var$addBasename(basename, (0, $0e3a6b1020765bd1$export$90c043f1c57770b8)(location));
        context.url = $8e7337eeed3043b3$var$createURL(context.location);
    };
    _proto.render = function render() {
        var _this$props2 = this.props, _this$props2$basename = _this$props2.basename, basename = _this$props2$basename === void 0 ? "" : _this$props2$basename, _this$props2$context = _this$props2.context, context = _this$props2$context === void 0 ? {} : _this$props2$context, _this$props2$location = _this$props2.location, location = _this$props2$location === void 0 ? "/" : _this$props2$location, rest = (0, $612ace97f19660e2$export$2e2bcd8739ae039)(_this$props2, [
            "basename",
            "context",
            "location"
        ]);
        var history = {
            createHref: function createHref(path) {
                return $8e7337eeed3043b3$var$addLeadingSlash(basename + $8e7337eeed3043b3$var$createURL(path));
            },
            action: "POP",
            location: $8e7337eeed3043b3$var$stripBasename(basename, (0, $0e3a6b1020765bd1$export$90c043f1c57770b8)(location)),
            push: this.handlePush,
            replace: this.handleReplace,
            go: $8e7337eeed3043b3$var$staticHandler("go"),
            goBack: $8e7337eeed3043b3$var$staticHandler("goBack"),
            goForward: $8e7337eeed3043b3$var$staticHandler("goForward"),
            listen: this.handleListen,
            block: this.handleBlock
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).createElement($8e7337eeed3043b3$export$55185c17a0fcbe46, (0, $6767be368738adce$export$2e2bcd8739ae039)({}, rest, {
            history: history,
            staticContext: context
        }));
    };
    return StaticRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).Component);
/**
 * The public API for rendering the first <Route> that matches.
 */ var $8e7337eeed3043b3$export$b5d5cf8927ab7262 = /*#__PURE__*/ function(_React$Component) {
    (0, $0d767dd10c1fa0a3$export$2e2bcd8739ae039)(Switch, _React$Component);
    function Switch() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Switch.prototype;
    _proto.render = function render() {
        var _this = this;
        return (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).createElement($8e7337eeed3043b3$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $d23b6a4945e6cbc3$export$2e2bcd8739ae039)(false);
            var location = _this.props.location || context.location;
            var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
            // here because toArray adds keys to all child elements and we do not want
            // to trigger an unmount/remount for two <Route>s that render the same
            // component at different URLs.
            (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).Children.forEach(_this.props.children, function(child) {
                if (match == null && (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).isValidElement(child)) {
                    element = child;
                    var path = child.props.path || child.props.from;
                    match = path ? $8e7337eeed3043b3$export$81336c211d5ff295(location.pathname, (0, $6767be368738adce$export$2e2bcd8739ae039)({}, child.props, {
                        path: path
                    })) : context.match;
                }
            });
            return match ? (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).cloneElement(element, {
                location: location,
                computedMatch: match
            }) : null;
        });
    };
    return Switch;
}((0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).Component);
/**
 * A public higher-order component to access the imperative API
 */ function $8e7337eeed3043b3$export$369b6b2b30582e8e(Component) {
    var displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
    var C = function C(props) {
        var wrappedComponentRef = props.wrappedComponentRef, remainingProps = (0, $612ace97f19660e2$export$2e2bcd8739ae039)(props, [
            "wrappedComponentRef"
        ]);
        return (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).createElement($8e7337eeed3043b3$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $d23b6a4945e6cbc3$export$2e2bcd8739ae039)(false);
            return (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).createElement(Component, (0, $6767be368738adce$export$2e2bcd8739ae039)({}, remainingProps, context, {
                ref: wrappedComponentRef
            }));
        });
    };
    C.displayName = displayName;
    C.WrappedComponent = Component;
    return (0, (/*@__PURE__*/$parcel$interopDefault($a32b854b69af5a94$exports)))(C, Component);
}
var $8e7337eeed3043b3$var$useContext = (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).useContext;
function $8e7337eeed3043b3$export$3420e1dc2c4a518c() {
    return $8e7337eeed3043b3$var$useContext($8e7337eeed3043b3$export$c213558b66925821);
}
function $8e7337eeed3043b3$export$45d76561a5302f2b() {
    return $8e7337eeed3043b3$var$useContext($8e7337eeed3043b3$export$63baa8ccbe60bb07).location;
}
function $8e7337eeed3043b3$export$99eaa27ddbbb95ef() {
    var match = $8e7337eeed3043b3$var$useContext($8e7337eeed3043b3$export$63baa8ccbe60bb07).match;
    return match ? match.params : {};
}
function $8e7337eeed3043b3$export$632be4bb944c1bc7(path) {
    var location = $8e7337eeed3043b3$export$45d76561a5302f2b();
    var match = $8e7337eeed3043b3$var$useContext($8e7337eeed3043b3$export$63baa8ccbe60bb07).match;
    return path ? $8e7337eeed3043b3$export$81336c211d5ff295(location.pathname, path) : match;
}
var $8e7337eeed3043b3$var$global, $8e7337eeed3043b3$var$key, $8e7337eeed3043b3$var$buildNames, $8e7337eeed3043b3$var$initialBuildName, $8e7337eeed3043b3$var$secondaryBuildName;



var $j2CB6 = parcelRequire("j2CB6");


function $c7a90d94d5f55ffc$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $c7a90d94d5f55ffc$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $c7a90d94d5f55ffc$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $c7a90d94d5f55ffc$var$_typeof(obj);
}
var $c7a90d94d5f55ffc$var$createSelectors = function createSelectors(structure) {
    var getIn = structure.getIn, toJS = structure.toJS;
    var isRouter = function isRouter(value) {
        return value != null && $c7a90d94d5f55ffc$var$_typeof(value) === "object" && getIn(value, [
            "location"
        ]) && getIn(value, [
            "action"
        ]);
    };
    var getRouter = function getRouter(state) {
        var router = toJS(getIn(state, [
            "router"
        ]));
        if (!isRouter(router)) throw 'Could not find router reducer in state tree, it must be mounted under "router"';
        return router;
    };
    var getLocation = function getLocation(state) {
        return toJS(getIn(getRouter(state), [
            "location"
        ]));
    };
    var getAction = function getAction(state) {
        return toJS(getIn(getRouter(state), [
            "action"
        ]));
    };
    var getSearch = function getSearch(state) {
        return toJS(getIn(getRouter(state), [
            "location",
            "search"
        ]));
    };
    var getHash = function getHash(state) {
        return toJS(getIn(getRouter(state), [
            "location",
            "hash"
        ]));
    }; // It only makes sense to recalculate the `matchPath` whenever the pathname
    // of the location changes. That's why `createMatchSelector` memoizes
    // the latest result based on the location's pathname.
    var createMatchSelector = function createMatchSelector(path) {
        var lastPathname = null;
        var lastMatch = null;
        return function(state) {
            var _ref = getLocation(state) || {}, pathname = _ref.pathname;
            if (pathname === lastPathname) return lastMatch;
            lastPathname = pathname;
            var match = (0, $8e7337eeed3043b3$export$81336c211d5ff295)(pathname, path);
            if (!match || !lastMatch || match.url !== lastMatch.url // When URL matched for nested routes, URL is the same but isExact is not.
             || match.isExact !== lastMatch.isExact) lastMatch = match;
            return lastMatch;
        };
    };
    return {
        getLocation: getLocation,
        getAction: getAction,
        getRouter: getRouter,
        getSearch: getSearch,
        getHash: getHash,
        createMatchSelector: createMatchSelector
    };
};
var $c7a90d94d5f55ffc$export$2e2bcd8739ae039 = $c7a90d94d5f55ffc$var$createSelectors;


function $c98faa92fc223753$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $c98faa92fc223753$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $c98faa92fc223753$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $c98faa92fc223753$var$_typeof(obj);
}
function $c98faa92fc223753$var$_extends() {
    $c98faa92fc223753$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c98faa92fc223753$var$_extends.apply(this, arguments);
}
function $c98faa92fc223753$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c98faa92fc223753$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $c98faa92fc223753$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $c98faa92fc223753$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c98faa92fc223753$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $c98faa92fc223753$var$_createSuper(Derived) {
    return function() {
        var Super = $c98faa92fc223753$var$_getPrototypeOf(Derived), result;
        if ($c98faa92fc223753$var$_isNativeReflectConstruct()) {
            var NewTarget = $c98faa92fc223753$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $c98faa92fc223753$var$_possibleConstructorReturn(this, result);
    };
}
function $c98faa92fc223753$var$_possibleConstructorReturn(self, call) {
    if (call && ($c98faa92fc223753$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $c98faa92fc223753$var$_assertThisInitialized(self);
}
function $c98faa92fc223753$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $c98faa92fc223753$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $c98faa92fc223753$var$_getPrototypeOf(o) {
    $c98faa92fc223753$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $c98faa92fc223753$var$_getPrototypeOf(o);
}
function $c98faa92fc223753$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $c98faa92fc223753$var$_setPrototypeOf(subClass, superClass);
}
function $c98faa92fc223753$var$_setPrototypeOf(o, p) {
    $c98faa92fc223753$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $c98faa92fc223753$var$_setPrototypeOf(o, p);
}
var $c98faa92fc223753$var$createConnectedRouter = function createConnectedRouter(structure) {
    var _createSelectors = (0, $c7a90d94d5f55ffc$export$2e2bcd8739ae039)(structure), getLocation = _createSelectors.getLocation;
    /*
   * ConnectedRouter listens to a history object passed from props.
   * When history is changed, it dispatches action to redux store.
   * Then, store will pass props to component to render.
   * This creates uni-directional flow from history->store->router->components.
   */ var ConnectedRouter = /*#__PURE__*/ function(_PureComponent) {
        $c98faa92fc223753$var$_inherits(ConnectedRouter, _PureComponent);
        var _super = $c98faa92fc223753$var$_createSuper(ConnectedRouter);
        function ConnectedRouter(props) {
            var _this;
            $c98faa92fc223753$var$_classCallCheck(this, ConnectedRouter);
            _this = _super.call(this, props);
            var store = props.store, history = props.history, onLocationChanged = props.onLocationChanged, stateCompareFunction = props.stateCompareFunction;
            _this.inTimeTravelling = false; // Subscribe to store changes to check if we are in time travelling
            _this.unsubscribe = store.subscribe(function() {
                // Allow time travel debugging compatibility to be turned off
                // as the detection for this (below) is error prone in apps where the
                // store may be unmounted, a navigation occurs, and then the store is re-mounted
                // during the app's lifetime. Detection could be much improved if Redux DevTools
                // simply set a global variable like `REDUX_DEVTOOLS_IS_TIME_TRAVELLING=true`.
                var isTimeTravelDebuggingAllowed = !props.noTimeTravelDebugging; // Extract store's location
                var _getLocation = getLocation(store.getState()), pathnameInStore = _getLocation.pathname, searchInStore = _getLocation.search, hashInStore = _getLocation.hash, stateInStore = _getLocation.state; // Extract history's location
                var _history$location = history.location, pathnameInHistory = _history$location.pathname, searchInHistory = _history$location.search, hashInHistory = _history$location.hash, stateInHistory = _history$location.state; // If we do time travelling, the location in store is changed but location in history is not changed
                if (isTimeTravelDebuggingAllowed && props.history.action === "PUSH" && (pathnameInHistory !== pathnameInStore || searchInHistory !== searchInStore || hashInHistory !== hashInStore || !(0, (/*@__PURE__*/$parcel$interopDefault($j2CB6)))(stateInStore, stateInHistory, stateCompareFunction))) {
                    _this.inTimeTravelling = true; // Update history's location to match store's location
                    history.push({
                        pathname: pathnameInStore,
                        search: searchInStore,
                        hash: hashInStore,
                        state: stateInStore
                    });
                }
            });
            var handleLocationChange = function handleLocationChange(location, action) {
                var isFirstRendering = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                // Dispatch onLocationChanged except when we're in time travelling
                if (!_this.inTimeTravelling) onLocationChanged(location, action, isFirstRendering);
                else _this.inTimeTravelling = false;
            }; // Listen to history changes
            _this.unlisten = history.listen(handleLocationChange);
            if (!props.noInitialPop) // Dispatch a location change action for the initial location.
            // This makes it backward-compatible with react-router-redux.
            // But, we add `isFirstRendering` to `true` to prevent double-rendering.
            handleLocationChange(history.location, history.action, true);
            return _this;
        }
        $c98faa92fc223753$var$_createClass(ConnectedRouter, [
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    this.unlisten();
                    this.unsubscribe();
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this$props = this.props, omitRouter = _this$props.omitRouter, history = _this$props.history, children = _this$props.children; // The `omitRouter` option is available for applications that must
                    // have a Router instance higher in the component tree but still desire
                    // to use connected-react-router for its Redux integration.
                    if (omitRouter) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).Fragment, null, children);
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).createElement((0, $8e7337eeed3043b3$export$55185c17a0fcbe46), {
                        history: history
                    }, children);
                }
            }
        ]);
        return ConnectedRouter;
    }((0, $aivMx.PureComponent));
    ConnectedRouter.propTypes = {
        store: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).shape({
            getState: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).func.isRequired,
            subscribe: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).func.isRequired
        }).isRequired,
        history: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).shape({
            action: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).string.isRequired,
            listen: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).func.isRequired,
            location: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).object.isRequired,
            push: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).func.isRequired
        }).isRequired,
        basename: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).string,
        children: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).node
        ]),
        onLocationChanged: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).func.isRequired,
        noInitialPop: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).bool,
        noTimeTravelDebugging: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).bool,
        stateCompareFunction: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).func,
        omitRouter: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).bool
    };
    var mapDispatchToProps = function mapDispatchToProps(dispatch) {
        return {
            onLocationChanged: function onLocationChanged(location, action, isFirstRendering) {
                return dispatch((0, $a53ee0234d47ba63$export$924382de27029fe1)(location, action, isFirstRendering));
            }
        };
    };
    var ConnectedRouterWithContext = function ConnectedRouterWithContext(props) {
        var Context = props.context || (0, $361aa446d88712bf$export$cc80c08dc91f1c00);
        if (Context == null) throw "Please upgrade to react-redux v6";
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).createElement(Context.Consumer, null, function(_ref) {
            var store = _ref.store;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).createElement(ConnectedRouter, $c98faa92fc223753$var$_extends({
                store: store
            }, props));
        });
    };
    ConnectedRouterWithContext.propTypes = {
        context: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).object
    };
    return (0, $0e647a1d90b9cc81$export$2e2bcd8739ae039)(null, mapDispatchToProps)(ConnectedRouterWithContext);
};
var $c98faa92fc223753$export$2e2bcd8739ae039 = $c98faa92fc223753$var$createConnectedRouter;



function $5968623de8942272$var$_slicedToArray(arr, i) {
    return $5968623de8942272$var$_arrayWithHoles(arr) || $5968623de8942272$var$_iterableToArrayLimit(arr, i) || $5968623de8942272$var$_unsupportedIterableToArray(arr, i) || $5968623de8942272$var$_nonIterableRest();
}
function $5968623de8942272$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $5968623de8942272$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $5968623de8942272$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $5968623de8942272$var$_arrayLikeToArray(o, minLen);
}
function $5968623de8942272$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $5968623de8942272$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $5968623de8942272$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $5968623de8942272$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $5968623de8942272$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $5968623de8942272$var$ownKeys(Object(source), true).forEach(function(key) {
            $5968623de8942272$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $5968623de8942272$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $5968623de8942272$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
/**
 * Adds query to location.
 * Utilises the search prop of location to construct query.
 */ var $5968623de8942272$var$injectQuery = function injectQuery(location) {
    if (location && location.query) // Don't inject query if it already exists in history
    return location;
    var searchQuery = location && location.search;
    if (typeof searchQuery !== "string" || searchQuery.length === 0) return $5968623de8942272$var$_objectSpread({}, location, {
        query: {}
    });
     // Ignore the `?` part of the search string e.g. ?username=codejockie
    var search = searchQuery.substring(1); // Split the query string on `&` e.g. ?username=codejockie&name=Kennedy
    var queries = search.split("&"); // Contruct query
    var query = queries.reduce(function(acc, currentQuery) {
        // Split on `=`, to get key and value
        var _currentQuery$split = currentQuery.split("="), _currentQuery$split2 = $5968623de8942272$var$_slicedToArray(_currentQuery$split, 2), queryKey = _currentQuery$split2[0], queryValue = _currentQuery$split2[1];
        return $5968623de8942272$var$_objectSpread({}, acc, $5968623de8942272$var$_defineProperty({}, queryKey, queryValue));
    }, {});
    return $5968623de8942272$var$_objectSpread({}, location, {
        query: query
    });
};
var $5968623de8942272$var$createConnectRouter = function createConnectRouter(structure) {
    var fromJS = structure.fromJS, merge = structure.merge;
    var createRouterReducer = function createRouterReducer(history) {
        var initialRouterState = fromJS({
            location: $5968623de8942272$var$injectQuery(history.location),
            action: history.action
        });
        /*
    * This reducer will update the state with the most recent location history
    * has transitioned to.
    */ return function() {
            var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialRouterState;
            var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, type = _ref.type, payload = _ref.payload;
            if (type === (0, $a53ee0234d47ba63$export$be84bd1ba815d4c2)) {
                var location = payload.location, action = payload.action, isFirstRendering = payload.isFirstRendering; // Don't update the state ref for the first rendering
                // to prevent the double-rendering issue on initilization
                return isFirstRendering ? state : merge(state, {
                    location: fromJS($5968623de8942272$var$injectQuery(location)),
                    action: action
                });
            }
            return state;
        };
    };
    return createRouterReducer;
};
var $5968623de8942272$export$2e2bcd8739ae039 = $5968623de8942272$var$createConnectRouter;



/* Code from github.com/erikras/redux-form by Erik Rasmussen */ var $af56e0acff310495$var$getIn = function getIn(state, path) {
    if (!state) return state;
    var length = path.length;
    if (!length) return undefined;
    var result = state;
    for(var i = 0; i < length && !!result; ++i)result = result[path[i]];
    return result;
};
var $af56e0acff310495$export$2e2bcd8739ae039 = $af56e0acff310495$var$getIn;


function $108ff65151654715$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $108ff65151654715$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $108ff65151654715$var$ownKeys(Object(source), true).forEach(function(key) {
            $108ff65151654715$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $108ff65151654715$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $108ff65151654715$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $108ff65151654715$var$structure = {
    fromJS: function fromJS(value) {
        return value;
    },
    getIn: (0, $af56e0acff310495$export$2e2bcd8739ae039),
    merge: function merge(state, payload) {
        return $108ff65151654715$var$_objectSpread({}, state, {}, payload);
    },
    toJS: function toJS(value) {
        return value;
    }
};
var $108ff65151654715$export$2e2bcd8739ae039 = $108ff65151654715$var$structure;




var $bcf121fb6549cc53$export$28f92b8268ba8447 = /*#__PURE__*/ (0, $c98faa92fc223753$export$2e2bcd8739ae039)((0, $108ff65151654715$export$2e2bcd8739ae039));
var $bcf121fb6549cc53$export$2c021ec3f68e26bf = /*#__PURE__*/ (0, $5968623de8942272$export$2e2bcd8739ae039)((0, $108ff65151654715$export$2e2bcd8739ae039));
var $bcf121fb6549cc53$var$_createSelectors = /*#__PURE__*/ (0, $c7a90d94d5f55ffc$export$2e2bcd8739ae039)((0, $108ff65151654715$export$2e2bcd8739ae039)), $bcf121fb6549cc53$export$e7fd20fad3cf4b5f = $bcf121fb6549cc53$var$_createSelectors.getLocation, $bcf121fb6549cc53$export$6ca3170acb89054 = $bcf121fb6549cc53$var$_createSelectors.getAction, $bcf121fb6549cc53$export$adaba664e531641c = $bcf121fb6549cc53$var$_createSelectors.getHash, $bcf121fb6549cc53$export$3b1eb3bad78dcdd4 = $bcf121fb6549cc53$var$_createSelectors.getRouter, $bcf121fb6549cc53$export$786f9a4bc80cc6b0 = $bcf121fb6549cc53$var$_createSelectors.getSearch, $bcf121fb6549cc53$export$a7b4d762fce9f62a = $bcf121fb6549cc53$var$_createSelectors.createMatchSelector;



var $bd80e90ec7f1f3b2$export$f1bd415280efb039;
(function(PageActionTypes) {
    PageActionTypes["LOCATION_CHANGE"] = "@@router/LOCATION_CHANGE";
    PageActionTypes["PAGE_REQUEST"] = "@@router/PAGE_REQUEST";
    PageActionTypes["PAGE_SUCCESS"] = "@@page/PAGE_SUCCESS";
    PageActionTypes["PAGE_ERROR"] = "@@page/PAGE_ERROR";
    PageActionTypes["CLEAR_FORMS"] = "@@page/CLEAR_FORMS";
    PageActionTypes["UPDATE_ITEM_REQUEST"] = "@@page/UPDATE_ITEM_REQUEST";
    PageActionTypes["UPDATE_ITEM_SUCCESS"] = "@@page/UPDATE_ITEM_SUCCESS";
    PageActionTypes["SUBMIT_FORM_REQUEST"] = "@@page/SUBMIT_FORM_REQUEST";
    PageActionTypes["SUBMIT_FORM_SUCCESS"] = "@@page/SUBMIT_FORM_SUCCESS";
    PageActionTypes["UPLOAD_FILE_REQUEST"] = "@@page/UPLOAD_FILE_REQUEST";
    PageActionTypes["SET_FORM_VALUES_REQUEST"] = "@@page/SET_FORM_VALUES_REQUEST";
    PageActionTypes["SET_FORM_VALUES_SUCCESS"] = "@@page/SET_FORM_VALUES_SUCCESS";
    PageActionTypes["RESET_FORM_VALUES"] = "@@page/RESET_FORM_VALUES";
    PageActionTypes["RESET_FORM_VALUES_SUCCESS"] = "@@page/RESET_FORM_VALUES_SUCCESS";
    PageActionTypes["MERGE_STYLE_REQUEST"] = "@@page/MERGE_STYLE_REQUEST";
    PageActionTypes["MERGE_STYLE_SUCCESS"] = "@@page/MERGE_STYLE_SUCCESS";
    PageActionTypes["UPDATE_NODE_ACTIVE_STATE_REQUEST"] = "@@page/UPDATE_NODE_ACTIVE_STATE_REQUEST";
    PageActionTypes["UPDATE_NODE_ACTIVE_STATE_SUCCESS"] = "@@page/UPDATE_NODE_ACTIVE_STATE_SUCCESS";
    PageActionTypes["UPDATE_VARIABLE_REQUEST"] = "@@page/UPDATE_VARIABLE_REQUEST";
    PageActionTypes["UPDATE_VARIABLE_SUCCESS"] = "@@page/UPDATE_VARIABLE_SUCCESS";
    PageActionTypes["UNCHECK_DEPENDENT_RADIO_REQUEST"] = "@@page/UNCHECK_DEPENDENT_RADIO_REQUEST";
    PageActionTypes["UNCHECK_DEPENDENT_RADIO_SUCCESS"] = "@@page/UNCHECK_DEPENDENT_RADIO_SUCCESS";
})($bd80e90ec7f1f3b2$export$f1bd415280efb039 || ($bd80e90ec7f1f3b2$export$f1bd415280efb039 = {}));


var $649c168665c7425f$var$randomUUID = typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $649c168665c7425f$export$2e2bcd8739ae039 = {
    randomUUID: $649c168665c7425f$var$randomUUID
};


// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var $c2c280843ba50cbb$var$getRandomValues;
var $c2c280843ba50cbb$var$rnds8 = new Uint8Array(16);
function $c2c280843ba50cbb$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$c2c280843ba50cbb$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        $c2c280843ba50cbb$var$getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!$c2c280843ba50cbb$var$getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    return $c2c280843ba50cbb$var$getRandomValues($c2c280843ba50cbb$var$rnds8);
}


var $4e4d94e12bdb53af$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/i;


function $7418090bafe93e4a$var$validate(uuid) {
    return typeof uuid === "string" && (0, $4e4d94e12bdb53af$export$2e2bcd8739ae039).test(uuid);
}
var $7418090bafe93e4a$export$2e2bcd8739ae039 = $7418090bafe93e4a$var$validate;


/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $9b0cf9279d5d0a2e$var$byteToHex = [];
for(var $9b0cf9279d5d0a2e$var$i = 0; $9b0cf9279d5d0a2e$var$i < 256; ++$9b0cf9279d5d0a2e$var$i)$9b0cf9279d5d0a2e$var$byteToHex.push(($9b0cf9279d5d0a2e$var$i + 0x100).toString(16).slice(1));
function $9b0cf9279d5d0a2e$export$8fb373d660548968(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    //
    // Note to future-self: No, you can't remove the `toLowerCase()` call.
    // REF: https://github.com/uuidjs/uuid/pull/677#issuecomment-1757351351
    return ($9b0cf9279d5d0a2e$var$byteToHex[arr[offset + 0]] + $9b0cf9279d5d0a2e$var$byteToHex[arr[offset + 1]] + $9b0cf9279d5d0a2e$var$byteToHex[arr[offset + 2]] + $9b0cf9279d5d0a2e$var$byteToHex[arr[offset + 3]] + "-" + $9b0cf9279d5d0a2e$var$byteToHex[arr[offset + 4]] + $9b0cf9279d5d0a2e$var$byteToHex[arr[offset + 5]] + "-" + $9b0cf9279d5d0a2e$var$byteToHex[arr[offset + 6]] + $9b0cf9279d5d0a2e$var$byteToHex[arr[offset + 7]] + "-" + $9b0cf9279d5d0a2e$var$byteToHex[arr[offset + 8]] + $9b0cf9279d5d0a2e$var$byteToHex[arr[offset + 9]] + "-" + $9b0cf9279d5d0a2e$var$byteToHex[arr[offset + 10]] + $9b0cf9279d5d0a2e$var$byteToHex[arr[offset + 11]] + $9b0cf9279d5d0a2e$var$byteToHex[arr[offset + 12]] + $9b0cf9279d5d0a2e$var$byteToHex[arr[offset + 13]] + $9b0cf9279d5d0a2e$var$byteToHex[arr[offset + 14]] + $9b0cf9279d5d0a2e$var$byteToHex[arr[offset + 15]]).toLowerCase();
}
function $9b0cf9279d5d0a2e$var$stringify(arr, offset = 0) {
    var uuid = $9b0cf9279d5d0a2e$export$8fb373d660548968(arr, offset);
    // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $7418090bafe93e4a$export$2e2bcd8739ae039)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
var $9b0cf9279d5d0a2e$export$2e2bcd8739ae039 = $9b0cf9279d5d0a2e$var$stringify;


function $70c7bcd05bb92b18$var$v4(options, buf, offset) {
    if ((0, $649c168665c7425f$export$2e2bcd8739ae039).randomUUID && !buf && !options) return (0, $649c168665c7425f$export$2e2bcd8739ae039).randomUUID();
    options = options || {};
    var rnds = options.random || (options.rng || (0, $c2c280843ba50cbb$export$2e2bcd8739ae039))();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(var i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $9b0cf9279d5d0a2e$export$8fb373d660548968)(rnds);
}
var $70c7bcd05bb92b18$export$2e2bcd8739ae039 = $70c7bcd05bb92b18$var$v4;


class $2857511e8f5d961e$export$2e2bcd8739ae039 {
    static sessionKey = "sessionId";
    static sessionId = null;
    // Method to get the sessionId from the internal property
    static getSessionId() {
        return $2857511e8f5d961e$export$2e2bcd8739ae039.sessionId;
    }
    // Method to set the sessionId in the internal property
    static setSessionId(sessionId) {
        $2857511e8f5d961e$export$2e2bcd8739ae039.sessionId = sessionId;
    }
    // Method to generate a new sessionId and store it in the internal property
    static generateSessionId() {
        const sessionId = (0, $70c7bcd05bb92b18$export$2e2bcd8739ae039)();
        $2857511e8f5d961e$export$2e2bcd8739ae039.setSessionId(sessionId);
        return sessionId;
    }
    // Method to clear the sessionId from the internal property
    static clearSessionId() {
        $2857511e8f5d961e$export$2e2bcd8739ae039.sessionId = null;
    }
    // Method to get or create a sessionId
    static getOrCreateSessionId() {
        let sessionId = $2857511e8f5d961e$export$2e2bcd8739ae039.getSessionId();
        if (!sessionId) sessionId = $2857511e8f5d961e$export$2e2bcd8739ae039.generateSessionId();
        return sessionId;
    }
}



var $94WEq = parcelRequire("94WEq");
/* eslint-disable max-len */ var $9f90670b1354254b$exports = {};
!function(n, t) {
    t($9f90670b1354254b$exports);
}($9f90670b1354254b$exports, function(n) {
    "use strict";
    function t(n) {
        return null == n;
    }
    function r(n) {
        throw new Error("Argument " + n + " is empty.");
    }
    function e(n) {
        return "function" == typeof n && "getType" in n;
    }
    function i(n) {
        throw new Error("Argument " + n + ' is invalid, it should be an action-creator instance from "typesafe-actions"');
    }
    function o(n, t) {
        if (null == n) throw new Error("Argument contains array with empty element at index " + t);
        if (null == n.getType) throw new Error("Argument contains array with invalid element at index " + t + ', it should be an action-creator instance from "typesafe-actions"');
    }
    function u(n) {
        return "string" == typeof n || "symbol" == typeof n;
    }
    function a(n) {
        return !u(n);
    }
    function c(n) {
        throw new Error("Argument " + n + " is invalid, it should be an action type of type: string | symbol");
    }
    function f(n, t) {
        if (null == n) throw new Error("Argument contains array with empty element at index " + t);
        if ("string" != typeof n && "symbol" != typeof n) throw new Error("Argument contains array with invalid element at index " + t + ", it should be of type: string | symbol");
    }
    function s(n, e, o, u) {
        return t(n) && r(1), a(n) && i(1), {
            type: n,
            payload: e,
            meta: o,
            error: u
        };
    }
    function y(n, e) {
        t(n) && r(1), a(n) && c(1);
        return Object.assign(function() {
            var t = null != e ? e.apply(void 0, arguments) : void 0;
            return Object.assign({
                type: n
            }, t);
        }, {
            getType: function() {
                return n;
            },
            toString: function() {
                return n;
            }
        });
    }
    function l(n, e, i) {
        return t(n) && r(1), a(n) && c(1), function() {
            return y(n, function() {
                var n = arguments.length <= 0 ? void 0 : arguments[0], t = arguments.length <= 1 ? void 0 : arguments[1];
                return null == e && null == i || (n = null != e ? e.apply(void 0, arguments) : void 0, t = null != i ? i.apply(void 0, arguments) : void 0), Object.assign({}, void 0 !== n && {
                    payload: n
                }, {}, void 0 !== t && {
                    meta: t
                });
            });
        };
    }
    function p(n) {
        return t(n) && r(1), e(n) || i(1), n.getType();
    }
    function d(n, e) {
        t(n) && r(1), a(n) && c(1);
        var i = null != e ? e(n) : function() {
            return {
                type: n
            };
        };
        return Object.assign(i, {
            getType: function() {
                return n;
            },
            toString: function() {
                return n;
            }
        });
    }
    var g = {
        createAction: function(n, t) {
            var r = null == t ? function() {
                return s(n);
            } : t(s.bind(null, n));
            return Object.assign(r, {
                getType: function() {
                    return n;
                },
                toString: function() {
                    return n;
                }
            });
        },
        createCustomAction: d,
        createStandardAction: function(n) {
            return t(n) && r(1), a(n) && c(1), Object.assign(function() {
                return d(n, function(n) {
                    return function(t, r) {
                        return {
                            type: n,
                            payload: t,
                            meta: r
                        };
                    };
                });
            }, {
                map: function(t) {
                    return d(n, function(n) {
                        return function(r, e) {
                            return Object.assign(t(r, e), {
                                type: n
                            });
                        };
                    });
                }
            });
        }
    };
    n.action = s, n.createAction = l, n.createAsyncAction = function(n, t, r, e) {
        return function() {
            var i = [
                n,
                t,
                r,
                e
            ].map(function(n, t) {
                return Array.isArray(n) ? l(n[0], n[1], n[2])() : "string" == typeof n || "symbol" == typeof n ? l(n)() : void (t < 3 && function(n) {
                    throw new Error("Argument " + n + ' is invalid, it should be an action type of "string | symbol" or a tuple of "[string | symbol, Function, Function?]"');
                }(t));
            });
            return {
                request: i[0],
                success: i[1],
                failure: i[2],
                cancel: i[3]
            };
        };
    }, n.createCustomAction = y, n.createReducer = function n(t, r) {
        void 0 === r && (r = {});
        var i = Object.assign({}, r), o = function(r, o) {
            var a = Array.isArray(r) ? r : [
                r
            ], c = {};
            return a.map(function(n, t) {
                return e(n) ? p(n) : u(n) ? n : function(n) {
                    throw new Error("Argument " + n + ' is invalid, it should be an action-creator instance from "typesafe-actions" or action type of type: string | symbol');
                }(t + 1);
            }).forEach(function(n) {
                return c[n] = o;
            }), n(t, Object.assign({}, i, {}, c));
        };
        return Object.assign(function(n, r) {
            if (void 0 === n && (n = t), i.hasOwnProperty(r.type)) {
                var e = i[r.type];
                if ("function" != typeof e) throw Error('Reducer under "' + r.type + '" key is not a valid reducer');
                return e(n, r);
            }
            return n;
        }, {
            handlers: Object.assign({}, i),
            handleAction: o,
            handleType: o
        });
    }, n.deprecated = g, n.getType = p, n.isActionOf = function(n, e) {
        t(n) && r(1);
        var i = Array.isArray(n) ? n : [
            n
        ];
        i.forEach(o);
        var u = function(n) {
            return i.some(function(t) {
                return n.type === t.getType();
            });
        };
        return void 0 === e ? u : u(e);
    }, n.isOfType = function(n, e) {
        t(n) && r(1);
        var i = Array.isArray(n) ? n : [
            n
        ];
        i.forEach(f);
        var o = function(n) {
            return i.includes(n.type);
        };
        return void 0 === e ? o : o(e);
    };
});



const $8eba69c5466928d3$export$482be58a32bbf82f = (data)=>(0, $9f90670b1354254b$exports.action)((0, $bd80e90ec7f1f3b2$export$f1bd415280efb039).RESET_FORM_VALUES, data);
const $8eba69c5466928d3$export$6e19b0a4e4c542c1 = (data)=>(0, $9f90670b1354254b$exports.action)((0, $bd80e90ec7f1f3b2$export$f1bd415280efb039).RESET_FORM_VALUES_SUCCESS, data);
const $8eba69c5466928d3$export$528cdcbbafe26779 = (data)=>(0, $9f90670b1354254b$exports.action)((0, $bd80e90ec7f1f3b2$export$f1bd415280efb039).SET_FORM_VALUES_REQUEST, data);
const $8eba69c5466928d3$export$4452cb953514838a = (data)=>(0, $9f90670b1354254b$exports.action)((0, $bd80e90ec7f1f3b2$export$f1bd415280efb039).SET_FORM_VALUES_SUCCESS, data);
const $8eba69c5466928d3$export$c75cc2fedb4914bf = (data)=>(0, $9f90670b1354254b$exports.action)((0, $bd80e90ec7f1f3b2$export$f1bd415280efb039).UNCHECK_DEPENDENT_RADIO_REQUEST, data);
const $8eba69c5466928d3$export$22aa4fb508251850 = (data)=>(0, $9f90670b1354254b$exports.action)((0, $bd80e90ec7f1f3b2$export$f1bd415280efb039).UNCHECK_DEPENDENT_RADIO_SUCCESS, data);
const $8eba69c5466928d3$export$fe25ce1cfff10000 = (data, indexTrigger)=>(0, $9f90670b1354254b$exports.action)((0, $bd80e90ec7f1f3b2$export$f1bd415280efb039).MERGE_STYLE_REQUEST, data, indexTrigger);
const $8eba69c5466928d3$export$eecf287d0d9bbcd2 = (data)=>(0, $9f90670b1354254b$exports.action)((0, $bd80e90ec7f1f3b2$export$f1bd415280efb039).MERGE_STYLE_SUCCESS, data);
const $8eba69c5466928d3$export$45df6e804e1ad53a = (data)=>(0, $9f90670b1354254b$exports.action)((0, $bd80e90ec7f1f3b2$export$f1bd415280efb039).UPDATE_NODE_ACTIVE_STATE_REQUEST, data);
const $8eba69c5466928d3$export$1b7ea3ca287f7c67 = (data)=>(0, $9f90670b1354254b$exports.action)((0, $bd80e90ec7f1f3b2$export$f1bd415280efb039).UPDATE_NODE_ACTIVE_STATE_SUCCESS, data);
const $8eba69c5466928d3$export$ea176eb1668c7b4b = (data)=>(0, $9f90670b1354254b$exports.action)((0, $bd80e90ec7f1f3b2$export$f1bd415280efb039).PAGE_REQUEST, data);
const $8eba69c5466928d3$export$98eb18032ef4d6ea = (data)=>(0, $9f90670b1354254b$exports.action)((0, $bd80e90ec7f1f3b2$export$f1bd415280efb039).PAGE_SUCCESS, data);
const $8eba69c5466928d3$export$64caae22913cebe0 = (message)=>(0, $9f90670b1354254b$exports.action)((0, $bd80e90ec7f1f3b2$export$f1bd415280efb039).PAGE_ERROR, message);
const $8eba69c5466928d3$export$3653d7e5cadcf5e3 = ()=>(0, $9f90670b1354254b$exports.action)((0, $bd80e90ec7f1f3b2$export$f1bd415280efb039).CLEAR_FORMS);
const $8eba69c5466928d3$export$81fe670df87c5d15 = (data)=>(0, $9f90670b1354254b$exports.action)((0, $bd80e90ec7f1f3b2$export$f1bd415280efb039).UPDATE_ITEM_REQUEST, data);
const $8eba69c5466928d3$export$18d621f2121f5823 = (data)=>(0, $9f90670b1354254b$exports.action)((0, $bd80e90ec7f1f3b2$export$f1bd415280efb039).UPDATE_ITEM_SUCCESS, data);
const $8eba69c5466928d3$export$decff28e578bd5f9 = (data, triggerNode)=>(0, $9f90670b1354254b$exports.action)((0, $bd80e90ec7f1f3b2$export$f1bd415280efb039).SUBMIT_FORM_REQUEST, data, triggerNode);
const $8eba69c5466928d3$export$4e69707328f57b7 = (data)=>(0, $9f90670b1354254b$exports.action)((0, $bd80e90ec7f1f3b2$export$f1bd415280efb039).SUBMIT_FORM_SUCCESS, data);
const $8eba69c5466928d3$export$45ef82085fbba598 = (data)=>(0, $9f90670b1354254b$exports.action)((0, $bd80e90ec7f1f3b2$export$f1bd415280efb039).UPLOAD_FILE_REQUEST, data);
const $8eba69c5466928d3$export$36f0c40eded97f9d = (data)=>(0, $9f90670b1354254b$exports.action)((0, $bd80e90ec7f1f3b2$export$f1bd415280efb039).UPDATE_VARIABLE_REQUEST, data);
const $8eba69c5466928d3$export$7b322c1959eae1de = (data)=>(0, $9f90670b1354254b$exports.action)((0, $bd80e90ec7f1f3b2$export$f1bd415280efb039).UPDATE_VARIABLE_SUCCESS, data);


/* eslint-disable max-len */ 
// Response object for POST /get
var $9c904b43c5ef6eaf$export$e378b6cc3d050bd4;
(function(ConfigActionTypes) {
    ConfigActionTypes["CONFIG_REQUEST"] = "@@config/CONFIG_REQUEST";
    ConfigActionTypes["CONFIG_EMPTY_REQUEST"] = "@@config/CONFIG_EMPTY_REQUEST";
    ConfigActionTypes["CONFIG_SUCCESS"] = "@@config/CONFIG_SUCCESS";
    ConfigActionTypes["CONFIG_ERROR"] = "@@config/CONFIG_ERROR";
})($9c904b43c5ef6eaf$export$e378b6cc3d050bd4 || ($9c904b43c5ef6eaf$export$e378b6cc3d050bd4 = {}));


const $2907166a90fe0a09$export$cf229b36ba13aa52 = (data)=>(0, $9f90670b1354254b$exports.action)((0, $9c904b43c5ef6eaf$export$e378b6cc3d050bd4).CONFIG_REQUEST, data);
const $2907166a90fe0a09$export$ba933bc7f0f71012 = (data)=>(0, $9f90670b1354254b$exports.action)((0, $9c904b43c5ef6eaf$export$e378b6cc3d050bd4).CONFIG_EMPTY_REQUEST, data);
const $2907166a90fe0a09$export$ff747514dac36e4c = (data)=>(0, $9f90670b1354254b$exports.action)((0, $9c904b43c5ef6eaf$export$e378b6cc3d050bd4).CONFIG_SUCCESS, data);
const $2907166a90fe0a09$export$3dbcfb3539facac2 = ()=>(0, $9f90670b1354254b$exports.action)((0, $9c904b43c5ef6eaf$export$e378b6cc3d050bd4).CONFIG_ERROR);




const $3668382e27becba6$var$BASE_API_PATH = "/api/1";
const $3668382e27becba6$var$BASE_SVC_PATH = "/svc/1";
async function $3668382e27becba6$export$2e2bcd8739ae039({ method: method, path: path, data: data, isMultipart: isMultipart }) {
    const url = isMultipart ? `${$3668382e27becba6$var$BASE_SVC_PATH}${path}` : `${$3668382e27becba6$var$BASE_API_PATH}${path}`;
    let body = JSON.stringify(data);
    const headers = {
        Accept: "application/json"
    };
    if (data && isMultipart) {
        const formData = new FormData();
        Object.entries(data).forEach(([name, value])=>formData.append(name, value));
        body = formData;
        delete headers["Content-Type"];
    } else headers["Content-Type"] = "application/json; charset=utf-8";
    const response = await fetch(url, {
        method: method,
        headers: headers,
        body: body
    });
    if (response.status !== 200) {
        let message = await response.text();
        if (message.startsWith("{")) message = JSON.parse(message).data;
        throw new Error(`${response.status} ${response.statusText}. ${message}`);
    }
    return response.json();
}


function* $44edbfa3e77e92f9$var$open(nextPage) {
    if (nextPage.startsWith("http")) window.open(nextPage);
    else yield (0, $8f51be6e3f59daaa$export$8743009a87fcb00f)((0, $a53ee0234d47ba63$export$4cbf152802aa238)(nextPage));
}
function* $44edbfa3e77e92f9$var$api(method, path, data, isMultipart) {
    let response = {};
    response = yield (0, $8f51be6e3f59daaa$export$a07804094c3ecf2d)((0, $3668382e27becba6$export$2e2bcd8739ae039), {
        method: method,
        path: path,
        data: data,
        isMultipart: isMultipart
    });
    switch(response.code){
        // page not found
        case 404:
            yield (0, $8f51be6e3f59daaa$export$8743009a87fcb00f)((0, $a53ee0234d47ba63$export$4cbf152802aa238)("/not_found"));
            break;
        // redirect
        case 302:
            if (response.data && response.data.nextPage) {
                if (response.data.close) {
                    window.close();
                    yield (0, $8f51be6e3f59daaa$export$c4ce752e73470fba)(500);
                    yield (0, $8f51be6e3f59daaa$export$a07804094c3ecf2d)($44edbfa3e77e92f9$var$open, response.data.nextPage);
                } else yield (0, $8f51be6e3f59daaa$export$a07804094c3ecf2d)($44edbfa3e77e92f9$var$open, response.data.nextPage);
            }
            break;
        default:
            break;
    }
    return response;
}
var $44edbfa3e77e92f9$export$2e2bcd8739ae039 = $44edbfa3e77e92f9$var$api;


const $c9e12427d7d919f3$var$DB_NAME = "main";
const $c9e12427d7d919f3$var$DB_VERSION = 1;
const $c9e12427d7d919f3$var$STORE_NAME = "cacheScreens";
function $c9e12427d7d919f3$var$openDatabase() {
    return new Promise((resolve, reject)=>{
        const request = indexedDB.open($c9e12427d7d919f3$var$DB_NAME, $c9e12427d7d919f3$var$DB_VERSION);
        request.onupgradeneeded = (event)=>{
            const db = event.target.result;
            if (!db.objectStoreNames.contains($c9e12427d7d919f3$var$STORE_NAME)) db.createObjectStore($c9e12427d7d919f3$var$STORE_NAME, {
                keyPath: "id",
                autoIncrement: true
            });
        };
        request.onsuccess = (event)=>{
            resolve(event.target.result);
        };
        request.onerror = (event)=>{
            reject(event.target.error);
        };
    });
}
async function $c9e12427d7d919f3$export$8a8216c44337cd5(key, value) {
    const db = await $c9e12427d7d919f3$var$openDatabase();
    return new Promise((resolve, reject)=>{
        const transaction = db.transaction([
            $c9e12427d7d919f3$var$STORE_NAME
        ], "readwrite");
        const store = transaction.objectStore($c9e12427d7d919f3$var$STORE_NAME);
        const request = store.put({
            id: key,
            value: value
        });
        request.onsuccess = ()=>{
            resolve();
        };
        request.onerror = (event)=>{
            reject(event.target.error);
        };
    });
}
async function $c9e12427d7d919f3$export$fe2d9b4e03920b4c(key) {
    const db = await $c9e12427d7d919f3$var$openDatabase();
    return new Promise((resolve, reject)=>{
        const transaction = db.transaction([
            $c9e12427d7d919f3$var$STORE_NAME
        ], "readwrite");
        const store = transaction.objectStore($c9e12427d7d919f3$var$STORE_NAME);
        const request = store.delete(key);
        request.onsuccess = ()=>{
            resolve();
        };
        request.onerror = (event)=>{
            reject(event.target.error);
        };
    });
}
async function $c9e12427d7d919f3$export$f92dfeb71e9bb569(key) {
    const db = await $c9e12427d7d919f3$var$openDatabase();
    return new Promise((resolve, reject)=>{
        const transaction = db.transaction([
            $c9e12427d7d919f3$var$STORE_NAME
        ], "readonly");
        const store = transaction.objectStore($c9e12427d7d919f3$var$STORE_NAME);
        const request = store.get(key);
        request.onsuccess = (event)=>{
            resolve(event.target.result?.value);
        };
        request.onerror = (event)=>{
            reject(event.target.error);
        };
    });
}


var $4aeabe14c1618d30$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    var nativeCodeString = "[native code]";
    function classNames() {
        var classes = [];
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (!arg) continue;
            var argType = typeof arg;
            if (argType === "string" || argType === "number") classes.push(arg);
            else if (Array.isArray(arg)) {
                if (arg.length) {
                    var inner = classNames.apply(null, arg);
                    if (inner) classes.push(inner);
                }
            } else if (argType === "object") {
                if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) {
                    classes.push(arg.toString());
                    continue;
                }
                for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes.push(key);
            }
        }
        return classes.join(" ");
    }
    if (0, $4aeabe14c1618d30$exports) {
        classNames.default = classNames;
        $4aeabe14c1618d30$exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();



var $4vp6j = parcelRequire("4vp6j");
function $7b0e169a5380005e$export$8c51936ffbb22bee(input) {
    try {
        const parsedJSON = JSON.parse(input);
        return parsedJSON;
    } catch (error) {
        // console.log(error);
        // Parsing failed, return the original input
        return input;
    }
}
function $7b0e169a5380005e$export$678f3c59bb79515(input, pretty) {
    if (typeof input === "object" && input !== null) try {
        // Add the second and third parameters to JSON.stringify for indentation
        const jsonString = JSON.stringify(input, null, pretty ? 2 : 0);
        return jsonString;
    } catch (error) {
        // Stringification failed, return the original input
        return "";
    }
    else // Input is not an object, return it as is
    return "";
}
const $7b0e169a5380005e$export$1ed0175478ddd28b = (functionString, $event, internalFns)=>{
    try {
        // Check for state function calls
        const hasSetState = functionString.includes("$setVariable");
        const hasGetState = functionString.includes("$getVariable");
        // Create context with allowed internal functions
        const context = {
            $event: $event,
            ...hasSetState && {
                $setVariable: internalFns?.$setVariable
            },
            ...hasGetState && {
                $getVariable: internalFns?.$getVariable
            }
        };
        // Create function with controlled scope
        const func = new Function(...Object.keys(context), `
      "use strict";
      ${functionString}
    `);
        // Execute with provided context
        func(...Object.values(context));
    } catch (error) {
        console.error("Error executing function:", error);
    }
};
const $7b0e169a5380005e$export$2516322ffbb7f3fb = (obj, path)=>{
    // Handle empty/invalid paths
    if (!path) return undefined;
    // Split path into parts (e.g. "user.address.street" -> ["user", "address", "street"])
    const parts = path.split(".");
    let result = obj;
    // Traverse the object following the path
    for (const part of parts){
        if (result === null || result === undefined) return undefined;
        result = result[part];
    }
    return result;
};
const $7b0e169a5380005e$export$61fc7d43ac8f84b0 = (func, delay)=>{
    let timeoutId;
    return function deb(...args) {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(()=>func.apply(this, args), delay);
    };
};
const $7b0e169a5380005e$export$78e968efcca6b7ef = (pattern, nodeId)=>{
    const regex = new RegExp(`^${pattern.replace("*", ".*")}$`);
    return regex.test(nodeId);
};
function $7b0e169a5380005e$export$ab2a4759dabf5477(obj) {
    const { command: command, action: action, component_id: component_id, screen_id: screen_id } = obj || {};
    let cacheKey = command;
    if (component_id && screen_id) {
        if (action) cacheKey = `${screen_id}/${component_id}/${action}`;
        else if (command) cacheKey = `${screen_id}/${component_id}/${command}`;
    }
    return cacheKey;
}
function $7b0e169a5380005e$export$b40f43cc69224c6e(scheme) {
    let hasCache = false;
    const pattern = /{{.*}}/;
    function analyzeObject(obj) {
        // Create copy of object to avoid mutations
        const result = {
            ...obj
        };
        // Check if current object has cache:true or value matches the pattern
        if (obj.cache === true || typeof obj.value === "string" && pattern.test(obj.value) && obj.cache !== false) {
            hasCache = true;
            result.sceleton = true;
            return result;
        }
        // Only process if items array exists
        if (Array.isArray(obj.items)) result.items = obj.items.map((item)=>analyzeObject(item));
        return result;
    }
    const transformed = scheme.map((obj)=>analyzeObject(obj));
    return {
        status: hasCache,
        transformed: transformed
    };
}
function $7b0e169a5380005e$export$8f49bf34d2145408(items, idsObject, updateFunc, insideTable = false) {
    return items.map((item)=>{
        const isTable = item.component === "table";
        const newInsideTable = insideTable || isTable;
        // Check if item.id matches any pattern in ids or if item.id is directly in ids
        const idMatches = Object.keys(idsObject).some((id)=>id === item.id || $7b0e169a5380005e$export$78e968efcca6b7ef(id, item.id) && idsObject[id]?.object_type === item.component);
        if (idMatches) item = updateFunc({
            ...item
        }, newInsideTable);
        if (item.items && item.items.length > 0) return {
            ...item,
            items: $7b0e169a5380005e$export$8f49bf34d2145408(item.items, idsObject, updateFunc, newInsideTable)
        };
        return item;
    });
}
function $7b0e169a5380005e$export$142f03d1558de863(items, excludeId) {
    return items.map((item)=>{
        if (!(item.id === excludeId && item.component === "input") && item.style && item.style.states && item.style.states.loading) item.activeState = "loading";
        if (item.items && item.items.length > 0) return {
            ...item,
            items: $7b0e169a5380005e$export$142f03d1558de863(item.items, excludeId)
        };
        return item;
    });
}
function $7b0e169a5380005e$export$5c5b0ec7b0e2d3dd(items, name, excludeId) {
    const changedIds = [];
    const updatedItems = items.map((item)=>{
        if (item.component === "radio" && item.name === name && item.id !== excludeId) {
            item.value = false;
            changedIds.push(item.id);
        } else if (item.component === "radio" && item.name === name && item.id === excludeId) item.value = true;
        if (item.items && item.items.length > 0) {
            const nestedResult = $7b0e169a5380005e$export$5c5b0ec7b0e2d3dd(item.items, name, excludeId);
            changedIds.push(...nestedResult.changedIds);
            return {
                ...item,
                items: nestedResult.items
            };
        }
        return item;
    });
    return {
        items: updatedItems,
        changedIds: changedIds
    };
}
function $7b0e169a5380005e$export$ff76c51b0f744e0a(style) {
    const tag = document.createElement("style");
    tag.innerHTML = style;
    document.head.appendChild(tag);
}
function $7b0e169a5380005e$export$2e00a35bd25acfb1(className, style) {
    const cssProperties = Object.keys(style).map((property)=>{
        let value = style[property];
        if (typeof value === "string" && value.startsWith("$")) value = `var(--${value.slice(1)})`;
        return `${property.replace(/([A-Z])/g, "-$1").toLowerCase()}: ${value};`;
    }).join("\n");
    return `.${className} {\n${cssProperties}\n}`;
}
const $7b0e169a5380005e$export$c48968220937aa25 = (styles)=>{
    const { display: display, ...filteredStyles } = styles || {};
    return filteredStyles;
};
function $7b0e169a5380005e$export$fce6876652108ab(value) {
    return typeof value === "undefined" || value === null || value.length === 0;
}
function $7b0e169a5380005e$export$4385e60b38654f68() {
    return Math.floor(Math.random() * 0xffff);
}
function $7b0e169a5380005e$export$aeecb75b7111fef7(inputString) {
    if (!inputString || !inputString.length) return inputString;
    return inputString.replace(/\$[a-zA-Z0-9_-]+/g, (match)=>`var(--${match.slice(1)})`);
}
const $7b0e169a5380005e$export$189053d41e721fcb = (...classes)=>{
    const processedClasses = classes.reduce((acc, className)=>{
        if (typeof className === "string") acc.push(...className.split(" "));
        else if (Array.isArray(className)) acc.push(...className);
        else if (className && typeof className === "object") Object.keys(className).forEach((key)=>{
            if (className[key]) acc.push(key);
        });
        return acc;
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($4aeabe14c1618d30$exports)))(...processedClasses);
};
const $7b0e169a5380005e$export$1d5a11bc88171059 = (spacing)=>{
    if (Array.isArray(spacing)) {
        const [top = 0, right = 0, bottom = 0, left = 0] = spacing.map((val)=>typeof val === "number" ? `${val}px` : val);
        return `${top} ${right} ${bottom} ${left}`;
    }
    if (typeof spacing === "number") return `${spacing}px`;
    return spacing;
};
function $7b0e169a5380005e$export$d673a9445babfbef(svgString) {
    if (typeof svgString !== "string") return false;
    if (!svgString.trim().match(/^<svg[^>]*>[\s\S]*<\/svg>$/i)) return false;
    const parser = new DOMParser();
    const doc = parser.parseFromString(svgString, "image/svg+xml");
    return doc.documentElement.nodeName === "svg";
}
function $7b0e169a5380005e$export$bdbb3c5ef337077e(gradient, opacity) {
    // Regular expression to match the gradient type (linear or radial)
    const gradientRegex = /^(linear|radial)-gradient\((.*)\)/;
    // Extract the gradient type and content
    const match = gradientRegex.exec(gradient);
    if (!match) throw new Error("Invalid gradient format");
    const gradientType = match[1];
    const gradientContent = match[2];
    // Apply opacity to each color stop
    const colorStops = gradientContent.split(",");
    const updatedColorStops = colorStops.map((colorStop)=>{
        // Extract the color and opacity (if present)
        const colorMatch = /rgba?\((.*)\)/.exec(colorStop);
        if (colorMatch) {
            const colorValues = colorMatch[1].split(",");
            const alpha = parseFloat(colorValues[3] || "1");
            const updatedAlpha = alpha * opacity;
            return `rgba(${colorValues[0]}, ${colorValues[1]}, ${colorValues[2]}, ${updatedAlpha})`;
        } else {
            // If no opacity is present, apply the desired opacity directly
            const updatedAlpha = opacity;
            return `rgba(${colorStop}, ${updatedAlpha})`;
        }
    });
    // Reconstruct the gradient with the updated color stops
    const updatedGradient = `${gradientType}-gradient(${updatedColorStops.join(",")})`;
    return updatedGradient;
}
function $7b0e169a5380005e$export$a5202107d3e3cdb0() {
    const parser = new (0, (/*@__PURE__*/$parcel$interopDefault($4vp6j)))();
    const browserInfo = parser.getResult();
    let geodata = null;
    navigator.permissions;
    return {
        localization: navigator.language || null,
        device_id: null,
        device_os: browserInfo.os.name || null,
        browser_version: browserInfo.browser.version || null,
        browser_provider: browserInfo.browser.name || null,
        front_version: "0.1",
        back_version: "0.1",
        screen_resolution: {
            w: window.screen.width || null,
            h: window.screen.height || null
        },
        device_type: browserInfo.device.type || "desktop",
        external_ip: null,
        internal_ip: null,
        geodata: geodata ? {
            latitude: geodata.latitude,
            longitude: geodata.longitude,
            altitude: geodata.altitude,
            accuracy: geodata.accuracy,
            altitude_accuracy: geodata.altitudeAccuracy,
            heading: geodata.heading,
            speed: geodata.speed
        } : null
    };
}
function $7b0e169a5380005e$export$a8c212b8aefc29ec(section) {
    const formValues = {};
    const parseItems = (items)=>{
        items.forEach((item)=>{
            if (item.id && item.value !== undefined && (item.component === "input" || item.component === "checkbox" || item.component === "radio" || item.component === "select" || item.component === "switcher")) formValues[item.id] = item.value;
            if (item.items && item.items.length > 0) parseItems(item.items);
        });
    };
    if (Array.isArray(section)) section.forEach((sec)=>{
        if (sec.items) parseItems(sec.items);
    });
    if (section && section.items) parseItems(section.items);
    return formValues;
}
const $7b0e169a5380005e$export$9b89bb1262f2987f = (value)=>{
    const regex = /^\{\{.*\}\}$/;
    return regex.test(value);
};
const $7b0e169a5380005e$export$19c69f429b13dbe1 = (value)=>{
    if (typeof value !== "string") return $7b0e169a5380005e$export$678f3c59bb79515(value, false);
    const match = value.match(/^\{\{(.*)\}\}$/);
    return match ? match[1] : value;
};
const $7b0e169a5380005e$export$a87687c5ea189578 = (obj, path)=>{
    // Handle the case where the path is exactly 'this'
    if (path === "this") return typeof obj === "string" ? obj : JSON.stringify(obj);
    // Remove 'this.' prefix if it exists
    const normalizedPath = path.startsWith("this.") ? path.slice(5) : path;
    const value = normalizedPath.split(".").reduce((acc, part)=>acc && acc[part], obj);
    return typeof value === "string" ? value : JSON.stringify(value);
};
const $7b0e169a5380005e$export$ebda49d0e9aa0c89 = (obj, path)=>path.split(".").reduce((acc, part)=>{
        const value = acc !== undefined && acc !== null && typeof acc === "object" && !Array.isArray(acc) ? acc[part] : acc;
        if (typeof value === "number" || typeof value === "boolean") return value.toString();
        return value;
    }, obj);
const $7b0e169a5380005e$export$9a7eef5d73136d1e = (style, variables)=>{
    const parsedVars = $7b0e169a5380005e$export$8c51936ffbb22bee(variables);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const replacePlaceholders = (obj)=>{
        if (typeof obj === "string") {
            const regex = /{{(.*?)}}/g;
            let match;
            let result = obj;
            const matches = [];
            // eslint-disable-next-line no-cond-assign
            while((match = regex.exec(obj)) !== null)matches.push(match);
            // eslint-disable-next-line @typescript-eslint/no-shadow
            matches.forEach((match)=>{
                if (match[0].startsWith("{{this")) return;
                const variablePath = match[1].trim();
                const variableValue = $7b0e169a5380005e$export$ebda49d0e9aa0c89(parsedVars, variablePath);
                // eslint-disable-next-line no-nested-ternary
                const replacement = variableValue !== undefined ? typeof variableValue === "object" ? JSON.stringify(variableValue) : variableValue : "";
                result = result.replace(match[0], replacement);
            });
            return result;
        }
        if (Array.isArray(obj)) return obj.map((item)=>replacePlaceholders(item));
        if (typeof obj === "object" && obj !== null) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const newObj = {};
            Object.keys(obj).forEach((key)=>{
                newObj[key] = replacePlaceholders(obj[key]);
            });
            return newObj;
        }
        return obj;
    };
    return replacePlaceholders(style);
};
const $7b0e169a5380005e$export$485c71a5d8ecbaad = (style, variables)=>{
    const parsedVars = $7b0e169a5380005e$export$8c51936ffbb22bee(variables);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const replacePlaceholders = (obj)=>{
        if (typeof obj === "string") {
            const regex = /{{(this(?:\..*?)?)}}/g;
            let match;
            let result = obj;
            const matches = [];
            // eslint-disable-next-line no-cond-assign
            while((match = regex.exec(obj)) !== null)matches.push(match);
            // eslint-disable-next-line @typescript-eslint/no-shadow
            matches.forEach((match)=>{
                const variablePath = match[1].trim();
                let replacement;
                if (variablePath === "this") replacement = JSON.stringify(parsedVars);
                else {
                    const variableValue = $7b0e169a5380005e$export$ebda49d0e9aa0c89(parsedVars, variablePath.slice(5)); // Remove 'this.' from the path
                    replacement = variableValue !== undefined ? typeof variableValue === "object" ? JSON.stringify(variableValue) : variableValue : "";
                }
                result = result.replace(match[0], replacement);
            });
            return result;
        }
        if (Array.isArray(obj)) return obj.map((item)=>replacePlaceholders(item));
        if (typeof obj === "object" && obj !== null) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const newObj = {};
            Object.keys(obj).forEach((key)=>{
                newObj[key] = replacePlaceholders(obj[key]);
            });
            return newObj;
        }
        return obj;
    };
    return replacePlaceholders(style);
};
function $7b0e169a5380005e$export$1ab2cd8b58d4bd64(scriptUrls) {
    // Regex to match <script> tags
    const scriptTagRegex = /<script.*?>([\s\S]*?)<\/script>/gs;
    // Regex to match URLs not inside <script> tags
    const urlRegex = /https?:\/\/[^\s;]+(?![^<]*<\/script>)/g;
    const scriptTagsArray = scriptUrls.match(scriptTagRegex) || [];
    const urlsArray = scriptUrls.match(urlRegex) || [];
    scriptTagsArray.forEach((scriptContent)=>{
        $7b0e169a5380005e$var$attachScriptIfMissing(scriptContent, true);
    });
    urlsArray.forEach((url)=>{
        $7b0e169a5380005e$var$attachScriptIfMissing(url, false);
    });
}
function $7b0e169a5380005e$export$dda81216098e0f9d(fonts) {
    const fontRegex = /<link.*?href="([^"]+)"[^>]*>/gs;
    const fontUrls = fonts.match(fontRegex) || [];
    fontUrls.forEach((fontUrl)=>{
        $7b0e169a5380005e$var$attachFontIfMissing(fontUrl);
    });
}
function $7b0e169a5380005e$var$attachFontIfMissing(fontString) {
    const tempContainer = document.createElement("div");
    tempContainer.innerHTML = fontString;
    const fontElement = tempContainer.firstChild;
    if (!fontElement || fontElement.tagName !== "LINK" || fontElement.rel !== "stylesheet") {
        console.error("Invalid font string");
        return;
    }
    const existingFonts = document.querySelectorAll('link[rel="stylesheet"]');
    // Check if the font is already present
    for(let i = 0; i < existingFonts.length; i++){
        if (existingFonts[i].href === fontElement.href) return; // Font already exists
    }
    // Attach the font
    document.head?.appendChild(fontElement);
}
function $7b0e169a5380005e$var$attachScriptIfMissing(scriptContent, isInline) {
    const existingScripts = document.querySelectorAll("script");
    if (!isInline) {
        // Check if the URL script is already present
        for(let i = 0; i < existingScripts.length; i++){
            if (existingScripts[i].src === scriptContent) return; // Script already exists
        }
        // Attach the URL script
        const script = document.createElement("script");
        script.src = scriptContent;
        document.head?.appendChild(script);
    } else {
        // Extract the inner content of the inline script
        const inlineScriptContent = $7b0e169a5380005e$var$extractScriptContent(scriptContent);
        // Check if the inline script is already present
        for(let i = 0; i < existingScripts.length; i++){
            if (existingScripts[i].innerHTML.trim() === inlineScriptContent) return; // Script already exists
        }
        // Attach the inline script
        const script = document.createElement("script");
        script.innerHTML = inlineScriptContent;
        document.head?.appendChild(script);
    }
}
function $7b0e169a5380005e$var$extractScriptContent(content) {
    const scriptRegex = /<script.*?>([\s\S]*?)<\/script>/s;
    const match = scriptRegex.exec(content);
    return match ? match[1].trim() : "";
}
const $7b0e169a5380005e$export$b5ac3c35b6e379b6 = (value, delay, isOpenNewTab)=>{
    const openUrl = ()=>{
        const url = value.startsWith("/") ? `${window.location.origin}${value}` : value;
        const isDownloadable = url.match(/\.(pdf|docx?|xlsx?|zip|rar|tar\.gz|jpg|jpeg|png|gif)$/i);
        if (isDownloadable) {
            const link = document.createElement("a");
            link.href = url;
            link.rel = "noopener noreferrer";
            link.target = "_blank";
            link.download = "";
            link.click();
        } else if (isOpenNewTab) window.open(url, "_blank", "noopener,noreferrer");
        else window.location.href = url;
    };
    if (delay && delay > 0) setTimeout(openUrl, delay * 1000);
    else openUrl();
};
const $7b0e169a5380005e$export$2c457c0314f4f781 = (source)=>/^\{\{(.*)\}\}$/.test(source || "");
function $7b0e169a5380005e$export$e9c29559b77b0f7b(data, parentData, dataLake, i, variables, parentI = 0) {
    if (data?.type === "table-header-row" || data?.type === "table-body-row") {
        // eslint-disable-next-line max-len
        const replacedVariables = $7b0e169a5380005e$export$2c457c0314f4f781(parentData?.settings?.source) ? $7b0e169a5380005e$export$9a7eef5d73136d1e(parentData?.settings?.source, variables) : parentData?.settings?.source;
        const parseSourceIfExist = $7b0e169a5380005e$export$8c51936ffbb22bee(replacedVariables);
        return {
            settings: {
                ...parentData?.settings,
                source: replacedVariables
            },
            cols: parentData?.cols,
            data: Array.isArray(parseSourceIfExist) ? parseSourceIfExist[i] : undefined
        };
    }
    if (data?.type === "table-header-row-cell") {
        // eslint-disable-next-line max-len
        const replacedVariables = $7b0e169a5380005e$export$2c457c0314f4f781(dataLake?.settings?.source) ? $7b0e169a5380005e$export$9a7eef5d73136d1e(dataLake?.settings?.source, variables) : dataLake?.settings?.source;
        return {
            settings: {
                ...dataLake?.settings,
                source: replacedVariables
            },
            cols: dataLake?.cols,
            data: dataLake?.cols?.items?.[i]
        };
    }
    if (data?.type === "table-body-row-cell") {
        const parseSourceIfExist = $7b0e169a5380005e$export$8c51936ffbb22bee(dataLake?.settings?.source);
        return {
            settings: dataLake?.settings,
            cols: dataLake?.cols,
            data: Array.isArray(parseSourceIfExist) ? parseSourceIfExist[parentI] : undefined
        };
    }
    if (dataLake) return dataLake;
    return undefined;
}
const $7b0e169a5380005e$export$e58d7eefdadeb732 = (screen)=>{
    switch(screen){
        case "4k":
            return 2560;
        case "2k":
            return 1920;
        case "laptopL":
            return 1440;
        case "laptop":
            return 1024;
        case "tablet":
            return 768;
        case "mobileL":
            return 425;
        case "mobileM":
            return 375;
        case "mobileS":
            return 320;
        default:
            return 1440;
    }
};


const $6ace1c53c6a18897$var$parseOldFormat = (data)=>{
    const { sections: sections } = data || {};
    const [first] = sections || [];
    return {
        page: first,
        settings: {},
        variableData: {},
        screenId: undefined
    };
};
const $6ace1c53c6a18897$var$parseNewFormat = (data)=>{
    const { screen: screen, variable_data: variableData } = data || {};
    const { sections: sections, settings: settings, id: id } = screen || {};
    return {
        page: sections,
        settings: settings,
        variableData: variableData,
        screenId: id
    };
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* $6ace1c53c6a18897$var$handlePageRequest(action) {
    const screenId = yield (0, $8f51be6e3f59daaa$export$6559d589eb85fbb6)((state)=>state.page.screenId);
    const { payload: payload } = action || {};
    const { location: location, silent: silent, componentId: componentId } = payload || {};
    const { pathname: pathname, search: search } = location || {};
    try {
        const breakLoadPages = [
            "/not_found",
            "/frame/internal"
        ];
        if (pathname && !breakLoadPages.includes(pathname)) {
            const page = pathname === "/" || pathname === "" ? "/" : pathname.replace("/", "");
            yield (0, $8f51be6e3f59daaa$export$8743009a87fcb00f)((0, $8eba69c5466928d3$export$3653d7e5cadcf5e3)());
            if (!silent) try {
                const currentPath = window.location.pathname;
                const currentSearch = window.location.search;
                const navigateTo = search ? `${pathname}${search}` : pathname;
                if (currentPath !== pathname || search && currentSearch !== search) window.history.pushState(null, "", navigateTo);
            } catch (navError) {
                console.error("Navigation failed:", navError);
            // Continue execution even if navigation fails
            }
            const cacheKey = (0, $7b0e169a5380005e$export$ab2a4759dabf5477)({
                command: `${page}${search?.length ? search : ""}`,
                action: undefined,
                component_id: componentId,
                screen_id: screenId
            });
            const value = yield (0, $8f51be6e3f59daaa$export$a07804094c3ecf2d)((0, $c9e12427d7d919f3$export$f92dfeb71e9bb569), cacheKey);
            if (value && !silent) {
                const { page: pp, settings: settings, variableData: variableData, screenId: screenIdParsed } = value.sections ? $6ace1c53c6a18897$var$parseOldFormat(value) : $6ace1c53c6a18897$var$parseNewFormat(value);
                yield (0, $8f51be6e3f59daaa$export$8743009a87fcb00f)((0, $8eba69c5466928d3$export$98eb18032ef4d6ea)({
                    data: pp,
                    settings: settings,
                    sessionData: {},
                    variableData: variableData,
                    screenId: screenIdParsed
                }));
            }
            const { code: code, data: data, sessionData: sessionData } = yield (0, $8f51be6e3f59daaa$export$a07804094c3ecf2d)((0, $44edbfa3e77e92f9$export$2e2bcd8739ae039), "post", "/get", {
                command: `${page}${search?.length ? search : ""}`,
                skip_cache: silent ? true : !!value,
                screen_id: screenId,
                active_route: `${window.location.pathname}${window.location.search || ""}`,
                component_id: componentId,
                device_info: (0, $7b0e169a5380005e$export$a5202107d3e3cdb0)(),
                session_id: (0, $2857511e8f5d961e$export$2e2bcd8739ae039).getOrCreateSessionId()
            });
            if (code !== 200 || !data) return;
            const { page: pp, settings: settings, variableData: variableData, screenId: screenIdParsed } = data.sections ? $6ace1c53c6a18897$var$parseOldFormat(data) : $6ace1c53c6a18897$var$parseNewFormat(data);
            yield (0, $8f51be6e3f59daaa$export$8743009a87fcb00f)((0, $8eba69c5466928d3$export$98eb18032ef4d6ea)({
                data: pp,
                settings: settings,
                sessionData: sessionData,
                variableData: variableData,
                screenId: screenIdParsed
            }));
            const { status: status, transformed: transformed } = (0, $7b0e169a5380005e$export$b40f43cc69224c6e)(data?.screen?.sections);
            if (status && transformed && !silent) // Update response with transformed sections
            // Save
            (0, $c9e12427d7d919f3$export$8a8216c44337cd5)(cacheKey, {
                ...data,
                screen: {
                    ...data.screen,
                    sections: transformed
                },
                variable_data: variableData
            });
            else if (!silent) (0, $c9e12427d7d919f3$export$fe2d9b4e03920b4c)(cacheKey);
            // Handle settings.command URL update
            if (settings?.command) {
                const newCommand = settings.command.replace(/^\//, "");
                const currentPath = window.location.pathname.replace(/^\//, "") + window.location.search;
                if (!/\{\{[^}]+\}\}/.test(newCommand) && newCommand !== currentPath) window.history.pushState(null, "", `/${newCommand}`);
            }
            // Parse form values
            const formValues = (0, $7b0e169a5380005e$export$a8c212b8aefc29ec)(pp);
            yield (0, $8f51be6e3f59daaa$export$8743009a87fcb00f)((0, $8eba69c5466928d3$export$6e19b0a4e4c542c1)({
                data: formValues
            }));
        }
    } catch (error) {
        if (error instanceof Error) console.error("Error in handlePageRequest:", error.message);
    }
}
function* $6ace1c53c6a18897$var$handleSetFormValuesRequest(action) {
    const { payload: payload } = action || {};
    const { field: field } = payload || {};
    const { id: id, value: value } = field || {};
    yield (0, $8f51be6e3f59daaa$export$8743009a87fcb00f)((0, $8eba69c5466928d3$export$4452cb953514838a)({
        data: {
            [id]: value
        }
    }));
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* $6ace1c53c6a18897$var$sendAllFormValues(action) {
    const screenId = yield (0, $8f51be6e3f59daaa$export$6559d589eb85fbb6)((state)=>state.page.screenId);
    const { payload: payload, meta: meta } = action || {};
    const { value: value, delay: del, componentId: componentId, block: block, silent: silent } = payload || {};
    // Stop processing if block is true
    if (block) return;
    const page = yield (0, $8f51be6e3f59daaa$export$6559d589eb85fbb6)((state)=>state.page);
    const { settings: settings, variableData: variableData, formValues: formValues } = page || {};
    const mergedVariables = (0, (/*@__PURE__*/$parcel$interopDefault($94WEq)))({}, settings?.variables || {}, variableData || {});
    const replacedFormValue = (0, $7b0e169a5380005e$export$9a7eef5d73136d1e)(formValues, mergedVariables);
    yield (0, $8f51be6e3f59daaa$export$c4ce752e73470fba)(del || 0);
    // if (meta) {
    //   yield put(updateNodeActiveState({ id: meta }));
    // }
    const cacheKey = (0, $7b0e169a5380005e$export$ab2a4759dabf5477)({
        command: undefined,
        action: value,
        component_id: componentId,
        screen_id: screenId
    });
    const value2 = yield (0, $8f51be6e3f59daaa$export$a07804094c3ecf2d)((0, $c9e12427d7d919f3$export$f92dfeb71e9bb569), cacheKey);
    if (value2 && !silent) {
        const { page: pp, settings: settings, variableData: variableData, screenId: screenIdParsed } = value2.sections ? $6ace1c53c6a18897$var$parseOldFormat(value2) : $6ace1c53c6a18897$var$parseNewFormat(value2);
        yield (0, $8f51be6e3f59daaa$export$8743009a87fcb00f)((0, $8eba69c5466928d3$export$98eb18032ef4d6ea)({
            data: pp,
            settings: settings,
            sessionData: {},
            variableData: variableData,
            screenId: screenIdParsed
        }));
    }
    try {
        yield (0, $8f51be6e3f59daaa$export$8743009a87fcb00f)((0, $8eba69c5466928d3$export$3653d7e5cadcf5e3)());
        const { code: code, data: data, sessionData: sessionData } = yield (0, $8f51be6e3f59daaa$export$a07804094c3ecf2d)((0, $44edbfa3e77e92f9$export$2e2bcd8739ae039), "post", "/get", {
            action: value,
            screen_id: screenId,
            skip_cache: silent ? true : !!value,
            active_route: `${window.location.pathname}${window.location.search || ""}`,
            component_id: componentId,
            device_info: (0, $7b0e169a5380005e$export$a5202107d3e3cdb0)(),
            session_id: (0, $2857511e8f5d961e$export$2e2bcd8739ae039).getOrCreateSessionId(),
            ...replacedFormValue
        });
        if (code !== 200 || !data) return;
        const { page: pp, settings: settings, variableData: variableData, screenId: screenIdParsed } = data.sections ? $6ace1c53c6a18897$var$parseOldFormat(data) : $6ace1c53c6a18897$var$parseNewFormat(data);
        yield (0, $8f51be6e3f59daaa$export$8743009a87fcb00f)((0, $8eba69c5466928d3$export$98eb18032ef4d6ea)({
            data: pp,
            settings: settings,
            sessionData: sessionData,
            variableData: variableData,
            screenId: screenIdParsed
        }));
        const { status: status, transformed: transformed } = (0, $7b0e169a5380005e$export$b40f43cc69224c6e)(data?.screen?.sections);
        if (status && transformed && !silent) (0, $c9e12427d7d919f3$export$8a8216c44337cd5)(cacheKey, {
            ...data,
            screen: {
                ...data.screen,
                sections: transformed
            },
            variable_data: variableData
        });
        else if (!silent) (0, $c9e12427d7d919f3$export$fe2d9b4e03920b4c)(cacheKey);
        // Handle settings.command URL update
        if (settings?.command) {
            const newCommand = settings.command.replace(/^\//, "");
            const currentPath = window.location.pathname.replace(/^\//, "") + window.location.search;
            if (!/\{\{[^}]+\}\}/.test(newCommand) && newCommand !== currentPath) window.history.pushState(null, "", `/${newCommand}`);
        }
        // Parse form values
        const formValues = (0, $7b0e169a5380005e$export$a8c212b8aefc29ec)(pp);
        yield (0, $8f51be6e3f59daaa$export$8743009a87fcb00f)((0, $8eba69c5466928d3$export$6e19b0a4e4c542c1)({
            data: formValues
        }));
    } catch (error) {
        if (error instanceof Error) console.error("Error in sendAllFormValues:", error.message);
    }
}
function* $6ace1c53c6a18897$var$updateVariableRequest(action) {
    const { payload: payload } = action || {};
    const { variable: variable, value: value } = payload || {};
    const keys = variable.split(".");
    const result = keys.reduceRight((acc, key)=>({
            [key]: acc
        }), value);
    yield (0, $8f51be6e3f59daaa$export$8743009a87fcb00f)((0, $8eba69c5466928d3$export$7b322c1959eae1de)({
        data: result
    }));
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* $6ace1c53c6a18897$var$handleLocationChange(action) {
    const { location: location, isFirstRendering: isFirstRendering } = action.payload;
    if (isFirstRendering === true) yield (0, $8f51be6e3f59daaa$export$8743009a87fcb00f)((0, $2907166a90fe0a09$export$cf229b36ba13aa52)(location));
    else yield (0, $8f51be6e3f59daaa$export$8743009a87fcb00f)((0, $8eba69c5466928d3$export$ea176eb1668c7b4b)({
        ...action.payload
    }));
}
function* $6ace1c53c6a18897$var$handleMergeStyle(action) {
    const { payload: payload, meta: meta } = action || {};
    const updates = Array.isArray(payload) ? payload : [
        payload
    ];
    const { page: page } = yield (0, $8f51be6e3f59daaa$export$6559d589eb85fbb6)((state)=>state.page.data);
    const settings = yield (0, $8f51be6e3f59daaa$export$6559d589eb85fbb6)((state)=>state.page.settings);
    const styleChunks = yield (0, $8f51be6e3f59daaa$export$6559d589eb85fbb6)((state)=>state.page.styleChunks);
    const variableData = yield (0, $8f51be6e3f59daaa$export$6559d589eb85fbb6)((state)=>state.page.variableData);
    const screenId = yield (0, $8f51be6e3f59daaa$export$6559d589eb85fbb6)((state)=>state.page.screenId);
    const updatesMap = updates.reduce((map, update)=>{
        map[update.object_id] = update;
        return map;
    }, {});
    const inArr = Array.isArray(page) ? page : [
        page
    ];
    const updatedComponents = (0, $7b0e169a5380005e$export$8f49bf34d2145408)(inArr, updatesMap, (item, insideTable)=>{
        const update = Object.keys(updatesMap).find((objId)=>objId === item.id || (0, $7b0e169a5380005e$export$78e968efcca6b7ef)(objId, item.id) && updatesMap[objId]?.object_type === item.component);
        if (update) {
            if (insideTable && typeof meta === "number") {
                if (!styleChunks[item.id]) styleChunks[item.id] = {};
                styleChunks[item.id][meta] = (0, (/*@__PURE__*/$parcel$interopDefault($94WEq)))({}, styleChunks[item.id][meta], updatesMap[update]?.style);
                return item;
            } else return {
                ...item,
                style: (0, (/*@__PURE__*/$parcel$interopDefault($94WEq)))({}, item.style, updatesMap[update]?.style)
            };
        }
        return item;
    });
    yield (0, $8f51be6e3f59daaa$export$8743009a87fcb00f)((0, $8eba69c5466928d3$export$98eb18032ef4d6ea)({
        data: updatedComponents,
        settings: settings,
        variableData: variableData,
        styleChunks: styleChunks,
        screenId: screenId
    }));
}
function* $6ace1c53c6a18897$var$handleNodeActiveState(action) {
    const { payload: payload } = action || {};
    const { id: id } = payload || {};
    const { page: page } = yield (0, $8f51be6e3f59daaa$export$6559d589eb85fbb6)((state)=>state.page.data);
    const updatedComponents = (0, $7b0e169a5380005e$export$142f03d1558de863)(page, id);
    yield (0, $8f51be6e3f59daaa$export$8743009a87fcb00f)((0, $8eba69c5466928d3$export$1b7ea3ca287f7c67)({
        data: updatedComponents
    }));
}
function* $6ace1c53c6a18897$var$handleUncheck(action) {
    const { payload: payload } = action || {};
    const { name: name, excludeId: excludeId } = payload || {};
    const { page: page } = yield (0, $8f51be6e3f59daaa$export$6559d589eb85fbb6)((state)=>state.page.data);
    const { items: items, changedIds: changedIds } = (0, $7b0e169a5380005e$export$5c5b0ec7b0e2d3dd)(page, name, excludeId);
    yield (0, $8f51be6e3f59daaa$export$8743009a87fcb00f)((0, $8eba69c5466928d3$export$22aa4fb508251850)({
        data: items
    }));
    for (const item of changedIds)yield (0, $8f51be6e3f59daaa$export$8743009a87fcb00f)((0, $8eba69c5466928d3$export$528cdcbbafe26779)({
        field: {
            id: item,
            value: false
        }
    }));
}
function* $6ace1c53c6a18897$var$watchNodeActiveStatePending() {
    yield (0, $17b5b1be37557756$export$4e24be1e1c9d5c69)((0, $bd80e90ec7f1f3b2$export$f1bd415280efb039).UPDATE_NODE_ACTIVE_STATE_REQUEST, $6ace1c53c6a18897$var$handleNodeActiveState);
}
function* $6ace1c53c6a18897$var$watchLocationChange() {
    yield (0, $17b5b1be37557756$export$4e24be1e1c9d5c69)((0, $bd80e90ec7f1f3b2$export$f1bd415280efb039).LOCATION_CHANGE, $6ace1c53c6a18897$var$handleLocationChange);
}
function* $6ace1c53c6a18897$var$watchFetchRequest() {
    yield (0, $17b5b1be37557756$export$ca010cea618a298a)((0, $bd80e90ec7f1f3b2$export$f1bd415280efb039).PAGE_REQUEST, $6ace1c53c6a18897$var$handlePageRequest);
    yield (0, $17b5b1be37557756$export$4e24be1e1c9d5c69)((0, $bd80e90ec7f1f3b2$export$f1bd415280efb039).MERGE_STYLE_REQUEST, $6ace1c53c6a18897$var$handleMergeStyle);
}
function* $6ace1c53c6a18897$var$watchHandleInputRequest() {
    yield (0, $17b5b1be37557756$export$4e24be1e1c9d5c69)((0, $bd80e90ec7f1f3b2$export$f1bd415280efb039).SET_FORM_VALUES_REQUEST, $6ace1c53c6a18897$var$handleSetFormValuesRequest);
}
function* $6ace1c53c6a18897$var$watchSubmitFormRequest() {
    yield (0, $17b5b1be37557756$export$ca010cea618a298a)((0, $bd80e90ec7f1f3b2$export$f1bd415280efb039).SUBMIT_FORM_REQUEST, $6ace1c53c6a18897$var$sendAllFormValues);
}
function* $6ace1c53c6a18897$var$watchUpdateVariableRequest() {
    yield (0, $17b5b1be37557756$export$ca010cea618a298a)((0, $bd80e90ec7f1f3b2$export$f1bd415280efb039).UPDATE_VARIABLE_REQUEST, $6ace1c53c6a18897$var$updateVariableRequest);
}
function* $6ace1c53c6a18897$var$watchUncheckDependent() {
    yield (0, $17b5b1be37557756$export$4e24be1e1c9d5c69)((0, $bd80e90ec7f1f3b2$export$f1bd415280efb039).UNCHECK_DEPENDENT_RADIO_REQUEST, $6ace1c53c6a18897$var$handleUncheck);
}
function* $6ace1c53c6a18897$var$pageSaga() {
    yield (0, $8f51be6e3f59daaa$export$71511d61b312f219)([
        (0, $8f51be6e3f59daaa$export$61196ced6d74a310)($6ace1c53c6a18897$var$watchNodeActiveStatePending),
        (0, $8f51be6e3f59daaa$export$61196ced6d74a310)($6ace1c53c6a18897$var$watchHandleInputRequest),
        (0, $8f51be6e3f59daaa$export$61196ced6d74a310)($6ace1c53c6a18897$var$watchFetchRequest),
        (0, $8f51be6e3f59daaa$export$61196ced6d74a310)($6ace1c53c6a18897$var$watchSubmitFormRequest),
        (0, $8f51be6e3f59daaa$export$61196ced6d74a310)($6ace1c53c6a18897$var$watchLocationChange),
        (0, $8f51be6e3f59daaa$export$61196ced6d74a310)($6ace1c53c6a18897$var$watchUpdateVariableRequest),
        (0, $8f51be6e3f59daaa$export$61196ced6d74a310)($6ace1c53c6a18897$var$watchUncheckDependent)
    ]);
}
var $6ace1c53c6a18897$export$2e2bcd8739ae039 = $6ace1c53c6a18897$var$pageSaga;


/* eslint-disable @typescript-eslint/default-param-last */ 

var $94WEq = parcelRequire("94WEq");
const $471be8cf4b44b657$export$d4c72bab9d6cc13a = {
    data: {
        page: {}
    },
    screenId: undefined,
    styleChunks: {},
    sessionData: {},
    settings: {},
    variableData: {},
    formValues: {},
    loading: true
};
const $471be8cf4b44b657$export$df5f0d913620ea1b = (state = $471be8cf4b44b657$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case (0, $bd80e90ec7f1f3b2$export$f1bd415280efb039).PAGE_REQUEST:
            return {
                ...state,
                loading: true,
                notifications: []
            };
        case (0, $bd80e90ec7f1f3b2$export$f1bd415280efb039).SET_FORM_VALUES_SUCCESS:
            return {
                ...state,
                formValues: {
                    ...state.formValues,
                    ...action.payload.data
                }
            };
        case (0, $bd80e90ec7f1f3b2$export$f1bd415280efb039).RESET_FORM_VALUES_SUCCESS:
            return {
                ...state,
                formValues: {
                    ...action.payload.data
                }
            };
        case (0, $bd80e90ec7f1f3b2$export$f1bd415280efb039).PAGE_SUCCESS:
            return {
                ...state,
                loading: false,
                previewFile: undefined,
                screenId: action.payload.screenId,
                data: {
                    page: action.payload.data
                },
                settings: {
                    ...action.payload.settings
                },
                variableData: {
                    ...action.payload.variableData
                },
                sessionData: {
                    ...action.payload.sessionData
                }
            };
        case (0, $bd80e90ec7f1f3b2$export$f1bd415280efb039).UNCHECK_DEPENDENT_RADIO_SUCCESS:
            return {
                ...state,
                data: {
                    page: action.payload.data
                }
            };
        case (0, $bd80e90ec7f1f3b2$export$f1bd415280efb039).UPDATE_VARIABLE_SUCCESS:
            return {
                ...state,
                variableData: (0, (/*@__PURE__*/$parcel$interopDefault($94WEq)))({}, state.variableData, action.payload.data)
            };
        case (0, $bd80e90ec7f1f3b2$export$f1bd415280efb039).UPDATE_NODE_ACTIVE_STATE_SUCCESS:
            return {
                ...state,
                data: {
                    page: action.payload.data
                }
            };
        case (0, $bd80e90ec7f1f3b2$export$f1bd415280efb039).PAGE_ERROR:
            return {
                ...state,
                loading: false
            };
        case (0, $bd80e90ec7f1f3b2$export$f1bd415280efb039).CLEAR_FORMS:
            return {
                ...state,
                data: {
                    ...state.data,
                    forms: []
                }
            };
        case (0, $bd80e90ec7f1f3b2$export$f1bd415280efb039).UPDATE_ITEM_SUCCESS:
            return {
                ...state,
                loading: false,
                data: {
                    ...state.data,
                    ...action.payload
                }
            };
        default:
            return state;
    }
};








function* $7888bad15d99924f$var$handleConfigRequest(action) {
    const { code: code, data: data } = yield (0, $8f51be6e3f59daaa$export$a07804094c3ecf2d)((0, $44edbfa3e77e92f9$export$2e2bcd8739ae039), "get", "/config");
    if (code === 200) {
        yield (0, $8f51be6e3f59daaa$export$8743009a87fcb00f)((0, $2907166a90fe0a09$export$ff747514dac36e4c)({
            data: {
                ...data
            }
        }));
        if (data.style) (0, $7b0e169a5380005e$export$ff76c51b0f744e0a)(data.style);
        yield (0, $8f51be6e3f59daaa$export$8743009a87fcb00f)((0, $8eba69c5466928d3$export$ea176eb1668c7b4b)({
            location: {
                ...action.payload
            }
        }));
    } else yield (0, $8f51be6e3f59daaa$export$8743009a87fcb00f)((0, $2907166a90fe0a09$export$3dbcfb3539facac2)());
}
function* $7888bad15d99924f$var$handleConfigEmptyRequest() {
    const { code: code, data: data } = yield (0, $8f51be6e3f59daaa$export$a07804094c3ecf2d)((0, $44edbfa3e77e92f9$export$2e2bcd8739ae039), "get", "/config");
    if (code === 200) {
        if (data.style) (0, $7b0e169a5380005e$export$ff76c51b0f744e0a)(data.style);
        yield (0, $8f51be6e3f59daaa$export$8743009a87fcb00f)((0, $2907166a90fe0a09$export$ff747514dac36e4c)({
            data: {
                ...data
            }
        }));
    } else yield (0, $8f51be6e3f59daaa$export$8743009a87fcb00f)((0, $2907166a90fe0a09$export$3dbcfb3539facac2)());
}
function* $7888bad15d99924f$var$watchFetchRequest() {
    yield (0, $17b5b1be37557756$export$4e24be1e1c9d5c69)((0, $9c904b43c5ef6eaf$export$e378b6cc3d050bd4).CONFIG_REQUEST, $7888bad15d99924f$var$handleConfigRequest);
    yield (0, $17b5b1be37557756$export$4e24be1e1c9d5c69)((0, $9c904b43c5ef6eaf$export$e378b6cc3d050bd4).CONFIG_EMPTY_REQUEST, $7888bad15d99924f$var$handleConfigEmptyRequest);
}
function* $7888bad15d99924f$var$configSaga() {
    yield (0, $8f51be6e3f59daaa$export$71511d61b312f219)([
        (0, $8f51be6e3f59daaa$export$61196ced6d74a310)($7888bad15d99924f$var$watchFetchRequest)
    ]);
}
var $7888bad15d99924f$export$2e2bcd8739ae039 = $7888bad15d99924f$var$configSaga;


/* eslint-disable @typescript-eslint/default-param-last */ 
const $7cc89248c7209f44$export$d4c72bab9d6cc13a = {
    data: {}
};
const $7cc89248c7209f44$export$21f3d8f1fe4f2d8 = (state = $7cc89248c7209f44$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case (0, $9c904b43c5ef6eaf$export$e378b6cc3d050bd4).CONFIG_SUCCESS:
            return {
                ...state,
                data: {
                    ...action.payload.data
                }
            };
        default:
            return state;
    }
};


const $0f4aec746757b732$export$3be10229d3544b83 = (history)=>(0, $b4bc487a38c3f200$export$66e4520cdb265d18)({
        router: (0, $bcf121fb6549cc53$export$2c021ec3f68e26bf)(history),
        page: (0, $471be8cf4b44b657$export$df5f0d913620ea1b),
        config: (0, $7cc89248c7209f44$export$21f3d8f1fe4f2d8)
    });
function* $0f4aec746757b732$export$6a6f973fb1abcfdc() {
    yield (0, $8f51be6e3f59daaa$export$71511d61b312f219)([
        (0, $8f51be6e3f59daaa$export$61196ced6d74a310)((0, $7888bad15d99924f$export$2e2bcd8739ae039)),
        (0, $8f51be6e3f59daaa$export$61196ced6d74a310)((0, $6ace1c53c6a18897$export$2e2bcd8739ae039))
    ]);
}


const $4931f7746d84676b$export$55abd4691b317664 = (0, $0e3a6b1020765bd1$export$719fc203c4e16dee)();
function $4931f7746d84676b$export$2e2bcd8739ae039(initialState) {
    const composeEnhancers = (0, $60658be5529a36bf$export$d32324a03b6bde1b)({});
    const sagaMiddleware = (0, $e77394150e9d59e6$export$2e2bcd8739ae039)();
    const store = (0, $b4bc487a38c3f200$export$f51a9068ac82ea43)((0, $0f4aec746757b732$export$3be10229d3544b83)($4931f7746d84676b$export$55abd4691b317664), initialState, composeEnhancers((0, $b4bc487a38c3f200$export$9ff26e0402cc7b7)((0, $bf36379e38a118fb$export$2e2bcd8739ae039)($4931f7746d84676b$export$55abd4691b317664), sagaMiddleware)));
    sagaMiddleware.run((0, $0f4aec746757b732$export$6a6f973fb1abcfdc));
    return store;
}



parcelRequire("aivMx");



parcelRequire("aivMx");



var $aivMx = parcelRequire("aivMx");

/* eslint-disable react/jsx-props-no-spreading */ 

var $aivMx = parcelRequire("aivMx");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $2b0605493dba51bd$var$extendStatics = function(d, b) {
    $2b0605493dba51bd$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $2b0605493dba51bd$var$extendStatics(d, b);
};
function $2b0605493dba51bd$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $2b0605493dba51bd$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $2b0605493dba51bd$export$18ce0697a983be9b = function() {
    $2b0605493dba51bd$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2b0605493dba51bd$export$18ce0697a983be9b.apply(this, arguments);
};
function $2b0605493dba51bd$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $2b0605493dba51bd$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $2b0605493dba51bd$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $2b0605493dba51bd$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $2b0605493dba51bd$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $2b0605493dba51bd$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $2b0605493dba51bd$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $2b0605493dba51bd$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $2b0605493dba51bd$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $2b0605493dba51bd$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $2b0605493dba51bd$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $2b0605493dba51bd$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $2b0605493dba51bd$export$45d3717a4c69092e(o, m, p);
}
function $2b0605493dba51bd$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $2b0605493dba51bd$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $2b0605493dba51bd$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($2b0605493dba51bd$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $2b0605493dba51bd$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $2b0605493dba51bd$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $2b0605493dba51bd$export$10c90e4f7922046c(v) {
    return this instanceof $2b0605493dba51bd$export$10c90e4f7922046c ? (this.v = v, this) : new $2b0605493dba51bd$export$10c90e4f7922046c(v);
}
function $2b0605493dba51bd$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $2b0605493dba51bd$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $2b0605493dba51bd$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $2b0605493dba51bd$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $2b0605493dba51bd$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $2b0605493dba51bd$export$19a8beecd37a4c45 === "function" ? $2b0605493dba51bd$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $2b0605493dba51bd$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $2b0605493dba51bd$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $2b0605493dba51bd$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $2b0605493dba51bd$export$45d3717a4c69092e(result, mod, k);
    }
    $2b0605493dba51bd$var$__setModuleDefault(result, mod);
    return result;
}
function $2b0605493dba51bd$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $2b0605493dba51bd$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $2b0605493dba51bd$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $2b0605493dba51bd$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $2b0605493dba51bd$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $2b0605493dba51bd$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $2b0605493dba51bd$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $2b0605493dba51bd$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $2b0605493dba51bd$export$2e2bcd8739ae039 = {
    __extends: $2b0605493dba51bd$export$a8ba968b8961cb8a,
    __assign: $2b0605493dba51bd$export$18ce0697a983be9b,
    __rest: $2b0605493dba51bd$export$3c9a16f847548506,
    __decorate: $2b0605493dba51bd$export$29e00dfd3077644b,
    __param: $2b0605493dba51bd$export$d5ad3fd78186038f,
    __metadata: $2b0605493dba51bd$export$f1db080c865becb9,
    __awaiter: $2b0605493dba51bd$export$1050f835b63b671e,
    __generator: $2b0605493dba51bd$export$67ebef60e6f28a6,
    __createBinding: $2b0605493dba51bd$export$45d3717a4c69092e,
    __exportStar: $2b0605493dba51bd$export$f33643c0debef087,
    __values: $2b0605493dba51bd$export$19a8beecd37a4c45,
    __read: $2b0605493dba51bd$export$8d051b38c9118094,
    __spread: $2b0605493dba51bd$export$afc72e2116322959,
    __spreadArrays: $2b0605493dba51bd$export$6388937ca91ccae8,
    __spreadArray: $2b0605493dba51bd$export$1216008129fb82ed,
    __await: $2b0605493dba51bd$export$10c90e4f7922046c,
    __asyncGenerator: $2b0605493dba51bd$export$e427f37a30a4de9b,
    __asyncDelegator: $2b0605493dba51bd$export$bbd80228419bb833,
    __asyncValues: $2b0605493dba51bd$export$e3b29a3d6162315f,
    __makeTemplateObject: $2b0605493dba51bd$export$4fb47efe1390b86f,
    __importStar: $2b0605493dba51bd$export$c21735bcef00d192,
    __importDefault: $2b0605493dba51bd$export$da59b14a69baef04,
    __classPrivateFieldGet: $2b0605493dba51bd$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $2b0605493dba51bd$export$d40a35129aaff81f,
    __classPrivateFieldIn: $2b0605493dba51bd$export$81fdc39f203e4e04,
    __addDisposableResource: $2b0605493dba51bd$export$88ac25d8e944e405,
    __disposeResources: $2b0605493dba51bd$export$8f076105dc360e92
};


function $685fb41f75d10f60$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $021663a6134a8be0$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $021663a6134a8be0$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $685fb41f75d10f60$export$2e2bcd8739ae039)(function(prop) {
    return $021663a6134a8be0$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});



var $aivMx = parcelRequire("aivMx");
var $a69eca18a69a3816$exports = {};
//
$a69eca18a69a3816$exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};


var $9839ee8e660104a4$export$71ad59f2e432cfe8 = "-ms-";
var $9839ee8e660104a4$export$2c0f367103c8d01c = "-moz-";
var $9839ee8e660104a4$export$39dfd62a25e0fe93 = "-webkit-";
var $9839ee8e660104a4$export$a29989082612d0d9 = "comm";
var $9839ee8e660104a4$export$aa3a2e812ca8570d = "rule";
var $9839ee8e660104a4$export$527d108ccf083c2b = "decl";
var $9839ee8e660104a4$export$d3d35020fa5b54f0 = "@page";
var $9839ee8e660104a4$export$500415a86c544f73 = "@media";
var $9839ee8e660104a4$export$a763edbf796b780a = "@import";
var $9839ee8e660104a4$export$2790aeb8b4e5c826 = "@charset";
var $9839ee8e660104a4$export$1cc683e23b84b133 = "@viewport";
var $9839ee8e660104a4$export$9447a5efea57e862 = "@supports";
var $9839ee8e660104a4$export$ef011b4e114b1fba = "@document";
var $9839ee8e660104a4$export$6aad947bda0f3f46 = "@namespace";
var $9839ee8e660104a4$export$b44a8529a35fcb60 = "@keyframes";
var $9839ee8e660104a4$export$2c16de31893252e6 = "@font-face";
var $9839ee8e660104a4$export$3d846dd52e150c6f = "@counter-style";
var $9839ee8e660104a4$export$22314bfbb57653fe = "@font-feature-values";
var $9839ee8e660104a4$export$d773506282b3cfe6 = "@layer";
var $9839ee8e660104a4$export$2335f513bbd82c6d = Math.abs;
var $9839ee8e660104a4$export$6788812c4e6611e6 = String.fromCharCode;
var $9839ee8e660104a4$export$e6e34fd1f2686227 = Object.assign;
function $9839ee8e660104a4$export$d6af199866bfb566(e, r) {
    return $9839ee8e660104a4$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $9839ee8e660104a4$export$a9db5e087081082d(e, 0)) << 2 ^ $9839ee8e660104a4$export$a9db5e087081082d(e, 1)) << 2 ^ $9839ee8e660104a4$export$a9db5e087081082d(e, 2)) << 2 ^ $9839ee8e660104a4$export$a9db5e087081082d(e, 3) : 0;
}
function $9839ee8e660104a4$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $9839ee8e660104a4$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $9839ee8e660104a4$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $9839ee8e660104a4$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $9839ee8e660104a4$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $9839ee8e660104a4$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $9839ee8e660104a4$export$36776f635604f274(e) {
    return e.length;
}
function $9839ee8e660104a4$export$f9084667e487ed46(e) {
    return e.length;
}
function $9839ee8e660104a4$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $9839ee8e660104a4$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
function $9839ee8e660104a4$export$3dea766d36a8935f(e, r) {
    return e.filter(function(e) {
        return !$9839ee8e660104a4$export$4659b591c19bdf3d(e, r);
    });
}
var $9839ee8e660104a4$export$53f1d5ea8de3d7c = 1;
var $9839ee8e660104a4$export$4e0c71f277ca26b3 = 1;
var $9839ee8e660104a4$export$f24224f1c91d8156 = 0;
var $9839ee8e660104a4$export$5880b8b5730aff45 = 0;
var $9839ee8e660104a4$export$c0306caf338ac095 = 0;
var $9839ee8e660104a4$export$30a86d91af8ff6e6 = "";
function $9839ee8e660104a4$export$35059013cd4a06db(e, r, a, n, c, s, t, u) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $9839ee8e660104a4$export$53f1d5ea8de3d7c,
        column: $9839ee8e660104a4$export$4e0c71f277ca26b3,
        length: t,
        return: "",
        siblings: u
    };
}
function $9839ee8e660104a4$export$784d13d8ee351f07(e, r) {
    return $9839ee8e660104a4$export$e6e34fd1f2686227($9839ee8e660104a4$export$35059013cd4a06db("", null, null, "", null, null, 0, e.siblings), e, {
        length: -e.length
    }, r);
}
function $9839ee8e660104a4$export$590e8b2c435046d9(e) {
    while(e.root)e = $9839ee8e660104a4$export$784d13d8ee351f07(e.root, {
        children: [
            e
        ]
    });
    $9839ee8e660104a4$export$10d8903dec122b9d(e, e.siblings);
}
function $9839ee8e660104a4$export$eba6f6f03b0a92e7() {
    return $9839ee8e660104a4$export$c0306caf338ac095;
}
function $9839ee8e660104a4$export$232faf9add678146() {
    $9839ee8e660104a4$export$c0306caf338ac095 = $9839ee8e660104a4$export$5880b8b5730aff45 > 0 ? $9839ee8e660104a4$export$a9db5e087081082d($9839ee8e660104a4$export$30a86d91af8ff6e6, --$9839ee8e660104a4$export$5880b8b5730aff45) : 0;
    if ($9839ee8e660104a4$export$4e0c71f277ca26b3--, $9839ee8e660104a4$export$c0306caf338ac095 === 10) $9839ee8e660104a4$export$4e0c71f277ca26b3 = 1, $9839ee8e660104a4$export$53f1d5ea8de3d7c--;
    return $9839ee8e660104a4$export$c0306caf338ac095;
}
function $9839ee8e660104a4$export$48cfd1e771a65c4f() {
    $9839ee8e660104a4$export$c0306caf338ac095 = $9839ee8e660104a4$export$5880b8b5730aff45 < $9839ee8e660104a4$export$f24224f1c91d8156 ? $9839ee8e660104a4$export$a9db5e087081082d($9839ee8e660104a4$export$30a86d91af8ff6e6, $9839ee8e660104a4$export$5880b8b5730aff45++) : 0;
    if ($9839ee8e660104a4$export$4e0c71f277ca26b3++, $9839ee8e660104a4$export$c0306caf338ac095 === 10) $9839ee8e660104a4$export$4e0c71f277ca26b3 = 1, $9839ee8e660104a4$export$53f1d5ea8de3d7c++;
    return $9839ee8e660104a4$export$c0306caf338ac095;
}
function $9839ee8e660104a4$export$4d3fb11e950abb9e() {
    return $9839ee8e660104a4$export$a9db5e087081082d($9839ee8e660104a4$export$30a86d91af8ff6e6, $9839ee8e660104a4$export$5880b8b5730aff45);
}
function $9839ee8e660104a4$export$e88cb2efb12ae807() {
    return $9839ee8e660104a4$export$5880b8b5730aff45;
}
function $9839ee8e660104a4$export$58adb3bec8346d0f(e, r) {
    return $9839ee8e660104a4$export$2f35ab04d2335697($9839ee8e660104a4$export$30a86d91af8ff6e6, e, r);
}
function $9839ee8e660104a4$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $9839ee8e660104a4$export$2de70f21292aac9e(e) {
    return $9839ee8e660104a4$export$53f1d5ea8de3d7c = $9839ee8e660104a4$export$4e0c71f277ca26b3 = 1, $9839ee8e660104a4$export$f24224f1c91d8156 = $9839ee8e660104a4$export$36776f635604f274($9839ee8e660104a4$export$30a86d91af8ff6e6 = e), $9839ee8e660104a4$export$5880b8b5730aff45 = 0, [];
}
function $9839ee8e660104a4$export$45918ac1574455b1(e) {
    return $9839ee8e660104a4$export$30a86d91af8ff6e6 = "", e;
}
function $9839ee8e660104a4$export$410ac95b9ec204b8(e) {
    return $9839ee8e660104a4$export$87c2784dc9fc4ab($9839ee8e660104a4$export$58adb3bec8346d0f($9839ee8e660104a4$export$5880b8b5730aff45 - 1, $9839ee8e660104a4$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $9839ee8e660104a4$export$660b2ee2d4fb4eff(e) {
    return $9839ee8e660104a4$export$45918ac1574455b1($9839ee8e660104a4$export$5f8c09e3ae6f64e1($9839ee8e660104a4$export$2de70f21292aac9e(e)));
}
function $9839ee8e660104a4$export$7af1228ff777d175(e) {
    while($9839ee8e660104a4$export$c0306caf338ac095 = $9839ee8e660104a4$export$4d3fb11e950abb9e())if ($9839ee8e660104a4$export$c0306caf338ac095 < 33) $9839ee8e660104a4$export$48cfd1e771a65c4f();
    else break;
    return $9839ee8e660104a4$export$9e1725a4cfeada27(e) > 2 || $9839ee8e660104a4$export$9e1725a4cfeada27($9839ee8e660104a4$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $9839ee8e660104a4$export$5f8c09e3ae6f64e1(e) {
    while($9839ee8e660104a4$export$48cfd1e771a65c4f())switch($9839ee8e660104a4$export$9e1725a4cfeada27($9839ee8e660104a4$export$c0306caf338ac095)){
        case 0:
            $9839ee8e660104a4$export$10d8903dec122b9d($9839ee8e660104a4$export$c2ab62c7bf24634($9839ee8e660104a4$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $9839ee8e660104a4$export$10d8903dec122b9d($9839ee8e660104a4$export$410ac95b9ec204b8($9839ee8e660104a4$export$c0306caf338ac095), e);
            break;
        default:
            $9839ee8e660104a4$export$10d8903dec122b9d($9839ee8e660104a4$export$6788812c4e6611e6($9839ee8e660104a4$export$c0306caf338ac095), e);
    }
    return e;
}
function $9839ee8e660104a4$export$955ba06d119e085e(e, r) {
    while(--r && $9839ee8e660104a4$export$48cfd1e771a65c4f())if ($9839ee8e660104a4$export$c0306caf338ac095 < 48 || $9839ee8e660104a4$export$c0306caf338ac095 > 102 || $9839ee8e660104a4$export$c0306caf338ac095 > 57 && $9839ee8e660104a4$export$c0306caf338ac095 < 65 || $9839ee8e660104a4$export$c0306caf338ac095 > 70 && $9839ee8e660104a4$export$c0306caf338ac095 < 97) break;
    return $9839ee8e660104a4$export$58adb3bec8346d0f(e, $9839ee8e660104a4$export$e88cb2efb12ae807() + (r < 6 && $9839ee8e660104a4$export$4d3fb11e950abb9e() == 32 && $9839ee8e660104a4$export$48cfd1e771a65c4f() == 32));
}
function $9839ee8e660104a4$export$c889f2fcc19dbf12(e) {
    while($9839ee8e660104a4$export$48cfd1e771a65c4f())switch($9839ee8e660104a4$export$c0306caf338ac095){
        case e:
            return $9839ee8e660104a4$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $9839ee8e660104a4$export$c889f2fcc19dbf12($9839ee8e660104a4$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $9839ee8e660104a4$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $9839ee8e660104a4$export$48cfd1e771a65c4f();
            break;
    }
    return $9839ee8e660104a4$export$5880b8b5730aff45;
}
function $9839ee8e660104a4$export$4254d4e2b3745c4c(e, r) {
    while($9839ee8e660104a4$export$48cfd1e771a65c4f())if (e + $9839ee8e660104a4$export$c0306caf338ac095 === 57) break;
    else if (e + $9839ee8e660104a4$export$c0306caf338ac095 === 84 && $9839ee8e660104a4$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $9839ee8e660104a4$export$58adb3bec8346d0f(r, $9839ee8e660104a4$export$5880b8b5730aff45 - 1) + "*" + $9839ee8e660104a4$export$6788812c4e6611e6(e === 47 ? e : $9839ee8e660104a4$export$48cfd1e771a65c4f());
}
function $9839ee8e660104a4$export$c2ab62c7bf24634(e) {
    while(!$9839ee8e660104a4$export$9e1725a4cfeada27($9839ee8e660104a4$export$4d3fb11e950abb9e()))$9839ee8e660104a4$export$48cfd1e771a65c4f();
    return $9839ee8e660104a4$export$58adb3bec8346d0f(e, $9839ee8e660104a4$export$5880b8b5730aff45);
}
function $9839ee8e660104a4$export$ef7acd7185315e22(e) {
    return $9839ee8e660104a4$export$45918ac1574455b1($9839ee8e660104a4$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $9839ee8e660104a4$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $9839ee8e660104a4$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var g = 0;
    var k = "";
    var m = c;
    var x = s;
    var y = n;
    var j = k;
    while(w)switch(h = g, g = $9839ee8e660104a4$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $9839ee8e660104a4$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($9839ee8e660104a4$export$f8e21b1e77979a08(j += $9839ee8e660104a4$export$77ad94ebf1c2b9ed($9839ee8e660104a4$export$410ac95b9ec204b8(g), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $9839ee8e660104a4$export$410ac95b9ec204b8(g);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $9839ee8e660104a4$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $9839ee8e660104a4$export$955ba06d119e085e($9839ee8e660104a4$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($9839ee8e660104a4$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $9839ee8e660104a4$export$10d8903dec122b9d($9839ee8e660104a4$export$4a34f930e789283c($9839ee8e660104a4$export$4254d4e2b3745c4c($9839ee8e660104a4$export$48cfd1e771a65c4f(), $9839ee8e660104a4$export$e88cb2efb12ae807()), r, a, i), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $9839ee8e660104a4$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch(g){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $9839ee8e660104a4$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $9839ee8e660104a4$export$36776f635604f274(j) - l) $9839ee8e660104a4$export$10d8903dec122b9d(p > 32 ? $9839ee8e660104a4$export$f8483753829ec8f3(j + ";", n, a, l - 1, i) : $9839ee8e660104a4$export$f8483753829ec8f3($9839ee8e660104a4$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2, i), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $9839ee8e660104a4$export$10d8903dec122b9d(y = $9839ee8e660104a4$export$3307ffa7023ede1e(j, r, a, f, o, c, u, k, m = [], x = [], l, s), s);
                    if (g === 123) {
                        if (o === 0) $9839ee8e660104a4$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $9839ee8e660104a4$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $9839ee8e660104a4$export$98e6a39c04603d36(e, y, y, n && $9839ee8e660104a4$export$10d8903dec122b9d($9839ee8e660104a4$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, k, c, m = [], l, x), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $9839ee8e660104a4$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, k = j = "", l = t;
            break;
        case 58:
            l = 1 + $9839ee8e660104a4$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if (g == 123) --b;
                else if (g == 125 && b++ == 0 && $9839ee8e660104a4$export$232faf9add678146() == 125) continue;
            }
            switch(j += $9839ee8e660104a4$export$6788812c4e6611e6(g), g * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($9839ee8e660104a4$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($9839ee8e660104a4$export$4d3fb11e950abb9e() === 45) j += $9839ee8e660104a4$export$410ac95b9ec204b8($9839ee8e660104a4$export$48cfd1e771a65c4f());
                    v = $9839ee8e660104a4$export$4d3fb11e950abb9e(), o = l = $9839ee8e660104a4$export$36776f635604f274(k = j += $9839ee8e660104a4$export$c2ab62c7bf24634($9839ee8e660104a4$export$e88cb2efb12ae807())), g++;
                    break;
                case 45:
                    if (h === 45 && $9839ee8e660104a4$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $9839ee8e660104a4$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l, v) {
    var p = s - 1;
    var h = s === 0 ? t : [
        ""
    ];
    var b = $9839ee8e660104a4$export$f9084667e487ed46(h);
    for(var w = 0, d = 0, g = 0; w < n; ++w)for(var $ = 0, m = $9839ee8e660104a4$export$2f35ab04d2335697(e, p + 1, p = $9839ee8e660104a4$export$2335f513bbd82c6d(d = u[w])), x = e; $ < b; ++$)if (x = $9839ee8e660104a4$export$87c2784dc9fc4ab(d > 0 ? h[$] + " " + m : $9839ee8e660104a4$export$77ad94ebf1c2b9ed(m, /&\f/g, h[$]))) f[g++] = x;
    return $9839ee8e660104a4$export$35059013cd4a06db(e, r, a, s === 0 ? $9839ee8e660104a4$export$aa3a2e812ca8570d : i, f, o, l, v);
}
function $9839ee8e660104a4$export$4a34f930e789283c(e, r, a, c) {
    return $9839ee8e660104a4$export$35059013cd4a06db(e, r, a, $9839ee8e660104a4$export$a29989082612d0d9, $9839ee8e660104a4$export$6788812c4e6611e6($9839ee8e660104a4$export$eba6f6f03b0a92e7()), $9839ee8e660104a4$export$2f35ab04d2335697(e, 2, -2), 0, c);
}
function $9839ee8e660104a4$export$f8483753829ec8f3(e, r, a, n, c) {
    return $9839ee8e660104a4$export$35059013cd4a06db(e, r, a, $9839ee8e660104a4$export$527d108ccf083c2b, $9839ee8e660104a4$export$2f35ab04d2335697(e, 0, n), $9839ee8e660104a4$export$2f35ab04d2335697(e, n + 1, -1), n, c);
}
function $9839ee8e660104a4$export$82e9f45cca5ba907(n, c, s) {
    switch($9839ee8e660104a4$export$d6af199866bfb566(n, c)){
        case 5103:
            return $9839ee8e660104a4$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $9839ee8e660104a4$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $9839ee8e660104a4$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $9839ee8e660104a4$export$39dfd62a25e0fe93 + n + $9839ee8e660104a4$export$2c0f367103c8d01c + n + $9839ee8e660104a4$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($9839ee8e660104a4$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $9839ee8e660104a4$export$39dfd62a25e0fe93 + n + $9839ee8e660104a4$export$71ad59f2e432cfe8 + $9839ee8e660104a4$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $9839ee8e660104a4$export$39dfd62a25e0fe93 + n + $9839ee8e660104a4$export$71ad59f2e432cfe8 + $9839ee8e660104a4$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $9839ee8e660104a4$export$39dfd62a25e0fe93 + n + $9839ee8e660104a4$export$71ad59f2e432cfe8 + $9839ee8e660104a4$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $9839ee8e660104a4$export$39dfd62a25e0fe93 + n + $9839ee8e660104a4$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $9839ee8e660104a4$export$39dfd62a25e0fe93 + n + $9839ee8e660104a4$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $9839ee8e660104a4$export$39dfd62a25e0fe93 + n + $9839ee8e660104a4$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $9839ee8e660104a4$export$39dfd62a25e0fe93 + "box-$1$2" + $9839ee8e660104a4$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $9839ee8e660104a4$export$39dfd62a25e0fe93 + n + $9839ee8e660104a4$export$71ad59f2e432cfe8 + "flex-item-" + $9839ee8e660104a4$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$9839ee8e660104a4$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $9839ee8e660104a4$export$71ad59f2e432cfe8 + "grid-row-" + $9839ee8e660104a4$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $9839ee8e660104a4$export$39dfd62a25e0fe93 + n + $9839ee8e660104a4$export$71ad59f2e432cfe8 + "flex-line-pack" + $9839ee8e660104a4$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $9839ee8e660104a4$export$39dfd62a25e0fe93 + n + $9839ee8e660104a4$export$71ad59f2e432cfe8 + $9839ee8e660104a4$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $9839ee8e660104a4$export$39dfd62a25e0fe93 + n + $9839ee8e660104a4$export$71ad59f2e432cfe8 + $9839ee8e660104a4$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $9839ee8e660104a4$export$39dfd62a25e0fe93 + "box-" + $9839ee8e660104a4$export$77ad94ebf1c2b9ed(n, "-grow", "") + $9839ee8e660104a4$export$39dfd62a25e0fe93 + n + $9839ee8e660104a4$export$71ad59f2e432cfe8 + $9839ee8e660104a4$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $9839ee8e660104a4$export$39dfd62a25e0fe93 + $9839ee8e660104a4$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $9839ee8e660104a4$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $9839ee8e660104a4$export$77ad94ebf1c2b9ed($9839ee8e660104a4$export$77ad94ebf1c2b9ed($9839ee8e660104a4$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $9839ee8e660104a4$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $9839ee8e660104a4$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $9839ee8e660104a4$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $9839ee8e660104a4$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $9839ee8e660104a4$export$77ad94ebf1c2b9ed($9839ee8e660104a4$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $9839ee8e660104a4$export$39dfd62a25e0fe93 + "box-pack:$3" + $9839ee8e660104a4$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $9839ee8e660104a4$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$9839ee8e660104a4$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $9839ee8e660104a4$export$71ad59f2e432cfe8 + "grid-column-align" + $9839ee8e660104a4$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $9839ee8e660104a4$export$71ad59f2e432cfe8 + $9839ee8e660104a4$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $9839ee8e660104a4$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$9839ee8e660104a4$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $9839ee8e660104a4$export$71ad59f2e432cfe8 + $9839ee8e660104a4$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $9839ee8e660104a4$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$9839ee8e660104a4$export$f8e21b1e77979a08(s, "span") ? $9839ee8e660104a4$export$4659b591c19bdf3d(s, /\d+/) : +$9839ee8e660104a4$export$4659b591c19bdf3d(s, /\d+/) - +$9839ee8e660104a4$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $9839ee8e660104a4$export$71ad59f2e432cfe8 + $9839ee8e660104a4$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $9839ee8e660104a4$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $9839ee8e660104a4$export$71ad59f2e432cfe8 + $9839ee8e660104a4$export$77ad94ebf1c2b9ed($9839ee8e660104a4$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $9839ee8e660104a4$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $9839ee8e660104a4$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($9839ee8e660104a4$export$36776f635604f274(n) - 1 - c > 6) switch($9839ee8e660104a4$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($9839ee8e660104a4$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $9839ee8e660104a4$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $9839ee8e660104a4$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $9839ee8e660104a4$export$2c0f367103c8d01c + ($9839ee8e660104a4$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$9839ee8e660104a4$export$f8e21b1e77979a08(n, "stretch") ? $9839ee8e660104a4$export$82e9f45cca5ba907($9839ee8e660104a4$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $9839ee8e660104a4$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $9839ee8e660104a4$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $9839ee8e660104a4$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($9839ee8e660104a4$export$a9db5e087081082d(n, c + 6) === 121) return $9839ee8e660104a4$export$77ad94ebf1c2b9ed(n, ":", ":" + $9839ee8e660104a4$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($9839ee8e660104a4$export$a9db5e087081082d(n, $9839ee8e660104a4$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $9839ee8e660104a4$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $9839ee8e660104a4$export$39dfd62a25e0fe93 + ($9839ee8e660104a4$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $9839ee8e660104a4$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $9839ee8e660104a4$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $9839ee8e660104a4$export$77ad94ebf1c2b9ed(n, ":", ":" + $9839ee8e660104a4$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $9839ee8e660104a4$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $9839ee8e660104a4$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    for(var n = 0; n < e.length; n++)a += r(e[n], n, e, r) || "";
    return a;
}
function $9839ee8e660104a4$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $9839ee8e660104a4$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $9839ee8e660104a4$export$a763edbf796b780a:
        case $9839ee8e660104a4$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $9839ee8e660104a4$export$a29989082612d0d9:
            return "";
        case $9839ee8e660104a4$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $9839ee8e660104a4$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $9839ee8e660104a4$export$aa3a2e812ca8570d:
            if (!$9839ee8e660104a4$export$36776f635604f274(e.value = e.props.join(","))) return "";
    }
    return $9839ee8e660104a4$export$36776f635604f274(a = $9839ee8e660104a4$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $9839ee8e660104a4$export$5a7767152ae0305f(e) {
    var r = $9839ee8e660104a4$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $9839ee8e660104a4$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $9839ee8e660104a4$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $9839ee8e660104a4$export$527d108ccf083c2b:
                n.return = $9839ee8e660104a4$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $9839ee8e660104a4$export$b44a8529a35fcb60:
                return $9839ee8e660104a4$export$dfdc1655ccc5b9cb([
                    $9839ee8e660104a4$export$784d13d8ee351f07(n, {
                        value: $9839ee8e660104a4$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $9839ee8e660104a4$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $9839ee8e660104a4$export$aa3a2e812ca8570d:
                if (n.length) return $9839ee8e660104a4$export$1be1fc439b849fdf(u = n.props, function(c) {
                    switch($9839ee8e660104a4$export$4659b591c19bdf3d(c, i = /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            $9839ee8e660104a4$export$590e8b2c435046d9($9839ee8e660104a4$export$784d13d8ee351f07(n, {
                                props: [
                                    $9839ee8e660104a4$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $9839ee8e660104a4$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $9839ee8e660104a4$export$590e8b2c435046d9($9839ee8e660104a4$export$784d13d8ee351f07(n, {
                                props: [
                                    c
                                ]
                            }));
                            $9839ee8e660104a4$export$e6e34fd1f2686227(n, {
                                props: $9839ee8e660104a4$export$3dea766d36a8935f(u, i)
                            });
                            break;
                        case "::placeholder":
                            $9839ee8e660104a4$export$590e8b2c435046d9($9839ee8e660104a4$export$784d13d8ee351f07(n, {
                                props: [
                                    $9839ee8e660104a4$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $9839ee8e660104a4$export$39dfd62a25e0fe93 + "input-$1")
                                ]
                            }));
                            $9839ee8e660104a4$export$590e8b2c435046d9($9839ee8e660104a4$export$784d13d8ee351f07(n, {
                                props: [
                                    $9839ee8e660104a4$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $9839ee8e660104a4$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $9839ee8e660104a4$export$590e8b2c435046d9($9839ee8e660104a4$export$784d13d8ee351f07(n, {
                                props: [
                                    $9839ee8e660104a4$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $9839ee8e660104a4$export$71ad59f2e432cfe8 + "input-$1")
                                ]
                            }));
                            $9839ee8e660104a4$export$590e8b2c435046d9($9839ee8e660104a4$export$784d13d8ee351f07(n, {
                                props: [
                                    c
                                ]
                            }));
                            $9839ee8e660104a4$export$e6e34fd1f2686227(n, {
                                props: $9839ee8e660104a4$export$3dea766d36a8935f(u, i)
                            });
                            break;
                    }
                    return "";
                });
        }
    }
}
function $9839ee8e660104a4$export$76a88f7de6507443(e) {
    switch(e.type){
        case $9839ee8e660104a4$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $9839ee8e660104a4$export$1be1fc439b849fdf($9839ee8e660104a4$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($9839ee8e660104a4$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $9839ee8e660104a4$export$2f35ab04d2335697(r, 1, $9839ee8e660104a4$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $9839ee8e660104a4$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $9839ee8e660104a4$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $9839ee8e660104a4$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}


var $4b34b39cb95ff80d$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};


var $b25fa153619ca5c1$exports = {};
// shim for using process in browser
var $b25fa153619ca5c1$var$process = $b25fa153619ca5c1$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $b25fa153619ca5c1$var$cachedSetTimeout;
var $b25fa153619ca5c1$var$cachedClearTimeout;
function $b25fa153619ca5c1$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $b25fa153619ca5c1$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $b25fa153619ca5c1$var$cachedSetTimeout = setTimeout;
        else $b25fa153619ca5c1$var$cachedSetTimeout = $b25fa153619ca5c1$var$defaultSetTimout;
    } catch (e) {
        $b25fa153619ca5c1$var$cachedSetTimeout = $b25fa153619ca5c1$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $b25fa153619ca5c1$var$cachedClearTimeout = clearTimeout;
        else $b25fa153619ca5c1$var$cachedClearTimeout = $b25fa153619ca5c1$var$defaultClearTimeout;
    } catch (e) {
        $b25fa153619ca5c1$var$cachedClearTimeout = $b25fa153619ca5c1$var$defaultClearTimeout;
    }
})();
function $b25fa153619ca5c1$var$runTimeout(fun) {
    if ($b25fa153619ca5c1$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($b25fa153619ca5c1$var$cachedSetTimeout === $b25fa153619ca5c1$var$defaultSetTimout || !$b25fa153619ca5c1$var$cachedSetTimeout) && setTimeout) {
        $b25fa153619ca5c1$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $b25fa153619ca5c1$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $b25fa153619ca5c1$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $b25fa153619ca5c1$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $b25fa153619ca5c1$var$runClearTimeout(marker) {
    if ($b25fa153619ca5c1$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($b25fa153619ca5c1$var$cachedClearTimeout === $b25fa153619ca5c1$var$defaultClearTimeout || !$b25fa153619ca5c1$var$cachedClearTimeout) && clearTimeout) {
        $b25fa153619ca5c1$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $b25fa153619ca5c1$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $b25fa153619ca5c1$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $b25fa153619ca5c1$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $b25fa153619ca5c1$var$queue = [];
var $b25fa153619ca5c1$var$draining = false;
var $b25fa153619ca5c1$var$currentQueue;
var $b25fa153619ca5c1$var$queueIndex = -1;
function $b25fa153619ca5c1$var$cleanUpNextTick() {
    if (!$b25fa153619ca5c1$var$draining || !$b25fa153619ca5c1$var$currentQueue) return;
    $b25fa153619ca5c1$var$draining = false;
    if ($b25fa153619ca5c1$var$currentQueue.length) $b25fa153619ca5c1$var$queue = $b25fa153619ca5c1$var$currentQueue.concat($b25fa153619ca5c1$var$queue);
    else $b25fa153619ca5c1$var$queueIndex = -1;
    if ($b25fa153619ca5c1$var$queue.length) $b25fa153619ca5c1$var$drainQueue();
}
function $b25fa153619ca5c1$var$drainQueue() {
    if ($b25fa153619ca5c1$var$draining) return;
    var timeout = $b25fa153619ca5c1$var$runTimeout($b25fa153619ca5c1$var$cleanUpNextTick);
    $b25fa153619ca5c1$var$draining = true;
    var len = $b25fa153619ca5c1$var$queue.length;
    while(len){
        $b25fa153619ca5c1$var$currentQueue = $b25fa153619ca5c1$var$queue;
        $b25fa153619ca5c1$var$queue = [];
        while(++$b25fa153619ca5c1$var$queueIndex < len)if ($b25fa153619ca5c1$var$currentQueue) $b25fa153619ca5c1$var$currentQueue[$b25fa153619ca5c1$var$queueIndex].run();
        $b25fa153619ca5c1$var$queueIndex = -1;
        len = $b25fa153619ca5c1$var$queue.length;
    }
    $b25fa153619ca5c1$var$currentQueue = null;
    $b25fa153619ca5c1$var$draining = false;
    $b25fa153619ca5c1$var$runClearTimeout(timeout);
}
$b25fa153619ca5c1$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $b25fa153619ca5c1$var$queue.push(new $b25fa153619ca5c1$var$Item(fun, args));
    if ($b25fa153619ca5c1$var$queue.length === 1 && !$b25fa153619ca5c1$var$draining) $b25fa153619ca5c1$var$runTimeout($b25fa153619ca5c1$var$drainQueue);
};
// v8 likes predictible objects
function $b25fa153619ca5c1$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$b25fa153619ca5c1$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$b25fa153619ca5c1$var$process.title = "browser";
$b25fa153619ca5c1$var$process.browser = true;
$b25fa153619ca5c1$var$process.env = {};
$b25fa153619ca5c1$var$process.argv = [];
$b25fa153619ca5c1$var$process.version = ""; // empty string to avoid regexp issues
$b25fa153619ca5c1$var$process.versions = {};
function $b25fa153619ca5c1$var$noop() {}
$b25fa153619ca5c1$var$process.on = $b25fa153619ca5c1$var$noop;
$b25fa153619ca5c1$var$process.addListener = $b25fa153619ca5c1$var$noop;
$b25fa153619ca5c1$var$process.once = $b25fa153619ca5c1$var$noop;
$b25fa153619ca5c1$var$process.off = $b25fa153619ca5c1$var$noop;
$b25fa153619ca5c1$var$process.removeListener = $b25fa153619ca5c1$var$noop;
$b25fa153619ca5c1$var$process.removeAllListeners = $b25fa153619ca5c1$var$noop;
$b25fa153619ca5c1$var$process.emit = $b25fa153619ca5c1$var$noop;
$b25fa153619ca5c1$var$process.prependListener = $b25fa153619ca5c1$var$noop;
$b25fa153619ca5c1$var$process.prependOnceListener = $b25fa153619ca5c1$var$noop;
$b25fa153619ca5c1$var$process.listeners = function(name) {
    return [];
};
$b25fa153619ca5c1$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$b25fa153619ca5c1$var$process.cwd = function() {
    return "/";
};
$b25fa153619ca5c1$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$b25fa153619ca5c1$var$process.umask = function() {
    return 0;
};


var $6e03950c2a9b6039$var$f = ("undefined" != typeof $b25fa153619ca5c1$exports && void 0 !== $b25fa153619ca5c1$exports.env && undefined, "data-styled"), $6e03950c2a9b6039$var$m = "active", $6e03950c2a9b6039$var$y = "data-styled-version", $6e03950c2a9b6039$export$83d89fbfd8236492 = "6.0.9", $6e03950c2a9b6039$var$g = "/*!sc*/\n", $6e03950c2a9b6039$var$S = "undefined" != typeof window && "HTMLElement" in window, $6e03950c2a9b6039$var$w = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : ("undefined" != typeof $b25fa153619ca5c1$exports && $b25fa153619ca5c1$exports.env, "undefined" != typeof $b25fa153619ca5c1$exports && $b25fa153619ca5c1$exports.env, false)), $6e03950c2a9b6039$var$b = {}, $6e03950c2a9b6039$var$E = /invalid hook call/i, $6e03950c2a9b6039$var$N = new Set, $6e03950c2a9b6039$var$P = function(t, n) {
    var o, s, i, a, e;
}, $6e03950c2a9b6039$var$_ = Object.freeze([]), $6e03950c2a9b6039$var$C = Object.freeze({});
function $6e03950c2a9b6039$var$I(e, t, n) {
    return void 0 === n && (n = $6e03950c2a9b6039$var$C), e.theme !== n.theme && e.theme || t || n.theme;
}
var $6e03950c2a9b6039$var$A = new Set([
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "tr",
    "track",
    "u",
    "ul",
    "use",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
]), $6e03950c2a9b6039$var$O = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, $6e03950c2a9b6039$var$D = /(^-|-$)/g;
function $6e03950c2a9b6039$var$R(e) {
    return e.replace($6e03950c2a9b6039$var$O, "-").replace($6e03950c2a9b6039$var$D, "");
}
var $6e03950c2a9b6039$var$T = /(a)(d)/gi, $6e03950c2a9b6039$var$k = 52, $6e03950c2a9b6039$var$j = function(e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function $6e03950c2a9b6039$var$x(e) {
    var t, n = "";
    for(t = Math.abs(e); t > $6e03950c2a9b6039$var$k; t = t / $6e03950c2a9b6039$var$k | 0)n = $6e03950c2a9b6039$var$j(t % $6e03950c2a9b6039$var$k) + n;
    return ($6e03950c2a9b6039$var$j(t % $6e03950c2a9b6039$var$k) + n).replace($6e03950c2a9b6039$var$T, "$1-$2");
}
var $6e03950c2a9b6039$var$V, $6e03950c2a9b6039$var$F = 5381, $6e03950c2a9b6039$var$M = function(e, t) {
    for(var n = t.length; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, $6e03950c2a9b6039$var$$ = function(e) {
    return $6e03950c2a9b6039$var$M($6e03950c2a9b6039$var$F, e);
};
function $6e03950c2a9b6039$var$z(e) {
    return $6e03950c2a9b6039$var$x($6e03950c2a9b6039$var$$(e) >>> 0);
}
function $6e03950c2a9b6039$var$B(e) {
    return (0, e.displayName) || e.name || "Component";
}
function $6e03950c2a9b6039$var$L(e) {
    return "string" == typeof e && true;
}
var $6e03950c2a9b6039$var$G = "function" == typeof Symbol && Symbol.for, $6e03950c2a9b6039$var$Y = $6e03950c2a9b6039$var$G ? Symbol.for("react.memo") : 60115, $6e03950c2a9b6039$var$W = $6e03950c2a9b6039$var$G ? Symbol.for("react.forward_ref") : 60112, $6e03950c2a9b6039$var$q = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
}, $6e03950c2a9b6039$var$H = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
}, $6e03950c2a9b6039$var$U = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
}, $6e03950c2a9b6039$var$J = (($6e03950c2a9b6039$var$V = {})[$6e03950c2a9b6039$var$W] = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
}, $6e03950c2a9b6039$var$V[$6e03950c2a9b6039$var$Y] = $6e03950c2a9b6039$var$U, $6e03950c2a9b6039$var$V);
function $6e03950c2a9b6039$var$X(e) {
    var t;
    return ("type" in (t = e) && t.type.$$typeof) === $6e03950c2a9b6039$var$Y ? $6e03950c2a9b6039$var$U : "$$typeof" in e ? $6e03950c2a9b6039$var$J[e.$$typeof] : $6e03950c2a9b6039$var$q;
}
var $6e03950c2a9b6039$var$Z = Object.defineProperty, $6e03950c2a9b6039$var$K = Object.getOwnPropertyNames, $6e03950c2a9b6039$var$Q = Object.getOwnPropertySymbols, $6e03950c2a9b6039$var$ee = Object.getOwnPropertyDescriptor, $6e03950c2a9b6039$var$te = Object.getPrototypeOf, $6e03950c2a9b6039$var$ne = Object.prototype;
function $6e03950c2a9b6039$var$oe(e, t, n) {
    if ("string" != typeof t) {
        if ($6e03950c2a9b6039$var$ne) {
            var o = $6e03950c2a9b6039$var$te(t);
            o && o !== $6e03950c2a9b6039$var$ne && $6e03950c2a9b6039$var$oe(e, o, n);
        }
        var r = $6e03950c2a9b6039$var$K(t);
        $6e03950c2a9b6039$var$Q && (r = r.concat($6e03950c2a9b6039$var$Q(t)));
        for(var s = $6e03950c2a9b6039$var$X(e), i = $6e03950c2a9b6039$var$X(t), a = 0; a < r.length; ++a){
            var c = r[a];
            if (!(c in $6e03950c2a9b6039$var$H || n && n[c] || i && c in i || s && c in s)) {
                var l = $6e03950c2a9b6039$var$ee(t, c);
                try {
                    $6e03950c2a9b6039$var$Z(e, c, l);
                } catch (e) {}
            }
        }
    }
    return e;
}
function $6e03950c2a9b6039$var$re(e) {
    return "function" == typeof e;
}
function $6e03950c2a9b6039$export$7ba318d8d2f06c76(e) {
    return "object" == typeof e && "styledComponentId" in e;
}
function $6e03950c2a9b6039$var$ie(e, t) {
    return e && t ? "".concat(e, " ").concat(t) : e || t || "";
}
function $6e03950c2a9b6039$var$ae(e, t) {
    if (0 === e.length) return "";
    for(var n = e[0], o = 1; o < e.length; o++)n += t ? t + e[o] : e[o];
    return n;
}
function $6e03950c2a9b6039$var$ce(e) {
    return null !== e && "object" == typeof e && e.constructor.name === Object.name && !("props" in e && e.$$typeof);
}
function $6e03950c2a9b6039$var$le(e, t, n) {
    if (void 0 === n && (n = !1), !n && !$6e03950c2a9b6039$var$ce(e) && !Array.isArray(e)) return t;
    if (Array.isArray(t)) for(var o = 0; o < t.length; o++)e[o] = $6e03950c2a9b6039$var$le(e[o], t[o]);
    else if ($6e03950c2a9b6039$var$ce(t)) for(var o in t)e[o] = $6e03950c2a9b6039$var$le(e[o], t[o]);
    return e;
}
function $6e03950c2a9b6039$var$ue(e, t) {
    Object.defineProperty(e, "toString", {
        value: t
    });
}
var $6e03950c2a9b6039$var$pe = {};
function $6e03950c2a9b6039$var$de() {
    for(var e = [], t = 0; t < arguments.length; t++)e[t] = arguments[t];
    for(var n = e[0], o = [], r = 1, s = e.length; r < s; r += 1)o.push(e[r]);
    return o.forEach(function(e) {
        n = n.replace(/%[a-z]/, e);
    }), n;
}
function $6e03950c2a9b6039$var$he(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    return new Error("An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#".concat(t, " for more information.").concat(n.length > 0 ? " Args: ".concat(n.join(", ")) : ""));
}
var $6e03950c2a9b6039$var$fe = function() {
    function e(e) {
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    return e.prototype.indexOfGroup = function(e) {
        for(var t = 0, n = 0; n < e; n++)t += this.groupSizes[n];
        return t;
    }, e.prototype.insertRules = function(e, t) {
        if (e >= this.groupSizes.length) {
            for(var n = this.groupSizes, o = n.length, r = o; e >= r;)if ((r <<= 1) < 0) throw $6e03950c2a9b6039$var$he(16, "".concat(e));
            this.groupSizes = new Uint32Array(r), this.groupSizes.set(n), this.length = r;
            for(var s = o; s < r; s++)this.groupSizes[s] = 0;
        }
        for(var i = this.indexOfGroup(e + 1), a = (s = 0, t.length); s < a; s++)this.tag.insertRule(i, t[s]) && (this.groupSizes[e]++, i++);
    }, e.prototype.clearGroup = function(e) {
        if (e < this.length) {
            var t = this.groupSizes[e], n = this.indexOfGroup(e), o = n + t;
            this.groupSizes[e] = 0;
            for(var r = n; r < o; r++)this.tag.deleteRule(n);
        }
    }, e.prototype.getGroup = function(e) {
        var t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        for(var n = this.groupSizes[e], o = this.indexOfGroup(e), r = o + n, s = o; s < r; s++)t += "".concat(this.tag.getRule(s)).concat($6e03950c2a9b6039$var$g);
        return t;
    }, e;
}(), $6e03950c2a9b6039$var$me = new Map, $6e03950c2a9b6039$var$ye = new Map, $6e03950c2a9b6039$var$ve = 1, $6e03950c2a9b6039$var$ge = function(e) {
    if ($6e03950c2a9b6039$var$me.has(e)) return $6e03950c2a9b6039$var$me.get(e);
    for(; $6e03950c2a9b6039$var$ye.has($6e03950c2a9b6039$var$ve);)$6e03950c2a9b6039$var$ve++;
    var t = $6e03950c2a9b6039$var$ve++;
    return $6e03950c2a9b6039$var$me.set(e, t), $6e03950c2a9b6039$var$ye.set(t, e), t;
}, $6e03950c2a9b6039$var$Se = function(e, t) {
    $6e03950c2a9b6039$var$me.set(e, t), $6e03950c2a9b6039$var$ye.set(t, e);
}, $6e03950c2a9b6039$var$we = "style[".concat($6e03950c2a9b6039$var$f, "][").concat($6e03950c2a9b6039$var$y, '="').concat($6e03950c2a9b6039$export$83d89fbfd8236492, '"]'), $6e03950c2a9b6039$var$be = new RegExp("^".concat($6e03950c2a9b6039$var$f, '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)')), $6e03950c2a9b6039$var$Ee = function(e, t, n) {
    for(var o, r = n.split(","), s = 0, i = r.length; s < i; s++)(o = r[s]) && e.registerName(t, o);
}, $6e03950c2a9b6039$var$Ne = function(e, t) {
    for(var n, o = (null !== (n = t.textContent) && void 0 !== n ? n : "").split($6e03950c2a9b6039$var$g), r = [], s = 0, i = o.length; s < i; s++){
        var a = o[s].trim();
        if (a) {
            var c = a.match($6e03950c2a9b6039$var$be);
            if (c) {
                var l = 0 | parseInt(c[1], 10), u = c[2];
                0 !== l && ($6e03950c2a9b6039$var$Se(u, l), $6e03950c2a9b6039$var$Ee(e, u, c[3]), e.getTag().insertRules(l, r)), r.length = 0;
            } else r.push(a);
        }
    }
};
function $6e03950c2a9b6039$var$Pe() {
    return "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : null;
}
var $6e03950c2a9b6039$var$_e = function(e) {
    var t = document.head, n = e || t, o = document.createElement("style"), r = function(e) {
        var t = Array.from(e.querySelectorAll("style[".concat($6e03950c2a9b6039$var$f, "]")));
        return t[t.length - 1];
    }(n), s = void 0 !== r ? r.nextSibling : null;
    o.setAttribute($6e03950c2a9b6039$var$f, $6e03950c2a9b6039$var$m), o.setAttribute($6e03950c2a9b6039$var$y, $6e03950c2a9b6039$export$83d89fbfd8236492);
    var i = $6e03950c2a9b6039$var$Pe();
    return i && o.setAttribute("nonce", i), n.insertBefore(o, s), o;
}, $6e03950c2a9b6039$var$Ce = function() {
    function e(e) {
        this.element = $6e03950c2a9b6039$var$_e(e), this.element.appendChild(document.createTextNode("")), this.sheet = function(e) {
            if (e.sheet) return e.sheet;
            for(var t = document.styleSheets, n = 0, o = t.length; n < o; n++){
                var r = t[n];
                if (r.ownerNode === e) return r;
            }
            throw $6e03950c2a9b6039$var$he(17);
        }(this.element), this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }, e.prototype.deleteRule = function(e) {
        this.sheet.deleteRule(e), this.length--;
    }, e.prototype.getRule = function(e) {
        var t = this.sheet.cssRules[e];
        return t && t.cssText ? t.cssText : "";
    }, e;
}(), $6e03950c2a9b6039$var$Ie = function() {
    function e(e) {
        this.element = $6e03950c2a9b6039$var$_e(e), this.nodes = this.element.childNodes, this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        if (e <= this.length && e >= 0) {
            var n = document.createTextNode(t);
            return this.element.insertBefore(n, this.nodes[e] || null), this.length++, !0;
        }
        return !1;
    }, e.prototype.deleteRule = function(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }, e;
}(), $6e03950c2a9b6039$var$Ae = function() {
    function e(e) {
        this.rules = [], this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
    }, e.prototype.deleteRule = function(e) {
        this.rules.splice(e, 1), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.rules[e] : "";
    }, e;
}(), $6e03950c2a9b6039$var$Oe = $6e03950c2a9b6039$var$S, $6e03950c2a9b6039$var$De = {
    isServer: !$6e03950c2a9b6039$var$S,
    useCSSOMInjection: !$6e03950c2a9b6039$var$w
}, $6e03950c2a9b6039$var$Re = function() {
    function e(e, n, o) {
        void 0 === e && (e = $6e03950c2a9b6039$var$C), void 0 === n && (n = {});
        var r = this;
        this.options = (0, $2b0605493dba51bd$export$18ce0697a983be9b)((0, $2b0605493dba51bd$export$18ce0697a983be9b)({}, $6e03950c2a9b6039$var$De), e), this.gs = n, this.names = new Map(o), this.server = !!e.isServer, !this.server && $6e03950c2a9b6039$var$S && $6e03950c2a9b6039$var$Oe && ($6e03950c2a9b6039$var$Oe = !1, function(e) {
            for(var t = document.querySelectorAll($6e03950c2a9b6039$var$we), n = 0, o = t.length; n < o; n++){
                var r = t[n];
                r && r.getAttribute($6e03950c2a9b6039$var$f) !== $6e03950c2a9b6039$var$m && ($6e03950c2a9b6039$var$Ne(e, r), r.parentNode && r.parentNode.removeChild(r));
            }
        }(this)), $6e03950c2a9b6039$var$ue(this, function() {
            return function(e) {
                for(var t = e.getTag(), n = t.length, o = "", r = function(n) {
                    var r = function(e) {
                        return $6e03950c2a9b6039$var$ye.get(e);
                    }(n);
                    if (void 0 === r) return "continue";
                    var s = e.names.get(r), i = t.getGroup(n);
                    if (void 0 === s || 0 === i.length) return "continue";
                    var a = "".concat($6e03950c2a9b6039$var$f, ".g").concat(n, '[id="').concat(r, '"]'), c = "";
                    void 0 !== s && s.forEach(function(e) {
                        e.length > 0 && (c += "".concat(e, ","));
                    }), o += "".concat(i).concat(a, '{content:"').concat(c, '"}').concat($6e03950c2a9b6039$var$g);
                }, s = 0; s < n; s++)r(s);
                return o;
            }(r);
        });
    }
    return e.registerId = function(e) {
        return $6e03950c2a9b6039$var$ge(e);
    }, e.prototype.reconstructWithOptions = function(n, o) {
        return void 0 === o && (o = !0), new e((0, $2b0605493dba51bd$export$18ce0697a983be9b)((0, $2b0605493dba51bd$export$18ce0697a983be9b)({}, this.options), n), this.gs, o && this.names || void 0);
    }, e.prototype.allocateGSInstance = function(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }, e.prototype.getTag = function() {
        var e;
        return this.tag || (this.tag = (e = function(e) {
            var t = e.useCSSOMInjection, n = e.target;
            return e.isServer ? new $6e03950c2a9b6039$var$Ae(n) : t ? new $6e03950c2a9b6039$var$Ce(n) : new $6e03950c2a9b6039$var$Ie(n);
        }(this.options), new $6e03950c2a9b6039$var$fe(e)));
    }, e.prototype.hasNameForId = function(e, t) {
        return this.names.has(e) && this.names.get(e).has(t);
    }, e.prototype.registerName = function(e, t) {
        if ($6e03950c2a9b6039$var$ge(e), this.names.has(e)) this.names.get(e).add(t);
        else {
            var n = new Set;
            n.add(t), this.names.set(e, n);
        }
    }, e.prototype.insertRules = function(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules($6e03950c2a9b6039$var$ge(e), n);
    }, e.prototype.clearNames = function(e) {
        this.names.has(e) && this.names.get(e).clear();
    }, e.prototype.clearRules = function(e) {
        this.getTag().clearGroup($6e03950c2a9b6039$var$ge(e)), this.clearNames(e);
    }, e.prototype.clearTag = function() {
        this.tag = void 0;
    }, e;
}(), $6e03950c2a9b6039$var$Te = /&/g, $6e03950c2a9b6039$var$ke = /^\s*\/\/.*$/gm;
function $6e03950c2a9b6039$var$je(e, t) {
    return e.map(function(e) {
        return "rule" === e.type && (e.value = "".concat(t, " ").concat(e.value), e.value = e.value.replaceAll(",", ",".concat(t, " ")), e.props = e.props.map(function(e) {
            return "".concat(t, " ").concat(e);
        })), Array.isArray(e.children) && "@keyframes" !== e.type && (e.children = $6e03950c2a9b6039$var$je(e.children, t)), e;
    });
}
function $6e03950c2a9b6039$var$xe(e) {
    var t, n, o, r = void 0 === e ? $6e03950c2a9b6039$var$C : e, s = r.options, i = void 0 === s ? $6e03950c2a9b6039$var$C : s, a = r.plugins, c = void 0 === a ? $6e03950c2a9b6039$var$_ : a, l = function(e, o, r) {
        return r === n || r.startsWith(n) && r.endsWith(n) && r.replaceAll(n, "").length > 0 ? ".".concat(t) : e;
    }, u = c.slice();
    u.push(function(e) {
        e.type === $9839ee8e660104a4$export$aa3a2e812ca8570d && e.value.includes("&") && (e.props[0] = e.props[0].replace($6e03950c2a9b6039$var$Te, n).replace(o, l));
    }), i.prefix && u.push($9839ee8e660104a4$export$e08c7d021b829b7a), u.push($9839ee8e660104a4$export$fac44ee5b035f737);
    var p = function(e, r, s, a) {
        void 0 === r && (r = ""), void 0 === s && (s = ""), void 0 === a && (a = "&"), t = a, n = r, o = new RegExp("\\".concat(n, "\\b"), "g");
        var c = e.replace($6e03950c2a9b6039$var$ke, ""), l = $9839ee8e660104a4$export$ef7acd7185315e22(s || r ? "".concat(s, " ").concat(r, " { ").concat(c, " }") : c);
        i.namespace && (l = $6e03950c2a9b6039$var$je(l, i.namespace));
        var p = [];
        return $9839ee8e660104a4$export$dfdc1655ccc5b9cb(l, $9839ee8e660104a4$export$5a7767152ae0305f(u.concat($9839ee8e660104a4$export$38bcb760f1d4871c(function(e) {
            return p.push(e);
        })))), p;
    };
    return p.hash = c.length ? c.reduce(function(e, t) {
        return t.name || $6e03950c2a9b6039$var$he(15), $6e03950c2a9b6039$var$M(e, t.name);
    }, $6e03950c2a9b6039$var$F).toString() : "", p;
}
var $6e03950c2a9b6039$var$Ve = new $6e03950c2a9b6039$var$Re, $6e03950c2a9b6039$var$Fe = $6e03950c2a9b6039$var$xe(), $6e03950c2a9b6039$export$8c190ef828af4c86 = (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).createContext({
    shouldForwardProp: void 0,
    styleSheet: $6e03950c2a9b6039$var$Ve,
    stylis: $6e03950c2a9b6039$var$Fe
}), $6e03950c2a9b6039$export$91317688fc694efa = $6e03950c2a9b6039$export$8c190ef828af4c86.Consumer, $6e03950c2a9b6039$var$ze = (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).createContext(void 0);
function $6e03950c2a9b6039$var$Be() {
    return (0, $aivMx.useContext)($6e03950c2a9b6039$export$8c190ef828af4c86);
}
function $6e03950c2a9b6039$export$a473771da2f0ff7c(e) {
    var t = (0, $aivMx.useState)(e.stylisPlugins), n = t[0], r = t[1], c = $6e03950c2a9b6039$var$Be().styleSheet, l = (0, $aivMx.useMemo)(function() {
        var t = c;
        return e.sheet ? t = e.sheet : e.target && (t = t.reconstructWithOptions({
            target: e.target
        }, !1)), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
            useCSSOMInjection: !1
        })), t;
    }, [
        e.disableCSSOMInjection,
        e.sheet,
        e.target,
        c
    ]), u = (0, $aivMx.useMemo)(function() {
        return $6e03950c2a9b6039$var$xe({
            options: {
                namespace: e.namespace,
                prefix: e.enableVendorPrefixes
            },
            plugins: n
        });
    }, [
        e.enableVendorPrefixes,
        e.namespace,
        n
    ]);
    (0, $aivMx.useEffect)(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($a69eca18a69a3816$exports)))(n, e.stylisPlugins) || r(e.stylisPlugins);
    }, [
        e.stylisPlugins
    ]);
    var d = (0, $aivMx.useMemo)(function() {
        return {
            shouldForwardProp: e.shouldForwardProp,
            styleSheet: l,
            stylis: u
        };
    }, [
        e.shouldForwardProp,
        l,
        u
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).createElement($6e03950c2a9b6039$export$8c190ef828af4c86.Provider, {
        value: d
    }, (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).createElement($6e03950c2a9b6039$var$ze.Provider, {
        value: u
    }, e.children));
}
var $6e03950c2a9b6039$var$Ge = function() {
    function e(e, t) {
        var n = this;
        this.inject = function(e, t) {
            void 0 === t && (t = $6e03950c2a9b6039$var$Fe);
            var o = n.name + t.hash;
            e.hasNameForId(n.id, o) || e.insertRules(n.id, o, t(n.rules, o, "@keyframes"));
        }, this.name = e, this.id = "sc-keyframes-".concat(e), this.rules = t, $6e03950c2a9b6039$var$ue(this, function() {
            throw $6e03950c2a9b6039$var$he(12, String(n.name));
        });
    }
    return e.prototype.getName = function(e) {
        return void 0 === e && (e = $6e03950c2a9b6039$var$Fe), this.name + e.hash;
    }, e;
}(), $6e03950c2a9b6039$var$Ye = function(e) {
    return e >= "A" && e <= "Z";
};
function $6e03950c2a9b6039$var$We(e) {
    for(var t = "", n = 0; n < e.length; n++){
        var o = e[n];
        if (1 === n && "-" === o && "-" === e[0]) return e;
        $6e03950c2a9b6039$var$Ye(o) ? t += "-" + o.toLowerCase() : t += o;
    }
    return t.startsWith("ms-") ? "-" + t : t;
}
var $6e03950c2a9b6039$var$qe = function(e) {
    return null == e || !1 === e || "" === e;
}, $6e03950c2a9b6039$var$He = function(t) {
    var n, o, r = [];
    for(var s in t){
        var i = t[s];
        t.hasOwnProperty(s) && !$6e03950c2a9b6039$var$qe(i) && (Array.isArray(i) && i.isCss || $6e03950c2a9b6039$var$re(i) ? r.push("".concat($6e03950c2a9b6039$var$We(s), ":"), i, ";") : $6e03950c2a9b6039$var$ce(i) ? r.push.apply(r, (0, $2b0605493dba51bd$export$1216008129fb82ed)((0, $2b0605493dba51bd$export$1216008129fb82ed)([
            "".concat(s, " {")
        ], $6e03950c2a9b6039$var$He(i), !1), [
            "}"
        ], !1)) : r.push("".concat($6e03950c2a9b6039$var$We(s), ": ").concat((n = s, null == (o = i) || "boolean" == typeof o || "" === o ? "" : "number" != typeof o || 0 === o || n in (0, $4b34b39cb95ff80d$export$2e2bcd8739ae039) || n.startsWith("--") ? String(o).trim() : "".concat(o, "px")), ";")));
    }
    return r;
};
function $6e03950c2a9b6039$var$Ue(e, t, n, o) {
    if ($6e03950c2a9b6039$var$qe(e)) return [];
    if ($6e03950c2a9b6039$export$7ba318d8d2f06c76(e)) return [
        ".".concat(e.styledComponentId)
    ];
    if ($6e03950c2a9b6039$var$re(e)) {
        if (!$6e03950c2a9b6039$var$re(s = e) || s.prototype && s.prototype.isReactComponent || !t) return [
            e
        ];
        var r = e(t);
        return $6e03950c2a9b6039$var$Ue(r, t, n, o);
    }
    var s;
    return e instanceof $6e03950c2a9b6039$var$Ge ? n ? (e.inject(n, o), [
        e.getName(o)
    ]) : [
        e
    ] : $6e03950c2a9b6039$var$ce(e) ? $6e03950c2a9b6039$var$He(e) : Array.isArray(e) ? Array.prototype.concat.apply($6e03950c2a9b6039$var$_, e.map(function(e) {
        return $6e03950c2a9b6039$var$Ue(e, t, n, o);
    })) : [
        e.toString()
    ];
}
function $6e03950c2a9b6039$var$Je(e) {
    for(var t = 0; t < e.length; t += 1){
        var n = e[t];
        if ($6e03950c2a9b6039$var$re(n) && !$6e03950c2a9b6039$export$7ba318d8d2f06c76(n)) return !1;
    }
    return !0;
}
var $6e03950c2a9b6039$var$Xe = $6e03950c2a9b6039$var$$($6e03950c2a9b6039$export$83d89fbfd8236492), $6e03950c2a9b6039$var$Ze = function() {
    function e(e, t, n) {
        this.rules = e, this.staticRulesId = "", this.isStatic = (void 0 === n || n.isStatic) && $6e03950c2a9b6039$var$Je(e), this.componentId = t, this.baseHash = $6e03950c2a9b6039$var$M($6e03950c2a9b6039$var$Xe, t), this.baseStyle = n, $6e03950c2a9b6039$var$Re.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function(e, t, n) {
        var o = this.baseStyle ? this.baseStyle.generateAndInjectStyles(e, t, n) : "";
        if (this.isStatic && !n.hash) {
            if (this.staticRulesId && t.hasNameForId(this.componentId, this.staticRulesId)) o = $6e03950c2a9b6039$var$ie(o, this.staticRulesId);
            else {
                var r = $6e03950c2a9b6039$var$ae($6e03950c2a9b6039$var$Ue(this.rules, e, t, n)), s = $6e03950c2a9b6039$var$x($6e03950c2a9b6039$var$M(this.baseHash, r) >>> 0);
                if (!t.hasNameForId(this.componentId, s)) {
                    var i = n(r, ".".concat(s), void 0, this.componentId);
                    t.insertRules(this.componentId, s, i);
                }
                o = $6e03950c2a9b6039$var$ie(o, s), this.staticRulesId = s;
            }
        } else {
            for(var a = $6e03950c2a9b6039$var$M(this.baseHash, n.hash), c = "", l = 0; l < this.rules.length; l++){
                var u = this.rules[l];
                if ("string" == typeof u) c += u;
                else if (u) {
                    var p = $6e03950c2a9b6039$var$ae($6e03950c2a9b6039$var$Ue(u, e, t, n));
                    a = $6e03950c2a9b6039$var$M(a, p + l), c += p;
                }
            }
            if (c) {
                var d = $6e03950c2a9b6039$var$x(a >>> 0);
                t.hasNameForId(this.componentId, d) || t.insertRules(this.componentId, d, n(c, ".".concat(d), void 0, this.componentId)), o = $6e03950c2a9b6039$var$ie(o, d);
            }
        }
        return o;
    }, e;
}(), $6e03950c2a9b6039$export$2c657da244d00bd6 = (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).createContext(void 0), $6e03950c2a9b6039$export$b631efc24e9d5e2f = $6e03950c2a9b6039$export$2c657da244d00bd6.Consumer;
function $6e03950c2a9b6039$export$93d4e7f90805808f() {
    var e = (0, $aivMx.useContext)($6e03950c2a9b6039$export$2c657da244d00bd6);
    if (!e) throw $6e03950c2a9b6039$var$he(18);
    return e;
}
function $6e03950c2a9b6039$export$d8964aec282183a3(e) {
    var n = (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).useContext($6e03950c2a9b6039$export$2c657da244d00bd6), r = (0, $aivMx.useMemo)(function() {
        return function(e, n) {
            if (!e) throw $6e03950c2a9b6039$var$he(14);
            if ($6e03950c2a9b6039$var$re(e)) {
                var o = e(n);
                return o;
            }
            if (Array.isArray(e) || "object" != typeof e) throw $6e03950c2a9b6039$var$he(8);
            return n ? (0, $2b0605493dba51bd$export$18ce0697a983be9b)((0, $2b0605493dba51bd$export$18ce0697a983be9b)({}, n), e) : e;
        }(e.theme, n);
    }, [
        e.theme,
        n
    ]);
    return e.children ? (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).createElement($6e03950c2a9b6039$export$2c657da244d00bd6.Provider, {
        value: r
    }, e.children) : null;
}
var $6e03950c2a9b6039$var$nt = {}, $6e03950c2a9b6039$var$ot = new Set;
function $6e03950c2a9b6039$var$rt(e, r, s) {
    var i = $6e03950c2a9b6039$export$7ba318d8d2f06c76(e), a = e, c = !$6e03950c2a9b6039$var$L(e), p = r.attrs, d = void 0 === p ? $6e03950c2a9b6039$var$_ : p, h = r.componentId, f = void 0 === h ? function(e, t) {
        var n = "string" != typeof e ? "sc" : $6e03950c2a9b6039$var$R(e);
        $6e03950c2a9b6039$var$nt[n] = ($6e03950c2a9b6039$var$nt[n] || 0) + 1;
        var o = "".concat(n, "-").concat($6e03950c2a9b6039$var$z($6e03950c2a9b6039$export$83d89fbfd8236492 + n + $6e03950c2a9b6039$var$nt[n]));
        return t ? "".concat(t, "-").concat(o) : o;
    }(r.displayName, r.parentComponentId) : h, m = r.displayName, y = void 0 === m ? function(e) {
        return $6e03950c2a9b6039$var$L(e) ? "styled.".concat(e) : "Styled(".concat($6e03950c2a9b6039$var$B(e), ")");
    }(e) : m, g = r.displayName && r.componentId ? "".concat($6e03950c2a9b6039$var$R(r.displayName), "-").concat(r.componentId) : r.componentId || f, S = i && a.attrs ? a.attrs.concat(d).filter(Boolean) : d, w = r.shouldForwardProp;
    if (i && a.shouldForwardProp) {
        var b = a.shouldForwardProp;
        if (r.shouldForwardProp) {
            var E = r.shouldForwardProp;
            w = function(e, t) {
                return b(e, t) && E(e, t);
            };
        } else w = b;
    }
    var N = new $6e03950c2a9b6039$var$Ze(s, g, i ? a.componentStyle : void 0);
    function O(e, r) {
        return function(e, r, s) {
            var i = e.attrs, a = e.componentStyle, c = e.defaultProps, p = e.foldedComponentIds, d = e.styledComponentId, h = e.target, f = (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).useContext($6e03950c2a9b6039$export$2c657da244d00bd6), m = $6e03950c2a9b6039$var$Be(), y = e.shouldForwardProp || m.shouldForwardProp;
            var v = function(e, n, o) {
                for(var r, s = (0, $2b0605493dba51bd$export$18ce0697a983be9b)((0, $2b0605493dba51bd$export$18ce0697a983be9b)({}, n), {
                    className: void 0,
                    theme: o
                }), i = 0; i < e.length; i += 1){
                    var a = $6e03950c2a9b6039$var$re(r = e[i]) ? r(s) : r;
                    for(var c in a)s[c] = "className" === c ? $6e03950c2a9b6039$var$ie(s[c], a[c]) : "style" === c ? (0, $2b0605493dba51bd$export$18ce0697a983be9b)((0, $2b0605493dba51bd$export$18ce0697a983be9b)({}, s[c]), a[c]) : a[c];
                }
                return n.className && (s.className = $6e03950c2a9b6039$var$ie(s.className, n.className)), s;
            }(i, r, $6e03950c2a9b6039$var$I(r, f, c) || $6e03950c2a9b6039$var$C), g = v.as || h, S = {};
            for(var w in v)void 0 === v[w] || "$" === w[0] || "as" === w || "theme" === w || ("forwardedAs" === w ? S.as = v.forwardedAs : y && !y(w, g) || (S[w] = v[w], y));
            var b = function(e, t) {
                var n = $6e03950c2a9b6039$var$Be(), o = e.generateAndInjectStyles(t, n.styleSheet, n.stylis);
                return o;
            }(a, v);
            var E = $6e03950c2a9b6039$var$ie(p, d);
            return b && (E += " " + b), v.className && (E += " " + v.className), S[$6e03950c2a9b6039$var$L(g) && !$6e03950c2a9b6039$var$A.has(g) ? "class" : "className"] = E, S.ref = s, (0, $aivMx.createElement)(g, S);
        }(D, e, r);
    }
    var D = (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).forwardRef(O);
    return D.attrs = S, D.componentStyle = N, D.shouldForwardProp = w, D.foldedComponentIds = i ? $6e03950c2a9b6039$var$ie(a.foldedComponentIds, a.styledComponentId) : "", D.styledComponentId = g, D.target = i ? a.target : e, Object.defineProperty(D, "defaultProps", {
        get: function() {
            return this._foldedDefaultProps;
        },
        set: function(e) {
            this._foldedDefaultProps = i ? function(e) {
                for(var t = [], n = 1; n < arguments.length; n++)t[n - 1] = arguments[n];
                for(var o = 0, r = t; o < r.length; o++)$6e03950c2a9b6039$var$le(e, r[o], !0);
                return e;
            }({}, a.defaultProps, e) : e;
        }
    }), $6e03950c2a9b6039$var$ue(D, function() {
        return ".".concat(D.styledComponentId);
    }), c && $6e03950c2a9b6039$var$oe(D, e, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0
    }), D;
}
function $6e03950c2a9b6039$var$st(e, t) {
    for(var n = [
        e[0]
    ], o = 0, r = t.length; o < r; o += 1)n.push(t[o], e[o + 1]);
    return n;
}
var $6e03950c2a9b6039$var$it = function(e) {
    return Object.assign(e, {
        isCss: !0
    });
};
function $6e03950c2a9b6039$export$dbf350e5966cf602(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    if ($6e03950c2a9b6039$var$re(t) || $6e03950c2a9b6039$var$ce(t)) return $6e03950c2a9b6039$var$it($6e03950c2a9b6039$var$Ue($6e03950c2a9b6039$var$st($6e03950c2a9b6039$var$_, (0, $2b0605493dba51bd$export$1216008129fb82ed)([
        t
    ], n, !0))));
    var r = t;
    return 0 === n.length && 1 === r.length && "string" == typeof r[0] ? $6e03950c2a9b6039$var$Ue(r) : $6e03950c2a9b6039$var$it($6e03950c2a9b6039$var$Ue($6e03950c2a9b6039$var$st(r, n)));
}
function $6e03950c2a9b6039$var$ct(n, o, r) {
    if (void 0 === r && (r = $6e03950c2a9b6039$var$C), !o) throw $6e03950c2a9b6039$var$he(1, o);
    var s = function(t) {
        for(var s = [], i = 1; i < arguments.length; i++)s[i - 1] = arguments[i];
        return n(o, r, $6e03950c2a9b6039$export$dbf350e5966cf602.apply(void 0, (0, $2b0605493dba51bd$export$1216008129fb82ed)([
            t
        ], s, !1)));
    };
    return s.attrs = function(e) {
        return $6e03950c2a9b6039$var$ct(n, o, (0, $2b0605493dba51bd$export$18ce0697a983be9b)((0, $2b0605493dba51bd$export$18ce0697a983be9b)({}, r), {
            attrs: Array.prototype.concat(r.attrs, e).filter(Boolean)
        }));
    }, s.withConfig = function(e) {
        return $6e03950c2a9b6039$var$ct(n, o, (0, $2b0605493dba51bd$export$18ce0697a983be9b)((0, $2b0605493dba51bd$export$18ce0697a983be9b)({}, r), e));
    }, s;
}
var $6e03950c2a9b6039$var$lt = function(e) {
    return $6e03950c2a9b6039$var$ct($6e03950c2a9b6039$var$rt, e);
}, $6e03950c2a9b6039$export$2e2bcd8739ae039 = $6e03950c2a9b6039$var$lt;
$6e03950c2a9b6039$var$A.forEach(function(e) {
    $6e03950c2a9b6039$export$2e2bcd8739ae039[e] = $6e03950c2a9b6039$var$lt(e);
});
var $6e03950c2a9b6039$var$pt = function() {
    function e(e, t) {
        this.rules = e, this.componentId = t, this.isStatic = $6e03950c2a9b6039$var$Je(e), $6e03950c2a9b6039$var$Re.registerId(this.componentId + 1);
    }
    return e.prototype.createStyles = function(e, t, n, o) {
        var r = o($6e03950c2a9b6039$var$ae($6e03950c2a9b6039$var$Ue(this.rules, t, n, o)), ""), s = this.componentId + e;
        n.insertRules(s, s, r);
    }, e.prototype.removeStyles = function(e, t) {
        t.clearRules(this.componentId + e);
    }, e.prototype.renderStyles = function(e, t, n, o) {
        e > 2 && $6e03950c2a9b6039$var$Re.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, o);
    }, e;
}();
function $6e03950c2a9b6039$export$f0f03736edb61697(n) {
    for(var r = [], s = 1; s < arguments.length; s++)r[s - 1] = arguments[s];
    var i = $6e03950c2a9b6039$export$dbf350e5966cf602.apply(void 0, (0, $2b0605493dba51bd$export$1216008129fb82ed)([
        n
    ], r, !1)), a = "sc-global-".concat($6e03950c2a9b6039$var$z(JSON.stringify(i))), c = new $6e03950c2a9b6039$var$pt(i, a);
    var l = function(e) {
        var t = $6e03950c2a9b6039$var$Be(), n = (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).useContext($6e03950c2a9b6039$export$2c657da244d00bd6), r = (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).useRef(t.styleSheet.allocateGSInstance(a)).current;
        return t.styleSheet.server && u(r, e, t.styleSheet, n, t.stylis), (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).useLayoutEffect(function() {
            if (!t.styleSheet.server) return u(r, e, t.styleSheet, n, t.stylis), function() {
                return c.removeStyles(r, t.styleSheet);
            };
        }, [
            r,
            e,
            t.styleSheet,
            n,
            t.stylis
        ]), null;
    };
    function u(e, n, o, r, s) {
        if (c.isStatic) c.renderStyles(e, $6e03950c2a9b6039$var$b, o, s);
        else {
            var i = (0, $2b0605493dba51bd$export$18ce0697a983be9b)((0, $2b0605493dba51bd$export$18ce0697a983be9b)({}, n), {
                theme: $6e03950c2a9b6039$var$I(n, r, l.defaultProps)
            });
            c.renderStyles(e, i, o, s);
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).memo(l);
}
function $6e03950c2a9b6039$export$d25ddfdf17c3ad3e(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    var r = $6e03950c2a9b6039$var$ae($6e03950c2a9b6039$export$dbf350e5966cf602.apply(void 0, (0, $2b0605493dba51bd$export$1216008129fb82ed)([
        t
    ], n, !1))), s = $6e03950c2a9b6039$var$z(r);
    return new $6e03950c2a9b6039$var$Ge(s, r);
}
function $6e03950c2a9b6039$export$e8748c6a27b910dc(e) {
    var n = (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).forwardRef(function(n, r) {
        var s = $6e03950c2a9b6039$var$I(n, (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).useContext($6e03950c2a9b6039$export$2c657da244d00bd6), e.defaultProps);
        return (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).createElement(e, (0, $2b0605493dba51bd$export$18ce0697a983be9b)({}, n, {
            theme: s,
            ref: r
        }));
    });
    return $6e03950c2a9b6039$var$oe(n, e);
}
var $6e03950c2a9b6039$export$ae8c7d15c8b89a20 = function() {
    function e() {
        var e = this;
        this._emitSheetCSS = function() {
            var t = e.instance.toString(), n = $6e03950c2a9b6039$var$Pe(), o = $6e03950c2a9b6039$var$ae([
                n && 'nonce="'.concat(n, '"'),
                "".concat($6e03950c2a9b6039$var$f, '="true"'),
                "".concat($6e03950c2a9b6039$var$y, '="').concat($6e03950c2a9b6039$export$83d89fbfd8236492, '"')
            ].filter(Boolean), " ");
            return "<style ".concat(o, ">").concat(t, "</style>");
        }, this.getStyleTags = function() {
            if (e.sealed) throw $6e03950c2a9b6039$var$he(2);
            return e._emitSheetCSS();
        }, this.getStyleElement = function() {
            var n;
            if (e.sealed) throw $6e03950c2a9b6039$var$he(2);
            var r = ((n = {})[$6e03950c2a9b6039$var$f] = "", n[$6e03950c2a9b6039$var$y] = $6e03950c2a9b6039$export$83d89fbfd8236492, n.dangerouslySetInnerHTML = {
                __html: e.instance.toString()
            }, n), s = $6e03950c2a9b6039$var$Pe();
            return s && (r.nonce = s), [
                (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).createElement("style", (0, $2b0605493dba51bd$export$18ce0697a983be9b)({}, r, {
                    key: "sc-0-0"
                }))
            ];
        }, this.seal = function() {
            e.sealed = !0;
        }, this.instance = new $6e03950c2a9b6039$var$Re({
            isServer: !0
        }), this.sealed = !1;
    }
    return e.prototype.collectStyles = function(e) {
        if (this.sealed) throw $6e03950c2a9b6039$var$he(2);
        return (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).createElement($6e03950c2a9b6039$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, e);
    }, e.prototype.interleaveWithNodeStream = function(e) {
        throw $6e03950c2a9b6039$var$he(3);
    }, e;
}(), $6e03950c2a9b6039$export$5c87cfe6c475f500 = {
    StyleSheet: $6e03950c2a9b6039$var$Re,
    mainSheet: $6e03950c2a9b6039$var$Ve
};
var $6e03950c2a9b6039$var$vt = "__sc-".concat($6e03950c2a9b6039$var$f, "__");




parcelRequire("aivMx");


/* eslint-disable @typescript-eslint/naming-convention */ /* eslint-disable no-nested-ternary */ /* eslint-disable no-restricted-syntax */ 

const $e0d24bf85c947bed$var$blockList = [
    "loading",
    "success",
    "error",
    "disabled"
];
function $e0d24bf85c947bed$var$getBackgroundImage(input) {
    if ((0, $7b0e169a5380005e$export$d673a9445babfbef)(input)) // If the input is a valid SVG, use it as a data URL
    return `url("data:image/svg+xml,${encodeURIComponent(input)}")`;
    else // If the input is not a valid SVG, assume it's a URL to an image
    return `url("${input}")`;
}
// Helper type guards
const $e0d24bf85c947bed$var$isBorderDirectional = (width)=>{
    return width?.type && [
        "top",
        "right",
        "bottom",
        "left"
    ].includes(width.type);
};
const $e0d24bf85c947bed$var$isBorderCustom = (width)=>{
    return width?.type === "custom" && Array.isArray(width.value);
};
const $e0d24bf85c947bed$var$generateGapStyles = (flex)=>{
    if (!flex?.gap) return {};
    // Handle single number or string value
    if (typeof flex.gap === "number") return {
        gap: `${flex.gap}px`
    };
    if (typeof flex.gap === "string") {
        // Split by space or comma and trim whitespace
        const values = flex.gap.split(/[\s,]+/).filter(Boolean).map((val)=>val.trim());
        // Process each value to ensure proper format
        const processedValues = values.map((val)=>{
            // If it's a pure number
            if (/^\d+$/.test(val)) return `${val}px`;
            // If it already has units (px, em, rem, etc.)
            if (/^\d+(?:px|em|rem|vh|vw|%)$/.test(val)) return val;
            // Invalid format
            return val;
        });
        // Return formatted gap value based on number of values
        if (processedValues.length === 1) return {
            gap: processedValues[0]
        };
        if (processedValues.length === 2) return {
            gap: processedValues.join(" ")
        };
        // If more than 2 values, only use the first two
        return {
            gap: `${processedValues[0]} ${processedValues[1]}`
        };
    }
    return {};
};
// Modified border width generation
const $e0d24bf85c947bed$var$generateBorderWidth = (border)=>{
    if (!border?.width) return {};
    if (typeof border.width === "string" || typeof border.width === "number") return {
        borderWidth: border.width
    };
    if (border.width === null) return {
        borderWidth: 0
    };
    if ($e0d24bf85c947bed$var$isBorderDirectional(border.width)) {
        const { type: type, value: value } = border.width;
        return {
            borderWidth: 0,
            [`border${type?.charAt(0).toUpperCase()}${type?.slice(1)}Width`]: value
        };
    }
    if ($e0d24bf85c947bed$var$isBorderCustom(border.width)) return {
        borderTopWidth: border.width.value[0],
        borderRightWidth: border.width.value[1],
        borderBottomWidth: border.width.value[2],
        borderLeftWidth: border.width.value[3]
    };
    return {};
};
const $e0d24bf85c947bed$var$generateBorderRadius = (border)=>{
    if (!border?.radius) return {};
    if (typeof border.radius === "string" || typeof border.radius === "number") return {
        borderRadius: border.radius
    };
    if (border.radius === null) return {
        borderRadius: 0
    };
    if ($e0d24bf85c947bed$var$isBorderCustom(border.radius)) return {
        borderTopLeftRadius: border.radius.value[0],
        borderTopRightRadius: border.radius.value[1],
        borderBottomRightRadius: border.radius.value[2],
        borderBottomLeftRadius: border.radius.value[3]
    };
    return {};
};
const $e0d24bf85c947bed$var$parseBackgroundSize = (url)=>{
    try {
        const baseUrl = window.location.origin; // Base URL for relative URLs
        const urlObj = new URL(url, baseUrl);
        const backgroundSize = urlObj.searchParams.get("backgroundSize");
        if (backgroundSize !== null) urlObj.searchParams.delete("backgroundSize");
        const resultUrl = url.startsWith("http") ? urlObj.toString() : urlObj.pathname + urlObj.search;
        return {
            url: resultUrl,
            backgroundSize: backgroundSize
        };
    } catch (e) {
        return {
            url: url,
            backgroundSize: null
        };
    }
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $e0d24bf85c947bed$var$filterUndefinedProperties = (obj)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const filteredObj = {}; // Add index signature
    const validNumberRegex = /^-?\d+(\.\d+)?$/; // Regular expression to match valid numbers
    for(const key in obj)if (obj[key] !== undefined) {
        let value = obj[key];
        if (typeof value === "string" && validNumberRegex.test(value)) value = parseFloat(value);
        filteredObj[key] = (0, $7b0e169a5380005e$export$aeecb75b7111fef7)(value);
    }
    return filteredObj;
};
function $e0d24bf85c947bed$var$getBackgroundProperties(shapes) {
    if (!shapes || shapes.length === 0 || !Array.isArray(shapes)) return {
        backgroundImage: undefined,
        backgroundPosition: undefined,
        backgroundSize: undefined,
        backgroundRepeat: undefined
    };
    const backgroundImages = [];
    const backgroundPositions = [];
    const backgroundSizes = [];
    const backgroundRepeats = [];
    shapes.filter((el)=>!((el.type === "image" || el.type === "gradient") && el.opacity === 0)).forEach((shape)=>{
        if (shape.value.startsWith("linear-gradient") || shape.value.startsWith("radial-gradient")) {
            backgroundImages.push(shape.value);
            backgroundPositions.push("center");
            backgroundSizes.push("cover");
            backgroundRepeats.push("no-repeat");
        } else if (shape.value.startsWith("http") || shape.value.startsWith("/")) {
            backgroundImages.push(`url(${$e0d24bf85c947bed$var$parseBackgroundSize(shape.value).url})`);
            backgroundPositions.push("center");
            backgroundSizes.push($e0d24bf85c947bed$var$parseBackgroundSize(shape.value).backgroundSize || "contain");
            backgroundRepeats.push("no-repeat");
        } else {
            const gradientValue = `linear-gradient(${shape.value}, ${shape.value})`;
            backgroundImages.push(gradientValue);
            backgroundPositions.push("center");
            backgroundSizes.push("cover");
            backgroundRepeats.push("no-repeat");
        }
    });
    return {
        backgroundImage: backgroundImages.reverse().join(", "),
        backgroundPosition: backgroundPositions.reverse().join(", "),
        backgroundSize: backgroundSizes.reverse().join(", "),
        backgroundRepeat: backgroundRepeats.reverse().join(", ")
    };
}
const $e0d24bf85c947bed$var$generateComponentStyles = (style, baseWidth, skipStates, parentDisplay)=>{
    if (!style) return null;
    const { font: font, align: align, height: height, width: width, max_width: max_width, min_width: min_width, max_height: max_height, min_height: min_height, margin: margin, padding: padding, grid: grid, border: border, position: position, z_index: z_index, user_select: user_select, scroll: scroll, cursor: cursor, breakpoints: breakpoints, states: states, display: display, flex: flex, box: box, background: background, left: left, bottom: bottom, top: top, right: right, object: object, transform: transform, placeholder: placeholder, opacity: opacity, visibility: visibilityParam } = style;
    const isFlexObject = flex && typeof flex !== "string";
    const isBorderObject = border && typeof border !== "string";
    const isPaddingArray = padding && Array.isArray(padding);
    const isMarginArray = margin && Array.isArray(margin);
    const isMarginObject = margin && typeof margin === "object" && !Array.isArray(margin);
    const isPaddingObject = padding && typeof padding === "object" && !Array.isArray(padding);
    // const backgroundShape = background?.[background.length - 1];
    const placeholderStyles = $e0d24bf85c947bed$var$filterUndefinedProperties({
        fontWeight: placeholder?.weight,
        fontStyle: placeholder?.style,
        fontSize: placeholder?.size,
        color: placeholder?.color,
        fontFamily: placeholder?.family,
        lineHeight: placeholder?.height,
        letterSpacing: placeholder?.letter_spacing,
        textDecoration: placeholder?.decoration,
        textTransform: placeholder?.transform
    });
    const componentStyles = $e0d24bf85c947bed$var$filterUndefinedProperties({
        textOverflow: font?.text_overflow,
        textTransform: font?.transform,
        whiteSpace: font?.text_overflow === "ellipsis" ? "nowrap" : font?.text_wrap,
        fontSize: font?.size,
        fontWeight: font?.weight,
        lineHeight: font?.height,
        letterSpacing: font?.letter_spacing,
        color: font?.color,
        fontFamily: font?.family,
        fontStyle: font?.style,
        textDecoration: font?.decoration,
        textAlign: align?.horizontal,
        verticalAlign: align?.vertical,
        gridAutoFlow: grid?.auto?.flow,
        gridAutoColumns: grid?.auto?.columns,
        gridAutoRows: grid?.auto?.rows,
        height: height,
        width: width,
        maxWidth: max_width || (typeof flex?.basis === "number" && width ? width : undefined),
        minWidth: min_width || (typeof flex?.basis === "number" && width ? width : undefined),
        maxHeight: max_height,
        minHeight: min_height,
        margin: isMarginArray ? (0, $7b0e169a5380005e$export$1d5a11bc88171059)(margin) : typeof margin === "string" ? margin : undefined,
        padding: isPaddingArray ? (0, $7b0e169a5380005e$export$1d5a11bc88171059)(padding) : typeof padding === "string" ? padding : undefined,
        display: visibilityParam && visibilityParam === "hidden" ? "none" : visibilityParam && visibilityParam === "visible" ? display || parentDisplay : display,
        alignItems: grid?.align_items || (isFlexObject ? flex.align_items : undefined),
        alignContent: isFlexObject ? flex.align_items : undefined,
        cursor: cursor,
        gridColumnStart: grid?.x ? `${grid.x}` : undefined,
        gridColumnEnd: grid?.cols ? `span ${grid?.cols}` : undefined,
        gridRowStart: grid?.y ? `${grid.y}` : undefined,
        gridRowEnd: grid?.rows ? `span ${grid?.rows}` : undefined,
        justifyItems: grid?.justify_items,
        justifyContent: grid?.justify_content || (isFlexObject ? flex.justify_content : undefined),
        ...$e0d24bf85c947bed$var$getBackgroundProperties(background),
        flexDirection: isFlexObject ? flex?.direction : undefined,
        flexShrink: isFlexObject ? flex?.shrink : undefined,
        flexGrow: isFlexObject ? flex?.grow : undefined,
        flexBasis: isFlexObject ? flex?.basis : undefined,
        flexWrap: isFlexObject ? flex?.wrap : undefined,
        ...$e0d24bf85c947bed$var$generateGapStyles(flex),
        // Modified
        ...isBorderObject ? $e0d24bf85c947bed$var$generateBorderWidth(border) : {},
        ...isBorderObject ? $e0d24bf85c947bed$var$generateBorderRadius(border) : {},
        borderStyle: isBorderObject ? border?.style : undefined,
        borderColor: isBorderObject ? border?.color : undefined,
        border: !isBorderObject ? border : undefined,
        position: position ? `${position} !important` : undefined,
        zIndex: z_index,
        overflow: scroll?.direction === "both" ? scroll?.type === "none" ? "auto" : scroll?.type || "auto" : font?.text_overflow === "ellipsis" ? "hidden" : undefined,
        overflowX: scroll?.direction === "x" || scroll?.direction === "both" ? scroll?.type || "auto" : display === "grid" ? "hidden" : flex?.direction === "row" ? scroll?.type === "none" ? "auto" : scroll?.type || "hidden" : "hidden",
        overflowY: scroll?.direction === "y" || scroll?.direction === "both" ? scroll?.type || "auto" : display === "grid" ? scroll?.type === "none" ? "auto" : scroll?.type || "hidden" : flex?.direction === "column" ? scroll?.type === "none" ? "auto" : scroll?.type || "hidden" : "hidden",
        scrollSnapType: scroll?.snap ? "both mandatory" : undefined,
        boxShadow: box?.shadow ? box?.shadow : undefined,
        boxSizing: box?.sizing ? box?.sizing : "border-box",
        objectFit: object?.fit,
        objectPosition: object?.position,
        userSelect: user_select,
        left: left,
        bottom: bottom,
        top: top,
        right: right,
        transform: transform,
        opacity: opacity,
        scrollbarWidth: scroll?.type === "none" ? "none" : undefined
    });
    if (breakpoints) Object.keys(breakpoints).forEach((breakpoint)=>{
        const baseWidthForBreakpoint = (0, $7b0e169a5380005e$export$e58d7eefdadeb732)(breakpoint);
        if (baseWidthForBreakpoint > baseWidth) componentStyles[`@media (min-width: ${baseWidthForBreakpoint}px)`] = {
            ...$e0d24bf85c947bed$var$generateComponentStyles(breakpoints[breakpoint], undefined, skipStates, display)
        };
        else if (baseWidthForBreakpoint < baseWidth) componentStyles[`@media (max-width: ${baseWidthForBreakpoint}px)`] = {
            ...$e0d24bf85c947bed$var$generateComponentStyles(breakpoints[breakpoint], undefined, skipStates, display)
        };
    });
    if (states && !skipStates) Object.keys(states).filter((st)=>!$e0d24bf85c947bed$var$blockList.includes(st)).forEach((state)=>{
        const modifiedState = state === "focus-within" ? "focusWithin" : state;
        componentStyles[`&:${modifiedState}`] = {
            ...$e0d24bf85c947bed$var$generateComponentStyles(states[state], undefined, true, display)
        };
    });
    if (placeholder) componentStyles["&::placeholder"] = placeholderStyles;
    if (scroll?.type === "none") componentStyles["&::-webkit-scrollbar"] = {
        display: "none"
    };
    return componentStyles;
};
var $e0d24bf85c947bed$export$2e2bcd8739ae039 = $e0d24bf85c947bed$var$generateComponentStyles;


var $4fda23bb7a4f4783$exports = {};

$parcel$export($4fda23bb7a4f4783$exports, "container", function () { return $4fda23bb7a4f4783$export$34e0f9847d4c02dd; }, function (v) { return $4fda23bb7a4f4783$export$34e0f9847d4c02dd = v; });
var $4fda23bb7a4f4783$export$34e0f9847d4c02dd;
$4fda23bb7a4f4783$export$34e0f9847d4c02dd = `_2bL_iq_container`;


const $a7e21da0c6689673$var$StyledContainer = (0, $6e03950c2a9b6039$export$2e2bcd8739ae039).div`
  ${(props)=>(0, $e0d24bf85c947bed$export$2e2bcd8739ae039)(props.$shape, props.$baseScreenResolution, props.$skipStates)}
    position: relative;
    visibility: visible;
    pointer-events: none;
  ${(props)=>props.$nested && `
    position: absolute;
    z-index: 99999999;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  `}
`;
const $a7e21da0c6689673$var$ContainerSkeleton = ({ style: style, skipStates: skipStates, baseScreenResolution: baseScreenResolution, nested: nested })=>/*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)($a7e21da0c6689673$var$StyledContainer, {
        $shape: {
            display: style.display,
            grid: style.grid,
            flex: style.flex,
            width: style.width,
            height: style.height,
            min_height: !style.height ? "16px" : undefined,
            border: {
                radius: style.border.radius
            }
        },
        $baseScreenResolution: baseScreenResolution,
        $skipStates: skipStates,
        $nested: nested,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($4aeabe14c1618d30$exports)))("shimmer-container", (0, (/*@__PURE__*/$parcel$interopDefault($4fda23bb7a4f4783$exports))).container)
    });
var $a7e21da0c6689673$export$2e2bcd8739ae039 = $a7e21da0c6689673$var$ContainerSkeleton;


var $cefd49c6ff42e132$export$2e2bcd8739ae039 = (0, $a7e21da0c6689673$export$2e2bcd8739ae039);





var $aivMx = parcelRequire("aivMx");



var $94WEq = parcelRequire("94WEq");

var $g1KQj = parcelRequire("g1KQj");

// selectors.ts
const $79fc67ed759ae65b$export$8054c67068b60a33 = (state)=>state.page;
const $79fc67ed759ae65b$export$e3ab06c283dfbb87 = (state)=>$79fc67ed759ae65b$export$8054c67068b60a33(state).variableData;
const $79fc67ed759ae65b$export$78b26e3ba532c6ce = (state)=>$79fc67ed759ae65b$export$8054c67068b60a33(state).settings?.variables;





const $43a41cb6de4b5efd$var$StyledCheckboxLabel = (0, $6e03950c2a9b6039$export$2e2bcd8739ae039).label`
    cursor: pointer;
    display: flex;
    align-items: center;
    jsutify-content: center;
    position: relative;
    z-index: 1;
  ${(props)=>(0, $e0d24bf85c947bed$export$2e2bcd8739ae039)(props.$shape, props.$baseScreenResolution, props.$skipStates)}
`;
const $43a41cb6de4b5efd$var$StyledCheckbox = (0, $6e03950c2a9b6039$export$2e2bcd8739ae039).input`
  cursor: pointer;
  margin: 0;
  pading: 0;
  position: absolute;
  opacity: 0;
  height: 0;
  width: 0;
`;
const $43a41cb6de4b5efd$var$Checkbox = ({ id: id, style: stDraft, value: value, events: eventsDraft, soc: soc, pageSettings: pageSettings, dataLake: dataLake, nestedTable: nestedTable, parentIndex: parentIndex, styleChunks: styleChunks, settings: settings, sceleton: renderSceleton, activeState: activeStateDraft })=>{
    const containerRef = (0, $aivMx.useRef)(null);
    const variableData = (0, $f40d1f3d995cccef$export$2105062e25df4afe)((0, $79fc67ed759ae65b$export$e3ab06c283dfbb87));
    const localVariableData = (0, $f40d1f3d995cccef$export$2105062e25df4afe)((0, $79fc67ed759ae65b$export$78b26e3ba532c6ce));
    const { style: styleDraft, events: events, activeState: activeState } = dataLake?.data ? (0, $7b0e169a5380005e$export$485c71a5d8ecbaad)({
        style: stDraft,
        events: eventsDraft,
        activeState: activeStateDraft
    }, dataLake.data) : {
        style: stDraft,
        events: eventsDraft,
        activeState: activeStateDraft
    };
    const mergeStylesWithChunks = (0, $aivMx.useCallback)((style, chunks, index)=>{
        if (chunks && chunks[id] && chunks[id][index] && typeof index === "number") return (0, (/*@__PURE__*/$parcel$interopDefault($94WEq)))({}, style, chunks[id][index]);
        return style;
    }, [
        id
    ]);
    // First useMemo to merge active state styles with base style
    const mergedStyleWithState = (0, $aivMx.useMemo)(()=>{
        let mergedStyle = styleDraft;
        if (activeState && styleDraft?.states?.[activeState]) mergedStyle = (0, (/*@__PURE__*/$parcel$interopDefault($94WEq)))({}, styleDraft, styleDraft.states[activeState]);
        // Handle states in breakpoints
        if (styleDraft?.breakpoints) mergedStyle.breakpoints = Object.entries(styleDraft.breakpoints).reduce((acc, [breakpoint, breakpointStyle])=>{
            const typedBreakpointStyle = breakpointStyle;
            if (typedBreakpointStyle?.states?.[activeState]) acc[breakpoint] = (0, (/*@__PURE__*/$parcel$interopDefault($94WEq)))({}, typedBreakpointStyle, typedBreakpointStyle.states[activeState]);
            else acc[breakpoint] = typedBreakpointStyle;
            return acc;
        }, {});
        return mergedStyle;
    }, [
        styleDraft,
        activeState
    ]);
    // Second useMemo to merge styles with chunks based on parentIndex
    const style = (0, $aivMx.useMemo)(()=>{
        return mergeStylesWithChunks(mergedStyleWithState, styleChunks, parentIndex);
    }, [
        mergedStyleWithState,
        styleChunks,
        parentIndex
    ]);
    const [isChecked, setIsChecked] = (0, $aivMx.useState)(value === "true");
    const baseScreenResolution = pageSettings?.baseScreenResolution ? (0, $7b0e169a5380005e$export$e58d7eefdadeb732)(pageSettings?.baseScreenResolution) : undefined;
    const debouncedSubmitForm = (0, $aivMx.useCallback)((0, $7b0e169a5380005e$export$61fc7d43ac8f84b0)(()=>{
        dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
            value: "soc",
            componentId: id
        }));
    }, 500), []);
    (0, $aivMx.useEffect)(()=>{
        setIsChecked(value === "true");
    }, [
        value
    ]);
    const handleCheckboxChange = ()=>{
        setIsChecked(!isChecked);
        dispatch((0, $8eba69c5466928d3$export$528cdcbbafe26779)({
            field: {
                id: id,
                value: !isChecked
            }
        }));
        if (soc) debouncedSubmitForm(!isChecked);
    };
    const { on_change: clickUpdates, on_launch: launchUpdates, on_hover: hoverUpdates, on_unhover: unhoverUpdates, on_outclick: outclickUpdates } = events || {};
    const dispatch = (0, $d023060d48542f4c$export$8ad76b76a4c905f8)();
    const timeoutsRef = (0, $aivMx.useRef)([]);
    const internalFns = {
        $setVariable: (key, value)=>{
            dispatch((0, $8eba69c5466928d3$export$36f0c40eded97f9d)({
                variable: key,
                value: value
            }));
        },
        $getVariable: (key)=>{
            const value = (0, $7b0e169a5380005e$export$2516322ffbb7f3fb)(variableData, key) || (0, $7b0e169a5380005e$export$2516322ffbb7f3fb)(localVariableData, key);
            return value;
        },
        $moment: (...args)=>(0, (/*@__PURE__*/$parcel$interopDefault($g1KQj)))(...args)
    };
    const handleClick = (e)=>{
        if (activeState === "disabled" || activeState === "loading") {
            e.preventDefault();
            e.stopPropagation();
            return;
        }
        e.preventDefault();
        handleCheckboxChange();
        if (clickUpdates) {
            e.stopPropagation();
            const styleUpdates = clickUpdates.filter((update)=>"style" in update);
            const requestUpdates = clickUpdates.filter((update)=>"request" in update);
            const functionUpdates = clickUpdates.filter((update)=>"function" in update);
            if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates));
            if (requestUpdates.length) requestUpdates.forEach((update)=>{
                const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                const { delay: delay } = config || {};
                if (update?.request && method === "command") dispatch((0, $8eba69c5466928d3$export$ea176eb1668c7b4b)({
                    location: {
                        pathname: value
                    },
                    silent: silent,
                    componentId: id
                }));
                else if (update?.request && method === "action") dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                    value: value,
                    silent: silent,
                    delay: delay,
                    componentId: id
                }, stDraft?.states?.loading ? id : undefined));
                else if (update?.request && method === "open-url") (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent);
            });
            if (functionUpdates.length) functionUpdates.forEach((update)=>{
                if (update?.function) (0, $7b0e169a5380005e$export$1ed0175478ddd28b)(update.function, e, internalFns);
            });
        }
    };
    const handleHover = (e)=>{
        if (activeState === "disabled" || activeState === "loading") {
            e.preventDefault();
            e.stopPropagation();
            return;
        }
        if (hoverUpdates) {
            const styleUpdates = hoverUpdates.filter((update)=>"style" in update);
            const requestUpdates = hoverUpdates.filter((update)=>"request" in update);
            const functionUpdates = hoverUpdates.filter((update)=>"function" in update);
            if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates));
            if (requestUpdates.length) requestUpdates.forEach((update)=>{
                const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                const { delay: delay } = config || {};
                if (update?.request && method === "action") dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                    value: value,
                    silent: silent,
                    delay: delay,
                    componentId: id
                }, stDraft?.states?.loading ? id : undefined));
                else if (update?.request && method === "open-url") (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent);
            });
            if (functionUpdates.length) functionUpdates.forEach((update)=>{
                if (update?.function) (0, $7b0e169a5380005e$export$1ed0175478ddd28b)(update.function, e, internalFns);
            });
        }
    };
    const handleUnhover = (e)=>{
        if (activeState === "disabled" || activeState === "loading") {
            e.preventDefault();
            e.stopPropagation();
            return;
        }
        if (unhoverUpdates) {
            const styleUpdates = unhoverUpdates.filter((update)=>"style" in update);
            const requestUpdates = unhoverUpdates.filter((update)=>"request" in update);
            const functionUpdates = unhoverUpdates.filter((update)=>"function" in update);
            if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates));
            if (requestUpdates.length) requestUpdates.forEach((update)=>{
                const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                const { delay: delay } = config || {};
                if (update?.request && method === "action") dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                    value: value,
                    silent: silent,
                    delay: delay,
                    componentId: id
                }, stDraft?.states?.loading ? id : undefined));
                else if (update?.request && method === "open-url") (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent);
            });
            if (functionUpdates.length) functionUpdates.forEach((update)=>{
                if (update?.function) (0, $7b0e169a5380005e$export$1ed0175478ddd28b)(update.function, e, internalFns);
            });
        }
    };
    (0, $aivMx.useEffect)(()=>{
        if (launchUpdates && launchUpdates.length) {
            const styleUpdates = launchUpdates.filter((update)=>"style" in update);
            const requestUpdates = launchUpdates.filter((update)=>"request" in update);
            const functionUpdates = launchUpdates.filter((update)=>"function" in update);
            if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates));
            if (requestUpdates.length) requestUpdates.forEach((update)=>{
                const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                const { delay: delay } = config || {};
                if (update?.request && method === "action") ;
                else if (update?.request && method === "open-url") (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent);
            });
            if (functionUpdates.length) functionUpdates.forEach((update)=>{
                if (update?.function) (0, $7b0e169a5380005e$export$1ed0175478ddd28b)(update.function, undefined, internalFns);
            });
        }
        return ()=>{
            timeoutsRef?.current?.forEach((timeout)=>{
                clearTimeout(timeout);
            });
        };
    }, [
        launchUpdates
    ]);
    (0, $aivMx.useEffect)(()=>{
        const handleUnclick = (e)=>{
            if (activeState === "disabled" || activeState === "loading") return;
            if (containerRef.current && !containerRef.current.contains(e.target)) {
                if (outclickUpdates) {
                    const styleUpdates = outclickUpdates.filter((update)=>"style" in update);
                    const requestUpdates = outclickUpdates.filter((update)=>"request" in update);
                    const functionUpdates = outclickUpdates.filter((update)=>"function" in update);
                    if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates, parentIndex));
                    if (requestUpdates.length) requestUpdates.forEach((update)=>{
                        const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                        const { delay: delay } = config || {};
                        if (update?.request && method === "action") dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                            value: value,
                            delay: delay,
                            silent: silent,
                            componentId: id
                        }, stDraft?.states?.loading ? id : undefined));
                        else if (update?.request && method === "open-url") (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent);
                    });
                    if (functionUpdates.length) functionUpdates.forEach((update)=>{
                        if (update?.function) (0, $7b0e169a5380005e$export$1ed0175478ddd28b)(update.function, undefined, internalFns);
                    });
                }
            }
        };
        if (outclickUpdates) {
            document.addEventListener("mousedown", handleUnclick);
            return ()=>{
                document.removeEventListener("mousedown", handleUnclick);
            };
        }
        return undefined;
    }, [
        parentIndex,
        activeState,
        containerRef.current
    ]);
    if (renderSceleton && style) return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $cefd49c6ff42e132$export$2e2bcd8739ae039), {
        style: style,
        baseScreenResolution: baseScreenResolution,
        skipStates: activeState === "disabled" || activeState === "loading"
    });
    return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsxs)($43a41cb6de4b5efd$var$StyledCheckboxLabel, {
        ref: containerRef,
        htmlFor: `${id}${nestedTable && typeof parentIndex === "number" ? `::${parentIndex}` : ""}`,
        $shape: style,
        $baseScreenResolution: baseScreenResolution,
        $skipStates: activeState === "disabled" || activeState === "loading",
        "data-component": "checkbox",
        className: (0, $7b0e169a5380005e$export$189053d41e721fcb)(style.class),
        onClick: handleClick,
        onMouseEnter: handleHover,
        onMouseLeave: handleUnhover,
        children: [
            /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)($43a41cb6de4b5efd$var$StyledCheckbox, {
                id: `${id}${nestedTable && typeof parentIndex === "number" ? `::${parentIndex}` : ""}`,
                type: "checkbox"
            }),
            isChecked ? settings?.icons?.active ? /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("img", {
                style: {
                    maxWidth: "100%",
                    maxHeight: "100%"
                },
                src: settings.icons.active
            }) : /*#__PURE__*/ (0, $02de83db299f7983$exports.jsxs)("svg", {
                width: "16",
                height: "16",
                viewBox: "0 0 16 16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                style: {
                    transform: "scale(0.9)",
                    overflow: "visible"
                },
                children: [
                    /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("path", {
                        d: "M0.5 4C0.5 2.067 2.067 0.5 4 0.5H12C13.933 0.5 15.5 2.067 15.5 4V12C15.5 13.933 13.933 15.5 12 15.5H4C2.067 15.5 0.5 13.933 0.5 12V4Z",
                        stroke: style?.font?.color || "white"
                    }),
                    /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("path", {
                        d: "M12 5L6.5 10.5L4 8",
                        stroke: style?.font?.color || "white",
                        strokeWidth: "1.6666",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }) : settings?.icons?.inactive ? /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("img", {
                style: {
                    maxWidth: "100%",
                    maxHeight: "100%"
                },
                src: settings.icons.inactive
            }) : /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("svg", {
                width: "16",
                height: "16",
                viewBox: "0 0 16 16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                style: {
                    transform: "scale(0.9)",
                    overflow: "visible"
                },
                children: /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("path", {
                    d: "M0.5 4C0.5 2.067 2.067 0.5 4 0.5H12C13.933 0.5 15.5 2.067 15.5 4V12C15.5 13.933 13.933 15.5 12 15.5H4C2.067 15.5 0.5 13.933 0.5 12V4Z",
                    stroke: style?.font?.color || "white"
                })
            })
        ]
    });
};
var $43a41cb6de4b5efd$export$2e2bcd8739ae039 = $43a41cb6de4b5efd$var$Checkbox;


var $2c90db8687e433b8$export$2e2bcd8739ae039 = (0, $43a41cb6de4b5efd$export$2e2bcd8739ae039);



parcelRequire("aivMx");


parcelRequire("aivMx");
const $e8d6e02fe13adc9b$var$SvgRenderer = ({ svgString: svgString })=>{
    return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("img", {
        src: `data:image/svg+xml;utf8,${encodeURIComponent(svgString)}`
    });
};
var $e8d6e02fe13adc9b$export$2e2bcd8739ae039 = $e8d6e02fe13adc9b$var$SvgRenderer;


var $319d67322a675734$export$2e2bcd8739ae039 = (0, $e8d6e02fe13adc9b$export$2e2bcd8739ae039);




const $cd789220c822bcdc$var$StyledImage = (0, $6e03950c2a9b6039$export$2e2bcd8739ae039).img`
 z-index: 1;
  ${(props)=>(0, $e0d24bf85c947bed$export$2e2bcd8739ae039)(props.$shape)}
`;
const $cd789220c822bcdc$var$StyledDiv = (0, $6e03950c2a9b6039$export$2e2bcd8739ae039).div`
  ${(props)=>(0, $e0d24bf85c947bed$export$2e2bcd8739ae039)(props.$shape)}
`;
const $cd789220c822bcdc$var$Image = ({ id: id, image: image, style: style, svgString: svgString })=>{
    // if (image && image.startsWith('$')) {
    //   const iconName = image.substring(1);
    //   const SvgComponent = result[iconName];
    //   if (SvgComponent) {
    //     return <SvgComponent />;
    //   } else {
    //     // Handle the case where the SVG component is not found
    //     console.error(`SVG component "${iconName}" not found in result2.`);
    //     return null;
    //   }
    // }
    // If svgString is provided, render SVGRenderer
    if (svgString) return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $319d67322a675734$export$2e2bcd8739ae039), {
        svgString: svgString
    });
    // Otherwise, render the StyledImage component
    return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)($cd789220c822bcdc$var$StyledImage, {
        id: id,
        src: image,
        alt: id,
        $shape: style,
        "data-component": "image",
        className: (0, $7b0e169a5380005e$export$189053d41e721fcb)(style.class)
    });
};
var $cd789220c822bcdc$export$2e2bcd8739ae039 = $cd789220c822bcdc$var$Image;


var $aa8f0f735a0f79aa$export$2e2bcd8739ae039 = (0, $cd789220c822bcdc$export$2e2bcd8739ae039);


/* eslint-disable react/jsx-props-no-spreading */ /* eslint-disable max-len */ 

var $aivMx = parcelRequire("aivMx");

/** Checks if value is string */ function $b4195841d15b2d87$export$844ec244b1367d54(str) {
    return typeof str === "string" || str instanceof String;
}
/** Checks if value is object */ function $b4195841d15b2d87$export$a6cdc56e425d0d0a(obj) {
    var _obj$constructor;
    return typeof obj === "object" && obj != null && (obj == null || (_obj$constructor = obj.constructor) == null ? void 0 : _obj$constructor.name) === "Object";
}
function $b4195841d15b2d87$export$357523c63a2253b9(obj, keys) {
    if (Array.isArray(keys)) return $b4195841d15b2d87$export$357523c63a2253b9(obj, (_, k)=>keys.includes(k));
    return Object.entries(obj).reduce((acc, _ref)=>{
        let [k, v] = _ref;
        if (keys(v, k)) acc[k] = v;
        return acc;
    }, {});
}
/** Direction */ const $b4195841d15b2d87$export$9106728c49045482 = {
    NONE: "NONE",
    LEFT: "LEFT",
    FORCE_LEFT: "FORCE_LEFT",
    RIGHT: "RIGHT",
    FORCE_RIGHT: "FORCE_RIGHT"
};
/** Direction */ function $b4195841d15b2d87$export$32af4dafed14c8ce(direction) {
    switch(direction){
        case $b4195841d15b2d87$export$9106728c49045482.LEFT:
            return $b4195841d15b2d87$export$9106728c49045482.FORCE_LEFT;
        case $b4195841d15b2d87$export$9106728c49045482.RIGHT:
            return $b4195841d15b2d87$export$9106728c49045482.FORCE_RIGHT;
        default:
            return direction;
    }
}
/** Escapes regular expression control chars */ function $b4195841d15b2d87$export$7c57da42ce8e346f(str) {
    return str.replace(/([.*+?^=!:${}()|[\]/\\])/g, "\\$1");
}
// cloned from https://github.com/epoberezkin/fast-deep-equal with small changes
function $b4195841d15b2d87$export$7aeb68f71172641d(b, a) {
    if (a === b) return true;
    const arrA = Array.isArray(a), arrB = Array.isArray(b);
    let i;
    if (arrA && arrB) {
        if (a.length != b.length) return false;
        for(i = 0; i < a.length; i++)if (!$b4195841d15b2d87$export$7aeb68f71172641d(a[i], b[i])) return false;
        return true;
    }
    if (arrA != arrB) return false;
    if (a && b && typeof a === "object" && typeof b === "object") {
        const dateA = a instanceof Date, dateB = b instanceof Date;
        if (dateA && dateB) return a.getTime() == b.getTime();
        if (dateA != dateB) return false;
        const regexpA = a instanceof RegExp, regexpB = b instanceof RegExp;
        if (regexpA && regexpB) return a.toString() == b.toString();
        if (regexpA != regexpB) return false;
        const keys = Object.keys(a);
        // if (keys.length !== Object.keys(b).length) return false;
        for(i = 0; i < keys.length; i++)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = 0; i < keys.length; i++)if (!$b4195841d15b2d87$export$7aeb68f71172641d(b[keys[i]], a[keys[i]])) return false;
        return true;
    } else if (a && b && typeof a === "function" && typeof b === "function") return a.toString() === b.toString();
    return false;
}



/** Provides details of changing input */ class $5bfe4737c33ba518$export$2e2bcd8739ae039 {
    /** Current input value */ /** Current cursor position */ /** Old input value */ /** Old selection */ constructor(opts){
        Object.assign(this, opts);
        // double check if left part was changed (autofilling, other non-standard input triggers)
        while(this.value.slice(0, this.startChangePos) !== this.oldValue.slice(0, this.startChangePos))--this.oldSelection.start;
        if (this.insertedCount) {
            // double check right part
            while(this.value.slice(this.cursorPos) !== this.oldValue.slice(this.oldSelection.end))if (this.value.length - this.cursorPos < this.oldValue.length - this.oldSelection.end) ++this.oldSelection.end;
            else ++this.cursorPos;
        }
    }
    /** Start changing position */ get startChangePos() {
        return Math.min(this.cursorPos, this.oldSelection.start);
    }
    /** Inserted symbols count */ get insertedCount() {
        return this.cursorPos - this.startChangePos;
    }
    /** Inserted symbols */ get inserted() {
        return this.value.substr(this.startChangePos, this.insertedCount);
    }
    /** Removed symbols count */ get removedCount() {
        // Math.max for opposite operation
        return Math.max(this.oldSelection.end - this.startChangePos || // for Delete
        this.oldValue.length - this.value.length, 0);
    }
    /** Removed symbols */ get removed() {
        return this.oldValue.substr(this.startChangePos, this.removedCount);
    }
    /** Unchanged head symbols */ get head() {
        return this.value.substring(0, this.startChangePos);
    }
    /** Unchanged tail symbols */ get tail() {
        return this.value.substring(this.startChangePos + this.insertedCount);
    }
    /** Remove direction */ get removeDirection() {
        if (!this.removedCount || this.insertedCount) return (0, $b4195841d15b2d87$export$9106728c49045482).NONE;
        // align right if delete at right
        return (this.oldSelection.end === this.cursorPos || this.oldSelection.start === this.cursorPos) && // if not range removed (event with backspace)
        this.oldSelection.end === this.oldSelection.start ? (0, $b4195841d15b2d87$export$9106728c49045482).RIGHT : (0, $b4195841d15b2d87$export$9106728c49045482).LEFT;
    }
}



/** Applies mask on element */ function $7dec8b23e7031bbf$export$2e2bcd8739ae039(el, opts) {
    // currently available only for input-like elements
    return new $7dec8b23e7031bbf$export$2e2bcd8739ae039.InputMask(el, opts);
}


// TODO can't use overloads here because of https://github.com/microsoft/TypeScript/issues/50754
// export function maskedClass(mask: string): typeof MaskedPattern;
// export function maskedClass(mask: DateConstructor): typeof MaskedDate;
// export function maskedClass(mask: NumberConstructor): typeof MaskedNumber;
// export function maskedClass(mask: Array<any> | ArrayConstructor): typeof MaskedDynamic;
// export function maskedClass(mask: MaskedDate): typeof MaskedDate;
// export function maskedClass(mask: MaskedNumber): typeof MaskedNumber;
// export function maskedClass(mask: MaskedEnum): typeof MaskedEnum;
// export function maskedClass(mask: MaskedRange): typeof MaskedRange;
// export function maskedClass(mask: MaskedRegExp): typeof MaskedRegExp;
// export function maskedClass(mask: MaskedFunction): typeof MaskedFunction;
// export function maskedClass(mask: MaskedPattern): typeof MaskedPattern;
// export function maskedClass(mask: MaskedDynamic): typeof MaskedDynamic;
// export function maskedClass(mask: Masked): typeof Masked;
// export function maskedClass(mask: typeof Masked): typeof Masked;
// export function maskedClass(mask: typeof MaskedDate): typeof MaskedDate;
// export function maskedClass(mask: typeof MaskedNumber): typeof MaskedNumber;
// export function maskedClass(mask: typeof MaskedEnum): typeof MaskedEnum;
// export function maskedClass(mask: typeof MaskedRange): typeof MaskedRange;
// export function maskedClass(mask: typeof MaskedRegExp): typeof MaskedRegExp;
// export function maskedClass(mask: typeof MaskedFunction): typeof MaskedFunction;
// export function maskedClass(mask: typeof MaskedPattern): typeof MaskedPattern;
// export function maskedClass(mask: typeof MaskedDynamic): typeof MaskedDynamic;
// export function maskedClass<Mask extends typeof Masked> (mask: Mask): Mask;
// export function maskedClass(mask: RegExp): typeof MaskedRegExp;
// export function maskedClass(mask: (value: string, ...args: any[]) => boolean): typeof MaskedFunction;
/** Get Masked class by mask type */ function $d30869383ae23901$export$81ad4b1539a22420(mask) /* TODO */ {
    if (mask == null) throw new Error("mask property should be defined");
    if (mask instanceof RegExp) return (0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).MaskedRegExp;
    if ((0, $b4195841d15b2d87$export$844ec244b1367d54)(mask)) return (0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).MaskedPattern;
    if (mask === Date) return (0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).MaskedDate;
    if (mask === Number) return (0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).MaskedNumber;
    if (Array.isArray(mask) || mask === Array) return (0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).MaskedDynamic;
    if ((0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).Masked && mask.prototype instanceof (0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).Masked) return mask;
    if ((0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).Masked && mask instanceof (0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).Masked) return mask.constructor;
    if (mask instanceof Function) return (0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).MaskedFunction;
    console.warn("Mask not found for mask", mask); // eslint-disable-line no-console
    return (0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).Masked;
}
function $d30869383ae23901$export$a213ae1c699d7230(opts) {
    if (!opts) throw new Error("Options in not defined");
    if ((0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).Masked) {
        if (opts.prototype instanceof (0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).Masked) return {
            mask: opts
        };
        /*
      handle cases like:
      1) opts = Masked
      2) opts = { mask: Masked, ...instanceOpts }
    */ const { mask: mask, ...instanceOpts } = opts instanceof (0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).Masked ? {
            mask: opts
        } : (0, $b4195841d15b2d87$export$a6cdc56e425d0d0a)(opts) && opts.mask instanceof (0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).Masked ? opts : {};
        if (mask) {
            const _mask = mask.mask;
            return {
                ...(0, $b4195841d15b2d87$export$357523c63a2253b9)(mask, (_, k)=>!k.startsWith("_")),
                mask: mask.constructor,
                _mask: _mask,
                ...instanceOpts
            };
        }
    }
    if (!(0, $b4195841d15b2d87$export$a6cdc56e425d0d0a)(opts)) return {
        mask: opts
    };
    return {
        ...opts
    };
}
// TODO can't use overloads here because of https://github.com/microsoft/TypeScript/issues/50754
// From masked
// export default function createMask<Opts extends Masked, ReturnMasked=Opts> (opts: Opts): ReturnMasked;
// // From masked class
// export default function createMask<Opts extends MaskedOptions<typeof Masked>, ReturnMasked extends Masked=InstanceType<Opts['mask']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedOptions<typeof MaskedDate>, ReturnMasked extends MaskedDate=MaskedDate<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedOptions<typeof MaskedNumber>, ReturnMasked extends MaskedNumber=MaskedNumber<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedOptions<typeof MaskedEnum>, ReturnMasked extends MaskedEnum=MaskedEnum<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedOptions<typeof MaskedRange>, ReturnMasked extends MaskedRange=MaskedRange<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedOptions<typeof MaskedRegExp>, ReturnMasked extends MaskedRegExp=MaskedRegExp<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedOptions<typeof MaskedFunction>, ReturnMasked extends MaskedFunction=MaskedFunction<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedOptions<typeof MaskedPattern>, ReturnMasked extends MaskedPattern=MaskedPattern<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedOptions<typeof MaskedDynamic>, ReturnMasked extends MaskedDynamic=MaskedDynamic<Opts['parent']>> (opts: Opts): ReturnMasked;
// // From mask opts
// export default function createMask<Opts extends MaskedOptions<Masked>, ReturnMasked=Opts extends MaskedOptions<infer M> ? M : never> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedNumberOptions, ReturnMasked extends MaskedNumber=MaskedNumber<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedDateFactoryOptions, ReturnMasked extends MaskedDate=MaskedDate<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedEnumOptions, ReturnMasked extends MaskedEnum=MaskedEnum<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedRangeOptions, ReturnMasked extends MaskedRange=MaskedRange<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedPatternOptions, ReturnMasked extends MaskedPattern=MaskedPattern<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedDynamicOptions, ReturnMasked extends MaskedDynamic=MaskedDynamic<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedOptions<RegExp>, ReturnMasked extends MaskedRegExp=MaskedRegExp<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedOptions<Function>, ReturnMasked extends MaskedFunction=MaskedFunction<Opts['parent']>> (opts: Opts): ReturnMasked;
/** Creates new {@link Masked} depending on mask type */ function $d30869383ae23901$export$2e2bcd8739ae039(opts) {
    if ((0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).Masked && opts instanceof (0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).Masked) return opts;
    const nOpts = $d30869383ae23901$export$a213ae1c699d7230(opts);
    const MaskedClass = $d30869383ae23901$export$81ad4b1539a22420(nOpts.mask);
    if (!MaskedClass) throw new Error("Masked class is not found for provided mask " + nOpts.mask + ", appropriate module needs to be imported manually before creating mask.");
    if (nOpts.mask === MaskedClass) delete nOpts.mask;
    if (nOpts._mask) {
        nOpts.mask = nOpts._mask;
        delete nOpts._mask;
    }
    return new MaskedClass(nOpts);
}
(0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).createMask = $d30869383ae23901$export$2e2bcd8739ae039;



/**  Generic element API to use with mask */ class $ae7da51f8113dc85$export$2e2bcd8739ae039 {
    /** */ /** */ /** */ /** Safely returns selection start */ get selectionStart() {
        let start;
        try {
            start = this._unsafeSelectionStart;
        } catch  {}
        return start != null ? start : this.value.length;
    }
    /** Safely returns selection end */ get selectionEnd() {
        let end;
        try {
            end = this._unsafeSelectionEnd;
        } catch  {}
        return end != null ? end : this.value.length;
    }
    /** Safely sets element selection */ select(start, end) {
        if (start == null || end == null || start === this.selectionStart && end === this.selectionEnd) return;
        try {
            this._unsafeSelect(start, end);
        } catch  {}
    }
    /** */ get isActive() {
        return false;
    }
}
(0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).MaskElement = $ae7da51f8113dc85$export$2e2bcd8739ae039;




const $ecbac16a2bea0b4a$var$KEY_Z = 90;
const $ecbac16a2bea0b4a$var$KEY_Y = 89;
/** Bridge between HTMLElement and {@link Masked} */ class $ecbac16a2bea0b4a$export$2e2bcd8739ae039 extends (0, $ae7da51f8113dc85$export$2e2bcd8739ae039) {
    /** HTMLElement to use mask on */ constructor(input){
        super();
        this.input = input;
        this._onKeydown = this._onKeydown.bind(this);
        this._onInput = this._onInput.bind(this);
        this._onBeforeinput = this._onBeforeinput.bind(this);
        this._onCompositionEnd = this._onCompositionEnd.bind(this);
    }
    get rootElement() {
        var _this$input$getRootNo, _this$input$getRootNo2, _this$input;
        return (_this$input$getRootNo = (_this$input$getRootNo2 = (_this$input = this.input).getRootNode) == null ? void 0 : _this$input$getRootNo2.call(_this$input)) != null ? _this$input$getRootNo : document;
    }
    /** Is element in focus */ get isActive() {
        return this.input === this.rootElement.activeElement;
    }
    /** Binds HTMLElement events to mask internal events */ bindEvents(handlers) {
        this.input.addEventListener("keydown", this._onKeydown);
        this.input.addEventListener("input", this._onInput);
        this.input.addEventListener("beforeinput", this._onBeforeinput);
        this.input.addEventListener("compositionend", this._onCompositionEnd);
        this.input.addEventListener("drop", handlers.drop);
        this.input.addEventListener("click", handlers.click);
        this.input.addEventListener("focus", handlers.focus);
        this.input.addEventListener("blur", handlers.commit);
        this._handlers = handlers;
    }
    _onKeydown(e) {
        if (this._handlers.redo && (e.keyCode === $ecbac16a2bea0b4a$var$KEY_Z && e.shiftKey && (e.metaKey || e.ctrlKey) || e.keyCode === $ecbac16a2bea0b4a$var$KEY_Y && e.ctrlKey)) {
            e.preventDefault();
            return this._handlers.redo(e);
        }
        if (this._handlers.undo && e.keyCode === $ecbac16a2bea0b4a$var$KEY_Z && (e.metaKey || e.ctrlKey)) {
            e.preventDefault();
            return this._handlers.undo(e);
        }
        if (!e.isComposing) this._handlers.selectionChange(e);
    }
    _onBeforeinput(e) {
        if (e.inputType === "historyUndo" && this._handlers.undo) {
            e.preventDefault();
            return this._handlers.undo(e);
        }
        if (e.inputType === "historyRedo" && this._handlers.redo) {
            e.preventDefault();
            return this._handlers.redo(e);
        }
    }
    _onCompositionEnd(e) {
        this._handlers.input(e);
    }
    _onInput(e) {
        if (!e.isComposing) this._handlers.input(e);
    }
    /** Unbinds HTMLElement events to mask internal events */ unbindEvents() {
        this.input.removeEventListener("keydown", this._onKeydown);
        this.input.removeEventListener("input", this._onInput);
        this.input.removeEventListener("beforeinput", this._onBeforeinput);
        this.input.removeEventListener("compositionend", this._onCompositionEnd);
        this.input.removeEventListener("drop", this._handlers.drop);
        this.input.removeEventListener("click", this._handlers.click);
        this.input.removeEventListener("focus", this._handlers.focus);
        this.input.removeEventListener("blur", this._handlers.commit);
        this._handlers = {};
    }
}
(0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).HTMLMaskElement = $ecbac16a2bea0b4a$export$2e2bcd8739ae039;




/** Bridge between InputElement and {@link Masked} */ class $ebab80655d6a9181$export$2e2bcd8739ae039 extends (0, $ecbac16a2bea0b4a$export$2e2bcd8739ae039) {
    /** InputElement to use mask on */ constructor(input){
        super(input);
        this.input = input;
    }
    /** Returns InputElement selection start */ get _unsafeSelectionStart() {
        return this.input.selectionStart != null ? this.input.selectionStart : this.value.length;
    }
    /** Returns InputElement selection end */ get _unsafeSelectionEnd() {
        return this.input.selectionEnd;
    }
    /** Sets InputElement selection */ _unsafeSelect(start, end) {
        this.input.setSelectionRange(start, end);
    }
    get value() {
        return this.input.value;
    }
    set value(value) {
        this.input.value = value;
    }
}
(0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).HTMLMaskElement = (0, $ecbac16a2bea0b4a$export$2e2bcd8739ae039);





class $6deed0002d645a3f$export$2e2bcd8739ae039 extends (0, $ecbac16a2bea0b4a$export$2e2bcd8739ae039) {
    /** Returns HTMLElement selection start */ get _unsafeSelectionStart() {
        const root = this.rootElement;
        const selection = root.getSelection && root.getSelection();
        const anchorOffset = selection && selection.anchorOffset;
        const focusOffset = selection && selection.focusOffset;
        if (focusOffset == null || anchorOffset == null || anchorOffset < focusOffset) return anchorOffset;
        return focusOffset;
    }
    /** Returns HTMLElement selection end */ get _unsafeSelectionEnd() {
        const root = this.rootElement;
        const selection = root.getSelection && root.getSelection();
        const anchorOffset = selection && selection.anchorOffset;
        const focusOffset = selection && selection.focusOffset;
        if (focusOffset == null || anchorOffset == null || anchorOffset > focusOffset) return anchorOffset;
        return focusOffset;
    }
    /** Sets HTMLElement selection */ _unsafeSelect(start, end) {
        if (!this.rootElement.createRange) return;
        const range = this.rootElement.createRange();
        range.setStart(this.input.firstChild || this.input, start);
        range.setEnd(this.input.lastChild || this.input, end);
        const root = this.rootElement;
        const selection = root.getSelection && root.getSelection();
        if (selection) {
            selection.removeAllRanges();
            selection.addRange(range);
        }
    }
    /** HTMLElement value */ get value() {
        return this.input.textContent || "";
    }
    set value(value) {
        this.input.textContent = value;
    }
}
(0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).HTMLContenteditableMaskElement = $6deed0002d645a3f$export$2e2bcd8739ae039;



class $8d4d359c9723b699$export$2e2bcd8739ae039 {
    constructor(){
        this.states = [];
        this.currentIndex = 0;
    }
    get currentState() {
        return this.states[this.currentIndex];
    }
    get isEmpty() {
        return this.states.length === 0;
    }
    push(state) {
        // if current index points before the last element then remove the future
        if (this.currentIndex < this.states.length - 1) this.states.length = this.currentIndex + 1;
        this.states.push(state);
        if (this.states.length > $8d4d359c9723b699$export$2e2bcd8739ae039.MAX_LENGTH) this.states.shift();
        this.currentIndex = this.states.length - 1;
    }
    go(steps) {
        this.currentIndex = Math.min(Math.max(this.currentIndex + steps, 0), this.states.length - 1);
        return this.currentState;
    }
    undo() {
        return this.go(-1);
    }
    redo() {
        return this.go(1);
    }
    clear() {
        this.states.length = 0;
        this.currentIndex = 0;
    }
}
$8d4d359c9723b699$export$2e2bcd8739ae039.MAX_LENGTH = 100;



/** Listens to element events and controls changes between element and {@link Masked} */ class $3895576b00a3d126$export$2e2bcd8739ae039 {
    /**
    View element
  */ /** Internal {@link Masked} model */ constructor(el, opts){
        this.el = el instanceof (0, $ae7da51f8113dc85$export$2e2bcd8739ae039) ? el : el.isContentEditable && el.tagName !== "INPUT" && el.tagName !== "TEXTAREA" ? new (0, $6deed0002d645a3f$export$2e2bcd8739ae039)(el) : new (0, $ebab80655d6a9181$export$2e2bcd8739ae039)(el);
        this.masked = (0, $d30869383ae23901$export$2e2bcd8739ae039)(opts);
        this._listeners = {};
        this._value = "";
        this._unmaskedValue = "";
        this._rawInputValue = "";
        this.history = new (0, $8d4d359c9723b699$export$2e2bcd8739ae039)();
        this._saveSelection = this._saveSelection.bind(this);
        this._onInput = this._onInput.bind(this);
        this._onChange = this._onChange.bind(this);
        this._onDrop = this._onDrop.bind(this);
        this._onFocus = this._onFocus.bind(this);
        this._onClick = this._onClick.bind(this);
        this._onUndo = this._onUndo.bind(this);
        this._onRedo = this._onRedo.bind(this);
        this.alignCursor = this.alignCursor.bind(this);
        this.alignCursorFriendly = this.alignCursorFriendly.bind(this);
        this._bindEvents();
        // refresh
        this.updateValue();
        this._onChange();
    }
    maskEquals(mask) {
        var _this$masked;
        return mask == null || ((_this$masked = this.masked) == null ? void 0 : _this$masked.maskEquals(mask));
    }
    /** Masked */ get mask() {
        return this.masked.mask;
    }
    set mask(mask) {
        if (this.maskEquals(mask)) return;
        if (!(mask instanceof (0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).Masked) && this.masked.constructor === (0, $d30869383ae23901$export$81ad4b1539a22420)(mask)) {
            // TODO "any" no idea
            this.masked.updateOptions({
                mask: mask
            });
            return;
        }
        const masked = mask instanceof (0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).Masked ? mask : (0, $d30869383ae23901$export$2e2bcd8739ae039)({
            mask: mask
        });
        masked.unmaskedValue = this.masked.unmaskedValue;
        this.masked = masked;
    }
    /** Raw value */ get value() {
        return this._value;
    }
    set value(str) {
        if (this.value === str) return;
        this.masked.value = str;
        this.updateControl("auto");
    }
    /** Unmasked value */ get unmaskedValue() {
        return this._unmaskedValue;
    }
    set unmaskedValue(str) {
        if (this.unmaskedValue === str) return;
        this.masked.unmaskedValue = str;
        this.updateControl("auto");
    }
    /** Raw input value */ get rawInputValue() {
        return this._rawInputValue;
    }
    set rawInputValue(str) {
        if (this.rawInputValue === str) return;
        this.masked.rawInputValue = str;
        this.updateControl();
        this.alignCursor();
    }
    /** Typed unmasked value */ get typedValue() {
        return this.masked.typedValue;
    }
    set typedValue(val) {
        if (this.masked.typedValueEquals(val)) return;
        this.masked.typedValue = val;
        this.updateControl("auto");
    }
    /** Display value */ get displayValue() {
        return this.masked.displayValue;
    }
    /** Starts listening to element events */ _bindEvents() {
        this.el.bindEvents({
            selectionChange: this._saveSelection,
            input: this._onInput,
            drop: this._onDrop,
            click: this._onClick,
            focus: this._onFocus,
            commit: this._onChange,
            undo: this._onUndo,
            redo: this._onRedo
        });
    }
    /** Stops listening to element events */ _unbindEvents() {
        if (this.el) this.el.unbindEvents();
    }
    /** Fires custom event */ _fireEvent(ev, e) {
        const listeners = this._listeners[ev];
        if (!listeners) return;
        listeners.forEach((l)=>l(e));
    }
    /** Current selection start */ get selectionStart() {
        return this._cursorChanging ? this._changingCursorPos : this.el.selectionStart;
    }
    /** Current cursor position */ get cursorPos() {
        return this._cursorChanging ? this._changingCursorPos : this.el.selectionEnd;
    }
    set cursorPos(pos) {
        if (!this.el || !this.el.isActive) return;
        this.el.select(pos, pos);
        this._saveSelection();
    }
    /** Stores current selection */ _saveSelection() {
        if (this.displayValue !== this.el.value) console.warn("Element value was changed outside of mask. Syncronize mask using `mask.updateValue()` to work properly."); // eslint-disable-line no-console
        this._selection = {
            start: this.selectionStart,
            end: this.cursorPos
        };
    }
    /** Syncronizes model value from view */ updateValue() {
        this.masked.value = this.el.value;
        this._value = this.masked.value;
        this._unmaskedValue = this.masked.unmaskedValue;
        this._rawInputValue = this.masked.rawInputValue;
    }
    /** Syncronizes view from model value, fires change events */ updateControl(cursorPos) {
        const newUnmaskedValue = this.masked.unmaskedValue;
        const newValue = this.masked.value;
        const newRawInputValue = this.masked.rawInputValue;
        const newDisplayValue = this.displayValue;
        const isChanged = this.unmaskedValue !== newUnmaskedValue || this.value !== newValue || this._rawInputValue !== newRawInputValue;
        this._unmaskedValue = newUnmaskedValue;
        this._value = newValue;
        this._rawInputValue = newRawInputValue;
        if (this.el.value !== newDisplayValue) this.el.value = newDisplayValue;
        if (cursorPos === "auto") this.alignCursor();
        else if (cursorPos != null) this.cursorPos = cursorPos;
        if (isChanged) this._fireChangeEvents();
        if (!this._historyChanging && (isChanged || this.history.isEmpty)) this.history.push({
            unmaskedValue: newUnmaskedValue,
            selection: {
                start: this.selectionStart,
                end: this.cursorPos
            }
        });
    }
    /** Updates options with deep equal check, recreates {@link Masked} model if mask type changes */ updateOptions(opts) {
        const { mask: mask, ...restOpts } = opts; // TODO types, yes, mask is optional
        const updateMask = !this.maskEquals(mask);
        const updateOpts = this.masked.optionsIsChanged(restOpts);
        if (updateMask) this.mask = mask;
        if (updateOpts) this.masked.updateOptions(restOpts); // TODO
        if (updateMask || updateOpts) this.updateControl();
    }
    /** Updates cursor */ updateCursor(cursorPos) {
        if (cursorPos == null) return;
        this.cursorPos = cursorPos;
        // also queue change cursor for mobile browsers
        this._delayUpdateCursor(cursorPos);
    }
    /** Delays cursor update to support mobile browsers */ _delayUpdateCursor(cursorPos) {
        this._abortUpdateCursor();
        this._changingCursorPos = cursorPos;
        this._cursorChanging = setTimeout(()=>{
            if (!this.el) return; // if was destroyed
            this.cursorPos = this._changingCursorPos;
            this._abortUpdateCursor();
        }, 10);
    }
    /** Fires custom events */ _fireChangeEvents() {
        this._fireEvent("accept", this._inputEvent);
        if (this.masked.isComplete) this._fireEvent("complete", this._inputEvent);
    }
    /** Aborts delayed cursor update */ _abortUpdateCursor() {
        if (this._cursorChanging) {
            clearTimeout(this._cursorChanging);
            delete this._cursorChanging;
        }
    }
    /** Aligns cursor to nearest available position */ alignCursor() {
        this.cursorPos = this.masked.nearestInputPos(this.masked.nearestInputPos(this.cursorPos, (0, $b4195841d15b2d87$export$9106728c49045482).LEFT));
    }
    /** Aligns cursor only if selection is empty */ alignCursorFriendly() {
        if (this.selectionStart !== this.cursorPos) return; // skip if range is selected
        this.alignCursor();
    }
    /** Adds listener on custom event */ on(ev, handler) {
        if (!this._listeners[ev]) this._listeners[ev] = [];
        this._listeners[ev].push(handler);
        return this;
    }
    /** Removes custom event listener */ off(ev, handler) {
        if (!this._listeners[ev]) return this;
        if (!handler) {
            delete this._listeners[ev];
            return this;
        }
        const hIndex = this._listeners[ev].indexOf(handler);
        if (hIndex >= 0) this._listeners[ev].splice(hIndex, 1);
        return this;
    }
    /** Handles view input event */ _onInput(e) {
        this._inputEvent = e;
        this._abortUpdateCursor();
        const details = new (0, $5bfe4737c33ba518$export$2e2bcd8739ae039)({
            // new state
            value: this.el.value,
            cursorPos: this.cursorPos,
            // old state
            oldValue: this.displayValue,
            oldSelection: this._selection
        });
        const oldRawValue = this.masked.rawInputValue;
        const offset = this.masked.splice(details.startChangePos, details.removed.length, details.inserted, details.removeDirection, {
            input: true,
            raw: true
        }).offset;
        // force align in remove direction only if no input chars were removed
        // otherwise we still need to align with NONE (to get out from fixed symbols for instance)
        const removeDirection = oldRawValue === this.masked.rawInputValue ? details.removeDirection : (0, $b4195841d15b2d87$export$9106728c49045482).NONE;
        let cursorPos = this.masked.nearestInputPos(details.startChangePos + offset, removeDirection);
        if (removeDirection !== (0, $b4195841d15b2d87$export$9106728c49045482).NONE) cursorPos = this.masked.nearestInputPos(cursorPos, (0, $b4195841d15b2d87$export$9106728c49045482).NONE);
        this.updateControl(cursorPos);
        delete this._inputEvent;
    }
    /** Handles view change event and commits model value */ _onChange() {
        if (this.displayValue !== this.el.value) this.updateValue();
        this.masked.doCommit();
        this.updateControl();
        this._saveSelection();
    }
    /** Handles view drop event, prevents by default */ _onDrop(ev) {
        ev.preventDefault();
        ev.stopPropagation();
    }
    /** Restore last selection on focus */ _onFocus(ev) {
        this.alignCursorFriendly();
    }
    /** Restore last selection on focus */ _onClick(ev) {
        this.alignCursorFriendly();
    }
    _onUndo() {
        this._applyHistoryState(this.history.undo());
    }
    _onRedo() {
        this._applyHistoryState(this.history.redo());
    }
    _applyHistoryState(state) {
        if (!state) return;
        this._historyChanging = true;
        this.unmaskedValue = state.unmaskedValue;
        this.el.select(state.selection.start, state.selection.end);
        this._saveSelection();
        this._historyChanging = false;
    }
    /** Unbind view events and removes element reference */ destroy() {
        this._unbindEvents();
        this._listeners.length = 0;
        delete this.el;
    }
}
(0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).InputMask = $3895576b00a3d126$export$2e2bcd8739ae039;








/** Provides details of changing model value */ class $b285a78e7d6163d8$export$2e2bcd8739ae039 {
    /** Inserted symbols */ /** Additional offset if any changes occurred before tail */ /** Raw inserted is used by dynamic mask */ /** Can skip chars */ static normalize(prep) {
        return Array.isArray(prep) ? prep : [
            prep,
            new $b285a78e7d6163d8$export$2e2bcd8739ae039()
        ];
    }
    constructor(details){
        Object.assign(this, {
            inserted: "",
            rawInserted: "",
            tailShift: 0,
            skip: false
        }, details);
    }
    /** Aggregate changes */ aggregate(details) {
        this.inserted += details.inserted;
        this.rawInserted += details.rawInserted;
        this.tailShift += details.tailShift;
        this.skip = this.skip || details.skip;
        return this;
    }
    /** Total offset considering all changes */ get offset() {
        return this.tailShift + this.inserted.length;
    }
    get consumed() {
        return Boolean(this.rawInserted) || this.skip;
    }
    equals(details) {
        return this.inserted === details.inserted && this.tailShift === details.tailShift && this.rawInserted === details.rawInserted && this.skip === details.skip;
    }
}
(0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).ChangeDetails = $b285a78e7d6163d8$export$2e2bcd8739ae039;




/** Provides details of continuous extracted tail */ class $8648f741d9791934$export$2e2bcd8739ae039 {
    /** Tail value as string */ /** Tail start position */ /** Start position */ constructor(value, from, stop){
        if (value === void 0) value = "";
        if (from === void 0) from = 0;
        this.value = value;
        this.from = from;
        this.stop = stop;
    }
    toString() {
        return this.value;
    }
    extend(tail) {
        this.value += String(tail);
    }
    appendTo(masked) {
        return masked.append(this.toString(), {
            tail: true
        }).aggregate(masked._appendPlaceholder());
    }
    get state() {
        return {
            value: this.value,
            from: this.from,
            stop: this.stop
        };
    }
    set state(state) {
        Object.assign(this, state);
    }
    unshift(beforePos) {
        if (!this.value.length || beforePos != null && this.from >= beforePos) return "";
        const shiftChar = this.value[0];
        this.value = this.value.slice(1);
        return shiftChar;
    }
    shift() {
        if (!this.value.length) return "";
        const shiftChar = this.value[this.value.length - 1];
        this.value = this.value.slice(0, -1);
        return shiftChar;
    }
}




/** Append flags */ /** Extract flags */ // see https://github.com/microsoft/TypeScript/issues/6223
/** Provides common masking stuff */ class $9b02b15c72a43b68$export$2e2bcd8739ae039 {
    /** */ /** */ /** Transforms value before mask processing */ /** Transforms each char before mask processing */ /** Validates if value is acceptable */ /** Does additional processing at the end of editing */ /** Format typed value to string */ /** Parse string to get typed value */ /** Enable characters overwriting */ /** */ /** */ /** */ /** */ constructor(opts){
        this._value = "";
        this._update({
            ...$9b02b15c72a43b68$export$2e2bcd8739ae039.DEFAULTS,
            ...opts
        });
        this._initialized = true;
    }
    /** Sets and applies new options */ updateOptions(opts) {
        if (!this.optionsIsChanged(opts)) return;
        this.withValueRefresh(this._update.bind(this, opts));
    }
    /** Sets new options */ _update(opts) {
        Object.assign(this, opts);
    }
    /** Mask state */ get state() {
        return {
            _value: this.value,
            _rawInputValue: this.rawInputValue
        };
    }
    set state(state) {
        this._value = state._value;
    }
    /** Resets value */ reset() {
        this._value = "";
    }
    get value() {
        return this._value;
    }
    set value(value) {
        this.resolve(value, {
            input: true
        });
    }
    /** Resolve new value */ resolve(value, flags) {
        if (flags === void 0) flags = {
            input: true
        };
        this.reset();
        this.append(value, flags, "");
        this.doCommit();
    }
    get unmaskedValue() {
        return this.value;
    }
    set unmaskedValue(value) {
        this.resolve(value, {});
    }
    get typedValue() {
        return this.parse ? this.parse(this.value, this) : this.unmaskedValue;
    }
    set typedValue(value) {
        if (this.format) this.value = this.format(value, this);
        else this.unmaskedValue = String(value);
    }
    /** Value that includes raw user input */ get rawInputValue() {
        return this.extractInput(0, this.displayValue.length, {
            raw: true
        });
    }
    set rawInputValue(value) {
        this.resolve(value, {
            raw: true
        });
    }
    get displayValue() {
        return this.value;
    }
    get isComplete() {
        return true;
    }
    get isFilled() {
        return this.isComplete;
    }
    /** Finds nearest input position in direction */ nearestInputPos(cursorPos, direction) {
        return cursorPos;
    }
    totalInputPositions(fromPos, toPos) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this.displayValue.length;
        return Math.min(this.displayValue.length, toPos - fromPos);
    }
    /** Extracts value in range considering flags */ extractInput(fromPos, toPos, flags) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this.displayValue.length;
        return this.displayValue.slice(fromPos, toPos);
    }
    /** Extracts tail in range */ extractTail(fromPos, toPos) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this.displayValue.length;
        return new (0, $8648f741d9791934$export$2e2bcd8739ae039)(this.extractInput(fromPos, toPos), fromPos);
    }
    /** Appends tail */ appendTail(tail) {
        if ((0, $b4195841d15b2d87$export$844ec244b1367d54)(tail)) tail = new (0, $8648f741d9791934$export$2e2bcd8739ae039)(String(tail));
        return tail.appendTo(this);
    }
    /** Appends char */ _appendCharRaw(ch, flags) {
        if (!ch) return new (0, $b285a78e7d6163d8$export$2e2bcd8739ae039)();
        this._value += ch;
        return new (0, $b285a78e7d6163d8$export$2e2bcd8739ae039)({
            inserted: ch,
            rawInserted: ch
        });
    }
    /** Appends char */ _appendChar(ch, flags, checkTail) {
        if (flags === void 0) flags = {};
        const consistentState = this.state;
        let details;
        [ch, details] = this.doPrepareChar(ch, flags);
        if (ch) {
            details = details.aggregate(this._appendCharRaw(ch, flags));
            // TODO handle `skip`?
            // try `autofix` lookahead
            if (!details.rawInserted && this.autofix === "pad") {
                const noFixState = this.state;
                this.state = consistentState;
                let fixDetails = this.pad(flags);
                const chDetails = this._appendCharRaw(ch, flags);
                fixDetails = fixDetails.aggregate(chDetails);
                // if fix was applied or
                // if details are equal use skip restoring state optimization
                if (chDetails.rawInserted || fixDetails.equals(details)) details = fixDetails;
                else this.state = noFixState;
            }
        }
        if (details.inserted) {
            let consistentTail;
            let appended = this.doValidate(flags) !== false;
            if (appended && checkTail != null) {
                // validation ok, check tail
                const beforeTailState = this.state;
                if (this.overwrite === true) {
                    consistentTail = checkTail.state;
                    for(let i = 0; i < details.rawInserted.length; ++i)checkTail.unshift(this.displayValue.length - details.tailShift);
                }
                let tailDetails = this.appendTail(checkTail);
                appended = tailDetails.rawInserted.length === checkTail.toString().length;
                // not ok, try shift
                if (!(appended && tailDetails.inserted) && this.overwrite === "shift") {
                    this.state = beforeTailState;
                    consistentTail = checkTail.state;
                    for(let i = 0; i < details.rawInserted.length; ++i)checkTail.shift();
                    tailDetails = this.appendTail(checkTail);
                    appended = tailDetails.rawInserted.length === checkTail.toString().length;
                }
                // if ok, rollback state after tail
                if (appended && tailDetails.inserted) this.state = beforeTailState;
            }
            // revert all if something went wrong
            if (!appended) {
                details = new (0, $b285a78e7d6163d8$export$2e2bcd8739ae039)();
                this.state = consistentState;
                if (checkTail && consistentTail) checkTail.state = consistentTail;
            }
        }
        return details;
    }
    /** Appends optional placeholder at the end */ _appendPlaceholder() {
        return new (0, $b285a78e7d6163d8$export$2e2bcd8739ae039)();
    }
    /** Appends optional eager placeholder at the end */ _appendEager() {
        return new (0, $b285a78e7d6163d8$export$2e2bcd8739ae039)();
    }
    /** Appends symbols considering flags */ append(str, flags, tail) {
        if (!(0, $b4195841d15b2d87$export$844ec244b1367d54)(str)) throw new Error("value should be string");
        const checkTail = (0, $b4195841d15b2d87$export$844ec244b1367d54)(tail) ? new (0, $8648f741d9791934$export$2e2bcd8739ae039)(String(tail)) : tail;
        if (flags != null && flags.tail) flags._beforeTailState = this.state;
        let details;
        [str, details] = this.doPrepare(str, flags);
        for(let ci = 0; ci < str.length; ++ci){
            const d = this._appendChar(str[ci], flags, checkTail);
            if (!d.rawInserted && !this.doSkipInvalid(str[ci], flags, checkTail)) break;
            details.aggregate(d);
        }
        if ((this.eager === true || this.eager === "append") && flags != null && flags.input && str) details.aggregate(this._appendEager());
        // append tail but aggregate only tailShift
        if (checkTail != null) details.tailShift += this.appendTail(checkTail).tailShift;
        return details;
    }
    remove(fromPos, toPos) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this.displayValue.length;
        this._value = this.displayValue.slice(0, fromPos) + this.displayValue.slice(toPos);
        return new (0, $b285a78e7d6163d8$export$2e2bcd8739ae039)();
    }
    /** Calls function and reapplies current value */ withValueRefresh(fn) {
        if (this._refreshing || !this._initialized) return fn();
        this._refreshing = true;
        const rawInput = this.rawInputValue;
        const value = this.value;
        const ret = fn();
        this.rawInputValue = rawInput;
        // append lost trailing chars at the end
        if (this.value && this.value !== value && value.indexOf(this.value) === 0) {
            this.append(value.slice(this.displayValue.length), {}, "");
            this.doCommit();
        }
        delete this._refreshing;
        return ret;
    }
    runIsolated(fn) {
        if (this._isolated || !this._initialized) return fn(this);
        this._isolated = true;
        const state = this.state;
        const ret = fn(this);
        this.state = state;
        delete this._isolated;
        return ret;
    }
    doSkipInvalid(ch, flags, checkTail) {
        return Boolean(this.skipInvalid);
    }
    /** Prepares string before mask processing */ doPrepare(str, flags) {
        if (flags === void 0) flags = {};
        return (0, $b285a78e7d6163d8$export$2e2bcd8739ae039).normalize(this.prepare ? this.prepare(str, this, flags) : str);
    }
    /** Prepares each char before mask processing */ doPrepareChar(str, flags) {
        if (flags === void 0) flags = {};
        return (0, $b285a78e7d6163d8$export$2e2bcd8739ae039).normalize(this.prepareChar ? this.prepareChar(str, this, flags) : str);
    }
    /** Validates if value is acceptable */ doValidate(flags) {
        return (!this.validate || this.validate(this.value, this, flags)) && (!this.parent || this.parent.doValidate(flags));
    }
    /** Does additional processing at the end of editing */ doCommit() {
        if (this.commit) this.commit(this.value, this);
    }
    splice(start, deleteCount, inserted, removeDirection, flags) {
        if (inserted === void 0) inserted = "";
        if (removeDirection === void 0) removeDirection = (0, $b4195841d15b2d87$export$9106728c49045482).NONE;
        if (flags === void 0) flags = {
            input: true
        };
        const tailPos = start + deleteCount;
        const tail = this.extractTail(tailPos);
        const eagerRemove = this.eager === true || this.eager === "remove";
        let oldRawValue;
        if (eagerRemove) {
            removeDirection = (0, $b4195841d15b2d87$export$32af4dafed14c8ce)(removeDirection);
            oldRawValue = this.extractInput(0, tailPos, {
                raw: true
            });
        }
        let startChangePos = start;
        const details = new (0, $b285a78e7d6163d8$export$2e2bcd8739ae039)();
        // if it is just deletion without insertion
        if (removeDirection !== (0, $b4195841d15b2d87$export$9106728c49045482).NONE) {
            startChangePos = this.nearestInputPos(start, deleteCount > 1 && start !== 0 && !eagerRemove ? (0, $b4195841d15b2d87$export$9106728c49045482).NONE : removeDirection);
            // adjust tailShift if start was aligned
            details.tailShift = startChangePos - start;
        }
        details.aggregate(this.remove(startChangePos));
        if (eagerRemove && removeDirection !== (0, $b4195841d15b2d87$export$9106728c49045482).NONE && oldRawValue === this.rawInputValue) {
            if (removeDirection === (0, $b4195841d15b2d87$export$9106728c49045482).FORCE_LEFT) {
                let valLength;
                while(oldRawValue === this.rawInputValue && (valLength = this.displayValue.length))details.aggregate(new (0, $b285a78e7d6163d8$export$2e2bcd8739ae039)({
                    tailShift: -1
                })).aggregate(this.remove(valLength - 1));
            } else if (removeDirection === (0, $b4195841d15b2d87$export$9106728c49045482).FORCE_RIGHT) tail.unshift();
        }
        return details.aggregate(this.append(inserted, flags, tail));
    }
    maskEquals(mask) {
        return this.mask === mask;
    }
    optionsIsChanged(opts) {
        return !(0, $b4195841d15b2d87$export$7aeb68f71172641d)(this, opts);
    }
    typedValueEquals(value) {
        const tval = this.typedValue;
        return value === tval || $9b02b15c72a43b68$export$2e2bcd8739ae039.EMPTY_VALUES.includes(value) && $9b02b15c72a43b68$export$2e2bcd8739ae039.EMPTY_VALUES.includes(tval) || (this.format ? this.format(value, this) === this.format(this.typedValue, this) : false);
    }
    pad(flags) {
        return new (0, $b285a78e7d6163d8$export$2e2bcd8739ae039)();
    }
}
$9b02b15c72a43b68$export$2e2bcd8739ae039.DEFAULTS = {
    skipInvalid: true
};
$9b02b15c72a43b68$export$2e2bcd8739ae039.EMPTY_VALUES = [
    undefined,
    null,
    ""
];
(0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).Masked = $9b02b15c72a43b68$export$2e2bcd8739ae039;











class $6a2e65700e83fd33$export$2e2bcd8739ae039 {
    /** */ constructor(chunks, from){
        if (chunks === void 0) chunks = [];
        if (from === void 0) from = 0;
        this.chunks = chunks;
        this.from = from;
    }
    toString() {
        return this.chunks.map(String).join("");
    }
    extend(tailChunk) {
        if (!String(tailChunk)) return;
        tailChunk = (0, $b4195841d15b2d87$export$844ec244b1367d54)(tailChunk) ? new (0, $8648f741d9791934$export$2e2bcd8739ae039)(String(tailChunk)) : tailChunk;
        const lastChunk = this.chunks[this.chunks.length - 1];
        const extendLast = lastChunk && // if stops are same or tail has no stop
        (lastChunk.stop === tailChunk.stop || tailChunk.stop == null) && // if tail chunk goes just after last chunk
        tailChunk.from === lastChunk.from + lastChunk.toString().length;
        if (tailChunk instanceof (0, $8648f741d9791934$export$2e2bcd8739ae039)) {
            // check the ability to extend previous chunk
            if (extendLast) // extend previous chunk
            lastChunk.extend(tailChunk.toString());
            else // append new chunk
            this.chunks.push(tailChunk);
        } else if (tailChunk instanceof $6a2e65700e83fd33$export$2e2bcd8739ae039) {
            if (tailChunk.stop == null) {
                // unwrap floating chunks to parent, keeping `from` pos
                let firstTailChunk;
                while(tailChunk.chunks.length && tailChunk.chunks[0].stop == null){
                    firstTailChunk = tailChunk.chunks.shift(); // not possible to be `undefined` because length was checked above
                    firstTailChunk.from += tailChunk.from;
                    this.extend(firstTailChunk);
                }
            }
            // if tail chunk still has value
            if (tailChunk.toString()) {
                // if chunks contains stops, then popup stop to container
                tailChunk.stop = tailChunk.blockIndex;
                this.chunks.push(tailChunk);
            }
        }
    }
    appendTo(masked) {
        if (!(masked instanceof (0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).MaskedPattern)) {
            const tail = new (0, $8648f741d9791934$export$2e2bcd8739ae039)(this.toString());
            return tail.appendTo(masked);
        }
        const details = new (0, $b285a78e7d6163d8$export$2e2bcd8739ae039)();
        for(let ci = 0; ci < this.chunks.length; ++ci){
            const chunk = this.chunks[ci];
            const lastBlockIter = masked._mapPosToBlock(masked.displayValue.length);
            const stop = chunk.stop;
            let chunkBlock;
            if (stop != null && // if block not found or stop is behind lastBlock
            (!lastBlockIter || lastBlockIter.index <= stop)) {
                if (chunk instanceof $6a2e65700e83fd33$export$2e2bcd8739ae039 || // for continuous block also check if stop is exist
                masked._stops.indexOf(stop) >= 0) details.aggregate(masked._appendPlaceholder(stop));
                chunkBlock = chunk instanceof $6a2e65700e83fd33$export$2e2bcd8739ae039 && masked._blocks[stop];
            }
            if (chunkBlock) {
                const tailDetails = chunkBlock.appendTail(chunk);
                details.aggregate(tailDetails);
                // get not inserted chars
                const remainChars = chunk.toString().slice(tailDetails.rawInserted.length);
                if (remainChars) details.aggregate(masked.append(remainChars, {
                    tail: true
                }));
            } else details.aggregate(masked.append(chunk.toString(), {
                tail: true
            }));
        }
        return details;
    }
    get state() {
        return {
            chunks: this.chunks.map((c)=>c.state),
            from: this.from,
            stop: this.stop,
            blockIndex: this.blockIndex
        };
    }
    set state(state) {
        const { chunks: chunks, ...props } = state;
        Object.assign(this, props);
        this.chunks = chunks.map((cstate)=>{
            const chunk = "chunks" in cstate ? new $6a2e65700e83fd33$export$2e2bcd8739ae039() : new (0, $8648f741d9791934$export$2e2bcd8739ae039)();
            chunk.state = cstate;
            return chunk;
        });
    }
    unshift(beforePos) {
        if (!this.chunks.length || beforePos != null && this.from >= beforePos) return "";
        const chunkShiftPos = beforePos != null ? beforePos - this.from : beforePos;
        let ci = 0;
        while(ci < this.chunks.length){
            const chunk = this.chunks[ci];
            const shiftChar = chunk.unshift(chunkShiftPos);
            if (chunk.toString()) {
                // chunk still contains value
                // but not shifted - means no more available chars to shift
                if (!shiftChar) break;
                ++ci;
            } else // clean if chunk has no value
            this.chunks.splice(ci, 1);
            if (shiftChar) return shiftChar;
        }
        return "";
    }
    shift() {
        if (!this.chunks.length) return "";
        let ci = this.chunks.length - 1;
        while(0 <= ci){
            const chunk = this.chunks[ci];
            const shiftChar = chunk.shift();
            if (chunk.toString()) {
                // chunk still contains value
                // but not shifted - means no more available chars to shift
                if (!shiftChar) break;
                --ci;
            } else // clean if chunk has no value
            this.chunks.splice(ci, 1);
            if (shiftChar) return shiftChar;
        }
        return "";
    }
}



class $f69f0b66e48a7ef0$export$2e2bcd8739ae039 {
    constructor(masked, pos){
        this.masked = masked;
        this._log = [];
        const { offset: offset, index: index } = masked._mapPosToBlock(pos) || (pos < 0 ? // first
        {
            index: 0,
            offset: 0
        } : // last
        {
            index: this.masked._blocks.length,
            offset: 0
        });
        this.offset = offset;
        this.index = index;
        this.ok = false;
    }
    get block() {
        return this.masked._blocks[this.index];
    }
    get pos() {
        return this.masked._blockStartPos(this.index) + this.offset;
    }
    get state() {
        return {
            index: this.index,
            offset: this.offset,
            ok: this.ok
        };
    }
    set state(s) {
        Object.assign(this, s);
    }
    pushState() {
        this._log.push(this.state);
    }
    popState() {
        const s = this._log.pop();
        if (s) this.state = s;
        return s;
    }
    bindBlock() {
        if (this.block) return;
        if (this.index < 0) {
            this.index = 0;
            this.offset = 0;
        }
        if (this.index >= this.masked._blocks.length) {
            this.index = this.masked._blocks.length - 1;
            this.offset = this.block.displayValue.length; // TODO this is stupid type error, `block` depends on index that was changed above
        }
    }
    _pushLeft(fn) {
        this.pushState();
        for(this.bindBlock(); 0 <= this.index; --this.index, this.offset = ((_this$block = this.block) == null ? void 0 : _this$block.displayValue.length) || 0){
            var _this$block;
            if (fn()) return this.ok = true;
        }
        return this.ok = false;
    }
    _pushRight(fn) {
        this.pushState();
        for(this.bindBlock(); this.index < this.masked._blocks.length; ++this.index, this.offset = 0){
            if (fn()) return this.ok = true;
        }
        return this.ok = false;
    }
    pushLeftBeforeFilled() {
        return this._pushLeft(()=>{
            if (this.block.isFixed || !this.block.value) return;
            this.offset = this.block.nearestInputPos(this.offset, (0, $b4195841d15b2d87$export$9106728c49045482).FORCE_LEFT);
            if (this.offset !== 0) return true;
        });
    }
    pushLeftBeforeInput() {
        // cases:
        // filled input: 00|
        // optional empty input: 00[]|
        // nested block: XX<[]>|
        return this._pushLeft(()=>{
            if (this.block.isFixed) return;
            this.offset = this.block.nearestInputPos(this.offset, (0, $b4195841d15b2d87$export$9106728c49045482).LEFT);
            return true;
        });
    }
    pushLeftBeforeRequired() {
        return this._pushLeft(()=>{
            if (this.block.isFixed || this.block.isOptional && !this.block.value) return;
            this.offset = this.block.nearestInputPos(this.offset, (0, $b4195841d15b2d87$export$9106728c49045482).LEFT);
            return true;
        });
    }
    pushRightBeforeFilled() {
        return this._pushRight(()=>{
            if (this.block.isFixed || !this.block.value) return;
            this.offset = this.block.nearestInputPos(this.offset, (0, $b4195841d15b2d87$export$9106728c49045482).FORCE_RIGHT);
            if (this.offset !== this.block.value.length) return true;
        });
    }
    pushRightBeforeInput() {
        return this._pushRight(()=>{
            if (this.block.isFixed) return;
            // const o = this.offset;
            this.offset = this.block.nearestInputPos(this.offset, (0, $b4195841d15b2d87$export$9106728c49045482).NONE);
            // HACK cases like (STILL DOES NOT WORK FOR NESTED)
            // aa|X
            // aa<X|[]>X_    - this will not work
            // if (o && o === this.offset && this.block instanceof PatternInputDefinition) continue;
            return true;
        });
    }
    pushRightBeforeRequired() {
        return this._pushRight(()=>{
            if (this.block.isFixed || this.block.isOptional && !this.block.value) return;
            // TODO check |[*]XX_
            this.offset = this.block.nearestInputPos(this.offset, (0, $b4195841d15b2d87$export$9106728c49045482).NONE);
            return true;
        });
    }
}






class $f65e3184e2233cc5$export$2e2bcd8739ae039 {
    /** */ /** */ /** */ /** */ /** */ /** */ constructor(opts){
        Object.assign(this, opts);
        this._value = "";
        this.isFixed = true;
    }
    get value() {
        return this._value;
    }
    get unmaskedValue() {
        return this.isUnmasking ? this.value : "";
    }
    get rawInputValue() {
        return this._isRawInput ? this.value : "";
    }
    get displayValue() {
        return this.value;
    }
    reset() {
        this._isRawInput = false;
        this._value = "";
    }
    remove(fromPos, toPos) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this._value.length;
        this._value = this._value.slice(0, fromPos) + this._value.slice(toPos);
        if (!this._value) this._isRawInput = false;
        return new (0, $b285a78e7d6163d8$export$2e2bcd8739ae039)();
    }
    nearestInputPos(cursorPos, direction) {
        if (direction === void 0) direction = (0, $b4195841d15b2d87$export$9106728c49045482).NONE;
        const minPos = 0;
        const maxPos = this._value.length;
        switch(direction){
            case (0, $b4195841d15b2d87$export$9106728c49045482).LEFT:
            case (0, $b4195841d15b2d87$export$9106728c49045482).FORCE_LEFT:
                return minPos;
            case (0, $b4195841d15b2d87$export$9106728c49045482).NONE:
            case (0, $b4195841d15b2d87$export$9106728c49045482).RIGHT:
            case (0, $b4195841d15b2d87$export$9106728c49045482).FORCE_RIGHT:
            default:
                return maxPos;
        }
    }
    totalInputPositions(fromPos, toPos) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this._value.length;
        return this._isRawInput ? toPos - fromPos : 0;
    }
    extractInput(fromPos, toPos, flags) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this._value.length;
        if (flags === void 0) flags = {};
        return flags.raw && this._isRawInput && this._value.slice(fromPos, toPos) || "";
    }
    get isComplete() {
        return true;
    }
    get isFilled() {
        return Boolean(this._value);
    }
    _appendChar(ch, flags) {
        if (flags === void 0) flags = {};
        if (this.isFilled) return new (0, $b285a78e7d6163d8$export$2e2bcd8739ae039)();
        const appendEager = this.eager === true || this.eager === "append";
        const appended = this.char === ch;
        const isResolved = appended && (this.isUnmasking || flags.input || flags.raw) && (!flags.raw || !appendEager) && !flags.tail;
        const details = new (0, $b285a78e7d6163d8$export$2e2bcd8739ae039)({
            inserted: this.char,
            rawInserted: isResolved ? this.char : ""
        });
        this._value = this.char;
        this._isRawInput = isResolved && (flags.raw || flags.input);
        return details;
    }
    _appendEager() {
        return this._appendChar(this.char, {
            tail: true
        });
    }
    _appendPlaceholder() {
        const details = new (0, $b285a78e7d6163d8$export$2e2bcd8739ae039)();
        if (this.isFilled) return details;
        this._value = details.inserted = this.char;
        return details;
    }
    extractTail() {
        return new (0, $8648f741d9791934$export$2e2bcd8739ae039)("");
    }
    appendTail(tail) {
        if ((0, $b4195841d15b2d87$export$844ec244b1367d54)(tail)) tail = new (0, $8648f741d9791934$export$2e2bcd8739ae039)(String(tail));
        return tail.appendTo(this);
    }
    append(str, flags, tail) {
        const details = this._appendChar(str[0], flags);
        if (tail != null) details.tailShift += this.appendTail(tail).tailShift;
        return details;
    }
    doCommit() {}
    get state() {
        return {
            _value: this._value,
            _rawInputValue: this.rawInputValue
        };
    }
    set state(state) {
        this._value = state._value;
        this._isRawInput = Boolean(state._rawInputValue);
    }
    pad(flags) {
        return this._appendPlaceholder();
    }
}






class $8bc8830b315da14a$export$2e2bcd8739ae039 {
    /** */ /** */ /** */ /** */ /** */ /** */ /** */ /** */ constructor(opts){
        const { parent: parent, isOptional: isOptional, placeholderChar: placeholderChar, displayChar: displayChar, lazy: lazy, eager: eager, ...maskOpts } = opts;
        this.masked = (0, $d30869383ae23901$export$2e2bcd8739ae039)(maskOpts);
        Object.assign(this, {
            parent: parent,
            isOptional: isOptional,
            placeholderChar: placeholderChar,
            displayChar: displayChar,
            lazy: lazy,
            eager: eager
        });
    }
    reset() {
        this.isFilled = false;
        this.masked.reset();
    }
    remove(fromPos, toPos) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this.value.length;
        if (fromPos === 0 && toPos >= 1) {
            this.isFilled = false;
            return this.masked.remove(fromPos, toPos);
        }
        return new (0, $b285a78e7d6163d8$export$2e2bcd8739ae039)();
    }
    get value() {
        return this.masked.value || (this.isFilled && !this.isOptional ? this.placeholderChar : "");
    }
    get unmaskedValue() {
        return this.masked.unmaskedValue;
    }
    get rawInputValue() {
        return this.masked.rawInputValue;
    }
    get displayValue() {
        return this.masked.value && this.displayChar || this.value;
    }
    get isComplete() {
        return Boolean(this.masked.value) || this.isOptional;
    }
    _appendChar(ch, flags) {
        if (flags === void 0) flags = {};
        if (this.isFilled) return new (0, $b285a78e7d6163d8$export$2e2bcd8739ae039)();
        const state = this.masked.state;
        // simulate input
        let details = this.masked._appendChar(ch, this.currentMaskFlags(flags));
        if (details.inserted && this.doValidate(flags) === false) {
            details = new (0, $b285a78e7d6163d8$export$2e2bcd8739ae039)();
            this.masked.state = state;
        }
        if (!details.inserted && !this.isOptional && !this.lazy && !flags.input) details.inserted = this.placeholderChar;
        details.skip = !details.inserted && !this.isOptional;
        this.isFilled = Boolean(details.inserted);
        return details;
    }
    append(str, flags, tail) {
        // TODO probably should be done via _appendChar
        return this.masked.append(str, this.currentMaskFlags(flags), tail);
    }
    _appendPlaceholder() {
        if (this.isFilled || this.isOptional) return new (0, $b285a78e7d6163d8$export$2e2bcd8739ae039)();
        this.isFilled = true;
        return new (0, $b285a78e7d6163d8$export$2e2bcd8739ae039)({
            inserted: this.placeholderChar
        });
    }
    _appendEager() {
        return new (0, $b285a78e7d6163d8$export$2e2bcd8739ae039)();
    }
    extractTail(fromPos, toPos) {
        return this.masked.extractTail(fromPos, toPos);
    }
    appendTail(tail) {
        return this.masked.appendTail(tail);
    }
    extractInput(fromPos, toPos, flags) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this.value.length;
        return this.masked.extractInput(fromPos, toPos, flags);
    }
    nearestInputPos(cursorPos, direction) {
        if (direction === void 0) direction = (0, $b4195841d15b2d87$export$9106728c49045482).NONE;
        const minPos = 0;
        const maxPos = this.value.length;
        const boundPos = Math.min(Math.max(cursorPos, minPos), maxPos);
        switch(direction){
            case (0, $b4195841d15b2d87$export$9106728c49045482).LEFT:
            case (0, $b4195841d15b2d87$export$9106728c49045482).FORCE_LEFT:
                return this.isComplete ? boundPos : minPos;
            case (0, $b4195841d15b2d87$export$9106728c49045482).RIGHT:
            case (0, $b4195841d15b2d87$export$9106728c49045482).FORCE_RIGHT:
                return this.isComplete ? boundPos : maxPos;
            case (0, $b4195841d15b2d87$export$9106728c49045482).NONE:
            default:
                return boundPos;
        }
    }
    totalInputPositions(fromPos, toPos) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this.value.length;
        return this.value.slice(fromPos, toPos).length;
    }
    doValidate(flags) {
        return this.masked.doValidate(this.currentMaskFlags(flags)) && (!this.parent || this.parent.doValidate(this.currentMaskFlags(flags)));
    }
    doCommit() {
        this.masked.doCommit();
    }
    get state() {
        return {
            _value: this.value,
            _rawInputValue: this.rawInputValue,
            masked: this.masked.state,
            isFilled: this.isFilled
        };
    }
    set state(state) {
        this.masked.state = state.masked;
        this.isFilled = state.isFilled;
    }
    currentMaskFlags(flags) {
        var _flags$_beforeTailSta;
        return {
            ...flags,
            _beforeTailState: (flags == null || (_flags$_beforeTailSta = flags._beforeTailState) == null ? void 0 : _flags$_beforeTailSta.masked) || (flags == null ? void 0 : flags._beforeTailState)
        };
    }
    pad(flags) {
        return new (0, $b285a78e7d6163d8$export$2e2bcd8739ae039)();
    }
}
$8bc8830b315da14a$export$2e2bcd8739ae039.DEFAULT_DEFINITIONS = {
    "0": /\d/,
    "a": /[\u0041-\u005A\u0061-\u007A\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0\u08A2-\u08AC\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097F\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA697\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA793\uA7A0-\uA7AA\uA7F8-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA80-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/,
    // http://stackoverflow.com/a/22075070
    "*": /./
};







/** Masking by RegExp */ class $3514f0c5efff08c9$export$2e2bcd8739ae039 extends (0, $9b02b15c72a43b68$export$2e2bcd8739ae039) {
    /** */ /** Enable characters overwriting */ /** */ /** */ /** */ updateOptions(opts) {
        super.updateOptions(opts);
    }
    _update(opts) {
        const mask = opts.mask;
        if (mask) opts.validate = (value)=>value.search(mask) >= 0;
        super._update(opts);
    }
}
(0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).MaskedRegExp = $3514f0c5efff08c9$export$2e2bcd8739ae039;



/** Pattern mask */ class $855f132dbdeea111$export$2e2bcd8739ae039 extends (0, $9b02b15c72a43b68$export$2e2bcd8739ae039) {
    /** */ /** */ /** Single char for empty input */ /** Single char for filled input */ /** Show placeholder only when needed */ /** Enable characters overwriting */ /** */ /** */ /** */ constructor(opts){
        super({
            ...$855f132dbdeea111$export$2e2bcd8739ae039.DEFAULTS,
            ...opts,
            definitions: Object.assign({}, (0, $8bc8830b315da14a$export$2e2bcd8739ae039).DEFAULT_DEFINITIONS, opts == null ? void 0 : opts.definitions)
        });
    }
    updateOptions(opts) {
        super.updateOptions(opts);
    }
    _update(opts) {
        opts.definitions = Object.assign({}, this.definitions, opts.definitions);
        super._update(opts);
        this._rebuildMask();
    }
    _rebuildMask() {
        const defs = this.definitions;
        this._blocks = [];
        this.exposeBlock = undefined;
        this._stops = [];
        this._maskedBlocks = {};
        const pattern = this.mask;
        if (!pattern || !defs) return;
        let unmaskingBlock = false;
        let optionalBlock = false;
        for(let i = 0; i < pattern.length; ++i){
            if (this.blocks) {
                const p = pattern.slice(i);
                const bNames = Object.keys(this.blocks).filter((bName)=>p.indexOf(bName) === 0);
                // order by key length
                bNames.sort((a, b)=>b.length - a.length);
                // use block name with max length
                const bName = bNames[0];
                if (bName) {
                    const { expose: expose, repeat: repeat, ...bOpts } = (0, $d30869383ae23901$export$a213ae1c699d7230)(this.blocks[bName]); // TODO type Opts<Arg & Extra>
                    const blockOpts = {
                        lazy: this.lazy,
                        eager: this.eager,
                        placeholderChar: this.placeholderChar,
                        displayChar: this.displayChar,
                        overwrite: this.overwrite,
                        autofix: this.autofix,
                        ...bOpts,
                        repeat: repeat,
                        parent: this
                    };
                    const maskedBlock = repeat != null ? new (0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).RepeatBlock(blockOpts /* TODO */ ) : (0, $d30869383ae23901$export$2e2bcd8739ae039)(blockOpts);
                    if (maskedBlock) {
                        this._blocks.push(maskedBlock);
                        if (expose) this.exposeBlock = maskedBlock;
                        // store block index
                        if (!this._maskedBlocks[bName]) this._maskedBlocks[bName] = [];
                        this._maskedBlocks[bName].push(this._blocks.length - 1);
                    }
                    i += bName.length - 1;
                    continue;
                }
            }
            let char = pattern[i];
            let isInput = char in defs;
            if (char === $855f132dbdeea111$export$2e2bcd8739ae039.STOP_CHAR) {
                this._stops.push(this._blocks.length);
                continue;
            }
            if (char === "{" || char === "}") {
                unmaskingBlock = !unmaskingBlock;
                continue;
            }
            if (char === "[" || char === "]") {
                optionalBlock = !optionalBlock;
                continue;
            }
            if (char === $855f132dbdeea111$export$2e2bcd8739ae039.ESCAPE_CHAR) {
                ++i;
                char = pattern[i];
                if (!char) break;
                isInput = false;
            }
            const def = isInput ? new (0, $8bc8830b315da14a$export$2e2bcd8739ae039)({
                isOptional: optionalBlock,
                lazy: this.lazy,
                eager: this.eager,
                placeholderChar: this.placeholderChar,
                displayChar: this.displayChar,
                ...(0, $d30869383ae23901$export$a213ae1c699d7230)(defs[char]),
                parent: this
            }) : new (0, $f65e3184e2233cc5$export$2e2bcd8739ae039)({
                char: char,
                eager: this.eager,
                isUnmasking: unmaskingBlock
            });
            this._blocks.push(def);
        }
    }
    get state() {
        return {
            ...super.state,
            _blocks: this._blocks.map((b)=>b.state)
        };
    }
    set state(state) {
        if (!state) {
            this.reset();
            return;
        }
        const { _blocks: _blocks, ...maskedState } = state;
        this._blocks.forEach((b, bi)=>b.state = _blocks[bi]);
        super.state = maskedState;
    }
    reset() {
        super.reset();
        this._blocks.forEach((b)=>b.reset());
    }
    get isComplete() {
        return this.exposeBlock ? this.exposeBlock.isComplete : this._blocks.every((b)=>b.isComplete);
    }
    get isFilled() {
        return this._blocks.every((b)=>b.isFilled);
    }
    get isFixed() {
        return this._blocks.every((b)=>b.isFixed);
    }
    get isOptional() {
        return this._blocks.every((b)=>b.isOptional);
    }
    doCommit() {
        this._blocks.forEach((b)=>b.doCommit());
        super.doCommit();
    }
    get unmaskedValue() {
        return this.exposeBlock ? this.exposeBlock.unmaskedValue : this._blocks.reduce((str, b)=>str += b.unmaskedValue, "");
    }
    set unmaskedValue(unmaskedValue) {
        if (this.exposeBlock) {
            const tail = this.extractTail(this._blockStartPos(this._blocks.indexOf(this.exposeBlock)) + this.exposeBlock.displayValue.length);
            this.exposeBlock.unmaskedValue = unmaskedValue;
            this.appendTail(tail);
            this.doCommit();
        } else super.unmaskedValue = unmaskedValue;
    }
    get value() {
        return this.exposeBlock ? this.exposeBlock.value : // TODO return _value when not in change?
        this._blocks.reduce((str, b)=>str += b.value, "");
    }
    set value(value) {
        if (this.exposeBlock) {
            const tail = this.extractTail(this._blockStartPos(this._blocks.indexOf(this.exposeBlock)) + this.exposeBlock.displayValue.length);
            this.exposeBlock.value = value;
            this.appendTail(tail);
            this.doCommit();
        } else super.value = value;
    }
    get typedValue() {
        return this.exposeBlock ? this.exposeBlock.typedValue : super.typedValue;
    }
    set typedValue(value) {
        if (this.exposeBlock) {
            const tail = this.extractTail(this._blockStartPos(this._blocks.indexOf(this.exposeBlock)) + this.exposeBlock.displayValue.length);
            this.exposeBlock.typedValue = value;
            this.appendTail(tail);
            this.doCommit();
        } else super.typedValue = value;
    }
    get displayValue() {
        return this._blocks.reduce((str, b)=>str += b.displayValue, "");
    }
    appendTail(tail) {
        return super.appendTail(tail).aggregate(this._appendPlaceholder());
    }
    _appendEager() {
        var _this$_mapPosToBlock;
        const details = new (0, $b285a78e7d6163d8$export$2e2bcd8739ae039)();
        let startBlockIndex = (_this$_mapPosToBlock = this._mapPosToBlock(this.displayValue.length)) == null ? void 0 : _this$_mapPosToBlock.index;
        if (startBlockIndex == null) return details;
        // TODO test if it works for nested pattern masks
        if (this._blocks[startBlockIndex].isFilled) ++startBlockIndex;
        for(let bi = startBlockIndex; bi < this._blocks.length; ++bi){
            const d = this._blocks[bi]._appendEager();
            if (!d.inserted) break;
            details.aggregate(d);
        }
        return details;
    }
    _appendCharRaw(ch, flags) {
        if (flags === void 0) flags = {};
        const blockIter = this._mapPosToBlock(this.displayValue.length);
        const details = new (0, $b285a78e7d6163d8$export$2e2bcd8739ae039)();
        if (!blockIter) return details;
        for(let bi = blockIter.index, block; block = this._blocks[bi]; ++bi){
            var _flags$_beforeTailSta;
            const blockDetails = block._appendChar(ch, {
                ...flags,
                _beforeTailState: (_flags$_beforeTailSta = flags._beforeTailState) == null || (_flags$_beforeTailSta = _flags$_beforeTailSta._blocks) == null ? void 0 : _flags$_beforeTailSta[bi]
            });
            details.aggregate(blockDetails);
            if (blockDetails.consumed) break; // go next char
        }
        return details;
    }
    extractTail(fromPos, toPos) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this.displayValue.length;
        const chunkTail = new (0, $6a2e65700e83fd33$export$2e2bcd8739ae039)();
        if (fromPos === toPos) return chunkTail;
        this._forEachBlocksInRange(fromPos, toPos, (b, bi, bFromPos, bToPos)=>{
            const blockChunk = b.extractTail(bFromPos, bToPos);
            blockChunk.stop = this._findStopBefore(bi);
            blockChunk.from = this._blockStartPos(bi);
            if (blockChunk instanceof (0, $6a2e65700e83fd33$export$2e2bcd8739ae039)) blockChunk.blockIndex = bi;
            chunkTail.extend(blockChunk);
        });
        return chunkTail;
    }
    extractInput(fromPos, toPos, flags) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this.displayValue.length;
        if (flags === void 0) flags = {};
        if (fromPos === toPos) return "";
        let input = "";
        this._forEachBlocksInRange(fromPos, toPos, (b, _, fromPos, toPos)=>{
            input += b.extractInput(fromPos, toPos, flags);
        });
        return input;
    }
    _findStopBefore(blockIndex) {
        let stopBefore;
        for(let si = 0; si < this._stops.length; ++si){
            const stop = this._stops[si];
            if (stop <= blockIndex) stopBefore = stop;
            else break;
        }
        return stopBefore;
    }
    /** Appends placeholder depending on laziness */ _appendPlaceholder(toBlockIndex) {
        const details = new (0, $b285a78e7d6163d8$export$2e2bcd8739ae039)();
        if (this.lazy && toBlockIndex == null) return details;
        const startBlockIter = this._mapPosToBlock(this.displayValue.length);
        if (!startBlockIter) return details;
        const startBlockIndex = startBlockIter.index;
        const endBlockIndex = toBlockIndex != null ? toBlockIndex : this._blocks.length;
        this._blocks.slice(startBlockIndex, endBlockIndex).forEach((b)=>{
            if (!b.lazy || toBlockIndex != null) {
                var _blocks2;
                details.aggregate(b._appendPlaceholder((_blocks2 = b._blocks) == null ? void 0 : _blocks2.length));
            }
        });
        return details;
    }
    /** Finds block in pos */ _mapPosToBlock(pos) {
        let accVal = "";
        for(let bi = 0; bi < this._blocks.length; ++bi){
            const block = this._blocks[bi];
            const blockStartPos = accVal.length;
            accVal += block.displayValue;
            if (pos <= accVal.length) return {
                index: bi,
                offset: pos - blockStartPos
            };
        }
    }
    _blockStartPos(blockIndex) {
        return this._blocks.slice(0, blockIndex).reduce((pos, b)=>pos += b.displayValue.length, 0);
    }
    _forEachBlocksInRange(fromPos, toPos, fn) {
        if (toPos === void 0) toPos = this.displayValue.length;
        const fromBlockIter = this._mapPosToBlock(fromPos);
        if (fromBlockIter) {
            const toBlockIter = this._mapPosToBlock(toPos);
            // process first block
            const isSameBlock = toBlockIter && fromBlockIter.index === toBlockIter.index;
            const fromBlockStartPos = fromBlockIter.offset;
            const fromBlockEndPos = toBlockIter && isSameBlock ? toBlockIter.offset : this._blocks[fromBlockIter.index].displayValue.length;
            fn(this._blocks[fromBlockIter.index], fromBlockIter.index, fromBlockStartPos, fromBlockEndPos);
            if (toBlockIter && !isSameBlock) {
                // process intermediate blocks
                for(let bi = fromBlockIter.index + 1; bi < toBlockIter.index; ++bi)fn(this._blocks[bi], bi, 0, this._blocks[bi].displayValue.length);
                // process last block
                fn(this._blocks[toBlockIter.index], toBlockIter.index, 0, toBlockIter.offset);
            }
        }
    }
    remove(fromPos, toPos) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this.displayValue.length;
        const removeDetails = super.remove(fromPos, toPos);
        this._forEachBlocksInRange(fromPos, toPos, (b, _, bFromPos, bToPos)=>{
            removeDetails.aggregate(b.remove(bFromPos, bToPos));
        });
        return removeDetails;
    }
    nearestInputPos(cursorPos, direction) {
        if (direction === void 0) direction = (0, $b4195841d15b2d87$export$9106728c49045482).NONE;
        if (!this._blocks.length) return 0;
        const cursor = new (0, $f69f0b66e48a7ef0$export$2e2bcd8739ae039)(this, cursorPos);
        if (direction === (0, $b4195841d15b2d87$export$9106728c49045482).NONE) {
            // -------------------------------------------------
            // NONE should only go out from fixed to the right!
            // -------------------------------------------------
            if (cursor.pushRightBeforeInput()) return cursor.pos;
            cursor.popState();
            if (cursor.pushLeftBeforeInput()) return cursor.pos;
            return this.displayValue.length;
        }
        // FORCE is only about a|* otherwise is 0
        if (direction === (0, $b4195841d15b2d87$export$9106728c49045482).LEFT || direction === (0, $b4195841d15b2d87$export$9106728c49045482).FORCE_LEFT) {
            // try to break fast when *|a
            if (direction === (0, $b4195841d15b2d87$export$9106728c49045482).LEFT) {
                cursor.pushRightBeforeFilled();
                if (cursor.ok && cursor.pos === cursorPos) return cursorPos;
                cursor.popState();
            }
            // forward flow
            cursor.pushLeftBeforeInput();
            cursor.pushLeftBeforeRequired();
            cursor.pushLeftBeforeFilled();
            // backward flow
            if (direction === (0, $b4195841d15b2d87$export$9106728c49045482).LEFT) {
                cursor.pushRightBeforeInput();
                cursor.pushRightBeforeRequired();
                if (cursor.ok && cursor.pos <= cursorPos) return cursor.pos;
                cursor.popState();
                if (cursor.ok && cursor.pos <= cursorPos) return cursor.pos;
                cursor.popState();
            }
            if (cursor.ok) return cursor.pos;
            if (direction === (0, $b4195841d15b2d87$export$9106728c49045482).FORCE_LEFT) return 0;
            cursor.popState();
            if (cursor.ok) return cursor.pos;
            cursor.popState();
            if (cursor.ok) return cursor.pos;
            return 0;
        }
        if (direction === (0, $b4195841d15b2d87$export$9106728c49045482).RIGHT || direction === (0, $b4195841d15b2d87$export$9106728c49045482).FORCE_RIGHT) {
            // forward flow
            cursor.pushRightBeforeInput();
            cursor.pushRightBeforeRequired();
            if (cursor.pushRightBeforeFilled()) return cursor.pos;
            if (direction === (0, $b4195841d15b2d87$export$9106728c49045482).FORCE_RIGHT) return this.displayValue.length;
            // backward flow
            cursor.popState();
            if (cursor.ok) return cursor.pos;
            cursor.popState();
            if (cursor.ok) return cursor.pos;
            return this.nearestInputPos(cursorPos, (0, $b4195841d15b2d87$export$9106728c49045482).LEFT);
        }
        return cursorPos;
    }
    totalInputPositions(fromPos, toPos) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this.displayValue.length;
        let total = 0;
        this._forEachBlocksInRange(fromPos, toPos, (b, _, bFromPos, bToPos)=>{
            total += b.totalInputPositions(bFromPos, bToPos);
        });
        return total;
    }
    /** Get block by name */ maskedBlock(name) {
        return this.maskedBlocks(name)[0];
    }
    /** Get all blocks by name */ maskedBlocks(name) {
        const indices = this._maskedBlocks[name];
        if (!indices) return [];
        return indices.map((gi)=>this._blocks[gi]);
    }
    pad(flags) {
        const details = new (0, $b285a78e7d6163d8$export$2e2bcd8739ae039)();
        this._forEachBlocksInRange(0, this.displayValue.length, (b)=>details.aggregate(b.pad(flags)));
        return details;
    }
}
$855f132dbdeea111$export$2e2bcd8739ae039.DEFAULTS = {
    ...(0, $9b02b15c72a43b68$export$2e2bcd8739ae039).DEFAULTS,
    lazy: true,
    placeholderChar: "_"
};
$855f132dbdeea111$export$2e2bcd8739ae039.STOP_CHAR = "`";
$855f132dbdeea111$export$2e2bcd8739ae039.ESCAPE_CHAR = "\\";
$855f132dbdeea111$export$2e2bcd8739ae039.InputDefinition = (0, $8bc8830b315da14a$export$2e2bcd8739ae039);
$855f132dbdeea111$export$2e2bcd8739ae039.FixedDefinition = (0, $f65e3184e2233cc5$export$2e2bcd8739ae039);
(0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).MaskedPattern = $855f132dbdeea111$export$2e2bcd8739ae039;














/** Pattern which accepts ranges */ class $cffc19e600b54687$export$2e2bcd8739ae039 extends (0, $855f132dbdeea111$export$2e2bcd8739ae039) {
    /**
    Optionally sets max length of pattern.
    Used when pattern length is longer then `to` param length. Pads zeros at start in this case.
  */ /** Min bound */ /** Max bound */ get _matchFrom() {
        return this.maxLength - String(this.from).length;
    }
    constructor(opts){
        super(opts); // mask will be created in _update
    }
    updateOptions(opts) {
        super.updateOptions(opts);
    }
    _update(opts) {
        const { to: to = this.to || 0, from: from = this.from || 0, maxLength: maxLength = this.maxLength || 0, autofix: autofix = this.autofix, ...patternOpts } = opts;
        this.to = to;
        this.from = from;
        this.maxLength = Math.max(String(to).length, maxLength);
        this.autofix = autofix;
        const fromStr = String(this.from).padStart(this.maxLength, "0");
        const toStr = String(this.to).padStart(this.maxLength, "0");
        let sameCharsCount = 0;
        while(sameCharsCount < toStr.length && toStr[sameCharsCount] === fromStr[sameCharsCount])++sameCharsCount;
        patternOpts.mask = toStr.slice(0, sameCharsCount).replace(/0/g, "\\0") + "0".repeat(this.maxLength - sameCharsCount);
        super._update(patternOpts);
    }
    get isComplete() {
        return super.isComplete && Boolean(this.value);
    }
    boundaries(str) {
        let minstr = "";
        let maxstr = "";
        const [, placeholder, num] = str.match(/^(\D*)(\d*)(\D*)/) || [];
        if (num) {
            minstr = "0".repeat(placeholder.length) + num;
            maxstr = "9".repeat(placeholder.length) + num;
        }
        minstr = minstr.padEnd(this.maxLength, "0");
        maxstr = maxstr.padEnd(this.maxLength, "9");
        return [
            minstr,
            maxstr
        ];
    }
    doPrepareChar(ch, flags) {
        if (flags === void 0) flags = {};
        let details;
        [ch, details] = super.doPrepareChar(ch.replace(/\D/g, ""), flags);
        if (!ch) details.skip = !this.isComplete;
        return [
            ch,
            details
        ];
    }
    _appendCharRaw(ch, flags) {
        if (flags === void 0) flags = {};
        if (!this.autofix || this.value.length + 1 > this.maxLength) return super._appendCharRaw(ch, flags);
        const fromStr = String(this.from).padStart(this.maxLength, "0");
        const toStr = String(this.to).padStart(this.maxLength, "0");
        const [minstr, maxstr] = this.boundaries(this.value + ch);
        if (Number(maxstr) < this.from) return super._appendCharRaw(fromStr[this.value.length], flags);
        if (Number(minstr) > this.to) {
            if (!flags.tail && this.autofix === "pad" && this.value.length + 1 < this.maxLength) return super._appendCharRaw(fromStr[this.value.length], flags).aggregate(this._appendCharRaw(ch, flags));
            return super._appendCharRaw(toStr[this.value.length], flags);
        }
        return super._appendCharRaw(ch, flags);
    }
    doValidate(flags) {
        const str = this.value;
        const firstNonZero = str.search(/[^0]/);
        if (firstNonZero === -1 && str.length <= this._matchFrom) return true;
        const [minstr, maxstr] = this.boundaries(str);
        return this.from <= Number(maxstr) && Number(minstr) <= this.to && super.doValidate(flags);
    }
    pad(flags) {
        const details = new (0, $b285a78e7d6163d8$export$2e2bcd8739ae039)();
        if (this.value.length === this.maxLength) return details;
        const value = this.value;
        const padLength = this.maxLength - this.value.length;
        if (padLength) {
            this.reset();
            for(let i = 0; i < padLength; ++i)details.aggregate(super._appendCharRaw("0", flags));
            // append tail
            value.split("").forEach((ch)=>this._appendCharRaw(ch));
        }
        return details;
    }
}
(0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).MaskedRange = $cffc19e600b54687$export$2e2bcd8739ae039;













const $88a08c76ce88c37c$var$DefaultPattern = "d{.}`m{.}`Y";
// Make format and parse required when pattern is provided
/** Date mask */ class $88a08c76ce88c37c$export$2e2bcd8739ae039 extends (0, $855f132dbdeea111$export$2e2bcd8739ae039) {
    static extractPatternOptions(opts) {
        const { mask: mask, pattern: pattern, ...patternOpts } = opts;
        return {
            ...patternOpts,
            mask: (0, $b4195841d15b2d87$export$844ec244b1367d54)(mask) ? mask : pattern
        };
    }
    /** Pattern mask for date according to {@link MaskedDate#format} */ /** Start date */ /** End date */ /** Format typed value to string */ /** Parse string to get typed value */ constructor(opts){
        super($88a08c76ce88c37c$export$2e2bcd8739ae039.extractPatternOptions({
            ...$88a08c76ce88c37c$export$2e2bcd8739ae039.DEFAULTS,
            ...opts
        }));
    }
    updateOptions(opts) {
        super.updateOptions(opts);
    }
    _update(opts) {
        const { mask: mask, pattern: pattern, blocks: blocks, ...patternOpts } = {
            ...$88a08c76ce88c37c$export$2e2bcd8739ae039.DEFAULTS,
            ...opts
        };
        const patternBlocks = Object.assign({}, $88a08c76ce88c37c$export$2e2bcd8739ae039.GET_DEFAULT_BLOCKS());
        // adjust year block
        if (opts.min) patternBlocks.Y.from = opts.min.getFullYear();
        if (opts.max) patternBlocks.Y.to = opts.max.getFullYear();
        if (opts.min && opts.max && patternBlocks.Y.from === patternBlocks.Y.to) {
            patternBlocks.m.from = opts.min.getMonth() + 1;
            patternBlocks.m.to = opts.max.getMonth() + 1;
            if (patternBlocks.m.from === patternBlocks.m.to) {
                patternBlocks.d.from = opts.min.getDate();
                patternBlocks.d.to = opts.max.getDate();
            }
        }
        Object.assign(patternBlocks, this.blocks, blocks);
        super._update({
            ...patternOpts,
            mask: (0, $b4195841d15b2d87$export$844ec244b1367d54)(mask) ? mask : pattern,
            blocks: patternBlocks
        });
    }
    doValidate(flags) {
        const date = this.date;
        return super.doValidate(flags) && (!this.isComplete || this.isDateExist(this.value) && date != null && (this.min == null || this.min <= date) && (this.max == null || date <= this.max));
    }
    /** Checks if date is exists */ isDateExist(str) {
        return this.format(this.parse(str, this), this).indexOf(str) >= 0;
    }
    /** Parsed Date */ get date() {
        return this.typedValue;
    }
    set date(date) {
        this.typedValue = date;
    }
    get typedValue() {
        return this.isComplete ? super.typedValue : null;
    }
    set typedValue(value) {
        super.typedValue = value;
    }
    maskEquals(mask) {
        return mask === Date || super.maskEquals(mask);
    }
    optionsIsChanged(opts) {
        return super.optionsIsChanged($88a08c76ce88c37c$export$2e2bcd8739ae039.extractPatternOptions(opts));
    }
}
$88a08c76ce88c37c$export$2e2bcd8739ae039.GET_DEFAULT_BLOCKS = ()=>({
        d: {
            mask: (0, $cffc19e600b54687$export$2e2bcd8739ae039),
            from: 1,
            to: 31,
            maxLength: 2
        },
        m: {
            mask: (0, $cffc19e600b54687$export$2e2bcd8739ae039),
            from: 1,
            to: 12,
            maxLength: 2
        },
        Y: {
            mask: (0, $cffc19e600b54687$export$2e2bcd8739ae039),
            from: 1900,
            to: 9999
        }
    });
$88a08c76ce88c37c$export$2e2bcd8739ae039.DEFAULTS = {
    ...(0, $855f132dbdeea111$export$2e2bcd8739ae039).DEFAULTS,
    mask: Date,
    pattern: $88a08c76ce88c37c$var$DefaultPattern,
    format: (date, masked)=>{
        if (!date) return "";
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        return [
            day,
            month,
            year
        ].join(".");
    },
    parse: (str, masked)=>{
        const [day, month, year] = str.split(".").map(Number);
        return new Date(year, month - 1, day);
    }
};
(0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).MaskedDate = $88a08c76ce88c37c$export$2e2bcd8739ae039;








/** Dynamic mask for choosing appropriate mask in run-time */ class $7708daf759dfe080$export$2e2bcd8739ae039 extends (0, $9b02b15c72a43b68$export$2e2bcd8739ae039) {
    constructor(opts){
        super({
            ...$7708daf759dfe080$export$2e2bcd8739ae039.DEFAULTS,
            ...opts
        });
        this.currentMask = undefined;
    }
    updateOptions(opts) {
        super.updateOptions(opts);
    }
    _update(opts) {
        super._update(opts);
        if ("mask" in opts) {
            this.exposeMask = undefined;
            // mask could be totally dynamic with only `dispatch` option
            this.compiledMasks = Array.isArray(opts.mask) ? opts.mask.map((m)=>{
                const { expose: expose, ...maskOpts } = (0, $d30869383ae23901$export$a213ae1c699d7230)(m);
                const masked = (0, $d30869383ae23901$export$2e2bcd8739ae039)({
                    overwrite: this._overwrite,
                    eager: this._eager,
                    skipInvalid: this._skipInvalid,
                    ...maskOpts
                });
                if (expose) this.exposeMask = masked;
                return masked;
            }) : [];
        // this.currentMask = this.doDispatch(''); // probably not needed but lets see
        }
    }
    _appendCharRaw(ch, flags) {
        if (flags === void 0) flags = {};
        const details = this._applyDispatch(ch, flags);
        if (this.currentMask) details.aggregate(this.currentMask._appendChar(ch, this.currentMaskFlags(flags)));
        return details;
    }
    _applyDispatch(appended, flags, tail) {
        if (appended === void 0) appended = "";
        if (flags === void 0) flags = {};
        if (tail === void 0) tail = "";
        const prevValueBeforeTail = flags.tail && flags._beforeTailState != null ? flags._beforeTailState._value : this.value;
        const inputValue = this.rawInputValue;
        const insertValue = flags.tail && flags._beforeTailState != null ? flags._beforeTailState._rawInputValue : inputValue;
        const tailValue = inputValue.slice(insertValue.length);
        const prevMask = this.currentMask;
        const details = new (0, $b285a78e7d6163d8$export$2e2bcd8739ae039)();
        const prevMaskState = prevMask == null ? void 0 : prevMask.state;
        // clone flags to prevent overwriting `_beforeTailState`
        this.currentMask = this.doDispatch(appended, {
            ...flags
        }, tail);
        // restore state after dispatch
        if (this.currentMask) {
            if (this.currentMask !== prevMask) {
                // if mask changed reapply input
                this.currentMask.reset();
                if (insertValue) {
                    this.currentMask.append(insertValue, {
                        raw: true
                    });
                    details.tailShift = this.currentMask.value.length - prevValueBeforeTail.length;
                }
                if (tailValue) details.tailShift += this.currentMask.append(tailValue, {
                    raw: true,
                    tail: true
                }).tailShift;
            } else if (prevMaskState) // Dispatch can do something bad with state, so
            // restore prev mask state
            this.currentMask.state = prevMaskState;
        }
        return details;
    }
    _appendPlaceholder() {
        const details = this._applyDispatch();
        if (this.currentMask) details.aggregate(this.currentMask._appendPlaceholder());
        return details;
    }
    _appendEager() {
        const details = this._applyDispatch();
        if (this.currentMask) details.aggregate(this.currentMask._appendEager());
        return details;
    }
    appendTail(tail) {
        const details = new (0, $b285a78e7d6163d8$export$2e2bcd8739ae039)();
        if (tail) details.aggregate(this._applyDispatch("", {}, tail));
        return details.aggregate(this.currentMask ? this.currentMask.appendTail(tail) : super.appendTail(tail));
    }
    currentMaskFlags(flags) {
        var _flags$_beforeTailSta, _flags$_beforeTailSta2;
        return {
            ...flags,
            _beforeTailState: ((_flags$_beforeTailSta = flags._beforeTailState) == null ? void 0 : _flags$_beforeTailSta.currentMaskRef) === this.currentMask && ((_flags$_beforeTailSta2 = flags._beforeTailState) == null ? void 0 : _flags$_beforeTailSta2.currentMask) || flags._beforeTailState
        };
    }
    doDispatch(appended, flags, tail) {
        if (flags === void 0) flags = {};
        if (tail === void 0) tail = "";
        return this.dispatch(appended, this, flags, tail);
    }
    doValidate(flags) {
        return super.doValidate(flags) && (!this.currentMask || this.currentMask.doValidate(this.currentMaskFlags(flags)));
    }
    doPrepare(str, flags) {
        if (flags === void 0) flags = {};
        let [s, details] = super.doPrepare(str, flags);
        if (this.currentMask) {
            let currentDetails;
            [s, currentDetails] = super.doPrepare(s, this.currentMaskFlags(flags));
            details = details.aggregate(currentDetails);
        }
        return [
            s,
            details
        ];
    }
    doPrepareChar(str, flags) {
        if (flags === void 0) flags = {};
        let [s, details] = super.doPrepareChar(str, flags);
        if (this.currentMask) {
            let currentDetails;
            [s, currentDetails] = super.doPrepareChar(s, this.currentMaskFlags(flags));
            details = details.aggregate(currentDetails);
        }
        return [
            s,
            details
        ];
    }
    reset() {
        var _this$currentMask;
        (_this$currentMask = this.currentMask) == null || _this$currentMask.reset();
        this.compiledMasks.forEach((m)=>m.reset());
    }
    get value() {
        return this.exposeMask ? this.exposeMask.value : this.currentMask ? this.currentMask.value : "";
    }
    set value(value) {
        if (this.exposeMask) {
            this.exposeMask.value = value;
            this.currentMask = this.exposeMask;
            this._applyDispatch();
        } else super.value = value;
    }
    get unmaskedValue() {
        return this.exposeMask ? this.exposeMask.unmaskedValue : this.currentMask ? this.currentMask.unmaskedValue : "";
    }
    set unmaskedValue(unmaskedValue) {
        if (this.exposeMask) {
            this.exposeMask.unmaskedValue = unmaskedValue;
            this.currentMask = this.exposeMask;
            this._applyDispatch();
        } else super.unmaskedValue = unmaskedValue;
    }
    get typedValue() {
        return this.exposeMask ? this.exposeMask.typedValue : this.currentMask ? this.currentMask.typedValue : "";
    }
    set typedValue(typedValue) {
        if (this.exposeMask) {
            this.exposeMask.typedValue = typedValue;
            this.currentMask = this.exposeMask;
            this._applyDispatch();
            return;
        }
        let unmaskedValue = String(typedValue);
        // double check it
        if (this.currentMask) {
            this.currentMask.typedValue = typedValue;
            unmaskedValue = this.currentMask.unmaskedValue;
        }
        this.unmaskedValue = unmaskedValue;
    }
    get displayValue() {
        return this.currentMask ? this.currentMask.displayValue : "";
    }
    get isComplete() {
        var _this$currentMask2;
        return Boolean((_this$currentMask2 = this.currentMask) == null ? void 0 : _this$currentMask2.isComplete);
    }
    get isFilled() {
        var _this$currentMask3;
        return Boolean((_this$currentMask3 = this.currentMask) == null ? void 0 : _this$currentMask3.isFilled);
    }
    remove(fromPos, toPos) {
        const details = new (0, $b285a78e7d6163d8$export$2e2bcd8739ae039)();
        if (this.currentMask) details.aggregate(this.currentMask.remove(fromPos, toPos))// update with dispatch
        .aggregate(this._applyDispatch());
        return details;
    }
    get state() {
        var _this$currentMask4;
        return {
            ...super.state,
            _rawInputValue: this.rawInputValue,
            compiledMasks: this.compiledMasks.map((m)=>m.state),
            currentMaskRef: this.currentMask,
            currentMask: (_this$currentMask4 = this.currentMask) == null ? void 0 : _this$currentMask4.state
        };
    }
    set state(state) {
        const { compiledMasks: compiledMasks, currentMaskRef: currentMaskRef, currentMask: currentMask, ...maskedState } = state;
        if (compiledMasks) this.compiledMasks.forEach((m, mi)=>m.state = compiledMasks[mi]);
        if (currentMaskRef != null) {
            this.currentMask = currentMaskRef;
            this.currentMask.state = currentMask;
        }
        super.state = maskedState;
    }
    extractInput(fromPos, toPos, flags) {
        return this.currentMask ? this.currentMask.extractInput(fromPos, toPos, flags) : "";
    }
    extractTail(fromPos, toPos) {
        return this.currentMask ? this.currentMask.extractTail(fromPos, toPos) : super.extractTail(fromPos, toPos);
    }
    doCommit() {
        if (this.currentMask) this.currentMask.doCommit();
        super.doCommit();
    }
    nearestInputPos(cursorPos, direction) {
        return this.currentMask ? this.currentMask.nearestInputPos(cursorPos, direction) : super.nearestInputPos(cursorPos, direction);
    }
    get overwrite() {
        return this.currentMask ? this.currentMask.overwrite : this._overwrite;
    }
    set overwrite(overwrite) {
        this._overwrite = overwrite;
    }
    get eager() {
        return this.currentMask ? this.currentMask.eager : this._eager;
    }
    set eager(eager) {
        this._eager = eager;
    }
    get skipInvalid() {
        return this.currentMask ? this.currentMask.skipInvalid : this._skipInvalid;
    }
    set skipInvalid(skipInvalid) {
        this._skipInvalid = skipInvalid;
    }
    get autofix() {
        return this.currentMask ? this.currentMask.autofix : this._autofix;
    }
    set autofix(autofix) {
        this._autofix = autofix;
    }
    maskEquals(mask) {
        return Array.isArray(mask) ? this.compiledMasks.every((m, mi)=>{
            if (!mask[mi]) return;
            const { mask: oldMask, ...restOpts } = mask[mi];
            return (0, $b4195841d15b2d87$export$7aeb68f71172641d)(m, restOpts) && m.maskEquals(oldMask);
        }) : super.maskEquals(mask);
    }
    typedValueEquals(value) {
        var _this$currentMask5;
        return Boolean((_this$currentMask5 = this.currentMask) == null ? void 0 : _this$currentMask5.typedValueEquals(value));
    }
}
/** Currently chosen mask */ /** Currently chosen mask */ /** Compliled {@link Masked} options */ /** Chooses {@link Masked} depending on input value */ $7708daf759dfe080$export$2e2bcd8739ae039.DEFAULTS = {
    ...(0, $9b02b15c72a43b68$export$2e2bcd8739ae039).DEFAULTS,
    dispatch: (appended, masked, flags, tail)=>{
        if (!masked.compiledMasks.length) return;
        const inputValue = masked.rawInputValue;
        // simulate input
        const inputs = masked.compiledMasks.map((m, index)=>{
            const isCurrent = masked.currentMask === m;
            const startInputPos = isCurrent ? m.displayValue.length : m.nearestInputPos(m.displayValue.length, (0, $b4195841d15b2d87$export$9106728c49045482).FORCE_LEFT);
            if (m.rawInputValue !== inputValue) {
                m.reset();
                m.append(inputValue, {
                    raw: true
                });
            } else if (!isCurrent) m.remove(startInputPos);
            m.append(appended, masked.currentMaskFlags(flags));
            m.appendTail(tail);
            return {
                index: index,
                weight: m.rawInputValue.length,
                totalInputPositions: m.totalInputPositions(0, Math.max(startInputPos, m.nearestInputPos(m.displayValue.length, (0, $b4195841d15b2d87$export$9106728c49045482).FORCE_LEFT)))
            };
        });
        // pop masks with longer values first
        inputs.sort((i1, i2)=>i2.weight - i1.weight || i2.totalInputPositions - i1.totalInputPositions);
        return masked.compiledMasks[inputs[0].index];
    }
};
(0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).MaskedDynamic = $7708daf759dfe080$export$2e2bcd8739ae039;














/** Pattern which validates enum values */ class $d05fe604ad915261$export$2e2bcd8739ae039 extends (0, $855f132dbdeea111$export$2e2bcd8739ae039) {
    constructor(opts){
        super({
            ...$d05fe604ad915261$export$2e2bcd8739ae039.DEFAULTS,
            ...opts
        }); // mask will be created in _update
    }
    updateOptions(opts) {
        super.updateOptions(opts);
    }
    _update(opts) {
        const { enum: enum_, ...eopts } = opts;
        if (enum_) {
            const lengths = enum_.map((e)=>e.length);
            const requiredLength = Math.min(...lengths);
            const optionalLength = Math.max(...lengths) - requiredLength;
            eopts.mask = "*".repeat(requiredLength);
            if (optionalLength) eopts.mask += "[" + "*".repeat(optionalLength) + "]";
            this.enum = enum_;
        }
        super._update(eopts);
    }
    _appendCharRaw(ch, flags) {
        if (flags === void 0) flags = {};
        const matchFrom = Math.min(this.nearestInputPos(0, (0, $b4195841d15b2d87$export$9106728c49045482).FORCE_RIGHT), this.value.length);
        const matches = this.enum.filter((e)=>this.matchValue(e, this.unmaskedValue + ch, matchFrom));
        if (matches.length) {
            if (matches.length === 1) this._forEachBlocksInRange(0, this.value.length, (b, bi)=>{
                const mch = matches[0][bi];
                if (bi >= this.value.length || mch === b.value) return;
                b.reset();
                b._appendChar(mch, flags);
            });
            const d = super._appendCharRaw(matches[0][this.value.length], flags);
            if (matches.length === 1) matches[0].slice(this.unmaskedValue.length).split("").forEach((mch)=>d.aggregate(super._appendCharRaw(mch)));
            return d;
        }
        return new (0, $b285a78e7d6163d8$export$2e2bcd8739ae039)({
            skip: !this.isComplete
        });
    }
    extractTail(fromPos, toPos) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this.displayValue.length;
        // just drop tail
        return new (0, $8648f741d9791934$export$2e2bcd8739ae039)("", fromPos);
    }
    remove(fromPos, toPos) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this.displayValue.length;
        if (fromPos === toPos) return new (0, $b285a78e7d6163d8$export$2e2bcd8739ae039)();
        const matchFrom = Math.min(super.nearestInputPos(0, (0, $b4195841d15b2d87$export$9106728c49045482).FORCE_RIGHT), this.value.length);
        let pos;
        for(pos = fromPos; pos >= 0; --pos){
            const matches = this.enum.filter((e)=>this.matchValue(e, this.value.slice(matchFrom, pos), matchFrom));
            if (matches.length > 1) break;
        }
        const details = super.remove(pos, toPos);
        details.tailShift += pos - fromPos;
        return details;
    }
    get isComplete() {
        return this.enum.indexOf(this.value) >= 0;
    }
}
/** Match enum value */ $d05fe604ad915261$export$2e2bcd8739ae039.DEFAULTS = {
    ...(0, $855f132dbdeea111$export$2e2bcd8739ae039).DEFAULTS,
    matchValue: (estr, istr, matchFrom)=>estr.indexOf(istr, matchFrom) === matchFrom
};
(0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).MaskedEnum = $d05fe604ad915261$export$2e2bcd8739ae039;








/** Masking by custom Function */ class $b4d52afcbabd034f$export$2e2bcd8739ae039 extends (0, $9b02b15c72a43b68$export$2e2bcd8739ae039) {
    /** */ /** Enable characters overwriting */ /** */ /** */ /** */ updateOptions(opts) {
        super.updateOptions(opts);
    }
    _update(opts) {
        super._update({
            ...opts,
            validate: opts.mask
        });
    }
}
(0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).MaskedFunction = $b4d52afcbabd034f$export$2e2bcd8739ae039;







var $b7b274a57cc86b76$var$_MaskedNumber;
/** Number mask */ class $b7b274a57cc86b76$export$2e2bcd8739ae039 extends (0, $9b02b15c72a43b68$export$2e2bcd8739ae039) {
    /** Single char */ /** Single char */ /** Array of single chars */ /** */ /** */ /** Digits after point */ /** Flag to remove leading and trailing zeros in the end of editing */ /** Flag to pad trailing zeros after point in the end of editing */ /** Enable characters overwriting */ /** */ /** */ /** */ /** Format typed value to string */ /** Parse string to get typed value */ constructor(opts){
        super({
            ...$b7b274a57cc86b76$export$2e2bcd8739ae039.DEFAULTS,
            ...opts
        });
    }
    updateOptions(opts) {
        super.updateOptions(opts);
    }
    _update(opts) {
        super._update(opts);
        this._updateRegExps();
    }
    _updateRegExps() {
        const start = "^" + (this.allowNegative ? "[+|\\-]?" : "");
        const mid = "\\d*";
        const end = (this.scale ? "(" + (0, $b4195841d15b2d87$export$7c57da42ce8e346f)(this.radix) + "\\d{0," + this.scale + "})?" : "") + "$";
        this._numberRegExp = new RegExp(start + mid + end);
        this._mapToRadixRegExp = new RegExp("[" + this.mapToRadix.map((0, $b4195841d15b2d87$export$7c57da42ce8e346f)).join("") + "]", "g");
        this._thousandsSeparatorRegExp = new RegExp((0, $b4195841d15b2d87$export$7c57da42ce8e346f)(this.thousandsSeparator), "g");
    }
    _removeThousandsSeparators(value) {
        return value.replace(this._thousandsSeparatorRegExp, "");
    }
    _insertThousandsSeparators(value) {
        // https://stackoverflow.com/questions/2901102/how-to-print-a-number-with-commas-as-thousands-separators-in-javascript
        const parts = value.split(this.radix);
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, this.thousandsSeparator);
        return parts.join(this.radix);
    }
    doPrepareChar(ch, flags) {
        if (flags === void 0) flags = {};
        const [prepCh, details] = super.doPrepareChar(this._removeThousandsSeparators(this.scale && this.mapToRadix.length && /*
      radix should be mapped when
      1) input is done from keyboard = flags.input && flags.raw
      2) unmasked value is set = !flags.input && !flags.raw
      and should not be mapped when
      1) value is set = flags.input && !flags.raw
      2) raw value is set = !flags.input && flags.raw
    */ (flags.input && flags.raw || !flags.input && !flags.raw) ? ch.replace(this._mapToRadixRegExp, this.radix) : ch), flags);
        if (ch && !prepCh) details.skip = true;
        if (prepCh && !this.allowPositive && !this.value && prepCh !== "-") details.aggregate(this._appendChar("-"));
        return [
            prepCh,
            details
        ];
    }
    _separatorsCount(to, extendOnSeparators) {
        if (extendOnSeparators === void 0) extendOnSeparators = false;
        let count = 0;
        for(let pos = 0; pos < to; ++pos)if (this._value.indexOf(this.thousandsSeparator, pos) === pos) {
            ++count;
            if (extendOnSeparators) to += this.thousandsSeparator.length;
        }
        return count;
    }
    _separatorsCountFromSlice(slice) {
        if (slice === void 0) slice = this._value;
        return this._separatorsCount(this._removeThousandsSeparators(slice).length, true);
    }
    extractInput(fromPos, toPos, flags) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this.displayValue.length;
        [fromPos, toPos] = this._adjustRangeWithSeparators(fromPos, toPos);
        return this._removeThousandsSeparators(super.extractInput(fromPos, toPos, flags));
    }
    _appendCharRaw(ch, flags) {
        if (flags === void 0) flags = {};
        const prevBeforeTailValue = flags.tail && flags._beforeTailState ? flags._beforeTailState._value : this._value;
        const prevBeforeTailSeparatorsCount = this._separatorsCountFromSlice(prevBeforeTailValue);
        this._value = this._removeThousandsSeparators(this.value);
        const oldValue = this._value;
        this._value += ch;
        const num = this.number;
        let accepted = !isNaN(num);
        let skip = false;
        if (accepted) {
            let fixedNum;
            if (this.min != null && this.min < 0 && this.number < this.min) fixedNum = this.min;
            if (this.max != null && this.max > 0 && this.number > this.max) fixedNum = this.max;
            if (fixedNum != null) {
                if (this.autofix) {
                    this._value = this.format(fixedNum, this).replace($b7b274a57cc86b76$export$2e2bcd8739ae039.UNMASKED_RADIX, this.radix);
                    skip || (skip = oldValue === this._value && !flags.tail); // if not changed on tail it's still ok to proceed
                } else accepted = false;
            }
            accepted && (accepted = Boolean(this._value.match(this._numberRegExp)));
        }
        let appendDetails;
        if (!accepted) {
            this._value = oldValue;
            appendDetails = new (0, $b285a78e7d6163d8$export$2e2bcd8739ae039)();
        } else appendDetails = new (0, $b285a78e7d6163d8$export$2e2bcd8739ae039)({
            inserted: this._value.slice(oldValue.length),
            rawInserted: skip ? "" : ch,
            skip: skip
        });
        this._value = this._insertThousandsSeparators(this._value);
        const beforeTailValue = flags.tail && flags._beforeTailState ? flags._beforeTailState._value : this._value;
        const beforeTailSeparatorsCount = this._separatorsCountFromSlice(beforeTailValue);
        appendDetails.tailShift += (beforeTailSeparatorsCount - prevBeforeTailSeparatorsCount) * this.thousandsSeparator.length;
        return appendDetails;
    }
    _findSeparatorAround(pos) {
        if (this.thousandsSeparator) {
            const searchFrom = pos - this.thousandsSeparator.length + 1;
            const separatorPos = this.value.indexOf(this.thousandsSeparator, searchFrom);
            if (separatorPos <= pos) return separatorPos;
        }
        return -1;
    }
    _adjustRangeWithSeparators(from, to) {
        const separatorAroundFromPos = this._findSeparatorAround(from);
        if (separatorAroundFromPos >= 0) from = separatorAroundFromPos;
        const separatorAroundToPos = this._findSeparatorAround(to);
        if (separatorAroundToPos >= 0) to = separatorAroundToPos + this.thousandsSeparator.length;
        return [
            from,
            to
        ];
    }
    remove(fromPos, toPos) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this.displayValue.length;
        [fromPos, toPos] = this._adjustRangeWithSeparators(fromPos, toPos);
        const valueBeforePos = this.value.slice(0, fromPos);
        const valueAfterPos = this.value.slice(toPos);
        const prevBeforeTailSeparatorsCount = this._separatorsCount(valueBeforePos.length);
        this._value = this._insertThousandsSeparators(this._removeThousandsSeparators(valueBeforePos + valueAfterPos));
        const beforeTailSeparatorsCount = this._separatorsCountFromSlice(valueBeforePos);
        return new (0, $b285a78e7d6163d8$export$2e2bcd8739ae039)({
            tailShift: (beforeTailSeparatorsCount - prevBeforeTailSeparatorsCount) * this.thousandsSeparator.length
        });
    }
    nearestInputPos(cursorPos, direction) {
        if (!this.thousandsSeparator) return cursorPos;
        switch(direction){
            case (0, $b4195841d15b2d87$export$9106728c49045482).NONE:
            case (0, $b4195841d15b2d87$export$9106728c49045482).LEFT:
            case (0, $b4195841d15b2d87$export$9106728c49045482).FORCE_LEFT:
                {
                    const separatorAtLeftPos = this._findSeparatorAround(cursorPos - 1);
                    if (separatorAtLeftPos >= 0) {
                        const separatorAtLeftEndPos = separatorAtLeftPos + this.thousandsSeparator.length;
                        if (cursorPos < separatorAtLeftEndPos || this.value.length <= separatorAtLeftEndPos || direction === (0, $b4195841d15b2d87$export$9106728c49045482).FORCE_LEFT) return separatorAtLeftPos;
                    }
                    break;
                }
            case (0, $b4195841d15b2d87$export$9106728c49045482).RIGHT:
            case (0, $b4195841d15b2d87$export$9106728c49045482).FORCE_RIGHT:
                {
                    const separatorAtRightPos = this._findSeparatorAround(cursorPos);
                    if (separatorAtRightPos >= 0) return separatorAtRightPos + this.thousandsSeparator.length;
                }
        }
        return cursorPos;
    }
    doCommit() {
        if (this.value) {
            const number = this.number;
            let validnum = number;
            // check bounds
            if (this.min != null) validnum = Math.max(validnum, this.min);
            if (this.max != null) validnum = Math.min(validnum, this.max);
            if (validnum !== number) this.unmaskedValue = this.format(validnum, this);
            let formatted = this.value;
            if (this.normalizeZeros) formatted = this._normalizeZeros(formatted);
            if (this.padFractionalZeros && this.scale > 0) formatted = this._padFractionalZeros(formatted);
            this._value = formatted;
        }
        super.doCommit();
    }
    _normalizeZeros(value) {
        const parts = this._removeThousandsSeparators(value).split(this.radix);
        // remove leading zeros
        parts[0] = parts[0].replace(/^(\D*)(0*)(\d*)/, (match, sign, zeros, num)=>sign + num);
        // add leading zero
        if (value.length && !/\d$/.test(parts[0])) parts[0] = parts[0] + "0";
        if (parts.length > 1) {
            parts[1] = parts[1].replace(/0*$/, ""); // remove trailing zeros
            if (!parts[1].length) parts.length = 1; // remove fractional
        }
        return this._insertThousandsSeparators(parts.join(this.radix));
    }
    _padFractionalZeros(value) {
        if (!value) return value;
        const parts = value.split(this.radix);
        if (parts.length < 2) parts.push("");
        parts[1] = parts[1].padEnd(this.scale, "0");
        return parts.join(this.radix);
    }
    doSkipInvalid(ch, flags, checkTail) {
        if (flags === void 0) flags = {};
        const dropFractional = this.scale === 0 && ch !== this.thousandsSeparator && (ch === this.radix || ch === $b7b274a57cc86b76$export$2e2bcd8739ae039.UNMASKED_RADIX || this.mapToRadix.includes(ch));
        return super.doSkipInvalid(ch, flags, checkTail) && !dropFractional;
    }
    get unmaskedValue() {
        return this._removeThousandsSeparators(this._normalizeZeros(this.value)).replace(this.radix, $b7b274a57cc86b76$export$2e2bcd8739ae039.UNMASKED_RADIX);
    }
    set unmaskedValue(unmaskedValue) {
        super.unmaskedValue = unmaskedValue;
    }
    get typedValue() {
        return this.parse(this.unmaskedValue, this);
    }
    set typedValue(n) {
        this.rawInputValue = this.format(n, this).replace($b7b274a57cc86b76$export$2e2bcd8739ae039.UNMASKED_RADIX, this.radix);
    }
    /** Parsed Number */ get number() {
        return this.typedValue;
    }
    set number(number) {
        this.typedValue = number;
    }
    get allowNegative() {
        return this.min != null && this.min < 0 || this.max != null && this.max < 0;
    }
    get allowPositive() {
        return this.min != null && this.min > 0 || this.max != null && this.max > 0;
    }
    typedValueEquals(value) {
        // handle  0 -> '' case (typed = 0 even if value = '')
        // for details see https://github.com/uNmAnNeR/imaskjs/issues/134
        return (super.typedValueEquals(value) || $b7b274a57cc86b76$export$2e2bcd8739ae039.EMPTY_VALUES.includes(value) && $b7b274a57cc86b76$export$2e2bcd8739ae039.EMPTY_VALUES.includes(this.typedValue)) && !(value === 0 && this.value === "");
    }
}
$b7b274a57cc86b76$var$_MaskedNumber = $b7b274a57cc86b76$export$2e2bcd8739ae039;
$b7b274a57cc86b76$export$2e2bcd8739ae039.UNMASKED_RADIX = ".";
$b7b274a57cc86b76$export$2e2bcd8739ae039.EMPTY_VALUES = [
    ...(0, $9b02b15c72a43b68$export$2e2bcd8739ae039).EMPTY_VALUES,
    0
];
$b7b274a57cc86b76$export$2e2bcd8739ae039.DEFAULTS = {
    ...(0, $9b02b15c72a43b68$export$2e2bcd8739ae039).DEFAULTS,
    mask: Number,
    radix: ",",
    thousandsSeparator: "",
    mapToRadix: [
        $b7b274a57cc86b76$var$_MaskedNumber.UNMASKED_RADIX
    ],
    min: Number.MIN_SAFE_INTEGER,
    max: Number.MAX_SAFE_INTEGER,
    scale: 2,
    normalizeZeros: true,
    padFractionalZeros: false,
    parse: Number,
    format: (n)=>n.toLocaleString("en-US", {
            useGrouping: false,
            maximumFractionDigits: 20
        })
};
(0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).MaskedNumber = $b7b274a57cc86b76$export$2e2bcd8739ae039;









/** Mask pipe source and destination types */ const $ace06d054ccb72d8$export$90dab59c3d4b6e03 = {
    MASKED: "value",
    UNMASKED: "unmaskedValue",
    TYPED: "typedValue"
};
/** Creates new pipe function depending on mask type, source and destination options */ function $ace06d054ccb72d8$export$a504d53a5b99e1b9(arg, from, to) {
    if (from === void 0) from = $ace06d054ccb72d8$export$90dab59c3d4b6e03.MASKED;
    if (to === void 0) to = $ace06d054ccb72d8$export$90dab59c3d4b6e03.MASKED;
    const masked = (0, $d30869383ae23901$export$2e2bcd8739ae039)(arg);
    return (value)=>masked.runIsolated((m)=>{
            m[from] = value;
            return m[to];
        });
}
/** Pipes value through mask depending on mask type, source and destination options */ function $ace06d054ccb72d8$export$a4627e546088548d(value, mask, from, to) {
    return $ace06d054ccb72d8$export$a504d53a5b99e1b9(mask, from, to)(value);
}
(0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).PIPE_TYPE = $ace06d054ccb72d8$export$90dab59c3d4b6e03;
(0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).createPipe = $ace06d054ccb72d8$export$a504d53a5b99e1b9;
(0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).pipe = $ace06d054ccb72d8$export$a4627e546088548d;
















/** Pattern mask */ class $8bb8b34d96ef61f6$export$2e2bcd8739ae039 extends (0, $855f132dbdeea111$export$2e2bcd8739ae039) {
    get repeatFrom() {
        var _ref;
        return (_ref = Array.isArray(this.repeat) ? this.repeat[0] : this.repeat === Infinity ? 0 : this.repeat) != null ? _ref : 0;
    }
    get repeatTo() {
        var _ref2;
        return (_ref2 = Array.isArray(this.repeat) ? this.repeat[1] : this.repeat) != null ? _ref2 : Infinity;
    }
    constructor(opts){
        super(opts);
    }
    updateOptions(opts) {
        super.updateOptions(opts);
    }
    _update(opts) {
        var _ref3, _ref4, _this$_blocks;
        const { repeat: repeat, ...blockOpts } = (0, $d30869383ae23901$export$a213ae1c699d7230)(opts); // TODO type
        this._blockOpts = Object.assign({}, this._blockOpts, blockOpts);
        const block = (0, $d30869383ae23901$export$2e2bcd8739ae039)(this._blockOpts);
        this.repeat = (_ref3 = (_ref4 = repeat != null ? repeat : block.repeat) != null ? _ref4 : this.repeat) != null ? _ref3 : Infinity; // TODO type
        super._update({
            mask: "m".repeat(Math.max(this.repeatTo === Infinity && ((_this$_blocks = this._blocks) == null ? void 0 : _this$_blocks.length) || 0, this.repeatFrom)),
            blocks: {
                m: block
            },
            eager: block.eager,
            overwrite: block.overwrite,
            skipInvalid: block.skipInvalid,
            lazy: block.lazy,
            placeholderChar: block.placeholderChar,
            displayChar: block.displayChar
        });
    }
    _allocateBlock(bi) {
        if (bi < this._blocks.length) return this._blocks[bi];
        if (this.repeatTo === Infinity || this._blocks.length < this.repeatTo) {
            this._blocks.push((0, $d30869383ae23901$export$2e2bcd8739ae039)(this._blockOpts));
            this.mask += "m";
            return this._blocks[this._blocks.length - 1];
        }
    }
    _appendCharRaw(ch, flags) {
        if (flags === void 0) flags = {};
        const details = new (0, $b285a78e7d6163d8$export$2e2bcd8739ae039)();
        for(let bi = (_this$_mapPosToBlock$ = (_this$_mapPosToBlock = this._mapPosToBlock(this.displayValue.length)) == null ? void 0 : _this$_mapPosToBlock.index) != null ? _this$_mapPosToBlock$ : Math.max(this._blocks.length - 1, 0), block, allocated; // try to get a block or
        // try to allocate a new block if not allocated already
        block = (_this$_blocks$bi = this._blocks[bi]) != null ? _this$_blocks$bi : allocated = !allocated && this._allocateBlock(bi); ++bi){
            var _this$_mapPosToBlock$, _this$_mapPosToBlock, _this$_blocks$bi, _flags$_beforeTailSta;
            const blockDetails = block._appendChar(ch, {
                ...flags,
                _beforeTailState: (_flags$_beforeTailSta = flags._beforeTailState) == null || (_flags$_beforeTailSta = _flags$_beforeTailSta._blocks) == null ? void 0 : _flags$_beforeTailSta[bi]
            });
            if (blockDetails.skip && allocated) {
                // remove the last allocated block and break
                this._blocks.pop();
                this.mask = this.mask.slice(1);
                break;
            }
            details.aggregate(blockDetails);
            if (blockDetails.consumed) break; // go next char
        }
        return details;
    }
    _trimEmptyTail(fromPos, toPos) {
        var _this$_mapPosToBlock2, _this$_mapPosToBlock3;
        if (fromPos === void 0) fromPos = 0;
        const firstBlockIndex = Math.max(((_this$_mapPosToBlock2 = this._mapPosToBlock(fromPos)) == null ? void 0 : _this$_mapPosToBlock2.index) || 0, this.repeatFrom, 0);
        let lastBlockIndex;
        if (toPos != null) lastBlockIndex = (_this$_mapPosToBlock3 = this._mapPosToBlock(toPos)) == null ? void 0 : _this$_mapPosToBlock3.index;
        if (lastBlockIndex == null) lastBlockIndex = this._blocks.length - 1;
        let removeCount = 0;
        for(let blockIndex = lastBlockIndex; firstBlockIndex <= blockIndex; --blockIndex, ++removeCount){
            if (this._blocks[blockIndex].unmaskedValue) break;
        }
        if (removeCount) {
            this._blocks.splice(lastBlockIndex - removeCount + 1, removeCount);
            this.mask = this.mask.slice(removeCount);
        }
    }
    reset() {
        super.reset();
        this._trimEmptyTail();
    }
    remove(fromPos, toPos) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this.displayValue.length;
        const removeDetails = super.remove(fromPos, toPos);
        this._trimEmptyTail(fromPos, toPos);
        return removeDetails;
    }
    totalInputPositions(fromPos, toPos) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos == null && this.repeatTo === Infinity) return Infinity;
        return super.totalInputPositions(fromPos, toPos);
    }
    get state() {
        return super.state;
    }
    set state(state) {
        this._blocks.length = state._blocks.length;
        this.mask = this.mask.slice(0, this._blocks.length);
        super.state = state;
    }
}
(0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).RepeatBlock = $8bb8b34d96ef61f6$export$2e2bcd8739ae039;






try {
    globalThis.IMask = (0, $7dec8b23e7031bbf$export$2e2bcd8739ae039);
} catch  {}















var $aivMx = parcelRequire("aivMx");

var $aivMx = parcelRequire("aivMx");


const $15fa0f632c3d3783$var$MASK_PROPS = {
    // common
    mask: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).array,
        (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).instanceOf(RegExp),
        (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).oneOf([
            Date,
            Number,
            (0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).Masked
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).instanceOf((0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).Masked)
    ]),
    value: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).any,
    unmask: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).oneOf([
            "typed"
        ])
    ]),
    prepare: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).func,
    prepareChar: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).func,
    validate: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).func,
    commit: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).func,
    overwrite: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).oneOf([
            "shift"
        ])
    ]),
    eager: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).oneOf([
            "append",
            "remove"
        ])
    ]),
    skipInvalid: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).bool,
    // events
    onAccept: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).func,
    onComplete: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).func,
    // pattern
    placeholderChar: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).string,
    displayChar: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).string,
    lazy: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).bool,
    definitions: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).object,
    blocks: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).object,
    // enum
    enum: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).string),
    // range
    maxLength: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).number,
    from: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).number,
    to: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).number,
    // date
    pattern: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).string,
    format: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).func,
    parse: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).func,
    autofix: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).oneOf([
            "pad"
        ])
    ]),
    // number
    radix: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).string,
    thousandsSeparator: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).string,
    mapToRadix: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).string),
    scale: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).number,
    normalizeZeros: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).bool,
    padFractionalZeros: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).bool,
    min: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).instanceOf(Date)
    ]),
    max: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).instanceOf(Date)
    ]),
    // dynamic
    dispatch: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).func,
    // ref
    inputRef: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).shape({
            current: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).object
        })
    ])
};
const $15fa0f632c3d3783$var$MASK_PROPS_NAMES = Object.keys($15fa0f632c3d3783$var$MASK_PROPS).filter((p)=>p !== "value");
const $15fa0f632c3d3783$var$NON_MASK_OPTIONS_NAMES = [
    "value",
    "unmask",
    "onAccept",
    "onComplete",
    "inputRef"
];
const $15fa0f632c3d3783$var$MASK_OPTIONS_NAMES = $15fa0f632c3d3783$var$MASK_PROPS_NAMES.filter((pName)=>$15fa0f632c3d3783$var$NON_MASK_OPTIONS_NAMES.indexOf(pName) < 0);
function $15fa0f632c3d3783$export$2e2bcd8739ae039(ComposedComponent) {
    var _Class;
    const MaskedComponent = (_Class = class MaskedComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).Component {
        constructor(props){
            super(props);
            this._inputRef = this._inputRef.bind(this);
        }
        componentDidMount() {
            if (!this.props.mask) return;
            this.initMask();
        }
        componentDidUpdate() {
            const props = this.props;
            const maskOptions = this._extractMaskOptionsFromProps(props);
            if (maskOptions.mask) {
                if (this.maskRef) {
                    this.maskRef.updateOptions(maskOptions); // TODO fix
                    if ("value" in props && props.value !== undefined) this.maskValue = props.value;
                } else this.initMask(maskOptions);
            } else {
                this.destroyMask();
                if ("value" in props && props.value !== undefined) {
                    var _this$element;
                    if ((_this$element = this.element) != null && _this$element.isContentEditable && this.element.tagName !== "INPUT" && this.element.tagName !== "TEXTAREA") this.element.textContent = props.value;
                    else this.element.value = props.value;
                }
            }
        }
        componentWillUnmount() {
            this.destroyMask();
        }
        _inputRef(el) {
            this.element = el;
            if (this.props.inputRef) {
                if (Object.prototype.hasOwnProperty.call(this.props.inputRef, "current")) this.props.inputRef.current = el;
                else this.props.inputRef(el);
            }
        }
        initMask(maskOptions) {
            if (maskOptions === void 0) maskOptions = this._extractMaskOptionsFromProps(this.props);
            this.maskRef = (0, $7dec8b23e7031bbf$export$2e2bcd8739ae039)(this.element, maskOptions).on("accept", this._onAccept.bind(this)).on("complete", this._onComplete.bind(this));
            if ("value" in this.props && this.props.value !== undefined) this.maskValue = this.props.value;
        }
        destroyMask() {
            if (this.maskRef) {
                this.maskRef.destroy();
                delete this.maskRef;
            }
        }
        _extractMaskOptionsFromProps(props) {
            const { ...cloneProps } = props;
            // keep only mask options
            Object.keys(cloneProps).filter((prop)=>$15fa0f632c3d3783$var$MASK_OPTIONS_NAMES.indexOf(prop) < 0).forEach((nonMaskProp)=>{
                delete cloneProps[nonMaskProp];
            });
            return cloneProps;
        }
        _extractNonMaskProps(props) {
            const { ...cloneProps } = props;
            $15fa0f632c3d3783$var$MASK_PROPS_NAMES.forEach((maskProp)=>{
                if (maskProp !== "maxLength") delete cloneProps[maskProp];
            });
            if (!("defaultValue" in cloneProps)) cloneProps.defaultValue = props.mask ? "" : cloneProps.value;
            delete cloneProps.value;
            return cloneProps;
        }
        get maskValue() {
            if (!this.maskRef) return "";
            if (this.props.unmask === "typed") return this.maskRef.typedValue;
            if (this.props.unmask) return this.maskRef.unmaskedValue;
            return this.maskRef.value;
        }
        set maskValue(value) {
            if (!this.maskRef) return;
            value = value == null && this.props.unmask !== "typed" ? "" : value;
            if (this.props.unmask === "typed") this.maskRef.typedValue = value;
            else if (this.props.unmask) this.maskRef.unmaskedValue = value;
            else this.maskRef.value = value;
        }
        _onAccept(e) {
            if (this.props.onAccept && this.maskRef) this.props.onAccept(this.maskValue, this.maskRef, e);
        }
        _onComplete(e) {
            if (this.props.onComplete && this.maskRef) this.props.onComplete(this.maskValue, this.maskRef, e);
        }
        render() {
            return (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).createElement(ComposedComponent, {
                ...this._extractNonMaskProps(this.props),
                inputRef: this._inputRef
            });
        }
    }, _Class.displayName = void 0, _Class.propTypes = void 0, _Class);
    const nestedComponentName = ComposedComponent.displayName || ComposedComponent.name || "Component";
    MaskedComponent.displayName = "IMask(" + nestedComponentName + ")";
    MaskedComponent.propTypes = $15fa0f632c3d3783$var$MASK_PROPS;
    return (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).forwardRef((props, ref)=>(0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).createElement(MaskedComponent, {
            ...props,
            ref: ref
        }));
}




const $416d9e5f2c67c58b$var$IMaskInputClass = (0, $15fa0f632c3d3783$export$2e2bcd8739ae039)((_ref)=>{
    let { inputRef: inputRef, ...props } = _ref;
    return (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).createElement("input", {
        ...props,
        ref: inputRef
    });
});
const $416d9e5f2c67c58b$var$IMaskInputFn = (props, ref)=>(0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).createElement($416d9e5f2c67c58b$var$IMaskInputClass, {
        ...props,
        ref: ref
    }) // TODO fix no idea
;
const $416d9e5f2c67c58b$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).forwardRef($416d9e5f2c67c58b$var$IMaskInputFn);




var $aivMx = parcelRequire("aivMx");
function $175ba8d7564d9b4b$export$2e2bcd8739ae039(opts, _temp) {
    let { onAccept: onAccept, onComplete: onComplete, ref: ref = (0, $aivMx.useRef)(null), defaultValue: defaultValue, defaultUnmaskedValue: defaultUnmaskedValue, defaultTypedValue: defaultTypedValue } = _temp === void 0 ? {} : _temp;
    const maskRef = (0, $aivMx.useRef)(null);
    const [lastAcceptState, setLastAcceptState] = (0, $aivMx.useState)({});
    const [value, setValue] = (0, $aivMx.useState)("");
    const [unmaskedValue, setUnmaskedValue] = (0, $aivMx.useState)("");
    const [typedValue, setTypedValue] = (0, $aivMx.useState)();
    const _destroyMask = (0, $aivMx.useCallback)(()=>{
        var _maskRef$current;
        (_maskRef$current = maskRef.current) == null || _maskRef$current.destroy();
        maskRef.current = null;
    }, []);
    const storeLastAcceptedValues = (0, $aivMx.useCallback)(()=>{
        const m = maskRef.current;
        if (!m) return;
        setLastAcceptState({
            value: m.value,
            unmaskedValue: m.unmaskedValue,
            typedValue: m.typedValue
        });
        setTypedValue(m.typedValue);
        setUnmaskedValue(m.unmaskedValue);
        setValue(m.value);
    }, []);
    const _onAccept = (0, $aivMx.useCallback)((event)=>{
        const m = maskRef.current;
        if (!m) return;
        storeLastAcceptedValues();
        onAccept == null || onAccept(m.value, m, event);
    }, [
        onAccept
    ]);
    const _onComplete = (0, $aivMx.useCallback)((event)=>maskRef.current && (onComplete == null ? void 0 : onComplete(maskRef.current.value, maskRef.current, event)), [
        onComplete
    ]);
    (0, $aivMx.useEffect)(()=>{
        const { value: lastAcceptValue, ...state } = lastAcceptState;
        const mask = maskRef.current;
        if (!mask || value === undefined) return;
        if (lastAcceptValue !== value) {
            mask.value = value;
            if (mask.value !== value) _onAccept();
        }
        setLastAcceptState(state);
    }, [
        value
    ]);
    (0, $aivMx.useEffect)(()=>{
        const { unmaskedValue: lastAcceptUnmaskedValue, ...state } = lastAcceptState;
        const mask = maskRef.current;
        if (!mask || unmaskedValue === undefined) return;
        if (lastAcceptUnmaskedValue !== unmaskedValue) {
            mask.unmaskedValue = unmaskedValue;
            if (mask.unmaskedValue !== unmaskedValue) _onAccept();
        }
        setLastAcceptState(state);
    }, [
        unmaskedValue
    ]);
    (0, $aivMx.useEffect)(()=>{
        const { typedValue: lastAcceptTypedValue, ...state } = lastAcceptState;
        const mask = maskRef.current;
        if (!mask || typedValue === undefined) return;
        if (lastAcceptTypedValue !== typedValue) {
            mask.typedValue = typedValue;
            if (!mask.masked.typedValueEquals(typedValue)) _onAccept();
        }
        setLastAcceptState(state);
    }, [
        typedValue
    ]);
    (0, $aivMx.useEffect)(()=>{
        const el = ref.current;
        if (!el || !(opts != null && opts.mask)) return _destroyMask();
        const mask = maskRef.current;
        if (!mask) {
            if (el && opts != null && opts.mask) {
                maskRef.current = (0, $7dec8b23e7031bbf$export$2e2bcd8739ae039)(el, opts);
                storeLastAcceptedValues();
                if (defaultValue !== undefined) setValue(defaultValue);
                if (defaultUnmaskedValue !== undefined) setUnmaskedValue(defaultUnmaskedValue);
                if (defaultTypedValue !== undefined) setTypedValue(defaultTypedValue);
            }
        } else mask == null || mask.updateOptions(opts); // TODO fix no idea
    }, [
        opts,
        _destroyMask,
        _onAccept
    ]);
    (0, $aivMx.useEffect)(()=>{
        if (!maskRef.current) return;
        const mask = maskRef.current;
        mask.on("accept", _onAccept);
        mask.on("complete", _onComplete);
        return ()=>{
            mask.off("accept", _onAccept);
            mask.off("complete", _onComplete);
        };
    }, [
        _onAccept,
        _onComplete
    ]);
    (0, $aivMx.useEffect)(()=>_destroyMask, [
        _destroyMask
    ]);
    return {
        ref: ref,
        maskRef: maskRef,
        value: value,
        setValue: setValue,
        unmaskedValue: unmaskedValue,
        setUnmaskedValue: setUnmaskedValue,
        typedValue: typedValue,
        setTypedValue: setTypedValue
    };
}



parcelRequire("aivMx");






var $94WEq = parcelRequire("94WEq");

var $g1KQj = parcelRequire("g1KQj");





var $aivMx = parcelRequire("aivMx");







var $i4YVD = parcelRequire("i4YVD");
var $cdef6bd59ed00ff5$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as references for various `Number` constants. */ var $cdef6bd59ed00ff5$var$INFINITY = 1 / 0;
/** `Object#toString` result references. */ var $cdef6bd59ed00ff5$var$symbolTag = "[object Symbol]";
/** Used to match words composed of alphanumeric characters. */ var $cdef6bd59ed00ff5$var$reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
/** Used to match Latin Unicode letters (excluding mathematical operators). */ var $cdef6bd59ed00ff5$var$reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
/** Used to compose unicode character classes. */ var $cdef6bd59ed00ff5$var$rsAstralRange = "\ud800-\udfff", $cdef6bd59ed00ff5$var$rsComboMarksRange = "\\u0300-\\u036f\\ufe20-\\ufe23", $cdef6bd59ed00ff5$var$rsComboSymbolsRange = "\\u20d0-\\u20f0", $cdef6bd59ed00ff5$var$rsDingbatRange = "\\u2700-\\u27bf", $cdef6bd59ed00ff5$var$rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", $cdef6bd59ed00ff5$var$rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", $cdef6bd59ed00ff5$var$rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", $cdef6bd59ed00ff5$var$rsPunctuationRange = "\\u2000-\\u206f", $cdef6bd59ed00ff5$var$rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", $cdef6bd59ed00ff5$var$rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", $cdef6bd59ed00ff5$var$rsVarRange = "\\ufe0e\\ufe0f", $cdef6bd59ed00ff5$var$rsBreakRange = $cdef6bd59ed00ff5$var$rsMathOpRange + $cdef6bd59ed00ff5$var$rsNonCharRange + $cdef6bd59ed00ff5$var$rsPunctuationRange + $cdef6bd59ed00ff5$var$rsSpaceRange;
/** Used to compose unicode capture groups. */ var $cdef6bd59ed00ff5$var$rsApos = "['’]", $cdef6bd59ed00ff5$var$rsAstral = "[" + $cdef6bd59ed00ff5$var$rsAstralRange + "]", $cdef6bd59ed00ff5$var$rsBreak = "[" + $cdef6bd59ed00ff5$var$rsBreakRange + "]", $cdef6bd59ed00ff5$var$rsCombo = "[" + $cdef6bd59ed00ff5$var$rsComboMarksRange + $cdef6bd59ed00ff5$var$rsComboSymbolsRange + "]", $cdef6bd59ed00ff5$var$rsDigits = "\\d+", $cdef6bd59ed00ff5$var$rsDingbat = "[" + $cdef6bd59ed00ff5$var$rsDingbatRange + "]", $cdef6bd59ed00ff5$var$rsLower = "[" + $cdef6bd59ed00ff5$var$rsLowerRange + "]", $cdef6bd59ed00ff5$var$rsMisc = "[^" + $cdef6bd59ed00ff5$var$rsAstralRange + $cdef6bd59ed00ff5$var$rsBreakRange + $cdef6bd59ed00ff5$var$rsDigits + $cdef6bd59ed00ff5$var$rsDingbatRange + $cdef6bd59ed00ff5$var$rsLowerRange + $cdef6bd59ed00ff5$var$rsUpperRange + "]", $cdef6bd59ed00ff5$var$rsFitz = "\ud83c[\udffb-\udfff]", $cdef6bd59ed00ff5$var$rsModifier = "(?:" + $cdef6bd59ed00ff5$var$rsCombo + "|" + $cdef6bd59ed00ff5$var$rsFitz + ")", $cdef6bd59ed00ff5$var$rsNonAstral = "[^" + $cdef6bd59ed00ff5$var$rsAstralRange + "]", $cdef6bd59ed00ff5$var$rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", $cdef6bd59ed00ff5$var$rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", $cdef6bd59ed00ff5$var$rsUpper = "[" + $cdef6bd59ed00ff5$var$rsUpperRange + "]", $cdef6bd59ed00ff5$var$rsZWJ = "\\u200d";
/** Used to compose unicode regexes. */ var $cdef6bd59ed00ff5$var$rsLowerMisc = "(?:" + $cdef6bd59ed00ff5$var$rsLower + "|" + $cdef6bd59ed00ff5$var$rsMisc + ")", $cdef6bd59ed00ff5$var$rsUpperMisc = "(?:" + $cdef6bd59ed00ff5$var$rsUpper + "|" + $cdef6bd59ed00ff5$var$rsMisc + ")", $cdef6bd59ed00ff5$var$rsOptLowerContr = "(?:" + $cdef6bd59ed00ff5$var$rsApos + "(?:d|ll|m|re|s|t|ve))?", $cdef6bd59ed00ff5$var$rsOptUpperContr = "(?:" + $cdef6bd59ed00ff5$var$rsApos + "(?:D|LL|M|RE|S|T|VE))?", $cdef6bd59ed00ff5$var$reOptMod = $cdef6bd59ed00ff5$var$rsModifier + "?", $cdef6bd59ed00ff5$var$rsOptVar = "[" + $cdef6bd59ed00ff5$var$rsVarRange + "]?", $cdef6bd59ed00ff5$var$rsOptJoin = "(?:" + $cdef6bd59ed00ff5$var$rsZWJ + "(?:" + [
    $cdef6bd59ed00ff5$var$rsNonAstral,
    $cdef6bd59ed00ff5$var$rsRegional,
    $cdef6bd59ed00ff5$var$rsSurrPair
].join("|") + ")" + $cdef6bd59ed00ff5$var$rsOptVar + $cdef6bd59ed00ff5$var$reOptMod + ")*", $cdef6bd59ed00ff5$var$rsSeq = $cdef6bd59ed00ff5$var$rsOptVar + $cdef6bd59ed00ff5$var$reOptMod + $cdef6bd59ed00ff5$var$rsOptJoin, $cdef6bd59ed00ff5$var$rsEmoji = "(?:" + [
    $cdef6bd59ed00ff5$var$rsDingbat,
    $cdef6bd59ed00ff5$var$rsRegional,
    $cdef6bd59ed00ff5$var$rsSurrPair
].join("|") + ")" + $cdef6bd59ed00ff5$var$rsSeq, $cdef6bd59ed00ff5$var$rsSymbol = "(?:" + [
    $cdef6bd59ed00ff5$var$rsNonAstral + $cdef6bd59ed00ff5$var$rsCombo + "?",
    $cdef6bd59ed00ff5$var$rsCombo,
    $cdef6bd59ed00ff5$var$rsRegional,
    $cdef6bd59ed00ff5$var$rsSurrPair,
    $cdef6bd59ed00ff5$var$rsAstral
].join("|") + ")";
/** Used to match apostrophes. */ var $cdef6bd59ed00ff5$var$reApos = RegExp($cdef6bd59ed00ff5$var$rsApos, "g");
/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */ var $cdef6bd59ed00ff5$var$reComboMark = RegExp($cdef6bd59ed00ff5$var$rsCombo, "g");
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $cdef6bd59ed00ff5$var$reUnicode = RegExp($cdef6bd59ed00ff5$var$rsFitz + "(?=" + $cdef6bd59ed00ff5$var$rsFitz + ")|" + $cdef6bd59ed00ff5$var$rsSymbol + $cdef6bd59ed00ff5$var$rsSeq, "g");
/** Used to match complex or compound words. */ var $cdef6bd59ed00ff5$var$reUnicodeWord = RegExp([
    $cdef6bd59ed00ff5$var$rsUpper + "?" + $cdef6bd59ed00ff5$var$rsLower + "+" + $cdef6bd59ed00ff5$var$rsOptLowerContr + "(?=" + [
        $cdef6bd59ed00ff5$var$rsBreak,
        $cdef6bd59ed00ff5$var$rsUpper,
        "$"
    ].join("|") + ")",
    $cdef6bd59ed00ff5$var$rsUpperMisc + "+" + $cdef6bd59ed00ff5$var$rsOptUpperContr + "(?=" + [
        $cdef6bd59ed00ff5$var$rsBreak,
        $cdef6bd59ed00ff5$var$rsUpper + $cdef6bd59ed00ff5$var$rsLowerMisc,
        "$"
    ].join("|") + ")",
    $cdef6bd59ed00ff5$var$rsUpper + "?" + $cdef6bd59ed00ff5$var$rsLowerMisc + "+" + $cdef6bd59ed00ff5$var$rsOptLowerContr,
    $cdef6bd59ed00ff5$var$rsUpper + "+" + $cdef6bd59ed00ff5$var$rsOptUpperContr,
    $cdef6bd59ed00ff5$var$rsDigits,
    $cdef6bd59ed00ff5$var$rsEmoji
].join("|"), "g");
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $cdef6bd59ed00ff5$var$reHasUnicode = RegExp("[" + $cdef6bd59ed00ff5$var$rsZWJ + $cdef6bd59ed00ff5$var$rsAstralRange + $cdef6bd59ed00ff5$var$rsComboMarksRange + $cdef6bd59ed00ff5$var$rsComboSymbolsRange + $cdef6bd59ed00ff5$var$rsVarRange + "]");
/** Used to detect strings that need a more robust regexp to match words. */ var $cdef6bd59ed00ff5$var$reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
/** Used to map Latin Unicode letters to basic Latin letters. */ var $cdef6bd59ed00ff5$var$deburredLetters = {
    // Latin-1 Supplement block.
    "\xc0": "A",
    "\xc1": "A",
    "\xc2": "A",
    "\xc3": "A",
    "\xc4": "A",
    "\xc5": "A",
    "\xe0": "a",
    "\xe1": "a",
    "\xe2": "a",
    "\xe3": "a",
    "\xe4": "a",
    "\xe5": "a",
    "\xc7": "C",
    "\xe7": "c",
    "\xd0": "D",
    "\xf0": "d",
    "\xc8": "E",
    "\xc9": "E",
    "\xca": "E",
    "\xcb": "E",
    "\xe8": "e",
    "\xe9": "e",
    "\xea": "e",
    "\xeb": "e",
    "\xcc": "I",
    "\xcd": "I",
    "\xce": "I",
    "\xcf": "I",
    "\xec": "i",
    "\xed": "i",
    "\xee": "i",
    "\xef": "i",
    "\xd1": "N",
    "\xf1": "n",
    "\xd2": "O",
    "\xd3": "O",
    "\xd4": "O",
    "\xd5": "O",
    "\xd6": "O",
    "\xd8": "O",
    "\xf2": "o",
    "\xf3": "o",
    "\xf4": "o",
    "\xf5": "o",
    "\xf6": "o",
    "\xf8": "o",
    "\xd9": "U",
    "\xda": "U",
    "\xdb": "U",
    "\xdc": "U",
    "\xf9": "u",
    "\xfa": "u",
    "\xfb": "u",
    "\xfc": "u",
    "\xdd": "Y",
    "\xfd": "y",
    "\xff": "y",
    "\xc6": "Ae",
    "\xe6": "ae",
    "\xde": "Th",
    "\xfe": "th",
    "\xdf": "ss",
    // Latin Extended-A block.
    "Ā": "A",
    "Ă": "A",
    "Ą": "A",
    "ā": "a",
    "ă": "a",
    "ą": "a",
    "Ć": "C",
    "Ĉ": "C",
    "Ċ": "C",
    "Č": "C",
    "ć": "c",
    "ĉ": "c",
    "ċ": "c",
    "č": "c",
    "Ď": "D",
    "Đ": "D",
    "ď": "d",
    "đ": "d",
    "Ē": "E",
    "Ĕ": "E",
    "Ė": "E",
    "Ę": "E",
    "Ě": "E",
    "ē": "e",
    "ĕ": "e",
    "ė": "e",
    "ę": "e",
    "ě": "e",
    "Ĝ": "G",
    "Ğ": "G",
    "Ġ": "G",
    "Ģ": "G",
    "ĝ": "g",
    "ğ": "g",
    "ġ": "g",
    "ģ": "g",
    "Ĥ": "H",
    "Ħ": "H",
    "ĥ": "h",
    "ħ": "h",
    "Ĩ": "I",
    "Ī": "I",
    "Ĭ": "I",
    "Į": "I",
    "İ": "I",
    "ĩ": "i",
    "ī": "i",
    "ĭ": "i",
    "į": "i",
    "ı": "i",
    "Ĵ": "J",
    "ĵ": "j",
    "Ķ": "K",
    "ķ": "k",
    "ĸ": "k",
    "Ĺ": "L",
    "Ļ": "L",
    "Ľ": "L",
    "Ŀ": "L",
    "Ł": "L",
    "ĺ": "l",
    "ļ": "l",
    "ľ": "l",
    "ŀ": "l",
    "ł": "l",
    "Ń": "N",
    "Ņ": "N",
    "Ň": "N",
    "Ŋ": "N",
    "ń": "n",
    "ņ": "n",
    "ň": "n",
    "ŋ": "n",
    "Ō": "O",
    "Ŏ": "O",
    "Ő": "O",
    "ō": "o",
    "ŏ": "o",
    "ő": "o",
    "Ŕ": "R",
    "Ŗ": "R",
    "Ř": "R",
    "ŕ": "r",
    "ŗ": "r",
    "ř": "r",
    "Ś": "S",
    "Ŝ": "S",
    "Ş": "S",
    "Š": "S",
    "ś": "s",
    "ŝ": "s",
    "ş": "s",
    "š": "s",
    "Ţ": "T",
    "Ť": "T",
    "Ŧ": "T",
    "ţ": "t",
    "ť": "t",
    "ŧ": "t",
    "Ũ": "U",
    "Ū": "U",
    "Ŭ": "U",
    "Ů": "U",
    "Ű": "U",
    "Ų": "U",
    "ũ": "u",
    "ū": "u",
    "ŭ": "u",
    "ů": "u",
    "ű": "u",
    "ų": "u",
    "Ŵ": "W",
    "ŵ": "w",
    "Ŷ": "Y",
    "ŷ": "y",
    "Ÿ": "Y",
    "Ź": "Z",
    "Ż": "Z",
    "Ž": "Z",
    "ź": "z",
    "ż": "z",
    "ž": "z",
    "Ĳ": "IJ",
    "ĳ": "ij",
    "Œ": "Oe",
    "œ": "oe",
    "ŉ": "'n",
    "ſ": "ss"
};
/** Detect free variable `global` from Node.js. */ var $cdef6bd59ed00ff5$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $cdef6bd59ed00ff5$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $cdef6bd59ed00ff5$var$root = $cdef6bd59ed00ff5$var$freeGlobal || $cdef6bd59ed00ff5$var$freeSelf || Function("return this")();
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function $cdef6bd59ed00ff5$var$arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array ? array.length : 0;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $cdef6bd59ed00ff5$var$asciiToArray(string) {
    return string.split("");
}
/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $cdef6bd59ed00ff5$var$asciiWords(string) {
    return string.match($cdef6bd59ed00ff5$var$reAsciiWord) || [];
}
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */ function $cdef6bd59ed00ff5$var$basePropertyOf(object) {
    return function(key) {
        return object == null ? undefined : object[key];
    };
}
/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */ var $cdef6bd59ed00ff5$var$deburrLetter = $cdef6bd59ed00ff5$var$basePropertyOf($cdef6bd59ed00ff5$var$deburredLetters);
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $cdef6bd59ed00ff5$var$hasUnicode(string) {
    return $cdef6bd59ed00ff5$var$reHasUnicode.test(string);
}
/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */ function $cdef6bd59ed00ff5$var$hasUnicodeWord(string) {
    return $cdef6bd59ed00ff5$var$reHasUnicodeWord.test(string);
}
/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $cdef6bd59ed00ff5$var$stringToArray(string) {
    return $cdef6bd59ed00ff5$var$hasUnicode(string) ? $cdef6bd59ed00ff5$var$unicodeToArray(string) : $cdef6bd59ed00ff5$var$asciiToArray(string);
}
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $cdef6bd59ed00ff5$var$unicodeToArray(string) {
    return string.match($cdef6bd59ed00ff5$var$reUnicode) || [];
}
/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $cdef6bd59ed00ff5$var$unicodeWords(string) {
    return string.match($cdef6bd59ed00ff5$var$reUnicodeWord) || [];
}
/** Used for built-in method references. */ var $cdef6bd59ed00ff5$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $cdef6bd59ed00ff5$var$objectToString = $cdef6bd59ed00ff5$var$objectProto.toString;
/** Built-in value references. */ var $cdef6bd59ed00ff5$var$Symbol = $cdef6bd59ed00ff5$var$root.Symbol;
/** Used to convert symbols to primitives and strings. */ var $cdef6bd59ed00ff5$var$symbolProto = $cdef6bd59ed00ff5$var$Symbol ? $cdef6bd59ed00ff5$var$Symbol.prototype : undefined, $cdef6bd59ed00ff5$var$symbolToString = $cdef6bd59ed00ff5$var$symbolProto ? $cdef6bd59ed00ff5$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $cdef6bd59ed00ff5$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $cdef6bd59ed00ff5$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if ($cdef6bd59ed00ff5$var$isSymbol(value)) return $cdef6bd59ed00ff5$var$symbolToString ? $cdef6bd59ed00ff5$var$symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -$cdef6bd59ed00ff5$var$INFINITY ? "-0" : result;
}
/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function $cdef6bd59ed00ff5$var$castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : $cdef6bd59ed00ff5$var$baseSlice(array, start, end);
}
/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function $cdef6bd59ed00ff5$var$createCaseFirst(methodName) {
    return function(string) {
        string = $cdef6bd59ed00ff5$var$toString(string);
        var strSymbols = $cdef6bd59ed00ff5$var$hasUnicode(string) ? $cdef6bd59ed00ff5$var$stringToArray(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? $cdef6bd59ed00ff5$var$castSlice(strSymbols, 1).join("") : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */ function $cdef6bd59ed00ff5$var$createCompounder(callback) {
    return function(string) {
        return $cdef6bd59ed00ff5$var$arrayReduce($cdef6bd59ed00ff5$var$words($cdef6bd59ed00ff5$var$deburr(string).replace($cdef6bd59ed00ff5$var$reApos, "")), callback, "");
    };
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $cdef6bd59ed00ff5$var$isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $cdef6bd59ed00ff5$var$isSymbol(value) {
    return typeof value == "symbol" || $cdef6bd59ed00ff5$var$isObjectLike(value) && $cdef6bd59ed00ff5$var$objectToString.call(value) == $cdef6bd59ed00ff5$var$symbolTag;
}
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $cdef6bd59ed00ff5$var$toString(value) {
    return value == null ? "" : $cdef6bd59ed00ff5$var$baseToString(value);
}
/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */ var $cdef6bd59ed00ff5$var$camelCase = $cdef6bd59ed00ff5$var$createCompounder(function(result, word, index) {
    word = word.toLowerCase();
    return result + (index ? $cdef6bd59ed00ff5$var$capitalize(word) : word);
});
/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */ function $cdef6bd59ed00ff5$var$capitalize(string) {
    return $cdef6bd59ed00ff5$var$upperFirst($cdef6bd59ed00ff5$var$toString(string).toLowerCase());
}
/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */ function $cdef6bd59ed00ff5$var$deburr(string) {
    string = $cdef6bd59ed00ff5$var$toString(string);
    return string && string.replace($cdef6bd59ed00ff5$var$reLatin, $cdef6bd59ed00ff5$var$deburrLetter).replace($cdef6bd59ed00ff5$var$reComboMark, "");
}
/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var $cdef6bd59ed00ff5$var$upperFirst = $cdef6bd59ed00ff5$var$createCaseFirst("toUpperCase");
/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */ function $cdef6bd59ed00ff5$var$words(string, pattern, guard) {
    string = $cdef6bd59ed00ff5$var$toString(string);
    pattern = guard ? undefined : pattern;
    if (pattern === undefined) return $cdef6bd59ed00ff5$var$hasUnicodeWord(string) ? $cdef6bd59ed00ff5$var$unicodeWords(string) : $cdef6bd59ed00ff5$var$asciiWords(string);
    return string.match(pattern) || [];
}
$cdef6bd59ed00ff5$exports = $cdef6bd59ed00ff5$var$camelCase;



var $94WEq = parcelRequire("94WEq");
var $4ccf8135492ead97$exports = {};


/**
* @version: 3.1
* @author: Dan Grossman http://www.dangrossman.info/
* @copyright: Copyright (c) 2012-2019 Dan Grossman. All rights reserved.
* @license: Licensed under the MIT license. See http://www.opensource.org/licenses/mit-license.php
* @website: http://www.daterangepicker.com/
*/ // Following the UMD template https://github.com/umdjs/umd/blob/master/templates/returnExportsGlobal.js
(function(root, factory) {
    if (typeof define === "function" && define.amd) // AMD. Make globaly available as well
    define([
        "moment",
        "jquery"
    ], function(moment, jquery) {
        if (!jquery.fn) jquery.fn = {}; // webpack server rendering
        if (typeof moment !== "function" && moment.hasOwnProperty("default")) moment = moment["default"];
        return factory(moment, jquery);
    });
    else if (0, $4ccf8135492ead97$exports) {
        // Node / Browserify
        //isomorphic issue
        var jQuery = typeof window != "undefined" ? window.jQuery : undefined;
        if (!jQuery) {
            jQuery = (parcelRequire("i4YVD"));
            if (!jQuery.fn) jQuery.fn = {};
        }
        var moment = typeof window != "undefined" && typeof window.moment != "undefined" ? window.moment : (parcelRequire("g1KQj"));
        $4ccf8135492ead97$exports = factory(moment, jQuery);
    } else // Browser globals
    root.daterangepicker = factory(root.moment, root.jQuery);
})($4ccf8135492ead97$exports, function(moment, $) {
    var DateRangePicker = function(element, options, cb) {
        //default settings for options
        this.parentEl = "body";
        this.element = $(element);
        this.startDate = moment().startOf("day");
        this.endDate = moment().endOf("day");
        this.minDate = false;
        this.maxDate = false;
        this.maxSpan = false;
        this.autoApply = false;
        this.singleDatePicker = false;
        this.showDropdowns = false;
        this.minYear = moment().subtract(100, "year").format("YYYY");
        this.maxYear = moment().add(100, "year").format("YYYY");
        this.showWeekNumbers = false;
        this.showISOWeekNumbers = false;
        this.showCustomRangeLabel = true;
        this.timePicker = false;
        this.timePicker24Hour = false;
        this.timePickerIncrement = 1;
        this.timePickerSeconds = false;
        this.linkedCalendars = true;
        this.autoUpdateInput = true;
        this.alwaysShowCalendars = false;
        this.ranges = {};
        this.opens = "right";
        if (this.element.hasClass("pull-right")) this.opens = "left";
        this.drops = "down";
        if (this.element.hasClass("dropup")) this.drops = "up";
        this.buttonClasses = "btn btn-sm";
        this.applyButtonClasses = "btn-primary";
        this.cancelButtonClasses = "btn-default";
        this.locale = {
            direction: "ltr",
            format: moment.localeData().longDateFormat("L"),
            separator: " - ",
            applyLabel: "Apply",
            cancelLabel: "Cancel",
            weekLabel: "W",
            customRangeLabel: "Custom Range",
            daysOfWeek: moment.weekdaysMin(),
            monthNames: moment.monthsShort(),
            firstDay: moment.localeData().firstDayOfWeek()
        };
        this.callback = function() {};
        //some state information
        this.isShowing = false;
        this.leftCalendar = {};
        this.rightCalendar = {};
        //custom options from user
        if (typeof options !== "object" || options === null) options = {};
        //allow setting options with data attributes
        //data-api options will be overwritten with custom javascript options
        options = $.extend(this.element.data(), options);
        //html template for the picker UI
        if (typeof options.template !== "string" && !(options.template instanceof $)) options.template = '<div class="daterangepicker"><div class="ranges"></div><div class="drp-calendar left"><div class="calendar-table"></div><div class="calendar-time"></div></div><div class="drp-calendar right"><div class="calendar-table"></div><div class="calendar-time"></div></div><div class="drp-buttons"><span class="drp-selected"></span><button class="cancelBtn" type="button"></button><button class="applyBtn" disabled="disabled" type="button"></button> </div></div>';
        this.parentEl = options.parentEl && $(options.parentEl).length ? $(options.parentEl) : $(this.parentEl);
        this.container = $(options.template).appendTo(this.parentEl);
        //
        // handle all the possible options overriding defaults
        //
        if (typeof options.locale === "object") {
            if (typeof options.locale.direction === "string") this.locale.direction = options.locale.direction;
            if (typeof options.locale.format === "string") this.locale.format = options.locale.format;
            if (typeof options.locale.separator === "string") this.locale.separator = options.locale.separator;
            if (typeof options.locale.daysOfWeek === "object") this.locale.daysOfWeek = options.locale.daysOfWeek.slice();
            if (typeof options.locale.monthNames === "object") this.locale.monthNames = options.locale.monthNames.slice();
            if (typeof options.locale.firstDay === "number") this.locale.firstDay = options.locale.firstDay;
            if (typeof options.locale.applyLabel === "string") this.locale.applyLabel = options.locale.applyLabel;
            if (typeof options.locale.cancelLabel === "string") this.locale.cancelLabel = options.locale.cancelLabel;
            if (typeof options.locale.weekLabel === "string") this.locale.weekLabel = options.locale.weekLabel;
            if (typeof options.locale.customRangeLabel === "string") {
                //Support unicode chars in the custom range name.
                var elem = document.createElement("textarea");
                elem.innerHTML = options.locale.customRangeLabel;
                var rangeHtml = elem.value;
                this.locale.customRangeLabel = rangeHtml;
            }
        }
        this.container.addClass(this.locale.direction);
        if (typeof options.startDate === "string") this.startDate = moment(options.startDate, this.locale.format);
        if (typeof options.endDate === "string") this.endDate = moment(options.endDate, this.locale.format);
        if (typeof options.minDate === "string") this.minDate = moment(options.minDate, this.locale.format);
        if (typeof options.maxDate === "string") this.maxDate = moment(options.maxDate, this.locale.format);
        if (typeof options.startDate === "object") this.startDate = moment(options.startDate);
        if (typeof options.endDate === "object") this.endDate = moment(options.endDate);
        if (typeof options.minDate === "object") this.minDate = moment(options.minDate);
        if (typeof options.maxDate === "object") this.maxDate = moment(options.maxDate);
        // sanity check for bad options
        if (this.minDate && this.startDate.isBefore(this.minDate)) this.startDate = this.minDate.clone();
        // sanity check for bad options
        if (this.maxDate && this.endDate.isAfter(this.maxDate)) this.endDate = this.maxDate.clone();
        if (typeof options.applyButtonClasses === "string") this.applyButtonClasses = options.applyButtonClasses;
        if (typeof options.applyClass === "string") this.applyButtonClasses = options.applyClass;
        if (typeof options.cancelButtonClasses === "string") this.cancelButtonClasses = options.cancelButtonClasses;
        if (typeof options.cancelClass === "string") this.cancelButtonClasses = options.cancelClass;
        if (typeof options.maxSpan === "object") this.maxSpan = options.maxSpan;
        if (typeof options.dateLimit === "object") this.maxSpan = options.dateLimit;
        if (typeof options.opens === "string") this.opens = options.opens;
        if (typeof options.drops === "string") this.drops = options.drops;
        if (typeof options.showWeekNumbers === "boolean") this.showWeekNumbers = options.showWeekNumbers;
        if (typeof options.showISOWeekNumbers === "boolean") this.showISOWeekNumbers = options.showISOWeekNumbers;
        if (typeof options.buttonClasses === "string") this.buttonClasses = options.buttonClasses;
        if (typeof options.buttonClasses === "object") this.buttonClasses = options.buttonClasses.join(" ");
        if (typeof options.showDropdowns === "boolean") this.showDropdowns = options.showDropdowns;
        if (typeof options.minYear === "number") this.minYear = options.minYear;
        if (typeof options.maxYear === "number") this.maxYear = options.maxYear;
        if (typeof options.showCustomRangeLabel === "boolean") this.showCustomRangeLabel = options.showCustomRangeLabel;
        if (typeof options.singleDatePicker === "boolean") {
            this.singleDatePicker = options.singleDatePicker;
            if (this.singleDatePicker) this.endDate = this.startDate.clone();
        }
        if (typeof options.timePicker === "boolean") this.timePicker = options.timePicker;
        if (typeof options.timePickerSeconds === "boolean") this.timePickerSeconds = options.timePickerSeconds;
        if (typeof options.timePickerIncrement === "number") this.timePickerIncrement = options.timePickerIncrement;
        if (typeof options.timePicker24Hour === "boolean") this.timePicker24Hour = options.timePicker24Hour;
        if (typeof options.autoApply === "boolean") this.autoApply = options.autoApply;
        if (typeof options.autoUpdateInput === "boolean") this.autoUpdateInput = options.autoUpdateInput;
        if (typeof options.linkedCalendars === "boolean") this.linkedCalendars = options.linkedCalendars;
        if (typeof options.isInvalidDate === "function") this.isInvalidDate = options.isInvalidDate;
        if (typeof options.isCustomDate === "function") this.isCustomDate = options.isCustomDate;
        if (typeof options.alwaysShowCalendars === "boolean") this.alwaysShowCalendars = options.alwaysShowCalendars;
        // update day names order to firstDay
        if (this.locale.firstDay != 0) {
            var iterator = this.locale.firstDay;
            while(iterator > 0){
                this.locale.daysOfWeek.push(this.locale.daysOfWeek.shift());
                iterator--;
            }
        }
        var start, end, range;
        //if no start/end dates set, check if an input element contains initial values
        if (typeof options.startDate === "undefined" && typeof options.endDate === "undefined") {
            if ($(this.element).is(":text")) {
                var val = $(this.element).val(), split = val.split(this.locale.separator);
                start = end = null;
                if (split.length == 2) {
                    start = moment(split[0], this.locale.format);
                    end = moment(split[1], this.locale.format);
                } else if (this.singleDatePicker && val !== "") {
                    start = moment(val, this.locale.format);
                    end = moment(val, this.locale.format);
                }
                if (start !== null && end !== null) {
                    this.setStartDate(start);
                    this.setEndDate(end);
                }
            }
        }
        if (typeof options.ranges === "object") {
            for(range in options.ranges){
                if (typeof options.ranges[range][0] === "string") start = moment(options.ranges[range][0], this.locale.format);
                else start = moment(options.ranges[range][0]);
                if (typeof options.ranges[range][1] === "string") end = moment(options.ranges[range][1], this.locale.format);
                else end = moment(options.ranges[range][1]);
                // If the start or end date exceed those allowed by the minDate or maxSpan
                // options, shorten the range to the allowable period.
                if (this.minDate && start.isBefore(this.minDate)) start = this.minDate.clone();
                var maxDate = this.maxDate;
                if (this.maxSpan && maxDate && start.clone().add(this.maxSpan).isAfter(maxDate)) maxDate = start.clone().add(this.maxSpan);
                if (maxDate && end.isAfter(maxDate)) end = maxDate.clone();
                // If the end of the range is before the minimum or the start of the range is
                // after the maximum, don't display this range option at all.
                if (this.minDate && end.isBefore(this.minDate, this.timepicker ? "minute" : "day") || maxDate && start.isAfter(maxDate, this.timepicker ? "minute" : "day")) continue;
                //Support unicode chars in the range names.
                var elem = document.createElement("textarea");
                elem.innerHTML = range;
                var rangeHtml = elem.value;
                this.ranges[rangeHtml] = [
                    start,
                    end
                ];
            }
            var list = "<ul>";
            for(range in this.ranges)list += '<li data-range-key="' + range + '">' + range + "</li>";
            if (this.showCustomRangeLabel) list += '<li data-range-key="' + this.locale.customRangeLabel + '">' + this.locale.customRangeLabel + "</li>";
            list += "</ul>";
            this.container.find(".ranges").prepend(list);
        }
        if (typeof cb === "function") this.callback = cb;
        if (!this.timePicker) {
            this.startDate = this.startDate.startOf("day");
            this.endDate = this.endDate.endOf("day");
            this.container.find(".calendar-time").hide();
        }
        //can't be used together for now
        if (this.timePicker && this.autoApply) this.autoApply = false;
        if (this.autoApply) this.container.addClass("auto-apply");
        if (typeof options.ranges === "object") this.container.addClass("show-ranges");
        if (this.singleDatePicker) {
            this.container.addClass("single");
            this.container.find(".drp-calendar.left").addClass("single");
            this.container.find(".drp-calendar.left").show();
            this.container.find(".drp-calendar.right").hide();
            if (!this.timePicker && this.autoApply) this.container.addClass("auto-apply");
        }
        if (typeof options.ranges === "undefined" && !this.singleDatePicker || this.alwaysShowCalendars) this.container.addClass("show-calendar");
        this.container.addClass("opens" + this.opens);
        //apply CSS classes and labels to buttons
        this.container.find(".applyBtn, .cancelBtn").addClass(this.buttonClasses);
        if (this.applyButtonClasses.length) this.container.find(".applyBtn").addClass(this.applyButtonClasses);
        if (this.cancelButtonClasses.length) this.container.find(".cancelBtn").addClass(this.cancelButtonClasses);
        this.container.find(".applyBtn").html(this.locale.applyLabel);
        this.container.find(".cancelBtn").html(this.locale.cancelLabel);
        //
        // event listeners
        //
        this.container.find(".drp-calendar").on("click.daterangepicker", ".prev", $.proxy(this.clickPrev, this)).on("click.daterangepicker", ".next", $.proxy(this.clickNext, this)).on("mousedown.daterangepicker", "td.available", $.proxy(this.clickDate, this)).on("mouseenter.daterangepicker", "td.available", $.proxy(this.hoverDate, this)).on("change.daterangepicker", "select.yearselect", $.proxy(this.monthOrYearChanged, this)).on("change.daterangepicker", "select.monthselect", $.proxy(this.monthOrYearChanged, this)).on("change.daterangepicker", "select.hourselect,select.minuteselect,select.secondselect,select.ampmselect", $.proxy(this.timeChanged, this));
        this.container.find(".ranges").on("click.daterangepicker", "li", $.proxy(this.clickRange, this));
        this.container.find(".drp-buttons").on("click.daterangepicker", "button.applyBtn", $.proxy(this.clickApply, this)).on("click.daterangepicker", "button.cancelBtn", $.proxy(this.clickCancel, this));
        if (this.element.is("input") || this.element.is("button")) this.element.on({
            "click.daterangepicker": $.proxy(this.show, this),
            "focus.daterangepicker": $.proxy(this.show, this),
            "keyup.daterangepicker": $.proxy(this.elementChanged, this),
            "keydown.daterangepicker": $.proxy(this.keydown, this) //IE 11 compatibility
        });
        else {
            this.element.on("click.daterangepicker", $.proxy(this.toggle, this));
            this.element.on("keydown.daterangepicker", $.proxy(this.toggle, this));
        }
        //
        // if attached to a text input, set the initial value
        //
        this.updateElement();
    };
    DateRangePicker.prototype = {
        constructor: DateRangePicker,
        setStartDate: function(startDate) {
            if (typeof startDate === "string") this.startDate = moment(startDate, this.locale.format);
            if (typeof startDate === "object") this.startDate = moment(startDate);
            if (!this.timePicker) this.startDate = this.startDate.startOf("day");
            if (this.timePicker && this.timePickerIncrement) this.startDate.minute(Math.round(this.startDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);
            if (this.minDate && this.startDate.isBefore(this.minDate)) {
                this.startDate = this.minDate.clone();
                if (this.timePicker && this.timePickerIncrement) this.startDate.minute(Math.round(this.startDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);
            }
            if (this.maxDate && this.startDate.isAfter(this.maxDate)) {
                this.startDate = this.maxDate.clone();
                if (this.timePicker && this.timePickerIncrement) this.startDate.minute(Math.floor(this.startDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);
            }
            if (!this.isShowing) this.updateElement();
            this.updateMonthsInView();
        },
        setEndDate: function(endDate) {
            if (typeof endDate === "string") this.endDate = moment(endDate, this.locale.format);
            if (typeof endDate === "object") this.endDate = moment(endDate);
            if (!this.timePicker) this.endDate = this.endDate.endOf("day");
            if (this.timePicker && this.timePickerIncrement) this.endDate.minute(Math.round(this.endDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);
            if (this.endDate.isBefore(this.startDate)) this.endDate = this.startDate.clone();
            if (this.maxDate && this.endDate.isAfter(this.maxDate)) this.endDate = this.maxDate.clone();
            if (this.maxSpan && this.startDate.clone().add(this.maxSpan).isBefore(this.endDate)) this.endDate = this.startDate.clone().add(this.maxSpan);
            this.previousRightTime = this.endDate.clone();
            this.container.find(".drp-selected").html(this.startDate.format(this.locale.format) + this.locale.separator + this.endDate.format(this.locale.format));
            if (!this.isShowing) this.updateElement();
            this.updateMonthsInView();
        },
        isInvalidDate: function() {
            return false;
        },
        isCustomDate: function() {
            return false;
        },
        updateView: function() {
            if (this.timePicker) {
                this.renderTimePicker("left");
                this.renderTimePicker("right");
                if (!this.endDate) this.container.find(".right .calendar-time select").prop("disabled", true).addClass("disabled");
                else this.container.find(".right .calendar-time select").prop("disabled", false).removeClass("disabled");
            }
            if (this.endDate) this.container.find(".drp-selected").html(this.startDate.format(this.locale.format) + this.locale.separator + this.endDate.format(this.locale.format));
            this.updateMonthsInView();
            this.updateCalendars();
            this.updateFormInputs();
        },
        updateMonthsInView: function() {
            if (this.endDate) {
                //if both dates are visible already, do nothing
                if (!this.singleDatePicker && this.leftCalendar.month && this.rightCalendar.month && (this.startDate.format("YYYY-MM") == this.leftCalendar.month.format("YYYY-MM") || this.startDate.format("YYYY-MM") == this.rightCalendar.month.format("YYYY-MM")) && (this.endDate.format("YYYY-MM") == this.leftCalendar.month.format("YYYY-MM") || this.endDate.format("YYYY-MM") == this.rightCalendar.month.format("YYYY-MM"))) return;
                this.leftCalendar.month = this.startDate.clone().date(2);
                if (!this.linkedCalendars && (this.endDate.month() != this.startDate.month() || this.endDate.year() != this.startDate.year())) this.rightCalendar.month = this.endDate.clone().date(2);
                else this.rightCalendar.month = this.startDate.clone().date(2).add(1, "month");
            } else if (this.leftCalendar.month.format("YYYY-MM") != this.startDate.format("YYYY-MM") && this.rightCalendar.month.format("YYYY-MM") != this.startDate.format("YYYY-MM")) {
                this.leftCalendar.month = this.startDate.clone().date(2);
                this.rightCalendar.month = this.startDate.clone().date(2).add(1, "month");
            }
            if (this.maxDate && this.linkedCalendars && !this.singleDatePicker && this.rightCalendar.month > this.maxDate) {
                this.rightCalendar.month = this.maxDate.clone().date(2);
                this.leftCalendar.month = this.maxDate.clone().date(2).subtract(1, "month");
            }
        },
        updateCalendars: function() {
            if (this.timePicker) {
                var hour, minute, second;
                if (this.endDate) {
                    hour = parseInt(this.container.find(".left .hourselect").val(), 10);
                    minute = parseInt(this.container.find(".left .minuteselect").val(), 10);
                    if (isNaN(minute)) minute = parseInt(this.container.find(".left .minuteselect option:last").val(), 10);
                    second = this.timePickerSeconds ? parseInt(this.container.find(".left .secondselect").val(), 10) : 0;
                    if (!this.timePicker24Hour) {
                        var ampm = this.container.find(".left .ampmselect").val();
                        if (ampm === "PM" && hour < 12) hour += 12;
                        if (ampm === "AM" && hour === 12) hour = 0;
                    }
                } else {
                    hour = parseInt(this.container.find(".right .hourselect").val(), 10);
                    minute = parseInt(this.container.find(".right .minuteselect").val(), 10);
                    if (isNaN(minute)) minute = parseInt(this.container.find(".right .minuteselect option:last").val(), 10);
                    second = this.timePickerSeconds ? parseInt(this.container.find(".right .secondselect").val(), 10) : 0;
                    if (!this.timePicker24Hour) {
                        var ampm = this.container.find(".right .ampmselect").val();
                        if (ampm === "PM" && hour < 12) hour += 12;
                        if (ampm === "AM" && hour === 12) hour = 0;
                    }
                }
                this.leftCalendar.month.hour(hour).minute(minute).second(second);
                this.rightCalendar.month.hour(hour).minute(minute).second(second);
            }
            this.renderCalendar("left");
            this.renderCalendar("right");
            //highlight any predefined range matching the current start and end dates
            this.container.find(".ranges li").removeClass("active");
            if (this.endDate == null) return;
            this.calculateChosenLabel();
        },
        renderCalendar: function(side) {
            //
            // Build the matrix of dates that will populate the calendar
            //
            var calendar = side == "left" ? this.leftCalendar : this.rightCalendar;
            var month = calendar.month.month();
            var year = calendar.month.year();
            var hour = calendar.month.hour();
            var minute = calendar.month.minute();
            var second = calendar.month.second();
            var daysInMonth = moment([
                year,
                month
            ]).daysInMonth();
            var firstDay = moment([
                year,
                month,
                1
            ]);
            var lastDay = moment([
                year,
                month,
                daysInMonth
            ]);
            var lastMonth = moment(firstDay).subtract(1, "month").month();
            var lastYear = moment(firstDay).subtract(1, "month").year();
            var daysInLastMonth = moment([
                lastYear,
                lastMonth
            ]).daysInMonth();
            var dayOfWeek = firstDay.day();
            //initialize a 6 rows x 7 columns array for the calendar
            var calendar = [];
            calendar.firstDay = firstDay;
            calendar.lastDay = lastDay;
            for(var i = 0; i < 6; i++)calendar[i] = [];
            //populate the calendar with date objects
            var startDay = daysInLastMonth - dayOfWeek + this.locale.firstDay + 1;
            if (startDay > daysInLastMonth) startDay -= 7;
            if (dayOfWeek == this.locale.firstDay) startDay = daysInLastMonth - 6;
            var curDate = moment([
                lastYear,
                lastMonth,
                startDay,
                12,
                minute,
                second
            ]);
            var col, row;
            for(var i = 0, col = 0, row = 0; i < 42; i++, col++, curDate = moment(curDate).add(24, "hour")){
                if (i > 0 && col % 7 === 0) {
                    col = 0;
                    row++;
                }
                calendar[row][col] = curDate.clone().hour(hour).minute(minute).second(second);
                curDate.hour(12);
                if (this.minDate && calendar[row][col].format("YYYY-MM-DD") == this.minDate.format("YYYY-MM-DD") && calendar[row][col].isBefore(this.minDate) && side == "left") calendar[row][col] = this.minDate.clone();
                if (this.maxDate && calendar[row][col].format("YYYY-MM-DD") == this.maxDate.format("YYYY-MM-DD") && calendar[row][col].isAfter(this.maxDate) && side == "right") calendar[row][col] = this.maxDate.clone();
            }
            //make the calendar object available to hoverDate/clickDate
            if (side == "left") this.leftCalendar.calendar = calendar;
            else this.rightCalendar.calendar = calendar;
            //
            // Display the calendar
            //
            var minDate = side == "left" ? this.minDate : this.startDate;
            var maxDate = this.maxDate;
            var selected = side == "left" ? this.startDate : this.endDate;
            var arrow = this.locale.direction == "ltr" ? {
                left: "chevron-left",
                right: "chevron-right"
            } : {
                left: "chevron-right",
                right: "chevron-left"
            };
            var html = '<table class="table-condensed">';
            html += "<thead>";
            html += "<tr>";
            // add empty cell for week number
            if (this.showWeekNumbers || this.showISOWeekNumbers) html += "<th></th>";
            if ((!minDate || minDate.isBefore(calendar.firstDay)) && (!this.linkedCalendars || side == "left")) html += '<th class="prev available"><span></span></th>';
            else html += "<th></th>";
            var dateHtml = this.locale.monthNames[calendar[1][1].month()] + calendar[1][1].format(" YYYY");
            if (this.showDropdowns) {
                var currentMonth = calendar[1][1].month();
                var currentYear = calendar[1][1].year();
                var maxYear = maxDate && maxDate.year() || this.maxYear;
                var minYear = minDate && minDate.year() || this.minYear;
                var inMinYear = currentYear == minYear;
                var inMaxYear = currentYear == maxYear;
                var monthHtml = '<select class="monthselect">';
                for(var m = 0; m < 12; m++)if ((!inMinYear || minDate && m >= minDate.month()) && (!inMaxYear || maxDate && m <= maxDate.month())) monthHtml += "<option value='" + m + "'" + (m === currentMonth ? " selected='selected'" : "") + ">" + this.locale.monthNames[m] + "</option>";
                else monthHtml += "<option value='" + m + "'" + (m === currentMonth ? " selected='selected'" : "") + " disabled='disabled'>" + this.locale.monthNames[m] + "</option>";
                monthHtml += "</select>";
                var yearHtml = '<select class="yearselect">';
                for(var y = minYear; y <= maxYear; y++)yearHtml += '<option value="' + y + '"' + (y === currentYear ? ' selected="selected"' : "") + ">" + y + "</option>";
                yearHtml += "</select>";
                dateHtml = monthHtml + yearHtml;
            }
            html += '<th colspan="5" class="month">' + dateHtml + "</th>";
            if ((!maxDate || maxDate.isAfter(calendar.lastDay)) && (!this.linkedCalendars || side == "right" || this.singleDatePicker)) html += '<th class="next available"><span></span></th>';
            else html += "<th></th>";
            html += "</tr>";
            html += "<tr>";
            // add week number label
            if (this.showWeekNumbers || this.showISOWeekNumbers) html += '<th class="week">' + this.locale.weekLabel + "</th>";
            $.each(this.locale.daysOfWeek, function(index, dayOfWeek) {
                html += "<th>" + dayOfWeek + "</th>";
            });
            html += "</tr>";
            html += "</thead>";
            html += "<tbody>";
            //adjust maxDate to reflect the maxSpan setting in order to
            //grey out end dates beyond the maxSpan
            if (this.endDate == null && this.maxSpan) {
                var maxLimit = this.startDate.clone().add(this.maxSpan).endOf("day");
                if (!maxDate || maxLimit.isBefore(maxDate)) maxDate = maxLimit;
            }
            for(var row = 0; row < 6; row++){
                html += "<tr>";
                // add week number
                if (this.showWeekNumbers) html += '<td class="week">' + calendar[row][0].week() + "</td>";
                else if (this.showISOWeekNumbers) html += '<td class="week">' + calendar[row][0].isoWeek() + "</td>";
                for(var col = 0; col < 7; col++){
                    var classes = [];
                    //highlight today's date
                    if (calendar[row][col].isSame(new Date(), "day")) classes.push("today");
                    //highlight weekends
                    if (calendar[row][col].isoWeekday() > 5) classes.push("weekend");
                    //grey out the dates in other months displayed at beginning and end of this calendar
                    if (calendar[row][col].month() != calendar[1][1].month()) classes.push("off", "ends");
                    //don't allow selection of dates before the minimum date
                    if (this.minDate && calendar[row][col].isBefore(this.minDate, "day")) classes.push("off", "disabled");
                    //don't allow selection of dates after the maximum date
                    if (maxDate && calendar[row][col].isAfter(maxDate, "day")) classes.push("off", "disabled");
                    //don't allow selection of date if a custom function decides it's invalid
                    if (this.isInvalidDate(calendar[row][col])) classes.push("off", "disabled");
                    //highlight the currently selected start date
                    if (calendar[row][col].format("YYYY-MM-DD") == this.startDate.format("YYYY-MM-DD")) classes.push("active", "start-date");
                    //highlight the currently selected end date
                    if (this.endDate != null && calendar[row][col].format("YYYY-MM-DD") == this.endDate.format("YYYY-MM-DD")) classes.push("active", "end-date");
                    //highlight dates in-between the selected dates
                    if (this.endDate != null && calendar[row][col] > this.startDate && calendar[row][col] < this.endDate) classes.push("in-range");
                    //apply custom classes for this date
                    var isCustom = this.isCustomDate(calendar[row][col]);
                    if (isCustom !== false) {
                        if (typeof isCustom === "string") classes.push(isCustom);
                        else Array.prototype.push.apply(classes, isCustom);
                    }
                    var cname = "", disabled = false;
                    for(var i = 0; i < classes.length; i++){
                        cname += classes[i] + " ";
                        if (classes[i] == "disabled") disabled = true;
                    }
                    if (!disabled) cname += "available";
                    html += '<td class="' + cname.replace(/^\s+|\s+$/g, "") + '" data-title="' + "r" + row + "c" + col + '">' + calendar[row][col].date() + "</td>";
                }
                html += "</tr>";
            }
            html += "</tbody>";
            html += "</table>";
            this.container.find(".drp-calendar." + side + " .calendar-table").html(html);
        },
        renderTimePicker: function(side) {
            // Don't bother updating the time picker if it's currently disabled
            // because an end date hasn't been clicked yet
            if (side == "right" && !this.endDate) return;
            var html, selected, minDate, maxDate = this.maxDate;
            if (this.maxSpan && (!this.maxDate || this.startDate.clone().add(this.maxSpan).isBefore(this.maxDate))) maxDate = this.startDate.clone().add(this.maxSpan);
            if (side == "left") {
                selected = this.startDate.clone();
                minDate = this.minDate;
            } else if (side == "right") {
                selected = this.endDate.clone();
                minDate = this.startDate;
                //Preserve the time already selected
                var timeSelector = this.container.find(".drp-calendar.right .calendar-time");
                if (timeSelector.html() != "") {
                    selected.hour(!isNaN(selected.hour()) ? selected.hour() : timeSelector.find(".hourselect option:selected").val());
                    selected.minute(!isNaN(selected.minute()) ? selected.minute() : timeSelector.find(".minuteselect option:selected").val());
                    selected.second(!isNaN(selected.second()) ? selected.second() : timeSelector.find(".secondselect option:selected").val());
                    if (!this.timePicker24Hour) {
                        var ampm = timeSelector.find(".ampmselect option:selected").val();
                        if (ampm === "PM" && selected.hour() < 12) selected.hour(selected.hour() + 12);
                        if (ampm === "AM" && selected.hour() === 12) selected.hour(0);
                    }
                }
                if (selected.isBefore(this.startDate)) selected = this.startDate.clone();
                if (maxDate && selected.isAfter(maxDate)) selected = maxDate.clone();
            }
            //
            // hours
            //
            html = '<select class="hourselect">';
            var start = this.timePicker24Hour ? 0 : 1;
            var end = this.timePicker24Hour ? 23 : 12;
            for(var i = start; i <= end; i++){
                var i_in_24 = i;
                if (!this.timePicker24Hour) i_in_24 = selected.hour() >= 12 ? i == 12 ? 12 : i + 12 : i == 12 ? 0 : i;
                var time = selected.clone().hour(i_in_24);
                var disabled = false;
                if (minDate && time.minute(59).isBefore(minDate)) disabled = true;
                if (maxDate && time.minute(0).isAfter(maxDate)) disabled = true;
                if (i_in_24 == selected.hour() && !disabled) html += '<option value="' + i + '" selected="selected">' + i + "</option>";
                else if (disabled) html += '<option value="' + i + '" disabled="disabled" class="disabled">' + i + "</option>";
                else html += '<option value="' + i + '">' + i + "</option>";
            }
            html += "</select> ";
            //
            // minutes
            //
            html += ': <select class="minuteselect">';
            for(var i = 0; i < 60; i += this.timePickerIncrement){
                var padded = i < 10 ? "0" + i : i;
                var time = selected.clone().minute(i);
                var disabled = false;
                if (minDate && time.second(59).isBefore(minDate)) disabled = true;
                if (maxDate && time.second(0).isAfter(maxDate)) disabled = true;
                if (selected.minute() == i && !disabled) html += '<option value="' + i + '" selected="selected">' + padded + "</option>";
                else if (disabled) html += '<option value="' + i + '" disabled="disabled" class="disabled">' + padded + "</option>";
                else html += '<option value="' + i + '">' + padded + "</option>";
            }
            html += "</select> ";
            //
            // seconds
            //
            if (this.timePickerSeconds) {
                html += ': <select class="secondselect">';
                for(var i = 0; i < 60; i++){
                    var padded = i < 10 ? "0" + i : i;
                    var time = selected.clone().second(i);
                    var disabled = false;
                    if (minDate && time.isBefore(minDate)) disabled = true;
                    if (maxDate && time.isAfter(maxDate)) disabled = true;
                    if (selected.second() == i && !disabled) html += '<option value="' + i + '" selected="selected">' + padded + "</option>";
                    else if (disabled) html += '<option value="' + i + '" disabled="disabled" class="disabled">' + padded + "</option>";
                    else html += '<option value="' + i + '">' + padded + "</option>";
                }
                html += "</select> ";
            }
            //
            // AM/PM
            //
            if (!this.timePicker24Hour) {
                html += '<select class="ampmselect">';
                var am_html = "";
                var pm_html = "";
                if (minDate && selected.clone().hour(12).minute(0).second(0).isBefore(minDate)) am_html = ' disabled="disabled" class="disabled"';
                if (maxDate && selected.clone().hour(0).minute(0).second(0).isAfter(maxDate)) pm_html = ' disabled="disabled" class="disabled"';
                if (selected.hour() >= 12) html += '<option value="AM"' + am_html + '>AM</option><option value="PM" selected="selected"' + pm_html + ">PM</option>";
                else html += '<option value="AM" selected="selected"' + am_html + '>AM</option><option value="PM"' + pm_html + ">PM</option>";
                html += "</select>";
            }
            this.container.find(".drp-calendar." + side + " .calendar-time").html(html);
        },
        updateFormInputs: function() {
            if (this.singleDatePicker || this.endDate && (this.startDate.isBefore(this.endDate) || this.startDate.isSame(this.endDate))) this.container.find("button.applyBtn").prop("disabled", false);
            else this.container.find("button.applyBtn").prop("disabled", true);
        },
        move: function() {
            var parentOffset = {
                top: 0,
                left: 0
            }, containerTop, drops = this.drops;
            var parentRightEdge = $(window).width();
            if (!this.parentEl.is("body")) {
                parentOffset = {
                    top: this.parentEl.offset().top - this.parentEl.scrollTop(),
                    left: this.parentEl.offset().left - this.parentEl.scrollLeft()
                };
                parentRightEdge = this.parentEl[0].clientWidth + this.parentEl.offset().left;
            }
            switch(drops){
                case "auto":
                    containerTop = this.element.offset().top + this.element.outerHeight() - parentOffset.top;
                    if (containerTop + this.container.outerHeight() >= this.parentEl[0].scrollHeight) {
                        containerTop = this.element.offset().top - this.container.outerHeight() - parentOffset.top;
                        drops = "up";
                    }
                    break;
                case "up":
                    containerTop = this.element.offset().top - this.container.outerHeight() - parentOffset.top;
                    break;
                default:
                    containerTop = this.element.offset().top + this.element.outerHeight() - parentOffset.top;
                    break;
            }
            // Force the container to it's actual width
            this.container.css({
                top: 0,
                left: 0,
                right: "auto"
            });
            var containerWidth = this.container.outerWidth();
            this.container.toggleClass("drop-up", drops == "up");
            if (this.opens == "left") {
                var containerRight = parentRightEdge - this.element.offset().left - this.element.outerWidth();
                if (containerWidth + containerRight > $(window).width()) this.container.css({
                    top: containerTop,
                    right: "auto",
                    left: 9
                });
                else this.container.css({
                    top: containerTop,
                    right: containerRight,
                    left: "auto"
                });
            } else if (this.opens == "center") {
                var containerLeft = this.element.offset().left - parentOffset.left + this.element.outerWidth() / 2 - containerWidth / 2;
                if (containerLeft < 0) this.container.css({
                    top: containerTop,
                    right: "auto",
                    left: 9
                });
                else if (containerLeft + containerWidth > $(window).width()) this.container.css({
                    top: containerTop,
                    left: "auto",
                    right: 0
                });
                else this.container.css({
                    top: containerTop,
                    left: containerLeft,
                    right: "auto"
                });
            } else {
                var containerLeft = this.element.offset().left - parentOffset.left;
                if (containerLeft + containerWidth > $(window).width()) this.container.css({
                    top: containerTop,
                    left: "auto",
                    right: 0
                });
                else this.container.css({
                    top: containerTop,
                    left: containerLeft,
                    right: "auto"
                });
            }
        },
        show: function(e) {
            if (this.isShowing) return;
            // Create a click proxy that is private to this instance of datepicker, for unbinding
            this._outsideClickProxy = $.proxy(function(e) {
                this.outsideClick(e);
            }, this);
            // Bind global datepicker mousedown for hiding and
            $(document).on("mousedown.daterangepicker", this._outsideClickProxy)// also support mobile devices
            .on("touchend.daterangepicker", this._outsideClickProxy)// also explicitly play nice with Bootstrap dropdowns, which stopPropagation when clicking them
            .on("click.daterangepicker", "[data-toggle=dropdown]", this._outsideClickProxy)// and also close when focus changes to outside the picker (eg. tabbing between controls)
            .on("focusin.daterangepicker", this._outsideClickProxy);
            // Reposition the picker if the window is resized while it's open
            $(window).on("resize.daterangepicker", $.proxy(function(e) {
                this.move(e);
            }, this));
            this.oldStartDate = this.startDate.clone();
            this.oldEndDate = this.endDate.clone();
            this.previousRightTime = this.endDate.clone();
            this.updateView();
            this.container.show();
            this.move();
            this.element.trigger("show.daterangepicker", this);
            this.isShowing = true;
        },
        hide: function(e) {
            if (!this.isShowing) return;
            //incomplete date selection, revert to last values
            if (!this.endDate) {
                this.startDate = this.oldStartDate.clone();
                this.endDate = this.oldEndDate.clone();
            }
            //if a new date range was selected, invoke the user callback function
            if (!this.startDate.isSame(this.oldStartDate) || !this.endDate.isSame(this.oldEndDate)) this.callback(this.startDate.clone(), this.endDate.clone(), this.chosenLabel);
            //if picker is attached to a text input, update it
            this.updateElement();
            $(document).off(".daterangepicker");
            $(window).off(".daterangepicker");
            this.container.hide();
            this.element.trigger("hide.daterangepicker", this);
            this.isShowing = false;
        },
        toggle: function(e) {
            if (this.isShowing) this.hide();
            else this.show();
        },
        outsideClick: function(e) {
            var target = $(e.target);
            // if the page is clicked anywhere except within the daterangerpicker/button
            // itself then call this.hide()
            if (// ie modal dialog fix
            e.type == "focusin" || target.closest(this.element).length || target.closest(this.container).length || target.closest(".calendar-table").length) return;
            this.hide();
            this.element.trigger("outsideClick.daterangepicker", this);
        },
        showCalendars: function() {
            this.container.addClass("show-calendar");
            this.move();
            this.element.trigger("showCalendar.daterangepicker", this);
        },
        hideCalendars: function() {
            this.container.removeClass("show-calendar");
            this.element.trigger("hideCalendar.daterangepicker", this);
        },
        clickRange: function(e) {
            var label = e.target.getAttribute("data-range-key");
            this.chosenLabel = label;
            if (label == this.locale.customRangeLabel) this.showCalendars();
            else {
                var dates = this.ranges[label];
                this.startDate = dates[0];
                this.endDate = dates[1];
                if (!this.timePicker) {
                    this.startDate.startOf("day");
                    this.endDate.endOf("day");
                }
                if (!this.alwaysShowCalendars) this.hideCalendars();
                this.clickApply();
            }
        },
        clickPrev: function(e) {
            var cal = $(e.target).parents(".drp-calendar");
            if (cal.hasClass("left")) {
                this.leftCalendar.month.subtract(1, "month");
                if (this.linkedCalendars) this.rightCalendar.month.subtract(1, "month");
            } else this.rightCalendar.month.subtract(1, "month");
            this.updateCalendars();
        },
        clickNext: function(e) {
            var cal = $(e.target).parents(".drp-calendar");
            if (cal.hasClass("left")) this.leftCalendar.month.add(1, "month");
            else {
                this.rightCalendar.month.add(1, "month");
                if (this.linkedCalendars) this.leftCalendar.month.add(1, "month");
            }
            this.updateCalendars();
        },
        hoverDate: function(e) {
            //ignore dates that can't be selected
            if (!$(e.target).hasClass("available")) return;
            var title = $(e.target).attr("data-title");
            var row = title.substr(1, 1);
            var col = title.substr(3, 1);
            var cal = $(e.target).parents(".drp-calendar");
            var date = cal.hasClass("left") ? this.leftCalendar.calendar[row][col] : this.rightCalendar.calendar[row][col];
            //highlight the dates between the start date and the date being hovered as a potential end date
            var leftCalendar = this.leftCalendar;
            var rightCalendar = this.rightCalendar;
            var startDate = this.startDate;
            if (!this.endDate) this.container.find(".drp-calendar tbody td").each(function(index, el) {
                //skip week numbers, only look at dates
                if ($(el).hasClass("week")) return;
                var title = $(el).attr("data-title");
                var row = title.substr(1, 1);
                var col = title.substr(3, 1);
                var cal = $(el).parents(".drp-calendar");
                var dt = cal.hasClass("left") ? leftCalendar.calendar[row][col] : rightCalendar.calendar[row][col];
                if (dt.isAfter(startDate) && dt.isBefore(date) || dt.isSame(date, "day")) $(el).addClass("in-range");
                else $(el).removeClass("in-range");
            });
        },
        clickDate: function(e) {
            if (!$(e.target).hasClass("available")) return;
            var title = $(e.target).attr("data-title");
            var row = title.substr(1, 1);
            var col = title.substr(3, 1);
            var cal = $(e.target).parents(".drp-calendar");
            var date = cal.hasClass("left") ? this.leftCalendar.calendar[row][col] : this.rightCalendar.calendar[row][col];
            //
            // this function needs to do a few things:
            // * alternate between selecting a start and end date for the range,
            // * if the time picker is enabled, apply the hour/minute/second from the select boxes to the clicked date
            // * if autoapply is enabled, and an end date was chosen, apply the selection
            // * if single date picker mode, and time picker isn't enabled, apply the selection immediately
            // * if one of the inputs above the calendars was focused, cancel that manual input
            //
            if (this.endDate || date.isBefore(this.startDate, "day")) {
                if (this.timePicker) {
                    var hour = parseInt(this.container.find(".left .hourselect").val(), 10);
                    if (!this.timePicker24Hour) {
                        var ampm = this.container.find(".left .ampmselect").val();
                        if (ampm === "PM" && hour < 12) hour += 12;
                        if (ampm === "AM" && hour === 12) hour = 0;
                    }
                    var minute = parseInt(this.container.find(".left .minuteselect").val(), 10);
                    if (isNaN(minute)) minute = parseInt(this.container.find(".left .minuteselect option:last").val(), 10);
                    var second = this.timePickerSeconds ? parseInt(this.container.find(".left .secondselect").val(), 10) : 0;
                    date = date.clone().hour(hour).minute(minute).second(second);
                }
                this.endDate = null;
                this.setStartDate(date.clone());
            } else if (!this.endDate && date.isBefore(this.startDate)) //special case: clicking the same date for start/end,
            //but the time of the end date is before the start date
            this.setEndDate(this.startDate.clone());
            else {
                if (this.timePicker) {
                    var hour = parseInt(this.container.find(".right .hourselect").val(), 10);
                    if (!this.timePicker24Hour) {
                        var ampm = this.container.find(".right .ampmselect").val();
                        if (ampm === "PM" && hour < 12) hour += 12;
                        if (ampm === "AM" && hour === 12) hour = 0;
                    }
                    var minute = parseInt(this.container.find(".right .minuteselect").val(), 10);
                    if (isNaN(minute)) minute = parseInt(this.container.find(".right .minuteselect option:last").val(), 10);
                    var second = this.timePickerSeconds ? parseInt(this.container.find(".right .secondselect").val(), 10) : 0;
                    date = date.clone().hour(hour).minute(minute).second(second);
                }
                this.setEndDate(date.clone());
                if (this.autoApply) {
                    this.calculateChosenLabel();
                    this.clickApply();
                }
            }
            if (this.singleDatePicker) {
                this.setEndDate(this.startDate);
                if (!this.timePicker && this.autoApply) this.clickApply();
            }
            this.updateView();
            //This is to cancel the blur event handler if the mouse was in one of the inputs
            e.stopPropagation();
        },
        calculateChosenLabel: function() {
            var customRange = true;
            var i = 0;
            for(var range in this.ranges){
                if (this.timePicker) {
                    var format = this.timePickerSeconds ? "YYYY-MM-DD HH:mm:ss" : "YYYY-MM-DD HH:mm";
                    //ignore times when comparing dates if time picker seconds is not enabled
                    if (this.startDate.format(format) == this.ranges[range][0].format(format) && this.endDate.format(format) == this.ranges[range][1].format(format)) {
                        customRange = false;
                        this.chosenLabel = this.container.find(".ranges li:eq(" + i + ")").addClass("active").attr("data-range-key");
                        break;
                    }
                } else //ignore times when comparing dates if time picker is not enabled
                if (this.startDate.format("YYYY-MM-DD") == this.ranges[range][0].format("YYYY-MM-DD") && this.endDate.format("YYYY-MM-DD") == this.ranges[range][1].format("YYYY-MM-DD")) {
                    customRange = false;
                    this.chosenLabel = this.container.find(".ranges li:eq(" + i + ")").addClass("active").attr("data-range-key");
                    break;
                }
                i++;
            }
            if (customRange) {
                if (this.showCustomRangeLabel) this.chosenLabel = this.container.find(".ranges li:last").addClass("active").attr("data-range-key");
                else this.chosenLabel = null;
                this.showCalendars();
            }
        },
        clickApply: function(e) {
            this.hide();
            this.element.trigger("apply.daterangepicker", this);
        },
        clickCancel: function(e) {
            this.startDate = this.oldStartDate;
            this.endDate = this.oldEndDate;
            this.hide();
            this.element.trigger("cancel.daterangepicker", this);
        },
        monthOrYearChanged: function(e) {
            var isLeft = $(e.target).closest(".drp-calendar").hasClass("left"), leftOrRight = isLeft ? "left" : "right", cal = this.container.find(".drp-calendar." + leftOrRight);
            // Month must be Number for new moment versions
            var month = parseInt(cal.find(".monthselect").val(), 10);
            var year = cal.find(".yearselect").val();
            if (!isLeft) {
                if (year < this.startDate.year() || year == this.startDate.year() && month < this.startDate.month()) {
                    month = this.startDate.month();
                    year = this.startDate.year();
                }
            }
            if (this.minDate) {
                if (year < this.minDate.year() || year == this.minDate.year() && month < this.minDate.month()) {
                    month = this.minDate.month();
                    year = this.minDate.year();
                }
            }
            if (this.maxDate) {
                if (year > this.maxDate.year() || year == this.maxDate.year() && month > this.maxDate.month()) {
                    month = this.maxDate.month();
                    year = this.maxDate.year();
                }
            }
            if (isLeft) {
                this.leftCalendar.month.month(month).year(year);
                if (this.linkedCalendars) this.rightCalendar.month = this.leftCalendar.month.clone().add(1, "month");
            } else {
                this.rightCalendar.month.month(month).year(year);
                if (this.linkedCalendars) this.leftCalendar.month = this.rightCalendar.month.clone().subtract(1, "month");
            }
            this.updateCalendars();
        },
        timeChanged: function(e) {
            var cal = $(e.target).closest(".drp-calendar"), isLeft = cal.hasClass("left");
            var hour = parseInt(cal.find(".hourselect").val(), 10);
            var minute = parseInt(cal.find(".minuteselect").val(), 10);
            if (isNaN(minute)) minute = parseInt(cal.find(".minuteselect option:last").val(), 10);
            var second = this.timePickerSeconds ? parseInt(cal.find(".secondselect").val(), 10) : 0;
            if (!this.timePicker24Hour) {
                var ampm = cal.find(".ampmselect").val();
                if (ampm === "PM" && hour < 12) hour += 12;
                if (ampm === "AM" && hour === 12) hour = 0;
            }
            if (isLeft) {
                var start = this.startDate.clone();
                start.hour(hour);
                start.minute(minute);
                start.second(second);
                this.setStartDate(start);
                if (this.singleDatePicker) this.endDate = this.startDate.clone();
                else if (this.endDate && this.endDate.format("YYYY-MM-DD") == start.format("YYYY-MM-DD") && this.endDate.isBefore(start)) this.setEndDate(start.clone());
            } else if (this.endDate) {
                var end = this.endDate.clone();
                end.hour(hour);
                end.minute(minute);
                end.second(second);
                this.setEndDate(end);
            }
            //update the calendars so all clickable dates reflect the new time component
            this.updateCalendars();
            //update the form inputs above the calendars with the new time
            this.updateFormInputs();
            //re-render the time pickers because changing one selection can affect what's enabled in another
            this.renderTimePicker("left");
            this.renderTimePicker("right");
        },
        elementChanged: function() {
            if (!this.element.is("input")) return;
            if (!this.element.val().length) return;
            var dateString = this.element.val().split(this.locale.separator), start = null, end = null;
            if (dateString.length === 2) {
                start = moment(dateString[0], this.locale.format);
                end = moment(dateString[1], this.locale.format);
            }
            if (this.singleDatePicker || start === null || end === null) {
                start = moment(this.element.val(), this.locale.format);
                end = start;
            }
            if (!start.isValid() || !end.isValid()) return;
            this.setStartDate(start);
            this.setEndDate(end);
            this.updateView();
        },
        keydown: function(e) {
            //hide on tab or enter
            if (e.keyCode === 9 || e.keyCode === 13) this.hide();
            //hide on esc and prevent propagation
            if (e.keyCode === 27) {
                e.preventDefault();
                e.stopPropagation();
                this.hide();
            }
        },
        updateElement: function() {
            if (this.element.is("input") && this.autoUpdateInput) {
                var newValue = this.startDate.format(this.locale.format);
                if (!this.singleDatePicker) newValue += this.locale.separator + this.endDate.format(this.locale.format);
                if (newValue !== this.element.val()) this.element.val(newValue).trigger("change");
            }
        },
        remove: function() {
            this.container.remove();
            this.element.off(".daterangepicker");
            this.element.removeData();
        }
    };
    $.fn.daterangepicker = function(options, callback) {
        var implementOptions = $.extend(true, {}, $.fn.daterangepicker.defaultOptions, options);
        this.each(function() {
            var el = $(this);
            if (el.data("daterangepicker")) el.data("daterangepicker").remove();
            el.data("daterangepicker", new DateRangePicker(el, implementOptions, callback));
        });
        return this;
    };
    return DateRangePicker;
});




var $g1KQj = parcelRequire("g1KQj");

var $b1c1f0d19c8481bd$export$79b718b15081b231;
var $b1c1f0d19c8481bd$export$3c83a39499c722d6;
$b1c1f0d19c8481bd$export$79b718b15081b231 = `TEjdDq_applyBtn`;
$b1c1f0d19c8481bd$export$3c83a39499c722d6 = `TEjdDq_cancelBtn`;



const $3fb5be8cad0655cb$var$ranges = {
    "Сьогодні": [
        (0, (/*@__PURE__*/$parcel$interopDefault($g1KQj)))().startOf("day"),
        (0, (/*@__PURE__*/$parcel$interopDefault($g1KQj)))().endOf("day")
    ],
    "Вчора": [
        (0, (/*@__PURE__*/$parcel$interopDefault($g1KQj)))().subtract(1, "day").startOf("day"),
        (0, (/*@__PURE__*/$parcel$interopDefault($g1KQj)))().subtract(1, "day").endOf("day")
    ],
    "Поточний тиждень": [
        (0, (/*@__PURE__*/$parcel$interopDefault($g1KQj)))().startOf("isoWeek"),
        (0, (/*@__PURE__*/$parcel$interopDefault($g1KQj)))().endOf("isoWeek")
    ],
    "Минулий тиждень": [
        (0, (/*@__PURE__*/$parcel$interopDefault($g1KQj)))().subtract(1, "week").startOf("isoWeek"),
        (0, (/*@__PURE__*/$parcel$interopDefault($g1KQj)))().subtract(1, "week").endOf("isoWeek")
    ],
    "Поточний місяць": [
        (0, (/*@__PURE__*/$parcel$interopDefault($g1KQj)))().startOf("month"),
        (0, (/*@__PURE__*/$parcel$interopDefault($g1KQj)))().endOf("month")
    ],
    "Минулий місяць": [
        (0, (/*@__PURE__*/$parcel$interopDefault($g1KQj)))().subtract(1, "month").startOf("month"),
        (0, (/*@__PURE__*/$parcel$interopDefault($g1KQj)))().subtract(1, "month").endOf("month")
    ],
    "Поточний рік": [
        (0, (/*@__PURE__*/$parcel$interopDefault($g1KQj)))().startOf("year"),
        (0, (/*@__PURE__*/$parcel$interopDefault($g1KQj)))().endOf("year")
    ],
    "Минулий рік": [
        (0, (/*@__PURE__*/$parcel$interopDefault($g1KQj)))().subtract(1, "year").startOf("year"),
        (0, (/*@__PURE__*/$parcel$interopDefault($g1KQj)))().subtract(1, "year").endOf("year")
    ],
    "Весь час": [
        (0, (/*@__PURE__*/$parcel$interopDefault($g1KQj)))().startOf("year"),
        (0, (/*@__PURE__*/$parcel$interopDefault($g1KQj)))().endOf("year")
    ]
};
const $3fb5be8cad0655cb$var$transformKeysDeep = (obj)=>{
    if (Array.isArray(obj)) return obj.map((item)=>$3fb5be8cad0655cb$var$transformKeysDeep(item));
    if (obj && typeof obj === "object") return Object.keys(obj).reduce((acc, key)=>{
        const value = obj[key];
        const newKey = (0, (/*@__PURE__*/$parcel$interopDefault($cdef6bd59ed00ff5$exports)))(key);
        acc[newKey] = $3fb5be8cad0655cb$var$transformKeysDeep(value);
        return acc;
    }, {});
    return obj;
};
const $3fb5be8cad0655cb$var$StyledInput = (0, $6e03950c2a9b6039$export$2e2bcd8739ae039).input`
    z-index: 1;
  ${(props)=>(0, $e0d24bf85c947bed$export$2e2bcd8739ae039)(props.$shape, props.$baseScreenResolution, props.$skipStates)}
`;
const $3fb5be8cad0655cb$var$validateInputPattern = (value, pattern)=>{
    if (!pattern) return true;
    try {
        const regex = new RegExp(pattern);
        return regex.test(value);
    } catch (e) {
        console.error("Invalid regex pattern:", e);
        return true; // Return true if pattern is invalid to avoid blocking input
    }
};
const $3fb5be8cad0655cb$var$getTimeRanges = (inputValue, ranges)=>{
    let start;
    let end;
    if (inputValue.includes(":")) {
        // Custom range with unix timestamps
        const [startUnix, endUnix] = inputValue.split(":").map(Number);
        start = (0, (/*@__PURE__*/$parcel$interopDefault($g1KQj))).unix(startUnix);
        end = (0, (/*@__PURE__*/$parcel$interopDefault($g1KQj))).unix(endUnix);
    } else if (inputValue.length === 10) {
        // Single value with unix timestamp
        const startUnix = Number(inputValue);
        start = (0, (/*@__PURE__*/$parcel$interopDefault($g1KQj))).unix(startUnix);
        end = start;
    } else // Predefined ranges
    switch(inputValue){
        case "1d":
            [start, end] = ranges["1 Day"];
            break;
        case "1w":
            [start, end] = ranges["1 Week"];
            break;
        case "2w":
            [start, end] = ranges["2 Weeks"];
            break;
        case "1M":
            [start, end] = ranges["1 Month"];
            break;
        default:
            break; // Invalid input, do nothing
    }
    return {
        start: start,
        end: end
    };
};
const $3fb5be8cad0655cb$var$labelMatcher = {
    "1d": "1 Day",
    "1w": "1 Week",
    "2w": "2 Weeks",
    "1M": "1 Month"
};
const $3fb5be8cad0655cb$var$DateTimePicker = ({ id: id, style: stDraft, placeholder: placeholder, value: value, tooltip: tooltip, events: eventsDraft, soc: soc, pageSettings: pageSettings, dataLake: dataLake, activeState: activeStateDraft, regexp: regexp, settings: settings, nestedTable: nestedTable, parentIndex: parentIndex, styleChunks: styleChunks, parentRef: parentRef, sceleton: renderSceleton })=>{
    const inputRef = (0, $aivMx.useMemo)(()=>{
        if (parentRef?.current) return parentRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).createRef();
    }, [
        parentRef?.current
    ]);
    const { delay: delay = 500, json: json } = settings || {};
    const transformedJSON = json ? $3fb5be8cad0655cb$var$transformKeysDeep(json) : {};
    const variableData = (0, $f40d1f3d995cccef$export$2105062e25df4afe)((0, $79fc67ed759ae65b$export$e3ab06c283dfbb87));
    const localVariableData = (0, $f40d1f3d995cccef$export$2105062e25df4afe)((0, $79fc67ed759ae65b$export$78b26e3ba532c6ce));
    const { style: styleDraft, events: events, activeState: activeState } = dataLake?.data ? (0, $7b0e169a5380005e$export$485c71a5d8ecbaad)({
        style: stDraft,
        events: eventsDraft,
        activeState: activeStateDraft
    }, dataLake.data) : {
        style: stDraft,
        events: eventsDraft,
        activeState: activeStateDraft
    };
    const mergeStylesWithChunks = (0, $aivMx.useCallback)((style, chunks, index)=>{
        if (chunks && chunks[id] && chunks[id][index] && typeof index === "number") return (0, (/*@__PURE__*/$parcel$interopDefault($94WEq)))({}, style, chunks[id][index]);
        return style;
    }, [
        id
    ]);
    // First useMemo to merge active state styles with base style
    const mergedStyleWithState = (0, $aivMx.useMemo)(()=>{
        let mergedStyle = styleDraft;
        if (activeState && styleDraft?.states?.[activeState]) mergedStyle = (0, (/*@__PURE__*/$parcel$interopDefault($94WEq)))({}, styleDraft, styleDraft.states[activeState]);
        // Handle states in breakpoints
        if (styleDraft?.breakpoints) mergedStyle.breakpoints = Object.entries(styleDraft.breakpoints).reduce((acc, [breakpoint, breakpointStyle])=>{
            const typedBreakpointStyle = breakpointStyle;
            if (typedBreakpointStyle?.states?.[activeState]) acc[breakpoint] = (0, (/*@__PURE__*/$parcel$interopDefault($94WEq)))({}, typedBreakpointStyle, typedBreakpointStyle.states[activeState]);
            else acc[breakpoint] = typedBreakpointStyle;
            return acc;
        }, {});
        return mergedStyle;
    }, [
        styleDraft,
        activeState
    ]);
    // Second useMemo to merge styles with chunks based on parentIndex
    const style = (0, $aivMx.useMemo)(()=>{
        return mergeStylesWithChunks(mergedStyleWithState, styleChunks, parentIndex);
    }, [
        mergedStyleWithState,
        styleChunks,
        parentIndex
    ]);
    const baseScreenResolution = pageSettings?.baseScreenResolution ? (0, $7b0e169a5380005e$export$e58d7eefdadeb732)(pageSettings?.baseScreenResolution) : undefined;
    const { autofocus: autofocus } = style || {};
    const dispatch = (0, $d023060d48542f4c$export$8ad76b76a4c905f8)();
    const internalFns = {
        $setVariable: (key, value)=>{
            dispatch((0, $8eba69c5466928d3$export$36f0c40eded97f9d)({
                variable: key,
                value: value
            }));
        },
        $getVariable: (key)=>{
            const value = (0, $7b0e169a5380005e$export$2516322ffbb7f3fb)(variableData, key) || (0, $7b0e169a5380005e$export$2516322ffbb7f3fb)(localVariableData, key);
            return value;
        },
        $moment: (...args)=>(0, (/*@__PURE__*/$parcel$interopDefault($g1KQj)))(...args)
    };
    const timeoutsRef = (0, $aivMx.useRef)([]);
    const { on_focus: focusStyles, on_change: changeStyles, on_blur: blurStyles, on_launch: launchUpdates, on_hover: hoverUpdates, on_unhover: unhoverUpdates, on_regexp_success: regexpSuccessUpdates, on_regexp_error: regexpErorUpdates, on_outclick: outclickUpdates } = events || {};
    const handleInput = (e)=>{
        if (activeState === "disabled" || activeState === "loading") {
            e.preventDefault();
            e.stopPropagation();
            return;
        }
        const newValue = e.target.value;
        // Check max length
        if (regexp?.max_length && newValue.length > regexp.max_length) return;
        setInternalInputValue(newValue);
        dispatch((0, $8eba69c5466928d3$export$528cdcbbafe26779)({
            field: {
                id: id,
                value: newValue
            }
        }));
        // Check pattern validation
        if (regexp?.pattern && typeof regexp.pattern === "string") {
            const result = !$3fb5be8cad0655cb$var$validateInputPattern(newValue, regexp.pattern);
            if (regexpSuccessUpdates && result) {
                const styleUpdates = regexpSuccessUpdates.filter((update)=>"style" in update);
                const requestUpdates = regexpSuccessUpdates.filter((update)=>"request" in update);
                const functionUpdates = regexpSuccessUpdates.filter((update)=>"function" in update);
                if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates));
                if (requestUpdates.length) requestUpdates.forEach((update)=>{
                    const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                    const { delay: delay } = config || {};
                    if (update?.request && method === "command") dispatch((0, $8eba69c5466928d3$export$ea176eb1668c7b4b)({
                        location: {
                            pathname: value
                        },
                        silent: silent,
                        componentId: id
                    }));
                    else if (update?.request && method === "action") dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                        value: value,
                        silent: silent,
                        delay: delay,
                        componentId: id
                    }, stDraft?.states?.loading ? id : undefined));
                    else if (update?.request && method === "open-url") (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent);
                });
                if (functionUpdates.length) functionUpdates.forEach((update)=>{
                    if (update?.function) (0, $7b0e169a5380005e$export$1ed0175478ddd28b)(update.function, e, internalFns);
                });
            } else if (regexpErorUpdates && !result) {
                const styleUpdates = regexpErorUpdates.filter((update)=>"style" in update);
                const requestUpdates = regexpErorUpdates.filter((update)=>"request" in update);
                const functionUpdates = regexpErorUpdates.filter((update)=>"function" in update);
                if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates));
                if (requestUpdates.length) requestUpdates.forEach((update)=>{
                    const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                    const { delay: delay } = config || {};
                    if (update?.request && method === "command") dispatch((0, $8eba69c5466928d3$export$ea176eb1668c7b4b)({
                        location: {
                            pathname: value
                        },
                        silent: silent,
                        componentId: id
                    }));
                    else if (update?.request && method === "action") dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                        value: value,
                        silent: silent,
                        delay: delay,
                        componentId: id
                    }, stDraft?.states?.loading ? id : undefined));
                    else if (update?.request && method === "open-url") (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent);
                });
                if (functionUpdates.length) functionUpdates.forEach((update)=>{
                    if (update?.function) (0, $7b0e169a5380005e$export$1ed0175478ddd28b)(update.function, e, internalFns);
                });
            }
        }
        if (changeStyles) {
            const styleUpdates = changeStyles.filter((update)=>"style" in update);
            const requestUpdates = changeStyles.filter((update)=>"request" in update);
            const functionUpdates = changeStyles.filter((update)=>"function" in update);
            if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates));
            if (requestUpdates.length) requestUpdates.forEach((update)=>{
                const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                const { delay: delay } = config || {};
                if (update?.request && method === "command") dispatch((0, $8eba69c5466928d3$export$ea176eb1668c7b4b)({
                    location: {
                        pathname: value
                    },
                    silent: silent,
                    componentId: id
                }));
                else if (update?.request && method === "action") dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                    value: value,
                    silent: silent,
                    delay: delay,
                    componentId: id
                }, stDraft?.states?.loading ? id : undefined));
                else if (update?.request && method === "open-url") (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent);
            });
            if (functionUpdates.length) functionUpdates.forEach((update)=>{
                if (update?.function) (0, $7b0e169a5380005e$export$1ed0175478ddd28b)(update.function, e, internalFns);
            });
        }
        if (soc) dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
            value: "soc",
            delay: delay,
            componentId: id
        }, stDraft?.states?.loading ? id : undefined));
    };
    const handleFocus = (e)=>{
        if (activeState === "disabled" || activeState === "loading") {
            e.preventDefault();
            e.stopPropagation();
            return;
        }
        if (focusStyles) {
            const styleUpdates = focusStyles.filter((update)=>"style" in update);
            const requestUpdates = focusStyles.filter((update)=>"request" in update);
            const functionUpdates = focusStyles.filter((update)=>"function" in update);
            if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates));
            if (requestUpdates.length) requestUpdates.forEach((update)=>{
                const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                const { delay: delay } = config || {};
                if (update?.request && method === "command") dispatch((0, $8eba69c5466928d3$export$ea176eb1668c7b4b)({
                    location: {
                        pathname: value
                    },
                    silent: silent,
                    componentId: id
                }));
                else if (update?.request && method === "action") dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                    value: value,
                    silent: silent,
                    delay: delay,
                    componentId: id
                }, stDraft?.states?.loading ? id : undefined));
                else if (update?.request && method === "open-url") (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent);
            });
            if (functionUpdates.length) functionUpdates.forEach((update)=>{
                if (update?.function) (0, $7b0e169a5380005e$export$1ed0175478ddd28b)(update.function, e, internalFns);
            });
        }
    };
    const handleBlur = (e)=>{
        if (activeState === "disabled" || activeState === "loading") {
            e.preventDefault();
            e.stopPropagation();
            return;
        }
        if (blurStyles) {
            const styleUpdates = blurStyles.filter((update)=>"style" in update);
            const requestUpdates = blurStyles.filter((update)=>"request" in update);
            const functionUpdates = blurStyles.filter((update)=>"function" in update);
            if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates));
            if (requestUpdates.length) requestUpdates.forEach((update)=>{
                const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                const { delay: delay } = config || {};
                if (update?.request && method === "command") dispatch((0, $8eba69c5466928d3$export$ea176eb1668c7b4b)({
                    location: {
                        pathname: value
                    },
                    silent: silent,
                    componentId: id
                }));
                else if (update?.request && method === "action") dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                    value: value,
                    silent: silent,
                    delay: delay,
                    componentId: id
                }, stDraft?.states?.loading ? id : undefined));
                else if (update?.request && method === "open-url") (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent);
            });
            if (functionUpdates.length) functionUpdates.forEach((update)=>{
                if (update?.function) (0, $7b0e169a5380005e$export$1ed0175478ddd28b)(update.function, e, internalFns);
            });
        }
    };
    const handleHover = (e)=>{
        if (activeState === "disabled" || activeState === "loading") {
            e.preventDefault();
            e.stopPropagation();
            return;
        }
        if (hoverUpdates) {
            const styleUpdates = hoverUpdates.filter((update)=>"style" in update);
            const requestUpdates = hoverUpdates.filter((update)=>"request" in update);
            const functionUpdates = hoverUpdates.filter((update)=>"function" in update);
            if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates));
            if (requestUpdates.length) requestUpdates.forEach((update)=>{
                const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                const { delay: delay } = config || {};
                if (update?.request && method === "action") dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                    value: value,
                    silent: silent,
                    delay: delay,
                    componentId: id
                }, stDraft?.states?.loading ? id : undefined));
                else if (update?.request && method === "open-url") (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent);
            });
            if (functionUpdates.length) functionUpdates.forEach((update)=>{
                if (update?.function) (0, $7b0e169a5380005e$export$1ed0175478ddd28b)(update.function, e, internalFns);
            });
        }
    };
    const handleUnhover = (e)=>{
        if (activeState === "disabled" || activeState === "loading") {
            e.preventDefault();
            e.stopPropagation();
            return;
        }
        if (unhoverUpdates) {
            const styleUpdates = unhoverUpdates.filter((update)=>"style" in update);
            const requestUpdates = unhoverUpdates.filter((update)=>"request" in update);
            const functionUpdates = unhoverUpdates.filter((update)=>"function" in update);
            if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates));
            if (requestUpdates.length) requestUpdates.forEach((update)=>{
                const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                const { delay: delay } = config || {};
                if (update?.request && method === "action") dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                    value: value,
                    silent: silent,
                    delay: delay,
                    componentId: id
                }, stDraft?.states?.loading ? id : undefined));
                else if (update?.request && method === "open-url") (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent);
            });
            if (functionUpdates.length) functionUpdates.forEach((update)=>{
                if (update?.function) (0, $7b0e169a5380005e$export$1ed0175478ddd28b)(update.function, e, internalFns);
            });
        }
    };
    (0, $aivMx.useEffect)(()=>{
        if (launchUpdates && launchUpdates.length) {
            const requestUpdates = launchUpdates.filter((update)=>"request" in update);
            const functionUpdates = launchUpdates.filter((update)=>"function" in update);
            if (requestUpdates.length) requestUpdates.forEach((update)=>{
                const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                const { delay: delay } = config || {};
                if (update?.request && method === "action") {
                    const newTimeout = setTimeout(()=>{
                        dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                            value: value,
                            silent: silent,
                            delay: delay,
                            componentId: id
                        }, stDraft?.states?.loading ? id : undefined));
                    }, config?.delay * 1000 || 0);
                    timeoutsRef.current.push(newTimeout);
                } else if (update?.request && method === "open-url") (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent);
            });
            if (functionUpdates.length) functionUpdates.forEach((update)=>{
                if (update?.function) (0, $7b0e169a5380005e$export$1ed0175478ddd28b)(update.function);
            });
        }
        return ()=>{
            timeoutsRef?.current?.forEach((timeout)=>{
                clearTimeout(timeout);
            });
        };
    }, [
        launchUpdates
    ]);
    (0, $aivMx.useEffect)(()=>{
        const handleUnclick = (e)=>{
            if (activeState === "disabled" || activeState === "loading") return;
            if (inputRef.current && !inputRef.current.contains(e.target)) {
                if (outclickUpdates) {
                    const styleUpdates = outclickUpdates.filter((update)=>"style" in update);
                    const requestUpdates = outclickUpdates.filter((update)=>"request" in update);
                    const functionUpdates = outclickUpdates.filter((update)=>"function" in update);
                    if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates, parentIndex));
                    if (requestUpdates.length) requestUpdates.forEach((update)=>{
                        const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                        const { delay: delay } = config || {};
                        if (update?.request && method === "action") dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                            value: value,
                            silent: silent,
                            delay: delay,
                            componentId: id
                        }, stDraft?.states?.loading ? id : undefined));
                        else if (update?.request && method === "open-url") (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent);
                    });
                    if (functionUpdates.length) functionUpdates.forEach((update)=>{
                        if (update?.function) (0, $7b0e169a5380005e$export$1ed0175478ddd28b)(update.function);
                    });
                }
            }
        };
        if (outclickUpdates) {
            document.addEventListener("mousedown", handleUnclick);
            return ()=>{
                document.removeEventListener("mousedown", handleUnclick);
            };
        }
        return undefined;
    }, [
        parentIndex,
        activeState,
        inputRef.current
    ]);
    const [startDate, setStartDate] = (0, $aivMx.useState)();
    const [endDate, setEndDate] = (0, $aivMx.useState)();
    const [internalInputValue, setInternalInputValue] = (0, $aivMx.useState)("");
    const [isCalendarOpen, setIsCalendarOpen] = (0, $aivMx.useState)(false);
    (0, $aivMx.useEffect)(()=>{
        if (value) {
            const { start: start, end: end } = $3fb5be8cad0655cb$var$getTimeRanges(value);
            // Always update internal value when external value changes
            if (value.includes(":")) setInternalInputValue(`${start?.format("HH:mm DD/MM/YY")} - ${end?.format("HH:mm DD/MM/YY")}`);
            else if (value.length === 10) setInternalInputValue(start?.format("HH:mm DD/MM/YY") || "");
            else setInternalInputValue($3fb5be8cad0655cb$var$labelMatcher[value]);
        } else {
            // Clear internal value when external value is cleared
            setInternalInputValue("");
            if (inputRef.current) {
                inputRef.current.value = "";
                inputRef.current.dates = [];
            }
        }
    }, [
        value
    ]);
    (0, $aivMx.useEffect)(()=>{
        const dateRangePickerContainer = document.createElement("div");
        dateRangePickerContainer.id = `dateRangePickerContainer-${id}`;
        document.body.appendChild(dateRangePickerContainer);
        const { start: startUnix, end: endUnix } = $3fb5be8cad0655cb$var$getTimeRanges(value);
        const $dateRangePicker = (0, (/*@__PURE__*/$parcel$interopDefault($i4YVD)))(inputRef.current).daterangepicker({
            startDate: startUnix,
            endDate: endUnix,
            ranges: $3fb5be8cad0655cb$var$ranges,
            cancelButtonClasses: $b1c1f0d19c8481bd$export$3c83a39499c722d6,
            showCustomRangeLabel: false,
            applyButtonClasses: $b1c1f0d19c8481bd$export$79b718b15081b231,
            timePicker: true,
            timePicker24Hour: true,
            timePickerSeconds: false,
            alwaysShowCalendars: true,
            opens: "left",
            autoUpdateInput: false,
            maxDate: (0, (/*@__PURE__*/$parcel$interopDefault($g1KQj)))().endOf("day"),
            locale: {
                format: "DD/MM/YYYY",
                separator: " : ",
                applyLabel: "Save",
                cancelLabel: "Cancel",
                fromLabel: "From",
                toLabel: "To",
                customRangeLabel: "Custom",
                weekLabel: "W",
                daysOfWeek: [
                    "Sub",
                    "Mo",
                    "Tu",
                    "We",
                    "Th",
                    "Fr",
                    "Sa"
                ],
                monthNames: [
                    "January",
                    "February",
                    "March",
                    "April",
                    "May",
                    "June",
                    "July",
                    "August",
                    "September",
                    "October",
                    "November",
                    "December"
                ],
                firstDay: 1
            },
            ...transformedJSON || {}
        }, (start, end, label)=>{
            if (label === "1 Day" || label === "1 Week" || label === "2 Weeks" || label === "1 Month") setInternalInputValue(label);
            else if (transformedJSON?.singleDatePicker) setInternalInputValue(start.format(transformedJSON.locale?.format));
            else setInternalInputValue(`${start.format(transformedJSON.locale?.format)} - ${end.format(transformedJSON.locale?.format)}`);
            // Create and dispatch a synthetic input event
            const syntheticEvent = {
                target: {
                    value: label === "1 Day" || label === "1 Week" || label === "2 Weeks" || label === "1 Month" ? label : transformedJSON?.singleDatePicker ? start.format(transformedJSON.locale?.format) : `${start.format(transformedJSON.locale?.format)} - ${end.format(transformedJSON.locale?.format)}`
                },
                preventDefault: ()=>{},
                stopPropagation: ()=>{}
            };
            // Call handleInput with the synthetic event
            handleInput(syntheticEvent);
        });
        $dateRangePicker.on("show.daterangepicker", ()=>{
            setIsCalendarOpen(true);
        });
        $dateRangePicker.on("hide.daterangepicker", ()=>{
            setIsCalendarOpen(false);
        });
        // Cleanup event listeners on component unmount
        return ()=>{
            $dateRangePicker.off("show.daterangepicker");
            $dateRangePicker.off("hide.daterangepicker");
            document.body.removeChild(dateRangePickerContainer);
        };
    }, [
        value,
        id
    ]);
    if (renderSceleton && style) return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $cefd49c6ff42e132$export$2e2bcd8739ae039), {
        style: style,
        baseScreenResolution: baseScreenResolution,
        skipStates: activeState === "disabled" || activeState === "loading"
    });
    return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)($3fb5be8cad0655cb$var$StyledInput, {
        ref: inputRef,
        style: {
            display: style?.visibility === "hidden" ? "none" : undefined
        },
        placeholder: placeholder,
        id: `${id}${nestedTable && typeof parentIndex === "number" ? `::${parentIndex}` : ""}`,
        type: "text",
        $shape: style,
        $baseScreenResolution: baseScreenResolution,
        $skipStates: activeState === "disabled" || activeState === "loading",
        disabled: activeState === "disabled" || activeState === "loading",
        "data-component": "input",
        className: (0, $7b0e169a5380005e$export$189053d41e721fcb)(style.class),
        value: internalInputValue,
        title: tooltip,
        autoFocus: autofocus,
        onInput: handleInput,
        onFocus: handleFocus,
        onBlur: handleBlur,
        onMouseEnter: handleHover,
        onMouseLeave: handleUnhover,
        maxLength: regexp?.max_length
    });
};
var $3fb5be8cad0655cb$export$2e2bcd8739ae039 = $3fb5be8cad0655cb$var$DateTimePicker;


var $896243df65db0cdd$export$2e2bcd8739ae039 = (0, $3fb5be8cad0655cb$export$2e2bcd8739ae039);



const $62d6cd46aaf31470$var$validateInputPattern = (value, pattern)=>{
    if (!pattern) return true;
    try {
        const regex = new RegExp(pattern);
        return regex.test(value);
    } catch (e) {
        console.error("Invalid regex pattern:", e);
        return true; // Return true if pattern is invalid to avoid blocking input
    }
};
const $62d6cd46aaf31470$var$StyledInput = (0, $6e03950c2a9b6039$export$2e2bcd8739ae039).input`
    z-index: 1;
  ${(props)=>(0, $e0d24bf85c947bed$export$2e2bcd8739ae039)(props.$shape, props.$baseScreenResolution, props.$skipStates)}
`;
// trigger
const $62d6cd46aaf31470$var$StyledTextarea = (0, $6e03950c2a9b6039$export$2e2bcd8739ae039).textarea`
  resize: none;
  z-index: 1;
  ${(props)=>(0, $e0d24bf85c947bed$export$2e2bcd8739ae039)(props.$shape, props.$baseScreenResolution, props.$skipStates)}
`;
const $62d6cd46aaf31470$var$Input = ({ id: id, style: stDraft, placeholder: placeholder, value: value, tooltip: tooltip, events: eventsDraft, soc: soc, pageSettings: pageSettings, dataLake: dataLake, activeState: activeStateDraft, regexp: regexp, settings: settings, type: type, nestedTable: nestedTable, parentIndex: parentIndex, styleChunks: styleChunks, sceleton: renderSceleton })=>{
    const inputRef = (0, $aivMx.useRef)(null);
    const variableData = (0, $f40d1f3d995cccef$export$2105062e25df4afe)((0, $79fc67ed759ae65b$export$e3ab06c283dfbb87));
    const localVariableData = (0, $f40d1f3d995cccef$export$2105062e25df4afe)((0, $79fc67ed759ae65b$export$78b26e3ba532c6ce));
    const { delay: delay = 500 } = settings || {};
    const { style: styleDraft, events: events, activeState: activeState } = dataLake?.data ? (0, $7b0e169a5380005e$export$485c71a5d8ecbaad)({
        style: stDraft,
        events: eventsDraft,
        activeState: activeStateDraft
    }, dataLake.data) : {
        style: stDraft,
        events: eventsDraft,
        activeState: activeStateDraft
    };
    const mergeStylesWithChunks = (0, $aivMx.useCallback)((style, chunks, index)=>{
        if (chunks && chunks[id] && chunks[id][index] && typeof index === "number") return (0, (/*@__PURE__*/$parcel$interopDefault($94WEq)))({}, style, chunks[id][index]);
        return style;
    }, [
        id
    ]);
    // First useMemo to merge active state styles with base style
    const mergedStyleWithState = (0, $aivMx.useMemo)(()=>{
        let mergedStyle = styleDraft;
        if (activeState && styleDraft?.states?.[activeState]) mergedStyle = (0, (/*@__PURE__*/$parcel$interopDefault($94WEq)))({}, styleDraft, styleDraft.states[activeState]);
        // Handle states in breakpoints
        if (styleDraft?.breakpoints) mergedStyle.breakpoints = Object.entries(styleDraft.breakpoints).reduce((acc, [breakpoint, breakpointStyle])=>{
            const typedBreakpointStyle = breakpointStyle;
            if (typedBreakpointStyle?.states?.[activeState]) acc[breakpoint] = (0, (/*@__PURE__*/$parcel$interopDefault($94WEq)))({}, typedBreakpointStyle, typedBreakpointStyle.states[activeState]);
            else acc[breakpoint] = typedBreakpointStyle;
            return acc;
        }, {});
        return mergedStyle;
    }, [
        styleDraft,
        activeState
    ]);
    // Second useMemo to merge styles with chunks based on parentIndex
    const style = (0, $aivMx.useMemo)(()=>{
        return mergeStylesWithChunks(mergedStyleWithState, styleChunks, parentIndex);
    }, [
        mergedStyleWithState,
        styleChunks,
        parentIndex
    ]);
    const baseScreenResolution = pageSettings?.baseScreenResolution ? (0, $7b0e169a5380005e$export$e58d7eefdadeb732)(pageSettings?.baseScreenResolution) : undefined;
    const [internalValue, setInternalValue] = (0, $aivMx.useState)(value);
    const { autofocus: autofocus } = style || {};
    const dispatch = (0, $d023060d48542f4c$export$8ad76b76a4c905f8)();
    const internalFns = {
        $setVariable: (key, value)=>{
            dispatch((0, $8eba69c5466928d3$export$36f0c40eded97f9d)({
                variable: key,
                value: value
            }));
        },
        $getVariable: (key)=>{
            const value = (0, $7b0e169a5380005e$export$2516322ffbb7f3fb)(variableData, key) || (0, $7b0e169a5380005e$export$2516322ffbb7f3fb)(localVariableData, key);
            return value;
        },
        $moment: (...args)=>(0, (/*@__PURE__*/$parcel$interopDefault($g1KQj)))(...args)
    };
    const timeoutsRef = (0, $aivMx.useRef)([]);
    const { on_focus: focusStyles, on_change: changeStyles, on_blur: blurStyles, on_launch: launchUpdates, on_hover: hoverUpdates, on_unhover: unhoverUpdates, on_regexp_success: regexpSuccessUpdates, on_regexp_error: regexpErrorUpdates, on_outclick: outclickUpdates } = events || {};
    (0, $aivMx.useEffect)(()=>{
        setInternalValue(value);
    }, [
        value
    ]);
    (0, $aivMx.useEffect)(()=>{
        if (value !== internalValue) setInternalValue(value);
    }, [
        value
    ]);
    const handleInput = (e)=>{
        if (activeState === "disabled" || activeState === "loading") {
            e.preventDefault();
            e.stopPropagation();
            return;
        }
        dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
            block: true
        }));
        const newValue = e.target.value;
        // Check max length
        if (regexp?.max_length && newValue.length > regexp.max_length) return;
        setInternalValue(newValue);
        dispatch((0, $8eba69c5466928d3$export$528cdcbbafe26779)({
            field: {
                id: id,
                value: newValue
            }
        }));
        // Check pattern validation
        if (changeStyles) {
            const styleUpdates = changeStyles.filter((update)=>"style" in update);
            const requestUpdates = changeStyles.filter((update)=>"request" in update);
            const functionUpdates = changeStyles.filter((update)=>"function" in update);
            if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates));
            if (requestUpdates.length) requestUpdates.forEach((update)=>{
                const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                const { delay: delay } = config || {};
                if (update?.request && method === "command") dispatch((0, $8eba69c5466928d3$export$ea176eb1668c7b4b)({
                    location: {
                        pathname: value
                    },
                    silent: silent,
                    componentId: id
                }));
                else if (update?.request && method === "action") dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                    value: value,
                    silent: silent,
                    delay: delay,
                    componentId: id
                }, stDraft?.states?.loading ? id : undefined));
                else if (update?.request && method === "open-url") (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent);
            });
            if (functionUpdates.length) functionUpdates.forEach((update)=>{
                if (update?.function) (0, $7b0e169a5380005e$export$1ed0175478ddd28b)(update.function, e, internalFns);
            });
        }
        if (regexp?.pattern && typeof regexp.pattern === "string") {
            const result = $62d6cd46aaf31470$var$validateInputPattern(newValue, regexp.pattern);
            if (regexpErrorUpdates && !result) {
                const styleUpdates = regexpErrorUpdates.filter((update)=>"style" in update);
                const requestUpdates = regexpErrorUpdates.filter((update)=>"request" in update);
                const functionUpdates = regexpErrorUpdates.filter((update)=>"function" in update);
                if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates));
                if (requestUpdates.length) requestUpdates.forEach((update)=>{
                    const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                    const { delay: delay } = config || {};
                    if (update?.request && method === "command") dispatch((0, $8eba69c5466928d3$export$ea176eb1668c7b4b)({
                        location: {
                            pathname: value
                        },
                        silent: silent,
                        componentId: id
                    }));
                    else if (update?.request && method === "action") dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                        value: value,
                        silent: silent,
                        delay: delay,
                        componentId: id
                    }, stDraft?.states?.loading ? id : undefined));
                    else if (update?.request && method === "open-url") (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent);
                });
                if (functionUpdates.length) functionUpdates.forEach((update)=>{
                    if (update?.function) (0, $7b0e169a5380005e$export$1ed0175478ddd28b)(update.function, e, internalFns);
                });
            } else if (regexpSuccessUpdates && result) {
                const styleUpdates = regexpSuccessUpdates.filter((update)=>"style" in update);
                const requestUpdates = regexpSuccessUpdates.filter((update)=>"request" in update);
                const functionUpdates = regexpSuccessUpdates.filter((update)=>"function" in update);
                if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates));
                if (requestUpdates.length) requestUpdates.forEach((update)=>{
                    const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                    const { delay: delay } = config || {};
                    if (update?.request && method === "command") dispatch((0, $8eba69c5466928d3$export$ea176eb1668c7b4b)({
                        location: {
                            pathname: value
                        },
                        silent: silent,
                        componentId: id
                    }));
                    else if (update?.request && method === "action") dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                        value: value,
                        silent: silent,
                        delay: delay,
                        componentId: id
                    }, stDraft?.states?.loading ? id : undefined));
                    else if (update?.request && method === "open-url") (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent);
                });
                if (functionUpdates.length) functionUpdates.forEach((update)=>{
                    if (update?.function) (0, $7b0e169a5380005e$export$1ed0175478ddd28b)(update.function, e, internalFns);
                });
            }
        }
        if (soc) dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
            value: "soc",
            delay: delay,
            componentId: id
        }, stDraft?.states?.loading ? id : undefined));
    };
    const handleKeyDown = (e)=>{
        if (activeState === "disabled" || activeState === "loading") {
            e.preventDefault();
            e.stopPropagation();
            return;
        }
    };
    const handleFocus = (e)=>{
        if (activeState === "disabled" || activeState === "loading") {
            e.preventDefault();
            e.stopPropagation();
            return;
        }
        if (focusStyles) {
            const styleUpdates = focusStyles.filter((update)=>"style" in update);
            const requestUpdates = focusStyles.filter((update)=>"request" in update);
            const functionUpdates = focusStyles.filter((update)=>"function" in update);
            if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates));
            if (requestUpdates.length) requestUpdates.forEach((update)=>{
                const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                const { delay: delay } = config || {};
                if (update?.request && method === "command") dispatch((0, $8eba69c5466928d3$export$ea176eb1668c7b4b)({
                    location: {
                        pathname: value
                    },
                    silent: silent,
                    componentId: id
                }));
                else if (update?.request && method === "action") dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                    value: value,
                    delay: delay,
                    componentId: id
                }, stDraft?.states?.loading ? id : undefined));
                else if (update?.request && method === "open-url") (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent);
            });
            if (functionUpdates.length) functionUpdates.forEach((update)=>{
                if (update?.function) (0, $7b0e169a5380005e$export$1ed0175478ddd28b)(update.function, e, internalFns);
            });
        }
    };
    const handleBlur = (e)=>{
        if (activeState === "disabled" || activeState === "loading") {
            e.preventDefault();
            e.stopPropagation();
            return;
        }
        if (blurStyles) {
            const styleUpdates = blurStyles.filter((update)=>"style" in update);
            const requestUpdates = blurStyles.filter((update)=>"request" in update);
            const functionUpdates = blurStyles.filter((update)=>"function" in update);
            if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates));
            if (requestUpdates.length) requestUpdates.forEach((update)=>{
                const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                const { delay: delay } = config || {};
                if (update?.request && method === "command") dispatch((0, $8eba69c5466928d3$export$ea176eb1668c7b4b)({
                    location: {
                        pathname: value
                    },
                    silent: silent,
                    componentId: id
                }));
                else if (update?.request && method === "action") dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                    value: value,
                    silent: silent,
                    delay: delay,
                    componentId: id
                }, stDraft?.states?.loading ? id : undefined));
                else if (update?.request && method === "open-url") (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent);
            });
            if (functionUpdates.length) functionUpdates.forEach((update)=>{
                if (update?.function) (0, $7b0e169a5380005e$export$1ed0175478ddd28b)(update.function, e, internalFns);
            });
        }
    };
    const handleHover = (e)=>{
        if (activeState === "disabled" || activeState === "loading") {
            e.preventDefault();
            e.stopPropagation();
            return;
        }
        if (hoverUpdates) {
            const styleUpdates = hoverUpdates.filter((update)=>"style" in update);
            const requestUpdates = hoverUpdates.filter((update)=>"request" in update);
            const functionUpdates = hoverUpdates.filter((update)=>"function" in update);
            if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates));
            if (requestUpdates.length) requestUpdates.forEach((update)=>{
                const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                const { delay: delay } = config || {};
                if (update?.request && method === "action") dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                    value: value,
                    silent: silent,
                    delay: delay,
                    componentId: id
                }, stDraft?.states?.loading ? id : undefined));
                else if (update?.request && method === "open-url") (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent);
            });
            if (functionUpdates.length) functionUpdates.forEach((update)=>{
                if (update?.function) (0, $7b0e169a5380005e$export$1ed0175478ddd28b)(update.function, e, internalFns);
            });
        }
    };
    const handleUnhover = (e)=>{
        if (activeState === "disabled" || activeState === "loading") {
            e.preventDefault();
            e.stopPropagation();
            return;
        }
        if (unhoverUpdates) {
            const styleUpdates = unhoverUpdates.filter((update)=>"style" in update);
            const requestUpdates = unhoverUpdates.filter((update)=>"request" in update);
            const functionUpdates = unhoverUpdates.filter((update)=>"function" in update);
            if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates));
            if (requestUpdates.length) requestUpdates.forEach((update)=>{
                const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                const { delay: delay } = config || {};
                if (update?.request && method === "action") dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                    value: value,
                    silent: silent,
                    delay: delay,
                    componentId: id
                }, stDraft?.states?.loading ? id : undefined));
                else if (update?.request && method === "open-url") (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent);
            });
            if (functionUpdates.length) functionUpdates.forEach((update)=>{
                if (update?.function) (0, $7b0e169a5380005e$export$1ed0175478ddd28b)(update.function, e, internalFns);
            });
        }
    };
    (0, $aivMx.useEffect)(()=>{
        if (launchUpdates && launchUpdates.length) {
            const requestUpdates = launchUpdates.filter((update)=>"request" in update);
            const functionUpdates = launchUpdates.filter((update)=>"function" in update);
            if (requestUpdates.length) requestUpdates.forEach((update)=>{
                const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                const { delay: delay } = config || {};
                if (update?.request && method === "action") ;
                else if (update?.request && method === "open-url") (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent);
            });
            if (functionUpdates.length) functionUpdates.forEach((update)=>{
                if (update?.function) (0, $7b0e169a5380005e$export$1ed0175478ddd28b)(update.function, undefined, internalFns);
            });
        }
        return ()=>{
            timeoutsRef?.current?.forEach((timeout)=>{
                clearTimeout(timeout);
            });
        };
    }, [
        launchUpdates
    ]);
    (0, $aivMx.useEffect)(()=>{
        const handleUnclick = (e)=>{
            if (activeState === "disabled" || activeState === "loading") return;
            if (inputRef.current && !inputRef.current.contains(e.target)) {
                if (outclickUpdates) {
                    const styleUpdates = outclickUpdates.filter((update)=>"style" in update);
                    const requestUpdates = outclickUpdates.filter((update)=>"request" in update);
                    const functionUpdates = outclickUpdates.filter((update)=>"function" in update);
                    if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates, parentIndex));
                    if (requestUpdates.length) requestUpdates.forEach((update)=>{
                        const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                        const { delay: delay } = config || {};
                        if (update?.request && method === "action") dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                            value: value,
                            silent: silent,
                            delay: delay,
                            componentId: id
                        }, stDraft?.states?.loading ? id : undefined));
                        else if (update?.request && method === "open-url") (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent);
                    });
                    if (functionUpdates.length) functionUpdates.forEach((update)=>{
                        if (update?.function) (0, $7b0e169a5380005e$export$1ed0175478ddd28b)(update.function, undefined, internalFns);
                    });
                }
            }
        };
        if (outclickUpdates) {
            document.addEventListener("mousedown", handleUnclick);
            return ()=>{
                document.removeEventListener("mousedown", handleUnclick);
            };
        }
        return undefined;
    }, [
        parentIndex,
        activeState,
        inputRef.current
    ]);
    if (renderSceleton && style) return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $cefd49c6ff42e132$export$2e2bcd8739ae039), {
        style: style,
        baseScreenResolution: baseScreenResolution,
        skipStates: activeState === "disabled" || activeState === "loading"
    });
    return(// <Wrapper $shape={style}>
    // {activeBackground?.background && Array.isArray(activeBackground?.background) ? activeBackground.background.map((bg) => (
    //   <MainLayerController
    //     options={{ 
    //       borderRadius: activeBackground.borderRadius,
    //       borderWidth: activeBackground.borderWidth,
    //      }}
    //     key={uuidv4()}
    //     {...bg}
    //   />
    // )) : null}
    // Inside your Input component, modify the return statement:
    regexp?.mask_pattern ? /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)($62d6cd46aaf31470$var$StyledInput, {
        as: (0, $416d9e5f2c67c58b$export$2e2bcd8739ae039),
        mask: regexp.mask_pattern,
        value: internalValue,
        onAccept: (value)=>handleInput({
                target: {
                    value: value
                }
            }),
        onKeyDown: handleKeyDown,
        onFocus: handleFocus,
        onBlur: handleBlur,
        onMouseEnter: handleHover,
        onMouseLeave: handleUnhover,
        disabled: activeState === "disabled",
        inputRef: inputRef,
        placeholder: placeholder,
        id: `${id}${nestedTable && typeof parentIndex === "number" ? `::${parentIndex}` : ""}`,
        type: type || "text",
        style: {
            display: style?.visibility === "hidden" ? "none" : undefined
        },
        autoFocus: autofocus,
        maxLength: regexp?.max_length,
        onClick: (e)=>{
            e.stopPropagation();
        },
        $shape: style,
        $baseScreenResolution: baseScreenResolution,
        $skipStates: activeState === "disabled" || activeState === "loading",
        "data-component": "input",
        className: (0, $7b0e169a5380005e$export$189053d41e721fcb)(style.class),
        title: tooltip,
        onInput: handleInput
    }) : /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)($62d6cd46aaf31470$var$StyledInput, {
        ref: inputRef,
        style: {
            display: style?.visibility === "hidden" ? "none" : undefined
        },
        placeholder: placeholder,
        id: `${id}${nestedTable && typeof parentIndex === "number" ? `::${parentIndex}` : ""}`,
        type: type || "text",
        $shape: style,
        $baseScreenResolution: baseScreenResolution,
        $skipStates: activeState === "disabled" || activeState === "loading",
        disabled: activeState === "disabled",
        "data-component": "input",
        className: (0, $7b0e169a5380005e$export$189053d41e721fcb)(style.class),
        value: internalValue,
        title: tooltip,
        autoFocus: autofocus,
        onInput: handleInput,
        onClick: (e)=>e.stopPropagation(),
        onFocus: handleFocus,
        onBlur: handleBlur,
        onMouseEnter: handleHover,
        onMouseLeave: handleUnhover,
        maxLength: regexp?.max_length
    }));
};
const $62d6cd46aaf31470$var$TextArea = ({ id: id, style: stDraft, placeholder: placeholder, value: value, tooltip: tooltip, events: eventsDraft, soc: soc, pageSettings: pageSettings, dataLake: dataLake, activeState: activeStateDraft, regexp: regexp, settings: settings, nestedTable: nestedTable, parentIndex: parentIndex, styleChunks: styleChunks, sceleton: renderSceleton })=>{
    const inputRef = (0, $aivMx.useRef)(null);
    const { delay: delay = 500 } = settings || {};
    const variableData = (0, $f40d1f3d995cccef$export$2105062e25df4afe)((0, $79fc67ed759ae65b$export$e3ab06c283dfbb87));
    const localVariableData = (0, $f40d1f3d995cccef$export$2105062e25df4afe)((0, $79fc67ed759ae65b$export$78b26e3ba532c6ce));
    const { style: styleDraft, events: events, activeState: activeState } = dataLake?.data ? (0, $7b0e169a5380005e$export$485c71a5d8ecbaad)({
        style: stDraft,
        events: eventsDraft,
        activeState: activeStateDraft
    }, dataLake.data) : {
        style: stDraft,
        events: eventsDraft,
        activeState: activeStateDraft
    };
    const mergeStylesWithChunks = (0, $aivMx.useCallback)((style, chunks, index)=>{
        if (chunks && chunks[id] && chunks[id][index] && typeof index === "number") return (0, (/*@__PURE__*/$parcel$interopDefault($94WEq)))({}, style, chunks[id][index]);
        return style;
    }, [
        id
    ]);
    // First useMemo to merge active state styles with base style
    const mergedStyleWithState = (0, $aivMx.useMemo)(()=>{
        let mergedStyle = styleDraft;
        if (activeState && styleDraft?.states?.[activeState]) mergedStyle = (0, (/*@__PURE__*/$parcel$interopDefault($94WEq)))({}, styleDraft, styleDraft.states[activeState]);
        // Handle states in breakpoints
        if (styleDraft?.breakpoints) mergedStyle.breakpoints = Object.entries(styleDraft.breakpoints).reduce((acc, [breakpoint, breakpointStyle])=>{
            const typedBreakpointStyle = breakpointStyle;
            if (typedBreakpointStyle?.states?.[activeState]) acc[breakpoint] = (0, (/*@__PURE__*/$parcel$interopDefault($94WEq)))({}, typedBreakpointStyle, typedBreakpointStyle.states[activeState]);
            else acc[breakpoint] = typedBreakpointStyle;
            return acc;
        }, {});
        return mergedStyle;
    }, [
        styleDraft,
        activeState
    ]);
    // Second useMemo to merge styles with chunks based on parentIndex
    const style = (0, $aivMx.useMemo)(()=>{
        return mergeStylesWithChunks(mergedStyleWithState, styleChunks, parentIndex);
    }, [
        mergedStyleWithState,
        styleChunks,
        parentIndex
    ]);
    const baseScreenResolution = pageSettings?.baseScreenResolution ? (0, $7b0e169a5380005e$export$e58d7eefdadeb732)(pageSettings?.baseScreenResolution) : undefined;
    const [internalValue, setInternalValue] = (0, $aivMx.useState)(value);
    const { autofocus: autofocus } = style || {};
    const dispatch = (0, $d023060d48542f4c$export$8ad76b76a4c905f8)();
    const internalFns = {
        $setVariable: (key, value)=>{
            dispatch((0, $8eba69c5466928d3$export$36f0c40eded97f9d)({
                variable: key,
                value: value
            }));
        },
        $getVariable: (key)=>{
            const value = (0, $7b0e169a5380005e$export$2516322ffbb7f3fb)(variableData, key) || (0, $7b0e169a5380005e$export$2516322ffbb7f3fb)(localVariableData, key);
            return value;
        },
        $moment: (...args)=>(0, (/*@__PURE__*/$parcel$interopDefault($g1KQj)))(...args)
    };
    const timeoutsRef = (0, $aivMx.useRef)([]);
    const { on_focus: focusStyles, on_change: changeStyles, on_blur: blurStyles, on_launch: launchUpdates, on_hover: hoverUpdates, on_unhover: unhoverUpdates, on_regexp_success: regexpSuccessUpdates, on_regexp_error: regexpErorUpdates, on_outclick: outclickUpdates } = events || {};
    (0, $aivMx.useEffect)(()=>{
        setInternalValue(value);
    }, [
        value
    ]);
    (0, $aivMx.useEffect)(()=>{
        if (value !== internalValue) setInternalValue(value);
    }, [
        value
    ]);
    const handleInput = (e)=>{
        if (activeState === "disabled" || activeState === "loading") {
            e.preventDefault();
            e.stopPropagation();
            return;
        }
        const newValue = e.target.value;
        // Check max length
        if (regexp?.max_length && newValue.length > regexp.max_length) return;
        setInternalValue(newValue);
        dispatch((0, $8eba69c5466928d3$export$528cdcbbafe26779)({
            field: {
                id: id,
                value: newValue
            }
        }));
        // Check pattern validation
        if (changeStyles) {
            const styleUpdates = changeStyles.filter((update)=>"style" in update);
            const requestUpdates = changeStyles.filter((update)=>"request" in update);
            const functionUpdates = changeStyles.filter((update)=>"function" in update);
            if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates));
            if (requestUpdates.length) requestUpdates.forEach((update)=>{
                const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                const { delay: delay } = config || {};
                if (update?.request && method === "command") dispatch((0, $8eba69c5466928d3$export$ea176eb1668c7b4b)({
                    location: {
                        pathname: value
                    },
                    silent: silent,
                    componentId: id
                }));
                else if (update?.request && method === "action") dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                    value: value,
                    silent: silent,
                    delay: delay,
                    componentId: id
                }, stDraft?.states?.loading ? id : undefined));
                else if (update?.request && method === "open-url") (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent);
            });
            if (functionUpdates.length) functionUpdates.forEach((update)=>{
                if (update?.function) (0, $7b0e169a5380005e$export$1ed0175478ddd28b)(update.function, e, internalFns);
            });
        }
        if (regexp?.pattern && typeof regexp.pattern === "string") {
            const result = !$62d6cd46aaf31470$var$validateInputPattern(newValue, regexp.pattern);
            if (regexpSuccessUpdates && result) {
                const styleUpdates = regexpSuccessUpdates.filter((update)=>"style" in update);
                const requestUpdates = regexpSuccessUpdates.filter((update)=>"request" in update);
                const functionUpdates = regexpSuccessUpdates.filter((update)=>"function" in update);
                if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates));
                if (requestUpdates.length) requestUpdates.forEach((update)=>{
                    const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                    const { delay: delay } = config || {};
                    if (update?.request && method === "command") dispatch((0, $8eba69c5466928d3$export$ea176eb1668c7b4b)({
                        location: {
                            pathname: value
                        },
                        silent: silent,
                        componentId: id
                    }));
                    else if (update?.request && method === "action") dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                        value: value,
                        silent: silent,
                        delay: delay,
                        componentId: id
                    }, stDraft?.states?.loading ? id : undefined));
                    else if (update?.request && method === "open-url") (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent);
                });
                if (functionUpdates.length) functionUpdates.forEach((update)=>{
                    if (update?.function) (0, $7b0e169a5380005e$export$1ed0175478ddd28b)(update.function, e, internalFns);
                });
            } else if (regexpErorUpdates && !result) {
                const styleUpdates = regexpErorUpdates.filter((update)=>"style" in update);
                const requestUpdates = regexpErorUpdates.filter((update)=>"request" in update);
                const functionUpdates = regexpErorUpdates.filter((update)=>"function" in update);
                if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates));
                if (requestUpdates.length) requestUpdates.forEach((update)=>{
                    const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                    const { delay: delay } = config || {};
                    if (update?.request && method === "command") dispatch((0, $8eba69c5466928d3$export$ea176eb1668c7b4b)({
                        location: {
                            pathname: value
                        },
                        silent: silent,
                        componentId: id
                    }));
                    else if (update?.request && method === "action") dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                        value: value,
                        silent: silent,
                        delay: delay,
                        componentId: id
                    }, stDraft?.states?.loading ? id : undefined));
                    else if (update?.request && method === "open-url") (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent);
                });
                if (functionUpdates.length) functionUpdates.forEach((update)=>{
                    if (update?.function) (0, $7b0e169a5380005e$export$1ed0175478ddd28b)(update.function, e, internalFns);
                });
            }
        }
        if (soc) dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
            value: "soc",
            delay: delay,
            componentId: id
        }, stDraft?.states?.loading ? id : undefined));
    };
    const handleFocus = (e)=>{
        if (activeState === "disabled" || activeState === "loading") {
            e.preventDefault();
            e.stopPropagation();
            return;
        }
        if (focusStyles) {
            const styleUpdates = focusStyles.filter((update)=>"style" in update);
            const requestUpdates = focusStyles.filter((update)=>"request" in update);
            const functionUpdates = focusStyles.filter((update)=>"function" in update);
            if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates));
            if (requestUpdates.length) requestUpdates.forEach((update)=>{
                const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                const { delay: delay } = config || {};
                if (update?.request && method === "command") dispatch((0, $8eba69c5466928d3$export$ea176eb1668c7b4b)({
                    location: {
                        pathname: value
                    },
                    silent: silent,
                    componentId: id
                }));
                else if (update?.request && method === "action") dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                    value: value,
                    silent: silent,
                    delay: delay,
                    componentId: id
                }, stDraft?.states?.loading ? id : undefined));
                else if (update?.request && method === "open-url") (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent);
            });
            if (functionUpdates.length) functionUpdates.forEach((update)=>{
                if (update?.function) (0, $7b0e169a5380005e$export$1ed0175478ddd28b)(update.function, e, internalFns);
            });
        }
    };
    const handleBlur = (e)=>{
        if (activeState === "disabled" || activeState === "loading") {
            e.preventDefault();
            e.stopPropagation();
            return;
        }
        if (blurStyles) {
            const styleUpdates = blurStyles.filter((update)=>"style" in update);
            const requestUpdates = blurStyles.filter((update)=>"request" in update);
            const functionUpdates = blurStyles.filter((update)=>"function" in update);
            if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates));
            if (requestUpdates.length) requestUpdates.forEach((update)=>{
                const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                const { delay: delay } = config || {};
                if (update?.request && method === "command") dispatch((0, $8eba69c5466928d3$export$ea176eb1668c7b4b)({
                    location: {
                        pathname: value
                    },
                    silent: silent,
                    componentId: id
                }));
                else if (update?.request && method === "action") dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                    value: value,
                    silent: silent,
                    delay: delay,
                    componentId: id
                }, stDraft?.states?.loading ? id : undefined));
                else if (update?.request && method === "open-url") (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent);
            });
            if (functionUpdates.length) functionUpdates.forEach((update)=>{
                if (update?.function) (0, $7b0e169a5380005e$export$1ed0175478ddd28b)(update.function, e, internalFns);
            });
        }
    };
    const handleHover = (e)=>{
        if (activeState === "disabled" || activeState === "loading") {
            e.preventDefault();
            e.stopPropagation();
            return;
        }
        if (hoverUpdates) {
            const styleUpdates = hoverUpdates.filter((update)=>"style" in update);
            const requestUpdates = hoverUpdates.filter((update)=>"request" in update);
            const functionUpdates = hoverUpdates.filter((update)=>"function" in update);
            if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates));
            if (requestUpdates.length) requestUpdates.forEach((update)=>{
                const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                const { delay: delay } = config || {};
                if (update?.request && method === "action") dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                    value: value,
                    silent: silent,
                    delay: delay,
                    componentId: id
                }, stDraft?.states?.loading ? id : undefined));
                else if (update?.request && method === "open-url") (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent);
            });
            if (functionUpdates.length) functionUpdates.forEach((update)=>{
                if (update?.function) (0, $7b0e169a5380005e$export$1ed0175478ddd28b)(update.function, e, internalFns);
            });
        }
    };
    const handleUnhover = (e)=>{
        if (activeState === "disabled" || activeState === "loading") {
            e.preventDefault();
            e.stopPropagation();
            return;
        }
        if (unhoverUpdates) {
            const styleUpdates = unhoverUpdates.filter((update)=>"style" in update);
            const requestUpdates = unhoverUpdates.filter((update)=>"request" in update);
            const functionUpdates = unhoverUpdates.filter((update)=>"function" in update);
            if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates));
            if (requestUpdates.length) requestUpdates.forEach((update)=>{
                const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                const { delay: delay } = config || {};
                if (update?.request && method === "action") dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                    value: value,
                    silent: silent,
                    delay: delay,
                    componentId: id
                }, stDraft?.states?.loading ? id : undefined));
                else if (update?.request && method === "open-url") (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent);
            });
            if (functionUpdates.length) functionUpdates.forEach((update)=>{
                if (update?.function) (0, $7b0e169a5380005e$export$1ed0175478ddd28b)(update.function, e, internalFns);
            });
        }
    };
    (0, $aivMx.useEffect)(()=>{
        if (launchUpdates && launchUpdates.length) {
            const requestUpdates = launchUpdates.filter((update)=>"request" in update);
            const functionUpdates = launchUpdates.filter((update)=>"function" in update);
            if (requestUpdates.length) requestUpdates.forEach((update)=>{
                const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                const { delay: delay } = config || {};
                if (update?.request && method === "action") {
                    const newTimeout = setTimeout(()=>{
                        dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                            value: value,
                            silent: silent,
                            delay: delay,
                            componentId: id
                        }, stDraft?.states?.loading ? id : undefined));
                    }, config?.delay * 1000 || 0);
                    timeoutsRef.current.push(newTimeout);
                } else if (update?.request && method === "open-url") (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent);
            });
            if (functionUpdates.length) functionUpdates.forEach((update)=>{
                if (update?.function) (0, $7b0e169a5380005e$export$1ed0175478ddd28b)(update.function, undefined, internalFns);
            });
        }
        return ()=>{
            timeoutsRef?.current?.forEach((timeout)=>{
                clearTimeout(timeout);
            });
        };
    }, [
        launchUpdates
    ]);
    (0, $aivMx.useEffect)(()=>{
        const handleUnclick = (e)=>{
            if (activeState === "disabled" || activeState === "loading") return;
            if (inputRef.current && !inputRef.current.contains(e.target)) {
                if (outclickUpdates) {
                    const styleUpdates = outclickUpdates.filter((update)=>"style" in update);
                    const requestUpdates = outclickUpdates.filter((update)=>"request" in update);
                    const functionUpdates = outclickUpdates.filter((update)=>"function" in update);
                    if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates, parentIndex));
                    if (requestUpdates.length) requestUpdates.forEach((update)=>{
                        const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                        const { delay: delay } = config || {};
                        if (update?.request && method === "action") dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                            value: value,
                            silent: silent,
                            delay: delay,
                            componentId: id
                        }, stDraft?.states?.loading ? id : undefined));
                        else if (update?.request && method === "open-url") (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent);
                    });
                    if (functionUpdates.length) functionUpdates.forEach((update)=>{
                        if (update?.function) (0, $7b0e169a5380005e$export$1ed0175478ddd28b)(update.function, undefined, internalFns);
                    });
                }
            }
        };
        if (outclickUpdates) {
            document.addEventListener("mousedown", handleUnclick);
            return ()=>{
                document.removeEventListener("mousedown", handleUnclick);
            };
        }
        return undefined;
    }, [
        parentIndex,
        activeState,
        inputRef.current
    ]);
    if (renderSceleton && style) return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $cefd49c6ff42e132$export$2e2bcd8739ae039), {
        style: style,
        baseScreenResolution: baseScreenResolution,
        skipStates: activeState === "disabled" || activeState === "loading"
    });
    return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)($62d6cd46aaf31470$var$StyledTextarea, {
        ref: inputRef,
        placeholder: placeholder,
        id: `${id}${nestedTable && typeof parentIndex === "number" ? `::${parentIndex}` : ""}`,
        $shape: style,
        $baseScreenResolution: baseScreenResolution,
        $skipStates: activeState === "disabled" || activeState === "loading",
        "data-component": "input",
        className: (0, $7b0e169a5380005e$export$189053d41e721fcb)(style.class),
        value: internalValue,
        title: tooltip,
        autoFocus: autofocus,
        disabled: activeState === "disabled",
        onInput: handleInput,
        onFocus: handleFocus,
        onBlur: handleBlur,
        onMouseEnter: handleHover,
        onMouseLeave: handleUnhover,
        maxLength: regexp?.max_length
    });
};
const $62d6cd46aaf31470$var$Email = ({ id: id, style: style, placeholder: placeholder })=>/*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)($62d6cd46aaf31470$var$StyledInput, {
        placeholder: placeholder,
        id: id,
        type: "email",
        $shape: style,
        "data-component": "input",
        className: (0, $7b0e169a5380005e$export$189053d41e721fcb)(style.class)
    });
const $62d6cd46aaf31470$var$Number = ({ id: id, style: style, placeholder: placeholder })=>/*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)($62d6cd46aaf31470$var$StyledInput, {
        placeholder: placeholder,
        id: id,
        type: "number",
        $shape: style,
        "data-component": "input",
        className: (0, $7b0e169a5380005e$export$189053d41e721fcb)(style.class)
    });
const $62d6cd46aaf31470$var$File = ({ id: id, style: style, placeholder: placeholder })=>/*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)($62d6cd46aaf31470$var$StyledInput, {
        placeholder: placeholder,
        id: id,
        type: "file",
        $shape: style,
        "data-component": "input",
        className: (0, $7b0e169a5380005e$export$189053d41e721fcb)(style.class)
    });
const $62d6cd46aaf31470$var$Phone = ({ id: id, style: style, placeholder: placeholder })=>/*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)($62d6cd46aaf31470$var$StyledInput, {
        placeholder: placeholder,
        id: id,
        type: "tel",
        $shape: style,
        "data-component": "input",
        className: (0, $7b0e169a5380005e$export$189053d41e721fcb)(style.class)
    });
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $62d6cd46aaf31470$var$Global = (props)=>{
    const { type: type } = props;
    switch(type){
        case "text":
        case "password":
        case "number":
            return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)($62d6cd46aaf31470$var$Input, {
                ...props
            });
        case "textarea":
            return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)($62d6cd46aaf31470$var$TextArea, {
                ...props
            });
        // case 'password':
        //   return <Password {...props} />;
        case "email":
            return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)($62d6cd46aaf31470$var$Email, {
                ...props
            });
        case "number":
            return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)($62d6cd46aaf31470$var$Number, {
                ...props
            });
        case "file":
            return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)($62d6cd46aaf31470$var$File, {
                ...props
            });
        case "phone":
            return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)($62d6cd46aaf31470$var$Phone, {
                ...props
            });
        case "daterangepicker":
            return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $896243df65db0cdd$export$2e2bcd8739ae039), {
                ...props
            });
        default:
            return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)($62d6cd46aaf31470$var$Input, {
                ...props
            });
    }
};
var $62d6cd46aaf31470$export$2e2bcd8739ae039 = $62d6cd46aaf31470$var$Global;


var $7ea0c43ec9b05f7e$export$2e2bcd8739ae039 = (0, $62d6cd46aaf31470$export$2e2bcd8739ae039);




var $aivMx = parcelRequire("aivMx");



var $94WEq = parcelRequire("94WEq");

var $g1KQj = parcelRequire("g1KQj");




parcelRequire("aivMx");
const $b4c89c9d73897b7f$var$SvgRadioChecked = (props)=>/*#__PURE__*/ (0, $02de83db299f7983$exports.jsxs)("svg", {
        width: 16,
        height: 16,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("path", {
                d: "M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Z",
                fill: "#7F56D9"
            }),
            /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("path", {
                d: "M5 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0Z",
                fill: "#fff"
            })
        ]
    });
var $b4c89c9d73897b7f$export$2e2bcd8739ae039 = $b4c89c9d73897b7f$var$SvgRadioChecked;



parcelRequire("aivMx");
const $e7abda7e005876c0$var$SvgRadioUnchecked = (props)=>/*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("svg", {
        width: 16,
        height: 16,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("path", {
            d: "M.5 8a7.5 7.5 0 1 1 15 0 7.5 7.5 0 0 1-15 0Z",
            stroke: "#D0D5DD"
        })
    });
var $e7abda7e005876c0$export$2e2bcd8739ae039 = $e7abda7e005876c0$var$SvgRadioUnchecked;




const $6858d9d764342496$var$StyledRadioLabel = (0, $6e03950c2a9b6039$export$2e2bcd8739ae039).label`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 0;
  ${(props)=>(0, $e0d24bf85c947bed$export$2e2bcd8739ae039)(props.$shape, props.$baseScreenResolution, props.$skipStates)}
`;
const $6858d9d764342496$var$StyledRadio = (0, $6e03950c2a9b6039$export$2e2bcd8739ae039).input`
  z-index: 1;
  cursor: pointer;
  margin: 0;
  padding: 0;
  position: absolute;
  opacity: 0;
  height: 0;
  width: 0;
`;
const $6858d9d764342496$var$Radio = ({ id: id, style: stDraft, name: name, events: eventsDraft, soc: soc, value: value, pageSettings: pageSettings, dataLake: dataLake, nestedTable: nestedTable, parentIndex: parentIndex, styleChunks: styleChunks, settings: settings, sceleton: renderSceleton, activeState: activeStateDraft })=>{
    const containerRef = (0, $aivMx.useRef)(null);
    const { style: styleDraft, events: events, activeState: activeState } = dataLake?.data ? (0, $7b0e169a5380005e$export$485c71a5d8ecbaad)({
        style: stDraft,
        events: eventsDraft,
        activeState: activeStateDraft
    }, dataLake.data) : {
        style: stDraft,
        events: eventsDraft,
        activeState: activeStateDraft
    };
    const mergeStylesWithChunks = (0, $aivMx.useCallback)((style, chunks, index)=>{
        if (chunks && chunks[id] && chunks[id][index] && typeof index === "number") return (0, (/*@__PURE__*/$parcel$interopDefault($94WEq)))({}, style, chunks[id][index]);
        return style;
    }, [
        id
    ]);
    const variableData = (0, $f40d1f3d995cccef$export$2105062e25df4afe)((0, $79fc67ed759ae65b$export$e3ab06c283dfbb87));
    const localVariableData = (0, $f40d1f3d995cccef$export$2105062e25df4afe)((0, $79fc67ed759ae65b$export$78b26e3ba532c6ce));
    // First useMemo to merge active state styles with base style
    const mergedStyleWithState = (0, $aivMx.useMemo)(()=>{
        let mergedStyle = styleDraft;
        if (activeState && styleDraft?.states?.[activeState]) mergedStyle = (0, (/*@__PURE__*/$parcel$interopDefault($94WEq)))({}, styleDraft, styleDraft.states[activeState]);
        // Handle states in breakpoints
        if (styleDraft?.breakpoints) mergedStyle.breakpoints = Object.entries(styleDraft.breakpoints).reduce((acc, [breakpoint, breakpointStyle])=>{
            const typedBreakpointStyle = breakpointStyle;
            if (typedBreakpointStyle?.states?.[activeState]) acc[breakpoint] = (0, (/*@__PURE__*/$parcel$interopDefault($94WEq)))({}, typedBreakpointStyle, typedBreakpointStyle.states[activeState]);
            else acc[breakpoint] = typedBreakpointStyle;
            return acc;
        }, {});
        return mergedStyle;
    }, [
        styleDraft,
        activeState
    ]);
    // Second useMemo to merge styles with chunks based on parentIndex
    const style = (0, $aivMx.useMemo)(()=>{
        return mergeStylesWithChunks(mergedStyleWithState, styleChunks, parentIndex);
    }, [
        mergedStyleWithState,
        styleChunks,
        parentIndex
    ]);
    const baseScreenResolution = pageSettings?.baseScreenResolution ? (0, $7b0e169a5380005e$export$e58d7eefdadeb732)(pageSettings?.baseScreenResolution) : undefined;
    const [checkedInternal, setCheckedInternal] = (0, $aivMx.useState)(value === "true" ? true : value === "false" ? false : value);
    const debouncedSubmitForm = (0, $aivMx.useCallback)((0, $7b0e169a5380005e$export$61fc7d43ac8f84b0)(()=>{
        dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
            value: "soc",
            componentId: id
        }));
    }, 500), []);
    (0, $aivMx.useEffect)(()=>{
        setCheckedInternal(value === "true" ? true : value === "false" ? false : value);
    }, [
        value
    ]);
    const { on_change: clickUpdates, on_launch: launchUpdates, on_hover: hoverUpdates, on_unhover: unhoverUpdates, on_outclick: outclickUpdates } = events || {};
    const dispatch = (0, $d023060d48542f4c$export$8ad76b76a4c905f8)();
    const timeoutsRef = (0, $aivMx.useRef)([]);
    const internalFns = {
        $setVariable: (key, value)=>{
            dispatch((0, $8eba69c5466928d3$export$36f0c40eded97f9d)({
                variable: key,
                value: value
            }));
        },
        $getVariable: (key)=>{
            const value = (0, $7b0e169a5380005e$export$2516322ffbb7f3fb)(variableData, key) || (0, $7b0e169a5380005e$export$2516322ffbb7f3fb)(localVariableData, key);
            return value;
        },
        $moment: (...args)=>(0, (/*@__PURE__*/$parcel$interopDefault($g1KQj)))(...args)
    };
    const handleCheckboxChange = ()=>{
        if (checkedInternal && checkedInternal !== "false") return;
        setCheckedInternal(!checkedInternal);
        dispatch((0, $8eba69c5466928d3$export$528cdcbbafe26779)({
            field: {
                id: id,
                value: !checkedInternal
            }
        }));
        dispatch((0, $8eba69c5466928d3$export$c75cc2fedb4914bf)({
            excludeId: id,
            name: name
        }));
        if (soc) debouncedSubmitForm(!checkedInternal);
    };
    const handleClick = (e)=>{
        if (activeState === "disabled" || activeState === "loading") {
            e.preventDefault();
            e.stopPropagation();
            return;
        }
        handleCheckboxChange();
        e.preventDefault();
        if (clickUpdates) {
            e.stopPropagation();
            const styleUpdates = clickUpdates.filter((update)=>"style" in update);
            const requestUpdates = clickUpdates.filter((update)=>"request" in update);
            const functionUpdates = clickUpdates.filter((update)=>"function" in update);
            if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates));
            if (requestUpdates.length) requestUpdates.forEach((update)=>{
                const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                const { delay: delay } = config || {};
                if (update?.request && method === "command") dispatch((0, $8eba69c5466928d3$export$ea176eb1668c7b4b)({
                    location: {
                        pathname: value
                    },
                    silent: silent,
                    componentId: id
                }));
                else if (update?.request && method === "action") dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                    value: value,
                    silent: silent,
                    delay: delay,
                    componentId: id
                }, stDraft?.states?.loading ? id : undefined));
                else if (update?.request && method === "open-url") (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent);
            });
            if (functionUpdates.length) functionUpdates.forEach((update)=>{
                if (update?.function) (0, $7b0e169a5380005e$export$1ed0175478ddd28b)(update.function, e, internalFns);
            });
        }
    };
    const handleHover = (e)=>{
        if (activeState === "disabled" || activeState === "loading") {
            e.stopPropagation();
            e.preventDefault();
            return;
        }
        if (hoverUpdates) {
            const styleUpdates = hoverUpdates.filter((update)=>"style" in update);
            const requestUpdates = hoverUpdates.filter((update)=>"request" in update);
            const functionUpdates = hoverUpdates.filter((update)=>"function" in update);
            if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates));
            if (requestUpdates.length) requestUpdates.forEach((update)=>{
                const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                const { delay: delay } = config || {};
                if (update?.request && method === "action") dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                    value: value,
                    silent: silent,
                    delay: delay,
                    componentId: id
                }, stDraft?.states?.loading ? id : undefined));
                else if (update?.request && method === "open-url") (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent);
            });
            if (functionUpdates.length) functionUpdates.forEach((update)=>{
                if (update?.function) (0, $7b0e169a5380005e$export$1ed0175478ddd28b)(update.function, e, internalFns);
            });
        }
    };
    const handleUnhover = (e)=>{
        if (activeState === "disabled" || activeState === "loading") {
            e.stopPropagation();
            e.preventDefault();
            return;
        }
        if (unhoverUpdates) {
            const styleUpdates = unhoverUpdates.filter((update)=>"style" in update);
            const requestUpdates = unhoverUpdates.filter((update)=>"request" in update);
            const functionUpdates = unhoverUpdates.filter((update)=>"function" in update);
            if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates));
            if (requestUpdates.length) requestUpdates.forEach((update)=>{
                const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                const { delay: delay } = config || {};
                if (update?.request && method === "action") dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                    value: value,
                    silent: silent,
                    delay: delay,
                    componentId: id
                }, stDraft?.states?.loading ? id : undefined));
                else if (update?.request && method === "open-url") (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent);
            });
            if (functionUpdates.length) functionUpdates.forEach((update)=>{
                if (update?.function) (0, $7b0e169a5380005e$export$1ed0175478ddd28b)(update.function, e, internalFns);
            });
        }
    };
    (0, $aivMx.useEffect)(()=>{
        if (launchUpdates && launchUpdates.length) {
            const styleUpdates = launchUpdates.filter((update)=>"style" in update);
            const requestUpdates = launchUpdates.filter((update)=>"request" in update);
            const functionUpdates = launchUpdates.filter((update)=>"function" in update);
            if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates));
            if (requestUpdates.length) requestUpdates.forEach((update)=>{
                const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                const { delay: delay } = config || {};
                if (update?.request && method === "action") ;
                else if (update?.request && method === "open-url") (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent);
            });
            if (functionUpdates.length) functionUpdates.forEach((update)=>{
                if (update?.function) (0, $7b0e169a5380005e$export$1ed0175478ddd28b)(update.function, undefined, internalFns);
            });
        }
        return ()=>{
            timeoutsRef?.current?.forEach((timeout)=>{
                clearTimeout(timeout);
            });
        };
    }, [
        launchUpdates
    ]);
    (0, $aivMx.useEffect)(()=>{
        const handleUnclick = (e)=>{
            if (activeState === "disabled" || activeState === "loading") return;
            if (containerRef.current && !containerRef.current.contains(e.target)) {
                if (outclickUpdates) {
                    const styleUpdates = outclickUpdates.filter((update)=>"style" in update);
                    const requestUpdates = outclickUpdates.filter((update)=>"request" in update);
                    const functionUpdates = outclickUpdates.filter((update)=>"function" in update);
                    if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates, parentIndex));
                    if (requestUpdates.length) requestUpdates.forEach((update)=>{
                        const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                        const { delay: delay } = config || {};
                        if (update?.request && method === "action") dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                            value: value,
                            silent: silent,
                            delay: delay,
                            componentId: id
                        }, stDraft?.states?.loading ? id : undefined));
                        else if (update?.request && method === "open-url") (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent);
                    });
                    if (functionUpdates.length) functionUpdates.forEach((update)=>{
                        if (update?.function) (0, $7b0e169a5380005e$export$1ed0175478ddd28b)(update.function, undefined, internalFns);
                    });
                }
            }
        };
        if (outclickUpdates) {
            document.addEventListener("mousedown", handleUnclick);
            return ()=>{
                document.removeEventListener("mousedown", handleUnclick);
            };
        }
        return undefined;
    }, [
        parentIndex,
        activeState,
        containerRef.current
    ]);
    if (renderSceleton && style) return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $cefd49c6ff42e132$export$2e2bcd8739ae039), {
        style: style,
        baseScreenResolution: baseScreenResolution,
        skipStates: activeState === "disabled" || activeState === "loading"
    });
    return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsxs)($6858d9d764342496$var$StyledRadioLabel, {
        ref: containerRef,
        htmlFor: `${id}${nestedTable && typeof parentIndex === "number" ? `::${parentIndex}` : ""}`,
        $shape: style,
        $baseScreenResolution: baseScreenResolution,
        $skipStates: activeState === "disabled" || activeState === "loading",
        "data-component": "radio",
        className: (0, $7b0e169a5380005e$export$189053d41e721fcb)(style.class),
        onClick: handleClick,
        onMouseEnter: handleHover,
        onMouseLeave: handleUnhover,
        children: [
            /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)($6858d9d764342496$var$StyledRadio, {
                id: `${id}${nestedTable && typeof parentIndex === "number" ? `::${parentIndex}` : ""}`,
                name: name,
                value: id,
                type: "radio",
                checked: checkedInternal
            }),
            checkedInternal ? settings?.icons?.active ? /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("img", {
                style: {
                    maxWidth: "100%",
                    maxHeight: "100%"
                },
                src: settings.icons.active
            }) : /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $b4c89c9d73897b7f$export$2e2bcd8739ae039), {}) : settings?.icons?.inactive ? /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("img", {
                style: {
                    maxWidth: "100%",
                    maxHeight: "100%"
                },
                src: settings.icons.inactive
            }) : /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $e7abda7e005876c0$export$2e2bcd8739ae039), {})
        ]
    });
};
var $6858d9d764342496$export$2e2bcd8739ae039 = $6858d9d764342496$var$Radio;


var $b35bf230db392315$export$2e2bcd8739ae039 = (0, $6858d9d764342496$export$2e2bcd8739ae039);




var $aivMx = parcelRequire("aivMx");





var $94WEq = parcelRequire("94WEq");

var $g1KQj = parcelRequire("g1KQj");


parcelRequire("aivMx");
const $b08c9de2ff5f2c28$var$SvgXClose = (props)=>/*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("path", {
            d: "M18 6 6 18M6 6l12 12",
            stroke: "#000",
            strokeWidth: 2,
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
var $b08c9de2ff5f2c28$export$2e2bcd8739ae039 = $b08c9de2ff5f2c28$var$SvgXClose;






parcelRequire("aivMx");
const $c07e36697bce3a79$var$SvgChevronDown = (props)=>/*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("path", {
            d: "m5 7.5 5 5 5-5",
            stroke: "#667085",
            strokeWidth: 1.667,
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
var $c07e36697bce3a79$export$2e2bcd8739ae039 = $c07e36697bce3a79$var$SvgChevronDown;


var $cd0af89cb2a229cd$export$5cfb6affd60879e9;
var $cd0af89cb2a229cd$export$a1499cbfa2755cde;
var $cd0af89cb2a229cd$export$f26c97331adc89d5;
var $cd0af89cb2a229cd$export$ff8e94cb38bad9e7;
$cd0af89cb2a229cd$export$5cfb6affd60879e9 = `BDHbBq_chipIcon`;
$cd0af89cb2a229cd$export$a1499cbfa2755cde = `BDHbBq_chipItem`;
$cd0af89cb2a229cd$export$f26c97331adc89d5 = `BDHbBq_selectItem`;
$cd0af89cb2a229cd$export$ff8e94cb38bad9e7 = `BDHbBq_selectItemsContainer`;


const $c98b0135d71b9ff2$var$SelectWrapper = (0, $6e03950c2a9b6039$export$2e2bcd8739ae039).div`
  z-index: 1;
  position: relative;
  display: grid;
  ${(props)=>(0, $e0d24bf85c947bed$export$2e2bcd8739ae039)(props.$shape)}
`;
const $c98b0135d71b9ff2$var$SelectButton = (0, $6e03950c2a9b6039$export$2e2bcd8739ae039).button`
  display: grid;
  cursor: pointer;
  width: 100%;
  overflow: hidden;
  z-index: 0;
  padding: 0;
  background-color: transparent;
  ${(props)=>(0, $e0d24bf85c947bed$export$2e2bcd8739ae039)(props.$shape, props.$baseScreenResolution, props.$skipStates)}
  display: flex;
  position: relative;
  justify-content: space-between;
  align-items: center;
  gap: 8px;

  &:focus, &:focus-within {
    outline: none;
    box-shadow: ${(props)=>props.isOpen ? "none" : "none"};
  }
`;
const $c98b0135d71b9ff2$var$SelectInput = (0, $6e03950c2a9b6039$export$2e2bcd8739ae039).input`
    border: 0;
    margin: 0;
    padding: 0;
    outline: none;
    width: 100%;
    min-width: 80px;
    ${(props)=>(0, $e0d24bf85c947bed$export$2e2bcd8739ae039)(props.$shape)}
`;
const $c98b0135d71b9ff2$var$SelectOptions = (0, $6e03950c2a9b6039$export$2e2bcd8739ae039).div`
  position: fixed;
  top: ${(props)=>`${props.top + props.height + 4 || 0}px`};
  left: ${(props)=>`${props.left || 0}px`};
  width: ${(props)=>`${props.width || 0}px`};
  max-height: calc(7 * 2.5em);
  overflow-y: auto;
  background: #fff;
  box-shadow: 0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03);
  z-index: 999999999999;
  ${(props)=>(0, $e0d24bf85c947bed$export$2e2bcd8739ae039)(props.$shape)}

  /* Custom Scrollbar for Webkit browsers */
  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-thumb {
    background: var(--Colors-Background-bg-quaternary, #EAECF0);
    border-radius: var(--radius-full, 9999px);
  }

  ::-webkit-scrollbar-track {
    background: transparent;
  }

  /* Custom Scrollbar for Firefox */
  scrollbar-width: thin;
  scrollbar-color: var(--Colors-Background-bg-quaternary, #EAECF0) transparent;
`;
const $c98b0135d71b9ff2$var$SelectOption = (0, $6e03950c2a9b6039$export$2e2bcd8739ae039).div`
  padding: 10px;
  cursor: pointer;
  background: ${(props)=>props.isSelected ? "#F9FAFB" : "#FFF"};
  display: flex;
  justify-content: space-between;
  align-items: center;
  overflow: hidden;

  &:hover {
    background: #F9FAFB;
  }
`;
const $c98b0135d71b9ff2$var$CombinedSelect = ({ id: id, type: type, options: optionsDraft, style: stDraft, value: valueDraft, events: eventsDraft, soc: soc, placeholder: placeholder, settings: settings, pageSettings: pageSettings, dataLake: dataLake, nestedTable: nestedTable, parentIndex: parentIndex, styleChunks: styleChunks, parentRef: parentRef, sceleton: renderSceleton, activeState: activeStateDraft })=>{
    const { delay: delay = 500 } = settings || {};
    const { style: styleDraft, events: events, options: optionsTransformed, value: value, activeState: activeState } = dataLake?.data ? (0, $7b0e169a5380005e$export$485c71a5d8ecbaad)({
        style: stDraft,
        events: eventsDraft,
        value: valueDraft,
        options: optionsDraft,
        activeState: activeStateDraft
    }, dataLake.data) : {
        style: stDraft,
        events: eventsDraft,
        value: valueDraft,
        options: optionsDraft,
        activeState: activeStateDraft
    };
    const mergeStylesWithChunks = (0, $aivMx.useCallback)((style, chunks, index)=>{
        if (chunks && chunks[id] && chunks[id][index] && typeof index === "number") return (0, (/*@__PURE__*/$parcel$interopDefault($94WEq)))({}, style, chunks[id][index]);
        return style;
    }, [
        id
    ]);
    const variableData = (0, $f40d1f3d995cccef$export$2105062e25df4afe)((0, $79fc67ed759ae65b$export$e3ab06c283dfbb87));
    const localVariableData = (0, $f40d1f3d995cccef$export$2105062e25df4afe)((0, $79fc67ed759ae65b$export$78b26e3ba532c6ce));
    // First useMemo to merge active state styles with base styles
    const mergedStyleWithState = (0, $aivMx.useMemo)(()=>{
        let mergedStyle = styleDraft;
        if (activeState && styleDraft?.states?.[activeState]) mergedStyle = (0, (/*@__PURE__*/$parcel$interopDefault($94WEq)))({}, styleDraft, styleDraft.states[activeState]);
        // Handle states in breakpoints
        if (styleDraft?.breakpoints) mergedStyle.breakpoints = Object.entries(styleDraft.breakpoints).reduce((acc, [breakpoint, breakpointStyle])=>{
            const typedBreakpointStyle = breakpointStyle;
            if (typedBreakpointStyle?.states?.[activeState]) acc[breakpoint] = (0, (/*@__PURE__*/$parcel$interopDefault($94WEq)))({}, typedBreakpointStyle, typedBreakpointStyle.states[activeState]);
            else acc[breakpoint] = typedBreakpointStyle;
            return acc;
        }, {});
        return mergedStyle;
    }, [
        styleDraft,
        activeState
    ]);
    // Second useMemo to merge styles with chunks based on parentIndex
    const style = (0, $aivMx.useMemo)(()=>{
        return mergeStylesWithChunks(mergedStyleWithState, styleChunks, parentIndex);
    }, [
        mergedStyleWithState,
        styleChunks,
        parentIndex
    ]);
    const baseScreenResolution = pageSettings?.baseScreenResolution ? (0, $7b0e169a5380005e$export$e58d7eefdadeb732)(pageSettings?.baseScreenResolution) : undefined;
    const { grid: gridStyle, border: border, font: font, placeholder: placeholderStyle, ...otherStyle } = style || {};
    const { width: width, height: height, flex: flexStyle } = style || {};
    const { grow: grow, shrink: shrink, basis: basis } = flexStyle || {};
    const selectRef = (0, $aivMx.useRef)(null);
    const dropdownRef = (0, $aivMx.useRef)(null);
    const options = typeof optionsTransformed === "string" ? (0, $7b0e169a5380005e$export$8c51936ffbb22bee)(optionsTransformed) : optionsTransformed;
    const [position, setPosition] = (0, $aivMx.useState)({
        top: 0,
        left: 0,
        width: 0,
        height: 0
    });
    const isSearchEnabled = settings?.search;
    const isMultiple = type === "multiple";
    const dispatch = (0, $d023060d48542f4c$export$8ad76b76a4c905f8)();
    const internalFns = {
        $setVariable: (key, value)=>{
            dispatch((0, $8eba69c5466928d3$export$36f0c40eded97f9d)({
                variable: key,
                value: value
            }));
        },
        $getVariable: (key)=>{
            const value = (0, $7b0e169a5380005e$export$2516322ffbb7f3fb)(variableData, key) || (0, $7b0e169a5380005e$export$2516322ffbb7f3fb)(localVariableData, key);
            return value;
        },
        $moment: (...args)=>(0, (/*@__PURE__*/$parcel$interopDefault($g1KQj)))(...args)
    };
    const timeoutsRef = (0, $aivMx.useRef)([]);
    const [isOpen, setIsOpen] = (0, $aivMx.useState)(false);
    const [searchTerm, setSearchTerm] = (0, $aivMx.useState)();
    const [internalValue, setInternalValue] = (0, $aivMx.useState)(Array.isArray(value) ? value : value ? [
        value
    ] : []);
    const { on_change: changeStyles, on_launch: launchUpdates, on_hover: hoverUpdates, on_unhover: unhoverUpdates, on_focus: focusUpdates, on_blur: blurUpdates, on_outclick: outclickUpdates } = events || {};
    (0, $aivMx.useEffect)(()=>{
        if (Array.isArray(value) && value.length || value && typeof value === "string") setInternalValue(Array.isArray(value) ? value : value ? [
            value
        ] : []);
    }, [
        value
    ]);
    const updatePosition = ()=>{
        if (parentRef && parentRef.current) {
            const rect = parentRef.current.getBoundingClientRect();
            setPosition({
                top: rect.top,
                height: rect.height,
                left: rect.left,
                width: rect.width
            });
        } else if (selectRef.current) {
            const rect = selectRef.current.getBoundingClientRect();
            setPosition({
                top: rect.top,
                height: rect.height,
                left: rect.left,
                width: rect.width
            });
        }
    };
    (0, $aivMx.useEffect)(()=>{
        updatePosition(); // Update position when isOpen changes
    }, [
        isOpen
    ]);
    (0, $aivMx.useEffect)(()=>{
        window.addEventListener("resize", updatePosition);
        window.addEventListener("scroll", updatePosition, true); // true to capture event in the capturing phase
        updatePosition(); // Initial position update
        return ()=>{
            window.removeEventListener("resize", updatePosition);
            window.removeEventListener("scroll", updatePosition, true);
        };
    }, [
        parentRef
    ]);
    (0, $aivMx.useEffect)(()=>{
        if (Array.isArray(value) && value.length && value.join(" ") !== internalValue?.join(" ")) setInternalValue(value);
        else if (!Array.isArray(value) && value !== internalValue[0]) setInternalValue(value ? [
            value
        ] : []);
    }, [
        value
    ]);
    const handleHover = (e)=>{
        if (activeState === "disabled" || activeState === "loading") {
            e.preventDefault();
            e.stopPropagation();
            return;
        }
        if (hoverUpdates) {
            const styleUpdates = hoverUpdates.filter((update)=>"style" in update);
            const requestUpdates = hoverUpdates.filter((update)=>"request" in update);
            const functionUpdates = hoverUpdates.filter((update)=>"function" in update);
            if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates));
            if (requestUpdates.length) requestUpdates.forEach((update)=>{
                const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                const { delay: delay } = config || {};
                if (update?.request && method === "action") dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                    value: value,
                    silent: silent,
                    delay: delay,
                    componentId: id
                }, stDraft?.states?.loading ? id : undefined));
                else if (update?.request && method === "open-url") (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent);
            });
            if (functionUpdates.length) functionUpdates.forEach((update)=>{
                if (update?.function) (0, $7b0e169a5380005e$export$1ed0175478ddd28b)(update.function, e, internalFns);
            });
        }
    };
    const handleUnhover = (e)=>{
        if (activeState === "disabled" || activeState === "loading") {
            e.preventDefault();
            e.stopPropagation();
            return;
        }
        if (unhoverUpdates) {
            const styleUpdates = unhoverUpdates.filter((update)=>"style" in update);
            const requestUpdates = unhoverUpdates.filter((update)=>"request" in update);
            const functionUpdates = unhoverUpdates.filter((update)=>"function" in update);
            if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates));
            if (requestUpdates.length) requestUpdates.forEach((update)=>{
                const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                const { delay: delay } = config || {};
                if (update?.request && method === "action") dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                    value: value,
                    silent: silent,
                    delay: delay,
                    componentId: id
                }, stDraft?.states?.loading ? id : undefined));
                else if (update?.request && method === "open-url") (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent);
            });
            if (functionUpdates.length) functionUpdates.forEach((update)=>{
                if (update?.function) (0, $7b0e169a5380005e$export$1ed0175478ddd28b)(update.function, e, internalFns);
            });
        }
    };
    (0, $aivMx.useEffect)(()=>{
        let clickInsidePortal = false;
        const handleMouseDown = (event)=>{
            if (dropdownRef.current && dropdownRef.current.contains(event.target)) clickInsidePortal = true;
        };
        const handleClickOutside = (event)=>{
            if (!clickInsidePortal && selectRef.current && !selectRef.current.contains(event.target)) setIsOpen(false);
            clickInsidePortal = false; // Reset the flag
        };
        if (isOpen) {
            document.addEventListener("mousedown", handleMouseDown);
            document.addEventListener("click", handleClickOutside);
            return ()=>{
                document.removeEventListener("mousedown", handleMouseDown);
                document.removeEventListener("click", handleClickOutside);
            };
        }
    }, [
        isOpen
    ]);
    (0, $aivMx.useEffect)(()=>{
        if (isOpen && focusUpdates) {
            const styleUpdates = focusUpdates.filter((update)=>"style" in update);
            const requestUpdates = focusUpdates.filter((update)=>"request" in update);
            const functionUpdates = focusUpdates.filter((update)=>"function" in update);
            if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates));
            if (requestUpdates.length) requestUpdates.forEach((update)=>{
                const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                const { delay: delay } = config || {};
                if (update?.request && method === "action") dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                    value: value,
                    silent: silent,
                    delay: delay,
                    componentId: id
                }, stDraft?.states?.loading ? id : undefined));
                else if (update?.request && method === "open-url") (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent);
            });
            if (functionUpdates.length) functionUpdates.forEach((update)=>{
                if (update?.function) (0, $7b0e169a5380005e$export$1ed0175478ddd28b)(update.function, undefined, internalFns);
            });
        } else if (!isOpen && blurUpdates) {
            const styleUpdates = blurUpdates.filter((update)=>"style" in update);
            const requestUpdates = blurUpdates.filter((update)=>"request" in update);
            const functionUpdates = blurUpdates.filter((update)=>"function" in update);
            if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates));
            if (requestUpdates.length) requestUpdates.forEach((update)=>{
                const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                const { delay: delay } = config || {};
                if (update?.request && method === "action") dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                    value: value,
                    silent: silent,
                    delay: delay,
                    componentId: id
                }, stDraft?.states?.loading ? id : undefined));
                else if (update?.request && method === "open-url") (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent);
            });
            if (functionUpdates.length) functionUpdates.forEach((update)=>{
                if (update?.function) (0, $7b0e169a5380005e$export$1ed0175478ddd28b)(update.function, undefined, internalFns);
            });
        }
    }, [
        isOpen
    ]);
    (0, $aivMx.useEffect)(()=>{
        if (launchUpdates && launchUpdates.length) {
            const styleUpdates = launchUpdates.filter((update)=>"style" in update);
            const requestUpdates = launchUpdates.filter((update)=>"request" in update);
            const functionUpdates = launchUpdates.filter((update)=>"function" in update);
            if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates));
            if (requestUpdates.length) requestUpdates.forEach((update)=>{
                const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                const { delay: delay } = config || {};
                if (update?.request && method === "action") ;
                else if (update?.request && method === "open-url") (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent);
            });
            if (functionUpdates.length) functionUpdates.forEach((update)=>{
                if (update?.function) (0, $7b0e169a5380005e$export$1ed0175478ddd28b)(update.function, undefined, internalFns);
            });
        }
        return ()=>{
            timeoutsRef?.current?.forEach((timeout)=>{
                clearTimeout(timeout);
            });
        };
    }, [
        launchUpdates
    ]);
    const handleChange = (e, selected)=>{
        if (type === "multiple") {
            const newValuesBuffer = [
                ...internalValue,
                selected
            ];
            const uniqueValues = newValuesBuffer.filter((value, index)=>newValuesBuffer.indexOf(value) === index);
            setInternalValue(uniqueValues);
            setSearchTerm("");
            dispatch((0, $8eba69c5466928d3$export$528cdcbbafe26779)({
                field: {
                    id: id,
                    value: uniqueValues
                }
            }));
        } else {
            setInternalValue([
                selected
            ]);
            setSearchTerm("");
            dispatch((0, $8eba69c5466928d3$export$528cdcbbafe26779)({
                field: {
                    id: id,
                    value: selected
                }
            }));
        }
        if (changeStyles) {
            const styleUpdates = changeStyles.filter((update)=>"style" in update);
            const requestUpdates = changeStyles.filter((update)=>"request" in update);
            const functionUpdates = changeStyles.filter((update)=>"function" in update);
            if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates));
            if (requestUpdates.length) requestUpdates.forEach((update)=>{
                const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                const { delay: delay } = config || {};
                if (update?.request && method === "command") dispatch((0, $8eba69c5466928d3$export$ea176eb1668c7b4b)({
                    location: {
                        pathname: value
                    },
                    silent: silent,
                    componentId: id
                }));
                else if (update?.request && method === "action") dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                    value: value,
                    silent: silent,
                    delay: delay,
                    componentId: id
                }, stDraft?.states?.loading ? id : undefined));
                else if (update?.request && method === "open-url") (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent);
            });
            if (functionUpdates.length) functionUpdates.forEach((update)=>{
                if (update?.function) (0, $7b0e169a5380005e$export$1ed0175478ddd28b)(update.function, e, internalFns);
            });
        }
        if (soc) dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
            value: "soc",
            delay: delay,
            componentId: id
        }, stDraft?.states?.loading ? id : undefined));
    };
    (0, $aivMx.useEffect)(()=>{
        const handleUnclick = (e)=>{
            if (activeState === "disabled" || activeState === "loading") return;
            if (selectRef.current && !selectRef.current.contains(e.target)) {
                if (outclickUpdates) {
                    const styleUpdates = outclickUpdates.filter((update)=>"style" in update);
                    const requestUpdates = outclickUpdates.filter((update)=>"request" in update);
                    const functionUpdates = outclickUpdates.filter((update)=>"function" in update);
                    if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates, parentIndex));
                    if (requestUpdates.length) requestUpdates.forEach((update)=>{
                        const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                        const { delay: delay } = config || {};
                        if (update?.request && method === "action") dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                            value: value,
                            silent: silent,
                            delay: delay,
                            componentId: id
                        }, stDraft?.states?.loading ? id : undefined));
                        else if (update?.request && method === "open-url") (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent);
                    });
                    if (functionUpdates.length) functionUpdates.forEach((update)=>{
                        if (update?.function) (0, $7b0e169a5380005e$export$1ed0175478ddd28b)(update.function, undefined, internalFns);
                    });
                }
            }
        };
        if (outclickUpdates) {
            document.addEventListener("mousedown", handleUnclick);
            return ()=>{
                document.removeEventListener("mousedown", handleUnclick);
            };
        }
        return undefined;
    }, [
        parentIndex,
        activeState,
        selectRef.current
    ]);
    const handleSelect = (e, id)=>{
        handleChange(e, id);
        setIsOpen(false);
    };
    const handleDeleteChip = (chip, e)=>{
        e.stopPropagation();
        e.preventDefault();
        setInternalValue((prevValues)=>prevValues.filter((value)=>value !== chip));
    };
    const filteredOptions = (()=>{
        let parsedOptions = [];
        if (Array.isArray(options)) parsedOptions = options;
        else if (typeof options === "string") try {
            const parsed = JSON.parse(options);
            if (Array.isArray(parsed)) parsedOptions = parsed;
        } catch (e) {
            // If parsing fails, fallback to an empty array
            parsedOptions = [];
        }
        return parsedOptions.filter((option)=>{
            if (!isSearchEnabled || !searchTerm) return true;
            if (Array.isArray(option.value)) return option.value.some((val)=>val.toLowerCase().includes(searchTerm.toLowerCase()));
            if (typeof option.value === "string") return option.value.toLowerCase().includes(searchTerm.toLowerCase());
            return false;
        });
    })();
    const SelectInputComponent = ()=>/*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)($c98b0135d71b9ff2$var$SelectInput, {
            $shape: {
                font: font
            },
            value: searchTerm,
            onChange: (e)=>setSearchTerm(e.target.value),
            autoFocus: true
        });
    const getTitleFromSelectOptions = (value)=>{
        const parsedVaue = Array.isArray(value) ? value[0] : value;
        const selectedOption = options?.find((option)=>option.id === parsedVaue);
        return selectedOption?.value;
    };
    const PlaceholderSpan = ()=>{
        return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("span", {
            style: (0, $e0d24bf85c947bed$export$2e2bcd8739ae039)({
                font: {
                    ...placeholderStyle
                }
            }),
            children: placeholder
        });
    };
    const handleClick = (e)=>{
        if (activeState === "disabled" || activeState === "loading") {
            e.preventDefault();
            e.stopPropagation();
            return;
        }
        setIsOpen(!isOpen);
    };
    const ChevronDownComponent = ()=>/*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("div", {
            style: {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: 20,
                minWidth: 20
            },
            children: /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $c07e36697bce3a79$export$2e2bcd8739ae039), {})
        });
    if (renderSceleton && style) return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $cefd49c6ff42e132$export$2e2bcd8739ae039), {
        style: style,
        baseScreenResolution: baseScreenResolution,
        skipStates: activeState === "disabled" || activeState === "loading"
    });
    return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsxs)($c98b0135d71b9ff2$var$SelectWrapper, {
        id: `${id}${nestedTable && typeof parentIndex === "number" ? `::${parentIndex}` : ""}`,
        $shape: {
            grid: gridStyle,
            width: width,
            height: height,
            flex: {
                grow: grow,
                shrink: shrink,
                basis: basis
            }
        },
        className: (0, $7b0e169a5380005e$export$189053d41e721fcb)(style.class),
        "data-component": "select",
        ref: selectRef,
        role: "combobox",
        "aria-haspopup": "listbox",
        "aria-expanded": isOpen,
        onMouseEnter: handleHover,
        onMouseLeave: handleUnhover,
        children: [
            /*#__PURE__*/ (0, $02de83db299f7983$exports.jsxs)($c98b0135d71b9ff2$var$SelectButton, {
                $shape: {
                    ...otherStyle,
                    border: border,
                    font: font
                },
                $baseScreenResolution: baseScreenResolution,
                $skipStates: activeState === "disabled" || activeState === "loading",
                onClick: handleClick,
                "aria-haspopup": "true",
                isOpen: isOpen,
                children: [
                    isOpen && isSearchEnabled && !isMultiple && SelectInputComponent(),
                    isMultiple && isSearchEnabled && /*#__PURE__*/ (0, $02de83db299f7983$exports.jsxs)("div", {
                        className: $cd0af89cb2a229cd$export$ff8e94cb38bad9e7,
                        children: [
                            Array.isArray(internalValue) && internalValue?.length ? internalValue?.map((val)=>{
                                const selectedOption = options?.find((option)=>option.id === val);
                                return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsxs)("div", {
                                    className: $cd0af89cb2a229cd$export$f26c97331adc89d5,
                                    children: [
                                        /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("span", {
                                            className: $cd0af89cb2a229cd$export$a1499cbfa2755cde,
                                            children: selectedOption?.value
                                        }),
                                        /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("div", {
                                            className: $cd0af89cb2a229cd$export$5cfb6affd60879e9,
                                            role: "button",
                                            onClick: (e)=>handleDeleteChip(val, e),
                                            children: /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $b08c9de2ff5f2c28$export$2e2bcd8739ae039), {})
                                        })
                                    ]
                                }, val);
                            }) : null,
                            isOpen ? SelectInputComponent() : null,
                            !isOpen && !internalValue?.length ? PlaceholderSpan() : null
                        ]
                    }),
                    isMultiple && !isSearchEnabled && /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("div", {
                        className: $cd0af89cb2a229cd$export$ff8e94cb38bad9e7,
                        children: Array.isArray(internalValue) && internalValue?.length ? internalValue?.map((val)=>{
                            const selectedOption = Array.isArray(options) ? options?.find((option)=>option.id === val) : [];
                            return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsxs)("div", {
                                className: $cd0af89cb2a229cd$export$f26c97331adc89d5,
                                children: [
                                    /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("span", {
                                        className: $cd0af89cb2a229cd$export$a1499cbfa2755cde,
                                        children: selectedOption?.value
                                    }),
                                    /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("div", {
                                        className: $cd0af89cb2a229cd$export$5cfb6affd60879e9,
                                        role: "button",
                                        onClick: (e)=>handleDeleteChip(val, e),
                                        children: /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $b08c9de2ff5f2c28$export$2e2bcd8739ae039), {})
                                    })
                                ]
                            }, val);
                        }) : PlaceholderSpan()
                    }),
                    (!isOpen && !isMultiple || isOpen && !isSearchEnabled && !isMultiple) && /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("span", {
                        style: {
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis"
                        },
                        children: internalValue?.length ? /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("span", {
                            children: getTitleFromSelectOptions(internalValue)
                        }) : PlaceholderSpan()
                    }),
                    !isMultiple && !isSearchEnabled || !internalValue?.length && !isOpen ? ChevronDownComponent() : /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("div", {})
                ]
            }),
            isOpen && /*#__PURE__*/ (0, $9f97ad3b314012cb$exports.createPortal)(/*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)($c98b0135d71b9ff2$var$SelectOptions, {
                $shape: {
                    border: border
                },
                ref: dropdownRef,
                role: "listbox",
                height: position.height,
                top: position.top,
                left: position.left,
                width: position.width,
                children: filteredOptions.map((option)=>/*#__PURE__*/ (0, $02de83db299f7983$exports.jsxs)($c98b0135d71b9ff2$var$SelectOption, {
                        $shape: {
                            ...otherStyle
                        },
                        onClick: (e)=>handleSelect(e, option.id),
                        "aria-selected": internalValue.includes(option.id),
                        isSelected: internalValue.includes(option.id),
                        role: "option",
                        children: [
                            /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("span", {
                                style: {
                                    overflow: "hidden",
                                    whiteSpace: "nowrap",
                                    textOverflow: "ellipsis"
                                },
                                children: option.value
                            }),
                            internalValue.includes(option.id) ? /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("div", {
                                style: {
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    minHeight: 20,
                                    minWidth: 20
                                },
                                children: /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("svg", {
                                    width: "20",
                                    height: "20",
                                    viewBox: "0 0 20 20",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("g", {
                                        id: "check",
                                        children: /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("path", {
                                            id: "Icon",
                                            d: "M16.6668 5L7.50016 14.1667L3.3335 10",
                                            stroke: border?.color || "#7F56D9",
                                            "stroke-width": "1.66667",
                                            "stroke-linecap": "round",
                                            "stroke-linejoin": "round"
                                        })
                                    })
                                })
                            }) : null
                        ]
                    }, option.id))
            }), document.body)
        ]
    });
};
var $c98b0135d71b9ff2$export$2e2bcd8739ae039 = $c98b0135d71b9ff2$var$CombinedSelect;


var $bb9696960a8827ef$export$2e2bcd8739ae039 = (0, $c98b0135d71b9ff2$export$2e2bcd8739ae039);



parcelRequire("aivMx");



const $bc344fbf3bab5269$var$StyledSeparator = (0, $6e03950c2a9b6039$export$2e2bcd8739ae039).div`
  ${(props)=>(0, $e0d24bf85c947bed$export$2e2bcd8739ae039)(props.$shape)}
  /* Add specific styling for the separator */
  z-index: 1;
  border: ${(props)=>props.type === "line" ? "1px solid black" : "none"};
`;
const $bc344fbf3bab5269$var$Separator = ({ id: id, type: type, title: title, style: style })=>/*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)($bc344fbf3bab5269$var$StyledSeparator, {
        id: id,
        type: type,
        $shape: style,
        className: (0, $7b0e169a5380005e$export$189053d41e721fcb)(style.class),
        children: title
    });
var $bc344fbf3bab5269$export$2e2bcd8739ae039 = $bc344fbf3bab5269$var$Separator;


var $3492f55331d0a86f$export$2e2bcd8739ae039 = (0, $bc344fbf3bab5269$export$2e2bcd8739ae039);




var $aivMx = parcelRequire("aivMx");



var $94WEq = parcelRequire("94WEq");

var $g1KQj = parcelRequire("g1KQj");





var $9d2cfd122ae19143$export$b38bf4f33e9e4c25;
var $9d2cfd122ae19143$export$b2e11d516d0a2c5b;
$9d2cfd122ae19143$export$b38bf4f33e9e4c25 = `d2QKNq_slider`;
$9d2cfd122ae19143$export$b2e11d516d0a2c5b = `d2QKNq_toggleSlider`;


const $0a078e346477fb8c$var$StyledToggleContainer = (0, $6e03950c2a9b6039$export$2e2bcd8739ae039).div`
  z-index: 1;
  cursor: pointer;
  position: relative;
  ${(props)=>(0, $e0d24bf85c947bed$export$2e2bcd8739ae039)(props.$shape, props.$baseScreenResolution, props.$skipStates)}
`;
const $0a078e346477fb8c$var$ToggleSlider = ({ id: id, style: stDraft, checked: checked, events: eventsDraft, soc: soc, value: value, pageSettings: pageSettings, dataLake: dataLake, activeState: activeStateDraft, nestedTable: nestedTable, parentIndex: parentIndex, styleChunks: styleChunks, sceleton: renderSceleton })=>{
    const containerRef = (0, $aivMx.useRef)(null);
    const { style: styleDraft, events: events, activeState: activeState } = dataLake?.data ? (0, $7b0e169a5380005e$export$485c71a5d8ecbaad)({
        style: stDraft,
        events: eventsDraft,
        activeState: activeStateDraft
    }, dataLake.data) : {
        style: stDraft,
        events: eventsDraft,
        activeState: activeStateDraft
    };
    const mergeStylesWithChunks = (0, $aivMx.useCallback)((style, chunks, index)=>{
        if (chunks && chunks[id] && chunks[id][index] && typeof index === "number") return (0, (/*@__PURE__*/$parcel$interopDefault($94WEq)))({}, style, chunks[id][index]);
        return style;
    }, [
        id
    ]);
    const variableData = (0, $f40d1f3d995cccef$export$2105062e25df4afe)((0, $79fc67ed759ae65b$export$e3ab06c283dfbb87));
    const localVariableData = (0, $f40d1f3d995cccef$export$2105062e25df4afe)((0, $79fc67ed759ae65b$export$78b26e3ba532c6ce));
    // First useMemo to merge active state styles with base style
    const mergedStyleWithState = (0, $aivMx.useMemo)(()=>{
        let mergedStyle = styleDraft;
        if (activeState && styleDraft?.states?.[activeState]) mergedStyle = (0, (/*@__PURE__*/$parcel$interopDefault($94WEq)))({}, styleDraft, styleDraft.states[activeState]);
        // Handle states in breakpoints
        if (styleDraft?.breakpoints) mergedStyle.breakpoints = Object.entries(styleDraft.breakpoints).reduce((acc, [breakpoint, breakpointStyle])=>{
            const typedBreakpointStyle = breakpointStyle;
            if (typedBreakpointStyle?.states?.[activeState]) acc[breakpoint] = (0, (/*@__PURE__*/$parcel$interopDefault($94WEq)))({}, typedBreakpointStyle, typedBreakpointStyle.states[activeState]);
            else acc[breakpoint] = typedBreakpointStyle;
            return acc;
        }, {});
        return mergedStyle;
    }, [
        styleDraft,
        activeState
    ]);
    // Second useMemo to merge styles with chunks based on parentIndex
    const style = (0, $aivMx.useMemo)(()=>{
        return mergeStylesWithChunks(mergedStyleWithState, styleChunks, parentIndex);
    }, [
        mergedStyleWithState,
        styleChunks,
        parentIndex
    ]);
    const baseScreenResolution = pageSettings?.baseScreenResolution ? (0, $7b0e169a5380005e$export$e58d7eefdadeb732)(pageSettings?.baseScreenResolution) : undefined;
    const { on_change: clickUpdates, on_launch: launchUpdates, on_hover: hoverUpdates, on_unhover: unhoverUpdates, on_outclick: outclickUpdates } = events || {};
    const dispatch = (0, $d023060d48542f4c$export$8ad76b76a4c905f8)();
    const timeoutsRef = (0, $aivMx.useRef)([]);
    const [active, setActive] = (0, $aivMx.useState)(value === "true");
    const internalFns = {
        $setVariable: (key, value)=>{
            dispatch((0, $8eba69c5466928d3$export$36f0c40eded97f9d)({
                variable: key,
                value: value
            }));
        },
        $getVariable: (key)=>{
            const value = (0, $7b0e169a5380005e$export$2516322ffbb7f3fb)(variableData, key) || (0, $7b0e169a5380005e$export$2516322ffbb7f3fb)(localVariableData, key);
            return value;
        },
        $moment: (...args)=>(0, (/*@__PURE__*/$parcel$interopDefault($g1KQj)))(...args)
    };
    const debouncedSubmitForm = (0, $aivMx.useCallback)((0, $7b0e169a5380005e$export$61fc7d43ac8f84b0)(()=>{
        dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
            value: "soc",
            componentId: id
        }));
    }, 500), []);
    const handleToggle = ()=>{
        setActive(!active);
        dispatch((0, $8eba69c5466928d3$export$528cdcbbafe26779)({
            field: {
                id: id,
                value: !active
            }
        }));
        if (soc) debouncedSubmitForm(!active);
    };
    (0, $aivMx.useEffect)(()=>{
        setActive(value === "true");
    }, [
        value
    ]);
    const handleClick = (e)=>{
        if (activeState === "disabled" || activeState === "loading") {
            e.preventDefault();
            e.stopPropagation();
            return;
        }
        handleToggle();
        e.preventDefault();
        if (clickUpdates) {
            e.stopPropagation();
            const styleUpdates = clickUpdates.filter((update)=>"style" in update);
            const requestUpdates = clickUpdates.filter((update)=>"request" in update);
            const functionUpdates = clickUpdates.filter((update)=>"function" in update);
            if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates));
            if (requestUpdates.length) requestUpdates.forEach((update)=>{
                const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                const { delay: delay } = config || {};
                if (update?.request && method === "command") dispatch((0, $8eba69c5466928d3$export$ea176eb1668c7b4b)({
                    location: {
                        pathname: value
                    },
                    silent: silent,
                    componentId: id
                }));
                else if (update?.request && method === "action") dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                    value: value,
                    silent: silent,
                    delay: delay,
                    componentId: id
                }, stDraft?.states?.loading ? id : undefined));
                else if (update?.request && method === "open-url") (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent);
            });
            if (functionUpdates.length) functionUpdates.forEach((update)=>{
                if (update?.function) (0, $7b0e169a5380005e$export$1ed0175478ddd28b)(update.function, e, internalFns);
            });
        }
    };
    const handleHover = (e)=>{
        if (activeState === "disabled" || activeState === "loading") {
            e.stopPropagation();
            e.preventDefault();
            return;
        }
        if (hoverUpdates) {
            const styleUpdates = hoverUpdates.filter((update)=>"style" in update);
            const requestUpdates = hoverUpdates.filter((update)=>"request" in update);
            const functionUpdates = hoverUpdates.filter((update)=>"function" in update);
            if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates));
            if (requestUpdates.length) requestUpdates.forEach((update)=>{
                const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                const { delay: delay } = config || {};
                if (update?.request && method === "action") dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                    value: value,
                    silent: silent,
                    delay: delay,
                    componentId: id
                }, stDraft?.states?.loading ? id : undefined));
                else if (update?.request && method === "open-url") (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent);
            });
            if (functionUpdates.length) functionUpdates.forEach((update)=>{
                if (update?.function) (0, $7b0e169a5380005e$export$1ed0175478ddd28b)(update.function, e, internalFns);
            });
        }
    };
    const handleUnhover = (e)=>{
        if (activeState === "disabled" || activeState === "loading") {
            e.stopPropagation();
            e.preventDefault();
            return;
        }
        if (unhoverUpdates) {
            const styleUpdates = unhoverUpdates.filter((update)=>"style" in update);
            const requestUpdates = unhoverUpdates.filter((update)=>"request" in update);
            const functionUpdates = unhoverUpdates.filter((update)=>"function" in update);
            if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates));
            if (requestUpdates.length) requestUpdates.forEach((update)=>{
                const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                const { delay: delay } = config || {};
                if (update?.request && method === "action") dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                    value: value,
                    silent: silent,
                    delay: delay,
                    componentId: id
                }, stDraft?.states?.loading ? id : undefined));
                else if (update?.request && method === "open-url") (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent);
            });
            if (functionUpdates.length) functionUpdates.forEach((update)=>{
                if (update?.function) (0, $7b0e169a5380005e$export$1ed0175478ddd28b)(update.function, e, internalFns);
            });
        }
    };
    (0, $aivMx.useEffect)(()=>{
        if (launchUpdates && launchUpdates.length) {
            const styleUpdates = launchUpdates.filter((update)=>"style" in update);
            const requestUpdates = launchUpdates.filter((update)=>"request" in update);
            const functionUpdates = launchUpdates.filter((update)=>"function" in update);
            if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates));
            if (requestUpdates.length) requestUpdates.forEach((update)=>{
                const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                const { delay: delay } = config || {};
                if (update?.request && method === "action") ;
                else if (update?.request && method === "open-url") (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent);
            });
            if (functionUpdates.length) functionUpdates.forEach((update)=>{
                if (update?.function) (0, $7b0e169a5380005e$export$1ed0175478ddd28b)(update.function, undefined, internalFns);
            });
        }
        return ()=>{
            timeoutsRef?.current?.forEach((timeout)=>{
                clearTimeout(timeout);
            });
        };
    }, [
        launchUpdates
    ]);
    (0, $aivMx.useEffect)(()=>{
        const handleUnclick = (e)=>{
            if (activeState === "disabled" || activeState === "loading") return;
            if (containerRef.current && !containerRef.current.contains(e.target)) {
                if (outclickUpdates) {
                    const styleUpdates = outclickUpdates.filter((update)=>"style" in update);
                    const requestUpdates = outclickUpdates.filter((update)=>"request" in update);
                    const functionUpdates = outclickUpdates.filter((update)=>"function" in update);
                    if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates, parentIndex));
                    if (requestUpdates.length) requestUpdates.forEach((update)=>{
                        const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                        const { delay: delay } = config || {};
                        if (update?.request && method === "action") dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                            value: value,
                            silent: silent,
                            delay: delay,
                            componentId: id
                        }, stDraft?.states?.loading ? id : undefined));
                        else if (update?.request && method === "open-url") (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent);
                    });
                    if (functionUpdates.length) functionUpdates.forEach((update)=>{
                        if (update?.function) (0, $7b0e169a5380005e$export$1ed0175478ddd28b)(update.function, undefined, internalFns);
                    });
                }
            }
        };
        if (outclickUpdates) {
            document.addEventListener("mousedown", handleUnclick);
            return ()=>{
                document.removeEventListener("mousedown", handleUnclick);
            };
        }
        return undefined;
    }, [
        parentIndex,
        activeState,
        containerRef.current
    ]);
    if (renderSceleton && style) return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $cefd49c6ff42e132$export$2e2bcd8739ae039), {
        style: style,
        baseScreenResolution: baseScreenResolution,
        skipStates: activeState === "disabled" || activeState === "loading"
    });
    return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)($0a078e346477fb8c$var$StyledToggleContainer, {
        ref: containerRef,
        $shape: style,
        $baseScreenResolution: baseScreenResolution,
        $skipStates: activeState === "disabled" || activeState === "loading",
        "data-component": "switcher",
        className: (0, $7b0e169a5380005e$export$189053d41e721fcb)(style.class),
        onClick: handleClick,
        onMouseEnter: handleHover,
        onMouseLeave: handleUnhover,
        children: /*#__PURE__*/ (0, $02de83db299f7983$exports.jsxs)("div", {
            className: $9d2cfd122ae19143$export$b2e11d516d0a2c5b,
            children: [
                /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("input", {
                    type: "checkbox",
                    id: `${id}${nestedTable && typeof parentIndex === "number" ? `::${parentIndex}` : ""}`,
                    checked: active
                }),
                /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("label", {
                    htmlFor: id,
                    className: $9d2cfd122ae19143$export$b38bf4f33e9e4c25
                })
            ]
        })
    });
};
var $0a078e346477fb8c$export$2e2bcd8739ae039 = $0a078e346477fb8c$var$ToggleSlider;


var $f7a8d8148b95e31e$export$2e2bcd8739ae039 = (0, $0a078e346477fb8c$export$2e2bcd8739ae039);




var $aivMx = parcelRequire("aivMx");


var $751e048dd35ac525$exports = {};

$parcel$export($751e048dd35ac525$exports, "version", function () { return $751e048dd35ac525$export$83d89fbfd8236492; }, function (v) { return $751e048dd35ac525$export$83d89fbfd8236492 = v; });
$parcel$export($751e048dd35ac525$exports, "renderToString", function () { return $751e048dd35ac525$export$80e7718417253a51; }, function (v) { return $751e048dd35ac525$export$80e7718417253a51 = v; });
$parcel$export($751e048dd35ac525$exports, "renderToStaticMarkup", function () { return $751e048dd35ac525$export$eb3a06aef9e6ee51; }, function (v) { return $751e048dd35ac525$export$eb3a06aef9e6ee51 = v; });
$parcel$export($751e048dd35ac525$exports, "renderToNodeStream", function () { return $751e048dd35ac525$export$307591e98609eddd; }, function (v) { return $751e048dd35ac525$export$307591e98609eddd = v; });
$parcel$export($751e048dd35ac525$exports, "renderToStaticNodeStream", function () { return $751e048dd35ac525$export$b23711c915539651; }, function (v) { return $751e048dd35ac525$export$b23711c915539651 = v; });
$parcel$export($751e048dd35ac525$exports, "renderToReadableStream", function () { return $751e048dd35ac525$export$7020a3240b287705; }, function (v) { return $751e048dd35ac525$export$7020a3240b287705 = v; });
var $751e048dd35ac525$export$83d89fbfd8236492;
var $751e048dd35ac525$export$80e7718417253a51;
var $751e048dd35ac525$export$eb3a06aef9e6ee51;
var $751e048dd35ac525$export$307591e98609eddd;
var $751e048dd35ac525$export$b23711c915539651;
var $751e048dd35ac525$export$7020a3240b287705;
"use strict";
var $751e048dd35ac525$var$l, $751e048dd35ac525$var$s;

$751e048dd35ac525$var$l = (parcelRequire("anY5p"));

$751e048dd35ac525$var$s = (parcelRequire("3c06z"));
$751e048dd35ac525$export$83d89fbfd8236492 = $751e048dd35ac525$var$l.version;
$751e048dd35ac525$export$80e7718417253a51 = $751e048dd35ac525$var$l.renderToString;
$751e048dd35ac525$export$eb3a06aef9e6ee51 = $751e048dd35ac525$var$l.renderToStaticMarkup;
$751e048dd35ac525$export$307591e98609eddd = $751e048dd35ac525$var$l.renderToNodeStream;
$751e048dd35ac525$export$b23711c915539651 = $751e048dd35ac525$var$l.renderToStaticNodeStream;
$751e048dd35ac525$export$7020a3240b287705 = $751e048dd35ac525$var$s.renderToReadableStream;



var $94WEq = parcelRequire("94WEq");

var $g1KQj = parcelRequire("g1KQj");




var $e9bbf68589d97d54$exports = {};
"use strict";
var $e9bbf68589d97d54$var$__importDefault = $e9bbf68589d97d54$exports && $e9bbf68589d97d54$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($e9bbf68589d97d54$exports, "__esModule", {
    value: true
});
$e9bbf68589d97d54$exports.htmlToDOM = $e9bbf68589d97d54$exports.domToReact = $e9bbf68589d97d54$exports.attributesToProps = $e9bbf68589d97d54$exports.Text = $e9bbf68589d97d54$exports.ProcessingInstruction = $e9bbf68589d97d54$exports.Element = $e9bbf68589d97d54$exports.Comment = void 0;
$e9bbf68589d97d54$exports.default = $e9bbf68589d97d54$var$HTMLReactParser;

var $e9bbf68589d97d54$var$html_dom_parser_1 = $e9bbf68589d97d54$var$__importDefault((parcelRequire("hWFK5")));
$e9bbf68589d97d54$exports.htmlToDOM = $e9bbf68589d97d54$var$html_dom_parser_1.default;

var $e9bbf68589d97d54$var$attributes_to_props_1 = $e9bbf68589d97d54$var$__importDefault((parcelRequire("2FPJE")));
$e9bbf68589d97d54$exports.attributesToProps = $e9bbf68589d97d54$var$attributes_to_props_1.default;

var $e9bbf68589d97d54$var$dom_to_react_1 = $e9bbf68589d97d54$var$__importDefault((parcelRequire("cakMo")));
$e9bbf68589d97d54$exports.domToReact = $e9bbf68589d97d54$var$dom_to_react_1.default;
parcelRequire("1yd5Y");
var $afy9O = parcelRequire("afy9O");
Object.defineProperty($e9bbf68589d97d54$exports, "Comment", {
    enumerable: true,
    get: function() {
        return $afy9O.Comment;
    }
});
Object.defineProperty($e9bbf68589d97d54$exports, "Element", {
    enumerable: true,
    get: function() {
        return $afy9O.Element;
    }
});
Object.defineProperty($e9bbf68589d97d54$exports, "ProcessingInstruction", {
    enumerable: true,
    get: function() {
        return $afy9O.ProcessingInstruction;
    }
});
Object.defineProperty($e9bbf68589d97d54$exports, "Text", {
    enumerable: true,
    get: function() {
        return $afy9O.Text;
    }
});
var $e9bbf68589d97d54$var$domParserOptions = {
    lowerCaseAttributeNames: false
};
/**
 * Converts HTML string to React elements.
 *
 * @param html - HTML string.
 * @param options - Parser options.
 * @returns - React element(s), empty array, or string.
 */ function $e9bbf68589d97d54$var$HTMLReactParser(html, options) {
    if (typeof html !== "string") throw new TypeError("First argument must be a string");
    if (!html) return [];
    return (0, $e9bbf68589d97d54$var$dom_to_react_1.default)((0, $e9bbf68589d97d54$var$html_dom_parser_1.default)(html, (options === null || options === void 0 ? void 0 : options.htmlparser2) || $e9bbf68589d97d54$var$domParserOptions), options);
}


var $0da42676a80638d5$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($e9bbf68589d97d54$exports))).default || (0, (/*@__PURE__*/$parcel$interopDefault($e9bbf68589d97d54$exports)));




var $aivMx = parcelRequire("aivMx");

var $aivMx = parcelRequire("aivMx");
function $8e498fab81f77515$var$n() {
    return $8e498fab81f77515$var$n = Object.assign ? Object.assign.bind() : function(e) {
        for(var n = 1; n < arguments.length; n++){
            var r = arguments[n];
            for(var t in r)Object.prototype.hasOwnProperty.call(r, t) && (e[t] = r[t]);
        }
        return e;
    }, $8e498fab81f77515$var$n.apply(this, arguments);
}
var $8e498fab81f77515$export$e0aa44767d8750d5, $8e498fab81f77515$var$t, $8e498fab81f77515$var$i = [
    "children",
    "options"
];
!function(e) {
    e.blockQuote = "0", e.breakLine = "1", e.breakThematic = "2", e.codeBlock = "3", e.codeFenced = "4", e.codeInline = "5", e.footnote = "6", e.footnoteReference = "7", e.gfmTask = "8", e.heading = "9", e.headingSetext = "10", e.htmlBlock = "11", e.htmlComment = "12", e.htmlSelfClosing = "13", e.image = "14", e.link = "15", e.linkAngleBraceStyleDetector = "16", e.linkBareUrlDetector = "17", e.linkMailtoDetector = "18", e.newlineCoalescer = "19", e.orderedList = "20", e.paragraph = "21", e.ref = "22", e.refImage = "23", e.refLink = "24", e.table = "25", e.tableSeparator = "26", e.text = "27", e.textBolded = "28", e.textEmphasized = "29", e.textEscaped = "30", e.textMarked = "31", e.textStrikethroughed = "32", e.unorderedList = "33";
}($8e498fab81f77515$export$e0aa44767d8750d5 || ($8e498fab81f77515$export$e0aa44767d8750d5 = {})), function(e) {
    e[e.MAX = 0] = "MAX", e[e.HIGH = 1] = "HIGH", e[e.MED = 2] = "MED", e[e.LOW = 3] = "LOW", e[e.MIN = 4] = "MIN";
}($8e498fab81f77515$var$t || ($8e498fab81f77515$var$t = {}));
var $8e498fab81f77515$var$a = [
    "allowFullScreen",
    "allowTransparency",
    "autoComplete",
    "autoFocus",
    "autoPlay",
    "cellPadding",
    "cellSpacing",
    "charSet",
    "className",
    "classId",
    "colSpan",
    "contentEditable",
    "contextMenu",
    "crossOrigin",
    "encType",
    "formAction",
    "formEncType",
    "formMethod",
    "formNoValidate",
    "formTarget",
    "frameBorder",
    "hrefLang",
    "inputMode",
    "keyParams",
    "keyType",
    "marginHeight",
    "marginWidth",
    "maxLength",
    "mediaGroup",
    "minLength",
    "noValidate",
    "radioGroup",
    "readOnly",
    "rowSpan",
    "spellCheck",
    "srcDoc",
    "srcLang",
    "srcSet",
    "tabIndex",
    "useMap"
].reduce(function(e, n) {
    return e[n.toLowerCase()] = n, e;
}, {
    for: "htmlFor"
}), $8e498fab81f77515$var$c = {
    amp: "&",
    apos: "'",
    gt: ">",
    lt: "<",
    nbsp: "\xa0",
    quot: "“"
}, $8e498fab81f77515$var$o = [
    "style",
    "script"
], $8e498fab81f77515$var$l = /([-A-Z0-9_:]+)(?:\s*=\s*(?:(?:"((?:\\.|[^"])*)")|(?:'((?:\\.|[^'])*)')|(?:\{((?:\\.|{[^}]*?}|[^}])*)\})))?/gi, $8e498fab81f77515$var$u = /mailto:/i, $8e498fab81f77515$var$s = /\n{2,}$/, $8e498fab81f77515$var$f = /^( *>[^\n]+(\n[^\n]+)*\n*)+\n{2,}/, $8e498fab81f77515$var$d = /^ *> ?/gm, $8e498fab81f77515$var$p = /^ {2,}\n/, $8e498fab81f77515$var$h = /^(?:( *[-*_])){3,} *(?:\n *)+\n/, $8e498fab81f77515$var$m = /^\s*(`{3,}|~{3,}) *(\S+)?([^\n]*?)?\n([\s\S]+?)\s*\1 *(?:\n *)*\n?/, $8e498fab81f77515$var$g = /^(?: {4}[^\n]+\n*)+(?:\n *)+\n?/, $8e498fab81f77515$var$y = /^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/, $8e498fab81f77515$var$k = /^(?:\n *)*\n/, $8e498fab81f77515$var$v = /\r\n?/g, $8e498fab81f77515$var$x = /^\[\^([^\]]+)](:.*)\n/, $8e498fab81f77515$var$b = /^\[\^([^\]]+)]/, $8e498fab81f77515$var$S = /\f/g, $8e498fab81f77515$var$w = /^---[ \t]*\n(.|\n)*\n---[ \t]*\n/, $8e498fab81f77515$var$C = /^\s*?\[(x|\s)\]/, $8e498fab81f77515$var$E = /^ *(#{1,6}) *([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $8e498fab81f77515$var$$ = /^ *(#{1,6}) +([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $8e498fab81f77515$var$A = /^([^\n]+)\n *(=|-){3,} *(?:\n *)+\n/, $8e498fab81f77515$var$O = /^ *(?!<[a-z][^ >/]* ?\/>)<([a-z][^ >/]*) ?([^>]*)\/{0}>\n?(\s*(?:<\1[^>]*?>[\s\S]*?<\/\1>|(?!<\1)[\s\S])*?)<\/\1>\n*/i, $8e498fab81f77515$var$T = /&([a-z0-9]+|#[0-9]{1,6}|#x[0-9a-fA-F]{1,6});/gi, $8e498fab81f77515$var$L = /^<!--[\s\S]*?(?:-->)/, $8e498fab81f77515$var$z = /^(data|aria|x)-[a-z_][a-z\d_.-]*$/, $8e498fab81f77515$var$M = /^ *<([a-z][a-z0-9:]*)(?:\s+((?:<.*?>|[^>])*))?\/?>(?!<\/\1>)(\s*\n)?/i, $8e498fab81f77515$var$I = /^\{.*\}$/, $8e498fab81f77515$var$R = /^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/, $8e498fab81f77515$var$U = /^<([^ >]+@[^ >]+)>/, $8e498fab81f77515$var$j = /^<([^ >]+:\/[^ >]+)>/, $8e498fab81f77515$var$B = /-([a-z])?/gi, $8e498fab81f77515$var$N = /^(.*\|?.*)\n *(\|? *[-:]+ *\|[-| :]*)\n((?:.*\|.*\n)*)\n?/, $8e498fab81f77515$var$H = /^\[([^\]]*)\]:\s+<?([^\s>]+)>?\s*("([^"]*)")?/, $8e498fab81f77515$var$D = /^!\[([^\]]*)\] ?\[([^\]]*)\]/, $8e498fab81f77515$var$P = /^\[([^\]]*)\] ?\[([^\]]*)\]/, $8e498fab81f77515$var$_ = /(\[|\])/g, $8e498fab81f77515$var$F = /(\n|^[-*]\s|^#|^ {2,}|^-{2,}|^>\s)/, $8e498fab81f77515$var$W = /\t/g, $8e498fab81f77515$var$G = /^ *\| */, $8e498fab81f77515$var$Z = /(^ *\||\| *$)/g, $8e498fab81f77515$var$q = / *$/, $8e498fab81f77515$var$V = /^ *:-+: *$/, $8e498fab81f77515$var$X = /^ *:-+ *$/, $8e498fab81f77515$var$Q = /^ *-+: *$/, $8e498fab81f77515$var$J = /^([*_])\1((?:\[.*?\][([].*?[)\]]|<.*?>(?:.*?<.*?>)?|`.*?`|~+.*?~+|.)*?)\1\1(?!\1)/, $8e498fab81f77515$var$K = /^([*_])((?:\[.*?\][([].*?[)\]]|<.*?>(?:.*?<.*?>)?|`.*?`|~+.*?~+|.)*?)\1(?!\1|\w)/, $8e498fab81f77515$var$Y = /^==((?:\[.*?\]|<.*?>(?:.*?<.*?>)?|`.*?`|.)*?)==/, $8e498fab81f77515$var$ee = /^~~((?:\[.*?\]|<.*?>(?:.*?<.*?>)?|`.*?`|.)*?)~~/, $8e498fab81f77515$var$ne = /^\\([^0-9A-Za-z\s])/, $8e498fab81f77515$var$re = /^[\s\S]+?(?=[^0-9A-Z\s\u00c0-\uffff&#;.()'"]|\d+\.|\n\n| {2,}\n|\w+:\S|$)/i, $8e498fab81f77515$var$te = /^\n+/, $8e498fab81f77515$var$ie = /^([ \t]*)/, $8e498fab81f77515$var$ae = /\\([^\\])/g, $8e498fab81f77515$var$ce = / *\n+$/, $8e498fab81f77515$var$oe = /(?:^|\n)( *)$/, $8e498fab81f77515$var$le = "(?:\\d+\\.)", $8e498fab81f77515$var$ue = "(?:[*+-])";
function $8e498fab81f77515$var$se(e) {
    return "( *)(" + (1 === e ? $8e498fab81f77515$var$le : $8e498fab81f77515$var$ue) + ") +";
}
var $8e498fab81f77515$var$fe = $8e498fab81f77515$var$se(1), $8e498fab81f77515$var$de = $8e498fab81f77515$var$se(2);
function $8e498fab81f77515$var$pe(e) {
    return new RegExp("^" + (1 === e ? $8e498fab81f77515$var$fe : $8e498fab81f77515$var$de));
}
var $8e498fab81f77515$var$he = $8e498fab81f77515$var$pe(1), $8e498fab81f77515$var$me = $8e498fab81f77515$var$pe(2);
function $8e498fab81f77515$var$ge(e) {
    return new RegExp("^" + (1 === e ? $8e498fab81f77515$var$fe : $8e498fab81f77515$var$de) + "[^\\n]*(?:\\n(?!\\1" + (1 === e ? $8e498fab81f77515$var$le : $8e498fab81f77515$var$ue) + " )[^\\n]*)*(\\n|$)", "gm");
}
var $8e498fab81f77515$var$ye = $8e498fab81f77515$var$ge(1), $8e498fab81f77515$var$ke = $8e498fab81f77515$var$ge(2);
function $8e498fab81f77515$var$ve(e) {
    var n = 1 === e ? $8e498fab81f77515$var$le : $8e498fab81f77515$var$ue;
    return new RegExp("^( *)(" + n + ") [\\s\\S]+?(?:\\n{2,}(?! )(?!\\1" + n + " (?!" + n + " ))\\n*|\\s*\\n*$)");
}
var $8e498fab81f77515$var$xe = $8e498fab81f77515$var$ve(1), $8e498fab81f77515$var$be = $8e498fab81f77515$var$ve(2);
function $8e498fab81f77515$var$Se(e, n) {
    var r = 1 === n, t = r ? $8e498fab81f77515$var$xe : $8e498fab81f77515$var$be, i = r ? $8e498fab81f77515$var$ye : $8e498fab81f77515$var$ke, a = r ? $8e498fab81f77515$var$he : $8e498fab81f77515$var$me;
    return {
        match: function(e, n, r) {
            var i = $8e498fab81f77515$var$oe.exec(r);
            return i && (n.list || !n.inline && !n.simple) ? t.exec(e = i[1] + e) : null;
        },
        order: 1,
        parse: function(e, n, t) {
            var c = r ? +e[2] : void 0, o = e[0].replace($8e498fab81f77515$var$s, "\n").match(i), l = !1;
            return {
                items: o.map(function(e, r) {
                    var i = a.exec(e)[0].length, c = new RegExp("^ {1," + i + "}", "gm"), u = e.replace(c, "").replace(a, ""), s = r === o.length - 1, f = -1 !== u.indexOf("\n\n") || s && l;
                    l = f;
                    var d, p = t.inline, h = t.list;
                    t.list = !0, f ? (t.inline = !1, d = u.replace($8e498fab81f77515$var$ce, "\n\n")) : (t.inline = !0, d = u.replace($8e498fab81f77515$var$ce, ""));
                    var m = n(d, t);
                    return t.inline = p, t.list = h, m;
                }),
                ordered: r,
                start: c
            };
        },
        render: function(n, r, t) {
            return e(n.ordered ? "ol" : "ul", {
                key: t.key,
                start: "20" === n.type ? n.start : void 0
            }, n.items.map(function(n, i) {
                return e("li", {
                    key: i
                }, r(n, t));
            }));
        }
    };
}
var $8e498fab81f77515$var$we = /^\[([^\]]*)]\( *((?:\([^)]*\)|[^() ])*) *"?([^)"]*)?"?\)/, $8e498fab81f77515$var$Ce = /^!\[([^\]]*)]\( *((?:\([^)]*\)|[^() ])*) *"?([^)"]*)?"?\)/, $8e498fab81f77515$var$Ee = [
    $8e498fab81f77515$var$f,
    $8e498fab81f77515$var$m,
    $8e498fab81f77515$var$g,
    $8e498fab81f77515$var$E,
    $8e498fab81f77515$var$A,
    $8e498fab81f77515$var$$,
    $8e498fab81f77515$var$L,
    $8e498fab81f77515$var$N,
    $8e498fab81f77515$var$ye,
    $8e498fab81f77515$var$xe,
    $8e498fab81f77515$var$ke,
    $8e498fab81f77515$var$be
], $8e498fab81f77515$var$$e = [].concat($8e498fab81f77515$var$Ee, [
    /^[^\n]+(?:  \n|\n{2,})/,
    $8e498fab81f77515$var$O,
    $8e498fab81f77515$var$M
]);
function $8e498fab81f77515$var$Ae(e) {
    return e.replace(/[ÀÁÂÃÄÅàáâãäåæÆ]/g, "a").replace(/[çÇ]/g, "c").replace(/[ðÐ]/g, "d").replace(/[ÈÉÊËéèêë]/g, "e").replace(/[ÏïÎîÍíÌì]/g, "i").replace(/[Ññ]/g, "n").replace(/[øØœŒÕõÔôÓóÒò]/g, "o").replace(/[ÜüÛûÚúÙù]/g, "u").replace(/[ŸÿÝý]/g, "y").replace(/[^a-z0-9- ]/gi, "").replace(/ /gi, "-").toLowerCase();
}
function $8e498fab81f77515$var$Oe(e) {
    return $8e498fab81f77515$var$Q.test(e) ? "right" : $8e498fab81f77515$var$V.test(e) ? "center" : $8e498fab81f77515$var$X.test(e) ? "left" : null;
}
function $8e498fab81f77515$var$Te(e, n, r) {
    var t = r.inTable;
    r.inTable = !0;
    var i = n(e.trim(), r);
    r.inTable = t;
    var a = [
        []
    ];
    return i.forEach(function(e, n) {
        "26" === e.type ? 0 !== n && n !== i.length - 1 && a.push([]) : ("27" !== e.type || null != i[n + 1] && "26" !== i[n + 1].type || (e.text = e.text.replace($8e498fab81f77515$var$q, "")), a[a.length - 1].push(e));
    }), a;
}
function $8e498fab81f77515$var$Le(e, n, r) {
    r.inline = !0;
    var t = $8e498fab81f77515$var$Te(e[1], n, r), i = e[2].replace($8e498fab81f77515$var$Z, "").split("|").map($8e498fab81f77515$var$Oe), a = function(e, n, r) {
        return e.trim().split("\n").map(function(e) {
            return $8e498fab81f77515$var$Te(e, n, r);
        });
    }(e[3], n, r);
    return r.inline = !1, {
        align: i,
        cells: a,
        header: t,
        type: "25"
    };
}
function $8e498fab81f77515$var$ze(e, n) {
    return null == e.align[n] ? {} : {
        textAlign: e.align[n]
    };
}
function $8e498fab81f77515$var$Me(e) {
    return function(n, r) {
        return r.inline ? e.exec(n) : null;
    };
}
function $8e498fab81f77515$var$Ie(e) {
    return function(n, r) {
        return r.inline || r.simple ? e.exec(n) : null;
    };
}
function $8e498fab81f77515$var$Re(e) {
    return function(n, r) {
        return r.inline || r.simple ? null : e.exec(n);
    };
}
function $8e498fab81f77515$var$Ue(e) {
    return function(n) {
        return e.exec(n);
    };
}
function $8e498fab81f77515$var$je(e, n, r) {
    if (n.inline || n.simple) return null;
    if (r && !r.endsWith("\n")) return null;
    var t = "";
    e.split("\n").every(function(e) {
        return !$8e498fab81f77515$var$Ee.some(function(n) {
            return n.test(e);
        }) && (t += e + "\n", e.trim());
    });
    var i = t.trimEnd();
    return "" == i ? null : [
        t,
        i
    ];
}
function $8e498fab81f77515$var$Be(e) {
    try {
        if (decodeURIComponent(e).replace(/[^A-Za-z0-9/:]/g, "").match(/^\s*(javascript|vbscript|data(?!:image)):/i)) return;
    } catch (e) {
        return null;
    }
    return e;
}
function $8e498fab81f77515$var$Ne(e) {
    return e.replace($8e498fab81f77515$var$ae, "$1");
}
function $8e498fab81f77515$var$He(e, n, r) {
    var t = r.inline || !1, i = r.simple || !1;
    r.inline = !0, r.simple = !0;
    var a = e(n, r);
    return r.inline = t, r.simple = i, a;
}
function $8e498fab81f77515$var$De(e, n, r) {
    var t = r.inline || !1, i = r.simple || !1;
    r.inline = !1, r.simple = !0;
    var a = e(n, r);
    return r.inline = t, r.simple = i, a;
}
function $8e498fab81f77515$var$Pe(e, n, r) {
    return r.inline = !1, e(n, r);
}
var $8e498fab81f77515$var$_e = function(e, n, r) {
    return {
        children: $8e498fab81f77515$var$He(n, e[1], r)
    };
};
function $8e498fab81f77515$var$Fe() {
    return {};
}
function $8e498fab81f77515$var$We() {
    return null;
}
function $8e498fab81f77515$var$Ge() {
    return [].slice.call(arguments).filter(Boolean).join(" ");
}
function $8e498fab81f77515$var$Ze(e, n, r) {
    for(var t = e, i = n.split("."); i.length && void 0 !== (t = t[i[0]]);)i.shift();
    return t || r;
}
function $8e498fab81f77515$var$qe(e, n) {
    var r = $8e498fab81f77515$var$Ze(n, e);
    return r ? "function" == typeof r || "object" == typeof r && "render" in r ? r : $8e498fab81f77515$var$Ze(n, e + ".component", e) : e;
}
function $8e498fab81f77515$export$69f434acfbdb0b32(r, t) {
    var i;
    void 0 === t && (t = {}), t.overrides = t.overrides || {}, t.slugify = t.slugify || $8e498fab81f77515$var$Ae, t.namedCodesToUnicode = t.namedCodesToUnicode ? $8e498fab81f77515$var$n({}, $8e498fab81f77515$var$c, t.namedCodesToUnicode) : $8e498fab81f77515$var$c;
    var s = t.createElement || $aivMx.createElement;
    function Z(e, r) {
        var i = $8e498fab81f77515$var$Ze(t.overrides, e + ".props", {});
        return s.apply(void 0, [
            $8e498fab81f77515$var$qe(e, t.overrides),
            $8e498fab81f77515$var$n({}, r, i, {
                className: $8e498fab81f77515$var$Ge(null == r ? void 0 : r.className, i.className) || void 0
            })
        ].concat([].slice.call(arguments, 2)));
    }
    function q(n) {
        n = n.replace($8e498fab81f77515$var$w, "");
        var r = !1;
        t.forceInline ? r = !0 : t.forceBlock || (r = !1 === $8e498fab81f77515$var$F.test(n));
        for(var i = le(oe(r ? n : n.trimEnd().replace($8e498fab81f77515$var$te, "") + "\n\n", {
            inline: r
        })); "string" == typeof i[i.length - 1] && !i[i.length - 1].trim();)i.pop();
        if (null === t.wrapper) return i;
        var a, c = t.wrapper || (r ? "span" : "div");
        if (i.length > 1 || t.forceWrapper) a = i;
        else {
            if (1 === i.length) return "string" == typeof (a = i[0]) ? Z("span", {
                key: "outer"
            }, a) : a;
            a = null;
        }
        return $aivMx.createElement(c, {
            key: "outer"
        }, a);
    }
    function V(n) {
        var r = n.match($8e498fab81f77515$var$l);
        return r ? r.reduce(function(n, r, t) {
            var i = r.indexOf("=");
            if (-1 !== i) {
                var c = (function(e) {
                    return -1 !== e.indexOf("-") && null === e.match($8e498fab81f77515$var$z) && (e = e.replace($8e498fab81f77515$var$B, function(e, n) {
                        return n.toUpperCase();
                    })), e;
                })(r.slice(0, i)).trim(), o = function(e) {
                    var n = e[0];
                    return ('"' === n || "'" === n) && e.length >= 2 && e[e.length - 1] === n ? e.slice(1, -1) : e;
                }(r.slice(i + 1).trim()), l = $8e498fab81f77515$var$a[c] || c, u = n[l] = function(e, n) {
                    return "style" === e ? n.split(/;\s?/).reduce(function(e, n) {
                        var r = n.slice(0, n.indexOf(":"));
                        return e[r.replace(/(-[a-z])/g, function(e) {
                            return e[1].toUpperCase();
                        })] = n.slice(r.length + 1).trim(), e;
                    }, {}) : "href" === e || "src" === e ? $8e498fab81f77515$var$Be(n) : (n.match($8e498fab81f77515$var$I) && (n = n.slice(1, n.length - 1)), "true" === n || "false" !== n && n);
                }(c, o);
                "string" == typeof u && ($8e498fab81f77515$var$O.test(u) || $8e498fab81f77515$var$M.test(u)) && (n[l] = $aivMx.cloneElement(q(u.trim()), {
                    key: t
                }));
            } else "style" !== r && (n[$8e498fab81f77515$var$a[r] || r] = !0);
            return n;
        }, {}) : null;
    }
    var X = [], Q = {}, ae = ((i = {})[0] = {
        match: $8e498fab81f77515$var$Re($8e498fab81f77515$var$f),
        order: 1,
        parse: function(e, n, r) {
            return {
                children: n(e[0].replace($8e498fab81f77515$var$d, ""), r)
            };
        },
        render: function(e, n, r) {
            return Z("blockquote", {
                key: r.key
            }, n(e.children, r));
        }
    }, i[1] = {
        match: $8e498fab81f77515$var$Ue($8e498fab81f77515$var$p),
        order: 1,
        parse: $8e498fab81f77515$var$Fe,
        render: function(e, n, r) {
            return Z("br", {
                key: r.key
            });
        }
    }, i[2] = {
        match: $8e498fab81f77515$var$Re($8e498fab81f77515$var$h),
        order: 1,
        parse: $8e498fab81f77515$var$Fe,
        render: function(e, n, r) {
            return Z("hr", {
                key: r.key
            });
        }
    }, i[3] = {
        match: $8e498fab81f77515$var$Re($8e498fab81f77515$var$g),
        order: 0,
        parse: function(e) {
            return {
                lang: void 0,
                text: e[0].replace(/^ {4}/gm, "").replace(/\n+$/, "")
            };
        },
        render: function(e, r, t) {
            return Z("pre", {
                key: t.key
            }, Z("code", $8e498fab81f77515$var$n({}, e.attrs, {
                className: e.lang ? "lang-" + e.lang : ""
            }), e.text));
        }
    }, i[4] = {
        match: $8e498fab81f77515$var$Re($8e498fab81f77515$var$m),
        order: 0,
        parse: function(e) {
            return {
                attrs: V(e[3] || ""),
                lang: e[2] || void 0,
                text: e[4],
                type: "3"
            };
        }
    }, i[5] = {
        match: $8e498fab81f77515$var$Ie($8e498fab81f77515$var$y),
        order: 3,
        parse: function(e) {
            return {
                text: e[2]
            };
        },
        render: function(e, n, r) {
            return Z("code", {
                key: r.key
            }, e.text);
        }
    }, i[6] = {
        match: $8e498fab81f77515$var$Re($8e498fab81f77515$var$x),
        order: 0,
        parse: function(e) {
            return X.push({
                footnote: e[2],
                identifier: e[1]
            }), {};
        },
        render: $8e498fab81f77515$var$We
    }, i[7] = {
        match: $8e498fab81f77515$var$Me($8e498fab81f77515$var$b),
        order: 1,
        parse: function(e) {
            return {
                target: "#" + t.slugify(e[1]),
                text: e[1]
            };
        },
        render: function(e, n, r) {
            return Z("a", {
                key: r.key,
                href: $8e498fab81f77515$var$Be(e.target)
            }, Z("sup", {
                key: r.key
            }, e.text));
        }
    }, i[8] = {
        match: $8e498fab81f77515$var$Me($8e498fab81f77515$var$C),
        order: 1,
        parse: function(e) {
            return {
                completed: "x" === e[1].toLowerCase()
            };
        },
        render: function(e, n, r) {
            return Z("input", {
                checked: e.completed,
                key: r.key,
                readOnly: !0,
                type: "checkbox"
            });
        }
    }, i[9] = {
        match: $8e498fab81f77515$var$Re(t.enforceAtxHeadings ? $8e498fab81f77515$var$$ : $8e498fab81f77515$var$E),
        order: 1,
        parse: function(e, n, r) {
            return {
                children: $8e498fab81f77515$var$He(n, e[2], r),
                id: t.slugify(e[2]),
                level: e[1].length
            };
        },
        render: function(e, n, r) {
            return Z("h" + e.level, {
                id: e.id,
                key: r.key
            }, n(e.children, r));
        }
    }, i[10] = {
        match: $8e498fab81f77515$var$Re($8e498fab81f77515$var$A),
        order: 0,
        parse: function(e, n, r) {
            return {
                children: $8e498fab81f77515$var$He(n, e[1], r),
                level: "=" === e[2] ? 1 : 2,
                type: "9"
            };
        }
    }, i[11] = {
        match: $8e498fab81f77515$var$Ue($8e498fab81f77515$var$O),
        order: 1,
        parse: function(e, n, r) {
            var t, i = e[3].match($8e498fab81f77515$var$ie), a = new RegExp("^" + i[1], "gm"), c = e[3].replace(a, ""), l = (t = c, $8e498fab81f77515$var$$e.some(function(e) {
                return e.test(t);
            }) ? $8e498fab81f77515$var$Pe : $8e498fab81f77515$var$He), u = e[1].toLowerCase(), s = -1 !== $8e498fab81f77515$var$o.indexOf(u), f = {
                attrs: V(e[2]),
                noInnerParse: s,
                tag: s ? u : e[1]
            };
            return r.inAnchor = r.inAnchor || "a" === u, s ? f.text = e[3] : f.children = l(n, c, r), r.inAnchor = !1, f;
        },
        render: function(e, r, t) {
            return Z(e.tag, $8e498fab81f77515$var$n({
                key: t.key
            }, e.attrs), e.text || r(e.children, t));
        }
    }, i[13] = {
        match: $8e498fab81f77515$var$Ue($8e498fab81f77515$var$M),
        order: 1,
        parse: function(e) {
            return {
                attrs: V(e[2] || ""),
                tag: e[1]
            };
        },
        render: function(e, r, t) {
            return Z(e.tag, $8e498fab81f77515$var$n({}, e.attrs, {
                key: t.key
            }));
        }
    }, i[12] = {
        match: $8e498fab81f77515$var$Ue($8e498fab81f77515$var$L),
        order: 1,
        parse: function() {
            return {};
        },
        render: $8e498fab81f77515$var$We
    }, i[14] = {
        match: $8e498fab81f77515$var$Ie($8e498fab81f77515$var$Ce),
        order: 1,
        parse: function(e) {
            return {
                alt: e[1],
                target: $8e498fab81f77515$var$Ne(e[2]),
                title: e[3]
            };
        },
        render: function(e, n, r) {
            return Z("img", {
                key: r.key,
                alt: e.alt || void 0,
                title: e.title || void 0,
                src: $8e498fab81f77515$var$Be(e.target)
            });
        }
    }, i[15] = {
        match: $8e498fab81f77515$var$Me($8e498fab81f77515$var$we),
        order: 3,
        parse: function(e, n, r) {
            return {
                children: $8e498fab81f77515$var$De(n, e[1], r),
                target: $8e498fab81f77515$var$Ne(e[2]),
                title: e[3]
            };
        },
        render: function(e, n, r) {
            return Z("a", {
                key: r.key,
                href: $8e498fab81f77515$var$Be(e.target),
                title: e.title
            }, n(e.children, r));
        }
    }, i[16] = {
        match: $8e498fab81f77515$var$Me($8e498fab81f77515$var$j),
        order: 0,
        parse: function(e) {
            return {
                children: [
                    {
                        text: e[1],
                        type: "27"
                    }
                ],
                target: e[1],
                type: "15"
            };
        }
    }, i[17] = {
        match: function(e, n) {
            return n.inAnchor ? null : $8e498fab81f77515$var$Me($8e498fab81f77515$var$R)(e, n);
        },
        order: 0,
        parse: function(e) {
            return {
                children: [
                    {
                        text: e[1],
                        type: "27"
                    }
                ],
                target: e[1],
                title: void 0,
                type: "15"
            };
        }
    }, i[18] = {
        match: $8e498fab81f77515$var$Me($8e498fab81f77515$var$U),
        order: 0,
        parse: function(e) {
            var n = e[1], r = e[1];
            return $8e498fab81f77515$var$u.test(r) || (r = "mailto:" + r), {
                children: [
                    {
                        text: n.replace("mailto:", ""),
                        type: "27"
                    }
                ],
                target: r,
                type: "15"
            };
        }
    }, i[20] = $8e498fab81f77515$var$Se(Z, 1), i[33] = $8e498fab81f77515$var$Se(Z, 2), i[19] = {
        match: $8e498fab81f77515$var$Re($8e498fab81f77515$var$k),
        order: 3,
        parse: $8e498fab81f77515$var$Fe,
        render: function() {
            return "\n";
        }
    }, i[21] = {
        match: $8e498fab81f77515$var$je,
        order: 3,
        parse: $8e498fab81f77515$var$_e,
        render: function(e, n, r) {
            return Z("p", {
                key: r.key
            }, n(e.children, r));
        }
    }, i[22] = {
        match: $8e498fab81f77515$var$Me($8e498fab81f77515$var$H),
        order: 0,
        parse: function(e) {
            return Q[e[1]] = {
                target: e[2],
                title: e[4]
            }, {};
        },
        render: $8e498fab81f77515$var$We
    }, i[23] = {
        match: $8e498fab81f77515$var$Ie($8e498fab81f77515$var$D),
        order: 0,
        parse: function(e) {
            return {
                alt: e[1] || void 0,
                ref: e[2]
            };
        },
        render: function(e, n, r) {
            return Z("img", {
                key: r.key,
                alt: e.alt,
                src: $8e498fab81f77515$var$Be(Q[e.ref].target),
                title: Q[e.ref].title
            });
        }
    }, i[24] = {
        match: $8e498fab81f77515$var$Me($8e498fab81f77515$var$P),
        order: 0,
        parse: function(e, n, r) {
            return {
                children: n(e[1], r),
                fallbackChildren: n(e[0].replace($8e498fab81f77515$var$_, "\\$1"), r),
                ref: e[2]
            };
        },
        render: function(e, n, r) {
            return Q[e.ref] ? Z("a", {
                key: r.key,
                href: $8e498fab81f77515$var$Be(Q[e.ref].target),
                title: Q[e.ref].title
            }, n(e.children, r)) : Z("span", {
                key: r.key
            }, n(e.fallbackChildren, r));
        }
    }, i[25] = {
        match: $8e498fab81f77515$var$Re($8e498fab81f77515$var$N),
        order: 1,
        parse: $8e498fab81f77515$var$Le,
        render: function(e, n, r) {
            return Z("table", {
                key: r.key
            }, Z("thead", null, Z("tr", null, e.header.map(function(t, i) {
                return Z("th", {
                    key: i,
                    style: $8e498fab81f77515$var$ze(e, i)
                }, n(t, r));
            }))), Z("tbody", null, e.cells.map(function(t, i) {
                return Z("tr", {
                    key: i
                }, t.map(function(t, i) {
                    return Z("td", {
                        key: i,
                        style: $8e498fab81f77515$var$ze(e, i)
                    }, n(t, r));
                }));
            })));
        }
    }, i[26] = {
        match: function(e, n) {
            return n.inTable ? (n.inline = !0, $8e498fab81f77515$var$G.exec(e)) : null;
        },
        order: 1,
        parse: function() {
            return {
                type: "26"
            };
        },
        render: function() {
            return " | ";
        }
    }, i[27] = {
        match: $8e498fab81f77515$var$Ue($8e498fab81f77515$var$re),
        order: 4,
        parse: function(e) {
            return {
                text: e[0].replace($8e498fab81f77515$var$T, function(e, n) {
                    return t.namedCodesToUnicode[n] ? t.namedCodesToUnicode[n] : e;
                })
            };
        },
        render: function(e) {
            return e.text;
        }
    }, i[28] = {
        match: $8e498fab81f77515$var$Ie($8e498fab81f77515$var$J),
        order: 2,
        parse: function(e, n, r) {
            return {
                children: n(e[2], r)
            };
        },
        render: function(e, n, r) {
            return Z("strong", {
                key: r.key
            }, n(e.children, r));
        }
    }, i[29] = {
        match: $8e498fab81f77515$var$Ie($8e498fab81f77515$var$K),
        order: 3,
        parse: function(e, n, r) {
            return {
                children: n(e[2], r)
            };
        },
        render: function(e, n, r) {
            return Z("em", {
                key: r.key
            }, n(e.children, r));
        }
    }, i[30] = {
        match: $8e498fab81f77515$var$Ie($8e498fab81f77515$var$ne),
        order: 1,
        parse: function(e) {
            return {
                text: e[1],
                type: "27"
            };
        }
    }, i[31] = {
        match: $8e498fab81f77515$var$Ie($8e498fab81f77515$var$Y),
        order: 3,
        parse: $8e498fab81f77515$var$_e,
        render: function(e, n, r) {
            return Z("mark", {
                key: r.key
            }, n(e.children, r));
        }
    }, i[32] = {
        match: $8e498fab81f77515$var$Ie($8e498fab81f77515$var$ee),
        order: 3,
        parse: $8e498fab81f77515$var$_e,
        render: function(e, n, r) {
            return Z("del", {
                key: r.key
            }, n(e.children, r));
        }
    }, i);
    !0 === t.disableParsingRawHTML && (delete ae[11], delete ae[13]);
    var ce, oe = function(e) {
        var n = Object.keys(e);
        function r(t, i) {
            for(var a = [], c = ""; t;)for(var o = 0; o < n.length;){
                var l = n[o], u = e[l], s = u.match(t, i, c);
                if (s) {
                    var f = s[0];
                    t = t.substring(f.length);
                    var d = u.parse(s, r, i);
                    null == d.type && (d.type = l), a.push(d), c = f;
                    break;
                }
                o++;
            }
            return a;
        }
        return n.sort(function(n, r) {
            var t = e[n].order, i = e[r].order;
            return t !== i ? t - i : n < r ? -1 : 1;
        }), function(e, n) {
            return r(function(e) {
                return e.replace($8e498fab81f77515$var$v, "\n").replace($8e498fab81f77515$var$S, "").replace($8e498fab81f77515$var$W, "    ");
            }(e), n);
        };
    }(ae), le = (ce = function(e, n) {
        return function(r, t, i) {
            var a = e[r.type].render;
            return n ? n(function() {
                return a(r, t, i);
            }, r, t, i) : a(r, t, i);
        };
    }(ae, t.renderRule), function e(n, r) {
        if (void 0 === r && (r = {}), Array.isArray(n)) {
            for(var t = r.key, i = [], a = !1, c = 0; c < n.length; c++){
                r.key = c;
                var o = e(n[c], r), l = "string" == typeof o;
                l && a ? i[i.length - 1] += o : null !== o && i.push(o), a = l;
            }
            return r.key = t, i;
        }
        return ce(n, e, r);
    }), ue = q(r);
    return X.length ? Z("div", null, ue, Z("footer", {
        key: "footer"
    }, X.map(function(e) {
        return Z("div", {
            id: t.slugify(e.identifier),
            key: e.identifier
        }, e.identifier, le(oe(e.footnote, {
            inline: !0
        })));
    }))) : ue;
}
function $8e498fab81f77515$export$2e2bcd8739ae039(n) {
    var r = n.children, t = n.options, a = function(e, n) {
        if (null == e) return {};
        var r, t, i = {}, a = Object.keys(e);
        for(t = 0; t < a.length; t++)n.indexOf(r = a[t]) >= 0 || (i[r] = e[r]);
        return i;
    }(n, $8e498fab81f77515$var$i);
    return $aivMx.cloneElement($8e498fab81f77515$export$69f434acfbdb0b32(r, t), a);
}


const $5b62e0f9ddeec46b$var$MarkdownContent = ({ text: text })=>{
    if (!text) return null;
    const stringifiedText = typeof text === "object" ? JSON.stringify(text) : String(text);
    // const handleLinkClick = (e) => {
    //   e.preventDefault();
    //   const href = e.target.getAttribute('href');
    //   const target = e.target.getAttribute('target');
    //   if (href) {
    //     if (target === '_blank') {
    //       window.open(href, '_blank');
    //     } else {
    //       window.location.href = href;
    //     }
    //   }
    // };
    const handleLinkClick = (e)=>{
        e.preventDefault();
        const href = e.currentTarget.getAttribute("href");
        if (href) window.open(href, "_blank");
    };
    const CustomLink = (props)=>/*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("a", {
            ...props,
            onClick: handleLinkClick
        });
    const CustomListItem = (props)=>{
        const { children: children } = props;
        const modifiedChildren = (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).Children.map(children, (child)=>{
            if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).isValidElement(child) && child.type === "a") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).cloneElement(child, {
                onClick: handleLinkClick
            });
            return child;
        });
        return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("li", {
            ...props,
            children: modifiedChildren
        });
    };
    return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $8e498fab81f77515$export$2e2bcd8739ae039), {
        options: {
            overrides: {
                a: {
                    component: CustomLink
                },
                li: {
                    component: CustomListItem
                }
            }
        },
        children: stringifiedText
    });
};
var $5b62e0f9ddeec46b$export$2e2bcd8739ae039 = $5b62e0f9ddeec46b$var$MarkdownContent;


var $54f9738ec67d5626$export$2e2bcd8739ae039 = (0, $5b62e0f9ddeec46b$export$2e2bcd8739ae039);


var $42c5baa8fd68a26d$exports = {};

$parcel$export($42c5baa8fd68a26d$exports, "fix_overflow", function () { return $42c5baa8fd68a26d$export$a244188ab7675ec7; }, function (v) { return $42c5baa8fd68a26d$export$a244188ab7675ec7 = v; });
var $42c5baa8fd68a26d$export$a244188ab7675ec7;
$42c5baa8fd68a26d$export$a244188ab7675ec7 = `TOPzwa_fix_overflow`;


const $ca01b6cc23909411$var$addLineBreaksAndWrapChunks = (html)=>{
    return html.replace(/(<[^>]+>)([^<]+)(<\/[^>]+>)/g, (match, p1, p2, p3)=>{
        const wrappedText = p2.split("\n").map((chunk)=>`<span class="shimmer-text">${chunk}</span>`).join("<br/>");
        return `${p1}${wrappedText}${p3}`;
    });
};
// Function to wrap text nodes with <span class="shimmer-text"></span>
function $ca01b6cc23909411$var$transformHtmlString(htmlString, parentWidth) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, "text/html");
    function wrapTextNodes(node) {
        if (node.nodeType === Node.TEXT_NODE && node.nodeValue.trim() !== "") {
            const textContent = node.nodeValue.split(/(\s+|\n)/); // Split by spaces and line breaks
            const span = document.createElement("span");
            span.style.visibility = "hidden";
            span.style.whiteSpace = "nowrap";
            document.body.appendChild(span);
            let currentText = "";
            let wrappedText = "";
            let lineBreaks = 0;
            textContent.forEach((token, index)=>{
                if (token === "\n") {
                    wrappedText += `<span class="shimmer-text">${currentText.trim()}</span><br/>`;
                    currentText = "";
                    lineBreaks++;
                } else {
                    const testText = currentText ? `${currentText}${token}` : token;
                    span.textContent = testText;
                    if (span.offsetWidth > parentWidth) {
                        wrappedText += `<span class="shimmer-text">${currentText.trim()}</span><br/>`;
                        currentText = token.trim();
                        lineBreaks++;
                    } else currentText = testText;
                }
                if (index === textContent.length - 1 && currentText) wrappedText += `<span class="shimmer-text">${currentText.trim()}</span><br/>`;
            });
            document.body.removeChild(span);
            const wrapperSpan = document.createElement("span");
            wrapperSpan.innerHTML = wrappedText;
            node.replaceWith(wrapperSpan);
        } else if (node.nodeType === Node.ELEMENT_NODE) node.childNodes.forEach(wrapTextNodes);
    }
    doc.body.childNodes.forEach((node)=>wrapTextNodes(node));
    return doc.body.innerHTML;
}
const $ca01b6cc23909411$var$StyledInlineText = (0, $6e03950c2a9b6039$export$2e2bcd8739ae039).div`
  z-index: 1;
  position: relative;
  ${(props)=>(0, $e0d24bf85c947bed$export$2e2bcd8739ae039)(props.$shape, props.$baseScreenResolution, props.$skipStates)}

  ${({ $shape: $shape })=>$shape?.font?.text_overflow === "ellipsis" && (0, $6e03950c2a9b6039$export$dbf350e5966cf602)`      
      /* Apply to all nested elements */
      * {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    `}
`;
const $ca01b6cc23909411$var$InlineText = ({ id: id, value: value, style: stDraft, events: eventsDraft, dataLake: dataLake, pageSettings: pageSettings, activeState: activeStateDraft, nestedTable: nestedTable, parentIndex: parentIndex, styleChunks: styleChunks, sceleton: renderSceleton })=>{
    const containerRef = (0, $aivMx.useRef)(null);
    const { style: styleDraft, events: events, activeState: activeState } = dataLake?.data ? (0, $7b0e169a5380005e$export$485c71a5d8ecbaad)({
        style: stDraft,
        events: eventsDraft,
        activeState: activeStateDraft
    }, dataLake.data) : {
        style: stDraft,
        events: eventsDraft,
        activeState: activeStateDraft
    };
    const mergeStylesWithChunks = (0, $aivMx.useCallback)((style, chunks, index)=>{
        if (chunks && chunks[id] && chunks[id][index] && typeof index === "number") return (0, (/*@__PURE__*/$parcel$interopDefault($94WEq)))({}, style, chunks[id][index]);
        return style;
    }, [
        id
    ]);
    const variableData = (0, $f40d1f3d995cccef$export$2105062e25df4afe)((0, $79fc67ed759ae65b$export$e3ab06c283dfbb87));
    const localVariableData = (0, $f40d1f3d995cccef$export$2105062e25df4afe)((0, $79fc67ed759ae65b$export$78b26e3ba532c6ce));
    // Merge active state styles with base style
    // First useMemo to merge active state styles with base style
    const mergedStyleWithState = (0, $aivMx.useMemo)(()=>{
        let mergedStyle = styleDraft;
        if (activeState && styleDraft?.states?.[activeState]) mergedStyle = (0, (/*@__PURE__*/$parcel$interopDefault($94WEq)))({}, styleDraft, styleDraft.states[activeState]);
        // Handle states in breakpoints
        if (styleDraft?.breakpoints) mergedStyle.breakpoints = Object.entries(styleDraft.breakpoints).reduce((acc, [breakpoint, breakpointStyle])=>{
            const typedBreakpointStyle = breakpointStyle;
            if (typedBreakpointStyle?.states?.[activeState]) acc[breakpoint] = (0, (/*@__PURE__*/$parcel$interopDefault($94WEq)))({}, typedBreakpointStyle, typedBreakpointStyle.states[activeState]);
            else acc[breakpoint] = typedBreakpointStyle;
            return acc;
        }, {});
        return mergedStyle;
    }, [
        styleDraft,
        activeState
    ]);
    // Second useMemo to merge styles with chunks based on parentIndex
    const style = (0, $aivMx.useMemo)(()=>{
        return mergeStylesWithChunks(mergedStyleWithState, styleChunks, parentIndex);
    }, [
        mergedStyleWithState,
        styleChunks,
        parentIndex
    ]);
    const baseScreenResolution = pageSettings?.baseScreenResolution ? (0, $7b0e169a5380005e$export$e58d7eefdadeb732)(pageSettings?.baseScreenResolution) : undefined;
    const dispatch = (0, $d023060d48542f4c$export$8ad76b76a4c905f8)();
    const timeoutsRef = (0, $aivMx.useRef)([]);
    const internalFns = {
        $setVariable: (key, value)=>{
            dispatch((0, $8eba69c5466928d3$export$36f0c40eded97f9d)({
                variable: key,
                value: value
            }));
        },
        $getVariable: (key)=>{
            const value = (0, $7b0e169a5380005e$export$2516322ffbb7f3fb)(variableData, key) || (0, $7b0e169a5380005e$export$2516322ffbb7f3fb)(localVariableData, key);
            return value;
        },
        $moment: (...args)=>(0, (/*@__PURE__*/$parcel$interopDefault($g1KQj)))(...args)
    };
    const { on_click: clickUpdates, on_launch: launchUpdates, on_hover: hoverUpdates, on_unhover: unhoverUpdates, on_outclick: outclickUpdates } = events || {};
    const handleClick = (e)=>{
        if (activeState === "disabled" || activeState === "loading") {
            e.preventDefault();
            e.stopPropagation();
            return;
        }
        if (clickUpdates) {
            const styleUpdates = clickUpdates.filter((update)=>"style" in update);
            const requestUpdates = clickUpdates.filter((update)=>"request" in update);
            const functionUpdates = clickUpdates.filter((update)=>"function" in update);
            if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates));
            if (requestUpdates.length) requestUpdates.forEach((update)=>{
                const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                const { delay: delay } = config || {};
                if (update?.request && method === "command") dispatch((0, $8eba69c5466928d3$export$ea176eb1668c7b4b)({
                    location: {
                        pathname: value
                    },
                    silent: silent,
                    componentId: id
                }));
                else if (update?.request && method === "action") dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                    value: value,
                    silent: silent,
                    delay: delay,
                    componentId: id
                }, stDraft?.states?.loading ? id : undefined));
                else if (update?.request && method === "open-url") (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent);
            });
            if (functionUpdates.length) functionUpdates.forEach((update)=>{
                if (update?.function) (0, $7b0e169a5380005e$export$1ed0175478ddd28b)(update.function, e, internalFns);
            });
        }
    };
    const handleHover = (e)=>{
        if (activeState === "disabled" || activeState === "loading") {
            e.preventDefault();
            e.stopPropagation();
            return;
        }
        if (hoverUpdates) {
            const styleUpdates = hoverUpdates.filter((update)=>"style" in update);
            const requestUpdates = hoverUpdates.filter((update)=>"request" in update);
            const functionUpdates = hoverUpdates.filter((update)=>"function" in update);
            if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates));
            if (requestUpdates.length) requestUpdates.forEach((update)=>{
                const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                const { delay: delay } = config || {};
                if (update?.request && method === "action") dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                    value: value,
                    silent: silent,
                    delay: delay,
                    componentId: id
                }, stDraft?.states?.loading ? id : undefined));
                else if (update?.request && method === "open-url") (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent);
            });
            if (functionUpdates.length) functionUpdates.forEach((update)=>{
                if (update?.function) (0, $7b0e169a5380005e$export$1ed0175478ddd28b)(update.function, e, internalFns);
            });
        }
    };
    const handleUnhover = (e)=>{
        if (activeState === "disabled" || activeState === "loading") {
            e.stopPropagation();
            e.preventDefault();
            return;
        }
        if (unhoverUpdates) {
            const styleUpdates = unhoverUpdates.filter((update)=>"style" in update);
            const requestUpdates = unhoverUpdates.filter((update)=>"request" in update);
            const functionUpdates = unhoverUpdates.filter((update)=>"function" in update);
            if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates));
            if (requestUpdates.length) requestUpdates.forEach((update)=>{
                const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                const { delay: delay } = config || {};
                if (update?.request && method === "action") dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                    value: value,
                    silent: silent,
                    delay: delay,
                    componentId: id
                }, stDraft?.states?.loading ? id : undefined));
                else if (update?.request && method === "open-url") (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent);
            });
            if (functionUpdates.length) functionUpdates.forEach((update)=>{
                if (update?.function) (0, $7b0e169a5380005e$export$1ed0175478ddd28b)(update.function, e, internalFns);
            });
        }
    };
    (0, $aivMx.useEffect)(()=>{
        if (launchUpdates && launchUpdates.length) {
            const styleUpdates = launchUpdates.filter((update)=>"style" in update);
            const requestUpdates = launchUpdates.filter((update)=>"request" in update);
            const functionUpdates = launchUpdates.filter((update)=>"function" in update);
            if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates));
            if (requestUpdates.length) requestUpdates.forEach((update)=>{
                const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                const { delay: delay } = config || {};
                if (update?.request && method === "action") ;
                else if (update?.request && method === "open-url") (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent);
            });
            if (functionUpdates.length) functionUpdates.forEach((update)=>{
                if (update?.function) (0, $7b0e169a5380005e$export$1ed0175478ddd28b)(update.function, undefined, internalFns);
            });
        }
        return ()=>{
            timeoutsRef?.current?.forEach((timeout)=>{
                clearTimeout(timeout);
            });
        };
    }, [
        launchUpdates
    ]);
    (0, $aivMx.useEffect)(()=>{
        const handleUnclick = (e)=>{
            if (activeState === "disabled" || activeState === "loading") return;
            if (containerRef.current && !containerRef.current.contains(e.target)) {
                if (outclickUpdates) {
                    const styleUpdates = outclickUpdates.filter((update)=>"style" in update);
                    const requestUpdates = outclickUpdates.filter((update)=>"request" in update);
                    const functionUpdates = outclickUpdates.filter((update)=>"function" in update);
                    if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates, parentIndex));
                    if (requestUpdates.length) requestUpdates.forEach((update)=>{
                        const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                        const { delay: delay } = config || {};
                        if (update?.request && method === "action") dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                            value: value,
                            silent: silent,
                            delay: delay,
                            componentId: id
                        }, stDraft?.states?.loading ? id : undefined));
                        else if (update?.request && method === "open-url") (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent);
                    });
                    if (functionUpdates.length) functionUpdates.forEach((update)=>{
                        if (update?.function) (0, $7b0e169a5380005e$export$1ed0175478ddd28b)(update.function, undefined, internalFns);
                    });
                }
            }
        };
        if (outclickUpdates) {
            document.addEventListener("mousedown", handleUnclick);
            return ()=>{
                document.removeEventListener("mousedown", handleUnclick);
            };
        }
        return undefined;
    }, [
        parentIndex,
        activeState,
        containerRef.current
    ]);
    const extractedValue = (0, $7b0e169a5380005e$export$19c69f429b13dbe1)(value || "");
    const val = dataLake?.data && value.match(/{{this\..*}}/) ? (0, $7b0e169a5380005e$export$a87687c5ea189578)(dataLake.data, extractedValue) : value;
    if (renderSceleton) {
        const renderMarkdown = /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $54f9738ec67d5626$export$2e2bcd8739ae039), {
            text: val
        });
        const htmlString = (0, (/*@__PURE__*/$parcel$interopDefault($751e048dd35ac525$exports))).renderToString(renderMarkdown);
        const wrappedHtmlString = $ca01b6cc23909411$var$transformHtmlString(htmlString, containerRef.current?.clientWidth || document.body.clientWidth);
        // const finalHtmlString = addLineBreaksAndWrapChunks(wrappedHtmlString);
        const WrappedMarkdownContent = ()=>(0, $0da42676a80638d5$export$2e2bcd8739ae039)(wrappedHtmlString);
        return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)($ca01b6cc23909411$var$StyledInlineText, {
            ref: containerRef,
            id: `${id}${nestedTable && typeof parentIndex === "number" ? `::${parentIndex}` : ""}`,
            $shape: style,
            $baseScreenResolution: baseScreenResolution,
            $skipStates: activeState === "disabled" || activeState === "loading",
            "data-component": "text",
            className: (0, $7b0e169a5380005e$export$189053d41e721fcb)(style.class, (0, (/*@__PURE__*/$parcel$interopDefault($42c5baa8fd68a26d$exports))).fix_overflow),
            onClick: handleClick,
            onMouseEnter: handleHover,
            onMouseLeave: handleUnhover,
            children: /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)(WrappedMarkdownContent, {})
        });
    }
    return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)($ca01b6cc23909411$var$StyledInlineText, {
        ref: containerRef,
        id: `${id}${nestedTable && typeof parentIndex === "number" ? `::${parentIndex}` : ""}`,
        $shape: style,
        $baseScreenResolution: baseScreenResolution,
        $skipStates: activeState === "disabled" || activeState === "loading",
        "data-component": "text",
        className: (0, $7b0e169a5380005e$export$189053d41e721fcb)(style.class),
        onClick: handleClick,
        onMouseEnter: handleHover,
        onMouseLeave: handleUnhover,
        children: /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $54f9738ec67d5626$export$2e2bcd8739ae039), {
            text: val
        })
    });
};
var $ca01b6cc23909411$export$2e2bcd8739ae039 = $ca01b6cc23909411$var$InlineText;


var $d009549dd9adb801$export$2e2bcd8739ae039 = (0, $ca01b6cc23909411$export$2e2bcd8739ae039);



var $g1KQj = parcelRequire("g1KQj");

var $94WEq = parcelRequire("94WEq");



// constants.ts
const $2b42b3a2aa0ebb61$export$c5399bfb4d939924 = 12; // col size related to parent width
const $2b42b3a2aa0ebb61$export$a176cc2ca3635d69 = 16; // row size related to parent height


var $c5286964d8fcec84$exports = {};

$parcel$export($c5286964d8fcec84$exports, "main", function () { return $c5286964d8fcec84$export$f22da7240b7add18; }, function (v) { return $c5286964d8fcec84$export$f22da7240b7add18 = v; });
var $c5286964d8fcec84$export$f22da7240b7add18;
$c5286964d8fcec84$export$f22da7240b7add18 = `vB1vfG_main`;


const $d4ac9f041de1a90a$var$componentMapping = {
    checkbox: (0, $2c90db8687e433b8$export$2e2bcd8739ae039),
    image: (0, $aa8f0f735a0f79aa$export$2e2bcd8739ae039),
    input: (0, $7ea0c43ec9b05f7e$export$2e2bcd8739ae039),
    radio: (0, $b35bf230db392315$export$2e2bcd8739ae039),
    select: (0, $bb9696960a8827ef$export$2e2bcd8739ae039),
    separator: (0, $3492f55331d0a86f$export$2e2bcd8739ae039),
    switcher: (0, $f7a8d8148b95e31e$export$2e2bcd8739ae039),
    text: (0, $d009549dd9adb801$export$2e2bcd8739ae039)
};
const $d4ac9f041de1a90a$var$StyledContainer = (0, $6e03950c2a9b6039$export$2e2bcd8739ae039).div`
  ${(props)=>(0, $e0d24bf85c947bed$export$2e2bcd8739ae039)(props.$shape, props.$baseScreenResolution, props.$skipStates)}
`;
const $d4ac9f041de1a90a$var$GridContainerComponent = (obj)=>{
    const { id: id, items: items, style: stDraft, component: component, events: eventsDraft, dataLake: dataLake, parentIndex: parentIndex, pageSettings: pageSettings, styleChunks: styleChunks, activeState: activeStateDraft, nestedTable: nestedTable, sceleton: renderSceleton } = obj || {};
    const containerRef = (0, $aivMx.useRef)(null);
    const { style: styleDraft, events: events, activeState: activeState } = dataLake?.data ? (0, $7b0e169a5380005e$export$485c71a5d8ecbaad)({
        style: stDraft,
        events: eventsDraft,
        activeState: activeStateDraft
    }, dataLake.data) : {
        style: stDraft,
        events: eventsDraft,
        activeState: activeStateDraft
    };
    // Merge active state styles with base style
    const mergeStylesWithChunks = (0, $aivMx.useCallback)((style, chunks, index)=>{
        if (chunks && chunks[id] && chunks[id][index] && typeof index === "number") return (0, (/*@__PURE__*/$parcel$interopDefault($94WEq)))({}, style, chunks[id][index]);
        return style;
    }, [
        id
    ]);
    // First useMemo to merge active state styles with base style
    const mergedStyleWithState = (0, $aivMx.useMemo)(()=>{
        let mergedStyle = styleDraft;
        if (activeState && styleDraft?.states?.[activeState]) mergedStyle = (0, (/*@__PURE__*/$parcel$interopDefault($94WEq)))({}, styleDraft, styleDraft.states[activeState]);
        // Handle states in breakpoints
        if (styleDraft?.breakpoints) mergedStyle.breakpoints = Object.entries(styleDraft.breakpoints).reduce((acc, [breakpoint, breakpointStyle])=>{
            const typedBreakpointStyle = breakpointStyle;
            if (typedBreakpointStyle?.states?.[activeState]) acc[breakpoint] = (0, (/*@__PURE__*/$parcel$interopDefault($94WEq)))({}, typedBreakpointStyle, typedBreakpointStyle.states[activeState]);
            else acc[breakpoint] = typedBreakpointStyle;
            return acc;
        }, {});
        return mergedStyle;
    }, [
        styleDraft,
        activeState
    ]);
    // Second useMemo to merge styles with chunks based on parentIndex
    const st = (0, $aivMx.useMemo)(()=>{
        return mergeStylesWithChunks(mergedStyleWithState, styleChunks, parentIndex);
    }, [
        mergedStyleWithState,
        styleChunks,
        parentIndex
    ]);
    const { row: stickyRows } = dataLake?.settings?.pin || {};
    const isSticky = parentIndex < stickyRows;
    const { on_click: clickUpdates, on_launch: launchUpdates, on_hover: hoverUpdates, on_unhover: unhoverUpdates, on_outclick: outclickUpdates } = events || {};
    const { cols: colCount, rows: rowCount } = st || {};
    const baseScreenResolution = pageSettings?.baseScreenResolution ? (0, $7b0e169a5380005e$export$e58d7eefdadeb732)(pageSettings?.baseScreenResolution) : undefined;
    const variableData = (0, $f40d1f3d995cccef$export$2105062e25df4afe)((0, $79fc67ed759ae65b$export$e3ab06c283dfbb87));
    const localVariableData = (0, $f40d1f3d995cccef$export$2105062e25df4afe)((0, $79fc67ed759ae65b$export$78b26e3ba532c6ce));
    const dispatch = (0, $d023060d48542f4c$export$8ad76b76a4c905f8)();
    const timeoutsRef = (0, $aivMx.useRef)([]);
    const internalFns = {
        $setVariable: (key, value)=>{
            dispatch((0, $8eba69c5466928d3$export$36f0c40eded97f9d)({
                variable: key,
                value: value
            }));
        },
        $getVariable: (key)=>{
            const value = (0, $7b0e169a5380005e$export$2516322ffbb7f3fb)(variableData, key) || (0, $7b0e169a5380005e$export$2516322ffbb7f3fb)(localVariableData, key);
            return value;
        },
        $moment: (...args)=>(0, (/*@__PURE__*/$parcel$interopDefault($g1KQj)))(...args)
    };
    const handleClick = (e)=>{
        if (activeState === "disabled") {
            e.preventDefault();
            e.stopPropagation();
            return;
        }
        e.preventDefault();
        if (clickUpdates) {
            e.stopPropagation();
            const styleUpdates = clickUpdates.filter((update)=>"style" in update);
            const requestUpdates = clickUpdates.filter((update)=>"request" in update);
            const functionUpdates = clickUpdates.filter((update)=>"function" in update);
            if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates, parentIndex));
            if (requestUpdates.length) requestUpdates.forEach((update)=>{
                const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                const { delay: delay } = config || {};
                if (update?.request && method === "command") dispatch((0, $8eba69c5466928d3$export$ea176eb1668c7b4b)({
                    location: {
                        pathname: value
                    },
                    silent: silent,
                    componentId: id
                }));
                else if (update?.request && method === "action") dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                    value: value,
                    delay: delay,
                    silent: silent,
                    componentId: id
                }, stDraft?.states?.loading ? id : undefined));
                else if (update?.request && method === "open-url") (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent);
            });
            if (functionUpdates.length) functionUpdates.forEach((update)=>{
                if (update?.function) (0, $7b0e169a5380005e$export$1ed0175478ddd28b)(update.function, e, internalFns);
            });
        }
    };
    const handleHover = (e)=>{
        if (activeState === "disabled" || activeState === "loading") {
            e.preventDefault();
            e.stopPropagation();
            return;
        }
        if (hoverUpdates) {
            const styleUpdates = hoverUpdates.filter((update)=>"style" in update);
            const requestUpdates = hoverUpdates.filter((update)=>"request" in update);
            const functionUpdates = hoverUpdates.filter((update)=>"function" in update);
            if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates, parentIndex));
            if (requestUpdates.length) requestUpdates.forEach((update)=>{
                const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                const { delay: delay } = config || {};
                if (update?.request && method === "action") dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                    value: value,
                    silent: silent,
                    delay: delay,
                    componentId: id
                }, stDraft?.states?.loading ? id : undefined));
                else if (update?.request && method === "open-url") (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent);
            });
            if (functionUpdates.length) functionUpdates.forEach((update)=>{
                if (update?.function) (0, $7b0e169a5380005e$export$1ed0175478ddd28b)(update.function, e, internalFns);
            });
        }
    };
    const handleUnhover = (e)=>{
        if (activeState === "disabled") {
            e.preventDefault();
            e.stopPropagation();
            return;
        }
        if (unhoverUpdates) {
            const styleUpdates = unhoverUpdates.filter((update)=>"style" in update);
            const requestUpdates = unhoverUpdates.filter((update)=>"request" in update);
            const functionUpdates = unhoverUpdates.filter((update)=>"function" in update);
            if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates, parentIndex));
            if (requestUpdates.length) requestUpdates.forEach((update)=>{
                const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                const { delay: delay } = config || {};
                if (update?.request && method === "action") dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                    value: value,
                    silent: silent,
                    delay: delay,
                    componentId: id
                }, stDraft?.states?.loading ? id : undefined));
                else if (update?.request && method === "open-url") (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent);
            });
            if (functionUpdates.length) functionUpdates.forEach((update)=>{
                if (update?.function) (0, $7b0e169a5380005e$export$1ed0175478ddd28b)(update.function, e, internalFns);
            });
        }
    };
    (0, $aivMx.useEffect)(()=>{
        if (launchUpdates && launchUpdates.length) {
            const styleUpdates = launchUpdates.filter((update)=>"style" in update);
            const requestUpdates = launchUpdates.filter((update)=>"request" in update);
            const functionUpdates = launchUpdates.filter((update)=>"function" in update);
            if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates));
            if (requestUpdates.length) requestUpdates.forEach((update)=>{
                const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                const { delay: delay } = config || {};
                if (update?.request && method === "action") ;
                else if (update?.request && method === "open-url") (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent);
            });
            if (functionUpdates.length) functionUpdates.forEach((update)=>{
                if (update?.function) (0, $7b0e169a5380005e$export$1ed0175478ddd28b)(update.function, undefined, internalFns);
            });
        }
        return ()=>{
            timeoutsRef?.current?.forEach((timeout)=>{
                clearTimeout(timeout);
            });
        };
    }, [
        launchUpdates
    ]);
    (0, $aivMx.useEffect)(()=>{
        const handleUnclick = (e)=>{
            if (activeState === "disabled" || activeState === "loading") return;
            if (containerRef.current && !containerRef.current.contains(e.target)) {
                if (outclickUpdates) {
                    const styleUpdates = outclickUpdates.filter((update)=>"style" in update);
                    const requestUpdates = outclickUpdates.filter((update)=>"request" in update);
                    const functionUpdates = outclickUpdates.filter((update)=>"function" in update);
                    if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates, parentIndex));
                    if (requestUpdates.length) requestUpdates.forEach((update)=>{
                        const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                        const { delay: delay } = config || {};
                        if (update?.request && method === "action") dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                            value: value,
                            silent: silent,
                            delay: delay,
                            componentId: id
                        }, stDraft?.states?.loading ? id : undefined));
                        else if (update?.request && method === "open-url") (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent);
                    });
                    if (functionUpdates.length) functionUpdates.forEach((update)=>{
                        if (update?.function) (0, $7b0e169a5380005e$export$1ed0175478ddd28b)(update.function, undefined, internalFns);
                    });
                }
            }
        };
        if (outclickUpdates) {
            document.addEventListener("click", handleUnclick);
            return ()=>{
                document.removeEventListener("click", handleUnclick);
            };
        }
        return undefined;
    }, [
        parentIndex,
        activeState,
        containerRef.current
    ]);
    return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsxs)($d4ac9f041de1a90a$var$StyledContainer, {
        ref: containerRef,
        id: `${id}${nestedTable && typeof parentIndex === "number" ? `::${parentIndex}` : ""}`,
        style: {
            gridTemplateColumns: `repeat(${colCount || (0, $2b42b3a2aa0ebb61$export$c5399bfb4d939924)}, 1fr)`,
            gridTemplateRows: rowCount ? `repeat(${rowCount}, 1fr)` : undefined,
            gridAutoRows: rowCount ? undefined : `${0, $2b42b3a2aa0ebb61$export$a176cc2ca3635d69}px`,
            position: isSticky ? "sticky" : undefined,
            top: isSticky ? 0 : undefined,
            zIndex: isSticky ? `${99999999 - parentIndex}` : undefined,
            visibility: renderSceleton && st ? "hidden" : undefined
        },
        $shape: st,
        $baseScreenResolution: baseScreenResolution,
        $skipStates: activeState === "disabled" || activeState === "loading",
        "data-component": component,
        className: (0, $7b0e169a5380005e$export$189053d41e721fcb)((0, (/*@__PURE__*/$parcel$interopDefault($c5286964d8fcec84$exports))).class),
        onClick: handleClick,
        onMouseEnter: handleHover,
        onMouseLeave: handleUnhover,
        children: [
            items && items.map((item, index)=>{
                const Component = $d4ac9f041de1a90a$var$componentMapping[item.component];
                const commonProps = {
                    dataLake: (0, $7b0e169a5380005e$export$e9c29559b77b0f7b)(item, obj, dataLake, index, pageSettings?.variables, parentIndex),
                    parentIndex: parentIndex,
                    pageSettings: pageSettings,
                    styleChunks: styleChunks,
                    nestedTable: nestedTable
                };
                if (item.component === "container" && item.type === "table-body-row" && item.dynamic) {
                    const replaced = (0, $7b0e169a5380005e$export$9a7eef5d73136d1e)(commonProps?.dataLake?.settings?.source, pageSettings?.variables);
                    const parseSourceIfExist = (0, $7b0e169a5380005e$export$8c51936ffbb22bee)(replaced);
                    return Array.isArray(parseSourceIfExist) ? parseSourceIfExist?.map((sourceItem, sourceIndex)=>{
                        const dynamicProps = {
                            dataLake: (0, $7b0e169a5380005e$export$e9c29559b77b0f7b)(item, obj, dataLake, sourceIndex, pageSettings?.variables, parentIndex),
                            parentIndex: sourceIndex,
                            styleChunks: styleChunks,
                            nestedTable: true
                        };
                        if (Component) return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)(Component, {
                            ...item,
                            ...dynamicProps,
                            parentRef: containerRef
                        }, `${item.id}::${sourceIndex}`);
                        if (item.component === "container") return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)($d4ac9f041de1a90a$var$GridContainerComponent, {
                            ...item,
                            ...dynamicProps
                        }, `${item.id}::${sourceIndex}`);
                        if (item.component === "table") return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)($d4ac9f041de1a90a$var$GridContainerComponent, {
                            ...item,
                            ...dynamicProps
                        }, `${item.id}::${sourceIndex}`);
                        return null;
                    }) : null;
                }
                if (Component) return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)(Component, {
                    ...item,
                    ...commonProps,
                    parentRef: containerRef
                }, item.id);
                if (item.component === "container") return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)($d4ac9f041de1a90a$var$GridContainerComponent, {
                    ...item,
                    ...commonProps
                }, item.id);
                if (item.component === "table") return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)($d4ac9f041de1a90a$var$GridContainerComponent, {
                    ...item,
                    ...commonProps
                }, item.id);
                return null;
            }),
            renderSceleton && st ? /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $cefd49c6ff42e132$export$2e2bcd8739ae039), {
                style: st,
                baseScreenResolution: baseScreenResolution,
                skipStates: activeState === "disabled" || activeState === "loading",
                nested: true
            }) : null
        ]
    });
};
var $d4ac9f041de1a90a$export$2e2bcd8739ae039 = $d4ac9f041de1a90a$var$GridContainerComponent;


var $0380290541115933$export$2e2bcd8739ae039 = (0, $d4ac9f041de1a90a$export$2e2bcd8739ae039);












var $94WEq = parcelRequire("94WEq");
// utils/prefetchHelper.ts
const $fe90f07def2730ef$var$fetchedImageUrls = new Set();
const $fe90f07def2730ef$export$4358cc9d407dbd2f = (pp)=>{
    const imageUrls = new Set();
    const traverseScheme = (node)=>{
        if (Array.isArray(node)) node.forEach(traverseScheme);
        else if (typeof node === "object" && node !== null) {
            // Check for image URLs in the background property
            if (node.style) extractImageUrls(node.style);
            // Traverse child nodes
            Object.values(node).forEach(traverseScheme);
        }
    };
    const extractImageUrls = (style)=>{
        if (style.background) style.background.forEach((bg)=>{
            if (bg.type === "image" && bg.value) imageUrls.add(bg.value);
        });
        // Check nested properties (states, events, breakpoints)
        if (style.states) Object.values(style.states).forEach(extractImageUrls);
        if (style.events) Object.values(style.events).forEach((event)=>{
            if (Array.isArray(event)) event.forEach((e)=>{
                if (e.style) extractImageUrls(e.style);
            });
        });
        if (style.breakpoints) Object.values(style.breakpoints).forEach(extractImageUrls);
    };
    traverseScheme(pp);
    // Filter out already fetched URLs
    const newImageUrls = Array.from(imageUrls).filter((url)=>!$fe90f07def2730ef$var$fetchedImageUrls.has(url));
    // Add new URLs to the fetched set
    newImageUrls.forEach((url)=>$fe90f07def2730ef$var$fetchedImageUrls.add(url));
    // Send unique new image URLs to the Web Worker
    // worker.postMessage(newImageUrls);
    return newImageUrls;
};


const $73d63d58f0308e04$var$preloadedUrls = new Set();
const $73d63d58f0308e04$export$6b05b21262ec0515 = (imageUrls)=>{
    imageUrls.forEach((url)=>{
        if ($73d63d58f0308e04$var$preloadedUrls.has(url)) return;
        const img = new Image();
        img.src = url;
        img.onload = ()=>{
            // console.log(`Prefetched: ${url}`);
            $73d63d58f0308e04$var$preloadedUrls.add(url);
        };
        img.onerror = (error)=>{
            console.error(`Failed to prefetch: ${url}`, error);
        };
    });
};




const $a1fc314d6e34ac94$export$c169aefb7330cccb = Object.create(null); // no Map = no polyfill
$a1fc314d6e34ac94$export$c169aefb7330cccb["open"] = "0";
$a1fc314d6e34ac94$export$c169aefb7330cccb["close"] = "1";
$a1fc314d6e34ac94$export$c169aefb7330cccb["ping"] = "2";
$a1fc314d6e34ac94$export$c169aefb7330cccb["pong"] = "3";
$a1fc314d6e34ac94$export$c169aefb7330cccb["message"] = "4";
$a1fc314d6e34ac94$export$c169aefb7330cccb["upgrade"] = "5";
$a1fc314d6e34ac94$export$c169aefb7330cccb["noop"] = "6";
const $a1fc314d6e34ac94$export$47791e8004edd485 = Object.create(null);
Object.keys($a1fc314d6e34ac94$export$c169aefb7330cccb).forEach((key)=>{
    $a1fc314d6e34ac94$export$47791e8004edd485[$a1fc314d6e34ac94$export$c169aefb7330cccb[key]] = key;
});
const $a1fc314d6e34ac94$export$c718b5840781f8a7 = {
    type: "error",
    data: "parser error"
};


const $6f99c7ccf8da7f3e$var$withNativeBlob = typeof Blob === "function" || typeof Blob !== "undefined" && Object.prototype.toString.call(Blob) === "[object BlobConstructor]";
const $6f99c7ccf8da7f3e$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
// ArrayBuffer.isView method is not defined in IE10
const $6f99c7ccf8da7f3e$var$isView = (obj)=>{
    return typeof ArrayBuffer.isView === "function" ? ArrayBuffer.isView(obj) : obj && obj.buffer instanceof ArrayBuffer;
};
const $6f99c7ccf8da7f3e$export$57852049361a8e62 = ({ type: type, data: data }, supportsBinary, callback)=>{
    if ($6f99c7ccf8da7f3e$var$withNativeBlob && data instanceof Blob) {
        if (supportsBinary) return callback(data);
        else return $6f99c7ccf8da7f3e$var$encodeBlobAsBase64(data, callback);
    } else if ($6f99c7ccf8da7f3e$var$withNativeArrayBuffer && (data instanceof ArrayBuffer || $6f99c7ccf8da7f3e$var$isView(data))) {
        if (supportsBinary) return callback(data);
        else return $6f99c7ccf8da7f3e$var$encodeBlobAsBase64(new Blob([
            data
        ]), callback);
    }
    // plain string
    return callback((0, $a1fc314d6e34ac94$export$c169aefb7330cccb)[type] + (data || ""));
};
const $6f99c7ccf8da7f3e$var$encodeBlobAsBase64 = (data, callback)=>{
    const fileReader = new FileReader();
    fileReader.onload = function() {
        const content = fileReader.result.split(",")[1];
        callback("b" + (content || ""));
    };
    return fileReader.readAsDataURL(data);
};
function $6f99c7ccf8da7f3e$var$toArray(data) {
    if (data instanceof Uint8Array) return data;
    else if (data instanceof ArrayBuffer) return new Uint8Array(data);
    else return new Uint8Array(data.buffer, data.byteOffset, data.byteLength);
}
let $6f99c7ccf8da7f3e$var$TEXT_ENCODER;
function $6f99c7ccf8da7f3e$export$ec0c9b9013ee0ef5(packet, callback) {
    if ($6f99c7ccf8da7f3e$var$withNativeBlob && packet.data instanceof Blob) return packet.data.arrayBuffer().then($6f99c7ccf8da7f3e$var$toArray).then(callback);
    else if ($6f99c7ccf8da7f3e$var$withNativeArrayBuffer && (packet.data instanceof ArrayBuffer || $6f99c7ccf8da7f3e$var$isView(packet.data))) return callback($6f99c7ccf8da7f3e$var$toArray(packet.data));
    $6f99c7ccf8da7f3e$export$57852049361a8e62(packet, false, (encoded)=>{
        if (!$6f99c7ccf8da7f3e$var$TEXT_ENCODER) $6f99c7ccf8da7f3e$var$TEXT_ENCODER = new TextEncoder();
        callback($6f99c7ccf8da7f3e$var$TEXT_ENCODER.encode(encoded));
    });
}



// imported from https://github.com/socketio/base64-arraybuffer
const $d7bc315985e6f656$var$chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
// Use a lookup table to find the index.
const $d7bc315985e6f656$var$lookup = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
for(let i = 0; i < $d7bc315985e6f656$var$chars.length; i++)$d7bc315985e6f656$var$lookup[$d7bc315985e6f656$var$chars.charCodeAt(i)] = i;
const $d7bc315985e6f656$export$c564cdbbe6da493 = (arraybuffer)=>{
    let bytes = new Uint8Array(arraybuffer), i, len = bytes.length, base64 = "";
    for(i = 0; i < len; i += 3){
        base64 += $d7bc315985e6f656$var$chars[bytes[i] >> 2];
        base64 += $d7bc315985e6f656$var$chars[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
        base64 += $d7bc315985e6f656$var$chars[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
        base64 += $d7bc315985e6f656$var$chars[bytes[i + 2] & 63];
    }
    if (len % 3 === 2) base64 = base64.substring(0, base64.length - 1) + "=";
    else if (len % 3 === 1) base64 = base64.substring(0, base64.length - 2) + "==";
    return base64;
};
const $d7bc315985e6f656$export$2f872c0f2117be69 = (base64)=>{
    let bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
    if (base64[base64.length - 1] === "=") {
        bufferLength--;
        if (base64[base64.length - 2] === "=") bufferLength--;
    }
    const arraybuffer = new ArrayBuffer(bufferLength), bytes = new Uint8Array(arraybuffer);
    for(i = 0; i < len; i += 4){
        encoded1 = $d7bc315985e6f656$var$lookup[base64.charCodeAt(i)];
        encoded2 = $d7bc315985e6f656$var$lookup[base64.charCodeAt(i + 1)];
        encoded3 = $d7bc315985e6f656$var$lookup[base64.charCodeAt(i + 2)];
        encoded4 = $d7bc315985e6f656$var$lookup[base64.charCodeAt(i + 3)];
        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }
    return arraybuffer;
};


const $5b849b38c0cfea23$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
const $5b849b38c0cfea23$export$4647901878f33f31 = (encodedPacket, binaryType)=>{
    if (typeof encodedPacket !== "string") return {
        type: "message",
        data: $5b849b38c0cfea23$var$mapBinary(encodedPacket, binaryType)
    };
    const type = encodedPacket.charAt(0);
    if (type === "b") return {
        type: "message",
        data: $5b849b38c0cfea23$var$decodeBase64Packet(encodedPacket.substring(1), binaryType)
    };
    const packetType = (0, $a1fc314d6e34ac94$export$47791e8004edd485)[type];
    if (!packetType) return 0, $a1fc314d6e34ac94$export$c718b5840781f8a7;
    return encodedPacket.length > 1 ? {
        type: (0, $a1fc314d6e34ac94$export$47791e8004edd485)[type],
        data: encodedPacket.substring(1)
    } : {
        type: (0, $a1fc314d6e34ac94$export$47791e8004edd485)[type]
    };
};
const $5b849b38c0cfea23$var$decodeBase64Packet = (data, binaryType)=>{
    if ($5b849b38c0cfea23$var$withNativeArrayBuffer) {
        const decoded = (0, $d7bc315985e6f656$export$2f872c0f2117be69)(data);
        return $5b849b38c0cfea23$var$mapBinary(decoded, binaryType);
    } else return {
        base64: true,
        data: data
    }; // fallback for old browsers
};
const $5b849b38c0cfea23$var$mapBinary = (data, binaryType)=>{
    switch(binaryType){
        case "blob":
            if (data instanceof Blob) // from WebSocket + binaryType "blob"
            return data;
            else // from HTTP long-polling or WebTransport
            return new Blob([
                data
            ]);
        case "arraybuffer":
        default:
            if (data instanceof ArrayBuffer) // from HTTP long-polling (base64) or WebSocket + binaryType "arraybuffer"
            return data;
            else // from WebTransport (Uint8Array)
            return data.buffer;
    }
};



const $c8a38bcb71b20bd4$var$SEPARATOR = String.fromCharCode(30); // see https://en.wikipedia.org/wiki/Delimiter#ASCII_delimited_text
const $c8a38bcb71b20bd4$export$144d64fe58dad441 = (packets, callback)=>{
    // some packets may be added to the array while encoding, so the initial length must be saved
    const length = packets.length;
    const encodedPackets = new Array(length);
    let count = 0;
    packets.forEach((packet, i)=>{
        // force base64 encoding for binary packets
        (0, $6f99c7ccf8da7f3e$export$57852049361a8e62)(packet, false, (encodedPacket)=>{
            encodedPackets[i] = encodedPacket;
            if (++count === length) callback(encodedPackets.join($c8a38bcb71b20bd4$var$SEPARATOR));
        });
    });
};
const $c8a38bcb71b20bd4$export$d10cc2e7f7566a2d = (encodedPayload, binaryType)=>{
    const encodedPackets = encodedPayload.split($c8a38bcb71b20bd4$var$SEPARATOR);
    const packets = [];
    for(let i = 0; i < encodedPackets.length; i++){
        const decodedPacket = (0, $5b849b38c0cfea23$export$4647901878f33f31)(encodedPackets[i], binaryType);
        packets.push(decodedPacket);
        if (decodedPacket.type === "error") break;
    }
    return packets;
};
function $c8a38bcb71b20bd4$export$a525fb718e9c623a() {
    return new TransformStream({
        transform (packet, controller) {
            (0, $6f99c7ccf8da7f3e$export$ec0c9b9013ee0ef5)(packet, (encodedPacket)=>{
                const payloadLength = encodedPacket.length;
                let header;
                // inspired by the WebSocket format: https://developer.mozilla.org/en-US/docs/Web/API/WebSockets_API/Writing_WebSocket_servers#decoding_payload_length
                if (payloadLength < 126) {
                    header = new Uint8Array(1);
                    new DataView(header.buffer).setUint8(0, payloadLength);
                } else if (payloadLength < 65536) {
                    header = new Uint8Array(3);
                    const view = new DataView(header.buffer);
                    view.setUint8(0, 126);
                    view.setUint16(1, payloadLength);
                } else {
                    header = new Uint8Array(9);
                    const view = new DataView(header.buffer);
                    view.setUint8(0, 127);
                    view.setBigUint64(1, BigInt(payloadLength));
                }
                // first bit indicates whether the payload is plain text (0) or binary (1)
                if (packet.data && typeof packet.data !== "string") header[0] |= 0x80;
                controller.enqueue(header);
                controller.enqueue(encodedPacket);
            });
        }
    });
}
let $c8a38bcb71b20bd4$var$TEXT_DECODER;
function $c8a38bcb71b20bd4$var$totalLength(chunks) {
    return chunks.reduce((acc, chunk)=>acc + chunk.length, 0);
}
function $c8a38bcb71b20bd4$var$concatChunks(chunks, size) {
    if (chunks[0].length === size) return chunks.shift();
    const buffer = new Uint8Array(size);
    let j = 0;
    for(let i = 0; i < size; i++){
        buffer[i] = chunks[0][j++];
        if (j === chunks[0].length) {
            chunks.shift();
            j = 0;
        }
    }
    if (chunks.length && j < chunks[0].length) chunks[0] = chunks[0].slice(j);
    return buffer;
}
function $c8a38bcb71b20bd4$export$552d20aac7500f47(maxPayload, binaryType) {
    if (!$c8a38bcb71b20bd4$var$TEXT_DECODER) $c8a38bcb71b20bd4$var$TEXT_DECODER = new TextDecoder();
    const chunks = [];
    let state = 0 /* State.READ_HEADER */ ;
    let expectedLength = -1;
    let isBinary = false;
    return new TransformStream({
        transform (chunk, controller) {
            chunks.push(chunk);
            while(true){
                if (state === 0 /* State.READ_HEADER */ ) {
                    if ($c8a38bcb71b20bd4$var$totalLength(chunks) < 1) break;
                    const header = $c8a38bcb71b20bd4$var$concatChunks(chunks, 1);
                    isBinary = (header[0] & 0x80) === 0x80;
                    expectedLength = header[0] & 0x7f;
                    if (expectedLength < 126) state = 3 /* State.READ_PAYLOAD */ ;
                    else if (expectedLength === 126) state = 1 /* State.READ_EXTENDED_LENGTH_16 */ ;
                    else state = 2 /* State.READ_EXTENDED_LENGTH_64 */ ;
                } else if (state === 1 /* State.READ_EXTENDED_LENGTH_16 */ ) {
                    if ($c8a38bcb71b20bd4$var$totalLength(chunks) < 2) break;
                    const headerArray = $c8a38bcb71b20bd4$var$concatChunks(chunks, 2);
                    expectedLength = new DataView(headerArray.buffer, headerArray.byteOffset, headerArray.length).getUint16(0);
                    state = 3 /* State.READ_PAYLOAD */ ;
                } else if (state === 2 /* State.READ_EXTENDED_LENGTH_64 */ ) {
                    if ($c8a38bcb71b20bd4$var$totalLength(chunks) < 8) break;
                    const headerArray = $c8a38bcb71b20bd4$var$concatChunks(chunks, 8);
                    const view = new DataView(headerArray.buffer, headerArray.byteOffset, headerArray.length);
                    const n = view.getUint32(0);
                    if (n > Math.pow(2, 21) - 1) {
                        // the maximum safe integer in JavaScript is 2^53 - 1
                        controller.enqueue((0, $a1fc314d6e34ac94$export$c718b5840781f8a7));
                        break;
                    }
                    expectedLength = n * Math.pow(2, 32) + view.getUint32(4);
                    state = 3 /* State.READ_PAYLOAD */ ;
                } else {
                    if ($c8a38bcb71b20bd4$var$totalLength(chunks) < expectedLength) break;
                    const data = $c8a38bcb71b20bd4$var$concatChunks(chunks, expectedLength);
                    controller.enqueue((0, $5b849b38c0cfea23$export$4647901878f33f31)(isBinary ? data : $c8a38bcb71b20bd4$var$TEXT_DECODER.decode(data), binaryType));
                    state = 0 /* State.READ_HEADER */ ;
                }
                if (expectedLength === 0 || expectedLength > maxPayload) {
                    controller.enqueue((0, $a1fc314d6e34ac94$export$c718b5840781f8a7));
                    break;
                }
            }
        }
    });
}
const $c8a38bcb71b20bd4$export$a51d6b395ff4c65a = 4;


/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */ function $bd7e26f198897caa$export$4293555f241ae35a(obj) {
    if (obj) return $bd7e26f198897caa$var$mixin(obj);
}
/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */ function $bd7e26f198897caa$var$mixin(obj) {
    for(var key in $bd7e26f198897caa$export$4293555f241ae35a.prototype)obj[key] = $bd7e26f198897caa$export$4293555f241ae35a.prototype[key];
    return obj;
}
/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $bd7e26f198897caa$export$4293555f241ae35a.prototype.on = $bd7e26f198897caa$export$4293555f241ae35a.prototype.addEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    (this._callbacks["$" + event] = this._callbacks["$" + event] || []).push(fn);
    return this;
};
/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $bd7e26f198897caa$export$4293555f241ae35a.prototype.once = function(event, fn) {
    function on() {
        this.off(event, on);
        fn.apply(this, arguments);
    }
    on.fn = fn;
    this.on(event, on);
    return this;
};
/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $bd7e26f198897caa$export$4293555f241ae35a.prototype.off = $bd7e26f198897caa$export$4293555f241ae35a.prototype.removeListener = $bd7e26f198897caa$export$4293555f241ae35a.prototype.removeAllListeners = $bd7e26f198897caa$export$4293555f241ae35a.prototype.removeEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    // all
    if (0 == arguments.length) {
        this._callbacks = {};
        return this;
    }
    // specific event
    var callbacks = this._callbacks["$" + event];
    if (!callbacks) return this;
    // remove all handlers
    if (1 == arguments.length) {
        delete this._callbacks["$" + event];
        return this;
    }
    // remove specific handler
    var cb;
    for(var i = 0; i < callbacks.length; i++){
        cb = callbacks[i];
        if (cb === fn || cb.fn === fn) {
            callbacks.splice(i, 1);
            break;
        }
    }
    // Remove event specific arrays for event types that no
    // one is subscribed for to avoid memory leak.
    if (callbacks.length === 0) delete this._callbacks["$" + event];
    return this;
};
/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */ $bd7e26f198897caa$export$4293555f241ae35a.prototype.emit = function(event) {
    this._callbacks = this._callbacks || {};
    var args = new Array(arguments.length - 1), callbacks = this._callbacks["$" + event];
    for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    if (callbacks) {
        callbacks = callbacks.slice(0);
        for(var i = 0, len = callbacks.length; i < len; ++i)callbacks[i].apply(this, args);
    }
    return this;
};
// alias used for reserved events (protected method)
$bd7e26f198897caa$export$4293555f241ae35a.prototype.emitReserved = $bd7e26f198897caa$export$4293555f241ae35a.prototype.emit;
/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */ $bd7e26f198897caa$export$4293555f241ae35a.prototype.listeners = function(event) {
    this._callbacks = this._callbacks || {};
    return this._callbacks["$" + event] || [];
};
/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */ $bd7e26f198897caa$export$4293555f241ae35a.prototype.hasListeners = function(event) {
    return !!this.listeners(event).length;
};


const $296c7d23957f3d69$export$bdd553fddd433dcb = (()=>{
    const isPromiseAvailable = typeof Promise === "function" && typeof Promise.resolve === "function";
    if (isPromiseAvailable) return (cb)=>Promise.resolve().then(cb);
    else return (cb, setTimeoutFn)=>setTimeoutFn(cb, 0);
})();
const $296c7d23957f3d69$export$394f9358f6231289 = (()=>{
    if (typeof self !== "undefined") return self;
    else if (typeof window !== "undefined") return window;
    else return Function("return this")();
})();
const $296c7d23957f3d69$export$790dcbc41e2d75d5 = "arraybuffer";
function $296c7d23957f3d69$export$19413efcf2fac759() {}


function $e34120c3d721494a$export$357523c63a2253b9(obj, ...attr) {
    return attr.reduce((acc, k)=>{
        if (obj.hasOwnProperty(k)) acc[k] = obj[k];
        return acc;
    }, {});
}
// Keep a reference to the real timeout functions so they can be used when overridden
const $e34120c3d721494a$var$NATIVE_SET_TIMEOUT = (0, $296c7d23957f3d69$export$394f9358f6231289).setTimeout;
const $e34120c3d721494a$var$NATIVE_CLEAR_TIMEOUT = (0, $296c7d23957f3d69$export$394f9358f6231289).clearTimeout;
function $e34120c3d721494a$export$2f67576668b97183(obj, opts) {
    if (opts.useNativeTimers) {
        obj.setTimeoutFn = $e34120c3d721494a$var$NATIVE_SET_TIMEOUT.bind((0, $296c7d23957f3d69$export$394f9358f6231289));
        obj.clearTimeoutFn = $e34120c3d721494a$var$NATIVE_CLEAR_TIMEOUT.bind((0, $296c7d23957f3d69$export$394f9358f6231289));
    } else {
        obj.setTimeoutFn = (0, $296c7d23957f3d69$export$394f9358f6231289).setTimeout.bind((0, $296c7d23957f3d69$export$394f9358f6231289));
        obj.clearTimeoutFn = (0, $296c7d23957f3d69$export$394f9358f6231289).clearTimeout.bind((0, $296c7d23957f3d69$export$394f9358f6231289));
    }
}
// base64 encoded buffers are about 33% bigger (https://en.wikipedia.org/wiki/Base64)
const $e34120c3d721494a$var$BASE64_OVERHEAD = 1.33;
function $e34120c3d721494a$export$a48f0734ac7c2329(obj) {
    if (typeof obj === "string") return $e34120c3d721494a$var$utf8Length(obj);
    // arraybuffer or blob
    return Math.ceil((obj.byteLength || obj.size) * $e34120c3d721494a$var$BASE64_OVERHEAD);
}
function $e34120c3d721494a$var$utf8Length(str) {
    let c = 0, length = 0;
    for(let i = 0, l = str.length; i < l; i++){
        c = str.charCodeAt(i);
        if (c < 0x80) length += 1;
        else if (c < 0x800) length += 2;
        else if (c < 0xd800 || c >= 0xe000) length += 3;
        else {
            i++;
            length += 4;
        }
    }
    return length;
}
function $e34120c3d721494a$export$7fa8378418b4411e() {
    return Date.now().toString(36).substring(3) + Math.random().toString(36).substring(2, 5);
}


// imported from https://github.com/galkn/querystring
/**
 * Compiles a querystring
 * Returns string representation of the object
 *
 * @param {Object}
 * @api private
 */ function $671ed638d6347e9b$export$c564cdbbe6da493(obj) {
    let str = "";
    for(let i in obj)if (obj.hasOwnProperty(i)) {
        if (str.length) str += "&";
        str += encodeURIComponent(i) + "=" + encodeURIComponent(obj[i]);
    }
    return str;
}
function $671ed638d6347e9b$export$2f872c0f2117be69(qs) {
    let qry = {};
    let pairs = qs.split("&");
    for(let i = 0, l = pairs.length; i < l; i++){
        let pair = pairs[i].split("=");
        qry[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
    }
    return qry;
}


class $e667b4e5712dd5df$export$8e68de6fb26f2236 extends Error {
    constructor(reason, description, context){
        super(reason);
        this.description = description;
        this.context = context;
        this.type = "TransportError";
    }
}
class $e667b4e5712dd5df$export$86495b081fef8e52 extends (0, $bd7e26f198897caa$export$4293555f241ae35a) {
    /**
     * Transport abstract constructor.
     *
     * @param {Object} opts - options
     * @protected
     */ constructor(opts){
        super();
        this.writable = false;
        (0, $e34120c3d721494a$export$2f67576668b97183)(this, opts);
        this.opts = opts;
        this.query = opts.query;
        this.socket = opts.socket;
        this.supportsBinary = !opts.forceBase64;
    }
    /**
     * Emits an error.
     *
     * @param {String} reason
     * @param description
     * @param context - the error context
     * @return {Transport} for chaining
     * @protected
     */ onError(reason, description, context) {
        super.emitReserved("error", new $e667b4e5712dd5df$export$8e68de6fb26f2236(reason, description, context));
        return this;
    }
    /**
     * Opens the transport.
     */ open() {
        this.readyState = "opening";
        this.doOpen();
        return this;
    }
    /**
     * Closes the transport.
     */ close() {
        if (this.readyState === "opening" || this.readyState === "open") {
            this.doClose();
            this.onClose();
        }
        return this;
    }
    /**
     * Sends multiple packets.
     *
     * @param {Array} packets
     */ send(packets) {
        if (this.readyState === "open") this.write(packets);
    }
    /**
     * Called upon open
     *
     * @protected
     */ onOpen() {
        this.readyState = "open";
        this.writable = true;
        super.emitReserved("open");
    }
    /**
     * Called with data.
     *
     * @param {String} data
     * @protected
     */ onData(data) {
        const packet = (0, $5b849b38c0cfea23$export$4647901878f33f31)(data, this.socket.binaryType);
        this.onPacket(packet);
    }
    /**
     * Called with a decoded packet.
     *
     * @protected
     */ onPacket(packet) {
        super.emitReserved("packet", packet);
    }
    /**
     * Called upon close.
     *
     * @protected
     */ onClose(details) {
        this.readyState = "closed";
        super.emitReserved("close", details);
    }
    /**
     * Pauses the transport, in order not to lose packets during an upgrade.
     *
     * @param onPause
     */ pause(onPause) {}
    createUri(schema, query = {}) {
        return schema + "://" + this._hostname() + this._port() + this.opts.path + this._query(query);
    }
    _hostname() {
        const hostname = this.opts.hostname;
        return hostname.indexOf(":") === -1 ? hostname : "[" + hostname + "]";
    }
    _port() {
        if (this.opts.port && (this.opts.secure && Number(this.opts.port !== 443) || !this.opts.secure && Number(this.opts.port) !== 80)) return ":" + this.opts.port;
        else return "";
    }
    _query(query) {
        const encodedQuery = (0, $671ed638d6347e9b$export$c564cdbbe6da493)(query);
        return encodedQuery.length ? "?" + encodedQuery : "";
    }
}




class $4c9fe808dbd2b179$export$265ee5eefd4c309b extends (0, $e667b4e5712dd5df$export$86495b081fef8e52) {
    constructor(){
        super(...arguments);
        this._polling = false;
    }
    get name() {
        return "polling";
    }
    /**
     * Opens the socket (triggers polling). We write a PING message to determine
     * when the transport is open.
     *
     * @protected
     */ doOpen() {
        this._poll();
    }
    /**
     * Pauses polling.
     *
     * @param {Function} onPause - callback upon buffers are flushed and transport is paused
     * @package
     */ pause(onPause) {
        this.readyState = "pausing";
        const pause = ()=>{
            this.readyState = "paused";
            onPause();
        };
        if (this._polling || !this.writable) {
            let total = 0;
            if (this._polling) {
                total++;
                this.once("pollComplete", function() {
                    --total || pause();
                });
            }
            if (!this.writable) {
                total++;
                this.once("drain", function() {
                    --total || pause();
                });
            }
        } else pause();
    }
    /**
     * Starts polling cycle.
     *
     * @private
     */ _poll() {
        this._polling = true;
        this.doPoll();
        this.emitReserved("poll");
    }
    /**
     * Overloads onData to detect payloads.
     *
     * @protected
     */ onData(data) {
        const callback = (packet)=>{
            // if its the first message we consider the transport open
            if ("opening" === this.readyState && packet.type === "open") this.onOpen();
            // if its a close packet, we close the ongoing requests
            if ("close" === packet.type) {
                this.onClose({
                    description: "transport closed by the server"
                });
                return false;
            }
            // otherwise bypass onData and handle the message
            this.onPacket(packet);
        };
        // decode payload
        (0, $c8a38bcb71b20bd4$export$d10cc2e7f7566a2d)(data, this.socket.binaryType).forEach(callback);
        // if an event did not trigger closing
        if ("closed" !== this.readyState) {
            // if we got data we're not polling
            this._polling = false;
            this.emitReserved("pollComplete");
            if ("open" === this.readyState) this._poll();
        }
    }
    /**
     * For polling, send a close packet.
     *
     * @protected
     */ doClose() {
        const close = ()=>{
            this.write([
                {
                    type: "close"
                }
            ]);
        };
        if ("open" === this.readyState) close();
        else // in case we're trying to close while
        // handshaking is in progress (GH-164)
        this.once("open", close);
    }
    /**
     * Writes a packets payload.
     *
     * @param {Array} packets - data packets
     * @protected
     */ write(packets) {
        this.writable = false;
        (0, $c8a38bcb71b20bd4$export$144d64fe58dad441)(packets, (data)=>{
            this.doWrite(data, ()=>{
                this.writable = true;
                this.emitReserved("drain");
            });
        });
    }
    /**
     * Generates uri for connection.
     *
     * @private
     */ uri() {
        const schema = this.opts.secure ? "https" : "http";
        const query = this.query || {};
        // cache busting is forced
        if (false !== this.opts.timestampRequests) query[this.opts.timestampParam] = (0, $e34120c3d721494a$export$7fa8378418b4411e)();
        if (!this.supportsBinary && !query.sid) query.b64 = 1;
        return this.createUri(schema, query);
    }
}





// imported from https://github.com/component/has-cors
let $d9c1762a5ddb3730$var$value = false;
try {
    $d9c1762a5ddb3730$var$value = typeof XMLHttpRequest !== "undefined" && "withCredentials" in new XMLHttpRequest();
} catch (err) {
// if XMLHttp support is disabled in IE then it will throw
// when trying to create
}
const $d9c1762a5ddb3730$export$5235bbd4a1ef06e = $d9c1762a5ddb3730$var$value;


function $cbaeca2c76030d87$var$empty() {}
class $cbaeca2c76030d87$export$c959f2344155d309 extends (0, $4c9fe808dbd2b179$export$265ee5eefd4c309b) {
    /**
     * XHR Polling constructor.
     *
     * @param {Object} opts
     * @package
     */ constructor(opts){
        super(opts);
        if (typeof location !== "undefined") {
            const isSSL = "https:" === location.protocol;
            let port = location.port;
            // some user agents have empty `location.port`
            if (!port) port = isSSL ? "443" : "80";
            this.xd = typeof location !== "undefined" && opts.hostname !== location.hostname || port !== opts.port;
        }
    }
    /**
     * Sends data.
     *
     * @param {String} data to send.
     * @param {Function} called upon flush.
     * @private
     */ doWrite(data, fn) {
        const req = this.request({
            method: "POST",
            data: data
        });
        req.on("success", fn);
        req.on("error", (xhrStatus, context)=>{
            this.onError("xhr post error", xhrStatus, context);
        });
    }
    /**
     * Starts a poll cycle.
     *
     * @private
     */ doPoll() {
        const req = this.request();
        req.on("data", this.onData.bind(this));
        req.on("error", (xhrStatus, context)=>{
            this.onError("xhr poll error", xhrStatus, context);
        });
        this.pollXhr = req;
    }
}
class $cbaeca2c76030d87$export$7fa6c5b6f8193917 extends (0, $bd7e26f198897caa$export$4293555f241ae35a) {
    /**
     * Request constructor
     *
     * @param {Object} options
     * @package
     */ constructor(createRequest, uri, opts){
        super();
        this.createRequest = createRequest;
        (0, $e34120c3d721494a$export$2f67576668b97183)(this, opts);
        this._opts = opts;
        this._method = opts.method || "GET";
        this._uri = uri;
        this._data = undefined !== opts.data ? opts.data : null;
        this._create();
    }
    /**
     * Creates the XHR object and sends the request.
     *
     * @private
     */ _create() {
        var _a;
        const opts = (0, $e34120c3d721494a$export$357523c63a2253b9)(this._opts, "agent", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "autoUnref");
        opts.xdomain = !!this._opts.xd;
        const xhr = this._xhr = this.createRequest(opts);
        try {
            xhr.open(this._method, this._uri, true);
            try {
                if (this._opts.extraHeaders) {
                    // @ts-ignore
                    xhr.setDisableHeaderCheck && xhr.setDisableHeaderCheck(true);
                    for(let i in this._opts.extraHeaders)if (this._opts.extraHeaders.hasOwnProperty(i)) xhr.setRequestHeader(i, this._opts.extraHeaders[i]);
                }
            } catch (e) {}
            if ("POST" === this._method) try {
                xhr.setRequestHeader("Content-type", "text/plain;charset=UTF-8");
            } catch (e) {}
            try {
                xhr.setRequestHeader("Accept", "*/*");
            } catch (e) {}
            (_a = this._opts.cookieJar) === null || _a === void 0 || _a.addCookies(xhr);
            // ie6 check
            if ("withCredentials" in xhr) xhr.withCredentials = this._opts.withCredentials;
            if (this._opts.requestTimeout) xhr.timeout = this._opts.requestTimeout;
            xhr.onreadystatechange = ()=>{
                var _a;
                if (xhr.readyState === 3) (_a = this._opts.cookieJar) === null || _a === void 0 || _a.parseCookies(// @ts-ignore
                xhr.getResponseHeader("set-cookie"));
                if (4 !== xhr.readyState) return;
                if (200 === xhr.status || 1223 === xhr.status) this._onLoad();
                else // make sure the `error` event handler that's user-set
                // does not throw in the same tick and gets caught here
                this.setTimeoutFn(()=>{
                    this._onError(typeof xhr.status === "number" ? xhr.status : 0);
                }, 0);
            };
            xhr.send(this._data);
        } catch (e) {
            // Need to defer since .create() is called directly from the constructor
            // and thus the 'error' event can only be only bound *after* this exception
            // occurs.  Therefore, also, we cannot throw here at all.
            this.setTimeoutFn(()=>{
                this._onError(e);
            }, 0);
            return;
        }
        if (typeof document !== "undefined") {
            this._index = $cbaeca2c76030d87$export$7fa6c5b6f8193917.requestsCount++;
            $cbaeca2c76030d87$export$7fa6c5b6f8193917.requests[this._index] = this;
        }
    }
    /**
     * Called upon error.
     *
     * @private
     */ _onError(err) {
        this.emitReserved("error", err, this._xhr);
        this._cleanup(true);
    }
    /**
     * Cleans up house.
     *
     * @private
     */ _cleanup(fromError) {
        if ("undefined" === typeof this._xhr || null === this._xhr) return;
        this._xhr.onreadystatechange = $cbaeca2c76030d87$var$empty;
        if (fromError) try {
            this._xhr.abort();
        } catch (e) {}
        if (typeof document !== "undefined") delete $cbaeca2c76030d87$export$7fa6c5b6f8193917.requests[this._index];
        this._xhr = null;
    }
    /**
     * Called upon load.
     *
     * @private
     */ _onLoad() {
        const data = this._xhr.responseText;
        if (data !== null) {
            this.emitReserved("data", data);
            this.emitReserved("success");
            this._cleanup();
        }
    }
    /**
     * Aborts the request.
     *
     * @package
     */ abort() {
        this._cleanup();
    }
}
$cbaeca2c76030d87$export$7fa6c5b6f8193917.requestsCount = 0;
$cbaeca2c76030d87$export$7fa6c5b6f8193917.requests = {};
/**
 * Aborts pending requests when unloading the window. This is needed to prevent
 * memory leaks (e.g. when using IE) and to ensure that no spurious error is
 * emitted.
 */ if (typeof document !== "undefined") {
    // @ts-ignore
    if (typeof attachEvent === "function") // @ts-ignore
    attachEvent("onunload", $cbaeca2c76030d87$var$unloadHandler);
    else if (typeof addEventListener === "function") {
        const terminationEvent = "onpagehide" in (0, $296c7d23957f3d69$export$394f9358f6231289) ? "pagehide" : "unload";
        addEventListener(terminationEvent, $cbaeca2c76030d87$var$unloadHandler, false);
    }
}
function $cbaeca2c76030d87$var$unloadHandler() {
    for(let i in $cbaeca2c76030d87$export$7fa6c5b6f8193917.requests)if ($cbaeca2c76030d87$export$7fa6c5b6f8193917.requests.hasOwnProperty(i)) $cbaeca2c76030d87$export$7fa6c5b6f8193917.requests[i].abort();
}
const $cbaeca2c76030d87$var$hasXHR2 = function() {
    const xhr = $cbaeca2c76030d87$var$newRequest({
        xdomain: false
    });
    return xhr && xhr.responseType !== null;
}();
class $cbaeca2c76030d87$export$a2d42eb087c10497 extends $cbaeca2c76030d87$export$c959f2344155d309 {
    constructor(opts){
        super(opts);
        const forceBase64 = opts && opts.forceBase64;
        this.supportsBinary = $cbaeca2c76030d87$var$hasXHR2 && !forceBase64;
    }
    request(opts = {}) {
        Object.assign(opts, {
            xd: this.xd
        }, this.opts);
        return new $cbaeca2c76030d87$export$7fa6c5b6f8193917($cbaeca2c76030d87$var$newRequest, this.uri(), opts);
    }
}
function $cbaeca2c76030d87$var$newRequest(opts) {
    const xdomain = opts.xdomain;
    // XMLHttpRequest can be disabled on IE
    try {
        if ("undefined" !== typeof XMLHttpRequest && (!xdomain || (0, $d9c1762a5ddb3730$export$5235bbd4a1ef06e))) return new XMLHttpRequest();
    } catch (e) {}
    if (!xdomain) try {
        return new (0, $296c7d23957f3d69$export$394f9358f6231289)[[
            "Active"
        ].concat("Object").join("X")]("Microsoft.XMLHTTP");
    } catch (e) {}
}






// detect ReactNative environment
const $da85c64c883daff7$var$isReactNative = typeof navigator !== "undefined" && typeof navigator.product === "string" && navigator.product.toLowerCase() === "reactnative";
class $da85c64c883daff7$export$570bf71d2367e261 extends (0, $e667b4e5712dd5df$export$86495b081fef8e52) {
    get name() {
        return "websocket";
    }
    doOpen() {
        const uri = this.uri();
        const protocols = this.opts.protocols;
        // React Native only supports the 'headers' option, and will print a warning if anything else is passed
        const opts = $da85c64c883daff7$var$isReactNative ? {} : (0, $e34120c3d721494a$export$357523c63a2253b9)(this.opts, "agent", "perMessageDeflate", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "localAddress", "protocolVersion", "origin", "maxPayload", "family", "checkServerIdentity");
        if (this.opts.extraHeaders) opts.headers = this.opts.extraHeaders;
        try {
            this.ws = this.createSocket(uri, protocols, opts);
        } catch (err) {
            return this.emitReserved("error", err);
        }
        this.ws.binaryType = this.socket.binaryType;
        this.addEventListeners();
    }
    /**
     * Adds event listeners to the socket
     *
     * @private
     */ addEventListeners() {
        this.ws.onopen = ()=>{
            if (this.opts.autoUnref) this.ws._socket.unref();
            this.onOpen();
        };
        this.ws.onclose = (closeEvent)=>this.onClose({
                description: "websocket connection closed",
                context: closeEvent
            });
        this.ws.onmessage = (ev)=>this.onData(ev.data);
        this.ws.onerror = (e)=>this.onError("websocket error", e);
    }
    write(packets) {
        this.writable = false;
        // encodePacket efficient as it uses WS framing
        // no need for encodePayload
        for(let i = 0; i < packets.length; i++){
            const packet = packets[i];
            const lastPacket = i === packets.length - 1;
            (0, $6f99c7ccf8da7f3e$export$57852049361a8e62)(packet, this.supportsBinary, (data)=>{
                // Sometimes the websocket has already been closed but the browser didn't
                // have a chance of informing us about it yet, in that case send will
                // throw an error
                try {
                    this.doWrite(packet, data);
                } catch (e) {}
                if (lastPacket) // fake drain
                // defer to next tick to allow Socket to clear writeBuffer
                (0, $296c7d23957f3d69$export$bdd553fddd433dcb)(()=>{
                    this.writable = true;
                    this.emitReserved("drain");
                }, this.setTimeoutFn);
            });
        }
    }
    doClose() {
        if (typeof this.ws !== "undefined") {
            this.ws.onerror = ()=>{};
            this.ws.close();
            this.ws = null;
        }
    }
    /**
     * Generates uri for connection.
     *
     * @private
     */ uri() {
        const schema = this.opts.secure ? "wss" : "ws";
        const query = this.query || {};
        // append timestamp to URI
        if (this.opts.timestampRequests) query[this.opts.timestampParam] = (0, $e34120c3d721494a$export$7fa8378418b4411e)();
        // communicate binary support capabilities
        if (!this.supportsBinary) query.b64 = 1;
        return this.createUri(schema, query);
    }
}
const $da85c64c883daff7$var$WebSocketCtor = (0, $296c7d23957f3d69$export$394f9358f6231289).WebSocket || (0, $296c7d23957f3d69$export$394f9358f6231289).MozWebSocket;
class $da85c64c883daff7$export$911baa0677ac404c extends $da85c64c883daff7$export$570bf71d2367e261 {
    createSocket(uri, protocols, opts) {
        return !$da85c64c883daff7$var$isReactNative ? protocols ? new $da85c64c883daff7$var$WebSocketCtor(uri, protocols) : new $da85c64c883daff7$var$WebSocketCtor(uri) : new $da85c64c883daff7$var$WebSocketCtor(uri, protocols, opts);
    }
    doWrite(_packet, data) {
        this.ws.send(data);
    }
}





class $d801797666dc235e$export$961c930859384407 extends (0, $e667b4e5712dd5df$export$86495b081fef8e52) {
    get name() {
        return "webtransport";
    }
    doOpen() {
        try {
            // @ts-ignore
            this._transport = new WebTransport(this.createUri("https"), this.opts.transportOptions[this.name]);
        } catch (err) {
            return this.emitReserved("error", err);
        }
        this._transport.closed.then(()=>{
            this.onClose();
        }).catch((err)=>{
            this.onError("webtransport error", err);
        });
        // note: we could have used async/await, but that would require some additional polyfills
        this._transport.ready.then(()=>{
            this._transport.createBidirectionalStream().then((stream)=>{
                const decoderStream = (0, $c8a38bcb71b20bd4$export$552d20aac7500f47)(Number.MAX_SAFE_INTEGER, this.socket.binaryType);
                const reader = stream.readable.pipeThrough(decoderStream).getReader();
                const encoderStream = (0, $c8a38bcb71b20bd4$export$a525fb718e9c623a)();
                encoderStream.readable.pipeTo(stream.writable);
                this._writer = encoderStream.writable.getWriter();
                const read = ()=>{
                    reader.read().then(({ done: done, value: value })=>{
                        if (done) return;
                        this.onPacket(value);
                        read();
                    }).catch((err)=>{});
                };
                read();
                const packet = {
                    type: "open"
                };
                if (this.query.sid) packet.data = `{"sid":"${this.query.sid}"}`;
                this._writer.write(packet).then(()=>this.onOpen());
            });
        });
    }
    write(packets) {
        this.writable = false;
        for(let i = 0; i < packets.length; i++){
            const packet = packets[i];
            const lastPacket = i === packets.length - 1;
            this._writer.write(packet).then(()=>{
                if (lastPacket) (0, $296c7d23957f3d69$export$bdd553fddd433dcb)(()=>{
                    this.writable = true;
                    this.emitReserved("drain");
                }, this.setTimeoutFn);
            });
        }
    }
    doClose() {
        var _a;
        (_a = this._transport) === null || _a === void 0 || _a.close();
    }
}


const $0cb269c4f7ff6eee$export$46dec00755c1153b = {
    websocket: (0, $da85c64c883daff7$export$911baa0677ac404c),
    webtransport: (0, $d801797666dc235e$export$961c930859384407),
    polling: (0, $cbaeca2c76030d87$export$a2d42eb087c10497)
};




// imported from https://github.com/galkn/parseuri
/**
 * Parses a URI
 *
 * Note: we could also have used the built-in URL object, but it isn't supported on all platforms.
 *
 * See:
 * - https://developer.mozilla.org/en-US/docs/Web/API/URL
 * - https://caniuse.com/url
 * - https://www.rfc-editor.org/rfc/rfc3986#appendix-B
 *
 * History of the parse() method:
 * - first commit: https://github.com/socketio/socket.io-client/commit/4ee1d5d94b3906a9c052b459f1a818b15f38f91c
 * - export into its own module: https://github.com/socketio/engine.io-client/commit/de2c561e4564efeb78f1bdb1ba39ef81b2822cb3
 * - reimport: https://github.com/socketio/engine.io-client/commit/df32277c3f6d622eec5ed09f493cae3f3391d242
 *
 * @author Steven Levithan <stevenlevithan.com> (MIT license)
 * @api private
 */ const $22f7aeedd2aef9bc$var$re = /^(?:(?![^:@\/?#]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@\/?#]*)(?::([^:@\/?#]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;
const $22f7aeedd2aef9bc$var$parts = [
    "source",
    "protocol",
    "authority",
    "userInfo",
    "user",
    "password",
    "host",
    "port",
    "relative",
    "path",
    "directory",
    "file",
    "query",
    "anchor"
];
function $22f7aeedd2aef9bc$export$98e6a39c04603d36(str) {
    if (str.length > 8000) throw "URI too long";
    const src = str, b = str.indexOf("["), e = str.indexOf("]");
    if (b != -1 && e != -1) str = str.substring(0, b) + str.substring(b, e).replace(/:/g, ";") + str.substring(e, str.length);
    let m = $22f7aeedd2aef9bc$var$re.exec(str || ""), uri = {}, i = 14;
    while(i--)uri[$22f7aeedd2aef9bc$var$parts[i]] = m[i] || "";
    if (b != -1 && e != -1) {
        uri.source = src;
        uri.host = uri.host.substring(1, uri.host.length - 1).replace(/;/g, ":");
        uri.authority = uri.authority.replace("[", "").replace("]", "").replace(/;/g, ":");
        uri.ipv6uri = true;
    }
    uri.pathNames = $22f7aeedd2aef9bc$var$pathNames(uri, uri["path"]);
    uri.queryKey = $22f7aeedd2aef9bc$var$queryKey(uri, uri["query"]);
    return uri;
}
function $22f7aeedd2aef9bc$var$pathNames(obj, path) {
    const regx = /\/{2,9}/g, names = path.replace(regx, "/").split("/");
    if (path.slice(0, 1) == "/" || path.length === 0) names.splice(0, 1);
    if (path.slice(-1) == "/") names.splice(names.length - 1, 1);
    return names;
}
function $22f7aeedd2aef9bc$var$queryKey(uri, query) {
    const data = {};
    query.replace(/(?:^|&)([^&=]*)=?([^&]*)/g, function($0, $1, $2) {
        if ($1) data[$1] = $2;
    });
    return data;
}





const $9ebc607289cc7033$var$withEventListeners = typeof addEventListener === "function" && typeof removeEventListener === "function";
const $9ebc607289cc7033$var$OFFLINE_EVENT_LISTENERS = [];
if ($9ebc607289cc7033$var$withEventListeners) // within a ServiceWorker, any event handler for the 'offline' event must be added on the initial evaluation of the
// script, so we create one single event listener here which will forward the event to the socket instances
addEventListener("offline", ()=>{
    $9ebc607289cc7033$var$OFFLINE_EVENT_LISTENERS.forEach((listener)=>listener());
}, false);
class $9ebc607289cc7033$export$3874118029a0ee0d extends (0, $bd7e26f198897caa$export$4293555f241ae35a) {
    /**
     * Socket constructor.
     *
     * @param {String|Object} uri - uri or options
     * @param {Object} opts - options
     */ constructor(uri, opts){
        super();
        this.binaryType = (0, $296c7d23957f3d69$export$790dcbc41e2d75d5);
        this.writeBuffer = [];
        this._prevBufferLen = 0;
        this._pingInterval = -1;
        this._pingTimeout = -1;
        this._maxPayload = -1;
        /**
         * The expiration timestamp of the {@link _pingTimeoutTimer} object is tracked, in case the timer is throttled and the
         * callback is not fired on time. This can happen for example when a laptop is suspended or when a phone is locked.
         */ this._pingTimeoutTime = Infinity;
        if (uri && "object" === typeof uri) {
            opts = uri;
            uri = null;
        }
        if (uri) {
            const parsedUri = (0, $22f7aeedd2aef9bc$export$98e6a39c04603d36)(uri);
            opts.hostname = parsedUri.host;
            opts.secure = parsedUri.protocol === "https" || parsedUri.protocol === "wss";
            opts.port = parsedUri.port;
            if (parsedUri.query) opts.query = parsedUri.query;
        } else if (opts.host) opts.hostname = (0, $22f7aeedd2aef9bc$export$98e6a39c04603d36)(opts.host).host;
        (0, $e34120c3d721494a$export$2f67576668b97183)(this, opts);
        this.secure = null != opts.secure ? opts.secure : typeof location !== "undefined" && "https:" === location.protocol;
        if (opts.hostname && !opts.port) // if no port is specified manually, use the protocol default
        opts.port = this.secure ? "443" : "80";
        this.hostname = opts.hostname || (typeof location !== "undefined" ? location.hostname : "localhost");
        this.port = opts.port || (typeof location !== "undefined" && location.port ? location.port : this.secure ? "443" : "80");
        this.transports = [];
        this._transportsByName = {};
        opts.transports.forEach((t)=>{
            const transportName = t.prototype.name;
            this.transports.push(transportName);
            this._transportsByName[transportName] = t;
        });
        this.opts = Object.assign({
            path: "/engine.io",
            agent: false,
            withCredentials: false,
            upgrade: true,
            timestampParam: "t",
            rememberUpgrade: false,
            addTrailingSlash: true,
            rejectUnauthorized: true,
            perMessageDeflate: {
                threshold: 1024
            },
            transportOptions: {},
            closeOnBeforeunload: false
        }, opts);
        this.opts.path = this.opts.path.replace(/\/$/, "") + (this.opts.addTrailingSlash ? "/" : "");
        if (typeof this.opts.query === "string") this.opts.query = (0, $671ed638d6347e9b$export$2f872c0f2117be69)(this.opts.query);
        if ($9ebc607289cc7033$var$withEventListeners) {
            if (this.opts.closeOnBeforeunload) {
                // Firefox closes the connection when the "beforeunload" event is emitted but not Chrome. This event listener
                // ensures every browser behaves the same (no "disconnect" event at the Socket.IO level when the page is
                // closed/reloaded)
                this._beforeunloadEventListener = ()=>{
                    if (this.transport) {
                        // silently close the transport
                        this.transport.removeAllListeners();
                        this.transport.close();
                    }
                };
                addEventListener("beforeunload", this._beforeunloadEventListener, false);
            }
            if (this.hostname !== "localhost") {
                this._offlineEventListener = ()=>{
                    this._onClose("transport close", {
                        description: "network connection lost"
                    });
                };
                $9ebc607289cc7033$var$OFFLINE_EVENT_LISTENERS.push(this._offlineEventListener);
            }
        }
        if (this.opts.withCredentials) this._cookieJar = (0, $296c7d23957f3d69$export$19413efcf2fac759)();
        this._open();
    }
    /**
     * Creates transport of the given type.
     *
     * @param {String} name - transport name
     * @return {Transport}
     * @private
     */ createTransport(name) {
        const query = Object.assign({}, this.opts.query);
        // append engine.io protocol identifier
        query.EIO = (0, $c8a38bcb71b20bd4$export$a51d6b395ff4c65a);
        // transport name
        query.transport = name;
        // session id if we already have one
        if (this.id) query.sid = this.id;
        const opts = Object.assign({}, this.opts, {
            query: query,
            socket: this,
            hostname: this.hostname,
            secure: this.secure,
            port: this.port
        }, this.opts.transportOptions[name]);
        return new this._transportsByName[name](opts);
    }
    /**
     * Initializes transport to use and starts probe.
     *
     * @private
     */ _open() {
        if (this.transports.length === 0) {
            // Emit error on next tick so it can be listened to
            this.setTimeoutFn(()=>{
                this.emitReserved("error", "No transports available");
            }, 0);
            return;
        }
        const transportName = this.opts.rememberUpgrade && $9ebc607289cc7033$export$3874118029a0ee0d.priorWebsocketSuccess && this.transports.indexOf("websocket") !== -1 ? "websocket" : this.transports[0];
        this.readyState = "opening";
        const transport = this.createTransport(transportName);
        transport.open();
        this.setTransport(transport);
    }
    /**
     * Sets the current transport. Disables the existing one (if any).
     *
     * @private
     */ setTransport(transport) {
        if (this.transport) this.transport.removeAllListeners();
        // set up transport
        this.transport = transport;
        // set up transport listeners
        transport.on("drain", this._onDrain.bind(this)).on("packet", this._onPacket.bind(this)).on("error", this._onError.bind(this)).on("close", (reason)=>this._onClose("transport close", reason));
    }
    /**
     * Called when connection is deemed open.
     *
     * @private
     */ onOpen() {
        this.readyState = "open";
        $9ebc607289cc7033$export$3874118029a0ee0d.priorWebsocketSuccess = "websocket" === this.transport.name;
        this.emitReserved("open");
        this.flush();
    }
    /**
     * Handles a packet.
     *
     * @private
     */ _onPacket(packet) {
        if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) {
            this.emitReserved("packet", packet);
            // Socket is live - any packet counts
            this.emitReserved("heartbeat");
            switch(packet.type){
                case "open":
                    this.onHandshake(JSON.parse(packet.data));
                    break;
                case "ping":
                    this._sendPacket("pong");
                    this.emitReserved("ping");
                    this.emitReserved("pong");
                    this._resetPingTimeout();
                    break;
                case "error":
                    const err = new Error("server error");
                    // @ts-ignore
                    err.code = packet.data;
                    this._onError(err);
                    break;
                case "message":
                    this.emitReserved("data", packet.data);
                    this.emitReserved("message", packet.data);
                    break;
            }
        }
    }
    /**
     * Called upon handshake completion.
     *
     * @param {Object} data - handshake obj
     * @private
     */ onHandshake(data) {
        this.emitReserved("handshake", data);
        this.id = data.sid;
        this.transport.query.sid = data.sid;
        this._pingInterval = data.pingInterval;
        this._pingTimeout = data.pingTimeout;
        this._maxPayload = data.maxPayload;
        this.onOpen();
        // In case open handler closes socket
        if ("closed" === this.readyState) return;
        this._resetPingTimeout();
    }
    /**
     * Sets and resets ping timeout timer based on server pings.
     *
     * @private
     */ _resetPingTimeout() {
        this.clearTimeoutFn(this._pingTimeoutTimer);
        const delay = this._pingInterval + this._pingTimeout;
        this._pingTimeoutTime = Date.now() + delay;
        this._pingTimeoutTimer = this.setTimeoutFn(()=>{
            this._onClose("ping timeout");
        }, delay);
        if (this.opts.autoUnref) this._pingTimeoutTimer.unref();
    }
    /**
     * Called on `drain` event
     *
     * @private
     */ _onDrain() {
        this.writeBuffer.splice(0, this._prevBufferLen);
        // setting prevBufferLen = 0 is very important
        // for example, when upgrading, upgrade packet is sent over,
        // and a nonzero prevBufferLen could cause problems on `drain`
        this._prevBufferLen = 0;
        if (0 === this.writeBuffer.length) this.emitReserved("drain");
        else this.flush();
    }
    /**
     * Flush write buffers.
     *
     * @private
     */ flush() {
        if ("closed" !== this.readyState && this.transport.writable && !this.upgrading && this.writeBuffer.length) {
            const packets = this._getWritablePackets();
            this.transport.send(packets);
            // keep track of current length of writeBuffer
            // splice writeBuffer and callbackBuffer on `drain`
            this._prevBufferLen = packets.length;
            this.emitReserved("flush");
        }
    }
    /**
     * Ensure the encoded size of the writeBuffer is below the maxPayload value sent by the server (only for HTTP
     * long-polling)
     *
     * @private
     */ _getWritablePackets() {
        const shouldCheckPayloadSize = this._maxPayload && this.transport.name === "polling" && this.writeBuffer.length > 1;
        if (!shouldCheckPayloadSize) return this.writeBuffer;
        let payloadSize = 1; // first packet type
        for(let i = 0; i < this.writeBuffer.length; i++){
            const data = this.writeBuffer[i].data;
            if (data) payloadSize += (0, $e34120c3d721494a$export$a48f0734ac7c2329)(data);
            if (i > 0 && payloadSize > this._maxPayload) return this.writeBuffer.slice(0, i);
            payloadSize += 2; // separator + packet type
        }
        return this.writeBuffer;
    }
    /**
     * Checks whether the heartbeat timer has expired but the socket has not yet been notified.
     *
     * Note: this method is private for now because it does not really fit the WebSocket API, but if we put it in the
     * `write()` method then the message would not be buffered by the Socket.IO client.
     *
     * @return {boolean}
     * @private
     */ /* private */ _hasPingExpired() {
        if (!this._pingTimeoutTime) return true;
        const hasExpired = Date.now() > this._pingTimeoutTime;
        if (hasExpired) {
            this._pingTimeoutTime = 0;
            (0, $296c7d23957f3d69$export$bdd553fddd433dcb)(()=>{
                this._onClose("ping timeout");
            }, this.setTimeoutFn);
        }
        return hasExpired;
    }
    /**
     * Sends a message.
     *
     * @param {String} msg - message.
     * @param {Object} options.
     * @param {Function} fn - callback function.
     * @return {Socket} for chaining.
     */ write(msg, options, fn) {
        this._sendPacket("message", msg, options, fn);
        return this;
    }
    /**
     * Sends a message. Alias of {@link Socket#write}.
     *
     * @param {String} msg - message.
     * @param {Object} options.
     * @param {Function} fn - callback function.
     * @return {Socket} for chaining.
     */ send(msg, options, fn) {
        this._sendPacket("message", msg, options, fn);
        return this;
    }
    /**
     * Sends a packet.
     *
     * @param {String} type: packet type.
     * @param {String} data.
     * @param {Object} options.
     * @param {Function} fn - callback function.
     * @private
     */ _sendPacket(type, data, options, fn) {
        if ("function" === typeof data) {
            fn = data;
            data = undefined;
        }
        if ("function" === typeof options) {
            fn = options;
            options = null;
        }
        if ("closing" === this.readyState || "closed" === this.readyState) return;
        options = options || {};
        options.compress = false !== options.compress;
        const packet = {
            type: type,
            data: data,
            options: options
        };
        this.emitReserved("packetCreate", packet);
        this.writeBuffer.push(packet);
        if (fn) this.once("flush", fn);
        this.flush();
    }
    /**
     * Closes the connection.
     */ close() {
        const close = ()=>{
            this._onClose("forced close");
            this.transport.close();
        };
        const cleanupAndClose = ()=>{
            this.off("upgrade", cleanupAndClose);
            this.off("upgradeError", cleanupAndClose);
            close();
        };
        const waitForUpgrade = ()=>{
            // wait for upgrade to finish since we can't send packets while pausing a transport
            this.once("upgrade", cleanupAndClose);
            this.once("upgradeError", cleanupAndClose);
        };
        if ("opening" === this.readyState || "open" === this.readyState) {
            this.readyState = "closing";
            if (this.writeBuffer.length) this.once("drain", ()=>{
                if (this.upgrading) waitForUpgrade();
                else close();
            });
            else if (this.upgrading) waitForUpgrade();
            else close();
        }
        return this;
    }
    /**
     * Called upon transport error
     *
     * @private
     */ _onError(err) {
        $9ebc607289cc7033$export$3874118029a0ee0d.priorWebsocketSuccess = false;
        if (this.opts.tryAllTransports && this.transports.length > 1 && this.readyState === "opening") {
            this.transports.shift();
            return this._open();
        }
        this.emitReserved("error", err);
        this._onClose("transport error", err);
    }
    /**
     * Called upon transport close.
     *
     * @private
     */ _onClose(reason, description) {
        if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) {
            // clear timers
            this.clearTimeoutFn(this._pingTimeoutTimer);
            // stop event from firing again for transport
            this.transport.removeAllListeners("close");
            // ensure transport won't stay open
            this.transport.close();
            // ignore further transport communication
            this.transport.removeAllListeners();
            if ($9ebc607289cc7033$var$withEventListeners) {
                if (this._beforeunloadEventListener) removeEventListener("beforeunload", this._beforeunloadEventListener, false);
                if (this._offlineEventListener) {
                    const i = $9ebc607289cc7033$var$OFFLINE_EVENT_LISTENERS.indexOf(this._offlineEventListener);
                    if (i !== -1) $9ebc607289cc7033$var$OFFLINE_EVENT_LISTENERS.splice(i, 1);
                }
            }
            // set ready state
            this.readyState = "closed";
            // clear session id
            this.id = null;
            // emit close event
            this.emitReserved("close", reason, description);
            // clean buffers after, so users can still
            // grab the buffers on `close` event
            this.writeBuffer = [];
            this._prevBufferLen = 0;
        }
    }
}
$9ebc607289cc7033$export$3874118029a0ee0d.protocol = (0, $c8a38bcb71b20bd4$export$a51d6b395ff4c65a);
class $9ebc607289cc7033$export$cc521fcb1004e85c extends $9ebc607289cc7033$export$3874118029a0ee0d {
    constructor(){
        super(...arguments);
        this._upgrades = [];
    }
    onOpen() {
        super.onOpen();
        if ("open" === this.readyState && this.opts.upgrade) for(let i = 0; i < this._upgrades.length; i++)this._probe(this._upgrades[i]);
    }
    /**
     * Probes a transport.
     *
     * @param {String} name - transport name
     * @private
     */ _probe(name) {
        let transport = this.createTransport(name);
        let failed = false;
        $9ebc607289cc7033$export$3874118029a0ee0d.priorWebsocketSuccess = false;
        const onTransportOpen = ()=>{
            if (failed) return;
            transport.send([
                {
                    type: "ping",
                    data: "probe"
                }
            ]);
            transport.once("packet", (msg)=>{
                if (failed) return;
                if ("pong" === msg.type && "probe" === msg.data) {
                    this.upgrading = true;
                    this.emitReserved("upgrading", transport);
                    if (!transport) return;
                    $9ebc607289cc7033$export$3874118029a0ee0d.priorWebsocketSuccess = "websocket" === transport.name;
                    this.transport.pause(()=>{
                        if (failed) return;
                        if ("closed" === this.readyState) return;
                        cleanup();
                        this.setTransport(transport);
                        transport.send([
                            {
                                type: "upgrade"
                            }
                        ]);
                        this.emitReserved("upgrade", transport);
                        transport = null;
                        this.upgrading = false;
                        this.flush();
                    });
                } else {
                    const err = new Error("probe error");
                    // @ts-ignore
                    err.transport = transport.name;
                    this.emitReserved("upgradeError", err);
                }
            });
        };
        function freezeTransport() {
            if (failed) return;
            // Any callback called by transport should be ignored since now
            failed = true;
            cleanup();
            transport.close();
            transport = null;
        }
        // Handle any error that happens while probing
        const onerror = (err)=>{
            const error = new Error("probe error: " + err);
            // @ts-ignore
            error.transport = transport.name;
            freezeTransport();
            this.emitReserved("upgradeError", error);
        };
        function onTransportClose() {
            onerror("transport closed");
        }
        // When the socket is closed while we're probing
        function onclose() {
            onerror("socket closed");
        }
        // When the socket is upgraded while we're probing
        function onupgrade(to) {
            if (transport && to.name !== transport.name) freezeTransport();
        }
        // Remove all listeners on the transport and on self
        const cleanup = ()=>{
            transport.removeListener("open", onTransportOpen);
            transport.removeListener("error", onerror);
            transport.removeListener("close", onTransportClose);
            this.off("close", onclose);
            this.off("upgrading", onupgrade);
        };
        transport.once("open", onTransportOpen);
        transport.once("error", onerror);
        transport.once("close", onTransportClose);
        this.once("close", onclose);
        this.once("upgrading", onupgrade);
        if (this._upgrades.indexOf("webtransport") !== -1 && name !== "webtransport") // favor WebTransport
        this.setTimeoutFn(()=>{
            if (!failed) transport.open();
        }, 200);
        else transport.open();
    }
    onHandshake(data) {
        this._upgrades = this._filterUpgrades(data.upgrades);
        super.onHandshake(data);
    }
    /**
     * Filters upgrades, returning only those matching client transports.
     *
     * @param {Array} upgrades - server upgrades
     * @private
     */ _filterUpgrades(upgrades) {
        const filteredUpgrades = [];
        for(let i = 0; i < upgrades.length; i++)if (~this.transports.indexOf(upgrades[i])) filteredUpgrades.push(upgrades[i]);
        return filteredUpgrades;
    }
}
class $9ebc607289cc7033$export$4798917dbf149b79 extends $9ebc607289cc7033$export$cc521fcb1004e85c {
    constructor(uri, opts = {}){
        const o = typeof uri === "object" ? uri : opts;
        if (!o.transports || o.transports && typeof o.transports[0] === "string") o.transports = (o.transports || [
            "polling",
            "websocket",
            "webtransport"
        ]).map((transportName)=>(0, $0cb269c4f7ff6eee$export$46dec00755c1153b)[transportName]).filter((t)=>!!t);
        super(uri, o);
    }
}








class $e79e3bad237bb244$export$1e7deca84b429035 extends (0, $4c9fe808dbd2b179$export$265ee5eefd4c309b) {
    doPoll() {
        this._fetch().then((res)=>{
            if (!res.ok) return this.onError("fetch read error", res.status, res);
            res.text().then((data)=>this.onData(data));
        }).catch((err)=>{
            this.onError("fetch read error", err);
        });
    }
    doWrite(data, callback) {
        this._fetch(data).then((res)=>{
            if (!res.ok) return this.onError("fetch write error", res.status, res);
            callback();
        }).catch((err)=>{
            this.onError("fetch write error", err);
        });
    }
    _fetch(data) {
        var _a;
        const isPost = data !== undefined;
        const headers = new Headers(this.opts.extraHeaders);
        if (isPost) headers.set("content-type", "text/plain;charset=UTF-8");
        (_a = this.socket._cookieJar) === null || _a === void 0 || _a.appendCookies(headers);
        return fetch(this.uri(), {
            method: isPost ? "POST" : "GET",
            body: isPost ? data : null,
            headers: headers,
            credentials: this.opts.withCredentials ? "include" : "omit"
        }).then((res)=>{
            var _a;
            // @ts-ignore getSetCookie() was added in Node.js v19.7.0
            (_a = this.socket._cookieJar) === null || _a === void 0 || _a.parseCookies(res.headers.getSetCookie());
            return res;
        });
    }
}







const $700d97bd566e2b49$export$a51d6b395ff4c65a = (0, $9ebc607289cc7033$export$4798917dbf149b79).protocol;


function $7d769e07affedf95$export$128fa18b7194ef(uri, path = "", loc) {
    let obj = uri;
    // default to window.location
    loc = loc || typeof location !== "undefined" && location;
    if (null == uri) uri = loc.protocol + "//" + loc.host;
    // relative path support
    if (typeof uri === "string") {
        if ("/" === uri.charAt(0)) {
            if ("/" === uri.charAt(1)) uri = loc.protocol + uri;
            else uri = loc.host + uri;
        }
        if (!/^(https?|wss?):\/\//.test(uri)) {
            if ("undefined" !== typeof loc) uri = loc.protocol + "//" + uri;
            else uri = "https://" + uri;
        }
        // parse
        obj = (0, $22f7aeedd2aef9bc$export$98e6a39c04603d36)(uri);
    }
    // make sure we treat `localhost:80` and `localhost` equally
    if (!obj.port) {
        if (/^(http|ws)$/.test(obj.protocol)) obj.port = "80";
        else if (/^(http|ws)s$/.test(obj.protocol)) obj.port = "443";
    }
    obj.path = obj.path || "/";
    const ipv6 = obj.host.indexOf(":") !== -1;
    const host = ipv6 ? "[" + obj.host + "]" : obj.host;
    // define unique id
    obj.id = obj.protocol + "://" + host + ":" + obj.port + path;
    // define href
    obj.href = obj.protocol + "://" + host + (loc && loc.port === obj.port ? "" : ":" + obj.port);
    return obj;
}



var $13da305dc812d504$exports = {};

$parcel$export($13da305dc812d504$exports, "protocol", function () { return $13da305dc812d504$export$a51d6b395ff4c65a; });
$parcel$export($13da305dc812d504$exports, "PacketType", function () { return $13da305dc812d504$export$84d4095e16c6fc19; });
$parcel$export($13da305dc812d504$exports, "Encoder", function () { return $13da305dc812d504$export$a50aceb0e02a00aa; });
$parcel$export($13da305dc812d504$exports, "Decoder", function () { return $13da305dc812d504$export$f9de6ca0bc043724; });

const $7fa6351679be186c$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
const $7fa6351679be186c$var$isView = (obj)=>{
    return typeof ArrayBuffer.isView === "function" ? ArrayBuffer.isView(obj) : obj.buffer instanceof ArrayBuffer;
};
const $7fa6351679be186c$var$toString = Object.prototype.toString;
const $7fa6351679be186c$var$withNativeBlob = typeof Blob === "function" || typeof Blob !== "undefined" && $7fa6351679be186c$var$toString.call(Blob) === "[object BlobConstructor]";
const $7fa6351679be186c$var$withNativeFile = typeof File === "function" || typeof File !== "undefined" && $7fa6351679be186c$var$toString.call(File) === "[object FileConstructor]";
function $7fa6351679be186c$export$37488ff1135b1696(obj) {
    return $7fa6351679be186c$var$withNativeArrayBuffer && (obj instanceof ArrayBuffer || $7fa6351679be186c$var$isView(obj)) || $7fa6351679be186c$var$withNativeBlob && obj instanceof Blob || $7fa6351679be186c$var$withNativeFile && obj instanceof File;
}
function $7fa6351679be186c$export$5234c529abdb5610(obj, toJSON) {
    if (!obj || typeof obj !== "object") return false;
    if (Array.isArray(obj)) {
        for(let i = 0, l = obj.length; i < l; i++){
            if ($7fa6351679be186c$export$5234c529abdb5610(obj[i])) return true;
        }
        return false;
    }
    if ($7fa6351679be186c$export$37488ff1135b1696(obj)) return true;
    if (obj.toJSON && typeof obj.toJSON === "function" && arguments.length === 1) return $7fa6351679be186c$export$5234c529abdb5610(obj.toJSON(), true);
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key) && $7fa6351679be186c$export$5234c529abdb5610(obj[key])) return true;
    }
    return false;
}


function $703f86ca7e069862$export$ac2edb9eb7af56f6(packet) {
    const buffers = [];
    const packetData = packet.data;
    const pack = packet;
    pack.data = $703f86ca7e069862$var$_deconstructPacket(packetData, buffers);
    pack.attachments = buffers.length; // number of binary 'attachments'
    return {
        packet: pack,
        buffers: buffers
    };
}
function $703f86ca7e069862$var$_deconstructPacket(data, buffers) {
    if (!data) return data;
    if ((0, $7fa6351679be186c$export$37488ff1135b1696)(data)) {
        const placeholder = {
            _placeholder: true,
            num: buffers.length
        };
        buffers.push(data);
        return placeholder;
    } else if (Array.isArray(data)) {
        const newData = new Array(data.length);
        for(let i = 0; i < data.length; i++)newData[i] = $703f86ca7e069862$var$_deconstructPacket(data[i], buffers);
        return newData;
    } else if (typeof data === "object" && !(data instanceof Date)) {
        const newData = {};
        for(const key in data)if (Object.prototype.hasOwnProperty.call(data, key)) newData[key] = $703f86ca7e069862$var$_deconstructPacket(data[key], buffers);
        return newData;
    }
    return data;
}
function $703f86ca7e069862$export$a00da3b1ec037a04(packet, buffers) {
    packet.data = $703f86ca7e069862$var$_reconstructPacket(packet.data, buffers);
    delete packet.attachments; // no longer useful
    return packet;
}
function $703f86ca7e069862$var$_reconstructPacket(data, buffers) {
    if (!data) return data;
    if (data && data._placeholder === true) {
        const isIndexValid = typeof data.num === "number" && data.num >= 0 && data.num < buffers.length;
        if (isIndexValid) return buffers[data.num]; // appropriate buffer (should be natural order anyway)
        else throw new Error("illegal attachments");
    } else if (Array.isArray(data)) for(let i = 0; i < data.length; i++)data[i] = $703f86ca7e069862$var$_reconstructPacket(data[i], buffers);
    else if (typeof data === "object") {
        for(const key in data)if (Object.prototype.hasOwnProperty.call(data, key)) data[key] = $703f86ca7e069862$var$_reconstructPacket(data[key], buffers);
    }
    return data;
}



/**
 * These strings must not be used as event names, as they have a special meaning.
 */ const $13da305dc812d504$var$RESERVED_EVENTS = [
    "connect",
    "connect_error",
    "disconnect",
    "disconnecting",
    "newListener",
    "removeListener"
];
const $13da305dc812d504$export$a51d6b395ff4c65a = 5;
var $13da305dc812d504$export$84d4095e16c6fc19;
(function(PacketType) {
    PacketType[PacketType["CONNECT"] = 0] = "CONNECT";
    PacketType[PacketType["DISCONNECT"] = 1] = "DISCONNECT";
    PacketType[PacketType["EVENT"] = 2] = "EVENT";
    PacketType[PacketType["ACK"] = 3] = "ACK";
    PacketType[PacketType["CONNECT_ERROR"] = 4] = "CONNECT_ERROR";
    PacketType[PacketType["BINARY_EVENT"] = 5] = "BINARY_EVENT";
    PacketType[PacketType["BINARY_ACK"] = 6] = "BINARY_ACK";
})($13da305dc812d504$export$84d4095e16c6fc19 || ($13da305dc812d504$export$84d4095e16c6fc19 = {}));
class $13da305dc812d504$export$a50aceb0e02a00aa {
    /**
     * Encoder constructor
     *
     * @param {function} replacer - custom replacer to pass down to JSON.parse
     */ constructor(replacer){
        this.replacer = replacer;
    }
    /**
     * Encode a packet as a single string if non-binary, or as a
     * buffer sequence, depending on packet type.
     *
     * @param {Object} obj - packet object
     */ encode(obj) {
        if (obj.type === $13da305dc812d504$export$84d4095e16c6fc19.EVENT || obj.type === $13da305dc812d504$export$84d4095e16c6fc19.ACK) {
            if ((0, $7fa6351679be186c$export$5234c529abdb5610)(obj)) return this.encodeAsBinary({
                type: obj.type === $13da305dc812d504$export$84d4095e16c6fc19.EVENT ? $13da305dc812d504$export$84d4095e16c6fc19.BINARY_EVENT : $13da305dc812d504$export$84d4095e16c6fc19.BINARY_ACK,
                nsp: obj.nsp,
                data: obj.data,
                id: obj.id
            });
        }
        return [
            this.encodeAsString(obj)
        ];
    }
    /**
     * Encode packet as string.
     */ encodeAsString(obj) {
        // first is type
        let str = "" + obj.type;
        // attachments if we have them
        if (obj.type === $13da305dc812d504$export$84d4095e16c6fc19.BINARY_EVENT || obj.type === $13da305dc812d504$export$84d4095e16c6fc19.BINARY_ACK) str += obj.attachments + "-";
        // if we have a namespace other than `/`
        // we append it followed by a comma `,`
        if (obj.nsp && "/" !== obj.nsp) str += obj.nsp + ",";
        // immediately followed by the id
        if (null != obj.id) str += obj.id;
        // json data
        if (null != obj.data) str += JSON.stringify(obj.data, this.replacer);
        return str;
    }
    /**
     * Encode packet as 'buffer sequence' by removing blobs, and
     * deconstructing packet into object with placeholders and
     * a list of buffers.
     */ encodeAsBinary(obj) {
        const deconstruction = (0, $703f86ca7e069862$export$ac2edb9eb7af56f6)(obj);
        const pack = this.encodeAsString(deconstruction.packet);
        const buffers = deconstruction.buffers;
        buffers.unshift(pack); // add packet info to beginning of data list
        return buffers; // write all the buffers
    }
}
// see https://stackoverflow.com/questions/8511281/check-if-a-value-is-an-object-in-javascript
function $13da305dc812d504$var$isObject(value) {
    return Object.prototype.toString.call(value) === "[object Object]";
}
class $13da305dc812d504$export$f9de6ca0bc043724 extends (0, $bd7e26f198897caa$export$4293555f241ae35a) {
    /**
     * Decoder constructor
     *
     * @param {function} reviver - custom reviver to pass down to JSON.stringify
     */ constructor(reviver){
        super();
        this.reviver = reviver;
    }
    /**
     * Decodes an encoded packet string into packet JSON.
     *
     * @param {String} obj - encoded packet
     */ add(obj) {
        let packet;
        if (typeof obj === "string") {
            if (this.reconstructor) throw new Error("got plaintext data when reconstructing a packet");
            packet = this.decodeString(obj);
            const isBinaryEvent = packet.type === $13da305dc812d504$export$84d4095e16c6fc19.BINARY_EVENT;
            if (isBinaryEvent || packet.type === $13da305dc812d504$export$84d4095e16c6fc19.BINARY_ACK) {
                packet.type = isBinaryEvent ? $13da305dc812d504$export$84d4095e16c6fc19.EVENT : $13da305dc812d504$export$84d4095e16c6fc19.ACK;
                // binary packet's json
                this.reconstructor = new $13da305dc812d504$var$BinaryReconstructor(packet);
                // no attachments, labeled binary but no binary data to follow
                if (packet.attachments === 0) super.emitReserved("decoded", packet);
            } else // non-binary full packet
            super.emitReserved("decoded", packet);
        } else if ((0, $7fa6351679be186c$export$37488ff1135b1696)(obj) || obj.base64) {
            // raw binary data
            if (!this.reconstructor) throw new Error("got binary data when not reconstructing a packet");
            else {
                packet = this.reconstructor.takeBinaryData(obj);
                if (packet) {
                    // received final buffer
                    this.reconstructor = null;
                    super.emitReserved("decoded", packet);
                }
            }
        } else throw new Error("Unknown type: " + obj);
    }
    /**
     * Decode a packet String (JSON data)
     *
     * @param {String} str
     * @return {Object} packet
     */ decodeString(str) {
        let i = 0;
        // look up type
        const p = {
            type: Number(str.charAt(0))
        };
        if ($13da305dc812d504$export$84d4095e16c6fc19[p.type] === undefined) throw new Error("unknown packet type " + p.type);
        // look up attachments if type binary
        if (p.type === $13da305dc812d504$export$84d4095e16c6fc19.BINARY_EVENT || p.type === $13da305dc812d504$export$84d4095e16c6fc19.BINARY_ACK) {
            const start = i + 1;
            while(str.charAt(++i) !== "-" && i != str.length);
            const buf = str.substring(start, i);
            if (buf != Number(buf) || str.charAt(i) !== "-") throw new Error("Illegal attachments");
            p.attachments = Number(buf);
        }
        // look up namespace (if any)
        if ("/" === str.charAt(i + 1)) {
            const start = i + 1;
            while(++i){
                const c = str.charAt(i);
                if ("," === c) break;
                if (i === str.length) break;
            }
            p.nsp = str.substring(start, i);
        } else p.nsp = "/";
        // look up id
        const next = str.charAt(i + 1);
        if ("" !== next && Number(next) == next) {
            const start = i + 1;
            while(++i){
                const c = str.charAt(i);
                if (null == c || Number(c) != c) {
                    --i;
                    break;
                }
                if (i === str.length) break;
            }
            p.id = Number(str.substring(start, i + 1));
        }
        // look up json data
        if (str.charAt(++i)) {
            const payload = this.tryParse(str.substr(i));
            if ($13da305dc812d504$export$f9de6ca0bc043724.isPayloadValid(p.type, payload)) p.data = payload;
            else throw new Error("invalid payload");
        }
        return p;
    }
    tryParse(str) {
        try {
            return JSON.parse(str, this.reviver);
        } catch (e) {
            return false;
        }
    }
    static isPayloadValid(type, payload) {
        switch(type){
            case $13da305dc812d504$export$84d4095e16c6fc19.CONNECT:
                return $13da305dc812d504$var$isObject(payload);
            case $13da305dc812d504$export$84d4095e16c6fc19.DISCONNECT:
                return payload === undefined;
            case $13da305dc812d504$export$84d4095e16c6fc19.CONNECT_ERROR:
                return typeof payload === "string" || $13da305dc812d504$var$isObject(payload);
            case $13da305dc812d504$export$84d4095e16c6fc19.EVENT:
            case $13da305dc812d504$export$84d4095e16c6fc19.BINARY_EVENT:
                return Array.isArray(payload) && (typeof payload[0] === "number" || typeof payload[0] === "string" && $13da305dc812d504$var$RESERVED_EVENTS.indexOf(payload[0]) === -1);
            case $13da305dc812d504$export$84d4095e16c6fc19.ACK:
            case $13da305dc812d504$export$84d4095e16c6fc19.BINARY_ACK:
                return Array.isArray(payload);
        }
    }
    /**
     * Deallocates a parser's resources
     */ destroy() {
        if (this.reconstructor) {
            this.reconstructor.finishedReconstruction();
            this.reconstructor = null;
        }
    }
}
/**
 * A manager of a binary event's 'buffer sequence'. Should
 * be constructed whenever a packet of type BINARY_EVENT is
 * decoded.
 *
 * @param {Object} packet
 * @return {BinaryReconstructor} initialized reconstructor
 */ class $13da305dc812d504$var$BinaryReconstructor {
    constructor(packet){
        this.packet = packet;
        this.buffers = [];
        this.reconPack = packet;
    }
    /**
     * Method to be called when binary data received from connection
     * after a BINARY_EVENT packet.
     *
     * @param {Buffer | ArrayBuffer} binData - the raw binary data received
     * @return {null | Object} returns null if more binary data is expected or
     *   a reconstructed packet object if all buffers have been received.
     */ takeBinaryData(binData) {
        this.buffers.push(binData);
        if (this.buffers.length === this.reconPack.attachments) {
            // done with buffer list
            const packet = (0, $703f86ca7e069862$export$a00da3b1ec037a04)(this.reconPack, this.buffers);
            this.finishedReconstruction();
            return packet;
        }
        return null;
    }
    /**
     * Cleans up binary packet reconstruction variables.
     */ finishedReconstruction() {
        this.reconPack = null;
        this.buffers = [];
    }
}


function $28bdc64516b067d7$export$af631764ddc44097(obj, ev, fn) {
    obj.on(ev, fn);
    return function subDestroy() {
        obj.off(ev, fn);
    };
}



/**
 * Internal events.
 * These events can't be emitted by the user.
 */ const $ddd773b6996dfbad$var$RESERVED_EVENTS = Object.freeze({
    connect: 1,
    connect_error: 1,
    disconnect: 1,
    disconnecting: 1,
    // EventEmitter reserved events: https://nodejs.org/api/events.html#events_event_newlistener
    newListener: 1,
    removeListener: 1
});
class $ddd773b6996dfbad$export$4798917dbf149b79 extends (0, $bd7e26f198897caa$export$4293555f241ae35a) {
    /**
     * `Socket` constructor.
     */ constructor(io, nsp, opts){
        super();
        /**
         * Whether the socket is currently connected to the server.
         *
         * @example
         * const socket = io();
         *
         * socket.on("connect", () => {
         *   console.log(socket.connected); // true
         * });
         *
         * socket.on("disconnect", () => {
         *   console.log(socket.connected); // false
         * });
         */ this.connected = false;
        /**
         * Whether the connection state was recovered after a temporary disconnection. In that case, any missed packets will
         * be transmitted by the server.
         */ this.recovered = false;
        /**
         * Buffer for packets received before the CONNECT packet
         */ this.receiveBuffer = [];
        /**
         * Buffer for packets that will be sent once the socket is connected
         */ this.sendBuffer = [];
        /**
         * The queue of packets to be sent with retry in case of failure.
         *
         * Packets are sent one by one, each waiting for the server acknowledgement, in order to guarantee the delivery order.
         * @private
         */ this._queue = [];
        /**
         * A sequence to generate the ID of the {@link QueuedPacket}.
         * @private
         */ this._queueSeq = 0;
        this.ids = 0;
        /**
         * A map containing acknowledgement handlers.
         *
         * The `withError` attribute is used to differentiate handlers that accept an error as first argument:
         *
         * - `socket.emit("test", (err, value) => { ... })` with `ackTimeout` option
         * - `socket.timeout(5000).emit("test", (err, value) => { ... })`
         * - `const value = await socket.emitWithAck("test")`
         *
         * From those that don't:
         *
         * - `socket.emit("test", (value) => { ... });`
         *
         * In the first case, the handlers will be called with an error when:
         *
         * - the timeout is reached
         * - the socket gets disconnected
         *
         * In the second case, the handlers will be simply discarded upon disconnection, since the client will never receive
         * an acknowledgement from the server.
         *
         * @private
         */ this.acks = {};
        this.flags = {};
        this.io = io;
        this.nsp = nsp;
        if (opts && opts.auth) this.auth = opts.auth;
        this._opts = Object.assign({}, opts);
        if (this.io._autoConnect) this.open();
    }
    /**
     * Whether the socket is currently disconnected
     *
     * @example
     * const socket = io();
     *
     * socket.on("connect", () => {
     *   console.log(socket.disconnected); // false
     * });
     *
     * socket.on("disconnect", () => {
     *   console.log(socket.disconnected); // true
     * });
     */ get disconnected() {
        return !this.connected;
    }
    /**
     * Subscribe to open, close and packet events
     *
     * @private
     */ subEvents() {
        if (this.subs) return;
        const io = this.io;
        this.subs = [
            (0, $28bdc64516b067d7$export$af631764ddc44097)(io, "open", this.onopen.bind(this)),
            (0, $28bdc64516b067d7$export$af631764ddc44097)(io, "packet", this.onpacket.bind(this)),
            (0, $28bdc64516b067d7$export$af631764ddc44097)(io, "error", this.onerror.bind(this)),
            (0, $28bdc64516b067d7$export$af631764ddc44097)(io, "close", this.onclose.bind(this))
        ];
    }
    /**
     * Whether the Socket will try to reconnect when its Manager connects or reconnects.
     *
     * @example
     * const socket = io();
     *
     * console.log(socket.active); // true
     *
     * socket.on("disconnect", (reason) => {
     *   if (reason === "io server disconnect") {
     *     // the disconnection was initiated by the server, you need to manually reconnect
     *     console.log(socket.active); // false
     *   }
     *   // else the socket will automatically try to reconnect
     *   console.log(socket.active); // true
     * });
     */ get active() {
        return !!this.subs;
    }
    /**
     * "Opens" the socket.
     *
     * @example
     * const socket = io({
     *   autoConnect: false
     * });
     *
     * socket.connect();
     */ connect() {
        if (this.connected) return this;
        this.subEvents();
        if (!this.io["_reconnecting"]) this.io.open(); // ensure open
        if ("open" === this.io._readyState) this.onopen();
        return this;
    }
    /**
     * Alias for {@link connect()}.
     */ open() {
        return this.connect();
    }
    /**
     * Sends a `message` event.
     *
     * This method mimics the WebSocket.send() method.
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/API/WebSocket/send
     *
     * @example
     * socket.send("hello");
     *
     * // this is equivalent to
     * socket.emit("message", "hello");
     *
     * @return self
     */ send(...args) {
        args.unshift("message");
        this.emit.apply(this, args);
        return this;
    }
    /**
     * Override `emit`.
     * If the event is in `events`, it's emitted normally.
     *
     * @example
     * socket.emit("hello", "world");
     *
     * // all serializable datastructures are supported (no need to call JSON.stringify)
     * socket.emit("hello", 1, "2", { 3: ["4"], 5: Uint8Array.from([6]) });
     *
     * // with an acknowledgement from the server
     * socket.emit("hello", "world", (val) => {
     *   // ...
     * });
     *
     * @return self
     */ emit(ev, ...args) {
        var _a, _b, _c;
        if ($ddd773b6996dfbad$var$RESERVED_EVENTS.hasOwnProperty(ev)) throw new Error('"' + ev.toString() + '" is a reserved event name');
        args.unshift(ev);
        if (this._opts.retries && !this.flags.fromQueue && !this.flags.volatile) {
            this._addToQueue(args);
            return this;
        }
        const packet = {
            type: (0, $13da305dc812d504$export$84d4095e16c6fc19).EVENT,
            data: args
        };
        packet.options = {};
        packet.options.compress = this.flags.compress !== false;
        // event ack callback
        if ("function" === typeof args[args.length - 1]) {
            const id = this.ids++;
            const ack = args.pop();
            this._registerAckCallback(id, ack);
            packet.id = id;
        }
        const isTransportWritable = (_b = (_a = this.io.engine) === null || _a === void 0 ? void 0 : _a.transport) === null || _b === void 0 ? void 0 : _b.writable;
        const isConnected = this.connected && !((_c = this.io.engine) === null || _c === void 0 ? void 0 : _c._hasPingExpired());
        const discardPacket = this.flags.volatile && !isTransportWritable;
        if (discardPacket) ;
        else if (isConnected) {
            this.notifyOutgoingListeners(packet);
            this.packet(packet);
        } else this.sendBuffer.push(packet);
        this.flags = {};
        return this;
    }
    /**
     * @private
     */ _registerAckCallback(id, ack) {
        var _a;
        const timeout = (_a = this.flags.timeout) !== null && _a !== void 0 ? _a : this._opts.ackTimeout;
        if (timeout === undefined) {
            this.acks[id] = ack;
            return;
        }
        // @ts-ignore
        const timer = this.io.setTimeoutFn(()=>{
            delete this.acks[id];
            for(let i = 0; i < this.sendBuffer.length; i++)if (this.sendBuffer[i].id === id) this.sendBuffer.splice(i, 1);
            ack.call(this, new Error("operation has timed out"));
        }, timeout);
        const fn = (...args)=>{
            // @ts-ignore
            this.io.clearTimeoutFn(timer);
            ack.apply(this, args);
        };
        fn.withError = true;
        this.acks[id] = fn;
    }
    /**
     * Emits an event and waits for an acknowledgement
     *
     * @example
     * // without timeout
     * const response = await socket.emitWithAck("hello", "world");
     *
     * // with a specific timeout
     * try {
     *   const response = await socket.timeout(1000).emitWithAck("hello", "world");
     * } catch (err) {
     *   // the server did not acknowledge the event in the given delay
     * }
     *
     * @return a Promise that will be fulfilled when the server acknowledges the event
     */ emitWithAck(ev, ...args) {
        return new Promise((resolve, reject)=>{
            const fn = (arg1, arg2)=>{
                return arg1 ? reject(arg1) : resolve(arg2);
            };
            fn.withError = true;
            args.push(fn);
            this.emit(ev, ...args);
        });
    }
    /**
     * Add the packet to the queue.
     * @param args
     * @private
     */ _addToQueue(args) {
        let ack;
        if (typeof args[args.length - 1] === "function") ack = args.pop();
        const packet = {
            id: this._queueSeq++,
            tryCount: 0,
            pending: false,
            args: args,
            flags: Object.assign({
                fromQueue: true
            }, this.flags)
        };
        args.push((err, ...responseArgs)=>{
            if (packet !== this._queue[0]) // the packet has already been acknowledged
            return;
            const hasError = err !== null;
            if (hasError) {
                if (packet.tryCount > this._opts.retries) {
                    this._queue.shift();
                    if (ack) ack(err);
                }
            } else {
                this._queue.shift();
                if (ack) ack(null, ...responseArgs);
            }
            packet.pending = false;
            return this._drainQueue();
        });
        this._queue.push(packet);
        this._drainQueue();
    }
    /**
     * Send the first packet of the queue, and wait for an acknowledgement from the server.
     * @param force - whether to resend a packet that has not been acknowledged yet
     *
     * @private
     */ _drainQueue(force = false) {
        if (!this.connected || this._queue.length === 0) return;
        const packet = this._queue[0];
        if (packet.pending && !force) return;
        packet.pending = true;
        packet.tryCount++;
        this.flags = packet.flags;
        this.emit.apply(this, packet.args);
    }
    /**
     * Sends a packet.
     *
     * @param packet
     * @private
     */ packet(packet) {
        packet.nsp = this.nsp;
        this.io._packet(packet);
    }
    /**
     * Called upon engine `open`.
     *
     * @private
     */ onopen() {
        if (typeof this.auth == "function") this.auth((data)=>{
            this._sendConnectPacket(data);
        });
        else this._sendConnectPacket(this.auth);
    }
    /**
     * Sends a CONNECT packet to initiate the Socket.IO session.
     *
     * @param data
     * @private
     */ _sendConnectPacket(data) {
        this.packet({
            type: (0, $13da305dc812d504$export$84d4095e16c6fc19).CONNECT,
            data: this._pid ? Object.assign({
                pid: this._pid,
                offset: this._lastOffset
            }, data) : data
        });
    }
    /**
     * Called upon engine or manager `error`.
     *
     * @param err
     * @private
     */ onerror(err) {
        if (!this.connected) this.emitReserved("connect_error", err);
    }
    /**
     * Called upon engine `close`.
     *
     * @param reason
     * @param description
     * @private
     */ onclose(reason, description) {
        this.connected = false;
        delete this.id;
        this.emitReserved("disconnect", reason, description);
        this._clearAcks();
    }
    /**
     * Clears the acknowledgement handlers upon disconnection, since the client will never receive an acknowledgement from
     * the server.
     *
     * @private
     */ _clearAcks() {
        Object.keys(this.acks).forEach((id)=>{
            const isBuffered = this.sendBuffer.some((packet)=>String(packet.id) === id);
            if (!isBuffered) {
                // note: handlers that do not accept an error as first argument are ignored here
                const ack = this.acks[id];
                delete this.acks[id];
                if (ack.withError) ack.call(this, new Error("socket has been disconnected"));
            }
        });
    }
    /**
     * Called with socket packet.
     *
     * @param packet
     * @private
     */ onpacket(packet) {
        const sameNamespace = packet.nsp === this.nsp;
        if (!sameNamespace) return;
        switch(packet.type){
            case (0, $13da305dc812d504$export$84d4095e16c6fc19).CONNECT:
                if (packet.data && packet.data.sid) this.onconnect(packet.data.sid, packet.data.pid);
                else this.emitReserved("connect_error", new Error("It seems you are trying to reach a Socket.IO server in v2.x with a v3.x client, but they are not compatible (more information here: https://socket.io/docs/v3/migrating-from-2-x-to-3-0/)"));
                break;
            case (0, $13da305dc812d504$export$84d4095e16c6fc19).EVENT:
            case (0, $13da305dc812d504$export$84d4095e16c6fc19).BINARY_EVENT:
                this.onevent(packet);
                break;
            case (0, $13da305dc812d504$export$84d4095e16c6fc19).ACK:
            case (0, $13da305dc812d504$export$84d4095e16c6fc19).BINARY_ACK:
                this.onack(packet);
                break;
            case (0, $13da305dc812d504$export$84d4095e16c6fc19).DISCONNECT:
                this.ondisconnect();
                break;
            case (0, $13da305dc812d504$export$84d4095e16c6fc19).CONNECT_ERROR:
                this.destroy();
                const err = new Error(packet.data.message);
                // @ts-ignore
                err.data = packet.data.data;
                this.emitReserved("connect_error", err);
                break;
        }
    }
    /**
     * Called upon a server event.
     *
     * @param packet
     * @private
     */ onevent(packet) {
        const args = packet.data || [];
        if (null != packet.id) args.push(this.ack(packet.id));
        if (this.connected) this.emitEvent(args);
        else this.receiveBuffer.push(Object.freeze(args));
    }
    emitEvent(args) {
        if (this._anyListeners && this._anyListeners.length) {
            const listeners = this._anyListeners.slice();
            for (const listener of listeners)listener.apply(this, args);
        }
        super.emit.apply(this, args);
        if (this._pid && args.length && typeof args[args.length - 1] === "string") this._lastOffset = args[args.length - 1];
    }
    /**
     * Produces an ack callback to emit with an event.
     *
     * @private
     */ ack(id) {
        const self = this;
        let sent = false;
        return function(...args) {
            // prevent double callbacks
            if (sent) return;
            sent = true;
            self.packet({
                type: (0, $13da305dc812d504$export$84d4095e16c6fc19).ACK,
                id: id,
                data: args
            });
        };
    }
    /**
     * Called upon a server acknowledgement.
     *
     * @param packet
     * @private
     */ onack(packet) {
        const ack = this.acks[packet.id];
        if (typeof ack !== "function") return;
        delete this.acks[packet.id];
        // @ts-ignore FIXME ack is incorrectly inferred as 'never'
        if (ack.withError) packet.data.unshift(null);
        // @ts-ignore
        ack.apply(this, packet.data);
    }
    /**
     * Called upon server connect.
     *
     * @private
     */ onconnect(id, pid) {
        this.id = id;
        this.recovered = pid && this._pid === pid;
        this._pid = pid; // defined only if connection state recovery is enabled
        this.connected = true;
        this.emitBuffered();
        this.emitReserved("connect");
        this._drainQueue(true);
    }
    /**
     * Emit buffered events (received and emitted).
     *
     * @private
     */ emitBuffered() {
        this.receiveBuffer.forEach((args)=>this.emitEvent(args));
        this.receiveBuffer = [];
        this.sendBuffer.forEach((packet)=>{
            this.notifyOutgoingListeners(packet);
            this.packet(packet);
        });
        this.sendBuffer = [];
    }
    /**
     * Called upon server disconnect.
     *
     * @private
     */ ondisconnect() {
        this.destroy();
        this.onclose("io server disconnect");
    }
    /**
     * Called upon forced client/server side disconnections,
     * this method ensures the manager stops tracking us and
     * that reconnections don't get triggered for this.
     *
     * @private
     */ destroy() {
        if (this.subs) {
            // clean subscriptions to avoid reconnections
            this.subs.forEach((subDestroy)=>subDestroy());
            this.subs = undefined;
        }
        this.io["_destroy"](this);
    }
    /**
     * Disconnects the socket manually. In that case, the socket will not try to reconnect.
     *
     * If this is the last active Socket instance of the {@link Manager}, the low-level connection will be closed.
     *
     * @example
     * const socket = io();
     *
     * socket.on("disconnect", (reason) => {
     *   // console.log(reason); prints "io client disconnect"
     * });
     *
     * socket.disconnect();
     *
     * @return self
     */ disconnect() {
        if (this.connected) this.packet({
            type: (0, $13da305dc812d504$export$84d4095e16c6fc19).DISCONNECT
        });
        // remove socket from pool
        this.destroy();
        if (this.connected) // fire events
        this.onclose("io client disconnect");
        return this;
    }
    /**
     * Alias for {@link disconnect()}.
     *
     * @return self
     */ close() {
        return this.disconnect();
    }
    /**
     * Sets the compress flag.
     *
     * @example
     * socket.compress(false).emit("hello");
     *
     * @param compress - if `true`, compresses the sending data
     * @return self
     */ compress(compress) {
        this.flags.compress = compress;
        return this;
    }
    /**
     * Sets a modifier for a subsequent event emission that the event message will be dropped when this socket is not
     * ready to send messages.
     *
     * @example
     * socket.volatile.emit("hello"); // the server may or may not receive it
     *
     * @returns self
     */ get volatile() {
        this.flags.volatile = true;
        return this;
    }
    /**
     * Sets a modifier for a subsequent event emission that the callback will be called with an error when the
     * given number of milliseconds have elapsed without an acknowledgement from the server:
     *
     * @example
     * socket.timeout(5000).emit("my-event", (err) => {
     *   if (err) {
     *     // the server did not acknowledge the event in the given delay
     *   }
     * });
     *
     * @returns self
     */ timeout(timeout) {
        this.flags.timeout = timeout;
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback.
     *
     * @example
     * socket.onAny((event, ...args) => {
     *   console.log(`got ${event}`);
     * });
     *
     * @param listener
     */ onAny(listener) {
        this._anyListeners = this._anyListeners || [];
        this._anyListeners.push(listener);
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback. The listener is added to the beginning of the listeners array.
     *
     * @example
     * socket.prependAny((event, ...args) => {
     *   console.log(`got event ${event}`);
     * });
     *
     * @param listener
     */ prependAny(listener) {
        this._anyListeners = this._anyListeners || [];
        this._anyListeners.unshift(listener);
        return this;
    }
    /**
     * Removes the listener that will be fired when any event is emitted.
     *
     * @example
     * const catchAllListener = (event, ...args) => {
     *   console.log(`got event ${event}`);
     * }
     *
     * socket.onAny(catchAllListener);
     *
     * // remove a specific listener
     * socket.offAny(catchAllListener);
     *
     * // or remove all listeners
     * socket.offAny();
     *
     * @param listener
     */ offAny(listener) {
        if (!this._anyListeners) return this;
        if (listener) {
            const listeners = this._anyListeners;
            for(let i = 0; i < listeners.length; i++)if (listener === listeners[i]) {
                listeners.splice(i, 1);
                return this;
            }
        } else this._anyListeners = [];
        return this;
    }
    /**
     * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
     * e.g. to remove listeners.
     */ listenersAny() {
        return this._anyListeners || [];
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback.
     *
     * Note: acknowledgements sent to the server are not included.
     *
     * @example
     * socket.onAnyOutgoing((event, ...args) => {
     *   console.log(`sent event ${event}`);
     * });
     *
     * @param listener
     */ onAnyOutgoing(listener) {
        this._anyOutgoingListeners = this._anyOutgoingListeners || [];
        this._anyOutgoingListeners.push(listener);
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback. The listener is added to the beginning of the listeners array.
     *
     * Note: acknowledgements sent to the server are not included.
     *
     * @example
     * socket.prependAnyOutgoing((event, ...args) => {
     *   console.log(`sent event ${event}`);
     * });
     *
     * @param listener
     */ prependAnyOutgoing(listener) {
        this._anyOutgoingListeners = this._anyOutgoingListeners || [];
        this._anyOutgoingListeners.unshift(listener);
        return this;
    }
    /**
     * Removes the listener that will be fired when any event is emitted.
     *
     * @example
     * const catchAllListener = (event, ...args) => {
     *   console.log(`sent event ${event}`);
     * }
     *
     * socket.onAnyOutgoing(catchAllListener);
     *
     * // remove a specific listener
     * socket.offAnyOutgoing(catchAllListener);
     *
     * // or remove all listeners
     * socket.offAnyOutgoing();
     *
     * @param [listener] - the catch-all listener (optional)
     */ offAnyOutgoing(listener) {
        if (!this._anyOutgoingListeners) return this;
        if (listener) {
            const listeners = this._anyOutgoingListeners;
            for(let i = 0; i < listeners.length; i++)if (listener === listeners[i]) {
                listeners.splice(i, 1);
                return this;
            }
        } else this._anyOutgoingListeners = [];
        return this;
    }
    /**
     * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
     * e.g. to remove listeners.
     */ listenersAnyOutgoing() {
        return this._anyOutgoingListeners || [];
    }
    /**
     * Notify the listeners for each packet sent
     *
     * @param packet
     *
     * @private
     */ notifyOutgoingListeners(packet) {
        if (this._anyOutgoingListeners && this._anyOutgoingListeners.length) {
            const listeners = this._anyOutgoingListeners.slice();
            for (const listener of listeners)listener.apply(this, packet.data);
        }
    }
}




/**
 * Initialize backoff timer with `opts`.
 *
 * - `min` initial timeout in milliseconds [100]
 * - `max` max timeout [10000]
 * - `jitter` [0]
 * - `factor` [2]
 *
 * @param {Object} opts
 * @api public
 */ function $ee0df5f01f97328c$export$2d38012449449c89(opts) {
    opts = opts || {};
    this.ms = opts.min || 100;
    this.max = opts.max || 10000;
    this.factor = opts.factor || 2;
    this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
    this.attempts = 0;
}
/**
 * Return the backoff duration.
 *
 * @return {Number}
 * @api public
 */ $ee0df5f01f97328c$export$2d38012449449c89.prototype.duration = function() {
    var ms = this.ms * Math.pow(this.factor, this.attempts++);
    if (this.jitter) {
        var rand = Math.random();
        var deviation = Math.floor(rand * this.jitter * ms);
        ms = (Math.floor(rand * 10) & 1) == 0 ? ms - deviation : ms + deviation;
    }
    return Math.min(ms, this.max) | 0;
};
/**
 * Reset the number of attempts.
 *
 * @api public
 */ $ee0df5f01f97328c$export$2d38012449449c89.prototype.reset = function() {
    this.attempts = 0;
};
/**
 * Set the minimum duration
 *
 * @api public
 */ $ee0df5f01f97328c$export$2d38012449449c89.prototype.setMin = function(min) {
    this.ms = min;
};
/**
 * Set the maximum duration
 *
 * @api public
 */ $ee0df5f01f97328c$export$2d38012449449c89.prototype.setMax = function(max) {
    this.max = max;
};
/**
 * Set the jitter
 *
 * @api public
 */ $ee0df5f01f97328c$export$2d38012449449c89.prototype.setJitter = function(jitter) {
    this.jitter = jitter;
};



class $01e6adc4d3f15cb7$export$d0d38e7dec7a1a61 extends (0, $bd7e26f198897caa$export$4293555f241ae35a) {
    constructor(uri, opts){
        var _a;
        super();
        this.nsps = {};
        this.subs = [];
        if (uri && "object" === typeof uri) {
            opts = uri;
            uri = undefined;
        }
        opts = opts || {};
        opts.path = opts.path || "/socket.io";
        this.opts = opts;
        (0, $e34120c3d721494a$export$2f67576668b97183)(this, opts);
        this.reconnection(opts.reconnection !== false);
        this.reconnectionAttempts(opts.reconnectionAttempts || Infinity);
        this.reconnectionDelay(opts.reconnectionDelay || 1000);
        this.reconnectionDelayMax(opts.reconnectionDelayMax || 5000);
        this.randomizationFactor((_a = opts.randomizationFactor) !== null && _a !== void 0 ? _a : 0.5);
        this.backoff = new (0, $ee0df5f01f97328c$export$2d38012449449c89)({
            min: this.reconnectionDelay(),
            max: this.reconnectionDelayMax(),
            jitter: this.randomizationFactor()
        });
        this.timeout(null == opts.timeout ? 20000 : opts.timeout);
        this._readyState = "closed";
        this.uri = uri;
        const _parser = opts.parser || $13da305dc812d504$exports;
        this.encoder = new _parser.Encoder();
        this.decoder = new _parser.Decoder();
        this._autoConnect = opts.autoConnect !== false;
        if (this._autoConnect) this.open();
    }
    reconnection(v) {
        if (!arguments.length) return this._reconnection;
        this._reconnection = !!v;
        if (!v) this.skipReconnect = true;
        return this;
    }
    reconnectionAttempts(v) {
        if (v === undefined) return this._reconnectionAttempts;
        this._reconnectionAttempts = v;
        return this;
    }
    reconnectionDelay(v) {
        var _a;
        if (v === undefined) return this._reconnectionDelay;
        this._reconnectionDelay = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setMin(v);
        return this;
    }
    randomizationFactor(v) {
        var _a;
        if (v === undefined) return this._randomizationFactor;
        this._randomizationFactor = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setJitter(v);
        return this;
    }
    reconnectionDelayMax(v) {
        var _a;
        if (v === undefined) return this._reconnectionDelayMax;
        this._reconnectionDelayMax = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setMax(v);
        return this;
    }
    timeout(v) {
        if (!arguments.length) return this._timeout;
        this._timeout = v;
        return this;
    }
    /**
     * Starts trying to reconnect if reconnection is enabled and we have not
     * started reconnecting yet
     *
     * @private
     */ maybeReconnectOnOpen() {
        // Only try to reconnect if it's the first time we're connecting
        if (!this._reconnecting && this._reconnection && this.backoff.attempts === 0) // keeps reconnection from firing twice for the same reconnection loop
        this.reconnect();
    }
    /**
     * Sets the current transport `socket`.
     *
     * @param {Function} fn - optional, callback
     * @return self
     * @public
     */ open(fn) {
        if (~this._readyState.indexOf("open")) return this;
        this.engine = new (0, $9ebc607289cc7033$export$4798917dbf149b79)(this.uri, this.opts);
        const socket = this.engine;
        const self = this;
        this._readyState = "opening";
        this.skipReconnect = false;
        // emit `open`
        const openSubDestroy = (0, $28bdc64516b067d7$export$af631764ddc44097)(socket, "open", function() {
            self.onopen();
            fn && fn();
        });
        const onError = (err)=>{
            this.cleanup();
            this._readyState = "closed";
            this.emitReserved("error", err);
            if (fn) fn(err);
            else // Only do this if there is no fn to handle the error
            this.maybeReconnectOnOpen();
        };
        // emit `error`
        const errorSub = (0, $28bdc64516b067d7$export$af631764ddc44097)(socket, "error", onError);
        if (false !== this._timeout) {
            const timeout = this._timeout;
            // set timer
            const timer = this.setTimeoutFn(()=>{
                openSubDestroy();
                onError(new Error("timeout"));
                socket.close();
            }, timeout);
            if (this.opts.autoUnref) timer.unref();
            this.subs.push(()=>{
                this.clearTimeoutFn(timer);
            });
        }
        this.subs.push(openSubDestroy);
        this.subs.push(errorSub);
        return this;
    }
    /**
     * Alias for open()
     *
     * @return self
     * @public
     */ connect(fn) {
        return this.open(fn);
    }
    /**
     * Called upon transport open.
     *
     * @private
     */ onopen() {
        // clear old subs
        this.cleanup();
        // mark as open
        this._readyState = "open";
        this.emitReserved("open");
        // add new subs
        const socket = this.engine;
        this.subs.push((0, $28bdc64516b067d7$export$af631764ddc44097)(socket, "ping", this.onping.bind(this)), (0, $28bdc64516b067d7$export$af631764ddc44097)(socket, "data", this.ondata.bind(this)), (0, $28bdc64516b067d7$export$af631764ddc44097)(socket, "error", this.onerror.bind(this)), (0, $28bdc64516b067d7$export$af631764ddc44097)(socket, "close", this.onclose.bind(this)), // @ts-ignore
        (0, $28bdc64516b067d7$export$af631764ddc44097)(this.decoder, "decoded", this.ondecoded.bind(this)));
    }
    /**
     * Called upon a ping.
     *
     * @private
     */ onping() {
        this.emitReserved("ping");
    }
    /**
     * Called with data.
     *
     * @private
     */ ondata(data) {
        try {
            this.decoder.add(data);
        } catch (e) {
            this.onclose("parse error", e);
        }
    }
    /**
     * Called when parser fully decodes a packet.
     *
     * @private
     */ ondecoded(packet) {
        // the nextTick call prevents an exception in a user-provided event listener from triggering a disconnection due to a "parse error"
        (0, $296c7d23957f3d69$export$bdd553fddd433dcb)(()=>{
            this.emitReserved("packet", packet);
        }, this.setTimeoutFn);
    }
    /**
     * Called upon socket error.
     *
     * @private
     */ onerror(err) {
        this.emitReserved("error", err);
    }
    /**
     * Creates a new socket for the given `nsp`.
     *
     * @return {Socket}
     * @public
     */ socket(nsp, opts) {
        let socket = this.nsps[nsp];
        if (!socket) {
            socket = new (0, $ddd773b6996dfbad$export$4798917dbf149b79)(this, nsp, opts);
            this.nsps[nsp] = socket;
        } else if (this._autoConnect && !socket.active) socket.connect();
        return socket;
    }
    /**
     * Called upon a socket close.
     *
     * @param socket
     * @private
     */ _destroy(socket) {
        const nsps = Object.keys(this.nsps);
        for (const nsp of nsps){
            const socket = this.nsps[nsp];
            if (socket.active) return;
        }
        this._close();
    }
    /**
     * Writes a packet.
     *
     * @param packet
     * @private
     */ _packet(packet) {
        const encodedPackets = this.encoder.encode(packet);
        for(let i = 0; i < encodedPackets.length; i++)this.engine.write(encodedPackets[i], packet.options);
    }
    /**
     * Clean up transport subscriptions and packet buffer.
     *
     * @private
     */ cleanup() {
        this.subs.forEach((subDestroy)=>subDestroy());
        this.subs.length = 0;
        this.decoder.destroy();
    }
    /**
     * Close the current socket.
     *
     * @private
     */ _close() {
        this.skipReconnect = true;
        this._reconnecting = false;
        this.onclose("forced close");
    }
    /**
     * Alias for close()
     *
     * @private
     */ disconnect() {
        return this._close();
    }
    /**
     * Called when:
     *
     * - the low-level engine is closed
     * - the parser encountered a badly formatted packet
     * - all sockets are disconnected
     *
     * @private
     */ onclose(reason, description) {
        var _a;
        this.cleanup();
        (_a = this.engine) === null || _a === void 0 || _a.close();
        this.backoff.reset();
        this._readyState = "closed";
        this.emitReserved("close", reason, description);
        if (this._reconnection && !this.skipReconnect) this.reconnect();
    }
    /**
     * Attempt a reconnection.
     *
     * @private
     */ reconnect() {
        if (this._reconnecting || this.skipReconnect) return this;
        const self = this;
        if (this.backoff.attempts >= this._reconnectionAttempts) {
            this.backoff.reset();
            this.emitReserved("reconnect_failed");
            this._reconnecting = false;
        } else {
            const delay = this.backoff.duration();
            this._reconnecting = true;
            const timer = this.setTimeoutFn(()=>{
                if (self.skipReconnect) return;
                this.emitReserved("reconnect_attempt", self.backoff.attempts);
                // check again for the case socket closed in above events
                if (self.skipReconnect) return;
                self.open((err)=>{
                    if (err) {
                        self._reconnecting = false;
                        self.reconnect();
                        this.emitReserved("reconnect_error", err);
                    } else self.onreconnect();
                });
            }, delay);
            if (this.opts.autoUnref) timer.unref();
            this.subs.push(()=>{
                this.clearTimeoutFn(timer);
            });
        }
    }
    /**
     * Called upon successful reconnect.
     *
     * @private
     */ onreconnect() {
        const attempt = this.backoff.attempts;
        this._reconnecting = false;
        this.backoff.reset();
        this.emitReserved("reconnect", attempt);
    }
}





/**
 * Managers cache.
 */ const $47722129af947523$var$cache = {};
function $47722129af947523$export$841407ceb083bd74(uri, opts) {
    if (typeof uri === "object") {
        opts = uri;
        uri = undefined;
    }
    opts = opts || {};
    const parsed = (0, $7d769e07affedf95$export$128fa18b7194ef)(uri, opts.path || "/socket.io");
    const source = parsed.source;
    const id = parsed.id;
    const path = parsed.path;
    const sameNamespace = $47722129af947523$var$cache[id] && path in $47722129af947523$var$cache[id]["nsps"];
    const newConnection = opts.forceNew || opts["force new connection"] || false === opts.multiplex || sameNamespace;
    let io;
    if (newConnection) io = new (0, $01e6adc4d3f15cb7$export$d0d38e7dec7a1a61)(source, opts);
    else {
        if (!$47722129af947523$var$cache[id]) $47722129af947523$var$cache[id] = new (0, $01e6adc4d3f15cb7$export$d0d38e7dec7a1a61)(source, opts);
        io = $47722129af947523$var$cache[id];
    }
    if (parsed.query && !opts.query) opts.query = parsed.queryKey;
    return io.socket(parsed.path, opts);
}
// so that "lookup" can be used both as a function (e.g. `io(...)`) and as a
// namespace (e.g. `io.connect(...)`), for backward compatibility
Object.assign($47722129af947523$export$841407ceb083bd74, {
    Manager: $01e6adc4d3f15cb7$export$d0d38e7dec7a1a61,
    Socket: $ddd773b6996dfbad$export$4798917dbf149b79,
    io: $47722129af947523$export$841407ceb083bd74,
    connect: $47722129af947523$export$841407ceb083bd74
});



var $4c78f829eb748ae3$export$523fb3936f49e028;
var $4c78f829eb748ae3$export$fe63ae40556ad5d2;
$4c78f829eb748ae3$export$523fb3936f49e028 = `epB7vq_page`;
$4c78f829eb748ae3$export$fe63ae40556ad5d2 = `epB7vq_pageWrap`;


const $a4d47c1a2433f072$var$parseOldFormat = (data)=>{
    const { sections: sections } = data || {};
    const [first] = sections || [];
    return {
        page: first,
        settings: {},
        variableData: {},
        screenId: undefined
    };
};
const $a4d47c1a2433f072$var$parseNewFormat = (data)=>{
    const { screen: screen, variable_data: variableData } = data || {};
    const { sections: sections, settings: settings, id: id } = screen || {};
    return {
        page: sections,
        settings: settings,
        variableData: variableData,
        screenId: id
    };
};
const $a4d47c1a2433f072$var$styleElementId = "custom-css-header-kdlshHhgjhgf";
const $a4d47c1a2433f072$var$getWebSocketUrl = ()=>{
    const protocol = window.location.protocol === "https:" ? "wss:" : "ws:";
    return `${protocol}//${window.location.host}/ws`;
};
const $a4d47c1a2433f072$var$componentMapping = {
    checkbox: (0, $2c90db8687e433b8$export$2e2bcd8739ae039),
    image: (0, $aa8f0f735a0f79aa$export$2e2bcd8739ae039),
    input: (0, $7ea0c43ec9b05f7e$export$2e2bcd8739ae039),
    radio: (0, $b35bf230db392315$export$2e2bcd8739ae039),
    select: (0, $bb9696960a8827ef$export$2e2bcd8739ae039),
    separator: (0, $3492f55331d0a86f$export$2e2bcd8739ae039),
    switcher: (0, $f7a8d8148b95e31e$export$2e2bcd8739ae039),
    text: (0, $d009549dd9adb801$export$2e2bcd8739ae039)
};
const $a4d47c1a2433f072$var$Page = ()=>{
    const dispatch = (0, $d023060d48542f4c$export$8ad76b76a4c905f8)();
    const socketRef = (0, $aivMx.useRef)(null);
    const config = (0, $f40d1f3d995cccef$export$2105062e25df4afe)((state)=>state.config);
    const page = (0, $f40d1f3d995cccef$export$2105062e25df4afe)((state)=>state.page);
    const { data: data } = config || {};
    const { data: pageData2, settings: settings, variableData: variableData, sessionData: sessionData, styleChunks: styleChunks } = page || {};
    const { deviceId: deviceId, sessionId: sessionId } = sessionData || {};
    const mergedVariables = (0, (/*@__PURE__*/$parcel$interopDefault($94WEq)))({}, settings?.variables || {}, variableData || {});
    const pageData = (0, $7b0e169a5380005e$export$9a7eef5d73136d1e)(pageData2, mergedVariables);
    const newSettings = {
        ...settings,
        variables: mergedVariables
    };
    const { page: pp } = pageData || {};
    (0, $aivMx.useEffect)(()=>{
        const { basic: basic, variables: variables, classes: classes } = data || {};
        if (basic && variables && classes) {
            const classKeys = Object.keys(classes);
            let styleElement = document.getElementById($a4d47c1a2433f072$var$styleElementId);
            if (!styleElement) {
                styleElement = document.createElement("style");
                styleElement.id = $a4d47c1a2433f072$var$styleElementId;
                document.head.appendChild(styleElement);
            }
            const resulting = {};
            classKeys.forEach((k)=>{
                const classStyles = (0, $7b0e169a5380005e$export$c48968220937aa25)(classes[k]);
                resulting[k] = (0, $e0d24bf85c947bed$export$2e2bcd8739ae039)(classStyles);
            });
            const cssRules = Object.keys(resulting).map((className)=>(0, $7b0e169a5380005e$export$2e00a35bd25acfb1)(className, resulting[className])).join("\n\n");
            styleElement.innerText = `${variables}\n${basic}\n${cssRules}`;
        }
    }, [
        data
    ]);
    (0, $aivMx.useEffect)(()=>{
        if (settings?.script) (0, $7b0e169a5380005e$export$1ab2cd8b58d4bd64)(settings?.script);
    }, [
        settings?.script
    ]);
    (0, $aivMx.useEffect)(()=>{
        if (settings?.fonts) (0, $7b0e169a5380005e$export$dda81216098e0f9d)(settings?.fonts);
    }, [
        settings?.fonts
    ]);
    (0, $aivMx.useEffect)(()=>{
        if (settings?.page) {
            const { title: title, icon: icon } = settings.page;
            if (title) document.title = title;
            if (icon) {
                let link = document.querySelector("link[rel~='icon']");
                if (!link) {
                    link = document.createElement("link");
                    link.rel = "icon";
                    document.getElementsByTagName("head")[0].appendChild(link);
                }
                link.href = icon;
            }
        }
    }, [
        settings
    ]);
    const connectWebSocket = (0, $aivMx.useCallback)(()=>{
        if (!deviceId || !sessionId || socketRef.current) return;
        const socket = (0, $47722129af947523$export$841407ceb083bd74)($a4d47c1a2433f072$var$getWebSocketUrl(), {
            path: "/ws",
            transports: [
                "websocket"
            ]
        });
        socket.on("connect", ()=>{
            console.log("WebSocket Connected");
            socket.emit("authorize", {
                groupIdentifier: deviceId,
                sessionIdentifier: sessionId
            });
        });
        socket.on("disconnect", (reason)=>{
            console.log("WebSocket Disconnected", reason);
        });
        socket.on("connect_error", (error)=>{
            console.error("WebSocket Error:", error);
        });
        socket.on("pageUpdate", (message)=>{
            if (message.requireAck && message.messageId) socket.emit("ack", {
                messageId: message.messageId
            });
            if (message.type === "pageUpdate" && message.data) {
                const { data: data } = message.data || {};
                const { page: pp, settings: settings, variableData: variableData, screenId: screenId } = data.sections ? $a4d47c1a2433f072$var$parseOldFormat(data) : $a4d47c1a2433f072$var$parseNewFormat(data);
                dispatch((0, $8eba69c5466928d3$export$98eb18032ef4d6ea)({
                    data: pp,
                    settings: settings,
                    sessionData: sessionData,
                    variableData: variableData,
                    screenId: screenId
                }));
            }
        });
        socketRef.current = socket;
        return ()=>{
            if (socketRef.current) socketRef.current.disconnect();
        };
    }, [
        deviceId,
        sessionId,
        dispatch
    ]);
    (0, $aivMx.useEffect)(()=>{
        if (deviceId && sessionId) connectWebSocket();
    }, [
        deviceId,
        sessionId,
        connectWebSocket
    ]);
    (0, $aivMx.useEffect)(()=>{
        if (!pp) return;
        const url = (0, $fe90f07def2730ef$export$4358cc9d407dbd2f)(pp);
        (0, $73d63d58f0308e04$export$6b05b21262ec0515)(url);
    }, [
        pp
    ]);
    return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("div", {
        className: $4c78f829eb748ae3$export$523fb3936f49e028,
        children: /*#__PURE__*/ (0, $02de83db299f7983$exports.jsxs)("div", {
            className: $4c78f829eb748ae3$export$fe63ae40556ad5d2,
            style: {
                display: "grid",
                gridTemplateColumns: `repeat(${settings?.cols || (0, $2b42b3a2aa0ebb61$export$c5399bfb4d939924)}, 1fr)`,
                gridAutoRows: settings?.rows ? undefined : `${0, $2b42b3a2aa0ebb61$export$a176cc2ca3635d69}px`,
                gridTemplateRows: settings?.rows ? `repeat(${settings?.rows}, 1fr)` : undefined
            },
            children: [
                typeof pp === "object" && Object.keys(pp) && !Array.isArray(pp) ? /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $0380290541115933$export$2e2bcd8739ae039), {
                    ...pp,
                    pageSettings: newSettings,
                    styleChunks: styleChunks
                }) : null,
                Array.isArray(pp) ? /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $02de83db299f7983$exports.Fragment), {
                    children: pp.map((item)=>{
                        const Component = $a4d47c1a2433f072$var$componentMapping[item.component];
                        if (Component) return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)(Component, {
                            ...item,
                            pageSettings: newSettings,
                            styleChunks: styleChunks
                        }, item.id);
                        else if (item.component === "container" || item.component === "table") return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $0380290541115933$export$2e2bcd8739ae039), {
                            ...item,
                            pageSettings: newSettings,
                            styleChunks: styleChunks
                        }, item.id);
                        return null;
                    })
                }) : null
            ]
        })
    });
};
var $a4d47c1a2433f072$export$2e2bcd8739ae039 = $a4d47c1a2433f072$var$Page;



parcelRequire("aivMx");

parcelRequire("aivMx");
const $dde6212574de0fc3$var$SvgImg404 = (props)=>/*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("svg", {
        width: 720,
        height: 363,
        viewBox: "0 0 720 363",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("path", {
            className: "fill",
            d: "M385.293 205.372c0-14.962-2.173-26.529-6.518-34.691-4.345-8.163-10.523-12.244-18.53-12.244-8.011 0-14.102 4.081-18.275 12.244-4.178 8.162-6.263 19.729-6.263 34.691 0 14.967 2.085 26.573 6.263 34.819 4.173 8.251 10.264 12.372 18.275 12.372 8.007 0 14.185-4.121 18.53-12.372 4.345-8.246 6.518-19.852 6.518-34.819Zm43.707 0c0 13.097-1.705 24.743-5.112 34.947-3.411 10.203-8.14 18.749-14.186 25.636-6.049 6.888-13.291 12.117-21.725 15.689-8.434 3.57-17.597 5.356-27.477 5.356-10.057 0-19.297-1.786-27.732-5.356-8.434-3.572-15.68-8.801-21.725-15.689-6.051-6.887-10.735-15.433-14.058-25.636-3.322-10.204-4.985-21.85-4.985-34.947 0-13.093 1.663-24.699 4.985-34.819 3.323-10.115 8.007-18.621 14.058-25.509 6.045-6.887 13.291-12.116 21.725-15.687 8.435-3.571 17.675-5.357 27.732-5.357 9.88 0 19.043 1.786 27.477 5.357 8.434 3.571 15.676 8.8 21.725 15.687 6.046 6.888 10.775 15.394 14.186 25.509 3.407 10.12 5.112 21.726 5.112 34.819ZM517.634 168.642h-.766l-33.937 47.981h34.703v-47.981Zm-13.013-40.069c3.229-1.02 6.929-1.869 11.1-2.551 4.166-.678 7.95-1.022 11.355-1.022 3.911 0 7.694.384 11.355 1.149 3.656.765 6.929 2.041 9.824 3.829 2.891 1.785 5.189 4.21 6.89 7.273 1.698 3.062 2.552 6.891 2.552 11.484v67.888h22.71c1.021 1.874 2.042 4.338 3.061 7.401 1.022 3.062 1.532 6.296 1.532 9.698 0 6.468-1.447 11.063-4.339 13.782-2.894 2.723-6.551 4.084-10.972 4.084h-11.992v30.115c-1.873.338-4.681.806-8.421 1.405-3.744.593-7.316.892-10.717.892-3.744 0-7.061-.172-9.952-.511-2.896-.342-5.319-1.149-7.273-2.424-1.957-1.276-3.444-3.103-4.466-5.487-1.02-2.381-1.531-5.615-1.531-9.698v-14.292h-64.048c-3.915-2.042-7.272-5.061-10.078-9.062-2.807-3.994-4.211-8.888-4.211-14.674 0-3.23.423-6.802 1.276-10.719.849-3.911 2.297-7.313 4.338-10.208l62.007-78.352ZM216.634 168.642h-.766l-33.937 47.981h34.703v-47.981Zm-13.013-40.069c3.229-1.02 6.929-1.869 11.1-2.551 4.166-.678 7.95-1.022 11.355-1.022 3.911 0 7.694.384 11.355 1.149 3.656.765 6.929 2.041 9.824 3.829 2.891 1.785 5.189 4.21 6.89 7.273 1.698 3.062 2.552 6.891 2.552 11.484v67.888h22.71c1.021 1.874 2.042 4.338 3.061 7.401 1.022 3.062 1.532 6.296 1.532 9.698 0 6.468-1.447 11.063-4.339 13.782-2.894 2.723-6.551 4.084-10.972 4.084h-11.992v30.115c-1.873.338-4.681.806-8.421 1.405-3.744.593-7.316.892-10.717.892-3.744 0-7.061-.172-9.952-.511-2.896-.342-5.319-1.149-7.273-2.424-1.957-1.276-3.444-3.103-4.466-5.487-1.02-2.381-1.531-5.615-1.531-9.698v-14.292h-64.048c-3.915-2.042-7.272-5.061-10.078-9.062-2.807-3.994-4.211-8.888-4.211-14.674 0-3.23.423-6.802 1.276-10.719.849-3.911 2.297-7.313 4.338-10.208l62.007-78.352ZM123.577 345.391c0-1.922.601-3.504 1.802-4.747 1.201-1.241 2.859-1.864 4.978-1.864 2.118 0 3.777.623 4.978 1.864 1.202 1.243 1.802 2.825 1.802 4.747 0 1.922-.6 3.504-1.802 4.745-1.201 1.242-2.86 1.864-4.978 1.864-2.119 0-3.777-.622-4.978-1.864-1.201-1.241-1.802-2.823-1.802-4.745Zm2.331-9.212c-.801-.422-1.553-1.183-2.259-2.285-.707-1.101-1.059-2.401-1.059-3.902 0-1.452.387-2.543 1.165-3.269.776-.727 1.918-1.278 3.423-1.653l5.51-1.335c2.353-.61 3.531-1.736 3.531-3.376 0-.89-.436-1.664-1.307-2.32-.871-.656-2.366-.985-4.485-.985-1.93 0-3.742.247-5.437.738-1.694.493-3.06 1.067-4.096 1.723a8.785 8.785 0 0 1-2.048-2.214c-.565-.867-.846-1.91-.846-3.13 0-1.218.353-2.285 1.059-3.199.706-.914 1.682-1.664 2.93-2.251 1.246-.585 2.73-1.019 4.449-1.3 1.717-.281 3.612-.421 5.684-.421 5.555 0 9.757 1.23 12.605 3.691 2.849 2.461 4.273 5.684 4.273 9.668 0 7.5-5.32 12.305-15.959 14.414l-7.133 1.406ZM7.916 252.601c0-2.733.853-4.983 2.557-6.751 1.705-1.766 4.058-2.651 7.065-2.651 3.007 0 5.362.885 7.067 2.651 1.705 1.768 2.557 4.018 2.557 6.751 0 2.733-.852 4.982-2.557 6.748S20.545 262 17.538 262c-3.007 0-5.36-.885-7.065-2.651-1.704-1.766-2.557-4.015-2.557-6.748Zm3.308-13.102c-1.136-.601-2.204-1.682-3.206-3.249-1.003-1.566-1.504-3.416-1.504-5.551 0-2.065.55-3.616 1.654-4.649 1.102-1.033 2.722-1.816 4.86-2.35l7.82-1.9c3.339-.867 5.011-2.467 5.011-4.8 0-1.266-.62-2.367-1.855-3.301-1.237-.931-3.358-1.4-6.365-1.4-2.74 0-5.312.351-7.717 1.05-2.406.701-4.344 1.517-5.814 2.45A12.459 12.459 0 0 1 1.2 212.65C.399 211.417 0 209.934 0 208.199c0-1.732.5-3.25 1.503-4.55 1.002-1.3 2.387-2.366 4.16-3.201 1.768-.832 3.874-1.449 6.314-1.85 2.437-.399 5.126-.598 8.067-.598 7.885 0 13.848 1.749 17.891 5.249C41.978 206.749 44 211.333 44 217c0 10.667-7.551 17.5-22.652 20.5l-10.124 1.999ZM469.176 63.132c0-3.16.988-5.761 2.963-7.806 1.976-2.04 4.704-3.065 8.19-3.065 3.484 0 6.214 1.024 8.191 3.065 1.976 2.044 2.963 4.646 2.963 7.806s-.987 5.761-2.963 7.803c-1.977 2.042-4.707 3.065-8.191 3.065-3.486 0-6.214-1.023-8.19-3.066-1.975-2.04-2.963-4.642-2.963-7.802Zm3.834-15.148c-1.317-.695-2.555-1.946-3.716-3.758-1.163-1.81-1.743-3.95-1.743-6.417 0-2.388.637-4.182 1.917-5.376 1.276-1.195 3.155-2.1 5.632-2.718l9.064-2.196c3.871-1.002 5.809-2.853 5.809-5.55 0-1.465-.718-2.737-2.15-3.817-1.434-1.077-3.892-1.618-7.378-1.618-3.176 0-6.157.405-8.945 1.213-2.788.81-5.035 1.755-6.739 2.833a14.423 14.423 0 0 1-3.369-3.641c-.93-1.425-1.392-3.14-1.392-5.147 0-2.002.58-3.757 1.742-5.26 1.161-1.504 2.767-2.736 4.821-3.701 2.05-.963 4.491-1.676 7.319-2.14 2.825-.46 5.941-.691 9.351-.691 9.14 0 16.051 2.023 20.737 6.07 4.687 4.046 7.03 9.346 7.03 15.898 0 12.334-8.752 20.235-26.256 23.704l-11.734 2.312ZM77.694 131.901c0-4.1 1.26-7.474 3.777-10.126 2.519-2.648 5.995-3.977 10.438-3.977 4.441 0 7.92 1.329 10.44 3.977 2.518 2.652 3.777 6.026 3.777 10.126 0 4.099-1.259 7.474-3.777 10.122-2.52 2.65-5.999 3.977-10.44 3.977-4.443 0-7.92-1.327-10.438-3.977-2.517-2.648-3.777-6.023-3.777-10.122Zm4.887-19.652c-1.678-.901-3.256-2.524-4.736-4.875-1.483-2.348-2.222-5.123-2.222-8.325 0-3.098.813-5.424 2.444-6.974 1.627-1.55 4.02-2.725 7.178-3.526l11.553-2.848c4.932-1.301 7.403-3.702 7.403-7.201 0-1.9-.915-3.55-2.74-4.951-1.827-1.398-4.96-2.1-9.403-2.1-4.049 0-7.848.526-11.401 1.574-3.553 1.052-6.417 2.276-8.589 3.676-1.68-1.3-3.107-2.873-4.294-4.724C66.589 70.125 66 67.9 66 65.298c0-2.598.74-4.875 2.22-6.824 1.48-1.951 3.527-3.55 6.145-4.802 2.612-1.249 5.723-2.174 9.328-2.774 3.6-.599 7.572-.898 11.918-.898 11.648 0 20.457 2.624 26.43 7.874 5.973 5.25 8.959 12.125 8.959 20.625 0 16-11.155 26.251-33.463 30.75l-14.956 3ZM282.038 69.978c0-1.75.542-3.192 1.627-4.324 1.085-1.131 2.582-1.699 4.496-1.699 1.913 0 3.412.568 4.497 1.699 1.085 1.132 1.627 2.574 1.627 4.325 0 1.75-.542 3.192-1.627 4.323-1.085 1.131-2.584 1.698-4.497 1.698-1.914 0-3.411-.567-4.496-1.698-1.085-1.131-1.627-2.573-1.627-4.324Zm2.105-8.393c-.723-.385-1.403-1.077-2.041-2.081-.638-1.003-.957-2.188-.957-3.556 0-1.323.35-2.317 1.053-2.979.701-.662 1.732-1.163 3.092-1.505l4.977-1.217c2.125-.555 3.189-1.58 3.189-3.075 0-.811-.394-1.516-1.181-2.115-.787-.596-2.136-.897-4.05-.897-1.744 0-3.381.225-4.911.673-1.531.449-2.764.972-3.7 1.57a7.955 7.955 0 0 1-1.85-2.018c-.51-.79-.764-1.74-.764-2.852 0-1.11.318-2.081.956-2.914.638-.833 1.52-1.516 2.647-2.05 1.126-.534 2.466-.93 4.018-1.186 1.552-.255 3.262-.383 5.134-.383 5.018 0 8.813 1.12 11.386 3.363 2.573 2.242 3.859 5.178 3.859 8.809 0 6.833-4.805 11.211-14.415 13.133l-6.442 1.28ZM634.837 121.922c0-2.348.736-4.282 2.208-5.801 1.472-1.517 3.504-2.278 6.102-2.278 2.596 0 4.631.761 6.103 2.278 1.472 1.519 2.208 3.453 2.208 5.801 0 2.349-.736 4.282-2.208 5.8-1.472 1.518-3.507 2.278-6.103 2.278-2.598 0-4.63-.76-6.102-2.278-1.472-1.518-2.208-3.451-2.208-5.8Zm2.857-11.259c-.982-.516-1.904-1.445-2.769-2.792-.867-1.346-1.299-2.936-1.299-4.77 0-1.775.475-3.108 1.428-3.996.952-.888 2.351-1.56 4.197-2.02l6.754-1.631c2.884-.746 4.328-2.121 4.328-4.126 0-1.088-.535-2.034-1.602-2.837-1.068-.8-2.9-1.203-5.497-1.203-2.367 0-4.588.302-6.665.902-2.078.603-3.752 1.305-5.021 2.106a10.721 10.721 0 0 1-2.511-2.706c-.693-1.06-1.037-2.334-1.037-3.826 0-1.488.432-2.792 1.298-3.91.865-1.117 2.062-2.033 3.592-2.75 1.527-.716 3.346-1.246 5.453-1.59 2.106-.343 4.427-.514 6.968-.514 6.81 0 11.96 1.503 15.451 4.511 3.492 3.008 5.238 6.947 5.238 11.817 0 9.167-6.521 15.039-19.563 17.617l-8.743 1.718ZM666.694 290.901c0-4.1 1.261-7.474 3.777-10.126 2.519-2.648 5.995-3.977 10.438-3.977 4.441 0 7.921 1.329 10.44 3.977 2.518 2.652 3.777 6.026 3.777 10.126 0 4.099-1.259 7.474-3.777 10.122-2.519 2.65-5.999 3.977-10.44 3.977-4.443 0-7.919-1.327-10.438-3.977-2.516-2.648-3.777-6.023-3.777-10.122Zm4.887-19.652c-1.678-.901-3.256-2.524-4.736-4.875-1.482-2.348-2.222-5.123-2.222-8.325 0-3.098.813-5.424 2.444-6.974 1.627-1.55 4.021-2.725 7.178-3.526l11.553-2.848c4.932-1.301 7.403-3.702 7.403-7.201 0-1.9-.915-3.55-2.74-4.951-1.827-1.398-4.96-2.1-9.403-2.1-4.049 0-7.848.526-11.401 1.574-3.553 1.052-6.417 2.276-8.589 3.676-1.68-1.299-3.107-2.873-4.294-4.724-1.185-1.849-1.774-4.074-1.774-6.677 0-2.598.739-4.875 2.22-6.824 1.48-1.951 3.527-3.549 6.145-4.802 2.612-1.249 5.723-2.174 9.328-2.774 3.601-.599 7.572-.898 11.918-.898 11.648 0 20.457 2.624 26.43 7.874 5.973 5.25 8.959 12.125 8.959 20.626 0 16-11.155 26.25-33.463 30.749l-14.956 3ZM590.217 356.832c0-1.794.563-3.27 1.686-4.431 1.123-1.158 2.674-1.739 4.656-1.739 1.982 0 3.534.581 4.658 1.739 1.124 1.161 1.685 2.637 1.685 4.431 0 1.793-.561 3.27-1.685 4.428-1.124 1.16-2.676 1.74-4.658 1.74-1.982 0-3.533-.58-4.656-1.74-1.123-1.158-1.686-2.635-1.686-4.428Zm2.181-8.598c-.749-.394-1.453-1.104-2.113-2.133-.662-1.027-.992-2.241-.992-3.642 0-1.355.363-2.373 1.091-3.051.726-.678 1.794-1.192 3.202-1.543l5.155-1.246c2.2-.569 3.303-1.62 3.303-3.15 0-.831-.409-1.553-1.223-2.166-.815-.612-2.213-.919-4.195-.919-1.807 0-3.502.23-5.087.689-1.585.46-2.863.996-3.832 1.608a8.222 8.222 0 0 1-1.916-2.067c-.528-.809-.791-1.782-.791-2.921 0-1.137.33-2.133.99-2.986.661-.853 1.574-1.552 2.742-2.1 1.165-.547 2.553-.952 4.162-1.214 1.606-.262 3.378-.393 5.317-.393 5.197 0 9.127 1.148 11.792 3.445 2.665 2.297 3.997 5.305 3.997 9.024 0 7-4.977 11.484-14.93 13.453l-6.672 1.312Z"
        })
    });
var $dde6212574de0fc3$export$2e2bcd8739ae039 = $dde6212574de0fc3$var$SvgImg404;


var $c826ef794bd667d6$export$a33e918cb4258370;
var $c826ef794bd667d6$export$7fb0516b0ed6bd2;
var $c826ef794bd667d6$export$121a36a7c59b25d9;
$c826ef794bd667d6$export$a33e918cb4258370 = `YHTgIW_notFound`;
$c826ef794bd667d6$export$7fb0516b0ed6bd2 = `YHTgIW_notFoundBtn`;
$c826ef794bd667d6$export$121a36a7c59b25d9 = `YHTgIW_notFoundCenter`;


const $279d3b4c8110a250$var$NotFound = ()=>/*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("div", {
        className: $c826ef794bd667d6$export$a33e918cb4258370,
        children: /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("div", {
            className: $c826ef794bd667d6$export$121a36a7c59b25d9,
            children: /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $dde6212574de0fc3$export$2e2bcd8739ae039), {})
        })
    });
var $279d3b4c8110a250$export$2e2bcd8739ae039 = $279d3b4c8110a250$var$NotFound;


/* eslint-disable react/jsx-props-no-spreading */ 

var $aivMx = parcelRequire("aivMx");





function $9988b5a80f290978$export$2e2bcd8739ae039(jsonString) {
    try {
        const data = JSON.parse(jsonString);
        return {
            success: true,
            data: data
        };
    } catch (error) {
        return {
            success: false,
            error: error
        };
    }
}










var $d6aa166daaaad1e4$export$a2b3dd87d3e471be;
var $d6aa166daaaad1e4$export$e8c9778bf415dd08;
var $d6aa166daaaad1e4$export$3ffe842fbbf0db09;
var $d6aa166daaaad1e4$export$2adb16ac204af30e;
var $d6aa166daaaad1e4$export$73920f18ca706874;
var $d6aa166daaaad1e4$export$523fb3936f49e028;
var $d6aa166daaaad1e4$export$fe63ae40556ad5d2;
$d6aa166daaaad1e4$export$a2b3dd87d3e471be = `TIdUyG_centerButton`;
$d6aa166daaaad1e4$export$e8c9778bf415dd08 = `TIdUyG_divider`;
$d6aa166daaaad1e4$export$3ffe842fbbf0db09 = `TIdUyG_frameLayout`;
$d6aa166daaaad1e4$export$2adb16ac204af30e = `TIdUyG_full`;
$d6aa166daaaad1e4$export$73920f18ca706874 = `TIdUyG_hidden`;
$d6aa166daaaad1e4$export$523fb3936f49e028 = `TIdUyG_page`;
$d6aa166daaaad1e4$export$fe63ae40556ad5d2 = `TIdUyG_pageWrap`;




const $92fc1304e46d7bde$var$styleElementId = "custom-css-header-kdlshHhgjhgf";
const $92fc1304e46d7bde$var$componentMapping = {
    checkbox: (0, $2c90db8687e433b8$export$2e2bcd8739ae039),
    image: (0, $aa8f0f735a0f79aa$export$2e2bcd8739ae039),
    input: (0, $7ea0c43ec9b05f7e$export$2e2bcd8739ae039),
    radio: (0, $b35bf230db392315$export$2e2bcd8739ae039),
    select: (0, $bb9696960a8827ef$export$2e2bcd8739ae039),
    separator: (0, $3492f55331d0a86f$export$2e2bcd8739ae039),
    switcher: (0, $f7a8d8148b95e31e$export$2e2bcd8739ae039),
    text: (0, $d009549dd9adb801$export$2e2bcd8739ae039)
};
const $92fc1304e46d7bde$var$InternalFrame = ()=>{
    const [styleApplied, setStyleApplied] = (0, $aivMx.useState)(false);
    const config = (0, $f40d1f3d995cccef$export$2105062e25df4afe)((state)=>state.config);
    const page = (0, $f40d1f3d995cccef$export$2105062e25df4afe)((state)=>state.page);
    const { data: data } = config || {};
    const { editor: editorUrl } = data?.urls || {};
    const { data: pageData2, settings: settings, styleChunks: styleChunks } = page || {};
    const pageData = (0, $7b0e169a5380005e$export$9a7eef5d73136d1e)(pageData2, settings?.variables);
    const { page: pp } = pageData || {};
    const dispatch = (0, $d023060d48542f4c$export$8ad76b76a4c905f8)();
    const [output, setOutput] = (0, $aivMx.useState)(null);
    const [eventCopy, setLastEventCopy] = (0, $aivMx.useState)(null);
    const dispatchContentUpdateEvent = (height)=>{
        if (eventCopy) {
            const sourceWindow = eventCopy.source;
            sourceWindow.postMessage({
                newHeight: height
            }, eventCopy.origin);
        }
    };
    // Corrected syntax for the type guard function
    const expectedOrigin = editorUrl;
    (0, $aivMx.useEffect)(()=>{
        setTimeout(()=>{
            // const bodyScrollHeight = document.body.scrollHeight;
            const elementId = "6201:298088";
            const element = document.getElementById(elementId);
            if (element) {
                const { scrollHeight: scrollHeight } = element;
                dispatchContentUpdateEvent(scrollHeight); // Trigger the event
            }
        }, 1000);
    }, [
        output
    ]);
    (0, $aivMx.useEffect)(()=>{
        const receiveMessageFromParent = (event)=>{
            // Check the origin to ensure the message is from the expected source
            if (event.origin === expectedOrigin) {
                if (event.source) {
                    const result = (0, $9988b5a80f290978$export$2e2bcd8739ae039)(event.data);
                    const sourceWindow = event.source;
                    if (result.success && result?.data?.page) {
                        const responseMessage = "Parsed JSON";
                        setLastEventCopy(event);
                        setOutput(result?.data?.page);
                        dispatch((0, $8eba69c5466928d3$export$98eb18032ef4d6ea)({
                            data: result.data.page,
                            settings: result.data.settings
                        }));
                        sourceWindow.postMessage(responseMessage, event.origin);
                    } else {
                        const responseMessage = "Failed to parse JSON";
                        console.log("failed");
                        console.log(event.origin);
                        sourceWindow.postMessage(responseMessage, event.origin);
                    }
                }
            }
        };
        // Attach the receiveMessageFromParent function to the message event
        window.addEventListener("message", receiveMessageFromParent);
        // Cleanup the event listener on component unmount
        return ()=>{
            window.removeEventListener("message", receiveMessageFromParent);
        };
    }, [
        expectedOrigin
    ]);
    (0, $aivMx.useEffect)(()=>{
        const { basic: basic, variables: variables, classes: classes } = data || {};
        if (basic && variables && classes) {
            const classKeys = Object.keys(classes);
            let styleElement = document.getElementById($92fc1304e46d7bde$var$styleElementId);
            if (!styleElement) {
                styleElement = document.createElement("style");
                styleElement.id = $92fc1304e46d7bde$var$styleElementId;
                document.head.appendChild(styleElement);
            }
            const resulting = {};
            classKeys.forEach((k)=>{
                const classStyles = (0, $7b0e169a5380005e$export$c48968220937aa25)(classes[k]);
                resulting[k] = (0, $e0d24bf85c947bed$export$2e2bcd8739ae039)(classStyles);
            });
            const cssRules = Object.keys(resulting).map((className)=>(0, $7b0e169a5380005e$export$2e00a35bd25acfb1)(className, resulting[className])).join("\n\n");
            styleElement.innerText = `${variables}\n${basic}\n${cssRules}`;
        }
    }, [
        data
    ]);
    (0, $aivMx.useEffect)(()=>{
        // Notify parent window that iframe is ready to receive messages
        if (window.parent && expectedOrigin) window.parent.postMessage({
            type: "iframeReady"
        }, expectedOrigin);
    }, [
        expectedOrigin
    ]);
    return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("div", {
            children: /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("div", {
                className: $d6aa166daaaad1e4$export$3ffe842fbbf0db09,
                children: /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("div", {
                    style: {
                        boxSizing: "border-box"
                    },
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($4aeabe14c1618d30$exports)))({
                        [$d6aa166daaaad1e4$export$2adb16ac204af30e]: true
                    }),
                    children: /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("div", {
                        style: {
                            overflow: "auto",
                            height: "100%"
                        },
                        children: pp ? /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("div", {
                            className: $d6aa166daaaad1e4$export$523fb3936f49e028,
                            children: /*#__PURE__*/ (0, $02de83db299f7983$exports.jsxs)("div", {
                                className: $d6aa166daaaad1e4$export$fe63ae40556ad5d2,
                                style: {
                                    display: "grid",
                                    gridTemplateColumns: `repeat(${settings?.cols || (0, $2b42b3a2aa0ebb61$export$c5399bfb4d939924)}, 1fr)`,
                                    gridAutoRows: settings?.rows ? undefined : `${0, $2b42b3a2aa0ebb61$export$a176cc2ca3635d69}px`,
                                    gridTemplateRows: settings?.rows ? `repeat(${settings?.rows}, 1fr)` : undefined
                                },
                                children: [
                                    typeof pp === "object" && Object.keys(pp) && !Array.isArray(pp) ? /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $0380290541115933$export$2e2bcd8739ae039), {
                                        ...pp,
                                        pageSettings: settings,
                                        styleChunks: styleChunks
                                    }) : null,
                                    Array.isArray(pp) ? /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $02de83db299f7983$exports.Fragment), {
                                        children: pp.map((item)=>{
                                            const Component = $92fc1304e46d7bde$var$componentMapping[item.component];
                                            if (Component) return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)(Component, {
                                                ...item,
                                                pageSettings: settings,
                                                styleChunks: styleChunks
                                            }, item.id);
                                            else if (item.component === "container" || item.component === "table") return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $0380290541115933$export$2e2bcd8739ae039), {
                                                ...item,
                                                pageSettings: settings,
                                                styleChunks: styleChunks
                                            }, item.id);
                                            return null;
                                        })
                                    }) : null
                                ]
                            })
                        }) : /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("div", {
                            children: "No valid data"
                        })
                    })
                })
            })
        })
    });
};
var $92fc1304e46d7bde$export$2e2bcd8739ae039 = $92fc1304e46d7bde$var$InternalFrame;


const $24743a343556581e$var$Routes = ()=>/*#__PURE__*/ (0, $02de83db299f7983$exports.jsxs)((0, $8e7337eeed3043b3$export$b5d5cf8927ab7262), {
        children: [
            /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $8e7337eeed3043b3$export$e7b0ac011bb776c6), {
                exact: true,
                path: "/not_found",
                component: (0, $279d3b4c8110a250$export$2e2bcd8739ae039)
            }),
            /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $8e7337eeed3043b3$export$e7b0ac011bb776c6), {
                exact: true,
                path: "/frame/internal",
                component: (0, $92fc1304e46d7bde$export$2e2bcd8739ae039)
            }),
            /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $8e7337eeed3043b3$export$e7b0ac011bb776c6), {
                exact: true,
                component: (0, $a4d47c1a2433f072$export$2e2bcd8739ae039)
            })
        ]
    });
var $24743a343556581e$export$2e2bcd8739ae039 = $24743a343556581e$var$Routes;



parcelRequire("aivMx");
const $741fbedaf13cc59d$var$Theme = ({ children: children })=>{
    const brand = "tnbe";
    return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("div", {
        "data-testid": "theme",
        className: `theme-${brand} theme`,
        children: children
    });
};
var $741fbedaf13cc59d$export$2e2bcd8739ae039 = $741fbedaf13cc59d$var$Theme;


const $ae9ae0bb313ac8bf$var$Main = (props)=>{
    const { store: store, history: history } = props;
    return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $7a57c545a1f92740$export$2e2bcd8739ae039), {
        store: store,
        children: /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $bcf121fb6549cc53$export$28f92b8268ba8447), {
            history: history,
            children: /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $741fbedaf13cc59d$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $24743a343556581e$export$2e2bcd8739ae039), {})
            })
        })
    });
};
var $ae9ae0bb313ac8bf$export$2e2bcd8739ae039 = $ae9ae0bb313ac8bf$var$Main;


const $f0076a935b238615$var$store = (0, $4931f7746d84676b$export$2e2bcd8739ae039)();
const $f0076a935b238615$var$root = (0, $86dae81a7d15f03f$export$882461b6382ed46c)(document.getElementById("root"));
$f0076a935b238615$var$root.render(/*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $ae9ae0bb313ac8bf$export$2e2bcd8739ae039), {
    store: $f0076a935b238615$var$store,
    history: (0, $4931f7746d84676b$export$55abd4691b317664)
}));


//# sourceMappingURL=index.86006683.js.map
